/* This file is generated by scripts/generate-brand.mjs. Do not edit. */

import type { CarrierDecal, CarrierPalette, TruckGeometry } from '../brand/types';

export const DEFAULT_CARRIER_COLOR = "#8e8e93";

export const CARRIER_FAMILIES: Record<string, string> = {
  "ait-home-delivery": "ait-worldwide",
  "amazon-shipping": "amazon-logistics",
  "aramex-au": "aramex",
  "aramex-nz": "aramex",
  "delivengo": "la-poste",
  "dhl-ecommerce": "dhl",
  "dhl-ecommerce-es": "dhl",
  "dhl-ecommerce-nl": "dhl",
  "dhl-ecommerce-pl": "dhl",
  "dhl-ecommerce-uk": "dhl",
  "dhl-express": "dhl",
  "dhl-freight": "dhl",
  "dpd-at": "dpd",
  "dpd-be": "dpd",
  "dpd-de": "dpd",
  "dpd-fr": "dpd",
  "dpd-gr": "dpd",
  "dpd-hu": "dpd",
  "dpd-ie": "dpd",
  "dpd-nl": "dpd",
  "dpd-pl": "dpd",
  "dpd-pt": "dpd",
  "dpd-ro": "dpd",
  "dpd-uk": "dpd",
  "dpd-za": "dpd",
  "evri-uk": "evri",
  "fedex-freight": "fedex",
  "fedex-international-connect": "fedex",
  "fedex-pl": "fedex",
  "geodis-pl": "geodis",
  "gls-at": "gls",
  "gls-ch": "gls",
  "gls-de": "gls",
  "gls-es": "gls",
  "gls-fr": "gls",
  "gls-it": "gls",
  "gls-pl": "gls",
  "gofo-ca": "gofo",
  "gofo-es": "gofo",
  "gofo-fr": "gofo",
  "gofo-it": "gofo",
  "gofo-nl": "gofo",
  "hermes-at": "hermes",
  "j-and-t-au": "j-and-t-cn",
  "j-and-t-de": "j-and-t-cn",
  "j-and-t-uk": "j-and-t-cn",
  "mng-kargo": "dhl",
  "pickupp-sg": "pickupp",
  "postlogistics": "swiss-post",
  "swiss-post-cargo": "swiss-post",
  "tnt-au": "tnt",
  "tnt-it": "tnt",
  "wedo": "allegro-one",
  "yamato-america": "yamato",
  "zto-international": "zto"
};

export const CARRIER_PALETTES: Record<string, Partial<CarrierPalette>> = {
  "a1-post": {
    "accent": "#1d1d1b"
  },
  "allegro-one": {
    "truck": "#006d57",
    "edge": "#005746",
    "accent": "#7edf00"
  },
  "amazon-logistics": {
    "truck": "#232f3e",
    "edge": "#131a22",
    "accent": "#ff9900"
  },
  "amazon-shipping": {
    "truck": "#232f3e",
    "edge": "#131a22",
    "accent": "#ff9900"
  },
  "austrian-post": {
    "accent": "#1a1a1a",
    "brand-light": "#1a1a1a"
  },
  "bjs-home-delivery": {
    "accent": "#5c5147"
  },
  "bulgarian-posts": {
    "accent": "#000016"
  },
  "canada-post": {
    "truck": "#ffffff",
    "edge": "#0f4c9c",
    "accent": "#e4002b"
  },
  "ceska-posta": {
    "accent": "#fece22"
  },
  "chronopost": {
    "accent": "#0094cf",
    "truck": "#ffffff",
    "edge": "#0056a7"
  },
  "citymail-pk": {
    "accent": "#273985"
  },
  "cj-logistics": {
    "truck": "#ffffff",
    "edge": "#5a5a5a",
    "accent": "#ef151e"
  },
  "correios-br": {
    "accent": "#06416a",
    "brand-light": "#06416a"
  },
  "correos-express": {
    "accent": "#002e6d",
    "brand-light": "#002e6d"
  },
  "correos-spain": {
    "accent": "#002e6d",
    "brand-light": "#002e6d"
  },
  "custom-companies": {
    "truck": "#1e1e1e",
    "edge": "#000000",
    "accent": "#ffca43"
  },
  "cyprus-post": {
    "accent": "#202020"
  },
  "day-ross": {
    "truck": "#1a1919",
    "edge": "#000000"
  },
  "delivengo": {
    "accent": "#003da5",
    "brand-light": "#003da5"
  },
  "dellin": {
    "truck": "#2b2b2b",
    "edge": "#141414",
    "accent": "#fcaf17"
  },
  "deppon": {
    "accent": "#ffe100"
  },
  "dhl": {
    "surface-light": "#f7e8aa",
    "surface-dark": "#30210b",
    "ink-light": "#6c5419",
    "ink-dark": "#ead695",
    "brand-light": "#d40511",
    "brand-dark": "#ffe274",
    "truck": "#ffcc00",
    "edge": "#b88d16",
    "accent": "#d40511"
  },
  "dhl-ecommerce": {
    "surface-light": "#f7e8aa",
    "surface-dark": "#30210b",
    "ink-light": "#6c5419",
    "ink-dark": "#ead695",
    "brand-light": "#d40511",
    "brand-dark": "#ffe274",
    "truck": "#ffcc00",
    "edge": "#b88d16",
    "accent": "#d40511"
  },
  "dhl-ecommerce-es": {
    "surface-light": "#f7e8aa",
    "surface-dark": "#30210b",
    "ink-light": "#6c5419",
    "ink-dark": "#ead695",
    "brand-light": "#d40511",
    "brand-dark": "#ffe274",
    "truck": "#ffcc00",
    "edge": "#b88d16",
    "accent": "#d40511"
  },
  "dhl-ecommerce-nl": {
    "surface-light": "#f7e8aa",
    "surface-dark": "#30210b",
    "ink-light": "#6c5419",
    "ink-dark": "#ead695",
    "brand-light": "#d40511",
    "brand-dark": "#ffe274",
    "truck": "#ffcc00",
    "edge": "#b88d16",
    "accent": "#d40511"
  },
  "dhl-ecommerce-pl": {
    "surface-light": "#f7e8aa",
    "surface-dark": "#30210b",
    "ink-light": "#6c5419",
    "ink-dark": "#ead695",
    "brand-light": "#d40511",
    "brand-dark": "#ffe274",
    "truck": "#ffcc00",
    "edge": "#b88d16",
    "accent": "#d40511"
  },
  "dhl-ecommerce-uk": {
    "surface-light": "#f7e8aa",
    "surface-dark": "#30210b",
    "ink-light": "#6c5419",
    "ink-dark": "#ead695",
    "brand-light": "#d40511",
    "brand-dark": "#ffe274",
    "truck": "#ffcc00",
    "edge": "#b88d16",
    "accent": "#d40511"
  },
  "dhl-express": {
    "surface-light": "#f7e8aa",
    "surface-dark": "#30210b",
    "ink-light": "#6c5419",
    "ink-dark": "#ead695",
    "brand-light": "#d40511",
    "brand-dark": "#ffe274",
    "truck": "#ffcc00",
    "edge": "#b88d16",
    "accent": "#d40511"
  },
  "dhl-freight": {
    "surface-light": "#f7e8aa",
    "surface-dark": "#30210b",
    "ink-light": "#6c5419",
    "ink-dark": "#ead695",
    "brand-light": "#d40511",
    "brand-dark": "#ffe274",
    "truck": "#ffcc00",
    "edge": "#b88d16",
    "accent": "#d40511"
  },
  "dobropost": {
    "accent": "#1d2b37"
  },
  "elog-luxembourg": {
    "accent": "#000000"
  },
  "elta": {
    "accent": "#ebb811"
  },
  "emile": {
    "truck": "#ffffff",
    "edge": "#e42920",
    "accent": "#e42920"
  },
  "estes": {
    "accent": "#212121"
  },
  "evri": {
    "accent": "#53efef"
  },
  "evri-uk": {
    "accent": "#53efef"
  },
  "ewe": {
    "accent": "#f3e127"
  },
  "fedex": {
    "accent": "#ff6600"
  },
  "fedex-freight": {
    "accent": "#ff6600"
  },
  "fedex-international-connect": {
    "accent": "#ff6600"
  },
  "fedex-pl": {
    "accent": "#ff6600"
  },
  "geis": {
    "truck": "#ffe501",
    "edge": "#ff0001",
    "accent": "#0a2363"
  },
  "gls-at": {
    "surface-light": "#dfebfa",
    "surface-dark": "#152538",
    "ink-light": "#355e8a",
    "ink-dark": "#b7d1ee",
    "brand-light": "#1634a7",
    "brand-dark": "#abc7ff",
    "truck": "#1634a7",
    "edge": "#1634a7",
    "accent": "#ffcf00"
  },
  "gls-ch": {
    "surface-light": "#dfebfa",
    "surface-dark": "#152538",
    "ink-light": "#355e8a",
    "ink-dark": "#b7d1ee",
    "brand-light": "#1634a7",
    "brand-dark": "#abc7ff",
    "truck": "#1634a7",
    "edge": "#1634a7",
    "accent": "#ffcf00"
  },
  "gls-de": {
    "surface-light": "#dfebfa",
    "surface-dark": "#152538",
    "ink-light": "#355e8a",
    "ink-dark": "#b7d1ee",
    "brand-light": "#1634a7",
    "brand-dark": "#abc7ff",
    "truck": "#1634a7",
    "edge": "#1634a7",
    "accent": "#ffcf00"
  },
  "gls-es": {
    "surface-light": "#dfebfa",
    "surface-dark": "#152538",
    "ink-light": "#355e8a",
    "ink-dark": "#b7d1ee",
    "brand-light": "#1634a7",
    "brand-dark": "#abc7ff",
    "truck": "#1634a7",
    "edge": "#1634a7",
    "accent": "#ffcf00"
  },
  "gls-fr": {
    "surface-light": "#dfebfa",
    "surface-dark": "#152538",
    "ink-light": "#355e8a",
    "ink-dark": "#b7d1ee",
    "brand-light": "#1634a7",
    "brand-dark": "#abc7ff",
    "truck": "#1634a7",
    "edge": "#1634a7",
    "accent": "#ffcf00"
  },
  "gls-it": {
    "surface-light": "#dfebfa",
    "surface-dark": "#152538",
    "ink-light": "#355e8a",
    "ink-dark": "#b7d1ee",
    "brand-light": "#1634a7",
    "brand-dark": "#abc7ff",
    "truck": "#1634a7",
    "edge": "#1634a7",
    "accent": "#ffcf00"
  },
  "gls-pl": {
    "surface-light": "#dfebfa",
    "surface-dark": "#152538",
    "ink-light": "#355e8a",
    "ink-dark": "#b7d1ee",
    "brand-light": "#1634a7",
    "brand-dark": "#abc7ff",
    "truck": "#1634a7",
    "edge": "#1634a7",
    "accent": "#ffcf00"
  },
  "go4": {
    "truck": "#151515",
    "edge": "#000000",
    "accent": "#ffffff"
  },
  "helthjem": {
    "accent": "#050505"
  },
  "homexpress": {
    "accent": "#00864c"
  },
  "hongsuda": {
    "accent": "#000000"
  },
  "hp-mostar": {
    "accent": "#1d1d1b"
  },
  "hr-parcel": {
    "accent": "#1d1d1b"
  },
  "hrvatska-posta": {
    "accent": "#1d1d1b"
  },
  "india-post": {
    "accent": "#fedb01"
  },
  "inpost": {
    "accent": "#1d1d1d",
    "brand-light": "#1d1d1d"
  },
  "internet-express": {
    "accent": "#141414"
  },
  "jb-hunt": {
    "accent": "#000000"
  },
  "jitsu": {
    "accent": "#000000"
  },
  "la-poste": {
    "accent": "#003da5",
    "brand-light": "#003da5"
  },
  "lietuvos-pastas": {
    "accent": "#000000"
  },
  "mng-kargo": {
    "surface-light": "#f7e8aa",
    "surface-dark": "#30210b",
    "ink-light": "#6c5419",
    "ink-dark": "#ead695",
    "brand-light": "#d40511",
    "brand-dark": "#ffe274",
    "truck": "#ffcc00",
    "edge": "#b88d16",
    "accent": "#d40511"
  },
  "mondial-relay": {
    "truck": "#f5a9bb",
    "edge": "#94154b",
    "accent": "#94154b",
    "brand-light": "#94154b",
    "brand-dark": "#f5a9bb"
  },
  "montenegro-post": {
    "accent": "#1d1d1b"
  },
  "no-limit": {
    "accent": "#1d1d1b"
  },
  "noerpel": {
    "accent": "#1b1919"
  },
  "nox": {
    "truck": "#151515",
    "edge": "#000000",
    "accent": "#ffffff"
  },
  "nz-couriers": {
    "accent": "#1a1818"
  },
  "olva-courier": {
    "truck": "#fcb414",
    "edge": "#ca9010",
    "accent": "#1f3a93"
  },
  "packli-punkt": {
    "accent": "#f9e937"
  },
  "passport": {
    "accent": "#333333"
  },
  "paxi": {
    "accent": "#005065"
  },
  "post-one": {
    "accent": "#100f0f"
  },
  "posta-slovenije": {
    "accent": "#000000"
  },
  "posta-srbije": {
    "accent": "#0c4076"
  },
  "poste-italiane": {
    "accent": "#0047bb",
    "brand-light": "#0047bb"
  },
  "postlogistics": {
    "accent": "#141414",
    "brand-light": "#141414"
  },
  "postmedia-parcel-services": {
    "accent": "#000000"
  },
  "ptt": {
    "truck": "#ffc72c",
    "edge": "#cc9f23",
    "accent": "#007a99"
  },
  "purolator": {
    "truck": "#ffffff",
    "edge": "#22387d",
    "accent": "#da322a"
  },
  "quality-post": {
    "accent": "#9d1e21"
  },
  "royal-mail": {
    "accent": "#fdda24"
  },
  "sailpost": {
    "accent": "#000000"
  },
  "shipup": {
    "accent": "#1e4530",
    "brand-light": "#1e4530"
  },
  "slovenska-posta": {
    "accent": "#1c2024"
  },
  "stallion-express": {
    "accent": "#221e20"
  },
  "swiss-post": {
    "accent": "#141414",
    "brand-light": "#141414"
  },
  "swiss-post-cargo": {
    "accent": "#141414",
    "brand-light": "#141414"
  },
  "taqbin-hk": {
    "accent": "#231916",
    "brand-light": "#231916"
  },
  "tawssil": {
    "accent": "#008996"
  },
  "tcc-co": {
    "accent": "#ff002d"
  },
  "tdn": {
    "accent": "#000000"
  },
  "team-global-express": {
    "accent": "#cbff55"
  },
  "tipsa": {
    "accent": "#ff4f00"
  },
  "tusass": {
    "accent": "#14192e"
  },
  "tws-express": {
    "accent": "#1d1d1b"
  },
  "ukrposhta": {
    "accent": "#0e2f4b",
    "brand-light": "#0e2f4b"
  },
  "ups": {
    "surface-light": "#ede3d5",
    "surface-dark": "#2c2317",
    "ink-light": "#78573e",
    "ink-dark": "#dbc2a4",
    "brand-light": "#573626",
    "brand-dark": "#ebca99",
    "truck": "#573626",
    "edge": "#573626",
    "accent": "#f5c86b"
  },
  "usps": {
    "truck": "#ffffff",
    "edge": "#004b87",
    "accent": "#004b87"
  },
  "vnpost": {
    "accent": "#f9a81a"
  },
  "vrl-logistics": {
    "truck": "#ffcb00",
    "edge": "#c99f00",
    "accent": "#1a1a1a"
  },
  "wedo": {
    "truck": "#006d57",
    "edge": "#005746",
    "accent": "#7edf00"
  },
  "xcargo": {
    "accent": "#11262b"
  },
  "xyl": {
    "accent": "#000000"
  },
  "yamato": {
    "accent": "#141414",
    "brand-light": "#141414"
  },
  "yamato-america": {
    "accent": "#141414",
    "brand-light": "#141414"
  },
  "yunda": {
    "accent": "#393838",
    "brand-light": "#393838"
  },
  "zeleris": {
    "accent": "#212121"
  },
  "zr-express": {
    "accent": "#141414"
  }
};

export const CARRIER_DECALS: Record<string, CarrierDecal> = {
  "139express": "139express",
  "17feia": "17feia",
  "247express": "247express",
  "2ebox": "2ebox",
  "2go": "2go",
  "360lion": "360lion",
  "360zebra": "360zebra",
  "3pe-express": "3pe-express",
  "4-72": "4-72",
  "4sides": "4sides",
  "5post": "5post",
  "66post": "66post",
  "7hours-express": "7hours-express",
  "99minutos": "99minutos",
  "a-duie-pyle": "a-duie-pyle",
  "a-tu-hora-express": "a-tu-hora-express",
  "a1-post": "a1-post",
  "a2b-express": "a2b-express",
  "aaa-cooper": "aaa-cooper",
  "ab-courier": "ab-courier",
  "abf-freight": "abf-freight",
  "ace-ee": "ace-ee",
  "ace-lt": "ace-lt",
  "ace-lv": "ace-lv",
  "acex": "acex",
  "aci-express-kr": "aci-express-kr",
  "acs-courier": "acs-courier",
  "aeropost": "aeropost",
  "aex-paraguay": "aex-paraguay",
  "afghan-post": "afghan-post",
  "agt-kurye": "agt-kurye",
  "ahamove": "ahamove",
  "ahl-courier": "ahl-courier",
  "aics": "aics",
  "air-star-xpress": "air-star-xpress",
  "airmee": "airmee",
  "airpak-express": "airpak-express",
  "airroad": "airroad",
  "airspeed": "airspeed",
  "airwings-india": "airwings-india",
  "ait-home-delivery": "ait-worldwide",
  "ait-worldwide": "ait-worldwide",
  "ajex": "ajex",
  "akash-ganga": "akash-ganga",
  "akis-express": "akis-express",
  "aks-express": "aks-express",
  "aland-post": "aland-post",
  "alem-tat": "alem-tat",
  "algerie-poste": "algerie-poste",
  "aliexpress": "aliexpress",
  "alil-post": "alil-post",
  "allegro-one": "allegro-one",
  "alliance-air-freight": "alliance-air-freight",
  "alljoy": "alljoy",
  "am-home-delivery": "am-home-delivery",
  "amalgamated-distribution": "amalgamated-distribution",
  "amazon-logistics": "amazon",
  "amazon-shipping": "amazon",
  "ambro-express": "ambro-express",
  "ameex": "ameex",
  "american-west-express": "american-west-express",
  "amerijet": "amerijet",
  "ameriship": "ameriship",
  "ampm": "ampm",
  "ams-egroup": "ams-egroup",
  "an-post": "an-post",
  "anc-delivers": "anc-delivers",
  "andreani": "andreani",
  "ane-logistics": "ane-logistics",
  "anjun": "anjun",
  "annto": "annto",
  "anousith": "anousith",
  "anserx": "anserx",
  "antaria": "antaria",
  "anteraja": "anteraja",
  "ap-cargo": "ap-cargo",
  "apc-overnight": "apc-overnight",
  "apc-postal-logistics": "apc-postal-logistics",
  "apg-ecommerce": "apg-ecommerce",
  "apg-global": "apg-global",
  "apple-express": "apple-express",
  "apx-logistics": "apx-logistics",
  "aquiline": "aquiline",
  "aqx-logistics": "aqx-logistics",
  "aramex": "aramex",
  "aramex-au": "aramex",
  "aramex-nz": "aramex",
  "aras-kargo": "aras-kargo",
  "ark-express": "ark-express",
  "arrow-express": "arrow-express",
  "arrow-xl": "arrow-xl",
  "aruba-post": "aruba-post",
  "ase-express": "ase-express",
  "asendia": "asendia",
  "asiafly": "asiafly",
  "asigna": "asigna",
  "asyad-express": "asyad-express",
  "atlantic-courier": "atlantic-courier",
  "ats-healthcare": "ats-healthcare",
  "auexpress": "auexpress",
  "australia-post": "australia-post",
  "austrian-post": "austrian-post",
  "averitt": "averitt",
  "avis-logistics": "avis-logistics",
  "aymakan": "aymakan",
  "azerpost": "azerpost",
  "azul-cargo": "azul-cargo",
  "bangladesh-post": "bangladesh-post",
  "banling": "banling",
  "barid-al-maghrib": "barid-al-maghrib",
  "barq": "barq",
  "basic-shipping": "basic-shipping",
  "bee-fast": "bee-fast",
  "beexprss": "beexprss",
  "bel": "bel",
  "belpost": "belpost",
  "best-express-my": "best-express-my",
  "best-express-th": "best-express-th",
  "best-express-vn": "best-express-vn",
  "best-overnite-express": "best-overnite-express",
  "best-transport": "best-transport",
  "bestfulfill": "bestfulfill",
  "better-trucks": "better-trucks",
  "bex-express": "bex-express",
  "bfe-express": "bfe-express",
  "big-smart": "big-smart",
  "bjs-home-delivery": "bjs-home-delivery",
  "blue-dart": "blue-dart",
  "blue-express": "blue-express",
  "blueex": "blueex",
  "bluesky-parcel": "bluesky-parcel",
  "bluestreak-couriers": "bluestreak-couriers",
  "bolt-kargo": "bolt-kargo",
  "bombax": "bombax",
  "bombino": "bombino",
  "bonds-couriers": "bonds-couriers",
  "bookurier": "bookurier",
  "border-express": "border-express",
  "bosta": "bosta",
  "botswana-post": "botswana-post",
  "box-now": "box-now",
  "boxtal": "boxtal",
  "boyuan": "boyuan",
  "bpost": "bpost",
  "bqc-logistics": "bqc-logistics",
  "branding-worldwide": "branding-worldwide",
  "braspress": "braspress",
  "bridge-intl": "bridge-intl",
  "bring-posten": "bring",
  "bringer-parcel": "bringer-parcel",
  "brt": "dpd",
  "btc-logistic": "btc-logistic",
  "btd": "btd",
  "bts-uz": "bts-uz",
  "budbee": "budbee",
  "buffalo-ex": "buffalo-ex",
  "bulgarian-posts": "bulgarian-posts",
  "burd-delivery": "burd-delivery",
  "burundi-post": "burundi-post",
  "bussgods": "bussgods",
  "byhd": "byhd",
  "c-chez-vous": "c-chez-vous",
  "c3x": "c3x",
  "c807-xpress": "c807-xpress",
  "campost": "campost",
  "canada-air-express": "canada-air-express",
  "canada-post": "canada-post",
  "canpar": "canpar",
  "cargo-expreso": "cargo-expreso",
  "cargo-trans-logistik": "cargo-trans-logistik",
  "cargobus": "cargobus",
  "cargoline": "cargoline",
  "cargus": "cargus",
  "carry-flap": "carry-flap",
  "castores": "castores",
  "cathedis": "cathedis",
  "cbl-logistica": "cbl-logistica",
  "ccfs": "ccfs",
  "cdek": "cdek",
  "cdl": "cdl",
  "cel-changda": "cel-changda",
  "celeritas": "celeritas",
  "central-transport": "central-transport",
  "centurion-transport": "centurion-transport",
  "ceska-posta": "ceska-posta",
  "ceva-logistics": "ceva-logistics",
  "changjiang-express": "changjiang-express",
  "chazki": "chazki",
  "cheetah-delivery": "cheetah-delivery",
  "chilexpress": "chilexpress",
  "china-post": "china-post",
  "china-railway-express": "china-railway-express",
  "chinz-logistics": "chinz-logistics",
  "chit-chats": "chit-chats",
  "choir-express": "choir-express",
  "chronodiali": "chronodiali",
  "chronopost": "chronopost",
  "chukou1": "chukou1",
  "chunghwa-post": "chunghwa-post",
  "chunil": "chunil",
  "ciblex": "ciblex",
  "citi-sprint": "citi-sprint",
  "citilogistics": "citilogistics",
  "cititrans": "cititrans",
  "city-air-express": "city-air-express",
  "city-express-rs": "city-express-rs",
  "citylink-express": "citylink-express",
  "citymail": "citymail",
  "citymail-pk": "citymail-pk",
  "citysprint": "citysprint",
  "cj-logistics": "cj-logistics",
  "cj-packet": "cj-packet",
  "ckeex": "ckeex",
  "closer-logistics": "closer-logistics",
  "cmt-express": "cmt-express",
  "cne": "cne",
  "codexpress": "codexpress",
  "colis-prive": "colis-prive",
  "colisweb": "colisweb",
  "collicare": "collicare",
  "comone-express": "comone-express",
  "connect-couriers": "connect-couriers",
  "consegnia": "consegnia",
  "conveyor-uni-express": "conveyor-uni-express",
  "coordinadora": "coordinadora",
  "copa-courier": "copa-courier",
  "cope-sensitive-freight": "cope-sensitive-freight",
  "corporate-couriers": "corporate-couriers",
  "corre": "corre",
  "correios-angola": "correios-angola",
  "correios-br": "correios-br",
  "correo-argentino": "correo-argentino",
  "correo-paraguayo": "correo-paraguayo",
  "correo-uruguayo": "correo-uruguayo",
  "correos-bolivia": "correos-bolivia",
  "correos-chile": "correos-chile",
  "correos-cuba": "correos-cuba",
  "correos-de-mexico": "correos-de-mexico",
  "correos-ecuador": "correos-ecuador",
  "correos-el-salvador": "correos-el-salvador",
  "correos-express": "correos",
  "correos-nicaragua": "correos-nicaragua",
  "correos-spain": "correos",
  "costco-logistics": "costco-logistics",
  "coupang-logistics": "coupang-logistics",
  "courier-center": "courier-center",
  "courier-it": "courier-it",
  "courier-plus-ng": "courier-plus-ng",
  "couriersplease": "couriersplease",
  "cps-lastmile": "cps-lastmile",
  "cpszy": "cpszy",
  "crane-worldwide": "crane-worldwide",
  "credifin": "credifin",
  "cruz-del-sur": "cruz-del-sur",
  "cse-russia": "cse-russia",
  "cst-italia": "cst-italia",
  "ctc-express": "ctc-express",
  "ctt": "ctt",
  "ctt-express": "ctt",
  "cttyex": "cttyex",
  "cupost": "cupost",
  "custom-companies": "custom-companies",
  "cycloon": "cycloon",
  "cyprus-post": "cyprus-post",
  "czl-express": "czl-express",
  "d-express": "d-express",
  "dachser": "dachser",
  "daewoo-fastex": "daewoo-fastex",
  "daiichi": "daiichi",
  "daily-xpress": "daily-xpress",
  "dakota-cargo": "dakota-cargo",
  "danniao": "danniao",
  "danske-fragtmaend": "danske-fragtmaend",
  "dao": "dao",
  "day-ross": "day-ross",
  "daylight-transport": "daylight-transport",
  "dayone": "dayone",
  "dayton-freight": "dayton-freight",
  "dd-express": "dd-express",
  "ddu-express": "ddu-express",
  "dealersend": "dealersend",
  "delhivery": "delhivery",
  "delivengo": "la-poste",
  "deliverdirect": "deliverdirect",
  "deliveright": "deliveright",
  "delivro": "delivro",
  "dellin": "dellin",
  "delnext": "delnext",
  "depo": "depo",
  "deppon": "deppon",
  "deprisa": "deprisa",
  "der-kurier-sk": "der-kurier-sk",
  "designer-transport": "designer-transport",
  "dex-i": "dex-i",
  "dex-pk": "dex-pk",
  "dg-transporte": "dg-transporte",
  "dhl": "dhl",
  "dhl-ecommerce": "dhl",
  "dhl-ecommerce-es": "dhl",
  "dhl-ecommerce-nl": "dhl",
  "dhl-ecommerce-pl": "dhl",
  "dhl-ecommerce-uk": "dhl",
  "dhl-express": "dhl",
  "dhl-freight": "dhl",
  "dhlink": "dhlink",
  "dhx": "dhx",
  "diakinisis": "diakinisis",
  "dida-international": "dida-international",
  "dimex": "dimex",
  "direct-couriers": "direct-couriers",
  "direct-freight-express": "direct-freight-express",
  "direx": "direx",
  "dnipro-llc": "dnipro-llc",
  "dnx-cargo": "dnx-cargo",
  "dobropost": "dobropost",
  "dohrn-transfer": "dohrn-transfer",
  "domain-logistics": "domain-logistics",
  "domesa": "domesa",
  "domex": "domex",
  "dpd": "dpd",
  "dpd-at": "dpd",
  "dpd-be": "dpd",
  "dpd-de": "dpd",
  "dpd-fr": "dpd",
  "dpd-gr": "dpd",
  "dpd-hu": "dpd",
  "dpd-ie": "dpd",
  "dpd-nl": "dpd",
  "dpd-pl": "dpd",
  "dpd-pt": "dpd",
  "dpd-ro": "dpd",
  "dpd-uk": "dpd",
  "dpd-za": "dpd",
  "dpe-express": "dpe-express",
  "dpex": "dpex",
  "dpx-logistics": "dpx-logistics",
  "dragon-star-curier": "dragon-star-curier",
  "drop2shop": "drop2shop",
  "dropp": "dropp",
  "dsv": "dsv",
  "dtd-pk": "dtd-pk",
  "dtdc": "dtdc",
  "dx": "dx",
  "dynalogic": "dynalogic",
  "e-cargo": "e-cargo",
  "e-commerce-international": "e-commerce-international",
  "e24metro-ca": "e24metro-ca",
  "eac-cn": "eac-cn",
  "early-bird": "early-bird",
  "easy-mail": "easy-mail",
  "ecms-express": "ecms-express",
  "eco-express-ae": "eco-express-ae",
  "ecohai": "ecohai",
  "ecom-logistics": "ecom-logistics",
  "econt": "econt",
  "ecoscooting": "ecoscooting",
  "ecourier": "ecourier",
  "ecourier-uk": "ecourier-uk",
  "ecparcel": "ecparcel",
  "edi-express": "edi-express",
  "ees-logistics": "ees-logistics",
  "efs-asia": "efs-asia",
  "egxpress": "egxpress",
  "egypt-post": "egypt-post",
  "ekart": "ekart",
  "eli-express": "eli-express",
  "elianpost": "elianpost",
  "elog-luxembourg": "elog-luxembourg",
  "elta": "elta",
  "emex": "emex",
  "emile": "emile",
  "emirates-courier-express": "emirates-courier-express",
  "emirates-post": "emirates-post",
  "emiro": "emiro",
  "emons": "emons",
  "ems": "ems",
  "ems-vietnam": "ems-vietnam",
  "emu-express": "emu-express",
  "endeavour-delivery": "endeavour-delivery",
  "energia-tk": "energia-tk",
  "energo": "energo",
  "envia-colombia": "envia-colombia",
  "envialia": "envialia",
  "eparcel-kr": "eparcel-kr",
  "epost-global": "epost-global",
  "equick": "equick",
  "espeedpost": "espeedpost",
  "espoirer": "espoirer",
  "estafeta": "estafeta",
  "estes": "estes",
  "estes-forwarding": "estes-forwarding",
  "ethiopian-post": "ethiopian-post",
  "etomars": "etomars",
  "ets-express": "ets-express",
  "eurodis": "eurodis",
  "euroexpress-ba": "euroexpress-ba",
  "europochta": "europochta",
  "eushipments": "eushipments",
  "evdemo-lojistik": "evdemo-lojistik",
  "evri": "evri",
  "evri-uk": "evri",
  "evropat": "evropat",
  "ewe": "ewe",
  "exelot": "exelot",
  "exline-kz": "exline-kz",
  "exmate": "exmate",
  "expedico": "expedico",
  "explus-logistics": "explus-logistics",
  "express-one": "express-one",
  "express-one-bg": "express-one-bg",
  "express-ru": "express-ru",
  "ezship": "ezship",
  "famafutar": "famafutar",
  "famiport": "famiport",
  "fan-courier": "fan-courier",
  "far-international": "far-international",
  "fare-rata": "fare-rata",
  "fargo-courier": "fargo-courier",
  "fargo-uz": "fargo-uz",
  "fastbox": "fastbox",
  "fastdrop": "fastdrop",
  "faster-ae": "faster-ae",
  "fastfrate": "fastfrate",
  "fastgo": "fastgo",
  "fasttrack-ar": "fasttrack-ar",
  "fastwl": "fastwl",
  "fedex": "fedex",
  "fedex-freight": "fedex",
  "fedex-international-connect": "fedex",
  "fedex-pl": "fedex",
  "fermopoint": "fermopoint",
  "fez-delivery": "fez-delivery",
  "fg-delivery": "fg-delivery",
  "fimile": "fimile",
  "first-delivery-tn": "first-delivery-tn",
  "first-flight-me": "first-flight-me",
  "first-fly-express": "first-fly-express",
  "first-line": "first-line",
  "flash-express": "flash-express",
  "flash-express-ph": "flash-express-ph",
  "flashbird-ca": "flashbird-ca",
  "flecha-amarilla": "flecha-amarilla",
  "fleetex": "fleetex",
  "fleetoptics": "fleetoptics",
  "flickpost": "flickpost",
  "flight-logistics": "flight-logistics",
  "flippost": "flippost",
  "flipxpress": "flipxpress",
  "fliway": "fliway",
  "flyking": "flyking",
  "flyt-express": "flyt-express",
  "fm-transportes": "fm-transportes",
  "fmd-distribution": "fmd-distribution",
  "fmx": "fmx",
  "fofr": "fofr",
  "followmont": "followmont",
  "forward-air": "forward-air",
  "forza-delivery": "forza-delivery",
  "four-px": "four-px",
  "foxpost": "foxpost",
  "fragilepak": "fragilepak",
  "franch-express": "franch-express",
  "freightways-global": "freightways-global",
  "frontdoor-collective": "frontdoor-collective",
  "frontier-ca": "frontier-ca",
  "fukuyama": "fukuyama",
  "furniture-logis": "furniture-logis",
  "fxdc-post": "fxdc-post",
  "gaash": "gaash",
  "garantpost": "garantpost",
  "gati": "gati",
  "gcx": "gcx",
  "gdex": "gdex",
  "gebrueder-weiss": "gebrueder-weiss",
  "geis": "geis",
  "gel-express": "gel-express",
  "geniki-taxydromiki": "geniki-taxydromiki",
  "geodis": "geodis",
  "geodis-pl": "geodis",
  "geswl": "geswl",
  "ghana-post": "ghana-post",
  "ghn": "ghn",
  "ghtk": "ghtk",
  "gibraltar-post": "gibraltar-post",
  "gio-express": "gio-express",
  "gle-colombia": "gle-colombia",
  "global-business-tw": "global-business-tw",
  "global-delivery-network": "global-delivery-network",
  "global-parcel-service": "global-parcel-service",
  "globalpost": "globalpost",
  "gls-at": "gls",
  "gls-ch": "gls",
  "gls-de": "gls",
  "gls-es": "gls",
  "gls-fr": "gls",
  "gls-it": "gls",
  "gls-pl": "gls",
  "gms-worldwide": "gms-worldwide",
  "go-express": "go-express",
  "go-logistics-au": "go-logistics-au",
  "go-rush": "go-rush",
  "go-world-express": "go-world-express",
  "go4": "go4",
  "gobolt": "gobolt",
  "gofast": "gofast",
  "gofo": "gofo",
  "gofo-ca": "gofo",
  "gofo-es": "gofo",
  "gofo-fr": "gofo",
  "gofo-it": "gofo",
  "gofo-nl": "gofo",
  "gogo-xpress": "gogo-xpress",
  "golilla": "golilla",
  "goodluck-courier": "goodluck-courier",
  "goodmaji": "goodmaji",
  "grand-slam-express": "grand-slam-express",
  "greenway-vn": "greenway-vn",
  "groupe-guilbault": "groupe-guilbault",
  "gs-postbox": "gs-postbox",
  "gsi-express": "gsi-express",
  "gta-airskip": "gta-airskip",
  "gtl-goto": "gtl-goto",
  "guatex": "guatex",
  "gzyl": "gzyl",
  "hanjin": "hanjin",
  "hapdong": "hapdong",
  "happy-post": "happy-post",
  "hart2hart-express": "hart2hart-express",
  "haypost": "haypost",
  "hct-logistics": "hct-logistics",
  "hecny-ecom": "hecny-ecom",
  "helthjem": "helthjem",
  "heppner": "heppner",
  "hepsijet": "hepsijet",
  "hercules-freight": "hercules-freight",
  "hermes": "hermes",
  "hermes-at": "hermes",
  "hermes-de": "hermes",
  "herona-express": "herona-express",
  "hey-couriers": "hey-couriers",
  "hfd": "hfd",
  "hi-trans": "hi-trans",
  "hispapost": "hispapost",
  "hitch": "hitch",
  "hiyes": "hiyes",
  "hkd-express": "hkd-express",
  "holisol": "holisol",
  "homexpress": "homexpress",
  "honducor": "honducor",
  "hongkong-post": "hongkong-post",
  "hongsuda": "hongsuda",
  "horoz": "horoz",
  "hound-express": "hound-express",
  "houng-ah-loun": "houng-ah-loun",
  "hovership": "hovership",
  "hp-mostar": "hp-mostar",
  "hr-parcel": "hr-parcel",
  "hrvatska-posta": "hrvatska-posta",
  "hrx": "hrx",
  "htt-logistics": "htt-logistics",
  "huahan": "huahan",
  "huaya-express": "huaya-express",
  "hub-group-final-mile": "hub-group-final-mile",
  "hunter-express": "hunter-express",
  "hy-express": "hy-express",
  "hye": "hye",
  "hywl": "hywl",
  "hzt": "hzt",
  "icc-worldwide": "icc-worldwide",
  "icl-express": "icl-express",
  "ics-courier": "ics-courier",
  "idexpress": "idexpress",
  "ids-logistik": "ids-logistik",
  "ilyang-logis": "ilyang-logis",
  "imile": "imile",
  "indah-logistik": "indah-logistik",
  "india-post": "india-post",
  "indopaket": "indopaket",
  "inntralog": "inntralog",
  "inpost": "inpost",
  "instabox": "instabox",
  "instapack": "instapack",
  "integral-pack": "integral-pack",
  "intel-valley": "intel-valley",
  "intelcom": "intelcom",
  "inter-courier": "inter-courier",
  "inter-express-logistics": "inter-express-logistics",
  "intereuropa": "intereuropa",
  "interlogistica": "interlogistica",
  "internet-express": "internet-express",
  "interrapidisimo": "interrapidisimo",
  "intex-paketdienst": "intex-paketdienst",
  "intime-bg": "intime-bg",
  "ipostel": "ipostel",
  "iran-post": "iran-post",
  "islandwide-express": "islandwide-express",
  "israel-post": "israel-post",
  "j-and-t": "j-and-t",
  "j-and-t-au": "j-and-t-cn",
  "j-and-t-br": "j-and-t-cn",
  "j-and-t-cargo": "j-and-t-cargo",
  "j-and-t-cn": "j-and-t-cn",
  "j-and-t-de": "j-and-t-cn",
  "j-and-t-eg": "j-and-t-eg",
  "j-and-t-middle-east": "j-and-t-cn",
  "j-and-t-mx": "j-and-t-cn",
  "j-and-t-uk": "j-and-t-cn",
  "jadlog": "jadlog",
  "jamaica-post": "jamaica-post",
  "jamef": "jamef",
  "janco-express": "janco-express",
  "janio": "janio",
  "japan-post": "japan-post",
  "jas-worldwide": "jas-worldwide",
  "jaskipin": "jaskipin",
  "jb-hunt": "jb-hunt",
  "jcex": "jcex",
  "jcw-express": "jcw-express",
  "jd-logistics": "jd-logistics",
  "jdiex": "jdiex",
  "jeebly": "jeebly",
  "jersey-post": "jersey-post",
  "jet-global": "jet-global",
  "jet-logistic": "jet-logistic",
  "jetizz": "jetizz",
  "jetline-couriers": "jetline-couriers",
  "jetpak": "jetpak",
  "jhgj": "jhgj",
  "jiachen-express": "jiachen-express",
  "jiaying-express": "jiaying-express",
  "jiehang": "jiehang",
  "jifan": "jifan",
  "jikuaida": "jikuaida",
  "jitsu": "jitsu",
  "jiufang": "jiufang",
  "jne": "jne",
  "joom-logistics": "joom-logistics",
  "jordan-post": "jordan-post",
  "jp-home": "jp-home",
  "jrs-express": "jrs-express",
  "jrt": "jrt",
  "jumppoint": "jumppoint",
  "junfeng-international": "junfeng-international",
  "juxi-express": "juxi-express",
  "jy-express": "jy-express",
  "kargoist": "kargoist",
  "kargoturk": "kargoturk",
  "kart2door": "kart2door",
  "kazpost": "kazpost",
  "kec-ecommerce": "kec-ecommerce",
  "kerry-express-tw": "kerry-express-tw",
  "kerry-tj": "kerry-tj",
  "kex": "kex",
  "kex-express-hk": "kex-express-hk",
  "king-kong-express": "king-kong-express",
  "kit-tk": "kit-tk",
  "kiwi-express": "kiwi-express",
  "kolay-gelsin": "kolay-gelsin",
  "komon-express": "komon-express",
  "korea-post": "korea-post",
  "korexgarant": "korexgarant",
  "kronos-express": "kronos-express",
  "ktd": "ktd",
  "kuayuan-express": "kuayuan-express",
  "kuayue-express": "kuayue-express",
  "kuehne-nagel": "kuehne-nagel",
  "kun-express": "kun-express",
  "kunyoung": "kunyoung",
  "kwick-box": "kwick-box",
  "kyoungdong": "kyoungdong",
  "kyrgyz-post": "kyrgyz-post",
  "l-post": "l-post",
  "la-poste": "la-poste",
  "la-poste-burkina-faso": "la-poste-burkina-faso",
  "la-poste-ci": "la-poste-ci",
  "la-poste-senegal": "la-poste-senegal",
  "la-poste-tunisienne": "la-poste-tunisienne",
  "laar-courier": "laar-courier",
  "labaih": "labaih",
  "landmark-global": "landmark-global",
  "lao-post": "lao-post",
  "last-one-mile-coop": "last-one-mile-coop",
  "latam-global-express": "latam-global-express",
  "latvijas-pasts": "latvijas-pasts",
  "lbc-express": "lbc-express",
  "lbtx": "lbtx",
  "leopards-courier": "leopards-courier",
  "letter-track": "letter-track",
  "lex-id": "lex-id",
  "lex-my": "lex-my",
  "lex-vn": "lex-vn",
  "lhtex": "lhtex",
  "libang-logistics": "libang-logistics",
  "libanpost": "libanpost",
  "libya-post": "libya-post",
  "liccardi": "liccardi",
  "lietuvos-pastas": "lietuvos-pastas",
  "lightning-express": "lightning-express",
  "line-clear": "line-clear",
  "linear-logistics": "linear-logistics",
  "lingdong": "lingdong",
  "lion-parcel": "lion-parcel",
  "liuchen": "liuchen",
  "ljx-express": "ljx-express",
  "lm-parcel": "lm-parcel",
  "logen": "logen",
  "loggi": "loggi",
  "logisimple": "logisimple",
  "logista-parcel": "logista-parcel",
  "logistics-solution": "logistics-solution",
  "logistiq": "logistiq",
  "logoix": "logoix",
  "longcps": "longcps",
  "loomis-express": "loomis-express",
  "lotte-global": "lotte-global",
  "lso": "lso",
  "ltl-kr": "ltl-kr",
  "lucky-fast-express": "lucky-fast-express",
  "m-and-p": "m-and-p",
  "m-one": "m-one",
  "m-xpress": "m-xpress",
  "m24-logistics": "m24-logistics",
  "macau-post": "macau-post",
  "madhur-courier": "madhur-courier",
  "maersk-ecommerce": "pilot-freight",
  "magic-trans": "magic-trans",
  "magnum-transportation": "magnum-transportation",
  "magyar-posta": "magyar-posta",
  "mailex": "mailex",
  "mailplus-au": "mailplus-au",
  "mainfreight": "mainfreight",
  "major-express": "major-express",
  "makati-express": "makati-express",
  "maltapost": "maltapost",
  "mandae": "mandae",
  "maple-logistics": "maple-logistics",
  "maritime-ontario": "maritime-ontario",
  "mark-express": "mark-express",
  "maruti-air": "maruti-air",
  "matkahuolto": "matkahuolto",
  "matson": "matson",
  "mauritius-post": "mauritius-post",
  "max-pakket": "max-pakket",
  "maxzeego": "maxzeego",
  "mayiyinfu": "mayiyinfu",
  "mds-collivery": "mds-collivery",
  "meest": "meest",
  "megacity-courier": "megacity-courier",
  "mensajeros-urbanos": "mensajeros-urbanos",
  "meso-global": "meso-global",
  "messenger-cz": "messenger-cz",
  "method": "method",
  "metropolitan-warehouse": "metropolitan-warehouse",
  "mgl-express": "mgl-express",
  "mhi": "mhi",
  "micro-express": "micro-express",
  "midland-transport": "midland-transport",
  "mikropakket": "mikropakket",
  "miller-deliveries": "miller-deliveries",
  "mng-kargo": "dhl",
  "mobel-services": "mobel-services",
  "mobi-logistica": "mobi-logistica",
  "mondial-relay": "mondial-relay",
  "mongol-infinity-post": "mongol-infinity-post",
  "montenegro-post": "montenegro-post",
  "moova": "moova",
  "moovin": "moovin",
  "morning-global": "morning-global",
  "motorex": "motorex",
  "mountain-movers": "mountain-movers",
  "movin": "movin",
  "mrl-global": "mrl-global",
  "mrw": "mrw",
  "multientrega": "multientrega",
  "myanmar-post": "myanmar-post",
  "mylerz": "mylerz",
  "nacex": "nacex",
  "naqel": "naqel",
  "nas-express": "nas-express",
  "nationex": "nationex",
  "ncs-courier": "ncs-courier",
  "nege": "nege",
  "neighbour-express": "neighbour-express",
  "nepal-post": "nepal-post",
  "netpost-vn": "netpost-vn",
  "next-level-delivery": "next-level-delivery",
  "nhat-tin": "nhat-tin",
  "nim-express": "nim-express",
  "ninja-van": "ninja-van",
  "nipost": "nipost",
  "nippon-express": "nippon-express",
  "nk-logistic": "nk-logistic",
  "no-limit": "no-limit",
  "noerpel": "noerpel",
  "noest": "noest",
  "nord-wheel": "nord-wheel",
  "norsk-global": "norsk-global",
  "northline": "northline",
  "nova-global": "nova-poshta",
  "nova-poshta": "nova-poshta",
  "nox": "nox",
  "nz-couriers": "nz-couriers",
  "nz-post": "nz-post",
  "oak-harbor": "oak-harbor",
  "obibox": "obibox",
  "oca": "oca",
  "ocasa": "ocasa",
  "ocs-ana": "ocs-ana",
  "odm-express": "odm-express",
  "okaken": "okaken",
  "okay-parcel": "okay-parcel",
  "old-dominion": "old-dominion",
  "olva-courier": "olva-courier",
  "om-logistics": "om-logistics",
  "omniva": "omniva",
  "ondot-courier": "ondot-courier",
  "one-world-express": "one-world-express",
  "onex": "onex",
  "online-worldwide-logistics": "online-worldwide-logistics",
  "ontask-express": "ontask-express",
  "ontrac": "ontrac",
  "opt-nc": "opt-nc",
  "optima-overnight": "optima-overnight",
  "orian": "orian",
  "orlen-paczka": "orlen-paczka",
  "osm-worldwide": "osm-worldwide",
  "ots-chile": "ots-chile",
  "overnite": "overnite",
  "overseas-express": "overseas-express",
  "ozon-logistics": "ozon-logistics",
  "paack": "paack",
  "pack-man": "pack-man",
  "packeta": "packeta",
  "packli-punkt": "packli-punkt",
  "packs": "packs",
  "pactic": "pactic",
  "pago": "pago",
  "paisley-freight": "paisley-freight",
  "paket-cl": "paket-cl",
  "pakistan-post": "pakistan-post",
  "palletways": "palletways",
  "pallex": "pallex",
  "pandu-logistics": "pandu-logistics",
  "pannon-xp": "pannon-xp",
  "paositra-malagasy": "paositra-malagasy",
  "paperfly": "paperfly",
  "paquetexpress": "paquetexpress",
  "parcel-one": "parcel-one",
  "parcelabc": "parcelabc",
  "parcelforce": "parcelforce",
  "parceljet": "parceljet",
  "parcelpoint": "parcelpoint",
  "pargo": "pargo",
  "parxl": "parxl",
  "pasarex": "pasarex",
  "passport": "passport",
  "pathao-courier": "pathao-courier",
  "patuen": "patuen",
  "pavan-courier": "pavan-courier",
  "paxel": "paxel",
  "paxi": "paxi",
  "pbt": "pbt",
  "pcp-express": "pcp-express",
  "pcs-logistics-vn": "pcs-logistics-vn",
  "pdn-express": "pdn-express",
  "pdq-chile": "pdq-chile",
  "pecom": "pecom",
  "peddler": "peddler",
  "pelican-express": "pelican-express",
  "penguin-box": "penguin-box",
  "pengyou": "pengyou",
  "peninsula-truck-lines": "peninsula-truck-lines",
  "penta-express": "penta-express",
  "peqasus-az": "peqasus-az",
  "peregrine-ship": "peregrine-ship",
  "performance-freight": "performance-freight",
  "peru-box-air": "peru-box-air",
  "pfc-express": "pfc-express",
  "pflogistics": "pflogistics",
  "phlpost": "phlpost",
  "pickupp": "pickupp",
  "pickupp-sg": "pickupp",
  "pigeon-express": "pigeon-express",
  "piggy-express": "piggy-express",
  "pilot-freight": "pilot-freight",
  "pin-ag": "pin-ag",
  "pitney-bowes": "pitney-bowes",
  "pitt-ohio": "pitt-ohio",
  "planzer": "planzer",
  "plycon": "plycon",
  "pmm": "pmm",
  "poczta-polska": "poczta-polska",
  "polaris-transport": "polaris-transport",
  "polonez": "polonez",
  "pony-express": "pony-express",
  "porlor": "porlor",
  "pos-indonesia": "pos-indonesia",
  "pos-malaysia": "pos-malaysia",
  "post-haste": "post-haste",
  "post-luxembourg": "post-luxembourg",
  "post-one": "post-one",
  "posta-e-kosoves": "posta-e-kosoves",
  "posta-faroe": "posta-faroe",
  "posta-kenya": "posta-kenya",
  "posta-moldovei": "posta-moldovei",
  "posta-north-macedonia": "posta-north-macedonia",
  "posta-romana": "posta-romana",
  "posta-shqiptare": "posta-shqiptare",
  "posta-slovenije": "posta-slovenije",
  "posta-srbije": "posta-srbije",
  "postaplus": "postaplus",
  "poste-italiane": "poste-italiane",
  "postex": "postex",
  "posti": "posti",
  "postlogistics": "swiss-post",
  "postmedia-parcel-services": "postmedia-parcel-services",
  "postnord": "postnord",
  "postplus": "postplus",
  "posturinn": "posturinn",
  "ppl": "ppl",
  "precision-deliveries": "precision-deliveries",
  "premier-deliveries-uk": "premier-deliveries-uk",
  "pro-carrier": "pro-carrier",
  "product-care-group": "product-care-group",
  "professional-couriers": "professional-couriers",
  "profit-fields": "profit-fields",
  "promed-delivery": "promed-delivery",
  "prompt-xpress": "prompt-xpress",
  "pronto-lanka": "pronto-lanka",
  "proships": "proships",
  "pts-worldwide-express": "pts-worldwide-express",
  "ptt": "ptt",
  "pullman-cargo": "pullman-cargo",
  "purolator": "purolator",
  "pushpak-courier": "pushpak-courier",
  "pxc-pacific": "pxc-pacific",
  "qatar-post": "qatar-post",
  "qls-quince": "qls-quince",
  "quality-post": "quality-post",
  "quantium-solutions": "quantium-solutions",
  "quick-fort": "quick-fort",
  "quick-rabbit": "quick-rabbit",
  "quickpac": "quickpac",
  "quicksilver-sa": "quicksilver-sa",
  "quiqup": "quiqup",
  "qwintry": "qwintry",
  "raben": "raben",
  "ram-hand-to-hand": "ram-hand-to-hand",
  "rangel": "rangel",
  "rayspeed": "rayspeed",
  "red-express": "red-express",
  "redbox-mv": "redbox-mv",
  "redpack": "redpack",
  "redur": "redur",
  "redx": "redx",
  "relais-colis": "relais-colis",
  "rex-indonesia": "rex-indonesia",
  "rhenus-de": "rhenus-de",
  "rhenus-it": "rhenus-it",
  "rincos": "rincos",
  "rivigo": "rivigo",
  "rl-carriers": "rl-carriers",
  "roadie": "roadie",
  "roadrunner": "roadrunner",
  "rodonaves": "rodonaves",
  "rohlig": "rohlig",
  "ross-express": "ross-express",
  "route1-fulfilment": "route1-fulfilment",
  "royal-express-mm": "royal-express-mm",
  "royal-mail": "royal-mail",
  "royale-international": "royale-international",
  "rozetka-delivery": "rozetka-delivery",
  "rpx-hk": "rpx-hk",
  "rpx-indonesia": "rpx-indonesia",
  "rr-express-sg": "rr-express-sg",
  "rrs-logistics": "rrs-logistics",
  "rtt": "rtt",
  "runner-express": "runner-express",
  "russian-post": "russian-post",
  "rxo": "rxo",
  "ryder-last-mile": "ryder-last-mile",
  "saee": "saee",
  "safeway-express-cargo": "safeway-express-cargo",
  "safexpress": "safexpress",
  "sagawa": "sagawa",
  "sagawa-global": "sagawa-global",
  "sahara-express": "sahara-express",
  "saia": "saia",
  "sailpost": "sailpost",
  "sameday": "sameday",
  "samoa-post": "samoa-post",
  "sapx-express": "sapx-express",
  "sat-ukraine": "sat-ukraine",
  "saudi-post": "saudi-post",
  "savar-express": "savar-express",
  "sbs-sokuhai": "sbs-sokuhai",
  "scg-express": "scg-express",
  "schneider": "schneider",
  "seabourne-logistics": "seabourne-logistics",
  "seino": "seino",
  "seino-super-express": "seino-super-express",
  "seko": "seko",
  "sendex": "sendex",
  "sending": "sending",
  "sengi-express": "sengi-express",
  "sentral-cargo": "sentral-cargo",
  "senyu": "senyu",
  "serpost": "serpost",
  "servex": "servex",
  "servientrega": "servientrega",
  "seur": "seur",
  "seven-eleven-tw": "seven-eleven-tw",
  "sf-express": "sf-express",
  "sfc": "sfc",
  "sfyd-express": "sfyd-express",
  "sgk-home-delivery": "sgk-home-delivery",
  "shadowfax": "shadowfax",
  "shalom-pe": "shalom-pe",
  "shenghang": "shenghang",
  "shipa": "shipa",
  "shipblu": "shipblu",
  "shipentegra": "shipentegra",
  "shipgce": "shipgce",
  "shipglobal-in": "shipglobal-in",
  "shipglobal-us": "shipglobal-us",
  "shippify": "shippify",
  "shiprocket": "shiprocket",
  "shipter": "shipter",
  "shipup": "shipup",
  "shipx-asia": "shipx-asia",
  "shouwu": "shouwu",
  "showl": "showl",
  "shree-anjani": "shree-anjani",
  "shree-mahabali-express": "shree-mahabali-express",
  "shree-mahavir": "shree-mahavir",
  "shree-maruti": "shree-maruti",
  "shree-nandan": "shree-nandan",
  "shunbang-express": "shunbang-express",
  "sicepat": "sicepat",
  "singapore-post": "singapore-post",
  "sjl-express": "sjl-express",
  "skladusa": "skladusa",
  "skroutz-last-mile": "skroutz-last-mile",
  "skybox": "skybox",
  "skyex-ae": "skyex-ae",
  "skyking": "skyking",
  "skynet-sa": "skynet-worldwide",
  "skynet-worldwide": "skynet-worldwide",
  "skypostal": "skypostal",
  "slgtrax": "slgtrax",
  "slovak-parcel-service": "slovak-parcel-service",
  "slovenska-posta": "slovenska-posta",
  "sm-express": "sm-express",
  "smsa-express": "smsa-express",
  "sol-express": "sol-express",
  "sorthub": "sorthub",
  "south-african-post-office": "south-african-post-office",
  "southeastern-freight-lines": "southeastern-freight-lines",
  "southwestern-motor-transport": "southwestern-motor-transport",
  "sp-express": "sp-express",
  "spark-kz": "spark-kz",
  "spee-dee": "spee-dee",
  "speed-and-safe": "speed-and-safe",
  "speedex": "speedex",
  "speedpak": "speedpak",
  "speedx": "speedx",
  "speedy": "speedy",
  "spfly": "spfly",
  "spring-gds": "postnl",
  "spt-logistics": "spt-logistics",
  "sptexp": "sptexp",
  "spx-br": "spx",
  "spx-id": "spx",
  "spx-my": "spx",
  "spx-ph": "spx",
  "spx-sg": "spx",
  "spx-th": "spx",
  "spx-tw": "spx",
  "spx-vn": "spx",
  "sri-lanka-post": "sri-lanka-post",
  "st-courier": "st-courier",
  "stallion-express": "stallion-express",
  "starex-az": "starex-az",
  "starken": "starken",
  "starlinks": "starlinks",
  "starlinks-global": "starlinks-global",
  "steadfast": "steadfast",
  "stg-ltl": "stg-ltl",
  "sto": "sto",
  "stop-start": "stop-start",
  "straightship": "straightship",
  "sumxpress": "sumxpress",
  "sundarban-courier": "sundarban-courier",
  "suning-logistics": "suning-logistics",
  "sunyou": "sunyou",
  "super-parcel-track": "super-parcel-track",
  "superb-express": "superb-express",
  "surat-kargo": "surat-kargo",
  "suto-logistics": "suto-logistics",
  "svuum": "svuum",
  "sway": "sway",
  "swftbox": "swftbox",
  "swiftx": "swiftx",
  "swiss-post": "swiss-post",
  "swiss-post-cargo": "swiss-post",
  "sxjd-freight": "sxjd-freight",
  "syd": "syd",
  "t-cat": "t-cat",
  "t-group": "t-group",
  "takesend": "takesend",
  "tamex": "tamex",
  "tanzania-posts": "tanzania-posts",
  "tapuz-delivery": "tapuz-delivery",
  "taqbin-hk": "taqbin-hk",
  "taqbin-sg": "taqbin-sg",
  "tas-courier": "tas-courier",
  "tawssil": "tawssil",
  "taxydema": "taxydema",
  "tcc-co": "tcc-co",
  "tccs": "tccs",
  "tci-express": "tci-express",
  "tcs-pakistan": "tcs-pakistan",
  "tdn": "tdn",
  "tealca": "tealca",
  "team-express-ae": "team-express-ae",
  "team-global-express": "team-global-express",
  "team-worldwide": "team-worldwide",
  "techlink": "techlink",
  "tej-couriers": "tej-couriers",
  "teleship": "teleship",
  "tfm-express": "tfm-express",
  "tforce-freight": "tforce-freight",
  "tforce-integrated-solutions": "tforce-integrated-solutions",
  "tforce-logistics": "tforce-logistics",
  "thabit-logistics": "thabit-logistics",
  "thailand-post": "thailand-post",
  "the-courier-guy": "the-courier-guy",
  "the-human-express": "the-human-express",
  "thelorry": "thelorry",
  "thhy": "thhy",
  "tig-freight": "tig-freight",
  "tiki": "tiki",
  "timely-titan": "timely-titan",
  "tinypack": "tinypack",
  "tipsa": "tipsa",
  "tirupati-courier": "tirupati-courier",
  "tiui": "tiui",
  "tmm-express": "tmm-express",
  "tnt": "tnt",
  "tnt-au": "tnt",
  "tnt-it": "tnt",
  "today-kr": "today-kr",
  "togo-post": "togo-post",
  "tolos": "tolos",
  "tonami": "tonami",
  "tonda-global": "tonda-global",
  "too-express": "too-express",
  "top-logistics-au": "top-logistics-au",
  "topdelivery": "topdelivery",
  "topex-logistics": "topex-logistics",
  "topnic": "topnic",
  "toptrans": "toptrans",
  "torrestir": "torrestir",
  "total-express": "total-express",
  "toyou": "toyou",
  "tp-logistics-th": "tp-logistics-th",
  "tpl-rider": "tpl-rider",
  "trackon": "trackon",
  "tracx-logis": "tracx-logis",
  "trans-o-flex": "trans-o-flex",
  "trans-ontario": "trans-ontario",
  "transaher": "transaher",
  "transcorp": "transcorp",
  "transfera": "transfera",
  "transmission": "transmission",
  "transnatur": "transnatur",
  "transport-rdl": "transport-rdl",
  "trendyol-express": "trendyol-express",
  "trexity": "trexity",
  "tsb-es": "tsb-es",
  "tsjy": "tsjy",
  "tst-cf-express": "tst-cf-express",
  "ttk-europe": "ttk-europe",
  "tufesa": "tufesa",
  "tuodatong": "tuodatong",
  "turkmenpost": "turkmenpost",
  "tusass": "tusass",
  "tusk-logistics": "tusk-logistics",
  "tusou": "tusou",
  "tws-express": "tws-express",
  "u-envios": "u-envios",
  "ubi-smart-parcel": "ubi-smart-parcel",
  "ubx-uk": "ubx-uk",
  "ues-uy": "ues-uy",
  "ukp-worldwide": "ukp-worldwide",
  "ukrposhta": "ukrposhta",
  "union-express": "union-express",
  "united-delivery-service": "united-delivery-service",
  "united-worldwide-couriers": "united-worldwide-couriers",
  "uniuni": "uniuni",
  "uof-express": "uof-express",
  "uparcel": "uparcel",
  "upaya": "upaya",
  "ups": "ups",
  "ural-express": "ural-express",
  "urbano": "urbano",
  "urvaam": "urvaam",
  "us-cargo": "us-cargo",
  "usasd": "usasd",
  "usps": "usps",
  "utec-logistics": "utec-logistics",
  "uvan": "uvan",
  "uzbekistan-post": "uzbekistan-post",
  "v-xpress": "v-xpress",
  "valmo": "valmo",
  "value-logistics": "value-logistics",
  "valueway": "valueway",
  "vasp-expresso": "vasp-expresso",
  "vatican-post": "vatican-post",
  "veho": "veho",
  "veloces": "veloces",
  "venipak": "venipak",
  "vert-chez-vous": "vert-chez-vous",
  "vestovoy": "vestovoy",
  "via-cargo": "via-cargo",
  "viadireta": "viadireta",
  "viaxpress": "viaxpress",
  "victorian-freight-specialists": "victorian-freight-specialists",
  "viet-an-express": "viet-an-express",
  "viettel-post": "viettel-post",
  "vimenpaq": "vimenpaq",
  "vinted-go": "vinted-go",
  "vip-posta": "vip-posta",
  "vitran-express": "vitran-express",
  "vnlin": "vnlin",
  "vnpost": "vnpost",
  "vozovoz": "vozovoz",
  "vrl-logistics": "vrl-logistics",
  "vt-freight-express": "vt-freight-express",
  "w-express-ph": "w-express-ph",
  "wahana": "wahana",
  "wanbexpress": "wanbexpress",
  "wangjing-3cq": "wangjing-3cq",
  "ward-trucking": "ward-trucking",
  "wassel": "wassel",
  "we-world-express": "we-world-express",
  "wedo": "allegro-one",
  "welivery": "welivery",
  "wepost": "wepost",
  "western-bid": "western-bid",
  "whistl": "whistl",
  "whiz-delivery": "whiz-delivery",
  "widect": "widect",
  "wiio": "wiio",
  "winion-logis": "winion-logis",
  "winit": "winit",
  "wise-express": "wise-express",
  "wizmo": "wizmo",
  "wld-express": "wld-express",
  "wooliiporter": "wooliiporter",
  "world-package": "world-package",
  "wp-ground": "wp-ground",
  "x-express-ba": "x-express-ba",
  "x-trac": "x-trac",
  "xcargo": "xcargo",
  "xd-express": "xd-express",
  "xde-logistics": "xde-logistics",
  "xdp": "xdp",
  "xgs": "xgs",
  "xinghe-freight": "xinghe-freight",
  "xingyunyi": "xingyunyi",
  "xlcourier": "xlcourier",
  "xlmiles": "xlmiles",
  "xpect-same-day": "xpect-same-day",
  "xpo-ltl": "xpo-ltl",
  "xpress-courier-link": "xpress-courier-link",
  "xpressbees": "xpressbees",
  "xpressen": "xpressen",
  "xyl": "xyl",
  "yalidine": "yalidine",
  "yamato": "yamato",
  "yamato-america": "yamato",
  "yanwen": "yanwen",
  "yc-delivery": "yc-delivery",
  "ycs-logistics": "ycs-logistics",
  "ydh": "ydh",
  "yha": "yha",
  "yilong-logistics": "yilong-logistics",
  "yimidida": "yimidida",
  "yingtu": "yingtu",
  "yoseus": "yoseus",
  "youbang-express": "youbang-express",
  "yto": "yto",
  "yuema-express": "yuema-express",
  "yunda": "yunda",
  "yunexpress": "yunexpress",
  "yurtici-kargo": "yurtici-kargo",
  "ywe": "ywe",
  "zajel": "zajel",
  "zajil": "zajil",
  "zeleris": "zeleris",
  "zes-express": "zes-express",
  "zheldor": "zheldor",
  "zimpost": "zimpost",
  "zippd": "zippd",
  "znlogic": "znlogic",
  "zoom-ve": "zoom-ve",
  "zr-express": "zr-express",
  "zto": "zto",
  "zto-international": "zto"
};

export const CARRIER_TRUCK: TruckGeometry = {
  "viewBox": {
    "width": 32,
    "height": 21
  },
  "strokeWidth": 0.6,
  "body": {
    "x": 2,
    "y": 3,
    "width": 18,
    "height": 13,
    "rx": 1.3,
    "fill": "truck",
    "stroke": "edge"
  },
  "cab": {
    "d": "M20 8h5l5 5v3H20Z",
    "fill": "truck",
    "stroke": "edge"
  },
  "windshield": {
    "d": "M22 9.5h2.5l3 3H22Z",
    "fill": "#edf1ee",
    "dark": "#fff0ba"
  },
  "wheels": {
    "centers": [[8, 16.5], [25, 16.5]],
    "tire": {
      "r": 2.4,
      "fill": "#42483d",
      "dark": "#0e0d0a",
      "rim": "#fff4dc",
      "rimOpacity": 0.29,
      "rimWidth": 0.45
    },
    "hub": {
      "r": 0.9,
      "fill": "#d2d4c7"
    }
  },
  "decals": {
    "default": [
      {
        "type": "line",
        "d": "M5 9h8",
        "stroke": "accent",
        "strokeWidth": 2
      },
      {
        "type": "circle",
        "cx": 15,
        "cy": 9,
        "r": 1.1,
        "fill": "accent"
      }
    ],
    "dhl": [
      {
        "type": "line",
        "d": "M4 8h12M3 10h12",
        "stroke": "accent",
        "strokeWidth": 1.1
      }
    ],
    "ups": [
      {
        "type": "polygon",
        "d": "M6.8 5.2L7.831 5.006L8.801 4.873L9.741 4.79L10.894 4.75L11.978 4.774L13.024 4.854L14.064 4.989L15.198 5.2L15.199 9.219L15.113 10.018L14.914 10.724L14.62 11.358L14.19 11.995L13.692 12.533L13.068 13.04L12.413 13.442L11.682 13.776L10.984 13.996L10.19 13.725L9.375 13.324L8.626 12.81L8.015 12.236L7.583 11.686L7.267 11.143L7.018 10.528L6.857 9.848L6.8 9.151Z",
        "fill": "accent"
      },
      {
        "type": "polygon",
        "d": "M7.9 6.1L9.387 5.881L10.888 5.8L12.425 5.863L14.086 6.097L14.1 9.163L14.014 9.927L13.825 10.526L13.568 11.022L13.189 11.524L12.76 11.935L11.949 12.481L10.99 12.896L10.312 12.615L9.702 12.274L9.144 11.853L8.706 11.402L8.458 11.064L8.208 10.603L8.031 10.11L7.944 9.7L7.9 9.142Z",
        "fill": "truck"
      }
    ],
    "fedex": [
      {
        "type": "polygon",
        "d": "M5.6 8.17L11.9 8.17L11.9 6.37L16.4 9.25L11.9 12.13L11.9 10.33L5.6 10.33Z",
        "fill": "accent"
      }
    ],
    "dpd": [
      {
        "type": "line",
        "d": "M10.5 5L15.5 7.5L15.5 11.5L10.5 14L5.5 11.5L5.5 7.5L10.5 5M5.5 7.5L10.5 10L15.5 7.5M10.5 10L10.5 14M8 6.25L13 8.75",
        "stroke": "accent",
        "strokeWidth": 1
      }
    ],
    "amazon": [
      {
        "type": "polygon",
        "d": "M4.5 8.6L5.74 9.385L7.006 9.979L8.239 10.37L9.513 10.59L10.315 10.636L11.084 10.614L11.849 10.529L12.672 10.368L13.48 10.14L14.268 9.851L14.939 9.553L15.803 9.105L16.197 9.803L15.559 10.292L14.847 10.736L14.157 11.076L13.337 11.378L12.557 11.573L11.796 11.684L10.888 11.722L10.085 11.674L9.153 11.527L8.206 11.278L7.223 10.911L6.281 10.45L5.3 9.843L4.388 9.138L4.29 8.994L4.276 8.857L4.339 8.733Z",
        "fill": "accent"
      },
      {
        "type": "polygon",
        "d": "M13.5 8.7L14.404 8.434L15.268 8.311L16.105 8.314L17 8.453L16.985 9.29L16.86 10.012L16.591 10.805L16.202 11.547L15.938 9.446Z",
        "fill": "accent"
      }
    ],
    "japan-post": [
      {
        "type": "line",
        "d": "M6 6L16 6M6 9L16 9M11 9L11 14",
        "stroke": "accent",
        "strokeWidth": 1.5
      }
    ],
    "swiss-post": [
      {
        "type": "polygon",
        "d": "M6 6L8 6L8 8L10 8L10 10L8 10L8 12L6 12L6 10L4 10L4 8L6 8Z",
        "fill": "#e30613"
      },
      {
        "type": "polygon",
        "d": "M11.5 5.5L16 5.5L18 7L18 9L16 10.5L13.5 10.5L13.5 13L11.5 13Z",
        "fill": "accent"
      },
      {
        "type": "polygon",
        "d": "M13.5 7.2L15.5 7.2L16 7.7L16 8.3L15.5 8.8L13.5 8.8Z",
        "fill": "truck"
      }
    ],
    "quickpac": [
      {
        "type": "circle",
        "cx": 10.8,
        "cy": 9,
        "r": 3.6,
        "fill": "accent"
      },
      {
        "type": "circle",
        "cx": 10.8,
        "cy": 9,
        "r": 2.3,
        "fill": "truck"
      },
      {
        "type": "polygon",
        "d": "M11.4 10.1L12.2 9.6L14.7 12.6L13.9 13.2Z",
        "fill": "accent"
      },
      {
        "type": "line",
        "d": "M3.5 7.5L5.8 7.5M3.5 10.5L5.8 10.5",
        "stroke": "accent",
        "strokeWidth": 1
      }
    ],
    "la-poste": [
      {
        "type": "polygon",
        "d": "M7.171 6.31L10.226 7.696L14.86 7.696L14.895 7.687L15.293 6.994L15.337 6.883L15.358 6.765L15.356 6.645L15.329 6.529L15.28 6.42L15.21 6.323L15.053 6.2L14.942 6.157L14.823 6.14L7.193 6.14L7.155 6.151L7.112 6.215L7.116 6.254Z",
        "fill": "accent"
      },
      {
        "type": "polygon",
        "d": "M10.22 8.29L17.81 8.29L17.889 8.302L17.955 8.346L18 8.454L17.966 8.567L17.906 8.618L17.83 8.642L4.14 12.349L4.062 12.357L4.006 12.304L4 12.264L4.042 12.2Z",
        "fill": "accent"
      },
      {
        "type": "polygon",
        "d": "M6.376 12.36L11.413 12.266L11.728 12.216L11.955 12.138L12.169 12.03L12.334 11.918L12.512 11.757L12.658 11.568L13.277 10.494Z",
        "fill": "accent"
      }
    ],
    "chronopost": [
      {
        "type": "polygon",
        "d": "M11 4.25L15.031 6.377L15.024 6.397L12.236 7.961L12.244 8.628L15.262 7.063L15.27 7.089L15.27 11.448L15.248 11.606L15.185 11.752L15.086 11.878L14.931 12.004L11.008 14.246L6.786 11.811L6.73 11.763L6.735 7.174L10.54 9.3L10.551 12.653L10.586 12.72L10.729 12.86L10.83 12.924L10.945 12.957L11.025 12.953L11.135 12.907L11.226 12.829L11.322 12.702L11.337 12.666L11.337 8.987L11.318 8.958L6.846 6.387Z",
        "fill": "accent"
      },
      {
        "type": "polygon",
        "d": "M6.73 7.171L10.496 9.275L10.551 9.323L10.551 12.678L10.619 12.822L10.729 12.937L10.836 12.99L10.993 13.014L11 14.245L7.167 12.032L6.73 11.764Z",
        "fill": "#0085b8"
      }
    ],
    "india-post": [
      {
        "type": "polygon",
        "d": "M4 7.6L4.453 7.569L4.942 7.599L5.386 7.693L5.781 7.836L6.244 8.082L6.645 8.363L8.125 9.698L8.781 10.162L9.13 10.324L9.534 10.437L9.916 10.474L10.335 10.446L10.744 10.353L11.171 10.199L12.414 9.558L13.685 8.754L16.698 6.715L17.998 5.902L14.942 8.625L13.999 9.406L13.134 10.061L12.289 10.621L11.583 11.006L10.838 11.308L10.259 11.443L9.806 11.464L9.355 11.404L8.922 11.267L8.424 11.014L7.963 10.696L7.533 10.338L6.07 8.933L5.406 8.363L4.677 7.883Z",
        "fill": "accent"
      },
      {
        "type": "polygon",
        "d": "M3.8 9.7L4.287 9.657L4.706 9.682L5.117 9.765L5.611 9.941L6.495 10.438L8.074 11.537L8.533 11.792L9.016 11.995L9.766 12.161L10.185 12.175L10.603 12.137L11.183 12.005L11.774 11.79L12.375 11.506L13.166 11.057L14.364 10.268L16.945 8.404L18.188 7.557L15.392 10.162L14.325 11.067L13.548 11.663L12.676 12.248L11.91 12.668L11.099 12.994L10.419 13.158L9.931 13.196L9.41 13.145L8.937 13.016L8.395 12.774L7.518 12.199L6.004 10.956L5.245 10.394L4.518 9.975Z",
        "fill": "accent"
      }
    ],
    "mondial-relay": [
      {
        "type": "polygon",
        "d": "M7.527 4.534L8.715 4.374L10.07 4.272L11.308 4.254L12.466 4.302L13.501 4.398L14.686 4.575L14.951 4.663L15.164 4.773L15.358 4.914L15.527 5.084L15.665 5.279L15.785 5.532L15.858 5.802L15.885 6.08L15.885 12.394L15.853 12.752L15.764 13.058L15.609 13.337L15.392 13.571L15.164 13.732L14.876 13.871L14.611 13.959L14.295 14.01L13.462 14.115L12.587 14.193L11.749 14.236L10.869 14.248L9.991 14.226L9.113 14.17L8.199 14.076L7.368 13.959L7.134 13.908L6.873 13.808L6.667 13.685L6.488 13.526L6.343 13.335L6.235 13.122L6.155 12.854L6.117 12.537L6.127 5.903L6.194 5.591L6.285 5.369L6.41 5.165L6.566 4.984L6.783 4.807L6.991 4.689L7.253 4.591Z",
        "fill": "accent"
      },
      {
        "type": "polygon",
        "d": "M9.052 12.554L9.055 9.756L9.079 9.517L9.127 9.283L9.201 9.054L9.32 8.802L9.499 8.537L9.721 8.308L10.013 8.098L10.264 7.974L10.606 7.864L10.881 7.816L11.16 7.799L11.76 7.81L11.762 9.046L11.089 9.056L10.854 9.098L10.708 9.162L10.611 9.232L10.507 9.354L10.435 9.496L10.382 9.688L10.352 9.966L10.349 11.764Z",
        "fill": "#ffffff"
      },
      {
        "type": "polygon",
        "d": "M12.779 7.753L12.54 7.762L12.304 7.8L12.193 7.844L12.111 7.928L12.109 9.041L12.155 9.105L12.223 9.147L12.336 9.184L12.533 9.213L13.011 9.215L13.209 9.193L13.364 9.154L13.467 9.095L13.509 9.029L13.513 7.993L13.496 7.916L13.406 7.84L13.255 7.791Z",
        "fill": "#f5a9bb"
      },
      {
        "type": "circle",
        "cx": 10.52,
        "cy": 6.567,
        "r": 0.734,
        "fill": "#ffffff"
      }
    ],
    "postnl": [
      {
        "type": "polygon",
        "d": "M5.96 8.2L8.48 9.88L11 6.52L13.52 9.88L16.04 8.2L14.36 12.4L7.64 12.4Z",
        "fill": "accent"
      },
      {
        "type": "circle",
        "cx": 5.96,
        "cy": 6.52,
        "r": 0.756,
        "fill": "accent"
      },
      {
        "type": "circle",
        "cx": 11,
        "cy": 5.26,
        "r": 0.756,
        "fill": "accent"
      },
      {
        "type": "circle",
        "cx": 16.04,
        "cy": 6.52,
        "r": 0.756,
        "fill": "accent"
      }
    ],
    "usps": [
      {
        "type": "polygon",
        "d": "M5.91 10.7L8 4.9L16.8 4.9L14.71 10.7Z",
        "fill": "accent"
      },
      {
        "type": "polygon",
        "d": "M7.85 6.06L12.51 6.06L14.41 6.64L15.37 8.15L13.71 7.63L12.36 7.45L7.35 7.45Z",
        "fill": "truck"
      },
      {
        "type": "polygon",
        "d": "M7.01 8.38L11.32 8.38L12.39 8.84L9.72 9.89L6.47 9.89Z",
        "fill": "truck"
      },
      {
        "type": "line",
        "d": "M2.3 12.4L19.7 12.4",
        "stroke": "#e71921",
        "strokeWidth": 0.6
      },
      {
        "type": "line",
        "d": "M2.3 13.3L19.7 13.3",
        "stroke": "accent",
        "strokeWidth": 0.8
      }
    ],
    "royal-mail": [
      {
        "type": "polygon",
        "d": "M7.3 12.6L7.3 11.1L6.81 10.41L6.53 9.63L6.45 8.83L6.58 8.05L6.9 7.35L7.41 6.77L8.11 6.37L9 6.2L9.68 6.27L10.23 6.46L10.66 6.75L11 7.1L11.34 6.75L11.78 6.46L12.32 6.27L13 6.2L13.89 6.37L14.59 6.77L15.1 7.35L15.43 8.05L15.55 8.83L15.48 9.63L15.19 10.41L14.7 11.1L14.7 12.6Z",
        "fill": "accent"
      },
      {
        "type": "polygon",
        "d": "M8.3 10.7L7.5 9.5L7.6 8.1L8.6 7.25L9.8 7.3L10.45 7.9L10.45 10.7Z",
        "fill": "truck"
      },
      {
        "type": "polygon",
        "d": "M11.55 10.7L11.55 7.9L12.2 7.3L13.4 7.25L14.4 8.1L14.5 9.5L13.7 10.7Z",
        "fill": "truck"
      },
      {
        "type": "polygon",
        "d": "M10.65 3.9L11.35 3.9L11.35 4.5L11.9 4.5L11.9 5.2L11.35 5.2L11.35 7.2L10.65 7.2L10.65 5.2L10.1 5.2L10.1 4.5L10.65 4.5Z",
        "fill": "accent"
      }
    ],
    "canada-post": [
      {
        "type": "polygon",
        "d": "M2.3 6.6L19.7 6.6L19.7 11.8L2.3 11.8Z",
        "fill": "edge"
      },
      {
        "type": "polygon",
        "d": "M15.7 9.2L15.58 10.07L15.23 10.89L14.67 11.63L13.93 12.25L13.04 12.71L12.05 13L11 13.1L9.95 13L8.96 12.71L8.07 12.25L7.33 11.63L6.77 10.89L6.42 10.07L6.3 9.2L6.42 8.33L6.77 7.51L7.33 6.77L8.07 6.15L8.96 5.69L9.95 5.4L11 5.3L12.05 5.4L13.04 5.69L13.93 6.15L14.67 6.77L15.23 7.51L15.58 8.33Z",
        "fill": "truck"
      },
      {
        "type": "polygon",
        "d": "M15 9.2L14.9 9.92L14.6 10.61L14.13 11.23L13.49 11.74L12.74 12.13L11.89 12.37L11 12.45L10.11 12.37L9.26 12.13L8.51 11.74L7.87 11.23L7.4 10.61L7.1 9.92L7 9.2L7.1 8.48L7.4 7.79L7.87 7.17L8.51 6.66L9.26 6.27L10.11 6.03L11 5.95L11.89 6.03L12.74 6.27L13.49 6.66L14.13 7.17L14.6 7.79L14.9 8.48Z",
        "fill": "accent"
      },
      {
        "type": "polygon",
        "d": "M8.3 7.4L14.1 9.2L8.3 11L10.1 9.2Z",
        "fill": "truck"
      }
    ],
    "australia-post": [
      {
        "type": "circle",
        "cx": 11,
        "cy": 9.3,
        "r": 4.9,
        "fill": "accent"
      },
      {
        "type": "circle",
        "cx": 11,
        "cy": 9.3,
        "r": 4.3,
        "fill": "truck"
      },
      {
        "type": "circle",
        "cx": 11.5,
        "cy": 8.4,
        "r": 2,
        "fill": "accent"
      },
      {
        "type": "polygon",
        "d": "M9.5 8.4L10.75 8.4L10.75 12.4L9.5 12.4Z",
        "fill": "accent"
      },
      {
        "type": "circle",
        "cx": 11.5,
        "cy": 8.4,
        "r": 0.95,
        "fill": "truck"
      }
    ],
    "tnt": [
      {
        "type": "circle",
        "cx": 5.8,
        "cy": 9.2,
        "r": 2.6,
        "fill": "accent"
      },
      {
        "type": "circle",
        "cx": 11,
        "cy": 9.2,
        "r": 2.6,
        "fill": "accent"
      },
      {
        "type": "circle",
        "cx": 16.2,
        "cy": 9.2,
        "r": 2.6,
        "fill": "accent"
      },
      {
        "type": "circle",
        "cx": 5.8,
        "cy": 9.2,
        "r": 1.95,
        "fill": "truck"
      },
      {
        "type": "circle",
        "cx": 11,
        "cy": 9.2,
        "r": 1.95,
        "fill": "truck"
      },
      {
        "type": "circle",
        "cx": 16.2,
        "cy": 9.2,
        "r": 1.95,
        "fill": "truck"
      },
      {
        "type": "line",
        "d": "M4.8 8.2L6.8 8.2M5.8 8.2L5.8 10.4M10.1 10.4L10.1 8L11.9 10.4L11.9 8M15.2 8.2L17.2 8.2M16.2 8.2L16.2 10.4",
        "stroke": "accent",
        "strokeWidth": 0.7
      }
    ],
    "correos": [
      {
        "type": "polygon",
        "d": "M16.6 8.7L16.53 9.51L16.33 10.31L15.99 11.06L15.53 11.76L14.96 12.38L14.29 12.91L13.54 13.33L12.73 13.65L11.88 13.84L11 13.9L10.12 13.84L9.27 13.65L8.46 13.33L7.71 12.91L7.04 12.38L6.47 11.76L6.01 11.06L5.67 10.31L5.47 9.51L5.4 8.7Z",
        "fill": "accent"
      },
      {
        "type": "circle",
        "cx": 11,
        "cy": 9.9,
        "r": 3.1,
        "fill": "truck"
      },
      {
        "type": "circle",
        "cx": 11,
        "cy": 9.9,
        "r": 2.3,
        "fill": "accent"
      },
      {
        "type": "circle",
        "cx": 11,
        "cy": 9.9,
        "r": 1.45,
        "fill": "truck"
      },
      {
        "type": "circle",
        "cx": 11,
        "cy": 9.9,
        "r": 0.65,
        "fill": "accent"
      },
      {
        "type": "polygon",
        "d": "M8.7 6.9L8.7 5.5L9.5 4.9L10.3 5.5L11 4.9L11.7 5.5L12.5 4.9L13.3 5.5L13.3 6.9Z",
        "fill": "accent"
      },
      {
        "type": "line",
        "d": "M11 3.6L11 4.9M10.4 4.1L11.6 4.1",
        "stroke": "accent",
        "strokeWidth": 0.5
      }
    ],
    "yamato": [
      {
        "type": "polygon",
        "d": "M6.4 5L9.2 7.5L12 5L13.4 7.7L15.8 7.7L15.8 11.6L13.6 11.6L12.4 10.2L11.2 11.6L9.6 11.6L8.4 13.2L6.4 13.2Z",
        "fill": "accent"
      }
    ],
    "china-post": [
      {
        "type": "polygon",
        "d": "M11.14 4.6L12.34 4.6L10.86 13.8L9.66 13.8Z",
        "fill": "accent"
      },
      {
        "type": "line",
        "d": "M4.77 6.9L14.97 6.9L14.33 10.9L5.33 10.9M8.37 6.9L7.73 10.9M5.05 8.9L8.05 8.9M7.94 13.3L12.74 13.3",
        "stroke": "accent",
        "strokeWidth": 1
      }
    ],
    "inpost": [
      {
        "type": "circle",
        "cx": 12.8,
        "cy": 9.2,
        "r": 3,
        "fill": "accent"
      },
      {
        "type": "circle",
        "cx": 13.600000000000001,
        "cy": 9.2,
        "r": 2.8,
        "fill": "truck"
      },
      {
        "type": "line",
        "d": "M9 9.2L6.2 9.2M9.41 7.47L7.45 6.48M9.41 10.93L7.45 11.92M10.57 6.13L9.51 4.67M10.57 12.27L9.51 13.73M12.21 5.45L12.02 4.26M12.21 12.95L12.02 14.14",
        "stroke": "accent",
        "strokeWidth": 0.6
      }
    ],
    "bpost": [
      {
        "type": "polygon",
        "d": "M16.6 5L15.24 5.16L13.82 5.38L12.39 5.67L10.99 6.03L9.66 6.46L8.44 6.94L7.39 7.48L6.53 8.08L5.92 8.74L5.6 9.45L5.6 10.42L5.77 11.25L6.08 11.92L6.51 12.43L7.05 12.8L7.67 13.03L8.35 13.1L9.27 13.05L10.16 12.9L10.99 12.66L11.76 12.34L12.44 11.95L13 11.5L12.19 11.66L11.41 11.62L10.71 11.38L10.16 10.95L9.8 10.35L9.91 9.68L10.37 8.97L11.12 8.23L12.08 7.49L13.17 6.77L14.34 6.1L15.51 5.5Z",
        "fill": "accent"
      },
      {
        "type": "polygon",
        "d": "M7.9 8L7.54 8.89L7.46 9.75L7.66 10.53L8.14 11.19L8.88 11.69L9.9 12L9.18 11.55L8.63 11.01L8.23 10.38L7.97 9.66L7.87 8.87Z",
        "fill": "truck"
      }
    ],
    "austrian-post": [
      {
        "type": "line",
        "d": "M5.2 5.7L6.4 5.7L7.2 7.9L4 5.7L5.2 5.7M13 5.7L18.4 5.7L17.95 6.81L17.41 7.93L16.78 9.01L16.08 10.03L15.33 10.94L14.52 11.72L13.67 12.33L12.79 12.74L11.9 12.9L11.07 12.77L10.39 12.41L9.85 11.84L9.45 11.1L9.2 10.2L8.2 5.7L13 5.7M11.8 5.7L11.28 7L11.01 8.17L10.96 9.16L11.13 9.93L11.48 10.42L12 10.6L12.73 10.47L13.43 10.13L14.09 9.6L14.7 8.94L15.28 8.19L15.8 7.4",
        "stroke": "accent",
        "strokeWidth": 0.75
      }
    ],
    "hermes": [
      {
        "type": "polygon",
        "d": "M4.6 5.6L17 5.6L16.56 6.85L4.16 6.85Z",
        "fill": "accent"
      },
      {
        "type": "polygon",
        "d": "M6.24 7.5L16.34 7.5L15.9 8.75L5.8 8.75Z",
        "fill": "accent"
      },
      {
        "type": "polygon",
        "d": "M7.87 9.4L15.67 9.4L15.23 10.65L7.43 10.65Z",
        "fill": "accent"
      },
      {
        "type": "polygon",
        "d": "M9.51 11.3L15.01 11.3L14.57 12.55L9.07 12.55Z",
        "fill": "accent"
      }
    ],
    "nova-poshta": [
      {
        "type": "polygon",
        "d": "M11 4.4L13.2 6.8L11.9 6.8L11.9 11.6L13.2 11.6L11 14L8.8 11.6L10.1 11.6L10.1 6.8L8.8 6.8Z",
        "fill": "accent"
      },
      {
        "type": "polygon",
        "d": "M9.1 7.4L9.1 11L6.5 9.2Z",
        "fill": "accent"
      },
      {
        "type": "polygon",
        "d": "M12.9 7.4L15.5 9.2L12.9 11Z",
        "fill": "accent"
      }
    ],
    "korea-post": [
      {
        "type": "polygon",
        "d": "M4.6 5L12.6 5L8.5 11.2L11.4 11.2L12.5 12.3L11.4 13.4L3.4 13.4L7.5 7.2L4.6 7.2L5.7 6.1Z",
        "fill": "accent"
      },
      {
        "type": "line",
        "d": "M13.3 7.8L14.6 9.2L13.3 10.6",
        "stroke": "accent",
        "strokeWidth": 0.8
      },
      {
        "type": "line",
        "d": "M15 7.8L16.3 9.2L15 10.6",
        "stroke": "#ffb347",
        "strokeWidth": 0.8
      },
      {
        "type": "line",
        "d": "M16.7 7.8L18 9.2L16.7 10.6",
        "stroke": "#ffd84d",
        "strokeWidth": 0.8
      }
    ],
    "nz-post": [
      {
        "type": "circle",
        "cx": 11,
        "cy": 9.3,
        "r": 4.9,
        "fill": "accent"
      },
      {
        "type": "circle",
        "cx": 11,
        "cy": 9.3,
        "r": 4.4,
        "fill": "truck"
      },
      {
        "type": "line",
        "d": "M8.8 12.5L8.8 11L11.6 11L12.31 10.89L12.95 10.56L13.46 10.05L13.79 9.41L13.9 8.7L13.79 7.99L13.46 7.35L12.95 6.84L12.31 6.51L11.6 6.4L8.1 6.4M9.8 12.5L9.8 10L11.6 10L12 9.94L12.36 9.75L12.65 9.46L12.84 9.1L12.9 8.7L12.84 8.3L12.65 7.94L12.36 7.65L12 7.46L11.6 7.4L8.1 7.4",
        "stroke": "accent",
        "strokeWidth": 0.6
      }
    ],
    "poczta-polska": [
      {
        "type": "polygon",
        "d": "M4.4 13.2L4.4 9.2L9.6 7.2L11.6 11Z",
        "fill": "accent"
      },
      {
        "type": "circle",
        "cx": 11.6,
        "cy": 8.7,
        "r": 2.8,
        "fill": "accent"
      },
      {
        "type": "circle",
        "cx": 11.6,
        "cy": 8.7,
        "r": 1.25,
        "fill": "truck"
      },
      {
        "type": "line",
        "d": "M13.6 6.9L15.4 5.6L17.2 6",
        "stroke": "accent",
        "strokeWidth": 1
      }
    ],
    "ukrposhta": [
      {
        "type": "polygon",
        "d": "M7 5L17 5L12 12.4L7 10.4Z",
        "fill": "accent"
      },
      {
        "type": "circle",
        "cx": 9.9,
        "cy": 10.4,
        "r": 2.9,
        "fill": "accent"
      },
      {
        "type": "circle",
        "cx": 9.9,
        "cy": 10.4,
        "r": 1.25,
        "fill": "truck"
      }
    ],
    "correios-br": [
      {
        "type": "polygon",
        "d": "M12 6.8L9.4 6.8L5.4 10.2L9.4 13.6L12 13.6L8 10.2Z",
        "fill": "#e8a300"
      },
      {
        "type": "polygon",
        "d": "M10 5L12.6 5L16.6 8.4L12.6 11.8L10 11.8L14 8.4Z",
        "fill": "accent"
      }
    ],
    "ctt": [
      {
        "type": "polygon",
        "d": "M4.4 8.4L6.4 8.2L7.4 7.9L9.2 8.3L11.6 8L13.9 5.6L14.3 5L14.9 5.6L16.6 7L16.2 7.7L14.8 7.2L13.9 8.3L13.6 9.6L15.6 10.2L17.4 9.6L17.5 10.3L15.4 11.2L13.6 10.8L11.6 11L8.8 10.8L7.6 11.6L5.4 13.4L4.8 12.9L6.4 11L6.2 9.6L5.2 9.2Z",
        "fill": "accent"
      },
      {
        "type": "polygon",
        "d": "M9 8.4L9.5 5.6L10.9 5.6L10.6 8.4Z",
        "fill": "accent"
      },
      {
        "type": "circle",
        "cx": 10.4,
        "cy": 4.6,
        "r": 0.8,
        "fill": "accent"
      },
      {
        "type": "line",
        "d": "M10.4 6L13.2 4.7M9.9 8.2L11.2 10.6",
        "stroke": "accent",
        "strokeWidth": 0.6
      }
    ],
    "sf-express": [
      {
        "type": "circle",
        "cx": 11,
        "cy": 9.2,
        "r": 4.9,
        "fill": "#231815"
      },
      {
        "type": "circle",
        "cx": 11,
        "cy": 9.2,
        "r": 4.1,
        "fill": "accent"
      },
      {
        "type": "circle",
        "cx": 11,
        "cy": 9.2,
        "r": 3.5,
        "fill": "#231815"
      },
      {
        "type": "line",
        "d": "M10.3 7.9L8.8 7.9L8.8 9.2L10.2 9.2L10.2 10.5L8.7 10.5M11.9 10.5L11.9 7.9L13.4 7.9M11.9 9.2L13.1 9.2",
        "stroke": "accent",
        "strokeWidth": 0.7
      }
    ],
    "ninja-van": [
      {
        "type": "circle",
        "cx": 11,
        "cy": 9.2,
        "r": 4.5,
        "fill": "accent"
      },
      {
        "type": "circle",
        "cx": 11,
        "cy": 9.2,
        "r": 3.9,
        "fill": "#1a1a1a"
      },
      {
        "type": "polygon",
        "d": "M8.2 8.3L13.8 8.3L14.2 9.2L13.8 10.1L8.2 10.1L7.8 9.2Z",
        "fill": "accent"
      },
      {
        "type": "circle",
        "cx": 9.8,
        "cy": 9.2,
        "r": 0.6,
        "fill": "#1a1a1a"
      },
      {
        "type": "circle",
        "cx": 12.2,
        "cy": 9.2,
        "r": 0.6,
        "fill": "#1a1a1a"
      }
    ],
    "hongkong-post": [
      {
        "type": "polygon",
        "d": "M4.4 6.7L7 5.7L8 6.3L8.74 7.38L9.23 8.45L9.49 9.51L9.53 10.55L9.33 11.56L8.92 12.51L8.3 13.4L8.45 12.3L8.48 11.22L8.38 10.18L8.12 9.18L7.7 8.25L7.1 7.4Z",
        "fill": "accent"
      },
      {
        "type": "line",
        "d": "M8.9 7.4L10.01 6.58L11.18 5.98L12.4 5.58L13.63 5.36L14.85 5.31L16.05 5.4L17.2 5.6M9.5 8.5L10.51 7.86L11.57 7.4L12.66 7.1L13.76 6.96L14.87 6.97L15.95 7.12L17 7.4M9.9 9.7L10.86 9.15L11.82 8.79L12.79 8.6L13.74 8.58L14.68 8.72L15.6 9",
        "stroke": "accent",
        "strokeWidth": 0.75
      }
    ],
    "thailand-post": [
      {
        "type": "polygon",
        "d": "M4 5.2L14.6 5.2L11.8 8Z",
        "fill": "#1f3a8a"
      },
      {
        "type": "polygon",
        "d": "M14.6 5.2L18 5.2L12.8 13.2L11.8 8Z",
        "fill": "accent"
      },
      {
        "type": "polygon",
        "d": "M4 5.2L11.8 8L12.8 13.2Z",
        "fill": "#d7d9dc"
      }
    ],
    "bring": [
      {
        "type": "polygon",
        "d": "M6.7 8.85L6.78 8.01L7.03 7.2L7.42 6.46L7.96 5.81L8.61 5.27L9.35 4.88L10.16 4.63L11 4.55L11.84 4.63L12.65 4.88L13.39 5.27L14.04 5.81L14.58 6.46L14.97 7.2L15.22 8.01L15.3 8.85Z",
        "fill": "accent"
      },
      {
        "type": "polygon",
        "d": "M15.3 9.55L15.22 10.39L14.97 11.2L14.58 11.94L14.04 12.59L13.39 13.13L12.65 13.52L11.84 13.77L11 13.85L10.16 13.77L9.35 13.52L8.61 13.13L7.96 12.59L7.42 11.94L7.03 11.2L6.78 10.39L6.7 9.55Z",
        "fill": "#d5d8d2"
      },
      {
        "type": "circle",
        "cx": 11,
        "cy": 9.2,
        "r": 1.9,
        "fill": "truck"
      }
    ],
    "packeta": [
      {
        "type": "polygon",
        "d": "M11 4.9L15.1 7.1L11 9.3L6.9 7.1Z",
        "fill": "accent"
      },
      {
        "type": "polygon",
        "d": "M6.9 7.1L11 9.3L11 13.8L6.9 11.6Z",
        "fill": "#e9e9e9"
      },
      {
        "type": "polygon",
        "d": "M15.1 7.1L15.1 11.6L11 13.8L11 9.3Z",
        "fill": "#c2c2c2"
      },
      {
        "type": "line",
        "d": "M6.9 7.1L11 9.3L15.1 7.1M11 9.3L11 13.8",
        "stroke": "truck",
        "strokeWidth": 0.45
      },
      {
        "type": "line",
        "d": "M13.05 6L8.95 8.2L8.95 10.4",
        "stroke": "truck",
        "strokeWidth": 0.8
      }
    ],
    "gls": [
      {
        "type": "line",
        "d": "M7.32 7.77L6.53 7.28L5.65 7.38L4.94 8.02L4.59 9.04L4.72 10.14L5.29 10.99L6.12 11.35L6.98 11.12L7.63 10.36L7.87 9.3L6.31 9.3M9.59 7.25L9.59 11.35L11.64 11.35M15.62 7.76L15 7.31L14.19 7.31L13.56 7.76L13.42 8.45L13.83 9.06L14.59 9.3L15.38 9.54L15.81 10.15L15.66 10.84L15.01 11.29L14.17 11.29L13.53 10.84",
        "stroke": "#ffffff",
        "strokeWidth": 1.19
      },
      {
        "type": "circle",
        "cx": 17.75,
        "cy": 11.15,
        "r": 0.8,
        "fill": "accent"
      }
    ],
    "evri": [
      {
        "type": "line",
        "d": "M7.05 7.27L4.78 7.27L4.78 11.33L7.05 11.33M4.78 9.3L6.65 9.3M8.57 7.27L10.19 11.63M9.97 11.63L11.58 7.27M13.1 11.33L13.1 7.27L14.48 7.27L15.1 7.48L15.49 8.03L15.49 8.7L15.1 9.25L14.48 9.46L13.1 9.46M14.32 9.46L15.7 11.33M17.22 8.49L17.22 11.33",
        "stroke": "accent",
        "strokeWidth": 1.05
      },
      {
        "type": "circle",
        "cx": 17.22,
        "cy": 7.43,
        "r": 0.65,
        "fill": "accent"
      }
    ],
    "postnord": [
      {
        "type": "line",
        "d": "M5.07 5.35L5.07 9.1M7.32 6.66L7.11 7.43L6.55 7.91L5.85 7.91L5.29 7.43L5.07 6.66L5.29 5.89L5.85 5.41L6.55 5.41L7.11 5.89L7.32 6.66L7.11 7.43M10.77 6.66L10.56 7.43L10 7.91L9.3 7.91L8.74 7.43L8.52 6.66L8.74 5.89L9.3 5.41L10 5.41L10.56 5.89L10.77 6.66L10.56 7.43M13.55 5.68L13.01 5.36L12.35 5.48L12.02 5.94L12.22 6.45L12.84 6.66L13.48 6.88L13.7 7.39L13.34 7.85L12.66 7.96L12.09 7.65M15.35 4.38L15.35 7.23L15.46 7.64L15.76 7.91L16.14 7.96M14.9 5.35L16.17 5.35",
        "stroke": "accent",
        "strokeWidth": 0.95
      },
      {
        "type": "line",
        "d": "M5.07 10.6L5.07 13.23M5.07 11.65L5.07 11.65L5.36 10.91L6.05 10.6L6.74 10.91L7.03 11.65L7.03 13.23M10.48 11.91L10.26 12.68L9.7 13.16L9 13.16L8.44 12.68L8.23 11.91L8.44 11.14L9 10.66L9.7 10.66L10.26 11.14L10.48 11.91L10.26 12.68M11.68 10.6L11.68 13.23M11.68 11.73L11.68 11.73L11.85 11.08L12.32 10.67L12.9 10.64M16.14 11.91L15.92 12.68L15.36 13.16L14.66 13.16L14.1 12.68L13.89 11.91L14.1 11.14L14.66 10.66L15.36 10.66L15.92 11.14L16.14 11.91L15.92 12.68M16.14 9.48L16.14 13.23",
        "stroke": "accent",
        "strokeWidth": 0.95
      }
    ],
    "poste-italiane": [
      {
        "type": "line",
        "d": "M4.34 10.97L4.34 7.63L5.47 7.63L5.99 7.8L6.3 8.25L6.3 8.81L5.99 9.26L5.47 9.43L4.34 9.43M9.49 9.8L9.3 10.49L8.8 10.92L8.18 10.92L7.68 10.49L7.48 9.8L7.68 9.11L8.18 8.69L8.8 8.69L9.3 9.11L9.49 9.8L9.3 10.49M12.04 8.92L11.55 8.64L10.97 8.74L10.67 9.16L10.85 9.61L11.4 9.8L11.97 10L12.17 10.45L11.85 10.86L11.24 10.96L10.74 10.68M13.71 7.76L13.71 10.3L13.81 10.67L14.08 10.92L14.42 10.96M13.31 8.63L14.45 8.63M15.66 9.8L17.66 9.8L17.48 9.14L17.01 8.71L16.42 8.67L15.91 9.03L15.66 9.67L15.77 10.35L16.2 10.84L16.79 10.96L17.33 10.67",
        "stroke": "accent",
        "strokeWidth": 0.91
      }
    ],
    "aramex": [
      {
        "type": "line",
        "d": "M13.51 9.3L13.03 11.02L11.77 12.08L10.23 12.08L8.97 11.02L8.49 9.3L8.97 7.58L10.23 6.52L11.77 6.52L13.03 7.58L13.51 9.3L13.03 11.02M13.51 6.38L13.51 12.22",
        "stroke": "accent",
        "strokeWidth": 1.45
      }
    ],
    "j-and-t": [
      {
        "type": "line",
        "d": "M8.31 6.9L7.51 10.9L4.75 10.9M12.53 11.29L10.47 8.36L10.47 7.86L10.76 7.39L11.22 7.12L11.7 7.19L11.99 7.53L9.37 10.12L9.43 10.7L9.81 11.13L10.42 11.29L11.1 11.13L11.65 10.7L11.94 10.12L12.98 9.03M13.57 7.5L17.25 7.5M15.68 7.5L14.88 11.5",
        "stroke": "accent",
        "strokeWidth": 1.2
      }
    ],
    "aliexpress": [
      {
        "type": "line",
        "d": "M8.7 7.4L8.88 6.37L9.37 5.49L10.12 4.91L11 4.7L11.88 4.91L12.63 5.49L13.12 6.37L13.3 7.4",
        "stroke": "accent",
        "strokeWidth": 0.85
      },
      {
        "type": "polygon",
        "d": "M6.2 7.4L15.8 7.4L15.1 13.7L6.9 13.7Z",
        "fill": "accent"
      },
      {
        "type": "line",
        "d": "M13.69 10.05L13.25 10.76L12.62 11.32L11.85 11.68L11 11.8L10.15 11.68L9.38 11.32L8.75 10.76L8.31 10.05",
        "stroke": "truck",
        "strokeWidth": 0.95
      }
    ],
    "zto": [
      {
        "type": "line",
        "d": "M5.81 7.22L8.72 7.22M8.6 6.96L4.67 11.64M4.55 11.38L7.47 11.38M9.98 7.22L12.64 7.22M11.31 7.22L10.39 11.38M17.1 9.3L16.65 10.34L15.87 11.1L14.98 11.38L14.21 11.1L13.77 10.34L13.78 9.3L14.23 8.26L15 7.5L15.9 7.22L16.66 7.5L17.11 8.26L17.1 9.3L16.65 10.34",
        "stroke": "accent",
        "strokeWidth": 1.14
      }
    ],
    "yto": [
      {
        "type": "line",
        "d": "M4.76 7.1L6.3 9.48L7.84 7.1M6.3 9.48L6.3 11.5",
        "stroke": "accent",
        "strokeWidth": 1.2
      },
      {
        "type": "line",
        "d": "M9.49 7.1L12.31 7.1M10.9 7.1L10.9 11.5",
        "stroke": "#ff5fae",
        "strokeWidth": 1.2
      },
      {
        "type": "line",
        "d": "M17.26 9.3L17.02 10.4L16.38 11.21L15.5 11.5L14.62 11.21L13.98 10.4L13.74 9.3L13.98 8.2L14.62 7.39L15.5 7.1L16.38 7.39L17.02 8.2L17.26 9.3L17.02 10.4",
        "stroke": "accent",
        "strokeWidth": 1.2
      }
    ],
    "sto": [
      {
        "type": "line",
        "d": "M5 5.3L17 5.3L18.1 6.4L18.1 12.2L17 13.3L5 13.3L3.9 12.2L3.9 6.4L5 5.3L17 5.3",
        "stroke": "accent",
        "strokeWidth": 0.55
      },
      {
        "type": "line",
        "d": "M7.81 7.97L7.27 7.58L6.57 7.58L6.03 7.97L5.9 8.57L6.26 9.09L6.92 9.3L7.6 9.51L7.97 10.03L7.84 10.63L7.28 11.02L6.55 11.02L6 10.63M9.48 7.53L11.76 7.53M10.62 7.53L10.62 11.08M16.1 9.3L15.91 10.19L15.39 10.84L14.68 11.08L13.97 10.84L13.45 10.19L13.26 9.3L13.45 8.41L13.97 7.76L14.68 7.53L15.39 7.76L15.91 8.41L16.1 9.3L15.91 10.19",
        "stroke": "accent",
        "strokeWidth": 1.05
      }
    ],
    "yunda": [
      {
        "type": "polygon",
        "d": "M11 4.4L11.56 5.93L13.19 5.99L11.9 6.99L12.35 8.56L11 7.65L9.65 8.56L10.1 6.99L8.81 5.99L10.44 5.93Z",
        "fill": "accent"
      },
      {
        "type": "line",
        "d": "M6.6 6L6.6 8M15.4 6L15.4 8M15.89 9.56L15.43 10.73L14.64 11.75L13.59 12.53L12.34 13.03L11 13.2L9.66 13.03L8.41 12.53L7.36 11.75L6.57 10.73L6.11 9.56",
        "stroke": "accent",
        "strokeWidth": 1
      }
    ],
    "jd-logistics": [
      {
        "type": "line",
        "d": "M7.48 7.05L7.48 10.38L7.21 11.17L6.53 11.55L5.81 11.31L5.42 10.58M9.33 7.05L9.33 11.55M9.33 7.05L10.5 7.05L11.49 7.35L12.21 8.18L12.48 9.3L12.21 10.43L11.49 11.25L10.5 11.55L9.33 11.55M14.33 7.05L14.33 11.55L16.58 11.55",
        "stroke": "accent",
        "strokeWidth": 1.3
      }
    ],
    "ems": [
      {
        "type": "line",
        "d": "M10.25 7.56L8.3 7.56L7.6 11.04L9.55 11.04M7.95 9.3L9.55 9.3M10.88 11.04L11.63 7.27M11.46 7.29L12.62 10L14.83 7.33M14.7 7.27L13.94 11.04M17.8 8L17.35 7.61L16.66 7.61L16.05 8L15.81 8.58L16.06 9.1L16.66 9.3L17.29 9.5L17.55 10.02L17.31 10.6L16.68 10.99L15.97 10.99L15.5 10.6",
        "stroke": "accent",
        "strokeWidth": 0.99
      },
      {
        "type": "line",
        "d": "M3.4 7.4L6.4 7.4M3.1 9.3L5.6 9.3M2.8 11.2L4.8 11.2",
        "stroke": "#f58220",
        "strokeWidth": 0.9
      }
    ],
    "seur": [
      {
        "type": "polygon",
        "d": "M2.9 8.1L4.7 8.1L4.7 10.5L2.9 10.5Z",
        "fill": "#8fc1ee"
      },
      {
        "type": "polygon",
        "d": "M5 8.1L5.9 8.1L5.9 10.5L5 10.5Z",
        "fill": "#e2001a"
      },
      {
        "type": "line",
        "d": "M8.84 8.14L8.37 7.8L7.76 7.8L7.29 8.14L7.18 8.66L7.49 9.12L8.06 9.3L8.66 9.48L8.98 9.94L8.87 10.46L8.38 10.8L7.75 10.8L7.26 10.46M11.88 7.75L10.15 7.75L10.15 10.85L11.88 10.85M10.15 9.3L11.57 9.3M13.04 7.75L13.04 9.83L13.18 10.34L13.55 10.71L14.06 10.85L14.57 10.71L14.94 10.34L15.08 9.83L15.08 7.75M16.24 10.85L16.24 7.75L17.29 7.75L17.76 7.91L18.06 8.33L18.06 8.85L17.76 9.26L17.29 9.42L16.24 9.42M17.17 9.42L18.22 10.85",
        "stroke": "accent",
        "strokeWidth": 0.86
      }
    ],
    "mrw": [
      {
        "type": "line",
        "d": "M4.78 10.27L5.55 6.45M5.38 6.47L6.55 9.21L8.79 6.51M8.66 6.45L7.9 10.27M9.23 10.27L9.94 6.73L11.14 6.73L11.65 6.91L11.88 7.39L11.77 7.98L11.34 8.46L10.76 8.64L9.56 8.64M10.62 8.64L11.5 10.27M13.54 6.73L13.77 10.56M13.61 10.52L15.36 7.26M15.18 7.22L15.63 10.55M15.47 10.53L17.22 6.73",
        "stroke": "accent",
        "strokeWidth": 0.96
      },
      {
        "type": "line",
        "d": "M4.2 13L16.6 13",
        "stroke": "#e2001a",
        "strokeWidth": 0.9
      }
    ],
    "nacex": [
      {
        "type": "line",
        "d": "M3.81 10.76L4.25 7.62M4.12 7.65L5.97 10.95M5.83 10.98L6.27 7.84M6.85 10.76L8.5 7.65M8.35 7.63L9.13 10.76M7.46 9.77L8.8 9.77M12.43 8.21L11.95 7.87L11.36 7.9L10.8 8.28L10.42 8.93L10.31 9.67L10.51 10.32L10.97 10.7L11.55 10.73L12.13 10.39M15.21 7.84L13.57 7.84L13.16 10.76L14.8 10.76M13.36 9.3L14.71 9.3M16.2 7.84L17.78 10.76M18.19 7.84L15.79 10.76",
        "stroke": "accent",
        "strokeWidth": 0.72
      }
    ],
    "purolator": [
      {
        "type": "polygon",
        "d": "M4.2 13.2L6.8 5.2L9.2 5.2L6.6 13.2Z",
        "fill": "accent"
      },
      {
        "type": "polygon",
        "d": "M7.6 13.2L10.2 5.2L12.6 5.2L10 13.2Z",
        "fill": "edge"
      },
      {
        "type": "polygon",
        "d": "M11 13.2L13.6 5.2L16 5.2L13.4 13.2Z",
        "fill": "edge"
      }
    ],
    "parcelforce": [
      {
        "type": "line",
        "d": "M4.51 8.17L4.51 5.83L5.3 5.83L5.66 5.95L5.88 6.27L5.88 6.66L5.66 6.97L5.3 7.09L4.51 7.09M6.74 8.17L7.72 5.67M7.59 5.67L8.56 8.17M7.12 7.37L8.19 7.37M9.39 8.17L9.39 5.83L10.19 5.83L10.54 5.95L10.76 6.27L10.76 6.66L10.54 6.97L10.19 7.09L9.39 7.09M10.09 7.09L10.89 8.17M13.28 6.13L12.86 5.86L12.39 5.88L11.98 6.19L11.75 6.7L11.75 7.3L11.98 7.81L12.39 8.12L12.86 8.14L13.28 7.87M15.49 5.83L14.19 5.83L14.19 8.17L15.49 8.17M14.19 7L15.26 7M16.32 5.83L16.32 8.17L17.49 8.17",
        "stroke": "accent",
        "strokeWidth": 0.58
      },
      {
        "type": "line",
        "d": "M6.13 10.34L4.66 10.34L4.66 13.06M4.66 11.7L5.86 11.7M9.27 11.7L9.12 12.38L8.73 12.88L8.18 13.06L7.64 12.88L7.24 12.38L7.1 11.7L7.24 11.02L7.64 10.52L8.18 10.34L8.73 10.52L9.12 11.02L9.27 11.7L9.12 12.38M10.24 13.06L10.24 10.34L11.16 10.34L11.58 10.48L11.83 10.85L11.83 11.3L11.58 11.67L11.16 11.81L10.24 11.81M11.05 11.81L11.98 13.06M14.76 10.69L14.27 10.38L13.72 10.4L13.25 10.76L12.98 11.36L12.98 12.04L13.25 12.64L13.72 13L14.27 13.02L14.76 12.71M17.34 10.34L15.82 10.34L15.82 13.06L17.34 13.06M15.82 11.7L17.07 11.7",
        "stroke": "accent",
        "strokeWidth": 0.68
      }
    ],
    "posti": [
      {
        "type": "line",
        "d": "M5.11 7.92L5.11 11.65M7.34 9.23L7.13 9.99L6.57 10.47L5.88 10.47L5.32 9.99L5.11 9.23L5.32 8.46L5.88 7.99L6.57 7.99L7.13 8.46L7.34 9.23L7.13 9.99M10.64 9.23L10.43 9.99L9.87 10.47L9.18 10.47L8.62 9.99L8.41 9.23L8.62 8.46L9.18 7.99L9.87 7.99L10.43 8.46L10.64 9.23L10.43 9.99M13.27 8.25L12.73 7.94L12.08 8.05L11.75 8.51L11.96 9.01L12.56 9.23L13.2 9.44L13.42 9.95L13.07 10.4L12.39 10.52L11.82 10.2M14.93 6.95L14.93 9.78L15.04 10.19L15.34 10.47L15.72 10.52M14.49 7.92L15.75 7.92M16.89 7.92L16.89 10.53",
        "stroke": "accent",
        "strokeWidth": 0.84
      },
      {
        "type": "circle",
        "cx": 16.89,
        "cy": 6.95,
        "r": 0.52,
        "fill": "accent"
      }
    ],
    "an-post": [
      {
        "type": "line",
        "d": "M8.25 5.86L8.02 6.67L7.43 7.17L6.69 7.17L6.1 6.67L5.88 5.86L6.1 5.04L6.69 4.54L7.43 4.54L8.02 5.04L8.25 5.86L8.02 6.67M8.25 4.47L8.25 7.24M9.62 4.47L9.62 7.24M9.62 5.58L9.62 5.58L9.92 4.8L10.65 4.47L11.38 4.8L11.68 5.58L11.68 7.24",
        "stroke": "accent",
        "strokeWidth": 0.95
      },
      {
        "type": "line",
        "d": "M5.88 8.8L5.88 12.75M8.25 10.18L8.02 11L7.43 11.5L6.69 11.5L6.1 11L5.88 10.18L6.1 9.37L6.69 8.87L7.43 8.87L8.02 9.37L8.25 10.18L8.02 11M11.82 10.18L11.59 11L11 11.5L10.26 11.5L9.67 11L9.45 10.18L9.67 9.37L10.26 8.87L11 8.87L11.59 9.37L11.82 10.18L11.59 11M14.68 9.15L14.1 8.82L13.41 8.93L13.06 9.42L13.28 9.96L13.92 10.18L14.6 10.41L14.83 10.95L14.46 11.43L13.73 11.55L13.14 11.22M16.51 7.78L16.51 10.78L16.62 11.21L16.94 11.5L17.34 11.55M16.03 8.8L17.38 8.8",
        "stroke": "accent",
        "strokeWidth": 0.95
      }
    ],
    "delhivery": [
      {
        "type": "polygon",
        "d": "M7 5.2L15 5.2L7 13.2Z",
        "fill": "accent"
      },
      {
        "type": "polygon",
        "d": "M15 5.2L15 13.2L7 13.2Z",
        "fill": "#111820"
      }
    ],
    "blue-dart": [
      {
        "type": "line",
        "d": "M5.48 5.38L5.48 8.43M5.48 5.38L6.52 5.38L7.04 5.6L7.25 6.14L7.04 6.68L6.52 6.9L5.48 6.9M5.48 6.9L6.58 6.9L7.14 7.12L7.37 7.66L7.14 8.2L6.58 8.43L5.48 8.43M8.67 5.38L8.67 8.43L10.2 8.43M11.5 5.38L11.5 7.42L11.63 7.92L12 8.29L12.5 8.43L13.01 8.29L13.38 7.92L13.51 7.42L13.51 5.38M16.52 5.38L14.81 5.38L14.81 8.43L16.52 8.43M14.81 6.9L16.21 6.9",
        "stroke": "accent",
        "strokeWidth": 0.95
      },
      {
        "type": "line",
        "d": "M4.84 10.17L4.84 13.22M4.84 10.17L5.63 10.17L6.31 10.38L6.8 10.94L6.98 11.7L6.8 12.46L6.31 13.02L5.63 13.22L4.84 13.22M8.28 13.22L9.57 9.91M9.36 9.91L10.66 13.22M8.76 12.19L10.17 12.19M11.96 13.22L11.96 10.17L12.99 10.17L13.46 10.33L13.75 10.74L13.75 11.25L13.46 11.66L12.99 11.82L11.96 11.82M12.87 11.82L13.91 13.22M15.21 10.17L17.16 10.17M16.18 10.17L16.18 13.22",
        "stroke": "accent",
        "strokeWidth": 0.95
      }
    ],
    "dtdc": [
      {
        "type": "line",
        "d": "M5.27 7L4.63 10.2M5.27 7L6.1 7L6.77 7.21L7.17 7.8L7.2 8.6L6.85 9.4L6.21 9.99L5.46 10.2L4.63 10.2M8.68 7L10.73 7M9.71 7L9.07 10.2M11.9 7L11.26 10.2M11.9 7L12.73 7L13.4 7.21L13.8 7.8L13.82 8.6L13.48 9.4L12.84 9.99L12.09 10.2L11.26 10.2M17.37 7.41L16.87 7.04L16.21 7.06L15.57 7.49L15.11 8.19L14.95 9.01L15.13 9.71L15.6 10.14L16.24 10.16L16.89 9.79",
        "stroke": "accent",
        "strokeWidth": 0.87
      },
      {
        "type": "line",
        "d": "M4.4 12.9L16.4 12.9",
        "stroke": "#e31e24",
        "strokeWidth": 0.9
      }
    ],
    "sagawa": [
      {
        "type": "line",
        "d": "M4.93 8.43L4.57 8.18L4.11 8.18L3.76 8.43L3.68 8.82L3.91 9.16L4.34 9.3L4.79 9.44L5.03 9.78L4.95 10.17L4.58 10.42L4.11 10.42L3.74 10.17M5.76 10.46L6.72 7.99M6.6 7.99L7.57 10.46M6.13 9.67L7.19 9.67M9.83 8.44L9.38 8.16L8.89 8.21L8.48 8.58L8.29 9.15L8.36 9.77L8.68 10.25L9.15 10.46L9.64 10.33L10 9.9L10.14 9.3L9.26 9.3M10.86 10.46L11.82 7.99M11.7 7.99L12.66 10.46M11.23 9.67L12.29 9.67M13.38 8.14L14.03 10.62M13.93 10.62L14.64 8.49M14.53 8.49L15.24 10.62M15.15 10.62L15.79 8.14M16.51 10.46L17.47 7.99M17.35 7.99L18.32 10.46M16.88 9.67L17.95 9.67",
        "stroke": "accent",
        "strokeWidth": 0.55
      }
    ],
    "ontrac": [
      {
        "type": "line",
        "d": "M6.3 9.3L6.14 10.03L5.71 10.57L5.13 10.77L4.54 10.57L4.11 10.03L3.95 9.3L4.11 8.57L4.54 8.03L5.13 7.83L5.71 8.03L6.14 8.57L6.3 9.3L6.14 10.03M7.16 8.71L7.16 10.77M7.16 9.54L7.16 9.54L7.39 8.95L7.93 8.71L8.47 8.95L8.69 9.54L8.69 10.77M9.55 7.83L11.43 7.83M10.49 7.83L10.49 10.77M12.3 8.71L12.3 10.77M12.3 9.59L12.3 9.59L12.44 9.09L12.8 8.77L13.26 8.74M15.72 9.74L15.55 10.35L15.11 10.72L14.56 10.72L14.12 10.35L13.95 9.74L14.12 9.14L14.56 8.76L15.11 8.76L15.55 9.14L15.72 9.74L15.55 10.35M15.72 8.71L15.72 10.77M18.05 8.98L17.6 8.72L17.1 8.8L16.72 9.18L16.58 9.74L16.72 10.3L17.1 10.68L17.6 10.76L18.05 10.51",
        "stroke": "accent",
        "strokeWidth": 0.67
      }
    ],
    "estafeta": [
      {
        "type": "line",
        "d": "M8.63 9.27L13.37 9.27L13.26 7.7L12.35 6.68L10.96 6.59L9.59 7.44L8.71 8.95L8.65 10.57L9.42 11.73L10.75 12.01L12.17 11.33",
        "stroke": "accent",
        "strokeWidth": 1.7
      }
    ],
    "pos-malaysia": [
      {
        "type": "line",
        "d": "M4.56 11.58L4.56 7.03L6.11 7.03L6.81 7.26L7.24 7.87L7.24 8.63L6.81 9.25L6.11 9.48L4.56 9.48",
        "stroke": "accent",
        "strokeWidth": 1.25
      },
      {
        "type": "circle",
        "cx": 11,
        "cy": 9.3,
        "r": 2.9,
        "fill": "accent"
      },
      {
        "type": "polygon",
        "d": "M9.9 7.7L12.7 9.3L9.9 10.9L10.9 9.3Z",
        "fill": "truck"
      },
      {
        "type": "line",
        "d": "M17.32 7.59L16.63 7.09L15.73 7.09L15.03 7.59L14.88 8.36L15.33 9.03L16.18 9.3L17.06 9.57L17.52 10.24L17.36 11.01L16.64 11.51L15.71 11.51L15 11.01",
        "stroke": "accent",
        "strokeWidth": 1.25
      }
    ],
    "four-px": [
      {
        "type": "line",
        "d": "M7.78 11.54L8.53 7.35M8.69 7.43L5.84 10.61M5.73 10.38L8.69 10.38M9.98 11.54L10.68 7.66L12 7.66L12.56 7.86L12.83 8.38L12.71 9.03L12.25 9.56L11.62 9.76L10.3 9.76M14.51 7.66L16.45 11.54M17.15 7.66L13.82 11.54",
        "stroke": "accent",
        "strokeWidth": 1.05
      },
      {
        "type": "polygon",
        "d": "M6.1 6L5.25 6.27L5.66 7.06L4.87 6.65L4.6 7.5L4.33 6.65L3.54 7.06L3.95 6.27L3.1 6L3.95 5.73L3.54 4.94L4.33 5.35L4.6 4.5L4.87 5.35L5.66 4.94L5.25 5.73Z",
        "fill": "#ff8a00"
      }
    ],
    "planzer": [
      {
        "type": "line",
        "d": "M3.85 10.44L3.85 8.16L4.62 8.16L4.97 8.27L5.19 8.58L5.19 8.96L4.97 9.27L4.62 9.39L3.85 9.39M5.93 8.16L5.93 10.44L7.07 10.44M7.78 10.44L8.73 8.01M8.61 8.01L9.56 10.44M8.14 9.67L9.19 9.67M10.27 10.44L10.27 7.99M10.18 8.02L11.96 10.58M11.87 10.61L11.87 8.16M12.58 8.16L13.99 8.16L12.58 10.44L13.99 10.44M15.98 8.16L14.7 8.16L14.7 10.44L15.98 10.44M14.7 9.3L15.75 9.3M16.69 10.44L16.69 8.16L17.47 8.16L17.82 8.27L18.03 8.58L18.03 8.96L17.82 9.27L17.47 9.39L16.69 9.39M17.38 9.39L18.15 10.44",
        "stroke": "accent",
        "strokeWidth": 0.54
      }
    ],
    "tipsa": [
      {
        "type": "line",
        "d": "M5.81 8.05L7.42 8.05M6.62 8.05L6.62 10.55M8.37 8.05L8.37 10.55M9.32 10.55L9.32 8.05L10.17 8.05L10.56 8.17L10.79 8.51L10.79 8.93L10.56 9.27L10.17 9.4L9.32 9.4M13.16 8.36L12.78 8.08L12.28 8.08L11.9 8.36L11.81 8.78L12.06 9.15L12.53 9.3L13.01 9.45L13.27 9.82L13.18 10.24L12.78 10.52L12.27 10.52L11.88 10.24M14.23 10.55L15.28 7.85M15.13 7.85L16.19 10.55M14.63 9.7L15.79 9.7",
        "stroke": "#ffffff",
        "strokeWidth": 0.68
      },
      {
        "type": "line",
        "d": "M3.6 7L3.6 5.4L5.4 5.4M16.6 5.4L18.4 5.4L18.4 7M18.4 11.6L18.4 13.2L16.6 13.2M5.4 13.2L3.6 13.2L3.6 11.6",
        "stroke": "accent",
        "strokeWidth": 0.6
      }
    ],
    "gofo": [
      {
        "type": "line",
        "d": "M6.55 8.08L5.92 7.69L5.22 7.77L4.65 8.28L4.38 9.09L4.48 9.97L4.93 10.64L5.59 10.93L6.28 10.75L6.8 10.15L6.98 9.3L5.74 9.3M10.81 9.3L10.64 10.12L10.16 10.72L9.51 10.94L8.85 10.72L8.37 10.12L8.2 9.3L8.37 8.48L8.85 7.88L9.51 7.66L10.16 7.88L10.64 8.48L10.81 9.3L10.64 10.12M13.79 7.66L12.03 7.66L12.03 10.94M12.03 9.3L13.47 9.3M17.62 9.3L17.45 10.12L16.97 10.72L16.31 10.94L15.66 10.72L15.18 10.12L15.01 9.3L15.18 8.48L15.66 7.88L16.31 7.66L16.97 7.88L17.45 8.48L17.62 9.3L17.45 10.12",
        "stroke": "accent",
        "strokeWidth": 0.93
      }
    ],
    "dachser": [
      {
        "type": "polygon",
        "d": "M2.3 6.4L19.7 6.4L19.7 12.2L2.3 12.2Z",
        "fill": "#ffcc00"
      },
      {
        "type": "line",
        "d": "M3.8 8.22L3.8 10.38M3.8 8.22L4.36 8.22L4.84 8.37L5.18 8.76L5.31 9.3L5.18 9.84L4.84 10.23L4.36 10.38L3.8 10.38M6.04 10.38L6.94 8.07M6.82 8.07L7.71 10.38M6.38 9.64L7.37 9.64M9.88 8.5L9.49 8.25L9.06 8.27L8.68 8.55L8.47 9.03L8.47 9.57L8.68 10.05L9.06 10.33L9.49 10.35L9.88 10.1M10.68 8.22L10.68 10.38M12.14 8.22L12.14 10.38M10.68 9.3L12.14 9.3M14.05 8.49L13.73 8.26L13.3 8.26L12.97 8.49L12.9 8.86L13.11 9.17L13.51 9.3L13.93 9.43L14.15 9.74L14.07 10.11L13.73 10.34L13.29 10.34L12.95 10.11M16.09 8.22L14.89 8.22L14.89 10.38L16.09 10.38M14.89 9.3L15.88 9.3M16.82 10.38L16.82 8.22L17.55 8.22L17.88 8.34L18.08 8.63L18.08 8.98L17.88 9.28L17.55 9.39L16.82 9.39M17.47 9.39L18.2 10.38",
        "stroke": "truck",
        "strokeWidth": 0.56
      }
    ],
    "asendia": [
      {
        "type": "line",
        "d": "M5.62 9.02L5.46 9.61L5.04 9.96L4.51 9.96L4.09 9.61L3.93 9.02L4.09 8.44L4.51 8.08L5.04 8.08L5.46 8.44L5.62 9.02L5.46 9.61M5.62 8.03L5.62 10.01M7.58 8.28L7.17 8.05L6.67 8.13L6.42 8.48L6.58 8.86L7.04 9.02L7.52 9.19L7.69 9.57L7.42 9.92L6.9 10L6.48 9.77M8.45 9.02L10.15 9.02L10 8.46L9.6 8.1L9.1 8.06L8.67 8.37L8.46 8.91L8.55 9.49L8.91 9.9L9.41 10L9.87 9.76M10.92 8.03L10.92 10.01M10.92 8.83L10.92 8.83L11.13 8.27L11.65 8.03L12.17 8.27L12.38 8.83L12.38 10.01M14.85 9.02L14.68 9.61L14.26 9.96L13.74 9.96L13.31 9.61L13.15 9.02L13.31 8.44L13.74 8.08L14.26 8.08L14.68 8.44L14.85 9.02L14.68 9.61M14.85 7.19L14.85 10.01M15.61 8.03L15.61 10.01M18.07 9.02L17.91 9.61L17.49 9.96L16.96 9.96L16.54 9.61L16.38 9.02L16.54 8.44L16.96 8.08L17.49 8.08L17.91 8.44L18.07 9.02L17.91 9.61M18.07 8.03L18.07 10.01",
        "stroke": "accent",
        "strokeWidth": 0.61
      },
      {
        "type": "circle",
        "cx": 15.61,
        "cy": 7.3,
        "r": 0.38,
        "fill": "accent"
      },
      {
        "type": "line",
        "d": "M4.2 12.9L17.8 12.9",
        "stroke": "#fef200",
        "strokeWidth": 0.8
      }
    ],
    "colis-prive": [
      {
        "type": "circle",
        "cx": 9.6,
        "cy": 8.1,
        "r": 3.7,
        "fill": "#17091f"
      },
      {
        "type": "polygon",
        "d": "M6.9 10.6L12.3 10.6L9.6 14.2Z",
        "fill": "#17091f"
      },
      {
        "type": "line",
        "d": "M10.65 7.01L10.01 6.65L9.3 6.76L8.75 7.3L8.55 8.1L8.75 8.9L9.3 9.44L10.01 9.55L10.65 9.19",
        "stroke": "#ffffff",
        "strokeWidth": 1
      },
      {
        "type": "line",
        "d": "M15.9 5.4L15.4 10.4",
        "stroke": "#450c68",
        "strokeWidth": 1.2
      },
      {
        "type": "circle",
        "cx": 15.2,
        "cy": 12.5,
        "r": 0.75,
        "fill": "#450c68"
      }
    ],
    "ciblex": [
      {
        "type": "line",
        "d": "M14.8 5.9L8.6 5.9L7.2 7.3L7.2 11.3L8.6 12.7L14.8 12.7",
        "stroke": "accent",
        "strokeWidth": 1.7
      }
    ],
    "colisweb": [
      {
        "type": "circle",
        "cx": 11,
        "cy": 9.3,
        "r": 4.9,
        "fill": "accent"
      },
      {
        "type": "circle",
        "cx": 11,
        "cy": 9.3,
        "r": 4,
        "fill": "truck"
      },
      {
        "type": "line",
        "d": "M12.34 7.91L11.52 7.45L10.61 7.59L9.92 8.28L9.66 9.3L9.92 10.32L10.61 11.01L11.52 11.15L12.34 10.69",
        "stroke": "accent",
        "strokeWidth": 1.25
      }
    ],
    "uniuni": [
      {
        "type": "polygon",
        "d": "M6.4 4.4L15.6 4.4L15.6 9.8L11 14.2L6.4 9.8Z",
        "fill": "#111820"
      },
      {
        "type": "polygon",
        "d": "M11 5.7L13.7 7.05L11 8.4L8.3 7.05Z",
        "fill": "#ffc27a"
      },
      {
        "type": "polygon",
        "d": "M8.3 7.05L11 8.4L11 11.5L8.3 10.15Z",
        "fill": "truck"
      },
      {
        "type": "polygon",
        "d": "M13.7 7.05L13.7 10.15L11 11.5L11 8.4Z",
        "fill": "#d9681c"
      }
    ],
    "yunexpress": [
      {
        "type": "line",
        "d": "M7.6 12.2L6.47 11.85L5.74 10.92L5.65 9.74L6.25 8.72L7.32 8.22L7.95 6.82L8.59 5.91L9.51 5.31L10.6 5.1L11.69 5.31L12.61 5.91L13.25 6.82L13.64 7.67L14.75 7.67L15.72 8.18L16.35 9.08L16.48 10.17L16.09 11.21L15.27 11.94L14.2 12.2L7.6 12.2L6.47 11.85",
        "stroke": "accent",
        "strokeWidth": 0.95
      }
    ],
    "canpar": [
      {
        "type": "line",
        "d": "M6 7.7L5.52 7.35L4.91 7.38L4.31 7.78L3.89 8.45L3.75 9.21L3.93 9.88L4.38 10.28L4.99 10.3L5.6 9.95M8.48 9.28L8.19 9.9L7.67 10.29L7.11 10.29L6.73 9.9L6.67 9.28L6.95 8.66L7.47 8.28L8.03 8.28L8.42 8.66L8.48 9.28L8.19 9.9M8.67 8.22L8.29 10.34M9.52 8.22L9.14 10.34M9.37 9.07L9.37 9.07L9.7 8.47L10.3 8.22L10.82 8.47L10.94 9.07L10.71 10.34M11.94 8.22L11.39 11.25M13.56 9.28L13.28 9.9L12.75 10.29L12.19 10.29L11.81 9.9L11.75 9.28L12.03 8.66L12.56 8.28L13.12 8.28L13.5 8.66L13.56 9.28L13.28 9.9M16.22 9.28L15.94 9.9L15.42 10.29L14.86 10.29L14.47 9.9L14.41 9.28L14.7 8.66L15.22 8.28L15.78 8.28L16.16 8.66L16.22 9.28L15.94 9.9M16.41 8.22L16.03 10.34M17.26 8.22L16.88 10.34M17.1 9.13L17.1 9.13L17.34 8.61L17.77 8.28L18.25 8.25",
        "stroke": "accent",
        "strokeWidth": 0.66
      }
    ],
    "relais-colis": [
      {
        "type": "circle",
        "cx": 11,
        "cy": 9.2,
        "r": 4.8,
        "fill": "accent"
      },
      {
        "type": "polygon",
        "d": "M10 6.2L12 6.2L12 9.2L13.8 9.2L11 12.6L8.2 9.2L10 9.2Z",
        "fill": "truck"
      }
    ],
    "singapore-post": [
      {
        "type": "polygon",
        "d": "M3.8 13L7 5.4L18.2 5.4L15 13Z",
        "fill": "accent"
      },
      {
        "type": "polygon",
        "d": "M5.62 12L7.98 6.4L11.58 6.4L9.22 12Z",
        "fill": "#ee2f26"
      },
      {
        "type": "polygon",
        "d": "M10.22 12L12.58 6.4L16.38 6.4L14.02 12Z",
        "fill": "#ee2f26"
      }
    ],
    "geodis": [
      {
        "type": "line",
        "d": "M5.83 8.25L5.29 7.92L4.68 7.98L4.19 8.43L3.96 9.12L4.05 9.87L4.43 10.45L5 10.7L5.6 10.55L6.04 10.03L6.2 9.3L5.13 9.3M8.65 7.89L7.07 7.89L7.07 10.71L8.65 10.71M7.07 9.3L8.37 9.3M11.77 9.3L11.62 10L11.21 10.52L10.65 10.71L10.09 10.52L9.67 10L9.52 9.3L9.67 8.6L10.09 8.08L10.65 7.89L11.21 8.08L11.62 8.6L11.77 9.3L11.62 10M12.65 7.89L12.65 10.71M12.65 7.89L13.38 7.89L14 8.08L14.45 8.6L14.62 9.3L14.45 10L14 10.52L13.38 10.71L12.65 10.71M15.49 7.89L15.49 10.71M17.92 8.25L17.49 7.94L16.93 7.94L16.5 8.25L16.41 8.72L16.69 9.14L17.21 9.3L17.75 9.46L18.04 9.88L17.94 10.35L17.5 10.66L16.92 10.66L16.48 10.35",
        "stroke": "accent",
        "strokeWidth": 0.68
      }
    ],
    "lbc-express": [
      {
        "type": "line",
        "d": "M5.2 5.2L16.8 5.2L18.2 9.3L16.8 13.4L5.2 13.4L3.8 9.3L5.2 5.2L16.8 5.2",
        "stroke": "accent",
        "strokeWidth": 0.55
      },
      {
        "type": "line",
        "d": "M6.33 7.53L6.33 11.08L8.1 11.08M9.6 7.53L9.6 11.08M9.6 7.53L10.81 7.53L11.41 7.78L11.66 8.41L11.41 9.04L10.81 9.3L9.6 9.3M9.6 9.3L10.88 9.3L11.53 9.56L11.8 10.19L11.53 10.82L10.88 11.08L9.6 11.08M15.67 7.98L15.03 7.57L14.32 7.6L13.7 8.07L13.35 8.85L13.35 9.75L13.7 10.53L14.32 11L15.03 11.03L15.67 10.62",
        "stroke": "accent",
        "strokeWidth": 1.05
      }
    ],
    "spx": [
      {
        "type": "line",
        "d": "M7.45 7.59L6.76 7.09L5.85 7.09L5.16 7.59L5.01 8.36L5.46 9.03L6.31 9.3L7.18 9.57L7.65 10.24L7.49 11.01L6.77 11.51L5.84 11.51L5.12 11.01M9.42 11.58L9.42 7.03L10.97 7.03L11.66 7.26L12.09 7.87L12.09 8.63L11.66 9.25L10.97 9.48L9.42 9.48M13.9 7.03L16.99 11.58M16.99 7.03L13.9 11.58",
        "stroke": "accent",
        "strokeWidth": 1.25
      }
    ],
    "ekart": [
      {
        "type": "line",
        "d": "M4.54 9.83L6.68 9.83L6.49 9.13L5.99 8.67L5.35 8.63L4.81 9.01L4.55 9.69L4.67 10.42L5.12 10.94L5.75 11.07L6.32 10.76M7.73 7.52L7.73 11.08M9.93 7.52L7.73 9.66M8.44 9.02L10 11.08M13.19 9.83L12.98 10.56L12.45 11.02L11.79 11.02L11.26 10.56L11.05 9.83L11.26 9.1L11.79 8.65L12.45 8.65L12.98 9.1L13.19 9.83L12.98 10.56M13.19 8.59L13.19 11.08M14.24 8.59L14.24 11.08M14.24 9.66L14.24 9.66L14.4 9.04L14.84 8.65L15.4 8.63M16.67 7.66L16.67 10.37L16.78 10.76L17.06 11.02L17.42 11.07M16.25 8.59L17.46 8.59",
        "stroke": "accent",
        "strokeWidth": 0.81
      }
    ],
    "xpressbees": [
      {
        "type": "line",
        "d": "M6.4 6.9L8.8 11.7M9.66 6.9L5.54 11.7",
        "stroke": "accent",
        "strokeWidth": 1.4
      },
      {
        "type": "line",
        "d": "M13.15 6.9L12.28 11.7M13.15 6.9L14.78 6.9L15.53 7.25L15.72 8.1L15.23 8.95L14.35 9.3L12.72 9.3M12.72 9.3L14.44 9.3L15.26 9.65L15.48 10.5L14.96 11.35L14.01 11.7L12.28 11.7",
        "stroke": "#111820",
        "strokeWidth": 1.4
      }
    ],
    "cne": [
      {
        "type": "line",
        "d": "M4 5.4L18 5.4L18 13.2L4 13.2L4 5.4L18 5.4",
        "stroke": "accent",
        "strokeWidth": 0.55
      },
      {
        "type": "line",
        "d": "M8.58 8.02L8.02 7.62L7.32 7.65L6.66 8.1L6.21 8.86L6.09 9.74L6.33 10.5L6.86 10.95L7.55 10.98L8.23 10.58M9.68 11.02L10.21 7.28M10.02 7.31L12.24 11.29M12.05 11.32L12.57 7.58M15.91 7.58L13.98 7.58L13.5 11.02L15.43 11.02M13.74 9.3L15.32 9.3",
        "stroke": "accent",
        "strokeWidth": 1.02
      }
    ],
    "yanwen": [
      {
        "type": "line",
        "d": "M3.85 8.11L4.68 9.4L5.52 8.11M4.68 9.4L4.68 10.49M6.24 10.49L7.23 7.95M7.11 7.95L8.1 10.49M6.62 9.68L7.72 9.68M8.82 10.49L8.82 7.93M8.73 7.96L10.59 10.64M10.5 10.67L10.5 8.11M11.22 8.11L11.88 10.66M11.78 10.66L12.51 8.47M12.4 8.47L13.13 10.66M13.04 10.66L13.7 8.11M15.76 8.11L14.42 8.11L14.42 10.49L15.76 10.49M14.42 9.3L15.52 9.3M16.48 10.49L16.48 7.93M16.38 7.96L18.25 10.64M18.15 10.67L18.15 8.11",
        "stroke": "accent",
        "strokeWidth": 0.57
      }
    ],
    "sunyou": [
      {
        "type": "line",
        "d": "M4.82 8.68L5.54 7.54L6.56 6.56L7.83 5.78L9.29 5.26L10.86 5.02L12.45 5.06L14 5.4L15.4 6.01L16.6 6.85",
        "stroke": "accent",
        "strokeWidth": 0.85
      },
      {
        "type": "line",
        "d": "M6.3 9.21L7.08 8.25L8.15 7.46L9.45 6.91L10.89 6.63L12.38 6.64L13.82 6.93L15.11 7.5L16.17 8.29",
        "stroke": "#03428c",
        "strokeWidth": 0.85
      },
      {
        "type": "line",
        "d": "M10.65 9.67L10.19 9.28L9.48 9.28L8.87 9.67L8.62 10.27L8.87 10.79L9.49 11L10.13 11.21L10.39 11.73L10.15 12.33L9.51 12.72L8.78 12.72L8.3 12.33M12.41 9.23L13.27 11.14L14.9 9.23M13.27 11.14L12.94 12.77",
        "stroke": "accent",
        "strokeWidth": 1.05
      }
    ],
    "speedx": [
      {
        "type": "line",
        "d": "M15.2 4.9L6.8 13.5",
        "stroke": "#bfe6ff",
        "strokeWidth": 1.9
      },
      {
        "type": "line",
        "d": "M6.8 4.9L15.2 13.5",
        "stroke": "accent",
        "strokeWidth": 1.9
      }
    ],
    "spee-dee": [
      {
        "type": "line",
        "d": "M7.17 5.76L6.71 5.42L6.1 5.42L5.64 5.76L5.53 6.27L5.84 6.72L6.41 6.9L6.99 7.08L7.31 7.53L7.2 8.04L6.72 8.38L6.09 8.38L5.61 8.04M8.62 8.43L8.62 5.38L9.66 5.38L10.12 5.53L10.41 5.94L10.41 6.45L10.12 6.86L9.66 7.02L8.62 7.02M13.46 5.38L11.75 5.38L11.75 8.43L13.46 8.43M11.75 6.9L13.15 6.9M16.47 5.38L14.76 5.38L14.76 8.43L16.47 8.43M14.76 6.9L16.16 6.9",
        "stroke": "accent",
        "strokeWidth": 0.95
      },
      {
        "type": "line",
        "d": "M6.92 10.17L6.92 13.22M6.92 10.17L7.72 10.17L8.39 10.38L8.88 10.94L9.06 11.7L8.88 12.46L8.39 13.02L7.72 13.22L6.92 13.22M12.07 10.17L10.36 10.17L10.36 13.22L12.07 13.22M10.36 11.7L11.76 11.7M15.08 10.17L13.37 10.17L13.37 13.22L15.08 13.22M13.37 11.7L14.77 11.7",
        "stroke": "accent",
        "strokeWidth": 0.95
      }
    ],
    "speedpak": [
      {
        "type": "line",
        "d": "M5.85 5.79L5.4 5.47L4.82 5.47L4.37 5.79L4.27 6.29L4.56 6.73L5.11 6.9L5.68 7.07L5.98 7.51L5.88 8.01L5.41 8.33L4.81 8.33L4.34 8.01M7.14 8.38L7.14 5.43L8.15 5.43L8.6 5.58L8.88 5.98L8.88 6.47L8.6 6.87L8.15 7.02L7.14 7.02M11.72 5.43L10.06 5.43L10.06 8.38L11.72 8.38M10.06 6.9L11.42 6.9M14.52 5.43L12.87 5.43L12.87 8.38L14.52 8.38M12.87 6.9L14.22 6.9M15.67 5.43L15.67 8.38M15.67 5.43L16.44 5.43L17.08 5.62L17.56 6.16L17.73 6.9L17.56 7.64L17.08 8.18L16.44 8.38L15.67 8.38",
        "stroke": "accent",
        "strokeWidth": 0.85
      },
      {
        "type": "line",
        "d": "M6.87 13.18L6.87 10.23L7.87 10.23L8.32 10.38L8.6 10.78L8.6 11.27L8.32 11.67L7.87 11.82L6.87 11.82M9.79 13.18L11.03 9.99M10.85 9.99L12.09 13.18M10.26 12.17L11.62 12.17M13.24 10.23L13.24 13.18M15.07 10.23L13.24 12M13.83 11.46L15.13 13.18",
        "stroke": "accent",
        "strokeWidth": 0.85
      }
    ],
    "the-courier-guy": [
      {
        "type": "circle",
        "cx": 12.5,
        "cy": 5.3,
        "r": 1.05,
        "fill": "accent"
      },
      {
        "type": "line",
        "d": "M12 6.9L10.6 10M10.6 10L12.5 11.5L11.8 13.8M10.6 10L8.5 11.5L6.4 11.1M11.9 7.3L13.9 8.7L15.4 8M11.7 7.3L9.5 7.1L8.4 8.8",
        "stroke": "accent",
        "strokeWidth": 1.05
      },
      {
        "type": "polygon",
        "d": "M15 5.2L17.4 5.2L17.4 7.6L15 7.6Z",
        "fill": "#e92a17"
      }
    ],
    "landmark-global": [
      {
        "type": "polygon",
        "d": "M11 4.4L12.1 8.1L15.8 9.2L12.1 10.3L11 14L9.9 10.3L6.2 9.2L9.9 8.1Z",
        "fill": "accent"
      }
    ],
    "old-dominion": [
      {
        "type": "circle",
        "cx": 11,
        "cy": 9.2,
        "r": 5,
        "fill": "accent"
      },
      {
        "type": "circle",
        "cx": 11,
        "cy": 9.2,
        "r": 4.3,
        "fill": "truck"
      },
      {
        "type": "line",
        "d": "M10.51 9.2L10.34 10.01L9.86 10.61L9.21 10.83L8.56 10.61L8.09 10.01L7.91 9.2L8.09 8.39L8.56 7.79L9.21 7.57L9.86 7.79L10.34 8.39L10.51 9.2L10.34 10.01M11.81 7.57L11.81 10.83M11.81 7.57L12.66 7.57L13.37 7.79L13.9 8.39L14.09 9.2L13.9 10.01L13.37 10.61L12.66 10.83L11.81 10.83",
        "stroke": "accent",
        "strokeWidth": 0.95
      }
    ],
    "paack": [
      {
        "type": "polygon",
        "d": "M11.5 8.7L12.1 5.3L15.2 5L14.9 8.1Z",
        "fill": "accent"
      },
      {
        "type": "polygon",
        "d": "M11.5 9.7L14.9 10.3L15.2 13.4L12.1 13.1Z",
        "fill": "accent"
      },
      {
        "type": "polygon",
        "d": "M10.5 9.7L9.9 13.1L6.8 13.4L7.1 10.3Z",
        "fill": "accent"
      },
      {
        "type": "polygon",
        "d": "M10.5 8.7L7.1 8.1L6.8 5L9.9 5.3Z",
        "fill": "accent"
      }
    ],
    "c-chez-vous": [
      {
        "type": "line",
        "d": "M13.32 6.66L12.05 5.84L10.61 5.9L9.38 6.83L8.68 8.4L8.68 10.2L9.38 11.77L10.61 12.7L12.05 12.76L13.32 11.94",
        "stroke": "accent",
        "strokeWidth": 1.7
      }
    ],
    "ecoscooting": [
      {
        "type": "circle",
        "cx": 10.2,
        "cy": 9.9,
        "r": 4,
        "fill": "accent"
      },
      {
        "type": "circle",
        "cx": 10.2,
        "cy": 9.9,
        "r": 3.1,
        "fill": "truck"
      },
      {
        "type": "polygon",
        "d": "M9.4 4.4L11 4.4L11 6.1L9.4 6.1Z",
        "fill": "accent"
      },
      {
        "type": "line",
        "d": "M10.2 9.9L12 8.1",
        "stroke": "accent",
        "strokeWidth": 0.8
      },
      {
        "type": "polygon",
        "d": "M14.2 8.2L15.2 5.6L17.8 4.8L17.6 7.6L15.8 9.2Z",
        "fill": "#8be04e"
      }
    ],
    "correos-chile": [
      {
        "type": "line",
        "d": "M4.6 12.2L17 5.2M6.6 13L15.8 8.2M9.2 13.4L14.2 10.9",
        "stroke": "accent",
        "strokeWidth": 1.35
      }
    ],
    "intelcom": [
      {
        "type": "line",
        "d": "M5.8 5.5L12.9 5.5L14.7 7.3L14.7 10.1L13.4 11.4L5.8 11.4M5.8 8.45L11.5 8.45M11.5 5.5L11.5 11.4M5.8 13.5L11.2 13.5",
        "stroke": "accent",
        "strokeWidth": 1.15
      }
    ],
    "shipup": [
      {
        "type": "line",
        "d": "M12.74 6.66L11.66 5.88L10.27 5.88L9.19 6.66L8.95 7.84L9.65 8.89L10.97 9.3L12.32 9.71L13.05 10.76L12.8 11.94L11.69 12.72L10.24 12.72L9.13 11.94",
        "stroke": "accent",
        "strokeWidth": 1.75
      }
    ],
    "heppner": [
      {
        "type": "circle",
        "cx": 11,
        "cy": 5.2,
        "r": 1.15,
        "fill": "#8dc63f"
      },
      {
        "type": "line",
        "d": "M7.3 7.2L14.7 13.6M14.7 7.2L7.3 13.6",
        "stroke": "#8dc63f",
        "strokeWidth": 1.6
      }
    ],
    "j-and-t-cargo": [
      {
        "type": "line",
        "d": "M8.31 5.95L7.51 9.95L4.75 9.95M12.53 10.34L10.47 7.41L10.47 6.91L10.76 6.44L11.22 6.17L11.7 6.24L11.99 6.58L9.37 9.17L9.43 9.75L9.81 10.18L10.42 10.34L11.1 10.18L11.65 9.75L11.94 9.17L12.98 8.08M13.57 6.55L17.25 6.55M15.68 6.55L14.88 10.55",
        "stroke": "accent",
        "strokeWidth": 1.2
      },
      {
        "type": "line",
        "d": "M4.65 12.05L16.75 12.05",
        "stroke": "accent",
        "strokeWidth": 0.8
      }
    ],
    "emile": [
      {
        "type": "polygon",
        "d": "M11 4.35L7.03 6.65L11 8.96L14.97 6.65Z",
        "fill": "accent"
      },
      {
        "type": "polygon",
        "d": "M6.41 7.02L10.71 9.51L10.71 14.46L6.41 11.96Z",
        "fill": "accent"
      },
      {
        "type": "polygon",
        "d": "M11.29 9.51L15.59 7.02L15.59 11.96L11.29 14.46Z",
        "fill": "#454c51"
      },
      {
        "type": "polygon",
        "d": "M7.23 8.51L9.75 9.97L9.75 10.85L7.23 9.39Z",
        "fill": "truck"
      },
      {
        "type": "polygon",
        "d": "M7.23 10.52L10.71 12.53L10.71 13.42L7.23 11.41Z",
        "fill": "truck"
      },
      {
        "type": "polygon",
        "d": "M12.11 9.93L12.93 9.45L12.93 13.5L12.11 13.98Z",
        "fill": "truck"
      },
      {
        "type": "polygon",
        "d": "M13.89 8.9L14.7 8.42L14.7 12.48L13.89 12.96Z",
        "fill": "truck"
      }
    ],
    "abf-freight": [
      {
        "type": "line",
        "d": "M4.34 10.75L7.2 5.15L7.98 5.15L8.15 10.75M5.5 8.73L7.96 8.73M9.94 10.75L11.29 5.15L12.97 5.15L13.37 5.23L13.68 5.46L13.87 5.82L13.91 6.26L13.8 6.73L13.55 7.17L13.19 7.52L12.76 7.76L12.32 7.84L10.64 7.84M10.64 7.84L12.43 7.84L12.87 7.93L13.22 8.18L13.42 8.57L13.47 9.04L13.35 9.55L13.07 10.02L12.68 10.41L12.21 10.66L11.73 10.75L9.94 10.75M18.9 5.15L16.21 5.15L14.87 10.75M15.54 7.95L17.78 7.95",
        "stroke": "accent",
        "strokeWidth": 1.5
      },
      {
        "type": "polygon",
        "d": "M4.7 12.05L17 12.05L16.55 13.55L4.25 13.55Z",
        "fill": "#faca05"
      }
    ],
    "acs-courier": [
      {
        "type": "line",
        "d": "M4.33 12.56L7.41 6.84L7.97 6.84L8.28 12.56M5.52 10.5L8.04 10.5M14 7.57L13.47 7.01L12.73 6.84L11.91 7.09L11.11 7.71L10.46 8.62L10.05 9.7L9.95 10.78L10.16 11.69L10.66 12.31L11.35 12.56L12.18 12.39L12.98 11.82M18.18 7.66L17.94 7.22L17.5 6.92L16.93 6.84L16.32 6.96L15.76 7.28L15.32 7.75L15.09 8.29L15.08 8.84L15.31 9.29L15.74 9.59L16.29 9.7L16.85 9.81L17.28 10.11L17.5 10.56L17.5 11.11L17.26 11.65L16.84 12.11L16.27 12.43L15.66 12.56L15.09 12.47L14.65 12.18L14.41 11.74",
        "stroke": "#1d1d1b",
        "strokeWidth": 1.5
      },
      {
        "type": "line",
        "d": "M3.68 11.91L6.76 6.19L7.32 6.19L7.63 11.91M4.87 9.85L7.39 9.85M13.35 6.92L12.82 6.36L12.08 6.19L11.26 6.44L10.46 7.06L9.81 7.97L9.4 9.05L9.3 10.13L9.51 11.04L10.01 11.66L10.7 11.91L11.53 11.74L12.33 11.17M17.53 7.01L17.29 6.57L16.85 6.27L16.28 6.19L15.67 6.31L15.11 6.63L14.67 7.1L14.44 7.64L14.43 8.19L14.66 8.64L15.09 8.94L15.64 9.05L16.2 9.16L16.63 9.46L16.85 9.91L16.85 10.46L16.61 11L16.19 11.46L15.62 11.78L15.01 11.91L14.44 11.82L14 11.53L13.76 11.09",
        "stroke": "accent",
        "strokeWidth": 1.5
      }
    ],
    "allegro-one": [
      {
        "type": "polygon",
        "d": "M11 4.15L14.94 6.42L14.94 10.97L11 13.25L7.06 10.97L7.06 6.42Z",
        "fill": "accent"
      },
      {
        "type": "polygon",
        "d": "M11 5.82L12.77 6.84L11 7.86L9.23 6.84Z",
        "fill": "truck"
      },
      {
        "type": "polygon",
        "d": "M13.49 8.1L13.49 10.14L11.72 11.16L11.72 9.12Z",
        "fill": "truck"
      },
      {
        "type": "polygon",
        "d": "M8.51 8.1L10.28 9.12L10.28 11.16L8.51 10.14Z",
        "fill": "truck"
      },
      {
        "type": "polygon",
        "d": "M10.28 12.05L11.72 12.05L11.72 14.7L10.28 14.7Z",
        "fill": "accent"
      }
    ],
    "apc-overnight": [
      {
        "type": "line",
        "d": "M3.82 10.75L6.72 5.05L7.52 5.05L7.69 10.75M4.99 8.7L7.5 8.7M9.23 10.75L10.6 5.05L12.2 5.05L12.68 5.14L13.07 5.4L13.3 5.79L13.36 6.27L13.24 6.79L12.95 7.27L12.52 7.67L12.01 7.92L11.48 8.01L9.89 8.01M18.47 5.78L17.93 5.22L17.2 5.05L16.38 5.3L15.58 5.92L14.94 6.83L14.53 7.9L14.43 8.97L14.63 9.88L15.13 10.5L15.83 10.75L16.64 10.58L17.45 10.02",
        "stroke": "accent",
        "strokeWidth": 1.5
      },
      {
        "type": "polygon",
        "d": "M5.25 12.45L17.35 12.45L16.95 13.85L4.85 13.85Z",
        "fill": "#13b5ea"
      }
    ],
    "aras-kargo": [
      {
        "type": "polygon",
        "d": "M3.3 14.08L9.5 14.08L18.6 4.42Z",
        "fill": "accent"
      },
      {
        "type": "polygon",
        "d": "M11.97 14.08L18.7 14.08L18.7 4.58Z",
        "fill": "accent"
      }
    ],
    "box-now": [
      {
        "type": "polygon",
        "d": "M4 4.15L6.09 4.15L6.51 4.23L6.87 4.46L7.12 4.8L7.2 5.21L7.12 5.61L6.87 5.96L6.51 6.18L6.09 6.27L6.05 6.27L6.53 6.36L6.93 6.61L7.2 7L7.3 7.46L7.2 7.91L6.93 8.3L6.53 8.56L6.05 8.65L4 8.65Z",
        "fill": "accent"
      },
      {
        "type": "polygon",
        "d": "M5.4 5.3L5.75 5.3L5.75 5.82L5.4 5.82Z",
        "fill": "truck"
      },
      {
        "type": "polygon",
        "d": "M5.4 6.77L5.8 6.77L5.8 7.45L5.4 7.45Z",
        "fill": "truck"
      },
      {
        "type": "polygon",
        "d": "M10.05 4.15L9.58 4.21L9.14 4.37L8.74 4.64L8.41 5L8.16 5.42L8 5.9L7.95 6.4L8 6.9L8.16 7.38L8.41 7.8L8.74 8.16L9.14 8.43L9.58 8.59L10.05 8.65L10.52 8.59L10.96 8.43L11.36 8.16L11.69 7.8L11.94 7.38L12.1 6.9L12.15 6.4L12.1 5.9L11.94 5.42L11.69 5L11.36 4.64L10.96 4.37L10.52 4.21Z",
        "fill": "accent"
      },
      {
        "type": "polygon",
        "d": "M10.05 5.5L9.84 5.54L9.65 5.67L9.5 5.87L9.4 6.12L9.37 6.4L9.4 6.68L9.5 6.93L9.65 7.13L9.84 7.26L10.05 7.3L10.26 7.26L10.45 7.13L10.6 6.93L10.7 6.68L10.73 6.4L10.7 6.12L10.6 5.87L10.45 5.67L10.26 5.54Z",
        "fill": "truck"
      },
      {
        "type": "polygon",
        "d": "M12.8 4.15L14.4 4.15L14.65 4.69L14.9 4.15L16.5 4.15L15.45 6.4L16.5 8.65L14.9 8.65L14.65 8.11L14.4 8.65L12.8 8.65L13.85 6.4Z",
        "fill": "accent"
      },
      {
        "type": "polygon",
        "d": "M4 14.15L4 9.65L5.65 9.65L6.1 12.05L6.1 9.65L7.5 9.65L7.5 14.15L5.85 14.15L5.4 11.75L5.4 14.15Z",
        "fill": "accent"
      },
      {
        "type": "polygon",
        "d": "M10.25 9.65L9.78 9.71L9.34 9.87L8.94 10.14L8.61 10.5L8.36 10.92L8.2 11.4L8.15 11.9L8.2 12.4L8.36 12.88L8.61 13.3L8.94 13.66L9.34 13.93L9.78 14.09L10.25 14.15L10.72 14.09L11.16 13.93L11.56 13.66L11.89 13.3L12.14 12.88L12.3 12.4L12.35 11.9L12.3 11.4L12.14 10.92L11.89 10.5L11.56 10.14L11.16 9.87L10.72 9.71Z",
        "fill": "accent"
      },
      {
        "type": "polygon",
        "d": "M10.25 11L10.04 11.04L9.85 11.17L9.7 11.37L9.6 11.62L9.57 11.9L9.6 12.18L9.7 12.43L9.85 12.63L10.04 12.76L10.25 12.8L10.46 12.76L10.65 12.63L10.8 12.43L10.9 12.18L10.93 11.9L10.9 11.62L10.8 11.37L10.65 11.17L10.46 11.04Z",
        "fill": "truck"
      },
      {
        "type": "polygon",
        "d": "M13 9.65L14.5 9.65L14.95 11.85L15.33 9.65L16.57 9.65L16.95 11.85L17.4 9.65L18.9 9.65L17.75 14.15L16.45 14.15L15.95 11.8L15.45 14.15L14.15 14.15Z",
        "fill": "accent"
      }
    ],
    "cdek": [
      {
        "type": "line",
        "d": "M7.75 7.46L7.31 6.92L6.72 6.75L6.05 6.99L5.4 7.59L4.88 8.47L4.55 9.5L4.47 10.53L4.64 11.41L5.04 12.01L5.62 12.25L6.28 12.08L6.94 11.54M8.91 6.75L7.81 12.25L8.84 12.25L9.51 12.08L10.16 11.61L10.72 10.88L11.12 9.98L11.31 9.02L11.27 8.12L11 7.39L10.54 6.92L9.94 6.75L8.91 6.75M12.73 6.75L14.87 6.75M12.36 9.5L13.85 9.5M11.63 12.25L13.77 12.25M15.8 6.75L14.7 12.25M18.4 6.75L15.14 10.05M16.13 9.28L17.3 12.25",
        "stroke": "accent",
        "strokeWidth": 1.5
      }
    ],
    "ceska-posta": [
      {
        "type": "polygon",
        "d": "M3.82 5.59L7.86 5.59L7.88 6.45L7.89 7.31L8.05 8.15L8.35 8.95L8.79 9.68L9.35 10.31L10 10.83L10.74 11.21L11.53 11.44L12.35 11.5L12.97 11.4L13.53 11.12L13.98 10.69L14.28 10.14L14.4 9.53L14.34 8.91L14.08 8.33L13.67 7.86L13.14 7.54L12.53 7.39L11.9 7.43L11.32 7.66L10.83 8.05L10.48 8.57L10.31 9.17L10.32 9.8L10.52 10.39L10.89 10.89L10.51 10.85L10.15 10.71L9.81 10.49L9.48 10.21L9.2 9.85L8.95 9.44L8.77 8.97L8.66 8.45L9.02 7.56L9.59 6.79L10.34 6.19L11.21 5.79L12.15 5.62L13.11 5.69L14.02 6L14.82 6.53L15.47 7.23L15.92 8.08L16.15 9.01L16.13 9.97L15.33 10.5L14.47 11.55L13.47 12.4L12.35 13L11.16 13.34L9.93 13.4L8.72 13.18L7.57 12.68L6.51 11.94L5.59 10.97L4.84 9.8L4.28 8.48L3.94 7.06L3.82 5.59Z",
        "fill": "accent"
      },
      {
        "type": "polygon",
        "d": "M12.92 5.59L13.97 5.59L14.96 5.59L15.87 5.59L16.65 5.59L17.27 5.59L17.72 5.59L17.98 5.59L18.02 6.19L17.87 7.5L17.51 8.74L16.96 9.87L16.25 10.84L15.05 10.86L15.62 9.98L16.06 8.94L16.37 7.78L16.54 6.54L16.55 5.59L16.4 5.59L16.11 5.59L15.67 5.59L15.12 5.59L14.47 5.59L13.75 5.59L12.98 5.59Z",
        "fill": "accent"
      }
    ],
    "chit-chats": [
      {
        "type": "polygon",
        "d": "M11 4.17L8.06 9.62L5.55 7.67L6.24 11.89L11 14.63Z",
        "fill": "accent"
      },
      {
        "type": "polygon",
        "d": "M11 4.17L13.94 9.62L16.45 7.67L15.76 11.89L11 14.63Z",
        "fill": "#f6c6c9"
      }
    ],
    "correos-de-mexico": [
      {
        "type": "polygon",
        "d": "M3.7 7.9L5.05 7.9L5.05 13.15L16.95 13.15L16.95 7.9L18.3 7.9L18.3 14.5L3.7 14.5Z",
        "fill": "accent"
      },
      {
        "type": "polygon",
        "d": "M3.85 4.5L5.06 4.72L6.18 5.06L7.24 5.49L8.22 6.01L9.12 6.62L9.95 7.35L10.7 8.17L11.37 9.08L11.98 10.08L12.5 11.2L11.4 10.84L10.36 10.39L9.37 9.88L8.42 9.32L7.53 8.68L6.69 7.98L5.91 7.2L5.17 6.37L4.48 5.48Z",
        "fill": "accent"
      },
      {
        "type": "polygon",
        "d": "M18.15 4.5L16.94 4.72L15.82 5.06L14.76 5.49L13.78 6.01L12.88 6.62L12.05 7.35L11.3 8.17L10.63 9.08L10.02 10.08L9.5 11.2L10.6 10.84L11.64 10.39L12.63 9.88L13.58 9.32L14.47 8.68L15.31 7.98L16.09 7.2L16.83 6.37L17.52 5.48Z",
        "fill": "accent"
      },
      {
        "type": "polygon",
        "d": "M11 4.35L12.15 5.6L11 6.85L9.85 5.6Z",
        "fill": "accent"
      }
    ],
    "cyprus-post": [
      {
        "type": "polygon",
        "d": "M10.3 12.2L11.9 10.3L13.1 8.2L14.1 5.4L16.3 7L18.4 9.6L16.2 10.2L13.8 11.4L11.4 12.9L9.6 13.4Z",
        "fill": "accent"
      },
      {
        "type": "circle",
        "cx": 8.9,
        "cy": 10.2,
        "r": 3.35,
        "fill": "accent"
      },
      {
        "type": "circle",
        "cx": 8.9,
        "cy": 10.2,
        "r": 1.95,
        "fill": "truck"
      },
      {
        "type": "circle",
        "cx": 8.9,
        "cy": 10.2,
        "r": 0.8,
        "fill": "accent"
      },
      {
        "type": "line",
        "d": "M6 9.6L3.7 7.6",
        "stroke": "accent",
        "strokeWidth": 1.4
      }
    ],
    "day-ross": [
      {
        "type": "line",
        "d": "M14.58 13.9L14.21 13.49L13.68 12.9L13.07 12.22L12.44 11.53L11.87 10.91L11.34 10.36L10.8 9.81L10.28 9.29L9.82 8.8L9.45 8.36L9.18 7.96L8.97 7.61L8.84 7.29L8.77 6.98L8.77 6.68L8.84 6.38L8.98 6.07L9.19 5.79L9.43 5.54L9.69 5.36L9.99 5.25L10.34 5.18L10.71 5.16L11.05 5.19L11.34 5.28L11.58 5.43L11.8 5.66L11.98 5.93L12.1 6.22L12.14 6.51L12.09 6.79L11.97 7.09L11.78 7.4L11.55 7.71L11.28 8L10.96 8.29L10.58 8.56L10.16 8.83L9.75 9.11L9.37 9.41L9 9.73L8.63 10.06L8.27 10.4L7.98 10.74L7.76 11.08L7.62 11.44L7.55 11.82L7.54 12.19L7.59 12.54L7.7 12.84L7.88 13.12L8.14 13.38L8.46 13.61L8.81 13.79L9.17 13.9L9.57 13.94L10.01 13.92L10.48 13.85L10.92 13.72L11.33 13.55L11.7 13.32L12.04 13.02L12.37 12.68L12.66 12.32L12.93 11.96L13.19 11.57L13.42 11.12L13.62 10.68L13.79 10.3L13.91 10.03",
        "stroke": "#ff5f14",
        "strokeWidth": 2.1
      }
    ],
    "dsv": [
      {
        "type": "polygon",
        "d": "M3.3 6.1L5.9 6.1L6.67 6.36L7.31 7.1L7.75 8.2L7.9 9.5L7.75 10.8L7.31 11.9L6.67 12.64L5.9 12.9L3.3 12.9Z",
        "fill": "accent"
      },
      {
        "type": "polygon",
        "d": "M5.05 7.7L5.8 7.7L6.08 7.94L6.28 8.6L6.35 9.5L6.28 10.4L6.08 11.06L5.8 11.3L5.05 11.3Z",
        "fill": "truck"
      },
      {
        "type": "polygon",
        "d": "M9.55 6.1L12.85 6.1L12.85 7.7L10.55 7.7L10.55 8.7L12.15 8.7L12.85 9.3L12.85 12.2L12.15 12.9L8.85 12.9L8.85 11.3L11.15 11.3L11.15 10.3L9.55 10.3L8.85 9.7L8.85 6.8Z",
        "fill": "accent"
      },
      {
        "type": "polygon",
        "d": "M13.7 6.1L15.6 6.1L16.2 10.5L16.8 6.1L18.7 6.1L17.15 12.9L15.25 12.9Z",
        "fill": "accent"
      }
    ],
    "dx": [
      {
        "type": "polygon",
        "d": "M3.3 5.65L8.12 5.65L11 9.5L8.12 13.35L3.3 13.35Z",
        "fill": "accent"
      },
      {
        "type": "polygon",
        "d": "M5.71 8.06L7.05 8.06L8.12 9.5L7.05 10.94L5.71 10.94Z",
        "fill": "truck"
      },
      {
        "type": "polygon",
        "d": "M10.03 13.35L12.93 13.35L18.7 5.65L15.82 5.65Z",
        "fill": "accent"
      },
      {
        "type": "polygon",
        "d": "M10.03 5.65L12.93 5.65L14.37 7.57L12.93 9.5Z",
        "fill": "accent"
      },
      {
        "type": "polygon",
        "d": "M18.7 13.35L15.82 13.35L14.37 11.43L15.82 9.5Z",
        "fill": "accent"
      }
    ],
    "dynalogic": [
      {
        "type": "polygon",
        "d": "M5.4 4.3L11.6 4.3L12.71 4.43L13.77 4.81L14.72 5.43L15.51 6.26L16.1 7.24L16.47 8.34L16.6 9.5L16.47 10.66L16.1 11.76L15.51 12.74L14.72 13.57L13.77 14.19L12.71 14.57L11.6 14.7L5.4 14.7Z",
        "fill": "accent"
      },
      {
        "type": "polygon",
        "d": "M8.4 6.9L11.6 6.9L12.25 7.03L12.83 7.4L13.3 7.97L13.6 8.7L13.7 9.5L13.6 10.3L13.3 11.03L12.83 11.6L12.25 11.97L11.6 12.1L8.4 12.1Z",
        "fill": "truck"
      }
    ],
    "envialia": [
      {
        "type": "line",
        "d": "M15.7 9.5L15.72 8.24L15.27 7.11L14.41 6.22L13.21 5.64L11.79 5.45L10.29 5.66L8.86 6.24L7.65 7.14L6.76 8.28L6.29 9.54L6.29 10.79L6.75 11.92L7.62 12.81L8.83 13.37L10.26 13.55L11.76 13.33L13.18 12.74L14.39 11.82",
        "stroke": "accent",
        "strokeWidth": 2.1
      },
      {
        "type": "line",
        "d": "M6.3 9.5L15.7 9.5",
        "stroke": "accent",
        "strokeWidth": 2.1
      }
    ],
    "epost-global": [
      {
        "type": "polygon",
        "d": "M7.31 5.78L7.68 5.3L8.19 4.88L8.84 4.54L9.59 4.28L10.42 4.13L11.3 4.08L12.23 4.18L13.16 4.43L14.08 4.85L14.97 5.44L13.93 5.22L12.94 5.19L12.01 5.3L11.11 5.53L10.27 5.84L9.46 6.18L8.67 6.52L7.91 6.83L7.51 6.88L7.23 6.78L7.03 6.56L6.98 6.27L7.1 5.98Z",
        "fill": "accent"
      },
      {
        "type": "polygon",
        "d": "M5.55 8.31L5.81 8.74L6.27 9.05L6.92 9.24L7.73 9.3L8.68 9.24L9.74 9.05L10.89 8.74L12.1 8.31L13.17 7.87L14.15 7.59L15 7.5L15.68 7.63L16.15 8.04L16.4 8.75L16.45 9.56L16.4 10.29L15.95 9.87L15.31 9.62L14.53 9.52L13.63 9.57L12.62 9.75L11.55 10.07L10.73 10.37L9.91 10.66L9.12 10.92L8.36 11.14L7.63 11.27L6.96 11.3L6.36 11.2L5.83 10.95L5.58 10.12L5.49 9.21Z",
        "fill": "accent"
      },
      {
        "type": "polygon",
        "d": "M9.79 13.49L10.54 13.53L11.25 13.44L11.92 13.25L12.56 13.02L13.16 12.77L13.72 12.56L14.25 12.41L14.75 12.39L15.02 12.56L15.13 12.89L15.02 13.2L14.73 13.37L14.32 13.79L13.8 14.14L13.21 14.38L12.56 14.51L11.88 14.49L11.16 14.33L10.47 14.01Z",
        "fill": "accent"
      }
    ],
    "estes": [
      {
        "type": "circle",
        "cx": 11,
        "cy": 9.4,
        "r": 5.25,
        "fill": "accent"
      },
      {
        "type": "circle",
        "cx": 11,
        "cy": 9.4,
        "r": 3.95,
        "fill": "#e91b2c"
      },
      {
        "type": "polygon",
        "d": "M10.24 6.9L14.24 6.9L13.98 8.2L11.28 8.2L11.08 9.2L13.28 9.2L13.02 10.5L10.82 10.5L10.62 11.5L13.32 11.5L13.06 12.8L9.06 12.8Z",
        "fill": "accent"
      },
      {
        "type": "polygon",
        "d": "M9.69 6.45L13.69 6.45L13.43 7.75L10.73 7.75L10.53 8.75L12.73 8.75L12.47 10.05L10.27 10.05L10.07 11.05L12.77 11.05L12.51 12.35L8.51 12.35Z",
        "fill": "truck"
      }
    ],
    "fan-courier": [
      {
        "type": "polygon",
        "d": "M9.6 5.6L9.6 7L3.3 5.45L3.3 4.05Z",
        "fill": "accent"
      },
      {
        "type": "polygon",
        "d": "M12.4 5.6L18.7 4.05L18.7 5.45L12.4 7Z",
        "fill": "accent"
      },
      {
        "type": "polygon",
        "d": "M9.6 8L9.6 9.4L4.6 8.2L4.6 6.8Z",
        "fill": "accent"
      },
      {
        "type": "polygon",
        "d": "M12.4 8L17.4 6.8L17.4 8.2L12.4 9.4Z",
        "fill": "accent"
      },
      {
        "type": "polygon",
        "d": "M9.6 10.4L9.6 11.8L5.9 10.95L5.9 9.55Z",
        "fill": "accent"
      },
      {
        "type": "polygon",
        "d": "M12.4 10.4L16.1 9.55L16.1 10.95L12.4 11.8Z",
        "fill": "accent"
      },
      {
        "type": "polygon",
        "d": "M9.6 5.1L12.4 5.1L12.4 12.2L11 13.4L9.6 12.2Z",
        "fill": "accent"
      }
    ],
    "gebrueder-weiss": [
      {
        "type": "polygon",
        "d": "M16.38 5.42L15.2 4.82L13.88 4.41L12.48 4.2L11.05 4.2L9.65 4.42L8.33 4.85L7.16 5.46L6.17 6.23L5.41 7.14L4.91 8.14L4.69 9.2L4.75 10.26L5.09 11.3L5.71 12.26L6.57 13.12L7.64 13.83L8.88 14.36L10.24 14.7L11.66 14.82L13.09 14.74L14.46 14.44L15.73 13.94L16.83 13.27L17.74 12.44L18.41 11.5L18.81 10.47L18.92 9.4L18.75 8.34L17.34 8.66L17.47 9.43L17.38 10.21L17.06 10.95L16.53 11.64L15.81 12.24L14.93 12.73L13.92 13.09L12.82 13.31L11.69 13.37L10.56 13.28L9.48 13.04L8.49 12.65L7.64 12.13L6.95 11.51L6.46 10.81L6.18 10.06L6.13 9.28L6.31 8.51L6.71 7.78L7.32 7.12L8.1 6.56L9.04 6.11L10.08 5.81L11.2 5.65L12.34 5.64L13.46 5.79L14.51 6.09L15.45 6.53Z",
        "fill": "accent"
      },
      {
        "type": "polygon",
        "d": "M3.9 7.78L18.05 7.78L18.05 9.22L3.3 9.22Z",
        "fill": "accent"
      },
      {
        "type": "polygon",
        "d": "M8.3 8.5L9.85 8.5L10.3 10.2L11.05 8.5L12.6 8.5L10.75 12.1L9.25 12.1Z",
        "fill": "accent"
      },
      {
        "type": "polygon",
        "d": "M11.2 8.5L12.75 8.5L13.2 10.2L13.95 8.5L15.5 8.5L13.65 12.1L12.15 12.1Z",
        "fill": "accent"
      }
    ],
    "geniki-taxydromiki": [
      {
        "type": "circle",
        "cx": 5.09,
        "cy": 5.67,
        "r": 1.55,
        "fill": "accent"
      },
      {
        "type": "polygon",
        "d": "M5.13 6.78L5.47 6.7L5.62 6.69L5.88 6.81L6.18 7.13L6.49 7.65L6.77 8.36L6.98 9.27L8.32 9.06L8.23 8.05L8.05 7.11L7.76 6.27L7.34 5.53L6.74 4.91L5.94 4.5L5.22 4.38Z",
        "fill": "accent"
      },
      {
        "type": "polygon",
        "d": "M9.4 4.36L8.94 4.76L8.48 5.29L8.08 5.88L7.72 6.56L7.42 7.31L7.18 8.13L6.99 9L8.3 9.33L8.54 8.53L8.8 7.85L9.1 7.26L9.42 6.76L9.76 6.36L10.11 6.05L10.5 5.78Z",
        "fill": "accent"
      },
      {
        "type": "circle",
        "cx": 9.95,
        "cy": 5.07,
        "r": 1.05,
        "fill": "accent"
      },
      {
        "type": "polygon",
        "d": "M6.98 8.87L6.86 9.72L6.75 10.54L6.65 11.35L6.55 12.17L6.48 12.99L8.48 13.01L8.42 12.21L8.38 11.42L8.36 10.62L8.34 9.8L8.32 8.95Z",
        "fill": "accent"
      },
      {
        "type": "circle",
        "cx": 7.48,
        "cy": 13,
        "r": 1.05,
        "fill": "accent"
      },
      {
        "type": "polygon",
        "d": "M12.55 5.94L17.98 4.58L18.95 8.46L13.52 9.82Z",
        "fill": "accent"
      },
      {
        "type": "polygon",
        "d": "M13.13 6.2L17.59 5.09L15.87 7.69Z",
        "fill": "#e50019"
      }
    ],
    "jitsu": [
      {
        "type": "polygon",
        "d": "M7 4.15L15 7.69L11.6 9.16L7 7.15Z",
        "fill": "#ffffff"
      },
      {
        "type": "polygon",
        "d": "M15 7.69L15 10.66L7 14.15L7 11.15Z",
        "fill": "accent"
      }
    ],
    "kuehne-nagel": [
      {
        "type": "polygon",
        "d": "M15.28 12.79L15.78 12.01L16.14 11.16L16.35 10.26L16.4 9.34L16.29 8.42L16.03 7.53L15.62 6.71L15.08 5.96L14.42 5.32L13.65 4.8L12.81 4.41L11.92 4.18L11 4.1L10.08 4.18L9.19 4.41L8.35 4.8L7.58 5.32L6.92 5.96L6.38 6.71L5.97 7.53L5.71 8.42L5.6 9.34L5.65 10.26L5.86 11.16L6.22 12.01L6.72 12.79L7.87 11.9L7.5 11.34L7.24 10.71L7.09 10.05L7.05 9.38L7.13 8.71L7.32 8.06L7.62 7.46L8.02 6.91L8.5 6.44L9.06 6.06L9.67 5.78L10.33 5.61L11 5.55L11.67 5.61L12.33 5.78L12.94 6.06L13.5 6.44L13.98 6.91L14.38 7.46L14.68 8.06L14.87 8.71L14.95 9.38L14.91 10.05L14.76 10.71L14.5 11.34L14.13 11.9Z",
        "fill": "accent"
      },
      {
        "type": "polygon",
        "d": "M7.71 13.78L8.3 14.18L8.93 14.49L9.6 14.72L10.3 14.85L11 14.9L11.7 14.85L12.4 14.72L13.07 14.49L13.7 14.18L14.29 13.78L13.4 12.63L12.98 12.92L12.51 13.15L12.02 13.32L11.52 13.42L11 13.45L10.48 13.42L9.98 13.32L9.49 13.15L9.02 12.92L8.6 12.63Z",
        "fill": "accent"
      },
      {
        "type": "polygon",
        "d": "M10.28 8L11.72 8L11.72 13.65L10.28 13.65Z",
        "fill": "accent"
      },
      {
        "type": "polygon",
        "d": "M8.9 9.55L13.1 9.55L13.1 10.85L8.9 10.85Z",
        "fill": "accent"
      },
      {
        "type": "circle",
        "cx": 11,
        "cy": 7.35,
        "r": 1.55,
        "fill": "accent"
      },
      {
        "type": "circle",
        "cx": 11,
        "cy": 7.35,
        "r": 0.55,
        "fill": "truck"
      }
    ],
    "latvijas-pasts": [
      {
        "type": "polygon",
        "d": "M4.5 5.27L11.87 5.27L12.44 5.38L12.94 5.66L13.31 6.11L13.51 6.65L13.62 8.4L14.09 7.71L14.03 7.43L14.21 6.82L14.62 6.33L15.18 6.03L15.82 5.98L16.42 6.18L17.5 8.06L16.53 8.54L16.54 9.26L16.59 10.08L16.47 10.9L16.18 11.68L15.73 12.38L15.15 12.96L14.45 13.41L13.67 13.7L12.85 13.82L12.03 13.77L10.48 13.83L7.14 12.16L4.5 9.65L9.37 9.65L7.98 8.68L6.59 7.57L5.47 6.46Z",
        "fill": "accent"
      },
      {
        "type": "polygon",
        "d": "M9.23 9.58L12.7 10L10.41 12.71Z",
        "fill": "truck"
      }
    ],
    "loomis-express": [
      {
        "type": "polygon",
        "d": "M3.62 8.35L4.2 7.46L4.97 6.91L5.74 6.39L6.52 5.91L7.29 5.48L8.06 5.1L8.83 4.76L9.61 4.49L10.38 4.27L11.15 4.12L11.92 4.02L12.69 4L13.47 4.03L14.24 4.13L15.01 4.33L15.78 4.62L16.56 4.99L17.33 5.45L18.1 6.05L18.73 6.83L18.1 7.15L17.33 7.17L16.56 7.15L15.78 7.11L15.01 7.07L14.24 7.03L13.47 6.97L12.69 6.92L11.92 6.89L11.15 6.89L10.38 6.91L9.61 6.98L8.83 7.07L8.06 7.2L7.29 7.37L6.52 7.59L5.74 7.85L4.97 8.16L4.2 8.54Z",
        "fill": "accent"
      },
      {
        "type": "polygon",
        "d": "M4.2 7.88L4.97 7.33L5.74 6.81L6.52 6.33L7.29 5.9L8.06 5.52L8.83 5.18L9.61 4.91L10.38 4.69L11.15 4.54L11.92 4.44L12.69 4.42L13.47 4.45L14.24 4.55L15.01 4.75L15.78 5.04L16.56 5.41L17.33 5.87L18.1 6.47L18.1 6.73L17.33 6.75L16.56 6.73L15.78 6.69L15.01 6.65L14.24 6.61L13.47 6.55L12.69 6.5L11.92 6.47L11.15 6.47L10.38 6.49L9.61 6.56L8.83 6.65L8.06 6.78L7.29 6.95L6.52 7.17L5.74 7.43L4.97 7.74L4.2 8.12Z",
        "fill": "#d93835"
      },
      {
        "type": "polygon",
        "d": "M7.68 8.1L10.58 8.1L9.58 12.3L14.28 12.3L13.7 14.7L6.1 14.7Z",
        "fill": "accent"
      }
    ],
    "lso": [
      {
        "type": "polygon",
        "d": "M4.4 4.15L16.15 4.15L16.7 4.26L17.18 4.57L17.49 5.05L17.6 5.6L17.49 6.15L17.18 6.63L16.7 6.94L16.15 7.05L5.9 7.05L5.51 6.95L5.15 6.66L4.84 6.2L4.6 5.6L4.45 4.9Z",
        "fill": "accent"
      },
      {
        "type": "polygon",
        "d": "M5.75 8.05L16.15 8.05L16.7 8.16L17.18 8.47L17.49 8.95L17.6 9.5L17.49 10.05L17.18 10.53L16.7 10.84L16.15 10.95L7.25 10.95L6.86 10.85L6.5 10.56L6.19 10.1L5.95 9.5L5.8 8.8Z",
        "fill": "accent"
      },
      {
        "type": "polygon",
        "d": "M7.1 11.95L16.15 11.95L16.7 12.06L17.18 12.37L17.49 12.85L17.6 13.4L17.49 13.95L17.18 14.43L16.7 14.74L16.15 14.85L8.6 14.85L8.21 14.75L7.85 14.46L7.54 14L7.3 13.4L7.15 12.7Z",
        "fill": "accent"
      }
    ],
    "magyar-posta": [
      {
        "type": "polygon",
        "d": "M4.16 5.55L3.86 6.47L3.71 7.44L3.73 8.42L3.91 9.39L4.25 10.31L4.74 11.17L5.36 11.94L6.11 12.58L6.96 13.1L7.88 13.46L8.86 13.66L9.85 13.69L10.84 13.54L11.8 13.23L12.69 12.76L13.5 12.14L14.19 11.39L14.76 10.52L15.17 9.57L15.42 8.56L13.68 8.32L13.54 9.05L13.28 9.76L12.9 10.41L12.42 10.99L11.85 11.48L11.2 11.87L10.49 12.14L9.74 12.28L8.98 12.3L8.23 12.18L7.5 11.93L6.81 11.56L6.2 11.08L5.67 10.49L5.24 9.82L4.93 9.08L4.75 8.29L4.7 7.48L4.78 6.67L5 5.88Z",
        "fill": "accent"
      },
      {
        "type": "polygon",
        "d": "M4.13 5.91L3.63 4.21L5.03 5.56Z",
        "fill": "accent"
      },
      {
        "type": "polygon",
        "d": "M13.7 8.24L13.7 4.35L14.56 4.58L15.38 4.85L16.14 5.19L16.83 5.64L17.43 6.19L17.95 6.85L18.42 7.58L18.85 8.35L15.35 9.19Z",
        "fill": "accent"
      },
      {
        "type": "polygon",
        "d": "M6.55 10.58L6.62 9.59L6.83 9.01L7.17 8.49L7.62 8.06L8.16 7.74L8.77 7.53L9.4 7.46L10.03 7.53L10.64 7.74L11.18 8.06L11.63 8.49L11.97 9.01L12.18 9.59L12.25 10.58Z",
        "fill": "accent"
      },
      {
        "type": "polygon",
        "d": "M6.45 5.63L8.65 4.83L8.9 5.52L9.59 5.27L10.39 7.46L9.7 7.71L9.95 8.4L7.75 9.2L7.5 8.51L6.81 8.76L6.01 6.57L6.7 6.32Z",
        "fill": "accent"
      },
      {
        "type": "polygon",
        "d": "M7.1 10.2L7.16 9.71L7.33 9.25L7.6 8.84L7.97 8.49L8.4 8.23L8.89 8.07L9.4 8.02L9.91 8.07L10.4 8.23L10.83 8.49L11.2 8.84L11.47 9.25L11.64 9.71L11.7 10.2Z",
        "fill": "#ca342e"
      },
      {
        "type": "polygon",
        "d": "M7.16 5.96L8.32 5.53L8.57 6.22L9.26 5.97L9.68 7.14L8.99 7.39L9.24 8.07L8.08 8.5L7.83 7.81L7.14 8.06L6.72 6.89L7.41 6.64Z",
        "fill": "#ca342e"
      }
    ],
    "meest": [
      {
        "type": "polygon",
        "d": "M3.9 7.6L6.9 7.6L8.8 9.5L6.9 11.4L3.9 11.4Z",
        "fill": "accent"
      },
      {
        "type": "polygon",
        "d": "M10.05 4.4L13.92 4.4L18.68 9.5L13.92 14.6L10.05 14.6L14.82 9.5Z",
        "fill": "accent"
      },
      {
        "type": "polygon",
        "d": "M11.2 4.9L13.7 4.9L18 9.5L13.7 14.1L11.2 14.1L15.5 9.5Z",
        "fill": "#e60033"
      }
    ],
    "nationex": [
      {
        "type": "polygon",
        "d": "M5.95 13.12L8.6 7.94L8.79 7.69L8.97 7.57L9.18 7.51L9.4 7.53L9.6 7.61L9.76 7.76L9.87 7.95L9.92 8.26L9.92 10.72L10.06 11.56L10.52 12.39L11.22 13.03L12.09 13.4L13.03 13.47L13.94 13.22L14.73 12.69L15.24 12L18.48 5.68L16.05 5.68L13.4 10.86L13.21 11.11L13.03 11.23L12.82 11.29L12.6 11.27L12.4 11.19L12.24 11.04L12.13 10.85L12.08 10.54L12.08 8.08L11.94 7.24L11.48 6.41L10.78 5.77L9.91 5.4L8.97 5.33L8.06 5.58L7.27 6.11L6.76 6.8L3.52 13.12Z",
        "fill": "accent"
      }
    ],
    "post-luxembourg": [
      {
        "type": "polygon",
        "d": "M7.81 4.68L7.09 5.15L6.44 5.72L5.9 6.4L5.47 7.15L5.16 7.96L4.99 8.8L4.95 9.67L5.06 10.53L5.3 11.36L5.67 12.14L6.16 12.85L6.75 13.48L7.44 14L8.21 14.41L9.03 14.69L9.88 14.83L9.88 14.81L9.09 14.42L8.42 13.91L7.88 13.31L7.48 12.66L7.21 12L7.05 11.34L7 10.71L7.03 10.13L7.13 9.58L7.29 9.08L7.49 8.63L7.73 8.21L8 7.84L8.31 7.5L8.64 7.2L9.01 6.93Z",
        "fill": "#fddf00"
      },
      {
        "type": "polygon",
        "d": "M15.57 8.05L15.3 7.3L14.93 6.59L14.46 5.94L13.89 5.37L13.25 4.9L12.55 4.52L11.79 4.25L11.01 4.09L10.21 4.05L9.41 4.13L9.83 6.51L10.27 6.36L10.74 6.26L11.25 6.2L11.79 6.21L12.36 6.29L12.95 6.46L13.54 6.72L14.12 7.09L14.67 7.57L15.14 8.17Z",
        "fill": "#5ec4ec"
      },
      {
        "type": "circle",
        "cx": 11.45,
        "cy": 10.65,
        "r": 3.55,
        "fill": "accent"
      }
    ],
    "posta-slovenije": [
      {
        "type": "polygon",
        "d": "M14.53 5.31L18.21 5.31L18.15 6.43L17.97 7.54L17.69 8.6L17.29 9.6L16.8 10.52L16.21 11.34L15.55 12.05L14.82 12.62L14.03 13.06L13.21 13.35L12.37 13.48L11.52 13.46L9.43 13.22L8.67 12.86L7.99 12.34L7.44 11.7L7.03 10.97L6.77 10.16L6.69 9.32L6.78 8.48L7.03 7.67L7.45 6.93L8 6.3L8.68 5.79L9.44 5.42L10.26 5.22L11.11 5.19L11.94 5.34L12.73 5.65L13.44 6.11L14.04 6.71L14.5 7.42L14.81 8.2L14.96 9.04L14.76 9.5L14.52 9.91L14.23 10.27L13.92 10.57L13.58 10.82L13.22 11L12.87 11.13L12.51 11.2L12.85 10.73L13.12 10.23L13.26 9.68L13.28 9.11L13.16 8.55L12.92 8.04L12.57 7.59L12.13 7.24L11.62 7L11.06 6.88L10.5 6.89L9.95 7.03L9.44 7.29L9.01 7.66L8.68 8.12L8.46 8.65L8.37 9.21L8.41 9.77L8.58 10.32L8.86 10.81L9.25 11.22L9.73 11.53L10.26 11.72L10.83 11.78L11.46 11.8L12.21 11.74L12.95 11.56L13.65 11.26L14.3 10.85L14.87 10.35L15.37 9.76L15.76 9.1L16.05 8.38L16.23 7.62L16.29 6.85L14.53 6.85Z",
        "fill": "accent"
      },
      {
        "type": "polygon",
        "d": "M3.81 5.3L3.86 6.26L4.04 7.21L4.32 8.12L4.71 8.98L5.2 9.79L5.78 10.52L6.44 11.16L7.18 11.71L7.12 11.92L6.81 11.42L6.57 10.87L6.4 10.31L6.31 9.72L6.3 9.13L6.37 8.54L5.43 5.31Z",
        "fill": "accent"
      }
    ],
    "posta-srbije": [
      {
        "type": "polygon",
        "d": "M5.7 4.4L12.1 4.4L11.1 5.8L15.1 5.8L14.1 7.2L18.5 7.2L12.9 10L5.2 5.6Z",
        "fill": "accent"
      },
      {
        "type": "polygon",
        "d": "M4.6 6.6L12.9 11.2L18.3 8.6L16.1 13.3L9.1 13.3L9.9 12L6.1 12L6.9 10.7L3.4 10.7Z",
        "fill": "accent"
      }
    ],
    "ptt": [
      {
        "type": "polygon",
        "d": "M10.07 14.53L7.03 12.47L4.58 10.47L6.75 8.58L6.28 9.56L6.99 10.95L7.95 12.15L9.13 13.09L10.49 13.71L11.99 13.97L13.57 13.76L15.12 13.07L16.62 11.98L18.04 10.49L17.53 9.93L16 11.17L14.55 11.92L13.22 12.25L12.04 12.32L10.95 12.15L9.96 11.71L9.07 11.03L8.31 10.1L7.7 8.92L6.17 7.15L3.03 10.57L6.5 13.26L10 14.67Z",
        "fill": "accent"
      },
      {
        "type": "polygon",
        "d": "M6.77 4.7L8.6 4.91L10.33 5.25L11.91 5.73L13.29 6.36L14.44 7.14L15.3 8.06L15.83 9.13L16 10.36L15.74 11.74L15.55 10.74L15.12 9.84L14.46 9.01L13.6 8.24L12.54 7.52L11.32 6.82L9.93 6.13L8.41 5.43Z",
        "fill": "accent"
      },
      {
        "type": "polygon",
        "d": "M7.99 6.13L12.07 7.76L11.05 8.38L13.3 9.8L10.44 9.19L11.26 8.58L8.81 7.36Z",
        "fill": "accent"
      }
    ],
    "redpack": [
      {
        "type": "polygon",
        "d": "M6.31 4.9L11.18 4.9L11.94 5.24L12.19 6.03L12.02 7.15L11.68 8.73L11.18 9.62L10.26 10.41L10 11.2L9.08 14.12L7.23 14.12L7.9 12.21L5.89 12.21L5.13 14.12L3.2 14.12Z",
        "fill": "accent"
      },
      {
        "type": "polygon",
        "d": "M7.4 7.15L9.42 7.15L9.08 8.5L8.49 9.62L6.56 9.62Z",
        "fill": "truck"
      },
      {
        "type": "polygon",
        "d": "M16.39 4.9L18.74 4.9L13.87 10.07L14.54 14.12L12.69 14.12L11.85 10.07Z",
        "fill": "#062f87"
      }
    ],
    "rl-carriers": [
      {
        "type": "polygon",
        "d": "M6.15 5.3L10.95 5.3L11.54 5.55L11.62 6.2L10.92 9L10.41 9.65L9.77 10L10.24 10.35L10.42 11L9.75 13.7L7.65 13.7L8.3 11.1L8.15 10.9L6.85 10.9L6.15 13.7L4.05 13.7Z",
        "fill": "accent"
      },
      {
        "type": "polygon",
        "d": "M7.83 6.98L9.23 6.98L8.85 8.49L7.45 8.49Z",
        "fill": "truck"
      },
      {
        "type": "polygon",
        "d": "M10.86 8.85L14.36 8.85L14.04 10.15L10.54 10.15Z",
        "fill": "accent"
      },
      {
        "type": "polygon",
        "d": "M12.28 7.6L13.58 7.6L12.62 11.4L11.32 11.4Z",
        "fill": "accent"
      },
      {
        "type": "polygon",
        "d": "M15.15 5.3L17.25 5.3L15.65 11.7L17.95 11.7L17.45 13.7L13.05 13.7Z",
        "fill": "accent"
      }
    ],
    "russian-post": [
      {
        "type": "polygon",
        "d": "M7 14L7 4L15 4L15 14L12.8 14L12.8 6.2L9.2 6.2L9.2 14Z",
        "fill": "accent"
      }
    ],
    "saia": [
      {
        "type": "line",
        "d": "M7.01 5.99L6.7 5.56L6.26 5.29L5.75 5.2L5.25 5.32L4.83 5.63L4.55 6.07L4.46 6.6L4.57 7.12L4.86 7.55L5.29 7.85L5.8 7.95L6.3 8.05L6.73 8.35L7.03 8.78L7.13 9.3L7.04 9.83L6.76 10.27L6.34 10.58L5.84 10.7L5.33 10.61L4.89 10.34L4.59 9.91",
        "stroke": "accent",
        "strokeWidth": 1.5
      },
      {
        "type": "polygon",
        "d": "M8.68 10.7L10.33 5L11.98 10.7L10.68 10.7L10.33 8.7L9.98 10.7Z",
        "fill": "accent"
      },
      {
        "type": "polygon",
        "d": "M12.78 5.2L14.18 5.2L14.18 10.7L12.78 10.7Z",
        "fill": "accent"
      },
      {
        "type": "polygon",
        "d": "M14.98 10.7L16.63 5L18.28 10.7L16.98 10.7L16.63 8.7L16.28 10.7Z",
        "fill": "accent"
      },
      {
        "type": "polygon",
        "d": "M3.96 11.7L6.96 11.9L10.87 12.5L11.12 12.85L11.37 12.5L15.28 11.9L18.28 11.7L18.28 13L15.28 13.25L11.37 13.8L11.12 14.15L10.87 13.8L6.96 13.25L3.96 13Z",
        "fill": "accent"
      }
    ],
    "sameday": [
      {
        "type": "polygon",
        "d": "M7.81 4L14.19 4L16.18 10.29L11 14L5.82 10.29Z",
        "fill": "#af2025"
      },
      {
        "type": "polygon",
        "d": "M8.51 10.57L9.11 7.95L11 10.73L12.89 7.95L13.49 10.57L15.01 10.23L13.61 4.15L11 7.97L8.39 4.15L6.99 10.23Z",
        "fill": "accent"
      }
    ],
    "speedy": [
      {
        "type": "polygon",
        "d": "M11 4L16.35 6.73L16.35 12.27L11 15L5.65 12.27L5.65 6.73Z",
        "fill": "accent"
      },
      {
        "type": "line",
        "d": "M5.05 6.42L11 9.46L11 13.59",
        "stroke": "truck",
        "strokeWidth": 1.2
      },
      {
        "type": "line",
        "d": "M16.95 6.42L12.9 8.49",
        "stroke": "truck",
        "strokeWidth": 1.2
      }
    ],
    "trans-o-flex": [
      {
        "type": "polygon",
        "d": "M13.65 9.35L13.55 8.35L13.26 7.38L12.78 6.49L12.14 5.71L11.36 5.07L10.47 4.59L9.5 4.3L8.5 4.2L7.5 4.3L6.53 4.59L5.64 5.07L4.86 5.71L4.22 6.49L3.74 7.38L3.45 8.35L3.35 9.35L3.45 10.35L3.74 11.32L4.22 12.21L4.86 12.99L5.64 13.63L6.53 14.11L7.5 14.4L8.5 14.5L17 14.5L18.6 11.98L17.05 9.35L13.65 9.35Z",
        "fill": "accent"
      },
      {
        "type": "polygon",
        "d": "M12.1 9.35L12.02 8.58L11.77 7.85L11.38 7.19L10.86 6.63L10.23 6.19L9.51 5.9L8.76 5.76L7.99 5.79L7.24 5.98L6.55 6.32L5.95 6.8L5.47 7.4L5.13 8.09L4.94 8.84L4.91 9.61L5.05 10.36L5.34 11.08L5.78 11.71L6.34 12.23L7 12.62L7.73 12.87L8.5 12.95L15.7 12.95L15.7 11.95L8.5 11.95L7.83 11.86L7.2 11.6L6.66 11.19L6.25 10.65L5.99 10.02L5.9 9.35L5.99 8.68L6.25 8.05L6.66 7.51L7.2 7.1L7.83 6.84L8.5 6.75L9.17 6.84L9.8 7.1L10.34 7.51L10.75 8.05L11.01 8.68L11.1 9.35Z",
        "fill": "truck"
      },
      {
        "type": "polygon",
        "d": "M9.75 9.35L9.69 8.96L9.51 8.62L9.23 8.34L8.89 8.16L8.5 8.1L8.11 8.16L7.77 8.34L7.49 8.62L7.31 8.96L7.25 9.35Z",
        "fill": "truck"
      }
    ],
    "ubi-smart-parcel": [
      {
        "type": "line",
        "d": "M5.51 7.55L4.48 11.25L4.39 11.9L4.53 12.47L4.85 12.89L5.34 13.12L5.92 13.12L6.53 12.89L7.1 12.47L7.55 11.9L7.84 11.25L8.87 7.55M10.1 13.15L11.67 7.55L13.35 7.55L13.75 7.63L14.05 7.86L14.23 8.22L14.25 8.66L14.12 9.13L13.85 9.57L13.48 9.92L13.04 10.16L12.6 10.24L10.92 10.24M10.92 10.24L12.71 10.24L13.14 10.33L13.48 10.58L13.67 10.97L13.7 11.44L13.55 11.95L13.26 12.42L12.85 12.81L12.38 13.06L11.89 13.15L10.1 13.15M17.61 7.55L16.04 13.15",
        "stroke": "accent",
        "strokeWidth": 1.55
      },
      {
        "type": "polygon",
        "d": "M9.6 5.85L12.2 5.05L14.8 4.55L17.2 4.3L18.25 4.45L18.5 4.95L18.1 5.55L15 5.75L12.3 5.85Z",
        "fill": "#f2c46d"
      }
    ],
    "wanbexpress": [
      {
        "type": "polygon",
        "d": "M3.35 6L4.75 6L4.89 6.75L5.03 6L6.42 6L5.14 13L4.64 13Z",
        "fill": "accent"
      },
      {
        "type": "polygon",
        "d": "M5.02 6L6.42 6L6.56 6.75L6.7 6L8.1 6L6.81 13L6.31 13Z",
        "fill": "accent"
      },
      {
        "type": "polygon",
        "d": "M9.77 6L10.87 6L12.12 13L8.52 13Z",
        "fill": "#000000"
      },
      {
        "type": "polygon",
        "d": "M10.32 7.95L10.82 11.8L9.82 11.8Z",
        "fill": "truck"
      },
      {
        "type": "polygon",
        "d": "M12.54 6L13.79 6L14.39 10L14.39 6L15.54 6L15.54 13L14.29 13L13.69 9L13.69 13L12.54 13Z",
        "fill": "#000000"
      },
      {
        "type": "polygon",
        "d": "M15.96 6L17.76 6L18.16 6.08L18.5 6.31L18.73 6.65L18.81 7.05L18.81 8.84L18.41 9.39L18.96 9.89L18.88 12.35L18.65 12.69L18.31 12.92L17.91 13L15.96 13Z",
        "fill": "accent"
      },
      {
        "type": "polygon",
        "d": "M17.26 7.2L17.66 7.2L17.66 8.79L17.26 8.79Z",
        "fill": "truck"
      },
      {
        "type": "polygon",
        "d": "M17.26 9.89L17.71 9.89L17.71 11.8L17.26 11.8Z",
        "fill": "truck"
      }
    ],
    "whistl": [
      {
        "type": "circle",
        "cx": 11,
        "cy": 9.5,
        "r": 5.25,
        "fill": "accent"
      },
      {
        "type": "polygon",
        "d": "M14.82 11.18L14.46 11.73L14.03 12.23L13.52 12.66L12.95 13.01L12.33 13.26L11.67 13.42L11 13.48L10.33 13.42L9.67 13.26L9.05 13.01L8.48 12.66L7.97 12.23L7.54 11.73L7.18 11.18L7.08 10.84L7.16 10.49L7.41 10.22L7.75 10.11L8.11 10.2L8.37 10.44L8.66 10.78L9 11.07L9.36 11.3L9.75 11.49L10.16 11.62L10.58 11.7L11 11.73L11.42 11.7L11.84 11.62L12.25 11.49L12.64 11.3L13 11.07L13.34 10.78L13.63 10.44L13.89 10.2L14.25 10.11L14.59 10.22L14.84 10.49L14.92 10.84Z",
        "fill": "truck"
      }
    ],
    "xdp": [
      {
        "type": "polygon",
        "d": "M4.53 4.43L7.97 4.43L10.72 9.41L7.11 14.57L3.45 14.57L6.98 9.5Z",
        "fill": "#f4b84f"
      },
      {
        "type": "polygon",
        "d": "M12.35 4.43L15.79 4.43L18.55 9.41L14.93 14.57L11.28 14.57L14.81 9.5Z",
        "fill": "#f4b84f"
      }
    ],
    "xpo-ltl": [
      {
        "type": "line",
        "d": "M4.62 6.6L7.98 12.2M7.98 6.6L4.62 12.2M9.1 12.2L9.1 6.6L10.66 6.6L11.16 6.69L11.6 6.94L11.92 7.33L12.1 7.8L12.1 8.31L11.92 8.78L11.6 9.17L11.16 9.42L10.66 9.51L9.1 9.51M15.31 6.6L14.52 6.81L13.85 7.42L13.4 8.33L13.24 9.4L13.4 10.47L13.85 11.38L14.52 11.99L15.31 12.2L16.1 11.99L16.78 11.38L17.23 10.47L17.38 9.4L17.23 8.33L16.78 7.42L16.1 6.81L15.31 6.6",
        "stroke": "accent",
        "strokeWidth": 1.45
      }
    ],
    "yurtici-kargo": [
      {
        "type": "line",
        "d": "M5 5L8.2 8.7L5 13",
        "stroke": "accent",
        "strokeWidth": 1.75
      },
      {
        "type": "line",
        "d": "M12.6 5L7.6 13",
        "stroke": "accent",
        "strokeWidth": 2.1
      },
      {
        "type": "line",
        "d": "M16.8 5L12.2 8.7L17 13",
        "stroke": "#ee7d00",
        "strokeWidth": 1.75
      }
    ],
    "zeleris": [
      {
        "type": "circle",
        "cx": 11.74,
        "cy": 8.92,
        "r": 2.75,
        "fill": "accent"
      },
      {
        "type": "circle",
        "cx": 6.04,
        "cy": 11.63,
        "r": 1.98,
        "fill": "accent"
      },
      {
        "type": "circle",
        "cx": 14.51,
        "cy": 13.44,
        "r": 1.54,
        "fill": "accent"
      },
      {
        "type": "circle",
        "cx": 16.76,
        "cy": 6.75,
        "r": 1.17,
        "fill": "accent"
      },
      {
        "type": "circle",
        "cx": 8.85,
        "cy": 5.08,
        "r": 0.91,
        "fill": "accent"
      }
    ],
    "99minutos": [
      {
        "type": "circle",
        "cx": 10.6,
        "cy": 9.9,
        "r": 4.85,
        "fill": "accent"
      },
      {
        "type": "polygon",
        "d": "M14.29 7.16L15.04 6.42L14.08 5.46L13.34 6.21Z",
        "fill": "accent"
      },
      {
        "type": "polygon",
        "d": "M15.51 6.89L16.47 5.94L14.56 4.03L13.61 4.99Z",
        "fill": "accent"
      },
      {
        "type": "line",
        "d": "M9.8 9.46L9.87 8.94L9.76 8.43L9.48 8L9.08 7.73L8.61 7.65L8.15 7.78L7.76 8.09L7.52 8.54L7.45 9.06L7.56 9.57L7.84 10L8.24 10.27L8.71 10.35L9.17 10.22L9.56 9.91L9.8 9.46L9.87 9L9.33 12.15M13.58 9.46L13.65 8.94L13.54 8.43L13.26 8L12.86 7.73L12.39 7.65L11.93 7.78L11.54 8.09L11.3 8.54L11.23 9.06L11.34 9.57L11.62 10L12.02 10.27L12.49 10.35L12.95 10.22L13.34 9.91L13.58 9.46L13.65 9L13.11 12.15",
        "stroke": "#323634",
        "strokeWidth": 1.45
      }
    ],
    "cargus": [
      {
        "type": "polygon",
        "d": "M5.51 4L16.49 4L16.49 7.44L5.51 7.44Z",
        "fill": "accent"
      },
      {
        "type": "polygon",
        "d": "M5.51 8.54L13.49 8.54L5.99 11.98L5.51 11.98Z",
        "fill": "accent"
      },
      {
        "type": "polygon",
        "d": "M16.49 8.54L16.49 12.44L10.96 15L6.75 13.01Z",
        "fill": "accent"
      }
    ],
    "cdl": [
      {
        "type": "polygon",
        "d": "M10.2 8.4L7.6 8.3L5.3 9.4L7.9 10.4L5.9 11.7L3.6 14.5L6.9 13.4L7.6 15L10.3 13.4L12.6 12Z",
        "fill": "#fb3e3e"
      },
      {
        "type": "polygon",
        "d": "M13.06 4.76L15.43 5.81L17.36 8.3L14.99 7.24Z",
        "fill": "accent"
      },
      {
        "type": "polygon",
        "d": "M14.82 8.16L17.63 9.4L14.62 12.83L11.81 11.58Z",
        "fill": "accent"
      },
      {
        "type": "polygon",
        "d": "M11.88 4.71L14.12 7.59L11.09 11.03L8.86 8.15Z",
        "fill": "accent"
      }
    ],
    "dao": [
      {
        "type": "line",
        "d": "M5.62 8.65L4.86 8.87L4.25 9.48L3.9 10.36L3.9 11.33L4.25 12.21L4.86 12.82L5.62 13.03L6.4 12.82L7.01 12.21L7.35 11.33L7.35 10.36L7.01 9.48L6.4 8.87L5.62 8.65M7.39 5.97L7.39 13.03M10.93 8.65L10.19 8.87L9.61 9.48L9.28 10.36L9.28 11.33L9.61 12.21L10.19 12.82L10.93 13.03L11.67 12.82L12.26 12.21L12.58 11.33L12.58 10.36L12.26 9.48L11.67 8.87L10.93 8.65M12.63 8.65L12.63 13.03M16.3 8.65L15.5 8.87L14.87 9.48L14.51 10.36L14.51 11.33L14.87 12.21L15.5 12.82L16.3 13.03L17.1 12.82L17.73 12.21L18.1 11.33L18.1 10.36L17.73 9.48L17.1 8.87L16.3 8.65",
        "stroke": "accent",
        "strokeWidth": 1.5
      }
    ],
    "early-bird": [
      {
        "type": "polygon",
        "d": "M4.55 7.77L8.42 7.77L6.99 5.46L11.75 6.81L13.42 6.19L13.77 5.6L14.32 5.18L14.98 4.99L15.67 5.06L16.28 5.38L16.73 5.9L17.45 5.8L16.3 7.02L15.71 9.06L15.88 9.98L15.82 10.91L15.53 11.81L15.02 12.6L14.34 13.24L13.51 13.69L12.6 13.92L11.66 13.91L10.76 13.67L8.76 13.06L5.03 14.01L7.94 10.75Z",
        "fill": "accent"
      },
      {
        "type": "circle",
        "cx": 15.35,
        "cy": 6.61,
        "r": 0.6,
        "fill": "truck"
      }
    ],
    "econt": [
      {
        "type": "polygon",
        "d": "M7.94 4.3L15.12 4.3L15.71 4.46L16.11 4.91L16.22 5.53L15.99 6.14L15.5 6.59L14.87 6.75L9.35 6.75L8.79 12.25L14.32 12.25L14.92 12.41L15.32 12.86L15.42 13.47L15.2 14.09L14.7 14.54L14.08 14.7L6.9 14.7L6.46 14.58L6.17 14.25L6.09 13.8L6.95 5.2L7.12 4.75L7.48 4.42Z",
        "fill": "accent"
      },
      {
        "type": "circle",
        "cx": 12.47,
        "cy": 9.5,
        "r": 1.55,
        "fill": "accent"
      }
    ],
    "elta": [
      {
        "type": "polygon",
        "d": "M14.07 6.77L14.34 7.25L14.81 7.74L15.21 8.17L15.61 8.61L15.76 8.76L15.64 8.88L15.73 9.78L15.73 9.78L15.64 10.35L15.81 10.73L15.47 10.83L14.94 10.9L14.37 11.06L13.59 11.09L12.88 11.13L12.77 11.4L13.32 11.91L14.14 12.42L15.01 12.62L15.8 12.52L16.48 12.33L17.05 12.05L17.53 11.57L17.68 10.72L17.44 10.16L17.41 10.13L17.52 9.66L17.42 9.38L17.77 8.69L17.29 7.85L16.84 7.41L16.47 7.01L16.07 6.57L15.6 6.07L15.13 5.76Z",
        "fill": "accent"
      },
      {
        "type": "polygon",
        "d": "M15.45 5.02L14.71 4.67L13.93 4.87L13.28 5.26L12.74 5.72L12.32 6.24L11.97 6.8L11.68 7.36L11.38 7.89L11.04 8.41L11.16 8.56L11.77 8.35L12.35 8.03L12.91 7.68L13.42 7.34L13.87 7.03L14.25 6.78L14.6 6.64L14.92 6.56L15.42 6.23Z",
        "fill": "accent"
      },
      {
        "type": "polygon",
        "d": "M14.45 10.87L13.73 11.27L12.99 11.82L12.28 12.47L11.57 13.19L10.8 13.94L9.96 14.71L10.07 14.87L11.13 14.44L12.11 13.97L13.03 13.53L13.84 13.12L14.56 12.78L15.24 12.5Z",
        "fill": "accent"
      },
      {
        "type": "polygon",
        "d": "M5.39 4.54L6.54 4.31L7.73 4.11L8.95 4.01L10.18 4.06L11.43 4.33L12.69 4.88L13.96 5.78L12.69 5.94L11.43 6.09L10.18 6.17L8.95 6.11L7.73 5.86L6.54 5.36Z",
        "fill": "accent"
      },
      {
        "type": "polygon",
        "d": "M7.26 6.96L8.12 6.58L9 6.29L9.89 6.1L10.78 6.02L11.65 6.08L12.48 6.29L13.27 6.66L12.48 7.17L11.65 7.57L10.78 7.83L9.89 7.94L9 7.84L8.12 7.53Z",
        "fill": "accent"
      }
    ],
    "express-one": [
      {
        "type": "polygon",
        "d": "M11.48 4.74L10.38 4.27L9.21 4.06L8.03 4.12L6.89 4.46L5.85 5.05L4.98 5.86L4.32 6.84L3.9 7.95L3.75 9.13L3.87 10.31L4.26 11.44L4.9 12.44L5.75 13.27L6.76 13.89L7.9 14.25L9.08 14.35L10.25 14.17L11.36 13.73L12.33 13.04L13.12 12.15L18.58 4.35L16.75 4.35L11.89 11.29L11.33 11.92L10.64 12.41L9.86 12.72L9.03 12.85L8.19 12.78L7.39 12.52L6.67 12.09L6.06 11.5L5.61 10.79L5.34 9.99L5.25 9.15L5.36 8.32L5.66 7.53L6.12 6.83L6.74 6.26L7.47 5.84L8.28 5.6L9.12 5.56L9.95 5.7L10.73 6.04Z",
        "fill": "accent"
      },
      {
        "type": "polygon",
        "d": "M10.38 7L9.83 6.72L9.23 6.57L8.61 6.57L8 6.71L7.45 6.98L6.97 7.38L6.6 7.88L6.36 8.45L6.25 9.06L6.29 9.68L6.48 10.28L6.79 10.81L7.23 11.26L7.75 11.59L8.34 11.79L8.96 11.85L9.57 11.76L10.15 11.54L10.66 11.18L11.07 10.72L15.53 4.35L13.7 4.35L9.84 9.86L9.66 10.06L9.44 10.21L9.19 10.31L8.92 10.35L8.66 10.32L8.4 10.24L8.17 10.09L7.99 9.9L7.85 9.67L7.77 9.41L7.75 9.14L7.8 8.88L7.9 8.63L8.06 8.41L8.27 8.24L8.51 8.12L8.77 8.06L9.04 8.06L9.3 8.12L9.54 8.25Z",
        "fill": "accent"
      }
    ],
    "foxpost": [
      {
        "type": "polygon",
        "d": "M15.45 8.6L14.75 4.1L12 7L12.8 7.9L14.05 6.55L14.05 8Z",
        "fill": "accent"
      },
      {
        "type": "polygon",
        "d": "M6.55 8.6L7.25 4.1L10 7L9.2 7.9L7.95 6.55L7.95 8Z",
        "fill": "accent"
      },
      {
        "type": "polygon",
        "d": "M16.7 9.7L15.4 9.35L14.1 9.3L13 9.55L12.15 10.15L11.65 11L11.5 12L11.5 14.4Z",
        "fill": "accent"
      },
      {
        "type": "polygon",
        "d": "M5.3 9.7L6.6 9.35L7.9 9.3L9 9.55L9.85 10.15L10.35 11L10.5 12L10.5 14.4Z",
        "fill": "accent"
      },
      {
        "type": "circle",
        "cx": 9.25,
        "cy": 10.75,
        "r": 0.68,
        "fill": "#000000"
      },
      {
        "type": "circle",
        "cx": 12.75,
        "cy": 10.75,
        "r": 0.68,
        "fill": "#000000"
      },
      {
        "type": "circle",
        "cx": 11,
        "cy": 14.2,
        "r": 0.65,
        "fill": "#000000"
      }
    ],
    "geis": [
      {
        "type": "line",
        "d": "M7.54 6.92L6.99 6.31L6.31 6.1L5.59 6.33L4.92 6.95L4.4 7.9L4.1 9.04L4.06 10.21L4.28 11.26L4.73 12.04L5.36 12.45L6.07 12.44L6.78 12L7.38 11.19L7.79 10.13L7.8 9.62L6.3 9.62M9.65 10.52L12.53 10.52L12.5 9.79L12.28 9.17L11.89 8.73L11.39 8.54L10.85 8.62L10.35 8.96L9.94 9.52L9.69 10.22L9.64 10.96L9.79 11.63L10.11 12.16L10.57 12.45L11.11 12.48L11.64 12.23M17.96 9.01L17.68 8.74L17.29 8.57L16.84 8.54L16.39 8.64L16.01 8.86L15.75 9.18L15.65 9.54L15.72 9.89L15.96 10.19L16.32 10.38L16.76 10.45L17.21 10.53L17.57 10.73L17.8 11.05L17.88 11.43L17.77 11.81L17.51 12.15L17.13 12.39L16.68 12.5L16.22 12.46L15.83 12.28L15.56 11.99M14.35 8.53L13.95 12.5",
        "stroke": "accent",
        "strokeWidth": 1.5
      },
      {
        "type": "polygon",
        "d": "M13.78 5.95L15.38 5.95L15.28 7.5L13.68 7.5Z",
        "fill": "accent"
      }
    ],
    "go-express": [
      {
        "type": "line",
        "d": "M8.21 6.9L7.41 6.23L6.5 6L5.59 6.25L4.81 6.93L4.25 7.97L4.01 9.21L4.1 10.49L4.53 11.64L5.22 12.5L6.09 12.95L7.02 12.93L7.88 12.45L8.55 11.57L8.95 10.41L8.9 9.85L6.94 9.85M15.9 9.5L15.7 8.16L15.14 7.03L14.3 6.27L13.31 6L12.32 6.27L11.48 7.03L10.92 8.16L10.72 9.5L10.92 10.84L11.48 11.97L12.32 12.73L13.31 13L14.3 12.73L15.14 11.97L15.7 10.84L15.9 9.5L15.7 8.16",
        "stroke": "accent",
        "strokeWidth": 1.7
      },
      {
        "type": "polygon",
        "d": "M17.15 6L18.85 6L18.85 10.7L17.15 10.7Z",
        "fill": "accent"
      },
      {
        "type": "polygon",
        "d": "M17.15 11.6L18.85 11.6L18.85 13.15L17.15 13.15Z",
        "fill": "accent"
      }
    ],
    "helthjem": [
      {
        "type": "polygon",
        "d": "M9 4L14.51 5.49L11.83 8.3L6.04 6.51Z",
        "fill": "accent"
      },
      {
        "type": "polygon",
        "d": "M16.3 7.41L16.3 12.61L12.33 14.2L12.33 9.16Z",
        "fill": "accent"
      },
      {
        "type": "polygon",
        "d": "M5.7 9.76L5.7 7.49L11.33 9.18L11.33 11.38Z",
        "fill": "accent"
      },
      {
        "type": "polygon",
        "d": "M11.33 14.25L5.7 12.61L5.7 10.8L11.33 12.42Z",
        "fill": "accent"
      }
    ],
    "hrvatska-posta": [
      {
        "type": "polygon",
        "d": "M3.8 4.45L13.39 4.48L12.58 4.56L11.79 4.79L11.06 5.16L10.41 5.67L9.87 6.29L9.46 7L9.19 7.77L9.07 8.59L9.1 9.41L9.29 10.2L9.63 10.95L10.1 11.63L10.69 12.2L11.38 12.65L12.14 12.96L12.94 13.12L13.76 13.13L14.57 12.98L15.33 12.69L16.03 12.25L16.63 11.69L17.12 11.03L17.47 10.29L17.67 9.49L17.78 9.57L18.2 9.16L18.14 9.84L17.99 10.51L17.77 11.16L17.47 11.78L17.1 12.36L16.66 12.89L16.16 13.37L15.62 13.78L15.02 14.13L14.39 14.4L13.73 14.6L13.05 14.71L12.37 14.75L11.68 14.7L11.01 14.58L10.35 14.37L9.72 14.09L9.13 13.73L8.59 13.31L8.1 12.83Z",
        "fill": "accent"
      }
    ],
    "instabox": [
      {
        "type": "polygon",
        "d": "M6.15 9.5L10.7 4.95L11.25 4.52L11.89 4.23L12.58 4.1L13.28 4.15L13.95 4.36L14.38 4.62L7.82 11.17Z",
        "fill": "accent"
      },
      {
        "type": "polygon",
        "d": "M15.18 5.45L15.4 5.83L15.61 6.5L15.64 7.2L15.51 7.89L15.33 8.29L10.13 13.48L8.64 11.99Z",
        "fill": "accent"
      },
      {
        "type": "polygon",
        "d": "M15.02 10.23L15.22 10.47L15.51 11.11L15.64 11.8L15.61 12.5L15.4 13.17L15.04 13.77L14.55 14.27L13.95 14.64L13.28 14.85L12.58 14.9L11.89 14.77L11.25 14.48L10.98 14.27Z",
        "fill": "accent"
      }
    ],
    "lietuvos-pastas": [
      {
        "type": "polygon",
        "d": "M3.3 4.95L3.4 6.44L3.7 7.89L4.18 9.26L4.85 10.51L5.67 11.62L6.63 12.56L7.7 13.3L8.86 13.81L10.07 14.09L11.3 14.14L12.52 13.94L13.7 13.5L14.81 12.84L15.81 11.97L16.68 10.92L17.4 9.71L17.95 8.38L18.32 6.95L18.57 6.4L17.33 6.45L17.48 6.95L17.16 8.06L16.69 9.1L16.1 10.03L15.4 10.83L14.61 11.48L13.75 11.97L12.83 12.28L11.89 12.4L10.94 12.33L10.02 12.08L9.14 11.64L8.32 11.04L7.59 10.28L6.97 9.39L6.47 8.38L6.1 7.29L5.88 6.13L5.8 4.95Z",
        "fill": "accent"
      },
      {
        "type": "circle",
        "cx": 11.95,
        "cy": 7.95,
        "r": 3.45,
        "fill": "accent"
      },
      {
        "type": "polygon",
        "d": "M9.65 9.7L9.65 7.05L10.65 7.05L10.65 8.7L11.45 8.7L11.45 6.05L12.45 6.05L12.45 8.7L13.25 8.7L13.25 7.05L14.25 7.05L14.25 9.7Z",
        "fill": "truck"
      }
    ],
    "maltapost": [
      {
        "type": "polygon",
        "d": "M3.6 6.8L4.35 10.05L5.29 11.54L6.43 12.77L7.75 13.68L9.18 14.25L10.66 14.45L12.15 14.27L13.58 13.72L14.9 12.82L16.06 11.61L17.01 10.13L17.72 8.44L18.15 6.61L18.3 4.7L14.6 4.7L14.25 6.2L13.5 10.37L12.94 11.26L12.19 11.98L11.28 12.51L10.27 12.8L9.23 12.83L8.2 12.62L7.26 12.16L6.46 11.48L5.84 10.63L5.45 9.66Z",
        "fill": "accent"
      },
      {
        "type": "circle",
        "cx": 9.6,
        "cy": 8.55,
        "r": 3.25,
        "fill": "accent"
      },
      {
        "type": "polygon",
        "d": "M9.71 8.66L10.47 10.72L10.73 9.68L11.77 9.42Z",
        "fill": "truck"
      },
      {
        "type": "polygon",
        "d": "M9.49 8.66L7.43 9.42L8.47 9.68L8.73 10.72Z",
        "fill": "truck"
      },
      {
        "type": "polygon",
        "d": "M9.49 8.44L8.73 6.38L8.47 7.42L7.43 7.68Z",
        "fill": "truck"
      },
      {
        "type": "polygon",
        "d": "M9.71 8.44L11.77 7.68L10.73 7.42L10.47 6.38Z",
        "fill": "truck"
      }
    ],
    "matkahuolto": [
      {
        "type": "polygon",
        "d": "M16.01 7.58L15.55 6.58L14.9 5.71L14.08 4.99L13.13 4.45L12.09 4.11L11 4L9.91 4.11L8.87 4.45L7.92 4.99L7.1 5.71L6.45 6.58L5.99 7.58L8.19 7.58L8.52 7.12L8.92 6.74L9.39 6.42L9.9 6.19L10.44 6.05L11 6L11.56 6.05L12.1 6.19L12.61 6.42L13.08 6.74L13.48 7.12L13.81 7.58Z",
        "fill": "accent"
      },
      {
        "type": "polygon",
        "d": "M5.99 11.03L6.45 12.02L7.1 12.89L7.92 13.61L8.87 14.15L9.91 14.49L11 14.6L12.09 14.49L13.13 14.15L14.08 13.61L14.9 12.89L15.55 12.02L16.01 11.03L13.81 11.03L13.48 11.48L13.08 11.86L12.61 12.18L12.1 12.41L11.56 12.55L11 12.6L10.44 12.55L9.9 12.41L9.39 12.18L8.92 11.86L8.52 11.48L8.19 11.02Z",
        "fill": "accent"
      }
    ],
    "omniva": [
      {
        "type": "polygon",
        "d": "M6.2 6.35L6.87 5.77L7.62 5.31L8.44 4.98L9.3 4.77L10.18 4.7L11.06 4.77L11.91 4.98L12.73 5.31L13.48 5.77L14.15 6.35Z",
        "fill": "accent"
      },
      {
        "type": "polygon",
        "d": "M14.15 4.7L14.73 5.37L15.19 6.12L15.52 6.94L15.73 7.8L15.8 8.68L15.73 9.56L15.52 10.41L15.19 11.23L14.73 11.98L14.15 12.65Z",
        "fill": "accent"
      },
      {
        "type": "polygon",
        "d": "M15.8 12.65L15.13 13.23L14.38 13.69L13.56 14.02L12.7 14.23L11.82 14.3L10.94 14.23L10.09 14.02L9.27 13.69L8.52 13.23L7.85 12.65Z",
        "fill": "accent"
      },
      {
        "type": "polygon",
        "d": "M7.85 14.3L7.27 13.63L6.81 12.88L6.48 12.06L6.27 11.2L6.2 10.32L6.27 9.44L6.48 8.59L6.81 7.77L7.27 7.02L7.85 6.35Z",
        "fill": "accent"
      }
    ],
    "orlen-paczka": [
      {
        "type": "polygon",
        "d": "M6.55 6.39L6.55 5.78L7.02 5.03L7.77 4.48L8.79 4.14L10.08 4.01L11.65 4.01L13.14 4.21L14.5 4.76L15.59 5.57L18.51 8.43L18.45 9.11L17.9 9.58L17.09 9.72L16.34 9.52L13.35 6.8L12.73 6.39Z",
        "fill": "accent"
      },
      {
        "type": "polygon",
        "d": "M4.17 10.74L3.62 9.52L3.69 8.77L4.1 8.09L4.78 7.68L5.59 7.41L6.68 7.34L7.84 7.54L8.86 8.16L9.95 9.31L11.44 10.81L12.67 12.17L13.21 13.26L13.07 14.21L12.46 14.96L11.51 14.41L6.95 9.79L5.05 9.72L4.71 10.06Z",
        "fill": "accent"
      },
      {
        "type": "circle",
        "cx": 11.44,
        "cy": 8.16,
        "r": 0.82,
        "fill": "accent"
      }
    ],
    "osm-worldwide": [
      {
        "type": "polygon",
        "d": "M6.41 6.1L5.82 6.21L5.22 6.54L4.67 7.07L4.2 7.75L3.85 8.55L3.62 9.4L3.56 10.25L3.64 11.05L3.88 11.73L4.25 12.26L4.73 12.59L5.29 12.7L5.88 12.59L6.48 12.26L7.03 11.73L7.5 11.05L7.85 10.25L8.07 9.4L8.14 8.55L8.06 7.75L7.82 7.07L7.45 6.54L6.97 6.21Z",
        "fill": "accent"
      },
      {
        "type": "polygon",
        "d": "M6.15 7.62L5.91 7.73L5.66 8.04L5.43 8.51L5.26 9.09L5.15 9.71L5.13 10.29L5.2 10.76L5.34 11.07L5.55 11.18L5.79 11.07L6.04 10.76L6.27 10.29L6.44 9.71L6.55 9.09L6.57 8.51L6.5 8.04L6.36 7.73Z",
        "fill": "truck"
      },
      {
        "type": "line",
        "d": "M11.52 7.54L11.34 7.12L11.04 6.92L10.67 6.99L10.31 7.31L10.05 7.8L9.93 8.37L9.98 8.9L10.2 9.27L10.53 9.4L10.85 9.53L11.07 9.9L11.12 10.43L11 11L10.74 11.49L10.38 11.81L10.01 11.88L9.71 11.68L9.53 11.26",
        "stroke": "accent",
        "strokeWidth": 1.63
      },
      {
        "type": "polygon",
        "d": "M12.41 12.7L13.54 6.1L15.69 6.1L15.35 9.84L16.29 6.1L18.44 6.1L17.31 12.7L15.71 12.7L16.45 8.4L15.31 11.54L14.81 11.54L14.74 8.4L14.01 12.7Z",
        "fill": "accent"
      }
    ],
    "paquetexpress": [
      {
        "type": "polygon",
        "d": "M3.4 4.15L5.6 4.15L5.6 11.95L5.67 12.31L5.88 12.62L6.19 12.83L6.55 12.9L18.6 12.9L18.6 14.15L5.6 14.15L4.92 14.04L4.31 13.73L3.82 13.24L3.51 12.63L3.4 11.95Z",
        "fill": "accent"
      },
      {
        "type": "polygon",
        "d": "M6.6 4.15L7.9 4.15L7.9 10.4L7.92 10.5L7.97 10.58L8.05 10.63L8.15 10.65L18.6 10.65L18.6 11.9L8.1 11.9L7.64 11.83L7.22 11.61L6.89 11.28L6.67 10.86L6.6 10.4Z",
        "fill": "accent"
      },
      {
        "type": "polygon",
        "d": "M11.2 4.15L13.45 4.15L14.16 4.29L14.76 4.69L15.16 5.29L15.3 6L15.16 6.71L14.76 7.31L14.16 7.71L13.45 7.85L12.85 7.85L12.85 9.65L11.2 9.65Z",
        "fill": "accent"
      },
      {
        "type": "polygon",
        "d": "M12.85 5.35L13.45 5.35L13.77 5.44L14.01 5.68L14.1 6L14.01 6.33L13.77 6.56L13.45 6.65L12.85 6.65Z",
        "fill": "truck"
      }
    ],
    "passport": [
      {
        "type": "polygon",
        "d": "M6.37 4.8L10.86 4.8L11.72 5.01L12.28 5.33L12.44 5.54L10.86 6.08L9 6.54L7.3 6.82L6.37 6.64Z",
        "fill": "accent"
      },
      {
        "type": "polygon",
        "d": "M6.37 14.6L6.37 11.01L6.78 9.94L7.72 8.78L9.11 7.61L10.74 6.68L12.28 5.98L12.98 5.75L13.38 6.45L13.58 7.61L13.49 8.78L13.07 9.8L12.33 10.55L11.33 11.01L10.05 11.2L8.42 11.25L8.42 14.6Z",
        "fill": "accent"
      },
      {
        "type": "polygon",
        "d": "M12.65 4.68L15.63 4.4L13.96 6.12Z",
        "fill": "accent"
      }
    ],
    "ppl": [
      {
        "type": "polygon",
        "d": "M3.75 7.9L5.8 7.9L6 6.7L3.95 6.7Z",
        "fill": "accent"
      },
      {
        "type": "polygon",
        "d": "M3.4 10.1L5.45 10.1L5.64 8.9L3.59 8.9Z",
        "fill": "accent"
      },
      {
        "type": "polygon",
        "d": "M3.05 12.3L5.1 12.3L5.29 11.1L3.24 11.1Z",
        "fill": "accent"
      },
      {
        "type": "line",
        "d": "M6.45 12.3L7.35 6.7L8.5 6.7L9 6.81L9.38 7.12L9.6 7.58L9.62 8.12L9.43 8.66L9.06 9.12L8.58 9.43L8.04 9.54L6.89 9.54M11.15 12.3L12.05 6.7L13.2 6.7L13.7 6.81L14.08 7.12L14.3 7.58L14.32 8.12L14.13 8.66L13.76 9.12L13.28 9.43L12.74 9.54L11.59 9.54M16.75 6.7L15.85 12.3L18.2 12.3",
        "stroke": "accent",
        "strokeWidth": 1.5
      }
    ],
    "slovak-parcel-service": [
      {
        "type": "line",
        "d": "M9.55 9L9.25 8.59L8.88 8.24L8.45 7.97L7.97 7.79L7.47 7.71L6.96 7.72L6.46 7.84L6 8.05L5.59 8.35L5.24 8.72L4.97 9.15L4.79 9.63L4.71 10.13L4.72 10.64L4.84 11.14L5.05 11.6L5.35 12.01L5.72 12.36L6.15 12.63L6.63 12.81L7.13 12.89L7.64 12.88L8.14 12.76L8.6 12.55L17.4 4.7",
        "stroke": "accent",
        "strokeWidth": 1.5
      }
    ],
    "slovenska-posta": [
      {
        "type": "polygon",
        "d": "M4 4L18 4L18 14.1L4 14.1Z",
        "fill": "accent"
      },
      {
        "type": "polygon",
        "d": "M5.4 5.4L16.6 5.4L16.6 12.7L5.4 12.7Z",
        "fill": "truck"
      },
      {
        "type": "line",
        "d": "M4.84 4.84L5.55 7.29L6.33 9.06L7.23 10.27L8.28 11.01L9.53 11.37L11 11.47L12.47 11.37L13.72 11.01L14.77 10.27L15.67 9.06L16.45 7.29L17.16 4.84",
        "stroke": "accent",
        "strokeWidth": 1.4
      },
      {
        "type": "line",
        "d": "M4.7 13.4L7.9 11.42M17.3 13.4L14.1 11.42",
        "stroke": "accent",
        "strokeWidth": 1.4
      },
      {
        "type": "circle",
        "cx": 11.3,
        "cy": 8.39,
        "r": 2.2,
        "fill": "accent"
      },
      {
        "type": "circle",
        "cx": 11.3,
        "cy": 8.39,
        "r": 0.85,
        "fill": "truck"
      }
    ],
    "stallion-express": [
      {
        "type": "polygon",
        "d": "M11.99 7L11.99 6.1L12.87 6.56L13.63 7.28L14.22 8.28L14.63 9.44L14.84 10.64L14.92 11.83L16.55 11.72L16.47 10.45L16.22 9.03L15.71 7.57L14.92 6.26L13.83 5.21L12.56 4.55L10.36 4.01L10.36 7Z",
        "fill": "accent"
      },
      {
        "type": "polygon",
        "d": "M10.36 6.38L10.36 7.44L11.22 8.37L11.7 9.24L12 10.3L12.06 11.24L10.49 11.48L8.62 12.14L8.16 11.7L10.04 9.81L8.88 8.66L5.83 11.73L8.22 14.02L10.89 13.07L13.79 12.62L13.62 10.02L13.22 8.61L12.55 7.4L11.99 6.8L11.99 6.38Z",
        "fill": "accent"
      }
    ],
    "venipak": [
      {
        "type": "polygon",
        "d": "M15.9 5.2L15.9 13.8L11 13.8L6.1 5.2L9.04 5.2L13.25 12.6L13.25 5.2Z",
        "fill": "accent"
      }
    ],
    "vinted-go": [
      {
        "type": "polygon",
        "d": "M7.1 5.75L7.27 5.12L7.72 4.67L8.35 4.5L8.97 4.67L9.43 5.12L9.6 5.75L10.85 11.6L11.35 11.75L14.95 4.65L15.9 4.2L15.75 5.3L13.25 13L12.68 13.45L12.24 14.16L11.56 14.63L10.75 14.8L9.94 14.63L9.26 14.16L8.82 13.45L7.1 6Z",
        "fill": "accent"
      }
    ],
    "5post": [
      {
        "type": "circle",
        "cx": 11,
        "cy": 9.5,
        "r": 5.6,
        "fill": "#575756"
      },
      {
        "type": "line",
        "d": "M12.8 5.3L9.6 5.3L9.4 7.6L10.56 7.14L11.23 7.12L11.86 7.31L12.35 7.68L12.64 8.18L12.69 8.74L12.47 9.27L12.04 9.69L11.44 9.94L10.77 9.99L10.13 9.83L9.61 9.48",
        "stroke": "accent",
        "strokeWidth": 1.35
      },
      {
        "type": "line",
        "d": "M13.97 11.85L13.41 12.54L12.7 13.06L11.88 13.39L11 13.5L10.12 13.39L9.3 13.06L8.59 12.54L8.03 11.85",
        "stroke": "truck",
        "strokeWidth": 1.4
      }
    ],
    "a-duie-pyle": [
      {
        "type": "line",
        "d": "M3.75 12.25L3.75 6.75L5.12 6.75L5.56 6.84L5.94 7.08L6.22 7.46L6.38 7.93L6.38 8.43L6.22 8.89L5.94 9.28L5.56 9.52L5.12 9.61L3.75 9.61M7.77 6.75L9.29 9.61L10.8 6.75M9.29 9.61L9.29 12.25M12.18 6.75L12.18 12.25L14.43 12.25M18.25 6.75L15.8 6.75L15.8 12.25L18.25 12.25M15.8 9.5L17.86 9.5",
        "stroke": "accent",
        "strokeWidth": 1.6
      }
    ],
    "aaa-cooper": [
      {
        "type": "line",
        "d": "M4.8 13.05L8.3 6.05L8.72 13.05M6.05 10.53L8.59 10.53M14.8 6.95L14.27 6.26L13.54 6.05L12.7 6.35L11.88 7.12L11.2 8.24L10.76 9.55L10.63 10.86L10.81 11.98L11.29 12.75L12 13.05L12.83 12.84L13.66 12.15M16.38 6.05L19.84 6.05M18.11 6.05L16.57 13.05",
        "stroke": "#d0102e",
        "strokeWidth": 1.7
      },
      {
        "type": "line",
        "d": "M4.25 12.6L7.75 5.6L8.17 12.6M5.5 10.08L8.04 10.08M14.25 6.5L13.72 5.81L12.99 5.6L12.15 5.9L11.33 6.67L10.65 7.79L10.21 9.1L10.08 10.41L10.26 11.53L10.74 12.3L11.45 12.6L12.28 12.39L13.11 11.7M15.83 5.6L19.29 5.6M17.56 5.6L16.02 12.6",
        "stroke": "accent",
        "strokeWidth": 1.7
      }
    ],
    "andreani": [
      {
        "type": "polygon",
        "d": "M18.23 7.15L18.37 7.95L18.28 8.79L17.97 9.65L17.45 10.51L16.74 11.34L15.85 12.11L14.81 12.81L13.66 13.4L12.42 13.87L11.14 14.22L9.86 14.41L8.62 14.46L7.44 14.36L6.38 14.11L5.45 13.72L4.69 13.2L4.13 12.57L3.77 11.85L3.63 11.05L3.72 10.21L4.03 9.35L4.55 8.49L5.26 7.66L6.15 6.89L7.19 6.19L8.34 5.6L9.58 5.13L10.86 4.78L12.14 4.59L13.38 4.54L14.56 4.64L15.62 4.89L16.55 5.28L17.31 5.8L17.87 6.43Z",
        "fill": "accent"
      },
      {
        "type": "polygon",
        "d": "M17.15 7.41L17.24 7.98L17.15 8.59L16.88 9.21L16.44 9.84L15.85 10.46L15.12 11.03L14.28 11.56L13.35 12.02L12.35 12.39L11.33 12.67L10.31 12.85L9.32 12.92L8.39 12.88L7.55 12.73L6.83 12.48L6.24 12.13L5.81 11.69L5.55 11.19L5.46 10.62L5.55 10.01L5.82 9.39L6.26 8.76L6.85 8.14L7.58 7.57L8.42 7.04L9.35 6.58L10.35 6.21L11.37 5.93L12.39 5.75L13.38 5.68L14.31 5.72L15.15 5.87L15.87 6.12L16.46 6.47L16.89 6.91Z",
        "fill": "truck"
      },
      {
        "type": "polygon",
        "d": "M11.9 5L13.5 5L14.1 13.4L12.1 13.4L12 11.3L10 11.3L8.9 13.4L7.3 13.4Z",
        "fill": "accent"
      },
      {
        "type": "polygon",
        "d": "M11.95 7.4L10.8 9.9L12 9.9Z",
        "fill": "truck"
      }
    ],
    "anjun": [
      {
        "type": "polygon",
        "d": "M3.6 15L8.6 4.2L13.4 4.2L18.4 15L13.9 15L13.1 13L8.9 13L8.1 15Z",
        "fill": "accent"
      },
      {
        "type": "polygon",
        "d": "M9.7 10.4L11 6.9L12.3 10.4Z",
        "fill": "truck"
      }
    ],
    "anteraja": [
      {
        "type": "line",
        "d": "M11.46 11.81L11.05 12.67L10.38 13.41L9.52 13.97L8.52 14.31L7.45 14.4L6.39 14.24L5.42 13.83L4.6 13.22L4.01 12.44L3.67 11.55L3.61 10.61L3.85 9.69L4.35 8.86L5.09 8.18L6.01 7.69L7.04 7.43L15.59 5.36",
        "stroke": "accent",
        "strokeWidth": 1.8
      },
      {
        "type": "polygon",
        "d": "M18.7 4.6L15.5 7.54L14.51 3.46Z",
        "fill": "accent"
      }
    ],
    "apc-postal-logistics": [
      {
        "type": "polygon",
        "d": "M15.85 4.08L8.37 4.08L3.63 9.41L5.93 14.92L13.07 14.92L10.88 9.64Z",
        "fill": "accent"
      },
      {
        "type": "polygon",
        "d": "M16.43 4.7L11.82 9.78L13.94 14.92L18.38 9.84Z",
        "fill": "#088cb9"
      }
    ],
    "arrow-xl": [
      {
        "type": "line",
        "d": "M7.04 8.1L6.09 8.38L5.32 9.17L4.89 10.31L4.89 11.58L5.32 12.73L6.09 13.52L7.04 13.8L8 13.52L8.77 12.73L9.2 11.58L9.2 10.31L8.77 9.17L8 8.38L7.04 8.1M9.25 8.1L9.25 13.8M11.09 8.1L15.32 13.8M15.32 8.1L11.09 13.8M17.16 4.6L17.16 13.8",
        "stroke": "accent",
        "strokeWidth": 1.6
      }
    ],
    "averitt": [
      {
        "type": "polygon",
        "d": "M4.2 15L11.7 4.2L16.3 4.2L17.4 15L13.4 15L13.28 13.1L9.58 13.1L8.2 15Z",
        "fill": "accent"
      },
      {
        "type": "polygon",
        "d": "M11.25 10.4L13.2 7L13.25 10.4Z",
        "fill": "truck"
      }
    ],
    "azul-cargo": [
      {
        "type": "polygon",
        "d": "M4 4.6L6.9 4.6L11.5 9.5L6.9 14.4L4 14.4L8.6 9.5Z",
        "fill": "#3bb5e6"
      },
      {
        "type": "polygon",
        "d": "M10 4.6L12.9 4.6L17.5 9.5L12.9 14.4L10 14.4L14.6 9.5Z",
        "fill": "#3bb5e6"
      }
    ],
    "barid-al-maghrib": [
      {
        "type": "polygon",
        "d": "M5.54 7.37L7.52 7.74L9.36 8.47L10.97 9.21L12.26 9.85L13.73 8.38L15.02 6.91L16.49 5.16L16.12 6.91L15.2 8.84L13.82 10.59L12.26 11.88L10.6 12.89L9.04 13.35L9.04 12.24L8.58 10.68L7.52 9.07Z",
        "fill": "accent"
      },
      {
        "type": "circle",
        "cx": 11.98,
        "cy": 5.25,
        "r": 1.5,
        "fill": "accent"
      }
    ],
    "belpost": [
      {
        "type": "polygon",
        "d": "M8 3.9L12.6 7L11.03 6.22L9.3 6.76L7.76 8.3L7.2 10.4L7.2 8Z",
        "fill": "accent"
      },
      {
        "type": "circle",
        "cx": 11.4,
        "cy": 10.4,
        "r": 4.2,
        "fill": "accent"
      },
      {
        "type": "polygon",
        "d": "M13.6 14.05L18.4 14.3L15.2 12.2Z",
        "fill": "accent"
      },
      {
        "type": "circle",
        "cx": 11.4,
        "cy": 10.4,
        "r": 2,
        "fill": "truck"
      }
    ],
    "best-transport": [
      {
        "type": "line",
        "d": "M3.5 11.4L4.01 5L5.89 5L6.35 5.09L6.74 5.36L7.02 5.77L7.14 6.27L7.1 6.8L6.89 7.3L6.55 7.71L6.12 7.98L5.64 8.07L3.77 8.07M3.77 8.07L5.77 8.07L6.27 8.17L6.7 8.46L7 8.9L7.13 9.45L7.09 10.02L6.87 10.57L6.5 11.01L6.02 11.3L5.5 11.4L3.5 11.4M8.41 9.42L11.53 9.42L11.48 8.69L11.22 8.07L10.79 7.63L10.25 7.44L9.66 7.52L9.12 7.86L8.7 8.42L8.45 9.12L8.41 9.86L8.59 10.53L8.96 11.06L9.47 11.35L10.05 11.38L10.62 11.13M15.35 7.91L15.05 7.64L14.62 7.47L14.13 7.44L13.64 7.54L13.24 7.76L12.96 8.08L12.86 8.44L12.95 8.79L13.22 9.09L13.62 9.28L14.1 9.35L14.58 9.43L14.98 9.63L15.25 9.95L15.33 10.33L15.23 10.71L14.96 11.05L14.55 11.29L14.06 11.4L13.57 11.36L13.14 11.18L12.84 10.89M17.6 5.51L17.2 10.5L17.23 10.81L17.38 11.08L17.63 11.28L17.95 11.39L18.3 11.39M16.82 7.43L18.82 7.43",
        "stroke": "accent",
        "strokeWidth": 1.6
      }
    ],
    "better-trucks": [
      {
        "type": "polygon",
        "d": "M9.4 4.2L13.4 4.2L8.6 10.6L10.6 15L6.8 15L4.6 10.6Z",
        "fill": "accent"
      },
      {
        "type": "polygon",
        "d": "M12.6 7.4L16.2 7.4L18.6 11.2L16.2 15L12.6 15L14.6 11.2Z",
        "fill": "#c9d0db"
      }
    ],
    "bex-express": [
      {
        "type": "polygon",
        "d": "M3.6 5.6L3.99 6.79L4.45 7.9L4.99 8.93L5.6 9.88L6.29 10.75L7.05 11.54L7.89 12.25L8.8 12.88L9.79 13.43L10.85 13.9L11.99 14.29L13.2 14.6L12.81 13.41L12.35 12.3L11.81 11.27L11.2 10.32L10.51 9.45L9.75 8.66L8.91 7.95L8 7.32L7.01 6.77L5.95 6.3L4.81 5.91Z",
        "fill": "accent"
      },
      {
        "type": "line",
        "d": "M5.4 7.6L8.6 10.2L11.8 13.4",
        "stroke": "truck",
        "strokeWidth": 1
      },
      {
        "type": "polygon",
        "d": "M15.6 13.4L16.04 12.5L16.39 11.59L16.65 10.68L16.82 9.77L16.9 8.85L16.9 7.93L16.81 7L16.63 6.07L16.36 5.14L16 4.2L15.56 5.1L15.21 6.01L14.95 6.92L14.78 7.83L14.7 8.75L14.7 9.67L14.79 10.6L14.97 11.53L15.24 12.46Z",
        "fill": "accent"
      },
      {
        "type": "polygon",
        "d": "M16.4 14.6L17.01 13.98L17.55 13.31L17.99 12.62L18.36 11.89L18.64 11.12L18.84 10.31L18.96 9.48L19 8.6L18.39 9.22L17.86 9.89L17.41 10.58L17.04 11.31L16.76 12.08L16.55 12.89L16.44 13.72Z",
        "fill": "accent"
      }
    ],
    "blue-express": [
      {
        "type": "line",
        "d": "M8.9 8L8.9 4.9L12.9 4.9L13.7 5.04L14.41 5.45L14.94 6.08L15.21 6.84L15.21 7.66L14.94 8.43L14.41 9.05L13.7 9.46L12.9 9.6L10.7 9.6M10.7 9.6L13.3 9.6L14.14 9.75L14.87 10.17L15.42 10.83L15.71 11.62L15.71 12.48L15.42 13.28L14.87 13.93L14.14 14.35L13.3 14.5L8.9 14.5L8.9 11.4",
        "stroke": "accent",
        "strokeWidth": 2
      },
      {
        "type": "circle",
        "cx": 8.4,
        "cy": 9.65,
        "r": 1.55,
        "fill": "#41b6e6"
      }
    ],
    "bulgarian-posts": [
      {
        "type": "circle",
        "cx": 9,
        "cy": 10.6,
        "r": 4.3,
        "fill": "accent"
      },
      {
        "type": "circle",
        "cx": 9,
        "cy": 10.6,
        "r": 2.75,
        "fill": "truck"
      },
      {
        "type": "polygon",
        "d": "M4.6 8.2L6.6 6.2L10 5.3L13.5 5L16.4 4.2L18.4 4L18.4 11.2L16.6 10.6L14.6 9L13.2 8.2L11.5 7Z",
        "fill": "accent"
      }
    ],
    "burd-delivery": [
      {
        "type": "line",
        "d": "M12.05 7.12L14.65 6.8L15.27 7.35L15.78 12.46L15.27 13.19L10.2 14.01L9.56 13.56L9.06 10.61",
        "stroke": "accent",
        "strokeWidth": 1.45
      },
      {
        "type": "polygon",
        "d": "M5.54 3.97L6.43 4.65L7.94 5.24L9.72 5.82L11.09 6.5L12.05 7.12L9.06 10.61L7.94 10.34L7.12 9.79L6.57 9.24L8.08 8.9L6.98 8.56L6.02 7.87L5.54 6.85L6.78 7.05L5.75 6.09L5.34 5Z",
        "fill": "accent"
      }
    ],
    "castores": [
      {
        "type": "line",
        "d": "M14.84 6.36L13.52 5.36L11.93 4.85L10.25 4.89L8.69 5.47L7.42 6.51L6.59 7.91L6.3 9.5L6.59 11.09L7.42 12.49L8.69 13.53L10.25 14.11L11.93 14.15L13.52 13.64L14.84 12.64",
        "stroke": "accent",
        "strokeWidth": 2.2
      }
    ],
    "central-transport": [
      {
        "type": "polygon",
        "d": "M10.73 5L7.53 5L6.68 5.15L5.85 5.6L5.08 6.32L4.44 7.25L3.97 8.34L3.7 9.5L3.65 10.66L3.81 11.75L4.19 12.68L4.75 13.4L5.46 13.85L6.27 14L9.47 14L9.75 12L6.55 12L6.12 11.81L5.8 11.27L5.66 10.46L5.7 9.5L5.93 8.54L6.3 7.73L6.76 7.19L7.25 7L10.45 7Z",
        "fill": "#1d1d1b"
      },
      {
        "type": "polygon",
        "d": "M11.73 5L18.73 5L18.45 7L15.95 7L14.97 14L12.97 14L13.95 7L11.45 7Z",
        "fill": "#1d1d1b"
      }
    ],
    "ceva-logistics": [
      {
        "type": "polygon",
        "d": "M3.8 15L9.9 4.6L10.6 4.1L11.4 4.1L12.1 4.6L18.2 15Z",
        "fill": "#ff0000"
      },
      {
        "type": "polygon",
        "d": "M10.9 5.2L11.5 5.2L13.5 15.2L11.7 15.2Z",
        "fill": "truck"
      }
    ],
    "chilexpress": [
      {
        "type": "polygon",
        "d": "M5.19 11.83L5.15 12.33L5.3 12.82L5.62 13.21L6.07 13.45L6.57 13.49L7.06 13.34L7.45 13.02L7.69 12.57L9.85 5.37L9.89 4.87L9.74 4.38L9.42 3.99L8.97 3.75L8.47 3.71L7.98 3.86L7.59 4.18L7.35 4.63Z",
        "fill": "#1d1816"
      },
      {
        "type": "polygon",
        "d": "M8.47 14.23L8.43 14.73L8.58 15.22L8.9 15.61L9.35 15.85L9.85 15.89L10.34 15.74L10.73 15.42L10.97 14.97L13.85 5.37L13.89 4.87L13.74 4.38L13.42 3.99L12.97 3.75L12.47 3.71L11.98 3.86L11.59 4.18L11.35 4.63Z",
        "fill": "#1d1816"
      },
      {
        "type": "polygon",
        "d": "M13.19 11.83L13.15 12.33L13.3 12.82L13.62 13.21L14.07 13.45L14.57 13.49L15.06 13.34L15.45 13.02L15.69 12.57L17.85 5.37L17.89 4.87L17.74 4.38L17.42 3.99L16.97 3.75L16.47 3.71L15.98 3.86L15.59 4.18L15.35 4.63Z",
        "fill": "#1d1816"
      }
    ],
    "chunghwa-post": [
      {
        "type": "line",
        "d": "M8.35 3.99L8.35 14.38M8.35 4.62L10.84 4.62M5.57 7.87L6.76 6.64L7.78 7.4M8.92 7.4L10.02 6.64L11.2 7.87M5.57 10.42L6.76 9.19L7.78 9.95M8.92 9.95L10.02 9.19L11.2 10.42M5.84 11.83L11 11.83M5.84 14.38L11 14.38M12.41 4.62L15.94 4.62L15.94 7.11L12.41 7.11L12.41 4.62M11.86 9.23L16.02 9.23L16.02 11.83L12.47 11.83M12.47 9.23L12.47 14.38L16.61 14.38",
        "stroke": "accent",
        "strokeWidth": 1.3
      }
    ],
    "citylink-express": [
      {
        "type": "polygon",
        "d": "M7.4 13.8L8.74 13.67L10.05 13.46L11.3 13.15L12.52 12.74L13.69 12.25L14.82 11.66L15.9 10.99L16.95 10.22L17.94 9.35L18.9 8.4L17.56 8.53L16.25 8.74L15 9.05L13.78 9.46L12.61 9.95L11.48 10.54L10.4 11.21L9.35 11.98L8.36 12.85Z",
        "fill": "#ff6d00"
      },
      {
        "type": "circle",
        "cx": 8.4,
        "cy": 9.2,
        "r": 4.9,
        "fill": "#ab5e41"
      },
      {
        "type": "polygon",
        "d": "M10.3 11L10.17 11.9L9.78 12.7L9.19 13.35L8.43 13.76L7.6 13.9L6.77 13.76L6.01 13.35L5.42 12.7L5.03 11.9L4.9 11L5.03 10.1L5.42 9.3L6.01 8.65L6.77 8.24L7.6 8.1L8.43 8.24L9.19 8.65L9.78 9.3L10.17 10.1Z",
        "fill": "#ffb062"
      },
      {
        "type": "polygon",
        "d": "M4 5.6L7.9 5.4L8.1 8.9L4.2 9.1Z",
        "fill": "accent"
      },
      {
        "type": "polygon",
        "d": "M8.9 5.4L12.8 5.6L12.6 9.1L8.7 8.9Z",
        "fill": "accent"
      },
      {
        "type": "polygon",
        "d": "M5 6.5L7 6.4L7.1 8L5.1 8.1Z",
        "fill": "#1a1a1a"
      },
      {
        "type": "polygon",
        "d": "M9.8 6.4L11.8 6.5L11.7 8.1L9.7 8Z",
        "fill": "#1a1a1a"
      }
    ],
    "citysprint": [
      {
        "type": "line",
        "d": "M10.17 8.92L9.42 8.29L8.55 8.1L7.69 8.38L6.97 9.08L6.5 10.1L6.33 11.3L6.5 12.5L6.97 13.52L7.69 14.22L8.55 14.5L9.42 14.31L10.17 13.68M15.51 9.02L15.12 8.52L14.55 8.2L13.89 8.1L13.24 8.24L12.69 8.6L12.33 9.12L12.22 9.73L12.36 10.33L12.73 10.84L13.29 11.18L13.94 11.3L14.6 11.42L15.16 11.76L15.53 12.27L15.67 12.87L15.55 13.48L15.19 14L14.65 14.36L14 14.5L13.34 14.4L12.77 14.08L12.38 13.58",
        "stroke": "accent",
        "strokeWidth": 1.6
      },
      {
        "type": "line",
        "d": "M4.11 8.24L4.84 7.1L5.78 6.11L6.92 5.3L8.19 4.69L9.57 4.32L11 4.2L12.43 4.32L13.81 4.69L15.08 5.3L16.22 6.11L17.16 7.1L17.89 8.24",
        "stroke": "accent",
        "strokeWidth": 1.4
      }
    ],
    "cj-logistics": [
      {
        "type": "polygon",
        "d": "M10.41 6.45L10.68 7.14L10.84 7.84L10.89 8.5L10.82 9.11L10.64 9.63L10.36 10.03L9.99 10.29L9.56 10.4L9.07 10.36L8.56 10.17L8.05 9.83L7.57 9.36L7.14 8.79L6.79 8.15L6.52 7.46L6.36 6.76L6.31 6.1L6.38 5.49L6.56 4.97L6.84 4.57L7.21 4.31L7.64 4.2L8.13 4.24L8.64 4.43L9.15 4.77L9.63 5.24L10.06 5.81Z",
        "fill": "#006ecd"
      },
      {
        "type": "polygon",
        "d": "M17.58 8.02L17.63 8.54L17.52 9.07L17.24 9.6L16.81 10.09L16.26 10.52L15.61 10.87L14.9 11.12L14.15 11.26L13.41 11.28L12.72 11.19L12.1 10.97L11.6 10.66L11.23 10.25L11.02 9.78L10.97 9.26L11.08 8.73L11.36 8.2L11.79 7.71L12.34 7.28L12.99 6.93L13.7 6.68L14.45 6.54L15.19 6.52L15.88 6.61L16.5 6.83L17 7.14L17.37 7.55Z",
        "fill": "#ff9700"
      },
      {
        "type": "polygon",
        "d": "M12.2 12.6L12.13 13.13L11.94 13.64L11.63 14.1L11.22 14.48L10.73 14.76L10.18 14.94L9.6 15L9.02 14.94L8.47 14.76L7.98 14.48L7.57 14.1L7.26 13.64L7.07 13.13L7 12.6L7.07 12.07L7.26 11.56L7.57 11.1L7.98 10.72L8.47 10.44L9.02 10.26L9.6 10.2L10.18 10.26L10.73 10.44L11.22 10.72L11.63 11.1L11.94 11.56L12.13 12.07Z",
        "fill": "#ef151e"
      }
    ],
    "cj-packet": [
      {
        "type": "line",
        "d": "M12.41 5.81L11.51 4.88L10.29 4.6L8.95 5.01L7.66 6.04L6.63 7.54L5.99 9.3L5.85 11.06L6.23 12.56L7.06 13.59L8.23 14L9.56 13.72L10.87 12.79M18.31 4.6L16.82 11.37L16.49 12.27L15.94 13.06L15.24 13.65L14.46 13.96L13.71 13.96L13.07 13.65L12.63 13.06L12.43 12.27L12.5 11.37",
        "stroke": "accent",
        "strokeWidth": 1.7
      }
    ],
    "coordinadora": [
      {
        "type": "polygon",
        "d": "M11.21 8.39L11.32 9.04L11.23 9.71L10.96 10.38L10.51 11L9.92 11.56L9.2 12.02L8.4 12.36L7.55 12.56L6.7 12.61L5.89 12.51L5.16 12.26L4.55 11.88L4.08 11.39L3.79 10.81L3.68 10.16L3.77 9.49L4.04 8.82L4.49 8.2L5.08 7.64L5.8 7.18L6.6 6.84L7.45 6.64L8.3 6.59L9.11 6.69L9.84 6.94L10.45 7.32L10.92 7.81Z",
        "fill": "accent"
      },
      {
        "type": "polygon",
        "d": "M7.99 9.01L8.02 9.22L8 9.44L7.91 9.66L7.77 9.87L7.58 10.05L7.35 10.19L7.09 10.3L6.82 10.37L6.55 10.38L6.29 10.35L6.05 10.27L5.86 10.14L5.71 9.98L5.61 9.79L5.58 9.58L5.6 9.36L5.69 9.14L5.83 8.93L6.02 8.75L6.25 8.61L6.51 8.5L6.78 8.43L7.05 8.42L7.31 8.45L7.55 8.53L7.74 8.66L7.89 8.82Z",
        "fill": "truck"
      },
      {
        "type": "polygon",
        "d": "M18.21 8.39L18.32 9.04L18.23 9.71L17.96 10.38L17.51 11L16.92 11.56L16.2 12.02L15.4 12.36L14.55 12.56L13.7 12.61L12.89 12.51L12.16 12.26L11.55 11.88L11.08 11.39L10.79 10.81L10.68 10.16L10.77 9.49L11.04 8.82L11.49 8.2L12.08 7.64L12.8 7.18L13.6 6.84L14.45 6.64L15.3 6.59L16.11 6.69L16.84 6.94L17.45 7.32L17.92 7.81Z",
        "fill": "accent"
      },
      {
        "type": "polygon",
        "d": "M14.99 9.01L15.02 9.22L15 9.44L14.91 9.66L14.77 9.87L14.58 10.05L14.35 10.19L14.09 10.3L13.82 10.37L13.55 10.38L13.29 10.35L13.05 10.27L12.86 10.14L12.71 9.98L12.61 9.79L12.58 9.58L12.6 9.36L12.69 9.14L12.83 8.93L13.02 8.75L13.25 8.61L13.51 8.5L13.78 8.43L14.05 8.42L14.31 8.45L14.55 8.53L14.74 8.66L14.89 8.82Z",
        "fill": "truck"
      }
    ],
    "correo-argentino": [
      {
        "type": "polygon",
        "d": "M5.2 7.2L5.28 8.23L5.52 9.24L5.92 10.2L6.46 11.08L7.13 11.87L7.92 12.54L8.8 13.08L9.76 13.48L10.77 13.72L11.8 13.8L12.83 13.72L13.84 13.48L14.8 13.08L15.68 12.54L16.47 11.87L17.14 11.08L17.68 10.2L18.08 9.24L18.32 8.23L18.4 7.2L16.2 7.2L16.15 7.89L15.98 8.56L15.72 9.2L15.36 9.79L14.91 10.31L14.39 10.76L13.8 11.12L13.16 11.38L12.49 11.55L11.8 11.6L11.11 11.55L10.44 11.38L9.8 11.12L9.21 10.76L8.69 10.31L8.24 9.79L7.88 9.2L7.62 8.56L7.45 7.89L7.4 7.2Z",
        "fill": "#152663"
      },
      {
        "type": "polygon",
        "d": "M3.4 5L8.4 5L8.4 6.5L3.4 6.5Z",
        "fill": "#152663"
      },
      {
        "type": "circle",
        "cx": 11.8,
        "cy": 7,
        "r": 2.6,
        "fill": "#152663"
      },
      {
        "type": "circle",
        "cx": 11.8,
        "cy": 7,
        "r": 1.15,
        "fill": "truck"
      }
    ],
    "courier-center": [
      {
        "type": "polygon",
        "d": "M3.4 7.2L8.2 4.4L12.6 6.4L7.8 9.2Z",
        "fill": "accent"
      },
      {
        "type": "polygon",
        "d": "M3.4 8.4L7.2 10.6L7.2 15L3.4 12.6Z",
        "fill": "accent"
      },
      {
        "type": "line",
        "d": "M10 9.2L18.4 5.6M9.6 11.9L16.6 8.9M8.8 14.4L14.6 11.9",
        "stroke": "accent",
        "strokeWidth": 1.4
      }
    ],
    "couriersplease": [
      {
        "type": "circle",
        "cx": 11,
        "cy": 7.6,
        "r": 3.7,
        "fill": "accent"
      },
      {
        "type": "circle",
        "cx": 11,
        "cy": 7.6,
        "r": 1.55,
        "fill": "truck"
      },
      {
        "type": "polygon",
        "d": "M8.5 13.5L8.69 13.12L9.23 12.79L10.04 12.58L11 12.5L11.96 12.58L12.77 12.79L13.31 13.12L13.5 13.5L11.5 15.4L10.5 15.4Z",
        "fill": "accent"
      }
    ],
    "cycloon": [
      {
        "type": "line",
        "d": "M18 9.6L17.82 10.59L17.34 11.43L16.64 12.01L15.85 12.3L15.05 12.35L14.3 12.2L13.62 11.91L13 11.53L12.45 11.09L11.94 10.61L11.46 10.11L11 9.6L10.54 9.09L10.06 8.59L9.55 8.11L9 7.67L8.38 7.29L7.7 7L6.95 6.85L6.15 6.9L5.36 7.19L4.66 7.77L4.18 8.61L4 9.6L4.18 10.59L4.66 11.43L5.36 12.01L6.15 12.3L6.95 12.35L7.7 12.2L8.38 11.91L9 11.53L9.55 11.09L10.06 10.61L10.54 10.11L11 9.6L11.46 9.09L11.94 8.59L12.45 8.11L13 7.67L13.62 7.29L14.3 7L15.05 6.85L15.85 6.9L16.64 7.19L17.34 7.77L17.82 8.61L18 9.6",
        "stroke": "accent",
        "strokeWidth": 2
      }
    ],
    "d-express": [
      {
        "type": "polygon",
        "d": "M5 4L10.6 4L12.33 4.27L13.89 5.05L15.13 6.27L15.93 7.8L16.2 9.5L15.93 11.2L15.13 12.73L13.89 13.95L12.33 14.73L10.6 15L5 15Z",
        "fill": "accent"
      },
      {
        "type": "polygon",
        "d": "M4.9 8.6L11.2 8.6L11.2 10.4L4.9 10.4Z",
        "fill": "truck"
      },
      {
        "type": "polygon",
        "d": "M8.1 5.9L10.5 5.9L14.1 9.5L10.5 13.1L8.1 13.1L11.7 9.5Z",
        "fill": "truck"
      }
    ],
    "danske-fragtmaend": [
      {
        "type": "polygon",
        "d": "M5.32 6.91L19.56 6.91L18.18 8.83L5.32 8.83Z",
        "fill": "accent"
      },
      {
        "type": "circle",
        "cx": 5.32,
        "cy": 9.6,
        "r": 2.69,
        "fill": "accent"
      },
      {
        "type": "circle",
        "cx": 10.16,
        "cy": 9.6,
        "r": 2.69,
        "fill": "accent"
      },
      {
        "type": "circle",
        "cx": 14.99,
        "cy": 9.6,
        "r": 2.69,
        "fill": "accent"
      },
      {
        "type": "polygon",
        "d": "M5.32 7.36L18.93 7.36L17.73 8.38L5.32 8.38Z",
        "fill": "#e71f01"
      },
      {
        "type": "circle",
        "cx": 5.32,
        "cy": 9.6,
        "r": 2.24,
        "fill": "#e71f01"
      },
      {
        "type": "circle",
        "cx": 10.16,
        "cy": 9.6,
        "r": 2.24,
        "fill": "#e71f01"
      },
      {
        "type": "circle",
        "cx": 14.99,
        "cy": 9.6,
        "r": 2.24,
        "fill": "#e71f01"
      },
      {
        "type": "circle",
        "cx": 5.32,
        "cy": 9.6,
        "r": 0.8,
        "fill": "accent"
      },
      {
        "type": "circle",
        "cx": 10.16,
        "cy": 9.6,
        "r": 0.8,
        "fill": "accent"
      },
      {
        "type": "circle",
        "cx": 14.99,
        "cy": 9.6,
        "r": 0.8,
        "fill": "accent"
      }
    ],
    "dayton-freight": [
      {
        "type": "line",
        "d": "M6.32 4.4L4.72 12.4L6.48 12.4L7.62 12.16L8.72 11.46L9.65 10.4L10.29 9.09L10.57 7.71L10.45 6.4L9.95 5.34L9.13 4.64L8.08 4.4L6.32 4.4",
        "stroke": "accent",
        "strokeWidth": 1.8
      },
      {
        "type": "line",
        "d": "M17.72 4.4L13.88 4.4L12.28 12.4M13.08 8.4L16.28 8.4",
        "stroke": "#f78f1e",
        "strokeWidth": 1.8
      }
    ],
    "dellin": [
      {
        "type": "polygon",
        "d": "M4.65 15L10.24 15L11.1 13.48L6.3 12.14Z",
        "fill": "accent"
      },
      {
        "type": "polygon",
        "d": "M7 10.93L11.46 12.84L12.32 11.33L8.65 8.07Z",
        "fill": "accent"
      },
      {
        "type": "polygon",
        "d": "M9.35 6.86L12.68 10.69L13.54 9.17L11 4Z",
        "fill": "accent"
      },
      {
        "type": "polygon",
        "d": "M14.31 9.72L17.35 15L15.72 15L14.31 12.54L12.9 15L11.28 15Z",
        "fill": "accent"
      }
    ],
    "deppon": [
      {
        "type": "polygon",
        "d": "M11.15 3.85L16.65 3.85L16.65 11.85L11.15 11.85L11.15 9.35L14.15 9.35L14.15 6.35L11.15 6.35Z",
        "fill": "accent"
      },
      {
        "type": "polygon",
        "d": "M5.35 7.15L10.85 7.15L10.85 9.65L7.85 9.65L7.85 12.15L10.85 12.15L10.85 15.15L5.35 15.15Z",
        "fill": "accent"
      }
    ],
    "direct-freight-express": [
      {
        "type": "line",
        "d": "M7.34 4.3L6.74 10.3L8.06 10.3L8.9 10.12L9.67 9.6L10.29 8.8L10.67 7.82L10.78 6.78L10.59 5.8L10.13 5L9.46 4.48L8.66 4.3L7.34 4.3M15.86 4.3L12.98 4.3L12.38 10.3M12.68 7.3L15.08 7.3",
        "stroke": "accent",
        "strokeWidth": 1.7
      },
      {
        "type": "polygon",
        "d": "M4.2 11.7L17.8 11.7L17.8 13.5L4.2 13.5Z",
        "fill": "#f16924"
      }
    ],
    "egypt-post": [
      {
        "type": "polygon",
        "d": "M11.53 4L9.29 4.97L7.14 6.63L5.58 8.78L4.96 10.72L5.29 12.48L6.56 13.65L8.31 13.94L10.65 13.55L12.8 12.48L14.75 10.72L16.31 8.58L17.09 6.44L17.09 5.26L16.8 4.78L17.19 3.94L16.41 3.9L15.62 4.29L14.16 4.19L12.02 4.78L9.87 5.75L8.12 7.02L6.56 9.16L8.31 7.8L10.26 7.02L12.31 6.79L11.04 7.31L12.02 8.29L13.09 8.48L13.77 7.37L14.46 8.09L14.36 9.36L13.38 10.92L11.63 12.09L9.29 12.58L7.53 12.09L6.91 11.31L6.79 10.14L7.24 8.78L8.12 7.31L9.48 5.75Z",
        "fill": "accent"
      }
    ],
    "emirates-post": [
      {
        "type": "polygon",
        "d": "M3.3 5.2L4 4.3L4.8 4.06L5.8 4.14L6.6 4.2L6.4 3.86L10.2 3.54L14.2 3.7L18.6 4.5L14.8 4.46L12.6 5L11.2 5.8L10.5 6.6L10.4 7.3L10.8 8.1L12 9.2L14.6 10.5L13 10.8L18.4 12.9L13.2 11.4L9.2 9.7L7.2 8.7L6 7.5L5.5 5.9L4.4 5.4L3.6 5.3Z",
        "fill": "accent"
      }
    ],
    "flash-express": [
      {
        "type": "circle",
        "cx": 11,
        "cy": 9.6,
        "r": 5.5,
        "fill": "#1d1d1b"
      },
      {
        "type": "polygon",
        "d": "M12.9 4.9L8.3 10.5L11 10.5L9.3 14.3L14 8.6L11.3 8.6Z",
        "fill": "truck"
      }
    ],
    "forward-air": [
      {
        "type": "line",
        "d": "M4.8 9.4L4.9 8.39L5.2 7.41L5.68 6.51L6.32 5.72L7.11 5.08L8.01 4.6L8.99 4.3L10 4.2L11.01 4.3L11.99 4.6L12.89 5.08L13.68 5.72L14.32 6.51L14.8 7.41L15.1 8.39L15.2 9.4",
        "stroke": "accent",
        "strokeWidth": 1.5
      },
      {
        "type": "polygon",
        "d": "M4.05 8.7L19 8.7L19 10L4.05 10Z",
        "fill": "accent"
      },
      {
        "type": "polygon",
        "d": "M4.29 10.9L15.71 10.9L15.3 12L4.7 12Z",
        "fill": "accent"
      },
      {
        "type": "polygon",
        "d": "M5.18 12.8L14.82 12.8L13.93 13.8L6.07 13.8Z",
        "fill": "accent"
      }
    ],
    "fukuyama": [
      {
        "type": "circle",
        "cx": 11,
        "cy": 7.3,
        "r": 3.3,
        "fill": "accent"
      },
      {
        "type": "circle",
        "cx": 11,
        "cy": 7.3,
        "r": 1.45,
        "fill": "truck"
      },
      {
        "type": "polygon",
        "d": "M3.6 14.6L8.8 11.6L8.8 12.8L18.4 12.8L17.6 14.6Z",
        "fill": "accent"
      }
    ],
    "gati": [
      {
        "type": "line",
        "d": "M7.67 7.34L7.31 6.79L6.79 6.6L6.2 6.8L5.6 7.37L5.07 8.23L4.7 9.26L4.52 10.32L4.57 11.27L4.83 11.98L5.28 12.36L5.84 12.34L6.45 11.94L7.03 11.21L7.48 10.25L7.55 9.79M7.55 9.79L6.36 9.79M8.59 12.4L11.31 6.6M11.31 6.6L11.48 12.4M9.56 10.31L11.43 10.31M14.54 6.6L17.09 6.6M15.82 6.6L14.54 12.4M18.88 6.6L17.6 12.4",
        "stroke": "accent",
        "strokeWidth": 1.6
      },
      {
        "type": "circle",
        "cx": 7.55,
        "cy": 9.79,
        "r": 0.8,
        "fill": "accent"
      },
      {
        "type": "circle",
        "cx": 11.31,
        "cy": 6.6,
        "r": 0.8,
        "fill": "accent"
      }
    ],
    "gdex": [
      {
        "type": "line",
        "d": "M6.52 7.02L5.96 6.41L5.3 6.2L4.64 6.43L4.08 7.05L3.68 8L3.51 9.14L3.57 10.31L3.88 11.36L4.38 12.14L5 12.55L5.67 12.54L6.29 12.1L6.77 11.29L7.06 10.23L7.02 9.72L5.61 9.72M7.83 6.2L7.83 12.6L8.94 12.6L9.62 12.41L10.23 11.85L10.68 11L10.92 9.96L10.92 8.84L10.68 7.8L10.23 6.95L9.62 6.39L8.94 6.2L7.83 6.2M14.47 6.2L11.96 6.2L11.96 12.6L14.47 12.6M11.96 9.4L14.07 9.4M15.48 6.2L18.5 12.6M18.5 6.2L15.48 12.6",
        "stroke": "accent",
        "strokeWidth": 1.6
      }
    ],
    "ghn": [
      {
        "type": "polygon",
        "d": "M11 4L10.5 5.21L9.19 5.31L10.19 6.16L9.88 7.44L11 6.75L12.12 7.44L11.81 6.16L12.81 5.31L11.5 5.21Z",
        "fill": "accent"
      },
      {
        "type": "line",
        "d": "M7.34 9.32L6.71 8.78L5.99 8.6L5.26 8.8L4.64 9.35L4.2 10.18L4.01 11.17L4.08 12.2L4.42 13.11L4.97 13.8L5.66 14.16L6.39 14.15L7.08 13.76L7.61 13.05L7.93 12.12L7.89 11.68M7.89 11.68L6.33 11.68M9.44 8.6L9.44 14.2M12.78 8.6L12.78 14.2M9.44 11.4L12.78 11.4M14.56 14.2L14.56 8.6M14.56 8.6L18 14.2M18 14.2L18 8.6",
        "stroke": "accent",
        "strokeWidth": 1.6
      },
      {
        "type": "circle",
        "cx": 7.89,
        "cy": 11.68,
        "r": 0.8,
        "fill": "accent"
      },
      {
        "type": "circle",
        "cx": 14.56,
        "cy": 8.6,
        "r": 0.8,
        "fill": "accent"
      },
      {
        "type": "circle",
        "cx": 18,
        "cy": 14.2,
        "r": 0.8,
        "fill": "accent"
      }
    ],
    "ghtk": [
      {
        "type": "circle",
        "cx": 11,
        "cy": 10.2,
        "r": 5,
        "fill": "accent"
      },
      {
        "type": "polygon",
        "d": "M5.9 8.6L6.24 7.98L6.86 6.97L7.7 6.12L8.7 5.48L9.82 5.08L11 4.95L12.18 5.08L13.3 5.48L14.3 6.12L15.14 6.97L15.76 7.98L17.4 8.6L16.2 9.4L6.1 9.4Z",
        "fill": "#fa4215"
      },
      {
        "type": "circle",
        "cx": 9.2,
        "cy": 11,
        "r": 0.75,
        "fill": "#0b100c"
      },
      {
        "type": "circle",
        "cx": 12.8,
        "cy": 11,
        "r": 0.75,
        "fill": "#0b100c"
      },
      {
        "type": "line",
        "d": "M8.74 12.22L9.25 12.84L10.05 13.25L11 13.4L11.95 13.25L12.75 12.84L13.26 12.22",
        "stroke": "#0b100c",
        "strokeWidth": 1.2
      }
    ],
    "hanjin": [
      {
        "type": "line",
        "d": "M13.65 4.91L12.81 4.52L11.92 4.28L11 4.2L10.08 4.28L9.19 4.52L8.35 4.91L7.59 5.44L6.94 6.09L6.41 6.85L6.02 7.69L5.78 8.58L5.7 9.5L5.78 10.42L6.02 11.31M8.35 14.09L9.19 14.48L10.08 14.72L11 14.8L11.92 14.72L12.81 14.48L13.65 14.09L14.41 13.56L15.06 12.91L15.59 12.15L15.98 11.31L16.22 10.42L16.3 9.5L16.22 8.58L15.98 7.69",
        "stroke": "accent",
        "strokeWidth": 1.5
      },
      {
        "type": "line",
        "d": "M8.6 6.4L8.6 12.6M13.4 6.4L13.4 12.6M8.6 9.5L13.4 9.5",
        "stroke": "accent",
        "strokeWidth": 1.6
      }
    ],
    "hepsijet": [
      {
        "type": "line",
        "d": "M6.85 6.4L6.85 10.86L6.77 11.46L6.54 11.98L6.19 12.37L5.76 12.57L5.3 12.57L4.86 12.37L4.51 11.98L4.28 11.46L4.2 10.86M11.24 6.4L8.35 6.4M8.35 6.4L8.35 12.6M8.35 12.6L11.24 12.6M8.35 9.5L10.78 9.5M12.74 6.4L16.2 6.4M14.47 6.4L14.47 12.6",
        "stroke": "accent",
        "strokeWidth": 1.9
      },
      {
        "type": "circle",
        "cx": 8.35,
        "cy": 6.4,
        "r": 0.95,
        "fill": "accent"
      },
      {
        "type": "circle",
        "cx": 8.35,
        "cy": 12.6,
        "r": 0.95,
        "fill": "accent"
      },
      {
        "type": "polygon",
        "d": "M16.6 4.4L18.8 4.4L17.2 6.5L15.4 6.5Z",
        "fill": "#ff6000"
      }
    ],
    "hunter-express": [
      {
        "type": "polygon",
        "d": "M18.53 8.44L18.29 7.56L17.82 6.74L17.16 6.01L16.3 5.38L15.28 4.88L14.14 4.51L12.89 4.3L11.59 4.25L10.28 4.35L8.98 4.61L7.75 5.02L6.61 5.57L5.61 6.24L4.77 7L4.12 7.84L3.68 8.73L3.46 9.65L3.47 10.56L3.71 11.44L4.18 12.26L4.84 12.99L5.7 13.62L6.72 14.12L7.86 14.49L9.11 14.7L10.41 14.75L11.72 14.65L13.02 14.39L14.25 13.98L15.39 13.43L16.39 12.76L17.23 12L17.88 11.16L18.32 10.27L18.54 9.35L18.53 8.44Z",
        "fill": "#0053a1"
      },
      {
        "type": "line",
        "d": "M8.4 6.5L7.53 12.7M7.53 12.7L7.86 10.34L8.02 9.84L8.34 9.39L8.78 9.06L9.29 8.88L9.81 8.88L10.27 9.06L10.62 9.39L10.82 9.84L10.83 10.34L10.5 12.7M12.16 8.86L14.47 12.7M15.01 8.86L11.62 12.7",
        "stroke": "accent",
        "strokeWidth": 1.5
      }
    ],
    "ics-courier": [
      {
        "type": "line",
        "d": "M6.11 8.4L4.95 14.2M11.53 9.14L10.96 8.57L10.21 8.4L9.38 8.65L8.6 9.29L7.99 10.21L7.62 11.3L7.55 12.39L7.8 13.31L8.32 13.95L9.05 14.2L9.87 14.03L10.67 13.46M16.7 9.24L16.43 8.78L15.97 8.49L15.4 8.4L14.78 8.53L14.22 8.85L13.8 9.32L13.59 9.87L13.6 10.42L13.85 10.88L14.29 11.19L14.87 11.3L15.44 11.41L15.88 11.72L16.13 12.18L16.15 12.73L15.93 13.28L15.51 13.75L14.95 14.07L14.34 14.2L13.76 14.11L13.3 13.82L13.03 13.36",
        "stroke": "accent",
        "strokeWidth": 1.8
      },
      {
        "type": "polygon",
        "d": "M7.6 7.4L8.5 6.76L9.44 6.19L10.42 5.69L11.44 5.27L12.5 4.92L13.6 4.65L14.74 4.45L15.92 4.33L17.14 4.28L18.4 4.3L18.4 6L17.14 5.83L15.92 5.73L14.74 5.7L13.6 5.75L12.5 5.88L11.44 6.07L10.42 6.34L9.44 6.69L8.5 7.11L7.6 7.6Z",
        "fill": "#ff4a42"
      }
    ],
    "ids-logistik": [
      {
        "type": "line",
        "d": "M5.71 7.2L4.66 13M7.68 7.2L6.64 13M6.64 13L7.91 13L8.74 12.83L9.53 12.32L10.18 11.55L10.63 10.6L10.81 9.6L10.7 8.65L10.33 7.88L9.72 7.37L8.96 7.2L7.68 7.2M16.08 8.04L15.81 7.58L15.34 7.29L14.76 7.2L14.15 7.33L13.6 7.65L13.19 8.12L12.98 8.67L13.01 9.22L13.27 9.68L13.72 9.99L14.29 10.1L14.87 10.21L15.32 10.52L15.57 10.98L15.6 11.53L15.39 12.08L14.98 12.55L14.43 12.87L13.82 13L13.24 12.91L12.78 12.62L12.5 12.16",
        "stroke": "accent",
        "strokeWidth": 1.8
      },
      {
        "type": "circle",
        "cx": 6.64,
        "cy": 13,
        "r": 0.9,
        "fill": "accent"
      },
      {
        "type": "line",
        "d": "M6 5L18.2 5L18.2 14.2L12.2 14.2",
        "stroke": "accent",
        "strokeWidth": 1.4
      }
    ],
    "imile": [
      {
        "type": "polygon",
        "d": "M5 14.6L5 4.4L8 4.4L11 9.4L14 4.4L17 4.4L17 14.6L14.5 14.6L14.5 8.8L12 12.8L10 12.8L7.5 8.8L7.5 14.6Z",
        "fill": "accent"
      }
    ],
    "interrapidisimo": [
      {
        "type": "circle",
        "cx": 12.86,
        "cy": 5.58,
        "r": 1.25,
        "fill": "accent"
      },
      {
        "type": "line",
        "d": "M7.9 7.83L8.12 7.77L8.41 7.67L8.76 7.56L9.15 7.45L9.54 7.38L9.91 7.37L10.29 7.41L10.69 7.49L11.1 7.6L11.51 7.74L11.89 7.9L12.24 8.06L12.57 8.26L12.89 8.51L13.2 8.77L13.47 9.02L13.7 9.23L13.87 9.38M9.45 10L9.65 10.03L9.94 10.06L10.27 10.1L10.63 10.16L10.99 10.25L11.31 10.39L11.61 10.57L11.92 10.79L12.23 11.04L12.52 11.32L12.78 11.62L13.02 11.94L13.22 12.31L13.39 12.74L13.55 13.2L13.68 13.63L13.78 14L13.87 14.27M8.21 12.48L8.34 12.44L8.53 12.37L8.75 12.29L8.99 12.22L9.23 12.18L9.45 12.17L9.67 12.22L9.91 12.31L10.15 12.42L10.37 12.54L10.56 12.65L10.69 12.71",
        "stroke": "accent",
        "strokeWidth": 1.55
      }
    ],
    "israel-post": [
      {
        "type": "polygon",
        "d": "M4.8 10.2L5.6 9.2L7.6 8L9.6 7L11.2 6.9L12 7.6L12.6 9.4L13 11.4L10.6 11.4L10 10L8 10L6 10.7Z",
        "fill": "accent"
      },
      {
        "type": "line",
        "d": "M10.6 7.2L12 5.7L14.2 4.9L17.2 4.7M12 5.8L11.6 4M14.4 5L14.9 3.9",
        "stroke": "accent",
        "strokeWidth": 1.4
      },
      {
        "type": "polygon",
        "d": "M3 14.6L6 12.6L10 11.6L14 12L17 13.3L19 15L17 14.5L14 13.6L10 13.2L6 13.7Z",
        "fill": "accent"
      }
    ],
    "jadlog": [
      {
        "type": "polygon",
        "d": "M11 4.2L16.2 6.8L11 9.4L5.8 6.8Z",
        "fill": "accent"
      },
      {
        "type": "polygon",
        "d": "M5.8 7.8L10.5 10.15L10.5 15L5.8 12.6Z",
        "fill": "accent"
      },
      {
        "type": "polygon",
        "d": "M11.5 10.15L16.2 7.8L16.2 12.6L11.5 15Z",
        "fill": "#ffb3c4"
      }
    ],
    "jersey-post": [
      {
        "type": "polygon",
        "d": "M4.2 4.8L6.8 4.8L11.4 9.6L6.8 14.4L4.2 14.4L8.8 9.6Z",
        "fill": "accent"
      },
      {
        "type": "polygon",
        "d": "M10.6 4.8L13.2 4.8L17.8 9.6L13.2 14.4L10.6 14.4L15.2 9.6Z",
        "fill": "accent"
      }
    ],
    "jne": [
      {
        "type": "polygon",
        "d": "M3.4 13.4L18.6 11.4L18.6 13.4L7.2 14.4Z",
        "fill": "#ff3b42"
      },
      {
        "type": "line",
        "d": "M8.59 4.9L7.7 8.93L7.51 9.47L7.18 9.94L6.76 10.29L6.3 10.48L5.85 10.48L5.47 10.29L5.21 9.94L5.09 9.47L5.13 8.93M9.15 10.5L10.38 4.9M10.38 4.9L12.62 10.5M12.62 10.5L13.86 4.9M18.45 4.9L15.65 4.9M15.65 4.9L14.42 10.5M14.42 10.5L17.22 10.5M15.03 7.7L17.38 7.7",
        "stroke": "accent",
        "strokeWidth": 1.9
      },
      {
        "type": "circle",
        "cx": 10.38,
        "cy": 4.9,
        "r": 0.95,
        "fill": "accent"
      },
      {
        "type": "circle",
        "cx": 12.62,
        "cy": 10.5,
        "r": 0.95,
        "fill": "accent"
      },
      {
        "type": "circle",
        "cx": 15.65,
        "cy": 4.9,
        "r": 0.95,
        "fill": "accent"
      },
      {
        "type": "circle",
        "cx": 14.42,
        "cy": 10.5,
        "r": 0.95,
        "fill": "accent"
      }
    ],
    "kazpost": [
      {
        "type": "polygon",
        "d": "M3 4.5L10 5.1L19 4.4L17.4 6.5L10 6.8Z",
        "fill": "#0157a5"
      },
      {
        "type": "polygon",
        "d": "M4.4 8.4L11 9.2L18.4 8L16.7 9.9L15.5 11.9L15 14.8L13.4 12.6L13.4 11L11 10.9Z",
        "fill": "#0157a5"
      }
    ],
    "kex": [
      {
        "type": "line",
        "d": "M7 4.4L7 14.6M16.6 5L7 11M10.6 8.8L16.6 14.4",
        "stroke": "accent",
        "strokeWidth": 2
      }
    ],
    "kolay-gelsin": [
      {
        "type": "polygon",
        "d": "M7.81 10.44L7.27 9.35L7.1 8.15L7.3 6.96L7.86 5.88L8.72 5.03L9.8 4.49L11 4.3L12.2 4.49L13.28 5.03L14.14 5.88L14.7 6.96L14.9 8.15L14.73 9.35L14.19 10.44L11 14.8Z",
        "fill": "accent"
      },
      {
        "type": "circle",
        "cx": 11,
        "cy": 8.2,
        "r": 2,
        "fill": "truck"
      }
    ],
    "logen": [
      {
        "type": "polygon",
        "d": "M3.6 5.6L6.4 5.6L10 10L13.6 6.2L18.6 4.4L17.2 6.6L14 7.8L10.2 13.6Z",
        "fill": "#61553e"
      }
    ],
    "loggi": [
      {
        "type": "polygon",
        "d": "M16.55 8.88L16.17 9.69L14.95 10.48L13.5 11.05L12.2 12.5L11.76 13.96L12.78 14.74L12.2 15.32L6.97 14.45L5.61 12.8L4.95 10.77L5.44 9.17L7.27 8.24L9.73 8.07L12.05 8.36L13.5 7.78L14.95 7.2L15.96 7.87Z",
        "fill": "accent"
      },
      {
        "type": "polygon",
        "d": "M6.54 4.24L9.73 4.82L12.48 5.98L14.66 7.2L13.5 7.78L11.47 7.02L8.86 6.27L6.68 5.4Z",
        "fill": "accent"
      }
    ],
    "lotte-global": [
      {
        "type": "line",
        "d": "M8.2 11.6L8.69 11.12L9.39 10.45L10.19 9.67L10.97 8.88L11.6 8.2L12.1 7.61L12.55 7.04L12.93 6.51L13.22 6.02L13.4 5.6L13.45 5.23L13.37 4.92L13.21 4.66L13.01 4.45L12.8 4.3L12.57 4.2L12.3 4.14L12 4.14L11.69 4.22L11.4 4.4L11.11 4.69L10.8 5.07L10.5 5.53L10.23 6.05L10 6.6L9.81 7.21L9.65 7.89L9.53 8.61L9.44 9.33L9.4 10L9.4 10.66L9.43 11.33L9.51 11.97L9.63 12.54L9.8 13L10.03 13.36L10.31 13.65L10.63 13.84L11 13.93L11.4 13.9L11.9 13.67L12.49 13.25L13.1 12.76L13.63 12.3L14 12",
        "stroke": "accent",
        "strokeWidth": 1.6
      }
    ],
    "mainfreight": [
      {
        "type": "polygon",
        "d": "M4.3 14.3L7.5 5.9L10.7 5.9L11.55 10.3L16.5 5.9L19.7 5.9L16.5 14.3L13.7 14.3L15.45 9.9L11.5 14.3L9.3 14.3L9.45 9.9L7.1 14.3Z",
        "fill": "#003a73"
      },
      {
        "type": "polygon",
        "d": "M3.4 13L6.6 4.6L9.8 4.6L10.65 9L15.6 4.6L18.8 4.6L15.6 13L12.8 13L14.55 8.6L10.6 13L8.4 13L8.55 8.6L6.2 13Z",
        "fill": "accent"
      }
    ],
    "maritime-ontario": [
      {
        "type": "line",
        "d": "M3.56 12.6L3.56 6.6L5.9 10.32L8.24 6.6L8.24 12.6M10.04 9.96L12.2 9.96M16.22 6.6L15.37 6.83L14.65 7.48L14.17 8.45L14 9.6L14.17 10.75L14.65 11.72L15.37 12.37L16.22 12.6L17.07 12.37L17.79 11.72L18.27 10.75L18.44 9.6L18.27 8.45L17.79 7.48L17.07 6.83L16.22 6.6",
        "stroke": "accent",
        "strokeWidth": 1.7
      }
    ],
    "naqel": [
      {
        "type": "circle",
        "cx": 8.6,
        "cy": 8.4,
        "r": 4.3,
        "fill": "#e31837"
      },
      {
        "type": "polygon",
        "d": "M10.6 11.4L12 12.2L14.5 13.4L17 14L19 14.3L16.8 14.9L14 14.8L11.6 14L9.6 12.5Z",
        "fill": "#e31837"
      },
      {
        "type": "circle",
        "cx": 8.6,
        "cy": 8.4,
        "r": 2.3,
        "fill": "truck"
      }
    ],
    "nipost": [
      {
        "type": "polygon",
        "d": "M4 4L5.4 4.5L6.8 4L8.2 4.5L9.6 4L11 4.5L12.4 4L13.8 4.5L15.2 4L16.6 4.5L18 4L17.5 5.38L18 6.75L17.5 8.12L18 9.5L17.5 10.88L18 12.25L17.5 13.62L18 15L16.6 14.5L15.2 15L13.8 14.5L12.4 15L11 14.5L9.6 15L8.2 14.5L6.8 15L5.4 14.5L4 15L4.5 13.62L4 12.25L4.5 10.88L4 9.5L4.5 8.12L4 6.75L4.5 5.38Z",
        "fill": "#fcb92c"
      },
      {
        "type": "polygon",
        "d": "M5.6 13.6L7.2 11.8L9.6 10.6L12.2 9.8L14 8.8L15.4 8.6L16.2 9L17 9.6L15.8 9.9L14.8 11.2L12.8 12.4L9.8 12.8L7.8 12.8Z",
        "fill": "truck"
      },
      {
        "type": "polygon",
        "d": "M9 10.8L7.8 8.2L8.2 5.2L10 6L11.6 7.6L12.8 9.8Z",
        "fill": "truck"
      }
    ],
    "nippon-express": [
      {
        "type": "polygon",
        "d": "M3.4 4.8L5.8 4.8L8.4 10L8.4 4.8L10.4 4.8L10.4 14.2L8 14.2L5.4 9L5.4 14.2L3.4 14.2Z",
        "fill": "#1a005d"
      },
      {
        "type": "polygon",
        "d": "M11 4.8L13.5 4.8L14.75 7.6L16 4.8L18.5 4.8L16 9.5L18.5 14.2L16 14.2L14.75 11.4L13.5 14.2L11 14.2L13.5 9.5Z",
        "fill": "#1a005d"
      }
    ],
    "nz-couriers": [
      {
        "type": "polygon",
        "d": "M15.6 3.9L10.6 9.4L12.6 9.4L6.4 15.1L9.6 10.6L7.6 10.6L11.6 3.9Z",
        "fill": "accent"
      }
    ],
    "oca": [
      {
        "type": "polygon",
        "d": "M4 4.6L6.9 4.6L11.5 9.5L6.9 14.4L4 14.4L8.6 9.5Z",
        "fill": "#f3912d"
      },
      {
        "type": "polygon",
        "d": "M10 4.6L12.9 4.6L17.5 9.5L12.9 14.4L10 14.4L14.6 9.5Z",
        "fill": "accent"
      }
    ],
    "olva-courier": [
      {
        "type": "line",
        "d": "M6.62 6.8L6.02 7.02L5.41 7.65L4.89 8.59L4.54 9.7L4.4 10.81L4.51 11.75L4.84 12.38L5.34 12.6L5.94 12.38L6.55 11.75L7.07 10.81L7.42 9.7L7.56 8.59L7.45 7.65L7.12 7.02L6.62 6.8M9.39 6.8L8.11 12.6M8.11 12.6L9.9 12.6M12.5 6.8L12.48 12.6M12.48 12.6L15 6.8M15.05 12.6L17.65 6.8M17.65 6.8L17.7 12.6M15.98 10.51L17.69 10.51",
        "stroke": "accent",
        "strokeWidth": 1.9
      },
      {
        "type": "circle",
        "cx": 8.11,
        "cy": 12.6,
        "r": 0.95,
        "fill": "accent"
      },
      {
        "type": "circle",
        "cx": 12.48,
        "cy": 12.6,
        "r": 0.95,
        "fill": "accent"
      },
      {
        "type": "circle",
        "cx": 17.65,
        "cy": 6.8,
        "r": 0.95,
        "fill": "accent"
      }
    ],
    "overseas-express": [
      {
        "type": "line",
        "d": "M10 7.14L8.75 6.67L7.42 6.64L6.15 7.05L5.09 7.86L4.35 8.96L4.02 10.25L4.12 11.58L4.66 12.8L5.56 13.77L6.74 14.4L8.06 14.6L9.37 14.36",
        "stroke": "accent",
        "strokeWidth": 1.6
      },
      {
        "type": "line",
        "d": "M8.58 9L7.91 8.9L7.25 9.07L6.72 9.48L6.38 10.07L6.31 10.75L6.5 11.4L6.93 11.92L7.53 12.23L8.21 12.29L8.85 12.07",
        "stroke": "accent",
        "strokeWidth": 1.4
      },
      {
        "type": "polygon",
        "d": "M9 14.6L16.8 4.4L19 4.4L11.6 14.6Z",
        "fill": "accent"
      }
    ],
    "palletways": [
      {
        "type": "polygon",
        "d": "M11 4.2L9.29 6.59L12.71 6.59Z",
        "fill": "accent"
      },
      {
        "type": "polygon",
        "d": "M4.72 7.93L6.82 9.95L7.88 7.39Z",
        "fill": "accent"
      },
      {
        "type": "polygon",
        "d": "M7.12 13.97L10.13 12.83L7.36 11.25Z",
        "fill": "accent"
      },
      {
        "type": "polygon",
        "d": "M14.88 13.97L14.64 11.25L11.87 12.83Z",
        "fill": "accent"
      },
      {
        "type": "polygon",
        "d": "M17.28 7.93L14.12 7.39L15.18 9.95Z",
        "fill": "accent"
      },
      {
        "type": "polygon",
        "d": "M14.52 8.85L14.52 9.43L14.28 10.03L13.81 10.59L13.16 11.09L12.35 11.48L11.46 11.75L10.53 11.87L9.64 11.84L8.83 11.65L8.18 11.32L7.72 10.88L7.48 10.35L7.48 9.77L7.72 9.17L8.19 8.61L8.84 8.11L9.65 7.72L10.54 7.45L11.47 7.33L12.36 7.36L13.17 7.55L13.82 7.88L14.28 8.32Z",
        "fill": "accent"
      }
    ],
    "pecom": [
      {
        "type": "polygon",
        "d": "M2.9 6L7.1 6L7.1 13.4L5.5 13.4L5.5 7.6L4.5 7.6L4.5 13.4L2.9 13.4Z",
        "fill": "accent"
      },
      {
        "type": "polygon",
        "d": "M8.1 6L11.7 6L11.7 13.4L8.1 13.4L8.1 11.8L10.1 11.8L10.1 10.5L8.9 10.5L8.9 8.9L10.1 8.9L10.1 7.6L8.1 7.6Z",
        "fill": "accent"
      },
      {
        "type": "polygon",
        "d": "M12.7 6L14.3 6L14.3 8.9L14.9 8.9L15.9 6L17.6 6L16.3 9.7L17.6 13.4L15.9 13.4L14.9 10.5L14.3 10.5L14.3 13.4L12.7 13.4Z",
        "fill": "accent"
      },
      {
        "type": "polygon",
        "d": "M18.2 6L18.9 6L18.9 8.8L18.2 8.8Z",
        "fill": "#e4003e"
      },
      {
        "type": "polygon",
        "d": "M18.2 10.6L18.9 10.6L18.9 13.4L18.2 13.4Z",
        "fill": "#e4003e"
      }
    ],
    "pilot-freight": [
      {
        "type": "polygon",
        "d": "M11 4.1L9.92 7.55L6.54 6.25L8.56 9.24L5.44 11.07L9.05 11.36L8.53 14.94L11 12.3L13.47 14.94L12.95 11.36L16.56 11.07L13.44 9.24L15.46 6.25L12.08 7.55Z",
        "fill": "accent"
      }
    ],
    "pitt-ohio": [
      {
        "type": "line",
        "d": "M3.8 10.5L3.8 4.9L5.37 4.9L5.87 4.99L6.3 5.24L6.63 5.63L6.8 6.1L6.8 6.61L6.63 7.08L6.3 7.47L5.87 7.72L5.37 7.81L3.8 7.81M9 4.9L9 10.5M10.8 4.9L14.16 4.9M12.48 4.9L12.48 10.5M15.28 4.9L18.64 4.9M16.96 4.9L16.96 10.5",
        "stroke": "accent",
        "strokeWidth": 1.7
      },
      {
        "type": "polygon",
        "d": "M3.6 12.4L18.4 12.4L18.4 14.3L3.6 14.3Z",
        "fill": "#231f20"
      }
    ],
    "pos-indonesia": [
      {
        "type": "line",
        "d": "M3.75 11.1L3.75 4.9L5.43 4.9L5.96 5L6.43 5.28L6.78 5.71L6.96 6.23L6.96 6.79L6.78 7.32L6.43 7.75L5.96 8.03L5.43 8.12L3.75 8.12M11 4.9L10.15 5.14L9.43 5.81L8.95 6.81L8.78 8L8.95 9.19L9.43 10.19L10.15 10.86L11 11.1L11.85 10.86L12.57 10.19L13.05 9.19L13.22 8L13.05 6.81L12.57 5.81L11.85 5.14L11 4.9M18.1 5.79L17.73 5.31L17.2 5L16.58 4.9L15.97 5.04L15.46 5.38L15.13 5.89L15.01 6.47L15.15 7.06L15.5 7.55L16.02 7.88L16.63 8L17.25 8.12L17.77 8.45L18.12 8.94L18.25 9.53L18.14 10.11L17.8 10.62L17.29 10.96L16.68 11.1L16.07 11L15.53 10.69L15.17 10.21",
        "stroke": "accent",
        "strokeWidth": 1.9
      },
      {
        "type": "polygon",
        "d": "M4.2 12.6L17.8 12.6L17.8 14.4L4.2 14.4Z",
        "fill": "#f13f23"
      }
    ],
    "post-haste": [
      {
        "type": "line",
        "d": "M5.2 15L5.29 14.58L5.39 14.18L5.5 13.78L5.62 13.38L5.76 13L5.91 12.62L6.08 12.26L6.26 11.9L6.45 11.54L6.65 11.2L6.87 10.86L7.1 10.54L7.34 10.22L7.59 9.9L7.86 9.6L8.14 9.3L8.44 9.02L8.75 8.74L9.07 8.46L9.4 8.2L9.75 7.94L10.11 7.7L10.48 7.46L10.86 7.22L11.26 7L11.67 6.78L12.1 6.58L12.54 6.38L12.99 6.18L13.45 6L13.93 5.82L14.42 5.66L14.92 5.5L15.43 5.34L15.96 5.2L16.5 5.06L17.06 4.94L17.63 4.82L18.21 4.7L18.8 4.6",
        "stroke": "#161616",
        "strokeWidth": 1.4
      },
      {
        "type": "line",
        "d": "M5.5 13.78L3.98 11.88M5.5 13.78L6.6 13.83M5.91 12.62L4.46 10.35M5.91 12.62L7.12 12.81M6.45 11.54L5.19 8.97M6.45 11.54L7.7 11.89M7.1 10.54L6.13 7.79M7.1 10.54L8.32 11.03M7.86 9.6L7.22 6.83M7.86 9.6L9 10.21M8.75 8.74L8.43 6.09M8.75 8.74L9.74 9.42M9.75 7.94L9.7 5.57M9.75 7.94L10.57 8.64M10.86 7.22L11.01 5.24M10.86 7.22L11.49 7.87M12.1 6.58L12.34 5.06M12.1 6.58L12.54 7.11M13.45 6L13.69 5.02M13.45 6L13.71 6.37M14.92 5.5L15.05 5.07M14.92 5.5L15.02 5.67M16.5 5.06L16.5 5.06M16.5 5.06L16.5 5.06",
        "stroke": "#161616",
        "strokeWidth": 1.15
      }
    ],
    "posta-moldovei": [
      {
        "type": "polygon",
        "d": "M3.4 5L3.52 6.7L3.86 8.35L4.42 9.9L5.18 11.3L6.11 12.51L7.2 13.49L8.4 14.21L9.68 14.65L11 14.8L12.32 14.65L13.6 14.21L14.8 13.49L15.89 12.51L16.82 11.3L17.58 9.9L18.14 8.35L18.48 6.7L18.6 5L18.48 6.28L18.14 7.53L17.58 8.7L16.82 9.76L15.89 10.67L14.8 11.41L13.6 11.95L12.32 12.29L11 12.4L9.68 12.29L8.4 11.95L7.2 11.41L6.11 10.67L5.18 9.76L4.42 8.7L3.86 7.53L3.52 6.28Z",
        "fill": "#ffdf00"
      },
      {
        "type": "line",
        "d": "M13.53 10.02L14.01 9.24L14.27 8.36L14.27 7.44L14.01 6.56L13.53 5.78L12.85 5.16L12.02 4.76L11.12 4.6L10.2 4.7L9.35 5.04L8.63 5.61L8.09 6.35L7.77 7.21L7.71 8.13L7.9 9.03L8.33 9.84L8.97 10.5L9.76 10.96L10.66 11.18L11.57 11.15",
        "stroke": "#ffdf00",
        "strokeWidth": 1.8
      }
    ],
    "posta-north-macedonia": [
      {
        "type": "polygon",
        "d": "M4.46 9.73L5.12 10.93L6 11.98L7.04 12.84L8.22 13.48L9.48 13.87L10.8 14L12.12 13.87L13.38 13.48L14.56 12.84L15.6 11.98L16.48 10.93L17.14 9.73L16.34 9.6L15.7 10.46L14.91 11.2L14 11.8L12.99 12.24L11.91 12.51L10.8 12.6L9.69 12.51L8.61 12.24L7.6 11.8L6.69 11.2L5.9 10.46L5.26 9.6Z",
        "fill": "#e83030"
      },
      {
        "type": "polygon",
        "d": "M14.9 7.8L14.46 6.15L13.25 4.94L11.6 4.5L9.95 4.94L8.74 6.15L8.3 7.8L8.74 9.45L9.95 10.66L11.6 11.1L13.25 10.66L14.46 9.45L14.9 7.8L13.5 7.8L13.25 8.75L12.55 9.45L11.6 9.7L10.65 9.45L9.95 8.75L9.7 7.8L9.95 6.85L10.65 6.15L11.6 5.9L12.55 6.15L13.25 6.85Z",
        "fill": "#333333"
      },
      {
        "type": "polygon",
        "d": "M3.4 6.6L8.6 7L10.6 10.9L8 10Z",
        "fill": "#333333"
      },
      {
        "type": "line",
        "d": "M13.95 3.39L14.42 3.67L14.86 4.01L15.26 4.4L15.62 4.83L15.92 5.29L16.18 5.79L16.37 6.31L16.51 6.85L16.58 7.4L16.6 7.95L16.55 8.51L16.44 9.05L16.27 9.58L16.05 10.09L15.76 10.57L15.43 11.01",
        "stroke": "#333333",
        "strokeWidth": 1.3
      }
    ],
    "posta-romana": [
      {
        "type": "polygon",
        "d": "M4 4L8 4L9.3 4.24L10.4 4.94L11.14 5.98L11.4 7.2L11.14 8.42L10.4 9.46L9.3 10.16L8 10.4L6.8 10.4L6.8 14.6L4 14.6Z",
        "fill": "accent"
      },
      {
        "type": "circle",
        "cx": 13.8,
        "cy": 10.8,
        "r": 4.6,
        "fill": "truck"
      },
      {
        "type": "circle",
        "cx": 13.8,
        "cy": 10.8,
        "r": 3.8,
        "fill": "accent"
      }
    ],
    "posta-shqiptare": [
      {
        "type": "polygon",
        "d": "M2.84 9.22L3.62 10.3L4.45 11.28L5.34 12.14L6.28 12.88L7.27 13.48L8.31 13.95L9.4 14.28L10.53 14.48L11.7 14.52L12.9 14.43L14.13 14.2L15.34 13.85L14.66 11.75L13.57 12.14L12.57 12.39L11.6 12.53L10.67 12.55L9.77 12.46L8.89 12.25L8.03 11.93L7.19 11.48L6.36 10.91L5.55 10.21L4.75 9.37L3.96 8.38Z",
        "fill": "accent"
      },
      {
        "type": "polygon",
        "d": "M14.2 11.4L17.4 9.2L18.8 11L15.8 14.2Z",
        "fill": "accent"
      },
      {
        "type": "polygon",
        "d": "M7 10.8L6.6 8.2L7.6 5.6L10 4.2L18.6 3.9L15 6L16.4 6.2L12 8.4L13.4 8.6L9.4 10.6L8.4 11.4Z",
        "fill": "accent"
      }
    ],
    "posturinn": [
      {
        "type": "polygon",
        "d": "M14.8 7.3L14.68 6.6L14.32 5.95L13.75 5.39L13 4.96L12.13 4.69L11.2 4.6L10.27 4.69L9.4 4.96L8.65 5.39L8.08 5.95L7.72 6.6L7.6 7.3L7.72 8L8.08 8.65L8.65 9.21L9.4 9.64L10.27 9.91L11.2 10L12.13 9.91L13 9.64L13.75 9.21L14.32 8.65L14.68 8L14.8 7.3Z",
        "fill": "accent"
      },
      {
        "type": "polygon",
        "d": "M13.3 7.3L13.23 6.96L13.02 6.65L12.68 6.38L12.25 6.17L11.74 6.04L11.2 6L10.66 6.04L10.15 6.17L9.72 6.38L9.38 6.65L9.17 6.96L9.1 7.3L9.17 7.64L9.38 7.95L9.72 8.22L10.15 8.43L10.66 8.56L11.2 8.6L11.74 8.56L12.25 8.43L12.68 8.22L13.02 7.95L13.23 7.64L13.3 7.3Z",
        "fill": "truck"
      },
      {
        "type": "polygon",
        "d": "M10.4 9.2L11.9 9.2L11.9 15L10.4 15Z",
        "fill": "accent"
      },
      {
        "type": "polygon",
        "d": "M13.4 9L15.8 7.6L17.8 5L19 6L16.8 8.8L14 10.6Z",
        "fill": "accent"
      },
      {
        "type": "polygon",
        "d": "M3 9.6L7 5L8.2 6L5.4 9.5L7.8 10.9L10.4 11.4L10.4 12.9L7.2 12.4Z",
        "fill": "accent"
      }
    ],
    "professional-couriers": [
      {
        "type": "polygon",
        "d": "M7 5.6L8.73 5.28L10.47 4.98L12.2 4.7L13.93 4.44L15.67 4.21L17.4 4L17.26 5.43L17.09 6.87L16.9 8.3L16.69 9.73L16.46 11.17L16.2 12.6L15.61 11.46L15.11 10.44L14.7 9.55L14.38 8.78L14.14 8.13L14 7.6L13.42 7.43L12.6 7.2L11.55 6.9L10.27 6.53L8.75 6.1Z",
        "fill": "#ffcb05"
      },
      {
        "type": "polygon",
        "d": "M3.8 8.6L5.57 8.21L7.33 7.84L9.1 7.5L10.87 7.18L12.63 6.88L14.4 6.6L14.26 8L14.09 9.4L13.9 10.8L13.69 12.2L13.46 13.6L13.2 15L12.61 13.92L12.11 12.96L11.7 12.1L11.38 11.36L11.14 10.72L11 10.2L10.41 10.04L9.58 9.84L8.5 9.6L7.18 9.31L5.61 8.98Z",
        "fill": "accent"
      }
    ],
    "raben": [
      {
        "type": "line",
        "d": "M8.48 14L8.48 5L11 5L11.8 5.14L12.5 5.55L13.03 6.17L13.3 6.93L13.3 7.75L13.03 8.51L12.5 9.13L11.8 9.54L11 9.68L8.48 9.68M10.82 9.68L13.7 14",
        "stroke": "accent",
        "strokeWidth": 2.2
      }
    ],
    "ram-hand-to-hand": [
      {
        "type": "line",
        "d": "M3.7 12.4L3.7 6.82M3.7 8.98L3.8 8.18L4.08 7.64L4.51 7.24L5.04 7.03L5.6 7.03L6.13 7.24M9.45 6.82L8.68 7.1L8.07 7.87L7.73 8.99L7.73 10.23L8.07 11.35L8.68 12.12L9.45 12.4L10.22 12.12L10.84 11.35L11.18 10.23L11.18 8.99L10.84 7.87L10.22 7.1L9.45 6.82M11.22 6.82L11.22 12.4M12.7 12.4L12.7 6.82M12.7 8.62L12.78 8L13.02 7.46L13.4 7.06L13.85 6.85L14.34 6.85L14.8 7.06L15.17 7.46L15.41 8L15.5 8.62L15.5 12.4M15.5 8.62L15.58 8L15.83 7.46L16.2 7.06L16.66 6.85L17.14 6.85L17.6 7.06L17.97 7.46L18.22 8L18.3 8.62L18.3 12.4",
        "stroke": "accent",
        "strokeWidth": 1.8
      }
    ],
    "roadrunner": [
      {
        "type": "polygon",
        "d": "M4.6 7.2L11.2 7.2L6.6 14.6L4.6 14.6L8 9L4.6 9Z",
        "fill": "accent"
      },
      {
        "type": "line",
        "d": "M3.6 4.9L12.6 4.9L13.52 5.08L14.3 5.6L14.82 6.38L15 7.3L14.82 8.22L14.3 9L13.52 9.52L12.6 9.7L10.4 9.7L16.4 14.4",
        "stroke": "#1a1a1a",
        "strokeWidth": 1.8
      }
    ],
    "saudi-post": [
      {
        "type": "line",
        "d": "M7.63 6.01L7.25 5.46L6.71 5.11L6.09 5L5.47 5.15L4.95 5.54L4.61 6.11L4.5 6.78L4.63 7.44L4.99 8L5.52 8.37L6.14 8.5L6.76 8.63L7.29 9L7.65 9.56L7.78 10.22L7.67 10.89L7.33 11.46L6.81 11.85L6.19 12L5.57 11.89L5.03 11.54L4.65 10.99M9.6 12L9.6 5L11.3 5L11.84 5.11L12.32 5.43L12.67 5.91L12.86 6.5L12.86 7.14L12.67 7.73L12.32 8.21L11.84 8.53L11.3 8.64L9.6 8.64M14.71 5L14.71 12L17.5 12",
        "stroke": "accent",
        "strokeWidth": 1.8
      }
    ],
    "seino": [
      {
        "type": "polygon",
        "d": "M3 7.5L4.2 6.4L4.7 4.2L5.9 6L6.6 7L8.6 6.7L11 6.4L13.2 5.4L15.6 3.9L14.4 6.2L13 8.4L12.4 10.2L10.8 11.8L5.4 14.8L3.8 15L4.6 14.2L8.4 11.6L8.2 10.4L7.4 9.6L6.2 10.4L5.8 10L6.6 9L5.4 8.5L4 8.1Z",
        "fill": "accent"
      },
      {
        "type": "polygon",
        "d": "M15.6 6L19 6L19 7.2L14.8 7.2Z",
        "fill": "accent"
      },
      {
        "type": "polygon",
        "d": "M14.2 8.4L18.4 8.4L18.4 9.6L13.6 9.6Z",
        "fill": "accent"
      },
      {
        "type": "polygon",
        "d": "M13 10.8L17.8 10.8L17.8 12L12.2 12Z",
        "fill": "accent"
      }
    ],
    "seko": [
      {
        "type": "line",
        "d": "M6.73 5.28L6.54 4.86L6.23 4.59L5.82 4.5L5.39 4.62L5 4.92L4.7 5.36L4.54 5.87L4.55 6.38L4.72 6.81L5.03 7.1L5.43 7.2L5.83 7.3L6.13 7.59L6.3 8.02L6.31 8.53L6.15 9.04L5.85 9.48L5.46 9.78L5.03 9.9L4.63 9.81L4.31 9.54L4.13 9.12M10.69 4.5L8.66 4.5L7.79 9.9L9.82 9.9M8.23 7.2L9.93 7.2M12.39 4.5L11.52 9.9M14.66 4.5L11.87 7.74M12.72 6.98L13.8 9.9M17.86 4.5L17.26 4.71L16.68 5.29L16.21 6.17L15.93 7.2L15.88 8.23L16.06 9.11L16.46 9.69L17 9.9L17.61 9.69L18.19 9.11L18.65 8.23L18.93 7.2L18.98 6.17L18.8 5.29L18.4 4.71L17.86 4.5",
        "stroke": "#1a1a1a",
        "strokeWidth": 1.6
      },
      {
        "type": "polygon",
        "d": "M4.98 10.21L5.6 11.1L6.37 11.91L7.24 12.63L8.22 13.22L9.28 13.69L10.39 14.01L11.55 14.19L12.73 14.21L13.9 14.08L15.06 13.8L16.16 13.37L17.2 12.79L18.15 12.08L18.96 11.3L17.65 10.06L16.99 10.82L16.27 11.46L15.46 12L14.57 12.43L13.62 12.74L12.63 12.93L11.61 12.99L10.59 12.92L9.59 12.71L8.62 12.37L7.71 11.91L6.87 11.33L6.12 10.64L5.45 9.85Z",
        "fill": "accent"
      }
    ],
    "sendex": [
      {
        "type": "polygon",
        "d": "M6 4.4L18.6 4.4L16 14.6L3.4 14.6Z",
        "fill": "accent"
      },
      {
        "type": "line",
        "d": "M6.39 10.81L10.7 10.81L10.69 9.79L10.39 8.91L9.83 8.3L9.1 8.03L8.28 8.14L7.51 8.63L6.87 9.41L6.47 10.39L6.36 11.43L6.55 12.38L7.01 13.12L7.69 13.53L8.48 13.57L9.29 13.23M12.82 8.02L16 13.6M16.78 8.02L12.03 13.6",
        "stroke": "truck",
        "strokeWidth": 1.7
      }
    ],
    "sending": [
      {
        "type": "polygon",
        "d": "M6.6 10.89L8.9 10.8L11.2 10.34L13.04 9.05L14.33 7.49L15.16 5.83L13.96 7.21L12.35 8.5L10.28 9.51L7.98 10.34Z",
        "fill": "accent"
      },
      {
        "type": "polygon",
        "d": "M10.19 10.25L12.95 9.88L8.44 15.4Z",
        "fill": "accent"
      },
      {
        "type": "polygon",
        "d": "M12.67 11.63L14.51 14.39L12.3 14.11Z",
        "fill": "accent"
      },
      {
        "type": "circle",
        "cx": 10.51,
        "cy": 8.18,
        "r": 1.3,
        "fill": "accent"
      },
      {
        "type": "polygon",
        "d": "M14.58 4.29L12.88 3.83L12.42 5.54L14.12 5.99Z",
        "fill": "accent"
      }
    ],
    "serpost": [
      {
        "type": "polygon",
        "d": "M6.6 4.4L18.4 4.4L17.9 6.2L8.7 6.2L8.3 7.7L15.3 7.7L13.8 13L3.6 13L4.1 11.2L11.8 11.2L12.2 9.5L5.2 9.5Z",
        "fill": "accent"
      },
      {
        "type": "polygon",
        "d": "M10.52 15.05L11.64 15.03L12.75 14.95L13.83 14.81L14.9 14.61L15.94 14.35L16.96 14.03L17.96 13.65L18.92 13.22L18.28 11.98L17.41 12.49L16.52 12.94L15.6 13.34L14.65 13.69L13.66 13.99L12.64 14.23L11.58 14.42L10.48 14.55Z",
        "fill": "#ff3b3b"
      }
    ],
    "servientrega": [
      {
        "type": "polygon",
        "d": "M5.6 8.6L5.6 9L5.76 7.76L6.24 6.6L7.01 5.61L8 4.84L9.16 4.36L10.4 4.2L16.4 4.2L16.4 9.8L16.24 11.04L15.76 12.2L14.99 13.19L14 13.96L12.84 14.44L11.6 14.6L5.6 14.6Z",
        "fill": "accent"
      },
      {
        "type": "line",
        "d": "M13.73 6.85L13.05 6.16L11.99 5.71L10.75 5.61L9.55 5.85L8.62 6.41L8.14 7.17L8.2 7.99L8.78 8.72L9.77 9.22L11 9.4L12.23 9.58L13.22 10.08L13.8 10.81L13.86 11.63L13.38 12.39L12.45 12.95L11.25 13.19L10.01 13.09L8.95 12.64L8.27 11.95",
        "stroke": "truck",
        "strokeWidth": 1.6
      }
    ],
    "sfc": [
      {
        "type": "line",
        "d": "M8.76 5.32L8.48 4.82L7.99 4.5L7.36 4.4L6.7 4.54L6.1 4.9L5.64 5.42L5.41 6.03L5.42 6.63L5.69 7.14L6.16 7.48L6.78 7.6L7.39 7.72L7.87 8.06L8.13 8.57L8.15 9.17L7.91 9.78L7.46 10.3L6.85 10.66L6.19 10.8L5.57 10.7L5.08 10.38L4.79 9.88M13.73 4.4L10.73 4.4L9.45 10.8M10.09 7.6L12.59 7.6M18.95 5.22L18.34 4.59L17.53 4.4L16.63 4.68L15.79 5.38L15.12 6.4L14.71 7.6L14.64 8.8L14.9 9.82L15.47 10.52L16.25 10.8L17.13 10.61L17.99 9.98",
        "stroke": "accent",
        "strokeWidth": 1.9
      },
      {
        "type": "polygon",
        "d": "M3.86 14.94L5.15 14.39L6.46 13.93L7.82 13.56L9.22 13.27L10.66 13.07L12.15 12.95L13.67 12.91L15.24 12.96L16.86 13.09L18.54 13.3L18.66 11.9L16.95 11.8L15.27 11.78L13.64 11.84L12.06 11.99L10.54 12.23L9.07 12.55L7.65 12.95L6.29 13.44L4.98 14.01L3.74 14.66Z",
        "fill": "accent"
      }
    ],
    "shadowfax": [
      {
        "type": "polygon",
        "d": "M5 4.2L16.4 7.7L17 8.44L14.6 10.56L13.64 10.56L10.16 7.38L7.88 14.38L6.8 14.8L6.2 14.16Z",
        "fill": "#f1ee1b"
      }
    ],
    "shree-maruti": [
      {
        "type": "line",
        "d": "M14 7.1L13.89 6.44L13.55 5.82L13.02 5.3L12.33 4.9L11.53 4.67L10.68 4.6L9.84 4.72L9.06 5L8.41 5.43L7.93 5.99L7.66 6.62L7.61 7.29L7.79 7.94L8.18 8.53",
        "stroke": "accent",
        "strokeWidth": 1.8
      },
      {
        "type": "line",
        "d": "M8 11.9L8.11 12.56L8.45 13.18L8.98 13.7L9.67 14.1L10.47 14.33L11.32 14.4L12.16 14.28L12.94 14L13.59 13.57L14.07 13.01L14.34 12.38L14.39 11.71L14.21 11.06L13.82 10.47",
        "stroke": "accent",
        "strokeWidth": 1.8
      },
      {
        "type": "polygon",
        "d": "M9.12 9.95L7.12 9.24L9.24 7.83Z",
        "fill": "accent"
      },
      {
        "type": "polygon",
        "d": "M12.88 9.05L14.88 9.76L12.76 11.17Z",
        "fill": "accent"
      }
    ],
    "sicepat": [
      {
        "type": "polygon",
        "d": "M16.09 8.29L16.18 7.79L16.06 7.3L15.77 6.88L15.34 6.61L9.74 4.46L9.24 4.37L8.75 4.49L8.33 4.78L8.06 5.21L5.91 10.81L5.82 11.31L5.94 11.8L6.23 12.22L6.66 12.49L12.26 14.64L12.76 14.73L13.25 14.61L13.67 14.32L13.94 13.89Z",
        "fill": "accent"
      },
      {
        "type": "polygon",
        "d": "M9.67 7.89L14.98 7.49L11.64 9.25L12.16 11.27L6.87 11.66L10.36 9.89Z",
        "fill": "truck"
      }
    ],
    "skynet-worldwide": [
      {
        "type": "line",
        "d": "M13.37 5.02L13.09 4.52L12.59 4.2L11.95 4.1L11.27 4.24L10.65 4.6L10.17 5.12L9.92 5.73L9.93 6.33L10.19 6.84L10.68 7.18L11.3 7.3L11.93 7.42L12.42 7.76L12.68 8.27L12.69 8.87L12.43 9.48L11.96 10L11.34 10.36L10.66 10.5L10.02 10.4L9.52 10.08L9.24 9.58",
        "stroke": "accent",
        "strokeWidth": 2.1
      },
      {
        "type": "polygon",
        "d": "M5.3 11.8L17.7 11.8L17.2 13.5L4.8 13.5Z",
        "fill": "accent"
      }
    ],
    "smsa-express": [
      {
        "type": "line",
        "d": "M5.38 7.29L5.11 6.81L4.72 6.5L4.26 6.4L3.81 6.54L3.43 6.88L3.18 7.39L3.1 7.97L3.2 8.56L3.46 9.05L3.84 9.38L4.3 9.5L4.75 9.62L5.14 9.95L5.4 10.44L5.5 11.03L5.41 11.61L5.17 12.12L4.79 12.46L4.34 12.6L3.88 12.5L3.49 12.19L3.21 11.71M7.01 12.6L7.01 6.4L8.74 10.24L10.47 6.4L10.47 12.6",
        "stroke": "#400099",
        "strokeWidth": 1.5
      },
      {
        "type": "line",
        "d": "M14.26 7.29L13.99 6.81L13.59 6.5L13.14 6.4L12.69 6.54L12.31 6.88L12.06 7.39L11.98 7.97L12.07 8.56L12.33 9.05L12.72 9.38L13.17 9.5L13.63 9.62L14.02 9.95L14.28 10.44L14.37 11.03L14.29 11.61L14.04 12.12L13.66 12.46L13.21 12.6L12.76 12.5L12.36 12.19L12.09 11.71M15.88 12.6L17.39 6.4L18.9 12.6M16.41 10.37L18.37 10.37",
        "stroke": "accent",
        "strokeWidth": 1.5
      }
    ],
    "south-african-post-office": [
      {
        "type": "polygon",
        "d": "M4.05 8.22L9.59 5.37L10.28 8.22Z",
        "fill": "accent"
      },
      {
        "type": "polygon",
        "d": "M10.23 5.12L16.39 4.2L18.01 8.43Z",
        "fill": "accent"
      },
      {
        "type": "polygon",
        "d": "M3.95 9.11L10.49 9.11L11.88 15.27Z",
        "fill": "accent"
      },
      {
        "type": "polygon",
        "d": "M11.25 9.11L18.18 9.03L12.79 15.27Z",
        "fill": "accent"
      }
    ],
    "southeastern-freight-lines": [
      {
        "type": "polygon",
        "d": "M3.2 4.3L9.4 4.3L9.4 5.75L3.2 5.75Z",
        "fill": "accent"
      },
      {
        "type": "polygon",
        "d": "M3.6 8.05L9 8.05L9 9.5L3.6 9.5Z",
        "fill": "accent"
      },
      {
        "type": "polygon",
        "d": "M3.2 11.8L9 11.8L9 13.25L3.2 13.25Z",
        "fill": "accent"
      },
      {
        "type": "polygon",
        "d": "M3.6 4.3L5.1 4.3L5.1 9.55L3.6 9.55Z",
        "fill": "accent"
      },
      {
        "type": "polygon",
        "d": "M7.5 8.05L9 8.05L9 13.3L7.5 13.3Z",
        "fill": "accent"
      },
      {
        "type": "polygon",
        "d": "M12.6 4.3L18.8 4.3L18.8 5.75L12.6 5.75Z",
        "fill": "accent"
      },
      {
        "type": "polygon",
        "d": "M12.6 8.05L18.4 8.05L18.4 9.5L12.6 9.5Z",
        "fill": "accent"
      },
      {
        "type": "polygon",
        "d": "M12.6 11.8L18.8 11.8L18.8 13.25L12.6 13.25Z",
        "fill": "accent"
      },
      {
        "type": "polygon",
        "d": "M12.6 4.3L14.1 4.3L14.1 13.3L12.6 13.3Z",
        "fill": "accent"
      },
      {
        "type": "polygon",
        "d": "M11 4.6L11.9 6.2L11.4 6.6L11.6 12.8L11 13.4L10.4 12.8L10.6 6.6L10.1 6.2Z",
        "fill": "accent"
      }
    ],
    "speedex": [
      {
        "type": "polygon",
        "d": "M3.7 8.74L11.07 8.74L8.2 6.08L10.93 6.08L14.61 9.5L10.93 12.9L8.2 12.9L11.02 10.28L3.7 10.28Z",
        "fill": "accent"
      },
      {
        "type": "polygon",
        "d": "M13.48 8.02L15.57 6.08L18.3 6.08L14.84 9.28Z",
        "fill": "accent"
      },
      {
        "type": "polygon",
        "d": "M13.48 10.95L14.84 9.71L18.3 12.9L15.57 12.9Z",
        "fill": "accent"
      }
    ],
    "starken": [
      {
        "type": "line",
        "d": "M8.4 5L16 5L16 10.4",
        "stroke": "accent",
        "strokeWidth": 1.6
      },
      {
        "type": "line",
        "d": "M6 7.6L6 13.2L13.6 13.2",
        "stroke": "accent",
        "strokeWidth": 1.6
      },
      {
        "type": "polygon",
        "d": "M6.6 5L8.5 3.55L8.5 6.45Z",
        "fill": "accent"
      },
      {
        "type": "polygon",
        "d": "M15.4 13.2L13.5 11.75L13.5 14.65Z",
        "fill": "accent"
      },
      {
        "type": "line",
        "d": "M9.6 11.6L9.6 7.2M9.6 8.9L9.7 8.35L10 7.87L10.45 7.51L11 7.32L11.6 7.32L12.15 7.51L12.6 7.87L12.9 8.35L13 8.9L13 9.6",
        "stroke": "accent",
        "strokeWidth": 1.6
      }
    ],
    "surat-kargo": [
      {
        "type": "polygon",
        "d": "M5.08 7.03L7.53 8.52L10.28 6.92L13.46 5.43L17.5 4.32L16.64 4.05L12.59 4.16L8.84 5.11Z",
        "fill": "#ff5a4f"
      },
      {
        "type": "polygon",
        "d": "M4.5 13.82L6.67 10.37L9.56 8.11L12.88 6.91L15.92 8.29L12.59 8.4L9.7 9.52L7.25 11.56L5.22 13.61Z",
        "fill": "accent"
      }
    ],
    "team-global-express": [
      {
        "type": "polygon",
        "d": "M3.4 4.6L4.12 4.88L4.84 5.13L5.56 5.33L6.28 5.46L7 5.5L7.72 5.46L8.44 5.33L9.16 5.13L9.88 4.88L10.6 4.6L10.6 6.6L9.88 6.88L9.16 7.13L8.44 7.33L7.72 7.46L7 7.5L6.28 7.46L5.56 7.33L4.84 7.13L4.12 6.88L3.4 6.6Z",
        "fill": "accent"
      },
      {
        "type": "polygon",
        "d": "M11.4 4.6L12.12 4.88L12.84 5.13L13.56 5.33L14.28 5.46L15 5.5L15.72 5.46L16.44 5.33L17.16 5.13L17.88 4.88L18.6 4.6L18.6 6.6L17.88 6.88L17.16 7.13L16.44 7.33L15.72 7.46L15 7.5L14.28 7.46L13.56 7.33L12.84 7.13L12.12 6.88L11.4 6.6Z",
        "fill": "accent"
      },
      {
        "type": "polygon",
        "d": "M3.4 8L4.12 8.28L4.84 8.53L5.56 8.73L6.28 8.86L7 8.9L7.72 8.86L8.44 8.73L9.16 8.53L9.88 8.28L10.6 8L10.6 10L9.88 10.28L9.16 10.53L8.44 10.73L7.72 10.86L7 10.9L6.28 10.86L5.56 10.73L4.84 10.53L4.12 10.28L3.4 10Z",
        "fill": "accent"
      },
      {
        "type": "polygon",
        "d": "M11.4 8L12.12 8.28L12.84 8.53L13.56 8.73L14.28 8.86L15 8.9L15.72 8.86L16.44 8.73L17.16 8.53L17.88 8.28L18.6 8L18.6 10L17.88 10.28L17.16 10.53L16.44 10.73L15.72 10.86L15 10.9L14.28 10.86L13.56 10.73L12.84 10.53L12.12 10.28L11.4 10Z",
        "fill": "accent"
      },
      {
        "type": "polygon",
        "d": "M3.4 11.4L4.12 11.68L4.84 11.93L5.56 12.13L6.28 12.26L7 12.3L7.72 12.26L8.44 12.13L9.16 11.93L9.88 11.68L10.6 11.4L10.6 13.4L9.88 13.68L9.16 13.93L8.44 14.13L7.72 14.26L7 14.3L6.28 14.26L5.56 14.13L4.84 13.93L4.12 13.68L3.4 13.4Z",
        "fill": "accent"
      },
      {
        "type": "polygon",
        "d": "M11.4 11.4L12.12 11.68L12.84 11.93L13.56 12.13L14.28 12.26L15 12.3L15.72 12.26L16.44 12.13L17.16 11.93L17.88 11.68L18.6 11.4L18.6 13.4L17.88 13.68L17.16 13.93L16.44 14.13L15.72 14.26L15 14.3L14.28 14.26L13.56 14.13L12.84 13.93L12.12 13.68L11.4 13.4Z",
        "fill": "accent"
      }
    ],
    "tforce-freight": [
      {
        "type": "line",
        "d": "M7.56 7L11.52 7M9.54 7L8.36 13.6M16.01 7L12.84 7L11.66 13.6M12.25 10.3L14.89 10.3",
        "stroke": "accent",
        "strokeWidth": 2
      },
      {
        "type": "polygon",
        "d": "M4.46 10.26L5.17 8.61L6.18 7.17L7.43 6.01L8.88 5.17L10.44 4.7L12.06 4.62L13.66 4.92L15.17 5.61L15.17 6.67L13.66 6.08L12.06 5.81L10.44 5.89L8.88 6.29L7.43 7.01L6.18 8.01L5.17 9.25L4.46 10.67Z",
        "fill": "#ff6b5e"
      }
    ],
    "toptrans": [
      {
        "type": "polygon",
        "d": "M6.21 4.3L19.01 4.3L18.48 6.7L13.48 6.7L12.4 11.6L9.6 11.6L10.68 6.7L5.68 6.7Z",
        "fill": "accent"
      },
      {
        "type": "polygon",
        "d": "M3.86 12.4L18.66 12.4L18.4 13.6L3.6 13.6Z",
        "fill": "#ee3124"
      },
      {
        "type": "polygon",
        "d": "M3.42 14.2L18.22 14.2L18 15.2L3.2 15.2Z",
        "fill": "accent"
      }
    ],
    "total-express": [
      {
        "type": "polygon",
        "d": "M6.52 4.4L19.72 4.4L19.16 7.2L14.16 7.2L12.6 15L9.4 15L10.96 7.2L5.96 7.2Z",
        "fill": "accent"
      },
      {
        "type": "polygon",
        "d": "M3.6 13.6L4.68 12.75L5.79 12L6.94 11.35L8.11 10.8L9.32 10.35L10.55 10L11.82 9.75L13.11 9.6L14.44 9.55L15.79 9.6L17.18 9.75L18.6 10L17.26 10.12L15.93 10.27L14.62 10.45L13.33 10.67L12.06 10.92L10.8 11.2L9.56 11.52L8.33 11.87L7.12 12.25L5.93 12.67L4.76 13.12Z",
        "fill": "#22315e"
      }
    ],
    "trackon": [
      {
        "type": "polygon",
        "d": "M7.43 4L10.8 5.66L8.26 7.29Z",
        "fill": "#f27224"
      },
      {
        "type": "polygon",
        "d": "M11 7.44L12.46 6.49L16.15 8.29L12.79 10.26Z",
        "fill": "#f27224"
      },
      {
        "type": "polygon",
        "d": "M8.64 8.93L9.67 8.29L11.47 11.08L5.85 14.4Z",
        "fill": "#f27224"
      }
    ],
    "trendyol-express": [
      {
        "type": "line",
        "d": "M9.9 4.2L9.9 11.2L10.09 12.05L10.63 12.76L11.42 13.2L12.33 13.29L13.2 13.02",
        "stroke": "accent",
        "strokeWidth": 2
      },
      {
        "type": "line",
        "d": "M7.3 6.9L13.9 6.9",
        "stroke": "accent",
        "strokeWidth": 1.8
      }
    ],
    "vasp-expresso": [
      {
        "type": "line",
        "d": "M3.5 6L5.1 12.6L6.7 6M7.7 12.6L9.4 6L11.1 12.6M8.3 10.22L10.5 10.22M14.67 6.95L14.37 6.44L13.92 6.1L13.41 6L12.9 6.14L12.47 6.51L12.19 7.05L12.1 7.68L12.21 8.3L12.5 8.83L12.94 9.18L13.45 9.3L13.96 9.42L14.4 9.77L14.69 10.3L14.8 10.92L14.71 11.55L14.43 12.09L14 12.46L13.49 12.6L12.98 12.5L12.53 12.16L12.23 11.65M15.8 12.6L15.8 6L17.2 6L17.64 6.1L18.04 6.4L18.33 6.86L18.48 7.42L18.48 8.01L18.33 8.57L18.04 9.03L17.64 9.33L17.2 9.43L15.8 9.43",
        "stroke": "accent",
        "strokeWidth": 1.7
      }
    ],
    "viettel-post": [
      {
        "type": "line",
        "d": "M3.64 6.4L5.69 12.8L7.74 6.4M9.4 6.4L13.24 6.4M11.32 6.4L11.32 12.8M14.9 12.8L14.9 6.4L16.7 6.4L17.27 6.5L17.77 6.79L18.14 7.23L18.33 7.78L18.33 8.35L18.14 8.9L17.77 9.34L17.27 9.63L16.7 9.73L14.9 9.73",
        "stroke": "accent",
        "strokeWidth": 1.7
      }
    ],
    "vnpost": [
      {
        "type": "polygon",
        "d": "M3.4 10L6.4 7.4L9.8 10L10.23 9.2L15.83 9.2L12.4 14.6L9.2 14.6Z",
        "fill": "accent"
      },
      {
        "type": "polygon",
        "d": "M13.4 4.2L19 4.2L18.12 5.6L12.52 5.6Z",
        "fill": "accent"
      },
      {
        "type": "polygon",
        "d": "M11.88 6.6L17.48 6.6L16.59 8L10.99 8Z",
        "fill": "accent"
      },
      {
        "type": "polygon",
        "d": "M5.2 10L7 8.9L7.6 10.7Z",
        "fill": "truck"
      }
    ],
    "ward-trucking": [
      {
        "type": "line",
        "d": "M5 4.6L4.53 10.6L6.31 6.4L6.42 10.6L8.35 4.6M8.24 10.6L10.68 4.6L10.72 10.6M9.11 8.44L10.71 8.44M11.81 10.6L13.01 4.6L14.03 4.6L14.34 4.69L14.57 4.96L14.69 5.38L14.7 5.89L14.6 6.43L14.38 6.94L14.09 7.36L13.75 7.63L13.41 7.72L12.39 7.72M13.33 7.72L13.92 10.6M16.14 4.6L14.94 10.6L15.74 10.6L16.28 10.42L16.82 9.9L17.3 9.1L17.67 8.12L17.88 7.08L17.9 6.1L17.74 5.3L17.41 4.78L16.94 4.6L16.14 4.6",
        "stroke": "accent",
        "strokeWidth": 1.4
      },
      {
        "type": "polygon",
        "d": "M4.6 12L17.8 12L17.6 13.2L4.4 13.2Z",
        "fill": "accent"
      }
    ],
    "17feia": [
      {
        "type": "polygon",
        "d": "M14.82 5.93L13.98 5.12L12.98 4.52L11.88 4.16L10.72 4.05L9.56 4.2L8.47 4.6L7.49 5.23L6.67 6.05L6.06 7.04L5.68 8.14L5.55 9.3L5.68 10.46L6.06 11.56L6.67 12.55L7.49 13.37L8.47 14L9.56 14.4L10.72 14.55L11.88 14.44L12.98 14.08L13.98 13.48L14.82 12.67L13.71 11.74L13.1 12.32L12.38 12.76L11.58 13.02L10.74 13.1L9.9 12.99L9.11 12.7L8.4 12.25L7.81 11.65L7.37 10.93L7.09 10.14L7 9.3L7.09 8.46L7.37 7.67L7.81 6.95L8.4 6.35L9.11 5.9L9.9 5.61L10.74 5.5L11.58 5.58L12.38 5.84L13.1 6.28L13.71 6.86Z",
        "fill": "accent"
      },
      {
        "type": "line",
        "d": "M8.34 7.76L10.14 6.55L9.48 12.05M12.01 6.55L14.87 6.55L12.23 12.05",
        "stroke": "accent",
        "strokeWidth": 1.6
      }
    ],
    "tsjy": [
      {
        "type": "circle",
        "cx": 11,
        "cy": 9.35,
        "r": 5.35,
        "fill": "#ff6600"
      },
      {
        "type": "polygon",
        "d": "M6.7 6.05L14.4 6.05L14.4 7.6L6.7 7.6Z",
        "fill": "accent"
      },
      {
        "type": "polygon",
        "d": "M8.95 7.55L10.5 7.55L10.5 13.7L8.95 13.7Z",
        "fill": "accent"
      },
      {
        "type": "line",
        "d": "M14.46 9.31L14.16 8.93L13.72 8.68L13.21 8.6L12.7 8.71L12.28 8.98L12.01 9.39L11.91 9.86L12.02 10.32L12.31 10.72L12.74 10.98L13.25 11.07L13.76 11.17L14.19 11.43L14.48 11.83L14.59 12.29L14.49 12.76L14.22 13.17L13.8 13.44L13.29 13.55L12.78 13.47L12.34 13.22L12.04 12.84",
        "stroke": "accent",
        "strokeWidth": 1.45
      }
    ],
    "hywl": [
      {
        "type": "line",
        "d": "M3.4 13.3L7.2 13.3L7.75 13.15L8.15 12.75L8.3 12.2L8.3 8.9L11.9 8.9L11.9 12.2L12.05 12.75L12.45 13.15L13 13.3L18.6 13.3",
        "stroke": "accent",
        "strokeWidth": 1.6
      },
      {
        "type": "line",
        "d": "M5.05 10.16L5.4 8.91L6.04 7.77L6.95 6.82L8.07 6.12L9.33 5.71L10.65 5.61L11.96 5.83L13.17 6.35L14.22 7.15",
        "stroke": "accent",
        "strokeWidth": 1.45
      },
      {
        "type": "polygon",
        "d": "M13.3 4.5L16.9 4.5L18.8 6.3L16.9 8.1L13.3 8.1Z",
        "fill": "#f4a51c"
      }
    ],
    "dhlink": [
      {
        "type": "line",
        "d": "M4 8.45L11.4 4.5L18.8 8.45",
        "stroke": "#efab58",
        "strokeWidth": 1.45
      },
      {
        "type": "line",
        "d": "M7.45 8.6L6.79 14.1L8 14.1L8.77 13.93L9.49 13.46L10.07 12.72L10.44 11.83L10.55 10.87L10.4 9.97L10 9.24L9.39 8.77L8.66 8.6L7.45 8.6M12.51 8.6L11.85 14.1M15.81 8.6L15.15 14.1M12.18 11.35L15.48 11.35",
        "stroke": "accent",
        "strokeWidth": 1.55
      }
    ],
    "gzyl": [
      {
        "type": "polygon",
        "d": "M7.6 5L14.4 5L14.4 7L16.9 7L18.9 9.6L18.9 12.6L7.6 12.6Z",
        "fill": "accent"
      },
      {
        "type": "polygon",
        "d": "M15.3 8L16.5 8L17.6 9.6L15.3 9.6Z",
        "fill": "truck"
      },
      {
        "type": "circle",
        "cx": 10,
        "cy": 13,
        "r": 2,
        "fill": "truck"
      },
      {
        "type": "circle",
        "cx": 10,
        "cy": 13,
        "r": 1.35,
        "fill": "accent"
      },
      {
        "type": "circle",
        "cx": 16.4,
        "cy": 13,
        "r": 2,
        "fill": "truck"
      },
      {
        "type": "circle",
        "cx": 16.4,
        "cy": 13,
        "r": 1.35,
        "fill": "accent"
      },
      {
        "type": "line",
        "d": "M3.3 6.6L6.4 6.6M4.4 9.1L6.4 9.1M3.3 11.6L6.4 11.6",
        "stroke": "accent",
        "strokeWidth": 1.4
      }
    ],
    "thhy": [
      {
        "type": "line",
        "d": "M4.25 6.6L6.85 6.6M5.55 6.6L4.65 12.2M8.15 6.6L7.26 12.2M10.75 6.6L9.86 12.2M7.7 9.4L10.31 9.4M12.06 6.6L11.16 12.2M14.66 6.6L13.76 12.2M11.61 9.4L14.21 9.4M15.96 6.6L16.84 9.51L18.65 6.6M16.84 9.51L16.41 12.2",
        "stroke": "accent",
        "strokeWidth": 1.5
      }
    ],
    "jrt": [
      {
        "type": "line",
        "d": "M4.4 14.6L4.4 8.8L11 4.6L17.6 8.8L17.6 14.6",
        "stroke": "accent",
        "strokeWidth": 1.5
      },
      {
        "type": "polygon",
        "d": "M6.6 9.6L12.4 9.6L12.4 10.8L14.2 10.8L15.6 12.4L15.6 14.2L6.6 14.2Z",
        "fill": "#e66926"
      },
      {
        "type": "circle",
        "cx": 8.7,
        "cy": 14.1,
        "r": 1.35,
        "fill": "truck"
      },
      {
        "type": "circle",
        "cx": 8.7,
        "cy": 14.1,
        "r": 0.8,
        "fill": "#e66926"
      },
      {
        "type": "circle",
        "cx": 13.5,
        "cy": 14.1,
        "r": 1.35,
        "fill": "truck"
      },
      {
        "type": "circle",
        "cx": 13.5,
        "cy": 14.1,
        "r": 0.8,
        "fill": "#e66926"
      }
    ],
    "jhgj": [
      {
        "type": "polygon",
        "d": "M4.8 7.28L5.38 6.41L6.2 5.64L7.21 5.01L8.39 4.54L9.67 4.25L11 4.15L12.33 4.25L13.61 4.54L14.79 5.01L15.8 5.64L16.62 6.41L17.2 7.28L16.45 7.97L15.94 7.34L15.22 6.78L14.33 6.32L13.3 5.98L12.17 5.77L11 5.7L9.83 5.77L8.7 5.98L7.67 6.32L6.78 6.78L6.06 7.34L5.55 7.97Z",
        "fill": "#78cc1d"
      },
      {
        "type": "line",
        "d": "M6.25 8.35L5.62 12.31L5.47 12.84L5.2 13.3L4.85 13.64L4.46 13.83L4.08 13.83L3.75 13.64L3.51 13.3L3.39 12.84L3.41 12.31M7.69 8.35L6.81 13.85M10.58 8.35L9.7 13.85M7.25 11.1L10.14 11.1M14.79 9.06L14.33 8.53L13.73 8.35L13.08 8.54L12.45 9.08L11.94 9.9L11.62 10.87L11.52 11.88L11.67 12.78L12.04 13.46L12.58 13.81L13.22 13.8L13.87 13.42L14.44 12.72L14.86 11.81L14.9 11.38L13.55 11.38M18.84 8.35L18.21 12.31L18.06 12.84L17.79 13.3L17.44 13.64L17.05 13.83L16.67 13.83L16.34 13.64L16.1 13.3L15.98 12.84L16 12.31",
        "stroke": "accent",
        "strokeWidth": 1.5
      }
    ],
    "ktd": [
      {
        "type": "circle",
        "cx": 11,
        "cy": 9.5,
        "r": 5.5,
        "fill": "accent"
      },
      {
        "type": "polygon",
        "d": "M13.22 6.06L12.04 5.68L10.79 5.62L9.58 5.89L8.5 6.46L7.65 7.3L7.1 8.31L6.9 9.43L7.06 10.56L7.57 11.59L8.39 12.45L9.44 13.06L10.64 13.37L11.89 13.35L13.08 13.01L13.38 12.12L12.5 12.29L11.6 12.24L10.74 11.98L10.01 11.51L9.43 10.89L9.07 10.15L8.95 9.35L9.07 8.55L9.43 7.81L10.01 7.19L10.74 6.72L11.6 6.46L12.5 6.41L13.38 6.58Z",
        "fill": "truck"
      },
      {
        "type": "polygon",
        "d": "M11.3 7.7L12.75 7.7L11.85 12.3L10.4 12.3Z",
        "fill": "truck"
      },
      {
        "type": "polygon",
        "d": "M12.6 10.1L16.2 7.4L14.9 10.6L12.4 11.6Z",
        "fill": "truck"
      }
    ],
    "swiftx": [
      {
        "type": "polygon",
        "d": "M8.4 8L10.19 7.46L11.96 6.89L13.72 6.27L15.46 5.62L17.19 4.93L18.9 4.2L17.2 6.95L15.77 7.2L14.33 7.42L12.87 7.62L11.4 7.77L9.91 7.9Z",
        "fill": "accent"
      },
      {
        "type": "polygon",
        "d": "M5.6 11L7.64 10.58L9.66 10.12L11.67 9.62L13.66 9.09L15.64 8.51L17.6 7.9L15.9 10.65L14.22 10.79L12.53 10.89L10.82 10.96L9.1 11.01L7.36 11.02Z",
        "fill": "accent"
      },
      {
        "type": "polygon",
        "d": "M3.2 13.9L5.42 13.6L7.63 13.26L9.82 12.88L12 12.46L14.16 12L16.3 11.5L14.6 14.25L12.74 14.27L10.86 14.26L8.97 14.21L7.06 14.14L5.14 14.04Z",
        "fill": "accent"
      }
    ],
    "celeritas": [
      {
        "type": "polygon",
        "d": "M15.6 10.48L15.69 9.21L15.44 7.97L14.87 6.84L14.02 5.9L12.95 5.22L11.74 4.86L10.47 4.83L9.24 5.14L9.88 6.72L10.66 6.52L11.47 6.54L12.24 6.77L12.93 7.2L13.47 7.8L13.84 8.52L13.99 9.32L13.93 10.12Z",
        "fill": "accent"
      },
      {
        "type": "polygon",
        "d": "M7.65 7.22L8.66 4.42L10.62 7.33Z",
        "fill": "accent"
      },
      {
        "type": "polygon",
        "d": "M6.4 8.52L6.31 9.79L6.56 11.03L7.13 12.16L7.98 13.1L9.05 13.78L10.26 14.14L11.53 14.17L12.76 13.86L12.12 12.28L11.34 12.48L10.53 12.46L9.76 12.23L9.07 11.8L8.53 11.2L8.16 10.48L8.01 9.68L8.07 8.88Z",
        "fill": "accent"
      },
      {
        "type": "polygon",
        "d": "M14.35 11.78L13.34 14.58L11.38 11.67Z",
        "fill": "accent"
      }
    ],
    "asyad-express": [
      {
        "type": "line",
        "d": "M5.6 4.9L10.6 10L10.6 15.2",
        "stroke": "accent",
        "strokeWidth": 2.2
      },
      {
        "type": "circle",
        "cx": 15.2,
        "cy": 6.1,
        "r": 2.1,
        "fill": "#00baeb"
      }
    ],
    "border-express": [
      {
        "type": "polygon",
        "d": "M3.6 4.2L7.8 4.2L8.9 9.5Z",
        "fill": "accent"
      },
      {
        "type": "polygon",
        "d": "M7.8 4.2L13.1 9.5L8.9 9.5Z",
        "fill": "#1c252c"
      },
      {
        "type": "polygon",
        "d": "M8.9 9.5L13.1 9.5L14.2 14.8Z",
        "fill": "accent"
      },
      {
        "type": "polygon",
        "d": "M13.1 9.5L18.4 14.8L14.2 14.8Z",
        "fill": "#1c252c"
      },
      {
        "type": "polygon",
        "d": "M14.2 4.2L18.4 4.2L7.8 14.8L3.6 14.8Z",
        "fill": "accent"
      }
    ],
    "bosta": [
      {
        "type": "line",
        "d": "M11 4.2L6.41 6.85L6.41 12.15L11 14.8L15.59 12.15L15.59 6.85L11 4.2",
        "stroke": "accent",
        "strokeWidth": 1.5
      },
      {
        "type": "line",
        "d": "M6.41 6.85L10.1 9.4L11 9.85L11.9 9.4L15.59 6.85M6.41 12.15L8.9 10.05M15.59 12.15L13.1 10.05",
        "stroke": "accent",
        "strokeWidth": 1.4
      }
    ],
    "correo-uruguayo": [
      {
        "type": "polygon",
        "d": "M13.6 10L13.47 9.2L13.1 8.47L12.53 7.9L11.8 7.53L11 7.4L10.2 7.53L9.47 7.9L8.9 8.47L8.53 9.2L8.4 10Z",
        "fill": "#fad000"
      },
      {
        "type": "polygon",
        "d": "M14.2 9.83L16.28 8.88L13.99 8.85Z",
        "fill": "#fad000"
      },
      {
        "type": "polygon",
        "d": "M13.56 8.07L14.75 6.12L12.84 7.38Z",
        "fill": "#fad000"
      },
      {
        "type": "polygon",
        "d": "M11.5 6.84L11 4.6L10.5 6.84Z",
        "fill": "#fad000"
      },
      {
        "type": "polygon",
        "d": "M9.16 7.38L7.25 6.12L8.44 8.07Z",
        "fill": "#fad000"
      },
      {
        "type": "polygon",
        "d": "M8.01 8.85L5.72 8.88L7.8 9.83Z",
        "fill": "#fad000"
      },
      {
        "type": "line",
        "d": "M3.6 11.5L4.83 11.32L6.07 11.15L7.3 11.01L8.53 10.89L9.77 10.82L11 10.8L12.23 10.82L13.47 10.89L14.7 11.01L15.93 11.15L17.17 11.32L18.4 11.5M5 13.9L6 13.72L7 13.55L8 13.41L9 13.29L10 13.22L11 13.2L12 13.22L13 13.29L14 13.41L15 13.55L16 13.72L17 13.9",
        "stroke": "accent",
        "strokeWidth": 1.4
      }
    ],
    "courier-it": [
      {
        "type": "polygon",
        "d": "M3.6 5L5.4 4.4L7.6 4.7L9.6 5.6L11.2 6.8L11 7.4L9.4 6.9L7.6 6.9L6.8 7.7L6.9 9L8 10.9L9.6 12.9L11 14.9L8.6 13.6L6.4 11.6L4.6 9.4L3.6 7.2Z",
        "fill": "accent"
      },
      {
        "type": "polygon",
        "d": "M18.6 5.2L18.5 7L17.2 9.4L15 11.6L11.6 14.9L13 12.6L14.6 10.2L15.2 8.7L14.6 7.9L12.4 7.6L12.6 6.6L14.4 5.6L16.6 5.1Z",
        "fill": "accent"
      }
    ],
    "daylight-transport": [
      {
        "type": "polygon",
        "d": "M13.92 13.33L18.98 13.24L18.5 11.03Z",
        "fill": "#fdb827"
      },
      {
        "type": "polygon",
        "d": "M13.35 12.13L17.88 9.66L16.54 7.89Z",
        "fill": "#fdb827"
      },
      {
        "type": "polygon",
        "d": "M12.3 11.3L15.41 6.94L13.48 5.96Z",
        "fill": "#fdb827"
      },
      {
        "type": "polygon",
        "d": "M11 11L12.08 5.62L9.92 5.62Z",
        "fill": "#fdb827"
      },
      {
        "type": "polygon",
        "d": "M9.7 11.3L8.52 5.96L6.59 6.94Z",
        "fill": "#fdb827"
      },
      {
        "type": "polygon",
        "d": "M8.65 12.13L5.46 7.89L4.12 9.66Z",
        "fill": "#fdb827"
      },
      {
        "type": "polygon",
        "d": "M8.08 13.33L3.5 11.03L3.02 13.24Z",
        "fill": "#fdb827"
      }
    ],
    "deprisa": [
      {
        "type": "polygon",
        "d": "M11 3.9L18.6 15L3.4 15Z",
        "fill": "accent"
      },
      {
        "type": "polygon",
        "d": "M11 6.55L16.35 14.3L5.65 14.3Z",
        "fill": "#c2222c"
      },
      {
        "type": "polygon",
        "d": "M5.6 14L9.6 14L13.4 12.7L16.9 9.9L14.6 10.2L12 11.3L8.4 12.4Z",
        "fill": "accent"
      }
    ],
    "envia-colombia": [
      {
        "type": "line",
        "d": "M4.4 9.6L12.6 9.6L12.32 8.37L11.52 7.29L10.3 6.48L8.8 6.05L7.2 6.05L5.7 6.48L4.48 7.29L3.68 8.37L3.4 9.44L3.56 10.53L4.12 11.53L5.04 12.36L6.24 12.93L7.6 13.19L9 13.11L10.3 12.72",
        "stroke": "accent",
        "strokeWidth": 1.8
      },
      {
        "type": "polygon",
        "d": "M9.5 12.4L13 11.3L15.8 9.3L18.6 6L18 9L15.8 11.9L12.8 13.7L10 14Z",
        "fill": "accent"
      }
    ],
    "europochta": [
      {
        "type": "line",
        "d": "M3.9 7.4L11 3.9L18.1 7.4",
        "stroke": "accent",
        "strokeWidth": 1.6
      },
      {
        "type": "polygon",
        "d": "M3.4 7.9L10.3 11.4L10.3 15.3L3.4 11.8Z",
        "fill": "#ed2024"
      },
      {
        "type": "polygon",
        "d": "M5.47 9.93L10.3 12.38L10.3 13.04L5.47 10.59Z",
        "fill": "truck"
      },
      {
        "type": "polygon",
        "d": "M5.47 11.21L10.3 13.66L10.3 14.33L5.47 11.88Z",
        "fill": "truck"
      },
      {
        "type": "polygon",
        "d": "M11.7 11.4L18.6 7.9L18.6 11.8L11.7 15.3Z",
        "fill": "accent"
      },
      {
        "type": "polygon",
        "d": "M13.91 11.33L16.39 10.07L16.39 12.92L13.91 14.18Z",
        "fill": "truck"
      }
    ],
    "midland-transport": [
      {
        "type": "polygon",
        "d": "M5.4 14.7L5.4 4.3L8.8 4.3L11 10.4L13.2 4.3L16.6 4.3L16.6 14.7L14.3 14.7L14.3 8L12.1 13.9L9.9 13.9L7.7 8L7.7 14.7Z",
        "fill": "accent"
      }
    ],
    "oak-harbor": [
      {
        "type": "polygon",
        "d": "M6.6 3.9L6.34 5.48L6.34 6.84L6.48 8.1L6.74 9.25L7.15 10.29L7.71 11.21L8.43 12L9.31 12.67L10.34 13.2L11.54 13.61L12.9 13.89L14.6 13.9L14.96 12.24L14.99 10.85L14.86 9.6L14.56 8.47L14.1 7.46L13.49 6.59L12.72 5.84L11.79 5.21L10.72 4.7L9.53 4.29L8.2 3.99Z",
        "fill": "#fdbf38"
      },
      {
        "type": "line",
        "d": "M14.6 13.9L15.54 14.92",
        "stroke": "#fdbf38",
        "strokeWidth": 1.4
      },
      {
        "type": "line",
        "d": "M8.36 6.1L14.6 13.9",
        "stroke": "truck",
        "strokeWidth": 1.2
      }
    ],
    "skroutz-last-mile": [
      {
        "type": "polygon",
        "d": "M4.3 7.5L4.6 8.22L5.1 8.89L6.3 10.2L7.4 11.64L8.55 11.46L9.7 11.41L10.85 11.5L12.35 11.91L13.55 12.18L15.25 12.27L16.35 12.27L17.3 11.96L17.75 10.92L17.45 10.02L16.45 9.66L14.9 10.18L14.25 10.58L13.85 8.18L13.95 5.03L13.6 4.21L12.85 3.94L10.8 4.08L7.85 4.67L5.6 5.56L4.5 6.6Z",
        "fill": "accent"
      },
      {
        "type": "polygon",
        "d": "M5.7 7.68L6.05 7.19L6.8 6.83L7.6 7.01L10 11.46L8.65 11.48Z",
        "fill": "truck"
      },
      {
        "type": "polygon",
        "d": "M13.05 13.53L11.55 13.67L10.15 14.43L8.6 15.29L7.05 15.51L5.6 15.24L5.2 14.52L5.6 13.89L6.8 13.31L8.55 12.99L11.1 13.17Z",
        "fill": "accent"
      }
    ],
    "tci-express": [
      {
        "type": "line",
        "d": "M5.43 5L9.35 5M7.39 5L6.36 13.6M15.36 6.1L14.69 5.26L13.83 5L12.92 5.37L12.07 6.31L11.42 7.69L11.05 9.3L11.03 10.91L11.35 12.29L11.97 13.23L12.8 13.6L13.72 13.34L14.59 12.5M17.83 5L16.8 13.6",
        "stroke": "accent",
        "strokeWidth": 2
      }
    ],
    "urbano": [
      {
        "type": "line",
        "d": "M8.88 7.6L8.12 11.4L8.13 12.39L8.54 13.24L9.31 13.8L10.3 14L11.37 13.8L12.36 13.24L13.12 12.39L13.52 11.4L14.28 7.6M14.28 7.6L13 14",
        "stroke": "accent",
        "strokeWidth": 2
      },
      {
        "type": "line",
        "d": "M9.82 3.9L9.48 5.6",
        "stroke": "accent",
        "strokeWidth": 1.6
      },
      {
        "type": "line",
        "d": "M14.82 3.9L14.48 5.6",
        "stroke": "accent",
        "strokeWidth": 1.6
      }
    ],
    "vrl-logistics": [
      {
        "type": "line",
        "d": "M5.4 5.4L7 13.4L8.6 5.4M9.9 13.4L9.9 5.4L11 5.4L11.6 5.52L12.12 5.88L12.52 6.43L12.72 7.09L12.72 7.81L12.52 8.47L12.12 9.02L11.6 9.38L11 9.5L9.9 9.5M11.1 9.5L12.9 13.4M14.3 5.4L14.3 13.4L15.6 13.4",
        "stroke": "#1a1a1a",
        "strokeWidth": 1.6
      },
      {
        "type": "polygon",
        "d": "M3 5.4L5.9 3.7L5.9 7.1Z",
        "fill": "#1a1a1a"
      },
      {
        "type": "polygon",
        "d": "M19 13.4L15.4 11.6L15.4 15.2Z",
        "fill": "#1a1a1a"
      }
    ],
    "blueex": [
      {
        "type": "polygon",
        "d": "M6.7 14.34L15.4 14.34L15.4 9.28L13.24 8.1L12.03 8.81L13.96 9.88L13.96 12.97L12.11 12.97L12.11 10.02L11.32 9.57L10.53 10.02L10.53 12.97L8.67 12.97L8.67 9.57L15.4 5.6L15.4 4.06L6.7 8.92Z",
        "fill": "accent"
      },
      {
        "type": "polygon",
        "d": "M6.7 4.06L9.91 5.86L8.64 6.58L6.7 5.5Z",
        "fill": "accent"
      }
    ],
    "leopards-courier": [
      {
        "type": "polygon",
        "d": "M19 7L18.5 7.7L17.4 8.2L16.7 9.1L17.7 10.3L18.8 11.7L18.9 12.6L17.6 12.6L16.4 11.2L15 10.2L12.4 10.3L9.6 10.2L8.4 10.6L6.2 12.2L4.3 13.4L3.1 13.6L3.3 12.5L5 11.2L6.1 9.6L6.4 8L7.6 7.2L10.6 6.8L13.6 6.5L15.6 6L16.5 5.6L16.8 4.9L17.4 5.2L18.3 5.5L19 6.2Z",
        "fill": "#1a1a1a"
      },
      {
        "type": "line",
        "d": "M6.9 7.6L5.6 7.2L4.6 6.5L3.9 5.5L3.7 4.4",
        "stroke": "#1a1a1a",
        "strokeWidth": 1.3
      }
    ],
    "tcs-pakistan": [
      {
        "type": "polygon",
        "d": "M4.86 4L13.4 4L16.32 9.3L15.16 10.84L12.39 5.8L3.56 5.8Z",
        "fill": "accent"
      },
      {
        "type": "polygon",
        "d": "M9.69 6.8L11.69 6.8L13.95 10.9L12.79 12.44Z",
        "fill": "accent"
      },
      {
        "type": "polygon",
        "d": "M6.44 6.8L8.44 6.8L11.58 12.5L10.42 14.04Z",
        "fill": "accent"
      }
    ],
    "postex": [
      {
        "type": "line",
        "d": "M8.2 14.3L8.2 5.15L10.7 5.15L11.53 5.28L12.29 5.67L12.88 6.26L13.27 7.02L13.4 7.85L13.27 8.68L12.88 9.44L12.29 10.03L11.53 10.42L10.7 10.55L8.2 10.55",
        "stroke": "#111111",
        "strokeWidth": 2.3
      },
      {
        "type": "circle",
        "cx": 15.4,
        "cy": 13.1,
        "r": 1.4,
        "fill": "#111111"
      }
    ],
    "slgtrax": [
      {
        "type": "line",
        "d": "M3.7 6.6L6.53 6.6M5.11 6.6L5.11 12.4M7.56 12.4L7.56 6.6L8.88 6.6L9.3 6.69L9.67 6.95L9.94 7.35L10.09 7.85L10.09 8.37L9.94 8.86L9.67 9.26L9.3 9.53L8.88 9.62L7.56 9.62M8.79 9.62L10.29 12.4M11.24 12.4L12.41 6.6L13.26 6.6L14.44 12.4M11.8 10.31L13.87 10.31M15.47 6.6L18.3 12.4M18.3 6.6L15.47 12.4",
        "stroke": "accent",
        "strokeWidth": 1.6
      }
    ],
    "m-and-p": [
      {
        "type": "polygon",
        "d": "M3.6 13.6L3.6 5L5.55 5L6.5 9.6L7.45 5L9.4 5L9.4 13.6L7.65 13.6L7.65 8.4L7 12L6 12L5.35 8.4L5.35 13.6Z",
        "fill": "accent"
      },
      {
        "type": "polygon",
        "d": "M13.9 13.6L13.9 5L15.9 5L16.88 5.19L17.7 5.75L18.26 6.57L18.45 7.55L18.26 8.53L17.7 9.35L16.88 9.91L15.9 10.1L15.65 10.1L15.65 13.6Z",
        "fill": "accent"
      },
      {
        "type": "polygon",
        "d": "M15.65 6.45L15.8 6.45L16.35 6.6L16.75 7L16.9 7.55L16.75 8.1L16.35 8.5L15.8 8.65L15.65 8.65Z",
        "fill": "truck"
      },
      {
        "type": "line",
        "d": "M13.39 12.6L10.47 9.35L10.39 8.74L10.31 8.31L10.35 7.87L10.51 7.47L10.77 7.18L11.09 7.02L11.43 7.02L11.75 7.18L12.01 7.47L12.17 7.87L12.21 8.31L12.13 8.74L11.93 9.1L10.7 9.8L10.09 10.82L10.03 11.31L10.13 11.79L10.38 12.2L10.75 12.48L11.19 12.6L11.63 12.54L12.03 12.3L12.32 11.93L13.27 10.08",
        "stroke": "accent",
        "strokeWidth": 1.4
      }
    ],
    "pakistan-post": [
      {
        "type": "polygon",
        "d": "M3.9 12.5L11.82 4.85L12.12 4.54L12.54 4.4L12.97 4.48L13.31 4.75L13.49 5.14L14.8 7.7L16.31 5.2L16.62 4.89L17.06 4.8L17.47 4.95L17.74 5.3L17.79 5.74L18.2 8.5Z",
        "fill": "accent"
      },
      {
        "type": "polygon",
        "d": "M9.9 14.8L15 10.4L15.7 10.6L16.1 12.8L15.6 13.4Z",
        "fill": "accent"
      }
    ],
    "pathao-courier": [
      {
        "type": "circle",
        "cx": 12.4,
        "cy": 8.4,
        "r": 4.3,
        "fill": "accent"
      },
      {
        "type": "polygon",
        "d": "M8.3 7.9L10.5 7.9L9.45 14L7.25 14Z",
        "fill": "accent"
      },
      {
        "type": "circle",
        "cx": 12.4,
        "cy": 8.4,
        "r": 2,
        "fill": "truck"
      }
    ],
    "redx": [
      {
        "type": "polygon",
        "d": "M11.99 9.21L9.2 14.28L5.56 14.28L8.37 9.2L5.57 4.12L9.2 4.12L12 9.2Z",
        "fill": "accent"
      },
      {
        "type": "polygon",
        "d": "M13.27 9.2L11.64 6.24L12.8 4.12L16.44 4.12L13.64 9.2L16.44 14.28L12.81 14.28L11.64 12.16Z",
        "fill": "accent"
      }
    ],
    "steadfast": [
      {
        "type": "polygon",
        "d": "M8.4 11.22L8.4 5.3L9.18 5.35L9.96 5.48L10.71 5.71L11.43 6.02L12.11 6.42L12.73 6.89Z",
        "fill": "accent"
      },
      {
        "type": "polygon",
        "d": "M9.18 12L15.1 12L15.05 11.22L14.92 10.44L14.69 9.69L14.38 8.97L13.98 8.29L13.51 7.67Z",
        "fill": "accent"
      },
      {
        "type": "polygon",
        "d": "M9 4L9.34 4.31L10.25 4.47L11.12 4.74L11.96 5.12L12.75 5.59L13.48 6.14L15.62 4Z",
        "fill": "#2a292b"
      },
      {
        "type": "polygon",
        "d": "M16.4 11.4L16.09 11.06L15.93 10.15L15.66 9.28L15.28 8.44L14.81 7.65L14.26 6.92L16.4 4.78Z",
        "fill": "#2a292b"
      },
      {
        "type": "polygon",
        "d": "M6.3 12.2L8.4 12.2L8.4 14.1Z",
        "fill": "accent"
      }
    ],
    "sundarban-courier": [
      {
        "type": "polygon",
        "d": "M3 7L3.5 7.7L4.6 8.2L5.3 9.1L4.3 10.3L3.2 11.7L3.1 12.6L4.4 12.6L5.6 11.2L7 10.2L9.6 10.3L12.4 10.2L13.6 10.6L15.8 12.2L17.7 13.4L18.9 13.6L18.7 12.5L17 11.2L15.9 9.6L15.6 8L14.4 7.2L11.4 6.8L8.4 6.5L6.4 6L5.5 5.6L5.2 4.9L4.6 5.2L3.7 5.5L3 6.2Z",
        "fill": "#ffbf00"
      },
      {
        "type": "line",
        "d": "M15.1 7.6L16.4 7L17.6 6.6L18.6 6",
        "stroke": "#ffbf00",
        "strokeWidth": 1.3
      },
      {
        "type": "line",
        "d": "M8.6 6.2L8 8.4M11.2 6.5L10.6 9M13.6 6.8L13.1 9.2",
        "stroke": "truck",
        "strokeWidth": 1.2
      }
    ],
    "paperfly": [
      {
        "type": "polygon",
        "d": "M3.41 5.24L18.59 5.24L6.65 8.2Z",
        "fill": "accent"
      },
      {
        "type": "polygon",
        "d": "M6.65 9.32L4.91 13.2L7.7 11.36L8.66 13.76L18.59 5.24Z",
        "fill": "#17479d"
      }
    ],
    "ecourier": [
      {
        "type": "line",
        "d": "M6.4 9.4L14.4 9.4L14.18 8.09L13.55 6.93L12.57 6.04L11.35 5.51L10.03 5.42L8.75 5.76L7.65 6.5L6.85 7.55L6.44 8.81L6.47 10.14L6.93 11.38L7.76 12.41L8.89 13.1L10.18 13.39L11.5 13.25L12.69 12.68",
        "stroke": "accent",
        "strokeWidth": 2.1
      },
      {
        "type": "circle",
        "cx": 14.38,
        "cy": 11.7,
        "r": 1.35,
        "fill": "#fff242"
      }
    ],
    "bangladesh-post": [
      {
        "type": "line",
        "d": "M3.2 9L18.6 9",
        "stroke": "accent",
        "strokeWidth": 1.2
      },
      {
        "type": "polygon",
        "d": "M2.6 9L4.6 8L4.6 10Z",
        "fill": "accent"
      },
      {
        "type": "polygon",
        "d": "M9.4 6.6L10.6 5.9L12.4 6.2L13.6 7.4L13.9 9.4L13 10.6L14.6 11.6L16.6 12L16.8 13.4L14.2 13.1L12 12L10.6 12.6L10.1 14.2L8.7 14.2L8.9 12L10.4 10.4L10.2 9.6L9 9.8L8.8 8.4L9.6 8.2Z",
        "fill": "accent"
      },
      {
        "type": "circle",
        "cx": 13,
        "cy": 7,
        "r": 1.55,
        "fill": "accent"
      },
      {
        "type": "circle",
        "cx": 9.4,
        "cy": 5.2,
        "r": 1.1,
        "fill": "accent"
      }
    ],
    "sri-lanka-post": [
      {
        "type": "line",
        "d": "M3.05 7.9L8.45 7.7L11.85 7.1L14.45 5.7M3.85 10.3L9.05 10.1L12.25 9.5L14.45 8.5M4.65 12.7L9.65 12.4L12.45 11.8L14.05 11.2",
        "stroke": "accent",
        "strokeWidth": 1.4
      },
      {
        "type": "polygon",
        "d": "M12.95 12.4L13.15 10.3L13.45 8.1L13.95 6.1L14.45 5L15.15 4.4L16.05 4.3L16.75 4.7L18.25 5.1L16.95 5.8L17.15 7.3L16.85 9L16.05 10.6L14.85 11.8Z",
        "fill": "accent"
      },
      {
        "type": "polygon",
        "d": "M17.95 4.3L19.35 4.1L19.5 5.6L18.1 5.8Z",
        "fill": "accent"
      }
    ],
    "domex": [
      {
        "type": "polygon",
        "d": "M7 4L11.4 4L12.4 4.1L13.34 4.4L14.2 4.89L14.92 5.54L15.48 6.31L15.84 7.19L16 8.11L15.93 9.05L15.9 9.4L6.6 9.4Z",
        "fill": "#7a1b28"
      },
      {
        "type": "polygon",
        "d": "M9.2 5.8L11.3 5.8L12.04 5.93L12.71 6.3L13.24 6.87L13.58 7.6L13.7 8.4L13.7 9.4L8.9 9.4Z",
        "fill": "truck"
      },
      {
        "type": "polygon",
        "d": "M4.4 10.4L15.6 10.4L15 11.8L4.2 11.8Z",
        "fill": "#7a1b28"
      },
      {
        "type": "polygon",
        "d": "M3.4 12.8L14.2 12.8L13 14.2L3.2 14.2Z",
        "fill": "#7a1b28"
      }
    ],
    "akash-ganga": [
      {
        "type": "polygon",
        "d": "M3.9 12.6L6.82 6.2L8.42 6.2L9.3 12.6L7.7 12.6L7.24 8.6L5.5 12.6Z",
        "fill": "accent"
      },
      {
        "type": "line",
        "d": "M13.4 7.02L12.93 6.41L12.31 6.2L11.62 6.43L10.96 7.05L10.42 8L10.06 9.14L9.94 10.31L10.07 11.36L10.44 12.14L11 12.55L11.66 12.54L12.35 12.1L12.96 11.29L13.42 10.23L13.46 9.72L12.06 9.72M17.9 7.02L17.41 6.39L16.76 6.2L16.05 6.48L15.37 7.18L14.83 8.2L14.51 9.4L14.45 10.6L14.66 11.62L15.11 12.32L15.74 12.6L16.45 12.41L17.14 11.78",
        "stroke": "accent",
        "strokeWidth": 1.6
      },
      {
        "type": "polygon",
        "d": "M3.6 12.2L5.6 10.9L8 10L10.4 9.6L11.6 9.7L9.8 10.5L7.6 11.3L5.4 12.2L3.9 12.8Z",
        "fill": "#e77817"
      }
    ],
    "madhur-courier": [
      {
        "type": "circle",
        "cx": 11,
        "cy": 9.5,
        "r": 5.55,
        "fill": "accent"
      },
      {
        "type": "circle",
        "cx": 11,
        "cy": 9.5,
        "r": 4.15,
        "fill": "truck"
      },
      {
        "type": "polygon",
        "d": "M9.45 6.1L11 8.3L10.15 8.3L10.15 12.6L8.75 12.6L8.75 8.3L7.9 8.3Z",
        "fill": "accent"
      },
      {
        "type": "polygon",
        "d": "M12.55 12.9L14.1 10.7L13.25 10.7L13.25 6.4L11.85 6.4L11.85 10.7L11 10.7Z",
        "fill": "accent"
      }
    ],
    "shree-nandan": [
      {
        "type": "polygon",
        "d": "M6.2 14.8L6.2 4.2L8.6 4.2L13.4 10.6L13.4 4.2L15.8 4.2L15.8 14.8L13.4 14.8L8.6 8.4L8.6 14.8Z",
        "fill": "accent"
      },
      {
        "type": "polygon",
        "d": "M18.4 9.5L18.26 10.09L17.84 10.65L17.15 11.17L16.23 11.62L15.11 11.99L13.83 12.27L12.44 12.44L11 12.5L9.56 12.44L8.17 12.27L6.89 11.99L5.77 11.62L4.85 11.17L4.16 10.65L3.74 10.09L3.6 9.5L3.74 8.91L4.16 8.35L4.85 7.83L5.77 7.38L6.89 7.01L8.17 6.73L9.56 6.56L11 6.5L12.44 6.56L13.83 6.73L15.11 7.01L16.23 7.38L17.15 7.83L17.84 8.35L18.26 8.91Z",
        "fill": "truck"
      },
      {
        "type": "polygon",
        "d": "M17.4 9.5L17.28 9.89L16.91 10.27L16.32 10.61L15.53 10.91L14.56 11.16L13.45 11.35L12.25 11.46L11 11.5L9.75 11.46L8.55 11.35L7.44 11.16L6.47 10.91L5.68 10.61L5.09 10.27L4.72 9.89L4.6 9.5L4.72 9.11L5.09 8.73L5.68 8.39L6.47 8.09L7.44 7.84L8.55 7.65L9.75 7.54L11 7.5L12.25 7.54L13.45 7.65L14.56 7.84L15.53 8.09L16.32 8.39L16.91 8.73L17.28 9.11Z",
        "fill": "accent"
      }
    ],
    "st-courier": [
      {
        "type": "line",
        "d": "M9.58 6.44L9.05 5.77L8.29 5.34L7.4 5.2L6.53 5.39L5.79 5.87L5.31 6.57L5.15 7.38L5.34 8.2L5.85 8.88L6.59 9.34L7.47 9.5L8.35 9.66L9.1 10.12L9.61 10.8L9.8 11.62L9.64 12.43L9.15 13.13L8.42 13.61L7.55 13.8L6.66 13.66L5.9 13.23L5.37 12.56M11.69 5.2L16.85 5.2M14.27 5.2L14.27 13.8",
        "stroke": "accent",
        "strokeWidth": 2
      }
    ],
    "tirupati-courier": [
      {
        "type": "line",
        "d": "M4.57 5.6L8.23 5.6M6.4 5.6L5.03 13.2M12.95 6.58L12.37 5.83L11.58 5.6L10.7 5.93L9.87 6.76L9.19 7.98L8.77 9.4L8.68 10.82L8.92 12.04L9.45 12.87L10.21 13.2L11.08 12.97L11.94 12.22M17.42 6.7L17.15 6.1L16.67 5.72L16.07 5.6L15.41 5.77L14.82 6.19L14.36 6.81L14.12 7.53L14.12 8.25L14.37 8.85L14.83 9.26L15.43 9.4L16.03 9.54L16.49 9.95L16.74 10.55L16.75 11.27L16.5 11.99L16.05 12.61L15.45 13.03L14.8 13.2L14.19 13.08L13.72 12.7L13.45 12.1",
        "stroke": "#1a1a1a",
        "strokeWidth": 1.8
      }
    ],
    "prompt-xpress": [
      {
        "type": "line",
        "d": "M6.62 5L9.98 13.4M11.66 5L4.94 13.4M11.32 13.4L13 5L15.36 5L16.08 5.13L16.66 5.51L17.03 6.09L17.15 6.8L16.99 7.56L16.59 8.28L15.99 8.86L15.26 9.24L14.48 9.37L12.13 9.37",
        "stroke": "accent",
        "strokeWidth": 2
      }
    ],
    "pronto-lanka": [
      {
        "type": "circle",
        "cx": 11,
        "cy": 9.5,
        "r": 5.4,
        "fill": "accent"
      },
      {
        "type": "line",
        "d": "M11 4L11 15M5.5 9.5L16.5 9.5",
        "stroke": "truck",
        "strokeWidth": 1
      },
      {
        "type": "line",
        "d": "M6.4 5.93L7.14 6.47L8 6.91L8.95 7.23L9.96 7.43L11 7.5L12.04 7.43L13.05 7.23L14 6.91L14.86 6.47L15.6 5.93M15.6 13.07L14.86 12.53L14 12.09L13.05 11.77L12.04 11.57L11 11.5L9.96 11.57L8.95 11.77L8 12.09L7.14 12.53L6.4 13.07",
        "stroke": "truck",
        "strokeWidth": 1
      }
    ],
    "nepal-post": [
      {
        "type": "line",
        "d": "M6.21 5.78L14.6 11.5M15.79 5.78L7.4 11.5",
        "stroke": "#1a1a1a",
        "strokeWidth": 1.2
      },
      {
        "type": "polygon",
        "d": "M3.9 4.2L4.54 5.39L5.2 6.03L6.07 6.16L6.52 5.5L6.07 4.74L5.24 4.36Z",
        "fill": "#1a1a1a"
      },
      {
        "type": "polygon",
        "d": "M18.1 4.2L16.76 4.36L15.93 4.74L15.48 5.5L15.93 6.16L16.8 6.03L17.46 5.39Z",
        "fill": "#1a1a1a"
      },
      {
        "type": "polygon",
        "d": "M5.4 12.6L6 10L8.6 8.9L11 9.2L14 8.9L16 7.6L17.2 6.2L19 6.6L19.2 12.6L16 12.9L11.4 14.6L8.6 15.5L6 14.6Z",
        "fill": "truck"
      },
      {
        "type": "line",
        "d": "M10.6 12.1L10.55 11.65L10.4 11.23L10.16 10.85L9.85 10.54L9.47 10.3L9.05 10.15L8.6 10.1L8.15 10.15L7.73 10.3L7.35 10.54L7.04 10.85L6.8 11.23L6.65 11.65L6.6 12.1L6.65 12.55L6.8 12.97L7.04 13.35L7.35 13.66L7.73 13.9L8.15 14.05L8.6 14.1L9.05 14.05L9.47 13.9L9.85 13.66L10.16 13.35L10.4 12.97L10.55 12.55L10.6 12.1",
        "stroke": "#1a1a1a",
        "strokeWidth": 1.45
      },
      {
        "type": "polygon",
        "d": "M10.3 10.6L12.4 10.2L14.2 10.1L15.5 9.6L16.6 8.7L17.4 7.6L18.4 11.6L17.1 11.7L15.7 11.5L14.4 11.3L12.6 11.6L10.6 12.6Z",
        "fill": "#1a1a1a"
      }
    ],
    "idexpress": [
      {
        "type": "polygon",
        "d": "M10.48 4.8L13.84 4.78L15.06 4.94L16.2 5.41L17.17 6.16L17.92 7.14L18.39 8.28L18.55 9.5L18.39 10.72L17.92 11.86L17.17 12.84L16.2 13.59L15.06 14.06L13.84 14.22L7.95 14.23L9.03 10.18L7.68 10.18L6.59 14.23L3.54 14.23L4.98 8.86L12.52 8.86L12.17 10.18L11.84 11.49L13.02 11.49L13.79 11.34L14.45 10.91L14.89 10.27L15.04 9.51L14.89 8.76L14.45 8.12L13.79 7.69L13.02 7.54L9.74 7.55Z",
        "fill": "accent"
      },
      {
        "type": "polygon",
        "d": "M8.54 5.19L8.79 5.67L8.79 6.25L8.55 6.85L8.11 7.38L7.54 7.74L6.91 7.9L6.33 7.82L5.89 7.52L5.64 7.04L5.64 6.45L5.88 5.85L6.32 5.33L6.89 4.96L7.52 4.8L8.1 4.88Z",
        "fill": "accent"
      }
    ],
    "lion-parcel": [
      {
        "type": "polygon",
        "d": "M9.86 7.57L10.9 6.36L12.14 5.77L13.66 6.05L15.04 6.81L16.14 7.5L15.86 8.46L14.35 8.71L15.66 9.22L15.38 9.98L14.97 10.33L15.31 11.15L15.04 12.12L12.76 11.15L11.24 11.02L10.48 9.43Z",
        "fill": "accent"
      },
      {
        "type": "line",
        "d": "M9.17 4.74L8.69 6.32L8.83 7.88L9.52 9.29L10.69 10.67M6.69 9.64L7.45 10.67L8.96 11.64L10.69 12.12M7.72 13.98L9.17 13.78L10.83 13.09",
        "stroke": "accent",
        "strokeWidth": 1.5
      },
      {
        "type": "circle",
        "cx": 12.41,
        "cy": 12.26,
        "r": 2.75,
        "fill": "truck"
      },
      {
        "type": "circle",
        "cx": 12.41,
        "cy": 12.26,
        "r": 1.95,
        "fill": "accent"
      }
    ],
    "sapx-express": [
      {
        "type": "polygon",
        "d": "M3.5 13.92L4.38 12.17L6.14 10.11L9.07 8.06L12 6.95L14.05 6.54L13.81 4.9L18.5 8.5L14.4 11.05L14.22 9.24L12 9.12L9.36 9.65L7.02 10.76L4.96 12.46L3.85 14.1Z",
        "fill": "#862880"
      }
    ],
    "tiki": [
      {
        "type": "line",
        "d": "M4.29 5.3L8.69 5.3M6.49 5.3L5.3 13.8M9.7 8.1L8.9 13.8M12.09 5.3L10.9 13.8M17.4 8.1L16.6 13.8",
        "stroke": "accent",
        "strokeWidth": 1.8
      },
      {
        "type": "line",
        "d": "M16.19 5.3L12.8 9.5L15.3 13.8",
        "stroke": "#ff0000",
        "strokeWidth": 1.9
      },
      {
        "type": "circle",
        "cx": 10.01,
        "cy": 5.9,
        "r": 1.05,
        "fill": "accent"
      },
      {
        "type": "circle",
        "cx": 17.71,
        "cy": 5.9,
        "r": 1.05,
        "fill": "accent"
      }
    ],
    "wahana": [
      {
        "type": "line",
        "d": "M5.84 8.2L6.34 13.7L6.83 13.85L10.25 9.55L10.72 9.7L10.96 13.7L11.44 13.86L17.36 6.6",
        "stroke": "accent",
        "strokeWidth": 1.9
      },
      {
        "type": "polygon",
        "d": "M3.85 10.45L4.39 9L5.13 7.69L6.04 6.55L7.1 5.63L8.27 4.95L9.52 4.54L10.8 4.4L12.08 4.54L13.33 4.95L14.5 5.63L13.52 6.95L12.65 6.54L11.75 6.29L10.82 6.2L9.89 6.28L8.99 6.52L8.12 6.93L7.32 7.48L6.59 8.17L5.95 8.98L5.43 9.9Z",
        "fill": "accent"
      }
    ],
    "line-clear": [
      {
        "type": "polygon",
        "d": "M11 4L12.1 4.6L15.33 9L15.76 9.76L15.97 10.58L15.97 11.42L15.76 12.24L15.33 13L14.72 13.68L13.94 14.24L13.03 14.65L12.04 14.91L11 15L9.96 14.91L8.97 14.65L8.06 14.24L7.28 13.68L6.67 13L6.24 12.24L6.03 11.42L6.03 10.58L6.24 9.76L6.67 9L9.9 4.6Z",
        "fill": "#1d3a8f"
      },
      {
        "type": "polygon",
        "d": "M7.2 8.2L12.8 8.2L15 10.2L15 12L7.2 12Z",
        "fill": "accent"
      },
      {
        "type": "polygon",
        "d": "M13.1 9L14.1 10.1L13.1 10.1Z",
        "fill": "#1d3a8f"
      },
      {
        "type": "circle",
        "cx": 9.1,
        "cy": 12.75,
        "r": 0.95,
        "fill": "accent"
      },
      {
        "type": "circle",
        "cx": 13.2,
        "cy": 12.75,
        "r": 0.95,
        "fill": "accent"
      }
    ],
    "2go": [
      {
        "type": "line",
        "d": "M4.1 7.24L4.38 6.68L4.81 6.25L5.33 6.03L5.9 6.03L6.42 6.25L6.85 6.68L7.13 7.24L7.23 7.89L6.99 8.94L4.27 12.64L4.45 13L7.23 13M12.02 6.9L11.35 6.23L10.57 6L9.79 6.25L9.12 6.93L8.64 7.97L8.43 9.21L8.52 10.49L8.88 11.64L9.47 12.5L10.21 12.95L11.01 12.93L11.74 12.45L12.32 11.57L12.66 10.41L12.62 9.85L10.94 9.85M15.79 6L14.94 6.27L14.22 7.03L13.74 8.16L13.57 9.5L13.74 10.84L14.22 11.97L14.94 12.73L15.79 13L16.63 12.73L17.35 11.97L17.83 10.84L18 9.5L17.83 8.16L17.35 7.03L16.63 6.27L15.79 6",
        "stroke": "accent",
        "strokeWidth": 1.9
      }
    ],
    "flash-express-ph": [
      {
        "type": "circle",
        "cx": 11,
        "cy": 9.6,
        "r": 5.5,
        "fill": "#1d1d1b"
      },
      {
        "type": "polygon",
        "d": "M12.9 4.9L8.3 10.5L11 10.5L9.3 14.3L14 8.6L11.3 8.6Z",
        "fill": "truck"
      }
    ],
    "jrs-express": [
      {
        "type": "line",
        "d": "M7.15 5.4L7.15 11.3L7.06 12.09L6.79 12.78L6.39 13.29L5.89 13.57L5.36 13.57L4.86 13.29L4.46 12.78L4.19 12.09L4.1 11.3M8.88 13.6L8.88 5.4L10.73 5.4L11.32 5.53L11.84 5.9L12.23 6.47L12.43 7.16L12.43 7.9L12.23 8.6L11.84 9.17L11.32 9.54L10.73 9.66L8.88 9.66M10.6 9.66L12.72 13.6M17.73 6.58L17.32 5.94L16.73 5.53L16.05 5.4L15.38 5.58L14.81 6.04L14.44 6.7L14.32 7.48L14.46 8.26L14.85 8.91L15.43 9.35L16.11 9.5L16.79 9.65L17.37 10.09L17.76 10.74L17.9 11.52L17.78 12.3L17.41 12.96L16.84 13.42L16.17 13.6L15.48 13.47L14.89 13.06L14.49 12.42",
        "stroke": "accent",
        "strokeWidth": 2
      }
    ],
    "xde-logistics": [
      {
        "type": "polygon",
        "d": "M3.6 4.6L6.4 4.6L10 14.4L7.2 14.4Z",
        "fill": "accent"
      },
      {
        "type": "polygon",
        "d": "M7.2 4.6L10 4.6L6.4 14.4L3.6 14.4Z",
        "fill": "accent"
      },
      {
        "type": "line",
        "d": "M12.02 6.6L11 13L12 13L12.66 12.81L13.29 12.25L13.84 11.4L14.22 10.36L14.4 9.24L14.35 8.2L14.08 7.35L13.62 6.79L13.03 6.6L12.02 6.6M18.22 6.6L15.94 6.6L14.92 13L17.2 13M15.43 9.8L17.35 9.8",
        "stroke": "accent",
        "strokeWidth": 1.6
      }
    ],
    "chunil": [
      {
        "type": "polygon",
        "d": "M12.18 4.69L11.11 4.81L10.09 5.16L9.17 5.74L8.41 6.5L7.84 7.41L7.48 8.43L7.36 9.5L7.48 10.57L7.84 11.59L8.41 12.5L9.17 13.26L10.09 13.84L11.11 14.19L12.18 14.31L12.18 11.85L11.65 11.79L11.16 11.62L10.71 11.34L10.34 10.97L10.06 10.52L9.88 10.02L9.82 9.5L9.88 8.98L10.06 8.48L10.34 8.03L10.71 7.66L11.16 7.38L11.65 7.21L12.18 7.15Z",
        "fill": "accent"
      },
      {
        "type": "circle",
        "cx": 4.37,
        "cy": 9.5,
        "r": 1.2,
        "fill": "#ff092c"
      },
      {
        "type": "circle",
        "cx": 8.65,
        "cy": 9.5,
        "r": 1.2,
        "fill": "#ff092c"
      },
      {
        "type": "circle",
        "cx": 13.35,
        "cy": 9.5,
        "r": 1.2,
        "fill": "#ff092c"
      },
      {
        "type": "circle",
        "cx": 17.63,
        "cy": 9.5,
        "r": 1.2,
        "fill": "#ff092c"
      }
    ],
    "gs-postbox": [
      {
        "type": "polygon",
        "d": "M11 4L15.76 6.75L15.76 12.25L11 15L6.24 12.25L6.24 6.75Z",
        "fill": "accent"
      },
      {
        "type": "polygon",
        "d": "M11 5.73L14.26 7.62L14.26 11.38L11 13.27L7.74 11.38L7.74 7.62Z",
        "fill": "truck"
      },
      {
        "type": "line",
        "d": "M7.74 7.62L11 9.5L14.26 7.62M11 9.5L11 13.27",
        "stroke": "accent",
        "strokeWidth": 1.4
      }
    ],
    "hapdong": [
      {
        "type": "polygon",
        "d": "M7.04 7.28L9.68 7.28L9.68 6.8L14.96 6.8L14.96 9.8L14.24 9.92L14.24 14.84L12.2 14.84L12.2 11.72L9.92 11.72L9.68 14.84L7.76 14.84L7.76 9.92L9.68 9.92L9.68 8.24L7.04 8.24Z",
        "fill": "accent"
      },
      {
        "type": "circle",
        "cx": 11.36,
        "cy": 5.24,
        "r": 1.14,
        "fill": "accent"
      },
      {
        "type": "polygon",
        "d": "M7.04 4.4L9.44 4.4L9.44 6.44L7.04 6.44Z",
        "fill": "#fff200"
      },
      {
        "type": "polygon",
        "d": "M11.51 7.19L14.57 7.19L14.57 10.01L11.51 10.01Z",
        "fill": "truck"
      },
      {
        "type": "polygon",
        "d": "M11.96 7.64L14.12 7.64L14.12 9.56L11.96 9.56Z",
        "fill": "#fff200"
      }
    ],
    "ilyang-logis": [
      {
        "type": "polygon",
        "d": "M5.38 4.4L7.38 4.4L5.6 11.8L3.6 11.8Z",
        "fill": "accent"
      },
      {
        "type": "polygon",
        "d": "M8.78 4.4L10.78 4.4L9 11.8L7 11.8Z",
        "fill": "accent"
      },
      {
        "type": "polygon",
        "d": "M7.46 9.9L13.06 9.9L12.6 11.8L7 11.8Z",
        "fill": "accent"
      },
      {
        "type": "polygon",
        "d": "M3.4 14.6L6.04 13.93L7.48 13.35L8.92 12.67L10.36 11.89L11.8 11.04L13.24 10.14L14.68 9.17L16.12 8.16L17.56 7.1L19 6L19 6L19 6.6L17.56 8.11L16.12 9.47L14.68 10.69L13.24 11.76L11.8 12.68L10.36 13.44L8.92 14.06L7.48 14.51L6.04 14.8Z",
        "fill": "#00afec"
      }
    ],
    "kunyoung": [
      {
        "type": "line",
        "d": "M14.57 6.71L13.95 6.06L13.2 5.54L12.37 5.18L11.48 4.99L10.58 4.99L9.69 5.16L8.85 5.51L8.1 6.01L7.47 6.66L6.97 7.42L6.64 8.26L6.48 9.15L6.5 10.06L6.7 10.94L7.07 11.77L7.6 12.5L8.27 13.12L9.04 13.59L9.89 13.9L10.79 14.03L11.69 13.98L12.57 13.75L13.38 13.35L14.1 12.8L14.7 12.12L15.14 11.33L15.43 10.47L15.53 9.57L15.46 8.67L15.2 7.8",
        "stroke": "accent",
        "strokeWidth": 1.4
      },
      {
        "type": "polygon",
        "d": "M7.44 6.86L16.29 6.39L10.08 9.15Z",
        "fill": "accent"
      },
      {
        "type": "polygon",
        "d": "M4.56 12.14L15.03 7.2L7.67 12.61Z",
        "fill": "accent"
      },
      {
        "type": "polygon",
        "d": "M15.25 6.97L10.31 13.75L10.43 11.8L11.69 10.3L13.76 8.81Z",
        "fill": "accent"
      }
    ],
    "hct-logistics": [
      {
        "type": "line",
        "d": "M3.5 13.6L10.4 7.2",
        "stroke": "#b5cc18",
        "strokeWidth": 1.5
      },
      {
        "type": "line",
        "d": "M5.61 6.6L4.45 12.4M9.09 6.6L7.93 12.4M5.03 9.5L8.51 9.5M13.3 7.34L12.73 6.77L11.98 6.6L11.15 6.85L10.37 7.49L9.75 8.41L9.38 9.5L9.32 10.59L9.57 11.51L10.09 12.15L10.82 12.4L11.64 12.23L12.44 11.66M14.43 6.6L17.91 6.6M16.17 6.6L15.01 12.4",
        "stroke": "accent",
        "strokeWidth": 1.55
      }
    ],
    "kerry-tj": [
      {
        "type": "line",
        "d": "M4.12 6.4L4.12 12.6M7.59 6.4L4.12 10.12M5.23 9.25L7.59 12.6M9.45 6.4L13.17 6.4M11.31 6.4L11.31 12.6M17.88 6.4L17.88 10.86L17.8 11.46L17.55 11.98L17.17 12.37L16.7 12.57L16.21 12.57L15.74 12.37L15.36 11.98L15.12 11.46L15.03 10.86",
        "stroke": "accent",
        "strokeWidth": 1.7
      }
    ],
    "pelican-express": [
      {
        "type": "polygon",
        "d": "M10.25 6.4L10.18 6.9L9.99 7.38L9.68 7.78L9.28 8.09L8.8 8.28L8.3 8.35L7.8 8.28L7.33 8.09L6.92 7.78L6.61 7.38L6.42 6.9L6.35 6.4L6.42 5.9L6.61 5.43L6.92 5.02L7.33 4.71L7.8 4.52L8.3 4.45L8.8 4.52L9.28 4.71L9.68 5.02L9.99 5.42L10.18 5.9Z",
        "fill": "accent"
      },
      {
        "type": "polygon",
        "d": "M7 7.6L9.9 7L10.9 9.6L8.6 10.6Z",
        "fill": "accent"
      },
      {
        "type": "polygon",
        "d": "M17 10.9L16.84 10.27L16.38 9.68L15.65 9.17L14.7 8.78L13.59 8.53L12.4 8.45L11.21 8.53L10.1 8.78L9.15 9.17L8.42 9.68L7.96 10.27L7.8 10.9L7.96 11.53L8.42 12.12L9.15 12.63L10.1 13.02L11.21 13.27L12.4 13.35L13.59 13.27L14.7 13.02L15.65 12.63L16.38 12.13L16.84 11.53Z",
        "fill": "accent"
      },
      {
        "type": "polygon",
        "d": "M16.4 9.9L18.4 10.3L16.6 11.8Z",
        "fill": "accent"
      },
      {
        "type": "polygon",
        "d": "M10.4 9.4L10.9 7L12.2 5.2L14.2 4.3L16.4 4.4L16 6L14.8 7.8L14.4 9.6Z",
        "fill": "accent"
      },
      {
        "type": "polygon",
        "d": "M7.4 5.6L3.2 6.3L3.1 7.3L3.7 8.8L5 10L6.6 10.1L7.8 8.8L8 7.4Z",
        "fill": "#fcca0f"
      },
      {
        "type": "polygon",
        "d": "M14.6 13.1L18.4 12.5L18 13.6L16.6 14.7L15.4 14.3Z",
        "fill": "#fcca0f"
      },
      {
        "type": "circle",
        "cx": 8.7,
        "cy": 5.9,
        "r": 0.5,
        "fill": "truck"
      }
    ],
    "seven-eleven-tw": [
      {
        "type": "polygon",
        "d": "M5 5L5.26 4.36L5.9 4.1L16.1 4.1L16.74 4.36L17 5L16.2 14.9L5.8 14.9Z",
        "fill": "accent"
      },
      {
        "type": "polygon",
        "d": "M6.9 5.4L14.07 5.4L10.7 7.75L6.9 7.75Z",
        "fill": "#ed6d00"
      },
      {
        "type": "polygon",
        "d": "M14.5 5.36L15.32 5.36L15.21 6.8L14.77 8.24L13.8 9.23L13.14 9.95L12.82 12.43L12.71 14.81L9.4 14.81L9.72 11.98L10.16 9.91L10.97 8.73L11.95 7.83L13.2 6.71Z",
        "fill": "#e4011e"
      }
    ],
    "t-cat": [
      {
        "type": "polygon",
        "d": "M18.4 9.5L18.29 10.41L17.95 11.3L17.41 12.12L16.67 12.87L15.76 13.52L14.7 14.05L13.53 14.43L12.28 14.67L11 14.75L9.72 14.67L8.47 14.43L7.3 14.05L6.24 13.52L5.33 12.87L4.59 12.12L4.05 11.3L3.71 10.41L3.6 9.5L3.71 8.59L4.05 7.7L4.59 6.88L5.33 6.13L6.24 5.48L7.3 4.95L8.47 4.57L9.72 4.33L11 4.25L12.28 4.33L13.53 4.57L14.7 4.95L15.76 5.48L16.67 6.13L17.41 6.87L17.95 7.7L18.29 8.59Z",
        "fill": "#fdd000"
      },
      {
        "type": "polygon",
        "d": "M6.22 5.76L7.43 6.89L9.7 6.89L10.48 5.76L10.74 8.28L11.09 8.72L15.26 8.54L16.48 8.11L17.35 7.24L17.79 7.67L17 8.8L16.66 9.33L15.79 9.76L15.44 10.89L15.87 13.15L14.57 13.24L13.96 11.76L11 11.76L10.13 13.15L8.91 13.15L9.17 11.76L9 11.15L8.3 10.46L8.22 9.06L7.78 8.63L6.39 8.46Z",
        "fill": "#111111"
      },
      {
        "type": "polygon",
        "d": "M6.13 9.24L6.56 9.5L7.26 9.5L7.61 9.85L7.78 11.24L7.52 12.54L6.48 12.54L6.04 11.24L5.87 9.85Z",
        "fill": "#111111"
      }
    ],
    "kex-express-hk": [
      {
        "type": "line",
        "d": "M7 4.4L7 14.6M16.6 5L7 11M10.6 8.8L16.6 14.4",
        "stroke": "accent",
        "strokeWidth": 2
      }
    ],
    "sbs-sokuhai": [
      {
        "type": "polygon",
        "d": "M18.29 6.99L17.39 6.52L16.17 6.08L14.26 5.75L11.54 5.51L9.5 5.58L7.74 5.88L6.7 6.38L6.05 7.05L5.67 7.86L5.56 8.8L5.72 9.73L6.05 10.4L6.65 10.94L7.74 11.31L9.23 11.54L11.27 11.68L13.18 11.61L13.5 11.01L12.09 10.97L10.51 10.84L9.42 10.61L8.72 10.07L8.33 9.26L8.23 8.39L8.44 7.46L8.99 6.79L9.91 6.35L11.27 6.08L13.45 6.05L15.35 6.18L16.98 6.52Z",
        "fill": "accent"
      },
      {
        "type": "polygon",
        "d": "M3.49 12.28L4.47 12.65L5.97 13.08L7.74 13.42L9.37 13.65L11.27 13.75L12.9 13.62L14.13 13.29L15.03 12.75L15.68 12.01L16.06 11.07L16.22 10.07L16.11 9.13L15.68 8.46L14.94 8.03L13.86 7.72L12.36 7.59L10.18 7.59L8.72 7.66L8.72 8.19L10.86 8.19L12.03 8.39L12.8 8.86L13.34 9.6L13.67 10.47L13.61 11.61L13.23 12.28L12.52 12.62L11.44 12.88L9.64 13.05L7.74 13.02L6.1 12.82L4.74 12.51Z",
        "fill": "accent"
      }
    ],
    "tracx-logis": [
      {
        "type": "polygon",
        "d": "M5.6 14.9L6.8 14.76L7.94 14.37L8.97 13.72L9.82 12.87L10.47 11.84L10.86 10.7L11 9.5L10.86 8.3L10.47 7.16L9.82 6.13L8.97 5.28L7.94 4.63L6.8 4.24L5.6 4.1L5.6 6.02L6.37 6.11L7.11 6.37L7.77 6.78L8.32 7.33L8.73 7.99L8.99 8.73L9.08 9.5L8.99 10.27L8.73 11.01L8.32 11.67L7.77 12.22L7.11 12.63L6.37 12.89L5.6 12.98Z",
        "fill": "accent"
      },
      {
        "type": "polygon",
        "d": "M16.4 4.1L15.2 4.24L14.06 4.63L13.03 5.28L12.18 6.13L11.53 7.16L11.14 8.3L11 9.5L11.14 10.7L11.53 11.84L12.18 12.87L13.03 13.72L14.06 14.37L15.2 14.76L16.4 14.9L16.4 12.98L15.63 12.89L14.89 12.63L14.23 12.22L13.68 11.67L13.27 11.01L13.01 10.27L12.92 9.5L13.01 8.73L13.27 7.99L13.68 7.33L14.23 6.78L14.89 6.37L15.63 6.11L16.4 6.02Z",
        "fill": "accent"
      }
    ],
    "quantium-solutions": [
      {
        "type": "polygon",
        "d": "M9.89 4.32L16.36 4.32L16.36 10.91L12.23 14.82L12.23 8.49L5.64 8.49Z",
        "fill": "#7fbc03"
      },
      {
        "type": "polygon",
        "d": "M10.68 5.03L11.67 7.97L8.74 6.98L11.51 8.36L8.74 9.74L11.67 8.75L10.68 11.69L12.06 8.91L13.44 11.69L12.45 8.75L15.39 9.74L12.61 8.36L15.39 6.98L12.45 7.97L13.44 5.03L12.06 7.81Z",
        "fill": "truck"
      }
    ],
    "janio": [
      {
        "type": "polygon",
        "d": "M5.62 8.35L5.77 7.8L5.98 7.26L6.24 6.75L6.55 6.27L6.91 5.82L7.32 5.41L7.77 5.05L8.25 4.74L8.76 4.48L9.3 4.27L9.86 4.12L10.43 4.03L11 4L11.57 4.03L12.14 4.12L12.7 4.27L13.24 4.48L13.75 4.74L14.23 5.05L14.61 5.35Z",
        "fill": "accent"
      },
      {
        "type": "polygon",
        "d": "M16.5 9.5L16.47 10.07L16.38 10.64L16.23 11.2L16.02 11.74L15.76 12.25L15.45 12.73L15.09 13.18L14.68 13.59L14.23 13.95L13.75 14.26L13.24 14.52L12.7 14.73L12.14 14.88L12.13 14.88L15.34 6.13L15.45 6.27L15.76 6.75L16.02 7.26L16.23 7.8L16.38 8.36L16.47 8.93Z",
        "fill": "accent"
      },
      {
        "type": "polygon",
        "d": "M8.97 11.37L11.08 15L11 15L10.43 14.97L9.86 14.88L9.3 14.73L8.76 14.52L8.25 14.26L7.77 13.95L7.32 13.59L6.91 13.18L6.55 12.73L6.24 12.25L5.98 11.74L5.77 11.2L5.62 10.64L5.53 10.07L5.5 9.5L5.51 9.37Z",
        "fill": "accent"
      }
    ],
    "j-and-t-cn": [
      {
        "type": "line",
        "d": "M7.88 6.53L6.95 11.17L3.75 11.17M12.77 11.62L10.39 8.23L10.39 7.65L10.72 7.1L11.26 6.79L11.81 6.87L12.15 7.26L9.11 10.27L9.18 10.94L9.62 11.44L10.33 11.62L11.12 11.44L11.75 10.94L12.09 10.27L13.3 9M13.98 7.23L18.25 7.23M16.43 7.23L15.5 11.87",
        "stroke": "accent",
        "strokeWidth": 1.5
      }
    ],
    "equick": [
      {
        "type": "polygon",
        "d": "M10.4 5L5 5L4.39 5.12L3.87 5.47L3.52 5.99L3.4 6.6L3.4 12.4L3.52 13.01L3.87 13.53L4.39 13.88L5 14L10.4 14L10.4 11.7L5.9 11.7L5.9 10.65L9.7 10.65L9.7 8.35L5.9 8.35L5.9 7.3L10.4 7.3Z",
        "fill": "accent"
      },
      {
        "type": "line",
        "d": "M12 5.4L14.7 9.5L12 13.6M15.3 5.4L18 9.5L15.3 13.6",
        "stroke": "accent",
        "strokeWidth": 1.6
      }
    ],
    "pfc-express": [
      {
        "type": "polygon",
        "d": "M7.6 7.3L7.1 4.9L9.1 6L11 4.3L12.9 6L14.9 4.9L14.4 7.3Z",
        "fill": "accent"
      },
      {
        "type": "line",
        "d": "M4.96 14.2L5.7 8.9L7.18 8.9L7.64 8.98L8.02 9.22L8.28 9.59L8.38 10.04L8.31 10.52L8.09 10.97L7.73 11.33L7.28 11.57L6.8 11.66L5.31 11.66M12.8 8.9L10.26 8.9L9.52 14.2M9.89 11.55L12.01 11.55M17.59 9.58L17.04 9.06L16.34 8.9L15.6 9.13L14.92 9.71L14.4 10.56L14.13 11.55L14.13 12.54L14.4 13.39L14.92 13.97L15.6 14.2L16.34 14.04L17.04 13.52",
        "stroke": "accent",
        "strokeWidth": 1.55
      }
    ],
    "ecms-express": [
      {
        "type": "line",
        "d": "M6.51 6.6L4.15 6.6L3.45 12.4L5.82 12.4M3.8 9.5L5.79 9.5M10.22 7.34L9.73 6.77L9.11 6.6L8.44 6.85L7.83 7.49L7.37 8.41L7.11 9.5L7.11 10.59L7.35 11.51L7.81 12.15L8.41 12.4L9.08 12.23L9.7 11.66M10.65 12.4L11.35 6.6M11.46 6.88L12.76 10.2L14.78 7.01M15.04 6.6L14.34 12.4M18.33 7.44L18.09 6.98L17.7 6.69L17.23 6.6L16.73 6.73L16.29 7.05L15.97 7.52L15.81 8.07L15.85 8.62L16.07 9.08L16.45 9.39L16.92 9.5L17.39 9.61L17.77 9.92L17.99 10.38L18.03 10.93L17.87 11.48L17.55 11.95L17.11 12.27L16.61 12.4L16.14 12.31L15.75 12.02L15.51 11.56",
        "stroke": "accent",
        "strokeWidth": 1.55
      }
    ],
    "139express": [
      {
        "type": "line",
        "d": "M5.88 7.65L8.1 6.2L7.04 12.8M9.64 7.03L10.12 6.55L10.72 6.27L11.35 6.21L11.92 6.38L12.35 6.77L12.58 7.31L12.57 7.93L12.33 8.54L11.88 9.04L11.3 9.38L10.67 9.5L11.33 9.49L11.84 9.84L12.15 10.37L12.21 11L12.01 11.65L11.58 12.21L10.99 12.61L10.31 12.79L9.65 12.73L9.1 12.43L8.74 11.94M17.46 8.86L17.69 8.09L17.65 7.34L17.33 6.72L16.8 6.32L16.14 6.2L15.43 6.39L14.8 6.84L14.33 7.5L14.1 8.27L14.15 9.02L14.46 9.64L14.99 10.04L15.66 10.16L16.36 9.97L17 9.52L17.46 8.86L17.68 8.18L16.15 12.8",
        "stroke": "accent",
        "strokeWidth": 1.7
      }
    ],
    "winit": [
      {
        "type": "polygon",
        "d": "M3.49 5.59L7.83 13.95L10.65 9.86L9.31 8.94L8.03 10.8L4.93 4.84Z",
        "fill": "accent"
      },
      {
        "type": "polygon",
        "d": "M7.21 5.59L11.55 13.94L18.14 4.49L13.27 4.49L11.63 6.9L12.97 7.81L14.13 6.12L15.02 6.12L11.75 10.81L8.65 4.84Z",
        "fill": "accent"
      }
    ],
    "energia-tk": [
      {
        "type": "polygon",
        "d": "M6.38 7.52L6.94 7.15L7.56 6.88L8.21 6.71L8.89 6.65L9.56 6.7L10.22 6.87L10.84 7.14L11.4 7.5L11.9 7.96L12.32 8.49L12.65 9.08L11.28 9.69L11.07 9.32L10.8 8.98L10.49 8.69L10.13 8.46L9.73 8.29L9.32 8.18L8.89 8.15L8.46 8.19L8.05 8.29L7.66 8.47L7.3 8.7Z",
        "fill": "accent"
      },
      {
        "type": "polygon",
        "d": "M12.65 12.42L12.32 13.01L11.9 13.54L11.4 14L10.84 14.36L10.22 14.63L9.56 14.8L8.89 14.85L8.21 14.79L7.56 14.62L6.94 14.35L6.38 13.98L7.3 12.8L7.66 13.03L8.05 13.21L8.46 13.31L8.89 13.35L9.32 13.32L9.73 13.21L10.13 13.04L10.49 12.81L10.8 12.52L11.07 12.18L11.28 11.81Z",
        "fill": "accent"
      },
      {
        "type": "polygon",
        "d": "M9.35 10L13 10L13 11.5L9.35 11.5Z",
        "fill": "accent"
      },
      {
        "type": "polygon",
        "d": "M14.1 10L15.6 10L15.6 11.5L14.1 11.5Z",
        "fill": "accent"
      },
      {
        "type": "polygon",
        "d": "M8.4 4.5L8.46 4.31L8.65 4.25L9.75 4.25L9.94 4.31L10 4.5L10 5.6L9.94 5.79L9.75 5.85L8.65 5.85L8.46 5.79L8.4 5.6Z",
        "fill": "accent"
      },
      {
        "type": "polygon",
        "d": "M13.71 5.64L13.85 5.57L13.99 5.64L14.76 6.41L14.83 6.55L14.76 6.69L13.99 7.46L13.85 7.53L13.71 7.46L12.94 6.69L12.87 6.55L12.94 6.41Z",
        "fill": "accent"
      }
    ],
    "zheldor": [
      {
        "type": "polygon",
        "d": "M10.48 4.57L10.83 4.41L11.17 4.41L11.52 4.57L15.97 7.72L16.24 8L16.36 8.33L16.31 8.72L14.64 14.21L14.46 14.57L14.17 14.78L13.78 14.85L8.22 14.85L7.83 14.78L7.54 14.57L7.36 14.21L5.69 8.72L5.64 8.33L5.76 8L6.03 7.72Z",
        "fill": "accent"
      },
      {
        "type": "polygon",
        "d": "M6.75 8.65L11 9.1L15.25 8.65L11 10.55Z",
        "fill": "truck"
      },
      {
        "type": "polygon",
        "d": "M11 10.35L11.44 11.22L11.98 12.02L12.6 12.76L13.3 13.44L14.1 14.05L13.07 13.68L12.03 13.45L11 13.38L9.97 13.45L8.93 13.68L7.9 14.05L8.7 13.44L9.4 12.76L10.02 12.02L10.56 11.22Z",
        "fill": "truck"
      }
    ],
    "kit-tk": [
      {
        "type": "circle",
        "cx": 11,
        "cy": 9.5,
        "r": 5.6,
        "fill": "#fff01e"
      },
      {
        "type": "line",
        "d": "M7.3 6.3L7.3 12.9M10 8.6L7.4 11M8.5 10.1L10.2 12.9M11.6 8.7L11.6 12.9M13.55 6.6L13.55 11.6L13.75 12.35L14.4 12.75L15.1 12.8M12.5 8.75L15.1 8.75",
        "stroke": "truck",
        "strokeWidth": 1.55
      },
      {
        "type": "circle",
        "cx": 11.6,
        "cy": 7,
        "r": 0.85,
        "fill": "#f52d0e"
      }
    ],
    "alem-tat": [
      {
        "type": "polygon",
        "d": "M7.2 4.87L8.4 4.87L8.83 6.22L8.9 8.07L8.83 10.05L9.04 11.9L9.61 13.32L10.39 14.31L4.92 14.31L4.14 13.82L4.07 12.61L4.57 11.05L5.56 9.34L6.41 7.64L6.84 6.08Z",
        "fill": "accent"
      },
      {
        "type": "polygon",
        "d": "M9.47 4.8L17.56 4.8L13.66 14.31L11.74 14.31L10.89 13.32L10.32 11.9L10.04 10.05L10.04 8.07L9.96 6.22Z",
        "fill": "#00a1e6"
      },
      {
        "type": "line",
        "d": "M9.82 7L10.48 7.17L11.15 7.29L11.81 7.31L12.47 7.23L13.14 7.07L13.8 6.89L14.46 6.75L15.12 6.69L15.79 6.73L16.45 6.87L17.11 7.04L17.77 7.21M9.82 9.27L10.48 9.45L11.15 9.56L11.81 9.58L12.47 9.5L13.14 9.34L13.8 9.16L14.46 9.02L15.12 8.96L15.79 9L16.45 9.14L17.11 9.31L17.77 9.48",
        "stroke": "truck",
        "strokeWidth": 1.2
      }
    ],
    "sat-ukraine": [
      {
        "type": "line",
        "d": "M7.06 7.29L6.68 6.81L6.13 6.5L5.49 6.4L4.86 6.54L4.33 6.88L3.99 7.39L3.87 7.97L4.01 8.56L4.37 9.05L4.91 9.38L5.54 9.5L6.18 9.62L6.72 9.95L7.08 10.44L7.22 11.03L7.1 11.61L6.76 12.12L6.23 12.46L5.6 12.6L4.96 12.5L4.41 12.19L4.03 11.71M8.71 12.6L10.53 6.4L11.09 6.4L12.92 12.6M9.45 10.37L12.18 10.37M14.41 6.4L18.13 6.4M16.27 6.4L16.27 12.6",
        "stroke": "accent",
        "strokeWidth": 1.6
      }
    ],
    "taxydema": [
      {
        "type": "polygon",
        "d": "M5.6 7.35L16.2 7.35L16.2 5.45L5.6 5.45Z",
        "fill": "accent"
      },
      {
        "type": "polygon",
        "d": "M9.65 6.4L9.65 11.65L9.75 12.55L10.12 13.4L10.79 14.04L11.64 14.4L12.55 14.5L14.6 14.5L14.6 12.6L12.65 12.6L12.12 12.54L11.85 12.43L11.72 12.3L11.61 12.05L11.55 11.55L11.55 6.4Z",
        "fill": "accent"
      }
    ],
    "dropp": [
      {
        "type": "circle",
        "cx": 11,
        "cy": 9.5,
        "r": 5.6,
        "fill": "#00ffff"
      },
      {
        "type": "polygon",
        "d": "M6.8 8.3L6.91 7.54L7.22 6.82L7.72 6.18L8.38 5.64L9.18 5.24L10.07 4.99L11 4.9L11.93 4.99L12.82 5.24L13.62 5.64L14.28 6.18L14.78 6.82L15.09 7.54L15.2 8.3L14.5 7.89L13.8 7.75L13.1 7.89L11.7 7.89L11 7.75L10.3 7.89L8.9 7.89L8.2 7.75L7.5 7.89Z",
        "fill": "truck"
      },
      {
        "type": "line",
        "d": "M7.25 8.2L10 11.4M14.75 8.2L12 11.4",
        "stroke": "truck",
        "strokeWidth": 1.2
      },
      {
        "type": "polygon",
        "d": "M9.5 11.2L12.5 11.2L12.5 14.1L9.5 14.1Z",
        "fill": "truck"
      }
    ],
    "yalidine": [
      {
        "type": "polygon",
        "d": "M9.35 5.78L12.11 9.97L8.48 13.84L6.34 13.84Z",
        "fill": "accent"
      },
      {
        "type": "polygon",
        "d": "M11.01 5.15L18.12 5.15L18.51 5.54L14.01 9.1Z",
        "fill": "accent"
      },
      {
        "type": "polygon",
        "d": "M10.77 13.84L18.51 7.92L18.51 13.45L18.12 13.84Z",
        "fill": "accent"
      },
      {
        "type": "line",
        "d": "M3.5 9.25L7 9.25M4.4 11.45L6.2 11.45",
        "stroke": "accent",
        "strokeWidth": 1.2
      }
    ],
    "zr-express": [
      {
        "type": "polygon",
        "d": "M5.77 6.06L14.15 6.06L14.15 4.31L5.77 4.31Z",
        "fill": "accent"
      },
      {
        "type": "polygon",
        "d": "M13.93 6.05L15.05 6.13L15.63 6.3L15.95 6.52L16.11 6.77L16.17 7.17L16.11 7.58L15.95 7.83L15.63 8.05L15.04 8.22L14.12 8.29L12.16 8.29L12.16 10.04L14.19 10.04L15.36 9.95L16.39 9.65L17.24 9.07L17.78 8.2L17.95 7.17L17.78 6.14L17.24 5.28L16.39 4.7L15.35 4.39L14.05 4.31Z",
        "fill": "accent"
      },
      {
        "type": "polygon",
        "d": "M12.17 4.6L4.45 13.23L5.76 14.4L13.48 5.76Z",
        "fill": "accent"
      },
      {
        "type": "polygon",
        "d": "M4.19 14.69L13.16 14.69L13.16 12.94L4.19 12.94Z",
        "fill": "accent"
      },
      {
        "type": "polygon",
        "d": "M13.41 9.63L16.32 14.28L17.8 13.35L14.9 8.7Z",
        "fill": "accent"
      }
    ],
    "fargo-courier": [
      {
        "type": "polygon",
        "d": "M11 4.05L9.69 8.09L5.44 8.09L8.87 10.59L7.56 14.63L11 12.13L14.44 14.63L13.13 10.59L16.56 8.09L12.31 8.09Z",
        "fill": "accent"
      },
      {
        "type": "polygon",
        "d": "M11 8.42L10.67 9.44L9.59 9.44L10.46 10.07L10.13 11.1L11 10.47L11.87 11.1L11.54 10.07L12.41 9.44L11.33 9.44Z",
        "fill": "truck"
      },
      {
        "type": "polygon",
        "d": "M9.1 9.3L13.3 9.3L10.3 11.5Z",
        "fill": "#c79b46"
      }
    ],
    "internet-express": [
      {
        "type": "polygon",
        "d": "M7.3 7.7L9.3 7.7L9.3 14.6L7.3 14.6Z",
        "fill": "accent"
      },
      {
        "type": "circle",
        "cx": 8.3,
        "cy": 5.6,
        "r": 1.15,
        "fill": "accent"
      },
      {
        "type": "polygon",
        "d": "M10.3 4.3L11.5 4.3L11.5 14.6L10.3 14.6Z",
        "fill": "accent"
      },
      {
        "type": "polygon",
        "d": "M11.2 4.3L13.9 4.3L14.35 4.42L14.68 4.75L14.8 5.2L14.68 5.65L14.35 5.98L13.9 6.1L11.2 6.1Z",
        "fill": "accent"
      },
      {
        "type": "polygon",
        "d": "M11.2 8.55L13.9 8.55L14.35 8.67L14.68 9L14.8 9.45L14.68 9.9L14.35 10.23L13.9 10.35L11.2 10.35Z",
        "fill": "accent"
      },
      {
        "type": "polygon",
        "d": "M11.2 12.8L13.9 12.8L14.35 12.92L14.68 13.25L14.8 13.7L14.68 14.15L14.35 14.48L13.9 14.6L11.2 14.6Z",
        "fill": "accent"
      }
    ],
    "mds-collivery": [
      {
        "type": "polygon",
        "d": "M11 4.05L6.28 6.78L6.28 12.23L11 14.95L15.72 12.23L15.72 6.78Z",
        "fill": "accent"
      },
      {
        "type": "polygon",
        "d": "M11 6.75L8.62 8.12L8.62 10.88L11 12.25L13.38 10.88L13.38 8.12Z",
        "fill": "truck"
      },
      {
        "type": "polygon",
        "d": "M10.1 9.5L16.02 5.78L16.02 13.22Z",
        "fill": "truck"
      },
      {
        "type": "polygon",
        "d": "M11.55 9.5L15.72 7.83L15.72 11.17Z",
        "fill": "accent"
      }
    ],
    "paxi": [
      {
        "type": "line",
        "d": "M7.28 5.57L7.49 5.1L7.8 4.77L8.21 4.57L8.72 4.5L13.28 4.5L13.79 4.57L14.2 4.77L14.51 5.1L14.72 5.57L16.72 12.27L16.85 13.11L16.65 13.72L16.13 14.08L15.29 14.2L6.71 14.2L5.87 14.08L5.35 13.72L5.15 13.11L5.28 12.27L7.28 5.57",
        "stroke": "accent",
        "strokeWidth": 1.45
      },
      {
        "type": "polygon",
        "d": "M9.4 6.7L11.15 6.7L11.15 12.4L9.4 12.4Z",
        "fill": "accent"
      },
      {
        "type": "polygon",
        "d": "M10.6 6.7L12.2 6.7L12.95 6.85L13.58 7.27L14 7.9L14.15 8.65L14 9.4L13.58 10.03L12.95 10.45L12.2 10.6L10.6 10.6Z",
        "fill": "accent"
      },
      {
        "type": "polygon",
        "d": "M11.15 8L12 8L12.46 8.19L12.65 8.65L12.46 9.11L12 9.3L11.15 9.3Z",
        "fill": "truck"
      }
    ],
    "buffalo-ex": [
      {
        "type": "line",
        "d": "M17.11 6.52L13.86 7.6L11.07 5.58L5.18 4.66L10.51 7.45L9.89 9.3M8.28 8.68L4.56 9.62L6.73 13.49L16.02 14.57",
        "stroke": "accent",
        "strokeWidth": 1.6
      }
    ],
    "aeropost": [
      {
        "type": "polygon",
        "d": "M10.6 4.5L9.62 4.6L8.69 4.88L7.82 5.34L7.06 5.96L6.44 6.72L5.98 7.59L5.7 8.52L5.6 9.5L5.7 10.48L5.98 11.41L6.44 12.28L7.06 13.04L7.82 13.66L8.69 14.12L9.62 14.4L10.6 14.5L15.5 14.5L15.5 4.5Z",
        "fill": "accent"
      },
      {
        "type": "circle",
        "cx": 10.7,
        "cy": 9.5,
        "r": 2.15,
        "fill": "truck"
      }
    ],
    "aks-express": [
      {
        "type": "line",
        "d": "M3 9.2L6 9.2M3.4 11.1L5.6 11.1M3.8 13L5.2 13",
        "stroke": "#ee2329",
        "strokeWidth": 1.25
      },
      {
        "type": "line",
        "d": "M6.43 12.3L9.4 6.8L10.18 12.3M7.49 10.32L9.91 10.32M12.04 6.8L10.95 12.3M15.12 6.8L11.38 10.1M12.53 9.33L14.03 12.3M18.57 7.59L18.31 7.16L17.88 6.89L17.33 6.8L16.75 6.92L16.22 7.23L15.82 7.67L15.62 8.2L15.63 8.72L15.87 9.15L16.29 9.45L16.83 9.55L17.37 9.65L17.79 9.95L18.03 10.38L18.04 10.9L17.84 11.43L17.44 11.87L16.91 12.18L16.33 12.3L15.78 12.21L15.35 11.94L15.09 11.51",
        "stroke": "accent",
        "strokeWidth": 1.5
      }
    ],
    "algerie-poste": [
      {
        "type": "polygon",
        "d": "M4.47 6.02L6.1 5.39L7.9 4.75L9.7 4.3L11.51 4.1L12.86 4.1L14.21 4.37L15.57 4.98L16.58 5.84L17.26 6.96L17.53 8.09L17.37 9.33L16.92 10.46L16.13 11.47L15.23 12.26L14.66 12.56L15.57 11.7L16.13 10.8L16.42 9.89L16.42 8.99L16.13 8.2L15.45 7.53L14.44 7.08L12.86 6.69L11.06 6.47L8.8 6.24L6.55 6.08Z",
        "fill": "accent"
      },
      {
        "type": "polygon",
        "d": "M7.07 8.65L6.55 9.22L5.98 10.12L5.65 11.13L5.6 12.15L5.87 13.05L6.43 13.95L7.22 14.56L8.35 14.9L9.7 14.74L11.28 14.18L12.86 13.39L14.48 12.56L13.76 12.15L12.41 11.92L10.61 11.81L9.03 11.65L7.79 11.29L7 10.68L6.73 9.89L6.77 9.22Z",
        "fill": "#fecc0b"
      }
    ],
    "aymakan": [
      {
        "type": "polygon",
        "d": "M12.93 4.01L4.85 11.22L4.85 14.99L17.16 4.01Z",
        "fill": "#000814"
      },
      {
        "type": "polygon",
        "d": "M8.89 11.39L12.93 14.99L17.16 14.99L13.12 11.39Z",
        "fill": "#000814"
      }
    ],
    "azerpost": [
      {
        "type": "line",
        "d": "M12.4 6.4L5.2 6.4L5.2 14.3L15.2 14.3L15.2 8.6",
        "stroke": "accent",
        "strokeWidth": 1.4
      },
      {
        "type": "line",
        "d": "M6.6 8L13.4 12.9",
        "stroke": "accent",
        "strokeWidth": 1.5
      },
      {
        "type": "line",
        "d": "M6.6 12.9L17.4 4.7",
        "stroke": "accent",
        "strokeWidth": 1.5
      }
    ],
    "best-express-vn": [
      {
        "type": "line",
        "d": "M3.63 10L3.63 4.5L5.28 4.5L5.69 4.58L6.06 4.81L6.33 5.16L6.47 5.59L6.47 6.05L6.33 6.48L6.06 6.83L5.69 7.06L5.28 7.14L3.63 7.14M3.63 7.14L5.39 7.14L5.84 7.23L6.24 7.47L6.53 7.86L6.69 8.32L6.69 8.82L6.53 9.29L6.24 9.67L5.84 9.91L5.39 10L3.63 10M10.34 4.5L7.59 4.5L7.59 10L10.34 10M7.59 7.25L9.9 7.25M14.05 5.29L13.71 4.86L13.22 4.59L12.66 4.5L12.1 4.62L11.63 4.93L11.32 5.37L11.22 5.9L11.34 6.42L11.66 6.85L12.14 7.15L12.71 7.25L13.27 7.35L13.75 7.65L14.07 8.08L14.19 8.6L14.09 9.13L13.78 9.57L13.31 9.88L12.75 10L12.19 9.91L11.7 9.64L11.36 9.21M15.07 4.5L18.37 4.5M16.72 4.5L16.72 10",
        "stroke": "accent",
        "strokeWidth": 1.5
      },
      {
        "type": "polygon",
        "d": "M5.93 11.7L16.52 11.7L15.47 13.8L4.88 13.8Z",
        "fill": "accent"
      }
    ],
    "city-express-rs": [
      {
        "type": "polygon",
        "d": "M10.7 5.07L9.55 4.64L8.32 4.5L7.1 4.67L5.97 5.15L4.98 5.89L4.21 6.85L3.71 7.98L3.5 9.19L3.61 10.42L4.01 11.58L4.7 12.61L5.61 13.43L6.71 14L7.91 14.28L9.14 14.24L10.32 13.91L11.39 13.28L12.26 12.42L18.6 4.3L16.83 4.3L11.16 11.55L10.53 12.17L9.77 12.62L8.93 12.86L8.05 12.88L7.19 12.68L6.41 12.28L5.75 11.69L5.27 10.96L4.98 10.13L4.9 9.25L5.05 8.38L5.41 7.58L5.96 6.89L6.66 6.36L7.47 6.02L8.35 5.9L9.22 6L10.04 6.31Z",
        "fill": "accent"
      },
      {
        "type": "polygon",
        "d": "M10.32 7.79L9.81 7.34L9.2 7.03L8.53 6.9L7.85 6.96L7.21 7.2L6.66 7.6L6.24 8.14L5.98 8.77L5.9 9.44L6.01 10.12L6.29 10.74L6.73 11.26L7.29 11.64L7.94 11.86L8.62 11.89L9.28 11.74L9.88 11.41L10.37 10.94L15.56 4.3L13.78 4.3L9.27 10.08L9.05 10.29L8.79 10.43L8.5 10.5L8.2 10.48L7.91 10.39L7.66 10.22L7.47 9.99L7.35 9.72L7.3 9.42L7.34 9.12L7.45 8.84L7.64 8.61L7.88 8.43L8.16 8.33L8.46 8.3L8.75 8.36L9.02 8.49L9.24 8.69Z",
        "fill": "accent"
      }
    ],
    "cse-russia": [
      {
        "type": "polygon",
        "d": "M6.6 4.21L13.72 4.21L15.1 6.63L6.16 6.63Z",
        "fill": "accent"
      },
      {
        "type": "polygon",
        "d": "M5.83 8.34L16.68 8.34L17.52 9.58L16.11 10.69L5.32 10.69Z",
        "fill": "accent"
      },
      {
        "type": "polygon",
        "d": "M5.09 12.41L13.39 12.41L10.83 14.79L4.48 14.79Z",
        "fill": "accent"
      }
    ],
    "dohrn-transfer": [
      {
        "type": "line",
        "d": "M10.3 9.1L8 9.1L7.61 9.16L7.27 9.34L6.99 9.62L6.81 9.96L6.75 10.35L6.81 10.74L6.99 11.08L7.27 11.36L7.61 11.54L8 11.6L12 11.6L12 4M10.3 6.6L8 6.6L7.17 6.69L6.37 6.97L5.66 7.42L5.07 8.01L4.62 8.72L4.34 9.52L4.25 10.35L4.34 11.18L4.62 11.98L5.07 12.69L5.66 13.28L6.37 13.73L7.17 14.01L8 14.1L14.5 14.1L14.5 4M16.2 6.6L19 6.6M16.2 9.1L19 9.1",
        "stroke": "accent",
        "strokeWidth": 1.4
      }
    ],
    "ems-vietnam": [
      {
        "type": "line",
        "d": "M2.9 7.7L6.2 7.7M3.3 9.6L5.8 9.6M3.7 11.5L5.4 11.5",
        "stroke": "#f5821f",
        "strokeWidth": 1.3
      },
      {
        "type": "line",
        "d": "M10.07 6.75L7.32 6.75L6.22 12.25L8.97 12.25M6.77 9.5L9.09 9.5M9.74 12.25L10.84 6.75L12.31 10.16L15.13 6.75L14.04 12.25M18.58 7.54L18.32 7.11L17.89 6.84L17.34 6.75L16.76 6.87L16.23 7.18L15.83 7.62L15.63 8.15L15.64 8.67L15.88 9.1L16.3 9.4L16.84 9.5L17.38 9.6L17.8 9.9L18.04 10.33L18.05 10.85L17.85 11.38L17.45 11.82L16.92 12.13L16.34 12.25L15.79 12.16L15.36 11.89L15.1 11.46",
        "stroke": "accent",
        "strokeWidth": 1.5
      }
    ],
    "ethiopian-post": [
      {
        "type": "line",
        "d": "M4.6 14.5L13.1 9.2",
        "stroke": "#1a1a1a",
        "strokeWidth": 1.5
      },
      {
        "type": "polygon",
        "d": "M11.12 4.04L18.52 7.34L16.28 12.36L8.88 9.06Z",
        "fill": "#1a1a1a"
      },
      {
        "type": "polygon",
        "d": "M11.4 4.77L17.79 7.61L16 11.63L9.61 8.79Z",
        "fill": "accent"
      },
      {
        "type": "line",
        "d": "M11.55 5.16L13.5 8.66L17.4 7.77",
        "stroke": "#1a1a1a",
        "strokeWidth": 1.2
      }
    ],
    "euroexpress-ba": [
      {
        "type": "polygon",
        "d": "M5.2 3.9L5.47 4.15L5.84 4.37L6.3 4.57L6.85 4.74L7.49 4.88L8.22 5L9.05 5.09L9.97 5.15L10.98 5.22L12.08 5.34L13.27 5.43L14.56 5.5L15.93 5.54L17.4 5.55L17.4 7.45L15.93 7.44L14.56 7.4L13.27 7.33L12.08 7.24L10.98 7.12L9.97 6.89L9.05 6.61L8.22 6.3L7.49 5.97L6.85 5.61L6.3 5.22L5.84 4.81L5.47 4.37L5.2 3.9Z",
        "fill": "accent"
      },
      {
        "type": "polygon",
        "d": "M4 6L4.28 6.4L4.66 6.76L5.13 7.09L5.71 7.38L6.38 7.63L7.15 7.84L8.02 8.01L9 8.15L10.07 8.28L11.23 8.45L12.5 8.58L13.87 8.67L15.34 8.73L16.9 8.75L16.9 10.65L15.34 10.63L13.87 10.57L12.5 10.48L11.23 10.35L10.07 10.18L9 9.89L8.02 9.53L7.15 9.14L6.38 8.71L5.71 8.25L5.13 7.74L4.66 7.2L4.28 6.62L4 6Z",
        "fill": "accent"
      },
      {
        "type": "polygon",
        "d": "M2.8 8.1L3.08 8.65L3.47 9.16L3.96 9.61L4.56 10.02L5.27 10.37L6.08 10.68L7 10.94L8.02 11.15L9.16 11.34L10.39 11.56L11.73 11.73L13.18 11.85L14.74 11.93L16.4 11.95L16.4 13.85L14.74 13.83L13.18 13.75L11.73 13.63L10.39 13.46L9.16 13.24L8.02 12.89L7 12.46L6.08 11.98L5.27 11.46L4.56 10.89L3.96 10.26L3.47 9.59L3.08 8.87L2.8 8.1Z",
        "fill": "accent"
      }
    ],
    "followmont": [
      {
        "type": "polygon",
        "d": "M6.9 5.07L9.25 7.31L6.58 7.31Z",
        "fill": "#00b0f1"
      },
      {
        "type": "polygon",
        "d": "M6.4 8.6L8.75 10.85L6.08 10.85Z",
        "fill": "#00b0f1"
      },
      {
        "type": "polygon",
        "d": "M10.6 8.6L12.95 10.85L10.28 10.85Z",
        "fill": "#00b0f1"
      },
      {
        "type": "polygon",
        "d": "M7.15 8.15L9.82 8.15L9.5 10.4Z",
        "fill": "#00b0f1"
      },
      {
        "type": "polygon",
        "d": "M5.9 12.14L8.25 14.38L5.58 14.38Z",
        "fill": "#00b0f1"
      },
      {
        "type": "polygon",
        "d": "M10.1 12.14L12.45 14.38L9.78 14.38Z",
        "fill": "#00b0f1"
      },
      {
        "type": "polygon",
        "d": "M14.3 12.14L16.65 14.38L13.98 14.38Z",
        "fill": "#00b0f1"
      },
      {
        "type": "polygon",
        "d": "M6.65 11.69L9.32 11.69L9 13.93Z",
        "fill": "#00b0f1"
      },
      {
        "type": "polygon",
        "d": "M10.85 11.69L13.52 11.69L13.2 13.93Z",
        "fill": "#00b0f1"
      }
    ],
    "ghana-post": [
      {
        "type": "polygon",
        "d": "M8.6 8.6L11.9 8.6L14.5 4.4L11.2 4.4Z",
        "fill": "accent"
      },
      {
        "type": "polygon",
        "d": "M12.8 8.6L16.1 8.6L18.7 4.4L15.4 4.4Z",
        "fill": "#0c075b"
      },
      {
        "type": "polygon",
        "d": "M3.4 14.6L6.7 14.6L9.3 10.4L6 10.4Z",
        "fill": "#0c075b"
      },
      {
        "type": "polygon",
        "d": "M7.6 14.6L10.9 14.6L13.5 10.4L10.2 10.4Z",
        "fill": "accent"
      }
    ],
    "groupe-guilbault": [
      {
        "type": "polygon",
        "d": "M17.95 4.5L9.15 4.5L8.45 4.59L7.76 4.85L7.11 5.26L6.55 5.8L6.12 6.43L5.85 7.1L4.46 12.57L4.55 13.2L4.82 13.74L5.24 14.15L5.8 14.41L6.45 14.5L15.25 14.5L16.57 9.6L11.57 9.6L10.84 12.3L7.09 12.25L6.9 12.09L6.81 11.87L6.83 11.6L8.09 7.13L8.31 6.91L8.57 6.75L8.86 6.7L17.36 6.7Z",
        "fill": "#fcdf15"
      }
    ],
    "haypost": [
      {
        "type": "polygon",
        "d": "M11.2 5.6L15 5.6L15.88 5.73L16.6 6.11L17.12 6.71L17.39 7.5L17.4 8.42L17.15 9.4L16.66 10.38L15.95 11.3L15.08 12.09L14.1 12.69L13.09 13.07L12.11 13.2L8.31 13.2Z",
        "fill": "accent"
      },
      {
        "type": "polygon",
        "d": "M12.44 7.6L14.04 7.6L14.6 7.74L14.97 8.13L15.09 8.71L14.95 9.4L14.57 10.09L14 10.67L13.33 11.06L12.67 11.2L11.07 11.2Z",
        "fill": "truck"
      },
      {
        "type": "polygon",
        "d": "M11.65 4.4L13.65 4.4L13.16 5.7L11.16 5.7Z",
        "fill": "accent"
      },
      {
        "type": "polygon",
        "d": "M8 14L10 14L9.62 15L7.62 15Z",
        "fill": "accent"
      },
      {
        "type": "polygon",
        "d": "M5 5.6L11.3 5.6L10.61 7.4L6.31 7.4L5.56 7Z",
        "fill": "accent"
      },
      {
        "type": "polygon",
        "d": "M5.26 8.6L9.26 8.6L8.57 10.4L6.37 10.4L5.72 10Z",
        "fill": "accent"
      }
    ],
    "hi-trans": [
      {
        "type": "polygon",
        "d": "M18.25 9.5L9.73 4.3L9.73 7L13.82 9.5L9.73 12L9.73 14.7Z",
        "fill": "accent"
      },
      {
        "type": "polygon",
        "d": "M12 9.5L6.26 6L6.26 8.1L8.56 9.5L6.26 10.9L6.26 13Z",
        "fill": "accent"
      },
      {
        "type": "polygon",
        "d": "M6.8 9.5L3.69 7.6L3.69 9.5L3.69 9.5L3.69 9.5L3.69 11.4Z",
        "fill": "accent"
      }
    ],
    "jordan-post": [
      {
        "type": "polygon",
        "d": "M6 4.1L6.86 4.32L7.73 4.52L8.6 4.7L9.48 4.86L10.36 5L11.25 5.12L12.15 5.22L13.05 5.31L13.96 5.37L14.88 5.42L15.8 5.44L16.73 5.45L17.66 5.43L18.6 5.4L17.66 5.7L16.73 5.94L15.8 6.11L14.88 6.23L13.96 6.29L13.05 6.29L12.15 6.22L11.25 6.1L10.36 5.92L9.48 5.68L8.6 5.37L7.73 5.01L6.86 4.58Z",
        "fill": "#f39419"
      },
      {
        "type": "polygon",
        "d": "M3 5.4L4.01 6.1L5.04 6.7L6.09 7.22L7.16 7.64L8.24 7.98L9.35 8.22L10.47 8.38L11.62 8.44L12.79 8.41L13.97 8.29L15.17 8.08L16.4 7.78L17.64 7.38L18.9 6.9L17.56 7.86L16.25 8.66L14.97 9.29L13.72 9.76L12.51 10.06L11.33 10.2L10.18 10.17L9.06 9.99L7.97 9.63L6.91 9.11L5.89 8.43L4.89 7.59L3.93 6.58Z",
        "fill": "accent"
      },
      {
        "type": "polygon",
        "d": "M18.7 8.6L18.48 9.61L18.17 10.54L17.79 11.38L17.33 12.13L16.79 12.79L16.17 13.36L15.47 13.85L14.7 14.25L13.85 14.56L12.91 14.78L11.9 14.92L10.81 14.97L9.65 14.93L8.4 14.8L9.33 14.45L10.23 14.09L11.1 13.71L11.93 13.31L12.74 12.91L13.52 12.49L14.28 12.05L15 11.6L15.69 11.14L16.35 10.66L16.98 10.16L17.58 9.66L18.16 9.14Z",
        "fill": "#f39419"
      }
    ],
    "la-poste-tunisienne": [
      {
        "type": "polygon",
        "d": "M4.1 8.46L7.03 8.51L11.36 7.74L15.18 6.09L17.85 4L15.18 6.85L11.36 9.4L7.03 11.05L4.1 11.31Z",
        "fill": "accent"
      },
      {
        "type": "polygon",
        "d": "M4.35 15L7.03 12.83L10.85 11.18L14.41 10.03L17.47 9.73L17.47 12.96L14.41 12.71L10.85 12.83L7.03 13.73Z",
        "fill": "accent"
      },
      {
        "type": "polygon",
        "d": "M6.33 10.23L7.78 11.68L6.33 13.13L4.88 11.68Z",
        "fill": "truck"
      },
      {
        "type": "polygon",
        "d": "M5.88 9.93L7.18 11.23L5.88 12.53L4.58 11.23Z",
        "fill": "#fec321"
      },
      {
        "type": "polygon",
        "d": "M14.61 9.18L15.91 10.48L14.61 11.78L13.31 10.48Z",
        "fill": "truck"
      },
      {
        "type": "polygon",
        "d": "M14.16 8.88L15.31 10.03L14.16 11.18L13.01 10.03Z",
        "fill": "#fec321"
      },
      {
        "type": "polygon",
        "d": "M16.29 9.18L17.59 10.48L16.29 11.78L14.99 10.48Z",
        "fill": "truck"
      },
      {
        "type": "polygon",
        "d": "M15.84 8.88L16.99 10.03L15.84 11.18L14.69 10.03Z",
        "fill": "#fec321"
      }
    ],
    "libanpost": [
      {
        "type": "polygon",
        "d": "M4.2 14.6L10.6 4.4L18 5.7L11 14.6Z",
        "fill": "#fed300"
      },
      {
        "type": "line",
        "d": "M16.6 6.5L8.9 11.2L9.4 14.7",
        "stroke": "truck",
        "strokeWidth": 1.25
      }
    ],
    "mauritius-post": [
      {
        "type": "circle",
        "cx": 11,
        "cy": 9.5,
        "r": 5.5,
        "fill": "#00539b"
      },
      {
        "type": "polygon",
        "d": "M6.4 9.9L15 5.7L10.5 11Z",
        "fill": "accent"
      },
      {
        "type": "polygon",
        "d": "M11.1 11.1L15.1 6.3L11.7 13.9Z",
        "fill": "accent"
      }
    ],
    "mylerz": [
      {
        "type": "line",
        "d": "M4.28 11.16L4.28 5.46M4.28 7.3L4.39 6.67L4.69 6.12L5.16 5.71L5.73 5.49L6.34 5.49L6.91 5.71L7.37 6.12L7.67 6.67L7.78 7.3L7.78 11.16M7.78 7.3L7.89 6.67L8.19 6.12L8.65 5.71L9.22 5.49L9.83 5.49L10.4 5.71L10.87 6.12L11.17 6.67L11.28 7.3L11.28 11.16M13.12 5.46L13.12 8.22L13.25 9.16L13.65 9.99L14.27 10.61L15.02 10.94L15.82 10.94L16.57 10.61L17.18 9.99L17.58 9.16L17.72 8.22M17.72 5.46L17.72 11.16L17.57 12.04L17.15 12.8L16.5 13.35L15.72 13.63L14.89 13.58L14.14 13.23L13.55 12.61L13.19 11.81",
        "stroke": "accent",
        "strokeWidth": 1.8
      }
    ],
    "ncs-courier": [
      {
        "type": "line",
        "d": "M3.93 10.74L4.41 11.39L5.05 11.99L5.82 12.51L6.73 12.95L7.73 13.3L8.81 13.54L9.93 13.67L11.08 13.69L12.21 13.6L13.31 13.39L14.34 13.08L15.28 12.67L16.1 12.17L16.79 11.6L17.32 10.97L17.5 10.63",
        "stroke": "#e89c26",
        "strokeWidth": 1.3
      },
      {
        "type": "polygon",
        "d": "M19.04 8.84L16.54 9.99L17.99 11.34Z",
        "fill": "#e89c26"
      },
      {
        "type": "polygon",
        "d": "M5.04 4.1L6.72 4.1L6.71 7.75L7.44 4.1L9.04 4.1L7.9 9.8L6.22 9.8L6.23 6.15L5.5 9.8L3.9 9.8Z",
        "fill": "accent"
      },
      {
        "type": "line",
        "d": "M12.03 5.43L11.63 5.02L11.09 4.9L10.51 5.08L9.96 5.53L9.52 6.18L9.26 6.95L9.21 7.72L9.39 8.37L9.76 8.82L10.27 9L10.86 8.88L11.42 8.47M15.52 5.49L15.33 5.17L15 4.96L14.6 4.9L14.16 4.99L13.77 5.22L13.47 5.55L13.32 5.94L13.33 6.33L13.5 6.66L13.82 6.87L14.22 6.95L14.63 7.03L14.94 7.24L15.11 7.57L15.13 7.96L14.97 8.35L14.68 8.68L14.28 8.91L13.85 9L13.44 8.94L13.11 8.73L12.93 8.41",
        "stroke": "accent",
        "strokeWidth": 1.6
      }
    ],
    "nhat-tin": [
      {
        "type": "polygon",
        "d": "M3.34 7.92L3.84 8.7L4.42 9.42L5.08 10.08L5.8 10.66L6.58 11.16L7.4 11.58L8.27 11.92L9.16 12.16L10.07 12.3L11 12.35L11.93 12.3L12.84 12.16L13.73 11.92L14.6 11.58L15.43 11.16L16.2 10.66L16.92 10.08L17.58 9.42L18.16 8.7L18.66 7.92L16.5 6.67L16.14 7.23L15.72 7.75L15.25 8.22L14.73 8.64L14.18 9L13.58 9.3L12.96 9.54L12.32 9.71L11.66 9.82L11 9.85L10.34 9.82L9.68 9.71L9.04 9.54L8.42 9.3L7.83 9L7.27 8.64L6.75 8.22L6.28 7.75L5.86 7.23L5.5 6.67Z",
        "fill": "#484848"
      },
      {
        "type": "circle",
        "cx": 4.42,
        "cy": 7.3,
        "r": 1.25,
        "fill": "#484848"
      },
      {
        "type": "circle",
        "cx": 17.58,
        "cy": 7.3,
        "r": 1.25,
        "fill": "#484848"
      }
    ],
    "nim-express": [
      {
        "type": "polygon",
        "d": "M4.98 6.4L6.77 6.4L6.91 10.37L7.78 6.4L9.48 6.4L8.12 12.6L6.33 12.6L6.19 8.63L5.32 12.6L3.62 12.6Z",
        "fill": "accent"
      },
      {
        "type": "polygon",
        "d": "M9.84 8.63L11.54 8.63L10.67 12.6L8.97 12.6Z",
        "fill": "accent"
      },
      {
        "type": "polygon",
        "d": "M10.33 6.4L12.03 6.4L11.7 7.89L10 7.89Z",
        "fill": "accent"
      },
      {
        "type": "polygon",
        "d": "M12.88 6.4L14.67 6.4L15.06 9L16.6 6.4L18.38 6.4L17.02 12.6L15.32 12.6L16.19 8.63L14.59 11.13L14.09 8.63L13.22 12.6L11.52 12.6Z",
        "fill": "accent"
      }
    ],
    "northline": [
      {
        "type": "polygon",
        "d": "M5.6 4.2L8.58 4.2L13.97 8.94L13.97 4.2L16.39 4.2L16.39 11.03L12.48 11.03L5.6 4.98Z",
        "fill": "accent"
      },
      {
        "type": "polygon",
        "d": "M5.6 11.03L8.02 11.03L8.02 7.04L5.6 9.17Z",
        "fill": "accent"
      },
      {
        "type": "polygon",
        "d": "M5.6 13.36L16.39 13.36L16.39 14.79L5.6 14.79Z",
        "fill": "#e3173e"
      }
    ],
    "ozon-logistics": [
      {
        "type": "polygon",
        "d": "M18.26 7.82L18.35 8.63L18.26 9.46L17.99 10.28L17.55 11.09L16.95 11.86L16.2 12.57L15.33 13.21L14.34 13.75L13.28 14.19L12.16 14.52L11.01 14.72L9.86 14.79L8.74 14.73L7.67 14.54L6.69 14.23L5.81 13.81L5.06 13.27L4.45 12.64L4.01 11.94L3.74 11.18L3.65 10.37L3.74 9.54L4.01 8.72L4.45 7.91L5.05 7.14L5.8 6.43L6.67 5.79L7.66 5.25L8.72 4.81L9.84 4.48L10.99 4.28L12.14 4.21L13.26 4.27L14.33 4.46L15.31 4.77L16.19 5.19L16.94 5.73L17.55 6.36L17.99 7.06Z",
        "fill": "accent"
      },
      {
        "type": "polygon",
        "d": "M15.73 8.41L15.75 8.86L15.64 9.32L15.38 9.8L14.99 10.26L14.48 10.7L13.86 11.11L13.16 11.46L12.39 11.76L11.57 11.98L10.74 12.14L9.92 12.21L9.13 12.2L8.4 12.1L7.75 11.93L7.19 11.69L6.76 11.38L6.45 11.01L6.27 10.59L6.25 10.14L6.36 9.68L6.62 9.2L7.01 8.74L7.52 8.3L8.14 7.89L8.84 7.54L9.61 7.24L10.43 7.02L11.26 6.86L12.08 6.79L12.87 6.8L13.6 6.9L14.25 7.07L14.81 7.31L15.24 7.62L15.55 7.99Z",
        "fill": "truck"
      }
    ],
    "pargo": [
      {
        "type": "polygon",
        "d": "M14.89 13L15.62 11.88L16.07 10.61L16.2 9.28L16.01 7.95L15.51 6.71L14.73 5.62L13.71 4.74L12.52 4.14L11.21 3.83L9.87 3.85L8.57 4.18L7.39 4.81L6.39 5.71L5.63 6.81L5.16 8.07L5 9.4L5.16 10.73L5.63 11.99L6.39 13.09L7.39 13.99L8.57 14.62L9.87 14.95L11.21 14.97L12.52 14.66L11.66 12.31L10.69 12.5L9.71 12.37L8.82 11.94L8.11 11.25L7.66 10.38L7.5 9.4L7.66 8.42L8.11 7.55L8.82 6.86L9.71 6.43L10.69 6.3L11.66 6.49L12.52 6.97L13.19 7.7L13.59 8.6L13.69 9.58L13.48 10.54L12.97 11.39Z",
        "fill": "#000000"
      },
      {
        "type": "polygon",
        "d": "M12.3 11.4L14 9.7L17 12.7L15.3 14.4Z",
        "fill": "#000000"
      },
      {
        "type": "polygon",
        "d": "M17.6 15.6L17.6 10.6L12.6 15.6Z",
        "fill": "#000000"
      }
    ],
    "pbt": [
      {
        "type": "line",
        "d": "M3.87 12.6L3.87 6.4L5.61 6.4L6.16 6.5L6.64 6.78L7 7.21L7.19 7.73L7.19 8.29L7 8.82L6.64 9.25L6.16 9.53L5.61 9.62L3.87 9.62M9.08 12.6L9.08 6.4L10.94 6.4L11.4 6.49L11.81 6.75L12.12 7.14L12.28 7.63L12.28 8.15L12.12 8.63L11.81 9.03L11.4 9.29L10.94 9.38L9.08 9.38M9.08 9.38L11.06 9.38L11.57 9.47L12.02 9.75L12.35 10.18L12.53 10.71L12.53 11.27L12.35 11.79L12.02 12.22L11.57 12.5L11.06 12.6L9.08 12.6M14.41 6.4L18.13 6.4M16.27 6.4L16.27 12.6",
        "stroke": "accent",
        "strokeWidth": 1.8
      }
    ],
    "polaris-transport": [
      {
        "type": "polygon",
        "d": "M11 4L11.2 4.91L11.52 5.74L11.94 6.49L12.46 7.16L13.1 7.75L13.84 8.26L14.7 8.69L15.66 9.04L16.72 9.31L17.9 9.5L16.72 9.69L15.66 9.96L14.7 10.31L13.84 10.74L13.1 11.25L12.46 11.84L11.94 12.51L11.52 13.26L11.2 14.09L11 15L10.8 14.09L10.48 13.26L10.06 12.51L9.54 11.84L8.9 11.25L8.16 10.74L7.3 10.31L6.34 9.96L5.28 9.69L4.1 9.5L5.28 9.31L6.34 9.04L7.3 8.69L8.16 8.26L8.9 7.75L9.54 7.16L10.06 6.49L10.48 5.74L10.8 4.91Z",
        "fill": "#fdd310"
      }
    ],
    "posta-kenya": [
      {
        "type": "circle",
        "cx": 11,
        "cy": 9.5,
        "r": 5.5,
        "fill": "accent"
      },
      {
        "type": "line",
        "d": "M5.67 8.84L6.76 8.11L8.1 6.24L10.22 5.28L12.54 5.48L14.45 6.78L15.44 8.85L15.4 10.6L13.31 11.37L12.21 14.89",
        "stroke": "truck",
        "strokeWidth": 1.2
      },
      {
        "type": "circle",
        "cx": 12.65,
        "cy": 8.84,
        "r": 0.68,
        "fill": "truck"
      }
    ],
    "postaplus": [
      {
        "type": "polygon",
        "d": "M12.57 4L9.5 4L8.03 4.52L7.07 5.4L6.74 6.2L12.17 6.2L13.36 6.44L14.23 7.14L14.67 8.1L14.6 9.36L13.97 10.9L12.75 12.12L11.35 12.7L10.41 12.8L9.34 12.8L8.77 15L9.78 15L11.87 14.65L13.88 13.69L15.45 12.29L16.41 10.6L16.74 9.33L17.02 7.49L16.59 5.83L15.28 4.61Z",
        "fill": "accent"
      },
      {
        "type": "polygon",
        "d": "M6.16 8.4L11.54 8.4L12.13 8.54L12.45 8.92L12.39 9.43L12.27 9.8L11.79 10.37L10.74 10.6L7.73 10.6L6.57 15L5.67 14.79L5.1 14.21L4.98 13.43L5.06 12.8Z",
        "fill": "accent"
      }
    ],
    "quiqup": [
      {
        "type": "polygon",
        "d": "M12.5 8.92L8.31 4.73L8.46 4.65L8.89 4.47L9.33 4.33L9.78 4.23L10.24 4.17L10.7 4.15L11.16 4.17L11.62 4.23L12.07 4.33L12.51 4.47L12.94 4.65L13.35 4.86L13.74 5.11L14.11 5.39L14.45 5.7L14.76 6.04L15.03 6.39Z",
        "fill": "accent"
      },
      {
        "type": "polygon",
        "d": "M16 9.45L15.98 9.91L15.92 10.37L15.82 10.82L15.68 11.26L15.5 11.69L15.42 11.84L13.03 9.45L15.42 7.06L15.5 7.21L15.68 7.64L15.82 8.08L15.92 8.53L15.98 8.99Z",
        "fill": "accent"
      },
      {
        "type": "polygon",
        "d": "M13.06 14.19L12.94 14.25L12.51 14.43L12.07 14.57L11.62 14.67L11.16 14.73L10.7 14.75L10.24 14.73L9.78 14.67L9.33 14.57L8.89 14.43L8.46 14.25L8.31 14.17L10.67 11.81Z",
        "fill": "accent"
      },
      {
        "type": "polygon",
        "d": "M5.96 11.81L5.9 11.69L5.72 11.26L5.58 10.82L5.48 10.37L5.42 9.91L5.4 9.45L5.42 8.99L5.48 8.53L5.58 8.08L5.72 7.64L5.9 7.21L5.96 7.09L8.31 9.45Z",
        "fill": "accent"
      },
      {
        "type": "polygon",
        "d": "M12.5 9.98L15.95 13.42L14.65 14.72L11.2 11.28Z",
        "fill": "accent"
      },
      {
        "type": "polygon",
        "d": "M10.67 10.75L6.35 6.42L6.64 6.04L6.95 5.7L7.29 5.39L7.64 5.12L11.97 9.45Z",
        "fill": "#ffd100"
      },
      {
        "type": "polygon",
        "d": "M7.64 13.78L7.29 13.51L6.95 13.2L6.64 12.86L6.36 12.49L9.48 9.34L10.78 10.64Z",
        "fill": "#ffd100"
      }
    ],
    "roadie": [
      {
        "type": "polygon",
        "d": "M9.3 4.5L13.9 4.5L15.14 4.64L16.25 5.06L17.14 5.72L17.7 6.54L17.9 7.45L17.78 8.3L17.42 9.07L16.87 9.67L16.17 10.07L15.4 10.2L3.3 10.2L3.3 8.85L9.3 8.85Z",
        "fill": "#351c13"
      },
      {
        "type": "polygon",
        "d": "M12 6.75L14.25 6.75L14.78 6.89L15.16 7.28L15.3 7.8L15.16 8.32L14.78 8.71L14.25 8.85L12 8.85Z",
        "fill": "truck"
      },
      {
        "type": "polygon",
        "d": "M3.3 11.2L14.9 11.2L15.7 11.55L18.6 14.5L15.35 14.5L13.3 12.55L12 12.55L12 14.5L9.3 14.5L9.3 12.55L3.3 12.55Z",
        "fill": "#351c13"
      }
    ],
    "rpx-indonesia": [
      {
        "type": "line",
        "d": "M4.7 10.2L5.66 4.2L7.34 4.2L7.86 4.29L8.28 4.56L8.57 4.98L8.67 5.49L8.58 6.03L8.32 6.54L7.9 6.96L7.39 7.23L6.84 7.32L5.16 7.32M6.72 7.32L8.18 10.2M9.26 10.2L10.22 4.2L11.9 4.2L12.42 4.29L12.84 4.56L13.13 4.98L13.23 5.49L13.14 6.03L12.88 6.54L12.46 6.96L11.95 7.23L11.4 7.32L9.72 7.32M14.66 4.2L17.3 10.2M18.26 4.2L13.7 10.2",
        "stroke": "#231f20",
        "strokeWidth": 1.7
      },
      {
        "type": "line",
        "d": "M4.77 12L5.47 12.9L6.48 13.67L7.75 14.24L9.18 14.59L10.71 14.7L12.23 14.56L13.64 14.17L14.88 13.57L15.85 12.78L16.4 11.97",
        "stroke": "#231f20",
        "strokeWidth": 1.4
      },
      {
        "type": "polygon",
        "d": "M18.7 9.57L15.2 10.97L17.5 13.27Z",
        "fill": "#231f20"
      }
    ],
    "saee": [
      {
        "type": "line",
        "d": "M14.47 4.93L11.08 4.93L10.19 5.05L9.41 5.41L8.83 5.95L8.52 6.61L8.52 7.32L8.83 7.98L9.41 8.53L10.19 8.88L12.12 9.55L12.9 9.94L13.48 10.54L13.79 11.28L13.79 12.06L13.48 12.79L12.9 13.4L12.12 13.79L11.22 13.92L10.45 13.92",
        "stroke": "accent",
        "strokeWidth": 1.66
      },
      {
        "type": "polygon",
        "d": "M8.8 11.43L10.46 11.43L10.46 13.1L8.8 13.1Z",
        "fill": "accent"
      },
      {
        "type": "polygon",
        "d": "M7.13 13.1L8.8 13.1L8.8 14.76L7.13 14.76Z",
        "fill": "accent"
      }
    ],
    "scg-express": [
      {
        "type": "polygon",
        "d": "M3.6 4.6L6.1 4.6L13.6 14.4L11.1 14.4Z",
        "fill": "#221715"
      },
      {
        "type": "polygon",
        "d": "M11.1 4.6L13.6 4.6L6.1 14.4L3.6 14.4Z",
        "fill": "#221715"
      },
      {
        "type": "polygon",
        "d": "M13.89 4.73L18.9 5.2L18.9 5.6L13.89 6.08Z",
        "fill": "#221715"
      },
      {
        "type": "polygon",
        "d": "M12.13 7.03L18.2 7.5L18.2 7.9L12.13 8.38Z",
        "fill": "#221715"
      }
    ],
    "tanzania-posts": [
      {
        "type": "polygon",
        "d": "M9.89 4.2L13.29 4.2L17.07 7.93L13.66 11.3L10.04 11.3L13.48 7.93Z",
        "fill": "#fadb25"
      },
      {
        "type": "polygon",
        "d": "M8.34 7.53L11.52 7.53L8.04 11.11L11.52 14.78L8.34 14.78L4.41 11.11Z",
        "fill": "#fadb25"
      }
    ],
    "tst-cf-express": [
      {
        "type": "line",
        "d": "M3.66 6.8L5.95 6.8M4.8 6.8L4.14 12.3M8.57 7.59L8.39 7.16L8.09 6.89L7.7 6.8L7.3 6.92L6.94 7.23L6.67 7.67L6.54 8.2L6.56 8.72L6.73 9.15L7.03 9.45L7.41 9.55L7.78 9.65L8.08 9.95L8.25 10.38L8.27 10.9L8.14 11.43L7.87 11.87L7.51 12.18L7.11 12.3L6.73 12.21L6.42 11.94L6.24 11.51M9.53 6.8L11.81 6.8M10.67 6.8L10.01 12.3M12.2 9.88L13.58 9.88M16.91 7.51L16.53 6.97L16.03 6.8L15.49 7.04L14.99 7.64L14.6 8.52L14.38 9.55L14.35 10.58L14.53 11.46L14.89 12.06L15.37 12.3L15.91 12.13L16.42 11.59M19.66 6.8L17.83 6.8L17.17 12.3M17.5 9.55L19.03 9.55",
        "stroke": "accent",
        "strokeWidth": 1.4
      }
    ],
    "uzbekistan-post": [
      {
        "type": "polygon",
        "d": "M3.2 5.45L5.46 5.45L10.96 13.25L8.7 13.25Z",
        "fill": "#f07824"
      },
      {
        "type": "polygon",
        "d": "M5.74 5.45L8 5.45L12.15 11.34L11.39 13.45Z",
        "fill": "#f07824"
      },
      {
        "type": "polygon",
        "d": "M8.28 5.45L10.54 5.45L13.02 8.96L12.25 11.08Z",
        "fill": "#f07824"
      },
      {
        "type": "polygon",
        "d": "M12.27 7.33L17.14 7.33L17.92 7.61L18.41 8.18L18.8 9.21L17.5 9.21L16.44 9.35L15.59 9.78L14.81 10.62L14.18 11.84L13.61 13.35L11.99 13.35L13.61 8.93Z",
        "fill": "accent"
      }
    ],
    "zajil": [
      {
        "type": "line",
        "d": "M6.3 9.58L6.3 6.22L11 4.3L15.7 6.22L15.7 12.93L11 14.91L6.3 12.93L6.3 9.58M6.3 6.22L11 8.14L15.7 6.22M11 8.14L11 14.91",
        "stroke": "#02232a",
        "strokeWidth": 1.5
      }
    ],
    "4-72": [
      {
        "type": "line",
        "d": "M6.67 6.2L6.67 12.8M6.41 6.62L4.63 10.69M3.9 10.69L7.6 10.69M10.1 6.2L13.53 6.2L11.16 12.8M14.56 7.37L14.87 6.84L15.35 6.44L15.93 6.23L16.55 6.23L17.13 6.44L17.6 6.84L17.91 7.37L18.02 7.98L17.76 8.97L15.12 12.8M14.46 12.8L18.02 12.8",
        "stroke": "accent",
        "strokeWidth": 1.6
      },
      {
        "type": "circle",
        "cx": 8.85,
        "cy": 9.5,
        "r": 0.78,
        "fill": "#ffc72c"
      }
    ],
    "aex-paraguay": [
      {
        "type": "circle",
        "cx": 5.9,
        "cy": 9.6,
        "r": 2.7,
        "fill": "accent"
      },
      {
        "type": "circle",
        "cx": 5.9,
        "cy": 9.6,
        "r": 1.15,
        "fill": "truck"
      },
      {
        "type": "polygon",
        "d": "M6.95 6.9L8.6 6.9L8.6 12.3L6.95 12.3Z",
        "fill": "accent"
      },
      {
        "type": "circle",
        "cx": 11.15,
        "cy": 9.6,
        "r": 2.7,
        "fill": "accent"
      },
      {
        "type": "circle",
        "cx": 11.15,
        "cy": 9.6,
        "r": 1.15,
        "fill": "truck"
      },
      {
        "type": "polygon",
        "d": "M11.35 9.85L14.08 10.22L13.78 11.04L13.26 11.73L12.56 12.25Z",
        "fill": "truck"
      },
      {
        "type": "polygon",
        "d": "M9.9 9.15L13.85 9.15L13.85 10.05L9.9 10.05Z",
        "fill": "accent"
      },
      {
        "type": "polygon",
        "d": "M14.3 6.9L16.05 6.9L18.9 12.3L17.15 12.3Z",
        "fill": "accent"
      },
      {
        "type": "polygon",
        "d": "M17.15 6.9L18.9 6.9L16.05 12.3L14.3 12.3Z",
        "fill": "accent"
      }
    ],
    "ampm": [
      {
        "type": "polygon",
        "d": "M6.1 4.2L6.19 5.16L6.47 6.08L6.93 6.92L7.54 7.66L8.28 8.27L9.12 8.73L10.04 9.01L11 9.1L11.96 9.01L12.88 8.73L13.72 8.27L14.46 7.66L15.07 6.92L15.53 6.08L15.81 5.16L15.9 4.2Z",
        "fill": "accent"
      },
      {
        "type": "polygon",
        "d": "M15.9 14.8L15.81 13.84L15.53 12.92L15.07 12.08L14.46 11.34L13.72 10.73L12.88 10.27L11.96 9.99L11 9.9L10.04 9.99L9.12 10.27L8.28 10.73L7.54 11.34L6.93 12.08L6.47 12.92L6.19 13.84L6.1 14.8Z",
        "fill": "accent"
      }
    ],
    "chazki": [
      {
        "type": "polygon",
        "d": "M6.26 10.55L8.54 10.55L8.54 14.94L6.26 14.94Z",
        "fill": "accent"
      },
      {
        "type": "circle",
        "cx": 7.4,
        "cy": 5.7,
        "r": 1.64,
        "fill": "#35d32f"
      },
      {
        "type": "polygon",
        "d": "M13.4 4.12L14.39 5.25L15.13 6.57L15.58 8L15.74 9.5L15.58 11L15.13 12.43L14.39 13.75L13.4 14.88L12.09 12.61L12.57 11.92L12.93 11.16L13.15 10.34L13.22 9.5L13.15 8.66L12.93 7.84L12.57 7.08L12.09 6.39Z",
        "fill": "#35d32f"
      }
    ],
    "cruz-del-sur": [
      {
        "type": "polygon",
        "d": "M7.73 3.97L12.89 6.18L10.86 7.93L7.23 6.32Z",
        "fill": "#1392d1"
      },
      {
        "type": "polygon",
        "d": "M5.89 15.03L5.89 11.84L13.39 6.85L14.4 6.72L16.11 7.76L7.09 14.89Z",
        "fill": "accent"
      }
    ],
    "forza-delivery": [
      {
        "type": "polygon",
        "d": "M9.51 5.22L18.66 5.22L18.66 13.66L15.46 13.66L15.46 11.3L14.31 12.26L12.9 13.15L11.3 13.73L9.7 13.98L8.1 13.98L6.5 13.73L4.9 13.28L3.3 12.58L4.9 12.45L6.5 12.38L8.1 12.13L9.7 11.62L10.85 10.98L11.88 10.14L12.77 9.18L13.54 8.1L9.51 8.1Z",
        "fill": "accent"
      }
    ],
    "guatex": [
      {
        "type": "circle",
        "cx": 11,
        "cy": 9.5,
        "r": 5.3,
        "fill": "#e8732f"
      },
      {
        "type": "polygon",
        "d": "M6.47 12.25L15.53 12.25L14.53 13.45L7.47 13.45Z",
        "fill": "accent"
      },
      {
        "type": "polygon",
        "d": "M10.05 6.4L11.65 6.4L11.65 12.27L10.05 12.27Z",
        "fill": "accent"
      },
      {
        "type": "polygon",
        "d": "M7.65 7.3L9.05 7.3L9.05 10.6L7.65 10.6Z",
        "fill": "accent"
      },
      {
        "type": "polygon",
        "d": "M7.65 9.6L10.15 9.6L10.15 10.9L7.65 10.9Z",
        "fill": "accent"
      },
      {
        "type": "polygon",
        "d": "M12.65 8L14.05 8L14.05 9.9L12.65 9.9Z",
        "fill": "accent"
      },
      {
        "type": "polygon",
        "d": "M11.55 8.7L14.05 8.7L14.05 9.95L11.55 9.95Z",
        "fill": "accent"
      },
      {
        "type": "circle",
        "cx": 10.85,
        "cy": 6.4,
        "r": 0.8,
        "fill": "accent"
      },
      {
        "type": "circle",
        "cx": 8.35,
        "cy": 7.3,
        "r": 0.7,
        "fill": "accent"
      },
      {
        "type": "circle",
        "cx": 13.35,
        "cy": 8,
        "r": 0.7,
        "fill": "accent"
      }
    ],
    "jamaica-post": [
      {
        "type": "polygon",
        "d": "M3.4 4.7L4.28 4.96L5.15 5.13L6.03 5.13L6.9 4.96L7.78 4.7L8.65 4.44L9.53 4.27L10.4 4.27L6.9 9.24Z",
        "fill": "#009b3a"
      },
      {
        "type": "polygon",
        "d": "M3.4 14.2L4.28 14.46L5.15 14.63L6.03 14.63L6.9 14.46L7.78 14.2L8.65 13.94L9.53 13.77L10.4 13.77L6.9 9.24Z",
        "fill": "#009b3a"
      },
      {
        "type": "polygon",
        "d": "M3.4 4.7L6.9 9.24L3.4 14.2Z",
        "fill": "#141414"
      },
      {
        "type": "polygon",
        "d": "M10.4 4.27L6.9 9.24L10.4 13.77Z",
        "fill": "#141414"
      },
      {
        "type": "line",
        "d": "M3.4 4.7L10.4 13.77M10.4 4.27L3.4 14.2",
        "stroke": "#fed100",
        "strokeWidth": 1.5
      },
      {
        "type": "line",
        "d": "M11.9 7.6L12.47 7.99L13.05 8.15L13.62 7.99L14.2 7.6L14.78 7.21L15.35 7.05L15.93 7.21L16.5 7.6L17.07 7.99L17.65 8.15L18.23 7.99L18.8 7.6M11.9 10.4L12.47 10.79L13.05 10.95L13.62 10.79L14.2 10.4L14.78 10.01L15.35 9.85L15.93 10.01L16.5 10.4L17.07 10.79L17.65 10.95L18.23 10.79L18.8 10.4M11.9 13.2L12.47 13.59L13.05 13.75L13.62 13.59L14.2 13.2L14.78 12.81L15.35 12.65L15.93 12.81L16.5 13.2L17.07 13.59L17.65 13.75L18.23 13.59L18.8 13.2",
        "stroke": "accent",
        "strokeWidth": 1.4
      }
    ],
    "laar-courier": [
      {
        "type": "line",
        "d": "M5.68 4.5L4.23 9.32L7.63 9.32M12.95 5.28L9.75 5.28L8.53 9.32L11.73 9.32M16.13 9.32L12.73 9.32L13.95 5.28L17.05 5.28L16.41 7.41L13.31 7.41",
        "stroke": "#1d1d1d",
        "strokeWidth": 1.55
      },
      {
        "type": "polygon",
        "d": "M3.1 13.2L18.8 11.6L18.8 12.3L4.4 14.6L3.1 14.6Z",
        "fill": "#1d1d1d"
      }
    ],
    "pullman-cargo": [
      {
        "type": "circle",
        "cx": 11,
        "cy": 8.35,
        "r": 4,
        "fill": "accent"
      },
      {
        "type": "circle",
        "cx": 11,
        "cy": 8.35,
        "r": 1.95,
        "fill": "truck"
      },
      {
        "type": "polygon",
        "d": "M7 8.35L9 8.35L9.1 15L7.6 15L7 14.4Z",
        "fill": "accent"
      }
    ],
    "tealca": [
      {
        "type": "polygon",
        "d": "M9.6 8.6L9.7 5.4L9.78 4.97L10 4.6L10.35 4.32L10.77 4.17L11.23 4.17L11.65 4.32L12 4.6L12.22 4.97L12.65 5.4L12.75 6.3L12.3 6L12.4 8.6L11 9.6Z",
        "fill": "accent"
      },
      {
        "type": "circle",
        "cx": 10.9,
        "cy": 5.6,
        "r": 0.5,
        "fill": "truck"
      },
      {
        "type": "polygon",
        "d": "M3 4.9L9.2 7.6L9.2 9L4.2 6.9Z",
        "fill": "accent"
      },
      {
        "type": "polygon",
        "d": "M19 4.9L12.8 7.6L12.8 9L17.8 6.9Z",
        "fill": "accent"
      },
      {
        "type": "polygon",
        "d": "M4.7 8L9.2 9.9L9.2 11.3L5.9 10Z",
        "fill": "accent"
      },
      {
        "type": "polygon",
        "d": "M17.3 8L12.8 9.9L12.8 11.3L16.1 10Z",
        "fill": "accent"
      },
      {
        "type": "polygon",
        "d": "M6.4 11.1L9.2 12.2L9.2 13.4L7.6 13Z",
        "fill": "accent"
      },
      {
        "type": "polygon",
        "d": "M15.6 11.1L12.8 12.2L12.8 13.4L14.4 13Z",
        "fill": "accent"
      },
      {
        "type": "polygon",
        "d": "M9.2 8.6L12.8 8.6L12.8 13.4L9.2 13.4Z",
        "fill": "accent"
      },
      {
        "type": "polygon",
        "d": "M9.6 13.9L12.4 13.9L11 15.2Z",
        "fill": "accent"
      }
    ],
    "tufesa": [
      {
        "type": "polygon",
        "d": "M3.47 5.3L9.88 5.3L9.82 7.3L6.87 7.3L6.28 13.46L4.19 13.46L4.78 7.3L3.4 7.3Z",
        "fill": "accent"
      },
      {
        "type": "polygon",
        "d": "M10.61 5.3L15.52 5.3L17.02 5.61L18.01 6.46L18.46 7.84L18.33 9.23L17.68 10.38L16.5 11.07L15.06 11.31L12.44 11.31L12.11 13.54L9.95 13.54Z",
        "fill": "#232321"
      },
      {
        "type": "polygon",
        "d": "M13.03 7.38L15.85 7.38L16.3 7.99L16.24 8.77L15.71 9.3L12.83 9.3Z",
        "fill": "truck"
      }
    ],
    "via-cargo": [
      {
        "type": "polygon",
        "d": "M3 5.13L7.33 5.13L8.56 10.63L14.5 5.13L19 5.13L10.16 13.7L5 13.87Z",
        "fill": "accent"
      }
    ],
    "yimidida": [
      {
        "type": "polygon",
        "d": "M11.78 8.72L7.96 4.9L6.4 6.46L10.22 10.28Z",
        "fill": "#221814"
      },
      {
        "type": "polygon",
        "d": "M11 8.4L5.6 8.4L5.6 10.6L11 10.6Z",
        "fill": "#221814"
      },
      {
        "type": "polygon",
        "d": "M10.22 8.72L6.4 12.54L7.96 14.1L11.78 10.28Z",
        "fill": "#221814"
      },
      {
        "type": "polygon",
        "d": "M11.78 10.28L15.6 6.46L14.04 4.9L10.22 8.72Z",
        "fill": "#221814"
      },
      {
        "type": "polygon",
        "d": "M11 10.6L16.4 10.6L16.4 8.4L11 8.4Z",
        "fill": "#221814"
      },
      {
        "type": "polygon",
        "d": "M10.22 10.28L14.04 14.1L15.6 12.54L11.78 8.72Z",
        "fill": "#221814"
      },
      {
        "type": "polygon",
        "d": "M9.85 4.3L12.15 4.3L12.15 14.7L9.85 14.7Z",
        "fill": "accent"
      }
    ],
    "zoom-ve": [
      {
        "type": "polygon",
        "d": "M11.34 4.51L13.22 4.6L14.76 5.03L15.87 5.63L16.55 6.14L17.07 5.97L17.49 5.11L17.92 5.28L18.01 5.97L18.43 6.31L18.95 6.74L18.69 7.08L17.84 7.17L16.98 7.42L15.78 7.68L15.27 8.19L14.84 8.79L14.41 8.62L14.59 7.85L13.73 7.85L13.65 8.88L13.99 9.99L16.04 11.7L15.78 12.47L14.07 11.53L12.45 10.41L12.02 9.22L11.34 8.88L10.48 8.19L9.8 7.68L9.11 7.34L9.46 5.97L10.31 5.11Z",
        "fill": "accent"
      },
      {
        "type": "polygon",
        "d": "M8.96 5.82L7.53 7.08L6.08 8.4L4.85 9.37L4.19 9.68L3.79 9.39L3.15 10.41L4.12 10.98L5.51 10.6L7.02 9.69L8.64 8.62L10.29 7.82Z",
        "fill": "accent"
      }
    ],
    "mayiyinfu": [
      {
        "type": "polygon",
        "d": "M8.9 9.02L8.95 9.49L8.85 9.98L8.6 10.46L8.23 10.9L7.75 11.29L7.17 11.6L6.54 11.83L5.89 11.95L5.23 11.96L4.62 11.87L4.07 11.67L3.63 11.38L3.3 11.01L3.1 10.58L3.05 10.11L3.15 9.62L3.4 9.14L3.77 8.7L4.25 8.31L4.83 8L5.46 7.77L6.11 7.65L6.77 7.64L7.38 7.73L7.93 7.93L8.37 8.22L8.7 8.59Z",
        "fill": "accent"
      },
      {
        "type": "polygon",
        "d": "M12.88 9.08L12.87 9.29L12.78 9.51L12.62 9.71L12.39 9.9L12.11 10.05L11.78 10.17L11.43 10.24L11.08 10.27L10.73 10.24L10.42 10.17L10.14 10.06L9.93 9.91L9.78 9.73L9.72 9.52L9.73 9.31L9.82 9.09L9.98 8.89L10.21 8.7L10.49 8.55L10.82 8.43L11.17 8.36L11.52 8.33L11.87 8.36L12.18 8.43L12.46 8.54L12.67 8.69L12.82 8.87Z",
        "fill": "accent"
      },
      {
        "type": "circle",
        "cx": 14.9,
        "cy": 8.3,
        "r": 1.6,
        "fill": "accent"
      },
      {
        "type": "line",
        "d": "M10.3 9.8L9.1 12L8.3 14.6M11.3 10L11.9 12.2L11.5 14.6M12.3 9.7L14.1 11.6L15 14.4",
        "stroke": "accent",
        "strokeWidth": 1.4
      },
      {
        "type": "line",
        "d": "M15.7 6.9L16.4 4.8L18.6 4.4",
        "stroke": "accent",
        "strokeWidth": 1.4
      }
    ],
    "cttyex": [
      {
        "type": "line",
        "d": "M14.11 6.39L13.5 5.88L12.81 5.49L12.05 5.23L11.27 5.11L10.47 5.13L9.69 5.3L8.96 5.6L8.29 6.04L7.71 6.58L7.23 7.22L6.89 7.94L6.67 8.71L6.6 9.5L6.67 10.29L6.89 11.06L7.23 11.78L7.71 12.42L8.29 12.96L8.96 13.4L9.69 13.7L10.47 13.87L11.27 13.89L12.05 13.77L12.81 13.51L13.5 13.12L14.11 12.61",
        "stroke": "accent",
        "strokeWidth": 2.2
      },
      {
        "type": "polygon",
        "d": "M10 7.6L10 11.4L13.3 9.5Z",
        "fill": "#E88C20"
      }
    ],
    "ameex": [
      {
        "type": "polygon",
        "d": "M5.15 4L8.55 4L10.91 7.2L13.35 4L16.95 4L13.05 9.3L17.05 14.6L13.55 14.6L10.91 11.4L8.55 14.6L5.15 14.6L5.15 14.1L7.65 10.7L4.75 10.7L4.75 7.9L7.65 7.9L5.15 4.5Z",
        "fill": "accent"
      }
    ],
    "amerijet": [
      {
        "type": "polygon",
        "d": "M7.34 4.27L9.9 4.27L17.35 12L14.73 12L11.55 11.17L9 14.83L8.38 11.59L4.65 9.24L7.96 9.24Z",
        "fill": "accent"
      },
      {
        "type": "polygon",
        "d": "M8.78 6.89L11.04 9.24L9.07 9.24Z",
        "fill": "truck"
      },
      {
        "type": "polygon",
        "d": "M8.45 10.34L10.79 10.34L9.59 12.05L9.37 10.9Z",
        "fill": "truck"
      },
      {
        "type": "polygon",
        "d": "M9.91 5.38L15.76 11.45L14.32 11.45L8.47 5.38Z",
        "fill": "#eb1f27"
      }
    ],
    "anousith": [
      {
        "type": "polygon",
        "d": "M6.88 4.62L9.75 4.62L11.88 8.75L8.62 14.38L5.62 14.38L8.88 8.75Z",
        "fill": "accent"
      },
      {
        "type": "polygon",
        "d": "M11.38 4.62L14.25 4.62L16.38 8.75L13.12 14.38L10.12 14.38L13.38 8.75Z",
        "fill": "accent"
      }
    ],
    "ap-cargo": [
      {
        "type": "polygon",
        "d": "M10.53 5.24L10.59 4.8L10.76 4.56L11.06 4.52L11.48 4.7L15.6 7.08L15.17 10.2L10.53 7.54Z",
        "fill": "#41463f"
      },
      {
        "type": "polygon",
        "d": "M14.92 11.22L15.28 11.49L15.4 11.77L15.28 12.04L14.92 12.32L10.79 14.69L8.31 12.76L12.93 10.07Z",
        "fill": "#41463f"
      },
      {
        "type": "polygon",
        "d": "M7.55 12.04L7.13 12.21L6.84 12.18L6.66 11.94L6.6 11.49L6.61 6.73L9.52 5.54L9.54 10.89Z",
        "fill": "#41463f"
      }
    ],
    "bookurier": [
      {
        "type": "polygon",
        "d": "M9.02 4.38L9.18 5.13L9.62 5.77L10.29 6.19L11.07 6.34L12.67 6.34L12.67 5.52L14.93 7.04L12.67 8.56L12.67 7.72L10.11 7.72L9.16 7.92L8.36 8.48L7.83 9.33L7.64 10.33L12.3 10.33L12.88 10.49L13.3 10.91L13.45 11.49L13.3 12.07L12.88 12.49L12.3 12.65L8.24 12.65L7.16 12.8L6.24 13.23L5.63 13.87L5.41 14.62L11.99 14.62L13.52 14.39L14.81 13.72L15.67 12.73L15.97 11.55L15.67 10.37L14.81 9.38L14.38 9.37L15.54 8.54L16.27 7.79L16.58 6.87L16.41 5.93L15.79 5.11L14.82 4.57L13.65 4.38L9.02 4.38Z",
        "fill": "accent"
      }
    ],
    "botswana-post": [
      {
        "type": "polygon",
        "d": "M4.75 11.52L12.59 4.1L17.25 8.34L11.53 14.6L6.97 14.6Z",
        "fill": "#fdf003"
      },
      {
        "type": "line",
        "d": "M4.75 11.52L10.89 9.62L12.59 4.1",
        "stroke": "truck",
        "strokeWidth": 1.3
      }
    ],
    "bts-uz": [
      {
        "type": "line",
        "d": "M6.57 6.93L13.28 4.95L15.57 12.72",
        "stroke": "accent",
        "strokeWidth": 1.45
      },
      {
        "type": "polygon",
        "d": "M6.1 8.37L8.74 7.59L9.52 10.23L6.88 11Z",
        "fill": "accent"
      },
      {
        "type": "polygon",
        "d": "M7.19 12.06L9.83 11.28L10.6 13.92L7.97 14.7Z",
        "fill": "accent"
      },
      {
        "type": "polygon",
        "d": "M9.8 7.28L12.43 6.5L13.21 9.14L10.57 9.92Z",
        "fill": "accent"
      },
      {
        "type": "polygon",
        "d": "M10.88 10.97L13.52 10.2L14.3 12.83L11.66 13.61Z",
        "fill": "accent"
      }
    ],
    "budbee": [
      {
        "type": "circle",
        "cx": 11.2,
        "cy": 11.1,
        "r": 3.5,
        "fill": "accent"
      },
      {
        "type": "circle",
        "cx": 11.2,
        "cy": 11.1,
        "r": 1.65,
        "fill": "truck"
      },
      {
        "type": "polygon",
        "d": "M7.7 4.3L9.55 4.3L9.55 14.6L7.7 14.6Z",
        "fill": "accent"
      }
    ],
    "bussgods": [
      {
        "type": "polygon",
        "d": "M6.13 14.59L6.84 12.55L7.81 10.34L8.96 9.28L10.2 8.48L12.06 7.15L13.92 6.18L15.87 5.56L14.19 7.07L12.59 8.84L11.18 10.43L10.2 11.76L8.88 13L7.81 13.79L6.93 14.32Z",
        "fill": "#f61821"
      },
      {
        "type": "polygon",
        "d": "M7.81 4.41L10.29 4.41L10.29 14.5L7.81 14.5Z",
        "fill": "accent"
      },
      {
        "type": "polygon",
        "d": "M10.2 4.41L11.97 4.41L12.98 4.63L13.8 5.23L14.28 6.12L14.33 7.11L13.93 8.03L13.17 8.7L13.12 9.28L10.2 9.46L10.2 8.57L11 8.57L11.6 8.41L12.03 7.97L12.19 7.38L12.03 6.78L11.6 6.34L11 6.18L10.2 6.18Z",
        "fill": "accent"
      },
      {
        "type": "polygon",
        "d": "M10.2 9.19L13.12 9.1L14.55 10.19L15.11 11.06L15.24 12.04L14.93 13L14.23 13.79L13.23 14.32L12.06 14.5L10.2 14.5L10.2 12.73L11.66 12.73L12.26 12.57L12.7 12.13L12.86 11.54L12.7 10.94L12.26 10.5L11.66 10.34L10.2 10.34Z",
        "fill": "accent"
      }
    ],
    "campost": [
      {
        "type": "polygon",
        "d": "M3.48 3.95L5.22 4.45L7.16 5.15L8.91 5.85L10.07 6.55L10.85 7.45L11.53 8.75L12.3 10.35L13.28 11.95L14.05 10.95L14.92 10.15L15.89 9.75L16.86 9.85L17.54 10.25L18.61 10.95L17.25 11.25L16.28 11.55L15.31 12.35L14.44 13.35L13.66 14.55L12.69 13.95L11.43 12.35L9.88 11.25L7.94 10.25L6.19 9.35L5.03 7.95L4.25 6.15Z",
        "fill": "#144082"
      }
    ],
    "correos-bolivia": [
      {
        "type": "polygon",
        "d": "M3.6 6.9L9.6 5.5L10.6 7.3L8.4 7.9Z",
        "fill": "#e30613"
      },
      {
        "type": "polygon",
        "d": "M3 11.3L9.4 9.7L8.2 11.9Z",
        "fill": "#009640"
      },
      {
        "type": "polygon",
        "d": "M9.6 4.6L18.8 4.2L17.6 12L7.6 12.8Z",
        "fill": "#20539a"
      },
      {
        "type": "line",
        "d": "M9.9 4.85L13.4 8.6L18.5 4.45",
        "stroke": "truck",
        "strokeWidth": 1.2
      }
    ],
    "courier-plus-ng": [
      {
        "type": "polygon",
        "d": "M6.3 7.3L7.55 6.07L9.43 5.03L11.55 4.41L13.55 4.33L15.55 4.67L17.3 5.38L18.8 6.25L17.55 7.3L16.3 8.35L15.05 9.57L13.8 8.53L11.93 8L9.43 7.65Z",
        "fill": "#6a2a5e"
      },
      {
        "type": "polygon",
        "d": "M3.2 11.8L4.42 10.6L6.25 9.58L8.32 8.98L10.28 8.9L12.23 9.24L13.94 9.92L15.4 10.78L14.18 11.8L12.96 12.82L11.74 14.02L10.52 13L8.69 12.48L6.25 12.14Z",
        "fill": "accent"
      }
    ],
    "credifin": [
      {
        "type": "polygon",
        "d": "M9 4.2L18.9 4.2L18.9 5.2L18.83 5.58L18.64 5.91L18.34 6.12L18 6.2L15.9 6.9L16.9 7.2L17.28 7.28L17.61 7.49L17.82 7.82L17.9 8.2L17.82 8.58L17.61 8.91L17.28 9.12L16.9 9.2L14.4 10.3L15.4 10.8L15.78 10.88L16.11 11.09L16.32 11.42L16.4 11.8L16.32 12.18L16.11 12.51L15.78 12.72L15.4 12.8L9.4 12.8L7.7 14L6.35 13.44L5.51 12.78L4.82 11.95L4.33 10.99L4.06 9.95L4.01 8.88L4.19 7.82L4.6 6.83L5.21 5.94L5.99 5.21L6.91 4.66L7.93 4.32Z",
        "fill": "accent"
      },
      {
        "type": "polygon",
        "d": "M9 5.8L8.11 5.92L7.27 6.27L6.57 6.83L6.03 7.55L5.7 8.39L5.6 9.29L5.74 10.18L6.12 11L12.6 11L13.1 9.2L14 9.2L14.4 7.6L14.9 5.8Z",
        "fill": "#e1001e"
      },
      {
        "type": "polygon",
        "d": "M16.9 7.6L10.6 7.6L10.2 7.71L9.91 8L9.8 8.4L9.91 8.8L10.2 9.09L10.6 9.2L16.9 9.2Z",
        "fill": "accent"
      }
    ],
    "daewoo-fastex": [
      {
        "type": "polygon",
        "d": "M4.94 7.14L4.28 8.01L3.86 8.99L3.7 10.02L3.82 11.06L4.2 12.04L4.82 12.93L5.66 13.67L6.68 14.23L7.81 14.58L9 14.7L9.21 13.29L8.94 11.93L8.51 10.67L7.92 9.56L7.21 8.64L6.39 7.94L5.5 7.49L4.57 7.3Z",
        "fill": "accent"
      },
      {
        "type": "polygon",
        "d": "M17.06 7.14L17.72 8.01L18.14 8.99L18.3 10.02L18.18 11.06L17.8 12.04L17.18 12.93L16.34 13.67L15.32 14.23L14.19 14.58L13 14.7L12.79 13.29L13.06 11.93L13.49 10.67L14.08 9.56L14.79 8.64L15.61 7.94L16.5 7.49L17.43 7.3Z",
        "fill": "accent"
      },
      {
        "type": "polygon",
        "d": "M10.79 14.93L5.52 7.13L6.8 6.36L11.21 14.67Z",
        "fill": "accent"
      },
      {
        "type": "polygon",
        "d": "M10.76 14.86L7.56 4.85L9.01 4.46L11.24 14.74Z",
        "fill": "accent"
      },
      {
        "type": "polygon",
        "d": "M10.75 14.8L10.25 4L11.75 4L11.25 14.8Z",
        "fill": "accent"
      },
      {
        "type": "polygon",
        "d": "M10.76 14.74L12.99 4.46L14.44 4.85L11.24 14.86Z",
        "fill": "accent"
      },
      {
        "type": "polygon",
        "d": "M10.79 14.67L15.2 6.36L16.48 7.13L11.21 14.93Z",
        "fill": "accent"
      }
    ],
    "easy-mail": [
      {
        "type": "polygon",
        "d": "M3.53 7.1L3.53 5.94L3.62 5.45L3.9 5.04L4.31 4.76L4.8 4.66L17.2 4.66L17.69 4.76L18.1 5.04L18.38 5.45L18.47 5.94L18.47 13.06L18.38 13.55L18.1 13.96L17.69 14.24L17.2 14.34L8.85 14.34L9.8 13.55L10.51 12.53L10.92 11.36L10.98 10.12L10.71 8.91L10.12 7.82L9.26 6.94L8.19 6.32L6.98 6.02L5.74 6.05L4.56 6.42Z",
        "fill": "#fdb945"
      },
      {
        "type": "polygon",
        "d": "M10.09 6.04L14.45 5.06L15.37 5.11L16.17 5.41L16.75 5.94L17.04 6.65L16.91 7.45L16.51 8.11L16.04 8.59L16.96 8.96L17.68 9.65L18.02 10.55L17.86 11.5L17.31 12.24L16.17 12.77L11.22 13.73L11.65 12.99L11.96 12.2L12.15 11.37L12.22 10.51L12.16 9.66L11.97 8.83L11.66 8.04L11.24 7.3L10.71 6.63Z",
        "fill": "truck"
      },
      {
        "type": "polygon",
        "d": "M12.86 7.05L14.23 6.78L14.66 7.15L14.71 7.68L14.42 8.06L13.12 8.32Z",
        "fill": "#fdb945"
      },
      {
        "type": "polygon",
        "d": "M13.44 9.86L15.45 9.49L15.82 9.96L15.82 10.65L15.5 11.05L13.76 11.39Z",
        "fill": "#fdb945"
      }
    ],
    "evropat": [
      {
        "type": "polygon",
        "d": "M18.41 5.16L17.18 4.76L15.86 4.48L14.49 4.32L13.11 4.26L11.72 4.32L10.37 4.48L9.08 4.75L7.88 5.12L6.77 5.59L5.79 6.16L4.95 6.81L4.27 7.56L3.77 8.4L3.49 9.32L3.53 10.27L3.86 11.17L4.39 11.98L5.1 12.69L5.96 13.3L6.95 13.82L8.06 14.24L9.28 14.56L10.56 14.77L11.9 14.84L10.62 14.49L9.41 14.09L8.31 13.62L7.35 13.08L6.54 12.48L5.91 11.85L5.47 11.22L5.21 10.61L5.13 10.04L5.14 9.52L5.23 8.97L5.49 8.38L5.92 7.78L6.54 7.18L7.33 6.62L8.28 6.11L9.36 5.67L10.55 5.31L11.81 5.04L13.13 4.87L14.48 4.8L15.82 4.83L17.14 4.96Z",
        "fill": "#eb2c1b"
      },
      {
        "type": "polygon",
        "d": "M16.49 6.66L15.54 6.44L14.55 6.31L13.54 6.25L12.54 6.28L11.55 6.37L10.61 6.54L9.73 6.77L8.92 7.07L8.2 7.43L7.57 7.86L7.06 8.36L6.68 8.93L6.45 9.58L6.42 10.27L6.64 10.93L7.05 11.5L7.59 11.98L8.24 12.39L8.98 12.73L9.8 13.01L10.69 13.21L11.63 13.34L12.61 13.39L13.61 13.34L12.64 13.15L11.7 12.93L10.83 12.66L10.04 12.33L9.35 11.96L8.78 11.56L8.34 11.14L8.05 10.74L7.89 10.36L7.82 10.05L7.78 9.76L7.83 9.43L8 9.06L8.3 8.66L8.75 8.26L9.32 7.88L10.01 7.53L10.8 7.23L11.67 6.98L12.59 6.79L13.56 6.67L14.54 6.61L15.53 6.61Z",
        "fill": "#eb2c1b"
      },
      {
        "type": "polygon",
        "d": "M10.6 6.95L14.9 6.95L14.9 8.3L11.95 8.3L11.95 9.03L14.55 9.03L14.55 10.38L11.95 10.38L11.95 11.1L14.9 11.1L14.9 12.45L10.6 12.45Z",
        "fill": "accent"
      }
    ],
    "exline-kz": [
      {
        "type": "circle",
        "cx": 11,
        "cy": 9.55,
        "r": 5,
        "fill": "accent"
      },
      {
        "type": "line",
        "d": "M11 4.6L11 14.5",
        "stroke": "truck",
        "strokeWidth": 0.9
      },
      {
        "type": "line",
        "d": "M10.23 4.8L9.54 5.36L9.13 5.92L8.84 6.48L8.63 7.03L8.47 7.59L8.36 8.15M10.23 14.3L9.54 13.74L9.13 13.18L8.84 12.62L8.63 12.07L8.47 11.51L8.36 10.95",
        "stroke": "truck",
        "strokeWidth": 0.9
      },
      {
        "type": "line",
        "d": "M11.77 4.8L12.46 5.36L12.87 5.92L13.16 6.48L13.37 7.03L13.53 7.59L13.64 8.15M11.77 14.3L12.46 13.74L12.87 13.18L13.16 12.62L13.37 12.07L13.53 11.51L13.64 10.95",
        "stroke": "truck",
        "strokeWidth": 0.9
      },
      {
        "type": "line",
        "d": "M7.29 6.25L14.71 6.25",
        "stroke": "truck",
        "strokeWidth": 0.9
      },
      {
        "type": "line",
        "d": "M7.29 12.85L14.71 12.85",
        "stroke": "truck",
        "strokeWidth": 0.9
      },
      {
        "type": "polygon",
        "d": "M4.45 8.15L17.55 8.15L17.9 9.55L17.55 10.95L4.45 10.95L4.1 9.55Z",
        "fill": "#f3311d"
      }
    ],
    "fargo-uz": [
      {
        "type": "polygon",
        "d": "M3.31 5.61L18.12 5.61L4.45 7.89Z",
        "fill": "#17130f"
      },
      {
        "type": "polygon",
        "d": "M5.3 9.6L18.7 5.89L7.29 13.59L5.87 11.31L4.45 11.88Z",
        "fill": "accent"
      }
    ],
    "fastfrate": [
      {
        "type": "polygon",
        "d": "M5.8 4.45L16.2 4.45L16.2 5.77L5.8 5.77Z",
        "fill": "#141414"
      },
      {
        "type": "polygon",
        "d": "M5.8 6.67L16.2 6.67L16.2 7.99L5.8 7.99Z",
        "fill": "#141414"
      },
      {
        "type": "polygon",
        "d": "M5.8 8.89L14.85 8.89L14.85 10.21L5.8 10.21Z",
        "fill": "accent"
      },
      {
        "type": "polygon",
        "d": "M5.8 11.11L11 11.11L11 12.43L5.8 12.43Z",
        "fill": "accent"
      },
      {
        "type": "polygon",
        "d": "M5.8 13.33L11 13.33L11 14.65L5.8 14.65Z",
        "fill": "accent"
      }
    ],
    "first-delivery-tn": [
      {
        "type": "polygon",
        "d": "M11.37 4L9.52 4L8.46 6.16L9.78 6.16L6.93 14.59L11.97 14.59L15.47 4Z",
        "fill": "accent"
      }
    ],
    "franch-express": [
      {
        "type": "polygon",
        "d": "M3.9 4.8L6.3 4.8L10.7 9.5L6.3 14.2L3.9 14.2L8.3 9.5Z",
        "fill": "accent"
      },
      {
        "type": "polygon",
        "d": "M7.6 4.8L10 4.8L14.4 9.5L10 14.2L7.6 14.2L12 9.5Z",
        "fill": "accent"
      },
      {
        "type": "polygon",
        "d": "M11.3 4.8L13.7 4.8L18.1 9.5L13.7 14.2L11.3 14.2L15.7 9.5Z",
        "fill": "accent"
      }
    ],
    "gel-express": [
      {
        "type": "polygon",
        "d": "M9.03 8.8L6.08 8.8L5.37 8.98L4.78 9.47L4.46 10.15L3.82 13.35L3.87 14.03L4.26 14.52L4.9 14.7L6.5 14.7L7.21 14.52L7.8 14.03L8.12 13.35L8.44 11.75L6.16 11.75L5.91 12.98L6.89 12.98L6.86 13.15L6.56 13.4L5.36 13.4L5.16 13.15L5.72 10.35L6.02 10.1L8.77 10.1Z",
        "fill": "accent"
      },
      {
        "type": "polygon",
        "d": "M9.88 8.8L13.18 8.8L12.92 10.1L10.92 10.1L10.72 11.1L12.42 11.1L12.16 12.4L10.46 12.4L10.26 13.4L12.26 13.4L12 14.7L8.7 14.7Z",
        "fill": "accent"
      },
      {
        "type": "polygon",
        "d": "M14.03 8.8L15.33 8.8L14.41 13.4L16.21 13.4L15.95 14.7L12.85 14.7Z",
        "fill": "accent"
      },
      {
        "type": "polygon",
        "d": "M9 6.4L9.8 7.2L9 8L8.2 7.2Z",
        "fill": "accent"
      },
      {
        "type": "polygon",
        "d": "M12.2 5.55L13.1 6.45L12.2 7.35L11.3 6.45Z",
        "fill": "accent"
      },
      {
        "type": "polygon",
        "d": "M15.4 4.75L16.35 5.7L15.4 6.65L14.45 5.7Z",
        "fill": "accent"
      },
      {
        "type": "polygon",
        "d": "M18.2 4.3L18.95 5.05L18.2 5.8L17.45 5.05Z",
        "fill": "accent"
      }
    ],
    "gobolt": [
      {
        "type": "polygon",
        "d": "M15 4L8.56 7.9L10.19 7.9L7.82 10.25L10.11 10.25L11.89 7.95Z",
        "fill": "#ffbd5d"
      },
      {
        "type": "polygon",
        "d": "M11.89 7.95L14.48 7.95L12.11 10.25L13.59 10.25L7 14.2L10.11 10.25Z",
        "fill": "#b27330"
      }
    ],
    "gogo-xpress": [
      {
        "type": "line",
        "d": "M6.04 7.56L5.79 7.15L5.48 6.89L5.16 6.8L4.83 6.88L4.52 7.14L4.27 7.54L4.08 8.07L3.97 8.67L3.95 9.3L4.03 9.92L4.19 10.48L4.42 10.93L4.71 11.24L5.04 11.39L5.37 11.36L5.68 11.16L5.96 10.8L6.17 10.31L6.3 9.73L6.35 9.1L5.25 9.1",
        "stroke": "accent",
        "strokeWidth": 1.4
      },
      {
        "type": "polygon",
        "d": "M10.95 9.1L10.91 8.51L10.81 7.95L10.63 7.43L10.39 6.98L10.11 6.61L9.78 6.33L9.42 6.16L9.05 6.1L8.68 6.16L8.32 6.33L7.99 6.61L7.71 6.98L7.47 7.43L7.29 7.95L7.19 8.51L7.15 9.1L7.19 9.69L7.29 10.25L7.47 10.77L7.71 11.22L7.99 11.59L8.32 11.87L8.68 12.04L9.05 12.1L9.42 12.04L9.78 11.87L10.11 11.59L10.39 11.22L10.63 10.77L10.81 10.25L10.91 9.69Z",
        "fill": "#c21f44"
      },
      {
        "type": "polygon",
        "d": "M9.55 9.1L9.53 8.69L9.48 8.3L9.4 7.97L9.3 7.71L9.18 7.55L9.05 7.5L8.92 7.55L8.8 7.71L8.7 7.97L8.62 8.3L8.57 8.69L8.55 9.1L8.57 9.51L8.62 9.9L8.7 10.23L8.8 10.49L8.92 10.65L9.05 10.7L9.18 10.65L9.3 10.49L9.4 10.23L9.48 9.9L9.53 9.51Z",
        "fill": "truck"
      },
      {
        "type": "line",
        "d": "M13.84 7.56L13.59 7.15L13.28 6.89L12.96 6.8L12.63 6.88L12.32 7.14L12.07 7.54L11.88 8.07L11.77 8.67L11.75 9.3L11.83 9.92L11.99 10.48L12.22 10.93L12.51 11.24L12.84 11.39L13.17 11.36L13.48 11.16L13.76 10.8L13.97 10.31L14.1 9.73L14.15 9.1L13.05 9.1",
        "stroke": "accent",
        "strokeWidth": 1.4
      },
      {
        "type": "polygon",
        "d": "M18.75 9.1L18.71 8.51L18.61 7.95L18.43 7.43L18.19 6.98L17.91 6.61L17.58 6.33L17.22 6.16L16.85 6.1L16.48 6.16L16.12 6.33L15.79 6.61L15.51 6.98L15.27 7.43L15.09 7.95L14.99 8.51L14.95 9.1L14.99 9.69L15.09 10.25L15.27 10.77L15.51 11.22L15.79 11.59L16.12 11.87L16.48 12.04L16.85 12.1L17.22 12.04L17.58 11.87L17.91 11.59L18.19 11.22L18.43 10.77L18.61 10.25L18.71 9.69Z",
        "fill": "#c21f44"
      },
      {
        "type": "polygon",
        "d": "M17.35 9.1L17.33 8.69L17.28 8.3L17.2 7.97L17.1 7.71L16.98 7.55L16.85 7.5L16.72 7.55L16.6 7.71L16.5 7.97L16.42 8.3L16.37 8.69L16.35 9.1L16.37 9.51L16.42 9.9L16.5 10.23L16.6 10.49L16.72 10.65L16.85 10.7L16.98 10.65L17.1 10.49L17.2 10.23L17.28 9.9L17.33 9.51Z",
        "fill": "truck"
      }
    ],
    "horoz": [
      {
        "type": "polygon",
        "d": "M5.65 4L6.21 4.25L6.77 4.5L7.46 4.69L8.08 4.94L9.33 5.87L8.86 4.44L10.02 4.94L11.27 5.87L10.67 4.31L11.83 4.84L12.58 5.81L12.39 4.87L13.23 5.06L13.86 6L14.64 7.49L14.7 7.81L15.51 8.12L16.32 8.62L15.13 9.15L14.07 9.55L14.14 9.87L14.89 10.74L15.17 12.17L14.82 13.36L13.89 14.2L12.14 14.2L6.06 14.2L6.84 12.49L7.62 10.77L8.55 9.21L9.49 8.12L9.77 7.81L8.08 7.03L6.9 6L6.09 5.06Z",
        "fill": "accent"
      },
      {
        "type": "circle",
        "cx": 11.67,
        "cy": 8.74,
        "r": 0.68,
        "fill": "truck"
      }
    ],
    "integral-pack": [
      {
        "type": "polygon",
        "d": "M5.9 14.05L13.99 14.05L13.27 11.22L8.7 11.22L8.7 6.65L5.9 5.96Z",
        "fill": "#ffc629"
      },
      {
        "type": "polygon",
        "d": "M16.1 3.85L8.01 3.85L8.7 6.65L13.27 6.65L13.27 11.22L16.1 11.94Z",
        "fill": "accent"
      }
    ],
    "jeebly": [
      {
        "type": "polygon",
        "d": "M11 4.07L15.64 4.07L15.64 8.48L13.44 8.48L13.44 6.16L11 6.16Z",
        "fill": "accent"
      },
      {
        "type": "polygon",
        "d": "M6.36 10.8L6.52 11.79L6.98 12.71L7.72 13.51L8.68 14.12L9.8 14.5L11 14.63L12.2 14.5L13.32 14.12L14.28 13.51L15.02 12.71L15.48 11.79L15.64 10.8L13.44 10.8L13.31 11.37L12.95 11.89L12.38 12.3L11.67 12.57L10.88 12.66L10.1 12.57L9.38 12.3L8.82 11.89L8.46 11.37L8.33 10.8Z",
        "fill": "accent"
      }
    ],
    "kargoist": [
      {
        "type": "polygon",
        "d": "M7.45 7.66L7.72 8.65L8.67 9.52L10.41 10.31L12.78 11.25L14.59 12.04L15.7 12.99L16.17 14.37L15.07 13.7L13.49 13.23L11.2 12.44L8.83 11.49L7.01 10.58L5.94 9.75L5.94 8.77L6.62 8.09Z",
        "fill": "#4f5053"
      },
      {
        "type": "polygon",
        "d": "M15.62 4.38L13.57 5.17L11.59 5.88L10.09 6.59L9.14 7.15L8.75 7.82L8.99 8.49L9.78 9.12L11.59 9.99L13.57 10.78L14.83 11.33L15.5 11.77L15.42 10.78L14.67 9.91L13.25 8.96L11.99 8.17L11.43 7.62L11.75 7.3L12.7 6.75L14.16 5.8Z",
        "fill": "accent"
      },
      {
        "type": "circle",
        "cx": 8.12,
        "cy": 5.57,
        "r": 1.55,
        "fill": "accent"
      }
    ],
    "la-poste-ci": [
      {
        "type": "polygon",
        "d": "M7.6 4.25L15.8 4.25L16.6 4.65L16.9 5.45L16.3 9.15L13.6 9.45L5.4 14.65Z",
        "fill": "#ffdd00"
      },
      {
        "type": "line",
        "d": "M7.6 4.35L13.6 9.45",
        "stroke": "truck",
        "strokeWidth": 1.2
      },
      {
        "type": "polygon",
        "d": "M13.1 10.6L16 10.4L15.8 11.6L15.2 12.7L14.2 13.7L12.9 14.4L11.4 14.7L12.5 13.9L13.3 12.9L13.7 11.7Z",
        "fill": "#ffdd00"
      }
    ],
    "la-poste-senegal": [
      {
        "type": "polygon",
        "d": "M5.6 4.2L18.8 8L10 10.3L13 7.9Z",
        "fill": "accent"
      },
      {
        "type": "polygon",
        "d": "M9 11.3L18.8 9.2L9.2 12.6Z",
        "fill": "accent"
      },
      {
        "type": "circle",
        "cx": 6.3,
        "cy": 11.3,
        "r": 3.2,
        "fill": "accent"
      },
      {
        "type": "circle",
        "cx": 6.3,
        "cy": 11.3,
        "r": 2.1,
        "fill": "#99dbf8"
      }
    ],
    "mailplus-au": [
      {
        "type": "line",
        "d": "M3.9 13.31L3.9 5.5M3.9 8.02L4.01 7.16L4.31 6.4L4.78 5.84L5.35 5.54L5.95 5.54L6.53 5.84L6.99 6.4L7.29 7.16L7.4 8.02L7.4 13.31M7.4 8.02L7.51 7.16L7.81 6.4L8.28 5.84L8.85 5.54L9.45 5.54L10.03 5.84L10.49 6.4L10.79 7.16L10.9 8.02L10.9 13.31",
        "stroke": "accent",
        "strokeWidth": 1.8
      },
      {
        "type": "line",
        "d": "M15.2 6.1L15.2 12.7M11.9 9.4L18.5 9.4",
        "stroke": "#ffe70a",
        "strokeWidth": 2
      }
    ],
    "major-express": [
      {
        "type": "line",
        "d": "M3.93 10.13L10.51 9.17M10.47 9.22L10.47 8.37L10.28 7.6L9.9 6.96L9.35 6.49L8.68 6.21L7.92 6.14L7.12 6.28L6.32 6.64L5.58 7.18L4.93 7.87L4.42 8.67L4.08 9.54L3.92 10.42L3.97 11.25L4.2 12L4.62 12.6L5.2 13.04L5.89 13.27L6.66 13.29L7.47 13.1L8.26 12.7L8.99 12.12",
        "stroke": "accent",
        "strokeWidth": 1.55
      },
      {
        "type": "polygon",
        "d": "M11.48 4.2L13.14 4.2L15.48 7.24L13.14 10.27L11.48 10.27L13.83 7.24Z",
        "fill": "accent"
      },
      {
        "type": "polygon",
        "d": "M14.66 4.2L16.31 4.2L18.66 7.24L16.31 10.27L14.66 10.27L17 7.24Z",
        "fill": "accent"
      }
    ],
    "mandae": [
      {
        "type": "polygon",
        "d": "M4 13.24L18.2 6.43L18.2 7.77L4 14.59Z",
        "fill": "accent"
      },
      {
        "type": "polygon",
        "d": "M8.6 8.68L18.2 4.08L18.2 5.42L8.6 10.03Z",
        "fill": "accent"
      },
      {
        "type": "polygon",
        "d": "M8.6 13.39L18.2 8.78L18.2 10.12L8.6 14.73Z",
        "fill": "accent"
      },
      {
        "type": "polygon",
        "d": "M13 13.63L18.2 11.13L18.2 12.48L13 14.97Z",
        "fill": "accent"
      },
      {
        "type": "polygon",
        "d": "M4 10.89L8.6 8.68L8.6 10.03L4 12.24Z",
        "fill": "accent"
      },
      {
        "type": "polygon",
        "d": "M4 8.54L8.6 6.33L8.6 7.68L4 9.88Z",
        "fill": "accent"
      }
    ],
    "messenger-cz": [
      {
        "type": "polygon",
        "d": "M9.98 4.1L11.18 4.58L11.72 3.98L12.02 5.3L14.36 6.2L12.02 6.44L11.96 6.98L11.78 7.7L11.72 8.3L12.38 8.06L12.38 9.02L14.42 9.56L15.8 14.3L6.2 14.3L7.52 9.56L9.38 9.02L9.5 8.18L10.1 8.6L9.92 7.7L9.68 6.44L7.76 6.26L9.74 5.3Z",
        "fill": "#161615"
      }
    ],
    "nord-wheel": [
      {
        "type": "polygon",
        "d": "M11.18 14.3L10.37 14.26L9.58 14.1L8.82 13.82L8.12 13.42L7.49 12.92L6.94 12.32L6.5 11.65L6.16 10.91L5.94 10.13L5.85 9.33L5.89 8.52L6.05 7.73L6.33 6.97L6.73 6.27L7.23 5.64L7.83 5.09L7.83 5.09L7.43 5.83L7.08 6.5L6.81 7.2L6.66 7.9L6.6 8.61L6.66 9.3L6.81 9.96L7.06 10.58L7.39 11.15L7.8 11.65L8.28 12.07L8.8 12.41L9.36 12.66L9.95 12.81L10.54 12.88L11.13 12.85Z",
        "fill": "accent"
      },
      {
        "type": "polygon",
        "d": "M10.82 4L11.59 4.03L12.35 4.18L13.08 4.44L13.77 4.81L14.39 5.27L14.93 5.82L15.39 6.45L15.74 7.14L15.99 7.87L16.12 8.63L16.14 9.41L16.05 10.18L15.84 10.92L15.52 11.63L15.09 12.28L14.58 12.85L14.58 12.85L14.87 12.11L15.15 11.43L15.34 10.74L15.43 10.05L15.42 9.37L15.32 8.71L15.13 8.09L14.86 7.51L14.51 6.99L14.1 6.53L13.63 6.14L13.11 5.84L12.57 5.61L12 5.47L11.43 5.42L10.87 5.45Z",
        "fill": "accent"
      },
      {
        "type": "polygon",
        "d": "M6.77 6.57L8.42 6.57L8.88 8.05L8.15 10.25Z",
        "fill": "accent"
      },
      {
        "type": "polygon",
        "d": "M14.86 6.67L13.21 6.57L12.29 9.33L11.37 6.57L9.99 6.57L8.15 11.73L9.62 11.73L10.72 8.78L11.74 11.73L13.02 11.73Z",
        "fill": "accent"
      }
    ],
    "ocasa": [
      {
        "type": "polygon",
        "d": "M5.9 3.85L16.1 3.85L16.1 14.05L14 14.05L14 7.43L7.38 14.05L5.9 12.57L12.52 5.95L5.9 5.95Z",
        "fill": "accent"
      }
    ],
    "opt-nc": [
      {
        "type": "polygon",
        "d": "M11 4.3L18.6 4.3L18.6 14.6L11 14.6Z",
        "fill": "#fdc40a"
      },
      {
        "type": "polygon",
        "d": "M3.94 10.34L4.48 9.1L5.22 7.95L6.14 6.92L7.21 6.04L8.41 5.34L9.72 4.82L11.09 4.51L12.5 4.4L13.91 4.51L15.28 4.82L14.66 6.72L13.62 6.32L12.5 6.08L11.33 6.01L10.14 6.11L8.96 6.41L7.82 6.88L6.76 7.54L5.8 8.37L4.98 9.35L4.32 10.47Z",
        "fill": "accent"
      },
      {
        "type": "polygon",
        "d": "M5 12.35L5.27 11.61L5.64 10.91L6.11 10.26L6.68 9.66L7.32 9.14L8.04 8.69L8.81 8.33L9.63 8.06L10.49 7.88L11.36 7.8L11.43 9.7L10.78 9.61L10.1 9.59L9.41 9.65L8.72 9.8L8.04 10.03L7.4 10.35L6.8 10.76L6.25 11.25L5.78 11.81L5.39 12.45Z",
        "fill": "accent"
      },
      {
        "type": "polygon",
        "d": "M6.54 14.07L6.65 13.6L6.83 13.15L7.07 12.72L7.38 12.32L7.73 11.96L8.14 11.64L8.59 11.36L9.08 11.14L9.6 10.97L10.14 10.86L10.45 12.63L10.09 12.56L9.71 12.52L9.32 12.54L8.92 12.6L8.53 12.72L8.15 12.9L7.79 13.13L7.46 13.41L7.18 13.75L6.94 14.13Z",
        "fill": "accent"
      },
      {
        "type": "polygon",
        "d": "M11 4.3L13.6 4.6L15.6 5.6L17 7.2L17.8 9.4L18.2 11.6L16.6 10.2L14.6 9.9L16.2 9.2L15.4 7.4L13.8 6.2L11 5.7Z",
        "fill": "truck"
      },
      {
        "type": "circle",
        "cx": 15,
        "cy": 8.4,
        "r": 0.6,
        "fill": "truck"
      }
    ],
    "pmm": [
      {
        "type": "polygon",
        "d": "M3 6.4L5.62 6.4L6.1 6.49L6.53 6.78L6.87 7.22L7.09 7.78L7.17 8.39L7.09 9.01L6.87 9.57L6.53 10.01L6.1 10.29L5.62 10.39L4.35 10.39L4.35 12L3 12Z",
        "fill": "accent"
      },
      {
        "type": "polygon",
        "d": "M4.35 7.78L5.56 7.78L5.79 7.83L5.98 7.98L6.12 8.21L6.16 8.47L6.12 8.73L5.98 8.96L5.79 9.11L5.56 9.16L4.35 9.16Z",
        "fill": "truck"
      },
      {
        "type": "polygon",
        "d": "M7.47 6.4L8.82 6.4L10.19 8.93L11.67 6.4L12.95 6.4L12.95 12L11.67 12L11.67 9.39L10.19 11.54L8.82 9.39L8.82 12L7.47 12Z",
        "fill": "accent"
      },
      {
        "type": "polygon",
        "d": "M13.52 6.4L14.86 6.4L16.24 8.93L17.53 6.72L19 8.39L19 12L17.72 12L17.72 9.39L16.24 11.54L14.86 9.39L14.86 12L13.52 12Z",
        "fill": "accent"
      },
      {
        "type": "polygon",
        "d": "M17.82 6.4L19 6.4L19 7.74Z",
        "fill": "#3dae2b"
      }
    ],
    "pony-express": [
      {
        "type": "polygon",
        "d": "M3.87 5.97L3.28 8.19L13.4 8.19L10.54 11.07L12.1 12.63L18.72 5.97Z",
        "fill": "#7ac143"
      }
    ],
    "shipa": [
      {
        "type": "polygon",
        "d": "M7.2 14.6L11.6 4L14.9 4L10.95 13.4Z",
        "fill": "accent"
      }
    ],
    "shree-anjani": [
      {
        "type": "polygon",
        "d": "M5.5 14.4L16.5 4L15.9 14.4L13.3 14.4L13.6 9.9L9.7 14.4Z",
        "fill": "#1a1a1a"
      }
    ],
    "ues-uy": [
      {
        "type": "line",
        "d": "M5.4 4.5L14.4 4.5L17.8 9L14.4 13.5L3.4 13.5",
        "stroke": "#f47521",
        "strokeWidth": 1.4
      },
      {
        "type": "polygon",
        "d": "M3.8 3.8L4.7 3.8L4.4 5.2L3.5 5.2Z",
        "fill": "#f47521"
      },
      {
        "type": "line",
        "d": "M9.68 6L8.99 9.43L8.97 10.04L9.13 10.57L9.47 10.96L9.93 11.17L10.48 11.17L11.03 10.96L11.52 10.57L11.9 10.04L12.11 9.43L12.8 6",
        "stroke": "accent",
        "strokeWidth": 2
      }
    ],
    "upaya": [
      {
        "type": "polygon",
        "d": "M7.98 8.68L7.98 9.21L8.1 10.31L8.46 11.37L9.04 12.31L9.8 13.1L10.72 13.69L11.75 14.06L12.83 14.19L13.91 14.06L14.93 13.69L15.85 13.1L16.62 12.31L17.2 11.37L17.56 10.31L17.68 9.21L17.68 4.01L14.6 4.01L14.63 9.21L14.54 9.76L14.29 10.27L13.89 10.66L13.39 10.92L12.83 11.01L12.27 10.92L11.77 10.66L11.37 10.27L11.11 9.76L11.03 9.21L11 8.68Z",
        "fill": "accent"
      },
      {
        "type": "polygon",
        "d": "M7.98 4.01L11 4.01L11 5.12L7.98 5.12Z",
        "fill": "accent"
      },
      {
        "type": "polygon",
        "d": "M7.98 5.87L11 5.87L11 8.04L7.98 8.04Z",
        "fill": "#ff5527"
      },
      {
        "type": "polygon",
        "d": "M4.32 5.6L7.18 5.6L7.18 6.56L4.32 6.56Z",
        "fill": "#ff5527"
      },
      {
        "type": "polygon",
        "d": "M4.32 7.3L7.18 7.3L7.18 8.25L4.32 8.25Z",
        "fill": "#ff5527"
      }
    ],
    "vimenpaq": [
      {
        "type": "polygon",
        "d": "M12.45 8.8L16.15 8.8L16.15 7.45L15.22 7.45L15.88 6.8L14.92 5.84L12.31 8.46Z",
        "fill": "accent"
      },
      {
        "type": "polygon",
        "d": "M11.74 7.89L14.36 5.28L13.4 4.32L12.75 4.98L12.75 4.05L11.4 4.05L11.4 7.75Z",
        "fill": "#f42434"
      },
      {
        "type": "polygon",
        "d": "M10.6 7.75L10.6 4.05L9.25 4.05L9.25 4.98L8.6 4.32L7.64 5.28L10.26 7.89Z",
        "fill": "accent"
      },
      {
        "type": "polygon",
        "d": "M9.69 8.46L7.08 5.84L6.12 6.8L6.78 7.45L5.85 7.45L5.85 8.8L9.55 8.8Z",
        "fill": "accent"
      },
      {
        "type": "polygon",
        "d": "M9.55 9.6L5.85 9.6L5.85 10.95L6.78 10.95L6.12 11.6L7.08 12.56L9.69 9.94Z",
        "fill": "accent"
      },
      {
        "type": "polygon",
        "d": "M10.26 10.51L7.64 13.12L8.6 14.08L9.25 13.42L9.25 14.35L10.6 14.35L10.6 10.65Z",
        "fill": "accent"
      },
      {
        "type": "polygon",
        "d": "M11.4 10.65L11.4 14.35L12.75 14.35L12.75 13.42L13.4 14.08L14.36 13.12L11.74 10.51Z",
        "fill": "accent"
      },
      {
        "type": "polygon",
        "d": "M12.31 9.94L14.92 12.56L15.88 11.6L15.22 10.95L16.15 10.95L16.15 9.6L12.45 9.6Z",
        "fill": "accent"
      }
    ],
    "vozovoz": [
      {
        "type": "polygon",
        "d": "M6.52 5.25L6.87 4.3L7.96 4.07L8.52 4.34L8.74 4.73L8.93 10.58L13.61 4.6L14.31 4.12L15.09 4.14L15.44 4.6L15.26 5.38L8.31 13.84L7.56 14.25L7.17 13.87Z",
        "fill": "accent"
      }
    ],
    "x-express-ba": [
      {
        "type": "polygon",
        "d": "M6.46 4.18L9.27 4.18L11 6.56L12.73 4.18L15.54 4.18L12.62 8.93L15.54 14.12L12.73 14.12L11 11.74L9.27 14.12L6.46 14.12L9.27 8.93Z",
        "fill": "accent"
      }
    ],
    "metropolitan-warehouse": [
      {
        "type": "polygon",
        "d": "M11 3.9L16.6 9.5L11 15.1L5.4 9.5Z",
        "fill": "accent"
      },
      {
        "type": "polygon",
        "d": "M8.7 9.15L8.7 6.65L9.7 5.65L10.26 5.65L11 7.82L11.74 5.65L12.3 5.65L13.3 6.65L13.3 9.15L12.1 9.15L12.1 5.92L11 9.15L9.9 5.92L9.9 9.15Z",
        "fill": "truck"
      },
      {
        "type": "polygon",
        "d": "M8.7 9.85L8.7 12.35L9.7 13.35L10.26 13.35L11 11.18L11.74 13.35L12.3 13.35L13.3 12.35L13.3 9.85L12.1 9.85L12.1 13.08L11 9.85L9.9 13.08L9.9 9.85Z",
        "fill": "#fb9517"
      }
    ],
    "citymail": [
      {
        "type": "polygon",
        "d": "M8.48 4L16.54 4.43L16.34 8.75L16.12 12.72L15.68 12.71L15.6 14.7L9.06 14.47L6.63 14.6L6.58 13.59L6.07 13.63L5.46 7.76L5.64 7.53L6.21 7.48L6.07 5.26L6.07 5.05L8.44 4.91Z",
        "fill": "accent"
      },
      {
        "type": "line",
        "d": "M10.16 7.61L9.66 7.1L9.07 6.95L8.49 7.17L8.01 7.74L7.69 8.57L7.57 9.54L7.69 10.52L8.01 11.35L8.49 11.92L9.07 12.14L9.66 11.99L10.16 11.48M11.11 12.14L11.11 6.94L12.79 10.17L14.47 6.94L14.47 12.14",
        "stroke": "#00b140",
        "strokeWidth": 1.6
      }
    ],
    "correos-cuba": [
      {
        "type": "polygon",
        "d": "M6.28 9.58L12.5 4L15.71 6.77L12.6 9.58L15.71 12.39L12.5 15Z",
        "fill": "accent"
      },
      {
        "type": "line",
        "d": "M14.83 7.43L14.11 6.87L13.25 6.55L12.33 6.49L11.44 6.71L10.65 7.17L10.03 7.85L9.64 8.67L9.5 9.58L9.64 10.49L10.03 11.31L10.65 11.99L11.44 12.45L12.33 12.67L13.25 12.61L14.11 12.29L14.83 11.73",
        "stroke": "truck",
        "strokeWidth": 0.95
      }
    ],
    "correos-el-salvador": [
      {
        "type": "polygon",
        "d": "M11 6.09L14.41 9.5L11 12.91L7.59 9.5Z",
        "fill": "accent"
      },
      {
        "type": "polygon",
        "d": "M8.31 8.27L11.67 7.6L12.68 7.93L13.28 8.72L13.73 10.06L12.34 10.04L11.11 10.53L9.61 11.78L7.19 9.5Z",
        "fill": "truck"
      },
      {
        "type": "circle",
        "cx": 11.78,
        "cy": 8.74,
        "r": 0.42,
        "fill": "#fbb200"
      },
      {
        "type": "polygon",
        "d": "M8.2 6.7L11 3.9L13.8 6.7L12.7 7.8L11 6.09L9.3 7.8Z",
        "fill": "#1a6fa8"
      },
      {
        "type": "polygon",
        "d": "M13.8 6.7L16.6 9.5L13.8 12.3L12.7 11.2L14.41 9.5L12.7 7.8Z",
        "fill": "#b2216d"
      },
      {
        "type": "polygon",
        "d": "M13.8 12.3L11 15.1L8.2 12.3L9.3 11.2L11 12.91L12.7 11.2Z",
        "fill": "#fbb200"
      },
      {
        "type": "polygon",
        "d": "M8.2 12.3L5.4 9.5L8.2 6.7L9.3 7.8L7.59 9.5L9.3 11.2Z",
        "fill": "#6aa820"
      }
    ],
    "delnext": [
      {
        "type": "polygon",
        "d": "M6.52 4.05L12.57 4.05L15.68 10.41L12.57 14.45L6.52 14.45Z",
        "fill": "accent"
      },
      {
        "type": "polygon",
        "d": "M6.52 6.22L11.1 6.22L13.89 9.48L11.33 12.28L9.55 12.28L9.55 7.08L6.52 7.08Z",
        "fill": "truck"
      }
    ],
    "hispapost": [
      {
        "type": "line",
        "d": "M6.7 4.95L16.2 9.07L6.7 13.2",
        "stroke": "accent",
        "strokeWidth": 2.25
      },
      {
        "type": "circle",
        "cx": 6.7,
        "cy": 4.95,
        "r": 1.12,
        "fill": "accent"
      },
      {
        "type": "circle",
        "cx": 6.7,
        "cy": 13.2,
        "r": 1.12,
        "fill": "accent"
      }
    ],
    "intereuropa": [
      {
        "type": "polygon",
        "d": "M5.95 4.05L16.25 4.05L16.25 14.45L5.95 14.45Z",
        "fill": "accent"
      },
      {
        "type": "polygon",
        "d": "M8.61 6.1L10.56 6.1L10.56 9.65L8.61 9.65Z",
        "fill": "truck"
      },
      {
        "type": "line",
        "d": "M11.94 6.83L12.95 7.38L13.32 8.67L12.89 10.2L11.67 11.61L10.01 12.83L8.61 13.62",
        "stroke": "truck",
        "strokeWidth": 1.35
      },
      {
        "type": "line",
        "d": "M10.87 12.03L11.54 13.56",
        "stroke": "truck",
        "strokeWidth": 1.2
      },
      {
        "type": "line",
        "d": "M10.26 7.93L11.48 7.57L12.58 7.38",
        "stroke": "truck",
        "strokeWidth": 1
      },
      {
        "type": "circle",
        "cx": 12.83,
        "cy": 5.67,
        "r": 1.05,
        "fill": "truck"
      }
    ],
    "iran-post": [
      {
        "type": "line",
        "d": "M11.56 11.1L10.73 10.03L9.78 8.61L8.83 7.23L8 6.62L7.05 6.45L6.18 6.57L5.58 7.02L5.73 7.71L6.82 9.08L7.88 10.5L8.83 11.93L9.49 12.97L10.25 13.66L11.32 13.92L17.36 13.92",
        "stroke": "#fcd603",
        "strokeWidth": 1.55
      },
      {
        "type": "line",
        "d": "M11.56 11.1L12.74 10.6L14.04 9.79L15.23 8.84L16.06 7.78L16.58 6.47L16.82 5.05L16.82 4.48L14.87 4.67L13.45 5.53L11.91 6.47L10.99 7.33",
        "stroke": "#fcd603",
        "strokeWidth": 1.55
      },
      {
        "type": "line",
        "d": "M14.45 11.21L14.92 12.16L15.58 13.11L16.18 13.82",
        "stroke": "#fcd603",
        "strokeWidth": 1.45
      }
    ],
    "kronos-express": [
      {
        "type": "polygon",
        "d": "M9.19 4.08L10.21 4.33L11.23 4.67L12.25 5.18L13.27 5.78L14.12 6.46L14.8 7.22L15.31 7.91L15.73 8.59L13.44 9.35L11.23 10.12L11.06 9.69L10.97 8.84L10.89 7.82L10.72 6.8L10.46 5.78L10.04 4.93Z",
        "fill": "accent"
      },
      {
        "type": "polygon",
        "d": "M18.11 7.96L17.01 8.33L15.82 8.64L15.61 9.18L15.48 10.12L12.76 12.92L13.78 12.92L14.63 12.75L15.31 12.24L15.85 11.39L16.29 10.37L16.63 9.35L17.26 8.67Z",
        "fill": "accent"
      },
      {
        "type": "polygon",
        "d": "M4.05 14.36L6.17 13.69L8.39 13.02L10.16 12.61L11.47 12.34L11.23 11.06L9.84 11.29L8.01 11.88L5.83 12.91L3.95 14.14Z",
        "fill": "#f7941d"
      },
      {
        "type": "circle",
        "cx": 11.35,
        "cy": 11.7,
        "r": 0.65,
        "fill": "#f7941d"
      }
    ],
    "m-one": [
      {
        "type": "polygon",
        "d": "M11.68 7.23L16 4.83L16 12.87L14.56 13.95L14.56 9.03L11.68 10.23Z",
        "fill": "accent"
      },
      {
        "type": "line",
        "d": "M6.4 4.35L11.68 7.23L11.68 10.23L9.04 8.79L9.04 13.95L6.4 12.15L6.4 4.35",
        "stroke": "accent",
        "strokeWidth": 1
      },
      {
        "type": "polygon",
        "d": "M6.4 4.35L11.68 7.23L11.68 10.23L9.04 8.79L9.04 13.95L6.4 12.15Z",
        "fill": "#ec1c24"
      }
    ],
    "pack-man": [
      {
        "type": "polygon",
        "d": "M9.8 4.05L12.2 4.05L12.2 5.35L9.8 5.35Z",
        "fill": "#fbd733"
      },
      {
        "type": "polygon",
        "d": "M10.45 5.2L11.55 5.2L11.55 6.3L10.45 6.3Z",
        "fill": "#fbd733"
      },
      {
        "type": "circle",
        "cx": 11,
        "cy": 10.45,
        "r": 4.45,
        "fill": "#fbd733"
      },
      {
        "type": "circle",
        "cx": 11,
        "cy": 10.45,
        "r": 3.08,
        "fill": "accent"
      },
      {
        "type": "polygon",
        "d": "M11 10.45L12.94 8.95L13.22 9.41L13.39 9.92L13.45 10.45L13.39 10.98L13.22 11.49L12.94 11.95Z",
        "fill": "#fbd733"
      },
      {
        "type": "circle",
        "cx": 11.05,
        "cy": 8.25,
        "r": 0.62,
        "fill": "truck"
      }
    ],
    "pannon-xp": [
      {
        "type": "polygon",
        "d": "M3.3 5.4L5.05 5.4L8.25 9.5L5.05 13.6L3.3 13.6L6.5 9.5Z",
        "fill": "#414143"
      },
      {
        "type": "polygon",
        "d": "M9.4 5.4L11.15 5.4L14.35 9.5L11.15 13.6L9.4 13.6L12.6 9.5Z",
        "fill": "#414143"
      },
      {
        "type": "polygon",
        "d": "M12.9 5.4L18.7 5.4L15.9 9.5L18.7 13.6L12.9 13.6L15.25 9.5Z",
        "fill": "accent"
      }
    ],
    "phlpost": [
      {
        "type": "polygon",
        "d": "M8.86 9.46L10.32 9.11L11.98 9.31L12.95 9.46L13.64 8.59L13.77 7.67L14.71 7.61L14.71 8.88L14.12 10.05L13.15 11.51L14.32 12.29L15.49 11.9L16.27 12.2L14.71 13.66L12.56 12.78L11.39 12L10.61 12.78L9.25 14.24L7.88 14.24L7.3 12.78L6.13 12.39L6.13 11.03L8.47 11.9L10.22 11.61L10.03 10.34L9.35 10.15L8.86 10.34Z",
        "fill": "#feac01"
      },
      {
        "type": "circle",
        "cx": 11.36,
        "cy": 7.75,
        "r": 1.4,
        "fill": "#feac01"
      },
      {
        "type": "circle",
        "cx": 14.16,
        "cy": 7.22,
        "r": 0.78,
        "fill": "#feac01"
      },
      {
        "type": "circle",
        "cx": 8.16,
        "cy": 10.48,
        "r": 0.75,
        "fill": "#feac01"
      },
      {
        "type": "polygon",
        "d": "M12.41 4.2L15.26 3.73L15.45 5.72L12.99 6.19Z",
        "fill": "#feac01"
      },
      {
        "type": "line",
        "d": "M12.72 4.4L14.03 5.14L15.14 4.04",
        "stroke": "truck",
        "strokeWidth": 0.6
      }
    ],
    "redur": [
      {
        "type": "polygon",
        "d": "M6.75 4.05L14.5 4.05L15.54 4.33L16.34 5.09L16.76 6.31L16.59 7.7L15.89 9.09L14.68 10.13L13.18 10.93L14.74 13.85L11.96 13.85L11.55 13.61L9.36 10.31L8.25 13.85L5.64 13.85L6.68 9.96L7.03 9.26L7.55 8.92L8.25 8.81L12.24 8.81L13.29 8.57L13.81 7.94L14.05 7.18L13.81 6.73L13.11 6.52L8.25 6.52L7.55 6.31L7.2 5.79Z",
        "fill": "accent"
      }
    ],
    "torrestir": [
      {
        "type": "polygon",
        "d": "M12.01 4.87L11.43 4.05L10.25 3.75L9.03 3.9L8.07 4.41L7.45 5.02L7.06 5.56L6.62 6.07L5.97 6.71L5.44 7.53L5.39 8.49L5.62 9.34L6.03 10.02L6.38 10.57L6.64 11.05L6.77 11.48L6.76 11.79L6.69 11.99L6.46 12.04L5.98 11.92L5.88 12.07L6.28 12.54L6.94 12.65L7.54 12.2L7.74 11.48L7.65 10.73L7.39 10.03L7 9.41L6.68 8.91L6.62 8.44L6.74 8.07L7.07 7.72L7.74 7.19L8.33 6.52L8.67 5.89L8.93 5.41L9.44 4.97L10.28 4.72L11.16 4.7L11.9 5Z",
        "fill": "#ffc629"
      },
      {
        "type": "polygon",
        "d": "M9.55 8.1L8.9 8.3L8.32 8.83L8.03 9.59L8.05 10.4L8.39 11.11L8.9 11.71L9.43 12.24L9.94 12.68L10.32 13.16L10.6 13.59L10.77 13.95L10.87 14.46L11.13 14.52L11.47 14L11.54 13.34L11.32 12.59L10.88 11.89L10.37 11.3L9.87 10.81L9.49 10.37L9.33 10.06L9.26 9.69L9.27 9.28L9.42 8.78L9.66 8.24Z",
        "fill": "#ffc629"
      },
      {
        "type": "polygon",
        "d": "M13.83 5.65L14.51 5.64L14.84 5.77L14.96 5.98L14.98 6.16L14.8 6.36L14.3 6.59L13.69 7.07L13.33 7.85L13.37 8.7L13.77 9.47L14.59 9.96L15.49 9.95L15.93 9.81L15.93 9.8L16.09 10.21L16.44 10.25L16.71 9.63L16.22 8.97L15.48 8.89L14.91 8.86L14.69 8.64L14.57 8.38L14.55 8.05L14.63 7.74L14.91 7.46L15.43 7.1L15.9 6.45L15.86 5.6L15.25 4.99L14.4 4.94L13.76 5.49Z",
        "fill": "#ffc629"
      },
      {
        "type": "polygon",
        "d": "M11.09 8.71L11.04 9.31L11.24 9.99L11.81 10.47L12.46 10.6L12.9 10.38L12.92 10.2L12.62 9.91L12.25 9.7L11.93 9.44L11.61 9.09L11.26 8.66Z",
        "fill": "#ffc629"
      },
      {
        "type": "polygon",
        "d": "M10.8 5.88L11.81 5.94L12.85 5.47L12.82 5.29L11.66 5.17L10.76 5.7Z",
        "fill": "#ffc629"
      }
    ],
    "afghan-post": [
      {
        "type": "polygon",
        "d": "M11 4L15.76 6.75L15.76 12.25L11 15L6.24 12.25L6.24 6.75Z",
        "fill": "accent"
      },
      {
        "type": "polygon",
        "d": "M11 5.67L14.31 7.59L14.31 11.41L11 13.33L7.69 11.41L7.69 7.59Z",
        "fill": "truck"
      },
      {
        "type": "line",
        "d": "M7.43 7.44L11 9.5L14.57 7.44M11 9.1L11 13.63",
        "stroke": "accent",
        "strokeWidth": 1.45
      }
    ],
    "corre": [
      {
        "type": "polygon",
        "d": "M3 5.5L7.73 9.5L3 13.5Z",
        "fill": "accent"
      },
      {
        "type": "polygon",
        "d": "M8.63 5.5L13.37 9.5L8.63 13.5Z",
        "fill": "accent"
      },
      {
        "type": "polygon",
        "d": "M14.27 5.5L19 9.5L14.27 13.5Z",
        "fill": "accent"
      }
    ],
    "correos-nicaragua": [
      {
        "type": "circle",
        "cx": 10.64,
        "cy": 6.42,
        "r": 1.11,
        "fill": "accent"
      },
      {
        "type": "polygon",
        "d": "M13.36 7.47L13.52 7.52L13.71 7.55L13.39 6.74L12.97 6.78L12.34 6.89L11.72 7.02L11.18 7.13L10.67 7.25L10.17 7.39L9.72 7.6L9.29 7.83L8.85 8.1L8.45 8.46L8.07 8.85L7.68 9.27L7.33 9.76L6.99 10.27L6.65 10.77L6.33 11.28L6.01 11.77L5.68 12.23L5.24 12.74L4.74 13.24L4.4 13.63L4.56 13.87L5.05 13.71L5.73 13.43L6.41 13.09L6.96 12.69L7.45 12.29L7.93 11.89L8.39 11.49L8.83 11.09L9.24 10.75L9.59 10.42L9.93 10.13L10.25 9.88L10.53 9.63L10.8 9.41L11.12 9.19L11.45 8.92L11.82 8.66L12.22 8.4L12.74 8.13L13.3 7.86L13.67 7.66L13.44 6.83L13.33 6.96L13.23 7.1Z",
        "fill": "accent"
      },
      {
        "type": "polygon",
        "d": "M8.72 8.77L8.61 9.2L8.45 9.82L8.28 10.43L8.16 11L8.02 11.6L7.87 12.22L7.79 12.96L7.71 13.71L7.7 14.25L7.97 14.34L8.28 13.9L8.67 13.25L9.05 12.63L9.33 12.08L9.61 11.53L9.88 10.99L10.13 10.38L10.37 9.78L10.54 9.37Z",
        "fill": "accent"
      },
      {
        "type": "polygon",
        "d": "M3.15 10.52L3.57 10.42L4.16 10.23L4.77 10.05L5.36 9.85L5.99 9.64L6.6 9.47L7.16 9.26L7.7 9.09L8.2 8.96L8.73 8.86L9.28 8.8L9.67 8.76L9.59 7.51L9.19 7.52L8.59 7.55L7.94 7.63L7.32 7.78L6.72 7.98L6.11 8.2L5.51 8.51L4.91 8.85L4.35 9.18L3.82 9.58L3.33 9.97L3.01 10.27Z",
        "fill": "accent"
      },
      {
        "type": "polygon",
        "d": "M13.25 5.04L18.63 4.57L18.95 8.16L13.57 8.63Z",
        "fill": "accent"
      },
      {
        "type": "polygon",
        "d": "M13.84 5.44L16.1 6.6L18.12 5.07L18.22 6.16L16.21 7.88L13.94 6.53Z",
        "fill": "truck"
      }
    ],
    "kyrgyz-post": [
      {
        "type": "polygon",
        "d": "M4.2 4.41L14.02 4.41L16.24 4.97L17.16 5.63L17.86 6.5L18.3 7.5L18.45 8.58L18.3 9.66L17.86 10.67L17.16 11.53L16.24 12.19L15.17 12.61L14.02 12.75L10.89 12.75L10.21 12.87L9.38 13.79L8.52 14.36L7.54 14.57L3.55 13.05L5.49 9.09L6.14 8.33L7.22 7.85L8.62 7.69L12.3 7.69L13.05 7.79L13.7 8.23L14.29 8.87L14.35 9.74L13.7 9.52L8.73 9.52L8.08 9.74L7.54 10.28L7.11 11.03L6.36 12.04L7 12.33L7.54 12.44L8.08 12.11L8.41 11.57L8.95 11.03L9.7 10.84L14.02 10.84L14.58 10.76L15.1 10.52L15.55 10.14L15.89 9.65L16.11 9.08L16.18 8.46L16.11 7.85L15.89 7.28L15.55 6.78L15.1 6.41L14.58 6.17L14.02 6.09L6.57 6.1L5.82 5.9L5.17 5.53L4.63 4.99Z",
        "fill": "accent"
      }
    ],
    "la-poste-burkina-faso": [
      {
        "type": "polygon",
        "d": "M6.8 3.84L7.46 5.06L8.33 3.79L8.74 5.26L9.4 6.79L10.17 8.43L10.83 9.65L10.88 10.57L10.32 11.18L9.4 11.23L8.58 10.77L7.97 10.11L7.62 11.08L7.56 12.4L7.82 13.63L4.45 13.63L4.61 11.18L5.07 8.53L5.73 6.39L6.44 5.06Z",
        "fill": "#fed911"
      },
      {
        "type": "line",
        "d": "M4.94 10.11L4.29 10.5L3.85 10.93L3.63 11.37L3.63 11.83L3.85 12.27L4.29 12.7L4.94 13.09L5.77 13.44L6.76 13.73L7.87 13.96L9.08 14.11L10.36 14.19L11.64 14.19L12.92 14.11L14.13 13.96L15.24 13.73L16.23 13.44L17.06 13.09L17.71 12.7L18.15 12.27L18.37 11.83L18.37 11.37L18.15 10.93L17.71 10.5",
        "stroke": "truck",
        "strokeWidth": 3
      },
      {
        "type": "line",
        "d": "M4.94 10.11L4.29 10.5L3.85 10.93L3.63 11.37L3.63 11.83L3.85 12.27L4.29 12.7L4.94 13.09L5.77 13.44L6.76 13.73L7.87 13.96L9.08 14.11L10.36 14.19L11.64 14.19L12.92 14.11L14.13 13.96L15.24 13.73L16.23 13.44L17.06 13.09L17.71 12.7L18.15 12.27L18.37 11.83L18.37 11.37L18.15 10.93L17.71 10.5",
        "stroke": "accent",
        "strokeWidth": 1.4
      }
    ],
    "lao-post": [
      {
        "type": "polygon",
        "d": "M13.89 9.34L14.22 8.68L14.41 7.96L14.44 7.22L14.32 6.49L14.03 5.81L13.61 5.2L13.07 4.69L12.44 4.31L11.74 4.08L11 4L10.26 4.08L9.56 4.31L8.93 4.69L8.39 5.2L7.97 5.81L7.68 6.49L7.56 7.22L7.59 7.96L7.78 8.68L8.11 9.34L11 13.75Z",
        "fill": "accent"
      },
      {
        "type": "circle",
        "cx": 11,
        "cy": 7.45,
        "r": 2.15,
        "fill": "truck"
      },
      {
        "type": "polygon",
        "d": "M9.32 9.6L9.35 9.38L9.42 9.16L9.55 8.96L9.72 8.77L9.92 8.61L10.16 8.48L10.43 8.39L10.71 8.33L11 8.31L11.29 8.33L11.57 8.39L11.84 8.48L12.08 8.61L12.28 8.77L12.45 8.96L12.58 9.16L12.65 9.38L12.68 9.6Z",
        "fill": "accent"
      },
      {
        "type": "circle",
        "cx": 11,
        "cy": 6.95,
        "r": 0.92,
        "fill": "accent"
      },
      {
        "type": "polygon",
        "d": "M14.1 13.85L13.99 13.64L13.68 13.45L13.19 13.28L12.55 13.16L11.8 13.08L11 13.05L10.2 13.08L9.45 13.16L8.81 13.28L8.32 13.45L8.01 13.64L7.9 13.85L8.01 14.06L8.32 14.25L8.81 14.42L9.45 14.54L10.2 14.62L11 14.65L11.8 14.62L12.55 14.54L13.19 14.42L13.68 14.25L13.99 14.06L14.1 13.85Z",
        "fill": "accent"
      }
    ],
    "pitney-bowes": [
      {
        "type": "circle",
        "cx": 11,
        "cy": 9.5,
        "r": 5.6,
        "fill": "accent"
      },
      {
        "type": "circle",
        "cx": 11,
        "cy": 9.5,
        "r": 4.2,
        "fill": "truck"
      },
      {
        "type": "line",
        "d": "M10 8L11.7 8L12.09 8.05L12.45 8.2L12.76 8.44L13 8.75L13.15 9.11L13.2 9.5L13.15 9.89L13 10.25L12.76 10.56L12.45 10.8L12.09 10.95L11.7 11",
        "stroke": "accent",
        "strokeWidth": 1.45
      },
      {
        "type": "line",
        "d": "M10 6.55L10 12.45",
        "stroke": "accent",
        "strokeWidth": 1.45
      }
    ],
    "a1-post": [
      {
        "type": "polygon",
        "d": "M4.3 13.45L4.3 5.65L4.55 5.11L5.1 4.87L5.89 5.09L13.52 12.73L13.58 13.38L13.1 13.93L12.21 14.04L6.17 8L6.17 10.43L7.71 11.08L7.81 11.76L5.67 13.93L5 14.13Z",
        "fill": "accent"
      },
      {
        "type": "polygon",
        "d": "M17.7 5.55L17.7 13.35L17.45 13.89L16.9 14.13L16.11 13.91L8.48 6.27L8.42 5.62L8.9 5.07L9.79 4.96L15.83 11L15.83 8.57L14.29 7.92L14.19 7.24L16.33 5.07L17 4.87Z",
        "fill": "accent"
      }
    ],
    "direx": [
      {
        "type": "polygon",
        "d": "M14.79 5.44L13.47 4.53L11.95 4.03L10.35 3.99L8.81 4.4L7.45 5.24L6.38 6.43L5.69 7.87L5.45 9.45L5.67 11.04L6.33 12.49L7.37 13.7L8.72 14.56L10.26 15L11.86 14.98L13.38 14.51L14.71 13.62L13.78 12.58L12.78 13.25L11.64 13.6L10.44 13.61L9.3 13.28L8.29 12.64L7.5 11.74L7.01 10.65L6.85 9.46L7.03 8.28L7.54 7.2L8.34 6.31L9.36 5.69L10.52 5.38L11.71 5.41L12.85 5.78L13.83 6.46Z",
        "fill": "accent"
      },
      {
        "type": "polygon",
        "d": "M15.68 14.84L16.38 11.59L12.67 11.5Z",
        "fill": "accent"
      },
      {
        "type": "polygon",
        "d": "M14.1 9.5L14.02 8.81L13.79 8.15L13.42 7.57L12.93 7.08L12.35 6.71L11.69 6.48L11 6.4L10.31 6.48L9.65 6.71L9.07 7.08L8.58 7.57L8.21 8.15L7.98 8.81L7.9 9.5L7.98 10.19L8.21 10.85L8.58 11.43L9.07 11.92L9.65 12.29L10.31 12.52L11 12.6L11.69 12.52L12.35 12.29L12.93 11.92L13.42 11.43L13.79 10.85L14.02 10.19Z",
        "fill": "accent"
      },
      {
        "type": "polygon",
        "d": "M11 6.9L12.4 6.85L13.3 7.6L13.6 8.8L13 9.6L12.7 11.3L11.9 11.9L11.6 10.4L10.9 9.7L10.1 9.4L10.2 8.2L10.9 7.9Z",
        "fill": "truck"
      },
      {
        "type": "polygon",
        "d": "M8.3 8.6L9.1 9.3L9.3 10.4L8.9 11.4L8.3 10.6L8 9.6Z",
        "fill": "truck"
      }
    ],
    "fermopoint": [
      {
        "type": "polygon",
        "d": "M13.4 4L12.58 4.08L11.79 4.32L11.07 4.71L10.43 5.23L9.91 5.87L9.52 6.59L9.28 7.38L9.2 8.2L11.6 8.2L11.63 7.85L11.74 7.51L11.9 7.2L12.13 6.93L12.4 6.7L12.71 6.54L13.05 6.43L13.4 6.4Z",
        "fill": "accent"
      },
      {
        "type": "polygon",
        "d": "M13.2 4L16 4L16 6.4L13.2 6.4Z",
        "fill": "accent"
      },
      {
        "type": "polygon",
        "d": "M9.2 8.2L11.6 8.2L11.6 15L9.2 15Z",
        "fill": "accent"
      },
      {
        "type": "polygon",
        "d": "M6.8 7.9L14.8 7.9L14.8 10.2L6.8 10.2Z",
        "fill": "accent"
      }
    ],
    "fg-delivery": [
      {
        "type": "polygon",
        "d": "M14.35 11.25L14.91 10.42L15.26 9.48L15.4 8.49L15.31 7.5L14.99 6.55L14.47 5.7L13.77 4.99L12.93 4.45L11.99 4.11L11 4L10.01 4.11L9.07 4.45L8.23 4.99L7.53 5.7L7.01 6.55L6.69 7.5L6.6 8.49L6.74 9.48L7.09 10.42L7.65 11.25L11 15.2Z",
        "fill": "accent"
      },
      {
        "type": "polygon",
        "d": "M11 5.75L13.45 6.95L13.45 9.85L11 11.05L8.55 9.85L8.55 6.95Z",
        "fill": "truck"
      },
      {
        "type": "line",
        "d": "M8.55 6.95L11 8.15L13.45 6.95M11 8.15L11 11.05",
        "stroke": "accent",
        "strokeWidth": 1.2
      }
    ],
    "go4": [
      {
        "type": "polygon",
        "d": "M7.4 7L7.25 6.23L6.81 5.59L6.17 5.15L5.4 5L4.63 5.15L3.99 5.59L3.55 6.23L3.4 7L3.4 9.2L3.55 9.97L3.99 10.61L4.63 11.05L5.4 11.2L6.17 11.05L6.81 10.61L7.25 9.97L7.4 9.2Z",
        "fill": "accent"
      },
      {
        "type": "polygon",
        "d": "M5.9 7L5.86 6.81L5.75 6.65L5.59 6.54L5.4 6.5L5.21 6.54L5.05 6.65L4.94 6.81L4.9 7L4.9 9.2L4.94 9.39L5.05 9.55L5.21 9.66L5.4 9.7L5.59 9.66L5.75 9.55L5.86 9.39L5.9 9.2Z",
        "fill": "truck"
      },
      {
        "type": "polygon",
        "d": "M5.9 8L7.4 8L7.4 12.9L5.9 12.9Z",
        "fill": "accent"
      },
      {
        "type": "polygon",
        "d": "M5.9 12.6L7.4 12.6L7.4 13.5L7 14.3L6.2 14.65L3.5 14.65L3.5 13.15L5.6 13.15L5.9 12.9Z",
        "fill": "accent"
      },
      {
        "type": "polygon",
        "d": "M12.3 7L12.15 6.23L11.71 5.59L11.07 5.15L10.3 5L9.53 5.15L8.89 5.59L8.45 6.23L8.3 7L8.3 9.2L8.45 9.97L8.89 10.61L9.53 11.05L10.3 11.2L11.07 11.05L11.71 10.61L12.15 9.97L12.3 9.2Z",
        "fill": "accent"
      },
      {
        "type": "polygon",
        "d": "M10.8 7L10.76 6.81L10.65 6.65L10.49 6.54L10.3 6.5L10.11 6.54L9.95 6.65L9.84 6.81L9.8 7L9.8 9.2L9.84 9.39L9.95 9.55L10.11 9.66L10.3 9.7L10.49 9.66L10.65 9.55L10.76 9.39L10.8 9.2Z",
        "fill": "truck"
      },
      {
        "type": "polygon",
        "d": "M15.9 4L17.7 4L17.7 8.9L18.6 8.9L18.6 10.4L17.7 10.4L17.7 11.6L15.9 11.6L15.9 10.4L13.4 10.4L13.4 9Z",
        "fill": "#ef1f23"
      },
      {
        "type": "polygon",
        "d": "M15.9 6.9L15.9 8.9L14.9 8.9Z",
        "fill": "truck"
      }
    ],
    "happy-post": [
      {
        "type": "polygon",
        "d": "M13.24 8.2L12.88 7.77L7.37 11.54L4.82 10.22L4.46 9.61L4.87 9.04L16.59 4L17.34 4.62L15.3 14.64L14.93 15.12L14.33 15.1L11.21 13.51L8.97 15.2L8.13 14.72L8.29 13.22Z",
        "fill": "accent"
      }
    ],
    "hp-mostar": [
      {
        "type": "polygon",
        "d": "M13.9 7.5L13.83 7.16L13.64 6.86L13.34 6.67L13 6.6L6.2 6.6L5.86 6.67L5.56 6.86L5.37 7.16L5.3 7.5L5.3 14.1L5.37 14.44L5.56 14.74L5.86 14.93L6.2 15L13 15L13.34 14.93L13.64 14.74L13.83 14.44L13.9 14.1Z",
        "fill": "accent"
      },
      {
        "type": "polygon",
        "d": "M12.5 8.3L12.48 8.19L12.41 8.09L12.31 8.02L12.2 8L7 8L6.89 8.02L6.79 8.09L6.72 8.19L6.7 8.3L6.7 13.3L6.72 13.41L6.79 13.51L6.89 13.58L7 13.6L12.2 13.6L12.31 13.58L12.41 13.51L12.48 13.41L12.5 13.3Z",
        "fill": "truck"
      },
      {
        "type": "polygon",
        "d": "M16.7 4.9L16.63 4.56L16.44 4.26L16.14 4.07L15.8 4L9 4L8.66 4.07L8.36 4.26L8.17 4.56L8.1 4.9L8.1 11.5L8.17 11.84L8.36 12.14L8.66 12.33L9 12.4L15.8 12.4L16.14 12.33L16.44 12.14L16.63 11.84L16.7 11.5Z",
        "fill": "accent"
      },
      {
        "type": "polygon",
        "d": "M15.3 5.7L15.28 5.59L15.21 5.49L15.11 5.42L15 5.4L9.8 5.4L9.69 5.42L9.59 5.49L9.52 5.59L9.5 5.7L9.5 10.7L9.52 10.81L9.59 10.91L9.69 10.98L9.8 11L15 11L15.11 10.98L15.21 10.91L15.28 10.81L15.3 10.7Z",
        "fill": "#ffffff"
      },
      {
        "type": "line",
        "d": "M9.5 5.4L12.4 8.5L15.3 5.4",
        "stroke": "accent",
        "strokeWidth": 1.4
      }
    ],
    "hr-parcel": [
      {
        "type": "line",
        "d": "M4.52 6.3L3.5 12.7M8.36 6.3L7.34 12.7M4.01 9.5L7.85 9.5M9 12.7L10.02 6.3L11.82 6.3L12.37 6.4L12.82 6.69L13.12 7.13L13.23 7.68L13.14 8.25L12.86 8.8L12.42 9.24L11.87 9.53L11.28 9.63L9.49 9.63M11.16 9.63L12.71 12.7M14.25 12.7L15.27 6.3L17.06 6.3L17.62 6.4L18.07 6.69L18.37 7.13L18.48 7.68L18.39 8.25L18.11 8.8L17.66 9.24L17.12 9.53L16.53 9.63L14.74 9.63",
        "stroke": "accent",
        "strokeWidth": 1.8
      }
    ],
    "intex-paketdienst": [
      {
        "type": "polygon",
        "d": "M6.1 4L9.31 4L9.42 6.18L6.22 6.18Z",
        "fill": "accent"
      },
      {
        "type": "polygon",
        "d": "M9.31 4L12.17 4L12.17 6.18L9.42 6.18Z",
        "fill": "#7990a5"
      },
      {
        "type": "polygon",
        "d": "M6.22 6.18L9.42 6.18L9.77 8.35L6.67 8.35Z",
        "fill": "accent"
      },
      {
        "type": "polygon",
        "d": "M9.42 6.18L12.17 6.18L12.63 8.35L9.77 8.35Z",
        "fill": "#7990a5"
      },
      {
        "type": "polygon",
        "d": "M6.67 8.35L9.77 8.35L10.68 10.65L7.82 10.65Z",
        "fill": "accent"
      },
      {
        "type": "polygon",
        "d": "M9.77 8.35L12.63 8.35L13.55 10.65L10.68 10.65Z",
        "fill": "#7990a5"
      },
      {
        "type": "polygon",
        "d": "M7.82 10.65L10.68 10.65L12.17 12.94L9.88 12.94Z",
        "fill": "#7990a5"
      },
      {
        "type": "polygon",
        "d": "M10.68 10.65L13.55 10.65L14.58 12.94L12.17 12.94Z",
        "fill": "accent"
      },
      {
        "type": "polygon",
        "d": "M9.88 12.94L12.17 12.94L15.04 15L13.78 15Z",
        "fill": "#7990a5"
      },
      {
        "type": "polygon",
        "d": "M12.17 12.94L14.58 12.94L16.3 15L15.04 15Z",
        "fill": "accent"
      }
    ],
    "liccardi": [
      {
        "type": "polygon",
        "d": "M4.82 10.08L5.57 10.84L6.49 11.53L7.52 12.1L8.63 12.53L9.81 12.82L11.03 12.96L12.26 12.95L13.48 12.8L14.66 12.5L15.77 12.06L16.79 11.48L17.66 10.82L16.84 9.75L16.04 10.35L15.19 10.84L14.24 11.21L13.23 11.47L12.17 11.6L11.11 11.61L10.05 11.49L9.04 11.24L8.08 10.87L7.22 10.39L6.46 9.82L5.78 9.14Z",
        "fill": "#1fae5b"
      },
      {
        "type": "polygon",
        "d": "M4.8 11.5L7.69 8.47L10.44 6L12.78 4.62L16.22 4L14.02 4.96L12.51 6.13L11.34 7.72L14.57 7.85L17.6 7.92L16.22 9.23L13.88 9.92L10.44 10.47L7 11.09Z",
        "fill": "accent"
      },
      {
        "type": "polygon",
        "d": "M7.95 13.25L8.7 13.83L9.55 14.29L10.44 14.6L11.36 14.76L12.29 14.75L13.21 14.59L14.1 14.27L14.94 13.8L15.72 13.19L16.4 12.49L15.5 11.62L14.88 12.26L14.25 12.75L13.58 13.13L12.88 13.38L12.18 13.51L11.46 13.51L10.75 13.39L10.06 13.14L9.39 12.77L8.71 12.26Z",
        "fill": "#ff6b55"
      }
    ],
    "logoix": [
      {
        "type": "polygon",
        "d": "M11 8.33L13.68 5.65L12.25 5.65L12.25 4L16.5 4L16.5 8.25L14.85 8.25L14.85 6.82L12.17 9.5L14.85 12.18L14.85 10.75L16.5 10.75L16.5 15L12.25 15L12.25 13.35L13.68 13.35L11 10.67L8.32 13.35L9.75 13.35L9.75 15L5.5 15L5.5 10.75L7.15 10.75L7.15 12.18L9.83 9.5L7.15 6.82L7.15 8.25L5.5 8.25L5.5 4L9.75 4L9.75 5.65L8.32 5.65Z",
        "fill": "accent"
      }
    ],
    "nox": [
      {
        "type": "polygon",
        "d": "M5.05 12.3L5.05 8.93L5.1 8.66L5.21 8.51L5.36 8.4L5.55 8.37L5.74 8.4L5.89 8.51L6 8.66L6.05 8.93L6.05 12.3L7.7 12.3L7.7 8.77L7.55 8.02L7.08 7.32L6.38 6.85L5.55 6.68L4.72 6.85L4.02 7.32L3.55 8.02L3.4 8.77L3.4 12.3Z",
        "fill": "accent"
      },
      {
        "type": "polygon",
        "d": "M10.66 6.74L9.99 6.95L9.39 7.32L8.9 7.83L8.55 8.45L8.37 9.13L8.37 9.84L8.54 10.53L8.88 11.15L9.37 11.66L9.97 12.04L10.66 10.54L10.42 10.39L10.22 10.18L10.08 9.92L10.01 9.64L10.01 9.35L10.08 9.07L10.23 8.82L10.43 8.61L10.67 8.45L10.95 8.37Z",
        "fill": "accent"
      },
      {
        "type": "polygon",
        "d": "M11.39 12.29L12.13 12.12L12.8 11.77L13.34 11.24L13.73 10.59L13.93 9.87L13.92 9.11L13.72 8.38L13.33 7.74L12.78 7.22L12.11 6.87L11.54 8.42L11.82 8.56L12.04 8.78L12.2 9.04L12.29 9.34L12.29 9.65L12.21 9.95L12.05 10.22L11.83 10.43L11.55 10.58L11.25 10.65Z",
        "fill": "#fadb00"
      },
      {
        "type": "line",
        "d": "M14.55 6.7L18.45 12.3M18.45 6.7L14.55 12.3",
        "stroke": "accent",
        "strokeWidth": 1.65
      }
    ],
    "peddler": [
      {
        "type": "polygon",
        "d": "M6.9 4.3L8.69 4L8.69 14.63L6.9 15Z",
        "fill": "accent"
      },
      {
        "type": "polygon",
        "d": "M13.33 7.82L13.27 7.07L13.09 6.36L12.79 5.7L12.39 5.12L11.9 4.64L11.34 4.29L10.74 4.07L10.11 4L9.49 4.07L8.88 4.29L8.33 4.64L7.84 5.12L7.44 5.7L7.14 6.36L6.96 7.07L6.9 7.82L6.96 8.56L7.14 9.28L7.44 9.94L7.84 10.51L8.33 10.99L8.88 11.34L9.49 11.56L10.11 11.63L10.74 11.56L11.34 11.34L11.9 10.99L12.39 10.51L12.79 9.94L13.09 9.28L13.27 8.56Z",
        "fill": "accent"
      },
      {
        "type": "polygon",
        "d": "M11.54 7.82L11.49 7.25L11.34 6.73L11.12 6.28L10.82 5.94L10.48 5.72L10.11 5.65L9.75 5.72L9.4 5.94L9.11 6.28L8.88 6.73L8.74 7.25L8.69 7.82L8.74 8.38L8.88 8.9L9.11 9.35L9.4 9.7L9.75 9.91L10.11 9.99L10.48 9.91L10.82 9.7L11.12 9.35L11.34 8.9L11.49 8.38Z",
        "fill": "truck"
      },
      {
        "type": "circle",
        "cx": 13.33,
        "cy": 13.28,
        "r": 1.25,
        "fill": "#29b84f"
      }
    ],
    "pigeon-express": [
      {
        "type": "polygon",
        "d": "M6.06 6.11L7.45 7.33L9.56 8.48L10.97 9.65L11.7 11.39L12.31 10.31L12.97 10.15L13.67 10.38L14.33 11.16L14.52 11.93L13.84 11.93L13.08 12.12L12.57 12.59L10.74 14.11L8.86 15.01L6.44 15.1L7.8 14.11L8.58 12.26L7.92 10.71L6.63 9.89L6.13 9.02L5.95 7.42Z",
        "fill": "accent"
      },
      {
        "type": "polygon",
        "d": "M6.65 3.9L7.68 5.07L9.7 6.62L11.35 8.27L11.96 10.8L10.64 9.21L8.76 8.17L7.03 6.58L6.49 5.07Z",
        "fill": "#ff8c12"
      },
      {
        "type": "polygon",
        "d": "M12.99 12.4L15.57 11.51L15.85 12.96L13.27 14.14Z",
        "fill": "#ff8c12"
      }
    ],
    "posta-faroe": [
      {
        "type": "polygon",
        "d": "M10.22 4L12.39 4L15.37 7.66L12.39 11.34L10.22 11.34L13.2 7.66Z",
        "fill": "accent"
      },
      {
        "type": "polygon",
        "d": "M9.61 7.66L11.78 7.66L8.83 11.34L11.78 15L9.61 15L6.63 11.34Z",
        "fill": "accent"
      }
    ],
    "tusass": [
      {
        "type": "polygon",
        "d": "M10.72 4L11.56 4L11.56 6.63L13.82 6.63L13.82 8.51L11.56 8.51L11.56 11.8L11.69 12.42L12.03 12.93L12.55 13.28L13.16 13.4L13.82 13.4L13.82 15L12.26 14.89L11.42 14.57L10.7 14.06L10.15 13.4L9.8 12.63L9.68 11.8L9.68 8.51L8.18 8.51L8.18 7.85Z",
        "fill": "accent"
      }
    ],
    "tws-express": [
      {
        "type": "polygon",
        "d": "M11 3.95L6.19 6.73L6.19 12.28L11 15.05L15.81 12.28L15.81 6.72Z",
        "fill": "accent"
      },
      {
        "type": "polygon",
        "d": "M8.53 9.31L15.81 6.72L11.03 12.47L11.03 9.31Z",
        "fill": "truck"
      }
    ],
    "byhd": [
      {
        "type": "polygon",
        "d": "M9.76 4.14L8.88 4.43L8.06 4.85L7.32 5.42L6.68 6.09L6.17 6.87L5.8 7.72L5.57 8.62L5.5 9.54L5.59 10.47L5.83 11.36L6.21 12.21L6.74 12.98L7.38 13.64L8.13 14.19L8.96 14.61L9.54 12.95L8.98 12.66L8.48 12.28L8.06 11.82L7.71 11.3L7.46 10.73L7.3 10.12L7.25 9.49L7.3 8.87L7.46 8.26L7.72 7.69L8.07 7.16L8.5 6.71L9 6.33Z",
        "fill": "accent"
      },
      {
        "type": "polygon",
        "d": "M11.45 10.66L13.4 10.08L13.48 10.63L12.8 11.8L11.7 14.96L10.83 15L9.97 14.9Z",
        "fill": "accent"
      },
      {
        "type": "polygon",
        "d": "M10.92 4L11.77 4.05L12.59 4.24L9.89 11.96L9.36 11.64L8.92 11.22L8.58 10.7Z",
        "fill": "#df7017"
      },
      {
        "type": "polygon",
        "d": "M13.56 4.63L14.33 5.12L15 5.72L15.56 6.43L16 7.21L16.31 8.06L16.47 8.95L16.49 9.85L16.36 10.75L16.08 11.61L15.67 12.41L15.13 13.13L14.48 13.76L13.73 14.27L12.92 14.66L13.88 11.9L14.25 11.37L14.52 10.78L14.69 10.15L14.75 9.51L14.7 8.86L14.53 8.23L14.26 7.64L13.84 8.85L11.88 9.44Z",
        "fill": "#df7017"
      }
    ],
    "eurodis": [
      {
        "type": "polygon",
        "d": "M9.52 4L3.9 5.86L3.9 10.28L12.65 15L18.09 12.28L18.09 7.86Z",
        "fill": "accent"
      },
      {
        "type": "polygon",
        "d": "M9.44 5.5L5.57 6.78L12.65 10.71L16.52 8.68Z",
        "fill": "truck"
      }
    ],
    "parcelpoint": [
      {
        "type": "polygon",
        "d": "M7.85 14.6L7.85 4.4L11.15 4.4L12.08 4.55L12.91 4.97L13.58 5.64L14 6.47L14.15 7.4L14 8.33L13.58 9.16L12.91 9.83L12.08 10.25L11.15 10.4L10.25 10.4L10.25 14.6Z",
        "fill": "accent"
      },
      {
        "type": "polygon",
        "d": "M10.25 6.4L11.15 6.4L11.53 6.48L11.86 6.69L12.07 7.02L12.15 7.4L12.07 7.78L11.86 8.11L11.53 8.32L11.15 8.4L10.25 8.4Z",
        "fill": "truck"
      },
      {
        "type": "circle",
        "cx": 12.55,
        "cy": 13.25,
        "r": 1.35,
        "fill": "accent"
      }
    ],
    "drop2shop": [
      {
        "type": "line",
        "d": "M5.08 6.68L5.44 5.93L6.04 5.36L6.81 5.05L7.64 5.03L8.42 5.31L9.05 5.86L9.43 6.6L9.53 7.42L9.32 8.23L5.25 13.4L15.8 13.4",
        "stroke": "accent",
        "strokeWidth": 2
      },
      {
        "type": "polygon",
        "d": "M18.2 13.4L15.5 11.65L15.5 15.15Z",
        "fill": "accent"
      }
    ],
    "neighbour-express": [
      {
        "type": "polygon",
        "d": "M3.4 10.2L6.9 7.6L9.4 11L17.59 5.42L19 5.6L18 15L3.4 15Z",
        "fill": "#6ea25a"
      },
      {
        "type": "line",
        "d": "M3.4 10.2L6.9 7.6L9.4 11L16.6 6.1",
        "stroke": "accent",
        "strokeWidth": 1.6
      },
      {
        "type": "polygon",
        "d": "M18.58 4.75L17.58 7.55L15.62 4.65Z",
        "fill": "accent"
      }
    ],
    "packli-punkt": [
      {
        "type": "line",
        "d": "M5.04 13.7L5.04 5.3L7.39 5.3L8.13 5.43L8.79 5.81L9.28 6.39L9.54 7.1L9.54 7.86L9.28 8.58L8.79 9.16L8.13 9.54L7.39 9.67L5.04 9.67M12.43 13.7L12.43 5.3L14.78 5.3L15.53 5.43L16.18 5.81L16.67 6.39L16.93 7.1L16.93 7.86L16.67 8.58L16.18 9.16L15.53 9.54L14.78 9.67L12.43 9.67",
        "stroke": "accent",
        "strokeWidth": 2
      }
    ],
    "yilong-logistics": [
      {
        "type": "polygon",
        "d": "M14.9 7.05L14.62 6.25L14.13 5.58L13.51 5.03L12.79 4.62L12.01 4.36L11.2 4.25L10.38 4.31L9.58 4.52L8.84 4.88L8.18 5.38L7.61 5.99L7.17 6.69L6.86 7.45L6.7 8.24L6.68 9.04L6.79 9.8L7.04 10.51L7.39 11.13L7.84 11.66L8.36 12.06L8.92 12.33L9.49 12.47L10.05 12.48L10.57 12.35L11.02 12.1L11.35 11.67L11.01 11.51L10.72 11.41L10.46 11.29L10.22 11.13L10 10.95L9.8 10.75L9.63 10.51L9.48 10.24L9.36 9.95L9.27 9.63L9.21 9.29L9.19 8.93L9.22 8.55L9.3 8.16L9.44 7.77L9.64 7.38L9.91 7.02L10.24 6.69L10.65 6.41L11.12 6.2L11.65 6.07L12.23 6.04L12.85 6.11L13.5 6.31L14.17 6.63L14.9 7.05Z",
        "fill": "accent"
      },
      {
        "type": "polygon",
        "d": "M7.1 11.95L7.38 12.75L7.87 13.42L8.49 13.97L9.21 14.38L9.99 14.64L10.8 14.75L11.62 14.69L12.42 14.48L13.16 14.12L13.82 13.62L14.39 13.01L14.83 12.31L15.14 11.55L15.3 10.76L15.32 9.96L15.21 9.2L14.96 8.49L14.61 7.87L14.16 7.34L13.64 6.94L13.08 6.67L12.51 6.53L11.95 6.52L11.43 6.65L10.98 6.9L10.65 7.33L10.99 7.49L11.28 7.59L11.54 7.71L11.78 7.87L12 8.05L12.2 8.25L12.37 8.49L12.52 8.76L12.64 9.05L12.73 9.37L12.79 9.71L12.81 10.07L12.78 10.45L12.7 10.84L12.56 11.23L12.36 11.62L12.09 11.98L11.76 12.31L11.35 12.59L10.88 12.8L10.35 12.93L9.77 12.96L9.15 12.89L8.5 12.69L7.83 12.37L7.1 11.95Z",
        "fill": "accent"
      }
    ],
    "codexpress": [
      {
        "type": "polygon",
        "d": "M3.5 4.62L11 9.31L18.5 4.62L18.5 6.97L14.66 9.5L7.34 9.5L3.5 6.97Z",
        "fill": "#8fd4f5"
      },
      {
        "type": "polygon",
        "d": "M3.5 14.38L11 9.69L18.5 14.38L18.5 12.03L14.66 9.5L7.34 9.5L3.5 12.03Z",
        "fill": "#00aeef"
      }
    ],
    "designer-transport": [
      {
        "type": "polygon",
        "d": "M5.65 5.2L7.4 5.2L8.14 5.35L8.83 5.78L9.42 6.46L9.87 7.35L10.15 8.39L10.25 9.5L10.15 10.61L9.87 11.65L9.42 12.54L8.83 13.22L8.14 13.65L7.4 13.8L5.65 13.8Z",
        "fill": "accent"
      },
      {
        "type": "polygon",
        "d": "M7.25 6.8L7.4 6.8L7.72 6.89L8.03 7.16L8.28 7.59L8.48 8.15L8.61 8.8L8.65 9.5L8.61 10.2L8.48 10.85L8.28 11.41L8.03 11.84L7.72 12.11L7.4 12.2L7.25 12.2Z",
        "fill": "truck"
      },
      {
        "type": "polygon",
        "d": "M11.55 5.2L16.35 5.2L16.35 6.8L14.75 6.8L14.75 13.8L13.15 13.8L13.15 6.8L11.55 6.8Z",
        "fill": "accent"
      }
    ],
    "direct-couriers": [
      {
        "type": "polygon",
        "d": "M13.67 11.08L13.72 10.33L13.63 9.62L13.39 8.97L13.01 8.41L12.52 7.97L11.93 7.67L11.27 7.51L10.57 7.51L9.86 7.67L9.16 7.97L8.52 8.41L7.96 8.97L7.5 9.62L7.16 10.33L6.96 11.08L6.9 11.82L7 12.54L7.24 13.18L7.62 13.74L8.11 14.18L8.7 14.49L9.36 14.64L10.06 14.64L10.77 14.49L11.46 14.18L12.11 13.74L12.67 13.18L13.13 12.54L13.47 11.82Z",
        "fill": "accent"
      },
      {
        "type": "polygon",
        "d": "M12.83 5.21L14.13 4.06L15.12 4.06L13.29 14.66L11.38 14.66Z",
        "fill": "accent"
      },
      {
        "type": "polygon",
        "d": "M11.8 11L11.84 10.53L11.79 10.09L11.66 9.73L11.46 9.48L11.2 9.34L10.91 9.34L10.6 9.48L10.31 9.73L10.06 10.09L9.86 10.53L9.74 11L9.7 11.47L9.75 11.91L9.88 12.27L10.08 12.53L10.34 12.66L10.64 12.66L10.94 12.53L11.23 12.27L11.48 11.91L11.68 11.47Z",
        "fill": "truck"
      }
    ],
    "ewe": [
      {
        "type": "polygon",
        "d": "M3.13 5.8L6.93 5.8L6.93 7.45L3.13 7.45Z",
        "fill": "accent"
      },
      {
        "type": "polygon",
        "d": "M3.13 8.68L6.93 8.68L6.93 10.32L3.13 10.32Z",
        "fill": "accent"
      },
      {
        "type": "polygon",
        "d": "M3.13 10.32L4.78 10.32L4.78 11.55L6.93 11.55L6.93 13.2L3.13 13.2Z",
        "fill": "accent"
      },
      {
        "type": "polygon",
        "d": "M7.78 5.8L9.22 5.8L9.22 11.55L10.28 11.55L10.28 5.8L11.73 5.8L11.73 11.55L12.78 11.55L12.78 5.8L14.22 5.8L14.22 13.2L7.78 13.2Z",
        "fill": "accent"
      },
      {
        "type": "polygon",
        "d": "M15.07 5.8L18.88 5.8L18.88 7.45L15.07 7.45Z",
        "fill": "accent"
      },
      {
        "type": "polygon",
        "d": "M15.07 8.68L18.88 8.68L18.88 10.32L15.07 10.32Z",
        "fill": "accent"
      },
      {
        "type": "polygon",
        "d": "M15.07 10.32L16.72 10.32L16.72 11.55L18.88 11.55L18.88 13.2L15.07 13.2Z",
        "fill": "accent"
      }
    ],
    "homexpress": [
      {
        "type": "polygon",
        "d": "M7 5L9.4 5L9.4 8.5L12.6 8.5L12.6 5L15 5L15 14L12.6 14L12.6 10.5L9.4 10.5L9.4 14L7 14Z",
        "fill": "accent"
      }
    ],
    "postmedia-parcel-services": [
      {
        "type": "polygon",
        "d": "M5.15 4.2L7.45 4.2L12.75 9.5L7.45 14.8L5.15 14.8L10.45 9.5Z",
        "fill": "#707070"
      },
      {
        "type": "polygon",
        "d": "M9.25 4.2L11.55 4.2L16.85 9.5L11.55 14.8L9.25 14.8L14.55 9.5Z",
        "fill": "accent"
      }
    ],
    "precision-deliveries": [
      {
        "type": "polygon",
        "d": "M7 4.2L12.8 4.2L13.73 4.38L14.56 4.89L15.23 5.68L15.65 6.69L15.8 7.8L15.65 8.91L15.23 9.92L14.56 10.71L13.73 11.22L12.8 11.4L10.5 11.4L10.5 14.8L6.2 11.5L6.2 7.6L10.4 7.6L10.4 6.6L13.2 9L7.6 9L7.6 10.81L9.1 11.96L9.1 10L12.8 10L13.41 9.83L13.93 9.36L14.28 8.64L14.4 7.8L14.28 6.96L13.93 6.24L13.41 5.77L12.8 5.6L6.4 5.6Z",
        "fill": "accent"
      }
    ],
    "transport-rdl": [
      {
        "type": "polygon",
        "d": "M4.39 6.2L8.49 6.2L9.31 7.2L8.89 9.56L7.71 10.56L6.78 10.56L8.32 12.8L6.58 12.8L6.22 10.51L6.48 9.06L7.33 9.06L7.57 7.7L5.77 7.7L4.87 12.8L3.22 12.8Z",
        "fill": "accent"
      },
      {
        "type": "polygon",
        "d": "M10.59 6.2L14.14 6.2L15.21 7.5L14.5 11.5L12.97 12.8L9.17 12.8L9.89 8.7L11.54 8.7L11.08 11.3L12.63 11.3L12.93 11.05L13.48 7.95L13.27 7.7L10.32 7.7Z",
        "fill": "accent"
      },
      {
        "type": "polygon",
        "d": "M16.29 6.2L17.94 6.2L17.03 11.3L18.78 11.3L18.52 12.8L15.12 12.8Z",
        "fill": "accent"
      }
    ],
    "energo": [
      {
        "type": "polygon",
        "d": "M11 3.9L11.35 3.95L11.22 4.76L10.86 5.33L10.23 5.7L7.65 6.8L15.68 6.8L16.93 8.1L3.66 8.1L3.74 7.45L3.96 6.93L4.37 6.57Z",
        "fill": "accent"
      },
      {
        "type": "polygon",
        "d": "M7.37 9.1L17.14 9.1L18.4 10.4L8.35 10.4Z",
        "fill": "accent"
      },
      {
        "type": "polygon",
        "d": "M8.91 11.4L16.45 11.4L17.84 12.7L9.88 12.7Z",
        "fill": "accent"
      },
      {
        "type": "polygon",
        "d": "M10.3 13.7L15.19 13.7L16.45 15L11.42 15Z",
        "fill": "accent"
      }
    ],
    "t-group": [
      {
        "type": "polygon",
        "d": "M14.08 4.71L13.28 4.28L12.42 3.98L11.53 3.82L10.62 3.81L9.72 3.95L8.85 4.22L8.04 4.63L7.32 5.16L6.7 5.8L6.19 6.53L5.82 7.33L5.58 8.18L5.5 9.05L5.57 9.93L5.78 10.78L6.14 11.59L6.64 12.33L7.25 12.98L7.96 13.52L8.76 13.94L9.62 14.23L10.52 14.38L11.43 14.38L12.33 14.24L11.98 13.7L11.27 13.65L10.59 13.5L9.93 13.26L9.31 12.94L8.75 12.54L8.26 12.06L7.85 11.53L7.53 10.95L7.31 10.33L7.18 9.69L7.15 9.03L7.23 8.38L7.41 7.75L7.69 7.15L8.05 6.59L8.51 6.09L9.03 5.65L9.62 5.29L10.26 5.01L10.94 4.81L11.64 4.71L12.34 4.71L13.05 4.8L13.73 4.98Z",
        "fill": "accent"
      },
      {
        "type": "polygon",
        "d": "M10.62 6L16.52 6L16.1 7.55L14.49 7.55L13.15 12.5L10.9 12.5L12.24 7.55L10.2 7.55Z",
        "fill": "#0b4674"
      }
    ],
    "method": [
      {
        "type": "polygon",
        "d": "M5.4 13.9L5.4 4.1L7.7 4.1L11 10.7L14.3 4.1L16.6 4.1L16.6 13.9L14.5 13.9L14.5 7.4L12.1 13.9L9.9 13.9L7.5 7.4L7.5 13.9Z",
        "fill": "accent"
      }
    ],
    "sailpost": [
      {
        "type": "polygon",
        "d": "M7.45 13.8L7.48 13.4L7.53 12.88L7.6 12.4L7.68 11.9L7.77 11.42L7.89 10.95L8.04 10.49L8.23 10.04L8.47 9.58L8.77 9.12L9.13 8.65L9.56 8.18L10.07 7.69L10.62 7.22L11.18 6.82L11.76 6.46L12.39 6.15L12.98 5.87L13.47 5.68L14 5.53L14.58 5.4L15.42 5.27L17.15 5.14L18.7 5.04L18.7 4.29L17.14 4.22L15.38 4.17L14.43 4.2L13.76 4.28L13.12 4.39L12.5 4.56L11.78 4.83L11.06 5.2L10.38 5.61L9.73 6.08L9.1 6.61L8.51 7.17L8.02 7.72L7.59 8.28L7.22 8.84L6.92 9.41L6.68 9.99L6.5 10.55L6.36 11.11L6.25 11.65L6.16 12.19L6.09 12.72L6.04 13.27L6 13.68Z",
        "fill": "#000000"
      },
      {
        "type": "line",
        "d": "M10.8 13.74L10.82 12.8L10.94 11.77L11.22 10.75L11.6 9.72L12.17 8.7L12.93 7.67L13.88 6.65L14.64 6.03L15.4 5.62L16.16 5.34L16.92 5.13L17.68 4.93",
        "stroke": "#000000",
        "strokeWidth": 1.45
      },
      {
        "type": "line",
        "d": "M4.38 9.64L12.36 9.64M4.09 11.9L13.12 11.9",
        "stroke": "#000000",
        "strokeWidth": 1.4
      }
    ],
    "tforce-logistics": [
      {
        "type": "polygon",
        "d": "M4.83 7.3L10.63 7.3L10.2 9.1L8.4 9.1L7.22 14L5.17 14L6.35 9.1L4.4 9.1Z",
        "fill": "accent"
      },
      {
        "type": "polygon",
        "d": "M11.63 7.3L17.63 7.3L17.2 9.1L13.25 9.1L13.01 10.1L15.96 10.1L15.55 11.8L12.6 11.8L12.07 14L10.02 14Z",
        "fill": "accent"
      },
      {
        "type": "polygon",
        "d": "M8.3 6.55L10.1 5.45L12.1 4.7L14.2 4.28L16.2 4.12L17.8 4.2L18.9 4.42L18.6 5.94L17.65 5.52L16.22 5.22L14.32 5.13L12.27 5.29L10.25 5.75Z",
        "fill": "#ff6b5e"
      }
    ],
    "globalpost": [
      {
        "type": "polygon",
        "d": "M11 14.97L9.89 14.86L8.82 14.52L7.85 13.96L7.01 13.22L6.34 12.32L5.87 11.31L5.62 10.22L5.59 9.1L5.8 8L6.23 6.96L6.86 6.04L7.67 5.27L8.62 4.67L9.68 4.29L10.78 4.13L11.9 4.2L12.98 4.5L13.97 5.01L14.84 5.72L15.55 6.59L13.96 8.31L13.45 7.47L12.7 6.83L11.79 6.44L10.81 6.35L9.85 6.55L8.99 7.04L8.33 7.77L7.91 8.67L7.79 9.64L7.97 10.61L8.44 11.48L9.14 12.17L10.03 12.61L11 12.76Z",
        "fill": "accent"
      },
      {
        "type": "polygon",
        "d": "M16.34 9.59L16.34 13.32L14.69 14.97L14.69 11.24L10.96 11.24L12.59 9.59Z",
        "fill": "accent"
      }
    ],
    "united-delivery-service": [
      {
        "type": "polygon",
        "d": "M4.67 6L3.63 10.96L3.6 11.55L3.77 12.14L4.14 12.61L4.67 12.91L5.3 13.01L5.97 12.91L6.62 12.61L7.19 12.14L7.61 11.55L7.83 10.96L8.87 6L7.32 6L6.3 10.84L6.22 11.07L6.11 11.22L5.97 11.34L5.8 11.41L5.63 11.44L5.47 11.41L5.33 11.34L5.24 11.22L5.19 11.07L5.2 10.84L6.22 6Z",
        "fill": "accent"
      },
      {
        "type": "polygon",
        "d": "M9.72 6L10.42 6L11.3 6.12L12.07 6.47L12.68 7.03L13.08 7.75L13.26 8.59L13.18 9.5L12.88 10.41L12.35 11.25L11.64 11.97L10.8 12.53L9.88 12.88L8.95 13L8.25 13Z",
        "fill": "accent"
      },
      {
        "type": "polygon",
        "d": "M18.87 6L16.57 6L15.85 6.17L15.13 6.67L14.6 7.36L14.31 8.14L14.27 8.92L14.51 9.61L15.02 10.11L15.67 10.28L15.98 10.28L16.14 10.32L16.24 10.4L16.3 10.6L16.29 10.86L16.19 11.13L16.04 11.32L15.91 11.41L15.74 11.45L13.63 11.45L13.3 13L15.6 13L16.32 12.83L17.04 12.33L17.57 11.64L17.86 10.86L17.9 10.08L17.66 9.39L17.15 8.89L16.5 8.72L16.19 8.72L16.03 8.68L15.93 8.6L15.87 8.4L15.88 8.14L15.98 7.87L16.13 7.68L16.26 7.59L16.43 7.55L18.54 7.55Z",
        "fill": "accent"
      },
      {
        "type": "polygon",
        "d": "M3.75 12.07L3.77 12.14L4.14 12.61L4.67 12.91L5.3 13.01L5.97 12.91L6.62 12.61L7.19 12.14L7.61 11.55L7.83 10.96L7.84 10.89Z",
        "fill": "#cdcdcd"
      },
      {
        "type": "polygon",
        "d": "M13.2 9.35L13.18 9.5L12.88 10.41L12.35 11.25L11.64 11.97L10.8 12.53L9.88 12.88L8.95 13L8.25 13L8.75 10.63Z",
        "fill": "#cdcdcd"
      },
      {
        "type": "polygon",
        "d": "M14.31 9.03L14.51 9.61L15.02 10.11L15.67 10.28L15.98 10.28L16.14 10.32L16.24 10.4L16.3 10.6L16.29 10.86L16.19 11.13L16.04 11.32L15.91 11.41L15.74 11.45L13.63 11.45L13.3 13L15.6 13L16.32 12.83L17.04 12.33L17.57 11.64L17.86 10.86L17.9 10.08L17.66 9.39L17.15 8.89L16.5 8.72L16.19 8.72L16.03 8.68L15.93 8.6L15.92 8.56Z",
        "fill": "#cdcdcd"
      },
      {
        "type": "polygon",
        "d": "M3.43 12.66L18.88 8.21L18.62 7.29L3.17 11.74Z",
        "fill": "truck"
      },
      {
        "type": "polygon",
        "d": "M10.94 7.55L10.09 7.55L10.81 7.7L11.35 8.12L11.64 8.75L11.63 9.5L11.33 10.25L10.77 10.88L10.05 11.3L9.28 11.45L10.13 11.45Z",
        "fill": "truck"
      }
    ],
    "best-overnite-express": [
      {
        "type": "polygon",
        "d": "M3.47 14.6L6.41 13.73L9.37 12.91L12.35 12.19L15.46 11.56L18.48 11.16L18.72 13.24L15.74 13.54L12.65 13.91L9.63 14.29L6.59 14.67L3.53 14.9Z",
        "fill": "#ff5b61"
      },
      {
        "type": "polygon",
        "d": "M3.08 4.3L5.93 4.3L6.58 4.95L6.58 6.75L6.18 7.3L6.68 7.85L6.68 9.65L6.03 10.3L3.08 10.3Z",
        "fill": "accent"
      },
      {
        "type": "polygon",
        "d": "M7.48 4.3L10.43 4.3L10.43 5.6L8.83 5.6L8.83 6.65L10.08 6.65L10.08 7.95L8.83 7.95L8.83 9L10.43 9L10.43 10.3L7.48 10.3Z",
        "fill": "accent"
      },
      {
        "type": "polygon",
        "d": "M14.63 4.3L11.83 4.3L11.23 4.9L11.23 7.35L11.83 7.95L13.28 7.95L13.28 9L11.23 9L11.23 10.3L14.03 10.3L14.63 9.7L14.63 7.25L14.03 6.65L12.58 6.65L12.58 5.6L14.63 5.6Z",
        "fill": "accent"
      },
      {
        "type": "polygon",
        "d": "M15.43 4.3L18.93 4.3L18.93 5.6L17.85 5.6L17.85 10.3L16.5 10.3L16.5 5.6L15.43 5.6Z",
        "fill": "accent"
      },
      {
        "type": "polygon",
        "d": "M4.43 5.6L5.28 5.6L5.28 6.65L4.43 6.65Z",
        "fill": "truck"
      },
      {
        "type": "polygon",
        "d": "M4.43 7.95L5.38 7.95L5.38 9L4.43 9Z",
        "fill": "truck"
      }
    ],
    "estes-forwarding": [
      {
        "type": "polygon",
        "d": "M6.26 4.15L17.11 4.15L16.14 8.46L15.9 7.68L15.5 6.98L14.93 6.36L14.2 5.81L13.29 5.34L12.22 4.95L10.98 4.63L9.58 4.39L8 4.23Z",
        "fill": "accent"
      },
      {
        "type": "polygon",
        "d": "M5.21 9.46L6.49 9.3L7.67 9.12L8.75 8.91L9.72 8.69L10.59 8.44L11.36 8.17L12.03 7.87L12.6 7.56L13.07 7.22L12.1 11.86L11.69 11.46L11.19 11.09L10.6 10.76L9.92 10.46L9.16 10.19L8.31 9.96L7.36 9.76L6.33 9.6Z",
        "fill": "accent"
      },
      {
        "type": "polygon",
        "d": "M4.09 14.85L14.79 14.85L15.61 10.66L15.13 11.39L14.51 12.05L13.73 12.64L12.8 13.16L11.72 13.62L10.5 14L9.12 14.32L7.59 14.56L5.92 14.74Z",
        "fill": "accent"
      }
    ],
    "ajex": [
      {
        "type": "polygon",
        "d": "M3.16 12.3L4.86 6.6L5.86 6.6L7.56 12.3L5.96 12.3L5.53 10.85L5.2 10.85L4.76 12.3Z",
        "fill": "accent"
      },
      {
        "type": "polygon",
        "d": "M9.59 6.6L11.09 6.6L11.09 10.68L10.97 11.27L10.65 11.78L10.17 12.14L9.59 12.3L8.99 12.23L8.46 11.95L8.06 11.49L9.36 10.74L9.45 10.8L9.54 10.77L9.59 10.68Z",
        "fill": "accent"
      },
      {
        "type": "polygon",
        "d": "M11.79 6.6L14.54 6.6L14.54 7.9L13.29 7.9L13.29 8.8L14.24 8.8L14.24 10.1L13.29 10.1L13.29 11L14.54 11L14.54 12.3L11.79 12.3Z",
        "fill": "accent"
      },
      {
        "type": "polygon",
        "d": "M15.14 6.6L16.89 6.6L18.84 12.3L17.09 12.3Z",
        "fill": "accent"
      },
      {
        "type": "polygon",
        "d": "M17.09 6.6L18.84 6.6L16.89 12.3L15.14 12.3Z",
        "fill": "accent"
      }
    ],
    "exelot": [
      {
        "type": "polygon",
        "d": "M6.1 4L11.1 4L12.86 5.81L9.82 8.9L6.1 5.18Z",
        "fill": "#f68c38"
      },
      {
        "type": "polygon",
        "d": "M6.1 12.62L9.82 8.9L12.86 11.99L11.1 13.8L6.1 13.8Z",
        "fill": "#3d86ff"
      },
      {
        "type": "polygon",
        "d": "M12.86 5.81L15.9 8.9L12.86 11.99L9.82 8.9Z",
        "fill": "accent"
      }
    ],
    "kwick-box": [
      {
        "type": "polygon",
        "d": "M4.64 6.6L6.51 6.6L6.51 14.01L4.64 14.01Z",
        "fill": "#a7a9ac"
      },
      {
        "type": "polygon",
        "d": "M6.44 8.78L7.53 6.6L9.4 6.6L6.44 11.59Z",
        "fill": "#a7a9ac"
      },
      {
        "type": "polygon",
        "d": "M6.83 10.5L7.84 9.25L9.55 14.01L7.68 14.01Z",
        "fill": "#a7a9ac"
      },
      {
        "type": "polygon",
        "d": "M10.34 6.6L13.3 6.6L13.96 6.76L14.5 7.21L14.81 7.87L14.84 8.61L14.58 9.3L14.08 9.8L13.93 9.95L15.09 11.24L15.17 12.03L15.01 12.79L14.64 13.44L14.09 13.86L13.46 14.01L10.34 14.01Z",
        "fill": "accent"
      },
      {
        "type": "polygon",
        "d": "M12.99 8L13.08 8.02L13.16 8.07L13.21 8.15L13.23 8.24L13.23 9.02L13.21 9.11L13.16 9.18L13.08 9.23L12.99 9.25L12.29 9.25L12.2 9.23L12.12 9.18L12.07 9.11L12.05 9.02L12.05 8.24L12.07 8.15L12.12 8.07L12.2 8.02L12.29 8Z",
        "fill": "truck"
      },
      {
        "type": "polygon",
        "d": "M13.23 10.81L13.34 10.84L13.45 10.9L13.51 11L13.54 11.12L13.54 12.29L13.51 12.41L13.45 12.51L13.34 12.58L13.23 12.61L12.37 12.61L12.25 12.58L12.15 12.51L12.08 12.41L12.05 12.29L12.05 11.12L12.08 11L12.15 10.9L12.25 10.84L12.37 10.81Z",
        "fill": "truck"
      },
      {
        "type": "line",
        "d": "M12.84 4.8L16.66 4.8L16.66 8.55",
        "stroke": "accent",
        "strokeWidth": 1.4
      }
    ],
    "labaih": [
      {
        "type": "polygon",
        "d": "M4.2 4L5.8 4L5.8 10.4L18 10.4L18 11.75L4.2 11.75Z",
        "fill": "accent"
      },
      {
        "type": "polygon",
        "d": "M12.3 4L13.9 4L13.9 10.6L12.3 10.6Z",
        "fill": "accent"
      },
      {
        "type": "line",
        "d": "M13.1 7.33L13.26 6.58L13.7 5.95L14.37 5.53L15.15 5.38L15.93 5.53L16.6 5.95L17.04 6.58L17.2 7.33L17.2 10.6",
        "stroke": "accent",
        "strokeWidth": 1.6
      },
      {
        "type": "circle",
        "cx": 6.9,
        "cy": 12.45,
        "r": 0.95,
        "fill": "accent"
      },
      {
        "type": "circle",
        "cx": 15,
        "cy": 12.45,
        "r": 0.95,
        "fill": "accent"
      }
    ],
    "shipblu": [
      {
        "type": "polygon",
        "d": "M3.2 5.15L9.09 5.15L13.41 7.4L10.56 8.78Z",
        "fill": "accent"
      },
      {
        "type": "polygon",
        "d": "M13.41 7.5L17.55 5.47L16.54 8.92Z",
        "fill": "accent"
      },
      {
        "type": "polygon",
        "d": "M10.47 8.88L13.5 10.35L16.49 9.01L13.83 12.65L11.3 10.99Z",
        "fill": "accent"
      },
      {
        "type": "polygon",
        "d": "M11.3 10.99L13.83 12.65L9.09 13.75L6.51 13.94Z",
        "fill": "#0a3266"
      },
      {
        "type": "polygon",
        "d": "M17.32 5.33L18.93 6.67L16.86 6.81Z",
        "fill": "#0a3266"
      }
    ],
    "starlinks": [
      {
        "type": "polygon",
        "d": "M11 4.05L10.41 6.03L8.34 5.98L10.04 7.16L9.35 9.12L11 7.86L12.65 9.12L11.96 7.16L13.66 5.98L11.59 6.03Z",
        "fill": "accent"
      },
      {
        "type": "polygon",
        "d": "M3.4 14.3L4.35 13.4L5.3 12.54L6.25 11.74L7.2 11.05L8.15 10.48L9.1 10.05L10.05 9.79L11 9.7L11.95 9.79L12.9 10.05L13.85 10.48L14.8 11.05L15.75 11.74L16.7 12.54L17.65 13.4L18.6 14.3L18.6 15.6L17.65 14.84L16.7 14.1L15.75 13.41L14.8 12.8L13.85 12.29L12.9 11.91L11.95 11.68L11 11.6L10.05 11.68L9.1 11.91L8.15 12.29L7.2 12.8L6.25 13.41L5.3 14.1L4.35 14.84L3.4 15.6Z",
        "fill": "accent"
      }
    ],
    "gtl-goto": [
      {
        "type": "polygon",
        "d": "M6.74 5.96L6.13 6.04L5.52 6.28L4.92 6.67L4.37 7.18L3.9 7.78L3.54 8.45L3.31 9.14L3.22 9.82L3.28 10.45L3.47 11L3.8 11.43L4.24 11.72L5.15 10.04L4.99 9.81L4.91 9.52L4.91 9.2L4.98 8.85L5.14 8.51L5.35 8.2L5.62 7.93L5.93 7.73L6.24 7.6L6.55 7.55L8.62 7.55L9.21 5.96Z",
        "fill": "accent"
      },
      {
        "type": "polygon",
        "d": "M7.14 8.14L9.09 8.14L8.41 9.62L9.24 9.79L5.26 13.04L6.93 9.74L6.13 9.56Z",
        "fill": "accent"
      },
      {
        "type": "polygon",
        "d": "M10.34 5.96L15.06 5.96L14.58 7.55L13.19 7.55L11.9 11.86L9.95 11.86L11.24 7.55L9.86 7.55Z",
        "fill": "accent"
      },
      {
        "type": "polygon",
        "d": "M16.18 5.96L18.12 5.96L16.83 10.27L18.78 10.27L18.3 11.86L14.41 11.86Z",
        "fill": "accent"
      }
    ],
    "paxel": [
      {
        "type": "polygon",
        "d": "M13.43 4.8L15.8 7.11L13.43 7.11Z",
        "fill": "#ffb003"
      },
      {
        "type": "polygon",
        "d": "M6.5 11.73L8.81 11.73L8.81 14.1Z",
        "fill": "#ff434f"
      },
      {
        "type": "polygon",
        "d": "M15 6.71L15.5 6.81L15.92 7.09L16.2 7.51L16.3 8.01L16.3 13.3L16.2 13.8L15.92 14.22L15.5 14.5L15 14.6L9.71 14.6L9.21 14.5L8.79 14.22L8.51 13.8L8.41 13.3L8.41 8.01L8.51 7.51L8.79 7.09L9.21 6.81L9.71 6.71Z",
        "fill": "#ffb003"
      },
      {
        "type": "polygon",
        "d": "M14.6 8.11L14.71 8.13L14.81 8.2L14.88 8.3L14.9 8.41L14.9 12.9L14.88 13.01L14.81 13.11L14.71 13.18L14.6 13.2L10.11 13.2L10 13.18L9.9 13.11L9.83 13.01L9.81 12.9L9.81 8.41L9.83 8.3L9.9 8.2L10 8.13L10.11 8.11Z",
        "fill": "truck"
      },
      {
        "type": "polygon",
        "d": "M12.53 4L13.03 4.1L13.45 4.38L13.74 4.8L13.83 5.3L13.83 10.83L13.74 11.33L13.45 11.75L13.03 12.04L12.53 12.13L7 12.13L6.5 12.04L6.08 11.75L5.8 11.33L5.7 10.83L5.7 5.3L5.8 4.8L6.08 4.38L6.5 4.1L7 4Z",
        "fill": "#ff434f"
      },
      {
        "type": "polygon",
        "d": "M12.13 5.4L12.25 5.42L12.35 5.49L12.41 5.59L12.43 5.7L12.43 10.43L12.41 10.55L12.35 10.65L12.25 10.71L12.13 10.73L7.4 10.73L7.29 10.71L7.19 10.65L7.12 10.55L7.1 10.43L7.1 5.7L7.12 5.59L7.19 5.49L7.29 5.42L7.4 5.4Z",
        "fill": "truck"
      },
      {
        "type": "line",
        "d": "M9.11 11.43L9.11 7.41L13.13 7.41",
        "stroke": "#ff434f",
        "strokeWidth": 1.4
      },
      {
        "type": "line",
        "d": "M6.68 4.98L9.11 7.41",
        "stroke": "#ff434f",
        "strokeWidth": 1.4
      },
      {
        "type": "line",
        "d": "M9.11 7.41L15.32 13.62",
        "stroke": "#ffb003",
        "strokeWidth": 1.4
      }
    ],
    "pickupp": [
      {
        "type": "polygon",
        "d": "M11.3 4.3L10.7 4.37L10.11 4.57L9.58 4.89L9.11 5.33L8.72 5.86L8.44 6.46L8.26 7.12L8.2 7.8L8.26 8.48L8.44 9.14L8.72 9.74L9.11 10.27L9.58 10.71L10.11 11.03L10.7 11.23L11.3 11.3L11.9 11.23L12.49 11.03L13.02 10.71L13.49 10.27L13.88 9.74L14.16 9.14L14.34 8.48L14.4 7.8L14.34 7.12L14.16 6.46L13.88 5.86L13.49 5.33L13.02 4.89L12.49 4.57L11.9 4.37Z",
        "fill": "accent"
      },
      {
        "type": "polygon",
        "d": "M11.25 5.8L10.87 5.87L10.53 6.07L10.22 6.39L9.99 6.8L9.85 7.28L9.8 7.8L9.85 8.32L9.99 8.8L10.22 9.21L10.52 9.53L10.87 9.73L11.25 9.8L11.63 9.73L11.97 9.53L12.28 9.21L12.51 8.8L12.65 8.32L12.7 7.8L12.65 7.28L12.51 6.8L12.28 6.39L11.97 6.07L11.63 5.87Z",
        "fill": "truck"
      },
      {
        "type": "polygon",
        "d": "M7.9 4.3L9.8 4.3L9.8 13.9L7.9 13.9Z",
        "fill": "accent"
      }
    ],
    "247express": [
      {
        "type": "polygon",
        "d": "M5.7 5.59L10.73 4.26L16.23 6.29L16.07 8.16L15.21 10.5L13.26 12.84L10.84 14.87L8.78 13.04L7.02 10.89L5.93 8.55Z",
        "fill": "accent"
      },
      {
        "type": "polygon",
        "d": "M3.6 7.93L10.8 6.33L18.6 8.62L18.6 9.87L10.8 7.17L3.6 9.17Z",
        "fill": "truck"
      },
      {
        "type": "polygon",
        "d": "M3.6 10.33L10.8 8.72L18.6 11.02L18.6 12.27L10.8 9.58L3.6 11.57Z",
        "fill": "truck"
      },
      {
        "type": "polygon",
        "d": "M3.6 12.73L10.8 11.12L18.6 13.42L18.6 14.67L10.8 11.98L3.6 13.97Z",
        "fill": "truck"
      }
    ],
    "fleetoptics": [
      {
        "type": "polygon",
        "d": "M13.4 10.2L13.77 5.92L13.22 5.9L12.67 5.96L12.13 6.09L11.62 6.29L11.13 6.55L10.68 6.87L10.27 7.25L9.92 7.67L9.63 8.14L9.39 8.64L9.23 9.17L9.13 9.71L9.1 10.27L9.14 10.82L9.26 11.36L9.44 11.88L9.69 12.37L10 12.83L10.37 13.25L10.78 13.61L11.24 13.92L11.74 14.17L12.26 14.35L12.8 14.46L13.35 14.5L13.91 14.47L14.45 14.37L14.98 14.2L15.48 13.97L15.94 13.67L16.37 13.31L16.74 12.91L17.06 12.45L17.32 11.97L17.51 11.45L17.64 10.91L17.7 10.36L17.68 9.81L17.6 9.26L17.44 8.73Z",
        "fill": "accent"
      },
      {
        "type": "polygon",
        "d": "M14.43 8.85L18.29 7.45L18.05 6.92L17.74 6.43L17.37 5.98L16.93 5.6L16.45 5.28L15.92 5.03L15.37 4.86L14.79 4.77Z",
        "fill": "accent"
      },
      {
        "type": "polygon",
        "d": "M5.4 7.2L8.9 7.2L8.9 8.4L5.4 8.4Z",
        "fill": "accent"
      },
      {
        "type": "polygon",
        "d": "M3.6 9.6L8.2 9.6L8.2 10.8L3.6 10.8Z",
        "fill": "accent"
      },
      {
        "type": "polygon",
        "d": "M4.6 12L8.9 12L8.9 13.2L4.6 13.2Z",
        "fill": "accent"
      }
    ],
    "straightship": [
      {
        "type": "polygon",
        "d": "M5.6 8.1L6.07 7.42L6.54 6.84L7.01 6.33L7.48 5.87L7.95 5.46L8.42 5.11L8.9 4.81L9.37 4.56L9.84 4.36L10.31 4.21L10.78 4.11L11.25 4.06L11.72 4.06L12.19 4.11L12.66 4.21L13.13 4.36L13.6 4.56L14.07 4.8L14.55 5.1L15.02 5.44L15.49 5.83L15.96 6.27L16.43 6.76L16.9 7.33L16.43 7.02L15.96 6.72L15.49 6.45L15.02 6.21L14.55 6.01L14.07 5.84L13.6 5.7L13.13 5.59L12.66 5.52L12.19 5.48L11.72 5.48L11.25 5.5L10.78 5.56L10.31 5.64L9.84 5.76L9.37 5.91L8.9 6.09L8.42 6.3L7.95 6.54L7.48 6.81L7.01 7.11L6.54 7.44L6.07 7.78Z",
        "fill": "accent"
      },
      {
        "type": "line",
        "d": "M10.06 9.34L9.72 8.91L9.23 8.64L8.67 8.55L8.11 8.67L7.64 8.98L7.33 9.42L7.23 9.95L7.35 10.47L7.67 10.9L8.15 11.2L8.72 11.3L9.28 11.4L9.76 11.7L10.08 12.13L10.2 12.65L10.1 13.18L9.79 13.62L9.32 13.93L8.76 14.05L8.2 13.96L7.71 13.69L7.37 13.26",
        "stroke": "accent",
        "strokeWidth": 1.7
      },
      {
        "type": "line",
        "d": "M14.63 9.34L14.29 8.91L13.8 8.64L13.24 8.55L12.68 8.67L12.21 8.98L11.9 9.42L11.8 9.95L11.92 10.47L12.24 10.9L12.72 11.2L13.29 11.3L13.85 11.4L14.33 11.7L14.65 12.13L14.77 12.65L14.67 13.18L14.36 13.62L13.89 13.93L13.33 14.05L12.77 13.96L12.28 13.69L11.94 13.26",
        "stroke": "#333333",
        "strokeWidth": 1.7
      }
    ],
    "apple-express": [
      {
        "type": "line",
        "d": "M5.97 6.71L5.25 6.99L4.67 7.76L4.34 8.88L4.34 10.12L4.67 11.24L5.25 12.01L5.97 12.29L6.7 12.01L7.28 11.24L7.61 10.12L7.61 8.88L7.28 7.76L6.7 6.99L5.98 6.71M7.65 6.71L7.65 12.29M9.32 9.5L12.81 9.5L12.69 8.48L12.35 7.6L11.83 6.99L11.2 6.72L10.56 6.83L9.98 7.32L9.56 8.11L9.34 9.08L9.37 10.12L9.63 11.07L10.09 11.81L10.68 12.22L11.33 12.26L11.94 11.92M14.49 6.71L17.7 12.29M17.7 6.71L14.49 12.29",
        "stroke": "accent",
        "strokeWidth": 1.7
      }
    ],
    "ab-courier": [
      {
        "type": "polygon",
        "d": "M7.31 7.59L6.6 7.67L5.89 7.9L5.22 8.28L4.63 8.78L4.14 9.38L3.79 10.05L3.58 10.75L3.54 11.45L3.65 12.12L3.92 12.72L4.33 13.22L4.86 13.6L5.49 13.83L6.18 13.91L6.89 13.83L7.6 13.6L8.27 13.22L8.86 12.72L9.35 12.12L9.7 11.45L9.91 10.75L9.95 10.05L9.84 9.38L9.57 8.78L9.16 8.28L8.63 7.9L8 7.67Z",
        "fill": "accent"
      },
      {
        "type": "polygon",
        "d": "M7.21 9.14L6.71 9.22L6.24 9.45L5.83 9.8L5.53 10.25L5.37 10.75L5.35 11.25L5.49 11.7L5.77 12.05L6.16 12.28L6.63 12.36L7.12 12.28L7.6 12.05L8 11.7L8.3 11.25L8.47 10.75L8.48 10.25L8.34 9.8L8.06 9.45L7.67 9.22Z",
        "fill": "truck"
      },
      {
        "type": "polygon",
        "d": "M8.7 7.64L10.6 7.64L9.45 13.91L7.55 13.91Z",
        "fill": "accent"
      },
      {
        "type": "polygon",
        "d": "M12.72 5.23L14.62 5.23L13.13 13.91L11.29 13.91Z",
        "fill": "accent"
      },
      {
        "type": "polygon",
        "d": "M16.4 7.59L15.76 7.67L15.12 7.9L14.52 8.28L13.98 8.78L13.54 9.38L13.21 10.05L13.01 10.75L12.96 11.45L13.04 12.12L13.27 12.72L13.63 13.22L14.09 13.6L14.65 13.83L15.26 13.91L15.9 13.83L16.54 13.6L17.14 13.22L17.68 12.72L18.12 12.12L18.45 11.45L18.65 10.75L18.7 10.05L18.62 9.38L18.39 8.78L18.03 8.28L17.57 7.9L17.01 7.67Z",
        "fill": "accent"
      },
      {
        "type": "polygon",
        "d": "M11.35 9.77L15.48 9.77L15.48 11.61L11.35 11.61Z",
        "fill": "truck"
      },
      {
        "type": "polygon",
        "d": "M15.31 8.85L17.04 10.69L15.31 12.53Z",
        "fill": "truck"
      }
    ],
    "lightning-express": [
      {
        "type": "polygon",
        "d": "M11 4.42L16.57 7.2L16.57 12.2L11 14.98L5.43 12.2L5.43 7.2Z",
        "fill": "accent"
      },
      {
        "type": "line",
        "d": "M7.47 13.5L7.47 8.46L11 6.7L14.29 8.34",
        "stroke": "truck",
        "strokeWidth": 1.0079999999999998
      },
      {
        "type": "line",
        "d": "M16.57 7.2L11 9.99L11 14.98",
        "stroke": "truck",
        "strokeWidth": 0.95
      },
      {
        "type": "polygon",
        "d": "M15.56 8.79L12.92 12.1L14.22 11.91L12.97 14.16L15.9 10.56L14.6 10.8L15.99 8.64Z",
        "fill": "truck"
      }
    ],
    "kyoungdong": [
      {
        "type": "line",
        "d": "M5.9 5.92L7.73 9.63L10.67 8.69L10.23 7.31L8.47 7.87L7.2 5.28L5.9 5.92M9.95 7.35L12.25 7.35L11.6 10.75L9.3 10.75L9.95 7.35M11.31 8.64L14.21 10.19L14.89 8.91L11.99 7.36L11.31 8.64M8.8 10.25L12.1 10.25L14.55 14.45L12.9 14.45L10.9 11.7L10.5 11.7L9.9 14.45L8.25 14.45L8.8 10.25",
        "stroke": "accent",
        "strokeWidth": 0.9
      },
      {
        "type": "circle",
        "cx": 10.8,
        "cy": 5.75,
        "r": 1.65,
        "fill": "accent"
      },
      {
        "type": "polygon",
        "d": "M5.9 5.92L7.73 9.63L10.67 8.69L10.23 7.31L8.47 7.87L7.2 5.28Z",
        "fill": "#ed1c24"
      },
      {
        "type": "polygon",
        "d": "M9.95 7.35L12.25 7.35L11.6 10.75L9.3 10.75Z",
        "fill": "#ed1c24"
      },
      {
        "type": "polygon",
        "d": "M11.31 8.64L14.21 10.19L14.89 8.91L11.99 7.36Z",
        "fill": "#ed1c24"
      },
      {
        "type": "polygon",
        "d": "M8.8 10.25L12.1 10.25L14.55 14.45L12.9 14.45L10.9 11.7L10.5 11.7L9.9 14.45L8.25 14.45Z",
        "fill": "#ed1c24"
      },
      {
        "type": "circle",
        "cx": 10.8,
        "cy": 5.75,
        "r": 1.2,
        "fill": "#ed1c24"
      }
    ],
    "yc-delivery": [
      {
        "type": "polygon",
        "d": "M3.41 5.26L6.05 5.26L7.7 8.4L9.18 5.26L11.82 5.26L8.96 10.16L8.96 13.68L6.44 13.68L6.44 10.16Z",
        "fill": "accent"
      },
      {
        "type": "polygon",
        "d": "M14.19 4.99L13.49 5.04L12.81 5.21L12.17 5.48L11.57 5.84L11.04 6.29L10.59 6.83L10.22 7.42L9.95 8.07L9.79 8.75L9.73 9.44L9.79 10.14L9.95 10.82L10.22 11.47L10.59 12.06L11.04 12.6L11.57 13.05L12.17 13.41L12.81 13.68L13.49 13.85L14.19 13.9L14.89 13.85L15.57 13.68L16.21 13.41L16.81 13.05L17.34 12.6L17.79 12.06L18.16 11.47L18.43 10.82L18.59 10.14L18.65 9.45L17.21 9.44L17.17 9.99L17.02 10.52L16.78 11.01L16.45 11.45L16.06 11.83L15.6 12.12L15.09 12.33L14.55 12.45L14.01 12.46L13.47 12.38L12.95 12.2L12.47 11.93L12.05 11.58L11.7 11.16L11.43 10.69L11.25 10.17L11.17 9.63L11.19 9.08L11.3 8.55L11.51 8.04L11.81 7.58L12.18 7.18L12.63 6.86L13.12 6.62L13.64 6.47L14.19 6.42Z",
        "fill": "accent"
      },
      {
        "type": "polygon",
        "d": "M14.19 7.41L13.76 7.46L13.34 7.59L12.97 7.82L12.65 8.11L12.4 8.47L12.24 8.87L12.16 9.3L12.18 9.73L12.28 10.16L12.48 10.55L12.75 10.88L13.09 11.16L13.48 11.35L13.9 11.46L14.34 11.47L14.76 11.4L15.17 11.23L15.52 10.98L15.82 10.66L16.04 10.29L16.18 9.88L16.23 9.44L15.12 9.44L15.07 9.75L14.92 10.03L14.69 10.24L14.4 10.36L14.09 10.37L13.78 10.29L13.53 10.11L13.35 9.85L13.26 9.55L13.28 9.24L13.4 8.95L13.61 8.71L13.88 8.56L14.19 8.51Z",
        "fill": "accent"
      },
      {
        "type": "circle",
        "cx": 15.62,
        "cy": 8.01,
        "r": 0.68,
        "fill": "accent"
      },
      {
        "type": "circle",
        "cx": 17.16,
        "cy": 6.36,
        "r": 0.94,
        "fill": "accent"
      }
    ],
    "sagawa-global": [
      {
        "type": "line",
        "d": "M7.76 6.12L7.37 5.62L6.8 5.3L6.14 5.2L5.49 5.34L4.95 5.7L4.59 6.22L4.47 6.83L4.61 7.43L4.99 7.94L5.54 8.28L6.2 8.4L6.85 8.52L7.41 8.86L7.79 9.37L7.93 9.97L7.81 10.58L7.45 11.1L6.9 11.46L6.25 11.6L5.59 11.5L5.03 11.18L4.63 10.68",
        "stroke": "accent",
        "strokeWidth": 1.7
      },
      {
        "type": "line",
        "d": "M11.23 8.13L10.62 8.29L10.14 8.74L9.87 9.39L9.87 10.11L10.14 10.76L10.62 11.22L11.23 11.38L11.84 11.22L12.32 10.76L12.59 10.11L12.59 9.39L12.32 8.74L11.84 8.29L11.23 8.13M12.63 8.13L12.63 12.05L12.55 12.43L12.3 12.77L11.93 13.02L11.47 13.15L10.99 13.15L10.53 13.02L10.16 12.77L9.91 12.43",
        "stroke": "#a6a7a7",
        "strokeWidth": 1.7
      },
      {
        "type": "line",
        "d": "M14.53 6.6L14.53 11.6M17.53 6.6L17.53 11.6M14.53 9.1L17.53 9.1",
        "stroke": "#a6a7a7",
        "strokeWidth": 1.7
      }
    ],
    "copa-courier": [
      {
        "type": "polygon",
        "d": "M5.7 4.2L16.3 4.2L16.3 14.8L5.7 14.8Z",
        "fill": "accent"
      },
      {
        "type": "polygon",
        "d": "M6.81 14.8L6.84 14.77L7.06 14.62L7.29 14.47L7.52 14.33L7.76 14.2L8.01 14.07L8.26 13.95L8.52 13.84L8.78 13.74L9.06 13.65L9.34 13.58L9.62 13.51L9.91 13.46L10.19 13.42L10.48 13.39L10.77 13.36L11.07 13.35L11.36 13.35L11.64 13.36L11.93 13.38L12.22 13.4L12.5 13.44L12.78 13.49L13.05 13.54L13.32 13.61L13.58 13.68L13.84 13.76L14.09 13.85L14.34 13.94L14.58 14.05L14.81 14.16L15.03 14.28L15.25 14.41L15.46 14.54L15.65 14.67L15.55 14.8L15.31 14.72L15.07 14.65L14.83 14.59L14.58 14.54L14.34 14.49L14.1 14.46L13.85 14.42L13.61 14.4L13.37 14.38L13.13 14.37L12.89 14.37L12.65 14.37L12.41 14.38L12.18 14.4L11.94 14.42L11.71 14.45L11.49 14.49L11.26 14.53L11.04 14.58L10.83 14.63L10.61 14.69L10.4 14.75L10.25 14.8Z",
        "fill": "truck"
      },
      {
        "type": "polygon",
        "d": "M5.7 13.05L5.7 12.13L5.86 12.04L6.06 11.94L6.27 11.84L6.47 11.74L6.68 11.65L6.89 11.56L7.1 11.48L7.32 11.39L7.53 11.32L7.75 11.24L7.98 11.17L8.2 11.11L8.43 11.04L8.65 10.98L8.88 10.93L9.11 10.88L9.34 10.83L9.58 10.79L9.81 10.75L10.05 10.72L10.29 10.7L10.53 10.69L10.77 10.68L11.01 10.68L11.25 10.68L11.48 10.69L11.72 10.71L11.96 10.73L12.19 10.75L12.43 10.78L12.66 10.82L12.89 10.86L13.12 10.9L13.34 10.95L13.56 11L13.79 11.06L14 11.12L14.22 11.18L14.43 11.25L14.64 11.33L14.85 11.4L15.05 11.49L15.25 11.57L15.44 11.66L15.64 11.75L15.56 11.89L15.35 11.87L15.13 11.84L14.91 11.82L14.69 11.81L14.48 11.79L14.26 11.78L14.05 11.78L13.84 11.77L13.62 11.77L13.41 11.77L13.2 11.78L12.99 11.79L12.78 11.8L12.58 11.81L12.37 11.83L12.17 11.85L11.96 11.87L11.76 11.9L11.56 11.92L11.36 11.95L11.16 11.98L10.97 12.02L10.77 12.05L10.58 12.09L10.38 12.13L10.19 12.17L10 12.2L9.81 12.24L9.62 12.27L9.42 12.32L9.24 12.36L9.05 12.41L8.86 12.46L8.68 12.52L8.49 12.58L8.31 12.64L8.13 12.7L7.95 12.77L7.78 12.84L7.61 12.91L7.43 12.99L7.26 13.07L7.1 13.15L6.93 13.24L6.77 13.32L6.61 13.41L6.46 13.51L6.3 13.6Z",
        "fill": "truck"
      },
      {
        "type": "polygon",
        "d": "M5.7 9.92L5.7 9.11L5.86 9.05L6.07 8.97L6.28 8.9L6.48 8.83L6.7 8.77L6.91 8.7L7.12 8.64L7.34 8.58L7.55 8.52L7.77 8.47L7.99 8.42L8.2 8.37L8.42 8.33L8.65 8.28L8.87 8.24L9.09 8.21L9.31 8.17L9.54 8.14L9.76 8.11L9.99 8.09L10.22 8.07L10.44 8.06L10.67 8.06L10.9 8.06L11.13 8.07L11.35 8.08L11.58 8.09L11.81 8.11L12.03 8.13L12.26 8.15L12.48 8.18L12.7 8.21L12.92 8.25L13.14 8.29L13.36 8.33L13.57 8.38L13.79 8.43L14 8.48L14.21 8.54L14.42 8.59L14.63 8.66L14.83 8.72L15.03 8.79L15.23 8.86L15.43 8.93L15.63 9.01L15.57 9.16L15.36 9.15L15.14 9.14L14.93 9.13L14.72 9.13L14.51 9.13L14.29 9.13L14.08 9.13L13.87 9.14L13.67 9.15L13.46 9.16L13.25 9.17L13.04 9.18L12.84 9.19L12.63 9.21L12.43 9.23L12.23 9.25L12.03 9.27L11.83 9.3L11.63 9.32L11.43 9.35L11.23 9.37L11.03 9.4L10.84 9.43L10.64 9.46L10.45 9.49L10.25 9.52L10.06 9.54L9.86 9.57L9.67 9.6L9.48 9.63L9.28 9.66L9.09 9.69L8.9 9.73L8.71 9.77L8.52 9.81L8.33 9.86L8.14 9.9L7.95 9.95L7.77 10L7.58 10.06L7.4 10.11L7.22 10.17L7.04 10.23L6.85 10.29L6.68 10.36L6.5 10.42L6.32 10.49L6.15 10.56Z",
        "fill": "truck"
      }
    ],
    "hound-express": [
      {
        "type": "polygon",
        "d": "M9.9 4L9.01 4.11L8.24 4.35L7.58 4.85L7.14 5.57L6.9 6.45L6.81 7.33L6.75 8.21L6.48 8.82L6.31 9.76L6.2 10.64L5.59 11.63L4.93 12.52L4.71 13.51L4.73 15L6.09 15L6.15 14.56L5.98 14.23L6.09 13.29L6.7 12.41L7.19 12.08L7.25 15L8.9 15L8.9 14.5L8.68 14.23L8.68 13.07L9.01 11.97L9.57 11.3L10.89 11.36L12.1 11.47L12.16 13.73L12.21 15L13.59 15L13.59 14.56L13.43 14.28L13.43 12.85L13.87 11.97L14.48 13.18L14.53 15L16.02 15L16.02 14.5L15.8 14.28L15.8 12.63L15.63 11.3L15.52 10.2L15.36 9.21L15.3 8.44L15.58 7.72L16.02 7.17L16.52 6.89L16.96 6.5L17.29 5.95L17.12 5.51L16.57 5.07L15.91 4.63L15.19 4.46L14.53 4.68L14.09 5.29L13.81 6.17L13.21 6.84L12.1 7.28L11.11 7.55L9.79 7.66L8.35 7.66L8.08 7.44L8.19 6.56L8.3 5.79L8.74 5.24L9.35 4.96L9.95 4.85Z",
        "fill": "accent"
      },
      {
        "type": "line",
        "d": "M14.31 5.29L14.2 6.45L14.53 7.61L15.3 8.49",
        "stroke": "truck",
        "strokeWidth": 0.75
      }
    ],
    "pdq-chile": [
      {
        "type": "polygon",
        "d": "M4.99 6.7L7.79 6.7L8.19 6.78L8.47 7.02L8.6 7.38L8.56 7.8L7.84 9.92L7.49 10.28L7.07 10.52L6.62 10.6L5.37 10.6L4.86 12.3L3.31 12.3Z",
        "fill": "accent"
      },
      {
        "type": "polygon",
        "d": "M6.48 8.05L6.21 8.15L6.03 8.4L5.9 8.85L5.92 9.1L6.14 9.2L6.34 9.2L6.62 9.1L6.8 8.85L6.93 8.4L6.9 8.15L6.69 8.05Z",
        "fill": "truck"
      },
      {
        "type": "polygon",
        "d": "M9.59 6.7L12.29 6.7L12.7 6.77L13.03 6.97L13.25 7.28L13.33 7.67L13.27 8.1L12.23 11.33L11.92 11.72L11.51 12.03L11.06 12.23L10.61 12.3L7.91 12.3Z",
        "fill": "accent"
      },
      {
        "type": "polygon",
        "d": "M11.17 8.1L10.81 8.23L10.59 8.55L10.02 10.45L10.05 10.77L10.33 10.9L10.48 10.9L10.84 10.77L11.06 10.45L11.63 8.55L11.6 8.23L11.32 8.1Z",
        "fill": "truck"
      },
      {
        "type": "polygon",
        "d": "M15.79 6.7L15.34 6.77L14.89 6.97L14.48 7.28L14.17 7.67L13.97 8.1L13.13 10.9L13.07 11.33L13.15 11.72L13.37 12.03L13.7 12.23L14.11 12.3L17.01 12.3L18.27 8.1L18.33 7.67L18.25 7.28L18.03 6.97L17.7 6.77L17.29 6.7Z",
        "fill": "accent"
      },
      {
        "type": "polygon",
        "d": "M15.92 8.1L15.56 8.23L15.34 8.55L14.77 10.45L14.8 10.77L15.08 10.9L15.48 10.9L15.84 10.77L16.07 10.45L16.64 8.55L16.6 8.23L16.32 8.1Z",
        "fill": "truck"
      },
      {
        "type": "polygon",
        "d": "M16.79 11.05L18.29 11.05L17.91 12.3L16.41 12.3Z",
        "fill": "accent"
      }
    ],
    "skyking": [
      {
        "type": "polygon",
        "d": "M10.15 8.25L11.25 7.8L11.6 7.85L12.6 7.5L13.5 7.05L14.25 6.25L15.05 6.05L15.15 6.95L14.6 7.1L13.9 7.6L12.95 8.35L12.2 8.95L11.5 9.1L11.5 9.8L12.5 10.35L13.3 11.2L13.85 12.3L14.15 13.3L15.5 13.4L15.65 13.8L14.5 14.4L14.05 14.95L13.3 13.95L13.05 12.55L12.4 11.65L11.4 11L10.55 11.95L9.75 12.95L8.85 13.6L8.75 14.35L8.85 14.75L8.45 14.9L7.85 14.7L6.75 13.95L7.25 13.05L8.15 12.25L8.95 11.25L9.55 10.05L9.85 9Z",
        "fill": "accent"
      },
      {
        "type": "polygon",
        "d": "M8.9 5.5L9.6 5.22L10.3 5.1L10.45 5.15L10.81 5.08L11.18 5.15L11.49 5.34L11.71 5.64L11.8 6L11.75 6.37L11.57 6.69L11.29 6.92L10.93 7.03L10.57 7.01L10.4 6.85L9.85 6.35L9.35 5.92Z",
        "fill": "accent"
      },
      {
        "type": "polygon",
        "d": "M14.55 4.35L16.3 4L17.25 5L17.05 6.65L15.3 6.7L14.45 5.7Z",
        "fill": "accent"
      },
      {
        "type": "line",
        "d": "M14.5 5.05L15.75 5.25L17.2 4.55M15.75 5.25L15.6 6.75",
        "stroke": "truck",
        "strokeWidth": 0.55
      },
      {
        "type": "line",
        "d": "M4.2 5.15L8.6 5.15M3.6 6.55L9.2 6.55",
        "stroke": "accent",
        "strokeWidth": 0.85
      }
    ],
    "veloces": [
      {
        "type": "polygon",
        "d": "M4.28 5.03L11.48 5.03L7.64 11.57L5.36 10.13L6.44 7.73L4.28 6.05Z",
        "fill": "accent"
      },
      {
        "type": "polygon",
        "d": "M13.64 5.03L17.72 5.03L13.04 13.55L11.06 13.97L9.26 12.53Z",
        "fill": "accent"
      }
    ],
    "valmo": [
      {
        "type": "polygon",
        "d": "M4.77 7.26L8.22 4.4L9.17 4.08L17.24 4.08L13.47 7.26Z",
        "fill": "#61eeff"
      },
      {
        "type": "polygon",
        "d": "M17.24 4.08L17.24 10.71L16.85 11.51L13.47 14.43L13.47 7.26Z",
        "fill": "#0378b6"
      },
      {
        "type": "polygon",
        "d": "M4.76 8.43L7.12 8.43L8.6 11.64L10.09 8.43L12.43 8.43L9.68 13.93L7.52 13.93Z",
        "fill": "accent"
      }
    ],
    "rivigo": [
      {
        "type": "polygon",
        "d": "M5 4.2L11.6 9.5L5 14.8Z",
        "fill": "#4a4b4d"
      },
      {
        "type": "polygon",
        "d": "M9.5 4.2L17.2 9.5L9.5 14.8L9.5 12.25L13.5 9.5L9.5 6.75Z",
        "fill": "accent"
      }
    ],
    "bombino": [
      {
        "type": "polygon",
        "d": "M12.02 4.8L11.14 4.43L10.2 4.24L9.25 4.21L8.31 4.37L7.41 4.69L6.59 5.17L5.87 5.8L5.28 6.55L4.83 7.4L4.56 8.31L4.45 9.26L4.52 10.21L4.77 11.13L5.18 12L5.75 12.77L6.44 13.42L7.25 13.93L8.13 14.29L9.07 14.47L10.02 14.48L10.96 14.32L11.86 13.98L11.75 13.75L10.85 13.91L9.97 13.85L9.16 13.62L8.44 13.25L7.84 12.77L7.36 12.23L7 11.66L6.74 11.06L6.57 10.47L6.47 9.88L6.45 9.3L6.49 8.71L6.61 8.12L6.8 7.54L7.08 6.95L7.46 6.39L7.96 5.87L8.58 5.42L9.31 5.07L10.13 4.86L11.01 4.83L11.9 5.02Z",
        "fill": "accent"
      },
      {
        "type": "line",
        "d": "M9.15 14.1L9.15 5.9L11.61 5.9L12.23 6.02L12.77 6.36L13.17 6.88L13.39 7.53L13.39 8.21L13.17 8.85L12.77 9.38L12.23 9.72L11.61 9.84L9.15 9.84M9.15 9.84L11.77 9.84L12.45 9.96L13.04 10.33L13.48 10.9L13.71 11.6L13.71 12.34L13.48 13.03L13.04 13.6L12.45 13.97L11.77 14.1L9.15 14.1",
        "stroke": "accent",
        "strokeWidth": 1.5
      },
      {
        "type": "polygon",
        "d": "M12.9 4.15L18.8 4.3L14.7 7.4L14.5 5.55Z",
        "fill": "#f9ae1f"
      }
    ],
    "tccs": [
      {
        "type": "polygon",
        "d": "M10.6 6.1L10.04 6.15L9.51 6.29L9 6.53L8.54 6.85L8.15 7.24L7.83 7.7L7.59 8.21L7.45 8.74L7.4 9.3L7.45 9.86L7.59 10.39L7.83 10.9L8.15 11.36L8.54 11.75L9 12.07L9.51 12.31L10.04 12.45L10.6 12.5Z",
        "fill": "accent"
      },
      {
        "type": "polygon",
        "d": "M11.4 6.1L11 6.1L12.29 6.37L12.79 6.64L13.14 6.92L13.4 7.19L13.62 7.46L13.79 7.73L11.4 7.73Z",
        "fill": "accent"
      },
      {
        "type": "polygon",
        "d": "M11.4 8.48L14.09 8.48L14.15 8.76L14.19 9.03L14.2 9.3L14.19 9.57L14.15 9.84L14.09 10.12L11.4 10.12Z",
        "fill": "accent"
      },
      {
        "type": "polygon",
        "d": "M11.4 10.87L13.79 10.87L13.62 11.14L13.4 11.41L13.14 11.68L12.79 11.96L12.29 12.23L11 12.5L11.4 12.5Z",
        "fill": "accent"
      },
      {
        "type": "line",
        "d": "M17.93 7.73L17.75 6.96L17.38 6.26L16.82 5.64L16.1 5.14L15.23 4.75L14.24 4.49L13.16 4.37L12.01 4.39L10.84 4.55L9.66 4.85L8.53 5.27L7.47 5.81L6.51 6.45M4.07 10.87L4.25 11.64L4.62 12.34L5.18 12.96L5.9 13.46L6.77 13.85L7.76 14.11L8.84 14.23L9.99 14.21L11.16 14.05L12.34 13.75L13.47 13.33L14.53 12.79L15.49 12.15",
        "stroke": "accent",
        "strokeWidth": 1.5
      },
      {
        "type": "polygon",
        "d": "M5.68 7.18L6.39 4.81L8.15 7.12Z",
        "fill": "accent"
      },
      {
        "type": "polygon",
        "d": "M16.32 11.42L15.61 13.79L13.85 11.48Z",
        "fill": "accent"
      }
    ],
    "tej-couriers": [
      {
        "type": "circle",
        "cx": 12.6,
        "cy": 5.8,
        "r": 1.75,
        "fill": "accent"
      },
      {
        "type": "polygon",
        "d": "M4.6 14L7.8 14L12.4 8.6L9.2 8.6Z",
        "fill": "accent"
      },
      {
        "type": "polygon",
        "d": "M5.2 6L9.4 6L7.6 8.4L3.4 8.4Z",
        "fill": "accent"
      },
      {
        "type": "polygon",
        "d": "M15.7 6L18.8 6L17 8.4L13.9 8.4Z",
        "fill": "accent"
      }
    ],
    "shree-mahavir": [
      {
        "type": "polygon",
        "d": "M3.4 4.4L11 9.5L3.4 14.6L4.6 9.5Z",
        "fill": "#393186"
      },
      {
        "type": "polygon",
        "d": "M18.6 4.4L11 9.5L18.6 14.6L17.4 9.5Z",
        "fill": "#393186"
      },
      {
        "type": "circle",
        "cx": 11,
        "cy": 9.5,
        "r": 4.7,
        "fill": "truck"
      },
      {
        "type": "circle",
        "cx": 11,
        "cy": 9.5,
        "r": 3.7,
        "fill": "accent"
      },
      {
        "type": "line",
        "d": "M7.3 9.5L14.7 9.5M11 5.8L10.45 6.08L9.97 6.88L9.66 8.08L9.55 9.5L9.66 10.92L9.97 12.12L10.45 12.92L11 13.2L11.55 12.92L12.03 12.12L12.34 10.92L12.45 9.5L12.34 8.08L12.03 6.88L11.55 6.08L11 5.8",
        "stroke": "truck",
        "strokeWidth": 1.2
      }
    ],
    "maruti-air": [
      {
        "type": "circle",
        "cx": 7.4,
        "cy": 9.4,
        "r": 4.35,
        "fill": "accent"
      },
      {
        "type": "polygon",
        "d": "M3.66 9.7L5.53 7.75L7.4 9.5L9.27 7.75L11.14 9.7L10.95 10.65L3.85 10.65Z",
        "fill": "truck"
      },
      {
        "type": "polygon",
        "d": "M4.69 11.55L6.19 11.55L5.44 12.75Z",
        "fill": "truck"
      },
      {
        "type": "polygon",
        "d": "M6.65 11.55L8.15 11.55L7.4 12.75Z",
        "fill": "truck"
      },
      {
        "type": "polygon",
        "d": "M8.61 11.55L10.11 11.55L9.36 12.75Z",
        "fill": "truck"
      },
      {
        "type": "polygon",
        "d": "M14.4 4.6L15.9 4.6L13.5 14.2L12 14.2Z",
        "fill": "#3e4095"
      },
      {
        "type": "polygon",
        "d": "M16.8 4.6L18.3 4.6L15.9 14.2L14.4 14.2Z",
        "fill": "#3e4095"
      }
    ],
    "icc-worldwide": [
      {
        "type": "polygon",
        "d": "M3.95 5L6.25 5L6.25 7.53L3.95 7.53Z",
        "fill": "accent"
      },
      {
        "type": "polygon",
        "d": "M3.95 8.23L6.25 8.23L6.25 10.77L3.95 10.77Z",
        "fill": "accent"
      },
      {
        "type": "polygon",
        "d": "M3.95 11.47L6.25 11.47L6.25 14L3.95 14Z",
        "fill": "accent"
      },
      {
        "type": "polygon",
        "d": "M7.35 5L12.15 5L12.15 7.53L7.35 7.53Z",
        "fill": "accent"
      },
      {
        "type": "polygon",
        "d": "M7.35 8.23L9.45 8.23L9.45 10.77L7.35 10.77Z",
        "fill": "accent"
      },
      {
        "type": "polygon",
        "d": "M7.35 11.47L12.15 11.47L12.15 14L7.35 14Z",
        "fill": "accent"
      },
      {
        "type": "polygon",
        "d": "M13.25 5L18.05 5L18.05 7.53L13.25 7.53Z",
        "fill": "accent"
      },
      {
        "type": "polygon",
        "d": "M13.25 8.23L15.35 8.23L15.35 10.77L13.25 10.77Z",
        "fill": "accent"
      },
      {
        "type": "polygon",
        "d": "M13.25 11.47L18.05 11.47L18.05 14L13.25 14Z",
        "fill": "accent"
      }
    ],
    "noest": [
      {
        "type": "circle",
        "cx": 11,
        "cy": 9.5,
        "r": 5.4,
        "fill": "accent"
      },
      {
        "type": "polygon",
        "d": "M7.68 5.24L7.09 5.78L6.59 6.39L6.18 7.07L5.88 7.8L5.68 8.56L5.6 9.35L5.64 10.14L5.79 10.92L6.05 11.66L6.42 12.36L7.08 11.68L7.8 11.03L8.59 10.4L9.46 9.79L10.39 9.21L11.39 8.65L12.46 8.11L13.6 7.6Z",
        "fill": "#ab121c"
      },
      {
        "type": "polygon",
        "d": "M14.6 7.3L13.6 7.67L12.67 8.11L11.82 8.61L11.04 9.18L10.35 9.82L9.72 10.52L9.17 11.29L8.7 12.12L8.3 13.01L7.98 13.98L12.12 14.78L12.31 13.96L12.51 13.15L12.73 12.37L12.96 11.62L13.22 10.88L13.49 10.17L13.78 9.48L14.08 8.82L14.41 8.17L14.75 7.55Z",
        "fill": "truck"
      },
      {
        "type": "polygon",
        "d": "M13.7 14.18L13.92 13.21L14.13 12.3L14.33 11.44L14.52 10.64L14.71 9.9L14.88 9.21L15.05 8.58L15.2 8L15.26 12.82Z",
        "fill": "#ab121c"
      }
    ],
    "bjs-home-delivery": [
      {
        "type": "line",
        "d": "M4.43 12.6L4.43 6.4L6.29 6.4L6.75 6.49L7.16 6.75L7.47 7.14L7.63 7.63L7.63 8.15L7.47 8.63L7.16 9.03L6.75 9.29L6.29 9.38L4.43 9.38M4.43 9.38L6.41 9.38L6.92 9.47L7.37 9.75L7.7 10.18L7.88 10.71L7.88 11.27L7.7 11.79L7.37 12.22L6.92 12.5L6.41 12.6L4.43 12.6M12.49 6.4L12.49 10.86L12.4 11.46L12.15 11.98L11.77 12.37L11.31 12.57L10.81 12.57L10.35 12.37L9.97 11.98L9.72 11.46L9.64 10.86M17.42 7.29L17.03 6.81L16.48 6.5L15.84 6.4L15.21 6.54L14.69 6.88L14.34 7.39L14.22 7.97L14.36 8.56L14.72 9.05L15.26 9.38L15.9 9.5L16.53 9.62L17.07 9.95L17.44 10.44L17.57 11.03L17.46 11.61L17.11 12.12L16.58 12.46L15.95 12.6L15.31 12.5L14.76 12.19L14.38 11.71",
        "stroke": "accent",
        "strokeWidth": 1.65
      }
    ],
    "norsk-global": [
      {
        "type": "circle",
        "cx": 11,
        "cy": 9.5,
        "r": 5.3,
        "fill": "accent"
      },
      {
        "type": "circle",
        "cx": 11,
        "cy": 9.5,
        "r": 4.55,
        "fill": "#e4051f"
      },
      {
        "type": "polygon",
        "d": "M11 5.95L10.05 8.39L7.43 8.54L9.46 10.2L8.8 12.73L11 11.32L13.2 12.73L12.54 10.2L14.57 8.54L11.95 8.39Z",
        "fill": "accent"
      }
    ],
    "one-world-express": [
      {
        "type": "polygon",
        "d": "M11.22 4.61L12.19 4.32L13.18 4.23L14.18 4.32L15.14 4.6L16.04 5.05L16.83 5.67L17.49 6.43L17.99 7.29L18.32 8.24L18.47 9.23L18.42 10.23L18.19 11.21L17.78 12.12L17.2 12.94L16.47 13.64L15.63 14.18L14.7 14.56L13.72 14.75L12.72 14.75L11.73 14.57L10.8 14.2L9.95 13.66L10.85 12.51L11.46 12.91L12.13 13.17L12.85 13.31L13.58 13.31L14.29 13.17L14.96 12.89L15.57 12.5L16.1 12L16.52 11.4L16.82 10.74L16.99 10.03L17.02 9.31L16.91 8.59L16.67 7.9L16.31 7.27L15.83 6.72L15.26 6.28L14.61 5.94L13.91 5.74L13.19 5.68L12.46 5.75L11.77 5.95Z",
        "fill": "accent"
      },
      {
        "type": "line",
        "d": "M5.6 7.05L17.03 7.05M3.4 9.5L17.75 9.5M4.6 11.95L17.03 11.95",
        "stroke": "accent",
        "strokeWidth": 1.45
      },
      {
        "type": "polygon",
        "d": "M13.27 4.2L12.42 4.55L11.62 5.41L11.06 6.59L10.72 7.99L10.6 9.5L10.72 11.01L11.06 12.41L11.62 13.59L12.42 14.45L13.27 14.8L13.77 13.49L13.24 13.31L12.8 12.82L12.38 11.95L12.1 10.8L12 9.5L12.1 8.2L12.38 7.05L12.8 6.18L13.24 5.69L13.77 5.51Z",
        "fill": "accent"
      }
    ],
    "xlcourier": [
      {
        "type": "line",
        "d": "M5.07 6.5L7.35 12.5M8.67 6.5L3.75 12.5M10.23 6.5L8.91 12.5L11.67 12.5M17.99 7.27L17.41 6.68L16.63 6.5L15.77 6.76L14.95 7.42L14.29 8.38L13.89 9.5L13.8 10.62L14.04 11.58L14.57 12.24L15.32 12.5L16.17 12.32L17 11.73",
        "stroke": "accent",
        "strokeWidth": 1.65
      }
    ],
    "transmission": [
      {
        "type": "polygon",
        "d": "M3.78 10.4L10.83 7.24L10.83 9.13L6.39 11.12L10.83 13.11L10.83 15L3.78 11.85Z",
        "fill": "#1f3581"
      },
      {
        "type": "polygon",
        "d": "M18.22 7.15L10.97 4L10.97 5.9L15.53 7.88L10.97 9.86L10.97 11.75L18.22 8.6Z",
        "fill": "accent"
      }
    ],
    "packs": [
      {
        "type": "polygon",
        "d": "M4.43 9.5L7.77 4L14.07 4L17.57 9.5L14.07 15L7.77 15Z",
        "fill": "accent"
      },
      {
        "type": "line",
        "d": "M7.77 4L11.03 9.5L17.57 9.5M11.03 9.5L7.77 15",
        "stroke": "truck",
        "strokeWidth": 1
      }
    ],
    "tdn": [
      {
        "type": "polygon",
        "d": "M4.97 6.41L8.74 6.41L8.28 8.1L7.37 8.1L6.15 12.59L4.22 12.59L5.43 8.1L4.51 8.1Z",
        "fill": "accent"
      },
      {
        "type": "polygon",
        "d": "M9.51 6.41L11.5 6.41L12.13 6.56L12.62 7L12.91 7.68L12.99 8.54L12.84 9.5L12.47 10.46L11.93 11.32L11.26 12L10.54 12.44L9.83 12.59L7.84 12.59Z",
        "fill": "accent"
      },
      {
        "type": "polygon",
        "d": "M11 8.05L11.2 8.05L11.48 8.24L11.59 8.77L11.48 9.5L11.2 10.23L10.81 10.76L10.42 10.95L10.22 10.95Z",
        "fill": "truck"
      },
      {
        "type": "polygon",
        "d": "M12.78 12.59L14.45 6.41L16.22 6.41L16.45 8.15L16.92 6.41L18.7 6.41L17.03 12.59L15.25 12.59L15.02 10.85L14.55 12.59Z",
        "fill": "accent"
      }
    ],
    "cbl-logistica": [
      {
        "type": "line",
        "d": "M9.94 5.67L9.38 5.08L8.6 4.9L7.74 5.16L6.91 5.82L6.23 6.78L5.8 7.9L5.69 9.02L5.91 9.98L6.42 10.64L7.17 10.9L8.02 10.72L8.87 10.13M10 10.9L11.44 4.9L13.24 4.9L13.67 4.99L14.01 5.24L14.21 5.62L14.25 6.09L14.13 6.59L13.86 7.06L13.48 7.44L13.02 7.69L12.55 7.78L10.75 7.78M10.75 7.78L12.67 7.78L13.14 7.87L13.51 8.14L13.73 8.56L13.78 9.07L13.65 9.61L13.35 10.12L12.93 10.54L12.44 10.81L11.92 10.9L10 10.9M16 4.9L14.56 10.9L17.32 10.9",
        "stroke": "accent",
        "strokeWidth": 1.8
      },
      {
        "type": "polygon",
        "d": "M4.8 12.85L17.8 12.85L17.2 14.4L4.2 14.4Z",
        "fill": "accent"
      }
    ],
    "inter-courier": [
      {
        "type": "polygon",
        "d": "M10.92 10.68L14.9 7.14L14.8 9.54L16.75 3.78L11.06 5.93L13.46 5.75L10.06 9.85Z",
        "fill": "accent"
      },
      {
        "type": "polygon",
        "d": "M9.58 9.76L8.39 8.21L10.09 8.21L5.77 6.73L7.26 11.04L7.26 9.34L8.81 10.54Z",
        "fill": "#444445"
      },
      {
        "type": "polygon",
        "d": "M8.81 11.17L7.18 12.4L7.21 10.7L5.65 14.99L9.99 13.58L8.3 13.55L9.58 11.96Z",
        "fill": "#444445"
      },
      {
        "type": "polygon",
        "d": "M10.21 11.95L11.44 13.58L9.74 13.55L14.03 15.11L12.62 10.77L12.59 12.46L11.01 11.18Z",
        "fill": "#444445"
      }
    ],
    "sp-express": [
      {
        "type": "line",
        "d": "M7.51 7.22L7.12 6.72L6.55 6.4L5.89 6.3L5.24 6.44L4.69 6.8L4.33 7.32L4.22 7.93L4.36 8.53L4.73 9.04L5.29 9.38L5.94 9.5L6.6 9.62L7.16 9.96L7.53 10.47L7.67 11.07L7.55 11.68L7.19 12.2L6.65 12.56L6 12.7L5.34 12.6L4.77 12.28L4.38 11.78M9.08 12.7L9.08 6.3L10.87 6.3L11.44 6.4L11.94 6.69L12.31 7.13L12.51 7.68L12.51 8.25L12.31 8.8L11.94 9.24L11.44 9.53L10.87 9.63L9.08 9.63M13.94 6.3L17.78 12.7M15.92 9.4L13.94 12.7",
        "stroke": "accent",
        "strokeWidth": 1.75
      },
      {
        "type": "line",
        "d": "M17.78 6.3L16.41 8.58",
        "stroke": "accent",
        "strokeWidth": 1.75
      }
    ],
    "dragon-star-curier": [
      {
        "type": "polygon",
        "d": "M3.93 3.81L18.07 3.81L11 10.25Z",
        "fill": "accent"
      },
      {
        "type": "polygon",
        "d": "M5.09 4.26L16.91 4.26L11 9.65Z",
        "fill": "#aa182c"
      },
      {
        "type": "polygon",
        "d": "M4.28 5.48L10.47 11.13L10.47 14.74Z",
        "fill": "accent"
      },
      {
        "type": "polygon",
        "d": "M17.72 5.48L11.53 14.74L11.53 11.13Z",
        "fill": "accent"
      }
    ],
    "connect-couriers": [
      {
        "type": "polygon",
        "d": "M8.49 6.61L9.43 5.9L10.56 5.36L11.82 5.02L13.16 4.87L14.55 4.94L15.94 5.24L16.84 5.76L17.45 6.5L17.77 7.4L17.85 8.4L17.72 9.42L17.38 10.41L16.47 9.31L15.43 8.31L14.26 7.47L12.92 6.84L11.38 6.48L10.26 6.39L9.31 6.44Z",
        "fill": "accent"
      },
      {
        "type": "polygon",
        "d": "M13.51 12.39L12.57 13.1L11.44 13.64L10.18 13.98L8.84 14.13L7.45 14.06L6.06 13.76L5.16 13.24L4.55 12.5L4.23 11.6L4.15 10.6L4.28 9.58L4.62 8.59L5.53 9.69L6.57 10.69L7.74 11.53L9.08 12.16L10.62 12.52L11.74 12.61L12.69 12.56Z",
        "fill": "accent"
      },
      {
        "type": "polygon",
        "d": "M12.17 7.7L11.63 7.46L10.43 7.27L9.27 7.4L8.28 7.84L7.66 8.5L7.83 8.86L8.26 9.3L8.67 9.58Z",
        "fill": "#d2d1d1"
      },
      {
        "type": "polygon",
        "d": "M9.83 11.3L10.37 11.54L11.57 11.73L12.73 11.6L13.72 11.16L14.34 10.5L14.17 10.14L13.74 9.7L13.33 9.42Z",
        "fill": "#d2d1d1"
      }
    ],
    "fastdrop": [
      {
        "type": "polygon",
        "d": "M10.2 4.2L18.5 4.2L18.01 5.09L17.3 5.98L16.4 6.77L15.36 7.34L14.2 7.55L9 7.55L7.9 7.74L7.07 8.16L6.6 8.65L6.57 7.72L6.95 6.6L7.54 5.59L8.29 4.84L9.19 4.36Z",
        "fill": "accent"
      },
      {
        "type": "polygon",
        "d": "M8.4 9.25L12.95 9.25L12.49 10.08L11.79 10.97L10.89 11.78L9.83 12.37L8.65 12.6L7.05 12.6L5.78 12.92L4.78 13.65L4.09 14.46L3.75 15L3.65 13.78L3.91 12.49L4.52 11.26L5.47 10.23L6.77 9.52Z",
        "fill": "accent"
      }
    ],
    "pro-carrier": [
      {
        "type": "polygon",
        "d": "M15.39 8.3L15.81 7.88L15.96 7.3L15.81 6.73L15.39 6.3L14.81 6.15L14.24 6.3L6.61 10.7L6.19 11.12L6.04 11.7L6.19 12.27L6.61 12.7L7.19 12.85L7.76 12.7Z",
        "fill": "#46baba"
      },
      {
        "type": "polygon",
        "d": "M14.24 12.7L14.81 12.85L15.39 12.7L15.81 12.27L15.96 11.7L15.81 11.12L15.39 10.7L7.76 6.3L7.19 6.15L6.61 6.3L6.19 6.73L6.04 7.3L6.19 7.88L6.61 8.3Z",
        "fill": "#e2de00"
      },
      {
        "type": "polygon",
        "d": "M9.85 13.9L10 14.47L10.43 14.9L11 15.05L11.57 14.9L12 14.47L12.15 13.9L12.15 5.1L12 4.52L11.57 4.1L11 3.95L10.43 4.1L10 4.52L9.85 5.1Z",
        "fill": "#e72f70"
      },
      {
        "type": "polygon",
        "d": "M11 7.75L9.48 8.62L9.48 10.38L11 11.25L12.52 10.38L12.52 8.62Z",
        "fill": "truck"
      }
    ],
    "teleship": [
      {
        "type": "polygon",
        "d": "M11 4.1L6.24 6.85L6.24 12.35L11 15.1L15.76 12.35L15.76 6.85Z",
        "fill": "#1c1e1e"
      },
      {
        "type": "polygon",
        "d": "M11 5.32L14.29 7.22L11 9.12L7.71 7.22Z",
        "fill": "truck"
      },
      {
        "type": "polygon",
        "d": "M7.3 7.94L10.59 9.84L10.59 13.64L7.3 11.74Z",
        "fill": "#aaf2ad"
      },
      {
        "type": "polygon",
        "d": "M11.41 9.84L14.7 7.94L14.7 11.74L11.41 13.64Z",
        "fill": "#a3c8f0"
      }
    ],
    "a-tu-hora-express": [
      {
        "type": "polygon",
        "d": "M10.5 4.3L13.5 4.3L17 12.6L14.3 12.6L13.7 11L10.3 11L9.7 12.6L7 12.6Z",
        "fill": "accent"
      },
      {
        "type": "polygon",
        "d": "M11 9L13 9L12 6.4Z",
        "fill": "truck"
      },
      {
        "type": "polygon",
        "d": "M3.6 8.6L5.2 8.6L5.2 13L18.2 13.6L18.2 14.1L3.6 14.6Z",
        "fill": "#47bdda"
      }
    ],
    "transaher": [
      {
        "type": "circle",
        "cx": 11,
        "cy": 9.5,
        "r": 5.3,
        "fill": "#f8b32c"
      },
      {
        "type": "line",
        "d": "M7.9 9.7L10.2 12L14.4 7.4",
        "stroke": "truck",
        "strokeWidth": 1.7
      }
    ],
    "urvaam": [
      {
        "type": "polygon",
        "d": "M3.7 5.55L6.6 5.55L9.4 11.95L9 14.75L7.4 14.75Z",
        "fill": "accent"
      },
      {
        "type": "polygon",
        "d": "M9 14.75L9.46 13.37L9.95 12.11L10.47 10.96L11.01 9.92L11.58 9L12.17 8.19L12.8 7.49L13.44 6.91L14.12 6.43L14.82 6.08L15.55 5.83L16.3 5.7L16.3 4.5L15.43 4.7L14.61 4.97L13.84 5.32L13.13 5.75L12.48 6.26L11.87 6.84L11.33 7.5L10.83 8.23L10.39 9.05L10.01 9.94L9.68 10.91L9.4 11.95Z",
        "fill": "accent"
      },
      {
        "type": "circle",
        "cx": 17.65,
        "cy": 5.05,
        "r": 1.1,
        "fill": "accent"
      }
    ],
    "closer-logistics": [
      {
        "type": "line",
        "d": "M4.4 10.1L4.4 8.6L4.53 7.8L4.9 7.07L5.47 6.5L6.2 6.13L7 6L14.8 6M17.6 8.9L17.6 10.4L17.47 11.2L17.1 11.93L16.53 12.5L15.8 12.87L15 13L7.2 13",
        "stroke": "accent",
        "strokeWidth": 1.5
      },
      {
        "type": "circle",
        "cx": 17.75,
        "cy": 5.9,
        "r": 1,
        "fill": "accent"
      },
      {
        "type": "circle",
        "cx": 4.25,
        "cy": 13.1,
        "r": 1,
        "fill": "accent"
      }
    ],
    "chronodiali": [
      {
        "type": "polygon",
        "d": "M11 3.8L5.67 6.65L5.67 12.35L11 15.2L16.33 12.35L16.33 6.65Z",
        "fill": "accent"
      },
      {
        "type": "line",
        "d": "M5.27 6.42L11 9.5L11 13.9M12.1 8.86L16.73 6.42",
        "stroke": "truck",
        "strokeWidth": 1.3
      }
    ],
    "cst-italia": [
      {
        "type": "line",
        "d": "M8.13 7.37L7.42 6.78L6.6 6.6L5.8 6.86L5.13 7.52L4.68 8.48L4.52 9.6L4.68 10.72L5.13 11.68L5.8 12.34L6.6 12.6L7.42 12.42L8.13 11.83M12.53 7.47L12.16 7L11.63 6.69L11.01 6.6L10.4 6.73L9.89 7.06L9.55 7.55L9.44 8.12L9.57 8.69L9.92 9.17L10.45 9.49L11.06 9.6L11.67 9.71L12.2 10.03L12.55 10.51L12.68 11.08L12.57 11.65L12.23 12.14L11.72 12.47L11.11 12.6L10.49 12.51L9.96 12.2L9.59 11.73M13.88 6.6L17.48 6.6M15.68 6.6L15.68 12.6",
        "stroke": "accent",
        "strokeWidth": 1.6
      }
    ],
    "tmm-express": [
      {
        "type": "line",
        "d": "M5.9 11.6L11 7.4L16.1 11.6",
        "stroke": "accent",
        "strokeWidth": 1.3
      },
      {
        "type": "circle",
        "cx": 5.9,
        "cy": 11.6,
        "r": 2.9,
        "fill": "accent"
      },
      {
        "type": "circle",
        "cx": 11,
        "cy": 7.4,
        "r": 2.9,
        "fill": "accent"
      },
      {
        "type": "circle",
        "cx": 16.1,
        "cy": 11.6,
        "r": 2.9,
        "fill": "accent"
      },
      {
        "type": "polygon",
        "d": "M4.28 9.93L7.52 9.93L7.52 11.09L6.48 11.09L6.48 13.27L5.32 13.27L5.32 11.09L4.28 11.09Z",
        "fill": "truck"
      },
      {
        "type": "polygon",
        "d": "M9.25 9.07L9.25 5.73L10.41 5.73L11 6.76L11.59 5.73L12.75 5.73L12.75 9.07L11.59 9.07L11.59 7.59L11 7.97L10.41 7.59L10.41 9.07Z",
        "fill": "truck"
      },
      {
        "type": "polygon",
        "d": "M14.35 13.27L14.35 9.93L15.51 9.93L16.1 10.96L16.69 9.93L17.85 9.93L17.85 13.27L16.69 13.27L16.69 11.79L16.1 12.17L15.51 11.79L15.51 13.27Z",
        "fill": "truck"
      }
    ],
    "next-level-delivery": [
      {
        "type": "polygon",
        "d": "M10.6 4.3L18.7 9.5L10.6 14.7Z",
        "fill": "accent"
      },
      {
        "type": "line",
        "d": "M6 6.9L9.4 6.9M3.4 9.5L9.4 9.5M4.8 12.1L9.4 12.1",
        "stroke": "accent",
        "strokeWidth": 1.4
      }
    ],
    "pdn-express": [
      {
        "type": "polygon",
        "d": "M3 11.25L3 4.85L5.58 4.85L6.35 5L7.01 5.44L7.45 6.1L7.6 6.87L7.45 7.65L7.01 8.31L6.35 8.75L5.58 8.9L4.75 8.9L4.75 11.25Z",
        "fill": "accent"
      },
      {
        "type": "polygon",
        "d": "M4.75 6.2L5.58 6.2L5.91 6.29L6.16 6.54L6.25 6.87L6.16 7.21L5.91 7.46L5.58 7.55L4.75 7.55Z",
        "fill": "truck"
      },
      {
        "type": "polygon",
        "d": "M8.45 4.85L12.2 4.85L11.7 5.28L11.24 5.72L10.81 6.18L10.41 6.67L10.05 7.17L9.72 7.7L9.43 8.24L9.16 8.8L8.93 9.38L8.74 9.99L8.58 10.61L8.45 11.25Z",
        "fill": "accent"
      },
      {
        "type": "polygon",
        "d": "M10.55 11.25L11.22 11.16L11.85 10.9L12.39 10.49L12.8 9.95L13.06 9.32L13.15 8.65L13.15 5.29L12.82 5.57L12.34 5.98L11.92 6.39L11.53 6.81L11.17 7.25L10.84 7.7L10.54 8.18L10.27 8.67L10.04 9.18L9.83 9.7L9.65 10.25L9.5 10.82L9.42 11.25Z",
        "fill": "accent"
      },
      {
        "type": "polygon",
        "d": "M14.05 11.25L14.05 4.85L15.8 4.85L17.4 8.05L17.4 4.85L19 4.85L19 11.25L17.25 11.25L15.65 8.05L15.65 11.25Z",
        "fill": "accent"
      },
      {
        "type": "polygon",
        "d": "M3 13.95L4.33 13.64L5.67 13.35L7 13.1L8.33 12.88L9.67 12.69L11 12.52L12.33 12.39L13.67 12.29L15 12.22L16.33 12.19L17.67 12.18L19 12.2L18.4 14.45L17.14 14.31L15.88 14.19L14.61 14.09L13.35 14.01L12.09 13.96L10.82 13.92L9.56 13.92L8.3 13.93L7.04 13.96L5.77 14.02L4.51 14.1Z",
        "fill": "accent"
      }
    ],
    "x-trac": [
      {
        "type": "polygon",
        "d": "M6.45 14.7L9.25 14.7L10.7 12.36L12.15 14.7L14.95 14.7L12.1 10.1L14.49 6.25L11.69 6.25Z",
        "fill": "accent"
      },
      {
        "type": "polygon",
        "d": "M13.14 5.35L15.95 5.35L16.78 4L13.98 4Z",
        "fill": "accent"
      },
      {
        "type": "polygon",
        "d": "M5.41 6.25L9.61 6.25L10.63 6.25L7.74 10.91Z",
        "fill": "#da251d"
      }
    ],
    "hovership": [
      {
        "type": "polygon",
        "d": "M9.67 4.58L9.24 4.71L8.82 4.88L8.43 5.09L8.05 5.33L7.69 5.6L7.36 5.91L7.05 6.24L6.78 6.6L6.54 6.98L6.33 7.37L6.16 7.79L6.03 8.22L5.99 8.38L6.12 8.37L6.58 8.28L7.03 8.15L7.46 7.96L7.87 7.73L8.25 7.46L8.6 7.15L8.91 6.8L9.18 6.42L9.41 6.01L9.6 5.58L9.73 5.13L9.82 4.67L9.83 4.54Z",
        "fill": "accent"
      },
      {
        "type": "polygon",
        "d": "M5.85 9.55L5.87 10L5.93 10.44L6.03 10.88L6.14 11.23L6.54 11.19L6.9 11.13L7.25 11.05L7.61 10.95L7.95 10.84L8.29 10.71L8.62 10.56L8.95 10.4L9.26 10.22L9.57 10.02L9.87 9.81L10.15 9.58L10.36 9.32L10.46 8.99L10.42 8.65L10.26 8.35L9.99 8.14L9.67 8.04L9.33 8.08L9.03 8.24L8.81 8.41L8.59 8.57L8.36 8.72L8.12 8.86L7.87 8.98L7.62 9.09L7.37 9.19L7.1 9.28L6.84 9.35L6.57 9.41L6.3 9.45L6.03 9.48L5.85 9.5Z",
        "fill": "accent"
      },
      {
        "type": "polygon",
        "d": "M6.78 12.5L7.05 12.86L7.36 13.19L7.69 13.5L8.05 13.77L8.59 13.63L9.19 13.42L9.78 13.17L10.35 12.88L10.9 12.55L11.43 12.2L11.94 11.8L12.42 11.38L12.87 10.93L13.29 10.44L13.68 9.94L14.04 9.4L14.16 9.09L14.15 8.74L14.01 8.43L13.76 8.2L13.44 8.08L13.1 8.09L12.79 8.23L12.55 8.48L12.26 8.92L11.94 9.33L11.59 9.73L11.22 10.11L10.82 10.46L10.4 10.78L9.97 11.08L9.51 11.34L9.04 11.58L8.56 11.79L8.06 11.97L7.55 12.11L7.04 12.22L6.64 12.28Z",
        "fill": "accent"
      },
      {
        "type": "polygon",
        "d": "M9.67 14.52L10.11 14.62L10.55 14.68L11 14.7L11.45 14.68L11.89 14.62L12.33 14.52L12.76 14.39L13.18 14.22L13.58 14.01L13.95 13.77L14.26 13.53L14.64 13.19L14.98 12.81L15.22 12.5L15.46 12.13L15.67 11.73L15.84 11.31L15.97 10.88L16.07 10.44L16.13 10L16.15 9.55L16.13 9.1L16.07 8.66L15.97 8.22L15.92 8.05L15.51 9.01L14.92 10.07L14.21 11.05L13.4 11.95L12.5 12.76L11.52 13.47L10.46 14.06L9.5 14.47Z",
        "fill": "accent"
      }
    ],
    "shipentegra": [
      {
        "type": "polygon",
        "d": "M12.86 10.99L11.34 11.76L11.18 11.82L11 11.84L10.82 11.82L10.66 11.76L6.11 9.44L5.94 9.33L5.81 9.17L5.73 8.98L5.7 8.78L5.7 7.29L5.73 7.09L5.81 6.9L5.94 6.74L6.11 6.63L10.66 4.31L10.82 4.25L11 4.23L11.18 4.25L11.34 4.31L15.89 6.63L16.06 6.74L16.19 6.9L16.27 7.09L16.3 7.29L16.3 8.53L14.8 7.77L14.8 7.91L14.79 7.84L14.76 7.78L14.72 7.72L14.66 7.68L11.11 5.88L11.06 5.86L11 5.85L10.94 5.86L10.89 5.88L7.34 7.68L7.28 7.72L7.24 7.78L7.21 7.84L7.2 7.91L7.2 8.16L7.21 8.23L7.24 8.29L7.28 8.35L7.34 8.39L10.89 10.19L10.94 10.21L11 10.22L11.06 10.21L11.11 10.19L11.2 10.15Z",
        "fill": "accent"
      },
      {
        "type": "polygon",
        "d": "M9.14 8.01L10.66 7.24L10.82 7.18L11 7.16L11.18 7.18L11.34 7.24L15.89 9.56L16.06 9.67L16.19 9.83L16.27 10.02L16.3 10.22L16.3 11.71L16.27 11.91L16.19 12.1L16.06 12.26L15.89 12.37L11.34 14.69L11.18 14.75L11 14.77L10.82 14.75L10.66 14.69L6.11 12.37L5.94 12.26L5.81 12.1L5.73 11.91L5.7 11.71L5.7 10.47L7.2 11.23L7.2 11.09L7.21 11.16L7.24 11.22L7.28 11.28L7.34 11.32L10.89 13.12L10.94 13.14L11 13.15L11.06 13.14L11.11 13.12L14.66 11.32L14.72 11.28L14.76 11.22L14.79 11.16L14.8 11.09L14.8 10.84L14.79 10.77L14.76 10.71L14.72 10.65L14.66 10.61L11.11 8.81L11.06 8.79L11 8.78L10.94 8.79L10.89 8.81L10.8 8.85Z",
        "fill": "#444f60"
      }
    ],
    "pts-worldwide-express": [
      {
        "type": "line",
        "d": "M4.05 10.8L5.04 4.95L6.94 4.95L7.22 4.99L7.44 5.12L7.61 5.32L7.69 5.57L7.69 5.85L7.56 6.6L7.47 6.88L7.3 7.13L7.07 7.33L6.8 7.46L6.51 7.5L4.61 7.5M9.49 4.95L12.89 4.95M11.19 4.95L10.2 10.8M18.09 4.95L15.44 4.95L15.16 4.99L14.89 5.12L14.65 5.32L14.48 5.57L14.39 5.85L14.26 6.6L14.26 6.88L14.35 7.13L14.51 7.33L14.74 7.46L15.01 7.5L16.01 7.5L16.28 7.54L16.51 7.67L16.68 7.87L16.76 8.12L16.76 8.4L16.63 9.15L16.54 9.43L16.37 9.68L16.14 9.88L15.86 10.01L15.58 10.05L12.93 10.05",
        "stroke": "accent",
        "strokeWidth": 1.5
      },
      {
        "type": "polygon",
        "d": "M3.6 12.6L4.48 12.81L5.37 12.98L6.26 13.11L7.15 13.21L8.05 13.26L8.96 13.27L9.87 13.24L10.78 13.17L11.7 13.07L12.63 12.92L13.56 12.73L14.5 12.5L15.45 12.24L16.41 11.93L17.37 11.58L18.34 11.2L18.86 12.6L17.82 12.93L16.78 13.21L15.76 13.44L14.75 13.63L13.75 13.78L12.76 13.89L11.78 13.96L10.82 13.98L9.87 13.95L8.93 13.89L8.01 13.78L7.1 13.63L6.2 13.44L5.32 13.2L4.45 12.93Z",
        "fill": "accent"
      }
    ],
    "evdemo-lojistik": [
      {
        "type": "line",
        "d": "M4.05 5.1L5.7 6.77L6.64 12.91L18.09 11.9",
        "stroke": "accent",
        "strokeWidth": 1.45
      },
      {
        "type": "polygon",
        "d": "M11.03 4.62L13.62 4.39L13.85 6.98L11.26 7.21Z",
        "fill": "accent"
      },
      {
        "type": "polygon",
        "d": "M14.62 4.3L17.21 4.08L17.44 6.67L14.85 6.89Z",
        "fill": "accent"
      },
      {
        "type": "polygon",
        "d": "M11.35 8.2L13.94 7.98L14.16 10.57L11.57 10.79Z",
        "fill": "accent"
      },
      {
        "type": "polygon",
        "d": "M14.93 7.89L17.52 7.66L17.75 10.25L15.16 10.48Z",
        "fill": "accent"
      },
      {
        "type": "circle",
        "cx": 6.64,
        "cy": 12.91,
        "r": 1.2,
        "fill": "accent"
      },
      {
        "type": "circle",
        "cx": 6.64,
        "cy": 12.91,
        "r": 0.45,
        "fill": "truck"
      }
    ],
    "big-smart": [
      {
        "type": "line",
        "d": "M3.75 4.5L3.75 12.3M5.15 7.75L4.79 7.81L4.45 8L4.16 8.31L3.94 8.7L3.8 9.16L3.75 9.65L3.8 10.14L3.94 10.6L4.16 10.99L4.45 11.3L4.79 11.49L5.15 11.55L5.51 11.49L5.85 11.3L6.14 10.99L6.36 10.6L6.5 10.14L6.55 9.65L6.5 9.16L6.36 8.7L6.14 8.31L5.85 8L5.51 7.81L5.15 7.75M9 7L9 12.3M12.85 7.75L12.49 7.81L12.15 8L11.86 8.31L11.64 8.7L11.5 9.16L11.45 9.65L11.5 10.14L11.64 10.6L11.86 10.99L12.15 11.3L12.49 11.49L12.85 11.55L13.21 11.49L13.55 11.3L13.84 10.99L14.06 10.6L14.2 10.14L14.25 9.65L14.2 9.16L14.06 8.7L13.84 8.31L13.55 8L13.21 7.81L12.85 7.75M14.25 7L14.25 12L14.19 12.5L14.02 12.95L13.76 13.33L13.42 13.6L13.03 13.74L12.63 13.73L12.25 13.58L11.91 13.3L11.66 12.91L11.5 12.45",
        "stroke": "accent",
        "strokeWidth": 1.5
      },
      {
        "type": "circle",
        "cx": 9,
        "cy": 5.2,
        "r": 0.8,
        "fill": "accent"
      },
      {
        "type": "polygon",
        "d": "M18.9 9.65L16.9 7.65L15.95 8.6L17 9.65L15.95 10.7L16.9 11.65Z",
        "fill": "#f0bd18"
      }
    ],
    "proships": [
      {
        "type": "line",
        "d": "M8.1 13.9L8.1 5.3L11.5 5.3L12.07 5.37L12.6 5.59L13.06 5.94L13.41 6.4L13.63 6.93L13.7 7.5L13.63 8.07L13.41 8.6L13.06 9.06L12.6 9.41L12.07 9.63L11.5 9.7L8.1 9.7",
        "stroke": "#32343a",
        "strokeWidth": 2
      }
    ],
    "gta-airskip": [
      {
        "type": "polygon",
        "d": "M11.8 5.54L11.74 4.99L11.57 4.52L11.31 4.21L11 4.1L10.69 4.21L10.43 4.52L10.26 4.99L10.2 5.54L10.2 13.5L10.64 14.5L11.36 14.5L11.8 13.5Z",
        "fill": "accent"
      },
      {
        "type": "polygon",
        "d": "M11 7.6L18.6 10.5L18.6 11.6L11 10.7L11 10.5L11 10.7L3.4 11.6L3.4 10.5Z",
        "fill": "accent"
      },
      {
        "type": "polygon",
        "d": "M11 11.8L14 13.1L14 13.9L11 13.4L8 13.9L8 13.1Z",
        "fill": "accent"
      }
    ],
    "domain-logistics": [
      {
        "type": "polygon",
        "d": "M16.77 11.45L11.04 10.13L10.93 4.2L16.72 4.64Z",
        "fill": "accent"
      },
      {
        "type": "polygon",
        "d": "M11.06 14.8L5.23 13.01L11.04 10.13Z",
        "fill": "accent"
      },
      {
        "type": "polygon",
        "d": "M16.76 11.45L11.04 10.13L11.06 14.8Z",
        "fill": "#4e738a"
      }
    ],
    "fleetex": [
      {
        "type": "polygon",
        "d": "M6.7 8.8L6.7 7.72L6.73 7.45L6.81 7.22L6.94 7.03L7.13 6.88L7.38 6.77L14.57 4.31L14.69 4.29L14.78 4.3L14.85 4.34L14.89 4.43L14.9 4.55L14.9 5.43L14.88 5.64L14.81 5.82L14.71 5.98L14.55 6.1L14.36 6.18Z",
        "fill": "accent"
      },
      {
        "type": "polygon",
        "d": "M6.7 11.6L6.7 10.52L6.73 10.25L6.81 10.02L6.94 9.83L7.13 9.68L7.38 9.57L12.22 7.92L12.34 7.89L12.43 7.9L12.5 7.95L12.54 8.03L12.55 8.15L12.55 9.03L12.53 9.24L12.46 9.43L12.36 9.58L12.2 9.7L12.01 9.79Z",
        "fill": "accent"
      },
      {
        "type": "polygon",
        "d": "M6.7 14.4L6.7 13.26L6.73 13.02L6.8 12.8L6.93 12.63L7.1 12.49L7.33 12.39L9.02 11.81L9.14 11.78L9.23 11.79L9.3 11.84L9.34 11.92L9.35 12.04L9.35 12.96L9.33 13.16L9.27 13.33L9.17 13.47L9.03 13.58L8.85 13.67Z",
        "fill": "accent"
      }
    ],
    "postplus": [
      {
        "type": "polygon",
        "d": "M7.5 4.1L7.5 6.39L14.45 6.39L14.45 9.36L13 9.36L13 11.66L16.74 11.66L16.74 4.1Z",
        "fill": "accent"
      },
      {
        "type": "polygon",
        "d": "M12.03 9.35L12.03 11.65L9.79 11.65L9.79 13.9L7.51 13.9L7.51 11.65L5.26 11.65L5.26 9.35L7.51 9.35L7.51 7.41L9.79 7.41L9.79 9.35Z",
        "fill": "accent"
      }
    ],
    "bringer-parcel": [
      {
        "type": "polygon",
        "d": "M3.29 14L6.71 5L17.11 5L17.83 5.21L18.19 5.8L18.1 6.6L17.72 7.6L17.31 8.3L16.23 9.15L16.68 9.95L16.58 10.6L16.09 11.9L15.67 12.68L14.93 13.41L14.02 13.88L13.29 14L12.89 14Z",
        "fill": "accent"
      },
      {
        "type": "polygon",
        "d": "M10.1 6.6L12.7 6.6L13.11 6.72L13.26 7.5L12.51 8.28L12.02 8.4L9.42 8.4Z",
        "fill": "truck"
      },
      {
        "type": "polygon",
        "d": "M8.85 9.9L11.85 9.9L12.39 10.06L12.59 11.1L11.6 12.14L10.94 12.3L7.74 12.3Z",
        "fill": "truck"
      }
    ],
    "micro-express": [
      {
        "type": "circle",
        "cx": 11,
        "cy": 9.3,
        "r": 5.3,
        "fill": "accent"
      },
      {
        "type": "polygon",
        "d": "M7.5 12.4L7.5 6.2L9.9 6.2L11 8.93L12.1 6.2L14.5 6.2L14.5 12.4L12.9 12.4L12.9 7.69L11 12.4L9.1 7.69L9.1 12.4Z",
        "fill": "truck"
      }
    ],
    "l-post": [
      {
        "type": "polygon",
        "d": "M13.7 13.2L13.7 5.7L5.6 5.7L5.6 9.3L5.49 9.79L5.16 10.24L4.65 10.59L4.01 10.82L3.3 10.9L3.3 13.35L4.33 13.24L5.33 12.92L6.24 12.39L7.05 11.68L7.71 10.82L8.2 9.83L8.5 8.76L8.6 7.65L10.6 7.65L10.6 13.2Z",
        "fill": "accent"
      },
      {
        "type": "polygon",
        "d": "M14 4.2L15.07 4.33L16.08 4.72L16.99 5.36L17.75 6.2L18.32 7.2L18.68 8.32L18.8 9.5L18.68 10.68L18.32 11.8L17.75 12.8L16.99 13.64L16.08 14.28L15.07 14.67L14 14.8L14.57 14.67L15.11 14.28L15.59 13.64L15.99 12.8L16.3 11.8L16.49 10.68L16.55 9.5L16.49 8.32L16.3 7.2L15.99 6.2L15.59 5.36L15.11 4.72L14.57 4.33Z",
        "fill": "#65d0dd"
      }
    ],
    "vestovoy": [
      {
        "type": "circle",
        "cx": 11,
        "cy": 9.3,
        "r": 5,
        "fill": "accent"
      },
      {
        "type": "line",
        "d": "M9.62 11.95L10.46 6.65L12.05 6.65L12.44 6.73L12.76 6.95L12.96 7.29L13.03 7.7L12.96 8.14L12.76 8.56L12.44 8.9L12.06 9.12L11.65 9.19L10.06 9.19M10.06 9.19L11.75 9.19L12.17 9.28L12.52 9.52L12.74 9.88L12.82 10.33L12.75 10.81L12.52 11.26L12.18 11.63L11.76 11.87L11.31 11.95L9.62 11.95",
        "stroke": "#e96066",
        "strokeWidth": 1.5
      }
    ],
    "4sides": [
      {
        "type": "line",
        "d": "M9.22 13.4L9.22 5.6M9.22 5.6L4.38 11.13M4.38 11.13L9.97 11.13",
        "stroke": "accent",
        "strokeWidth": 1.5
      },
      {
        "type": "line",
        "d": "M17.47 7.14L16.92 6.37L16.14 5.83L15.22 5.6L14.28 5.71L13.44 6.14L12.8 6.83L12.44 7.71L12.41 8.65L12.71 9.55L13.31 10.28L14.12 10.76L15.05 10.93M15.05 7.97L15.92 8.12L16.7 8.54L17.3 9.2L17.64 10.02L17.7 10.91L17.47 11.76L16.96 12.49L16.25 13.02L15.4 13.28L14.51 13.25L13.68 12.93L13.01 12.35",
        "stroke": "accent",
        "strokeWidth": 1.5
      }
    ],
    "dobropost": [
      {
        "type": "polygon",
        "d": "M6.6 6.17L7.13 5.58L8.24 5.02L9.76 4.57L11.48 4.4L13.2 4.5L14.72 4.99L15.75 5.89L16.29 7.21L16.4 8.94L16.1 10.5L15.33 11.79L14.19 12.76L12.66 13.45L10.95 13.83L9.19 13.9L8.54 13.76L8.39 13.45L8.39 8.8L8.58 8.35L9.19 8.01L10.11 7.87L10.87 8.04L10.87 11.58L11.48 11.82L12.28 11.72L13.01 11.23L13.46 10.33L13.58 8.77L13.43 7.52L13.04 6.83L12.4 6.58L11.1 6.55L9.8 6.65L8.66 6.79L7.67 6.97L7.02 6.93L6.64 6.65Z",
        "fill": "accent"
      }
    ],
    "flippost": [
      {
        "type": "polygon",
        "d": "M15.45 4.71L14.01 4.33L12.49 4.13L10.93 4.12L9.4 4.29L7.95 4.64L6.63 5.17L5.48 5.84L4.56 6.63L3.89 7.52L3.5 8.48L3.4 9.46L3.6 10.44L4.08 11.38L4.84 12.24L5.84 13L7.04 13.62L8.41 14.09L9.9 14.39L10.5 13.54L9.37 13.23L8.35 12.8L7.47 12.25L6.75 11.62L6.22 10.91L5.9 10.16L5.8 9.37L5.92 8.59L6.25 7.84L6.79 7.14L7.52 6.51L8.41 5.97L9.44 5.55L10.57 5.25L11.77 5.08L13 5.06L14.21 5.17L15.37 5.43Z",
        "fill": "accent"
      },
      {
        "type": "polygon",
        "d": "M10 6.4L14.6 6.4L14.6 8.1L11.7 8.1L11.7 8.7L14 8.7L14 10.2L11.7 10.2L11.7 12.2L10 12.2Z",
        "fill": "accent"
      }
    ],
    "jet-logistic": [
      {
        "type": "polygon",
        "d": "M5.8 6.8L11.03 4.2L15.92 6.8L5.8 11.6Z",
        "fill": "accent"
      },
      {
        "type": "polygon",
        "d": "M6.41 12.4L15.31 7.79L10.51 14.64Z",
        "fill": "accent"
      },
      {
        "type": "polygon",
        "d": "M16.2 8.18L16.2 12.77L12.22 14.49Z",
        "fill": "accent"
      }
    ],
    "starex-az": [
      {
        "type": "line",
        "d": "M11 4.85L11 14.15M6.35 9.5L15.65 9.5",
        "stroke": "#ffa000",
        "strokeWidth": 1.6
      },
      {
        "type": "circle",
        "cx": 11,
        "cy": 4.85,
        "r": 0.8,
        "fill": "#ffa000"
      },
      {
        "type": "circle",
        "cx": 11,
        "cy": 14.15,
        "r": 0.8,
        "fill": "#ffa000"
      },
      {
        "type": "circle",
        "cx": 6.35,
        "cy": 9.5,
        "r": 0.8,
        "fill": "#ffa000"
      },
      {
        "type": "circle",
        "cx": 15.65,
        "cy": 9.5,
        "r": 0.8,
        "fill": "#ffa000"
      },
      {
        "type": "line",
        "d": "M7.65 6.15L14.35 12.85M14.35 6.15L7.65 12.85",
        "stroke": "accent",
        "strokeWidth": 1.6
      },
      {
        "type": "circle",
        "cx": 7.65,
        "cy": 6.15,
        "r": 0.8,
        "fill": "accent"
      },
      {
        "type": "circle",
        "cx": 14.35,
        "cy": 12.85,
        "r": 0.8,
        "fill": "accent"
      },
      {
        "type": "circle",
        "cx": 14.35,
        "cy": 6.15,
        "r": 0.8,
        "fill": "accent"
      },
      {
        "type": "circle",
        "cx": 7.65,
        "cy": 12.85,
        "r": 0.8,
        "fill": "accent"
      }
    ],
    "mongol-infinity-post": [
      {
        "type": "polygon",
        "d": "M9.25 11.19L9.47 11.47L9.54 11.75L9.47 12.04L9.25 12.32L8.26 13.31L7.98 13.52L7.7 13.59L7.41 13.52L7.13 13.31L4.46 10.63L4.16 10.21L4.02 9.7L4.07 9.19L4.29 8.71L4.66 8.34L5.13 8.12L5.65 8.08L6.15 8.21L6.58 8.51Z",
        "fill": "accent"
      },
      {
        "type": "polygon",
        "d": "M7.75 5.16L8.03 4.95L8.32 4.88L8.6 4.95L8.88 5.16L14.74 11.02L15.04 11.45L15.18 11.95L15.13 12.47L14.91 12.94L14.54 13.31L14.07 13.53L13.55 13.58L13.05 13.44L12.62 13.14L6.76 7.28L6.55 7L6.48 6.72L6.55 6.43L6.76 6.15Z",
        "fill": "accent"
      },
      {
        "type": "polygon",
        "d": "M13.82 5.57L14.1 5.36L14.39 5.29L14.67 5.36L14.95 5.57L18.07 8.69L18.28 8.97L18.35 9.25L18.28 9.54L18.07 9.82L17.08 10.81L16.79 11.02L16.51 11.09L16.23 11.02L15.95 10.81L12.83 7.7L12.62 7.41L12.55 7.13L12.62 6.85L12.83 6.56Z",
        "fill": "accent"
      }
    ],
    "peqasus-az": [
      {
        "type": "polygon",
        "d": "M5.1 5.5L9.7 6.4L10.15 7.2L10.6 10.05L9.2 10.4Z",
        "fill": "accent"
      },
      {
        "type": "polygon",
        "d": "M11.1 6.9L12.1 5.55L15.2 4.1L13.6 5.9L12.5 8.3L11.8 9.6L11.4 9.8Z",
        "fill": "accent"
      },
      {
        "type": "polygon",
        "d": "M8.5 10.25L10.4 10L12.3 9.8L13.1 8.7L13.45 7.4L13.5 6.2L14.15 6.95L14.9 7.55L15.95 8.45L15.75 9.05L14.75 8.95L14.45 9.7L14.55 10.45L15.1 10.7L16.6 10.95L17.45 11.75L17.75 13L16.6 13L16.35 12.2L15.5 12.05L13.6 12.1L11.4 12.15L10.3 12.25L8 13.85L6.3 13.85L7.1 13.1L8.2 12.3L7.9 11.2Z",
        "fill": "accent"
      },
      {
        "type": "line",
        "d": "M8.6 10.7L7.4 10.15L6.1 9.85L5 9.2",
        "stroke": "accent",
        "strokeWidth": 1.4
      }
    ],
    "c3x": [
      {
        "type": "line",
        "d": "M8.65 6.9L8.06 6.21L7.27 6L6.4 6.3L5.58 7.07L4.93 8.19L4.53 9.5L4.45 10.81L4.71 11.93L5.25 12.7L6.01 13L6.87 12.79L7.71 12.1M10.19 6.88L10.65 6.37L11.22 6.07L11.8 6.01L12.32 6.19L12.7 6.6L12.88 7.18L12.85 7.83L12.6 8.48L12.17 9.02L11.62 9.37L11.03 9.5L11.64 9.49L12.1 9.86L12.36 10.42L12.38 11.09L12.17 11.78L11.75 12.37L11.19 12.8L10.56 12.99L9.95 12.93L9.46 12.61L9.14 12.09M14.52 6L16.9 13M18.16 6L13.26 13",
        "stroke": "accent",
        "strokeWidth": 1.6
      }
    ],
    "eco-express-ae": [
      {
        "type": "polygon",
        "d": "M3.75 5.06L4.08 6.09L4.45 6.94L4.87 7.62L5.33 8.15L5.82 8.55L6.32 8.81L6.85 8.97L7.38 9.03L18.5 9.03Z",
        "fill": "accent"
      },
      {
        "type": "polygon",
        "d": "M18.5 9.97L7.38 9.97L6.85 10.03L6.32 10.2L5.82 10.48L5.33 10.89L4.87 11.44L4.45 12.14L4.08 13L3.75 14.04Z",
        "fill": "accent"
      }
    ],
    "logistiq": [
      {
        "type": "line",
        "d": "M11 9.5L10.49 9.02L9.98 8.56L9.46 8.11L8.94 7.7L8.41 7.34L7.87 7.05L7.33 6.82L6.79 6.69L6.26 6.66L5.75 6.75L5.27 6.95L4.85 7.28L4.49 7.72L4.22 8.25L4.06 8.86L4 9.5L4.06 10.14L4.22 10.75L4.49 11.28L4.85 11.72L5.27 12.05L5.75 12.25L6.26 12.34L6.79 12.31L7.33 12.18L7.87 11.95L8.41 11.66L8.94 11.3L9.46 10.89L9.98 10.44L10.49 9.98L11 9.5L11.51 9.02L12.02 8.56L12.54 8.11L13.06 7.7L13.59 7.34L14.13 7.05L14.67 6.82L15.21 6.69L15.74 6.66L16.25 6.75L16.73 6.95L17.15 7.28L17.51 7.72L17.78 8.25L17.94 8.86L18 9.5L17.94 10.14L17.78 10.75L17.51 11.28L17.15 11.72L16.73 12.05L16.25 12.25L15.74 12.34L15.21 12.31L14.67 12.18L14.13 11.95L13.59 11.66L13.06 11.3L12.54 10.89L12.02 10.44L11.51 9.98L11 9.5L10.49 9.02L9.98 8.56",
        "stroke": "accent",
        "strokeWidth": 1.9
      },
      {
        "type": "line",
        "d": "M12.04 10.46L11.88 10.31L11.71 10.17L11.55 10.01L11.39 9.86L11.22 9.71L11.06 9.56L10.9 9.4L10.73 9.25L10.57 9.1L10.41 8.94L10.24 8.79L10.08 8.65L9.92 8.5",
        "stroke": "truck",
        "strokeWidth": 3
      },
      {
        "type": "line",
        "d": "M12.04 10.46L11.88 10.31L11.71 10.17L11.55 10.01L11.39 9.86L11.22 9.71L11.06 9.56L10.9 9.4L10.73 9.25L10.57 9.1L10.41 8.94L10.24 8.79L10.08 8.65L9.92 8.5",
        "stroke": "accent",
        "strokeWidth": 1.9
      }
    ],
    "quicksilver-sa": [
      {
        "type": "line",
        "d": "M9.3 10.4L9.3 6.8L9.19 6.26L8.89 5.81L8.44 5.51L7.9 5.4L5.3 5.4L4.76 5.51L4.31 5.81L4.01 6.26L3.9 6.8L3.9 11.6L4.01 12.14L4.31 12.59L4.76 12.89L5.3 13L5.3 13L16.6 13L17.23 12.87L17.77 12.52L18.12 11.98L18.25 11.35L18.12 10.72L17.77 10.18L17.23 9.83L16.6 9.7L13.2 9.7",
        "stroke": "accent",
        "strokeWidth": 1.5
      },
      {
        "type": "line",
        "d": "M7.6 10.7L10.7 14.45",
        "stroke": "accent",
        "strokeWidth": 1.5
      },
      {
        "type": "line",
        "d": "M12 7.8L12 6.8L12.11 6.26L12.41 5.81L12.86 5.51L13.4 5.4L18.9 5.4",
        "stroke": "#bebbba",
        "strokeWidth": 1.5
      }
    ],
    "skyex-ae": [
      {
        "type": "line",
        "d": "M13.18 6.38L12.63 5.69L11.84 5.24L10.92 5.1L10.02 5.29L9.26 5.79L8.76 6.51L8.6 7.36L8.79 8.2L9.31 8.91L10.09 9.38L11 9.55L11.91 9.72L12.69 10.19L13.21 10.9L13.4 11.74L13.24 12.59L12.74 13.31L11.98 13.81L11.08 14L10.16 13.86L9.37 13.41L8.82 12.72",
        "stroke": "accent",
        "strokeWidth": 2.1
      }
    ],
    "team-express-ae": [
      {
        "type": "circle",
        "cx": 11,
        "cy": 9.5,
        "r": 5.4,
        "fill": "accent"
      },
      {
        "type": "line",
        "d": "M7 7.25L9.45 7.25M8.22 7.25L8.22 11.75M12.14 7.25L10.1 7.25L10.1 11.75L12.14 11.75M10.1 9.5L11.82 9.5M14.9 7.9L14.65 7.55L14.28 7.32L13.86 7.25L13.45 7.35L13.1 7.6L12.87 7.97L12.8 8.39L12.88 8.82L13.12 9.18L13.48 9.42L13.9 9.5L14.32 9.58L14.67 9.82L14.91 10.18L15 10.61L14.92 11.03L14.7 11.4L14.35 11.65L13.93 11.75L13.51 11.68L13.15 11.45L12.9 11.1",
        "stroke": "truck",
        "strokeWidth": 1.35
      }
    ],
    "tfm-express": [
      {
        "type": "polygon",
        "d": "M6.76 4.42L16.77 4.42L15.39 14.58L5.38 14.58Z",
        "fill": "#e83e05"
      },
      {
        "type": "polygon",
        "d": "M5.84 4.42L7.92 4.42L10.63 7.69L11.04 8.03L11.47 8.06L11.93 7.79L15.62 4.42L17.7 4.42L16.39 14.58L14.31 14.58L15.08 7.65L11.58 10.45L11.1 10.7L10.65 10.66L10.21 10.34L7.54 7.34L6.3 14.58L4.3 14.58Z",
        "fill": "accent"
      }
    ],
    "transcorp": [
      {
        "type": "polygon",
        "d": "M8.97 5.57L10.54 5.34L12.05 5.23L13.48 5.23L14.81 5.33L16.02 5.5L17.1 5.73L18.04 6.02L18.42 6.19L18.6 6.32L18.65 6.48L18.57 6.69L13.63 13.96L13.47 14.12L13.28 14.17L13.06 14.11L11.71 13.47L11.48 13.29L11.42 13.07L11.54 12.81L14.31 8.76L14.34 8.71L14.36 8.66L14.38 8.6L14.55 7.78L13.81 7.33L12.94 6.89L12 6.5L11.02 6.15L10.06 5.88L9.16 5.7Z",
        "fill": "#3e7c4b"
      },
      {
        "type": "polygon",
        "d": "M3.3 7.65L4.58 7.15L5.92 6.82L7.28 6.64L8.63 6.63L9.94 6.76L11.18 7.05L12.32 7.47L12.91 7.81L13.11 7.98L13.17 8.19L13.08 8.44L10.26 13.08L10.08 13.28L9.86 13.33L9.62 13.22L8.38 12.32L8.21 12.14L8.17 11.94L8.27 11.71L9.88 9.28L9.94 9.15L9.95 9L9.91 8.86L9.73 8.43L8.83 8.15L7.84 7.94L6.79 7.81L5.7 7.75L4.59 7.74L3.49 7.78Z",
        "fill": "accent"
      },
      {
        "type": "polygon",
        "d": "M3.87 9.47L4.57 9.24L5.34 9.09L6.14 9.03L6.93 9.07L7.7 9.21L8.4 9.47L6.89 11.68L6.61 11.42L6.04 11.21L5.48 11.05L4.93 10.91L4.39 10.78L3.87 10.64Z",
        "fill": "#3e7c4b"
      }
    ],
    "air-star-xpress": [
      {
        "type": "line",
        "d": "M3.9 13L6.07 6.1L8.25 13M4.67 10.52L7.48 10.52M12.82 7.1L12.43 6.56L11.86 6.21L11.2 6.1L10.55 6.25L10.01 6.63L9.65 7.2L9.53 7.85L9.67 8.5L10.04 9.05L10.6 9.42L11.26 9.55L11.91 9.68L12.47 10.05L12.84 10.6L12.98 11.25L12.86 11.9L12.51 12.47L11.96 12.85L11.31 13L10.65 12.89L10.08 12.54L9.69 12M14.26 6.1L18.1 13M18.1 6.1L14.26 13",
        "stroke": "accent",
        "strokeWidth": 1.7
      }
    ],
    "first-fly-express": [
      {
        "type": "polygon",
        "d": "M7.33 4.41L6.36 5.06L5.42 5.7L4.62 6.45L4 7.3L3.62 8.23L3.51 9.19L3.67 10.11L4.11 10.91L4.74 11.53L5.44 12.11L6.36 12.55L7.48 12.83L8.81 12.95L10.35 12.89L12.13 12.64L14.15 12.17L16.42 11.48L18.93 10.54L18.67 9.86L16.18 10.8L13.96 11.48L12 11.93L10.29 12.18L8.82 12.23L7.59 12.12L6.6 11.87L5.83 11.5L5.26 11.04L5.03 10.43L4.97 9.84L5.03 9.25L5.15 8.62L5.36 7.92L5.65 7.13L6.07 6.27L6.64 5.37L7.47 4.59Z",
        "fill": "accent"
      },
      {
        "type": "line",
        "d": "M13.04 4.7L10.02 4.7L8.5 11M9.26 7.85L11.78 7.85M18.21 4.7L15.18 4.7L13.67 11M14.43 7.85L16.95 7.85",
        "stroke": "accent",
        "strokeWidth": 1.5
      }
    ],
    "flyking": [
      {
        "type": "polygon",
        "d": "M5.47 14.95L5.55 14.44L5.65 14.07L5.79 13.74L5.99 13.43L6.29 13.12L6.71 12.81L7.26 12.5L7.96 12.21L8.8 11.93L9.78 11.67L10.92 11.42L12.21 11.18L13.66 10.95L15.28 10.73L17.07 10.51L19.03 10.28L18.97 9.52L16.99 9.63L15.18 9.73L13.54 9.84L12.05 9.95L10.72 10.08L9.51 10.22L8.43 10.39L7.47 10.59L6.61 10.83L5.83 11.13L5.14 11.49L4.53 11.94L4.01 12.48L3.6 13.1L3.3 13.79L3.13 14.45Z",
        "fill": "accent"
      },
      {
        "type": "polygon",
        "d": "M9.53 15.09L9.56 14.91L9.56 14.83L9.6 14.72L9.71 14.58L9.9 14.42L10.21 14.24L10.61 14.05L11.12 13.86L11.73 13.67L12.45 13.48L13.27 13.3L14.19 13.11L15.23 12.91L16.38 12.71L17.65 12.5L19.04 12.28L18.96 11.52L17.55 11.62L16.26 11.72L15.09 11.8L14.03 11.88L13.07 11.96L12.2 12.04L11.42 12.12L10.73 12.22L10.1 12.33L9.54 12.46L9.03 12.63L8.55 12.84L8.12 13.13L7.74 13.49L7.44 13.92L7.27 14.31Z",
        "fill": "accent"
      },
      {
        "type": "polygon",
        "d": "M10.73 9.54L14.94 7.34L18.28 5.43L18.57 4.72L18.28 4.37L17.82 4.33L17.72 4.37L14.26 6.06L10.07 8.26Z",
        "fill": "accent"
      },
      {
        "type": "polygon",
        "d": "M15.2 6.6L13.1 10.2L11.9 10.2L12.7 7.8Z",
        "fill": "accent"
      },
      {
        "type": "polygon",
        "d": "M10.6 8.4L9.8 5.6L11 5.6L12.4 7.6Z",
        "fill": "accent"
      }
    ],
    "goodluck-courier": [
      {
        "type": "polygon",
        "d": "M13.58 5.36L12.68 4.72L11.67 4.3L10.61 4.11L9.53 4.16L8.48 4.46L7.52 4.98L6.68 5.7L6 6.59L5.52 7.62L5.25 8.73L5.21 9.88L5.4 11L5.81 12.07L6.42 13.01L7.21 13.8L8.14 14.39L9.16 14.76L10.24 14.9L11.31 14.79L12.34 14.45L13.28 13.88L14.09 13.11L13.08 12.08L12.61 12.62L12.05 13.03L11.45 13.27L10.81 13.35L10.18 13.25L9.58 12.99L9.03 12.56L8.57 12L8.21 11.33L7.97 10.57L7.86 9.77L7.88 8.95L8.04 8.16L8.32 7.43L8.72 6.79L9.21 6.27L9.78 5.9L10.39 5.69L11.03 5.66L11.66 5.79L12.25 6.09L12.78 6.55Z",
        "fill": "accent"
      },
      {
        "type": "polygon",
        "d": "M12.68 5.21L13.83 4.76L13.83 7.66L13.18 6.76Z",
        "fill": "accent"
      },
      {
        "type": "polygon",
        "d": "M12 9.85L16.4 9.85L16.4 11.15L14.9 11.15L14.9 13.2L13.55 13.9L13.55 11.15L12 11.15Z",
        "fill": "accent"
      }
    ],
    "grand-slam-express": [
      {
        "type": "line",
        "d": "M18.21 11.11L18.14 11.3L18.01 11.48L17.83 11.64L17.6 11.78L17.32 11.91L16.99 12.01L16.61 12.1L16.19 12.17L15.73 12.21L15.24 12.24L14.71 12.24L14.16 12.22L13.58 12.18L12.98 12.13L12.37 12.05L11.74 11.95L11.11 11.83L10.48 11.69L9.86 11.54L9.24 11.37L8.63 11.18L8.05 10.99L7.48 10.78L6.95 10.56L6.44 10.33L5.97 10.1L5.54 9.86L5.14 9.62L4.8 9.37L4.5 9.13L4.25 8.89L4.05 8.65L3.9 8.42L3.81 8.2L3.77 7.99L3.79 7.79L3.86 7.6L3.99 7.42L4.17 7.26L4.4 7.12L4.68 6.99L5.01 6.89L5.39 6.8L5.81 6.73L6.27 6.69L6.76 6.66L7.29 6.66L7.84 6.68L8.42 6.72L9.02 6.77L9.63 6.85L10.26 6.95L10.89 7.07L11.52 7.21L12.14 7.36L12.76 7.53L13.37 7.72L13.95 7.91L14.52 8.12L15.05 8.34L15.56 8.57L16.03 8.8L16.46 9.04L16.86 9.28L17.2 9.53L17.5 9.77L17.75 10.01L17.95 10.25L18.1 10.48L18.19 10.7L18.23 10.91L18.21 11.11L18.14 11.3L18.01 11.48M12.34 4.79L12.51 4.86L12.68 4.96L12.83 5.1L12.96 5.27L13.09 5.48L13.19 5.71L13.28 5.97L13.35 6.26L13.41 6.57L13.44 6.91L13.46 7.26L13.46 7.63L13.44 8.02L13.4 8.41L13.34 8.82L13.27 9.22L13.18 9.63L13.07 10.04L12.94 10.45L12.8 10.84L12.65 11.23L12.48 11.6L12.31 11.96L12.12 12.29L11.93 12.61L11.72 12.9L11.52 13.17L11.3 13.4L11.09 13.61L10.88 13.78L10.66 13.93L10.45 14.03L10.24 14.11L10.04 14.14L9.85 14.15L9.66 14.11L9.49 14.04L9.32 13.94L9.17 13.8L9.04 13.63L8.91 13.42L8.81 13.19L8.72 12.93L8.65 12.64L8.59 12.33L8.56 11.99L8.54 11.64L8.54 11.27L8.56 10.88L8.6 10.49L8.66 10.08L8.73 9.68L8.82 9.27L8.93 8.86L9.06 8.45L9.2 8.06L9.35 7.67L9.52 7.3L9.69 6.94L9.88 6.61L10.07 6.29L10.28 6L10.48 5.73L10.7 5.5L10.91 5.29L11.12 5.12L11.34 4.97L11.55 4.87L11.76 4.79L11.96 4.76L12.15 4.75L12.34 4.79L12.51 4.86L12.68 4.96",
        "stroke": "accent",
        "strokeWidth": 1.45
      },
      {
        "type": "circle",
        "cx": 11,
        "cy": 9.45,
        "r": 2.35,
        "fill": "accent"
      }
    ],
    "jetline-couriers": [
      {
        "type": "polygon",
        "d": "M8.36 4.41L18.39 6.52L11.88 9.78L5.37 12.68L6.88 11.54L8.09 10.47L8.99 9.46L9.57 8.48L9.81 7.5L9.7 6.52L9.22 5.49Z",
        "fill": "accent"
      },
      {
        "type": "polygon",
        "d": "M6.25 5.82L10.65 6.78L10.11 7.64L9.75 8.26L9.48 8.71L9.24 9.07L9.03 8.16L8.62 7.41L8.01 6.78L7.22 6.26Z",
        "fill": "#00004a"
      },
      {
        "type": "polygon",
        "d": "M3.43 14.79L5.54 13.12L11.88 10.3L17.16 8.1L12.58 10.74L11.53 11.18Z",
        "fill": "#00004a"
      }
    ],
    "pavan-courier": [
      {
        "type": "polygon",
        "d": "M10.73 6.9L9.78 10.05L11.29 10.59L12.52 7.53Z",
        "fill": "accent"
      },
      {
        "type": "line",
        "d": "M11.12 7.55L8.27 8.72L6.84 9.82M12.05 8.05L12.05 9.82L13.81 8.89M10.2 10.32L8.1 12.5L5.16 14.35M10.87 10.49L13.98 11.16L10.96 13.34L11.29 13.76",
        "stroke": "accent",
        "strokeWidth": 1.4
      },
      {
        "type": "circle",
        "cx": 11.88,
        "cy": 5.53,
        "r": 1.3,
        "fill": "accent"
      },
      {
        "type": "polygon",
        "d": "M14.23 6.29L17.54 4.22L18.97 6.51L15.66 8.58Z",
        "fill": "accent"
      },
      {
        "type": "line",
        "d": "M14.62 6.34L16.76 6.65L17.42 4.59",
        "stroke": "truck",
        "strokeWidth": 0.6
      }
    ],
    "sahara-express": [
      {
        "type": "polygon",
        "d": "M15.21 5.39L14.32 4.74L13.32 4.28L12.25 4.04L11.15 4.02L10.07 4.22L9.05 4.64L8.14 5.26L7.37 6.05L6.78 6.97L6.38 8L7.74 8.36L8.03 7.6L8.47 6.92L9.03 6.33L9.71 5.87L10.46 5.56L11.27 5.41L12.08 5.43L12.88 5.61L13.62 5.95L14.28 6.43Z",
        "fill": "#ef7d1a"
      },
      {
        "type": "polygon",
        "d": "M9.54 14.5L10.64 14.82L11.79 14.9L12.93 14.74L14.01 14.34L14.99 13.73L15.81 12.94L16.46 11.98L16.89 10.92L17.09 9.78L17.05 8.63L15.46 8.86L15.49 9.67L15.35 10.47L15.04 11.23L14.59 11.91L14 12.47L13.31 12.91L12.54 13.18L11.74 13.3L10.92 13.24L10.14 13.02Z",
        "fill": "accent"
      },
      {
        "type": "polygon",
        "d": "M3.5 14.83L4.92 14.33L6.32 13.77L7.69 13.16L9.02 12.51L10.32 11.82L11.58 11.1L12.8 10.35L13.97 9.57L15.08 8.78L16.15 7.97L17.16 7.14L18.09 6.32L16.71 4.88L15.88 5.76L14.99 6.62L14.05 7.49L13.04 8.34L11.98 9.18L10.87 10L9.71 10.81L8.5 11.58L7.26 12.33L5.97 13.05L4.66 13.72L3.3 14.37Z",
        "fill": "#ef7d1a"
      },
      {
        "type": "polygon",
        "d": "M15.2 5.4L19 4.2L18.2 7.9L17 6.6Z",
        "fill": "#ef7d1a"
      }
    ],
    "shree-mahabali-express": [
      {
        "type": "polygon",
        "d": "M5.68 10.44L5.93 11.35L6.32 12.2L6.86 12.97L7.53 13.64L8.3 14.18L9.15 14.57L10.06 14.82L11 14.9L11.94 14.82L12.85 14.57L13.7 14.18L14.47 13.64L15.14 12.97L15.68 12.2L16.07 11.35L16.32 10.44L16.4 9.5L16.32 8.56L16.48 8.67L16.2 9.34L15.81 9.96L15.32 10.53L14.75 11.02L14.1 11.43L13.39 11.75L12.64 11.97L11.86 12.08L11.07 12.09L10.29 11.99L9.53 11.79L8.81 11.49L8.15 11.09L7.57 10.61L7.06 10.06L6.66 9.45L6.36 8.78Z",
        "fill": "#1429a8"
      },
      {
        "type": "line",
        "d": "M5.3 11.6L7.6 8.07L8.15 7.3L8.54 6.95L8.76 7.04L8.82 7.55L8.7 8.5L8.7 8.5L8.6 9.46L8.69 10L8.99 10.15L9.47 9.88L10.16 9.2L11.69 7.49L12.49 6.69L13.02 6.37L13.31 6.52L13.33 7.15L13.1 8.25L12.9 9L12.74 9.88L12.81 10.42L13.11 10.64L13.65 10.53L14.43 10.09L17.2 8.2",
        "stroke": "accent",
        "strokeWidth": 1.6
      }
    ],
    "speed-and-safe": [
      {
        "type": "polygon",
        "d": "M8.02 5.08L8.2 4.74L8.45 4.49L8.76 4.35L9.14 4.3L18.52 4.3L18.68 4.32L18.79 4.4L18.83 4.51L18.81 4.68L16.2 13.97L16.07 14.29L15.86 14.52L15.59 14.65L15.24 14.7L4.83 14.7L4.65 14.67L4.55 14.6L4.51 14.47L4.55 14.29Z",
        "fill": "accent"
      },
      {
        "type": "line",
        "d": "M14.24 6.73L13.89 6.12L13.27 5.72L12.49 5.6L11.67 5.77L10.91 6.2L10.35 6.84L10.06 7.58L10.08 8.32L10.41 8.94L11.01 9.35L11.78 9.5L12.55 9.65L13.15 10.06L13.48 10.68L13.5 11.42L13.21 12.16L12.65 12.8L11.89 13.23L11.07 13.4L10.29 13.28L9.67 12.88L9.32 12.27",
        "stroke": "truck",
        "strokeWidth": 1.8
      }
    ],
    "ocs-ana": [
      {
        "type": "polygon",
        "d": "M7.38 5L7.97 5.12L8.43 5.47L8.7 5.99L8.72 6.6L7.86 12L7.64 12.61L7.21 13.13L6.63 13.48L6 13.6L4.5 13.6L3.91 13.48L3.44 13.13L3.18 12.61L3.16 12L4.02 6.6L4.24 5.99L4.67 5.47L5.24 5.12L5.88 5Z",
        "fill": "accent"
      },
      {
        "type": "polygon",
        "d": "M6.5 6.7L6.69 6.74L6.83 6.85L6.92 7.01L6.92 7.2L6.25 11.4L6.18 11.59L6.05 11.75L5.87 11.86L5.67 11.9L5.37 11.9L5.19 11.86L5.04 11.75L4.96 11.59L4.95 11.4L5.62 7.2L5.69 7.01L5.83 6.85L6.01 6.74L6.2 6.7Z",
        "fill": "truck"
      },
      {
        "type": "polygon",
        "d": "M12.68 5L13.27 5.12L13.73 5.47L14 5.99L14.02 6.6L13.16 12L12.94 12.61L12.51 13.13L11.93 13.48L11.3 13.6L10.2 13.6L9.61 13.48L9.14 13.13L8.88 12.61L8.86 12L9.72 6.6L9.94 5.99L10.37 5.47L10.94 5.12L11.58 5Z",
        "fill": "accent"
      },
      {
        "type": "polygon",
        "d": "M14.5 6.7L14.69 6.74L14.83 6.85L14.92 7.01L14.92 7.2L14.25 11.4L14.18 11.59L14.05 11.75L13.87 11.86L13.67 11.9L11.07 11.9L10.89 11.86L10.74 11.75L10.66 11.59L10.65 11.4L11.32 7.2L11.39 7.01L11.53 6.85L11.71 6.74L11.9 6.7Z",
        "fill": "truck"
      },
      {
        "type": "polygon",
        "d": "M11.84 7.7L14.24 7.7L13.73 10.9L11.33 10.9Z",
        "fill": "truck"
      },
      {
        "type": "line",
        "d": "M18.55 6.75L18.69 5.85L16.49 5.85L15.91 6.35L15.49 9L15.84 9.3L17.74 9.3L18.09 9.6L17.67 12.25L17.09 12.75L14.89 12.75L15.03 11.85",
        "stroke": "accent",
        "strokeWidth": 1.7
      }
    ],
    "icl-express": [
      {
        "type": "polygon",
        "d": "M3.4 4.3L5.7 4.3L5.7 14.8L3.4 14.8Z",
        "fill": "accent"
      },
      {
        "type": "polygon",
        "d": "M10.2 4.3L11.12 4.48L11.9 5L12.42 5.78L12.6 6.7L12.6 12.4L12.42 13.32L11.9 14.1L11.12 14.62L10.2 14.8L9.2 14.8L8.28 14.62L7.5 14.1L6.98 13.32L6.8 12.4L6.8 6.7L6.98 5.78L7.5 5L8.28 4.48L9.2 4.3Z",
        "fill": "accent"
      },
      {
        "type": "polygon",
        "d": "M14 6.6L14.23 6.65L14.42 6.78L14.55 6.97L14.6 7.2L14.6 11.9L14.55 12.13L14.42 12.32L14.23 12.45L14 12.5L9.7 12.5L9.47 12.45L9.28 12.32L9.15 12.13L9.1 11.9L9.1 7.2L9.15 6.97L9.28 6.78L9.47 6.65L9.7 6.6Z",
        "fill": "truck"
      },
      {
        "type": "polygon",
        "d": "M13.7 4.3L16 4.3L16 12.5L18.6 12.5L18.6 14.8L13.7 14.8Z",
        "fill": "accent"
      },
      {
        "type": "line",
        "d": "M2.6 10.85L19.4 10.85",
        "stroke": "truck",
        "strokeWidth": 0.9
      },
      {
        "type": "line",
        "d": "M2.6 13.05L19.4 13.05",
        "stroke": "truck",
        "strokeWidth": 0.9
      }
    ],
    "atlantic-courier": [
      {
        "type": "circle",
        "cx": 11,
        "cy": 9.5,
        "r": 5.4,
        "fill": "accent"
      },
      {
        "type": "line",
        "d": "M15.08 5.19L14.37 5.27L13.66 5.4L12.96 5.59L12.29 5.83L11.63 6.13L11 6.48L10.4 6.87L9.83 7.32L9.31 7.81L8.82 8.33L8.37 8.9L7.98 9.5L7.63 10.13L7.33 10.79L7.09 11.46L6.9 12.16L6.77 12.87L6.69 13.58",
        "stroke": "truck",
        "strokeWidth": 1.1
      },
      {
        "type": "line",
        "d": "M16.32 8.06L15.62 8.25L14.95 8.49L14.29 8.79L13.66 9.14L13.06 9.53L12.49 9.98L11.97 10.47L11.48 10.99L11.03 11.56L10.64 12.16L10.29 12.79L9.99 13.45L9.75 14.12L9.56 14.82",
        "stroke": "truck",
        "strokeWidth": 1.1
      }
    ],
    "gms-worldwide": [
      {
        "type": "polygon",
        "d": "M9.95 4.1L12.05 4.1L14.59 5.3L7.41 5.3Z",
        "fill": "accent"
      },
      {
        "type": "polygon",
        "d": "M6.55 6.2L15.45 6.2L16.15 7.4L5.85 7.4Z",
        "fill": "accent"
      },
      {
        "type": "line",
        "d": "M6.87 9.32L6.29 8.78L5.62 8.6L4.96 8.8L4.39 9.35L3.99 10.18L3.81 11.17L3.88 12.2L4.18 13.11L4.69 13.8L5.32 14.16L6 14.15L6.63 13.76L7.12 13.05L7.41 12.12L7.37 11.68L5.94 11.68M9.31 14.2L9.31 8.6L11.31 12.07L13.3 8.6L13.3 14.2M18.07 9.41L17.76 8.97L17.3 8.69L16.78 8.6L16.26 8.72L15.82 9.03L15.54 9.49L15.44 10.02L15.55 10.55L15.85 11L16.3 11.3L16.82 11.4L17.34 11.5L17.79 11.8L18.09 12.25L18.2 12.78L18.11 13.31L17.82 13.77L17.38 14.08L16.87 14.2L16.34 14.11L15.89 13.83L15.57 13.39",
        "stroke": "accent",
        "strokeWidth": 1.6
      }
    ],
    "pushpak-courier": [
      {
        "type": "line",
        "d": "M14.34 6.58L13.1 5.46L11.54 4.84L9.87 4.81L8.29 5.35L6.99 6.41L6.14 7.85L5.85 9.5L6.14 11.15L6.99 12.59L8.29 13.65L9.87 14.19L11.54 14.16L13.1 13.54L14.34 12.42",
        "stroke": "accent",
        "strokeWidth": 1.6
      },
      {
        "type": "line",
        "d": "M10.5 12L10.5 7.3L11.9 7.3L12.55 7.47L13.03 7.95L13.2 8.6L13.03 9.25L12.55 9.73L11.9 9.9L10.5 9.9",
        "stroke": "accent",
        "strokeWidth": 1.4
      }
    ],
    "united-worldwide-couriers": [
      {
        "type": "circle",
        "cx": 7.5,
        "cy": 10.3,
        "r": 4.3,
        "fill": "accent"
      },
      {
        "type": "line",
        "d": "M9.3 10.3L9.16 8.42L8.77 6.84L8.19 5.77L7.5 5.4L6.81 5.77L6.23 6.84L5.84 8.42L5.7 10.3L5.84 12.18L6.23 13.76L6.81 14.83L7.5 15.2L8.19 14.83L8.77 13.76L9.16 12.18L9.3 10.3",
        "stroke": "truck",
        "strokeWidth": 0.95
      },
      {
        "type": "line",
        "d": "M2.7 10.3L12.3 10.3",
        "stroke": "truck",
        "strokeWidth": 0.95
      },
      {
        "type": "polygon",
        "d": "M12.4 11.6L14.2 10.7L16.1 10.3L17.5 9.2L18.1 7.9L19.2 7.5L18.5 6.7L17.6 6.7L16.8 7.4L16.3 3.9L15.3 5.7L14.4 4.3L13.9 6.7L13 5.9L13.2 8.6Z",
        "fill": "accent"
      }
    ],
    "dnx-cargo": [
      {
        "type": "polygon",
        "d": "M5.13 4.3L14.53 4.3L14.31 5.5L4.91 5.5Z",
        "fill": "#e8001c"
      },
      {
        "type": "polygon",
        "d": "M11.22 13.8L17.82 13.8L17.6 15L11 15Z",
        "fill": "#e8001c"
      },
      {
        "type": "polygon",
        "d": "M3.75 6.4L6.05 6.4L6.93 6.64L7.58 7.34L7.91 8.38L7.88 9.6L7.47 10.82L6.77 11.86L5.86 12.56L4.9 12.8L2.6 12.8Z",
        "fill": "accent"
      },
      {
        "type": "polygon",
        "d": "M5.06 8L5.76 8L6.05 8.12L6.25 8.47L6.33 8.99L6.28 9.6L6.1 10.21L5.84 10.73L5.52 11.08L5.19 11.2L4.49 11.2Z",
        "fill": "truck"
      },
      {
        "type": "polygon",
        "d": "M8.3 12.8L9.45 6.4L11.15 6.4L11.5 10L12.15 6.4L13.75 6.4L12.6 12.8L10.9 12.8L10.55 9.2L9.9 12.8Z",
        "fill": "accent"
      },
      {
        "type": "polygon",
        "d": "M14.55 6.4L16.45 6.4L16.66 8.6L17.65 6.4L19.55 6.4L17.43 9.6L18.4 12.8L16.5 12.8L16.3 10.6L15.3 12.8L13.4 12.8L15.53 9.6Z",
        "fill": "accent"
      }
    ],
    "daily-xpress": [
      {
        "type": "polygon",
        "d": "M5.2 4.2L9.8 4.2L11.22 4.46L12.5 5.21L13.52 6.38L14.17 7.86L14.4 9.5L14.17 11.14L13.52 12.62L12.5 13.79L11.22 14.54L9.8 14.8L5.2 14.8Z",
        "fill": "accent"
      },
      {
        "type": "polygon",
        "d": "M7.6 6.6L9.8 6.6L10.48 6.74L11.09 7.15L11.58 7.8L11.89 8.6L12 9.5L11.89 10.4L11.58 11.2L11.09 11.85L10.48 12.26L9.8 12.4L7.6 12.4Z",
        "fill": "truck"
      },
      {
        "type": "polygon",
        "d": "M3.4 12.8L4.71 12.14L6.03 11.48L7.33 10.82L8.64 10.15L9.95 9.47L11.25 8.79L12.55 8.1L13.84 7.41L15.13 6.72L16.43 6.02L17.71 5.31L19 4.6L19 4.6L18.23 6.28L17.36 7.79L16.39 9.11L15.33 10.24L14.17 11.2L12.92 11.98L11.57 12.57L10.13 12.98L8.59 13.21L6.96 13.25L5.23 13.12L3.4 12.8Z",
        "fill": "truck"
      },
      {
        "type": "polygon",
        "d": "M3.4 12.8L4.86 12.41L6.28 11.97L7.68 11.48L9.05 10.93L10.4 10.33L11.71 9.67L13 8.96L14.25 8.2L15.48 7.38L16.68 6.51L17.86 5.58L19 4.6L19 4.6L18.08 6.01L17.1 7.29L16.04 8.44L14.92 9.46L13.72 10.34L12.46 11.09L11.12 11.71L9.72 12.19L8.24 12.54L6.7 12.76L5.08 12.85L3.4 12.8Z",
        "fill": "accent"
      }
    ],
    "best-express-my": [
      {
        "type": "polygon",
        "d": "M5.61 9.49L5.48 9.25L5.44 9L5.48 8.76L5.6 8.51L8.36 4.3L8.51 4.12L8.68 4L8.88 3.93L9.1 3.9L12.9 3.9L13.12 3.93L13.32 4L13.49 4.12L13.64 4.3L16.4 8.51L16.52 8.76L16.56 9L16.52 9.25L16.39 9.49L13.99 13.05L13.9 13.17L13.78 13.23L13.66 13.25L13.51 13.23L11 12.52L8.49 13.23L8.34 13.25L8.22 13.23L8.1 13.17L8.01 13.05Z",
        "fill": "accent"
      },
      {
        "type": "polygon",
        "d": "M10.54 6.17L10.77 5.88L11 5.78L11.23 5.88L11.46 6.17L13.5 9.64L13.54 9.76L13.55 9.87L13.52 9.98L13.43 10.08L11 12.3L8.57 10.08L8.48 9.98L8.45 9.87L8.46 9.76L8.5 9.64Z",
        "fill": "truck"
      },
      {
        "type": "line",
        "d": "M5.02 9.05L8.54 9.88M13.46 9.88L16.98 9.05",
        "stroke": "truck",
        "strokeWidth": 0.88
      }
    ],
    "royal-express-mm": [
      {
        "type": "circle",
        "cx": 11,
        "cy": 9.5,
        "r": 5.45,
        "fill": "#ffed00"
      },
      {
        "type": "line",
        "d": "M9.42 12.6L10.14 6.6L11.82 6.6L12.34 6.69L12.78 6.96L13.08 7.38L13.2 7.89L13.14 8.43L12.89 8.94L12.49 9.36L11.99 9.63L11.45 9.72L9.77 9.72M11.33 9.72L12.9 12.6",
        "stroke": "truck",
        "strokeWidth": 1.9
      }
    ],
    "airpak-express": [
      {
        "type": "line",
        "d": "M14.9 4.95L12.6 4.9L10.4 5.7L8.3 7.3L6.6 9.6L5.6 12L5.5 13.5L6.2 14.15L7.4 14.05L8.9 13.1M14.9 4.95L12.9 13L13 13.85L13.7 14.15L15 13.7L16.6 12.4",
        "stroke": "accent",
        "strokeWidth": 1.7
      },
      {
        "type": "line",
        "d": "M7.6 10.4L13.9 9.4",
        "stroke": "accent",
        "strokeWidth": 1.5
      }
    ],
    "makati-express": [
      {
        "type": "circle",
        "cx": 7.5,
        "cy": 9.5,
        "r": 2.15,
        "fill": "#f4d702"
      },
      {
        "type": "polygon",
        "d": "M10.03 10.08L11.9 9.5L10.03 8.92Z",
        "fill": "#f4d702"
      },
      {
        "type": "polygon",
        "d": "M9.7 8.12L10.61 6.39L8.88 7.3Z",
        "fill": "#f4d702"
      },
      {
        "type": "polygon",
        "d": "M8.08 6.97L7.5 5.1L6.92 6.97Z",
        "fill": "#f4d702"
      },
      {
        "type": "polygon",
        "d": "M6.12 7.3L4.39 6.39L5.3 8.12Z",
        "fill": "#f4d702"
      },
      {
        "type": "polygon",
        "d": "M4.97 8.92L3.1 9.5L4.97 10.08Z",
        "fill": "#f4d702"
      },
      {
        "type": "polygon",
        "d": "M5.3 10.88L4.39 12.61L6.12 11.7Z",
        "fill": "#f4d702"
      },
      {
        "type": "polygon",
        "d": "M6.92 12.03L7.5 13.9L8.08 12.03Z",
        "fill": "#f4d702"
      },
      {
        "type": "polygon",
        "d": "M8.88 11.7L10.61 12.61L9.7 10.88Z",
        "fill": "#f4d702"
      },
      {
        "type": "polygon",
        "d": "M9.96 7.44L10.65 6.91L11.39 6.46L12.16 6.09L12.96 5.79L13.78 5.58L14.62 5.45L15.47 5.4L16.32 5.44L17.16 5.56L17.98 5.77L17.87 8.01L17.08 7.83L16.28 7.73L15.47 7.7L14.66 7.74L13.86 7.85L13.07 8.02L12.31 8.26L11.57 8.57L10.87 8.94L10.21 9.37Z",
        "fill": "accent"
      }
    ],
    "indah-logistik": [
      {
        "type": "polygon",
        "d": "M14.18 4.05L14.18 12.11L10.48 8.4Z",
        "fill": "#003b5b"
      },
      {
        "type": "polygon",
        "d": "M4.56 14.95L10.3 8.2L17.44 6.51Z",
        "fill": "accent"
      },
      {
        "type": "polygon",
        "d": "M8.7 6.51L17.44 6.51L10.36 8.2Z",
        "fill": "accent"
      }
    ],
    "pandu-logistics": [
      {
        "type": "polygon",
        "d": "M18.28 7.04L18.38 7.57L18.33 8.14L18.13 8.74L17.78 9.36L17.3 9.98L16.69 10.59L15.96 11.18L15.13 11.73L14.22 12.25L13.24 12.7L12.22 13.1L11.17 13.42L10.12 13.66L9.09 13.82L8.09 13.89L7.15 13.87L6.3 13.77L5.54 13.58L4.88 13.3L4.36 12.95L3.97 12.54L3.72 12.06L3.62 11.53L3.67 10.96L3.87 10.36L4.22 9.74L4.7 9.12L5.31 8.51L6.04 7.92L6.87 7.37L7.78 6.85L8.76 6.4L9.78 6L10.83 5.68L11.88 5.44L12.91 5.28L13.91 5.21L14.85 5.23L15.7 5.33L16.46 5.52L17.12 5.8L17.64 6.15L18.03 6.56Z",
        "fill": "accent"
      },
      {
        "type": "polygon",
        "d": "M7.35 9.84L9.03 9.19L9.43 9.12L9.83 9.21L10.17 9.45L10.39 9.8L10.46 10.2L10.37 10.6L10.13 10.94L9.78 11.15L8.1 11.8Z",
        "fill": "#d71921"
      },
      {
        "type": "polygon",
        "d": "M13.08 6.08L13.8 7.95L12.07 8.61L11.69 8.68L11.31 8.59L10.99 8.37L10.78 8.04L10.72 7.65L10.8 7.27L11.03 6.95L11.36 6.75Z",
        "fill": "#d71921"
      },
      {
        "type": "polygon",
        "d": "M11.45 9.92L13.23 9.24L13.61 9.18L13.99 9.26L14.31 9.49L14.52 9.82L14.58 10.2L14.5 10.58L14.27 10.9L13.94 11.11L12.17 11.79Z",
        "fill": "#d71921"
      }
    ],
    "pcp-express": [
      {
        "type": "line",
        "d": "M4 12.6L4.96 6.6L6.57 6.6L7.06 6.69L7.47 6.96L7.73 7.38L7.83 7.89L7.74 8.43L7.48 8.94L7.09 9.36L6.59 9.63L6.07 9.72L4.46 9.72M13.11 7.37L12.52 6.78L11.77 6.6L10.97 6.86L10.21 7.52L9.63 8.48L9.3 9.6L9.27 10.72L9.55 11.68L10.09 12.34L10.82 12.6L11.62 12.42L12.39 11.83M14.1 12.6L15.06 6.6L16.67 6.6L17.16 6.69L17.57 6.96L17.84 7.38L17.93 7.89L17.84 8.43L17.59 8.94L17.19 9.36L16.69 9.63L16.17 9.72L14.56 9.72",
        "stroke": "#111111",
        "strokeWidth": 1.9
      }
    ],
    "houng-ah-loun": [
      {
        "type": "line",
        "d": "M5 13.8L5 8.7L5.14 7.8L5.55 7L6.2 6.35L7 5.94L7.9 5.8L8.8 5.94L9.6 6.35L10.25 7L10.66 7.8L10.8 8.7L10.8 12",
        "stroke": "accent",
        "strokeWidth": 1.75
      },
      {
        "type": "line",
        "d": "M8.15 9.2L8.15 11.1L8.29 12L8.7 12.8L9.35 13.45L10.15 13.86L11.05 14L11.95 13.86L12.75 13.45L13.4 12.8L13.81 12L13.95 11.1L13.95 7.3",
        "stroke": "#111111",
        "strokeWidth": 1.75
      },
      {
        "type": "polygon",
        "d": "M14.8 4.5L16.3 4.5L16.3 6L14.8 6Z",
        "fill": "accent"
      },
      {
        "type": "polygon",
        "d": "M17.33 4.43L18.57 4.43L18.57 5.67L17.33 5.67Z",
        "fill": "accent"
      },
      {
        "type": "polygon",
        "d": "M16.54 6.94L17.86 6.94L17.86 8.26L16.54 8.26Z",
        "fill": "accent"
      }
    ],
    "netpost-vn": [
      {
        "type": "polygon",
        "d": "M18.13 6.67L18.31 7.25L18.33 7.88L18.21 8.55L17.94 9.24L17.53 9.95L17 10.65L16.34 11.33L15.58 11.99L14.72 12.6L13.79 13.15L12.81 13.64L11.79 14.04L10.76 14.36L9.73 14.59L8.73 14.72L7.78 14.75L6.9 14.68L6.11 14.51L5.41 14.24L4.83 13.89L4.38 13.45L4.07 12.93L3.89 12.35L3.87 11.72L3.99 11.05L4.26 10.36L4.67 9.65L5.2 8.95L5.86 8.27L6.62 7.61L7.48 7L8.41 6.45L9.39 5.96L10.41 5.56L11.44 5.24L12.47 5.01L13.47 4.88L14.42 4.85L15.3 4.92L16.09 5.09L16.79 5.36L17.37 5.71L17.82 6.15Z",
        "fill": "accent"
      },
      {
        "type": "polygon",
        "d": "M15.51 6.68L15.64 7.16L15.65 7.68L15.52 8.24L15.27 8.82L14.89 9.4L14.4 9.97L13.81 10.51L13.13 11.02L12.38 11.48L11.58 11.88L10.75 12.2L9.91 12.45L9.08 12.62L8.28 12.69L7.52 12.67L6.84 12.57L6.24 12.37L5.74 12.09L5.36 11.74L5.09 11.32L4.96 10.84L4.95 10.32L5.08 9.76L5.33 9.18L5.71 8.6L6.2 8.03L6.79 7.49L7.47 6.98L8.22 6.52L9.02 6.12L9.85 5.8L10.69 5.55L11.52 5.38L12.32 5.31L13.08 5.33L13.76 5.43L14.36 5.63L14.86 5.91L15.24 6.26Z",
        "fill": "truck"
      },
      {
        "type": "polygon",
        "d": "M12.43 7.78L12.49 8.06L12.43 8.38L12.25 8.72L11.97 9.06L11.6 9.39L11.15 9.69L10.66 9.94L10.14 10.14L9.62 10.27L9.12 10.33L8.68 10.31L8.31 10.21L8.04 10.05L7.87 9.82L7.81 9.54L7.87 9.22L8.05 8.88L8.33 8.54L8.7 8.21L9.15 7.91L9.64 7.66L10.16 7.46L10.68 7.33L11.18 7.27L11.62 7.29L11.99 7.39L12.26 7.55Z",
        "fill": "accent"
      }
    ],
    "tp-logistics-th": [
      {
        "type": "line",
        "d": "M3.9 5.6L10.25 5.6M7.07 5.6L7.07 14M11.95 14L11.95 5.6L15.3 5.6L16.04 5.72L16.71 6.06L17.24 6.59L17.58 7.26L17.7 8L17.58 8.74L17.24 9.41L16.71 9.94L16.04 10.28L15.3 10.4L11.95 10.4",
        "stroke": "accent",
        "strokeWidth": 1.9
      }
    ],
    "pcs-logistics-vn": [
      {
        "type": "polygon",
        "d": "M12.03 5.59L11.13 4.93L10.12 4.47L9.04 4.23L7.92 4.23L6.83 4.45L5.82 4.9L4.92 5.55L4.17 6.38L3.61 7.34L3.27 8.39L3.15 9.5L3.27 10.61L3.61 11.66L4.17 12.62L4.92 13.45L5.82 14.1L6.83 14.55L7.92 14.77L9.04 14.77L10.12 14.53L11.13 14.07L12.03 13.41L11.25 13.76L10.42 13.96L9.57 13.99L8.72 13.87L7.92 13.59L7.18 13.16L6.54 12.6L6.01 11.93L5.62 11.17L5.38 10.35L5.3 9.5L5.38 8.65L5.62 7.83L6.01 7.07L6.54 6.4L7.18 5.84L7.92 5.41L8.72 5.13L9.57 5.01L10.42 5.04L11.25 5.24Z",
        "fill": "accent"
      },
      {
        "type": "line",
        "d": "M8.45 12L8.45 7L9.72 7L10.12 7.08L10.48 7.3L10.74 7.65L10.88 8.07L10.88 8.53L10.74 8.95L10.48 9.3L10.12 9.52L9.72 9.6L8.45 9.6M14.62 7.64L14.08 7.15L13.47 7L12.86 7.22L12.35 7.76L12.01 8.56L11.89 9.5L12.01 10.44L12.35 11.24L12.86 11.78L13.47 12L14.08 11.85L14.62 11.36M18.04 7.72L17.76 7.33L17.35 7.08L16.89 7L16.43 7.11L16.04 7.39L15.79 7.79L15.7 8.27L15.8 8.74L16.07 9.14L16.46 9.41L16.93 9.5L17.39 9.59L17.78 9.86L18.05 10.26L18.15 10.73L18.07 11.21L17.81 11.61L17.43 11.89L16.96 12L16.5 11.92L16.1 11.67L15.82 11.28",
        "stroke": "accent",
        "strokeWidth": 1.45
      }
    ],
    "rr-express-sg": [
      {
        "type": "line",
        "d": "M8.9 14.05L11.27 4.95M11.27 4.95L13.37 4.95L14.2 7.12L12.23 9.3L10.13 9.3M11.13 9.3L12.9 14.05",
        "stroke": "accent",
        "strokeWidth": 1.65
      },
      {
        "type": "line",
        "d": "M4 14.05L6.37 4.95M6.37 4.95L8.47 4.95L9.3 7.12L7.33 9.3L5.24 9.3M6.24 9.3L8.5 14.05",
        "stroke": "#df1918",
        "strokeWidth": 1.65
      }
    ],
    "eparcel-kr": [
      {
        "type": "line",
        "d": "M4.25 10.6L9.75 10.6L9.54 9.45L8.94 8.48L8.05 7.83L7 7.6L6.1 7.77L5.29 8.25L4.68 8.99L4.32 9.91L4.26 10.9L4.51 11.87L5.03 12.69L5.77 13.28L6.64 13.57L7.56 13.54L8.41 13.18L9.11 12.53",
        "stroke": "accent",
        "strokeWidth": 1.7
      },
      {
        "type": "line",
        "d": "M12 13.6L12 5L14.2 5L14.93 5.12L15.58 5.45L16.1 5.97L16.43 6.62L16.55 7.35L16.43 8.08L16.1 8.73L15.58 9.25L14.93 9.58L14.2 9.7L12 9.7",
        "stroke": "accent",
        "strokeWidth": 1.7
      }
    ],
    "aci-express-kr": [
      {
        "type": "polygon",
        "d": "M6.67 6.11L7.26 5.47L7.95 4.92L8.72 4.5L9.54 4.2L10.4 4.03L11.28 4.01L12.15 4.12L12.99 4.37L13.78 4.76L14.5 5.26L15.13 5.87L15.66 6.57L16.06 7.35L16.34 8.18L16.48 9.05L16.48 9.93L16.35 10.79L16.07 11.63L15.67 12.41L15.15 13.11L14.52 13.73L13.8 14.23L13.01 14.62L12.17 14.87L11.3 14.99L10.43 14.97L10.81 13.72L11.43 13.42L12 13.04L12.51 12.58L12.96 12.06L13.33 11.48L13.62 10.86L13.82 10.2L13.93 9.52L13.95 8.83L13.87 8.15L13.7 7.48L13.44 6.85L13.1 6.25L12.68 5.71L12.2 5.22L11.65 4.81L11.05 4.48L10.4 4.23L9.74 4.07L9.05 4L8.37 4.03L7.69 4.15L7.04 4.36L6.42 4.65Z",
        "fill": "accent"
      },
      {
        "type": "polygon",
        "d": "M5.5 8.75L14.2 8.05L14.35 9.7L5.6 10.35Z",
        "fill": "#00043c"
      },
      {
        "type": "line",
        "d": "M6.3 9.5L6.36 10.22L6.52 10.92L6.79 11.59L7.16 12.21L7.62 12.76L8.16 13.24L8.76 13.63L9.42 13.93L10.12 14.12L10.84 14.2",
        "stroke": "#00043c",
        "strokeWidth": 1.6
      }
    ],
    "gsi-express": [
      {
        "type": "line",
        "d": "M7.9 5L4 5L4 13.6L7.9 13.6L7.9 9.3L5.75 9.3M14.35 5L10.85 5L10.85 9.3L14.35 9.3L14.35 13.6L10.85 13.6",
        "stroke": "accent",
        "strokeWidth": 1.7
      },
      {
        "type": "line",
        "d": "M17.3 4.15L17.3 14.45",
        "stroke": "accent",
        "strokeWidth": 1.7
      }
    ],
    "today-kr": [
      {
        "type": "polygon",
        "d": "M3.8 4.4L10.6 4.4L10.6 6.3L8.15 6.3L8.15 13.8L6.25 13.8L6.25 6.3L3.8 6.3Z",
        "fill": "accent"
      },
      {
        "type": "circle",
        "cx": 14.6,
        "cy": 10.4,
        "r": 3.4,
        "fill": "accent"
      },
      {
        "type": "circle",
        "cx": 14.6,
        "cy": 10.4,
        "r": 1.65,
        "fill": "truck"
      }
    ],
    "exmate": [
      {
        "type": "polygon",
        "d": "M4.6 4.4L8.9 4.4L16.9 14.6L12.6 14.6Z",
        "fill": "accent"
      },
      {
        "type": "polygon",
        "d": "M18.9 4L9.98 7.91L3.3 15L12.22 11.09Z",
        "fill": "truck"
      },
      {
        "type": "polygon",
        "d": "M18.9 4L10.44 8.56L3.3 15L11.76 10.44Z",
        "fill": "accent"
      }
    ],
    "winion-logis": [
      {
        "type": "polygon",
        "d": "M3 4.85L6.85 4.85L7.89 7.2L4.04 7.2Z",
        "fill": "#cdcdce"
      },
      {
        "type": "polygon",
        "d": "M10.18 4.85L14.13 4.85L10.49 10.84L8.51 14.25L6.64 11.08Z",
        "fill": "accent"
      },
      {
        "type": "polygon",
        "d": "M15.38 4.85L19.12 4.85L15.69 10.84L13.71 14.25L11.84 11.08Z",
        "fill": "accent"
      }
    ],
    "last-one-mile-coop": [
      {
        "type": "polygon",
        "d": "M5.6 4.2L7.3 4L8.6 12.4L6.9 12.6Z",
        "fill": "#000000"
      },
      {
        "type": "polygon",
        "d": "M6.9 11.4L16.2 11L16.4 12.5L7.1 12.8Z",
        "fill": "#000000"
      },
      {
        "type": "polygon",
        "d": "M9 4.8L11.9 4.5L12.2 7.4L9.3 7.7Z",
        "fill": "accent"
      },
      {
        "type": "polygon",
        "d": "M9.4 8.3L15 7.7L15.3 10.4L9.7 11Z",
        "fill": "accent"
      },
      {
        "type": "circle",
        "cx": 9,
        "cy": 13.5,
        "r": 1.45,
        "fill": "#000000"
      },
      {
        "type": "circle",
        "cx": 14.7,
        "cy": 13.35,
        "r": 1.45,
        "fill": "#000000"
      }
    ],
    "dpex": [
      {
        "type": "polygon",
        "d": "M4.14 5.7L5.49 5.7L6.09 5.8L6.61 6.08L6.98 6.52L7.18 7.08L7.19 7.7L6.8 10.3L6.61 10.92L6.24 11.48L5.73 11.92L5.13 12.2L4.5 12.3L3.15 12.3Z",
        "fill": "accent"
      },
      {
        "type": "polygon",
        "d": "M5.31 6.9L5.61 6.9L5.95 6.99L6.16 7.25L6.21 7.6L5.79 10.4L5.64 10.75L5.34 11.01L4.98 11.1L4.68 11.1Z",
        "fill": "truck"
      },
      {
        "type": "polygon",
        "d": "M7.25 12.3L8.24 5.7L9.79 5.7L10.38 5.82L10.85 6.17L11.12 6.69L11.15 7.3L11.02 8.15L10.85 8.65L10.5 9.07L10.04 9.35L9.53 9.45L9.03 9.45L8.6 12.3Z",
        "fill": "accent"
      },
      {
        "type": "polygon",
        "d": "M9.43 6.75L9.78 6.75L10 6.81L10.14 6.98L10.17 7.2L10.04 8L9.95 8.22L9.76 8.39L9.53 8.45L9.18 8.45Z",
        "fill": "truck"
      },
      {
        "type": "polygon",
        "d": "M12.14 5.7L14.89 5.7L14.7 6.95L13.3 6.95L13.09 8.38L14.19 8.38L14 9.62L12.9 9.62L12.69 11.05L14.09 11.05L13.9 12.3L11.15 12.3Z",
        "fill": "#c7c9c8"
      },
      {
        "type": "polygon",
        "d": "M15.59 5.7L17.09 5.7L17.9 12.3L16.4 12.3Z",
        "fill": "#c7c9c8"
      },
      {
        "type": "polygon",
        "d": "M17.39 5.7L18.89 5.7L16.1 12.3L14.6 12.3Z",
        "fill": "#c7c9c8"
      }
    ],
    "mrl-global": [
      {
        "type": "polygon",
        "d": "M3.25 10.3L4.41 4.5L9.46 4.5L9.9 4.59L10.24 4.85L10.42 5.24L10.42 5.7L9.5 10.3L8.05 10.3L8.94 5.85L7.99 5.85L7.1 10.3L5.65 10.3L6.54 5.85L5.59 5.85L4.7 10.3Z",
        "fill": "accent"
      },
      {
        "type": "polygon",
        "d": "M10.35 10.3L11.51 4.5L13.61 4.5L14.09 4.6L14.45 4.88L14.65 5.3L14.65 5.8L14.49 6.6L14.28 7.05L13.88 7.38L13.41 7.5L13.11 7.5L13.8 10.3L12.2 10.3L12.91 7.5L12.36 7.5L11.8 10.3Z",
        "fill": "accent"
      },
      {
        "type": "polygon",
        "d": "M12.56 6.25L14.88 5.65L14.77 6.2L12.44 6.85Z",
        "fill": "truck"
      },
      {
        "type": "polygon",
        "d": "M15.76 4.5L17.26 4.5L16.37 8.95L17.87 8.95L17.6 10.3L14.6 10.3Z",
        "fill": "accent"
      },
      {
        "type": "polygon",
        "d": "M4.45 11.25L18.76 11.25L3.4 14.65Z",
        "fill": "#f47e20"
      }
    ],
    "fliway": [
      {
        "type": "polygon",
        "d": "M7 4.3L15.2 4.3L15.2 6.65L10.85 6.65L10.35 7.15L10.35 8.15L10.85 8.65L15.2 8.65L15.2 10.9L10.35 10.9L10.35 13.9L7 13.9Z",
        "fill": "accent"
      }
    ],
    "morning-global": [
      {
        "type": "polygon",
        "d": "M6.93 4L6.34 4.12L5.83 4.47L5.49 4.99L5.37 5.61L5.49 6.22L5.83 6.74L6.34 7.09L6.93 7.21L7.52 7.09L8.03 6.74L8.37 6.22L8.49 5.61L8.37 4.99L8.03 4.47L7.52 4.12Z",
        "fill": "accent"
      },
      {
        "type": "polygon",
        "d": "M5 8.49L5.12 8.21L5.41 8L5.83 7.92L8.69 7.83L9.73 8.25L13.86 13.31L13.14 14.16L11.66 14.16L8.69 10.38L8.69 13.78L5 14.39Z",
        "fill": "accent"
      },
      {
        "type": "polygon",
        "d": "M13.14 14.16L14.74 10.52L16.83 10.52L16.83 14.02L15.29 14.02L15.29 12.03L14.91 12.03L14.03 14.16Z",
        "fill": "accent"
      },
      {
        "type": "polygon",
        "d": "M16.01 7.35L15.55 7.5L15.23 7.87L15.11 8.39L15.23 8.91L15.55 9.29L16.01 9.43L16.46 9.29L16.77 8.91L16.9 8.39L16.77 7.87L16.46 7.5Z",
        "fill": "accent"
      }
    ],
    "rpx-hk": [
      {
        "type": "polygon",
        "d": "M9.9 3.95L16.2 10.3L5.5 14.85Z",
        "fill": "#006b6e"
      },
      {
        "type": "line",
        "d": "M3.85 12.05L4.5 8.45L5.25 7.7L12.55 7.7L11.8 11.3L8.5 11.3L9.1 7.8",
        "stroke": "accent",
        "strokeWidth": 1.5
      },
      {
        "type": "polygon",
        "d": "M11.93 6.95L13.87 6.95L18.02 12.05L16.08 12.05Z",
        "fill": "accent"
      },
      {
        "type": "polygon",
        "d": "M16.57 6.95L18.83 6.95L13.08 12.05L10.82 12.05Z",
        "fill": "accent"
      }
    ],
    "montenegro-post": [
      {
        "type": "line",
        "d": "M17.85 9.52L17.85 11.43L17.75 12.05L17.47 12.61L17.03 13.05L16.47 13.33L15.85 13.43L5.53 13.33L4.97 13.05L4.53 12.61L4.25 12.05L4.15 11.43L4.25 6.55L4.53 5.99L4.97 5.55L5.53 5.27L6.15 5.17L16.5 5.23L17.08 5.39L17.53 5.65L17.79 5.96L17.84 6.31L17.68 6.64L17.31 6.93L16.79 7.14L10.58 8.91L7.49 7.64",
        "stroke": "accent",
        "strokeWidth": 1.5
      }
    ],
    "vitran-express": [
      {
        "type": "polygon",
        "d": "M7.4 7.4L10.15 7.4L10.8 11.38L13.05 7.4L15.8 7.4L11.3 14.4L9.1 14.4Z",
        "fill": "accent"
      },
      {
        "type": "polygon",
        "d": "M4 6.25L5.06 5.84L6.13 5.47L7.19 5.15L8.26 4.86L9.32 4.63L10.39 4.43L11.45 4.28L12.51 4.18L13.58 4.12L14.64 4.12L15.71 4.19L16.77 4.31L17.84 4.5L18.9 4.75L18.9 6.75L17.84 6.39L16.77 6.09L15.71 5.86L14.64 5.69L13.58 5.58L12.51 5.54L11.45 5.54L10.39 5.58L9.32 5.68L8.26 5.82L7.19 6L6.13 6.24L5.06 6.52L4 6.85Z",
        "fill": "accent"
      }
    ],
    "am-home-delivery": [
      {
        "type": "polygon",
        "d": "M3.3 14.6L8.3 4.4L10.9 4.4L10.7 14.6L8.5 14.6L8.5 12.5L6.6 12.5L5.7 14.6Z",
        "fill": "#ff4b55"
      },
      {
        "type": "polygon",
        "d": "M7.5 10.5L8.6 7.6L8.55 10.5Z",
        "fill": "truck"
      },
      {
        "type": "polygon",
        "d": "M11.9 14.6L11.9 4.4L14.2 4.4L15.35 8.4L16.5 4.4L18.8 4.4L18.8 14.6L16.9 14.6L16.9 9L15.95 12.2L14.75 12.2L13.8 9L13.8 14.6Z",
        "fill": "accent"
      }
    ],
    "american-west-express": [
      {
        "type": "polygon",
        "d": "M14.27 4.98L14.5 3.79L15.3 4.7Z",
        "fill": "#f2692b"
      },
      {
        "type": "polygon",
        "d": "M15.1 4.7L15.9 3.79L16.13 4.98Z",
        "fill": "#f2692b"
      },
      {
        "type": "polygon",
        "d": "M15.96 4.88L17.11 4.49L16.72 5.64Z",
        "fill": "#f2692b"
      },
      {
        "type": "polygon",
        "d": "M16.62 5.47L17.81 5.7L16.9 6.5Z",
        "fill": "#f2692b"
      },
      {
        "type": "polygon",
        "d": "M16.9 6.3L17.81 7.1L16.62 7.33Z",
        "fill": "#f2692b"
      },
      {
        "type": "polygon",
        "d": "M16.72 7.16L17.11 8.31L15.96 7.92Z",
        "fill": "#f2692b"
      },
      {
        "type": "polygon",
        "d": "M16.13 7.82L15.9 9.01L15.1 8.1Z",
        "fill": "#f2692b"
      },
      {
        "type": "polygon",
        "d": "M15.3 8.1L14.5 9.01L14.27 7.82Z",
        "fill": "#f2692b"
      },
      {
        "type": "polygon",
        "d": "M14.44 7.92L13.29 8.31L13.68 7.16Z",
        "fill": "#f2692b"
      },
      {
        "type": "circle",
        "cx": 15.2,
        "cy": 6.4,
        "r": 1.9,
        "fill": "#f2692b"
      },
      {
        "type": "polygon",
        "d": "M3.3 14.6L10.4 4.2L16.9 14.6Z",
        "fill": "accent"
      },
      {
        "type": "polygon",
        "d": "M9.8 7.02L9.03 7.78L8.44 8.79L8.09 9.96L8 11.2L8.18 12.43L8.61 13.56L9.26 14.49L10.08 15.17L11.5 14.63L10.91 14.04L10.44 13.22L10.13 12.24L10 11.17L10.07 10.09L10.32 9.08L10.74 8.2L11.3 7.54Z",
        "fill": "truck"
      }
    ],
    "ccfs": [
      {
        "type": "polygon",
        "d": "M13.2 4L15.3 5.3L16 4.1L16.7 4L16.5 5L16.3 5.9L18.3 7.3L18.8 8.6L18.4 10.5L17.6 11.2L17 13.5L16.3 12L16.1 14.4L14.6 14.4L14.4 12.2L8.5 11.8L6.9 14.4L4.8 14.4L4.4 12.1L3.8 10.4L3.2 10.8L3.7 9.2L5.4 7.6L7.2 6.6L7.8 5.7L8.3 6.2L9.4 5L9.8 5.5L11.2 4.6Z",
        "fill": "accent"
      },
      {
        "type": "polygon",
        "d": "M15.87 6.1L15.69 6.64L15.6 7.22L15.62 7.81L15.75 8.37L15.96 8.89L16.92 8.52L16.79 8.2L16.71 7.85L16.7 7.49L16.75 7.13L16.86 6.8Z",
        "fill": "truck"
      }
    ],
    "custom-companies": [
      {
        "type": "circle",
        "cx": 11,
        "cy": 9.5,
        "r": 5.5,
        "fill": "accent"
      },
      {
        "type": "polygon",
        "d": "M6.77 7.42L11.07 7.11L11.76 7.84L12.62 7.42L14.34 6.8L15.03 7.32L14 8.57L13.48 9.71L14.17 11.79L13.48 11.79L12.62 10.86L11.42 10.96L10.73 12L10.04 11.17L9.18 10.65L8.15 10.54L7.29 9.92L6.6 8.57Z",
        "fill": "truck"
      },
      {
        "type": "circle",
        "cx": 10.56,
        "cy": 9.09,
        "r": 0.95,
        "fill": "accent"
      }
    ],
    "hercules-freight": [
      {
        "type": "polygon",
        "d": "M3.6 15L5.73 7.4L8.03 7.4L7.24 10.2L11.54 10.2L12.33 7.4L14.63 7.4L12.5 15L10.2 15L11.01 12.1L6.71 12.1L5.9 15Z",
        "fill": "accent"
      },
      {
        "type": "polygon",
        "d": "M3.4 6.6L4.74 5.8L6.13 5.12L7.56 4.56L9.03 4.12L10.55 3.8L12.11 3.6L13.72 3.52L15.37 3.56L17.06 3.72L18.8 4L18.4 6.4L16.85 5.97L15.3 5.64L13.77 5.42L12.26 5.3L10.75 5.28L9.26 5.36L7.77 5.54L6.3 5.82L4.85 6.21Z",
        "fill": "#ff4b55"
      }
    ],
    "gaash": [
      {
        "type": "polygon",
        "d": "M8.98 4.97L11 3.8L13.02 4.97L12.27 6.27L11.7 5.94L11.7 7.4L10.3 7.4L10.3 5.94L9.73 6.27Z",
        "fill": "#f58020"
      },
      {
        "type": "polygon",
        "d": "M13.91 5.48L15.94 6.65L15.94 8.99L14.44 8.99L14.44 7.52L13.16 6.78Z",
        "fill": "accent"
      },
      {
        "type": "polygon",
        "d": "M15.94 10.01L15.94 12.35L13.91 13.52L13.16 12.22L13.74 11.89L12.47 11.16L13.17 9.94L14.44 10.68L14.44 10.01Z",
        "fill": "#f58020"
      },
      {
        "type": "polygon",
        "d": "M13.02 14.03L11 15.2L8.98 14.03L9.73 12.73L11 13.47L12.27 12.73Z",
        "fill": "accent"
      },
      {
        "type": "polygon",
        "d": "M8.09 13.52L6.06 12.35L6.06 10.01L7.56 10.01L7.56 10.68L8.83 9.94L9.53 11.16L8.26 11.89L8.84 12.22Z",
        "fill": "#f58020"
      },
      {
        "type": "polygon",
        "d": "M6.06 8.99L6.06 6.65L8.09 5.48L8.84 6.78L7.56 7.52L7.56 8.99Z",
        "fill": "accent"
      }
    ],
    "orian": [
      {
        "type": "polygon",
        "d": "M3 6.5L15 6.5L15 8.5L13 8.5L13 12.5L3 12.5Z",
        "fill": "accent"
      },
      {
        "type": "polygon",
        "d": "M9 8.5L11 8.5L11 10.5L9 10.5Z",
        "fill": "truck"
      },
      {
        "type": "polygon",
        "d": "M17 6.5L19 6.5L19 8.5L17 8.5Z",
        "fill": "accent"
      },
      {
        "type": "polygon",
        "d": "M15 10.5L17 10.5L17 12.5L15 12.5Z",
        "fill": "accent"
      }
    ],
    "qwintry": [
      {
        "type": "polygon",
        "d": "M11 3.9L15.85 6.7L15.85 12.3L11 15.1L6.15 12.3L6.15 6.7Z",
        "fill": "accent"
      },
      {
        "type": "polygon",
        "d": "M11 5.75L14.25 7.62L14.25 11.38L11 13.25L7.75 11.38L7.75 7.62Z",
        "fill": "truck"
      },
      {
        "type": "polygon",
        "d": "M11 6.94L13.22 8.22L13.22 10.78L11 12.06L8.78 10.78L8.78 8.22Z",
        "fill": "accent"
      },
      {
        "type": "polygon",
        "d": "M13.24 10.98L14.34 10.98L14.34 15.5L13.24 15.5Z",
        "fill": "truck"
      },
      {
        "type": "polygon",
        "d": "M16.1 9.06L13.9 10.33L13.9 11.6L16.1 10.33Z",
        "fill": "truck"
      },
      {
        "type": "line",
        "d": "M8.78 8.22L11 9.5L13.22 8.22M11 9.5L11 12.06",
        "stroke": "truck",
        "strokeWidth": 1
      }
    ],
    "skypostal": [
      {
        "type": "polygon",
        "d": "M8.47 4.33L7.7 4.83L7.04 5.54L6.71 6.31L6.88 7.08L7.37 7.79L8.25 8.51L9.35 9.34L10.45 10.44L11.55 11.48L12.15 12.36L12.32 13.24L11.99 14.12L11.22 14.72L10.78 15L12.21 14.89L13.86 14.45L15.07 13.85L15.95 13.07L16.39 12.14L16.45 11.26L16.12 10.32L15.4 9.55L14.3 8.95L12.98 8.46L11.66 8.02L10.45 7.52L9.52 6.86L8.91 6.09L8.69 5.32L8.69 4.66Z",
        "fill": "accent"
      },
      {
        "type": "polygon",
        "d": "M11.96 4.08L12.47 4.2L12.97 4.37L13.45 4.58L13.91 4.84L14.35 5.14L14.75 5.48L15.12 5.86L15.45 6.27L15.74 6.71L15.98 7.18L15.43 6.89L14.89 6.67L14.39 6.5L13.94 6.35L13.54 6.19L13.19 6L12.89 5.71L12.62 5.27L12.33 4.71Z",
        "fill": "accent"
      },
      {
        "type": "polygon",
        "d": "M5.55 8.73L5.51 9.12L5.5 9.5L5.51 9.88L5.55 10.27L5.62 10.64L5.71 11.02L5.83 11.38L5.98 11.74L6.14 12.08L6.34 12.41L6.42 11.93L6.54 11.48L6.67 11.08L6.79 10.71L6.88 10.38L6.93 10.07L6.94 9.78L6.74 9.5L6.23 9.17Z",
        "fill": "accent"
      }
    ],
    "ait-worldwide": [
      {
        "type": "polygon",
        "d": "M3.1 13.4L6.75 5.4L8.65 5.4L8.3 13.4L6.36 13.4L7.18 7.47L5.04 13.4Z",
        "fill": "accent"
      },
      {
        "type": "polygon",
        "d": "M11.2 5.4L13 5.4L11 13.4L9.2 13.4Z",
        "fill": "accent"
      },
      {
        "type": "polygon",
        "d": "M13.9 5.4L18.9 5.4L18.45 7.2L16.85 7.2L15.3 13.4L13.5 13.4L15.05 7.2L13.45 7.2Z",
        "fill": "accent"
      },
      {
        "type": "polygon",
        "d": "M4.65 11.98L5.68 10.68L7.08 10.68L7.46 11.98Z",
        "fill": "accent"
      }
    ],
    "team-worldwide": [
      {
        "type": "polygon",
        "d": "M4 4L10.52 4L10.52 6.29L8.22 6.29L8.22 12.11L5.77 12.11L5.77 6.29L4 6.29Z",
        "fill": "accent"
      },
      {
        "type": "polygon",
        "d": "M9.22 7.34L9.22 13.77L9.32 14.24L9.59 14.65L9.99 14.92L10.47 15.02L13.21 15.02L13.66 14.62L14.11 15.02L16.85 15.02L17.33 14.92L17.73 14.65L18 14.24L18.1 13.77L18.1 7.34Z",
        "fill": "accent"
      },
      {
        "type": "polygon",
        "d": "M11.41 7.14L12.56 7.14L12.56 12.57L11.41 12.57Z",
        "fill": "truck"
      },
      {
        "type": "polygon",
        "d": "M14.76 7.14L15.91 7.14L15.91 12.57L14.76 12.57Z",
        "fill": "truck"
      }
    ],
    "huahan": [
      {
        "type": "polygon",
        "d": "M12.38 4.18L11.47 4.02L10.53 4.02L9.62 4.18L8.74 4.5L7.93 4.97L7.22 5.57L6.62 6.28L6.15 7.09L5.83 7.97L5.67 8.88L5.67 9.82L5.83 10.73L6.15 11.61L6.62 12.42L7.22 13.13L7.93 13.73L8.74 14.2L8.56 13.75L7.88 13.14L7.41 12.4L7.14 11.45L7.07 10.5L7.28 9.55L7.61 8.81L8.16 8.06L9.04 7.39L9.51 8L10.19 8.81L11.07 8.54L11.88 8.13L12.49 7.59L12.9 6.98L13.1 6.17L13.03 5.42L12.76 4.74Z",
        "fill": "accent"
      },
      {
        "type": "polygon",
        "d": "M9.62 14.52L10.53 14.68L11.47 14.68L12.38 14.52L13.26 14.2L14.07 13.73L14.78 13.13L15.38 12.42L15.85 11.61L16.17 10.73L16.33 9.82L16.33 8.88L16.17 7.97L15.85 7.09L15.38 6.28L14.78 5.57L14.07 4.97L13.26 4.5L13.44 4.95L14.12 5.56L14.59 6.3L14.86 7.25L14.93 8.2L14.72 9.15L14.39 9.89L13.84 10.64L12.96 11.31L12.49 10.7L11.81 9.89L10.93 10.16L10.12 10.57L9.51 11.11L9.1 11.72L8.9 12.53L8.97 13.28L9.24 13.96Z",
        "fill": "#00c480"
      }
    ],
    "anserx": [
      {
        "type": "polygon",
        "d": "M5.5 6.98L6.26 6.39L7.22 5.92L8.34 5.61L9.55 5.48L10.84 5.56L12.13 5.87L13.4 6.44L14.59 7.31L15.67 8.48L16.58 10L15.23 9.76L13.91 9.7L12.6 9.83L11.31 10.15L10.74 9.45L10.01 8.81L9.12 8.25L8.07 7.76L6.86 7.33Z",
        "fill": "accent"
      },
      {
        "type": "polygon",
        "d": "M3.1 9L3.53 8.71L4.13 8.51L4.85 8.39L5.67 8.36L6.54 8.46L7.45 8.67L8.35 9.02L9.21 9.52L10 10.18L10.69 11.01L9.7 11.04L8.81 11.22L8.03 11.54L7.36 12.02L6.89 11.3L6.33 10.67L5.67 10.12L4.91 9.66L4.05 9.29Z",
        "fill": "#9cca2c"
      },
      {
        "type": "polygon",
        "d": "M12.01 11.18L12.31 11L12.78 10.84L13.38 10.74L14.09 10.71L14.88 10.77L15.72 10.95L16.58 11.25L17.43 11.7L18.24 12.32L18.98 13.12L17.83 13.02L16.7 13.06L15.58 13.24L14.49 13.56L14.03 13.03L13.59 12.56L13.17 12.13L12.77 11.76L12.38 11.45Z",
        "fill": "#9cca2c"
      }
    ],
    "chukou1": [
      {
        "type": "circle",
        "cx": 12.6,
        "cy": 9.6,
        "r": 4.7,
        "fill": "accent"
      },
      {
        "type": "line",
        "d": "M7.19 10.96L7.36 10.76L7.54 10.55L7.74 10.34L7.95 10.13L8.17 9.92L8.41 9.71L8.65 9.49L8.91 9.28L9.18 9.07L9.45 8.86L9.74 8.65L10.03 8.44L10.33 8.24L10.64 8.04L10.95 7.85L11.27 7.66L11.59 7.47L11.91 7.29L12.23 7.12L12.56 6.96L12.88 6.8L13.21 6.65L13.53 6.5L13.85 6.37L14.17 6.25L14.48 6.13L14.79 6.02L15.09 5.93L15.38 5.84L15.67 5.76L15.95 5.7L16.22 5.64L16.48 5.6L16.48 5.6",
        "stroke": "truck",
        "strokeWidth": 1.25
      },
      {
        "type": "polygon",
        "d": "M7.25 9.6L6.91 9.96L6.59 10.35L6.33 10.79L6.11 11.25L5.97 11.74L5.94 12.21L6 12.68L6.15 13.11L6.38 13.51L6.71 13.84L7.17 14.04L7.71 14.14L8.29 14.13L8.9 14.01L8.57 13.83L8.23 13.65L7.92 13.43L7.67 13.14L7.54 12.78L7.47 12.39L7.46 12L7.5 11.6L7.59 11.22L7.69 10.85L7.84 10.5L8.05 10.17L8.28 9.87L8.55 9.6Z",
        "fill": "accent"
      }
    ],
    "jumppoint": [
      {
        "type": "polygon",
        "d": "M8.82 12.46L8.45 12.94L7.93 13.25L7.33 13.33L6.75 13.18L6.27 12.81L5.96 12.29L5.88 11.69L6.03 11.1L8.47 6.09L8.83 5.61L9.36 5.31L9.96 5.22L10.54 5.38L11.02 5.74L11.33 6.26L11.41 6.86L11.26 7.45Z",
        "fill": "accent"
      },
      {
        "type": "polygon",
        "d": "M13.73 12.46L13.36 12.94L12.84 13.25L12.24 13.33L11.65 13.18L11.17 12.81L10.87 12.29L10.78 11.69L10.94 11.1L13.37 6.09L13.74 5.61L14.26 5.31L14.86 5.22L15.45 5.38L15.93 5.74L16.23 6.26L16.32 6.86L16.16 7.45Z",
        "fill": "accent"
      },
      {
        "type": "polygon",
        "d": "M4.84 10.16L6.36 7.84L6.64 7.11L6.59 6.33L6.22 5.65L5.6 5.17L4.84 5.01L4.07 5.17L3.45 5.65L3.08 6.33L3.03 7.11L3.31 7.84Z",
        "fill": "#56bfff"
      },
      {
        "type": "polygon",
        "d": "M17.18 8.7L15.63 10.84L15.31 11.57L15.33 12.38L15.69 13.1L16.32 13.6L17.1 13.79L17.89 13.62L18.54 13.14L18.92 12.43L18.97 11.63L18.67 10.88Z",
        "fill": "#56bfff"
      }
    ],
    "ycs-logistics": [
      {
        "type": "line",
        "d": "M3.9 6.3L5.81 9.63L7.73 6.3M5.81 9.63L5.81 12.7M13.04 7.12L12.32 6.49L11.48 6.3L10.65 6.58L9.96 7.28L9.49 8.3L9.33 9.5L9.49 10.7L9.96 11.72L10.65 12.42L11.48 12.7L12.32 12.51L13.04 11.88M17.94 7.22L17.56 6.72L17.02 6.4L16.38 6.3L15.75 6.44L15.23 6.8L14.88 7.32L14.77 7.93L14.9 8.53L15.26 9.04L15.8 9.38L16.43 9.5L17.06 9.62L17.6 9.96L17.97 10.47L18.1 11.07L17.99 11.68L17.64 12.2L17.11 12.56L16.49 12.7L15.85 12.6L15.3 12.28L14.92 11.78",
        "stroke": "accent",
        "strokeWidth": 1.7
      }
    ],
    "lingdong": [
      {
        "type": "polygon",
        "d": "M13.19 14.26L12.12 14.81L10.95 15.11L9.75 15.17L8.56 14.96L7.44 14.52L6.45 13.84L5.61 12.97L4.98 11.95L4.58 10.81L4.43 9.62L4.53 8.42L4.88 7.27L5.47 6.21L6.27 5.31L7.24 4.6L8.34 4.1L9.52 3.85L10.72 3.86L11.9 4.12L12.99 4.62L13.96 5.34L14.75 6.24L13.99 6.77L13.33 6.01L12.52 5.41L11.61 4.99L10.62 4.78L9.61 4.77L8.63 4.98L7.71 5.4L6.89 5.99L6.23 6.75L5.73 7.63L5.44 8.59L5.35 9.6L5.48 10.6L5.81 11.55L6.34 12.41L7.04 13.14L7.88 13.7L8.81 14.07L9.81 14.24L10.81 14.2L11.79 13.94L12.69 13.49Z",
        "fill": "accent"
      },
      {
        "type": "polygon",
        "d": "M15.61 8.13L15.77 9.32L15.68 10.52L15.34 11.68L14.76 12.74L13.97 13.65L13.34 12.98L14 12.21L14.49 11.33L14.77 10.36L14.85 9.35L14.71 8.35Z",
        "fill": "accent"
      },
      {
        "type": "polygon",
        "d": "M6.85 8.61L7.84 8.28L8.67 8.05L9.16 7.75L9.42 7.29L9.52 6.53L9.52 5.34L10.65 5.57L11.97 5.84L13.29 6L14.44 6L15.6 5.8L17.31 5.44L16.26 6.33L15.2 6.79L14.11 7.06L11.67 7.09L11.54 7.59L11.21 7.98L10.65 8.31L9.82 8.58L8.67 8.74L7.68 8.77Z",
        "fill": "accent"
      },
      {
        "type": "polygon",
        "d": "M10.32 9.27L11.07 8.77L11.57 8.25L11.97 7.78L12.96 7.72L14.11 7.59L15.1 7.36L16.09 6.99L17.58 6.37L16.92 7.12L16.26 7.75L15.69 8.28L14.61 8.74L13.78 9.07L12.96 9.3L12.53 9.57L13.02 10.23L13.42 10.92L13.68 11.58L13.85 12.21L13.98 12.8L13.98 13.66L13.62 13.39L13.22 12.93L12.86 12.24L12.49 11.55L12.06 10.89L11.57 10.29L10.91 9.73Z",
        "fill": "accent"
      },
      {
        "type": "polygon",
        "d": "M5.93 8.82L6.85 8.94L7.84 9.27L8.83 9.66L9.75 10.09L10.48 10.56L11.14 11.08L11.73 11.61L12.23 12.17L12.63 12.77L12.96 13.39L13.25 14.02L13.71 14.88L13.05 14.68L12.3 14.65L10.98 14.55L10.48 14.19L11.04 13.86L11.34 13.39L11.4 12.87L11.24 12.27L10.78 11.71L10.08 11.15L9.23 10.59L8.34 10.09L7.35 9.57L6.52 9.14Z",
        "fill": "accent"
      }
    ],
    "jcex": [
      {
        "type": "polygon",
        "d": "M5.64 6.26L6.96 7.3L6.29 11.05L6.11 11.45L5.87 11.81L5.58 12.09L5.17 12.37L4.68 12.59L4.23 12.7L3.32 12.72L3.55 11.39L4.05 11.34L4.38 11.21L4.69 10.98L4.91 10.62Z",
        "fill": "#f08200"
      },
      {
        "type": "polygon",
        "d": "M7.6 9.01L8.03 8.63L8.62 8.33L9.25 8.2L9.88 8.21L9.67 9.54L9.2 9.61L8.92 9.75L8.66 10.03L8.54 10.34L8.56 10.69L8.73 11.02L8.98 11.22L9.37 11.36L9.14 12.72L8.46 12.54L7.89 12.21L7.45 11.76L7.17 11.23L7.02 10.61L7.05 10.05L7.28 9.46Z",
        "fill": "#f08200"
      },
      {
        "type": "polygon",
        "d": "M10.6 8.17L13.4 8.17L13.95 9.27L11.86 9.27L11.75 9.9L12.86 9.9L13.44 10.9L11.61 10.9L11.46 11.6L12.86 11.6L13.56 12.72L9.88 12.72Z",
        "fill": "accent"
      },
      {
        "type": "polygon",
        "d": "M14.32 8.17L15.8 8.17L16.31 9.35L17.02 8.17L18.67 8.17L17.06 10.38L18.37 12.72L16.77 12.72L16.16 11.49L15.46 12.72L13.76 12.72L15.43 10.35Z",
        "fill": "accent"
      }
    ],
    "shiprocket": [
      {
        "type": "polygon",
        "d": "M10.37 6.36L13.97 8.41L14.3 8.43L14.6 8.31L14.78 8.09L14.81 7.79L14.73 7.58L14.55 7.41L9.87 4.71L9.57 4.68L9.32 4.79L9.18 4.97L9.12 5.3L9.04 5.37L8.42 5.06L8.38 4.94L8.53 4.54L8.96 4.1L9.53 3.91L10.06 3.96L15.04 6.81L15.3 7.05L15.48 7.34L15.57 7.65L15.58 8.09L15.37 8.6L15.05 8.93L9.39 12.22L9.2 12.48L9.13 12.76L9.18 13.03L9.36 13.24L9.62 13.33L9.92 13.26L14.6 10.56L14.77 10.34L14.81 10.04L14.73 9.83L14.48 9.61L14.45 9.5L15.01 9.13L15.12 9.13L15.23 9.22L15.46 9.56L15.56 9.85L15.59 10.24L15.4 10.81L15.03 11.19L10.26 13.96L9.92 14.07L9.57 14.1L9.14 13.99L8.76 13.75L8.49 13.39L8.38 13.06L8.35 6.43L8.27 6.13L8.05 5.91L7.77 5.8L7.53 5.82L7.31 5.98L7.19 6.23L7.18 11.67L7.25 11.94L7.49 12.16L7.72 12.21L8.07 12.09L8.18 12.13L8.21 12.82L8.13 12.9L7.82 12.97L7.22 12.88L6.8 12.61L6.52 12.2L6.41 11.67L6.41 6.2L6.54 5.75L6.87 5.32L7.36 5.07L7.79 5.03L8.36 5.19Z",
        "fill": "accent"
      },
      {
        "type": "polygon",
        "d": "M9.91 11.02L12.65 9.43L12.83 9.22L12.87 8.95L12.78 8.7L12.61 8.54L9.97 7.02L9.59 6.92L9.27 7.09L9.13 7.41L9.13 10.59L9.22 10.84L9.41 11.02L9.67 11.08Z",
        "fill": "truck"
      },
      {
        "type": "polygon",
        "d": "M9.84 9.97L9.93 10.14L10.13 10.14L11.85 9.15L11.93 9.03L11.91 8.89L10.13 7.83L9.95 7.82L9.84 7.98Z",
        "fill": "#18f040"
      }
    ],
    "first-line": [
      {
        "type": "polygon",
        "d": "M4.51 8.84L5.28 8.14L6.25 7.52L6.93 7.2L7.61 6.97L8.24 6.82L8.79 6.76L9.8 6.04L9.92 5.99L8.33 11.2L8.09 11.65L7.75 12.1L7.34 12.48L6.98 12.71L6.57 12.89L6.14 12.99L5.56 13.01L5.17 12.97L4.78 12.88L4.28 12.67L3.93 12.42L3.67 12.11L3.52 11.84L3.41 11.43L3.41 10.9L3.47 10.58L3.63 10.12L3.87 9.67L4.15 9.25Z",
        "fill": "accent"
      },
      {
        "type": "polygon",
        "d": "M5.41 8.5L4.96 9L4.62 9.57L4.42 10.2L4.44 10.73L4.57 11.05L4.69 11.21L4.88 11.37L5.08 11.48L5.3 11.54L5.55 11.55L5.81 11.5L6.1 11.37L6.46 11.11L6.74 10.83L6.95 10.54L8.15 7.87L7.26 7.84L8.54 6.92L7.86 7.06L6.88 7.46L6.2 7.86Z",
        "fill": "truck"
      },
      {
        "type": "polygon",
        "d": "M9.4 8.51L9.57 8.54L9.93 8.75L10.19 8.99L10.38 9.25L10.49 9.47L10.59 9.81L10.61 10.2L10.58 10.46L10.48 10.8L10.32 11.12L9.84 11.77L9.09 12.42L8.38 12.88L8.34 12.76L8.56 11.8L9.17 11.37L9.56 11.02L9.89 10.59L10.09 10.11L10.14 9.6L10.03 9.16L9.8 8.81L9.55 8.6Z",
        "fill": "accent"
      },
      {
        "type": "polygon",
        "d": "M10.31 6.76L11.27 6.76L12.28 10.07L13.31 6.76L14.24 6.76L12.72 11.73L11.77 11.73L10.79 8.41L10.54 9.09L10.19 8.69L9.82 8.42Z",
        "fill": "#f0832e"
      },
      {
        "type": "polygon",
        "d": "M14.94 6.76L18.6 6.76L18.34 7.59L15.7 7.59L15.51 8.15L14.5 8.15Z",
        "fill": "#f0832e"
      },
      {
        "type": "polygon",
        "d": "M14.34 8.72L17.91 8.72L17.69 9.54L15.11 9.54L14.89 10.22L13.86 10.22Z",
        "fill": "#f0832e"
      },
      {
        "type": "polygon",
        "d": "M13.65 10.91L17.55 10.91L17.31 11.73L13.39 11.73Z",
        "fill": "#f0832e"
      }
    ],
    "kun-express": [
      {
        "type": "polygon",
        "d": "M7.52 4.2L7.5 5.69L6.81 5.83L6.32 5.99L5.81 6.27L5.45 6.56L5.12 6.96L4.89 7.38L4.73 7.92L4.66 8.52L4.7 9.17L4.82 9.66L4.93 9.94L5.09 10.24L5.4 10.64L5.78 10.96L6.28 11.24L6.83 11.42L7.51 11.56L7.51 14.19L9.26 14.2L9.26 11.53L9.99 11.35L10.92 11L11.63 10.65L12.53 10.11L12.85 10.49L13.16 10.93L15.22 14.2L17.28 14.2L14.62 9.97L14.32 9.54L13.91 9.02L14.53 8.38L15.01 7.78L17.33 4.21L15.25 4.21L13.61 6.73L13.25 7.19L12.69 7.76L11.79 7.03L10.92 6.45L10.42 6.19L10.03 6.02L9.27 5.77L9.26 4.2Z",
        "fill": "accent"
      },
      {
        "type": "polygon",
        "d": "M9.27 7.6L9.27 9.73L9.84 9.55L10.29 9.36L10.79 9.11L11.25 8.84L10.74 8.43L10.21 8.07L9.66 7.76Z",
        "fill": "truck"
      },
      {
        "type": "polygon",
        "d": "M7.49 7.46L7.26 7.51L6.99 7.6L6.81 7.7L6.66 7.82L6.55 7.96L6.47 8.17L6.41 8.56L6.43 8.87L6.46 9.06L6.53 9.23L6.63 9.39L6.78 9.52L6.93 9.61L7.19 9.71L7.49 9.78Z",
        "fill": "truck"
      }
    ],
    "juxi-express": [
      {
        "type": "polygon",
        "d": "M6.86 5.92L6.49 6.66L6.24 7.45L6.11 8.27L6.11 9.1L6.23 9.92L6.47 10.71L6.83 11.46L7.3 12.14L7.86 12.75L8.51 13.27L9.23 13.68L10 13.98L10.81 14.16L11.64 14.22L12.46 14.15L13.27 13.96L14.04 13.65L14.75 13.23L15.4 12.71L15.95 12.1L14.58 11.31L13.92 11.7L13.21 11.99L12.47 12.17L11.7 12.23L10.94 12.17L10.19 12L9.48 11.72L8.82 11.33L8.23 10.84L7.72 10.27L7.3 9.63L6.98 8.93L6.78 8.2L6.69 7.43L6.71 6.67Z",
        "fill": "accent"
      },
      {
        "type": "polygon",
        "d": "M7.85 9.37L7.43 8.85L7.36 8.22L7.38 7.59L7.51 6.97L7.72 6.37L8.02 5.81L8.41 5.31L8.86 4.87L9.38 4.51L9.95 4.22L10.55 4.03L11.17 3.93L11.81 3.93L12.43 4.02L13.04 4.21L13.61 4.48L14.13 4.84L14.59 5.28L14.39 5.37L11.09 5.37L10.61 5.41L10.13 5.52L9.67 5.7L9.24 5.94L8.86 6.24L8.52 6.6L8.24 7L8.03 7.44L7.88 7.91L7.8 8.39L7.79 8.88Z",
        "fill": "#fbc624"
      },
      {
        "type": "polygon",
        "d": "M11.88 7.68L10.8 7.77L9.89 8.05L9.2 8.55L8.78 9.27L8.64 10.09L9.33 10.21L9.47 9.53L9.76 9.08L10.24 8.76L10.94 8.57L11.93 8.52Z",
        "fill": "#fbc624"
      },
      {
        "type": "polygon",
        "d": "M11.44 8.18L10.48 9.6L10.03 10.22L9.1 10.47L9.31 11.29L10.54 11.01L11.23 10.16L12.27 8.77Z",
        "fill": "#fbc624"
      },
      {
        "type": "polygon",
        "d": "M11.8 8.96L12.52 9.2L12.77 9.62L12.91 11.2L13.65 11.16L13.58 9.39L13.13 8.51L12.12 8.11Z",
        "fill": "#fbc624"
      },
      {
        "type": "polygon",
        "d": "M12.4 6.6L11.43 8.53L12.44 9.02L13.35 7.06Z",
        "fill": "#fbc624"
      },
      {
        "type": "circle",
        "cx": 12.44,
        "cy": 6.21,
        "r": 0.48,
        "fill": "accent"
      }
    ],
    "techlink": [
      {
        "type": "polygon",
        "d": "M7.72 5.32L14.92 9.52L15.4 9.65L15.87 9.52L16.22 9.18L16.35 8.7L16.22 8.23L15.88 7.88L8.68 3.68L8.2 3.55L7.73 3.68L7.38 4.02L7.25 4.5L7.38 4.97Z",
        "fill": "#f7bda4"
      },
      {
        "type": "polygon",
        "d": "M14.92 7.88L7.72 12.08L7.38 12.43L7.25 12.9L7.38 13.38L7.73 13.72L8.2 13.85L8.68 13.72L15.88 9.52L16.22 9.17L16.35 8.7L16.22 8.22L15.87 7.88L15.4 7.75Z",
        "fill": "accent"
      }
    ],
    "dayone": [
      {
        "type": "polygon",
        "d": "M7.1 4.8L9.8 4.8L9.8 11.29L12.9 11.29L13.92 11.14L14.55 10.69L14.91 10.1L15.03 9.43L14.98 8.64L14.71 7.96L14.14 7.49L13.24 7.2L10.34 7.2L10.34 4.8L14.26 4.8L15.75 5.25L16.87 5.93L17.55 6.72L17.96 7.73L18.1 8.97L18.1 9.65L17.93 10.67L17.55 11.57L16.87 12.47L15.84 13.15L14.48 13.6L6.68 13.6L6.68 8.16L6.13 8.48L5.34 8.73L3.9 8.86L3.9 6.49L4.89 6.15L5.79 5.82L6.45 5.36Z",
        "fill": "accent"
      }
    ],
    "shouwu": [
      {
        "type": "polygon",
        "d": "M6.2 6.19L6.76 6.01L7.43 5.86L8.15 5.7L9.02 5.55L10.61 5.34L11.82 5.24L12.8 5.21L14.29 5.29L14.85 5.34L15.63 5.45L16.45 5.6L16.78 5.7L15.78 5.81L14.24 6.06L13.03 6.37L12.08 6.68L10.9 7.14L9.95 7.6L8.84 8.22L7.89 8.84L7.02 9.45L6.4 9.99L8.38 7.3Z",
        "fill": "#0f74bc"
      },
      {
        "type": "polygon",
        "d": "M18.4 5.91L12.67 13.39L12.36 9.79L11.31 9.87L10.28 10.07L9.2 10.38L8.02 10.84L6.71 11.46L5.58 12.08L4.58 12.69L3.6 13.36L4.19 12.69L5.12 11.77L6.17 10.84L7.4 9.92L8.84 8.99L10.59 8.07L12.41 7.3L14.29 6.68L16.27 6.22L17.58 6.01Z",
        "fill": "accent"
      }
    ],
    "ywe": [
      {
        "type": "polygon",
        "d": "M7.13 7.02L9.98 7.01L11.13 8.72L14.26 5.74L14.25 7.24L11.8 9.62L11.77 10.29L13.01 9.14L13.16 10.33L15.63 7.98L15.64 9.31L13.11 11.8L12.96 10.61L10.71 12.77L10.64 10.8L7.84 13.58L6.36 13.6L10.96 8.9L8.28 8.87Z",
        "fill": "accent"
      },
      {
        "type": "circle",
        "cx": 11.5,
        "cy": 5.92,
        "r": 1.12,
        "fill": "accent"
      }
    ],
    "far-international": [
      {
        "type": "polygon",
        "d": "M6.13 6.74L9.49 6.74L8.95 7.82L7.06 7.82L4.89 12.26L3.43 12.26Z",
        "fill": "accent"
      },
      {
        "type": "polygon",
        "d": "M6.64 9.14L8.29 9.14L7.74 10.22L6.1 10.22Z",
        "fill": "#ed6d34"
      },
      {
        "type": "polygon",
        "d": "M10.39 6.74L13.06 6.74L13.06 8.9L11.74 8.9L11.74 7.82L11.14 7.82L9.22 12.26L7.63 12.26Z",
        "fill": "accent"
      },
      {
        "type": "polygon",
        "d": "M11.74 10.34L13.06 10.34L13.06 12.26L11.74 12.26Z",
        "fill": "accent"
      },
      {
        "type": "polygon",
        "d": "M14.63 6.74L18.1 6.74L18.57 7.1L18.57 8.06L18.34 9.26L17.38 10.22L17.85 12.26L16.53 12.26L16.06 10.22L10.3 10.22L10.78 9.14L16.77 9.14L17.08 8.66L17.13 7.82L15.82 7.82L15.69 8.9L14.12 8.9Z",
        "fill": "accent"
      },
      {
        "type": "polygon",
        "d": "M13.91 10.34L15.22 10.34L14.84 12.26L13.52 12.26Z",
        "fill": "accent"
      }
    ],
    "intel-valley": [
      {
        "type": "circle",
        "cx": 11,
        "cy": 9.25,
        "r": 5.2,
        "fill": "accent"
      },
      {
        "type": "circle",
        "cx": 11.97,
        "cy": 9.25,
        "r": 4.1,
        "fill": "truck"
      },
      {
        "type": "polygon",
        "d": "M9.83 6.49L13.88 6.49L14.15 6.57L14.33 6.77L14.38 7.03L14.29 7.29L12.05 10.33L14.54 10.33L14.54 11.83L9.79 11.83L9.52 11.76L9.34 11.56L9.29 11.29L9.38 11.04L11.69 7.89L9.83 7.89Z",
        "fill": "accent"
      }
    ],
    "pengyou": [
      {
        "type": "circle",
        "cx": 11,
        "cy": 9.5,
        "r": 5.3,
        "fill": "#0082ce"
      },
      {
        "type": "polygon",
        "d": "M13.42 5.11L12.68 5.56L12.24 6.16L11.76 5.58L11.05 5.36L8.83 5.4L7.79 5.28L7.61 5.43L7.57 5.58L7.79 5.87L8.39 6.32L10.16 6.75L10.76 6.99L11.07 7.36L11.17 7.8L11.07 8.54L10.67 9.28L9.57 10.33L7.87 11.36L8.09 11.42L8.98 11.02L9.17 11.06L7.84 11.8L7.94 11.87L8.39 11.75L8.49 11.8L7.73 12.24L7.94 12.27L8.68 12.01L10.61 11.11L11.94 10.18L12.68 9.4L13.14 8.69L13.46 7.8L13.61 5.58L13.8 5.13L13.72 5Z",
        "fill": "accent"
      },
      {
        "type": "polygon",
        "d": "M15.2 7.99L13.42 10.16L12.39 11.12L11.35 11.85L10.16 12.44L9.28 12.73L8.24 12.91L7.01 12.98L7.94 13.82L8.98 13.87L10.02 13.76L11.2 13.47L12.39 13.04L13.57 12.43L14.61 11.67L15.26 10.91L15.27 8.1Z",
        "fill": "accent"
      },
      {
        "type": "polygon",
        "d": "M14.46 12.5L13.13 13.32L12.09 13.78L11.2 14.07L9.15 14.47L9.57 14.6L10.46 14.54L12.39 14.05L13.42 13.59L14.43 12.98L14.54 12.84Z",
        "fill": "accent"
      },
      {
        "type": "polygon",
        "d": "M8.9 7.91L9.09 8.35L9.58 8.54L9.09 8.73L8.9 9.17L8.71 8.73L8.22 8.54L8.71 8.35Z",
        "fill": "accent"
      }
    ],
    "pin-ag": [
      {
        "type": "polygon",
        "d": "M17.55 7.35L16.44 12.61L5.84 12.61L5.28 12.56L4.84 12.42L4.52 12.19L4.33 11.88L4.25 11.51L4.29 11.07L5.07 7.52L5.25 7.14L5.53 6.83L5.92 6.6L6.44 6.46L7.13 6.41L15.27 6.41L13.85 7.35L7.89 7.35L7.34 7.41L7.14 7.5L6.86 7.77L6.8 7.96L6.17 11.08L6.15 11.28L6.22 11.44L6.34 11.55L6.73 11.67L13.83 11.69L14.37 11.62L14.73 11.41L14.84 11.26L15.37 8.79Z",
        "fill": "accent"
      },
      {
        "type": "polygon",
        "d": "M7.46 7.93L9.94 7.93L11.18 9.35L11.51 9.57L11.99 9.35L16.5 6.39L17.75 6.39L11.25 10.69L10.57 10.94L10.27 10.92L9.96 10.77L9.66 10.49Z",
        "fill": "#94c11f"
      }
    ],
    "tusk-logistics": [
      {
        "type": "polygon",
        "d": "M5.48 6.56L5.58 6.34L5.77 6.16L6 5.38L6.3 4.91L6.81 4.55L7.26 4.4L8.09 4.41L8.68 4.69L9 5.08L9.23 5.5L9.77 5.83L10.15 6.39L10.31 6.83L11.03 6.22L11.66 5.85L12.3 5.7L12.79 5.83L12.8 5.95L12.37 6.04L11.84 6.34L11.29 6.86L10.75 7.6L10.55 8.07L10.8 9.15L10.84 10.24L11.4 10.64L11.9 10.86L12.3 10.98L12.86 11.02L13.58 10.92L14.4 10.55L14.83 10.22L15.19 9.84L15.47 9.43L15.72 8.65L15.72 8.18L15.6 7.7L15.44 7.33L15.06 6.83L14.24 6.31L14.2 6.23L14.3 6.11L14.59 6.07L15.15 6.16L15.5 6.32L16.04 6.72L16.36 7.19L16.59 7.74L16.62 8.45L16.54 9.05L16.27 9.85L15.98 10.34L15.44 11.01L15.06 11.33L14.42 11.71L13.79 11.96L12.92 12.12L12.16 12.12L11.5 12.02L10.59 11.75L10.07 12.74L9.35 13.56L8.63 13.8L7.89 13.68L7.36 13.37L7.05 13.01L6.78 12.43L6.71 11.92L6.77 10.89L6.84 10.63L6.96 10.59L7.49 10.92L7.52 10.18L7.09 9.79L7.01 9.79L6.85 9.96L6.74 9.93L5.8 8.54L5.48 7.88L5.39 7.44L5.38 6.95Z",
        "fill": "accent"
      },
      {
        "type": "polygon",
        "d": "M15.67 6.76L15.98 7.09L16.21 7.52L16.3 7.87L16.33 8.38L16.23 9.05L16.03 9.65L15.45 10.57L15.05 10.96L14.5 11.35L13.59 11.73L12.86 11.87L12.28 11.9L11.65 11.78L11.28 11.62L11.02 11.39L10.86 11.1L10.8 10.82L10.85 10.65L11.82 11.12L12.39 11.25L12.88 11.27L13.56 11.13L14.13 10.91L14.61 10.63L15.18 10.12L15.48 9.75L15.78 9.14L15.88 8.69L15.88 8.12L15.7 7.47L15.51 7.14L15.3 6.86L14.66 6.29L15.1 6.39Z",
        "fill": "accent"
      },
      {
        "type": "polygon",
        "d": "M6.82 4.77L7.13 4.67L7.49 4.67L7.94 4.84L7.97 4.95L7.68 5.27L7.64 5.47L8.38 5.46L8.66 5.55L9 5.77L9.21 6.01L9.32 6.5L9.6 6.88L9.66 7.26L9.14 8.05L8.58 9.17L8.45 8.59L8.71 7.79L8.51 7.45L7.95 7.17L8.11 6.61L7.99 6.24L7.1 5.62L6.66 5.59L6.2 5.67L6.47 5.08Z",
        "fill": "truck"
      },
      {
        "type": "polygon",
        "d": "M11.39 6.2L11.41 6.28L10.86 6.9L10.44 7.56L8.69 10.93L8.23 11.43L7.92 11.44L7.79 11.26L7.69 10.84L7.69 10.31L7.76 10.03L7.93 9.93L8.13 10.02L8.19 10.15L8.14 10.71L8.19 10.79L10.11 7.41L10.75 6.66Z",
        "fill": "truck"
      },
      {
        "type": "polygon",
        "d": "M6.61 5.81L7.12 5.91L7.28 6.04L7.35 6.28L7.31 6.73L6.83 6.83L6.65 6.93L6.83 7.11L6.69 7.49L6.67 7.86L7.04 7.74L7.12 7.78L6.77 9.35L6.6 9.05L6.44 8.47L6.33 7.39L6 7.32L5.97 7.24L6.2 6.3L6.46 5.88Z",
        "fill": "truck"
      },
      {
        "type": "polygon",
        "d": "M6.93 10.85L7.06 10.93L7.15 11.12L7.11 11.92L7.17 12.26L7.29 12.47L7.52 12.64L7.93 12.68L8.31 12.62L8.37 12.64L8.35 12.74L8.53 12.72L8.92 12.51L9.51 11.98L9.34 12.41L8.99 12.89L8.55 13.18L8.2 13.26L7.63 13.19L7.25 12.97L7 12.63L6.84 12.12L6.82 11.43Z",
        "fill": "truck"
      },
      {
        "type": "polygon",
        "d": "M7.52 11.27L7.73 11.59L8.03 11.74L8.32 11.7L8.7 11.47L8.59 11.98L8.32 12.33L7.89 12.39L7.58 12.25L7.44 11.78Z",
        "fill": "truck"
      },
      {
        "type": "polygon",
        "d": "M6.54 6.22L7.02 6.19L7.1 6.29L7.13 6.53L6.63 6.47Z",
        "fill": "accent"
      }
    ],
    "eushipments": [
      {
        "type": "polygon",
        "d": "M4.75 8.41L5.3 7.83L6.08 7.29L6.92 6.96L7.82 6.8L9.01 6.75L18.7 6.75L18.36 7.36L17.84 7.88L17.18 8.23L16.58 8.38L7.77 8.41L6.92 8.48L6.11 8.65L5.27 9L4.6 9.55L4.05 10.21L3.3 11.4L3.56 10.67L3.97 9.77L4.38 8.99Z",
        "fill": "accent"
      },
      {
        "type": "polygon",
        "d": "M4.39 10.69L4.93 10.11L5.49 9.69L6.07 9.39L6.68 9.2L7.33 9.09L8.01 9.05L11.64 9.04L11.38 9.54L11 9.99L10.53 10.34L10.12 10.53L9.35 10.69L7.09 10.71L5.98 10.87L5.38 11.06L4.82 11.3L3.3 12.25Z",
        "fill": "#8dd7f7"
      },
      {
        "type": "polygon",
        "d": "M8.32 12.24L8.76 12.17L9.14 11.99L9.45 11.72L9.69 11.3L6.94 11.3L6.27 11.37L5.89 11.46L5.42 11.65L4.99 11.92L4.62 12.24Z",
        "fill": "#144880"
      }
    ],
    "timely-titan": [
      {
        "type": "polygon",
        "d": "M15.13 12.96L15.3 12.86L15.52 12.9L16.27 13.63L15.8 14.1L15.36 13.66L14.88 14.14L14.62 14.19L14.48 14.12L14.02 13.66L13.53 14.14L13.32 14.2L13.14 14.12L12.68 13.66L12.19 14.14L11.97 14.2L11.8 14.12L11.34 13.66L10.85 14.14L10.63 14.2L10.45 14.12L9.99 13.66L9.51 14.14L9.29 14.2L9.11 14.12L8.65 13.66L8.16 14.14L7.95 14.2L7.77 14.12L7.31 13.66L6.82 14.14L6.6 14.2L6.43 14.12L5.73 13.43L6.2 12.96L6.64 13.39L7.1 12.93L7.27 12.86L7.49 12.91L7.98 13.39L8.44 12.93L8.62 12.86L8.83 12.91L9.32 13.39L9.78 12.93L9.96 12.86L10.18 12.91L10.66 13.39L11.13 12.93L11.3 12.86L11.52 12.91L12.01 13.39L12.47 12.93L12.65 12.86L12.86 12.91L13.35 13.39L13.81 12.93L13.96 12.86L14.21 12.91L14.69 13.39Z",
        "fill": "accent"
      },
      {
        "type": "polygon",
        "d": "M6.87 12.76L6.7 12.85L6.48 12.82L5.73 12.09L6.2 11.61L6.64 12.04L7.1 11.59L7.24 11.52L7.49 11.57L7.98 12.04L8.31 11.71L8.31 10.17L7.21 8.52L7.16 8.34L7.21 8.15L7.31 8.05L8.31 7.71L8.31 6.14L8.99 6.14L8.99 5.47L10.33 5.47L10.33 4.8L11.67 4.8L11.67 5.47L13.01 5.47L13.01 6.14L13.69 6.14L13.69 7.71L14.65 8.03L14.77 8.12L14.84 8.31L14.79 8.52L13.69 10.17L13.69 11.71L13.89 11.54L14.12 11.53L14.69 12.04L15.18 11.57L15.43 11.52L15.57 11.59L16.27 12.29L15.8 12.76L15.36 12.32L14.9 12.78L14.73 12.86L14.51 12.8L14.02 12.32L13.56 12.78L13.38 12.86L13.17 12.8L12.68 12.32L12.22 12.78L12.04 12.86L11.82 12.8L11.34 12.32L10.87 12.78L10.7 12.86L10.48 12.8L9.99 12.32L9.53 12.78L9.35 12.86L9.14 12.8L8.65 12.32L8.19 12.78L8.04 12.85L7.79 12.8L7.31 12.32Z",
        "fill": "accent"
      },
      {
        "type": "polygon",
        "d": "M8.99 6.81L8.99 7.49L11 6.81L13.01 7.49L13.01 6.81L12.34 6.81L12.34 6.14L9.66 6.14L9.66 6.81Z",
        "fill": "truck"
      }
    ],
    "no-limit": [
      {
        "type": "polygon",
        "d": "M4.82 7.57L4.74 7.62L4.59 7.97L3.35 11.4L3.39 11.49L7.9 11.49L9.83 10.79L9.86 10.7L8.41 10.74L8.33 10.69L8.45 10.58L10.01 10.05L10.12 9.96L10.08 9.92L8.62 9.96L8.58 9.9L8.64 9.84L10.29 9.26L10.43 9.16L8.92 9.17L8.87 9.14L8.92 9.04L10.59 8.47L10.73 8.37L9.21 8.38L9.14 8.3L9.24 8.23L10.78 7.72L10.96 7.61L10.91 7.57Z",
        "fill": "accent"
      },
      {
        "type": "polygon",
        "d": "M5.72 8.36L6.06 8.35L6.16 8.43L6.25 9.69L6.31 9.63L6.64 8.42L6.76 8.35L7.05 8.35L7.13 8.4L7.13 8.49L6.37 10.64L6.27 10.73L5.99 10.73L5.9 10.65L5.8 9.37L5.76 9.31L5.31 10.62L5.2 10.73L4.92 10.73L4.86 10.66L4.88 10.51L5.56 8.57L5.63 8.41Z",
        "fill": "truck"
      },
      {
        "type": "polygon",
        "d": "M8.09 8.31L8.49 8.34L8.72 8.52L8.78 8.66L8.74 8.94L8.34 10.11L8.17 10.4L7.87 10.65L7.5 10.76L7.03 10.73L6.79 10.53L6.75 10.34L7.21 8.94L7.52 8.53L7.87 8.34Z",
        "fill": "truck"
      },
      {
        "type": "polygon",
        "d": "M8.06 8.64L7.86 8.75L7.71 9.06L7.31 10.23L7.32 10.35L7.42 10.41L7.55 10.41L7.73 10.26L8.23 8.84L8.22 8.72Z",
        "fill": "accent"
      },
      {
        "type": "polygon",
        "d": "M11.01 8.35L10.9 8.44L10.69 9.01L10.14 10.62L10.16 10.71L11.3 10.73L11.41 10.58L11.48 10.26L10.91 10.25L10.86 10.2L11.47 8.46L11.42 8.35Z",
        "fill": "accent"
      },
      {
        "type": "polygon",
        "d": "M12.42 8.35L12.28 8.48L11.86 9.69L11.54 10.65L11.59 10.73L12.02 10.73L12.11 10.65L12.89 8.43L12.84 8.35Z",
        "fill": "accent"
      },
      {
        "type": "polygon",
        "d": "M13.87 8.35L13.15 8.38L12.37 10.57L12.37 10.71L12.82 10.7L13.33 9.31L13.39 9.34L13.4 9.45L13.24 10.69L13.56 10.71L14.29 9.39L14.41 9.28L14.43 9.38L13.97 10.69L14.37 10.73L14.46 10.68L15.24 8.4L15.18 8.35L14.54 8.36L13.98 9.23L13.89 9.28L13.86 9.15L13.99 8.41Z",
        "fill": "accent"
      },
      {
        "type": "polygon",
        "d": "M15.58 8.35L15.46 8.51L14.72 10.64L14.75 10.71L15.22 10.73L15.34 10.54L16.07 8.46L16.02 8.35Z",
        "fill": "accent"
      },
      {
        "type": "polygon",
        "d": "M16.32 8.35L16.26 8.37L16.17 8.59L16.13 8.81L16.51 8.82L16.57 8.93L15.95 10.64L16.01 10.73L16.51 10.69L17.11 8.92L17.22 8.82L17.59 8.8L17.73 8.43L17.65 8.35Z",
        "fill": "accent"
      },
      {
        "type": "line",
        "d": "M10.2 11.69L2.9 11.69L4.51 7.31L19.1 7.31L17.51 11.69L10.2 11.69",
        "stroke": "accent",
        "strokeWidth": 0.24
      }
    ],
    "starlinks-global": [
      {
        "type": "polygon",
        "d": "M3.22 11L6.13 9.01L6.8 8.59L7.48 8.21L8.17 7.91L8.86 7.69L9.57 7.56L10.04 7.53L10.51 7.56L11.21 7.69L11.9 7.91L12.58 8.22L13.25 8.59L13.92 9.02L16.85 11.1L16.62 11.26L16.25 11.17L13.64 9.43L12.77 8.93L12.13 8.62L11.49 8.39L11.07 8.28L10.25 8.19L9.63 8.21L9.02 8.32L8.39 8.51L7.76 8.79L7.12 9.14L6.47 9.54L4.17 11.1L3.57 11.26Z",
        "fill": "accent"
      },
      {
        "type": "polygon",
        "d": "M10.08 4.91L10.25 6.02L11.36 5.85L10.36 6.36L10.87 7.36L10.08 6.56L9.29 7.36L9.8 6.36L8.8 5.85L9.9 6.02Z",
        "fill": "accent"
      },
      {
        "type": "polygon",
        "d": "M12.86 11.94L18.6 11.94L18.18 13.65L12.44 13.64Z",
        "fill": "accent"
      },
      {
        "type": "line",
        "d": "M13.85 12.57L13.78 12.5L13.7 12.46L13.61 12.45L13.52 12.47L13.44 12.52L13.37 12.59L13.33 12.69L13.32 12.79L13.33 12.89L13.37 12.99L13.44 13.06L13.52 13.11L13.61 13.13L13.7 13.12L13.78 13.08L13.85 13.01L13.85 12.83L13.66 12.83M14.42 12.3L14.42 13.25M15.4 12.9L15.38 12.99L15.33 13.06L15.24 13.11L15.15 13.13L15.05 13.11L14.97 13.06L14.92 12.99L14.9 12.9L14.92 12.81L14.97 12.73L15.05 12.68L15.15 12.67L15.24 12.68L15.33 12.73L15.38 12.81L15.4 12.9M15.88 12.3L15.88 13.25M15.88 12.67L16.12 12.67L16.19 12.67L16.24 12.7L16.29 12.73L16.33 12.78L16.36 12.84L16.37 12.9L16.36 12.96L16.33 13.02L16.29 13.06L16.24 13.1L16.19 13.12L16.12 13.13L15.88 13.13M17.18 12.9L17.16 12.99L17.12 13.06L17.06 13.11L16.98 13.13L16.9 13.11L16.84 13.06L16.8 12.99L16.78 12.9L16.8 12.81L16.84 12.73L16.9 12.68L16.98 12.67L17.06 12.68L17.12 12.73L17.16 12.81L17.18 12.9M17.2 12.55L17.2 13.25M17.7 12.3L17.7 13.25",
        "stroke": "truck",
        "strokeWidth": 0.24
      }
    ],
    "mhi": [
      {
        "type": "polygon",
        "d": "M4.09 8.13L4.14 8.02L4.23 7.93L4.43 7.87L6.04 7.87L6.18 7.9L6.28 7.97L6.35 8.07L6.38 8.22L6.39 10.55L6.46 10.72L6.59 10.86L6.86 10.94L7.12 10.86L7.25 10.72L7.32 10.55L7.33 8.22L7.36 8.07L7.43 7.97L7.53 7.9L7.67 7.87L9.32 7.87L9.47 7.9L9.61 8.02L9.66 8.22L9.66 10.46L9.7 10.64L9.88 10.86L10.14 10.94L10.4 10.86L10.58 10.64L10.61 10.46L10.61 8.19L10.58 7.9L10.42 7.53L10.27 7.33L10.01 7.11L9.79 7.01L9.34 6.92L7.6 6.93L7.21 7.01L6.86 7.21L6.59 7.04L6.26 6.94L4.41 6.92L4.11 6.96L3.74 7.11L3.48 7.33L3.33 7.53L3.22 7.75L3.14 8.15L3.14 10.55L3.27 10.8L3.52 10.93L3.7 10.93L3.87 10.86L4.01 10.72L4.08 10.55Z",
        "fill": "accent"
      },
      {
        "type": "polygon",
        "d": "M11.54 10.55L11.67 10.8L11.91 10.93L12.1 10.93L12.27 10.86L12.45 10.64L12.48 10.46L12.48 7.87L15.7 7.87L15.9 7.93L15.99 8.02L16.04 8.13L16.05 10.46L16.08 10.64L16.26 10.86L16.43 10.93L16.61 10.93L16.79 10.86L16.96 10.64L17 10.46L16.99 8.15L16.92 7.75L16.81 7.53L16.66 7.33L16.39 7.11L16.17 7.01L15.93 6.94L12.48 6.92L12.48 5.24L12.45 5.06L12.34 4.9L12.19 4.8L12.01 4.76L11.74 4.84L11.57 5.06L11.53 5.24Z",
        "fill": "accent"
      },
      {
        "type": "polygon",
        "d": "M17.87 10.46L17.91 10.64L18.01 10.8L18.26 10.93L18.44 10.93L18.61 10.86L18.74 10.72L18.82 10.55L18.82 7.4L18.69 7.15L18.44 7.02L18.26 7.02L18.09 7.1L17.95 7.23L17.88 7.4Z",
        "fill": "accent"
      },
      {
        "type": "polygon",
        "d": "M3.17 11.94L18.11 11.94L18.8 13.64L3.86 13.64Z",
        "fill": "accent"
      },
      {
        "type": "polygon",
        "d": "M3.17 11.94L8.58 11.94L7.2 12.79L9.11 13.64L3.86 13.64Z",
        "fill": "#e03126"
      },
      {
        "type": "polygon",
        "d": "M8.34 12.22L9.87 12.79L8.81 13.47L7.46 12.79Z",
        "fill": "truck"
      },
      {
        "type": "polygon",
        "d": "M9.11 11.94L12.5 11.94L10.93 12.58Z",
        "fill": "truck"
      },
      {
        "type": "polygon",
        "d": "M9.48 13.64L12.71 13.64L10.99 13.03Z",
        "fill": "truck"
      },
      {
        "type": "polygon",
        "d": "M13.29 12.1L13.82 13.51L12.02 12.87Z",
        "fill": "truck"
      },
      {
        "type": "polygon",
        "d": "M14.83 12.26L16.79 12.26L17.26 13.39L15.25 13.39Z",
        "fill": "truck"
      }
    ],
    "e-commerce-international": [
      {
        "type": "polygon",
        "d": "M6.4 6.27L6.4 10.45L6.45 10.63L6.59 10.77L10.2 12.62L10.43 12.59L11.26 12.16L11.39 12.04L11.45 11.87L11.38 11.64L11.16 11.5L10.98 11.51L10.63 11.69L10.63 8.32L13.44 6.87L13.44 7.75L13.52 7.93L13.69 8.05L13.88 8.05L14.05 7.96L14.15 7.76L14.15 6.28L14.04 6.03L10.33 4.12L10.11 4.15L6.59 5.97L6.45 6.1Z",
        "fill": "accent"
      },
      {
        "type": "polygon",
        "d": "M10.28 4.87L13.02 6.28L10.28 7.7L7.53 6.28Z",
        "fill": "truck"
      },
      {
        "type": "polygon",
        "d": "M7.11 6.87L9.92 8.32L9.92 11.69L7.11 10.23Z",
        "fill": "truck"
      },
      {
        "type": "polygon",
        "d": "M13.46 8.33L12.87 8.4L12.37 8.62L12.13 8.78L11.75 9.16L11.59 9.4L11.38 9.9L11.3 10.56L11.37 10.91L11.51 11.31L12.06 12.28L13.18 13.77L13.31 13.86L13.47 13.89L13.66 13.82L13.86 13.6L14.52 12.74L14.98 12.07L15.44 11.18L15.56 10.78L15.6 10.47L15.52 9.91L15.43 9.63L15.16 9.17L14.77 8.78L14.29 8.5L14.02 8.4Z",
        "fill": "accent"
      },
      {
        "type": "polygon",
        "d": "M13.45 12.98L12.87 12.21L12.4 11.49L12.11 10.9L12.01 10.48L12.13 9.92L12.43 9.46L12.89 9.15L13.45 9.04L14.01 9.15L14.47 9.46L14.78 9.92L14.89 10.48L14.79 10.9L14.49 11.5L14.04 12.2Z",
        "fill": "truck"
      }
    ],
    "boxtal": [
      {
        "type": "polygon",
        "d": "M8.43 4.3L14.36 4.3L14.66 4.38L14.88 4.6L14.96 4.89L14.88 5.19L14.66 5.41L14.36 5.49L8.43 5.49L8.13 5.41L7.91 5.19L7.83 4.89L7.91 4.6L8.13 4.38Z",
        "fill": "accent"
      },
      {
        "type": "polygon",
        "d": "M5.66 7.07L17.53 7.07L17.83 7.15L18.05 7.37L18.12 7.66L18.05 7.96L17.83 8.18L17.53 8.26L5.66 8.26L5.36 8.18L5.14 7.96L5.06 7.66L5.14 7.37L5.36 7.15Z",
        "fill": "#a42636"
      },
      {
        "type": "polygon",
        "d": "M4.47 9.84L12.39 9.84L12.68 9.92L12.9 10.14L12.98 10.44L12.9 10.73L12.68 10.95L12.39 11.03L4.47 11.03L4.17 10.95L3.95 10.73L3.88 10.44L3.95 10.14L4.17 9.92Z",
        "fill": "accent"
      },
      {
        "type": "polygon",
        "d": "M8.82 12.61L16.74 12.61L17.04 12.69L17.25 12.91L17.33 13.21L17.25 13.5L17.04 13.72L16.74 13.8L8.82 13.8L8.53 13.72L8.31 13.5L8.23 13.21L8.31 12.91L8.53 12.69Z",
        "fill": "accent"
      }
    ],
    "huaya-express": [
      {
        "type": "polygon",
        "d": "M10.78 4.9L9.78 5.08L9.34 5.32L8.94 5.64L8.22 6.54L6.64 8.91L5.35 10.72L5.14 10.92L4.9 11.02L5.26 12.46L5.52 12.34L6.18 12.22L6.78 11.92L7.44 11.22L8.07 10.18L8.38 9.88L8.59 9.85L8.88 10.18L9.52 11.34L9.96 11.92L10.42 12.18L11.04 12.3L11.22 12.46L11.2 12.66L10.42 13.74L10.38 14.02L10.5 14.1L11.44 14.1L12.36 13.9L12.94 13.56L13.38 13.12L16.42 8.7L16.84 8.16L16.92 8.1L17.08 8.1L16.8 6.54L16.68 6.54L16.44 6.7L15.84 6.78L15.36 7.02L15.1 7.26L14.58 7.86L13.68 9.1L13.42 9.34L13.24 9.3L13.06 9.12L12.82 8.74L12.48 8.04L12.1 7.44L11.74 7.08L11.2 6.78L10.98 6.72L10.86 6.6L10.86 6.4L11.58 5.38L11.68 5.04L11.52 4.92Z",
        "fill": "accent"
      },
      {
        "type": "polygon",
        "d": "M9.94 8.14L9.7 8.38L9.66 8.56L9.72 8.68L11.76 10.96L12 10.92L12.22 10.62L12.16 10.38L10.36 8.35L10.12 8.14Z",
        "fill": "#fac906"
      }
    ],
    "quick-rabbit": [
      {
        "type": "polygon",
        "d": "M9.48 3.95L9.34 4.55L9.32 5.12L9.37 5.68L9.52 6.32L9.8 7.02L10.24 7.82L10.85 8.65L11.34 9.19L11.12 9.44L10.68 9.84L9.96 9.2L9.26 8.71L8.38 8.24L7.54 7.95L6.9 7.84L6.31 7.82L5.44 7.99L6.02 8.61L6.52 9.01L7.11 9.38L7.77 9.69L8.46 9.89L9.15 10L9.85 10.02L10.63 9.91L10.01 10.83L9.87 11.18L9.85 11.6L10.09 12.34L10.79 13.72L11.46 14.7L11.68 14.89L12.02 15.04L12.39 15.05L12.71 14.99L13.72 14.5L16 12.24L16.49 11.18L16.56 10.78L16.52 10.46L16.33 10.1L15.61 9.53L14.27 8.79L13.3 8.4L12.81 8.35L12.53 8.42L11.99 8.72L11.43 9.15L11.51 8.43L11.51 7.78L11.41 7.06L11.22 6.37L10.89 5.63L10.46 4.95L10.05 4.46Z",
        "fill": "accent"
      },
      {
        "type": "polygon",
        "d": "M13.68 11.49L13.8 11.51L13.91 11.69L13.9 12.24L14.51 12.92L14.55 13.07L14.38 12.98L13.75 12.4L13.19 12.42L13 12.29L12.99 12.14L13.19 11.81L13.5 11.56Z",
        "fill": "truck"
      }
    ],
    "dealersend": [
      {
        "type": "polygon",
        "d": "M11.64 3.44L11.4 3.52L11.25 3.68L10.8 4.98L9.59 4.98L9.4 5.03L9.2 4.98L8.74 5L8.55 5.1L8.41 5.28L8.37 5.56L8.42 5.72L7.71 5.72L7.52 5.77L7.32 5.72L6.88 5.73L6.66 5.85L6.51 6.07L6.49 6.3L6.54 6.46L6.69 6.63L6.89 6.72L7.31 6.73L7.52 6.68L7.71 6.73L9.5 6.73L9.76 6.65L9.93 6.46L9.99 6.29L9.94 5.99L10.45 6L10.08 7.08L6.6 7.1L6.35 7.19L6.18 7.43L6.17 7.68L6.33 7.92L9.1 10.09L9 10.41L7.71 10.41L7.53 10.45L7.35 10.41L6.98 10.41L6.76 10.47L6.61 10.6L6.51 10.84L6.54 11.1L6.66 11.27L6.47 11.32L5.92 11.28L5.72 11.33L5.58 11.44L5.47 11.61L5.47 11.95L5.61 12.16L5.85 12.27L6.29 12.28L6.47 12.24L6.65 12.28L8.42 12.28L8.08 13.43L8.14 13.73L8.25 13.86L8.42 13.95L8.61 13.95L8.79 13.88L11.66 11.93L14.56 13.89L14.79 13.94L15.03 13.86L15.2 13.66L15.22 13.36L14.21 10.07L16.98 7.93L17.14 7.68L17.15 7.49L17.09 7.32L16.97 7.19L16.78 7.11L13.24 7.08L12.09 3.73L11.9 3.51Z",
        "fill": "accent"
      },
      {
        "type": "polygon",
        "d": "M11.64 3.79L11.55 3.87L11.04 5.33L9.59 5.33L9.46 5.44L9.49 5.59L9.58 5.64L11.44 5.64L11.55 5.74L11.54 5.87L11.44 5.95L10.83 5.97L10.32 7.43L6.6 7.45L6.53 7.49L6.51 7.58L8.38 9.07L9.01 8.53L8.39 8.68L8.37 8.62L8.42 8.57L9.33 8.17L10.24 7.95L11.12 7.9L11.77 7.97L12.21 8.08L12.32 8.19L12.72 8.42L13.21 8.88L13.48 9.43L13.52 9.71L13.5 10.05L13.32 10.6L12.97 10.13L12.69 9.95L12.46 9.87L12.22 9.86L11.89 9.92L11.58 10.1L11.49 10.18L11.51 10.23L11.78 10.73L12.02 10.98L13.27 11.84L13.86 12.36L14.15 12.82L14.27 13.28L14.72 13.59L14.81 13.59L14.87 13.53L14.87 13.41L13.81 9.95L16.74 7.67L16.8 7.53L16.71 7.45L13 7.43L11.76 3.86Z",
        "fill": "#1f3367"
      },
      {
        "type": "polygon",
        "d": "M7.71 6.07L7.57 6.19L7.59 6.3L7.71 6.38L9.5 6.38L9.58 6.35L9.64 6.25L9.61 6.13L9.5 6.07Z",
        "fill": "#1f3367"
      },
      {
        "type": "polygon",
        "d": "M6.66 11.63L6.56 11.69L6.53 11.79L6.56 11.87L6.65 11.93L8.47 11.93L8.57 11.87L8.6 11.79L8.55 11.67L8.47 11.63Z",
        "fill": "#1f3367"
      },
      {
        "type": "polygon",
        "d": "M8.85 5.33L8.72 5.45L8.79 5.62L9.21 5.64L9.32 5.56L9.33 5.44L9.23 5.34Z",
        "fill": "#1f3367"
      },
      {
        "type": "polygon",
        "d": "M6.98 10.76L6.86 10.88L6.88 10.99L6.97 11.06L7.36 11.06L7.47 10.96L7.47 10.86L7.37 10.76Z",
        "fill": "#1f3367"
      },
      {
        "type": "polygon",
        "d": "M6.98 6.07L6.89 6.1L6.84 6.19L6.85 6.28L6.92 6.36L7.31 6.38L7.45 6.27L7.44 6.16L7.37 6.08Z",
        "fill": "#1f3367"
      },
      {
        "type": "polygon",
        "d": "M5.92 11.63L5.8 11.74L5.81 11.86L5.88 11.92L6.29 11.93L6.4 11.84L6.39 11.71L6.31 11.63Z",
        "fill": "#1f3367"
      },
      {
        "type": "polygon",
        "d": "M10.85 7.99L9.86 8.12L8.9 8.44L9.21 8.42L9.26 8.48L8.78 8.82L8.46 9.12L9.51 9.95L9.26 10.76L7.71 10.76L7.6 10.86L7.61 10.99L7.73 11.07L9.87 11.07L9.99 11.2L9.95 11.32L9.85 11.37L9.08 11.38L8.43 13.47L8.44 13.56L8.51 13.61L8.6 13.59L11.65 11.51L14.17 13.21L14.04 12.8L13.77 12.4L13.14 11.86L12.37 11.36L11.87 10.96L11.6 10.63L11.35 10.1L11.21 9.45L11.31 9.34L11.53 9.29L11.71 9.18L11.41 9.15L11.18 9.03L11.03 8.82L10.98 8.51L11.06 8.48L11.71 8.77L11.98 8.84L12.08 8.79L12.17 8.62L12.24 8.32L12.23 8.21L11.57 8.03Z",
        "fill": "truck"
      }
    ],
    "pactic": [
      {
        "type": "polygon",
        "d": "M14.22 3.95L7.65 3.95L7.3 4.01L6.98 4.14L6.69 4.32L6.37 4.64L6.19 4.93L6.1 5.14L6 5.6L6 12.3L6.06 12.65L6.19 12.97L6.37 13.26L6.69 13.58L6.98 13.76L7.19 13.85L7.65 13.95L14.35 13.95L14.7 13.89L15.02 13.76L15.31 13.58L15.63 13.26L15.81 12.97L15.9 12.76L16 12.3L15.98 5.49L15.94 5.25L15.81 4.93L15.63 4.64L15.4 4.39L15.12 4.19L14.81 4.05L14.46 3.97Z",
        "fill": "accent"
      },
      {
        "type": "polygon",
        "d": "M15.17 12.17L15.14 12.43L15.04 12.66L14.85 12.89L14.65 13.03L14.29 13.13L13.15 13.13L13.34 12.72L13.42 12.26L13.42 8.18L13.36 7.83L13.24 7.5L13.05 7.21L12.82 6.97L12.54 6.77L12.23 6.62L11.89 6.54L11.65 6.52L7.69 6.53L7.23 6.61L6.82 6.8L6.83 5.6L6.9 5.35L7.06 5.1L7.24 4.93L7.4 4.85L7.78 4.77L14.22 4.77L14.53 4.82L14.85 5.01L15.07 5.3L15.17 5.66Z",
        "fill": "truck"
      },
      {
        "type": "polygon",
        "d": "M10.55 13.12L10.75 12.68L10.83 12.17L10.81 10.66L10.73 10.31L10.59 10L10.39 9.72L10.04 9.42L9.64 9.22L9.29 9.14L7.6 9.13L7.19 9.22L6.82 9.4L6.82 8.3L6.86 8.05L7.02 7.72L7.29 7.48L7.52 7.38L7.78 7.35L11.72 7.35L11.9 7.38L12.13 7.48L12.32 7.63L12.47 7.82L12.57 8.05L12.6 8.3L12.6 12.17L12.55 12.49L12.47 12.66L12.32 12.85L12.13 13L11.96 13.08L11.72 13.13Z",
        "fill": "truck"
      },
      {
        "type": "polygon",
        "d": "M7.78 13.12L7.46 13.07L7.19 12.92L6.98 12.7L6.86 12.42L6.82 12.17L6.82 10.83L6.86 10.64L6.95 10.42L7.06 10.27L7.24 10.11L7.46 10L7.65 9.95L9.11 9.94L9.3 9.98L9.53 10.07L9.68 10.18L9.84 10.36L9.95 10.58L9.99 10.77L10 12.24L9.97 12.42L9.87 12.65L9.76 12.8L9.58 12.96L9.24 13.1Z",
        "fill": "truck"
      }
    ],
    "express-one-bg": [
      {
        "type": "polygon",
        "d": "M18.54 5.04L18.37 4.84L18.13 4.74L16.2 4.74L14.88 6.64L13.8 8.04L12.61 9.43L11.34 10.74L10.43 11.53L10.02 11.82L9.67 12.03L9.23 12.23L8.84 12.36L8.43 12.43L8.01 12.46L7.59 12.43L7.17 12.35L6.76 12.21L6.37 12.03L6.02 11.8L5.69 11.52L5.4 11.21L5.15 10.86L4.95 10.48L4.8 10.08L4.7 9.66L4.66 9.24L4.67 8.81L4.73 8.39L4.85 7.98L5.01 7.58L5.23 7.22L5.49 6.88L5.79 6.58L6.13 6.31L6.5 6.1L6.89 5.93L7.31 5.81L7.73 5.75L8.16 5.74L8.58 5.79L9 5.89L9.4 6.04L9.77 6.24L10.12 6.49L10.44 6.77L10.71 7.1L11.46 6.06L11.05 5.65L10.6 5.3L10.11 5.01L9.59 4.78L9.04 4.62L8.47 4.53L7.9 4.5L7.33 4.55L6.77 4.67L6.23 4.86L5.72 5.12L5.24 5.43L4.81 5.81L4.42 6.23L4.09 6.7L3.82 7.21L3.62 7.74L3.49 8.3L3.42 8.87L3.43 9.44L3.51 10.01L3.66 10.56L3.87 11.09L4.15 11.59L4.49 12.05L4.88 12.47L5.33 12.83L5.81 13.13L6.33 13.38L6.87 13.55L7.44 13.66L8.01 13.7L8.51 13.67L9 13.61L9.48 13.51L10.16 13.3L11.02 12.92L12.01 12.33L12.9 11.65L13.83 10.8L15.34 9.2L18.43 5.69L18.52 5.55L18.57 5.37L18.57 5.21Z",
        "fill": "accent"
      },
      {
        "type": "polygon",
        "d": "M9.91 9.5L9.45 10.07L9.03 10.45L8.55 10.73L8.08 10.83L7.6 10.78L7.37 10.71L7.09 10.57L6.84 10.37L6.67 10.2L6.49 9.94L6.39 9.72L6.31 9.41L6.28 9.1L6.31 8.76L6.39 8.48L6.52 8.21L6.69 7.97L6.94 7.74L7.2 7.57L7.59 7.42L7.9 7.37L8.22 7.37L8.62 7.47L8.99 7.67L9.24 7.87L9.5 8.19L9.67 8.57L10.48 7.44L10.2 7.07L9.92 6.81L9.61 6.59L9.28 6.4L8.93 6.26L8.56 6.17L8.18 6.13L7.8 6.13L7.42 6.18L7.05 6.28L6.7 6.42L6.37 6.61L6.07 6.84L5.8 7.11L5.56 7.41L5.37 7.73L5.22 8.08L5.11 8.45L5.05 8.82L5.04 9.2L5.08 9.58L5.16 9.95L5.3 10.31L5.47 10.65L5.69 10.96L5.95 11.24L6.24 11.48L6.56 11.69L6.9 11.86L7.26 11.98L7.63 12.05L8.14 12.07L8.54 12.03L8.98 11.92L9.64 11.61L10.3 11.14L11.09 10.44L11.98 9.54L12.94 8.47L13.84 7.37L14.63 6.32L15.74 4.74L13.33 4.74Z",
        "fill": "accent"
      }
    ],
    "logisimple": [
      {
        "type": "polygon",
        "d": "M11.31 4.05L7.5 4.05L7.5 6.66L11.25 6.66L11.25 5.76L13.13 7.42L11.26 9.07L11.26 8.17L7.5 8.17L7.5 13.85L9.6 13.85L9.62 10.67L11.31 10.67L11.97 10.61L12.58 10.42L13.12 10.13L13.59 9.74L13.97 9.26L14.26 8.7L14.44 8.06L14.5 7.36L14.44 6.66L14.26 6.02L13.97 5.46L13.59 4.98L13.12 4.59L12.58 4.29L11.97 4.11Z",
        "fill": "accent"
      }
    ],
    "viadireta": [
      {
        "type": "polygon",
        "d": "M18.49 9.04L18.49 8.96L15.56 4.46L15.49 4.43L12.76 4.43L12.7 4.46L8.02 11.63L6.17 8.96L6.11 8.93L3.57 8.93L3.51 8.97L3.51 9.04L6.44 13.54L6.51 13.57L9.23 13.57L9.29 13.54L14.13 6.59L15.81 9L14.18 11.34L11.35 11.34L11.29 11.37L9.84 13.46L9.84 13.53L9.9 13.57L15.49 13.57L15.56 13.54Z",
        "fill": "accent"
      }
    ],
    "meso-global": [
      {
        "type": "polygon",
        "d": "M10.96 4.16L10.49 4.07L9.97 4.02L9.49 4.03L9.01 4.08L8.54 4.17L8.09 4.32L7.61 4.52L7.19 4.75L6.79 5.02L6.42 5.32L6.08 5.66L5.76 6.07L5.49 6.47L5.25 6.93L5.07 7.38L4.94 7.84L4.85 8.31L4.8 8.83L4.81 9.3L4.86 9.78L4.96 10.25L5.1 10.71L5.31 11.19L5.54 11.61L5.83 12.04L6.14 12.4L6.49 12.73L6.86 13.03L7.26 13.3L7.68 13.52L8.13 13.7L8.63 13.85L9.23 13.95L9.79 13.98L10.36 13.95L10.96 13.84L10.5 13.7L10.05 13.52L9.63 13.29L9.23 13.02L8.83 12.69L8.49 12.35L8.18 11.98L7.91 11.58L7.69 11.16L7.5 10.71L7.36 10.25L7.26 9.78L7.21 9.26L7.2 8.78L7.25 8.3L7.34 7.83L7.55 7.16L7.83 6.57L8.21 5.99L8.64 5.49L9.13 5.06L9.71 4.67L10.33 4.36Z",
        "fill": "accent"
      },
      {
        "type": "polygon",
        "d": "M11.18 7.62L10.29 7.65L10.22 7.72L10.2 8.39L10.13 8.59L10.13 8.67L10.19 8.71L10.32 8.64L10.46 8.31L10.79 7.9L11.09 7.79L11.42 7.78L11.52 7.79L11.58 7.89L11.46 8.06L10.13 11.01L10.2 11.06L12.6 11.06L12.67 10.99L12.68 10.15L12.72 10.03L12.68 9.9L12.58 9.93L12.54 10.13L12.35 10.46L11.98 10.8L11.55 10.94L11.28 10.94L11.23 10.83L11.42 10.49L12.67 7.72L12.6 7.65Z",
        "fill": "accent"
      },
      {
        "type": "line",
        "d": "M10.96 4.16L11.38 4.28L11.74 4.42L12.1 4.59L12.47 4.8L12.79 5.03L13.13 5.31L13.41 5.58L13.69 5.91L13.93 6.23L14.15 6.6L14.33 6.95L14.49 7.35L14.61 7.77L14.7 8.15L14.75 8.54L14.77 8.98L14.75 9.37L14.7 9.8L14.61 10.23L14.5 10.6L14.36 10.97L14.17 11.36L13.95 11.74L13.69 12.09L13.41 12.42L13.13 12.69L12.79 12.97L12.47 13.2L12.1 13.41L11.74 13.58L11.33 13.74L10.96 13.84M10.96 4.16L11.51 4.05L12.08 4L12.65 4.02L13.21 4.1L13.76 4.25L14.29 4.46L14.79 4.72L15.26 5.04L15.68 5.42L16.07 5.83L16.4 6.29L16.68 6.79L16.9 7.31L17.06 7.85L17.16 8.41L17.2 8.98L17.17 9.54L17.07 10.1L16.9 10.69L16.68 11.21L16.4 11.71L16.07 12.17L15.68 12.58L15.26 12.96L14.79 13.28L14.29 13.54L13.76 13.75L13.21 13.9L12.65 13.98L12.08 14L11.51 13.95L10.96 13.84",
        "stroke": "accent",
        "strokeWidth": 0.24
      }
    ],
    "jifan": [
      {
        "type": "polygon",
        "d": "M11 4.05L6.28 6.78L6.28 12.23L11 14.95L15.72 12.23L15.72 6.78Z",
        "fill": "accent"
      },
      {
        "type": "line",
        "d": "M8.55 7.45L8.55 10.98L13.45 13.8M11.06 6.24L11.06 9.44L13.68 10.95L13.68 5.2",
        "stroke": "truck",
        "strokeWidth": 0.8
      }
    ],
    "youbang-express": [
      {
        "type": "polygon",
        "d": "M11 4.95L11.8 4.99L12.58 5.11L13.33 5.3L14.05 5.56L14.71 5.89L15.31 6.28L15.84 6.73L16.28 7.22L16.64 7.76L16.89 8.32L17.05 8.91L17.1 9.5L17.05 10.09L16.89 10.68L16.64 11.24L16.28 11.77L15.84 12.27L15.31 12.72L14.71 13.11L14.05 13.44L13.33 13.7L12.58 13.89L11.8 14.01L11 14.05L10.2 14.01L9.42 13.89L8.67 13.7L7.95 13.44L7.29 13.11L6.69 12.72L6.16 12.27L5.72 11.78L5.36 11.24L5.11 10.68L4.95 10.09L4.9 9.5L4.95 8.91L5.11 8.32L5.36 7.76L5.72 7.22L6.16 6.73L6.69 6.28L7.29 5.89L7.95 5.56L8.67 5.3L9.42 5.11L10.2 4.99Z",
        "fill": "accent"
      },
      {
        "type": "polygon",
        "d": "M11 5.65L11.7 5.68L12.4 5.78L13.07 5.94L13.7 6.17L14.29 6.45L14.82 6.78L15.28 7.16L15.68 7.57L15.99 8.03L16.22 8.5L16.35 9L16.4 9.5L16.35 10L16.22 10.5L15.99 10.97L15.68 11.42L15.28 11.84L14.82 12.22L14.29 12.55L13.7 12.83L13.07 13.06L12.4 13.22L11.7 13.32L11 13.35L10.3 13.32L9.6 13.22L8.93 13.06L8.3 12.83L7.71 12.55L7.18 12.22L6.72 11.84L6.32 11.43L6.01 10.97L5.78 10.5L5.65 10L5.6 9.5L5.65 9L5.78 8.5L6.01 8.03L6.32 7.57L6.72 7.16L7.18 6.78L7.71 6.45L8.3 6.17L8.93 5.94L9.6 5.78L10.3 5.68Z",
        "fill": "truck"
      },
      {
        "type": "line",
        "d": "M11 5.3L11 13.7M11 5.3L11.43 5.34L11.85 5.44L12.26 5.62L12.65 5.86L13.01 6.17L13.33 6.53L13.62 6.94L13.86 7.4L14.05 7.89L14.19 8.41L14.27 8.95L14.3 9.5L14.27 10.05L14.19 10.59L14.05 11.11L13.86 11.6L13.62 12.06L13.33 12.47L13.01 12.83L12.65 13.14L12.26 13.38L11.85 13.56L11.43 13.66L11 13.7L10.57 13.66L10.15 13.56L9.74 13.38L9.35 13.14L8.99 12.83L8.67 12.47L8.38 12.06L8.14 11.6L7.95 11.11L7.81 10.59L7.73 10.05L7.7 9.5L7.73 8.95L7.81 8.41L7.95 7.89L8.14 7.4L8.38 6.94L8.67 6.53L8.99 6.17L9.35 5.86L9.74 5.62L10.15 5.44L10.57 5.34L11 5.3M6.02 7.4L6.64 7.27L7.26 7.16L7.89 7.06L8.51 6.99L9.13 6.93L9.75 6.88L10.38 6.86L11 6.85L11.62 6.86L12.25 6.88L12.87 6.93L13.49 6.99L14.11 7.06L14.73 7.16L15.36 7.27L15.98 7.4M6.02 11.6L6.64 11.73L7.26 11.84L7.89 11.94L8.51 12.01L9.13 12.07L9.75 12.12L10.38 12.14L11 12.15L11.62 12.14L12.25 12.12L12.87 12.07L13.49 12.01L14.11 11.94L14.73 11.84L15.36 11.73L15.98 11.6",
        "stroke": "accent",
        "strokeWidth": 0.45
      }
    ],
    "fastbox": [
      {
        "type": "polygon",
        "d": "M11 4.05L15.72 6.77L15.72 12.22L11 14.95L6.28 12.23L6.28 6.78Z",
        "fill": "accent"
      },
      {
        "type": "polygon",
        "d": "M11 6.16L13.9 7.83L13.9 11.17L11 12.84L8.1 11.17L8.1 7.83Z",
        "fill": "truck"
      },
      {
        "type": "polygon",
        "d": "M9.22 7.18L9.22 7.38L11.65 8.85L9.9 9.94L8.1 8.92L8.1 7.83Z",
        "fill": "accent"
      },
      {
        "type": "line",
        "d": "M15.94 6.65L13.68 7.95M6.06 12.35L8.32 11.05",
        "stroke": "truck",
        "strokeWidth": 0.35
      }
    ],
    "ydh": [
      {
        "type": "line",
        "d": "M5.26 7.7L3.76 11.3L5.19 11.3M5.88 7.7L7.18 9.61M8.48 7.7L7.18 9.61M7.18 9.35L7.18 11.3M9.84 7.7L9.84 11.3M9.84 7.7L10.79 7.7L11.58 7.95L12.16 8.61L12.37 9.51L12.16 10.4L11.58 11.06L10.79 11.3L9.84 11.3M13.82 7.7L13.82 11.3M16.12 7.7L16.12 11.3M13.82 9.49L16.12 9.49M16.74 7.7L18.24 7.7L16.79 11.3",
        "stroke": "accent",
        "strokeWidth": 0.95
      }
    ],
    "takesend": [
      {
        "type": "line",
        "d": "M5.63 5.38L7.58 5.38M6.6 5.38L5.99 8.43M7.56 8.43L9.51 5.12M9.3 5.12L9.94 8.43M8.25 7.4L9.66 7.4M11.97 5.38L11.36 8.43M13.86 5.38L11.6 7.21M12.32 6.65L13.31 8.43M16.98 5.38L15.27 5.38L14.66 8.43L16.37 8.43M14.97 6.9L16.37 6.9M7.17 10.55L6.77 10.21L6.16 10.21L5.64 10.55L5.42 11.06L5.64 11.51L6.18 11.69L6.72 11.87L6.95 12.32L6.74 12.83L6.19 13.17L5.56 13.17L5.15 12.83M10.54 10.17L8.83 10.17L8.22 13.22L9.93 13.22M8.53 11.69L9.93 11.69M11.52 10.17L10.91 13.22M11.46 10.47L12.87 12.92M13.42 10.17L12.81 13.22M14.87 10.17L14.26 13.22M14.87 10.17L15.67 10.17L16.3 10.38L16.67 10.94L16.7 11.7L16.37 12.46L15.77 13.02L15.06 13.22L14.26 13.22",
        "stroke": "accent",
        "strokeWidth": 0.95
      }
    ],
    "flyt-express": [
      {
        "type": "polygon",
        "d": "M7.85 5.83L7.74 6.52L7.71 7.03L7.77 7.71L7.92 8.21L8.08 8.55L8.38 9.07L9.43 10.43L9.54 10.6L9.66 10.94L9.85 11.07L10.04 10.94L9.92 10.6L8.9 8.89L8.18 7.37L8.1 6.69L8.22 5.83L8.21 5.71L8.11 5.66L7.96 5.66L7.86 5.71Z",
        "fill": "#ef8300"
      },
      {
        "type": "polygon",
        "d": "M7.51 8.89L7.59 9.23L7.86 9.75L8.24 10.25L8.74 10.77L8.91 11.11L10.08 11.43L9.33 11.11L9.12 10.77L8.62 10.25L8.35 9.91L8.05 9.41L7.97 9.23L7.87 8.77L7.77 8.72L7.63 8.72L7.53 8.77Z",
        "fill": "accent"
      },
      {
        "type": "polygon",
        "d": "M9.42 4.3L9.12 4.81L9.01 5.15L8.96 5.5L8.98 5.83L9.4 7.54L10.17 10.09L10.2 10.43L10.4 10.56L10.59 10.43L10.51 9.91L10.44 8.89L10.14 6.35L10.11 5.15L10.18 4.64L10.09 4.18L9.9 4.13L9.63 4.13L9.44 4.18Z",
        "fill": "accent"
      },
      {
        "type": "polygon",
        "d": "M11.69 4.13L11.62 4.3L11.49 4.47L11.22 7.2L11.02 10.09L11.02 10.43L11.17 10.56L11.32 10.43L11.44 9.91L12.29 7.2L12.67 5.67L12.73 5.15L12.71 4.64L12.63 4.47L12.35 4.13L12.33 4.01L12.15 3.96L11.89 3.96L11.71 4.01Z",
        "fill": "#ef8300"
      },
      {
        "type": "polygon",
        "d": "M13.81 5.15L13.75 5.5L13.74 6.17L13.66 6.52L12.31 9.41L11.88 10.09L11.78 10.43L12.07 10.56L12.35 10.43L12.52 10.09L13.8 8.38L14.22 7.71L14.46 7.2L14.55 6.69L14.54 6.17L14.46 5.83L14.18 5.33L14.06 5L13.96 4.97L13.85 5Z",
        "fill": "accent"
      },
      {
        "type": "polygon",
        "d": "M14.77 7.54L14.68 8.04L14.52 8.55L14.24 9.07L13.51 9.91L12.53 10.77L12.33 11.11L12.61 11.24L12.9 11.11L13.15 10.77L13.98 10.09L14.39 9.57L14.6 9.23L14.9 8.55L15.09 7.88L15.13 7.41L15.03 7.36L14.88 7.36L14.78 7.41Z",
        "fill": "#ef8300"
      },
      {
        "type": "polygon",
        "d": "M13.41 10.77L12.94 11.45L11.78 11.56L13.37 11.45L13.78 10.77L13.77 10.64L13.67 10.59L13.53 10.59L13.43 10.64Z",
        "fill": "accent"
      },
      {
        "type": "polygon",
        "d": "M10.19 10.61L11.65 10.61L11.85 10.82L11.85 11.73L11.65 11.94L10.19 11.94L9.98 11.73L9.98 10.82Z",
        "fill": "accent"
      },
      {
        "type": "polygon",
        "d": "M10.42 11.12L11.38 11.12L11.38 11.68L10.42 11.68Z",
        "fill": "#ef8300"
      },
      {
        "type": "polygon",
        "d": "M9.2 12.55L10.9 13.16L10.9 14.93L9.2 14.22Z",
        "fill": "#eaca5f"
      },
      {
        "type": "polygon",
        "d": "M10.9 13.16L12.43 12.82L12.43 14.49L10.9 14.93Z",
        "fill": "#d6ae55"
      },
      {
        "type": "polygon",
        "d": "M9.2 12.55L10.39 12.11L12.43 12.82L10.9 13.16Z",
        "fill": "#f4d35c"
      }
    ],
    "joom-logistics": [
      {
        "type": "polygon",
        "d": "M11.39 4.25L15.69 4.25L15.69 6.29L11.39 6.29Z",
        "fill": "accent"
      },
      {
        "type": "polygon",
        "d": "M6.31 11.59L10.61 11.59L10.61 13.63L6.31 13.63Z",
        "fill": "accent"
      },
      {
        "type": "polygon",
        "d": "M11.39 7.1L15.69 7.1L15.69 13.63L11.39 13.63Z",
        "fill": "accent"
      },
      {
        "type": "polygon",
        "d": "M6.31 4.25L10.61 4.25L10.61 10.78L6.31 10.78Z",
        "fill": "accent"
      }
    ],
    "veho": [
      {
        "type": "circle",
        "cx": 11,
        "cy": 5.08,
        "r": 1.19,
        "fill": "accent"
      },
      {
        "type": "polygon",
        "d": "M7.16 10.28L7.18 10.98L7.32 11.66L7.58 12.3L7.97 12.9L8.46 13.41L9.01 13.81L9.63 14.11L10.3 14.3L10.45 14.25L10.51 14.13L10.51 12.51L10.48 12.42L10.35 12.33L9.42 12.32L9.27 12.21L9.2 12.06L9.19 9.05L9.23 8.93L9.33 8.8L9.51 8.74L12.49 8.74L12.67 8.8L12.79 8.96L12.8 12.06L12.73 12.21L12.58 12.32L11.65 12.33L11.52 12.42L11.49 12.51L11.49 14.13L11.52 14.22L11.6 14.28L11.7 14.3L12.12 14.2L12.76 13.94L13.32 13.59L13.82 13.14L14.22 12.63L14.54 12.05L14.75 11.43L14.84 10.79L14.82 10.04L14.64 9.29L14.33 8.62L13.9 8.02L13.33 7.49L12.7 7.1L11.99 6.84L11.26 6.72L10.5 6.74L9.78 6.91L9.09 7.21L8.48 7.65L7.94 8.21L7.55 8.85L7.28 9.55Z",
        "fill": "accent"
      }
    ],
    "hfd": [
      {
        "type": "polygon",
        "d": "M13.42 12.03L13.93 11.98L14.52 11.82L14.75 11.81L14.75 11.66L14.48 11.45L14.15 11.31L13.74 11.29L13.42 11.36L13.4 11.31L13.58 10.88L13.56 10.78L12.91 10.67L12.44 10.55L11.71 10.21L11 9.78L10.52 9.42L10 8.94L9.55 8.39L9.22 7.84L8.98 7.28L8.87 6.9L8.79 6.53L8.73 5.84L8.8 5.03L8.96 4.36L9.15 3.85L9.13 3.8L9.04 3.89L8.79 4.36L8.53 5L8.39 5.62L8.36 6.16L8.39 6.76L8.52 7.37L8.68 7.89L9.01 8.6L9.39 9.24L9.8 9.79L10.36 10.43L11.21 11.2L11.62 11.49L12.31 11.85L12.81 11.98Z",
        "fill": "accent"
      },
      {
        "type": "polygon",
        "d": "M13.59 10.48L13.61 10.38L13.51 10.02L13.33 9.67L13.13 9.41L12.56 8.91L11.56 8.33L10.89 7.86L10.49 7.5L9.94 6.89L9.7 6.51L9.42 5.95L9.25 5.43L9.12 4.69L9.07 4.79L9.06 5.71L9.21 6.64L9.46 7.34L9.72 7.82L10.06 8.29L10.78 9.06L11.67 9.72L12.23 10.04L12.75 10.27L13.13 10.4Z",
        "fill": "accent"
      },
      {
        "type": "polygon",
        "d": "M12.56 13.11L12.89 13.07L13.21 12.98L13.58 12.64L13.9 12.18L13.31 12.25L12.85 12.24L12.49 12.18L11.88 11.94L11.32 11.58L11.09 12L10.72 12.38L10.72 12.44L10.83 12.54L11.37 12.89L11.95 13.07Z",
        "fill": "accent"
      },
      {
        "type": "polygon",
        "d": "M11.19 13.76L12.04 13.58L12.54 13.39L12.65 13.3L12.02 13.33L11.4 13.22L10.97 13.04L10.33 12.62L9.41 12.96L9.42 13.03L9.59 13.19L9.99 13.44L10.58 13.66Z",
        "fill": "accent"
      },
      {
        "type": "polygon",
        "d": "M10.03 13.79L10.03 13.75L9.45 13.48L8.94 13.06L8.2 13.15L7.3 13.19L7.25 13.22L7.29 13.27L7.68 13.39L8.56 13.61L9.36 13.75Z",
        "fill": "accent"
      }
    ],
    "cheetah-delivery": [
      {
        "type": "polygon",
        "d": "M10.58 13.97L11.1 13.99L11.6 13.85L12.85 12.89L13.68 12.98L14.42 12.93L15.2 12.73L15.94 12.41L16.59 11.94L17.12 11.38L17.54 10.69L17.85 9.86L17.8 9.82L15.87 9.81L16 9.37L16.04 8.98L16 8.59L15.86 8.13L17.87 8.1L17.68 7.57L17.4 7.03L17.03 6.53L16.57 6.08L15.78 5.54L14.88 5.18L13.96 5.03L12.92 5.06L11.68 4.18L11.41 4.06L11.04 4L10.48 4.06L9.98 4.3L4.13 8.99L10.04 13.74L10.3 13.89Z",
        "fill": "#12100c"
      },
      {
        "type": "polygon",
        "d": "M9.99 7.81L10.61 7.93L11.83 8.06L12.21 7.56L12.66 7.2L13.24 6.96L13.87 6.88L14.44 6.97L15.02 7.22L15.43 7.54L15.79 8L17.72 7.99L17.54 7.47L17.25 6.94L16.88 6.5L16.4 6.09L15.86 5.76L15.31 5.54L14.7 5.39L14.03 5.33L13.36 5.36L12.75 5.47L12.16 5.67L11.59 5.96L11.05 6.35L10.61 6.8L10.27 7.25Z",
        "fill": "accent"
      },
      {
        "type": "polygon",
        "d": "M15.73 10.05L15.46 10.42L15.14 10.7L14.89 10.85L14.33 11.04L13.65 11.08L12.97 10.92L12.4 10.61L11.97 10.15L11.7 9.59L10.93 9.76L10.57 9.79L10.23 9.73L9.86 9.49L9.82 9.53L9.97 10.14L10.21 10.68L10.58 11.22L11.02 11.66L11.56 12.05L12.14 12.35L12.77 12.55L13.42 12.66L14.18 12.67L14.9 12.58L15.55 12.38L16.14 12.08L16.68 11.68L17.11 11.2L17.47 10.62L17.7 9.99L17.64 9.95L15.89 9.95Z",
        "fill": "accent"
      },
      {
        "type": "polygon",
        "d": "M10.6 7.93L9.63 7.72L9.1 7.43L8.72 7.29L8.48 7.05L8.38 7.11L8.29 7.09L7.97 7.31L7.63 7.73L7.69 7.89L7.85 7.97L7.82 8.07L7.9 8.14L8.29 8.06L8.49 8.05L8.61 8.1L8.85 8.47L8.86 8.86L8.42 8.95L8.13 9.09L7.63 9.66L7.63 9.76L7.81 9.81L8.03 9.72L8.14 9.6L8.24 9.36L8.54 9.77L8.79 9.86L8.86 9.75L8.85 9.62L8.56 9.33L8.55 9.24L9.46 9.43L9.58 9.41L9.72 9.28L10.01 9.48L10.55 9.59L12.09 9.29L12.17 9.35L12.49 9.93L12.77 10.22L13.05 10.42L13.99 10.9L14.19 11.05L14.58 10.96L14.29 10.58L14.01 10.47L13.85 10.34L13.57 9.58L13.78 9.99L14.51 10.23L15.11 10.71L15.38 10.49L15.05 10.26L14.65 9.88L14.18 9.73L13.97 9.6L13.71 9.23L13.75 9.04L14.08 9.19L15.59 10.23L15.73 10.05L14.17 8.91L13.18 8.41L12.16 8.12Z",
        "fill": "truck"
      },
      {
        "type": "polygon",
        "d": "M15.38 10.49L15.59 10.23L14.06 9.18L13.82 9.04L13.74 9.04L13.72 9.23L13.98 9.61L14.18 9.73L14.65 9.87L15.06 10.27Z",
        "fill": "#12100c"
      },
      {
        "type": "polygon",
        "d": "M14.58 10.96L14.9 10.84L15.1 10.7L14.51 10.23L13.77 9.99L13.56 9.58L13.86 10.34L14.01 10.47L14.29 10.58Z",
        "fill": "#12100c"
      }
    ],
    "parcel-one": [
      {
        "type": "line",
        "d": "M7.08 13.5L7.08 4.99L10.3 4.99L10.62 5.03L10.94 5.15L11.23 5.35L11.49 5.62L11.69 5.94L11.85 6.31L11.95 6.71L11.98 7.13L11.95 7.55L11.85 7.95L11.69 8.32L11.49 8.65L11.23 8.91L10.94 9.11L10.62 9.23L10.3 9.27L7.08 9.27",
        "stroke": "accent",
        "strokeWidth": 1.69
      },
      {
        "type": "line",
        "d": "M15.52 5.17L15.44 5.48L15.21 5.74L14.86 5.92L14.46 5.98L14.05 5.92L13.71 5.74L13.48 5.48L13.4 5.17L13.48 4.85L13.71 4.59L14.05 4.41L14.46 4.35L14.86 4.41L15.21 4.59L15.44 4.85L15.52 5.17L15.44 5.48M13.22 6.85L15.7 6.85M15.57 6.85L13.34 8.15M13.22 8.15L15.7 8.15M13.4 10.56L13.4 9.14L15.52 9.14L15.52 10.51M14.46 9.14L14.46 10.4",
        "stroke": "accent",
        "strokeWidth": 0.5
      },
      {
        "type": "polygon",
        "d": "M13.22 11.04L15.7 11.04L15.7 13.5L13.22 13.5Z",
        "fill": "accent"
      }
    ],
    "post-one": [
      {
        "type": "line",
        "d": "M9.63 6.91L18.05 6.38L18.52 11.89L10 12.62L9.63 6.91L18.05 6.38",
        "stroke": "accent",
        "strokeWidth": 0.9
      },
      {
        "type": "line",
        "d": "M10.05 6.88L14.07 10.19L17.29 6.42",
        "stroke": "accent",
        "strokeWidth": 0.62
      },
      {
        "type": "polygon",
        "d": "M5.74 8.48L8.89 7.73L8.96 8.75Z",
        "fill": "accent"
      },
      {
        "type": "polygon",
        "d": "M3.7 10.48L9.04 9.57L9.11 10.59Z",
        "fill": "accent"
      },
      {
        "type": "polygon",
        "d": "M3.03 12.23L9.15 11.26L9.21 12.28Z",
        "fill": "accent"
      }
    ],
    "polonez": [
      {
        "type": "polygon",
        "d": "M15.48 7.37L15.42 8.01L15.24 8.6L14.94 9.12L14.53 9.6L14.04 9.98L13.52 10.26L12.96 10.42L12.38 10.48L10.69 10.48L10.69 13.45L8.67 13.45L8.67 9.22L6.72 8.23L10.69 8.23L10.69 9.22L14.33 7.37L10.69 5.51L10.69 6.5L8.67 6.5L8.67 4.25L12.38 4.25L12.95 4.3L13.49 4.46L14.01 4.73L14.51 5.1L14.66 5.25L14.93 5.56L15.05 5.73L15.23 6.09L15.31 6.29L15.42 6.69Z",
        "fill": "accent"
      }
    ],
    "tas-courier": [
      {
        "type": "line",
        "d": "M3.5 6.15L8 6.15M5.75 6.15L5.75 12.85M8.75 12.85L10.25 6.15L11.05 6.15L12.55 12.85M9.29 10.44L12.01 10.44M17.11 6.62L16.79 6.37L16.42 6.2L16.02 6.15L15.63 6.2L15.26 6.37L14.94 6.62L14.7 6.95L14.55 7.34L14.5 7.76L14.55 8.17L14.7 8.56L14.94 8.9L15.26 9.15L15.63 9.31L16.02 9.37L16.45 9.43L16.84 9.6L17.17 9.88L17.43 10.24L17.59 10.66L17.65 11.11L17.59 11.56L17.43 11.98L17.17 12.34L16.84 12.62L16.45 12.79L16.02 12.85L15.6 12.79L15.21 12.62L14.88 12.34",
        "stroke": "accent",
        "strokeWidth": 1.7
      }
    ],
    "famafutar": [
      {
        "type": "polygon",
        "d": "M11 3.83L16.67 9.5L11 15.17L5.33 9.5Z",
        "fill": "accent"
      },
      {
        "type": "polygon",
        "d": "M13.57 9.5L11.02 12.03L12.31 13.3L11 14.6L5.86 9.5L9.72 5.67L10.98 6.92L8.42 9.46L9.75 10.78L12.31 8.25Z",
        "fill": "truck"
      }
    ],
    "first-flight-me": [
      {
        "type": "line",
        "d": "M9.29 4.79L9.24 4.57L9.09 4.4L8.88 4.31L8.62 4.31L8.34 4.4L8.09 4.57L7.88 4.79L7.75 5.05L5.43 12.1M12.29 4.79L12.24 4.57L12.09 4.4L11.88 4.31L11.62 4.31L11.34 4.4L11.09 4.57L10.88 4.79L10.75 5.05L8.43 12.1",
        "stroke": "accent",
        "strokeWidth": 1.15
      },
      {
        "type": "polygon",
        "d": "M4.93 11.77L4.9 11.89L4.86 12.01L4.81 12.12L4.73 12.23L4.63 12.33L4.52 12.41L4.41 12.46L4.32 12.49L4.25 12.5L4.19 12.49L4.14 12.47L4.1 12.42L4.06 12.29L3.51 12.33L3.5 12.55L3.57 12.81L3.73 13.04L3.96 13.2L4.23 13.3L4.52 13.32L4.82 13.28L5.11 13.18L5.38 13.02L5.62 12.82L5.82 12.57L5.95 12.31L6.02 12.13Z",
        "fill": "accent"
      },
      {
        "type": "polygon",
        "d": "M7.93 11.77L7.9 11.88L7.84 12.04L7.75 12.18L7.63 12.3L7.49 12.39L7.36 12.44L7.28 12.45L7.23 12.45L7.18 12.43L7.14 12.35L7.13 12.21L7.18 12.02L7.32 11.8L6.93 11.48L6.69 11.71L6.51 12.01L6.43 12.36L6.47 12.72L6.67 13.05L6.99 13.27L7.37 13.36L7.77 13.32L8.15 13.19L8.49 12.96L8.77 12.65L8.95 12.32L9.02 12.13Z",
        "fill": "accent"
      },
      {
        "type": "line",
        "d": "M5.93 7.4L8.23 7.4M8.93 7.4L11.23 7.4",
        "stroke": "accent",
        "strokeWidth": 0.85
      },
      {
        "type": "line",
        "d": "M6.94 11.86L7.29 11.45L7.71 11.07L8.23 10.68L9.17 10.09L11.05 9.11L13.96 7.78",
        "stroke": "accent",
        "strokeWidth": 0.5
      },
      {
        "type": "polygon",
        "d": "M13.41 7.46L13.55 7.64L13.58 7.91L13.68 7.96L15.65 7.32L15.66 7.43L14.88 8.2L14.88 8.31L15.01 8.33L15.57 8.02L16.1 7.91L16.24 7.54L16.86 7.36L16.91 7.06L17.01 6.93L17.39 6.67L18.63 6.1L19.01 5.78L19.09 5.55L18.86 5.4L18.41 5.38L17.29 5.84L16.59 5.64L16.3 5.64L16.06 5.76L16.01 5.86L16.06 5.96L16.31 6.13L16.3 6.25L14.8 6.91L14.63 6.88L13.99 6.41L13.68 6.41L13.52 6.48L13.44 6.58L13.67 7.14Z",
        "fill": "accent"
      }
    ],
    "dd-express": [
      {
        "type": "line",
        "d": "M10.93 8.02L11.25 8.05L11.57 8.11L11.87 8.21L12.16 8.35L12.43 8.53L12.67 8.74L12.88 8.99L13.06 9.25L13.2 9.54L13.31 9.85L13.37 10.16L13.39 10.48L13.37 10.8L13.31 11.12L13.2 11.42L13.06 11.71L12.88 11.98L12.67 12.22L12.43 12.44L12.16 12.61L11.87 12.76L11.57 12.86L11.25 12.92L10.93 12.94L10.61 12.92L10.29 12.86L9.99 12.76L9.7 12.61L9.43 12.44L9.19 12.22L8.98 11.98L8.8 11.71L8.66 11.42L8.55 11.12L8.49 10.8L8.47 10.48L8.49 10.16L8.55 9.85L8.66 9.54L8.8 9.25L8.98 8.99L9.19 8.74L9.43 8.53L9.7 8.35L9.99 8.21L10.29 8.11L10.61 8.05L10.93 8.02L11.25 8.05",
        "stroke": "accent",
        "strokeWidth": 0.98
      },
      {
        "type": "polygon",
        "d": "M13.46 6.41L13.49 6.19L13.57 5.99L13.71 5.81L13.88 5.68L14.08 5.59L14.3 5.56L18.7 5.56L18.18 6.41L14.33 6.41L13.88 10.48L12.9 10.48Z",
        "fill": "accent"
      },
      {
        "type": "polygon",
        "d": "M15.01 7.11L17.68 7.11L16.97 7.95L15.01 7.95Z",
        "fill": "accent"
      },
      {
        "type": "line",
        "d": "M6.15 8.02L6.47 8.05L6.79 8.11L7.09 8.21L7.38 8.35L7.65 8.53L7.89 8.74L8.1 8.99L8.28 9.25L8.42 9.54L8.53 9.85L8.59 10.16L8.61 10.48L8.59 10.8L8.53 11.12L8.42 11.42L8.28 11.71L8.1 11.98L7.89 12.22L7.65 12.44L7.38 12.61L7.09 12.76L6.79 12.86L6.47 12.92L6.15 12.94L5.83 12.92L5.51 12.86L5.21 12.76L4.92 12.61L4.65 12.44L4.41 12.22L4.2 11.98L4.02 11.71L3.88 11.42L3.78 11.12L3.71 10.8L3.69 10.48L3.71 10.16L3.78 9.85L3.88 9.54L4.02 9.25L4.2 8.99L4.41 8.74L4.65 8.53L4.92 8.35L5.21 8.21L5.51 8.11L5.83 8.05L6.15 8.02L6.47 8.05",
        "stroke": "truck",
        "strokeWidth": 1.32
      },
      {
        "type": "polygon",
        "d": "M8.65 5.96L8.03 9.92L8.14 10.65L9.25 10.65L9.87 5.29Z",
        "fill": "truck"
      },
      {
        "type": "line",
        "d": "M6.15 8.02L6.47 8.05L6.79 8.11L7.09 8.21L7.38 8.35L7.65 8.53L7.89 8.74L8.1 8.99L8.28 9.25L8.42 9.54L8.53 9.85L8.59 10.16L8.61 10.48L8.59 10.8L8.53 11.12L8.42 11.42L8.28 11.71L8.1 11.98L7.89 12.22L7.65 12.44L7.38 12.61L7.09 12.76L6.79 12.86L6.47 12.92L6.15 12.94L5.83 12.92L5.51 12.86L5.21 12.76L4.92 12.61L4.65 12.44L4.41 12.22L4.2 11.98L4.02 11.71L3.88 11.42L3.78 11.12L3.71 10.8L3.69 10.48L3.71 10.16L3.78 9.85L3.88 9.54L4.02 9.25L4.2 8.99L4.41 8.74L4.65 8.53L4.92 8.35L5.21 8.21L5.51 8.11L5.83 8.05L6.15 8.02L6.47 8.05",
        "stroke": "#0056b8",
        "strokeWidth": 0.98
      },
      {
        "type": "polygon",
        "d": "M8.81 6.07L9.66 5.59L9.1 10.48L8.29 10.48L8.2 9.92Z",
        "fill": "#0056b8"
      }
    ],
    "boyuan": [
      {
        "type": "circle",
        "cx": 11,
        "cy": 9.3,
        "r": 4.9,
        "fill": "accent"
      },
      {
        "type": "circle",
        "cx": 11,
        "cy": 9.3,
        "r": 4.4,
        "fill": "truck"
      },
      {
        "type": "polygon",
        "d": "M7.06 7.34L7.57 7.7L7.86 8.01L8.03 8.24L8.18 8.49L8.36 8.88L8.44 9.16L8.51 9.58L8.51 10.16L8.44 10.58L8.36 10.86L8.18 11.25L8.03 11.5L7.77 11.84L7.56 12.04L7.62 12.11L10.72 7.97L10.03 7.1L7.19 7.1Z",
        "fill": "accent"
      },
      {
        "type": "polygon",
        "d": "M14.81 7.1L12.24 7.1L8.09 12.6L8.56 12.96L8.93 13.18L9.52 13.44L10.06 13.6L14.85 7.17Z",
        "fill": "accent"
      },
      {
        "type": "polygon",
        "d": "M15.39 9.08L15.32 8.44L15.21 8.02L15.07 7.62L14.85 7.17L10.06 13.6L10.57 13.68L11 13.7L11.43 13.68L12.07 13.57L12.48 13.44L12.88 13.28L13.26 13.07L13.79 12.7L14.26 12.25L14.53 11.92L14.77 11.56L15.07 10.98L15.21 10.58L15.35 9.95L15.39 9.52Z",
        "fill": "#172a88"
      }
    ],
    "emex": [
      {
        "type": "polygon",
        "d": "M5.82 11.79L5.82 4.4L3.45 4.4L3.45 13.72Z",
        "fill": "accent"
      },
      {
        "type": "polygon",
        "d": "M12.85 9.07L14.87 10.72L14.87 13.73L10.99 10.57L7.13 13.73L7.13 10.72L9.15 9.07L3.45 4.4L7.13 4.4L10.99 7.56L14.86 4.4L18.54 4.4Z",
        "fill": "accent"
      },
      {
        "type": "polygon",
        "d": "M16.18 11.79L16.18 4.4L18.55 4.4L18.55 13.72Z",
        "fill": "accent"
      }
    ],
    "interlogistica": [
      {
        "type": "polygon",
        "d": "M6.4 6.99L9.09 6.99L9.09 10.81L12.91 10.81L12.91 13.5L6.4 13.5Z",
        "fill": "#2b2a28"
      },
      {
        "type": "polygon",
        "d": "M9.09 6.99L11.79 4.3L15.6 4.3L15.6 8.11L12.91 10.81L12.91 6.99Z",
        "fill": "accent"
      }
    ],
    "intime-bg": [
      {
        "type": "polygon",
        "d": "M16.07 3.74L15.42 4.09L15.11 4.32L14.16 5.36L12.81 6.95L12.14 7.64L11.69 8.02L10.06 9.08L5.7 11.65L5.14 12.03L4.74 12.49L4.23 13.39L4.11 13.69L3.98 14.24L4.55 14.29L6.08 13.94L7.46 13.33L8.37 12.84L9.69 12.24L10.37 11.82L10.63 11.5L11.28 10.24L11.76 9.45L12.38 8.7L13.73 7.33L14.34 6.56L15.52 4.8Z",
        "fill": "accent"
      },
      {
        "type": "line",
        "d": "M15.79 4.09L15.75 4.13L15.68 4.22L15.57 4.35L15.42 4.52L15.27 4.68L15.14 4.85L15.01 5L14.88 5.15L14.76 5.3L14.65 5.44L14.53 5.57L14.42 5.7L14.31 5.83L14.19 5.97L14.07 6.12L13.95 6.27L13.83 6.42L13.7 6.57L13.58 6.72L13.44 6.87L13.31 7.02L13.17 7.17L13.03 7.32L12.88 7.47L12.74 7.62L12.58 7.76L12.43 7.89L12.27 8.02L12.12 8.15L11.96 8.26L11.81 8.38L11.65 8.48L11.53 8.57L11.45 8.62L11.41 8.65",
        "stroke": "truck",
        "strokeWidth": 0.3
      }
    ],
    "asigna": [
      {
        "type": "polygon",
        "d": "M5.59 14.92L8.41 11.55L8.84 12.13L9.16 12.42L9.69 12.75L10.24 12.93L11.04 12.97L11.5 12.88L12.05 12.62L12.45 12.2L12.48 12.79L14.39 12.77L14.39 7.36L12.94 7.36L12.46 7.89L12.23 7.66L11.88 7.41L14.96 3.75L13.88 3.75L4.5 14.92Z",
        "fill": "#e95910"
      },
      {
        "type": "polygon",
        "d": "M11.5 11.3L10.92 11.27L10.51 11.08L10.21 10.73L10.06 10.28L10.07 9.81L10.28 9.34L10.63 9.02L11.06 8.87L11.53 8.87L11.97 9.03L12.29 9.32L12.46 9.62L12.51 9.84L12.51 10.34L12.32 10.82L11.96 11.15Z",
        "fill": "truck"
      }
    ],
    "pflogistics": [
      {
        "type": "polygon",
        "d": "M9.67 8.12L14.68 8.12L14.94 6.65L9.93 6.65Z",
        "fill": "#fe8702"
      },
      {
        "type": "polygon",
        "d": "M9.29 10.23L13.66 10.23L13.92 8.77L9.55 8.77Z",
        "fill": "#fe8702"
      },
      {
        "type": "polygon",
        "d": "M8.91 12.35L10.4 12.35L10.66 10.88L9.17 10.88Z",
        "fill": "#fe8702"
      },
      {
        "type": "line",
        "d": "M3.63 12.35L4.51 7.43L7.87 7.43L8.05 7.45L8.21 7.52L8.33 7.63L8.42 7.78L8.46 7.95L8.45 8.14L8.24 9.34L8.18 9.52L8.08 9.69L7.94 9.84L7.77 9.95L7.59 10.02L7.4 10.05L4.04 10.05M16.11 6.65L15.23 11.57L18.99 11.57",
        "stroke": "accent",
        "strokeWidth": 1.55
      }
    ],
    "costco-logistics": [
      {
        "type": "polygon",
        "d": "M3.1 11.61L8.25 11.61L8.35 11.11L3.1 11.11Z",
        "fill": "#264b95"
      },
      {
        "type": "polygon",
        "d": "M3.1 12.41L8.09 12.41L8.19 11.91L3.1 11.91Z",
        "fill": "#264b95"
      },
      {
        "type": "polygon",
        "d": "M3.1 13.21L7.93 13.21L8.03 12.71L3.1 12.71Z",
        "fill": "#264b95"
      },
      {
        "type": "polygon",
        "d": "M8.23 13.21L18.7 13.21L19.12 11.11L8.65 11.11Z",
        "fill": "#264b95"
      },
      {
        "type": "line",
        "d": "M5.87 6.34L5.69 6.06L5.46 5.88L5.18 5.8L4.88 5.84L4.57 5.98L4.27 6.23L3.99 6.56L3.75 6.97L3.56 7.42L3.43 7.9L3.37 8.38L3.38 8.83L3.46 9.24L3.6 9.57L3.81 9.82L4.06 9.96L4.34 10L4.65 9.92L4.95 9.74L5.25 9.46M6.25 8.35L6.4 7.84L6.64 7.38L6.93 7.02L7.26 6.78L7.58 6.7L7.88 6.78L8.11 7.02L8.26 7.38L8.31 7.84L8.25 8.35L8.1 8.86L7.87 9.32L7.57 9.68L7.25 9.92L6.92 10L6.63 9.92L6.4 9.68L6.25 9.32L6.2 8.86L6.25 8.35L6.4 7.84M11.11 7.08L10.78 6.7L10.25 6.7L9.77 7.08L9.56 7.65L9.73 8.15L10.19 8.35L10.66 8.55L10.83 9.05L10.62 9.62L10.13 10L9.58 10L9.24 9.62M11.83 6.7L13.73 6.7M12.78 6.7L12.03 10.43M15.91 7.12L15.78 6.9L15.62 6.76L15.43 6.7L15.21 6.73L14.99 6.84L14.78 7.04L14.58 7.3L14.4 7.62L14.26 7.97L14.16 8.35L14.11 8.73L14.11 9.08L14.16 9.4L14.25 9.66L14.39 9.86L14.57 9.97L14.77 10L14.98 9.94L15.2 9.8L15.42 9.58M16.57 8.35L16.73 7.84L16.96 7.38L17.25 7.02L17.58 6.78L17.9 6.7L18.2 6.78L18.43 7.02L18.58 7.38L18.63 7.84L18.57 8.35L18.42 8.86L18.19 9.32L17.9 9.68L17.57 9.92L17.24 10L16.95 9.92L16.72 9.68L16.57 9.32L16.52 8.86L16.57 8.35L16.73 7.84",
        "stroke": "accent",
        "strokeWidth": 0.85
      }
    ],
    "quality-post": [
      {
        "type": "polygon",
        "d": "M10.99 12.46L8.6 9.61L8.05 8.89L7.74 8.41L7.46 7.86L7.3 7.31L7.25 6.87L7.32 6.34L7.55 5.73L7.8 5.33L8.29 4.84L8.54 4.68L8.8 4.57L9.07 4.5L9.35 4.49L9.62 4.52L9.87 4.59L10.25 4.74L10.53 4.89L11.01 5.28L11.22 5.07L11.47 4.88L11.75 4.74L12.13 4.59L12.38 4.52L12.68 4.49L13.14 4.55L13.46 4.68L13.81 4.92L14.18 5.31L14.43 5.69L14.62 6.13L14.73 6.58L14.75 7L14.66 7.5L14.51 7.93L14.33 8.3L13.8 9.11L12.26 11Z",
        "fill": "accent"
      },
      {
        "type": "polygon",
        "d": "M11.41 13.49L10.63 13.5L9.96 13.41L9.47 13.25L9.34 13.13L9.32 13.03L9.43 12.89L9.6 12.81L9.94 12.71L10.34 12.64L11.31 12.62L12.02 12.71L12.32 12.79L12.53 12.89L12.64 13L12.64 13.09L12.61 13.14L12.46 13.26L12.17 13.37Z",
        "fill": "accent"
      }
    ],
    "rxo": [
      {
        "type": "polygon",
        "d": "M14.6 7.63L14.57 7.2L14.48 6.78L14.34 6.39L14.04 5.86L13.79 5.54L13.32 5.14L12.97 4.92L12.58 4.74L11.94 4.56L11.49 4.51L7 4.5L7 6.73L11.25 6.73L11.43 6.75L11.7 6.85L11.83 6.95L11.95 7.08L12.08 7.33L12.12 7.63L12.08 7.94L11.95 8.2L11.84 8.33L11.7 8.43L11.43 8.53L11.25 8.54L7 8.54L7 13.5L9.4 13.5L9.4 10.76L10.74 10.76L12.32 13.5L15 13.5L13.13 10.26L13.46 10.03L13.75 9.76L14 9.47L14.21 9.14L14.38 8.79L14.5 8.42L14.57 8.04Z",
        "fill": "accent"
      }
    ],
    "runner-express": [
      {
        "type": "polygon",
        "d": "M11.76 11.13L11.71 11.12L12.62 10.38L13.18 9.8L13.63 9.14L13.9 8.5L13.98 7.99L13.95 7.66L13.86 7.39L13.72 7.12L13.55 6.92L13.34 6.73L13.05 6.54L12.74 6.4L12.37 6.28L11.65 6.15L10.54 6.15L9.68 6.25L8.69 6.48L7.68 6.83L6.82 7.22L5.68 7.87L5.65 7.87L6.08 7.4L6.57 6.95L7.08 6.56L7.74 6.13L8.44 5.74L9.18 5.39L9.82 5.14L10.58 4.89L11.41 4.69L12.13 4.57L12.81 4.5L13.4 4.5L13.98 4.54L14.56 4.65L15.05 4.81L15.5 5.04L15.85 5.31L16.08 5.58L16.27 5.93L16.37 6.32L16.38 6.75L16.31 7.08L16.15 7.56L15.94 7.95L15.61 8.42L15.2 8.89L14.76 9.31L14.29 9.7L13.73 10.1L13.16 10.45L12.46 10.81Z",
        "fill": "accent"
      },
      {
        "type": "polygon",
        "d": "M10.4 13.49L5.96 13.48L8.84 8.61L8.84 8.44L8.71 8.36L8.26 8.35L7.7 8.42L8.3 8.07L8.81 7.82L9.35 7.61L9.9 7.45L10.5 7.33L11.06 7.26L11.76 7.24L12.37 7.28L9.67 11.96L9.55 12.23L9.51 12.39L9.5 12.6L9.55 12.76L9.63 12.91L9.82 13.1L10.41 13.46Z",
        "fill": "accent"
      },
      {
        "type": "polygon",
        "d": "M15.89 13.49L14.02 13.5L13.92 13.47L13.85 13.38L12.88 11.12L14.44 10.11L15.9 13.44Z",
        "fill": "accent"
      }
    ],
    "jp-home": [
      {
        "type": "polygon",
        "d": "M8.18 4.69L8.14 10.58L8.03 10.91L7.83 11.2L7.64 11.38L7.42 11.51L7.1 11.62L6.75 11.65L6.48 11.62L6.15 11.51L5.93 11.38L5.74 11.2L5.55 10.91L5.46 10.67L5.42 10.41L5.39 9.24L5.25 8.9L4.99 8.64L4.83 8.55L4.46 8.47L4.1 8.55L3.79 8.75L3.67 8.9L3.53 9.24L3.52 10.57L3.58 10.98L3.75 11.53L3.93 11.91L4.2 12.31L4.59 12.73L4.97 13.02L5.47 13.29L5.93 13.45L6.5 13.54L7.08 13.54L7.64 13.45L8.1 13.29L8.6 13.02L8.99 12.73L9.41 12.26L9.74 11.72L9.96 11.13L10.06 10.5L10.04 4.69L9.99 4.51L9.78 4.2L9.48 4L9.3 3.94L8.93 3.94L8.58 4.09L8.32 4.35Z",
        "fill": "accent"
      },
      {
        "type": "polygon",
        "d": "M11.06 12.53L11.14 12.91L11.36 13.23L11.68 13.45L12.06 13.53L12.45 13.45L12.77 13.23L12.99 12.91L13.04 12.72L13.04 7.55L12.89 7.19L12.77 7.04L12.62 6.92L12.26 6.77L11.87 6.77L11.51 6.92L11.23 7.19L11.08 7.55Z",
        "fill": "accent"
      },
      {
        "type": "polygon",
        "d": "M11.83 5.78L15.52 5.83L15.77 5.9L16 6.02L16.26 6.25L16.41 6.46L16.52 6.7L16.58 6.95L16.58 7.31L16.52 7.65L16.41 7.89L16.26 8.1L16.07 8.28L15.85 8.41L15.61 8.5L14.9 8.57L14.72 8.62L14.42 8.83L14.21 9.14L14.16 9.31L14.16 9.69L14.3 10.03L14.56 10.29L14.72 10.38L15.09 10.45L15.65 10.43L16.07 10.35L16.47 10.22L16.85 10.03L17.25 9.76L17.56 9.48L17.84 9.16L18.07 8.81L18.31 8.29L18.42 7.88L18.48 7.47L18.48 6.95L18.43 6.53L18.33 6.12L18.14 5.67L17.93 5.31L17.41 4.72L16.9 4.35L16.27 4.06L15.5 3.91L11.83 3.92L11.65 3.97L11.34 4.18L11.13 4.49L11.08 4.66L11.08 5.04L11.22 5.38L11.48 5.64Z",
        "fill": "accent"
      }
    ],
    "cargoline": [
      {
        "type": "polygon",
        "d": "M13.45 5.51L12.98 5.07L12.46 4.7L11.9 4.41L11.3 4.19L10.68 4.05L10.05 4L9.41 4.03L8.78 4.15L8.18 4.34L7.6 4.62L7.07 4.97L6.59 5.38L6.17 5.86L5.81 6.39L5.53 6.96L5.32 7.56L5.2 8.19L5.16 8.82L5.21 9.46L5.33 10.08L5.54 10.68L5.83 11.25L6.19 11.77L6.62 12.25L7.1 12.66L7.64 13L8.22 13.27L8.82 13.46L9.45 13.57L10.09 13.6L10.72 13.54L11.34 13.4L11.94 13.17L12.5 12.87L13.02 12.5L13.48 12.06L11.6 10.21L11.37 10.43L11.11 10.62L10.82 10.77L10.51 10.87L10.2 10.93L9.87 10.94L9.55 10.89L9.24 10.81L8.95 10.67L8.68 10.49L8.44 10.28L8.23 10.03L8.07 9.75L7.95 9.45L7.87 9.14L7.84 8.81L7.87 8.49L7.94 8.18L8.05 7.87L8.21 7.59L8.41 7.34L8.65 7.12L8.92 6.94L9.21 6.8L9.52 6.71L9.84 6.66L10.16 6.66L10.48 6.71L10.79 6.81L11.08 6.95L11.34 7.14L11.58 7.36Z",
        "fill": "accent"
      },
      {
        "type": "polygon",
        "d": "M15.3 13.32L10.75 8.81L15.3 4.24L17.44 6.38L14.86 8.97L17.22 11.38Z",
        "fill": "accent"
      }
    ],
    "overnite": [
      {
        "type": "polygon",
        "d": "M11.9 4.43L11.4 4.4L10.93 4.42L10.46 4.49L10.01 4.61L9.56 4.77L9.14 4.97L8.73 5.21L8.35 5.49L8.01 5.81L7.69 6.15L7.41 6.53L7.17 6.94L6.97 7.36L6.81 7.81L6.69 8.26L6.62 8.73L6.6 9.2L6.62 9.67L6.69 10.14L6.81 10.59L6.97 11.04L7.17 11.46L7.41 11.87L7.69 12.25L8.01 12.59L8.35 12.91L8.73 13.19L9.14 13.43L9.56 13.63L10.01 13.79L10.46 13.91L10.93 13.98L11.4 14L11.9 13.97L12.39 13.9L12.85 13.78L13.29 13.61L13.74 13.39L14.14 13.14L14.53 12.84L13.8 12.77L13.11 12.6L12.45 12.32L11.83 11.93L11.29 11.46L10.81 10.9L10.43 10.26L10.17 9.6L10 8.88L9.95 8.17L10.01 7.46L10.19 6.75L10.46 6.09L10.83 5.48L11.27 4.96Z",
        "fill": "accent"
      },
      {
        "type": "polygon",
        "d": "M13.32 4.8L12.77 4.6L12.19 4.47L11.74 4.8Z",
        "fill": "accent"
      },
      {
        "type": "polygon",
        "d": "M14.79 5.8L14.2 5.3L11.23 5.3L10.86 5.8Z",
        "fill": "accent"
      },
      {
        "type": "polygon",
        "d": "M15.56 6.8L15.23 6.3L10.58 6.3L10.38 6.8Z",
        "fill": "accent"
      },
      {
        "type": "polygon",
        "d": "M15.99 7.8L15.81 7.3L10.24 7.3L10.17 7.8Z",
        "fill": "accent"
      },
      {
        "type": "polygon",
        "d": "M16.18 8.79L16.12 8.3L10.15 8.3L10.19 8.8Z",
        "fill": "accent"
      },
      {
        "type": "polygon",
        "d": "M10.29 9.31L10.45 9.8L16.16 9.8L16.2 9.3Z",
        "fill": "accent"
      },
      {
        "type": "polygon",
        "d": "M10.69 10.32L10.99 10.8L15.92 10.8L16.07 10.3Z",
        "fill": "accent"
      },
      {
        "type": "polygon",
        "d": "M11.41 11.3L12 11.8L15.43 11.8L15.71 11.3Z",
        "fill": "accent"
      },
      {
        "type": "polygon",
        "d": "M12.89 12.3L13.33 12.46L13.75 12.56L14.18 12.62L14.62 12.64L14.75 12.64L15.06 12.3Z",
        "fill": "accent"
      }
    ],
    "ambro-express": [
      {
        "type": "polygon",
        "d": "M9.75 13.15L9.25 13.13L8.98 13.03L8.75 12.8L8.65 12.5L8.61 6.53L8.42 6.59L8.16 6.93L6.94 9.15L7.41 9.16L7.61 9.2L7.8 9.3L7.98 9.49L8.09 9.8L8.1 10.25L8.03 10.59L7.9 10.81L7.71 10.94L7.38 11.03L5.92 11.04L5.04 12.62L4.8 12.9L4.52 13.07L4.08 13.15L3.41 13.12L3.12 12.94L3 12.66L3.02 12.41L3.13 12.15L6.11 6.74L6.58 5.98L6.95 5.49L7.35 5.12L7.83 4.85L8.36 4.7L9.2 4.67L9.58 4.74L9.87 4.86L10.12 5.05L10.32 5.31L10.45 5.6L10.53 5.96L10.58 6.76L10.57 12.47L10.48 12.78L10.29 12.99L10.08 13.1Z",
        "fill": "accent"
      },
      {
        "type": "polygon",
        "d": "M12.36 13.14L11.73 13.14L11.47 13.09L11.24 12.91L11.13 12.62L11.15 12.45L11.23 12.24L12.59 10.09L11.27 8L11.16 7.77L11.14 7.48L11.25 7.25L11.45 7.1L11.71 7.04L12.42 7.04L12.65 7.11L12.84 7.23L13.03 7.44L13.86 8.76L13.91 8.78L13.91 8.84L13.07 10.09L13.89 11.33L13.9 11.42L13.86 11.42L12.93 12.86L12.68 13.05Z",
        "fill": "accent"
      },
      {
        "type": "polygon",
        "d": "M16.61 13.11L15.03 13.11L13.03 10.1L15.07 7.04L16.88 7.05L15.35 9.37L18.99 9.38L18.97 10.78L15.34 10.78L16.88 13.1Z",
        "fill": "#ff0000"
      }
    ],
    "city-air-express": [
      {
        "type": "line",
        "d": "M5.23 5.06L5.07 4.9L4.87 4.79L4.64 4.75L4.41 4.78L4.21 4.89L4.05 5.05L3.94 5.25L3.91 5.47L3.91 7.32L3.94 7.55L4.05 7.75L4.21 7.91L4.41 8.02L4.64 8.05L4.87 8.01L5.07 7.9L5.23 7.74M6.29 4.75L6.29 8.05M7.09 4.75L8.69 4.75M7.89 4.75L7.89 8.05M9.44 4.75L10.29 6.4M11.14 4.75L10.29 6.4L10.29 8.05M12.5 8.05L13.25 4.75L13.61 4.75L14.35 8.05M12.76 6.93L14.1 6.93M15.51 4.75L15.51 8.05M16.68 8.05L16.68 4.75L17.23 4.75L17.56 4.82L17.83 5L18.02 5.28L18.08 5.61L18.02 5.94L17.83 6.21L17.56 6.4L17.23 6.47L16.68 6.47M17.17 6.47L18.08 8.05M4.54 9.5L3.34 9.5L3.34 12.8L4.54 12.8M3.34 11.15L4.36 11.15M5.3 9.5L6.85 12.8M6.85 9.5L5.3 12.8M7.98 12.8L7.98 9.5L8.52 9.5L8.85 9.57L9.13 9.75L9.32 10.03L9.38 10.36L9.32 10.69L9.13 10.96L8.85 11.15L8.52 11.22L7.98 11.22M10.56 12.8L10.56 9.5L11.1 9.5L11.43 9.57L11.71 9.75L11.9 10.03L11.96 10.36L11.9 10.69L11.71 10.96L11.43 11.15L11.1 11.22L10.56 11.22M11.05 11.22L11.96 12.8M14.34 9.5L13.14 9.5L13.14 12.8L14.34 12.8M13.14 11.15L14.16 11.15M16.3 9.88L15.95 9.5L15.49 9.5L15.14 9.88L15.06 10.45L15.29 10.95L15.72 11.15L16.16 11.35L16.41 11.85L16.32 12.42L15.96 12.8L15.48 12.8L15.12 12.42M18.54 9.88L18.19 9.5L17.73 9.5L17.38 9.88L17.3 10.45L17.53 10.95L17.97 11.15L18.41 11.35L18.65 11.85L18.56 12.42L18.2 12.8L17.72 12.8L17.36 12.42",
        "stroke": "accent",
        "strokeWidth": 0.75
      }
    ],
    "ameriship": [
      {
        "type": "polygon",
        "d": "M5.34 10L8.05 5.59L11.5 11.1L18.2 11.1L18.07 11.41L17.94 11.65L17.62 12.03L17.31 12.27L17.13 12.37L16.71 12.51L16.46 12.55L10.69 12.55L8.09 8.25L6.99 10.04Z",
        "fill": "#9c9c9c"
      },
      {
        "type": "polygon",
        "d": "M16.46 8.56L13.18 8.54L13.05 8.51L12.92 8.44L12.76 8.25L12.71 8.05L12.72 7.71L12.79 7.54L12.88 7.43L13.05 7.33L13.23 7.29L16.88 7.28L16.87 7.8L19.1 6.55L16.9 5.24L16.9 5.84L13.15 5.84L12.85 5.89L12.54 5.98L12.18 6.14L12 6.25L11.66 6.55L11.51 6.74L11.38 6.97L11.29 7.23L11.23 7.52L11.2 7.85L11.22 8.19L11.28 8.49L11.36 8.75L11.47 8.99L11.74 9.37L12.05 9.64L12.35 9.83L12.82 9.99L18.2 10.01L18.16 9.75L18.1 9.52L18 9.32L17.89 9.15L17.75 9.01L17.45 8.8L17.14 8.66L16.84 8.59Z",
        "fill": "accent"
      },
      {
        "type": "polygon",
        "d": "M8.85 11.15L5.12 11.15L5.13 10.6L2.9 11.85L5.1 13.15L5.1 12.55L8.06 12.55Z",
        "fill": "#9c9c9c"
      }
    ],
    "gio-express": [
      {
        "type": "polygon",
        "d": "M5.04 4.75L7.72 4.5L7.57 5Z",
        "fill": "accent"
      },
      {
        "type": "polygon",
        "d": "M3.55 5.88L7.22 5.63L7.07 6.13Z",
        "fill": "accent"
      },
      {
        "type": "polygon",
        "d": "M3.81 7.02L6.88 6.77L6.73 7.27Z",
        "fill": "accent"
      },
      {
        "type": "polygon",
        "d": "M4.58 8.15L6.85 7.9L6.7 8.4Z",
        "fill": "accent"
      },
      {
        "type": "line",
        "d": "M10.16 4.9L8.56 4.9L8.4 4.93L8.24 5.02L8.12 5.15L8.04 5.3L7.35 7.6L7.33 7.75L7.38 7.88L7.49 7.97L7.63 8L8.83 8L8.99 7.97L9.15 7.88L9.27 7.75L9.35 7.6L9.68 6.51L8.68 6.51M11.46 4.9L10.54 8M13.17 4.9L14.27 4.9L14.41 4.93L14.52 5.02L14.57 5.15L14.55 5.3L13.86 7.6L13.78 7.75L13.66 7.88L13.5 7.97L13.34 8L12.24 8L12.1 7.97L11.99 7.88L11.94 7.75L11.96 7.6L12.65 5.3L12.73 5.15L12.85 5.02L13.01 4.93L13.17 4.9L14.27 4.9M5.26 9.5L4.16 9.5L3.23 12.6L4.33 12.6M3.7 11.05L4.63 11.05M6.02 9.5L6.49 12.6M7.42 9.5L5.09 12.6M7.67 12.6L8.6 9.5L9.5 9.5L9.65 9.53L9.75 9.62L9.8 9.75L9.78 9.9L9.51 10.8L9.44 10.96L9.31 11.09L9.16 11.17L8.99 11.21L8.09 11.21M10.19 12.6L11.12 9.5L12.07 9.5L12.21 9.53L12.31 9.62L12.36 9.75L12.35 9.9L12.07 10.8L12 10.96L11.87 11.09L11.72 11.17L11.55 11.21L10.6 11.21M11.21 11.21L11.54 12.6M14.78 9.5L13.68 9.5L12.75 12.6L13.85 12.6M13.21 11.05L14.15 11.05M16.99 9.5L16.09 9.5L15.93 9.53L15.77 9.62L15.65 9.75L15.57 9.9L15.35 10.65L15.33 10.8L15.38 10.93L15.48 11.02L15.63 11.05L16.13 11.05L16.27 11.08L16.37 11.17L16.42 11.3L16.41 11.45L16.18 12.2L16.1 12.35L15.98 12.48L15.82 12.57L15.66 12.6L14.76 12.6M19.2 9.5L18.3 9.5L18.14 9.53L17.99 9.62L17.86 9.75L17.78 9.9L17.56 10.65L17.54 10.8L17.59 10.93L17.69 11.02L17.84 11.05L18.34 11.05L18.48 11.08L18.59 11.17L18.63 11.3L18.62 11.45L18.39 12.2L18.32 12.35L18.19 12.48L18.04 12.57L17.87 12.6L16.97 12.6",
        "stroke": "accent",
        "strokeWidth": 0.8
      }
    ],
    "sway": [
      {
        "type": "polygon",
        "d": "M13.85 4.66L13.83 4.55L13.78 4.46L13.7 4.39L13.6 4.36L13.23 4.31L12.85 4.3L12.48 4.31L12.12 4.36L11.52 4.49L10.96 4.7L10.43 4.98L9.94 5.32L9.5 5.72L9.1 6.16L8.77 6.66L8.55 7.09L8.34 7.65L8.22 8.13L8.17 8.5L8.15 8.88L8.16 8.98L8.21 9.07L8.31 9.16L8.44 9.19L9.79 9.19L9.93 9.15L10.03 9.08L10.1 8.96L10.16 8.56L10.23 8.26L10.32 7.99L10.47 7.66L10.61 7.43L10.77 7.21L10.96 7.01L11.21 6.79L11.43 6.65L11.72 6.49L11.97 6.39L12.23 6.32L12.57 6.27L12.85 6.26L13.12 6.27L13.5 6.32L13.62 6.29L13.72 6.24L13.82 6.13L13.85 6Z",
        "fill": "#96ff7a"
      },
      {
        "type": "polygon",
        "d": "M8.15 13.24L8.17 13.35L8.22 13.44L8.3 13.51L8.4 13.54L8.77 13.59L9.15 13.6L9.52 13.59L9.89 13.54L10.48 13.41L11.04 13.2L11.57 12.92L12.06 12.58L12.5 12.18L12.9 11.74L13.23 11.24L13.45 10.81L13.66 10.25L13.78 9.77L13.83 9.4L13.85 9.02L13.84 8.92L13.79 8.83L13.69 8.74L13.56 8.71L12.21 8.71L12.07 8.75L11.97 8.82L11.9 8.94L11.84 9.34L11.77 9.64L11.68 9.91L11.53 10.24L11.39 10.47L11.23 10.69L11.04 10.89L10.79 11.11L10.57 11.25L10.28 11.41L10.03 11.51L9.77 11.58L9.43 11.63L9.15 11.64L8.89 11.63L8.5 11.58L8.38 11.61L8.28 11.66L8.18 11.77L8.15 11.9Z",
        "fill": "accent"
      }
    ],
    "3pe-express": [
      {
        "type": "polygon",
        "d": "M2.3 11.03L6.15 11.03L5.93 11.48L2.3 11.48Z",
        "fill": "#e77b17"
      },
      {
        "type": "polygon",
        "d": "M14.83 11.03L19.7 11.03L19.7 11.48L14.63 11.48Z",
        "fill": "#e77b17"
      },
      {
        "type": "polygon",
        "d": "M2.3 11.92L5.33 11.92L3.76 12.37L2.3 12.37Z",
        "fill": "#e77b17"
      },
      {
        "type": "polygon",
        "d": "M14.43 11.92L19.7 11.92L19.7 12.37L15.51 12.37Z",
        "fill": "#e77b17"
      },
      {
        "type": "polygon",
        "d": "M2.3 12.8L3.76 12.8L3.76 13.25L2.3 13.25Z",
        "fill": "#e77b17"
      },
      {
        "type": "polygon",
        "d": "M15.51 12.8L19.7 12.8L19.7 13.25L15.51 13.25Z",
        "fill": "#e77b17"
      },
      {
        "type": "line",
        "d": "M7.54 5.2L9.39 5.2L9.49 5.21L9.58 5.24L9.65 5.29L9.71 5.36L9.74 5.44L9.75 5.54L9.73 5.64L9.69 5.75L8.28 8.9L6.48 8.9M8.28 8.9L7.44 10.75M9.42 10.75L11.92 5.2L13.77 5.2L13.87 5.21L13.96 5.24L14.03 5.29L14.08 5.36L14.11 5.44L14.12 5.54L14.11 5.64L14.07 5.75L13.09 7.92L12.96 8.16L12.79 8.38L12.59 8.59L12.36 8.77L12.11 8.92L11.85 9.03L11.59 9.1L11.35 9.12L10.15 9.12M18.39 5.2L16.29 5.2L13.79 10.75M14.62 8.9L16.41 8.9",
        "stroke": "accent",
        "strokeWidth": 1.3
      },
      {
        "type": "polygon",
        "d": "M6.53 11.03L14.7 11.03L14.7 10.47L6.53 10.47Z",
        "fill": "truck"
      },
      {
        "type": "polygon",
        "d": "M6.6 11.03L6.41 11.44L6.21 11.67L6.08 11.77L5.81 11.91L5.58 11.95L4.21 11.95L4.21 13.25L5.64 13.25L5.93 13.22L6.24 13.14L6.54 13.01L6.82 12.84L7.08 12.64L7.31 12.41L7.5 12.15L7.64 11.89L8.03 11.03Z",
        "fill": "#e77b17"
      },
      {
        "type": "polygon",
        "d": "M8.58 11.03L7.58 13.25L9.01 13.25L10 11.03Z",
        "fill": "#e77b17"
      },
      {
        "type": "polygon",
        "d": "M12.49 12.06L12.44 12.2L12.41 12.39L12.43 12.61L12.51 12.83L12.66 13.02L12.85 13.16L13.06 13.23L13.23 13.25L15.06 13.25L15.06 11.95L13.96 11.95L14.38 11.03L12.95 11.03Z",
        "fill": "#e77b17"
      }
    ],
    "xinghe-freight": [
      {
        "type": "line",
        "d": "M3.45 6.59L5.41 12.01M5.41 6.59L3.45 12.01M6.88 6.43L6.88 12.18M8.38 12.18L8.38 6.9L8.66 6.9L9.73 11.7L10.01 11.7L10.01 6.43M13 7.25L12.82 7.06L12.59 6.94L12.34 6.9L12.08 6.94L11.85 7.05L11.67 7.23L11.55 7.46L11.51 7.72L11.51 10.88L11.57 11.2L11.75 11.46L12.02 11.64L12.33 11.7L12.64 11.64L12.9 11.46L13.08 11.2L13.14 10.88L13.14 9.54L12.33 9.54M14.64 6.43L14.64 12.18M16.22 6.43L16.22 12.18M14.64 9.3L16.22 9.3M19 6.9L17.72 6.9L17.72 11.7L19 11.7M17.72 9.3L18.81 9.3",
        "stroke": "accent",
        "strokeWidth": 0.95
      }
    ],
    "instapack": [
      {
        "type": "circle",
        "cx": 12,
        "cy": 9.3,
        "r": 5.55,
        "fill": "accent"
      },
      {
        "type": "circle",
        "cx": 12,
        "cy": 9.3,
        "r": 5.05,
        "fill": "truck"
      },
      {
        "type": "polygon",
        "d": "M9.06 10.77L8.85 10.72L8.49 10.69L8.29 10.62L8.12 10.53L7.95 10.4L7.82 10.22L7.71 10.03L7.66 9.91L7.63 9.75L7.62 9.62L7.64 9.48L7.7 9.32L7.79 9.2L7.88 9.12L8.01 9.05L8.18 9.02L8.31 9.02L8.52 9.06L8.8 9.17L8.97 9.28L9.15 9.41L9.35 9.47L9.42 9.51L9.48 9.57L9.53 9.67L9.54 9.81L9.43 10.15L9.35 10.56L9.31 10.63L9.24 10.7L9.17 10.74Z",
        "fill": "accent"
      },
      {
        "type": "line",
        "d": "M12.92 7.64L12.19 7.54L11.63 7.42L11.15 7.28L10.72 7.13L10.43 6.99L10.15 6.82L9.9 6.64L9.61 6.35L9.53 6.22L9.48 6.06L9.47 5.95L9.49 5.88L9.55 5.81L9.64 5.77L10.1 5.74L10.63 5.82L11.1 5.93L11.48 6.05L11.91 6.11L11.96 6.09L11.98 6.05L12.01 5.78L12.04 5.68L12.11 5.61L12.19 5.59L12.52 5.63L13.01 5.85L13.55 6.17L13.93 6.47L14.21 6.75L14.38 6.97L14.55 7.24L14.82 7.89L14.93 7.99L15.42 8.26L15.78 8.6L15.93 8.8L16.02 8.97L16.11 9.31L16.09 9.56L16.02 9.76L15.87 9.92L15.67 10.04L15.42 10.12L15.1 10.16L14.33 10.09L14.25 10.12L14.22 10.19L14.17 10.95L14.11 11.22L13.97 11.59L13.83 11.85L13.62 12.12L13.38 12.35L13.11 12.55L12.67 12.78L12.31 12.9L11.98 12.97L11.61 13.01L11.23 13L10.88 12.95L10.47 12.84M13.85 7.51L13.62 7.21L13.24 6.89L12.84 6.63L12.15 6.29L11.96 6.12M8.81 10L9.03 9.82L9.41 9.59L9.86 9.03L10.12 8.8L10.39 8.61L10.65 8.47L10.95 8.36L11.26 8.29L11.68 8.25L12.12 8.29L12.52 8.38L12.88 8.5L13.31 8.73L13.57 8.96L13.84 9.29L13.97 9.5L14.24 10.09M8.8 10.02L8.9 10.19L9.15 10.52L9.22 10.96L9.34 11.25L9.56 11.53L9.86 11.81L10.25 12.02L10.49 12.1L10.78 12.15L11.25 12.18L11.58 12.14L11.89 12.07L12.47 11.84L12.69 11.7L12.91 11.52L13.1 11.29L13.21 11.12L13.31 10.89L13.37 10.6L13.38 10.42L13.33 10.1L13.25 9.89L13.16 9.73L12.98 9.53L12.78 9.37L12.54 9.24L12.25 9.14L12.01 9.09L11.68 9.07L11.26 9.12L10.92 9.21L10.63 9.35L10.39 9.52L10.15 9.76L10 9.97L9.91 10.27L9.91 10.59L9.99 10.82L10.17 11.03L10.42 11.19L10.76 11.31L11.12 11.36L11.53 11.35L11.81 11.3L12.15 11.16L12.33 11L12.47 10.79L12.52 10.49L12.46 10.17L12.4 10.06L12.28 9.92L12.06 9.76L11.76 9.68L11.51 9.71L11.26 9.82L11.06 10.03L11.01 10.17L11 10.3L11.06 10.5L11.23 10.64L11.49 10.7",
        "stroke": "accent",
        "strokeWidth": 0.55
      }
    ],
    "obibox": [
      {
        "type": "polygon",
        "d": "M12.88 4.7L13.35 4.74L13.81 4.86L14.24 5.06L14.63 5.34L14.96 5.67L15.24 6.06L15.44 6.49L15.56 6.95L15.6 7.42L15.6 11.18L15.56 11.65L15.44 12.11L15.24 12.54L14.96 12.93L14.63 13.26L14.24 13.54L13.81 13.74L13.35 13.86L12.88 13.9L9.12 13.9L8.65 13.86L8.19 13.74L7.76 13.54L7.37 13.26L7.04 12.93L6.76 12.54L6.56 12.11L6.44 11.65L6.4 11.18L6.4 7.42L6.44 6.95L6.56 6.49L6.76 6.06L7.04 5.67L7.37 5.34L7.76 5.06L8.19 4.86L8.65 4.74L9.12 4.7Z",
        "fill": "accent"
      },
      {
        "type": "polygon",
        "d": "M8.38 6.68L13.62 6.68L13.62 11.92L8.38 11.92Z",
        "fill": "truck"
      }
    ],
    "avis-logistics": [
      {
        "type": "line",
        "d": "M3.6 12.8L6.1 6.2L7.2 6.2L7.2 12.8M4.5 10.42L7.2 10.42M10.45 12.8L12.25 6.2M13.8 6.2L13.8 12.8M17.94 7.32L17.68 7.05L17.36 6.85L17 6.75L16.62 6.73L16.25 6.81L15.92 6.98L15.64 7.22L15.44 7.53L15.32 7.87L15.31 8.23L15.39 8.59L15.56 8.91L15.82 9.18L16.14 9.37L16.5 9.48L16.75 9.5L17.13 9.55L17.48 9.69L17.78 9.91L18.01 10.19L18.15 10.53L18.2 10.89L18.15 11.25L18.01 11.58L17.78 11.87L17.48 12.09L17.13 12.23L16.75 12.27L16.37 12.23L16.03 12.09L15.72 11.87",
        "stroke": "accent",
        "strokeWidth": 1.35
      },
      {
        "type": "polygon",
        "d": "M7.96 6.15L7.9 6.81L7.9 7.47L8 8.1L8.17 8.71L8.37 9.31L8.61 9.89L8.89 10.45L9.19 10.99L9.51 11.52L9.86 12.03L10.22 12.52L10.6 13L10.5 12.4L10.42 11.81L10.33 11.21L10.25 10.62L10.16 10.03L10.06 9.44L9.95 8.85L9.83 8.27L9.7 7.68L9.51 7.1L9.25 6.53L8.94 5.95Z",
        "fill": "#ed6b50"
      }
    ],
    "dakota-cargo": [
      {
        "type": "polygon",
        "d": "M14.12 4.95L12.73 8.01L8.96 8.01L8.96 11.3L11.31 11.3L10.98 12.02L6.8 12.02L6.47 11.4L6.22 10.74L6.06 10.04L6 9.34L6.04 8.63L6.17 7.93L6.4 7.26L6.71 6.62L7.11 6.04L7.59 5.51L8.13 5.05L8.73 4.68L9.37 4.38L10.05 4.18L10.75 4.07L11.46 4.06L12.17 4.14L12.85 4.32L13.51 4.59Z",
        "fill": "accent"
      },
      {
        "type": "polygon",
        "d": "M14.82 5.51L13.29 8.87L9.74 8.87L9.74 10.5L12.55 10.5L11.48 12.84L7.44 12.84L7.97 13.32L8.56 13.73L9.2 14.05L9.89 14.28L10.59 14.41L11.31 14.45L12.03 14.38L12.73 14.22L13.4 13.96L14.03 13.62L14.6 13.18L15.11 12.68L15.55 12.11L15.9 11.48L16.16 10.81L16.33 10.11L16.4 9.4L16.37 8.68L16.24 7.97L16.02 7.29L15.7 6.64L15.3 6.05Z",
        "fill": "#ff0000"
      }
    ],
    "sentral-cargo": [
      {
        "type": "polygon",
        "d": "M6.62 6.75L11 4L11 6.75L6.62 9.5Z",
        "fill": "accent"
      },
      {
        "type": "polygon",
        "d": "M6.62 9.5L8.81 8.12L11 9.5L11 12.25Z",
        "fill": "#a81c21"
      },
      {
        "type": "polygon",
        "d": "M11 6.75L15.38 9.5L13.19 10.88L11 9.5Z",
        "fill": "#4e4e4d"
      },
      {
        "type": "polygon",
        "d": "M11 12.25L15.38 9.5L15.38 12.25L11 15Z",
        "fill": "accent"
      }
    ],
    "depo": [
      {
        "type": "polygon",
        "d": "M16.89 6.46L16.4 5.9L15.86 5.49L15.22 5.18L14.53 5.02L13.91 4.99L13.27 5.06L12.52 4.97L11.79 5.01L10.93 5.21L10.1 5.61L9.53 6.02L9.01 6.55L8.61 7.12L8.29 7.78L8.06 8.64L8.01 9.5L8.12 10.35L8.39 11.13L7.96 11.17L7.65 11.39L7.55 11.7L7.66 12.07L8.14 12.64L8.7 13.09L9.34 13.41L10.07 13.58L10.73 13.61L11.43 13.52L12.21 13.62L12.99 13.59L13.85 13.38L14.68 12.99L15.27 12.55L15.8 12L16.2 11.39L16.51 10.69L16.7 9.89L16.73 9.09L16.61 8.27L16.32 7.48L16.73 7.39L16.99 7.14L17.05 6.81Z",
        "fill": "#220a0c"
      },
      {
        "type": "circle",
        "cx": 12.38,
        "cy": 9.31,
        "r": 2,
        "fill": "truck"
      },
      {
        "type": "polygon",
        "d": "M9.74 4.55L9.36 4.31L9.17 4.32L8.96 4.43L8.56 4.87L7.93 5.89L7.55 6.69L7.42 7.26L7.52 7.6L7.9 7.85L8.42 7.9L9.22 7.87L10.57 7.73L11.14 7.6L11.35 7.48L11.43 7.31L11.4 7.03L11.21 6.68L11.35 6.52L11.8 6.21L12.33 5.94L13.55 5.59L14.58 5.52L15.57 5.66L16.36 5.98L16.89 6.45L16.28 5.65L15.53 4.97L14.66 4.44L13.69 4.08L12.69 3.91L11.68 3.94L10.7 4.14Z",
        "fill": "accent"
      },
      {
        "type": "polygon",
        "d": "M14.31 10.83L13.6 10.95L13.24 11.14L13.17 11.45L13.39 11.95L13.02 12.25L12.22 12.69L11.28 12.97L10.19 13.08L9.13 12.97L8.27 12.64L7.94 12.41L7.71 12.15L8.32 12.95L9.05 13.61L9.91 14.14L10.85 14.5L11.69 14.67L12.55 14.69L13.72 14.51L14.86 14.05L15.13 14.26L15.4 14.29L15.64 14.17L15.91 13.9L16.67 12.72L17.11 11.76L17.18 11.4L17.16 11.14L16.91 10.84L16.45 10.71L15.53 10.72Z",
        "fill": "accent"
      }
    ],
    "e-cargo": [
      {
        "type": "polygon",
        "d": "M3.75 8.42L3.76 9.54L3.85 10.05L4.02 10.63L4.27 11.18L4.5 11.53L5.05 12.16L5.48 12.5L5.93 12.78L6.44 13.02L7.01 13.22L7.83 13.37L8.27 13.37L8.95 13.29L9.84 13.03L10.63 12.65L11.3 12.16L11.88 11.49L12.23 10.88L12.5 10.15L12.66 9.25L12.71 8.2L12.82 7.8L13.05 7.38L13.41 7L13.74 6.77L14.19 6.57L14.66 6.45L15.24 6.42L15.74 6.49L16.29 6.68L16.7 6.9L17.26 7.3L17.39 6.9L17.63 6.41L17.89 6.03L18.25 5.63L17.75 5.17L17.03 4.75L16.37 4.5L15.62 4.34L14.78 4.33L14.36 4.4L13.65 4.59L12.95 4.91L12.36 5.3L11.85 5.77L11.38 6.37L11.01 7.03L10.81 7.55L10.7 8.05L10.63 9.5L10.51 9.88L10.31 10.24L9.99 10.59L9.5 10.92L9.06 11.13L8.6 11.26L8.01 11.29L7.38 11.16L6.85 10.92L6.35 10.49L5.97 9.88L5.82 9.43L5.76 9.04L5.76 8.59L5.86 8.13L6.08 7.62L6.35 7.22L6.62 6.95L6.91 6.75L7.37 6.55L7.87 6.45L8.51 6.45L8.82 6.5L8.91 6.56L8.89 6.67L6.33 9.32L6.54 9.86L6.92 10.35L7.42 10.66L7.63 10.73L7.77 10.7L10.21 8.25L10.29 7.6L10.52 6.93L10.84 6.36L11.37 5.71L11.06 5.37L10.46 4.95L10.01 4.72L9.43 4.52L8.95 4.42L8.34 4.37L7.66 4.4L7.11 4.48L6.71 4.59L6.1 4.88L5.61 5.19L5.18 5.53L4.76 5.97L4.43 6.41L4.02 7.23L3.86 7.74Z",
        "fill": "accent"
      },
      {
        "type": "polygon",
        "d": "M12.02 12.03L12.13 12.17L12.63 12.53L13.42 12.94L14.24 13.19L15.13 13.3L15.87 13.25L16.72 12.99L17.33 12.68L18.11 12.07L17.56 11.29L17.2 10.44L16.66 10.78L15.89 11.11L15.34 11.22L14.79 11.22L14.19 11.08L13.77 10.88L13.34 10.56L12.93 10.15L12.58 11.14L12.3 11.65Z",
        "fill": "accent"
      }
    ],
    "sengi-express": [
      {
        "type": "polygon",
        "d": "M7.21 11.17L6.78 10.01L6.62 8.86L6.74 7.79L7.07 6.77L7.65 5.74L8.27 5.03L9.13 4.37L10.04 3.93L11.14 3.64L12.13 3.6L13.23 3.76L14.3 4.17L15.12 4.71L15.83 5.42L16.44 6.32L16.98 7.46L16.97 7.53L16.84 7.46L16.44 6.85L15.74 6.18L14.83 5.62L13.97 5.24L13.15 5.04L12.29 4.99L11.47 5.08L10.61 5.32L9.83 5.69L9.13 6.18L8.42 6.89L7.93 7.59L7.53 8.41L7.24 9.39L7.19 9.88Z",
        "fill": "#102a83"
      },
      {
        "type": "polygon",
        "d": "M11.14 14.21L10.16 13.84L9.38 13.34L8.8 12.75L8.29 12.02L7.98 11.28L7.77 10.25L7.77 9.31L7.98 8.45L8.39 7.51L8.88 6.85L9.42 6.35L10.2 5.85L11.06 5.52L12.01 5.36L12.95 5.4L13.69 5.56L14.1 5.73L14.18 5.84L13.11 5.85L12.05 6.06L11.23 6.4L10.61 6.8L10.06 7.34L9.69 7.83L9.12 9.06L9 9.64L8.97 10.5L9.08 11.28L9.33 12.06L9.62 12.63L10.03 13.21Z",
        "fill": "#008bd0"
      },
      {
        "type": "polygon",
        "d": "M13.6 13.74L12.95 13.75L12.21 13.66L11.47 13.47L10.9 13.22L10.32 12.85L9.96 12.5L9.57 11.98L9.37 11.52L9.24 11.03L9.21 10.21L9.33 9.47L9.53 8.86L9.86 8.16L10.19 7.67L10.65 7.21L11.06 6.96L11.03 7.1L10.47 7.96L10.23 8.78L10.19 9.93L10.39 10.83L10.69 11.44L11.09 12.02L11.6 12.52L12.13 12.86L12.74 13.09L13.36 13.22L15.45 13.37L14.51 13.63Z",
        "fill": "#009ee0"
      },
      {
        "type": "line",
        "d": "M14 8.25L13.99 8L13.91 7.78L13.76 7.61L13.55 7.5L13.3 7.46L13.03 7.5L12.74 7.61L12.47 7.78L12.23 8L12.03 8.25L11.9 8.53L11.83 8.8L11.84 9.06L11.92 9.28L12.07 9.45L12.28 9.55L12.53 9.59L12.8 9.63L13.03 9.74L13.19 9.93L13.28 10.17L13.29 10.44L13.22 10.74L13.07 11.04L12.86 11.32L12.6 11.56L12.3 11.74L11.99 11.85L11.69 11.89L11.42 11.85L11.19 11.74L11.03 11.56L10.94 11.32L10.93 11.04",
        "stroke": "accent",
        "strokeWidth": 0.85
      }
    ],
    "trans-ontario": [
      {
        "type": "polygon",
        "d": "M14.82 12.03L14.13 12.61L13.39 13.1L12.61 13.49L11.81 13.77L11.01 13.92L10.23 13.96L9.5 13.87L8.82 13.65L8.22 13.33L7.7 12.89L7.29 12.36L7 11.74L6.82 11.05L6.77 10.31L6.84 9.54L7.04 8.75L7.36 7.96L7.78 7.2L8.31 6.49L8.93 5.83L9.62 5.25L10.36 4.75L11.14 4.37L11.94 4.09L12.74 3.93L13.52 3.9L14.25 3.99L14.93 4.2L15.53 4.53L16.05 4.97L16.45 5.5L16.75 6.12L16.93 6.8L16.98 7.54L16.91 8.32L16.71 9.11L16.39 9.89L15.96 10.65L15.44 11.37Z",
        "fill": "accent"
      },
      {
        "type": "polygon",
        "d": "M15.02 10.28L14.69 10.91L14.3 11.48L13.85 12L13.35 12.43L12.81 12.78L12.26 13.04L11.69 13.19L11.13 13.24L10.59 13.18L10.08 13.01L9.62 12.75L9.22 12.39L8.88 11.94L8.61 11.42L8.43 10.83L8.33 10.2L8.32 9.54L8.4 8.86L8.56 8.18L8.81 7.52L9.14 6.89L9.53 6.32L9.98 5.8L10.48 5.37L11.01 5.02L11.57 4.76L12.14 4.61L12.69 4.56L13.24 4.62L13.74 4.79L14.21 5.05L14.61 5.41L14.95 5.86L15.22 6.38L15.4 6.97L15.5 7.6L15.51 8.26L15.43 8.94L15.26 9.62Z",
        "fill": "truck"
      },
      {
        "type": "polygon",
        "d": "M12.17 14.1L12.1 14.09L12.1 13.82L12.81 13.04L12.99 12.36L13.23 12.26L13.59 12.49L13.7 12.4L13.7 11.96L13.15 11.41L11.33 11.33L10.96 10.79L10.99 10.24L9.32 9.33L8.32 10.04L6.22 8.95L6.58 6.56L9.07 4.53L9.34 4.42L9.42 4.42L10.2 5L10.92 5.19L11.75 5.18L12.28 5.65L12.31 6.48L13.62 7.98L13.88 10.79L14.35 11.35L14.92 11.29L15.32 11.62L16.09 11.91L15.39 12.64L14.65 12.58L13.72 13.14L13.72 13.19L14.29 13.33L13.86 13.66L13.5 13.71Z",
        "fill": "#000000"
      }
    ],
    "pallex": [
      {
        "type": "line",
        "d": "M3.57 10.9L3.57 6.9L3.91 6.9L4.35 6.99L4.73 7.24L4.98 7.62L5.07 8.06L4.98 8.5L4.73 8.88L4.35 9.13L3.91 9.22L3.57 9.22M5.75 10.9L6.58 6.9L6.93 6.9L7.75 10.9M5.98 9.78L7.52 9.78M8.98 6.9L8.98 10.9L10.23 10.9M11.02 6.9L11.02 10.9L12.27 10.9M15.87 6.9L14.52 6.9L14.52 8.15L15.27 8.9L14.52 9.65L14.52 10.9L15.87 10.9M15.27 8.9L15.74 8.9M16.62 6.9L18.47 10.9M18.47 6.9L16.62 10.9",
        "stroke": "accent",
        "strokeWidth": 0.9
      },
      {
        "type": "polygon",
        "d": "M12.61 7.3L14.21 8.9L12.61 10.5Z",
        "fill": "accent"
      }
    ],
    "airmee": [
      {
        "type": "polygon",
        "d": "M6.83 6.59L6.83 8.64L10.33 8.64L10.04 8.99L9.71 9.4L9.35 9.84L8.99 10.29L8.65 10.71L8.33 11.09L8.18 11.25L8.03 11.39L7.87 11.49L7.69 11.57L7.5 11.62L7.27 11.63L6.83 11.63L6.83 13.7L7.26 13.7L7.86 13.67L8.39 13.56L8.86 13.35L9.33 13.01L9.84 12.5L10.42 11.81L11.77 10.14L11.77 13.7L13.76 13.7L13.76 6.59Z",
        "fill": "accent"
      },
      {
        "type": "polygon",
        "d": "M13.76 4.3L16.17 4.3L16.17 6.59L13.76 6.59Z",
        "fill": "accent"
      }
    ],
    "fofr": [
      {
        "type": "polygon",
        "d": "M7.52 7.35L8.01 7.18L8.03 7.12L6.75 6.27L6.77 6.13L7.33 6.01L8.68 6.9L9.16 6.75L9.17 6.68L7.45 5.63L5.76 6.07L7.44 7.34Z",
        "fill": "#fdb934"
      },
      {
        "type": "polygon",
        "d": "M5.26 8.17L7.27 7.44L7.28 7.39L5.53 6.11L3.48 6.67L3.48 6.71L3.98 7.11L5 6.83L5.02 6.79L4.85 6.67L4.88 6.58L6.08 6.81L6.01 7.53L5.65 7.32L4.65 7.65L5.2 8.16Z",
        "fill": "#fdb934"
      },
      {
        "type": "polygon",
        "d": "M4.72 10.36L5.11 8.29L4.56 7.8L4.51 7.79L4.28 9.39L4.19 9.46L3.67 8.92L3.88 7.24L3.37 6.82L3.18 8.83L4.65 10.34Z",
        "fill": "#fdb934"
      },
      {
        "type": "polygon",
        "d": "M6.98 9.53L8.57 8.76L9.24 6.95L9.23 6.88L8.73 7.1L8.42 7.95L8.44 7.99L8.6 7.93L8.6 8.06L7.91 8.83L7.53 8.48L7.52 8.39L7.81 8.2L8.08 7.32L8.03 7.31L7.54 7.52L6.95 9.49Z",
        "fill": "#fdb934"
      },
      {
        "type": "polygon",
        "d": "M4.92 10.41L6.78 9.54L7.31 7.58L5.29 8.34L4.88 10.35L4.88 10.4Z",
        "fill": "#fdb934"
      },
      {
        "type": "polygon",
        "d": "M2.99 10.63L2.99 10.79L3.02 10.77L4.34 12.29L4.43 11.8L3.81 11.1L3.72 11.23L3.64 11.19L3.31 10.22L3.86 10.1L3.88 10.43L4.55 11.14L4.68 10.57L3.16 9.08L3.06 10.49Z",
        "fill": "#fdb934"
      },
      {
        "type": "polygon",
        "d": "M4.53 12.35L6.32 11.36L6.77 9.74L4.86 10.6L4.73 11.11L4.75 11.18L6.14 10.48L6.22 10.6L6.03 11.11L4.61 11.85L4.5 12.3Z",
        "fill": "#fdb934"
      },
      {
        "type": "line",
        "d": "M9.85 9.38L8.18 9.38L7.41 13.01M7.79 11.2L9.21 11.2M12.22 11.2L12.09 11.67L11.9 12.1L11.67 12.48L11.41 12.77L11.15 12.95L10.89 13.01L10.66 12.95L10.47 12.77L10.33 12.48L10.26 12.1L10.26 11.67L10.33 11.2L10.46 10.73L10.65 10.29L10.87 9.91L11.13 9.62L11.4 9.44L11.65 9.38L11.89 9.44L12.08 9.62L12.21 9.91L12.28 10.29L12.28 10.73L12.22 11.2L12.09 11.67M15.68 9.38L14.01 9.38L13.25 13.01M13.63 11.2L15.05 11.2M15.95 13.01L16.71 9.38L17.75 9.38L18.11 9.45L18.39 9.67L18.54 10L18.54 10.38L18.38 10.76L18.09 11.08L17.72 11.3L17.33 11.38L16.29 11.38M17.1 11.38L17.98 13.01",
        "stroke": "accent",
        "strokeWidth": 0.94
      }
    ],
    "akis-express": [
      {
        "type": "polygon",
        "d": "M4.7 3.9L17.3 3.9L17.3 8.77L4.7 8.77Z",
        "fill": "#014c99"
      },
      {
        "type": "polygon",
        "d": "M4.7 8.77L17.3 8.77L17.3 13.64L4.7 13.64Z",
        "fill": "#ede049"
      },
      {
        "type": "line",
        "d": "M7.77 4.78L7.49 4.53L7.14 4.38L6.77 4.34L6.4 4.41L6.07 4.59L5.81 4.86L5.64 5.2L5.59 5.57L5.68 7.56L5.95 7.97L6.35 8.23L6.82 8.33L7.3 8.23L7.7 7.97L7.97 7.56L8.06 7.09L8.06 6.53L6.82 6.53M9.51 8.33L10.89 4.34L11.11 4.34L12.5 8.33M9.89 7.21L12.11 7.21M14.17 8.33L14.17 4.34L15.29 4.34L15.72 4.42L16.08 4.66L16.32 5.03L16.41 5.45L16.32 5.88L16.08 6.24L15.72 6.49L15.29 6.57L14.17 6.57",
        "stroke": "accent",
        "strokeWidth": 0.88
      },
      {
        "type": "line",
        "d": "M5.52 13.01L6.76 9.4L6.98 9.4L8.22 13.01M5.87 12L7.88 12M9.5 9.4L9.5 13.01M11.77 9.4L9.5 11.56M10.41 10.7L11.77 13.01M13.02 9.4L13.02 13.01M16.27 9.82L15.73 9.4L15.01 9.4L14.47 9.82L14.34 10.44L14.71 10.98L15.37 11.2L16.06 11.42L16.43 11.97L16.3 12.59L15.74 13.01L15 13.01L14.44 12.59",
        "stroke": "truck",
        "strokeWidth": 0.79
      }
    ],
    "collicare": [
      {
        "type": "polygon",
        "d": "M13.69 11.07L13.28 11.4L13.05 11.53L12.74 11.66L12.23 11.78L11.7 11.79L11.18 11.7L10.69 11.49L10.26 11.19L9.89 10.81L9.62 10.36L9.44 9.86L9.37 9.34L9.41 8.81L9.56 8.31L9.67 8.07L9.85 7.79L10.2 7.39L10.63 7.08L10.31 7.18L10.01 7.31L9.72 7.48L9.45 7.68L9.21 7.91L8.99 8.16L8.8 8.44L8.61 8.79L8.49 9.1L8.39 9.49L8.33 9.89L8.31 10.29L8.33 10.62L8.38 11.02L8.48 11.41L8.61 11.79L8.78 12.15L8.99 12.49L9.22 12.81L9.49 13.1L10.04 13.57L10.37 13.78L10.73 13.96L11.29 14.16L11.92 14.28L12.54 14.3L13.17 14.22L13.87 14.02L14.5 13.74L14.99 13.44L15.52 12.99L15.69 12.83L13.81 10.95Z",
        "fill": "accent"
      },
      {
        "type": "polygon",
        "d": "M8.38 12.53L8.07 11.87L7.87 11.18L7.78 10.46L7.81 9.73L7.94 9.09L8.18 8.46L8.53 7.89L8.98 7.39L9.51 6.98L10.06 6.71L10.38 6.6L10.7 6.53L11.02 6.49L11.35 6.48L11.99 6.57L12.62 6.78L13.23 7.11L13.47 7.28L13.82 7.59L15.68 5.73L15.27 5.35L14.91 5.06L14.47 4.78L14.06 4.57L13.57 4.37L13.06 4.23L12.54 4.14L12.09 4.1L11.62 4.1L11.1 4.16L10.59 4.26L10.08 4.42L9.66 4.6L9.2 4.85L8.76 5.15L8.36 5.49L7.99 5.87L7.67 6.28L7.39 6.72L7.15 7.2L6.96 7.69L6.81 8.26L6.74 8.78L6.71 9.31L6.75 9.9L6.87 10.54L7.04 11.11L7.29 11.65L7.55 12.11L7.86 12.53L8.21 12.92L8.65 13.32L9.13 13.66L9.65 13.95L9.29 13.66L8.92 13.29L8.63 12.92Z",
        "fill": "accent"
      }
    ],
    "western-bid": [
      {
        "type": "polygon",
        "d": "M3.22 5.35L6.44 5.35L6.58 5.37L6.72 5.42L6.83 5.5L6.93 5.61L12.12 13.45L8.89 13.45L8.75 13.43L8.61 13.38L8.5 13.3L8.4 13.19Z",
        "fill": "accent"
      },
      {
        "type": "polygon",
        "d": "M8.41 5.35L11.62 5.35L11.76 5.37L11.9 5.42L12.01 5.5L12.11 5.61L17.3 13.45L14.09 13.45L13.94 13.43L13.81 13.38L13.69 13.3L13.6 13.19Z",
        "fill": "accent"
      },
      {
        "type": "polygon",
        "d": "M15.08 5.61L15.17 5.5L15.29 5.42L15.42 5.37L15.57 5.35L18.78 5.35L16.1 9.41L14.46 6.94L14.41 6.84L14.4 6.74L14.41 6.64L14.46 6.55Z",
        "fill": "#aae2d6"
      }
    ],
    "ace-lt": [
      {
        "type": "line",
        "d": "M7.41 11.58L7.41 8.7L7.38 8.44L7.29 8.18L7.14 7.95L6.94 7.73L6.69 7.55L6.4 7.4L6.09 7.3L5.75 7.23L5.41 7.22L5.06 7.25L4.73 7.32L4.42 7.44L4.14 7.59L3.9 7.79M7.41 9.37L4.97 9.37L4.79 9.39L4.61 9.44L4.45 9.52L4.3 9.63L4.18 9.77L4.07 9.92L4 10.1L3.95 10.28L3.93 10.48L3.95 10.67L4 10.86L4.07 11.03L4.18 11.19L4.3 11.32L4.45 11.43L4.61 11.52L4.79 11.57L4.97 11.58L7.41 11.58M12.52 7.94L12.26 7.67L11.97 7.46L11.65 7.32L11.31 7.23L10.96 7.22L10.62 7.28L10.29 7.4L9.98 7.59L9.71 7.83L9.48 8.12L9.3 8.46L9.18 8.82L9.12 9.21L9.12 9.59L9.18 9.98L9.3 10.34L9.48 10.68L9.71 10.97L9.98 11.21L10.29 11.4L10.62 11.52L10.96 11.58L11.31 11.57L11.65 11.48L11.97 11.34L12.26 11.13L12.52 10.86M14 9.33L18.07 9.33L18.02 8.95L17.92 8.58L17.76 8.24L17.54 7.93L17.28 7.67L16.98 7.47L16.65 7.32L16.3 7.24L15.94 7.22L15.59 7.27L15.25 7.39L14.93 7.56L14.65 7.8L14.41 8.08L14.22 8.41L14.09 8.76L14.01 9.14L14 9.52L14.05 9.9L14.16 10.26L14.33 10.6L14.55 10.9L14.82 11.15L15.12 11.35L15.46 11.49L15.81 11.57L16.16 11.58L16.52 11.52L16.85 11.4L17.17 11.21L17.44 10.97L17.68 10.68",
        "stroke": "accent",
        "strokeWidth": 1.26
      }
    ],
    "ace-lv": [
      {
        "type": "line",
        "d": "M7.41 11.58L7.41 8.7L7.38 8.44L7.29 8.18L7.14 7.95L6.94 7.73L6.69 7.55L6.4 7.4L6.09 7.3L5.75 7.23L5.41 7.22L5.06 7.25L4.73 7.32L4.42 7.44L4.14 7.59L3.9 7.79M7.41 9.37L4.97 9.37L4.79 9.39L4.61 9.44L4.45 9.52L4.3 9.63L4.18 9.77L4.07 9.92L4 10.1L3.95 10.28L3.93 10.48L3.95 10.67L4 10.86L4.07 11.03L4.18 11.19L4.3 11.32L4.45 11.43L4.61 11.52L4.79 11.57L4.97 11.58L7.41 11.58M12.52 7.94L12.26 7.67L11.97 7.46L11.65 7.32L11.31 7.23L10.96 7.22L10.62 7.28L10.29 7.4L9.98 7.59L9.71 7.83L9.48 8.12L9.3 8.46L9.18 8.82L9.12 9.21L9.12 9.59L9.18 9.98L9.3 10.34L9.48 10.68L9.71 10.97L9.98 11.21L10.29 11.4L10.62 11.52L10.96 11.58L11.31 11.57L11.65 11.48L11.97 11.34L12.26 11.13L12.52 10.86M14 9.33L18.07 9.33L18.02 8.95L17.92 8.58L17.76 8.24L17.54 7.93L17.28 7.67L16.98 7.47L16.65 7.32L16.3 7.24L15.94 7.22L15.59 7.27L15.25 7.39L14.93 7.56L14.65 7.8L14.41 8.08L14.22 8.41L14.09 8.76L14.01 9.14L14 9.52L14.05 9.9L14.16 10.26L14.33 10.6L14.55 10.9L14.82 11.15L15.12 11.35L15.46 11.49L15.81 11.57L16.16 11.58L16.52 11.52L16.85 11.4L17.17 11.21L17.44 10.97L17.68 10.68",
        "stroke": "accent",
        "strokeWidth": 1.26
      }
    ],
    "kuayue-express": [
      {
        "type": "polygon",
        "d": "M6.43 5.71L7.67 6.2L8.04 5.95L8.65 5.64L9.08 5.47L9.76 5.26L10.22 5.15L10.92 5.04L11.59 4.98L12.23 4.99L12.62 5.02L13.33 5.13L14.57 5.39L15.49 5.68L16.82 6.19L16.48 5.86L15.75 5.26L15.36 5L14.53 4.55L13.66 4.21L13.21 4.07L12.29 3.89L11.82 3.84L10.88 3.83L10.4 3.87L9.93 3.94L9.46 4.04L9 4.17L8.54 4.34L8.09 4.54L7.64 4.77L7.21 5.04L6.79 5.35L6.38 5.69Z",
        "fill": "accent"
      },
      {
        "type": "polygon",
        "d": "M16.76 12.2L15.53 11.71L15.16 11.95L14.55 12.26L14.12 12.43L13.44 12.64L12.98 12.75L12.28 12.86L11.61 12.92L10.97 12.92L10.58 12.89L9.87 12.78L8.63 12.51L7.7 12.23L6.38 11.72L6.72 12.05L7.45 12.64L7.84 12.9L8.67 13.35L9.54 13.7L9.99 13.83L10.91 14.01L11.38 14.06L12.32 14.08L12.79 14.04L13.27 13.97L13.74 13.86L14.2 13.73L14.66 13.56L15.11 13.36L15.55 13.13L15.99 12.86L16.41 12.56L16.82 12.22Z",
        "fill": "accent"
      },
      {
        "type": "line",
        "d": "M7.55 7L7.55 10.91M7.55 9.34L9.27 7.25M8.28 8.45L9.31 10.75M10.78 7.18L11.71 8.95L12.64 7.18M11.71 8.95L11.71 10.91M16.22 7.39L14.25 7.39L14.25 10.52L16.26 10.52M14.25 8.95L16.11 8.95",
        "stroke": "accent",
        "strokeWidth": 0.78
      }
    ],
    "islandwide-express": [
      {
        "type": "polygon",
        "d": "M12.79 6.52L12.97 6.56L13.13 6.48L13.24 6.28L13.24 6.18L13.2 6.08L11.19 4.06L11.03 3.99L10.91 4L10.81 4.06L8.83 6.04L8.75 6.21L8.77 6.33L8.87 6.48L8.97 6.54L9.09 6.56L9.7 6.26L10.16 6.1L10.72 6.01L11.24 6L11.65 6.06L12.04 6.16L12.41 6.31Z",
        "fill": "accent"
      },
      {
        "type": "polygon",
        "d": "M13.78 11.09L13.74 11.27L13.82 11.43L14.02 11.54L14.12 11.54L14.22 11.5L16.24 9.49L16.31 9.33L16.3 9.21L16.24 9.11L14.26 7.13L14.09 7.05L13.97 7.07L13.82 7.17L13.76 7.27L13.74 7.39L14.04 8L14.2 8.46L14.29 9.02L14.3 9.54L14.24 9.95L14.14 10.34L13.99 10.71Z",
        "fill": "accent"
      },
      {
        "type": "polygon",
        "d": "M9.21 12.08L9.03 12.04L8.87 12.12L8.76 12.32L8.76 12.42L8.8 12.52L10.81 14.54L10.97 14.61L11.09 14.6L11.19 14.54L13.17 12.56L13.25 12.39L13.23 12.27L13.13 12.12L13.03 12.06L12.91 12.04L12.3 12.34L11.84 12.5L11.28 12.59L10.76 12.6L10.35 12.54L9.96 12.44L9.59 12.29Z",
        "fill": "accent"
      },
      {
        "type": "polygon",
        "d": "M8.22 7.51L8.26 7.33L8.18 7.17L7.98 7.06L7.88 7.06L7.78 7.1L5.76 9.11L5.69 9.27L5.7 9.39L5.76 9.49L7.74 11.47L7.91 11.55L8.03 11.53L8.18 11.43L8.24 11.33L8.26 11.21L7.96 10.6L7.8 10.14L7.71 9.58L7.7 9.06L7.76 8.65L7.86 8.26L8.01 7.89Z",
        "fill": "accent"
      }
    ],
    "piggy-express": [
      {
        "type": "polygon",
        "d": "M15.44 5.16L15.38 5.04L15.26 4.97L13.6 4.97L12.56 4.54L11.99 4.42L11.42 4.37L10.84 4.4L10.15 4.51L9.6 4.69L9 4.97L7.36 4.97L7.19 5.04L7.12 5.2L7.12 6.89L6.85 7.51L6.66 8.18L6.58 8.87L6.6 9.56L6.74 10.36L6.98 11.02L7.37 11.73L7.88 12.36L8.58 12.96L9.38 13.42L10.26 13.71L11.18 13.83L12.11 13.76L13 13.51L13.83 13.09L14.56 12.52L15.1 11.92L15.52 11.23L15.82 10.47L15.99 9.68L16.03 8.98L15.94 8.18L15.75 7.51L15.45 6.83Z",
        "fill": "accent"
      },
      {
        "type": "circle",
        "cx": 9.9,
        "cy": 7.05,
        "r": 0.41,
        "fill": "truck"
      },
      {
        "type": "circle",
        "cx": 12.64,
        "cy": 7.05,
        "r": 0.41,
        "fill": "truck"
      },
      {
        "type": "circle",
        "cx": 11.27,
        "cy": 9.07,
        "r": 1.6,
        "fill": "truck"
      }
    ],
    "rozetka-delivery": [
      {
        "type": "line",
        "d": "M3.71 11.69L3.71 7.3L3.86 7.3L4.2 7.35L4.51 7.51L4.75 7.75L4.91 8.06L4.96 8.4L4.91 8.74L4.75 9.05L4.51 9.29L4.2 9.45L3.86 9.5L3.71 9.5M4.27 9.5L5.06 11.55M7.45 7.98L7.4 7.72L7.26 7.5L7.04 7.35L6.78 7.3L6.52 7.35L6.3 7.5L6.16 7.72L6.1 7.98L6.1 10.62L6.16 10.88L6.3 11.1L6.52 11.25L6.78 11.3L7.04 11.25L7.26 11.1L7.4 10.88L7.45 10.62L7.45 7.98L7.4 7.72M8.48 7.3L9.63 7.3L8.48 11.3L9.63 11.3M11.89 7.3L10.89 7.3L10.89 11.3L11.89 11.3M10.89 9.3L11.74 9.3M12.25 7.3L13.55 7.3M12.9 7.3L12.9 11.69M14.3 6.91L14.3 11.69M15.56 7.08L14.3 9.62M14.76 8.69L15.53 11.59M16.64 11.63L17.3 7.3L17.64 7.3L18.29 11.63M16.89 10.02L18.05 10.02",
        "stroke": "accent",
        "strokeWidth": 0.78
      }
    ],
    "hrx": [
      {
        "type": "polygon",
        "d": "M12.54 3.3L11.78 3.45L10.91 3.66L9.94 3.94L8.89 4.3L7.8 4.74L6.68 5.29L5.54 5.94L4.42 6.72L3.33 7.62L2.3 8.66L2.3 4.3L2.33 4.04L2.43 3.8L2.59 3.59L2.8 3.43L3.04 3.33L3.3 3.3Z",
        "fill": "accent"
      },
      {
        "type": "line",
        "d": "M4.61 11.45L7.07 7.44M8.4 11.45L10.9 7.41M11.14 11.45L13.4 7.73L15.75 7.73L16.15 7.74L16.43 7.79L16.61 7.86L16.72 7.95L16.78 8.06L16.79 8.19L16.7 8.44L16.45 8.66L16.1 8.87L15.7 9.05L15.31 9.22L14.97 9.36L15.97 15.1",
        "stroke": "accent",
        "strokeWidth": 1.4
      },
      {
        "type": "line",
        "d": "M5.85 9.43L9.65 9.43",
        "stroke": "accent",
        "strokeWidth": 0.72
      },
      {
        "type": "line",
        "d": "M11.76 15.1L18.69 11.1",
        "stroke": "accent",
        "strokeWidth": 0.52
      }
    ],
    "cargobus": [
      {
        "type": "polygon",
        "d": "M8.8 4.64L15.7 4.64L15.7 13.36L8.8 13.36L12.88 9.01Z",
        "fill": "accent"
      },
      {
        "type": "polygon",
        "d": "M7.3 4.87L11.32 9.01L7.3 13.16Z",
        "fill": "#df0000"
      }
    ],
    "jetpak": [
      {
        "type": "line",
        "d": "M5.2 7.84L4.45 12.05L4.41 12.21L4.32 12.35L4.2 12.47L4.06 12.57L3.91 12.63L3.75 12.65L3.5 12.65M5.87 9.86L7.67 9.86L7.72 9.54L7.73 9.22L7.69 8.92L7.62 8.67L7.51 8.46L7.38 8.31L7.21 8.22L7.03 8.2L6.84 8.25L6.65 8.36L6.46 8.53L6.28 8.76L6.13 9.03L6.01 9.34L5.91 9.66L5.86 9.99L5.84 10.31L5.87 10.61L5.93 10.88L6.03 11.1L6.16 11.26L6.32 11.36L6.5 11.4L6.69 11.37L6.88 11.27L7.07 11.11M8.45 8.2L9.85 8.2M9.01 8.2L8.57 10.7L8.57 10.88L8.61 11.05L8.69 11.19L8.82 11.31L8.97 11.38L9.15 11.4L9.22 11.4M10.65 7.84L9.8 12.65M10.59 8.2L11.49 8.2L11.68 8.24L11.85 8.36L11.99 8.55L12.09 8.8L12.14 9.11L12.15 9.44L12.11 9.8L12.02 10.16L11.89 10.49L11.73 10.8L11.55 11.05L11.34 11.24L11.13 11.36L10.92 11.4L10.02 11.4M15.28 7.84L14.59 11.76M15.22 8.2L14.32 8.2L14.11 8.24L13.9 8.36L13.69 8.55L13.51 8.8L13.34 9.11L13.22 9.44L13.13 9.8L13.09 10.16L13.1 10.49L13.15 10.8L13.25 11.05L13.39 11.24L13.56 11.36L13.75 11.4L14.65 11.4M16.31 7.84L15.62 11.76M17.75 8.2L15.92 10.06M16.69 9.28L17.15 11.62",
        "stroke": "accent",
        "strokeWidth": 0.72
      },
      {
        "type": "polygon",
        "d": "M5.02 6.79L18.5 6.79L18 7.29L4.94 7.29Z",
        "fill": "accent"
      }
    ],
    "tonami": [
      {
        "type": "line",
        "d": "M3.35 7.3L4.95 7.3M4.15 7.3L4.15 11.7M6.22 7.3L6.87 7.3L7.06 7.34L7.22 7.45L7.33 7.61L7.37 7.8L7.37 10.8L7.33 10.99L7.22 11.15L7.06 11.26L6.87 11.3L6.22 11.3L6.03 11.26L5.87 11.15L5.76 10.99L5.72 10.8L5.72 7.8L5.76 7.61L5.87 7.45L6.03 7.34L6.22 7.3L6.87 7.3M8.55 11.7L8.55 7.3L8.85 7.3L10.05 11.3L10.35 11.3L10.35 6.9M11.52 11.62L12.39 7.3L12.69 7.3L13.55 11.62M11.84 10.02L13.23 10.02M14.72 11.7L14.72 7.3L15.02 7.3L15.68 10.3L16.12 10.3L16.77 7.3L17.07 7.3L17.07 11.7M18.25 6.9L18.25 11.7",
        "stroke": "accent",
        "strokeWidth": 0.8
      }
    ],
    "okaken": [
      {
        "type": "polygon",
        "d": "M7.73 6.74L7.66 6.32L7.5 5.9L7.26 5.55L6.98 5.31L6.61 5.12L6.21 5.02L5.75 5L5.32 5.06L4.94 5.2L4.6 5.41L4.28 5.7L4 6.04L3.76 6.46L3.58 6.91L3.46 7.4L3.4 7.87L3.46 8.6L3.67 9.38L4.02 10.14L4.52 10.88L5.11 11.53L5.82 12.11L6.61 12.61L7.49 13.02L7.02 11.92L6.65 10.8L6.45 9.78L6.4 8.95L6.53 8L6.76 7.37L6.94 7.13L7.14 6.96L7.39 6.84Z",
        "fill": "accent"
      },
      {
        "type": "polygon",
        "d": "M7.58 5.84L8.28 5.59L9.1 5.51L9.45 5.54L9.81 5.63L10.12 5.78L10.41 6L17.1 6L17.53 5.9L17.9 5.71L18.29 5.38L18.6 4.98L9.13 4.99L8.67 5.07L8.29 5.23L7.89 5.51Z",
        "fill": "#ee001e"
      },
      {
        "type": "polygon",
        "d": "M9.06 12.01L8.29 12.57L7.55 13.01L8.41 12.99L9.02 12.87L9.8 12.55L10.64 12.08L10.74 12.01Z",
        "fill": "#ee001e"
      },
      {
        "type": "polygon",
        "d": "M10.19 10.83L9.74 11.36L9.25 11.84L10.78 11.84L11.13 11.77L11.46 11.64L11.79 11.43L12.39 10.83Z",
        "fill": "#ee001e"
      },
      {
        "type": "polygon",
        "d": "M10.9 9.66L10.33 10.68L12.35 10.68L12.66 10.62L13 10.48L13.33 10.26L13.63 9.99L13.89 9.66Z",
        "fill": "#ee001e"
      },
      {
        "type": "polygon",
        "d": "M11.24 8.49L10.97 9.48L13.68 9.48L13.93 9.45L14.28 9.32L14.61 9.11L14.9 8.83L15.16 8.49Z",
        "fill": "#ee001e"
      },
      {
        "type": "polygon",
        "d": "M11.27 8.31L15.08 8.29L15.43 8.18L15.77 7.98L16.1 7.69L16.38 7.32L11.26 7.32L11.3 7.82Z",
        "fill": "#ee001e"
      },
      {
        "type": "polygon",
        "d": "M11.2 7.17L16.13 7.15L16.55 7.02L16.9 6.82L17.24 6.52L17.52 6.17L10.56 6.17L10.96 6.59Z",
        "fill": "#ee001e"
      }
    ],
    "trexity": [
      {
        "type": "line",
        "d": "M3.29 7.1L4.72 7.1M4 7.1L4 11.95M5.67 11.95L5.67 7.1L5.74 7.1L6.18 7.19L6.55 7.44L6.8 7.81L6.88 8.24L6.8 8.68L6.55 9.05L6.18 9.3L5.74 9.39L5.67 9.39M6.15 9.39L6.99 11.8M9.41 7.1L8.36 7.1L8.36 11.5L9.41 11.5M8.36 9.3L9.26 9.3M10.34 6.79L11.97 11.81M11.97 6.79L10.34 11.81M13.35 6.65L13.35 11.95M14.3 7.1L15.73 7.1M15.01 7.1L15.01 11.95M16.66 6.79L17.47 9.3M18.28 6.79L17.47 9.3L17.47 11.95",
        "stroke": "accent",
        "strokeWidth": 0.9
      }
    ],
    "savar-express": [
      {
        "type": "polygon",
        "d": "M8.74 9.25L8.89 9.32L10.35 9.32L10.47 9.28L10.55 9.14L10.56 8.52L10.61 8.25L10.74 7.95L10.94 7.7L11.25 7.48L11.63 7.37L12.03 7.38L12.45 7.52L12.59 7.48L15.63 4.88L15.69 4.74L15.69 4.37L15.65 4.27L15.55 4.2L15.06 4.07L13.95 3.87L12.96 3.8L12.05 3.83L11.19 3.94L10.39 4.15L9.67 4.43L9.02 4.82L8.52 5.25L8.15 5.74L7.91 6.29L7.8 6.86L7.84 7.46L8.01 8.08L8.32 8.68Z",
        "fill": "accent"
      },
      {
        "type": "polygon",
        "d": "M14.86 7.95L14.71 7.88L13.25 7.88L13.13 7.92L13.05 8.06L13.04 8.68L12.99 8.95L12.86 9.25L12.66 9.5L12.35 9.72L11.97 9.83L11.57 9.82L11.15 9.68L11.01 9.72L7.97 12.32L7.91 12.46L7.91 12.83L7.95 12.93L8.05 13L8.54 13.13L9.65 13.33L10.64 13.4L11.55 13.37L12.41 13.26L13.21 13.05L13.93 12.77L14.58 12.38L15.08 11.95L15.45 11.46L15.69 10.91L15.8 10.34L15.76 9.74L15.59 9.12L15.28 8.52Z",
        "fill": "accent"
      }
    ],
    "xgs": [
      {
        "type": "polygon",
        "d": "M6.12 8.44L6.22 7.75L6.45 7.07L6.82 6.4L7.28 5.81L7.86 5.27L8.51 4.82L9.24 4.44L10.05 4.16L10.83 3.99L11.74 3.91L12.42 3.93L13.32 4.06L14 4.24L14.67 4.51L15.55 5L16.32 5.63L16.44 5.63L16.47 5.52L16.24 5.25L15.79 4.84L15.16 4.39L14.42 4L13.48 3.65L12.48 3.46L11.74 3.4L10.7 3.46L9.7 3.66L8.76 4L7.89 4.48L7.12 5.09L6.48 5.79L6.14 6.3L5.87 6.84L5.63 7.56L5.53 8.11L5.49 8.68L5.53 9.25L5.66 9.9L5.83 10.35L5.94 10.34L6.3 9.93L6.14 9.16Z",
        "fill": "#f32735"
      },
      {
        "type": "polygon",
        "d": "M6.1 10.99L6.46 11.54L6.91 12.07L7.4 12.51L7.95 12.92L8.56 13.26L9.21 13.54L9.9 13.75L10.61 13.89L11.41 13.95L12.04 13.94L12.78 13.85L13.49 13.69L14.19 13.45L14.77 13.17L15.44 12.75L15.85 12.44L15.89 12.37L15.85 12.28L15.75 12.27L15.22 12.61L14.63 12.91L13.92 13.17L13.36 13.32L12.75 13.42L12.1 13.47L11.51 13.46L10.88 13.4L10.11 13.24L9.45 13.02L8.79 12.72L8.17 12.34L7.64 11.92L7.19 11.46L6.77 10.91L6.41 10.27L6.3 10.29L5.97 10.65L5.97 10.73Z",
        "fill": "#f32735"
      },
      {
        "type": "line",
        "d": "M5.73 10.73L10.2 7.04",
        "stroke": "accent",
        "strokeWidth": 0.5
      },
      {
        "type": "line",
        "d": "M7.48 6.93L8.4 10.83M13.65 7.5L11.75 7.5L11.36 7.57L10.99 7.78L10.7 8.1L10.54 8.48L10.35 9.29L10.33 9.66L10.47 9.98L10.74 10.19L11.1 10.27L12.01 10.27L12.4 10.19L12.77 9.98L13.06 9.66L13.22 9.29L13.32 8.88L11.88 8.88M18.23 7.5L16.08 7.5L15.71 7.57L15.36 7.77L15.09 8.07L14.93 8.43L15.04 7.95L15.03 8.31L15.16 8.61L15.41 8.81L15.75 8.88L16.97 8.88L17.31 8.95L17.56 9.15L17.69 9.46L17.68 9.81L17.79 9.34L17.63 9.69L17.36 9.99L17.01 10.2L16.64 10.27L14.49 10.27",
        "stroke": "accent",
        "strokeWidth": 0.92
      }
    ],
    "optima-overnight": [
      {
        "type": "polygon",
        "d": "M7.37 11.71L7.06 11.19L6.82 10.62L6.67 10.03L6.59 9.43L6.6 8.81L6.7 8.21L6.88 7.63L7.13 7.07L7.46 6.56L7.86 6.09L8.32 5.69L8.83 5.35L9.38 5.09L9.97 4.91L10.57 4.8L11.21 4.79L11.26 4.78L11.32 4.23L11.35 4.16L11.44 4.06L11.53 4L11.71 4L11.88 4.12L13.48 5.45L13.54 5.53L13.55 5.68L13.51 5.8L13.38 5.92L11.51 7.26L11.36 7.34L11.26 7.34L11.18 7.32L11.1 7.26L11.05 7.16L11.05 6.98L11.1 6.46L11.08 6.42L11.03 6.42L10.62 6.45L10.24 6.53L9.87 6.67L9.53 6.85L9.21 7.08L8.94 7.35L8.7 7.66L8.5 8L8.36 8.36L8.27 8.74L8.23 9.13L8.25 9.51L8.32 9.9L8.44 10.27L8.62 10.61L8.84 10.93L9.1 11.22L9.43 11.48L9.47 11.51L9.43 11.54L8.11 12.24L8.03 12.26L7.93 12.27L7.83 12.24L7.78 12.21Z",
        "fill": "#94bf36"
      },
      {
        "type": "polygon",
        "d": "M11.44 11.94L11.82 11.85L12.18 11.71L12.52 11.53L12.83 11.29L13.1 11.02L13.33 10.71L13.52 10.37L13.66 10.01L13.75 9.63L13.78 9.25L13.76 8.86L13.68 8.48L13.56 8.12L13.38 7.77L13.16 7.45L12.9 7.17L12.58 6.92L12.56 6.91L12.56 6.87L13.93 6.15L14.08 6.13L14.16 6.15L14.24 6.21L14.64 6.69L14.95 7.21L15.19 7.77L15.34 8.36L15.42 8.96L15.41 9.57L15.31 10.17L15.14 10.75L14.89 11.31L14.56 11.82L14.17 12.28L13.72 12.69L13.21 13.03L12.66 13.29L12.09 13.48L11.49 13.59L10.86 13.62L10.79 13.63L10.74 14.16L10.69 14.28L10.56 14.39L10.43 14.41L10.33 14.39L8.59 12.96L8.52 12.86L8.51 12.73L8.56 12.61L8.63 12.52L10.51 11.17L10.68 11.07L10.81 11.06L10.91 11.1L10.99 11.18L11.01 11.23L11.01 11.43L10.96 11.96L10.98 11.97L11.03 11.97Z",
        "fill": "accent"
      }
    ],
    "plycon": [
      {
        "type": "line",
        "d": "M15.59 9.2L15.55 9.8L15.43 10.39L15.24 10.96L14.97 11.49L14.64 11.99L14.24 12.44L13.79 12.84L13.29 13.17L12.76 13.44L12.19 13.63L11.6 13.75L11 13.79L10.4 13.75L9.81 13.63L9.24 13.44L8.71 13.17L8.21 12.84L7.76 12.44L7.36 11.99L7.03 11.49L6.76 10.96L6.57 10.39L6.45 9.8L6.41 9.2L6.45 8.6L6.57 8.01L6.76 7.44L7.03 6.91L7.36 6.41L7.76 5.96L8.21 5.56L8.71 5.23L9.24 4.96L9.81 4.77L10.4 4.65L11 4.61L11.6 4.65L12.19 4.77L12.76 4.96L13.29 5.23L13.79 5.56L14.24 5.96L14.64 6.41L14.97 6.91L15.24 7.44L15.43 8.01L15.55 8.6L15.59 9.2L15.55 9.8",
        "stroke": "#fff762",
        "strokeWidth": 0.42
      },
      {
        "type": "circle",
        "cx": 11,
        "cy": 9.2,
        "r": 3.31,
        "fill": "#fff762"
      },
      {
        "type": "polygon",
        "d": "M8.56 10.53L10.85 7.16L12.78 7.16L12.97 7.2L13.13 7.31L13.23 7.48L13.25 7.67L13.2 7.85L12.72 8.76L12.67 8.83L12.62 8.88L12.55 8.92L12.47 8.95L12.4 8.95L10.92 8.95L9.85 10.53Z",
        "fill": "truck"
      },
      {
        "type": "polygon",
        "d": "M11.9 8.2L11.8 8.31L11.69 8.39L11.59 8.42L11.51 8.4L11.46 8.33L11.46 8.23L11.49 8.1L11.56 7.97L11.66 7.86L11.76 7.78L11.86 7.75L11.94 7.77L11.99 7.83L12 7.94L11.97 8.07Z",
        "fill": "#fff762"
      }
    ],
    "peninsula-truck-lines": [
      {
        "type": "line",
        "d": "M3.55 8.49L3.55 5.28L3.75 5.28L4.05 5.34L4.31 5.51L4.48 5.77L4.54 6.07L4.48 6.38L4.31 6.64L4.05 6.81L3.75 6.87L3.55 6.87M6.32 5.28L5.47 5.28L5.47 8.18L6.32 8.18M5.47 6.73L6.2 6.73M6.93 8.49L6.93 5.28L7.15 5.28L7.81 8.18L8.03 8.18L8.03 4.97M8.95 4.97L8.95 8.49M9.87 8.49L9.87 5.28L10.09 5.28L10.74 8.18L10.96 8.18L10.96 4.97M12.81 5.61L12.55 5.28L12.38 5.23L12.21 5.28L12.06 5.41L11.95 5.61L11.88 5.98L11.91 6.23L12.06 6.55L12.21 6.65L12.63 6.84L12.76 6.99L12.88 7.34L12.88 7.6L12.82 7.84L12.63 8.12L12.55 8.18L12.38 8.22L12.2 8.18L11.93 7.84M13.81 4.97L13.81 7.65L13.84 7.81L13.91 7.96L14.03 8.08L14.17 8.15L14.33 8.18L14.49 8.15L14.64 8.08L14.76 7.96L14.83 7.81L14.86 7.65L14.86 4.97M15.78 4.97L15.78 8.18L16.58 8.18M17.19 8.44L17.67 5.28L17.97 5.28L18.46 8.44M17.37 7.25L18.28 7.25",
        "stroke": "accent",
        "strokeWidth": 0.62
      },
      {
        "type": "polygon",
        "d": "M3.24 9.58L18.76 9.58L18.76 13.28L3.24 13.28Z",
        "fill": "accent"
      },
      {
        "type": "line",
        "d": "M4.78 11.1L5.5 11.1M5.06 10.6L5.07 12.12L5.19 12.32L5.39 12.44L5.5 12.45M5.98 10.91L5.98 12.64M5.98 11.85L6.03 11.48L6.17 11.2L6.26 11.13L6.36 11.1L6.6 11.21M7.13 10.91L7.13 12.03L7.15 12.16L7.21 12.28L7.3 12.37L7.42 12.43L7.55 12.45L7.68 12.43L7.8 12.37L7.9 12.28L7.96 12.16L7.98 12.03M7.98 10.91L7.98 12.64M9.36 11.33L9.17 11.13L9.06 11.1L8.95 11.12L8.84 11.19L8.68 11.43L8.62 11.78L8.68 12.12L8.75 12.26L8.84 12.37L8.95 12.44L9.06 12.45L9.17 12.42L9.36 12.23M9.96 10.19L9.96 12.64M10.74 11.1L9.96 11.91M10.29 11.57L10.74 12.57M11.91 10.19L11.91 12.64M12.55 10.91L12.55 12.64M12.55 10.19L12.55 10.57M13.19 10.91L13.19 12.64M13.19 11.53L13.22 11.4L13.28 11.28L13.37 11.18L13.49 11.12L13.62 11.1L13.75 11.12L13.87 11.18L13.96 11.28L14.02 11.4L14.04 11.53L14.04 12.64M14.68 11.78L15.6 11.78L15.53 11.42L15.45 11.28L15.35 11.17L15.22 11.11L15.1 11.11L14.97 11.15L14.86 11.25L14.71 11.55L14.69 11.92L14.81 12.25L14.91 12.36L15.03 12.43L15.16 12.45L15.29 12.42L15.4 12.34L15.5 12.21M16.96 11.26L16.75 11.1L16.48 11.1L16.36 11.17L16.27 11.26L16.22 11.43L16.24 11.55L16.36 11.7L16.82 11.83L16.92 11.9L17.02 12.07L17.02 12.19L16.97 12.3L16.82 12.43L16.61 12.47L16.47 12.45L16.26 12.3",
        "stroke": "truck",
        "strokeWidth": 0.38
      }
    ],
    "ross-express": [
      {
        "type": "polygon",
        "d": "M16.73 3.8L18.8 3.8L18.8 13.4L3.2 13.4L3.2 11.65Z",
        "fill": "accent"
      },
      {
        "type": "line",
        "d": "M5.13 10.15L3.83 7.92L4.52 7.51L4.7 7.45L4.89 7.44L5.07 7.49L5.22 7.59L5.34 7.73L5.41 7.91L5.42 8.09L5.37 8.27L5.27 8.43L5.12 8.55L4.43 8.95M4.94 8.66L6.33 9.26M7.55 6.68L7.35 6.45L7.07 6.31L6.75 6.29L6.46 6.39L6.23 6.6L6.09 6.88L6.07 7.19L6.17 7.48L6.52 8.09L6.73 8.32L7.01 8.46L7.32 8.48L7.61 8.38L7.85 8.17L7.99 7.89L8.01 7.58L7.9 7.29L7.55 6.68L7.35 6.45M9.1 5.17L8.66 5.11L8.44 5.2L8.26 5.35L8.14 5.54L8.09 5.75L8.16 6.05L8.29 6.2L8.6 6.32L8.82 6.29L9.38 6.13L9.6 6.14L9.88 6.3L9.98 6.48L10 6.69L9.89 7.01L9.82 7.1L9.63 7.25L9.41 7.34L8.96 7.29M10.77 4.2L10.33 4.14L10.12 4.23L9.93 4.38L9.81 4.57L9.76 4.78L9.83 5.08L9.96 5.23L10.27 5.35L10.49 5.32L11.05 5.16L11.27 5.17L11.55 5.33L11.65 5.51L11.68 5.72L11.56 6.04L11.49 6.13L11.3 6.28L11.08 6.37L10.63 6.32",
        "stroke": "accent",
        "strokeWidth": 0.56
      },
      {
        "type": "line",
        "d": "M6.27 10.48L5.28 11.06L6.28 12.79L7.28 12.21M5.78 11.92L6.63 11.43M6.67 10.25L8.88 11.28M7.88 9.55L7.67 11.98M9.6 11.14L8.48 9.2L9.13 8.82L9.33 8.75L9.55 8.77L9.74 8.86L9.88 9.02L9.95 9.22L9.94 9.44L9.84 9.63L9.68 9.77L9.03 10.15M11.37 10.11L10.25 8.17L11.01 7.73L11.16 7.67L11.32 7.66L11.48 7.7L11.62 7.79L11.72 7.92L11.78 8.07L11.79 8.23L11.75 8.39L11.66 8.53L11.53 8.63L10.77 9.07M11.28 8.78L12.57 9.24M13.11 6.51L12.11 7.09L13.12 8.82L14.11 8.24M12.61 7.95L13.46 7.46M14.7 5.85L14.29 5.83L14.07 5.92L13.89 6.06L13.76 6.24L13.7 6.43L13.75 6.7L13.87 6.83L14.16 6.92L14.93 6.7L15.14 6.7L15.4 6.83L15.48 6.99L15.5 7.17L15.37 7.47L15.11 7.7L14.88 7.79L14.45 7.78M16.28 4.94L15.86 4.92L15.64 5.01L15.46 5.15L15.33 5.33L15.27 5.52L15.32 5.79L15.44 5.92L15.73 6.01L16.5 5.79L16.71 5.79L16.97 5.92L17.05 6.07L17.07 6.26L16.94 6.55L16.68 6.79L16.46 6.88L16.03 6.86",
        "stroke": "truck",
        "strokeWidth": 0.48
      }
    ],
    "centurion-transport": [
      {
        "type": "polygon",
        "d": "M5.29 10.18L5.37 10.35L5.53 10.43L6.03 10.13L6.18 10.1L6.23 10.15L5.43 10.72L5.32 11.16L5.4 11.31L5.65 11.29L6.53 10.75L6.78 10.79L6.92 11.01L6.85 11.49L6.61 12.08L6.29 12.48L5.83 12.84L5.8 13.08L5.91 13.2L6.09 13.18L6.33 13.05L6.86 12.56L7.2 11.99L7.45 11.12L7.56 10.99L7.74 10.94L7.9 10.98L8.03 11.1L8.43 12.06L8.73 12.58L8.98 12.84L9.23 12.97L9.67 12.96L10.22 12.74L10.77 12.37L11.33 11.81L11.52 11.75L11.77 11.87L11.9 12.2L12.03 12.36L13.21 12.93L14.77 13L15.5 12.96L15.72 12.73L15.56 11.99L15.66 11.57L15.55 11.42L15.65 11.14L15.64 10.72L16.12 10.62L16.23 10.53L16.26 10.37L16.2 10.13L15.63 9.04L15.72 8.29L15.48 8.07L15.44 7.83L15.63 7.58L16.65 7.02L16.7 6.79L16.19 6L15.51 5.18L15.18 5.19L14.73 5.76L14.42 5.91L13.53 5.46L12.56 5.14L12.44 4.85L12.62 4.59L13.85 4.5L13.77 4.1L13.57 3.95L13.15 3.86L11.91 3.81L11.82 3.77L11.68 3.81L11.4 3.75L10.21 3.84L9.52 3.99L8.63 4.33L7.77 4.8L7.09 5.32L6.63 5.84L6.51 6.05L6.58 6.16L6.72 6.19L7.02 6.06L7.11 6.15L6.99 6.28L5.96 6.84L5.92 7.07L6.03 7.15L6.17 7.13L6.55 6.9L6.64 6.91L6.66 6.99L6.52 7.16L5.78 7.69L5.71 7.86L5.79 7.94L6.24 7.76L6.34 7.77L6.37 7.83L5.59 8.41L5.48 8.58L5.54 8.72L5.68 8.77L6.21 8.53L6.3 8.53L6.32 8.6L5.53 9.13L5.42 9.28L5.4 9.48L5.43 9.6L5.5 9.63L6.14 9.29L6.23 9.29L6.25 9.37L5.46 9.88Z",
        "fill": "accent"
      },
      {
        "type": "line",
        "d": "M11.14 4.17L10.09 4.37L9.5 4.6L8.97 4.87L8.24 5.45L7.59 6.31L7.26 7.06L7.05 8L6.89 10.43L6.95 11.28",
        "stroke": "truck",
        "strokeWidth": 0.22
      },
      {
        "type": "line",
        "d": "M7.76 11.13L7.69 10.5L7.67 9.53L7.83 8.37L8.28 7L8.48 6.6L8.74 6.21L9.12 5.79L9.52 5.47L9.95 5.21L10.77 4.84L11.08 4.76L12.11 4.68L12.58 4.56L12.91 4.57",
        "stroke": "truck",
        "strokeWidth": 0.41
      },
      {
        "type": "line",
        "d": "M8.11 7.57L8.41 7.79L11.02 9.16",
        "stroke": "truck",
        "strokeWidth": 0.2
      },
      {
        "type": "line",
        "d": "M7.95 8.08L8.58 8.34L10.61 9.36L10.79 9.48L10.87 9.6L10.76 9.85L10.43 10.09L10.04 10.21L9.56 10.23L9.14 10.18L8.76 10.05L8.45 9.84L8.12 9.49",
        "stroke": "truck",
        "strokeWidth": 0.2
      },
      {
        "type": "line",
        "d": "M10.46 5.05L10.59 5.26L10.67 5.5L11.32 8.58L11.41 8.75L11.52 8.77L11.6 8.67L11.62 8.46L11.51 4.76",
        "stroke": "truck",
        "strokeWidth": 0.2
      },
      {
        "type": "line",
        "d": "M12.46 5.04L12.46 5.54L11.96 8.72",
        "stroke": "truck",
        "strokeWidth": 0.2
      },
      {
        "type": "line",
        "d": "M12.46 8.54L14.21 6.21L14.78 5.75",
        "stroke": "truck",
        "strokeWidth": 0.2
      },
      {
        "type": "line",
        "d": "M11.88 10.28L11.46 10.14L11.85 10.22L12.1 10.15L12.33 9.94L12.53 9.48L12.71 9.28L15 8.19L15.21 8.13L15.41 8.15L15.1 8.01",
        "stroke": "truck",
        "strokeWidth": 0.28
      },
      {
        "type": "line",
        "d": "M11.89 10.29L11.89 10.82L11.79 11.55L11.88 12.15",
        "stroke": "truck",
        "strokeWidth": 0.28
      },
      {
        "type": "line",
        "d": "M15.95 6.74L15.38 7.09L15.17 7.17",
        "stroke": "truck",
        "strokeWidth": 0.2
      },
      {
        "type": "line",
        "d": "M14.97 6.83L15.65 6.33",
        "stroke": "truck",
        "strokeWidth": 0.2
      },
      {
        "type": "line",
        "d": "M14.7 6.54L15.33 5.99",
        "stroke": "truck",
        "strokeWidth": 0.2
      },
      {
        "type": "line",
        "d": "M14.4 7.03L14.72 7.5",
        "stroke": "truck",
        "strokeWidth": 0.2
      },
      {
        "type": "polygon",
        "d": "M14.96 9.1L14.9 9.2L14.72 9.26L14.55 9.25L14.5 9.2L14.51 9.15L14.56 9.11L14.8 9.04L14.91 9.03Z",
        "fill": "truck"
      }
    ],
    "airroad": [
      {
        "type": "polygon",
        "d": "M3.22 7.15L7.01 7.25L7.11 7.29L7.56 7.54L7.97 7.91L9.15 9.4L9.61 9.9L9.61 10.2L6.57 12.8L11.32 12.8L14.46 10.15L14.92 10.15L17.76 7.97L18.32 7.5L18.34 7.36L18.41 7.27L18.77 7.2L18.78 7.05L18.74 6.88L18.61 6.74L17.72 6.35L14.87 6.35L14.67 6.55L14.52 6.55L14.29 6.75L14.47 6.55L12.72 6.55L12.47 6.15L11.77 4.75L8.92 4.6L8.14 4.69L7.38 4.85L6.64 5.07L5.9 5.36L5.19 5.72L4.48 6.14L3.84 6.61Z",
        "fill": "accent"
      },
      {
        "type": "polygon",
        "d": "M17.32 6.69L17.02 6.7L17.02 6.9L17.42 7.03L17.57 6.95L17.6 6.83L17.38 6.78Z",
        "fill": "truck"
      },
      {
        "type": "polygon",
        "d": "M18.62 7.05L17.84 7.19L17.53 7.31L17.27 7.45L17.57 7.41L17.71 7.42L17.87 7.55L17.78 7.62L17.89 7.63Z",
        "fill": "truck"
      },
      {
        "type": "polygon",
        "d": "M14.05 8.82L13.92 8.97L13.89 9.11L13.97 9.25L14.11 9.34L13.94 9.52L13.92 9.61L13.97 9.71L14.11 9.79L13.96 9.95L13.92 10.14L14.03 10.25L14.36 10.25L14.52 10.1L14.24 10.11L14.07 10.05L14.14 9.92L14.42 9.73L14.47 9.6L14.19 9.61L14.07 9.55L14.47 9.15L14.17 9.15L14.08 9.1L14.04 9.04L14.1 8.96L14.34 8.77L14.37 8.67L14.37 8.65L14.11 8.66L14.02 8.6L14.28 8.4L14.42 8.15L14.35 8.19L14.29 8.19L14.02 8.05L14.47 7.55L14.22 7.56L14.13 7.52L14.37 7.15L14.37 7.1L14.29 7.15L14.22 7.15L14.02 7L14.47 6.55L14.29 6.55L13.91 6.9L13.87 6.98L13.91 7.1L14.11 7.25L13.97 7.5L14.01 7.61L14.12 7.69L13.85 7.95L13.82 8.05L13.87 8.17L14.13 8.3L13.86 8.49L13.82 8.58L13.86 8.7Z",
        "fill": "truck"
      }
    ],
    "cope-sensitive-freight": [
      {
        "type": "polygon",
        "d": "M5.41 7.3L5.41 11.3L2.8 11.3Z",
        "fill": "accent"
      },
      {
        "type": "polygon",
        "d": "M5.59 7.3L8.16 7.3L8.16 11.3L5.59 11.3Z",
        "fill": "accent"
      },
      {
        "type": "polygon",
        "d": "M8.34 7.3L10.91 7.3L10.91 11.3L8.34 11.3Z",
        "fill": "accent"
      },
      {
        "type": "polygon",
        "d": "M11.09 7.3L13.65 7.3L13.65 11.3L11.09 11.3Z",
        "fill": "accent"
      },
      {
        "type": "polygon",
        "d": "M13.83 7.3L16.4 7.3L16.4 11.3L13.83 11.3Z",
        "fill": "accent"
      },
      {
        "type": "polygon",
        "d": "M16.58 11.3L16.58 7.3L19.2 7.3Z",
        "fill": "accent"
      },
      {
        "type": "line",
        "d": "M7.49 8.48L7.36 8.31L7.21 8.18L7.05 8.1L6.88 8.08L6.7 8.1L6.54 8.18L6.39 8.31L6.27 8.48L6.16 8.69L6.09 8.92L6.06 9.17L6.06 9.42L6.09 9.67L6.16 9.91L6.27 10.11L6.39 10.28L6.54 10.41L6.7 10.49L6.88 10.52L7.05 10.49L7.21 10.41L7.36 10.28L7.49 10.11M10.51 9.3L10.49 9.55L10.43 9.79L10.34 10.01L10.21 10.2L10.06 10.35L9.89 10.46L9.71 10.51L9.52 10.51L9.34 10.46L9.17 10.35L9.02 10.2L8.89 10.01L8.8 9.79L8.74 9.55L8.72 9.3L8.74 9.04L8.8 8.8L8.89 8.58L9.02 8.39L9.17 8.24L9.34 8.14L9.52 8.08L9.71 8.08L9.89 8.14L10.06 8.24L10.21 8.39L10.34 8.58L10.43 8.8L10.49 9.04L10.51 9.3L10.49 9.55M11.69 10.82L11.69 8.12L12.55 8.12L12.66 8.14L12.76 8.18L12.86 8.25L12.94 8.34L13.01 8.45L13.05 8.58L13.08 8.72L13.08 8.86L13.05 8.99L13.01 9.12L12.94 9.23L12.86 9.33L12.76 9.39L12.66 9.44L12.55 9.45L11.69 9.45M16.03 8.12L14.44 8.12L14.44 10.47L16.07 10.47M14.44 9.25L15.95 9.25",
        "stroke": "truck",
        "strokeWidth": 0.63
      }
    ],
    "kiwi-express": [
      {
        "type": "polygon",
        "d": "M4.81 13.12L4.68 13.12L4.55 13.06L3.97 12.61L3.52 12.1L3.15 11.5L2.83 10.5L2.79 9.81L2.89 9.17L3.14 8.5L3.41 7.99L3.82 7.43L4.35 6.89L4.9 6.47L5.52 6.1L6.34 5.74L6.97 5.54L8.4 5.25L10.22 5.2L11.6 5.32L13.34 5.73L14.35 6.07L15.18 6.42L16.48 7.1L17.22 7.57L18.06 8.18L18.98 8.96L19.16 9.19L19.13 9.25L19.01 9.23L17.82 8.58L17.03 8.23L16.06 7.88L14.71 7.52L13.77 7.35L12.83 7.27L11.3 7.27L10.5 7.33L9.56 7.52L8.55 7.87L7.74 8.27L7.02 8.76L6.22 9.53L5.66 10.33L5.3 11.09L5 12.12L4.91 12.98Z",
        "fill": "#f12434"
      },
      {
        "type": "line",
        "d": "M7.79 9.87L7.11 13.11M9.55 10.19L7.41 11.64M8.51 10.9L9.45 12.95M11.04 10.84L10.56 13.11M12.15 10.84L12.19 12.73L12.75 12.73L13.51 11.22L13.96 11.22L14.05 12.73L14.61 12.73L15.48 10.84M16.53 10.84L16.05 13.11",
        "stroke": "accent",
        "strokeWidth": 0.77
      },
      {
        "type": "line",
        "d": "M11.27 9.87L11.14 10.49M16.73 9.87L16.6 10.49",
        "stroke": "accent",
        "strokeWidth": 0.88
      }
    ],
    "inter-express-logistics": [
      {
        "type": "polygon",
        "d": "M3.4 4L18.6 4L18.6 10.65L3.4 10.65Z",
        "fill": "accent"
      },
      {
        "type": "polygon",
        "d": "M3.4 10.65L18.6 10.65L18.6 13.05L3.4 13.05Z",
        "fill": "#fedd04"
      },
      {
        "type": "line",
        "d": "M7.49 5.47L7.49 7.5M8.38 7.5L8.38 5.47L9.45 7.5L9.45 5.47M10.1 5.47L11.17 5.47M10.63 5.47L10.63 7.5M12.84 5.47L11.82 5.47L11.82 7.5L12.84 7.5M11.82 6.48L12.68 6.48M13.49 7.5L13.49 5.47L13.98 5.47L14.18 5.51L14.35 5.62L14.47 5.79L14.51 5.99L14.47 6.19L14.35 6.37L14.18 6.48L13.98 6.52L13.49 6.52M13.9 6.52L14.51 7.5M6.21 7.83L5.19 7.83L5.19 9.87L6.21 9.87M5.19 8.85L6.06 8.85M6.84 7.83L7.87 9.87M7.87 7.83L6.84 9.87M8.74 9.87L8.74 7.83L9.23 7.83L9.43 7.88L9.6 7.99L9.71 8.16L9.75 8.36L9.71 8.56L9.6 8.74L9.43 8.85L9.23 8.89L8.74 8.89M10.65 9.87L10.65 7.83L11.14 7.83L11.34 7.88L11.51 7.99L11.62 8.16L11.66 8.36L11.62 8.56L11.51 8.74L11.34 8.85L11.14 8.89L10.65 8.89M11.05 8.89L11.66 9.87M13.57 7.83L12.56 7.83L12.56 9.87L13.57 9.87M12.56 8.85L13.42 8.85M15.07 8.07L14.82 7.83L14.49 7.83L14.24 8.07L14.18 8.42L14.35 8.73L14.65 8.85L14.97 8.97L15.14 9.28L15.08 9.63L14.82 9.87L14.48 9.87L14.22 9.63M16.72 8.07L16.47 7.83L16.14 7.83L15.89 8.07L15.83 8.42L16 8.73L16.31 8.85L16.62 8.97L16.79 9.28L16.74 9.63L16.48 9.87L16.13 9.87L15.87 9.63",
        "stroke": "#1c191a",
        "strokeWidth": 0.47
      },
      {
        "type": "line",
        "d": "M4.29 11.31L4.29 12.39L4.85 12.39M6.55 11.85L6.54 11.99L6.51 12.12L6.46 12.23L6.39 12.32L6.31 12.37L6.22 12.39L6.13 12.37L6.05 12.32L5.98 12.23L5.93 12.12L5.9 11.99L5.88 11.85L5.9 11.71L5.93 11.58L5.98 11.47L6.05 11.38L6.13 11.33L6.22 11.31L6.31 11.33L6.39 11.38L6.46 11.47L6.51 11.58L6.54 11.71L6.55 11.85L6.54 11.99M8.35 11.43L8.27 11.36L8.18 11.32L8.08 11.31L7.98 11.33L7.89 11.38L7.82 11.45L7.77 11.54L7.76 11.64L7.78 12.18L7.85 12.29L7.96 12.36L8.09 12.39L8.22 12.36L8.33 12.29L8.4 12.18L8.43 12.06L8.43 11.9L8.09 11.9M9.64 11.31L9.64 12.39M11.41 11.43L11.25 11.31L11.05 11.31L10.89 11.43L10.85 11.62L10.96 11.78L11.15 11.85L11.35 11.92L11.46 12.08L11.42 12.27L11.26 12.39L11.04 12.39L10.88 12.27M12.43 11.31L13.1 11.31M12.77 11.31L12.77 12.39M14.18 11.31L14.18 12.39M15.98 11.43L15.9 11.36L15.81 11.32L15.71 11.31L15.61 11.33L15.52 11.38L15.45 11.45L15.4 11.54L15.39 11.64L15.39 12.06L15.4 12.16L15.45 12.25L15.52 12.32L15.61 12.37L15.71 12.39L15.81 12.38L15.9 12.34L15.98 12.27M17.66 11.43L17.5 11.31L17.3 11.31L17.14 11.43L17.1 11.62L17.21 11.78L17.4 11.85L17.6 11.92L17.71 12.08L17.67 12.27L17.51 12.39L17.29 12.39L17.13 12.27",
        "stroke": "truck",
        "strokeWidth": 0.27
      }
    ],
    "ats-healthcare": [
      {
        "type": "line",
        "d": "M5.44 10.86L7.21 6.13L7.66 6.13L9.42 10.86M5.97 9.45L8.89 9.45M9.45 6.13L12.66 6.13M11.05 6.13L11.05 10.86M16.26 6.68L15.53 6.13L14.55 6.13L13.82 6.68L13.65 7.49L14.14 8.21L15.05 8.5L15.97 8.79L16.48 9.51L16.31 10.32L15.54 10.86L14.54 10.86L13.77 10.32",
        "stroke": "accent",
        "strokeWidth": 1.07
      }
    ],
    "whiz-delivery": [
      {
        "type": "polygon",
        "d": "M11.2 3.8L12.07 4.3L9.32 5.89L12.41 5.59L11.89 7.38L14.64 5.79L15.56 6.32L11.16 8.87L10.23 8.34L10.96 6.43L7.66 6.85L6.79 6.35Z",
        "fill": "accent"
      },
      {
        "type": "polygon",
        "d": "M6.79 6.81L7.7 7.33L7.7 9.14L9.41 10.14L9.41 8.33L10.32 8.85L10.32 13.49L9.41 12.97L9.41 11.16L7.7 10.16L7.7 11.98L6.79 11.45Z",
        "fill": "accent"
      },
      {
        "type": "polygon",
        "d": "M12.02 8.83L15.56 6.78L15.56 8.59L13.18 11.84L15.56 10.46L15.56 11.48L12.02 13.53L12.02 11.66L14.33 8.52L12.02 9.85Z",
        "fill": "#fcc21d"
      },
      {
        "type": "polygon",
        "d": "M10.73 9.11L11.63 9.11L11.63 13.76L11.2 14L10.73 13.73Z",
        "fill": "#e0a637"
      }
    ],
    "ets-express": [
      {
        "type": "polygon",
        "d": "M6.7 11.49L10.96 9.04L10.96 7.84L7.78 9.68L7.78 8.65L9.93 7.41L9.93 6.68L7.78 7.92L7.78 6.84L10.96 5.01L10.96 4.05L6.7 6.5Z",
        "fill": "#e60012"
      },
      {
        "type": "polygon",
        "d": "M15.32 12.42L15.32 9.5L12.15 7.67L12.15 6.6L15.32 8.44L15.32 7.52L10.96 5L10.96 7.89L14.16 9.74L14.16 10.88L10.96 9.03L10.96 10.03Z",
        "fill": "accent"
      },
      {
        "type": "polygon",
        "d": "M10.96 10.03L9.3 10.98L13.56 13.44L15.32 12.42Z",
        "fill": "#e60012"
      },
      {
        "type": "polygon",
        "d": "M10.94 14.95L12.78 13.89L8.52 11.43L6.68 12.49Z",
        "fill": "accent"
      }
    ],
    "rincos": [
      {
        "type": "polygon",
        "d": "M8.67 4.27L9.2 3.99L9.78 3.77L10.38 3.64L11 3.6L11.59 3.64L12.2 3.77L12.78 3.98L13.33 4.27Z",
        "fill": "accent"
      },
      {
        "type": "polygon",
        "d": "M7.43 5.44L8.09 4.7L13.91 4.7L14.56 5.42Z",
        "fill": "accent"
      },
      {
        "type": "polygon",
        "d": "M6.83 6.6L7.16 5.86L14.84 5.86L15.16 6.59Z",
        "fill": "accent"
      },
      {
        "type": "polygon",
        "d": "M6.61 7.77L6.72 7.03L15.28 7.03L15.38 7.75Z",
        "fill": "accent"
      },
      {
        "type": "polygon",
        "d": "M11.11 8.93L11 8.46L10.9 8.93L6.71 8.93L6.61 8.19L15.39 8.19L15.29 8.93Z",
        "fill": "accent"
      },
      {
        "type": "polygon",
        "d": "M10.8 9.36L10.63 10.09L7.14 10.09L6.83 9.36Z",
        "fill": "accent"
      },
      {
        "type": "polygon",
        "d": "M11.37 10.09L11.21 9.36L15.17 9.36L14.86 10.09Z",
        "fill": "accent"
      },
      {
        "type": "polygon",
        "d": "M10.54 10.52L10.37 11.26L8.07 11.26L7.41 10.52Z",
        "fill": "accent"
      },
      {
        "type": "polygon",
        "d": "M11.64 11.26L11.47 10.52L14.59 10.52L13.95 11.25Z",
        "fill": "accent"
      },
      {
        "type": "polygon",
        "d": "M10.27 11.69L10.13 12.3L9.34 12.06L8.63 11.69Z",
        "fill": "accent"
      },
      {
        "type": "polygon",
        "d": "M11.73 11.69L13.37 11.69L12.66 12.06L11.88 12.29Z",
        "fill": "accent"
      },
      {
        "type": "polygon",
        "d": "M9.8 5.44L10.39 5.27L11 5.22L11.62 5.27L12.21 5.44Z",
        "fill": "#fdb813"
      },
      {
        "type": "polygon",
        "d": "M13.01 5.86L13.42 6.2L13.77 6.6L8.24 6.6L8.59 6.2L8.99 5.86Z",
        "fill": "#fdb813"
      },
      {
        "type": "polygon",
        "d": "M14.04 7.03L14.34 7.77L7.67 7.77L7.96 7.03Z",
        "fill": "#fdb813"
      },
      {
        "type": "polygon",
        "d": "M6.53 13.6L7.65 13.29L8.77 13.07L9.88 12.94L11 12.89L12.12 12.94L13.23 13.07L14.35 13.29L15.47 13.6Z",
        "fill": "accent"
      }
    ],
    "apg-ecommerce": [
      {
        "type": "circle",
        "cx": 5.85,
        "cy": 9.1,
        "r": 2.75,
        "fill": "accent"
      },
      {
        "type": "polygon",
        "d": "M4.8 6.44L5.68 6.24L5.68 11.96L4.8 11.76Z",
        "fill": "truck"
      },
      {
        "type": "polygon",
        "d": "M5.63 6.44L5.99 6.48L6.34 6.59L6.65 6.77L6.92 7.02L7.14 7.31L7.29 7.64L7.36 8L7.36 8.37L7.29 8.72L7.14 9.06L6.92 9.35L6.65 9.6L6.34 9.78L5.99 9.89L5.63 9.93Z",
        "fill": "truck"
      },
      {
        "type": "line",
        "d": "M9.61 11L10.73 7.2L10.91 7.2L12.03 11M9.94 9.86L11.69 9.86M13.34 11L13.34 7.2L13.7 7.2L14.11 7.28L14.46 7.51L14.69 7.86L14.77 8.26L14.69 8.67L14.46 9.02L14.11 9.25L13.7 9.33L13.34 9.33M18.08 7.88L17.84 7.52L17.54 7.29L17.22 7.2L16.9 7.26L16.6 7.45L16.34 7.78L16.15 8.21L16.04 8.7L16.01 9.23L16.08 9.75L16.24 10.22L16.46 10.6L16.74 10.86L17.06 10.99L17.39 10.97L17.7 10.81L17.97 10.51L18.18 10.11L18.31 9.62L18.35 9.18L17.18 9.18",
        "stroke": "accent",
        "strokeWidth": 0.85
      }
    ],
    "toyou": [
      {
        "type": "polygon",
        "d": "M9.31 4.39L9.37 4.15L9.54 3.98L9.77 3.92L10 3.98L18.26 8.59L18.34 8.67L18.37 8.78L18.34 8.89L18.26 8.97L10 13.6L9.77 13.66L9.54 13.6L9.37 13.43L9.31 13.19Z",
        "fill": "accent"
      },
      {
        "type": "polygon",
        "d": "M18.59 4.72L18.56 4.64L18.48 4.6L18.4 4.61L15.89 6.04L15.82 6.13L15.82 6.24L15.89 6.33L18.4 7.75L18.48 7.77L18.56 7.73L18.59 7.64Z",
        "fill": "accent"
      },
      {
        "type": "line",
        "d": "M5.53 7.02L5.53 9.2L5.55 9.39L5.63 9.57L5.74 9.72L5.9 9.84L6.07 9.91L6.26 9.94M5.53 7.72L6.26 7.72M7.75 7.66L8.05 7.69L8.32 7.81L8.56 7.99L8.74 8.22L8.85 8.5L8.89 8.79L8.85 9.08L8.74 9.36L8.56 9.59L8.32 9.77L8.05 9.89L7.75 9.92L7.46 9.89L7.19 9.77L6.95 9.59L6.77 9.36L6.66 9.08L6.62 8.79L6.66 8.5L6.77 8.22L6.95 7.99L7.19 7.81L7.46 7.69L7.75 7.66L8.05 7.69",
        "stroke": "accent",
        "strokeWidth": 0.42
      },
      {
        "type": "line",
        "d": "M9.92 7.6L9.92 8.89L9.96 9.17L10.09 9.42L10.29 9.61L10.54 9.74L10.81 9.78L11.09 9.74L11.34 9.61L11.53 9.42L11.66 9.17L11.71 8.89M11.71 7.6L11.71 10.11L11.67 10.35L11.59 10.56L11.44 10.75L11.26 10.89L11.04 10.98L10.81 11.01M13.53 7.8L13.78 7.83L14.02 7.93L14.23 8.09L14.38 8.29L14.48 8.53L14.52 8.79L14.48 9.04L14.38 9.28L14.23 9.49L14.02 9.64L13.78 9.74L13.53 9.78L13.27 9.74L13.03 9.64L12.83 9.49L12.67 9.28L12.57 9.04L12.54 8.79L12.57 8.53L12.67 8.29L12.83 8.09L13.03 7.93L13.27 7.83L13.53 7.8L13.78 7.83M15.35 7.59L15.35 8.89L15.39 9.16L15.52 9.41L15.72 9.61L15.97 9.73L16.24 9.78L16.52 9.73L16.77 9.61L16.96 9.41L17.09 9.16L17.13 8.89M17.13 7.59L17.13 10.23",
        "stroke": "truck",
        "strokeWidth": 0.54
      }
    ],
    "kec-ecommerce": [
      {
        "type": "line",
        "d": "M3.45 6.9L3.45 9.98L3.5 10.2L3.62 10.38L3.81 10.5L4.03 10.53L4.25 10.47L4.42 10.33L7.27 6.9M5.25 9.34L7.3 11.5M13 6.9L9.61 6.9L9.42 6.93L9.24 7.02L9.11 7.16L9.02 7.33L8.99 7.52L8.99 10.88L9.02 11.07L9.11 11.24L9.24 11.38L9.42 11.47L9.61 11.5L13 11.5M8.99 9.2L12.4 9.2M18.4 6.9L15.31 6.9L15.12 6.93L14.94 7.02L14.81 7.16L14.72 7.33L14.69 7.52L14.69 10.88L14.72 11.07L14.81 11.24L14.94 11.38L15.12 11.47L15.31 11.5L18.4 11.5",
        "stroke": "accent",
        "strokeWidth": 0.85
      }
    ],
    "thelorry": [
      {
        "type": "line",
        "d": "M3.65 4.6L5.37 4.6M4.51 4.6L3.85 7.9M6.3 4.6L5.64 7.9M7.82 4.6L7.16 7.9M5.97 6.25L7.49 6.25M10.4 4.6L9.08 4.6L8.42 7.9L9.74 7.9M8.75 6.25L9.87 6.25",
        "stroke": "accent",
        "strokeWidth": 0.82
      },
      {
        "type": "line",
        "d": "M4.36 9.3L3.7 12.6L4.89 12.6M6.94 9.3L7.19 9.3L7.45 9.35L7.64 9.51L7.75 9.73L7.75 10L7.37 11.9L7.26 12.17L7.06 12.39L6.81 12.55L6.53 12.6L6.28 12.6L6.02 12.55L5.82 12.39L5.72 12.17L5.72 11.9L6.1 10L6.21 9.73L6.4 9.51L6.66 9.35L6.94 9.3L7.19 9.3M8.49 12.6L9.15 9.3L10.16 9.3L10.32 9.33L10.45 9.43L10.52 9.58L10.52 9.75L10.33 10.67L10.26 10.84L10.14 10.98L9.97 11.08L9.79 11.12L8.79 11.12M9.44 11.12L9.95 12.6M11.21 12.6L11.87 9.3L12.87 9.3L13.04 9.33L13.16 9.43L13.23 9.58L13.23 9.75L13.05 10.67L12.98 10.84L12.85 10.98L12.69 11.08L12.51 11.12L11.51 11.12M12.16 11.12L12.66 12.6M14.45 9.3L14.94 10.95L14.61 12.6M16.1 9.3L14.94 10.95",
        "stroke": "accent",
        "strokeWidth": 0.82
      },
      {
        "type": "polygon",
        "d": "M18.51 4.19L18.7 4.24L18.85 4.38L18.9 4.58L18.85 4.77L18.7 4.92L18.51 4.97L11.54 4.97L11.35 4.92L11.2 4.77L11.15 4.58L11.2 4.38L11.35 4.24L11.54 4.19Z",
        "fill": "accent"
      },
      {
        "type": "polygon",
        "d": "M18.51 5.86L18.7 5.91L18.85 6.05L18.9 6.25L18.85 6.44L18.7 6.59L18.51 6.64L10.81 6.64L10.62 6.59L10.48 6.44L10.42 6.25L10.48 6.05L10.62 5.91L10.81 5.86Z",
        "fill": "accent"
      },
      {
        "type": "polygon",
        "d": "M18.51 7.53L18.7 7.58L18.85 7.72L18.9 7.92L18.85 8.11L18.7 8.26L18.51 8.31L11.03 8.31L10.84 8.26L10.69 8.11L10.64 7.92L10.69 7.72L10.84 7.58L11.03 7.53Z",
        "fill": "accent"
      },
      {
        "type": "polygon",
        "d": "M18.51 8.89L18.7 8.94L18.85 9.09L18.9 9.28L18.85 9.48L18.7 9.62L18.51 9.67L17.67 9.67L17.48 9.62L17.34 9.48L17.28 9.28L17.34 9.09L17.48 8.94L17.67 8.89Z",
        "fill": "accent"
      },
      {
        "type": "polygon",
        "d": "M18.36 10.56L18.55 10.61L18.7 10.76L18.75 10.95L18.7 11.15L18.55 11.29L18.36 11.34L16.85 11.34L16.65 11.29L16.51 11.15L16.46 10.95L16.51 10.76L16.65 10.61L16.85 10.56Z",
        "fill": "accent"
      },
      {
        "type": "polygon",
        "d": "M18.51 12.23L18.7 12.28L18.85 12.43L18.9 12.62L18.85 12.82L18.7 12.96L18.51 13.01L16.3 13.01L16.11 12.96L15.96 12.82L15.91 12.62L15.96 12.43L16.11 12.28L16.3 12.23Z",
        "fill": "accent"
      }
    ],
    "wizmo": [
      {
        "type": "polygon",
        "d": "M13.42 12.1L13.16 12.1L13.01 11.94L12.45 9.95L12.5 9.88L12.81 9.86L13.11 9.74L13.22 9.6L13.16 9.39L12.96 9.24L12.45 9.27L11.43 9.11L10.92 8.86L10.64 8.58L10.64 8.53L10.71 8.5L11.73 8.38L13.01 8.01L13.3 7.81L13.33 7.61L13.26 7.46L13.11 7.39L12.86 7.4L11.73 7.73L10.97 7.85L10.15 7.84L9.57 7.71L9.13 7.51L8.88 7.34L8.62 7.09L8.37 6.64L8.37 6.47L9.08 6.55L9.85 6.55L10.92 6.39L11.4 6.23L11.58 6.11L11.64 5.98L11.62 5.77L11.48 5.65L11.33 5.62L10.41 5.86L9.49 5.96L8.88 5.91L8.11 5.73L7.45 5.44L7.2 5.17L7.15 4.96L7.17 4.8L7.26 4.65L7.46 4.45L8.06 4.14L8.78 3.95L9.69 3.85L10.41 3.9L11.17 4.07L11.94 4.34L12.9 4.91L13.31 5.26L13.62 5.63L13.98 6.17L14.21 6.69L14.36 7.2L14.47 7.86L14.48 9.6L14.54 9.7L14.68 9.8L14.9 9.79L15.05 9.6L15.11 9.14L15.08 7.56L15.15 7.49L15.81 7.32L16.04 7.4L16.91 10.41L17.02 10.87L16.99 11.11L16.73 11.25Z",
        "fill": "accent"
      },
      {
        "type": "polygon",
        "d": "M8.06 7.69L7.04 7.74L6.69 7.68L6.28 7.53L6.08 7.35L6 7.2L6 6.95L6.1 6.74L6.54 6.28L7.04 6L7.14 6.01L7.55 6.22L7.63 6.33L7.79 6.89L8.21 7.61Z",
        "fill": "accent"
      },
      {
        "type": "polygon",
        "d": "M10.05 9.21L9.29 9.33L8.88 9.27L8.26 9.09L7.86 8.83L7.65 8.61L7.58 8.42L8.93 8.17L9.76 8.42L9.88 8.53L10.19 9.04L10.21 9.14Z",
        "fill": "accent"
      },
      {
        "type": "polygon",
        "d": "M12.09 12.99L12.03 12.96L11.92 12.66L11.15 9.9L11.16 9.75L11.22 9.71L11.58 9.78L11.68 9.89L12.27 11.94L12.41 12.5Z",
        "fill": "accent"
      },
      {
        "type": "polygon",
        "d": "M15.94 12.5L12.86 13.29L12.84 13.22L12.97 13.01L13.11 12.89L15.92 12.18L16.07 12.15L16.14 12.2L16.12 12.38Z",
        "fill": "accent"
      },
      {
        "type": "polygon",
        "d": "M10.42 10.84L10.57 10.87L10.67 10.99L10.65 11.15L10.52 11.25L9.99 11.38L9.83 11.35L9.73 11.22L9.76 11.07L9.89 10.97Z",
        "fill": "accent"
      },
      {
        "type": "polygon",
        "d": "M8.95 11.2L9.11 11.22L9.2 11.35L9.18 11.51L9.06 11.61L8.52 11.75L8.36 11.73L8.26 11.61L8.28 11.45L8.41 11.35Z",
        "fill": "accent"
      },
      {
        "type": "polygon",
        "d": "M10.77 12.1L10.92 12.13L11.02 12.25L11 12.41L10.87 12.51L8.67 13.09L8.51 13.07L8.41 12.94L8.43 12.78L8.56 12.68Z",
        "fill": "accent"
      }
    ],
    "ams-egroup": [
      {
        "type": "line",
        "d": "M3.46 11L5.21 7.2L5.51 7.2L5.74 11M4.02 9.78L5.67 9.78M7.03 11L7.79 7.2L8.09 7.2L8.65 9.56L10.15 7.2L10.45 7.2L9.69 11M13.4 7.75L13.23 7.43L12.92 7.24L12.54 7.21L12.15 7.35L11.82 7.64L11.61 8.02L11.56 8.42L11.68 8.77L11.94 9.01L12.3 9.1L12.66 9.19L12.92 9.43L13.04 9.78L12.99 10.18L12.78 10.56L12.45 10.85L12.06 10.99L11.68 10.96L11.37 10.77L11.2 10.45",
        "stroke": "accent",
        "strokeWidth": 0.9
      },
      {
        "type": "circle",
        "cx": 16.64,
        "cy": 9.1,
        "r": 2.4,
        "fill": "#489cd6"
      },
      {
        "type": "polygon",
        "d": "M18.17 9.91L18.09 9.39L17.95 9.06L17.76 8.76L17.5 8.51L17.21 8.32L16.88 8.18L16.53 8.11L16.18 8.11L15.83 8.18L15.5 8.32L15.21 8.51L14.96 8.76L14.76 9.06L14.62 9.39L14.55 9.74L14.55 10.09L14.6 10.35L14.7 10.5L14.95 10.79L15.23 11.03L15.37 10.9L15.2 10.69L15.07 10.44L14.97 10.05L14.97 9.78L15.07 9.38L15.2 9.14L15.47 8.84L15.82 8.63L16.22 8.53L16.49 8.53L16.76 8.58L17.01 8.69L17.34 8.93L17.51 9.14L17.64 9.38L17.72 9.64L17.75 9.91Z",
        "fill": "accent"
      },
      {
        "type": "polygon",
        "d": "M14.56 9.7L18.17 9.7L18.17 10.12L14.56 10.12Z",
        "fill": "accent"
      }
    ],
    "zes-express": [
      {
        "type": "polygon",
        "d": "M12.55 12.33L12.46 12.3L12.6 12.05L13.7 10.8L13.75 10.68L13.35 10.58L13.32 10.43L14.78 8.43L14.82 7.67L15.35 7.58L15.55 7.3L15.15 6.76L4.75 6.74L4.25 6.47L3.45 5.7L3.45 5.57L16.15 5.51L17.08 6.8L16.92 7.42L16.95 7.71L18.58 7.8L19 8.8L18.98 9.43L18.75 10.25L18.45 9.51L18.15 9.36L17.45 9.38Z",
        "fill": "accent"
      },
      {
        "type": "polygon",
        "d": "M14.85 7.68L4.03 7.68L3.73 7.72L3.44 7.85L3.18 8.07L2.98 8.35L2.85 8.69L2.8 9.03L2.8 10.69L2.84 11.04L2.95 11.39L3.14 11.69L3.39 11.94L3.71 12.1L4.02 12.15L5.85 12.15L5.85 11.45L4.08 11.45L3.93 11.43L3.81 11.36L3.69 11.25L3.59 11.09L3.52 10.89L3.5 10.66L3.5 9.07L3.51 8.83L3.56 8.62L3.65 8.44L3.76 8.3L3.9 8.21L4.07 8.16L14.85 8.16Z",
        "fill": "accent"
      },
      {
        "type": "line",
        "d": "M3.15 9.86L5.63 9.86M10.35 8.74L8.37 8.74L8.13 8.8L7.93 8.96L7.8 9.22L7.75 9.51L7.75 9.62L7.8 9.92L7.93 10.17L8.13 10.33L8.37 10.39L9.73 10.39L9.97 10.45L10.17 10.62L10.3 10.87L10.35 11.17L10.35 11.27L10.3 11.57L10.17 11.82L9.97 11.99L9.73 12.05L7.75 12.05",
        "stroke": "accent",
        "strokeWidth": 0.7
      }
    ],
    "profit-fields": [
      {
        "type": "line",
        "d": "M3.35 7.7L3.35 4.3L5.59 4.3L5.76 4.33L5.91 4.43L6 4.58L6.04 4.75L6.04 5.89L6 6.06L5.91 6.21L5.76 6.31L5.59 6.34L3.35 6.34M7.14 7.7L7.14 5.3L8.93 5.3L9.1 5.33L9.25 5.43L9.34 5.58L9.38 5.75L9.38 6.17L9.34 6.34L9.25 6.49L9.1 6.59L8.93 6.62L7.14 6.62M8.03 6.62L9.38 7.7M11.38 5.3L11.93 5.3L12.27 5.37L12.57 5.56L12.76 5.86L12.83 6.2L12.83 6.8L12.76 7.14L12.57 7.44L12.27 7.63L11.93 7.7L11.38 7.7L11.03 7.63L10.74 7.44L10.55 7.14L10.48 6.8L10.48 6.2L10.55 5.86L10.74 5.56L11.03 5.37L11.38 5.3L11.93 5.3M15.72 5.3L13.93 5.3L13.93 7.7M13.93 6.5L15.45 6.5M16.31 6.66L16.31 7.7M17.66 4.3L17.66 7.7M16.9 5.3L18.81 5.3M6.79 4.3L17.66 4.3M17.76 8.7L3.35 8.7L3.35 12.1M3.35 10.4L5.25 10.4M5.9 11.06L5.9 12.1M8.9 9.7L7 9.7L7 12.1L8.9 12.1M7 10.9L8.62 10.9M9.7 9.7L9.7 12.1L11.38 12.1M12.18 10.9L12.18 9.7L13.79 9.7L14.07 9.76L14.32 9.92L14.48 10.16L14.54 10.45L14.54 11.35L14.48 11.64L14.32 11.88L14.07 12.04L13.79 12.1L12.18 12.1L12.18 10.9L12.18 9.7M17.76 9.7L16.19 9.7L15.97 9.74L15.8 9.86L15.68 10.04L15.64 10.25L15.64 10.35L15.68 10.56L15.8 10.74L15.97 10.86L16.19 10.9L17.21 10.9L17.42 10.94L17.6 11.06L17.72 11.24L17.76 11.45L17.76 11.55L17.72 11.76L17.6 11.94L17.42 12.06L17.21 12.1L15.64 12.1",
        "stroke": "accent",
        "strokeWidth": 0.6
      },
      {
        "type": "line",
        "d": "M3.05 12.85L18.81 12.85",
        "stroke": "accent",
        "strokeWidth": 0.5
      },
      {
        "type": "polygon",
        "d": "M15.92 5.3L16.7 5.3L16.7 6.08L15.92 6.08Z",
        "fill": "#f18e00"
      },
      {
        "type": "polygon",
        "d": "M5.51 9.7L6.29 9.7L6.29 10.48L5.51 10.48Z",
        "fill": "#f18e00"
      }
    ],
    "alljoy": [
      {
        "type": "line",
        "d": "M3.18 11.35L4.31 7.45L4.86 7.45L5.98 11.35M3.5 10.26L5.67 10.26M7.16 7.45L7.16 11.35L8.11 11.35M8.88 7.45L8.88 11.35L9.83 11.35M11.91 7.45L11.91 10.6L11.87 10.84L11.75 11.06L11.57 11.22L11.35 11.32L11.11 11.35L10.87 11.29L10.66 11.16L10.51 10.97M16.11 9.4L16.07 9.81L15.98 10.19L15.82 10.55L15.61 10.85L15.36 11.09L15.07 11.25L14.76 11.34L14.45 11.34L14.14 11.25L13.86 11.09L13.6 10.85L13.39 10.55L13.24 10.19L13.14 9.81L13.11 9.4L13.14 8.99L13.24 8.61L13.39 8.25L13.6 7.95L13.86 7.71L14.14 7.55L14.45 7.46L14.76 7.46L15.07 7.55L15.36 7.71L15.61 7.95L15.82 8.25L15.98 8.61L16.07 8.99L16.11 9.4L16.07 9.81M16.75 7.45L17.8 9.4L17.8 11.35M18.85 7.45L17.8 9.4",
        "stroke": "accent",
        "strokeWidth": 0.86
      }
    ],
    "dpe-express": [
      {
        "type": "line",
        "d": "M6.58 9.39L6.56 9.65L6.48 9.91L6.35 10.15L6.17 10.37L5.95 10.56L5.7 10.71L5.42 10.82L5.12 10.89L4.81 10.91L4.5 10.89L4.2 10.82L3.92 10.71L3.67 10.56L3.45 10.37L3.27 10.15L3.14 9.91L3.06 9.65L3.03 9.39L3.06 9.12L3.14 8.87L3.27 8.62L3.45 8.41L3.67 8.22L3.92 8.07L4.2 7.95L4.5 7.88L4.81 7.86L5.12 7.88L5.42 7.95L5.7 8.07L5.95 8.22L6.17 8.41L6.35 8.62L6.48 8.87L6.56 9.12L6.58 9.39L6.56 9.65M6.58 4.62L6.58 10.91M11.23 9.34L11.21 9.6L11.13 9.85L11 10.08L10.82 10.29L10.6 10.47L10.35 10.62L10.07 10.73L9.77 10.8L9.46 10.82L9.15 10.8L8.85 10.73L8.57 10.62L8.32 10.47L8.1 10.29L7.92 10.08L7.79 9.85L7.71 9.6L7.68 9.34L7.71 9.08L7.79 8.83L7.92 8.6L8.1 8.39L8.32 8.21L8.57 8.06L8.85 7.95L9.15 7.88L9.46 7.86L9.77 7.88L10.07 7.95L10.35 8.06L10.6 8.21L10.82 8.39L11 8.6L11.13 8.83L11.21 9.08L11.23 9.34L11.21 9.6M7.68 7.86L7.68 13.16M15.44 8.28L15.26 8.09L15.04 7.94L14.8 7.82L14.54 7.73L14.27 7.68L13.99 7.67L13.72 7.7L13.45 7.77L13.2 7.87L12.97 8L12.76 8.17L12.59 8.36L12.45 8.58L12.36 8.81L12.3 9.05L12.29 9.3L12.32 9.55L12.39 9.78L12.51 10.01L12.66 10.21L12.85 10.4L13.07 10.55L13.31 10.67L13.57 10.76L13.84 10.81L14.11 10.82L14.39 10.79L14.66 10.72L14.91 10.62L15.14 10.49",
        "stroke": "accent",
        "strokeWidth": 0.72
      },
      {
        "type": "polygon",
        "d": "M14.58 9.59L13.72 9.6L13.58 9.55L13.15 9.54L13.14 9.48L13.62 9.41L13.91 9.31L14.67 8.93L15.51 8.29L15.99 7.81L17.03 6.53L17.84 5.29L18.54 4.03L18.58 3.97L18.63 3.99L18.89 5.09L18.89 5.91L18.69 6.57L18.26 7.29L17.63 8.02L17.21 8.39L16.44 8.92L15.53 9.35L14.91 9.54Z",
        "fill": "accent"
      },
      {
        "type": "polygon",
        "d": "M15.29 9.92L14.34 9.88L14.05 9.82L14 9.77L14.58 9.75L15.39 9.65L16.01 9.5L16.53 9.31L17.44 8.84L18.15 8.27L18.82 7.65L18.84 8.15L18.78 8.34L18.49 8.83L18.11 9.16L17.49 9.49L16.91 9.68L16.25 9.84Z",
        "fill": "accent"
      },
      {
        "type": "polygon",
        "d": "M17.3 11.02L16.58 11.03L15.67 10.83L14.72 10.44L14.39 10.25L14.53 10.23L15.44 10.42L16.2 10.42L17.01 10.22L18.25 9.63L18.27 10.01L18.21 10.25L17.97 10.68L17.73 10.87Z",
        "fill": "accent"
      },
      {
        "type": "line",
        "d": "M6.09 11.25L19.3 11.25",
        "stroke": "#ed7f12",
        "strokeWidth": 0.32
      }
    ],
    "goodmaji": [
      {
        "type": "line",
        "d": "M7.14 5.31L6.96 5.07L6.75 4.86L6.52 4.68L6.26 4.54L5.98 4.43L5.69 4.36L5.4 4.33L5.1 4.34L4.81 4.4L4.53 4.49L4.26 4.62L4.02 4.78L3.79 4.98L3.6 5.21L3.44 5.46L3.32 5.73L3.23 6.01L3.19 6.3L3.18 6.6L3.22 6.89L3.3 7.18L3.41 7.46L3.56 7.71L3.75 7.94L3.96 8.15L4.21 8.32L4.47 8.46L4.75 8.56L5.04 8.62L5.33 8.64L5.63 8.62L5.92 8.56L6.2 8.46L6.46 8.32L6.7 8.15L6.92 7.94L7.1 7.71L7.26 7.46L7.37 7.18L7.45 6.9L5.41 6.9M10.4 7.45L10.38 7.67L10.32 7.88L10.23 8.08L10.1 8.26L9.95 8.42L9.77 8.54L9.57 8.63L9.36 8.69L9.14 8.71L8.92 8.69L8.71 8.63L8.51 8.54L8.33 8.42L8.18 8.26L8.05 8.08L7.96 7.88L7.9 7.67L7.88 7.45L7.9 7.24L7.96 7.02L8.05 6.83L8.18 6.65L8.33 6.49L8.51 6.37L8.71 6.27L8.92 6.22L9.14 6.2L9.36 6.22L9.57 6.27L9.77 6.37L9.95 6.49L10.1 6.65L10.23 6.83L10.32 7.02L10.38 7.24L10.4 7.45L10.38 7.67M13.45 7.45L13.43 7.67L13.37 7.88L13.28 8.08L13.15 8.26L13 8.42L12.82 8.54L12.62 8.63L12.41 8.69L12.19 8.71L11.97 8.69L11.76 8.63L11.56 8.54L11.38 8.42L11.23 8.26L11.1 8.08L11.01 7.88L10.95 7.67L10.94 7.45L10.95 7.24L11.01 7.02L11.1 6.83L11.23 6.65L11.38 6.49L11.56 6.37L11.76 6.27L11.97 6.22L12.19 6.2L12.41 6.22L12.62 6.27L12.82 6.37L13 6.49L13.15 6.65L13.28 6.83L13.37 7.02L13.43 7.24L13.45 7.45L13.43 7.67M15.62 7.45L15.6 7.67L15.55 7.88L15.45 8.07L15.33 8.25L15.18 8.4L15 8.53L14.81 8.62L14.6 8.67L14.38 8.69L14.17 8.67L13.96 8.62L13.76 8.53L13.59 8.4L13.43 8.25L13.31 8.07L13.22 7.88L13.16 7.67L13.14 7.45L13.16 7.24L13.22 7.03L13.31 6.83L13.43 6.66L13.59 6.51L13.76 6.38L13.96 6.29L14.17 6.23L14.38 6.22L14.6 6.23L14.81 6.29L15 6.38L15.18 6.51L15.33 6.66L15.45 6.83L15.55 7.03L15.6 7.24L15.62 7.45L15.6 7.67M15.62 4.47L15.62 9.07",
        "stroke": "accent",
        "strokeWidth": 0.86
      },
      {
        "type": "polygon",
        "d": "M9.74 6.32L9.49 6.37L9.17 7.01L9.98 7.11L9.91 7.32L9.63 7.38L9.52 7.78L9.83 8L10.65 8.32L10.74 7.79L10.64 7.62L10.75 7.42L11.15 7.78L11.46 7.69L11.59 7.45L11.59 7.23L11.49 7.07L11.52 6.72L11.19 6.43L11.27 6.2L11.24 5.66L10.75 5.65L10.52 5.87L10.36 6.18L10.1 5.95Z",
        "fill": "truck"
      },
      {
        "type": "polygon",
        "d": "M10.43 7.93L9.97 7.75L9.84 7.67L9.86 7.62L10.12 7.56L10.37 6.84L9.89 6.83L9.82 6.79L9.6 6.77L9.68 6.62L9.93 6.57L9.99 6.45L10.11 6.33L10.16 6.38L10.18 6.5L10.5 6.46L10.66 6.23L10.76 6.04L10.86 5.93L10.97 5.93L10.98 6.16L10.85 6.59L11.04 6.89L11.08 6.89L11.19 6.8L11.24 6.84L11.24 6.95L11.18 7.1L11.31 7.31L11.31 7.38L11.27 7.45L11.22 7.47L10.68 6.98L10.6 7.1L10.32 7.63L10.45 7.85Z",
        "fill": "accent"
      },
      {
        "type": "polygon",
        "d": "M9.1 8.76L9 8.74L9.28 8.62L9.64 8.33L9.84 8.06L9.93 7.8L10 7.8L10.23 7.92L10.23 7.96L10.09 8.17L9.82 8.44L9.46 8.65L9.25 8.72L9.14 8.73Z",
        "fill": "truck"
      },
      {
        "type": "line",
        "d": "M8.64 12.62L8.64 9.72M8.64 10.54L8.68 10.29L8.8 10.06L8.98 9.87L9.21 9.76L9.46 9.72L9.72 9.76L9.95 9.87L10.13 10.06L10.25 10.29L10.29 10.54L10.29 12.62M10.29 10.54L10.33 10.29L10.45 10.06L10.63 9.87L10.86 9.76L11.11 9.72L11.37 9.76L11.6 9.87L11.78 10.06L11.9 10.29L11.94 10.54L11.94 12.62M15.69 11.01L15.67 11.23L15.62 11.44L15.52 11.65L15.39 11.83L15.24 11.98L15.05 12.11L14.85 12.21L14.64 12.26L14.42 12.28L14.2 12.26L13.98 12.21L13.78 12.11L13.6 11.98L13.44 11.83L13.31 11.65L13.22 11.44L13.16 11.23L13.14 11.01L13.16 10.79L13.22 10.57L13.31 10.37L13.44 10.19L13.6 10.03L13.78 9.9L13.98 9.81L14.2 9.75L14.42 9.73L14.64 9.75L14.85 9.81L15.05 9.9L15.24 10.03L15.39 10.19L15.52 10.37L15.62 10.57L15.67 10.79L15.69 11.01L15.67 11.23M15.67 9.79L15.67 12.62M17.11 9.79L17.11 12.8L17.09 12.97L17.02 13.13L16.92 13.26L16.79 13.36L16.63 13.43L16.46 13.45L15.53 13.45M18.58 9.79L18.58 12.62",
        "stroke": "accent",
        "strokeWidth": 1.08
      },
      {
        "type": "circle",
        "cx": 17.13,
        "cy": 8.51,
        "r": 0.7,
        "fill": "accent"
      },
      {
        "type": "circle",
        "cx": 18.58,
        "cy": 8.51,
        "r": 0.71,
        "fill": "accent"
      },
      {
        "type": "line",
        "d": "M8.64 12.62L8.64 9.72M8.64 10.54L8.68 10.29L8.8 10.06L8.98 9.87L9.21 9.76L9.46 9.72L9.72 9.76L9.95 9.87L10.13 10.06L10.25 10.29L10.29 10.54L10.29 12.62M10.29 10.54L10.33 10.29L10.45 10.06L10.63 9.87L10.86 9.76L11.11 9.72L11.37 9.76L11.6 9.87L11.78 10.06L11.9 10.29L11.94 10.54L11.94 12.62M15.69 11.01L15.67 11.23L15.62 11.44L15.52 11.65L15.39 11.83L15.24 11.98L15.05 12.11L14.85 12.21L14.64 12.26L14.42 12.28L14.2 12.26L13.98 12.21L13.78 12.11L13.6 11.98L13.44 11.83L13.31 11.65L13.22 11.44L13.16 11.23L13.14 11.01L13.16 10.79L13.22 10.57L13.31 10.37L13.44 10.19L13.6 10.03L13.78 9.9L13.98 9.81L14.2 9.75L14.42 9.73L14.64 9.75L14.85 9.81L15.05 9.9L15.24 10.03L15.39 10.19L15.52 10.37L15.62 10.57L15.67 10.79L15.69 11.01L15.67 11.23M15.67 9.79L15.67 12.62M17.11 9.79L17.11 12.8L17.09 12.97L17.02 13.13L16.92 13.26L16.79 13.36L16.63 13.43L16.46 13.45L15.53 13.45M18.58 9.79L18.58 12.62",
        "stroke": "#ed7c95",
        "strokeWidth": 0.8
      },
      {
        "type": "circle",
        "cx": 17.13,
        "cy": 8.51,
        "r": 0.56,
        "fill": "#ed7c95"
      },
      {
        "type": "circle",
        "cx": 18.58,
        "cy": 8.51,
        "r": 0.57,
        "fill": "#ed7c95"
      }
    ],
    "lex-my": [
      {
        "type": "line",
        "d": "M4.49 6.9L3.52 11.21L7.24 11.21M12.82 7.46L9.06 7.46L8.22 11.21L11.98 11.21M8.64 9.33L11.89 9.33",
        "stroke": "accent",
        "strokeWidth": 1.12
      },
      {
        "type": "polygon",
        "d": "M16.72 11.77L18.15 11.77L17.09 9.41L19.2 6.99L19.1 6.9L17.55 6.9L15.56 9.19Z",
        "fill": "#fb25a8"
      },
      {
        "type": "polygon",
        "d": "M12.06 11.67L12.17 11.77L13.72 11.77L15.83 9.43L14.62 6.9L13.18 6.9L14.28 9.2Z",
        "fill": "#f5690d"
      }
    ],
    "dex-pk": [
      {
        "type": "line",
        "d": "M7.48 10.1L7.45 10.47L7.36 10.83L7.21 11.17L7 11.47L6.75 11.73L6.46 11.95L6.14 12.1L5.79 12.2L5.44 12.23L5.08 12.2L4.74 12.1L4.42 11.95L4.12 11.73L3.87 11.47L3.67 11.17L3.52 10.83L3.43 10.47L3.39 10.1L3.43 9.73L3.52 9.38L3.67 9.04L3.87 8.74L4.12 8.47L4.42 8.26L4.74 8.1L5.08 8.01L5.44 7.98L5.79 8.01L6.14 8.1L6.46 8.26L6.75 8.47L7 8.74L7.21 9.04L7.36 9.38L7.45 9.73L7.48 10.1L7.45 10.47M7.59 4.7L7.59 12.96",
        "stroke": "accent",
        "strokeWidth": 1.23
      },
      {
        "type": "line",
        "d": "M8.97 7.98L11.99 7.98M8.97 10.27L11.99 10.27M12.55 6.55L17.42 12.96",
        "stroke": "accent",
        "strokeWidth": 0.95
      },
      {
        "type": "polygon",
        "d": "M8.97 11.87L13.06 11.87L18.71 5.17L18.93 5.35L13.52 12.82L8.97 12.82Z",
        "fill": "accent"
      }
    ],
    "parxl": [
      {
        "type": "line",
        "d": "M3.4 7.47L3.4 12.13M6.05 9.22L6.03 9.46L5.97 9.69L5.87 9.91L5.74 10.11L5.58 10.28L5.39 10.41L5.18 10.52L4.96 10.58L4.72 10.6L4.49 10.58L4.27 10.52L4.06 10.41L3.87 10.28L3.71 10.11L3.57 9.91L3.48 9.69L3.42 9.46L3.4 9.22L3.42 8.97L3.48 8.74L3.57 8.52L3.71 8.32L3.87 8.15L4.06 8.02L4.27 7.91L4.49 7.85L4.72 7.83L4.96 7.85L5.18 7.91L5.39 8.02L5.58 8.15L5.74 8.32L5.87 8.52L5.97 8.74L6.03 8.97L6.05 9.22L6.03 9.46M7.85 8.37L7.97 8.21L8.11 8.08L8.28 7.97L8.46 7.9L8.66 7.86L8.85 7.85L9.05 7.88L9.23 7.95L9.4 8.05L9.55 8.18L9.67 8.34L9.76 8.51L9.82 8.7L9.84 8.9L9.84 10.96M9.84 9.9L9.82 10.04L9.77 10.17L9.69 10.29L9.58 10.4L9.44 10.49L9.28 10.57L9.1 10.63L8.92 10.66L8.72 10.67L8.53 10.66L8.34 10.63L8.17 10.57L8.01 10.49L7.87 10.4L7.76 10.29L7.68 10.17L7.63 10.04L7.61 9.9L7.63 9.77L7.68 9.64L7.76 9.52L7.87 9.41L8.01 9.31L8.17 9.24L8.34 9.18L8.53 9.14L8.72 9.13L8.92 9.14L9.1 9.18L9.28 9.24L9.44 9.31L9.58 9.41L9.69 9.52L9.77 9.64L9.82 9.77L9.84 9.9L9.82 10.04M11.61 7.47L11.61 10.96M11.61 9.39L11.63 9.16L11.69 8.94L11.78 8.72L11.92 8.52L12.08 8.35L12.27 8.2L12.49 8.08L12.72 7.99L12.96 7.93L13.22 7.92M18.61 6.3L18.61 10.96",
        "stroke": "accent",
        "strokeWidth": 0.93
      },
      {
        "type": "polygon",
        "d": "M15.57 8.22L16.56 9.21L15.57 10.2L14.58 9.21Z",
        "fill": "#71c3d0"
      },
      {
        "type": "polygon",
        "d": "M14.58 7.23L15.57 8.22L14.58 9.21L13.59 8.22Z",
        "fill": "accent"
      },
      {
        "type": "polygon",
        "d": "M14.58 9.21L15.57 10.2L14.58 11.19L13.59 10.2Z",
        "fill": "accent"
      },
      {
        "type": "polygon",
        "d": "M16.56 7.23L17.55 8.22L16.56 9.21L15.57 8.22Z",
        "fill": "accent"
      },
      {
        "type": "polygon",
        "d": "M16.56 9.21L17.55 10.2L16.56 11.19L15.57 10.2Z",
        "fill": "accent"
      }
    ],
    "efs-asia": [
      {
        "type": "polygon",
        "d": "M8.83 6.28L7.6 6.68L7.02 6.91L5.96 7.41L5.48 7.68L5.03 7.97L4.64 8.26L4.28 8.56L3.98 8.87L3.72 9.18L3.52 9.49L3.36 9.8L3.26 10.11L3.22 10.42L3.22 10.72L3.29 11.01L3.4 11.29L3.57 11.56L3.79 11.82L4.06 12.06L4.38 12.28L4.75 12.49L5.16 12.67L5.61 12.84L6.1 12.98L6.63 13.1L7.19 13.19L8.39 13.31L9.67 13.33L10.33 13.3L11.67 13.17L13.01 12.94L13.66 12.79L14.93 12.43L15.79 11.34L14.47 11.77L13.09 12.13L12.39 12.27L11.69 12.4L10.3 12.57L9.62 12.63L8.32 12.66L7.12 12.59L6.56 12.52L6.04 12.43L5.56 12.31L5.13 12.17L4.74 12.01L4.4 11.83L4.11 11.63L3.87 11.41L3.68 11.17L3.55 10.92L3.48 10.66L3.46 10.38L3.5 10.1L3.6 9.8L3.75 9.5L3.96 9.2L4.22 8.89L4.87 8.28L5.25 7.98L5.67 7.68L6.12 7.4L7.13 6.89L7.68 6.66L8.25 6.46Z",
        "fill": "accent"
      },
      {
        "type": "polygon",
        "d": "M9.73 12.39L8.67 12.4L8.44 12.36L10.52 12.15L11.19 12.02L11.95 11.79L12.89 11.37L13.58 11.33L13.69 11.39L13.64 11.48L13.55 11.54L12.11 12.02L10.73 12.3Z",
        "fill": "accent"
      },
      {
        "type": "line",
        "d": "M10.12 7.62L6.4 7.62L5.37 11.07L9.25 11.07M5.91 9.25L9.5 9.25M14.5 7.62L11.03 7.62L9.84 11.57M10.54 9.25L13.75 9.25M18.13 8.14L17.87 7.88L17.44 7.71L16.9 7.63L16.3 7.66L15.73 7.79L15.26 8.02L14.95 8.3L14.83 8.61L14.93 8.9L15.23 9.14L15.69 9.3L16.25 9.35L16.72 9.39L17.13 9.5L17.44 9.67L17.62 9.89L17.66 10.14L17.55 10.4L17.3 10.64L16.94 10.84L16.49 10.99L16 11.06L15.51 11.07L15.06 10.99L14.88 11.94",
        "stroke": "accent",
        "strokeWidth": 1
      },
      {
        "type": "polygon",
        "d": "M15.99 5.96L15.7 5.9L15.13 5.48L14.56 5.28L13.3 5.31L13.23 5.45L13.07 5.46L12.67 5.23L12.38 5.15L12.27 5.03L11.8 4.8L11.76 4.75L11.81 4.71L11.92 4.72L12.55 4.97L12.68 4.9L12.82 4.6L12.9 4.57L13.08 4.6L13.24 4.9L13.58 4.87L13.62 4.8L13.3 4.53L11.98 3.87L11.94 3.8L12.21 3.78L14.1 4.51L14.61 4.53L14.84 4.67L16.1 4.52L16.85 4.52L17.14 4.58L17.2 4.7L16.96 4.85L16.1 5.1L15.58 5.15L15.65 5.3L15.93 5.33L16.07 5.45L16.05 5.54L15.91 5.65L16.06 5.9Z",
        "fill": "#ec1922"
      }
    ],
    "kart2door": [
      {
        "type": "line",
        "d": "M6.14 8.4L6.18 7.98L6.26 7.57L6.37 7.16L6.51 6.76L6.7 6.38L6.91 6.02L7.15 5.67L7.43 5.35L7.73 5.05L8.05 4.79L8.4 4.55L8.77 4.34L9.16 4.17L9.56 4.03L9.97 3.92L10.38 3.85L10.8 3.82L11.23 3.83L11.65 3.87L12.06 3.95L12.47 4.07L12.86 4.22M14.94 5.97L15.16 6.34L15.35 6.72L15.5 7.11L15.61 7.52L15.69 7.93L15.73 8.35",
        "stroke": "accent",
        "strokeWidth": 0.5
      },
      {
        "type": "polygon",
        "d": "M10.05 6.25L9.07 6.7L8.75 6.75L8.28 6.62L8.04 6.49L7.74 6.44L7.41 6.5L7.16 6.67L7.19 6.95L7.59 7.46L8.28 8L8.63 8.16L9.27 8.14L9.69 8.05L10.32 7.79L10.71 7.74L10.75 7.81L10.68 8.7L12.02 8.4L12.42 7.45L12.65 6.75L14.5 5.67L14.63 5.41L14.59 5.14L14.42 4.9L14.16 4.75L13.82 4.66L13.49 4.66L13.16 4.75L11.59 5.49L11.26 5.55L11.13 5.39L9.94 4.97L9.44 4.88L9.19 4.94L8.99 5.04L8.8 5.22L8.81 5.49L8.97 5.71L9.2 5.88Z",
        "fill": "accent"
      },
      {
        "type": "line",
        "d": "M9.72 5.93L10.51 6.2L11.16 5.77M10.96 7.54L11.01 7.01L11.28 6.65L11.71 6.41",
        "stroke": "truck",
        "strokeWidth": 0.2
      },
      {
        "type": "line",
        "d": "M11.53 10.34L11.7 10.09L12.28 9.86L12.49 9.71L12.62 9.55L12.66 9.39L12.62 9.22L12.56 9.14L12.33 9.04L11.92 9.03L11.06 9.13L8.58 9.54L8.14 9.68L7.55 10.06L7.18 10.44L6.37 11.45M7.99 13.15L8.97 12.34L9.34 12.13L9.69 12.1L11.93 12.09L12.26 12.04L12.77 11.89L13.35 11.61L13.98 11.23L15.2 10.34L15.53 10.06L15.68 9.78L15.64 9.67L15.5 9.57L15.14 9.46L14.88 9.49L14.67 9.57L13.64 10.11L12.91 10.42L12.59 10.5L12.05 10.54L11.73 10.51L11.53 10.39M11.5 10.36L10.8 10.46",
        "stroke": "accent",
        "strokeWidth": 0.45
      }
    ],
    "hart2hart-express": [
      {
        "type": "polygon",
        "d": "M10.64 4.53L10.58 4.51L10.63 4.2L10.53 4L10.23 3.78L9.87 3.72L9.89 3.64L10.31 3.6L10.66 3.68L10.92 3.83L11 4.05L10.96 4.25L10.82 4.43Z",
        "fill": "#00aeef"
      },
      {
        "type": "polygon",
        "d": "M6.02 9.79L5.61 9.8L5.54 9.66L5.5 8.94L5.56 8.2L5.77 7.26L6.08 6.52L6.49 5.88L6.99 5.3L7.56 4.81L7.73 4.7L7.77 4.73L7.11 5.63L6.7 6.52L6.62 6.8L6.74 6.89L7.73 6.9L7.94 6.88L8.04 6.8L8.32 5.81L8.62 5.17L8.41 4.91L8.42 4.63L8.65 4.21L8.98 3.93L9.03 3.94L9.01 4.02L8.78 4.51L8.85 4.76L9.01 4.85L9.18 4.87L10.1 4.81L9.82 4.96L9.44 5.07L8.9 5.11L8.76 5.22L8.43 6.09L8.37 6.77L8.6 6.78L9.72 6.48L10.49 6.18L11.6 5.6L10.95 6.09L10.05 6.58L9.31 6.89L8.37 7.18L8.33 7.69L8.5 9.27L8.47 9.4L8.39 9.44L8.04 9.52L7.92 9.4L7.91 7.31L7.78 7.26L6.48 7.35L6.39 7.57L6.28 8.2L6.26 9.71L6.2 9.77Z",
        "fill": "#00aeef"
      },
      {
        "type": "polygon",
        "d": "M12.14 14.66L12.05 14.6L12.93 14.23L13.77 13.72L14.4 13.2L14.91 12.64L15.32 12L15.63 11.29L15.93 10.22L15.94 9.78L15.87 9.8L14.85 10.97L14.5 11.85L14.1 12.59L13.7 13.12L13.19 13.61L13.11 13.61L13.13 13.56L13.58 13L13.99 12.33L14.3 11.65L14.28 11.51L12.98 12.3L11.99 12.71L10.92 12.93L10.08 12.96L9.95 12.93L9.94 12.87L10.1 12.81L10.71 12.8L11.33 12.72L12.27 12.4L13.37 11.77L14.49 10.81L14.61 10.14L14.6 9.4L14.5 8.71L14.21 7.72L14.46 7.44L14.54 7.46L14.62 7.59L14.91 8.71L14.95 10.22L15 10.26L15.12 10.14L16.03 8.84L15.95 8.02L15.84 7.57L15.37 6.44L15.59 6.11L15.74 6.02L15.93 6.32L16.24 7.06L16.44 7.82L16.54 8.61L16.54 9.25L16.45 10.04L16.24 10.85L16.04 11.39L15.73 12.03L15.31 12.67L14.49 13.53L13.95 13.92L13.39 14.23L12.88 14.44Z",
        "fill": "#00aeef"
      },
      {
        "type": "polygon",
        "d": "M11.43 12.17L10.99 11.67L9.57 9.42L9.49 9.45L9.47 9.91L9.4 10.04L8.19 10.37L7.14 10.53L7.02 10.47L6.84 10.22L6.66 10.48L5.77 10.58L5.67 10.52L5.66 10.22L6.55 10.04L6.57 9.04L6.61 8.92L7.32 10.05L8.01 9.95L8.98 9.69L9.04 9.55L9.04 7.92L9.08 7.77L9.19 7.87L10.46 10.05L10.59 10.19L10.44 9.45L10.49 9.29L11.1 8.89L11.61 9.15L11.63 8.79L11.68 8.67L12.3 8.32L13.01 7.73L13.27 7.77L12.63 6.13L12.75 6.16L13.72 6.9L13.9 6.98L14.71 6.09L15.16 5.35L15.25 5.34L15.43 5.55L15.46 5.68L15.11 6.24L14.03 7.5L13.93 7.56L13.72 7.54L14.3 8.92L14.31 9.06L14.18 9.03L13.24 8.36L13.06 8.3L12.1 8.99L12.12 10.1L11.99 10.06L11.2 9.46L11.1 9.43L10.97 9.51L10.97 9.85L11.45 11.98Z",
        "fill": "accent"
      }
    ],
    "top-logistics-au": [
      {
        "type": "polygon",
        "d": "M5.66 6.04L5.6 6.02L5.6 5.98L5.66 5.92L5.75 5.91L6.47 5.56L7.09 5.38L8.69 5.42L8.82 5.47L9.27 5.47L9.36 5.51L9.8 5.51L9.94 5.56L10.69 5.61L10.78 5.64L11.14 5.65L11.18 5.68L11.41 5.69L11.49 5.73L11.81 5.74L11.85 5.77L12.07 5.78L12.12 5.82L12.34 5.83L12.38 5.86L12.89 5.93L12.87 5.99L12.52 6L12.38 5.96L11.81 5.96L11.67 5.91L11.09 5.91L10.96 5.87L7.53 5.87L7.4 5.91L6.24 5.96L6.11 6L5.71 6.01Z",
        "fill": "accent"
      },
      {
        "type": "polygon",
        "d": "M2.99 9.11L2.94 9.09L3.02 8.83L3.24 8.38L3.32 8.29L3.42 8.07L3.87 7.45L4.53 6.74L5.18 6.23L5.75 6.17L5.84 6.13L6.73 6.09L6.87 6.05L7.89 6.05L8.02 6L10.03 6L10.16 6.05L11.32 6.05L11.45 6.09L12.52 6.13L12.65 6.18L13.01 6.18L13.1 6.22L13.41 6.22L13.54 6.27L13.9 6.27L13.94 6.31L14.21 6.32L14.3 6.36L14.65 6.36L14.96 6.44L15.28 6.45L15.59 6.53L16.17 6.58L16.21 6.62L16.7 6.67L16.89 6.74L16.89 6.78L16.83 6.8L16.66 6.8L16.57 6.76L14.07 6.76L13.9 6.8L13.14 6.8L13.01 6.85L12.65 6.85L12.52 6.89L11.67 6.94L11.63 6.97L11.36 6.99L11.27 7.02L10.92 7.03L10.6 7.11L10.29 7.12L10.25 7.15L9.49 7.25L9.22 7.33L8.51 7.43L7.71 7.64L7.53 7.65L6.64 7.88L6.15 8.04L5.84 8.1L4.33 8.59L4.2 8.67L4.06 8.68L3.93 8.75L3.71 8.81Z",
        "fill": "accent"
      },
      {
        "type": "line",
        "d": "M7.37 8.11L5.57 12.39M11.18 7.4L9.09 12.39",
        "stroke": "accent",
        "strokeWidth": 2.05
      },
      {
        "type": "line",
        "d": "M9.33 11.81L13.14 11.81",
        "stroke": "accent",
        "strokeWidth": 1.2
      },
      {
        "type": "line",
        "d": "M13.36 12.39L15.14 8.16L16.22 8.16L17.99 12.39",
        "stroke": "#cf4841",
        "strokeWidth": 2.05
      }
    ],
    "shipglobal-in": [
      {
        "type": "line",
        "d": "M5.2 5.18L4.98 4.94L4.67 4.78L4.32 4.72L3.97 4.76L3.65 4.91L3.41 5.14L3.28 5.42L3.28 5.72L3.4 6.01L3.63 6.24L3.94 6.4L4.29 6.45L4.65 6.5L4.96 6.66L5.19 6.89L5.31 7.18L5.31 7.48L5.18 7.76L4.94 7.99L4.62 8.14L4.27 8.18L3.91 8.12L3.61 7.96L3.39 7.72M6.2 4.45L6.2 8.45M6.2 6.75L6.24 6.48L6.34 6.24L6.5 6.03L6.71 5.86L6.96 5.76L7.22 5.73L7.49 5.76L7.73 5.86L7.95 6.03L8.11 6.24L8.21 6.48L8.25 6.75L8.25 8.45M9.15 5.51L9.15 8.45M10.05 5.46L10.05 9.51M12.5 6.98L12.48 7.19L12.42 7.39L12.33 7.58L12.21 7.75L12.06 7.9L11.88 8.02L11.69 8.11L11.49 8.17L11.27 8.18L11.06 8.17L10.86 8.11L10.66 8.02L10.49 7.9L10.34 7.75L10.22 7.58L10.13 7.39L10.07 7.19L10.05 6.98L10.07 6.77L10.13 6.57L10.22 6.38L10.34 6.21L10.49 6.06L10.66 5.94L10.86 5.85L11.06 5.8L11.27 5.78L11.49 5.8L11.69 5.85L11.88 5.94L12.06 6.06L12.21 6.21L12.33 6.38L12.42 6.57L12.48 6.77L12.5 6.98L12.48 7.19M6.1 10.02L5.88 9.8L5.62 9.63L5.34 9.52L5.04 9.45L4.74 9.45L4.44 9.51L4.16 9.62L3.9 9.79L3.68 10.01L3.5 10.26L3.36 10.55L3.28 10.86L3.25 11.18L3.28 11.49L3.36 11.8L3.49 12.09L3.67 12.35L3.9 12.56L4.15 12.73L4.43 12.85L4.73 12.91L5.03 12.91L5.33 12.85L5.61 12.73L5.87 12.57L6.09 12.35L6.27 12.1L6.41 11.81L6.49 11.5L6.52 11.18L5.08 11.18M7.4 9.18L7.4 13.18M10.74 11.66L10.72 11.87L10.66 12.07L10.57 12.26L10.45 12.44L10.3 12.58L10.13 12.7L9.94 12.79L9.73 12.85L9.52 12.87L9.31 12.85L9.11 12.79L8.92 12.7L8.74 12.58L8.6 12.44L8.47 12.26L8.38 12.07L8.33 11.87L8.31 11.66L8.33 11.45L8.38 11.25L8.47 11.06L8.6 10.89L8.74 10.74L8.92 10.62L9.11 10.53L9.31 10.48L9.52 10.46L9.73 10.48L9.94 10.53L10.13 10.62L10.3 10.74L10.45 10.89L10.57 11.06L10.66 11.25L10.72 11.45L10.74 11.66L10.72 11.87M11.65 9.13L11.65 13.18M14.09 11.66L14.07 11.87L14.02 12.07L13.93 12.26L13.8 12.44L13.65 12.58L13.48 12.7L13.29 12.79L13.08 12.85L12.87 12.87L12.66 12.85L12.45 12.79L12.26 12.7L12.08 12.58L11.93 12.44L11.81 12.26L11.72 12.07L11.67 11.87L11.65 11.66L11.67 11.45L11.72 11.25L11.81 11.06L11.93 10.89L12.08 10.74L12.26 10.62L12.45 10.53L12.66 10.48L12.87 10.46L13.08 10.48L13.29 10.53L13.48 10.62L13.65 10.74L13.8 10.89L13.93 11.06L14.02 11.25L14.07 11.45L14.09 11.66L14.07 11.87M17.39 11.66L17.37 11.87L17.32 12.07L17.23 12.26L17.11 12.44L16.96 12.58L16.79 12.7L16.59 12.79L16.39 12.85L16.18 12.87L15.97 12.85L15.77 12.79L15.57 12.7L15.4 12.58L15.25 12.44L15.13 12.26L15.04 12.07L14.99 11.87L14.97 11.66L14.99 11.45L15.04 11.25L15.13 11.06L15.25 10.89L15.4 10.74L15.57 10.62L15.77 10.53L15.97 10.48L16.18 10.46L16.39 10.48L16.59 10.53L16.79 10.62L16.96 10.74L17.11 10.89L17.23 11.06L17.32 11.25L17.37 11.45L17.39 11.66L17.37 11.87M17.39 10.46L17.39 13.18M18.4 9.13L18.4 13.13",
        "stroke": "accent",
        "strokeWidth": 0.63
      },
      {
        "type": "circle",
        "cx": 9.15,
        "cy": 4.73,
        "r": 0.31,
        "fill": "accent"
      },
      {
        "type": "polygon",
        "d": "M15.08 5.25L16.53 3.75L18.67 3.75L17.34 5.25Z",
        "fill": "#f4a11e"
      },
      {
        "type": "polygon",
        "d": "M17.34 5.25L18.69 3.77L18.69 5.96L17.34 7.54Z",
        "fill": "#d78228"
      }
    ],
    "faster-ae": [
      {
        "type": "polygon",
        "d": "M5.64 12.39L5.04 12.42L4.57 12.36L4.27 12.23L4.15 12.1L4.09 11.94L4.08 11.75L4.12 11.59L4.33 11.18L4.73 10.69L5.23 10.17L5.26 10.2L5.09 10.51L5.03 10.74L5.02 11.02L5.06 11.18L5.16 11.34L5.33 11.49L5.52 11.57L5.77 11.63L6.53 11.64L7.07 11.57L7.99 11.38L9.39 10.97L10.29 10.99L9.7 11.25L8.94 11.54L7.58 11.98L6.6 12.23Z",
        "fill": "accent"
      },
      {
        "type": "line",
        "d": "M6.69 7.46L4.14 7.46L3.35 11.4M3.81 9.1L6.15 9.1M7.19 8.97L7.27 8.84L7.39 8.72L7.53 8.63L7.68 8.57L7.84 8.54L8 8.54L8.15 8.57L8.28 8.64L8.38 8.73L8.44 8.85L8.47 8.98L8.47 9.12L8.24 10.83M8.31 10.1L8.26 10.23L8.19 10.35L8.08 10.47L7.95 10.56L7.8 10.64L7.64 10.69L7.47 10.72L7.31 10.72L7.15 10.69L7.01 10.64L6.89 10.56L6.8 10.47L6.74 10.35L6.71 10.23L6.72 10.1L6.77 9.97L6.84 9.85L6.95 9.74L7.08 9.64L7.23 9.57L7.39 9.51L7.55 9.49L7.72 9.49L7.88 9.51L8.02 9.57L8.14 9.64L8.23 9.74L8.29 9.85L8.32 9.97L8.31 10.1L8.26 10.23M11.12 8.96L10.97 8.82L10.76 8.73L10.51 8.68L10.25 8.7L10.02 8.78L9.85 8.91L9.75 9.07L9.74 9.24L9.82 9.41L9.99 9.54L10.21 9.63L10.46 9.66L10.46 9.69L10.68 9.77L10.84 9.9L10.93 10.06L10.93 10.23L10.84 10.39L10.68 10.52L10.46 10.61L10.21 10.64L9.96 10.61L9.74 10.52L9.58 10.39M12.66 7.63L12.16 10.13L12.23 10.39L12.43 10.56L12.7 10.58L12.98 10.45M11.73 8.55L13.57 8.55M14 9.41L15.73 9.41L15.72 9.24L15.69 9.09L15.63 8.95L15.55 8.84L15.44 8.74L15.31 8.67L15.17 8.63L15.01 8.61L14.85 8.63L14.69 8.68L14.54 8.75L14.39 8.85L14.26 8.97L14.15 9.11L14.06 9.26L13.99 9.42L13.96 9.59L13.95 9.75L13.97 9.91L14.02 10.05L14.09 10.18L14.19 10.29L14.31 10.37L14.45 10.42L14.6 10.45L14.75 10.45L14.92 10.41L15.07 10.35L15.22 10.26L15.36 10.15M17.08 8.3L16.58 10.77M16.99 9.56L17.01 9.42L17.06 9.27L17.15 9.13L17.26 9L17.4 8.89L17.57 8.79L17.75 8.72L17.96 8.66L18.17 8.62L18.39 8.61",
        "stroke": "accent",
        "strokeWidth": 0.79
      },
      {
        "type": "line",
        "d": "M10.21 11.15L17.06 7.34",
        "stroke": "truck",
        "strokeWidth": 0.55
      },
      {
        "type": "line",
        "d": "M10.21 11.15L17.06 7.34",
        "stroke": "accent",
        "strokeWidth": 0.21
      },
      {
        "type": "polygon",
        "d": "M18.93 7.32L18.32 6.84L17.61 7.15L17.58 7.19L17.63 7.31L17.6 7.34L17.37 7.2L17.25 7.24L17.06 7.34L17.03 7.31L17.21 7.21L17.25 7.15L17 7.03L16.96 7L16.98 6.96L17.31 7.02L17.34 7L17.35 6.87L17.37 6.83L17.44 6.81L17.53 6.88L17.6 6.89L17.88 6.65L17.82 6.58L17.18 6.27L16.96 6.11L16.95 6.08L16.99 6.03L17.09 6.04L17.98 6.3L18.2 6.2L18.27 6.27L18.27 6.36L18.32 6.38L18.93 6.01L19.12 5.94L19.31 5.94L19.32 6.01L19.18 6.2L18.69 6.58L18.77 6.76L18.86 6.77L18.9 6.81L18.91 6.87L18.86 6.96L19 7.25Z",
        "fill": "accent"
      }
    ],
    "shipter": [
      {
        "type": "line",
        "d": "M5.35 7.6L4.1 7.6L3.98 7.62L3.86 7.69L3.77 7.79L3.72 7.9L3.42 9.1L3.42 9.21L3.46 9.31L3.54 9.38L3.65 9.4L4.6 9.4L4.71 9.42L4.79 9.49L4.83 9.59L4.82 9.7L4.52 10.9L4.47 11.01L4.38 11.11L4.27 11.18L4.15 11.2L2.9 11.2M6.61 7.24L5.53 11.56M8.16 7.24L7.08 11.56M6.06 9.47L7.61 9.47M9.34 7.24L8.26 11.56M9.43 11.56L10.42 7.6L11.67 7.6L11.78 7.62L11.86 7.69L11.9 7.79L11.9 7.9L11.54 9.32L11.49 9.43L11.4 9.53L11.29 9.59L11.17 9.62L9.92 9.62M12.69 7.6L14.47 7.6M13.58 7.6L12.59 11.56M14.89 7.6L16.36 7.6M14.44 9.4L15.91 9.4M13.99 11.2L15.46 11.2M16.27 11.56L17.26 7.6L18.51 7.6L18.62 7.62L18.7 7.69L18.74 7.79L18.73 7.9L18.38 9.32L18.33 9.43L18.24 9.53L18.12 9.59L18 9.62L16.75 9.62M17.99 9.62L17.51 11.56",
        "stroke": "accent",
        "strokeWidth": 0.72
      }
    ],
    "linear-logistics": [
      {
        "type": "polygon",
        "d": "M13.7 5.74L12.57 5.75L11.57 5.91L10.32 6.27L8.87 6.9L9.78 6.62L10.72 6.46L11.88 6.38L12.96 6.4L13.77 5.74Z",
        "fill": "#e6382f"
      },
      {
        "type": "polygon",
        "d": "M15.02 4.67L13.92 4.72L12.94 4.91L11.72 5.3L10.29 5.96L11.18 5.66L12.1 5.47L13.23 5.35L14.27 5.33L15.08 4.67Z",
        "fill": "#008fd4"
      },
      {
        "type": "polygon",
        "d": "M16.33 3.6L15.27 3.7L14.31 3.91L13.12 4.33L11.71 5.02L12.58 4.69L13.48 4.48L14.58 4.32L15.59 4.26L16.39 3.6Z",
        "fill": "#e6382f"
      },
      {
        "type": "polygon",
        "d": "M10.27 9.02L8.82 8.88L7.81 8.89L6.8 9.03L5.61 9.35L6.44 9.27L7.4 9.29L8.35 9.39L10.4 9.71L11.77 9.71L13.13 9.49L14.49 9.03L13.64 9.17L12.82 9.2L11.38 9.15Z",
        "fill": "#008fd4"
      },
      {
        "type": "polygon",
        "d": "M11.31 8.66L12.54 8.74L13.8 8.65L14.99 8.38L15.96 8.01L14.99 8.16L13.68 8.16L12.69 8.1L10.93 7.89L9.92 7.84L8.95 7.9L7.91 8.09L7.11 8.33L6.21 8.7L7.25 8.46L8.46 8.39L9.81 8.46Z",
        "fill": "#e6382f"
      },
      {
        "type": "polygon",
        "d": "M12.39 6.81L11.22 6.77L10.19 6.9L8.92 7.23L7.45 7.84L8.37 7.58L9.34 7.45L10.54 7.41L11.65 7.47L12.45 6.82Z",
        "fill": "#008fd4"
      },
      {
        "type": "line",
        "d": "M3.98 10.17L3.98 13.05L5.54 13.05M6.51 10.17L6.51 13.32M7.76 13.32L7.76 10.45L8.06 10.45L9.25 13.05L9.55 13.05L9.55 10.17M12.09 10.45L10.8 10.45L10.8 13.05L12.09 13.05M10.8 11.75L11.89 11.75M13.05 13.24L13.93 10.45L14.13 10.45L15.01 13.24M16.25 13.32L16.25 10.45L17.33 10.45L17.59 10.5L17.8 10.65L17.95 10.87L18 11.13L17.95 11.38L17.8 11.6L17.59 11.75L17.33 11.8L16.25 11.8M16.99 11.8L18.09 13.15",
        "stroke": "accent",
        "strokeWidth": 0.55
      }
    ],
    "tonda-global": [
      {
        "type": "polygon",
        "d": "M15.98 6.34L15.7 5.91L15.37 5.5L15.01 5.13L14.61 4.79L14.18 4.5L13.73 4.25L13.25 4.04L12.75 3.89L12.24 3.78L11.73 3.72L11.21 3.72L10.69 3.76L10.18 3.85L9.68 4L9.19 4.19L8.73 4.43L8.3 4.72L7.89 5.04L7.52 5.4L7.18 5.8L6.89 6.23L6.64 6.69L6.43 7.17L6.28 7.66L6.17 8.17L6.11 8.69L6.1 9.21L6.15 9.73L6.24 10.24L6.39 10.74L6.58 11.22L6.82 11.68L7.26 12.33L7.79 12.9L8.4 13.38L9.11 13.79L9.83 14.08L10.62 14.26L11.4 14.31L12.18 14.26L12.4 13.43L11.73 13.53L11.07 13.53L10.41 13.43L9.74 13.23L9.14 12.94L8.57 12.55L8.06 12.08L7.65 11.55L7.34 11.03L7.12 10.49L6.96 9.92L6.88 9.35L6.88 8.76L6.95 8.16L7.1 7.59L7.32 7.05L7.62 6.52L7.97 6.05L8.38 5.64L8.84 5.28L9.34 4.98L9.88 4.75L10.46 4.58L11.04 4.5L11.54 4.48L12.04 4.53L12.5 4.62L12.98 4.77L13.59 5.04L14.15 5.41L14.64 5.85L15.06 6.35Z",
        "fill": "accent"
      },
      {
        "type": "polygon",
        "d": "M14.1 6.83L14.04 6.76L9.45 6.76L9.08 6.91L8.93 7.06L8.83 7.31L8.41 8.99L10.43 9.05L10.79 9.32L10.95 9.74L10.09 13.23L9.95 13.29L9.32 13.01L9.19 13.07L9.14 13.16L9.16 13.81L9.9 14.09L10.69 14.26L11.56 14.31L12.15 14.26L12.19 14.21Z",
        "fill": "accent"
      },
      {
        "type": "polygon",
        "d": "M16.36 9L14.19 9.02L14.09 8.98L14.12 8.66L14.61 6.81L14.75 6.75L17.46 6.78L17.05 8.33L16.92 8.64L16.62 8.92Z",
        "fill": "accent"
      },
      {
        "type": "polygon",
        "d": "M12.63 14.17L13.43 13.91L14.15 13.54L14.84 13.05L15.44 12.45L15.93 11.77L16.3 11.04L16.56 10.24L16.69 9.4L13.87 9.4Z",
        "fill": "#ca2d1c"
      }
    ],
    "liuchen": [
      {
        "type": "polygon",
        "d": "M11.39 14.27L10.18 14.07L9 13.57L7.98 12.78L7.57 12.33L7.21 11.77L8.05 10.59L8.78 9.74L9.65 8.87L10.91 7.88L12.06 7.24L13.02 6.88L14.04 6.7L15.41 6.69L15.66 6.54L15.98 6.12L16.38 6.8L16.67 7.53L16.85 8.36L16.9 9.13L16.82 9.96L16.62 10.72L16.3 11.48L15.89 12.13L14.87 11.81L14.07 11.43L13.27 10.85L12.85 10.31L12.66 9.77L12.69 9.19L12.92 8.59L13.46 7.82L13 8.14L12.41 8.75L12.09 9.26L11.9 9.77L11.86 10.53L12.12 11.3L12.44 11.77L13.02 12.35L14.54 13.37L14.13 13.67L13.18 13.2L12.12 12.38L11.45 11.49L11.22 10.63L11.25 10.12L11.41 9.64L11.9 8.82L12.76 7.94L13.88 7.07L12.8 7.47L11.47 8.17L10.5 8.95L9.91 9.73L9.67 10.31L9.6 10.69L9.6 11.2L9.7 11.74L10.28 12.92Z",
        "fill": "accent"
      },
      {
        "type": "polygon",
        "d": "M6.32 8.4L6.38 7.88L6.63 7.02L7.31 5.81L7.66 5.38L8.3 4.81L9.32 4.18L10.63 3.77L12.09 3.72L13.24 3.96L14.2 4.4L14.66 4.7L13.31 5.69L12.64 5.95L12.22 5.96L11.93 5.88L11.74 5.72L11.66 5.46L11.74 5.24L12.03 4.95L12.38 4.87L12.5 5.05L12.44 5.54L12.96 5.02L13.07 4.76L13.03 4.57L12.76 4.36L12.35 4.28L11.52 4.46L10.82 4.85L10.18 5.33L8.04 7.31L7.12 7.97Z",
        "fill": "accent"
      },
      {
        "type": "polygon",
        "d": "M6.96 11.49L6.76 11.2L6.47 10.4L6.28 9.13L7.03 8.98L7.63 8.7L8.2 8.27L9.19 7.3L10.05 6.7L10.76 6.44L11.26 6.48L9.65 7.57L8.27 8.88L7.4 10.18Z",
        "fill": "accent"
      }
    ],
    "eac-cn": [
      {
        "type": "polygon",
        "d": "M14.59 9.38L12.85 9.04L11.06 8.95L9.4 9.07L7.87 9.38L7.5 8.22L7.13 7.46L6.5 6.64L6.23 6.63L6.06 6.53L6.03 6.24L6.23 6.1L6.52 6.13L6.66 6.34L6.56 6.58L7.3 7.27L7.71 7.49L8.11 7.44L8.29 7.27L8.4 6.99L8.44 6.03L8.4 5.67L8.05 5.56L7.93 5.28L8.1 5.04L8.43 4.98L8.61 5.05L8.74 5.2L8.73 5.45L8.52 5.65L9.1 6.53L9.61 6.99L9.86 7.04L10.12 6.98L10.41 6.76L10.7 6.36L11.09 5.22L11.19 4.59L10.79 4.37L10.71 4.2L10.74 4L11.03 3.75L11.45 3.75L11.66 3.91L11.75 4.15L11.62 4.43L11.27 4.6L11.45 5.55L11.82 6.46L12.08 6.79L12.32 6.97L12.59 7.04L12.83 6.99L13.35 6.55L13.94 5.65L13.74 5.45L13.73 5.2L13.85 5.05L14.04 4.98L14.36 5.04L14.53 5.28L14.42 5.56L14.06 5.67L14.02 5.96L14.05 6.93L14.16 7.25L14.33 7.44L14.73 7.49L15.13 7.29L15.9 6.58L15.8 6.35L15.94 6.13L16.22 6.1L16.43 6.24L16.39 6.53L16.22 6.63L15.97 6.63L15.33 7.45L14.9 8.34Z",
        "fill": "accent"
      },
      {
        "type": "circle",
        "cx": 16.14,
        "cy": 6.37,
        "r": 0.33,
        "fill": "accent"
      },
      {
        "type": "circle",
        "cx": 6.34,
        "cy": 6.37,
        "r": 0.33,
        "fill": "accent"
      },
      {
        "type": "circle",
        "cx": 14.13,
        "cy": 5.33,
        "r": 0.41,
        "fill": "accent"
      },
      {
        "type": "circle",
        "cx": 8.36,
        "cy": 5.33,
        "r": 0.41,
        "fill": "accent"
      },
      {
        "type": "circle",
        "cx": 11.24,
        "cy": 4.16,
        "r": 0.52,
        "fill": "accent"
      },
      {
        "type": "polygon",
        "d": "M11.53 8.14L11.23 7.97L10.93 8.13L11.02 7.85L10.75 7.66L11.1 7.65L11.22 7.37L11.36 7.65L11.71 7.66L11.43 7.85Z",
        "fill": "truck"
      },
      {
        "type": "polygon",
        "d": "M9.75 8.43L9.74 8.14L9.41 8.02L9.75 7.93L9.78 7.63L10 7.87L10.34 7.81L10.13 8.05L10.31 8.31L9.98 8.21Z",
        "fill": "truck"
      },
      {
        "type": "polygon",
        "d": "M12.72 8.43L12.48 8.21L12.14 8.3L12.32 8.05L12.11 7.81L12.46 7.87L12.67 7.63L12.71 7.93L13.05 8.02L12.72 8.14Z",
        "fill": "truck"
      },
      {
        "type": "polygon",
        "d": "M8.49 8.87L8.39 8.58L8.05 8.53L8.35 8.38L8.29 8.09L8.57 8.28L8.89 8.15L8.75 8.42L9.01 8.63L8.65 8.62Z",
        "fill": "truck"
      },
      {
        "type": "polygon",
        "d": "M13.99 8.87L13.81 8.62L13.45 8.63L13.7 8.42L13.57 8.15L13.88 8.28L14.16 8.09L14.11 8.38L14.41 8.53L14.07 8.58Z",
        "fill": "truck"
      },
      {
        "type": "polygon",
        "d": "M14.48 10.15L12.82 9.85L11.06 9.76L9.5 9.86L7.99 10.15L7.91 9.7L8.76 9.48L9.92 9.32L11.03 9.26L12.24 9.29L13.43 9.43L14.53 9.67Z",
        "fill": "accent"
      },
      {
        "type": "line",
        "d": "M9.12 10.75L7.57 10.75L7.57 13.35L9.12 13.35M7.57 12.05L8.81 12.05M9.95 13.58L10.99 10.75L11.29 10.75L12.32 13.58M10.36 12.47L11.91 12.47M15 11.13L14.78 10.92L14.5 10.79L14.19 10.75L13.89 10.8L13.62 10.95L13.4 11.17L13.26 11.45L13.22 11.75L13.22 12.35L13.26 12.65L13.4 12.93L13.62 13.15L13.89 13.3L14.19 13.35L14.5 13.31L14.78 13.18L15 12.97",
        "stroke": "accent",
        "strokeWidth": 0.7
      }
    ],
    "lbtx": [
      {
        "type": "polygon",
        "d": "M8.24 5.56L8.98 5L9.67 4.63L10.1 4.2L10.66 3.82L11.31 3.7L11.96 3.82L12.46 4.2L12.71 4.51L13.39 4.51L13.82 4.72L13.2 5.1L12.64 5.1L12.58 5.37L12.95 5.93L12.77 6.3L12.33 6.92L11.78 7.61L11.34 7.98L10.91 7.85L10.41 7.42L10.19 6.8L10.35 6.27L10.85 5.87L11.46 5.62L11.59 5.31L11.15 5.13L10.54 5.19L9.91 5.22L9.23 5.44L8.68 5.68Z",
        "fill": "accent"
      },
      {
        "type": "line",
        "d": "M6.19 8.55L5.15 13.05L6.65 13.05M8.12 10.93L8.55 9.05L9.59 9.05L9.87 9.1L10.1 9.23L10.26 9.44L10.33 9.7L10.31 9.99L10.2 10.28L10.01 10.54L9.75 10.75L9.46 10.88L9.16 10.93L9.26 10.93L9.57 10.98L9.83 11.13L10.01 11.37L10.1 11.66L10.07 11.99L9.95 12.32L9.73 12.61L9.44 12.85L9.11 13L8.77 13.05L7.63 13.05L8.12 10.93L9.16 10.93M11.17 9.05L13.87 9.05M12.52 9.05L11.49 13.55M14.69 9.05L16.17 13.05M17.09 9.05L13.77 13.05",
        "stroke": "#102721",
        "strokeWidth": 1
      }
    ],
    "deliverdirect": [
      {
        "type": "line",
        "d": "M3.26 6.75L3.26 5.25L4.02 5.25L4.35 5.29L4.66 5.42L4.93 5.62L5.13 5.89L5.26 6.2L5.3 6.53L5.3 6.97L5.26 7.3L5.13 7.61L4.93 7.88L4.66 8.08L4.35 8.21L4.02 8.25L3.26 8.25L3.26 6.75M7.7 5.25L6.32 5.25L6.32 8.25L7.7 8.25M6.32 6.75L7.56 6.75M8.46 4.99L8.46 8.25L9.78 8.25M10.54 4.99L10.54 8.51M11.55 5.07L12.61 8.25L12.81 8.25L13.88 5.07M16.27 5.25L14.89 5.25L14.89 8.25L16.27 8.25M14.89 6.75L16.13 6.75M17.03 8.51L17.03 5.25L17.93 5.25L18.23 5.31L18.48 5.48L18.65 5.73L18.71 6.03L18.65 6.33L18.48 6.58L18.23 6.75L17.93 6.81L17.03 6.81M17.7 6.81L18.79 8.36M4.58 11.45L4.58 9.95L5.35 9.95L5.68 9.99L5.99 10.12L6.25 10.32L6.45 10.59L6.58 10.9L6.62 11.22L6.62 11.67L6.58 12L6.45 12.31L6.25 12.58L5.99 12.78L5.68 12.91L5.35 12.95L4.58 12.95L4.58 11.45M7.64 9.69L7.64 13.21M8.66 13.21L8.66 9.95L9.56 9.95L9.86 10.01L10.12 10.18L10.28 10.43L10.34 10.73L10.28 11.03L10.12 11.28L9.86 11.45L9.56 11.51L8.66 11.51M9.34 11.51L10.42 13.06M12.77 9.95L11.39 9.95L11.39 12.95L12.77 12.95M11.39 11.45L12.64 11.45M15.14 10.3L14.92 10.11L14.64 9.98L14.34 9.95L14.05 10.01L13.78 10.15L13.58 10.37L13.44 10.64L13.4 10.94L13.4 11.96L13.44 12.26L13.58 12.53L13.78 12.75L14.05 12.89L14.34 12.95L14.64 12.92L14.92 12.79L15.14 12.6M15.82 9.95L17.68 9.95M16.75 9.95L16.75 13.21",
        "stroke": "accent",
        "strokeWidth": 0.52
      }
    ],
    "ace-ee": [
      {
        "type": "line",
        "d": "M7.41 11.58L7.41 8.7L7.38 8.44L7.29 8.18L7.14 7.95L6.94 7.73L6.69 7.55L6.4 7.4L6.09 7.3L5.75 7.23L5.41 7.22L5.06 7.25L4.73 7.32L4.42 7.44L4.14 7.59L3.9 7.79M7.41 9.37L4.97 9.37L4.79 9.39L4.61 9.44L4.45 9.52L4.3 9.63L4.18 9.77L4.07 9.92L4 10.1L3.95 10.28L3.93 10.48L3.95 10.67L4 10.86L4.07 11.03L4.18 11.19L4.3 11.32L4.45 11.43L4.61 11.52L4.79 11.57L4.97 11.58L7.41 11.58M12.52 7.94L12.26 7.67L11.97 7.46L11.65 7.32L11.31 7.23L10.96 7.22L10.62 7.28L10.29 7.4L9.98 7.59L9.71 7.83L9.48 8.12L9.3 8.46L9.18 8.82L9.12 9.21L9.12 9.59L9.18 9.98L9.3 10.34L9.48 10.68L9.71 10.97L9.98 11.21L10.29 11.4L10.62 11.52L10.96 11.58L11.31 11.57L11.65 11.48L11.97 11.34L12.26 11.13L12.52 10.86M14 9.33L18.07 9.33L18.02 8.95L17.92 8.58L17.76 8.24L17.54 7.93L17.28 7.67L16.98 7.47L16.65 7.32L16.3 7.24L15.94 7.22L15.59 7.27L15.25 7.39L14.93 7.56L14.65 7.8L14.41 8.08L14.22 8.41L14.09 8.76L14.01 9.14L14 9.52L14.05 9.9L14.16 10.26L14.33 10.6L14.55 10.9L14.82 11.15L15.12 11.35L15.46 11.49L15.81 11.57L16.16 11.58L16.52 11.52L16.85 11.4L17.17 11.21L17.44 10.97L17.68 10.68",
        "stroke": "accent",
        "strokeWidth": 1.26
      }
    ],
    "transnatur": [
      {
        "type": "circle",
        "cx": 11.6,
        "cy": 9.3,
        "r": 5,
        "fill": "accent"
      },
      {
        "type": "circle",
        "cx": 11.6,
        "cy": 9.3,
        "r": 4.3,
        "fill": "truck"
      },
      {
        "type": "line",
        "d": "M9.83 7.65L8.83 13.05M11.73 7.4L10.53 13.84M14.58 5.72L13.1 13.71M7.25 7.65L11.85 7.65L13.47 11.26",
        "stroke": "accent",
        "strokeWidth": 0.68
      },
      {
        "type": "polygon",
        "d": "M6.54 11L16.66 11L16.66 11.62L6.54 11.62Z",
        "fill": "truck"
      }
    ],
    "rhenus-it": [
      {
        "type": "polygon",
        "d": "M6.45 4L15.95 4L15.95 13.5L6.45 13.5Z",
        "fill": "accent"
      },
      {
        "type": "polygon",
        "d": "M6.99 4.54L15.41 4.54L15.41 12.96L6.99 12.96Z",
        "fill": "truck"
      },
      {
        "type": "polygon",
        "d": "M12.44 8.83L15.13 6.31L12.48 6.31L9.78 8.83Z",
        "fill": "accent"
      },
      {
        "type": "polygon",
        "d": "M13.16 11.2L15.12 9.35L9.22 9.35L7.25 11.2Z",
        "fill": "accent"
      }
    ],
    "emons": [
      {
        "type": "line",
        "d": "M6.74 7.54L6.6 7.38L6.4 7.27L6.15 7.23L5.88 7.26L5.59 7.36L5.33 7.52L5.1 7.73L4.94 7.96L4.84 8.21L4.83 8.45L4.89 8.65L5.03 8.82L5.24 8.92L5.94 8.95M5.49 8.95L4.94 9.05L4.67 9.16L4.18 9.5L3.83 9.95L3.72 10.18L3.67 10.42L3.67 10.65L3.72 10.85L3.83 11.03L3.99 11.17L4.18 11.27L4.42 11.32L4.95 11.29L5.22 11.2L5.74 10.91M6.65 11.33L7.7 8.58M7.26 9.73L7.39 9.5L7.57 9.29L7.8 9.13L8.05 9.02L8.3 8.98L8.51 9.02L8.68 9.13L8.78 9.29L8.81 9.5L8.76 9.73L8.15 11.33M8.76 9.73L8.89 9.5L9.07 9.29L9.3 9.13L9.55 9.02L9.8 8.98L10.01 9.02L10.18 9.13L10.28 9.29L10.31 9.5L10.26 9.73L9.65 11.33M12.72 8.98L12.96 9.02L13.15 9.14L13.28 9.33L13.34 9.57L13.33 9.85L13.25 10.16L13.1 10.46L12.9 10.74L12.65 10.99L12.37 11.17L12.09 11.29L11.83 11.33L11.59 11.29L11.4 11.17L11.27 10.99L11.21 10.74L11.22 10.46L11.3 10.16L11.45 9.85L11.65 9.57L11.9 9.33L12.17 9.14L12.45 9.02L12.72 8.98L12.96 9.02M14 11.33L15.05 8.58M14.6 9.76L14.73 9.52L14.92 9.3L15.16 9.13L15.42 9.02L15.67 8.98L15.9 9.02L16.07 9.13L16.18 9.3L16.2 9.52L16.15 9.76L15.55 11.33M18.81 9.25L18.54 8.98L18.3 8.95L18.04 8.98L17.79 9.09L17.57 9.25L17.35 9.56L17.32 9.75L17.44 10.01L18.18 10.25L18.33 10.37L18.39 10.66L18.31 10.87L18.15 11.06L17.79 11.29L17.39 11.37L17.14 11.33L16.85 11.06",
        "stroke": "#030000",
        "strokeWidth": 0.8
      },
      {
        "type": "line",
        "d": "M6.61 7.24L6.47 7.08L6.27 6.97L6.02 6.93L5.75 6.96L5.46 7.06L5.2 7.22L4.97 7.43L4.81 7.66L4.71 7.91L4.7 8.15L4.76 8.35L4.9 8.52L5.11 8.62L5.81 8.65M5.36 8.65L4.81 8.75L4.54 8.86L4.05 9.2L3.7 9.65L3.59 9.88L3.54 10.12L3.54 10.35L3.59 10.55L3.7 10.73L3.86 10.87L4.05 10.97L4.29 11.02L4.82 10.99L5.09 10.9L5.61 10.61M6.52 11.03L7.57 8.28M7.13 9.43L7.26 9.2L7.44 8.99L7.67 8.83L7.92 8.72L8.17 8.68L8.38 8.72L8.55 8.83L8.65 8.99L8.68 9.2L8.63 9.43L8.02 11.03M8.63 9.43L8.76 9.2L8.94 8.99L9.17 8.83L9.42 8.72L9.67 8.68L9.88 8.72L10.05 8.83L10.15 8.99L10.18 9.2L10.13 9.43L9.52 11.03M12.59 8.68L12.83 8.72L13.02 8.84L13.15 9.03L13.21 9.27L13.2 9.55L13.12 9.86L12.97 10.16L12.77 10.44L12.52 10.69L12.24 10.87L11.96 10.99L11.7 11.03L11.46 10.99L11.27 10.87L11.14 10.69L11.08 10.44L11.09 10.16L11.17 9.86L11.32 9.55L11.52 9.27L11.77 9.03L12.04 8.84L12.32 8.72L12.59 8.68L12.83 8.72M13.87 11.03L14.92 8.28M14.47 9.46L14.6 9.22L14.79 9L15.03 8.83L15.29 8.72L15.54 8.68L15.77 8.72L15.94 8.83L16.05 9L16.07 9.22L16.02 9.46L15.42 11.03M18.68 8.95L18.41 8.68L18.17 8.65L17.91 8.68L17.66 8.79L17.44 8.95L17.22 9.26L17.19 9.45L17.31 9.71L18.05 9.95L18.2 10.07L18.26 10.36L18.18 10.57L18.02 10.76L17.66 10.99L17.26 11.07L17.01 11.03L16.72 10.76",
        "stroke": "accent",
        "strokeWidth": 0.8
      }
    ],
    "noerpel": [
      {
        "type": "line",
        "d": "M3.19 7.93L3.19 10.76M4.91 7.93L4.91 10.76M10.43 8.28L9.21 8.28L9.21 10.42L10.43 10.42M9.21 9.33L10.42 9.33M11.26 10.76L11.26 8.28L11.97 8.28L12.15 8.3L12.32 8.37L12.47 8.48L12.58 8.63L12.65 8.8L12.67 8.98L12.65 9.16L12.58 9.33L12.47 9.47L12.32 9.58L12.15 9.65L11.97 9.68L11.26 9.68M13.64 10.76L13.64 8.28L14.39 8.28L14.56 8.3L14.71 8.36L14.84 8.46L14.94 8.59L15.01 8.75L15.03 8.91L15.01 9.08L14.94 9.23L14.84 9.36L14.71 9.46L14.56 9.52L14.39 9.55L13.64 9.55M17.17 8.28L15.97 8.28L15.97 10.42L17.17 10.42M15.97 9.33L17.15 9.33M17.99 7.93L17.99 10.42L19.15 10.42",
        "stroke": "accent",
        "strokeWidth": 0.69
      },
      {
        "type": "polygon",
        "d": "M3.19 7.93L3.19 8.71L4.61 10.76L4.91 10.76L4.91 9.99L3.49 7.93Z",
        "fill": "accent"
      },
      {
        "type": "polygon",
        "d": "M11.47 9.68L12.27 9.68L13.02 10.76L12.21 10.76Z",
        "fill": "accent"
      },
      {
        "type": "circle",
        "cx": 7.05,
        "cy": 9.35,
        "r": 1.55,
        "fill": "accent"
      },
      {
        "type": "polygon",
        "d": "M5.74 10.17L5.83 10.3L5.96 10.44L6.1 10.57L6.23 10.66L8.36 8.52L8.15 8.26L8.01 8.13L7.87 8.04Z",
        "fill": "#ffffff"
      }
    ],
    "super-parcel-track": [
      {
        "type": "polygon",
        "d": "M12.68 14.93L7.42 11.92L7.42 11.5L10.26 11.5L10.26 10.81L6.83 10.81L6.83 10.31L9.02 10.31L9.02 9.69L6.19 9.69L6.19 9.19L9.55 9.19L9.55 8.51L4.77 8.51L4.77 8.01L8.25 8.01L8.25 7.26L7.42 7.26L7.42 6.08L12.68 7.61Z",
        "fill": "accent"
      },
      {
        "type": "polygon",
        "d": "M4.77 6.71L6.89 6.71L6.89 7.21L4.77 7.21Z",
        "fill": "accent"
      },
      {
        "type": "polygon",
        "d": "M3 9.31L5.12 9.31L5.12 9.81L3 9.81Z",
        "fill": "accent"
      },
      {
        "type": "polygon",
        "d": "M4.18 11.26L6.24 11.26L6.24 11.75L4.18 11.75Z",
        "fill": "accent"
      },
      {
        "type": "polygon",
        "d": "M18.43 5.52L18.43 4.98L12.85 3.86L12.74 4.4L17.17 5.28L13.32 6.26L8.08 4.93L7.95 5.45L13.33 6.82Z",
        "fill": "accent"
      },
      {
        "type": "polygon",
        "d": "M13.51 14.87L18.87 11.95L18.87 6.17L18.16 6.17L18.16 11.53L14.22 13.68L14.22 7.5L13.51 7.5Z",
        "fill": "accent"
      }
    ],
    "ural-express": [
      {
        "type": "line",
        "d": "M3.58 6.35L3.58 10.84L3.61 11.09L3.69 11.33L3.83 11.54L4.01 11.72L4.22 11.86L4.46 11.94L4.71 11.97L4.96 11.94L5.2 11.86L5.42 11.72L5.6 11.54L5.73 11.33L5.81 11.09L5.84 10.84L5.84 6.35M7.73 12.55L7.73 6.93L8.41 6.93L8.78 6.98L9.12 7.12L9.42 7.35L9.65 7.65L9.79 8L9.84 8.37L9.79 8.74L9.65 9.08L9.42 9.38L9.12 9.61L8.78 9.75L8.41 9.8L7.73 9.8M8.42 9.8L9.94 12.55M11.79 12.55L13.15 6.93L13.48 6.93L14.84 12.55M13.06 9.77L13.57 9.77M16.61 6.35L16.61 11.97L19.06 11.97",
        "stroke": "accent",
        "strokeWidth": 1.16
      },
      {
        "type": "line",
        "d": "M3.58 6.35L3.58 10.84L3.61 11.09L3.69 11.33L3.83 11.54L4.01 11.72L4.22 11.86L4.46 11.94L4.71 11.97L4.96 11.94L5.2 11.86L5.42 11.72L5.6 11.54L5.73 11.33L5.81 11.09L5.84 10.84L5.84 6.35M7.73 12.55L7.73 6.93L8.41 6.93L8.78 6.98L9.12 7.12L9.42 7.35L9.65 7.65L9.79 8L9.84 8.37L9.79 8.74L9.65 9.08L9.42 9.38L9.12 9.61L8.78 9.75L8.41 9.8L7.73 9.8M8.42 9.8L9.94 12.55M11.79 12.55L13.15 6.93L13.48 6.93L14.84 12.55M13.06 9.77L13.57 9.77M16.61 6.35L16.61 11.97L19.06 11.97",
        "stroke": "truck",
        "strokeWidth": 0.63
      },
      {
        "type": "line",
        "d": "M3.58 6.35L3.58 10.84L3.61 11.09L3.69 11.33L3.83 11.54L4.01 11.72L4.22 11.86L4.46 11.94L4.71 11.97L4.96 11.94L5.2 11.86L5.42 11.72L5.6 11.54L5.73 11.33L5.81 11.09L5.84 10.84L5.84 6.35M7.73 12.55L7.73 6.93L8.41 6.93L8.78 6.98L9.12 7.12L9.42 7.35L9.65 7.65L9.79 8L9.84 8.37L9.79 8.74L9.65 9.08L9.42 9.38L9.12 9.61L8.78 9.75L8.41 9.8L7.73 9.8M8.42 9.8L9.94 12.55M11.79 12.55L13.15 6.93L13.48 6.93L14.84 12.55M13.06 9.77L13.57 9.77M16.61 6.35L16.61 11.97L19.06 11.97",
        "stroke": "accent",
        "strokeWidth": 0.26
      }
    ],
    "onex": [
      {
        "type": "line",
        "d": "M6.76 10.65L6.63 11.15L6.46 11.63L6.25 12.07L6.01 12.45L5.76 12.77L5.49 13.01L5.23 13.15L4.97 13.2L4.74 13.15L4.53 13.01L4.37 12.77L4.25 12.45L4.17 12.07L4.15 11.63L4.18 11.15L4.26 10.65L4.39 10.15L4.57 9.67L4.77 9.23L5.01 8.85L5.27 8.53L5.54 8.29L5.8 8.15L6.06 8.1L6.29 8.15L6.49 8.29L6.66 8.53L6.78 8.85L6.85 9.23L6.88 9.67L6.84 10.15L6.76 10.65L6.63 11.15M7.84 13.2L8.92 8.1L9.52 8.1L9.84 13.2L10.44 13.2L11.52 8.1M15.19 8.1L13.14 8.1L12.05 13.2L14.1 13.2M12.59 10.65L14.23 10.65M16.14 8.1L17.66 13.2M18.74 8.1L15.06 13.2",
        "stroke": "accent",
        "strokeWidth": 1.2
      },
      {
        "type": "polygon",
        "d": "M19.14 3.76L15.27 4.84L15.15 4.92L15.13 5.06L15.22 5.15L16.18 5.56L18.97 3.99L16.77 5.8L18.37 6.47L18.49 6.48L18.64 6.36L19.3 3.91L19.27 3.77Z",
        "fill": "accent"
      },
      {
        "type": "polygon",
        "d": "M16.62 6.76L16.16 5.67L15.88 5.56L16.49 6.96L16.58 7.05L16.68 7.05L16.77 7L17.38 6.22L16.73 5.93Z",
        "fill": "accent"
      }
    ],
    "gcx": [
      {
        "type": "line",
        "d": "M9.7 6.57L9.46 6.28L9.18 6.04L8.85 5.85L8.48 5.71L8.06 5.62L7.54 5.58L6.86 5.59L6.4 5.66L6.01 5.78L5.66 5.94L5.36 6.16L5.09 6.42L4.87 6.73L4.69 7.09L4.56 7.5L4.47 7.96L4.42 8.51L4.42 9.3L4.47 9.85L4.56 10.32L4.69 10.72L4.87 11.08L5.09 11.39L5.36 11.66L5.66 11.87L6.01 12.04L6.4 12.15L6.86 12.22L7.54 12.23L8.06 12.19L8.48 12.1L8.85 11.96L9.18 11.77L9.46 11.53L9.7 11.24L9.9 10.91L10.06 10.53L10.18 10.09L10.24 9.59L10.27 8.97L7.73 8.97",
        "stroke": "accent",
        "strokeWidth": 1.96
      },
      {
        "type": "line",
        "d": "M17.11 6.87L16.95 6.6L16.76 6.36L16.53 6.15L16.29 5.97L16.01 5.82L15.71 5.7L15.37 5.61L15 5.55L14.55 5.52L13.93 5.53L13.51 5.56L13.14 5.63L12.81 5.72L12.52 5.85L12.25 6.01L12 6.19L11.79 6.41L11.6 6.65L11.44 6.92L11.31 7.22L11.2 7.55L11.13 7.92L11.08 8.34L11.07 8.91L11.08 9.47L11.13 9.89L11.2 10.26L11.31 10.59L11.44 10.89L11.6 11.16L11.79 11.41L12 11.62L12.25 11.81L12.52 11.96L12.81 12.09L13.14 12.19L13.51 12.25L13.93 12.29L14.55 12.29L15 12.26L15.37 12.2L15.71 12.11L16.01 11.99L16.29 11.84L16.53 11.66L16.76 11.45L16.95 11.21L17.11 10.94",
        "stroke": "truck",
        "strokeWidth": 3.27
      },
      {
        "type": "line",
        "d": "M17.11 6.87L16.95 6.6L16.76 6.36L16.53 6.15L16.29 5.97L16.01 5.82L15.71 5.7L15.37 5.61L15 5.55L14.55 5.52L13.93 5.53L13.51 5.56L13.14 5.63L12.81 5.72L12.52 5.85L12.25 6.01L12 6.19L11.79 6.41L11.6 6.65L11.44 6.92L11.31 7.22L11.2 7.55L11.13 7.92L11.08 8.34L11.07 8.91L11.08 9.47L11.13 9.89L11.2 10.26L11.31 10.59L11.44 10.89L11.6 11.16L11.79 11.41L12 11.62L12.25 11.81L12.52 11.96L12.81 12.09L13.14 12.19L13.51 12.25L13.93 12.29L14.55 12.29L15 12.26L15.37 12.2L15.71 12.11L16.01 11.99L16.29 11.84L16.53 11.66L16.76 11.45L16.95 11.21L17.11 10.94",
        "stroke": "accent",
        "strokeWidth": 1.96
      }
    ],
    "tusou": [
      {
        "type": "polygon",
        "d": "M6.57 10.47L6.35 9.51L6.35 8.29L6.69 7L7.17 6.11L8.68 6.08L10.04 5.81L11.13 5.33L11.51 5.02L10.93 4.65L10.79 4.65L9.97 5.17L9.29 5.46L8.34 5.72L7.53 5.8L7.44 5.77L7.66 5.5L8.27 4.93L8.89 4.53L9.63 4.19L10.93 3.91L11.81 3.92L12.56 4.05L13.37 4.34L13.87 4.62L12.42 4.99L10.52 5.67L9.16 6.35L8.34 6.89L7.49 7.68L7.08 8.22L6.81 8.76L6.61 9.44Z",
        "fill": "accent"
      },
      {
        "type": "polygon",
        "d": "M11.88 13.87L10.86 13.88L9.84 13.68L9.02 13.34L8.27 12.87L7.65 12.3L7.17 11.69L7.15 10.8L7.23 10.4L7.45 9.85L7.93 9.17L8.34 8.76L9.09 8.21L9.84 7.8L10.79 7.39L12.89 6.79L13.7 5.43L14.19 4.8L15.23 5.77L15.57 6.25L15.98 7.06L16.18 7.68L16.32 8.56L16.31 9.31L16.18 10.12L15.98 10.74L15.57 11.55L15.23 12.03L14.46 12.8L13.99 13.14L13.17 13.55Z",
        "fill": "accent"
      },
      {
        "type": "polygon",
        "d": "M11.84 13.19L11.32 11.95L11.08 11.54L10.18 11.47L9.37 11.28L8.97 11.08L8.56 10.65L8.43 10.26L8.43 9.86L8.56 9.32L8.94 8.46L8.92 8.44L8.15 9.22L7.6 10.18L7.46 11.01L7.53 11.36L7.74 11.77L8.33 12.36L9.28 12.84L10.72 13.18L11.75 13.27Z",
        "fill": "truck"
      },
      {
        "type": "polygon",
        "d": "M13.46 11.71L13.18 11.29L12.61 11.32L12.95 11.75Z",
        "fill": "truck"
      },
      {
        "type": "polygon",
        "d": "M14.35 11.92L14 11.49L13.57 11.53L13.77 11.95Z",
        "fill": "truck"
      },
      {
        "type": "polygon",
        "d": "M12.98 12.33L13.03 12.23L12.78 11.83L12.21 11.81L12.13 11.89L12.41 12.32Z",
        "fill": "truck"
      },
      {
        "type": "polygon",
        "d": "M12.36 12.73L12.21 12.35L12.03 12.15L11.52 12.15L11.47 12.3L11.73 12.78Z",
        "fill": "truck"
      },
      {
        "type": "polygon",
        "d": "M12.89 13.28L13.46 13.21L13.19 12.7L12.45 12.64L12.71 13.28Z",
        "fill": "truck"
      }
    ],
    "wise-express": [
      {
        "type": "polygon",
        "d": "M10.36 12.73L10.36 5.15L5.2 5.15L6.47 6.09L6.22 6.3L4.99 6.3L4.81 6.09L4.68 5.15L2.9 5.15L2.9 7.57L5.01 7.57L5.09 7.71L5.09 8.47L4.97 8.66L2.9 8.34L2.9 10.6L3.68 9.97L3.95 9.68L4.36 9.68L4.33 9.99L2.9 11.55L2.9 11.96L3.17 11.81L3.78 11.4L4.13 10.97L4.42 10.93L4.6 11.12L3.9 11.91L3.64 12.28L3.62 12.73L5.13 12.73L5.13 11.69L5.61 11.69L5.61 12.73L6.75 12.73L6.75 11.46L7.29 11.46L7.29 12.73L8.39 12.73L8.39 11.22L8.95 11.22L8.95 12.73Z",
        "fill": "accent"
      },
      {
        "type": "line",
        "d": "M11.2 9.06L11.7 12.46L12 12.46L12.5 9.06L13 12.46L13.3 12.46L13.8 9.06M14.71 10.01L14.71 12.46M16.73 10.29L16.42 10.01L16 10.01L15.69 10.29L15.62 10.71L15.83 11.09L16.21 11.23L16.6 11.38L16.82 11.76L16.75 12.18L16.42 12.46L16 12.46L15.67 12.18M17.45 11.23L18.9 11.23L18.89 10.99L18.85 10.76L18.78 10.54L18.69 10.36L18.57 10.21L18.44 10.09L18.31 10.03L18.16 10.01L18.02 10.04L17.88 10.12L17.76 10.24L17.65 10.4L17.56 10.6L17.5 10.82L17.46 11.05L17.46 11.3L17.48 11.54L17.53 11.77L17.6 11.97L17.7 12.15L17.82 12.3L17.95 12.4L18.09 12.45L18.23 12.46L18.38 12.41L18.51 12.33L18.63 12.19L18.74 12.02",
        "stroke": "#ef9917",
        "strokeWidth": 0.55
      },
      {
        "type": "circle",
        "cx": 14.71,
        "cy": 9.18,
        "r": 0.34,
        "fill": "#ef9917"
      }
    ],
    "rhenus-de": [
      {
        "type": "polygon",
        "d": "M6.45 4L15.95 4L15.95 13.5L6.45 13.5Z",
        "fill": "accent"
      },
      {
        "type": "polygon",
        "d": "M6.99 4.54L15.41 4.54L15.41 12.96L6.99 12.96Z",
        "fill": "truck"
      },
      {
        "type": "polygon",
        "d": "M12.44 8.83L15.13 6.31L12.48 6.31L9.78 8.83Z",
        "fill": "accent"
      },
      {
        "type": "polygon",
        "d": "M13.16 11.2L15.12 9.35L9.22 9.35L7.25 11.2Z",
        "fill": "accent"
      }
    ],
    "skybox": [
      {
        "type": "polygon",
        "d": "M9.35 5.38L7.83 9.98L6.98 10.34L6.12 10.57L5.26 10.67L4.4 10.63L5.04 10.89L5.69 11.1L6.98 11.29L7.62 11.28L8.91 11.1L10.85 10.5L14.08 9.11L15.37 8.63L16.66 8.33L17.95 8.28L16.74 7.81L15.53 7.52L15.75 5.85Z",
        "fill": "accent"
      },
      {
        "type": "polygon",
        "d": "M6.77 13.24L14.63 14.36L15.32 9.17L14.08 9.6L10.21 11.17L8.91 11.52L8.27 11.62L7.28 11.67Z",
        "fill": "accent"
      },
      {
        "type": "line",
        "d": "M11.47 5.65L11.47 5.46L11.5 5.26L11.57 5.06L11.69 4.88L11.85 4.74L12.03 4.63L12.24 4.56L12.46 4.54L12.68 4.56L12.89 4.63L13.08 4.74L13.24 4.88L13.35 5.06L13.43 5.26L13.45 5.46L13.45 5.78",
        "stroke": "accent",
        "strokeWidth": 0.43
      }
    ],
    "delivro": [
      {
        "type": "line",
        "d": "M5.56 9.74L5.53 9.99L5.46 10.22L5.35 10.43L5.19 10.62L5.01 10.78L4.79 10.89L4.56 10.96L4.31 10.99L4.07 10.96L3.84 10.89L3.62 10.78L3.43 10.62L3.28 10.43L3.16 10.22L3.09 9.99L3.07 9.74L3.09 9.5L3.16 9.27L3.28 9.05L3.43 8.86L3.62 8.71L3.84 8.59L4.07 8.52L4.31 8.5L4.56 8.52L4.79 8.59L5.01 8.71L5.19 8.86L5.35 9.05L5.46 9.27L5.53 9.5L5.56 9.74L5.53 9.99M5.56 7.3L5.56 11.26M6.04 9.72L8.9 9.72L8.88 9.53L8.83 9.33L8.75 9.14L8.63 8.97L8.48 8.81L8.32 8.69L8.13 8.59L7.93 8.53L7.72 8.5L7.52 8.51L7.31 8.55L7.11 8.62L6.93 8.73L6.77 8.86L6.64 9.02L6.53 9.2L6.46 9.4L6.42 9.61L6.41 9.81L6.44 10.02L6.51 10.22L6.6 10.41L6.73 10.57L6.88 10.72L7.06 10.83L7.25 10.92L7.45 10.97L7.66 10.99L7.87 10.97L8.07 10.92L8.26 10.83L8.43 10.71L8.59 10.57L8.71 10.4M9.82 7.3L9.82 11.26M10.88 8.27L10.88 11.26M14.76 8.27L14.76 11.26M14.76 9.74L14.77 9.58L14.82 9.42L14.89 9.26L14.99 9.12L15.12 8.99L15.27 8.89L15.43 8.8L15.62 8.73L15.81 8.7L16 8.68M18.88 9.74L18.86 9.99L18.79 10.22L18.67 10.43L18.52 10.62L18.33 10.78L18.11 10.89L17.88 10.96L17.64 10.99L17.39 10.96L17.16 10.89L16.94 10.78L16.76 10.62L16.6 10.43L16.49 10.22L16.42 9.99L16.39 9.74L16.42 9.5L16.49 9.27L16.6 9.05L16.76 8.86L16.94 8.71L17.16 8.59L17.39 8.52L17.64 8.5L17.88 8.52L18.11 8.59L18.33 8.71L18.52 8.86L18.67 9.05L18.79 9.27L18.86 9.5L18.88 9.74L18.86 9.99",
        "stroke": "accent",
        "strokeWidth": 0.74
      },
      {
        "type": "line",
        "d": "M7.13 7.63L8.19 7.63",
        "stroke": "accent",
        "strokeWidth": 0.28
      },
      {
        "type": "polygon",
        "d": "M11.41 8.27L12.15 8.27L12.9 10.27L13.63 8.27L14.36 8.27L13.28 11.26L12.54 11.26Z",
        "fill": "accent"
      },
      {
        "type": "circle",
        "cx": 10.91,
        "cy": 7.65,
        "r": 0.37,
        "fill": "accent"
      },
      {
        "type": "circle",
        "cx": 4.29,
        "cy": 9.74,
        "r": 0.37,
        "fill": "#f04f38"
      },
      {
        "type": "circle",
        "cx": 17.66,
        "cy": 9.74,
        "r": 0.37,
        "fill": "#f04f38"
      }
    ],
    "tforce-integrated-solutions": [
      {
        "type": "polygon",
        "d": "M6 8.33L3.7 8.33L4.14 6.64L11.3 6.64L10.86 8.33L8.56 8.33L7.28 13.23L4.72 13.23Z",
        "fill": "accent"
      },
      {
        "type": "polygon",
        "d": "M11.9 6.64L18.3 6.64L17.86 8.33L14.01 8.33L13.79 9.15L17.06 9.15L16.65 10.72L13.39 10.72L12.72 13.23L10.17 13.23Z",
        "fill": "accent"
      },
      {
        "type": "polygon",
        "d": "M18.11 5.84L18.38 4.8L18.07 4.65L16.72 4.28L15.47 4.01L12.79 3.72L10.46 3.74L8.31 4.01L6.43 4.46L4.29 5.25L4.45 5.49L6.22 5.04L8.26 4.7L9.76 4.58L11.62 4.58L13.12 4.69L14.81 4.95L16.04 5.23Z",
        "fill": "#ff6b5e"
      }
    ],
    "holisol": [
      {
        "type": "line",
        "d": "M3.07 7L3.07 11.03M3.07 9.37L3.1 9.15L3.2 8.95L3.34 8.78L3.53 8.65L3.75 8.56L3.99 8.54L4.22 8.56L4.44 8.65L4.63 8.78L4.78 8.95L4.87 9.15L4.9 9.37L4.9 11.03M8.05 9.66L8.03 9.9L7.95 10.13L7.83 10.34L7.66 10.52L7.47 10.65L7.25 10.73L7.02 10.76L6.79 10.73L6.57 10.65L6.37 10.52L6.2 10.34L6.08 10.13L6 9.9L5.98 9.66L6 9.41L6.08 9.18L6.2 8.97L6.37 8.8L6.57 8.67L6.79 8.58L7.02 8.56L7.25 8.58L7.47 8.67L7.66 8.8L7.83 8.97L7.95 9.18L8.03 9.41L8.05 9.66L8.03 9.9M9.13 7L9.13 11.03M10.54 8.16L10.54 11.03M13.39 8.78L12.94 8.54L12.35 8.54L11.9 8.78L11.79 9.16L12.09 9.48L12.65 9.61L13.22 9.75L13.53 10.07L13.42 10.45L12.95 10.69L12.34 10.69L11.87 10.45M18.93 7L18.93 11.03",
        "stroke": "accent",
        "strokeWidth": 0.75
      },
      {
        "type": "circle",
        "cx": 10.53,
        "cy": 7.56,
        "r": 0.42,
        "fill": "accent"
      },
      {
        "type": "polygon",
        "d": "M15.55 8.67L15.8 8.81L15.84 8.78L15.8 8.62L15.82 8.47L15.98 8.26L16.2 8.21L16.44 8.25L16.62 8.5L16.63 8.65L16.57 8.77L16.62 8.81L16.87 8.67L17.12 8.61L17.23 8.5L17.21 8.28L16.93 7.86L16.65 7.67L16.44 7.59L15.98 7.59L15.76 7.67L15.5 7.85L15.24 8.25L15.19 8.49L15.32 8.63Z",
        "fill": "#46b653"
      },
      {
        "type": "polygon",
        "d": "M17.18 8.98L17.04 9.23L17.06 9.27L17.23 9.22L17.37 9.24L17.59 9.4L17.64 9.62L17.6 9.86L17.34 10.05L17.2 10.05L17.07 10L17.04 10.05L17.18 10.29L17.24 10.54L17.35 10.65L17.57 10.63L17.99 10.35L18.18 10.08L18.26 9.86L18.26 9.41L18.18 9.18L18 8.92L17.6 8.66L17.36 8.61L17.22 8.74Z",
        "fill": "#46b653"
      },
      {
        "type": "polygon",
        "d": "M16.87 10.6L16.62 10.46L16.58 10.49L16.63 10.65L16.61 10.8L16.44 11.02L16.23 11.06L15.99 11.02L15.8 10.77L15.79 10.62L15.85 10.5L15.8 10.46L15.55 10.6L15.31 10.66L15.2 10.77L15.22 10.99L15.5 11.41L15.77 11.6L15.99 11.68L16.44 11.68L16.66 11.6L16.92 11.42L17.19 11.03L17.24 10.78L17.1 10.64Z",
        "fill": "#46b653"
      },
      {
        "type": "polygon",
        "d": "M15.25 10.29L15.38 10.04L15.36 10L15.2 10.05L15.05 10.03L14.83 9.87L14.78 9.65L14.83 9.41L15.08 9.22L15.23 9.22L15.35 9.27L15.39 9.22L15.25 8.98L15.19 8.73L15.08 8.62L14.85 8.64L14.44 8.92L14.25 9.19L14.17 9.41L14.17 9.86L14.25 10.09L14.43 10.35L14.82 10.61L15.07 10.66L15.2 10.53Z",
        "fill": "#46b653"
      }
    ],
    "ubx-uk": [
      {
        "type": "polygon",
        "d": "M5.6 12.32L4.54 12.23L4.01 12.07L3.36 11.65L2.93 11.07L2.78 10.65L2.68 10.09L2.68 6.82L2.76 6.76L4.51 6.75L4.61 6.79L4.65 10.17L4.75 10.42L4.91 10.6L5.08 10.68L5.5 10.75L6.03 10.66L6.26 10.49L6.36 10.29L6.43 9.83L6.43 6.87L6.47 6.75L15.5 6.75L15.61 6.84L15.99 7.48L16.49 6.75L18.66 6.78L17.15 8.93L19.31 12.1L19.29 12.17L16.97 12.16L16.02 10.55L15.95 10.53L14.92 12.17L12.64 12.17L12.47 12.08L11.58 12.16L8.31 12.17L8.25 12.1L8.27 10.89L8.23 10.82L7.84 11.5L7.59 11.74L7.23 11.98L6.56 12.22Z",
        "fill": "accent"
      },
      {
        "type": "polygon",
        "d": "M11.22 8.42L11.54 8.36L11.76 8.19L11.82 7.81L11.68 7.51L11.51 7.42L11.16 7.38L10.24 7.38L10.24 8.41Z",
        "fill": "truck"
      },
      {
        "type": "polygon",
        "d": "M13.97 10.1L14.77 8.93L13.8 7.49L13.71 7.43L13.66 8.02L13.57 8.25L13.3 8.6L13 8.85L13.38 9.06L13.65 9.32L13.82 9.62L13.91 10.08Z",
        "fill": "truck"
      },
      {
        "type": "polygon",
        "d": "M16.08 8.87L17.3 8.02L15 8.66L15.06 8.74Z",
        "fill": "truck"
      },
      {
        "type": "polygon",
        "d": "M15.77 10.03L17.37 8.16L17.29 8.16L16.15 9L15.73 9.97Z",
        "fill": "truck"
      },
      {
        "type": "polygon",
        "d": "M11.04 10.7L11.6 10.67L11.92 10.5L12 10.32L12.02 10.08L11.93 9.81L11.7 9.64L11.38 9.58L10.25 9.58L10.23 10.68Z",
        "fill": "truck"
      },
      {
        "type": "line",
        "d": "M2.82 10.48L3.51 10.59L4.51 10.69L5.03 10.73M5.79 10.77L6.5 10.78L7.5 10.76L8.5 10.7L9.49 10.59L10.17 10.49M12.08 10.08L12.48 9.98L13.48 9.68L13.73 9.59M14.61 9.28L15.47 8.93M2.97 10.99L3.51 11.05L4.51 11.14L5.51 11.19L6.5 11.21L7.5 11.19L7.95 11.17M8.33 11.15L8.5 11.14L9.49 11.03L10.49 10.88L11.06 10.77M11.91 10.57L12.48 10.43L13.48 10.12L13.83 9.99M14.22 9.84L14.48 9.75L15.47 9.32M3.31 11.48L3.51 11.5L4.51 11.59L5.51 11.64L6.5 11.66L7.5 11.64L7.61 11.63M8.32 11.58L8.5 11.57L9.49 11.47L10.49 11.31L11.49 11.11L12.48 10.85L13.48 10.54L14.48 10.17L15.47 9.74",
        "stroke": "#038dd6",
        "strokeWidth": 0.22
      },
      {
        "type": "polygon",
        "d": "M4.55 6.61L2.79 6.62L2.68 6.58L2.68 6.14L2.79 6.1L4.61 6.1L4.63 6.54Z",
        "fill": "#e11b22"
      },
      {
        "type": "polygon",
        "d": "M15.44 6.63L6.5 6.63L6.43 6.55L6.42 6.23L6.44 6.1L6.48 6.1L15.19 6.1L15.47 6.51Z",
        "fill": "#e11b22"
      },
      {
        "type": "polygon",
        "d": "M16.59 6.63L16.53 6.53L16.81 6.1L19.09 6.1L19.06 6.23L18.71 6.62Z",
        "fill": "#e11b22"
      }
    ],
    "ttk-europe": [
      {
        "type": "polygon",
        "d": "M3.56 4.9L14.89 4.9L14.39 6.27L13.45 6.95L13.91 7.61L13.33 9.21L11.77 9.21L12.95 5.98L2.6 5.98L3.14 5.29Z",
        "fill": "accent"
      },
      {
        "type": "polygon",
        "d": "M5.34 6.21L6.89 6.21L5.79 9.21L4.24 9.21Z",
        "fill": "accent"
      },
      {
        "type": "polygon",
        "d": "M9.36 6.21L10.91 6.21L9.82 9.21L8.27 9.21Z",
        "fill": "accent"
      },
      {
        "type": "polygon",
        "d": "M13.9 7.03L16.87 4.9L18.6 4.9L15.81 7.03L17.35 9.21L15.62 9.21Z",
        "fill": "accent"
      },
      {
        "type": "line",
        "d": "M4.62 10.71L3.27 10.71L3.27 12.81L4.62 12.81M3.27 11.76L4.42 11.76M5.57 10.71L5.57 12.03L5.59 12.23L5.67 12.42L5.8 12.58L5.96 12.7L6.14 12.78L6.34 12.81L6.54 12.78L6.73 12.7L6.89 12.58L7.01 12.42L7.09 12.23L7.12 12.03L7.12 10.71M8.32 12.81L8.32 10.71L9.19 10.71L9.37 10.74L9.53 10.82L9.66 10.95L9.74 11.11L9.77 11.29L9.74 11.46L9.66 11.62L9.53 11.75L9.37 11.83L9.19 11.86L8.32 11.86M8.9 11.86L9.77 12.81M10.93 11.63L11 11.28L11.2 10.98L11.5 10.78L11.85 10.71L12.21 10.78L12.51 10.98L12.71 11.28L12.78 11.63L12.78 11.88L12.71 12.24L12.51 12.54L12.21 12.74L11.85 12.81L11.5 12.74L11.2 12.54L11 12.24L10.93 11.88L10.93 11.63L11 11.28M13.98 12.81L13.98 10.71L14.8 10.71L14.98 10.74L15.14 10.82L15.27 10.95L15.35 11.11L15.38 11.29L15.35 11.46L15.27 11.62L15.14 11.75L14.98 11.83L14.8 11.86L13.98 11.86M17.93 10.71L16.58 10.71L16.58 12.81L17.93 12.81M16.58 11.76L17.73 11.76",
        "stroke": "accent",
        "strokeWidth": 0.5
      }
    ],
    "inntralog": [
      {
        "type": "line",
        "d": "M3.73 7.34L3.23 11.46M4.13 11.46L4.59 7.65L4.77 7.65L5.07 11.15L5.25 11.15L5.71 7.34M6.11 11.46L6.57 7.65L6.75 7.65L7.06 11.15L7.24 11.15L7.69 7.34M8.27 7.65L9.53 7.65M8.9 7.65L8.45 11.46M9.7 11.46L10.15 7.65L10.31 7.65L10.65 7.72L10.92 7.92L11.08 8.21L11.11 8.56L11 8.91L10.77 9.2L10.45 9.4L10.09 9.47L9.94 9.47M10.26 9.47L10.86 11.33M11.71 11.41L12.77 7.65L12.89 7.65L13.06 11.41M12.1 10.03L13 10.03M14.44 7.34L13.98 11.15L14.83 11.15M16.82 8.22L16.8 8L16.7 7.82L16.53 7.69L16.32 7.65L16.09 7.69L15.89 7.82L15.75 8L15.68 8.22L15.39 10.58L15.41 10.8L15.51 10.98L15.68 11.11L15.9 11.15L16.12 11.11L16.32 10.98L16.47 10.8L16.54 10.58L16.82 8.22L16.8 8M18.82 7.94L18.72 7.79L18.57 7.69L18.4 7.65L18.21 7.67L18.03 7.75L17.88 7.87L17.77 8.04L17.72 8.22L17.43 10.58L17.45 10.8L17.55 10.98L17.72 11.11L17.94 11.15L18.16 11.11L18.36 10.98L18.51 10.8L18.58 10.58L18.7 9.58L18.13 9.58",
        "stroke": "accent",
        "strokeWidth": 0.62
      }
    ],
    "dg-transporte": [
      {
        "type": "line",
        "d": "M4.13 4.3L4.13 8.08",
        "stroke": "#132732",
        "strokeWidth": 2.47
      },
      {
        "type": "line",
        "d": "M2.9 5.1L7.71 5.1L8.12 5.15L8.49 5.31L8.82 5.55L9.06 5.88L9.22 6.25L9.27 6.66L9.27 8.27L9.22 8.67L9.06 9.05L8.82 9.37L8.49 9.62L8.12 9.78L7.71 9.83L2.9 9.83",
        "stroke": "#132732",
        "strokeWidth": 1.62
      },
      {
        "type": "line",
        "d": "M2.9 11.17L10.51 11.17M2.9 11.8L10.92 11.8M2.9 12.45L11.6 12.45M2.9 13.09L12.76 13.09",
        "stroke": "#566873",
        "strokeWidth": 0.31
      },
      {
        "type": "line",
        "d": "M17.78 7.33L17.62 6.96L17.42 6.62L17.19 6.31L16.92 6.03L16.62 5.78L16.29 5.57L15.92 5.39L15.53 5.26L15.12 5.16L14.67 5.11L14.13 5.1L13.65 5.13L13.21 5.2L12.81 5.31L12.43 5.46L12.08 5.65L11.76 5.88L11.47 6.14L11.22 6.44L11 6.76L10.82 7.12L10.68 7.5L10.58 7.91L10.52 8.35L10.51 8.87L10.53 9.35L10.6 9.78L10.71 10.18L10.87 10.55L11.06 10.9L11.29 11.22L11.55 11.5L11.85 11.75L12.18 11.97L12.53 12.15L12.92 12.29L13.33 12.39L13.78 12.45L14.3 12.47L14.8 12.45L15.24 12.38L15.65 12.27L16.03 12.13L16.38 11.94L16.71 11.72L17 11.46L17.26 11.17L17.48 10.85",
        "stroke": "accent",
        "strokeWidth": 1.87
      },
      {
        "type": "line",
        "d": "M18.3 8.3L18.3 13.02",
        "stroke": "accent",
        "strokeWidth": 2
      },
      {
        "type": "line",
        "d": "M15.02 9.05L19.3 9.05",
        "stroke": "accent",
        "strokeWidth": 1.5
      }
    ],
    "bonds-couriers": [
      {
        "type": "line",
        "d": "M3.85 11.03L4.21 9.42L5.19 9.42L5.41 9.46L5.59 9.56L5.71 9.72L5.77 9.93L5.76 10.15L5.72 10.31L5.64 10.53L5.49 10.74L5.29 10.9L5.07 11L4.84 11.03L4.9 11.03L5.15 11.08L5.36 11.2L5.51 11.39L5.58 11.62L5.56 11.89L5.52 12.07L5.42 12.34L5.25 12.57L5.02 12.76L4.76 12.88L4.48 12.92L3.44 12.92L3.85 11.03L4.84 11.03M8.6 11.02L8.61 10.7L8.48 10.42L8.25 10.24L7.94 10.17L7.6 10.24L7.28 10.42L7.04 10.7L6.9 11.02L6.67 12.07L6.66 12.4L6.79 12.68L7.02 12.86L7.33 12.92L7.67 12.86L7.99 12.68L8.23 12.4L8.37 12.07L8.6 11.02L8.61 10.7M9.23 13.27L9.91 10.17L10.11 10.17L10.71 12.92L10.91 12.92L11.59 9.82M12.34 11.55L12.64 10.17L13.19 10.17L13.47 10.21L13.71 10.32L13.9 10.5L14.02 10.72L14.07 10.99L14.05 11.27L13.93 11.82L13.83 12.11L13.66 12.37L13.43 12.6L13.17 12.78L12.88 12.89L12.58 12.92L12.03 12.92L12.34 11.55M16.74 10.49L16.41 10.17L15.88 10.17L15.41 10.49L15.21 10.96L15.38 11.38L15.84 11.55L16.31 11.72L16.5 12.14L16.3 12.61L15.81 12.92L15.26 12.92L14.91 12.61",
        "stroke": "accent",
        "strokeWidth": 0.7
      },
      {
        "type": "circle",
        "cx": 6.7,
        "cy": 3.96,
        "r": 0.24,
        "fill": "accent"
      },
      {
        "type": "circle",
        "cx": 7.47,
        "cy": 3.97,
        "r": 0.27,
        "fill": "accent"
      },
      {
        "type": "circle",
        "cx": 7.54,
        "cy": 4.89,
        "r": 0.27,
        "fill": "#c79334"
      },
      {
        "type": "circle",
        "cx": 8.4,
        "cy": 4.05,
        "r": 0.35,
        "fill": "accent"
      },
      {
        "type": "circle",
        "cx": 8.46,
        "cy": 5.06,
        "r": 0.3,
        "fill": "#c79334"
      },
      {
        "type": "circle",
        "cx": 9.48,
        "cy": 4.17,
        "r": 0.41,
        "fill": "accent"
      },
      {
        "type": "circle",
        "cx": 9.53,
        "cy": 5.34,
        "r": 0.37,
        "fill": "#c79334"
      },
      {
        "type": "circle",
        "cx": 10.75,
        "cy": 5.68,
        "r": 0.48,
        "fill": "#c79334"
      },
      {
        "type": "circle",
        "cx": 10.76,
        "cy": 4.35,
        "r": 0.49,
        "fill": "accent"
      },
      {
        "type": "circle",
        "cx": 12.16,
        "cy": 4.55,
        "r": 0.59,
        "fill": "accent"
      },
      {
        "type": "circle",
        "cx": 12.18,
        "cy": 6.07,
        "r": 0.55,
        "fill": "#c79334"
      },
      {
        "type": "circle",
        "cx": 12.22,
        "cy": 7.5,
        "r": 0.55,
        "fill": "#c79334"
      },
      {
        "type": "circle",
        "cx": 13.79,
        "cy": 4.88,
        "r": 0.69,
        "fill": "accent"
      },
      {
        "type": "circle",
        "cx": 13.87,
        "cy": 6.66,
        "r": 0.68,
        "fill": "#c79334"
      },
      {
        "type": "circle",
        "cx": 13.89,
        "cy": 8.35,
        "r": 0.71,
        "fill": "accent"
      },
      {
        "type": "circle",
        "cx": 15.72,
        "cy": 5.4,
        "r": 0.9,
        "fill": "accent"
      },
      {
        "type": "circle",
        "cx": 15.85,
        "cy": 7.57,
        "r": 0.89,
        "fill": "accent"
      },
      {
        "type": "circle",
        "cx": 18.18,
        "cy": 6.36,
        "r": 1.2,
        "fill": "accent"
      }
    ],
    "amalgamated-distribution": [
      {
        "type": "polygon",
        "d": "M13.54 13.46L9.46 11.18L9.32 11.28L8.06 13.11L5.51 13.12L5.5 13.01L7.4 9.99L3.19 7.37L8.74 8.03L11.73 3.81L15.07 8.83L18.77 9.41L15.98 10.23L17.89 13.18L15.37 13.17L15.17 13.06L13.74 10.96L13.6 10.93L12.52 11.19L12.24 10.57L12.38 10.45L15.07 9.71L7.14 8.71L13.84 12.71L13.89 12.88Z",
        "fill": "accent"
      },
      {
        "type": "polygon",
        "d": "M12.15 8.46L11.67 7.65L11.21 8.32Z",
        "fill": "truck"
      }
    ],
    "victorian-freight-specialists": [
      {
        "type": "circle",
        "cx": 11.8,
        "cy": 9.2,
        "r": 5.4,
        "fill": "#000000"
      },
      {
        "type": "line",
        "d": "M7.51 7.74L8.76 10.41L9.22 10.41L10.41 7.74M10.94 10.85L10.94 8.81L10.97 8.59L11.06 8.38L11.2 8.2L11.38 8.06L11.59 7.97L11.82 7.94L13.31 7.94M10.94 9.23L13.26 9.23M16.5 7.94L14.16 7.94L13.98 7.97L13.83 8.05L13.7 8.17L13.62 8.33L13.59 8.51L13.59 8.71L13.62 8.87L13.69 9.01L13.8 9.13L13.95 9.2L14.11 9.23L15.5 9.23L15.66 9.25L15.8 9.32L15.91 9.44L15.99 9.58L16.01 9.74L16.01 9.95L15.99 10.11L15.91 10.25L15.8 10.36L15.66 10.44L15.5 10.46L13.26 10.46",
        "stroke": "truck",
        "strokeWidth": 0.9
      },
      {
        "type": "line",
        "d": "M7.63 8L8.76 10.41L9.22 10.41L10.3 8M10.94 10.56L10.94 8.81L10.97 8.59L11.06 8.38L11.2 8.2L11.38 8.06L11.59 7.97L11.82 7.94L13.03 7.94M10.94 9.23L12.98 9.23M16.22 7.94L14.16 7.94L13.98 7.97L13.83 8.05L13.7 8.17L13.62 8.33L13.59 8.51L13.59 8.71L13.62 8.87L13.69 9.01L13.8 9.13L13.95 9.2L14.11 9.23L15.5 9.23L15.66 9.25L15.8 9.32L15.91 9.44L15.99 9.58L16.01 9.74L16.01 9.95L15.99 10.11L15.91 10.25L15.8 10.36L15.66 10.44L15.5 10.46L13.54 10.46",
        "stroke": "#000000",
        "strokeWidth": 0.33
      }
    ],
    "vt-freight-express": [
      {
        "type": "polygon",
        "d": "M15.56 13.71L15.12 13.58L15.12 13.37L14.63 13.71L13.56 13.4L13.04 12.57L13.13 12.47L12.73 12.57L12.84 12.28L12.72 12.07L12.57 12.38L12.27 12.42L12.48 12.28L12.62 11.54L11.93 12.2L11.93 12.33L11.69 12.18L11.68 11.98L11.28 11.59L11.35 11.49L10.27 11.1L8.41 11.38L7.82 11.63L7.43 11.99L6.3 11.97L5.42 12.38L4.88 12.28L4.51 12.03L4.54 11.84L4.76 11.74L4.77 11.2L4.01 9.38L4.25 9.14L3.95 8.55L4.13 7.77L4.19 7.69L4.24 7.91L5.12 7.26L5.37 7.3L6.64 6.9L7.12 6.35L7.07 6.05L7.3 5.81L7.55 6.1L7.65 5.96L7.57 5.69L7.82 5.76L7.87 5.44L8.18 5.27L8.14 5.12L8.41 5.1L8.73 4.83L9 4.97L9.19 5.3L9.34 5.19L9.68 5.27L9.61 5.02L9.97 4.45L10.22 4.27L10.76 4.23L10.73 4.04L10.51 3.92L11.64 4.29L11.84 4.19L11.98 4.35L12.13 4.2L12.27 4.29L12.13 4.62L11.93 4.69L11.76 5.22L13.26 6.16L13.54 6.2L13.87 5.66L13.96 4.34L14.29 3.78L14.7 5.02L14.97 4.99L15.25 5.27L15.61 6.64L16.48 7.13L16.81 7.87L17.13 7.86L17.23 8.27L17.96 8.95L18.1 8.85L18.01 9.58L18.22 10.12L18 10.95L17.01 12.62L16.91 13.21L16.15 13.39Z",
        "fill": "accent"
      },
      {
        "type": "polygon",
        "d": "M15.95 15.33L15.51 15.33L15.32 15.14L15.04 14.53L15.07 14.36L15.61 14.52L16.31 14.43L16.2 15.22L16 15.15Z",
        "fill": "accent"
      },
      {
        "type": "line",
        "d": "M7.27 7.12L8.52 10.43L9 10.43L10.26 7.12",
        "stroke": "#000000",
        "strokeWidth": 1.4
      },
      {
        "type": "line",
        "d": "M11.46 7.44L15.19 7.44",
        "stroke": "#000000",
        "strokeWidth": 1.13
      },
      {
        "type": "line",
        "d": "M13.29 7.44L13.29 11.12",
        "stroke": "#000000",
        "strokeWidth": 1.5
      },
      {
        "type": "line",
        "d": "M7.34 7.31L8.52 10.43L9 10.43L10.19 7.31",
        "stroke": "truck",
        "strokeWidth": 1.01
      },
      {
        "type": "line",
        "d": "M11.66 7.44L14.99 7.44",
        "stroke": "truck",
        "strokeWidth": 0.74
      },
      {
        "type": "line",
        "d": "M13.29 7.44L13.29 10.93",
        "stroke": "truck",
        "strokeWidth": 1.11
      }
    ],
    "aland-post": [
      {
        "type": "polygon",
        "d": "M6.82 13.3L10.04 10.65L6.82 9.34Z",
        "fill": "accent"
      },
      {
        "type": "polygon",
        "d": "M7.14 13.49L13.65 13.49L10.39 10.8Z",
        "fill": "accent"
      },
      {
        "type": "polygon",
        "d": "M13.95 13.29L13.95 9.34L10.73 10.64Z",
        "fill": "accent"
      },
      {
        "type": "polygon",
        "d": "M6.5 5.42L6.79 8.73L9.88 7.47L9.81 6.75Z",
        "fill": "accent"
      },
      {
        "type": "polygon",
        "d": "M7.28 9.15L10.19 10.33L10.06 9.15Z",
        "fill": "#97b7c0"
      },
      {
        "type": "polygon",
        "d": "M10.41 9.15L10.54 10.35L13.5 9.15Z",
        "fill": "#97b7c0"
      },
      {
        "type": "polygon",
        "d": "M7.52 8.81L10.02 8.81L9.92 7.83Z",
        "fill": "#97b7c0"
      },
      {
        "type": "polygon",
        "d": "M10.25 7.7L10.37 8.81L13.29 8.81L10.39 7.64Z",
        "fill": "#97b7c0"
      },
      {
        "type": "polygon",
        "d": "M15.49 5.12L12.15 3.76L10.62 7.36L14.03 8.74Z",
        "fill": "#97b7c0"
      }
    ],
    "aruba-post": [
      {
        "type": "polygon",
        "d": "M2.89 5.07L2.45 7.42L2.45 12.33L19.55 8.6L19.55 8.04Z",
        "fill": "#5a5aa0"
      },
      {
        "type": "line",
        "d": "M3.73 5.98L3.73 11.82M3.73 8.19L3.75 7.86L3.83 7.55L3.96 7.26L4.14 7L4.35 6.8L4.59 6.64L4.85 6.54L5.12 6.51L5.39 6.54L5.65 6.64L5.89 6.8L6.1 7L6.28 7.26L6.41 7.55L6.49 7.86L6.51 8.19L6.49 8.52L6.41 8.83L6.28 9.13L6.1 9.38L5.89 9.59L5.65 9.74L5.39 9.84L5.12 9.87L4.85 9.84L4.59 9.74L4.35 9.59L4.14 9.38L3.96 9.13L3.83 8.83L3.75 8.52L3.73 8.19M11.36 8.19L11.33 8.52L11.25 8.83L11.11 9.13L10.92 9.38L10.7 9.59L10.44 9.74L10.16 9.84L9.87 9.87L9.58 9.84L9.3 9.74L9.05 9.59L8.82 9.38L8.63 9.13L8.5 8.83L8.41 8.52L8.38 8.19L8.41 7.86L8.5 7.55L8.63 7.26L8.82 7L9.05 6.8L9.3 6.64L9.58 6.54L9.87 6.51L10.16 6.54L10.44 6.64L10.7 6.8L10.92 7L11.11 7.26L11.25 7.55L11.33 7.86L11.36 8.19L11.33 8.52M14.95 6.9L14.82 6.78L14.64 6.63L14.43 6.51L14.21 6.47L13.97 6.47L13.75 6.51L13.55 6.6L13.37 6.74L13.24 6.9L13.15 7.08L13.1 7.28L13.11 7.48L13.18 7.66L13.3 7.84L13.46 7.99L13.65 8.08L13.87 8.14L14.1 8.19L14.32 8.25L14.55 8.31L14.75 8.4L14.9 8.54L15.03 8.72L15.1 8.91L15.11 9.1L15.07 9.3L14.98 9.49L14.84 9.64L14.65 9.78L14.44 9.87L14.21 9.91L13.97 9.91L13.74 9.87L13.53 9.76L13.33 9.6L13.2 9.49M17.36 5.26L17.36 8.67L17.4 8.98L17.52 9.27L17.71 9.52L17.96 9.71L18.25 9.83L18.56 9.87L18.73 9.87M16.4 6.49L18.73 6.49",
        "stroke": "accent",
        "strokeWidth": 1.06
      },
      {
        "type": "polygon",
        "d": "M9.68 5.46L9.04 7.7L11.11 7.7L12.06 5.46Z",
        "fill": "truck"
      },
      {
        "type": "polygon",
        "d": "M9.8 5.62L11.82 5.62L11 7.54L9.25 7.54Z",
        "fill": "#edb123"
      },
      {
        "type": "polygon",
        "d": "M8.36 11.46L7.74 13.02L19.55 13.02L19.55 11.46Z",
        "fill": "#30a54a"
      }
    ],
    "gibraltar-post": [
      {
        "type": "polygon",
        "d": "M8.51 13.41L7.07 13.41L4.29 10.1L3.93 9.88L3.22 9.88L3.08 9.52L6.58 7.4L6.86 7.42L6.94 7.72L6.6 8.9L7.36 10.63L8.11 9.64L7.99 12.09Z",
        "fill": "#f3a11e"
      },
      {
        "type": "polygon",
        "d": "M17.01 13.41L16.19 13.37L16.47 10.08L16.87 10.94L17.05 10.95L18.14 8.5L18.23 7.91L17.94 7.56L18.14 7.46L19.28 7.89L19.51 8.19L19.03 8.23L18.62 8.81L18.68 9.08L17.09 12.77Z",
        "fill": "#f3a11e"
      },
      {
        "type": "polygon",
        "d": "M8.21 3.69L16.38 3.69L16.38 11.04L16.34 11.58L16.24 12.1L16.07 12.6L15.83 13.08L15.54 13.53L15.18 13.93L14.78 14.28L14.34 14.58L13.86 14.81L13.35 14.99L12.83 15.09L12.3 15.12L11.76 15.09L11.24 14.99L10.73 14.81L10.26 14.58L9.81 14.28L9.41 13.93L9.06 13.53L8.76 13.08L8.53 12.6L8.35 12.1L8.25 11.58L8.21 11.04Z",
        "fill": "#f3a11e"
      },
      {
        "type": "polygon",
        "d": "M8.95 4.4L15.58 4.4L15.58 10.91L15.56 11.35L15.47 11.77L15.33 12.18L15.14 12.57L14.9 12.93L14.61 13.26L14.29 13.54L13.93 13.78L13.54 13.98L13.13 14.12L12.7 14.2L12.27 14.23L11.83 14.2L11.41 14.12L11 13.98L10.61 13.78L10.25 13.54L9.92 13.26L9.64 12.93L9.4 12.57L9.2 12.18L9.06 11.77L8.98 11.35L8.95 10.91Z",
        "fill": "truck"
      },
      {
        "type": "polygon",
        "d": "M8.95 4.4L15.58 4.4L15.58 10.92L8.95 10.92Z",
        "fill": "accent"
      },
      {
        "type": "polygon",
        "d": "M9.51 10.72L9.51 10.35L9.83 10.35L9.83 8.1L9.51 8.1L9.51 7.63L10.18 7.63L10.18 5.86L10.1 5.57L10.32 5.57L10.32 5.76L10.54 5.76L10.54 5.57L10.76 5.57L10.76 5.76L10.98 5.76L10.98 5.57L11.21 5.57L11.12 5.86L11.12 7.63L11.64 7.63L11.64 5.46L11.56 5.18L11.77 5.18L11.77 5.37L11.99 5.37L11.99 5.18L12.2 5.18L12.2 5.37L12.42 5.37L12.42 5.18L12.63 5.18L12.63 5.37L12.84 5.37L12.84 5.18L13.06 5.18L12.98 5.46L12.98 7.63L13.49 7.63L13.49 5.86L13.41 5.57L13.63 5.57L13.63 5.76L13.86 5.76L13.86 5.57L14.08 5.57L14.08 5.76L14.3 5.76L14.3 5.57L14.52 5.57L14.44 5.86L14.44 7.63L15.1 7.63L15.1 8.1L14.79 8.1L14.79 10.35L15.1 10.35L15.1 10.72Z",
        "fill": "truck"
      },
      {
        "type": "polygon",
        "d": "M11.72 10.35L11.72 9.58L11.77 9.36L11.89 9.17L12.08 9.04L12.3 9L12.52 9.04L12.71 9.17L12.84 9.36L12.88 9.58L12.88 10.35Z",
        "fill": "#262626"
      },
      {
        "type": "polygon",
        "d": "M10.26 10.3L10.26 9.72L10.29 9.56L10.38 9.43L10.52 9.34L10.67 9.31L10.83 9.34L10.97 9.43L11.06 9.56L11.09 9.72L11.09 10.3Z",
        "fill": "#262626"
      },
      {
        "type": "polygon",
        "d": "M13.53 10.3L13.53 9.72L13.56 9.56L13.65 9.43L13.79 9.34L13.94 9.31L14.1 9.34L14.24 9.43L14.32 9.56L14.36 9.72L14.36 10.3Z",
        "fill": "#262626"
      },
      {
        "type": "polygon",
        "d": "M10.43 7.57L10.43 6.98L10.44 6.89L10.5 6.82L10.57 6.76L10.66 6.75L10.75 6.76L10.83 6.82L10.88 6.89L10.9 6.98L10.9 7.57Z",
        "fill": "#262626"
      },
      {
        "type": "polygon",
        "d": "M11.96 7.63L11.96 6.97L11.99 6.84L12.06 6.73L12.17 6.66L12.3 6.63L12.43 6.66L12.54 6.73L12.62 6.84L12.65 6.97L12.65 7.63Z",
        "fill": "#262626"
      },
      {
        "type": "polygon",
        "d": "M13.72 7.57L13.72 6.98L13.74 6.89L13.79 6.82L13.86 6.76L13.96 6.75L14.05 6.76L14.12 6.82L14.17 6.89L14.19 6.98L14.19 7.57Z",
        "fill": "#262626"
      },
      {
        "type": "line",
        "d": "M12.8 11.56L12.73 11.7L12.54 11.8L12.29 11.83L12.04 11.8L11.85 11.7L11.78 11.56L11.85 11.43L12.04 11.33L12.29 11.29L12.54 11.33L12.73 11.43L12.8 11.56L12.73 11.7M12.29 11.83L12.29 13.84M12.29 13.84L11.65 13.84L11.65 13.13L12.29 13.13",
        "stroke": "#f3a11e",
        "strokeWidth": 0.31
      }
    ],
    "samoa-post": [
      {
        "type": "line",
        "d": "M5.37 5.02L5.29 4.9L5.17 4.73L5.03 4.6L4.85 4.55L4.65 4.55L4.46 4.6L4.27 4.7L4.08 4.85L3.93 5.02L3.81 5.22L3.73 5.45L3.69 5.66L3.7 5.87L3.76 6.07L3.85 6.22L3.99 6.33L4.17 6.39L4.34 6.45L4.52 6.51L4.7 6.57L4.84 6.67L4.94 6.83L5 7.03L5.02 7.24L4.98 7.45L4.89 7.68L4.77 7.88L4.61 8.05L4.42 8.2L4.23 8.3L4.02 8.35L3.82 8.35L3.63 8.3L3.48 8.17L3.36 8L3.27 7.88M6.02 8.3L7.6 4.6L8.1 4.6L8.05 8.3M6.52 7.12L8.06 7.12M9.32 8.3L10.13 4.6L10.38 4.6L10.78 6.89L12.18 4.6L12.43 4.6L11.62 8.3M15.25 6.45L15.11 6.93L14.92 7.38L14.68 7.76L14.42 8.05L14.15 8.24L13.89 8.3L13.65 8.24L13.46 8.05L13.33 7.76L13.26 7.38L13.26 6.93L13.34 6.45L13.48 5.97L13.67 5.52L13.9 5.14L14.17 4.85L14.44 4.66L14.7 4.6L14.93 4.66L15.12 4.85L15.26 5.14L15.32 5.52L15.32 5.97L15.25 6.45L15.11 6.93M15.92 8.3L17.5 4.6L18 4.6L17.95 8.3M16.42 7.12L17.96 7.12",
        "stroke": "accent",
        "strokeWidth": 0.78
      },
      {
        "type": "line",
        "d": "M3.33 13.1L4.14 9.4L4.9 9.4L5.28 9.48L5.57 9.7L5.72 10.04L5.71 10.44L5.54 10.83L5.25 11.17L4.86 11.39L4.45 11.47L3.69 11.47M8.73 11.25L8.59 11.73L8.39 12.18L8.16 12.56L7.9 12.85L7.62 13.04L7.36 13.1L7.13 13.04L6.94 12.85L6.81 12.56L6.74 12.18L6.74 11.73L6.81 11.25L6.95 10.77L7.15 10.32L7.38 9.94L7.64 9.65L7.92 9.46L8.18 9.4L8.41 9.46L8.6 9.65L8.73 9.94L8.8 10.32L8.8 10.77L8.73 11.25L8.59 11.73M11.77 9.83L11.69 9.7L11.57 9.53L11.43 9.4L11.25 9.35L11.05 9.35L10.85 9.4L10.66 9.5L10.48 9.65L10.33 9.83L10.21 10.02L10.12 10.25L10.08 10.46L10.1 10.67L10.16 10.87L10.25 11.03L10.39 11.12L10.56 11.19L10.74 11.25L10.92 11.31L11.09 11.38L11.24 11.47L11.33 11.63L11.4 11.83L11.41 12.04L11.37 12.25L11.29 12.48L11.17 12.68L11.01 12.85L10.82 13L10.62 13.1L10.42 13.15L10.21 13.15L10.03 13.1L9.88 12.97L9.76 12.8L9.67 12.68M12.6 9.4L14.45 9.4M13.52 9.4L12.71 13.1",
        "stroke": "#b50103",
        "strokeWidth": 0.78
      },
      {
        "type": "line",
        "d": "M15.59 10.55L18.89 10.55L18.89 12.89L15.59 12.89L15.59 10.55L18.89 10.55M15.59 10.55L17.24 11.72L18.89 10.55",
        "stroke": "#b50103",
        "strokeWidth": 0.42
      }
    ],
    "burundi-post": [
      {
        "type": "polygon",
        "d": "M17.25 6.15L15.27 6.12L15.2 5.24L15.12 5.13L15.06 3.9L14.99 3.75L19.61 3.52L19.59 3.62L17.86 5.08L17.49 5.59Z",
        "fill": "#f8f099"
      },
      {
        "type": "polygon",
        "d": "M15.11 6.15L12.72 6.15L12.11 5.74L11.39 5.58L10.49 5.69L9.74 6.15L7.65 6.12L8.03 5.56L8.64 4.91L9.43 4.35L10.62 3.9L11.66 3.83L12.71 4.05L13.71 4.57L14.62 5.39L15.04 5.94Z",
        "fill": "#f8f099"
      },
      {
        "type": "polygon",
        "d": "M7.32 6.15L6.35 6.15L5.87 5.41L5.87 5.24L6.37 4.51L6.51 4.11L6.96 5.1L7.14 5.73L7.35 6.08Z",
        "fill": "#f8f099"
      },
      {
        "type": "polygon",
        "d": "M11.64 14.62L10.99 14.61L10.26 14.46L9.52 14.15L8.94 13.78L8.32 13.22L7.87 12.68L7.43 11.92L7.13 11.19L15.62 11.15L15.48 11.68L15.12 12.37L14.66 13.02L14.06 13.62L12.93 14.31L12.24 14.53Z",
        "fill": "#f8f099"
      },
      {
        "type": "polygon",
        "d": "M3.03 9.86L6.4 9.86L5.97 10.78L2.59 10.78Z",
        "fill": "accent"
      },
      {
        "type": "polygon",
        "d": "M15.46 9.86L18.79 9.86L18.39 10.78L15.03 10.78Z",
        "fill": "accent"
      },
      {
        "type": "line",
        "d": "M7.52 10.46L8.7 6.84L9.56 6.84L9.92 6.91L10.17 7.13L10.28 7.45L10.23 7.83L10.03 8.22L9.71 8.54L9.32 8.76L8.91 8.83L8.05 8.83M8.89 8.83L9.37 10.46M10.96 10.46L12.14 6.84L12.49 6.84L12.66 10.46L13.01 10.46L14.19 6.84M14.59 10.46L15.77 6.84L16.57 6.84L16.94 6.92L17.21 7.15L17.33 7.49L17.28 7.89L17.07 8.29L16.73 8.63L16.31 8.86L15.88 8.94L15.08 8.94",
        "stroke": "accent",
        "strokeWidth": 1
      }
    ],
    "correo-paraguayo": [
      {
        "type": "polygon",
        "d": "M12.71 13.84L12.36 13.82L11.27 13.09L10.91 13.24L9.67 12.73L7.71 12.49L7.14 12.2L6.4 11.55L6.49 11.45L7.43 11.89L8.35 12.05L7.11 11.59L6.21 10.84L5.8 9.95L5.81 9.5L6.63 10.58L7.33 11.09L7.45 11.04L6.31 10.03L5.68 8.9L5.22 8.49L5.48 8.44L5.93 8.74L6.88 9.88L5.8 8.34L5.47 7.16L5.21 6.75L5.38 6.7L5.69 7.04L6.31 8.42L6.49 8.53L5.94 7.05L6.19 5.74L6.06 5.05L6.3 5.21L6.4 5.55L6.42 7.19L6.55 7.62L6.61 5.24L7.46 3.94L7.61 4.05L7.12 5.12L6.87 6.33L7.44 4.68L8.17 3.76L8.56 3.69L8.06 4.26L7.58 5.52L8.37 4.55L9.55 3.85L9.68 3.92L8.71 4.96L7.62 5.7L7.13 6.28L7.16 6.38L7.77 5.7L8.6 5.36L8.99 4.97L9.07 5.05L8.55 5.79L7.34 6.5L6.81 7.26L6.9 7.37L7.23 6.77L7.61 6.42L8.44 6.02L7.13 7.47L6.82 8.15L6.84 8.98L6.96 9.07L7.02 8.09L7.35 7.46L7.6 7.36L7.22 9.44L7.44 10.54L7.55 10.56L7.42 10.25L7.51 8.86L7.82 9.35L8.15 11.1L8.67 11.83L9.09 12.05L8.46 11.39L8.24 10.87L8.3 10.59L9.8 12.31L10.85 12.91L11.41 12.82L12.63 13.35L12.94 13.65Z",
        "fill": "accent"
      },
      {
        "type": "polygon",
        "d": "M13.49 5.29L12.87 5.16L12.42 4.68L12.89 4.65L13.25 4.84L12.84 4.4L12.76 3.92L13.49 4.18L13.89 4.59L13.44 3.73L13.51 3.61L14.24 3.99L14.36 4.53L13.89 4.8L13 4.24L13.32 4.65L13.85 4.9L13.35 4.99L13.65 5.17Z",
        "fill": "#3443b7"
      },
      {
        "type": "polygon",
        "d": "M14.13 4.53L14.14 4.29L13.84 3.94Z",
        "fill": "#3443b7"
      },
      {
        "type": "polygon",
        "d": "M15.64 8.04L15.29 6.94L15.11 6.79L15.11 7.02L14.52 6.78L14.03 6.17L14.16 6.09L14.61 6.59L14.9 6.66L14.37 6.2L14.33 5.67L14.43 5.84L14.63 5.79L14.99 6L15.26 6.58L14.52 5.87L14.46 6.05L15.03 6.59L15.41 6.68L15.16 5.89L14.49 5.67L14.17 5.29L14.82 4.96L15.18 5.29L14.97 5.43L15.13 5.71L15.44 4.74L15.71 5.8L15.95 5.4L16.07 5.5L15.88 7.13L15.61 7.17L15.84 7.77Z",
        "fill": "#3443b7"
      },
      {
        "type": "polygon",
        "d": "M16.24 7.35L16 7.17L16.16 6.89L16.28 6.94Z",
        "fill": "#3443b7"
      },
      {
        "type": "polygon",
        "d": "M15.44 8.74L15.09 8.21L15.12 7.19L15.48 7.7Z",
        "fill": "#3443b7"
      },
      {
        "type": "polygon",
        "d": "M15.44 9.27L14.78 8.6L14.78 7.68L14.97 7.76L14.98 8.32L15.44 9.13L15.8 7.97L16.66 7.21L16.69 7.97L16.49 8.43L16 9.04L15.69 9.15L16.44 7.63L15.89 8.28Z",
        "fill": "#3443b7"
      },
      {
        "type": "polygon",
        "d": "M14.23 12.01L14.1 11.96L14.37 11.36L14.63 11.37L14.9 11.1L14.77 10.74L14.49 10.78L14.35 10.51L14.49 9.04L14.65 8.99L14.82 9.39L14.68 9.71L14.75 10.5L14.84 9.71L14.94 9.64L15.1 9.82L15 10.76L15.26 10.34L15.09 10.32L15.23 9.86L15.54 9.37L15.67 9.37L15.6 9.87L15.32 10.3L15.64 9.97L16.02 9.87L16.25 9.52L16.26 9.97L15.98 10.52L15.56 10.97L14.9 11.35L15.26 11.48L15.83 11.28L16.05 10.86L15.62 11.27L15.19 11.31L16.33 10.46L16.08 11.24L15.54 11.61L14.61 11.51L14.45 11.94Z",
        "fill": "#3443b7"
      },
      {
        "type": "polygon",
        "d": "M15.12 11.01L15.97 10.08L15.58 10.33L15.06 10.92Z",
        "fill": "#3443b7"
      },
      {
        "type": "polygon",
        "d": "M13.38 13.08L11.58 12.88L12.33 12.62L12.75 11.78L13.58 11.12L13.63 11.27L12.84 12.56L13 12.65L13.66 11.44L14.23 10.8L14.14 11.66L13.66 12.33L13.24 12.56L13.84 12.62L14.01 12.44L14.7 12.36L14.79 12.22L14.03 12.31L13.7 12.5L14.07 12.1L15.17 11.92L15.26 12.06L14.77 12.52L14.11 12.62L14.35 12.78L14.28 12.89Z",
        "fill": "#3443b7"
      },
      {
        "type": "polygon",
        "d": "M13.39 12.4L13.94 11.72L14.01 11.33Z",
        "fill": "#3443b7"
      },
      {
        "type": "polygon",
        "d": "M9.67 13.84L9.16 13.71L9.37 13.46L10.52 13.09L10.67 13.17L10.66 13.35L9.84 13.64Z",
        "fill": "#3443b7"
      },
      {
        "type": "circle",
        "cx": 14.56,
        "cy": 4.75,
        "r": 0.2,
        "fill": "#3443b7"
      },
      {
        "type": "circle",
        "cx": 14.17,
        "cy": 5.01,
        "r": 0.2,
        "fill": "#3443b7"
      },
      {
        "type": "circle",
        "cx": 13.9,
        "cy": 5.35,
        "r": 0.2,
        "fill": "#3443b7"
      },
      {
        "type": "circle",
        "cx": 15.92,
        "cy": 7.46,
        "r": 0.2,
        "fill": "#3443b7"
      },
      {
        "type": "circle",
        "cx": 15.14,
        "cy": 9.47,
        "r": 0.2,
        "fill": "#3443b7"
      },
      {
        "type": "circle",
        "cx": 15.85,
        "cy": 9.63,
        "r": 0.2,
        "fill": "#3443b7"
      },
      {
        "type": "circle",
        "cx": 14.59,
        "cy": 11.06,
        "r": 0.2,
        "fill": "#3443b7"
      },
      {
        "type": "circle",
        "cx": 14.77,
        "cy": 11.79,
        "r": 0.2,
        "fill": "#3443b7"
      },
      {
        "type": "polygon",
        "d": "M11.1 6.19L11.67 7.82L13.4 7.86L12.02 8.91L12.52 10.56L11.1 9.57L9.68 10.56L10.18 8.91L8.8 7.86L10.53 7.82Z",
        "fill": "#edb512"
      }
    ],
    "tcc-co": [
      {
        "type": "line",
        "d": "M19.01 8.5L18.89 9.28L18.53 10.04L17.94 10.75L17.14 11.39L16.15 11.94L15.01 12.39L13.74 12.72L12.39 12.93L11 12.99L9.61 12.93L8.26 12.72L6.99 12.39L5.85 11.94L4.86 11.39L4.06 10.75L3.47 10.04L3.11 9.28L2.99 8.5L3.11 7.72L3.47 6.96L4.06 6.25L4.86 5.61L5.85 5.05L6.99 4.6L8.26 4.27L9.61 4.07L11 4L12.39 4.07L13.74 4.27L15.01 4.6L16.15 5.05L17.14 5.61L17.94 6.25L18.53 6.96L18.89 7.72L19.01 8.5L18.89 9.28",
        "stroke": "accent",
        "strokeWidth": 0.45
      },
      {
        "type": "line",
        "d": "M5.49 6.18L9.08 6.18M7.24 6.18L6.15 11.27M12.15 7.72L12.35 6.8L12.37 6.6L12.33 6.4L12.24 6.24L12.1 6.11L11.92 6.03L11.72 6L10.85 6L10.63 6.03L10.42 6.11L10.23 6.24L10.07 6.4L9.95 6.6L9.88 6.8L9.2 9.98L9.18 10.19L9.22 10.38L9.31 10.55L9.45 10.67L9.62 10.75L9.82 10.78L10.7 10.78L10.91 10.75L11.12 10.67L11.31 10.55L11.48 10.38L11.6 10.19L11.67 9.98L11.92 8.81M16.18 7.72L16.37 6.82L16.39 6.61L16.35 6.42L16.26 6.25L16.12 6.13L15.95 6.05L15.75 6.02L14.87 6.02L14.65 6.05L14.44 6.13L14.25 6.25L14.09 6.42L13.97 6.61L13.89 6.82L13.22 9.99L13.2 10.2L13.24 10.39L13.33 10.55L13.47 10.68L13.64 10.76L13.85 10.79L14.73 10.79L14.94 10.76L15.15 10.68L15.34 10.55L15.5 10.39L15.62 10.2L15.7 9.99L15.95 8.81",
        "stroke": "accent",
        "strokeWidth": 1.25
      }
    ],
    "fm-transportes": [
      {
        "type": "polygon",
        "d": "M10.88 3.8L9.82 4.37L14.48 7.06L13.64 9.4L12.79 7.84L8.08 5.26L6.47 6.11L11.32 8.82L11.34 14.2L12.83 13.36L12.84 10.53L13.27 11.27L13.38 11.28L13.69 11.12L14.03 10.81L14.45 9.59L14.49 12.41L15.5 11.77L15.53 6.3L14.64 5.81Z",
        "fill": "accent"
      },
      {
        "type": "polygon",
        "d": "M6.5 6.91L6.47 12.11L7.71 12.8L7.75 11.37L10.24 12.75L10.29 11.42L7.75 9.98L7.75 9.53L10.68 11.13L10.68 9.32Z",
        "fill": "accent"
      }
    ],
    "xcargo": [
      {
        "type": "line",
        "d": "M7.27 8.69L4.28 12.22L4.22 12.4L4.25 12.77L4.34 12.94L4.62 13.18L4.98 13.24L5.16 13.2L5.47 13L9.15 8.69L5.33 4.26L5.16 4.17L4.79 4.14L4.62 4.2L4.34 4.44L4.21 4.79L4.22 4.97L4.38 5.31L7.27 8.69L4.28 12.22M11.15 8.69L8.16 12.22L8.1 12.4L8.13 12.77L8.21 12.94L8.49 13.18L8.85 13.24L9.04 13.2L9.34 13L13.02 8.69L9.2 4.26L9.04 4.17L8.67 4.14L8.49 4.2L8.21 4.44L8.13 4.61L8.1 4.97L8.26 5.31L11.15 8.69L8.16 12.22M13.85 6.62L13.69 6.95L13.68 7.14L13.81 7.48L13.93 7.62L14.27 7.78L14.45 7.79L14.8 7.66L16.88 5.24L17.03 4.91L17.04 4.72L16.92 4.38L16.79 4.24L16.46 4.08L16.27 4.07L15.93 4.2L13.85 6.62L13.69 6.95M14.94 9.84L14.63 9.63L14.45 9.59L14.09 9.65L13.81 9.89L13.72 10.06L13.68 10.24L13.75 10.6L15.79 13.05L16.09 13.27L16.27 13.3L16.64 13.24L16.79 13.14L17 12.84L17.04 12.65L16.98 12.29L14.94 9.84L14.63 9.63",
        "stroke": "accent",
        "strokeWidth": 0.56
      },
      {
        "type": "polygon",
        "d": "M12.72 8.69L9.78 12.03L9.62 12.3L9.58 12.61L9.66 12.92L9.85 13.17L10.12 13.33L10.43 13.37L10.74 13.29L10.99 13.1L14.86 8.69L10.99 4.28L10.74 4.09L10.43 4.01L10.12 4.05L9.85 4.21L9.66 4.46L9.58 4.76L9.62 5.07L9.78 5.35Z",
        "fill": "accent"
      },
      {
        "type": "polygon",
        "d": "M17.88 5.3L18.03 5.03L18.07 4.71L17.98 4.41L17.78 4.17L17.51 4.01L17.19 3.98L16.89 4.07L16.65 4.26L14.79 6.46L14.63 6.74L14.6 7.05L14.69 7.35L14.88 7.6L15.16 7.75L15.47 7.79L15.77 7.7L16.02 7.5Z",
        "fill": "accent"
      },
      {
        "type": "polygon",
        "d": "M16.65 13.11L16.89 13.31L17.19 13.4L17.51 13.36L17.78 13.21L17.98 12.96L18.07 12.66L18.03 12.35L17.88 12.07L16.02 9.87L15.77 9.68L15.47 9.59L15.16 9.63L14.88 9.78L14.69 10.02L14.6 10.33L14.63 10.64L14.79 10.91Z",
        "fill": "accent"
      }
    ],
    "paket-cl": [
      {
        "type": "polygon",
        "d": "M12.43 6.17L11.47 6.15L11.24 5.97L11.17 5.67L11.49 4.38L11.65 4.08L12.03 3.8L13.2 3.8L13.41 3.98L13.47 4.25L13.14 5.61L13.04 5.81L12.8 6.05Z",
        "fill": "accent"
      },
      {
        "type": "polygon",
        "d": "M14.06 6.17L13.83 6.15L13.65 6.01L13.56 5.74L13.62 5.48L13.71 5.31L14 5.06L14.26 4.98L14.49 5L14.73 5.24L14.73 5.61L14.49 5.98L14.29 6.11Z",
        "fill": "accent"
      },
      {
        "type": "polygon",
        "d": "M13.93 9.37L10.14 9.38L9.94 9.31L9.76 9.1L9.74 8.87L10.23 7.04L10.5 6.76L10.87 6.64L14.53 6.66L14.76 6.74L14.91 6.94L14.93 7.17L14.5 8.83L14.41 9.03L14.2 9.25Z",
        "fill": "accent"
      },
      {
        "type": "polygon",
        "d": "M10.17 13.39L8.11 13.37L7.91 13.26L7.81 13.09L7.8 12.79L8.43 10.36L8.6 10.1L8.91 9.89L11.1 9.85L11.3 9.92L11.48 10.16L11.48 10.46L10.85 12.86L10.57 13.24Z",
        "fill": "accent"
      },
      {
        "type": "polygon",
        "d": "M13.76 13.39L11.73 13.4L11.5 13.33L11.32 13.09L11.32 12.79L11.96 10.36L12.23 10.02L12.47 9.89L14.59 9.86L14.86 9.96L15 10.16L15 10.46L14.37 12.89L14.06 13.27Z",
        "fill": "accent"
      }
    ],
    "fez-delivery": [
      {
        "type": "polygon",
        "d": "M7.39 3.99L5.14 8.58L8.55 13.21L10.8 8.62Z",
        "fill": "accent"
      },
      {
        "type": "polygon",
        "d": "M12.96 4.22L11.01 8.2L7.77 3.8L13.17 3.8L16.86 8.81L14.61 13.4L8.92 13.4L11.17 8.81L16.34 8.81Z",
        "fill": "accent"
      }
    ],
    "famiport": [
      {
        "type": "polygon",
        "d": "M2.9 4.5L19.1 4.5L19.1 6.75L2.9 6.75Z",
        "fill": "#00ab4f"
      },
      {
        "type": "polygon",
        "d": "M2.9 6.75L19.1 6.75L19.1 7.3L2.9 7.3Z",
        "fill": "accent"
      },
      {
        "type": "line",
        "d": "M5.05 9.02L3.82 9.02L3.82 11.09M3.82 9.86L4.98 9.86M5.41 9.94L5.45 9.86L5.51 9.8L5.58 9.76L5.67 9.72L5.76 9.71L5.85 9.71L5.94 9.74L6.02 9.78L6.09 9.83L6.14 9.9L6.17 9.97L6.18 10.05L6.18 11.09M6.18 10.63L6.17 10.68L6.14 10.73L6.09 10.78L6.02 10.81L5.94 10.84L5.85 10.86L5.76 10.87L5.66 10.86L5.58 10.84L5.49 10.81L5.43 10.78L5.38 10.73L5.35 10.68L5.34 10.63L5.35 10.58L5.38 10.53L5.43 10.49L5.49 10.45L5.58 10.42L5.66 10.4L5.76 10.4L5.85 10.4L5.94 10.42L6.02 10.45L6.09 10.49L6.14 10.53L6.17 10.58L6.18 10.63L6.17 10.68M6.92 11.09L6.92 9.49M6.92 10L6.94 9.91L7 9.83L7.1 9.77L7.22 9.72L7.36 9.71L7.5 9.72L7.62 9.77L7.72 9.83L7.78 9.91L7.8 10L7.8 11.09M7.8 10L7.83 9.91L7.89 9.83L7.99 9.77L8.11 9.72L8.25 9.71L8.38 9.72L8.51 9.77L8.6 9.83L8.67 9.91L8.69 10L8.69 11.09M9.43 9.49L9.43 11.09M10.16 8.8L10.16 11.09M10.83 9.49L11.37 10.82M11.91 9.49L11.37 10.82L11.17 11.5M12.55 8.8L12.55 11.09M14.22 8.8L14.22 11.09M12.57 8.95L13.38 10.13L14.2 8.95M14.97 9.94L15.02 9.86L15.08 9.8L15.15 9.76L15.24 9.72L15.33 9.71L15.43 9.71L15.52 9.74L15.6 9.78L15.67 9.83L15.73 9.9L15.76 9.97L15.77 10.05L15.77 11.09M15.77 10.63L15.76 10.68L15.73 10.73L15.67 10.78L15.61 10.81L15.52 10.84L15.43 10.86L15.33 10.87L15.24 10.86L15.15 10.84L15.06 10.81L14.99 10.78L14.94 10.73L14.91 10.68L14.9 10.63L14.91 10.58L14.94 10.53L14.99 10.49L15.06 10.45L15.15 10.42L15.24 10.4L15.33 10.4L15.43 10.4L15.52 10.42L15.61 10.45L15.67 10.49L15.73 10.53L15.76 10.58L15.77 10.63L15.76 10.68M16.46 9.49L16.46 11.09M16.46 10.18L16.47 10.09L16.51 10L16.58 9.92L16.67 9.85L16.79 9.79L16.91 9.75L17.05 9.72L17.2 9.71M17.79 8.9L17.79 10.52L17.8 10.62L17.84 10.72L17.91 10.8L17.99 10.86L18.1 10.9L18.2 10.91L18.4 10.91M17.34 9.71L18.4 9.71",
        "stroke": "accent",
        "strokeWidth": 0.44
      },
      {
        "type": "circle",
        "cx": 9.43,
        "cy": 9.02,
        "r": 0.25,
        "fill": "accent"
      }
    ],
    "ctc-express": [
      {
        "type": "line",
        "d": "M7.63 7.68L7.63 6.5L7.13 5.8L5.5 5.8L5 6.5L5 11.55L5.6 12.1L7.03 12.1L7.63 11.55L7.63 9.69M8.65 5.8L13.19 5.8M10.95 5.8L10.95 12.9M17 7.68L17 6.5L16.5 5.8L14.87 5.8L14.37 6.5L14.37 11.55L14.97 12.1L16.4 12.1L17 11.55L17 9.69",
        "stroke": "accent",
        "strokeWidth": 1.6
      },
      {
        "type": "line",
        "d": "M3.95 10.89L18.05 10.89M3.95 11.66L18.05 11.66M3.95 12.33L18.05 12.33",
        "stroke": "truck",
        "strokeWidth": 0.22
      },
      {
        "type": "polygon",
        "d": "M2.6 8.78L3.61 7.14L3.61 7.94L18.39 7.94L18.39 7.14L19.4 8.78L18.39 10.42L18.39 9.62L3.61 9.62L3.61 10.42Z",
        "fill": "#d81e27"
      }
    ],
    "maple-logistics": [
      {
        "type": "polygon",
        "d": "M7.85 13.55L7.5 13.35L7.43 13.11L8.35 11.95L8.95 10.8L8.74 10.64L6.22 9.81L7.31 9.07L6.32 5.69L7.08 5.77L7.68 4.06L8.84 5.04L9.58 4.51L10.12 6.85L10.24 6.91L11.47 3.76L12.13 4.79L12.3 4.85L14.19 3.75L13.86 5.9L15.22 6.19L12.75 8.58L15.21 8.16L14.98 9.07L16.38 9.73L16.33 9.9L15.04 10.88L15.39 11.54L14.52 11.73L11.8 11.98L11.56 13.26L9.74 11.26L9.58 11.21L8.72 12.12Z",
        "fill": "accent"
      }
    ],
    "seino-super-express": [
      {
        "type": "polygon",
        "d": "M3.2 4.3L18.8 4.3L18.8 4.91L3.2 4.91Z",
        "fill": "#a5c0dc"
      },
      {
        "type": "polygon",
        "d": "M3.2 4.91L18.8 4.91L18.8 6L3.2 6Z",
        "fill": "accent"
      },
      {
        "type": "polygon",
        "d": "M3.2 11.75L18.8 11.75L18.8 12.84L3.2 12.84Z",
        "fill": "accent"
      },
      {
        "type": "polygon",
        "d": "M3.2 12.84L18.8 12.84L18.8 13.45L3.2 13.45Z",
        "fill": "#a5c0dc"
      },
      {
        "type": "line",
        "d": "M7.97 8.13L7.97 7.85L7.93 7.6L7.83 7.36L7.67 7.18L7.47 7.06L7.24 7.02L4.78 7.02L4.56 7.06L4.35 7.18L4.19 7.36L4.09 7.6L4.05 7.85L4.09 8.11L4.19 8.35L4.35 8.53L4.56 8.65L4.78 8.69L7.24 9.05L7.47 9.09L7.67 9.21L7.83 9.39L7.93 9.63L7.97 9.88L7.93 10.14L7.83 10.38L7.67 10.56L7.47 10.68L7.24 10.72L4.78 10.72L4.56 10.68L4.35 10.56L4.19 10.38L4.09 10.14L4.05 9.88L4.05 9.68M12.97 8.13L12.97 7.85L12.94 7.6L12.83 7.36L12.67 7.18L12.47 7.06L12.25 7.02L9.79 7.02L9.56 7.06L9.36 7.18L9.2 7.36L9.09 7.6L9.06 7.85L9.09 8.11L9.2 8.35L9.36 8.53L9.56 8.65L9.79 8.69L12.25 9.05L12.47 9.09L12.67 9.21L12.83 9.39L12.94 9.63L12.97 9.88L12.94 10.14L12.83 10.38L12.67 10.56L12.47 10.68L12.25 10.72L9.79 10.72L9.56 10.68L9.36 10.56L9.2 10.38L9.09 10.14L9.06 9.88L9.06 9.68",
        "stroke": "accent",
        "strokeWidth": 0.7
      },
      {
        "type": "polygon",
        "d": "M16.8 6.67L15.64 8.16L14.03 6.67L12.95 6.67L15.19 8.74L13.37 11.07L14.3 11.07L15.73 9.24L17.71 11.07L18.79 11.07L16.18 8.66L17.73 6.67Z",
        "fill": "accent"
      }
    ],
    "taqbin-hk": [
      {
        "type": "polygon",
        "d": "M6.4 5L9.2 7.5L12 5L13.4 7.7L15.8 7.7L15.8 11.6L13.6 11.6L12.4 10.2L11.2 11.6L9.6 11.6L8.4 13.2L6.4 13.2Z",
        "fill": "accent"
      }
    ],
    "safexpress": [
      {
        "type": "line",
        "d": "M4.49 6.24L4.28 5.9L4 5.9L3.79 6.24L3.73 6.76L3.88 7.22L4.14 7.4L4.41 7.58L4.55 8.04L4.5 8.56L4.28 8.9L3.99 8.9L3.77 8.56M5.29 8.9L5.67 5.9L5.97 5.9L6.35 8.9M5.4 8L6.23 8M7.91 5.9L7.17 5.9L7.17 8.9M7.17 7.4L7.8 7.4M9.18 5.9L8.44 5.9L8.44 8.9L9.18 8.9M8.44 7.4L9.07 7.4M9.69 5.9L10.69 8.9M10.69 5.9L9.69 8.9M11.5 8.9L11.5 5.9L11.81 5.96L12.08 6.14L12.26 6.41L12.32 6.73L12.26 7.04L12.08 7.31L11.81 7.49L11.5 7.55M13.15 8.9L13.15 5.9L13.2 5.9L13.52 5.96L13.79 6.14L13.96 6.41L14.03 6.73L13.96 7.04L13.79 7.31L13.52 7.49L13.2 7.55L13.15 7.55M13.5 7.55L14.03 8.9M15.59 5.9L14.85 5.9L14.85 8.9L15.59 8.9M14.85 7.4L15.48 7.4M16.82 6.24L16.61 5.9L16.33 5.9L16.12 6.24L16.07 6.76L16.21 7.22L16.47 7.4L16.74 7.58L16.89 8.04L16.84 8.56L16.62 8.9L16.33 8.9L16.11 8.56M18.32 6.24L18.1 5.9L17.82 5.9L17.61 6.24L17.56 6.76L17.7 7.22L17.97 7.4L18.23 7.58L18.38 8.04L18.33 8.56L18.11 8.9L17.82 8.9L17.6 8.56",
        "stroke": "accent",
        "strokeWidth": 0.58
      },
      {
        "type": "polygon",
        "d": "M5 11.92L4.43 11.47L3.77 11.03L5.34 10.63L6.81 10.36L8.73 10.1L10.55 9.95L8.92 10.35L7.4 10.83L6.14 11.33Z",
        "fill": "accent"
      },
      {
        "type": "polygon",
        "d": "M11.26 11.92L10.63 11.42L10.02 11.03L11.58 10.64L13.2 10.33L14.96 10.1L16.81 9.95L15.22 10.34L13.65 10.83L12.31 11.36Z",
        "fill": "accent"
      }
    ],
    "movin": [
      {
        "type": "line",
        "d": "M3.63 12.01L3.63 9.38L4.34 9.24L4.94 11.27L5.56 11.15L6.16 8.88L6.88 8.74L6.88 11.37M10.36 9.14L10.32 9.44L10.2 9.75L10 10.03L9.75 10.26L9.45 10.44L9.13 10.54L8.81 10.56L8.51 10.5L8.25 10.37L8.06 10.17L7.93 9.91L7.89 9.62L7.93 9.31L8.06 9.01L8.25 8.73L8.51 8.5L8.81 8.32L9.13 8.22L9.45 8.2L9.75 8.25L10 8.39L10.2 8.59L10.32 8.84L10.36 9.14L10.32 9.44M11.19 7.42L11.93 9.91L12.57 9.78L13.39 6.99M14.7 6.73L14.7 9.84M16.03 9.58L16.03 6.95L16.7 6.82L17.69 8.78L18.36 8.65L18.36 6.02",
        "stroke": "#b8dde3",
        "strokeWidth": 0.96
      }
    ],
    "lex-vn": [
      {
        "type": "line",
        "d": "M4.49 6.9L3.52 11.21L7.24 11.21M12.82 7.46L9.06 7.46L8.22 11.21L11.98 11.21M8.64 9.33L11.89 9.33",
        "stroke": "accent",
        "strokeWidth": 1.12
      },
      {
        "type": "polygon",
        "d": "M16.72 11.77L18.15 11.77L17.09 9.41L19.2 6.99L19.1 6.9L17.55 6.9L15.56 9.19Z",
        "fill": "#fb25a8"
      },
      {
        "type": "polygon",
        "d": "M12.06 11.67L12.17 11.77L13.72 11.77L15.83 9.43L14.62 6.9L13.18 6.9L14.28 9.2Z",
        "fill": "#f5690d"
      }
    ],
    "best-express-th": [
      {
        "type": "polygon",
        "d": "M5.61 9.49L5.48 9.25L5.44 9L5.48 8.76L5.6 8.51L8.36 4.3L8.51 4.12L8.68 4L8.88 3.93L9.1 3.9L12.9 3.9L13.12 3.93L13.32 4L13.49 4.12L13.64 4.3L16.4 8.51L16.52 8.76L16.56 9L16.52 9.25L16.39 9.49L13.99 13.05L13.9 13.17L13.78 13.23L13.66 13.25L13.51 13.23L11 12.52L8.49 13.23L8.34 13.25L8.22 13.23L8.1 13.17L8.01 13.05Z",
        "fill": "accent"
      },
      {
        "type": "polygon",
        "d": "M10.54 6.17L10.77 5.88L11 5.78L11.23 5.88L11.46 6.17L13.5 9.64L13.54 9.76L13.55 9.87L13.52 9.98L13.43 10.08L11 12.3L8.57 10.08L8.48 9.98L8.45 9.87L8.46 9.76L8.5 9.64Z",
        "fill": "truck"
      },
      {
        "type": "line",
        "d": "M5.02 9.05L8.54 9.88M13.46 9.88L16.98 9.05",
        "stroke": "truck",
        "strokeWidth": 0.88
      }
    ],
    "airspeed": [
      {
        "type": "polygon",
        "d": "M18.16 13.71L18.21 13.62L18.13 13.51L11.32 4.14L11.2 4L11.03 3.93L10.87 3.96L10.69 4.12L3.79 13.63L3.83 13.71L3.9 13.71L10.67 6.93L10.84 6.83L11.05 6.81L11.31 6.92L18.08 13.69Z",
        "fill": "accent"
      },
      {
        "type": "polygon",
        "d": "M17.27 13.71L17.31 13.67L17.3 13.59L11.2 7.51L11.03 7.43L10.92 7.44L10.77 7.52L4.72 13.57L4.68 13.64L4.72 13.7L4.81 13.7L10.76 9.71L10.99 9.65L11.16 9.68L11.34 9.78L17.18 13.7Z",
        "fill": "accent"
      },
      {
        "type": "polygon",
        "d": "M16.14 13.71L16.18 13.66L16.13 13.57L11.24 10.28L11.04 10.19L10.83 10.23L5.85 13.58L5.82 13.64L5.84 13.7L5.93 13.72L10.74 12.45L11.05 12.4L15.92 13.68Z",
        "fill": "#cd212a"
      }
    ],
    "j-and-t-eg": [
      {
        "type": "line",
        "d": "M7.88 6.53L6.95 11.17L3.75 11.17M12.77 11.62L10.39 8.23L10.39 7.65L10.72 7.1L11.26 6.79L11.81 6.87L12.15 7.26L9.11 10.27L9.18 10.94L9.62 11.44L10.33 11.62L11.12 11.44L11.75 10.94L12.09 10.27L13.3 9M13.98 7.23L18.25 7.23M16.43 7.23L15.5 11.87",
        "stroke": "accent",
        "strokeWidth": 1.5
      }
    ],
    "egxpress": [
      {
        "type": "polygon",
        "d": "M10.42 4.1L10.01 6.05L5.68 6.05L6.09 4.1Z",
        "fill": "accent"
      },
      {
        "type": "polygon",
        "d": "M9.59 7.54L9.19 9.49L4.43 9.49L4.84 7.54Z",
        "fill": "accent"
      },
      {
        "type": "polygon",
        "d": "M9.26 10.98L8.85 12.93L3.1 12.93L3.51 10.98Z",
        "fill": "accent"
      },
      {
        "type": "polygon",
        "d": "M12.66 7.54L12.75 7.09L10.8 7.09L10.2 9.95L12.15 9.95L12.25 9.49L13.61 9.49L14.02 7.54Z",
        "fill": "accent"
      },
      {
        "type": "polygon",
        "d": "M10.08 10.74L10.13 11.25L10.28 11.72L10.54 12.14L10.88 12.48L11.3 12.73L11.78 12.89L12.26 12.93L16.75 12.93L17.81 7.86L15.86 7.86L15.21 10.98L12.57 10.96L12.31 10.85L12.11 10.53L10.11 10.53Z",
        "fill": "accent"
      },
      {
        "type": "polygon",
        "d": "M13.15 6.28L13.44 6.11L13.8 6.05L18.45 6.05L18.86 4.1L14.11 4.1L13.62 4.15L13.07 4.3L12.54 4.56L12.06 4.9L11.63 5.31L11.28 5.78L11.02 6.3L10.95 6.5L12.95 6.5Z",
        "fill": "accent"
      }
    ],
    "tawssil": [
      {
        "type": "line",
        "d": "M11.01 14.21L13.96 10.39L14.34 9.8L14.6 9.15L14.73 8.47L14.74 7.77L14.61 7.09L14.37 6.44L14 5.84L13.54 5.33L12.98 4.91L12.36 4.6L11.69 4.4L11 4.34L10.31 4.4L9.64 4.6L9.02 4.91L8.46 5.33L8 5.84L7.63 6.44L7.39 7.09L7.26 7.77L7.27 8.47L7.4 9.15L7.66 9.8L8.04 10.39L11.01 14.21L13.96 10.39",
        "stroke": "accent",
        "strokeWidth": 0.85
      },
      {
        "type": "circle",
        "cx": 11,
        "cy": 8.25,
        "r": 2.73,
        "fill": "#ffffff"
      },
      {
        "type": "polygon",
        "d": "M11.23 9.99L10.91 9.96L10.8 9.62L9.86 9.62L9.68 9.47L9.62 9.3L9.76 8.76L9.95 8.6L10.4 8.49L10.62 8.27L10.67 7.93L10.42 7.71L10.33 7.48L10.33 6.77L10.57 6.38L10.86 6.27L11.17 6.27L11.43 6.36L11.7 6.71L11.7 7.54L11.58 7.76L11.38 7.93L11.41 8.25L11.55 8.42L11.34 8.43L11.11 8.54L10.96 8.84L10.96 9.44L11.26 9.45L11.38 9.58L11.38 9.86Z",
        "fill": "truck"
      },
      {
        "type": "polygon",
        "d": "M12.56 10.36L11.31 10.36L11.07 10.2L10.99 10.01L11.28 9.99L11.41 9.81L11.38 9.55L11.28 9.45L10.99 9.44L10.99 8.78L11.17 8.52L11.31 8.46L12.59 8.46L12.83 8.64L12.89 8.78L12.89 10.03L12.8 10.2Z",
        "fill": "accent"
      }
    ],
    "ase-express": [
      {
        "type": "polygon",
        "d": "M8.54 12.07L12.24 12.07L12.54 12.03L12.87 11.89L13.15 11.68L13.36 11.4L13.5 11.07L13.54 10.77L13.54 9.95L10.55 8.26L10.58 8.05L19 8.04L19 6.75L10.56 6.75L10.26 6.79L9.93 6.92L9.65 7.14L9.44 7.42L9.3 7.74L9.26 8.05L9.26 9.02L12.24 10.7L12.23 10.76L12.15 10.78L9.34 10.78L7.33 6.75L5.62 6.75L3.12 12.07L4.55 12.07L6.44 8.04L6.53 8.04Z",
        "fill": "accent"
      },
      {
        "type": "polygon",
        "d": "M19 10.78L15.52 10.78L15.52 10.08L19 10.08L19 8.79L14.23 8.79L14.23 12.07L19 12.07Z",
        "fill": "accent"
      },
      {
        "type": "polygon",
        "d": "M7.25 10.78L5.8 10.78L5.2 12.07L7.89 12.07Z",
        "fill": "accent"
      }
    ],
    "zimpost": [
      {
        "type": "polygon",
        "d": "M6.06 5.78L8.67 5.78L6.28 7.7L6.06 7.7L6.06 8.28L9.8 8.28L9.8 7.7L7.2 7.7L9.59 5.78L9.8 5.78L9.8 5.2L6.06 5.2Z",
        "fill": "#190e5e"
      },
      {
        "type": "polygon",
        "d": "M12.08 5.2L11.44 5.2L11.44 5.27L11.4 5.3L11.44 5.35L11.44 8.28L12.01 8.28L12.01 5.99L13.6 7.74L15.18 5.99L15.18 8.28L15.76 8.28L15.76 5.35L15.8 5.3L15.76 5.27L15.76 5.2L15.12 5.2L13.6 6.88Z",
        "fill": "#190e5e"
      },
      {
        "type": "polygon",
        "d": "M10.26 8.28L10.84 8.28L10.84 5.2L10.26 5.2Z",
        "fill": "#190e5e"
      },
      {
        "type": "polygon",
        "d": "M11.17 9.36L11.04 9.45L10.94 9.58L10.88 9.72L10.87 9.86L10.87 10.44L10.88 10.58L10.94 10.72L11.04 10.85L11.17 10.94L11.31 11L11.45 11.02L14.05 11.03L14.06 11.06L14.06 11.74L14.06 11.77L14.02 11.78L10.87 11.78L10.87 12.35L14.06 12.35L14.2 12.34L14.34 12.28L14.47 12.18L14.56 12.06L14.62 11.91L14.64 11.77L14.64 11.03L14.62 10.89L14.56 10.74L14.47 10.62L14.34 10.52L14.2 10.46L14.06 10.44L11.46 10.44L11.44 10.4L11.44 9.9L11.46 9.86L16.45 9.85L16.45 12.35L17.03 12.35L17.03 9.85L18.84 9.85L18.84 9.28L11.45 9.28L11.31 9.29Z",
        "fill": "accent"
      },
      {
        "type": "polygon",
        "d": "M6.33 11.32L6.58 11.07L6.74 10.75L6.79 10.4L6.74 10.06L6.58 9.74L6.33 9.49L6.01 9.33L5.68 9.28L3.16 9.28L3.16 12.35L3.74 12.35L3.74 11.53L5.68 11.53L6.01 11.48Z",
        "fill": "accent"
      },
      {
        "type": "polygon",
        "d": "M8.28 12.33L9.35 12.32L9.66 12.26L9.89 12.16L10.13 12.01L10.36 11.81L10.53 11.6L10.62 11.41L10.67 11.2L10.7 10.68L10.67 10.37L10.59 10.13L10.47 9.93L10.28 9.72L10.08 9.56L9.72 9.38L9.41 9.3L8.76 9.28L8.15 9.31L7.87 9.39L7.58 9.55L7.33 9.76L7.14 9.99L7.02 10.22L6.97 10.42L6.96 10.94L6.99 11.32L7.08 11.54L7.24 11.77L7.46 11.98L7.7 12.13L7.73 12.09L7.74 11.79L7.78 11.72L9.88 10.45L7.9 12.23Z",
        "fill": "accent"
      },
      {
        "type": "polygon",
        "d": "M7.75 11.56L9.66 10.38L9.88 10.25L9.9 10.22L9.77 10.25L9.3 10.41L7.75 11L7.73 11.2Z",
        "fill": "truck"
      },
      {
        "type": "polygon",
        "d": "M7.78 10.8L9.89 10.04L8.19 10.02L7.79 10.05L7.75 10.08L7.74 10.16L7.74 10.77Z",
        "fill": "truck"
      },
      {
        "type": "polygon",
        "d": "M5.98 9.96L6.1 10.08L6.18 10.24L6.21 10.4L6.18 10.57L6.1 10.73L5.98 10.85L5.83 10.92L5.64 10.96L3.74 10.96L3.74 9.85L5.64 9.85L5.83 9.88Z",
        "fill": "truck"
      }
    ],
    "airwings-india": [
      {
        "type": "polygon",
        "d": "M12.85 4.9L12.9 4.8L12.84 4.76L7.45 4.76L6.84 4.72L6.54 4.65L6.01 4.41L5.66 4.14L5.28 3.76L5.22 3.74L5.2 3.78L5.19 4L5.25 4.45L5.38 4.82L5.6 5.2L5.87 5.47L6.23 5.72L6.58 5.86L7.13 5.98L11.83 6L11.89 6.01L11.73 6.19L11.94 6.19L12.08 6.12L12.14 6L12.53 5.6L12.59 5.49L12.99 5.08L13.09 4.79L12.94 4.79Z",
        "fill": "accent"
      },
      {
        "type": "polygon",
        "d": "M10.16 7.94L10.44 7.68L10.05 8.13L10.26 8.1L10.72 7.67L10.79 7.53L11.33 6.99L11.43 6.77L11.38 6.59L11.19 6.82L11.24 6.74L11.18 6.68L7.45 6.67L6.84 6.64L6.39 6.52L6.01 6.33L5.64 6.05L5.29 5.7L5.21 5.73L5.19 5.92L5.25 6.37L5.46 6.91L5.58 7.1L5.82 7.36L6.23 7.65L6.75 7.84L7.18 7.92Z",
        "fill": "accent"
      },
      {
        "type": "polygon",
        "d": "M8.49 9.87L8.66 9.71L8.71 9.6L8.8 9.57L8.37 10.07L8.54 10.06L8.66 9.99L8.94 9.7L9 9.58L9.31 9.27L9.38 9.14L9.53 9.05L9.67 8.84L9.71 8.7L9.67 8.56L9.39 8.89L9.52 8.69L9.48 8.64L9.35 8.62L7.38 8.61L6.74 8.55L6.49 8.49L5.96 8.24L5.29 7.63L5.21 7.62L5.19 7.82L5.24 8.24L5.39 8.69L5.63 9.1L6.04 9.47L6.5 9.7L7 9.83Z",
        "fill": "accent"
      },
      {
        "type": "polygon",
        "d": "M6.91 11.65L7.32 11.25L7.37 11.14L7.77 10.74L7.85 10.58L7.83 10.51L6.71 10.48L6.42 10.42L5.93 10.16L5.3 9.62L5.21 9.61L5.14 10.05L5.17 10.5L5.26 10.81L5.5 11.2L5.84 11.49L6.17 11.62Z",
        "fill": "accent"
      },
      {
        "type": "polygon",
        "d": "M5.65 13.21L12.94 4.79L16.82 4.79L15.82 5.72L15.82 13.21L13.01 13.21L13.01 5.75L12.75 5.75L9.04 10.07L8.93 10.46L8.95 11.1L9.07 11.74L9.39 12.38L9.79 12.82L10.26 13.21Z",
        "fill": "#2d2c7a"
      },
      {
        "type": "line",
        "d": "M12.98 12.18L12.52 12.14L12.08 12.01L11.68 11.81L11.32 11.53L11.03 11.19L10.82 10.8L10.68 10.38L10.64 9.94L10.68 9.51L10.82 9.09L11.03 8.7L11.32 8.36L11.68 8.08L12.08 7.87L12.52 7.75L12.98 7.7M12.98 12.18L12.69 12.11L12.42 11.88L12.18 11.53L12.01 11.06L11.89 10.52L11.86 9.94L11.89 9.36L12.01 8.82L12.18 8.36L12.42 8L12.69 7.78L12.98 7.7M10.64 9.94L12.98 9.94M10.87 8.98L12.98 8.98M10.87 10.9L12.98 10.9",
        "stroke": "#2d2c7a",
        "strokeWidth": 0.24
      },
      {
        "type": "line",
        "d": "M12.98 7.7L13.43 7.75L13.87 7.87L14.27 8.08L14.63 8.36L14.92 8.7L15.13 9.09L15.27 9.51L15.31 9.94L15.27 10.38L15.13 10.8L14.92 11.19L14.63 11.53L14.27 11.81L13.87 12.01L13.43 12.14L12.98 12.18M12.98 7.7L13.27 7.78L13.54 8L13.77 8.36L13.95 8.82L14.06 9.36L14.1 9.94L14.06 10.52L13.95 11.06L13.77 11.53L13.54 11.88L13.27 12.11L12.98 12.18M12.98 9.94L15.31 9.94M12.98 8.98L15.09 8.98M12.98 10.9L15.09 10.9",
        "stroke": "truck",
        "strokeWidth": 0.24
      }
    ],
    "apx-logistics": [
      {
        "type": "line",
        "d": "M3.7 11.3L5.1 6.61L5.57 6.61L6.97 11.3M4.11 9.93L6.56 9.93M8.75 11.39L8.75 6.61L10.25 6.61L10.47 6.64L10.67 6.73L10.84 6.86L10.97 7.03L11.06 7.23L11.09 7.45L11.09 7.98L11.06 8.19L10.97 8.4L10.84 8.57L10.67 8.7L10.47 8.79L10.25 8.81L8.75 8.81",
        "stroke": "accent",
        "strokeWidth": 1.3
      },
      {
        "type": "line",
        "d": "M12 12.66L15.69 6.13M12.93 6.13L15.81 11.23",
        "stroke": "#feac58",
        "strokeWidth": 1.19
      },
      {
        "type": "polygon",
        "d": "M19.01 4.22L18.47 4.22L18.46 3.9L19.02 3.9Z",
        "fill": "#feac58"
      },
      {
        "type": "polygon",
        "d": "M15.8 4.9L15.63 4.87L15.97 4.27L16.45 4.3L16.45 4.89Z",
        "fill": "#feac58"
      },
      {
        "type": "polygon",
        "d": "M18.42 5.32L17.47 5.32L17.45 4.39L18.44 4.38Z",
        "fill": "#feac58"
      },
      {
        "type": "polygon",
        "d": "M16.5 5.89L16.48 4.93L16.97 4.92Z",
        "fill": "#feac58"
      }
    ],
    "ark-express": [
      {
        "type": "polygon",
        "d": "M11.19 9.53L8.71 9.54L8.74 9.48L9.62 9.04L11.48 9.04L11.73 8.66L11.72 8.63L10.78 8.62L10.72 8.61L10.74 8.59L16.84 5.83L16.94 5.79L16.98 5.79L15.11 9.04L11.5 9.05L11.25 9.47Z",
        "fill": "accent"
      },
      {
        "type": "polygon",
        "d": "M8.2 10.4L6.74 10.41L6.68 10.38L7.6 9.94L9.09 9.94L9.14 9.95L9.13 9.98Z",
        "fill": "accent"
      },
      {
        "type": "polygon",
        "d": "M10.65 10.41L9.75 10.41L9.71 10.4L9.7 10.38L9.96 9.94L10.89 9.94L10.93 9.96L10.93 9.98L10.7 10.36Z",
        "fill": "accent"
      },
      {
        "type": "polygon",
        "d": "M6.24 11.31L4.79 11.31L4.74 11.28L5.59 10.84L7.03 10.84L7.06 10.86L6.99 10.91L6.3 11.29Z",
        "fill": "accent"
      },
      {
        "type": "polygon",
        "d": "M8.74 11.31L7 11.31L6.95 11.28L7.8 10.84L9.01 10.84L9.05 10.85L9.04 10.9L8.78 11.28Z",
        "fill": "accent"
      },
      {
        "type": "polygon",
        "d": "M10.13 11.31L9.19 11.31L9.15 11.28L9.46 10.85L10.37 10.84L10.41 10.85L10.4 10.9L10.19 11.25Z",
        "fill": "accent"
      },
      {
        "type": "polygon",
        "d": "M4.23 12.17L2.79 12.17L2.82 12.12L3.5 11.78L3.59 11.75L4.95 11.75L5.03 11.75L5 11.8Z",
        "fill": "accent"
      },
      {
        "type": "polygon",
        "d": "M9.63 12.17L8.71 12.17L8.68 12.13L8.93 11.77L8.98 11.75L9.86 11.75L9.9 11.76L9.89 11.81L9.68 12.14Z",
        "fill": "accent"
      },
      {
        "type": "line",
        "d": "M10.35 12.21L11.72 9.62L13.89 9.62L14.03 9.65L14.12 9.75L14.14 9.88L14.09 10.05L13.89 10.43L13.77 10.59L13.6 10.73L13.41 10.82L13.23 10.85L11.07 10.85M12.1 10.85L12.94 12.21M15.71 9.24L14.13 12.21M18.86 9.62L14.69 11.15M16.44 10.51L17.06 12.21",
        "stroke": "accent",
        "strokeWidth": 0.77
      }
    ],
    "chinz-logistics": [
      {
        "type": "polygon",
        "d": "M8.01 10.96L8.12 11.55L8.58 11.55L8.46 10.96L8.1 6.2L8.2 5.73L8.34 5.45L8.54 5.21L8.93 4.93L9.4 4.76L11.53 4.73L11.54 6.03L10.91 6.03L10.92 6.51L11.55 6.51L11.56 7.39L12.05 7.39L12.06 6.51L12.68 6.51L12.69 6.03L12.06 6.03L12.06 4.73L14.01 4.74L14.51 4.86L14.93 5.1L15.25 5.45L15.45 5.88L15.5 6.36L15.18 10.97L15.07 11.55L15.52 11.55L15.63 10.91L16.01 6.14L15.89 5.54L15.59 5.02L15.13 4.62L14.54 4.35L13.85 4.26L12.1 4.26L11.79 3.98L11.49 4.26L9.73 4.26L9.27 4.3L8.84 4.42L8.29 4.74L8.01 5.02L7.79 5.36L7.64 5.73L7.59 6.14Z",
        "fill": "accent"
      },
      {
        "type": "polygon",
        "d": "M9.7 10.59L10.14 10.12L10.06 8.28L11.57 8.28L11.57 9L10.51 9L10.52 9.47L11.33 9.47L9.4 11.55L10.03 11.55L11.55 9.89L11.57 11.73L11.79 11.86L12.01 11.73L12.05 9.9L13.61 11.55L14.24 11.55L12.3 9.47L13.63 9.47L13.87 9.39L13.97 9.27L14 9.11L14.05 8.16L14 7.97L13.9 7.86L13.72 7.81L12.39 7.81L12.45 8L12.47 8.28L13.56 8.28L13.53 9L12.05 9L12.04 8.09L11.99 7.95L11.86 7.85L11.65 7.81L9.98 7.8L9.72 7.86L9.6 7.99L9.57 8.16Z",
        "fill": "accent"
      },
      {
        "type": "polygon",
        "d": "M8.83 10.55L8.97 11.41L9.33 11L9.16 8.19L9.19 7.9L9.29 7.67L9.47 7.51L9.82 7.41L11.14 7.39L11.13 6.92L9.74 6.93L9.39 7.01L9.1 7.14L9.24 6.78L9.48 6.59L9.84 6.51L10.51 6.51L10.49 6.03L9.64 6.06L9.05 6.26L9.12 6.01L9.32 5.77L9.64 5.65L11.1 5.62L11.1 5.15L9.96 5.15L9.45 5.2L8.95 5.42L8.77 5.59L8.65 5.8L8.55 6.21L8.55 6.53Z",
        "fill": "accent"
      },
      {
        "type": "polygon",
        "d": "M14.27 7.61L14.4 7.81L14.46 8.19L14.3 11L14.67 11.41L14.79 10.66L15.05 6.53L15.03 6.06L14.89 5.69L14.74 5.5L14.54 5.35L14.14 5.2L13.63 5.15L12.5 5.15L12.49 5.62L13.71 5.62L14.1 5.68L14.41 5.9L14.55 6.26L13.96 6.06L13.11 6.03L13.1 6.51L13.77 6.51L14.13 6.59L14.37 6.78L14.51 7.14L14.22 7.01L13.87 6.93L12.47 6.92L12.47 7.39L13.79 7.41L14.07 7.47Z",
        "fill": "accent"
      },
      {
        "type": "polygon",
        "d": "M9.76 13.17L9.19 12.67L8.73 11.97L8.26 11.97L8.7 12.74L9.01 13.12L9.38 13.44L9.79 13.72L11.79 14.83L13.72 13.81L14.28 13.44L14.65 13.12L14.96 12.74L15.38 11.97L14.91 11.97L14.54 12.57L14 13.1L13.56 13.38L11.79 14.31Z",
        "fill": "accent"
      },
      {
        "type": "polygon",
        "d": "M10.64 13.2L11.79 13.83L13.71 12.8L14.18 12.39L14.46 11.97L13.96 11.97L13.72 12.23L13.4 12.47L11.79 13.31L10.19 12.43L9.93 12.23L9.69 11.97L9.18 11.97L9.41 12.31L9.69 12.6L10.03 12.86Z",
        "fill": "accent"
      },
      {
        "type": "polygon",
        "d": "M10.25 11.97L11.79 12.83L13.02 12.21L13.4 11.97L12.48 11.97L11.79 12.31L11.16 11.97Z",
        "fill": "accent"
      },
      {
        "type": "polygon",
        "d": "M13.66 10.3L13.93 10.59L13.97 9.81L13.71 9.88L13.27 9.89Z",
        "fill": "accent"
      },
      {
        "type": "polygon",
        "d": "M11.19 10.9L10.59 11.55L11.2 11.55Z",
        "fill": "accent"
      },
      {
        "type": "polygon",
        "d": "M13.05 11.55L12.45 10.9L12.44 11.55Z",
        "fill": "accent"
      }
    ],
    "citi-sprint": [
      {
        "type": "polygon",
        "d": "M2.89 7.66L5.8 7.66L5.99 7.95L2.86 7.95Z",
        "fill": "accent"
      },
      {
        "type": "polygon",
        "d": "M3.08 8.12L5.82 8.12L5.63 8.4L3.06 8.4Z",
        "fill": "accent"
      },
      {
        "type": "polygon",
        "d": "M3.28 8.57L5.54 8.57L5.45 8.86L3.25 8.86Z",
        "fill": "accent"
      },
      {
        "type": "polygon",
        "d": "M3.47 9.03L5.4 9.03L5.35 9.31L3.44 9.31Z",
        "fill": "accent"
      },
      {
        "type": "polygon",
        "d": "M3.66 9.49L5.34 9.49L5.34 9.77L3.64 9.77Z",
        "fill": "accent"
      },
      {
        "type": "polygon",
        "d": "M3.86 9.94L5.36 9.94L5.41 10.23L3.83 10.23Z",
        "fill": "accent"
      },
      {
        "type": "polygon",
        "d": "M4.05 10.4L5.47 10.4L5.61 10.68L4.03 10.68Z",
        "fill": "accent"
      },
      {
        "type": "polygon",
        "d": "M4.25 10.85L5.77 10.85L5.8 11.14L4.22 11.14Z",
        "fill": "accent"
      },
      {
        "type": "line",
        "d": "M7.11 8.29L6.96 8.03L6.77 7.85L6.55 7.76L6.32 7.76L6.09 7.86L5.87 8.04L5.68 8.3L5.52 8.63L5.4 8.99L5.34 9.38L5.34 9.76L5.38 10.12L5.48 10.43L5.62 10.69L5.79 10.88L6 10.99L6.22 11.01L6.45 10.94L6.66 10.78L6.86 10.55M7.82 8.64L7.59 11.22M8.72 7.58L8.4 11.22M8.18 8.87L9.09 8.87M9.47 8.64L9.25 11.22M9.87 9.93L10.72 9.93M12.36 8.19L12.16 7.83L11.81 7.83L11.49 8.19L11.33 8.73L11.43 9.21L11.72 9.4L12.02 9.59L12.12 10.07L11.96 10.61L11.63 10.97L11.27 10.97L11.06 10.61M12.96 8.64L12.65 12.1M12.85 9.88L12.9 9.59L12.99 9.33L13.13 9.1L13.29 8.92L13.47 8.81L13.66 8.78L13.85 8.81L14.01 8.92L14.14 9.1L14.24 9.33L14.29 9.59L14.29 9.88L14.24 10.16L14.14 10.42L14.01 10.65L13.84 10.83L13.66 10.94L13.47 10.97L13.29 10.94L13.12 10.83L12.99 10.65L12.89 10.42L12.85 10.16L12.85 9.88L12.9 9.59M14.95 8.64L14.72 11.22M14.87 9.55L14.91 9.35L14.99 9.16L15.11 9L15.26 8.88L15.43 8.8L15.6 8.78M16.03 8.64L15.8 11.22M16.73 8.64L16.5 11.22M16.65 9.55L16.7 9.31L16.8 9.1L16.94 8.92L17.11 8.81L17.28 8.78L17.46 8.81L17.6 8.92L17.71 9.1L17.77 9.31L17.78 9.55L17.63 11.22M18.74 7.58L18.42 11.22M18.21 8.87L19.11 8.87",
        "stroke": "#000000",
        "strokeWidth": 0.5
      },
      {
        "type": "circle",
        "cx": 7.9,
        "cy": 7.84,
        "r": 0.3,
        "fill": "#000000"
      },
      {
        "type": "circle",
        "cx": 9.53,
        "cy": 7.84,
        "r": 0.3,
        "fill": "#000000"
      },
      {
        "type": "circle",
        "cx": 16.08,
        "cy": 7.84,
        "r": 0.3,
        "fill": "#000000"
      }
    ],
    "citymail-pk": [
      {
        "type": "line",
        "d": "M8.31 7.22L6.11 7.22L5.75 7.26L5.4 7.35L5.08 7.5L4.78 7.71L4.53 7.96L4.32 8.26L4.17 8.58L4.08 8.93L4.04 9.29L4.08 9.65L4.17 10L4.32 10.33L4.53 10.62L4.78 10.88L5.08 11.08L5.4 11.24L5.75 11.33L6.11 11.36L8.31 11.36",
        "stroke": "accent",
        "strokeWidth": 1.85
      },
      {
        "type": "line",
        "d": "M10.69 12.11L11.83 7.49L12.36 7.49L13.9 11.18L14.6 11.18L16.32 7.49L16.85 7.49L17.9 12.11",
        "stroke": "#db2726",
        "strokeWidth": 1.85
      }
    ],
    "consegnia": [
      {
        "type": "polygon",
        "d": "M13.89 13.31L5.8 13.31L5.55 13.22L5.31 13.04L5.2 12.85L5.2 11.98L7.29 5.25L8.83 5.26L6.96 11.03L6.94 11.59L7.08 11.92L7.29 12.11L7.57 12.17L12.94 12.16L13.17 12.08L13.38 11.84L13.78 10.46L15.46 10.48L15.1 12.12L14.91 12.57L14.59 12.94L14.37 13.11Z",
        "fill": "#1cca87"
      },
      {
        "type": "polygon",
        "d": "M16.25 7.01L14.75 7L15.08 5.85L15.11 5.6L15 5.29L14.71 5.13L7.33 5.09L7.53 4.48L7.75 4.14L8.21 3.77L8.66 3.6L16.16 3.6L16.44 3.71L16.65 3.89L16.75 4.06L16.82 4.34L16.78 4.73Z",
        "fill": "#2586ea"
      },
      {
        "type": "polygon",
        "d": "M12.89 12.05L7.54 12.05L7.29 11.96L7.13 11.78L7.05 11.48L7.11 10.97L8.97 5.25L14.57 5.25L14.82 5.33L14.91 5.43L14.97 5.74L14.59 7.01L10.51 7.01L10.06 7.21L9.85 7.53L9.15 9.68L9.06 9.99L9.06 10.24L9.13 10.37L9.36 10.45L13.64 10.46L13.26 11.78L13.08 11.99Z",
        "fill": "accent"
      }
    ],
    "elog-luxembourg": [
      {
        "type": "polygon",
        "d": "M11.35 5.27L10.98 4.94L10.59 4.69L10.17 4.51L9.73 4.42L9.29 4.41L8.85 4.48L8.43 4.64L8.03 4.88L8.5 4.91L8.98 5L9.47 5.17L9.95 5.39L10.68 5.24Z",
        "fill": "#5ec5ed"
      },
      {
        "type": "polygon",
        "d": "M6.81 9.03L6.97 8.44L7.21 7.87L7.54 7.3L7.94 6.78L8.39 6.32L8.88 5.93L9.41 5.61L9.95 5.39L9 5.01L8.51 4.91L8.04 4.88L7.47 5.39L7.09 5.91L6.79 6.53L6.57 7.19L6.44 7.92L6.41 8.67L6.48 9.41L6.64 10.12L6.88 10.77L6.73 9.9Z",
        "fill": "#1fa12e"
      },
      {
        "type": "polygon",
        "d": "M13 8.05L13.04 7.53L13 7.05L12.89 6.61L12.7 6.21L12.44 5.87L12.13 5.6L11.76 5.4L11.35 5.27L11.7 5.7L12 6.19L12.24 6.74L12.42 7.32L12.74 7.67Z",
        "fill": "#5ec5ed"
      },
      {
        "type": "polygon",
        "d": "M11.59 6.74L11.56 6.73L12.03 7L12.42 7.32L12.24 6.74L12 6.19L11.7 5.7L11.35 5.27L10.68 5.24L9.95 5.39L10.82 5.98Z",
        "fill": "#00a6d4"
      },
      {
        "type": "polygon",
        "d": "M6.82 9.02L7.07 8.3L7.47 7.66L8.03 7.11L8.67 6.72L9.38 6.48L10.12 6.4L10.87 6.49L11.58 6.74L10.85 6L10.01 5.42L9.95 5.39L9.48 5.58L9.01 5.84L8.56 6.17L8.15 6.55L7.76 7L7.43 7.48L7.16 7.98L6.95 8.5Z",
        "fill": "#008836"
      },
      {
        "type": "line",
        "d": "M3.86 6.46L3.86 12.23L7.64 12.23M12.66 9.75L12.61 10.23L12.49 10.69L12.29 11.12L12.01 11.51L11.68 11.85L11.28 12.13L10.85 12.33L10.39 12.45L9.91 12.49L9.43 12.45L8.97 12.33L8.54 12.13L8.15 11.85L7.81 11.51L7.53 11.12L7.33 10.69L7.21 10.23L7.16 9.75L7.21 9.27L7.33 8.81L7.53 8.38L7.81 7.98L8.15 7.65L8.54 7.37L8.97 7.17L9.43 7.04L9.91 7L10.39 7.04L10.85 7.17L11.28 7.37L11.68 7.65L12.01 7.98L12.29 8.38L12.49 8.81L12.61 9.27L12.66 9.75L12.61 10.23M18.43 8.1L18.14 7.78L17.8 7.52L17.42 7.31L17.01 7.17L16.58 7.1L16.15 7.1L15.73 7.17L15.32 7.31L14.94 7.51L14.6 7.78L14.3 8.09L14.06 8.45L13.89 8.85L13.78 9.26L13.74 9.69L13.77 10.13L13.87 10.54L14.04 10.94L14.28 11.31L14.57 11.63L14.9 11.89L15.28 12.1L15.69 12.25L16.11 12.33L16.54 12.33L16.97 12.27L17.38 12.13L17.76 11.93L18.11 11.67L18.11 9.57",
        "stroke": "accent",
        "strokeWidth": 1.6
      }
    ],
    "fastgo": [
      {
        "type": "polygon",
        "d": "M9.07 7.59L8.97 7.6L8.88 7.52L8.75 7.16L8.7 6.71L8.77 6.29L9.2 5.73L9.46 5.56L9.88 5.39L10.37 5.31L17.06 5.33L18.3 5.19L18.95 5.02L19.03 5.08L19.02 5.21L18.9 5.34L18.07 5.86L17.48 6.11L16.41 6.4L10.98 6.42L10.24 6.56L9.65 6.9Z",
        "fill": "accent"
      },
      {
        "type": "polygon",
        "d": "M10.69 12.85L9.82 12.85L9.46 12.7L8.22 12.44L7.22 12.01L6.47 11.47L5.68 10.64L5.22 9.93L4.82 9.05L4.52 8.07L4.09 7.27L3.63 6.77L2.89 6.32L2.87 6.19L3.38 5.98L4.29 5.77L5.69 5.76L6.53 5.98L6.94 6.19L7.5 6.61L8.21 7.36L8.27 7.49L8.22 7.56L7.28 6.99L6.66 6.73L5.85 6.6L5.3 6.6L5.13 6.68L5.15 6.84L5.36 7.03L5.56 7.36L5.89 8.53L6.28 9.47L6.86 10.41L7.36 10.97L7.9 11.45L8.51 11.85L9.29 12.24L10.56 12.61L10.69 12.72Z",
        "fill": "accent"
      },
      {
        "type": "polygon",
        "d": "M10.17 9.77L10.03 9.73L9.85 9.3L9.8 8.89L9.84 8.56L10.04 8.18L10.24 7.96L10.53 7.74L10.98 7.55L11.44 7.5L16.02 7.48L16.93 7.41L17.94 7.23L18.06 7.29L17.97 7.5L17.09 8.05L16.57 8.27L15.76 8.51L15.05 8.61L11.89 8.62L11.37 8.72L10.7 9.11Z",
        "fill": "accent"
      },
      {
        "type": "polygon",
        "d": "M11.37 11.69L11.21 11.63L11.08 11.31L11.04 10.97L11.07 10.64L11.41 10.12L11.63 9.92L12.01 9.73L12.48 9.64L15.7 9.66L16.64 9.53L16.81 9.6L16.72 9.86L16.22 10.27L15.79 10.49L15.24 10.66L13.06 10.66L12.61 10.72L11.93 11.07Z",
        "fill": "accent"
      }
    ],
    "fmx": [
      {
        "type": "line",
        "d": "M5.14 9.1L5.26 8.96L5.41 8.85L5.58 8.77L5.76 8.72L5.95 8.71L6.14 8.74L6.31 8.8L6.47 8.9L6.61 9.02L6.73 9.17L6.81 9.34L6.85 9.53L4.96 9.53L4.95 9.7L4.97 9.87L5.02 10.03L5.1 10.18L5.21 10.31L5.33 10.43L5.48 10.52L5.63 10.58L5.8 10.61L5.97 10.62L6.14 10.59L6.3 10.54L6.45 10.45L6.58 10.35L6.69 10.22L6.77 10.07M10.08 8.29L8.2 8.29L7.41 11.05M7.84 9.53L9.37 9.53M9.93 11.05L10.71 8.29L11.06 8.29L11.3 10.77L11.42 10.77L13.07 8.29L13.43 8.29L12.64 11.05",
        "stroke": "accent",
        "strokeWidth": 0.55
      },
      {
        "type": "polygon",
        "d": "M3.56 9.26L4.78 9.26L4.78 9.4Z",
        "fill": "accent"
      },
      {
        "type": "polygon",
        "d": "M3.31 9.43L4.78 9.36L4.78 9.5Z",
        "fill": "accent"
      },
      {
        "type": "polygon",
        "d": "M3.11 9.64L4.78 9.57L4.78 9.71Z",
        "fill": "accent"
      },
      {
        "type": "polygon",
        "d": "M2.85 9.79L4.78 9.66L4.78 9.79Z",
        "fill": "accent"
      },
      {
        "type": "polygon",
        "d": "M14.08 8.02L15.39 8.02L15.6 8.82L16.61 8.02L17.6 8.02L15.92 9.5L16.65 10.98L15.34 10.98L15.12 10.18L14.03 11.05L13.04 11.05L13.28 10.85L14.8 9.5Z",
        "fill": "#ec1c24"
      },
      {
        "type": "line",
        "d": "M16.76 7.92L18.23 6.75M17.07 7.92L18.54 6.75M17.42 7.92L18.89 6.75M17.74 7.92L19.21 6.75M12.9 11.14L11.52 12.25M13.22 11.14L11.83 12.25M13.57 11.14L12.18 12.25M13.89 11.14L12.5 12.25",
        "stroke": "#ec1c24",
        "strokeWidth": 0.14
      }
    ],
    "freightways-global": [
      {
        "type": "line",
        "d": "M9.79 5.2L5.79 5.2L5.79 13.2M5.79 9.2L9.07 9.2M15.68 6.16L15.12 5.63L14.42 5.3L13.66 5.2L12.9 5.33L12.22 5.69L11.68 6.24L11.33 6.93L11.21 7.7L11.21 10.7L11.4 11.65L11.94 12.46L12.76 13.01L13.71 13.2L14.67 13.01L15.48 12.46L16.02 11.65L16.21 10.7L16.21 9.6L13.71 9.6",
        "stroke": "accent",
        "strokeWidth": 1.6
      }
    ],
    "hitch": [
      {
        "type": "polygon",
        "d": "M10.85 3.8L10.12 3.9L9.37 4.16L8.75 4.52L8.17 5.02L7.69 5.64L7.37 6.27L7.15 7.04L7.09 7.78L7.12 8.22L7.22 8.72L7.38 9.19L7.59 9.64L9.33 12.18L10.04 13.35L10.77 14.68L10.88 14.77L11.01 14.8L11.14 14.76L11.25 14.66L11.87 13.52L12.58 12.35L14.42 9.62L14.63 9.17L14.78 8.7L14.88 8.2L14.91 7.67L14.82 6.87L14.57 6.12L14.18 5.44L13.67 4.86L13.06 4.39L12.36 4.04L11.59 3.85Z",
        "fill": "accent"
      },
      {
        "type": "line",
        "d": "M13.19 7.72L13.15 8.15L13.03 8.56L12.82 8.94L12.55 9.27L12.22 9.54L11.84 9.74L11.43 9.87L11 9.91L10.57 9.87L10.16 9.74L9.78 9.54L9.45 9.27L9.18 8.94L8.97 8.56L8.85 8.15L8.81 7.72L8.85 7.29L8.97 6.88L9.18 6.5L9.45 6.17L9.78 5.89L10.16 5.69L10.57 5.56L11 5.52L11.43 5.56L11.84 5.69L12.22 5.89L12.55 6.17L12.82 6.5L13.03 6.88L13.15 7.29L13.19 7.72L13.15 8.15",
        "stroke": "#083eab",
        "strokeWidth": 0.18
      },
      {
        "type": "line",
        "d": "M12.72 7.72L12.68 8.05L12.59 8.37L12.43 8.67L12.21 8.93L11.95 9.14L11.66 9.3L11.33 9.4L11 9.43L10.67 9.4L10.34 9.3L10.05 9.14L9.79 8.93L9.57 8.67L9.41 8.37L9.32 8.05L9.28 7.72L9.32 7.38L9.41 7.06L9.57 6.76L9.79 6.5L10.05 6.29L10.34 6.13L10.67 6.03L11 6L11.33 6.03L11.66 6.13L11.95 6.29L12.21 6.5L12.43 6.76L12.59 7.06L12.68 7.38L12.72 7.72L12.68 8.05",
        "stroke": "#083eab",
        "strokeWidth": 0.62
      },
      {
        "type": "line",
        "d": "M12.24 7.72L12.22 7.96L12.15 8.19L12.03 8.41L11.88 8.59L11.69 8.75L11.47 8.86L11.24 8.93L11 8.96L10.76 8.93L10.53 8.86L10.31 8.75L10.12 8.59L9.97 8.41L9.85 8.19L9.78 7.96L9.76 7.72L9.78 7.48L9.85 7.24L9.97 7.03L10.12 6.84L10.31 6.69L10.53 6.57L10.76 6.5L11 6.48L11.24 6.5L11.47 6.57L11.69 6.69L11.88 6.84L12.03 7.03L12.15 7.24L12.22 7.48L12.24 7.72L12.22 7.96",
        "stroke": "#083eab",
        "strokeWidth": 0.18
      },
      {
        "type": "line",
        "d": "M12.72 7.75L12.69 7.99M12.64 8.22L12.55 8.44M12.44 8.65L12.29 8.84M12.15 8.99L11.96 9.14M11.75 9.26L11.53 9.35M11.3 9.41L11.06 9.43M11 9.43L10.76 9.42M10.53 9.37L10.3 9.28M10.09 9.17L9.9 9.03M9.72 8.87L9.58 8.68M9.46 8.47L9.37 8.25M9.32 8.04L9.29 7.81M9.29 7.54L9.34 7.3M9.4 7.1L9.5 6.89M9.63 6.68L9.79 6.5M9.97 6.35L10.17 6.22M10.39 6.12L10.61 6.05M10.85 6.01L11.09 6M11.33 6.03L11.56 6.09M11.78 6.19L11.98 6.31M12.17 6.46L12.33 6.64M12.47 6.83L12.58 7.05M12.66 7.27L12.7 7.51",
        "stroke": "accent",
        "strokeWidth": 0.1
      }
    ],
    "janco-express": [
      {
        "type": "polygon",
        "d": "M12.41 14.61L11.84 14.62L11.52 14.59L11.36 14.55L10.95 14.36L10.66 14.17L10.38 13.91L10.04 13.52L9.77 13.13L9.57 12.78L9.15 11.86L8.95 11.22L8.7 9.82L8.67 9.26L8.69 8.93L8.75 8.73L8.81 8.76L8.95 9.47L9.12 10.06L9.33 10.6L9.58 11.08L9.74 11.33L9.99 11.62L10.37 11.95L10.96 12.24L11.28 12.28L11.68 12.28L12.03 12.2L12.44 11.97L12.7 11.76L13.17 11.24L13.56 10.55L13.8 9.98L14.01 9.12L14.15 8.05L14.19 6.94L14.14 6.03L13.99 4.9L13.85 4.23L13.86 4.12L13.91 4.07L13.99 4.13L14.18 4.35L14.43 4.69L14.85 5.47L15.08 6.03L15.29 6.81L15.5 8.02L15.54 8.93L15.52 9.39L15.48 9.77L15.27 10.84L15.06 11.7L14.84 12.27L14.42 13.07L13.94 13.71L13.48 14.15L13.11 14.37L12.62 14.56Z",
        "fill": "accent"
      },
      {
        "type": "polygon",
        "d": "M11.68 11.57L11.33 11.58L11.07 11.54L10.53 11.33L10.22 11.11L9.79 10.63L9.61 10.33L9.36 9.74L9.17 9.15L9.08 8.72L9 7.99L8.98 7.35L9.02 6.68L9.1 5.95L9.17 5.63L9.36 5.04L9.61 4.65L9.65 4.69L9.67 4.82L9.62 5.52L9.62 6.19L9.7 6.81L9.79 7.27L10.02 7.9L10.4 8.66L10.83 9.18L11.04 9.36L11.28 9.48L11.68 9.58L12.06 9.55L12.52 9.41L12.84 9.19L13.16 8.85L13.34 8.61L13.73 7.91L13.83 7.84L13.89 7.89L13.89 8.21L13.75 8.93L13.54 9.61L13.34 10.09L13.16 10.41L12.91 10.73L12.49 11.17L12.19 11.36Z",
        "fill": "#007ec4"
      }
    ],
    "jcw-express": [
      {
        "type": "polygon",
        "d": "M5.37 11.9L5.3 12.09L5.17 12.23L4.99 12.31L4.79 12.32L4.57 12.23L4.42 12.05L4.36 11.86L4.36 11.54L3.3 11.54L3.31 12.07L3.47 12.54L3.76 12.93L4.15 13.22L4.62 13.38L5.11 13.38L5.58 13.22L5.98 12.93L6.21 12.64L6.4 12.19L7.07 7.79L5.99 7.79Z",
        "fill": "accent"
      },
      {
        "type": "polygon",
        "d": "M11.37 9.45L11.27 9.13L11.07 8.74L10.8 8.4L10.45 8.12L10.06 7.92L9.63 7.8L9.3 7.78L8.87 7.83L8.55 7.92L8.16 8.12L7.81 8.4L7.54 8.74L7.38 9.03L7.24 9.45L7.2 9.89L7.24 10.33L7.34 10.64L7.54 11.04L7.81 11.38L8.16 11.66L8.45 11.81L8.87 11.95L9.3 12L9.74 11.95L10.06 11.86L10.36 11.71L10.63 11.53L10.87 11.3L11.07 11.04L11.23 10.75L11.39 10.21L10.3 10.21L10.08 10.59L9.78 10.82L9.41 10.92L8.98 10.88L8.61 10.66L8.46 10.5L8.33 10.26L8.27 10.05L8.27 9.78L8.31 9.57L8.43 9.32L8.61 9.11L8.83 8.96L9.09 8.87L9.36 8.85L9.63 8.9L9.92 9.04L10.15 9.27L10.29 9.55L11.39 9.55Z",
        "fill": "accent"
      },
      {
        "type": "polygon",
        "d": "M14.93 9.4L15.09 12.03L16.71 12.03L18.66 7.79L17.49 7.79L16.09 10.84L15.9 7.79L14.45 7.79L13.18 10.79L12.84 7.79L11.77 7.79L12.24 12.03L13.81 12.03Z",
        "fill": "accent"
      },
      {
        "type": "polygon",
        "d": "M6.14 5.79L7.53 5.79L5.93 6.98Z",
        "fill": "accent"
      }
    ],
    "m-xpress": [
      {
        "type": "polygon",
        "d": "M13.46 10.82L15.13 9.12L14.19 8.2L13.19 9.22L12.96 7.88L11.67 8.1L12.06 10.38L9.82 12.66L11.67 12.66L12.33 11.98L12.44 12.66L13.78 12.66Z",
        "fill": "accent"
      },
      {
        "type": "polygon",
        "d": "M12.79 5.91L18.52 5.91L15.31 8.95L14 8.49L13.17 8.2L11.61 7.93Z",
        "fill": "#10b09e"
      },
      {
        "type": "polygon",
        "d": "M5.93 12.66L7.46 12.66L9.29 10.58L8.08 12.66L9.61 12.66L13.55 5.91L11.68 5.91L7.86 10.22L8.88 5.91L7.24 5.91L3.3 12.66L4.82 12.66L6.68 9.47Z",
        "fill": "#10b09e"
      },
      {
        "type": "polygon",
        "d": "M14.08 8.76L15.13 9.12L14.19 8.2L13.19 9.22L12.96 7.88L12.03 8.04L12.96 8.38L12.91 10.27Z",
        "fill": "truck"
      },
      {
        "type": "polygon",
        "d": "M13.15 9.58L13.19 8.22L11.86 7.73L13.2 7.32L13.25 5.92L14.04 7.07L15.38 6.67L14.55 7.79L15.32 8.95L14 8.5Z",
        "fill": "accent"
      }
    ],
    "mark-express": [
      {
        "type": "polygon",
        "d": "M9.24 13.37L8.74 13.27L8.21 13.09L7.68 12.83L7.24 12.54L6.81 12.18L6.45 11.8L6.11 11.34L5.84 10.86L5.63 10.34L5.5 9.85L5.42 9.34L5.4 8.72L5.45 8.17L5.58 7.62L5.76 7.12L5.99 6.65L6.51 5.92L7.14 5.32L7.86 4.85L8.66 4.54L9.58 4.37L10.09 4.36L10.6 4.4L11.04 4.49L11.52 4.64L11.95 4.83L12.41 5.09L13.46 4.54L14.48 4.12L13.5 4.7L12.72 5.21L11.93 5.81L11.13 6.51L10.45 7.19L9.75 7.99L9.17 8.75L8.59 9.62L9.37 8.19L9.29 8.01L9.17 7.88L8.92 7.81L6.76 7.83L6.55 7.89L6.4 8.05L6.35 8.22L6.39 8.43L7.44 10.4L8.32 12.41L8.45 12.54L8.6 12.6L9.45 12.6Z",
        "fill": "#e31e24"
      },
      {
        "type": "polygon",
        "d": "M10.15 13.41L9.62 13.39L9.93 12.28L10.28 11.29L10.71 10.3L11.19 9.34L11.75 8.4L12.71 7.06L13.79 5.84L15.02 4.72L16.32 3.76L15.54 4.45L14.94 5.06L14.33 5.78L13.82 6.53L14.11 7.1L14.31 7.68L14.43 8.28L14.47 8.93L14.42 9.58L14.28 10.18L14.06 10.78L13.76 11.33L13.43 11.78L13.07 12.17L12.67 12.5L12.21 12.81L11.72 13.06L11.21 13.24L10.68 13.36Z",
        "fill": "accent"
      }
    ],
    "nege": [
      {
        "type": "polygon",
        "d": "M2.99 10.41L3.19 10.7L3.46 10.98L3.78 11.22L4.17 11.46L4.59 11.66L5.08 11.84L6.22 12.13L7.59 12.32L9.21 12.4L10.88 12.35L11.63 12.28L12.17 12.18L13.5 11.85L14.82 11.43L16.05 10.92L17.09 10.38L17.36 10.47L17.65 10.48L17.93 10.42L18.17 10.29L18.35 10.12L18.47 9.92L18.54 9.6L18.48 9.28L18.87 8.71L19.13 8.11L19.24 7.52L19.2 6.96L19.09 6.61L18.92 6.29L18.69 5.99L18.38 5.72L18.02 5.47L17.59 5.24L17.1 5.04L16.56 4.88L15.93 4.73L15.28 4.62L14.52 4.55L13.81 4.51L13.06 4.52L12.24 4.56L10.96 4.75L10.31 4.93L10.34 5.04L10.44 5.07L11.51 4.9L12.51 4.8L13.36 4.77L14.15 4.8L14.98 4.88L15.71 5.01L16.38 5.2L16.96 5.44L17.44 5.71L17.85 6.04L18.17 6.39L18.41 6.8L18.53 7.13L18.55 7.47L18.47 7.88L18.3 8.32L18.01 8.8L17.74 8.71L17.43 8.71L17.13 8.79L16.88 8.94L16.69 9.17L16.59 9.42L16.58 9.7L16.66 9.97L15.84 10.43L14.79 10.9L13.7 11.29L12.5 11.62L11.36 11.84L10.1 11.95L8.7 11.99L7.47 11.93L6.31 11.79L5.16 11.52L4.65 11.34L4.21 11.15L3.83 10.92L3.52 10.68L3.27 10.44L2.97 10.07L2.9 10.17L2.9 10.21Z",
        "fill": "accent"
      },
      {
        "type": "line",
        "d": "M7.18 6.69L7.02 6.47L6.79 6.28L6.51 6.15L6.19 6.08L5.85 6.08L5.53 6.15L5.25 6.29L5.02 6.48L4.87 6.7L4.8 6.96L4.82 7.21L4.94 7.45L5.13 7.66L5.39 7.82L5.69 7.93L6.02 7.96L6.36 7.99L6.66 8.1L6.92 8.26L7.11 8.47L7.23 8.71L7.25 8.96L7.18 9.22L7.03 9.44L6.8 9.63L6.52 9.77L6.2 9.84L5.86 9.84L5.54 9.77L5.26 9.64L5.03 9.45L4.87 9.23M11.45 6.69L11.3 6.47L11.08 6.28L10.81 6.15L10.5 6.08L10.18 6.08L9.87 6.15L9.6 6.29L9.38 6.48L9.23 6.7L9.17 6.96L9.19 7.21L9.3 7.45L9.48 7.66L9.73 7.82L10.03 7.93L10.34 7.96L10.66 7.99L10.96 8.1L11.21 8.26L11.39 8.47L11.5 8.71L11.52 8.96L11.46 9.22L11.31 9.44L11.09 9.63L10.82 9.77L10.51 9.84L10.19 9.84L9.88 9.77L9.61 9.64L9.39 9.45L9.24 9.23M12.59 6.27L16.36 6.27M14.48 6.27L14.48 10.44",
        "stroke": "accent",
        "strokeWidth": 1.45
      }
    ],
    "patuen": [
      {
        "type": "polygon",
        "d": "M5.53 14.2L3.97 14.2L3.52 14.17L4.54 10.33L4.62 10.11L5 8.65L5.05 8.53L5.27 7.61L5.33 7.49L5.48 6.91L5.55 6.54L5.53 6.52L5.19 6.5L3.57 6.49L3.57 6.45L3.69 6.03L3.81 5.75L3.96 5.51L4.25 5.17L4.46 4.98L4.92 4.7L5.19 4.59L5.47 4.52L5.89 4.46L8.18 4.46L8.64 4.52L8.94 4.59L9.22 4.68L9.43 4.77L9.89 5.02L10.19 5.25L10.44 5.48L10.87 6.03L11.02 6.3L11.09 6.48L7.72 6.5L7.67 6.51L7.28 7.89L7.15 8.43L7.1 8.56L7 8.98L6.95 9.11L6.88 9.44L6.8 9.65L6.57 10.57L6.4 11.15L6.15 12.16L6.06 12.37L5.63 14.05L5.59 14.17Z",
        "fill": "accent"
      },
      {
        "type": "polygon",
        "d": "M13.64 14.24L13.09 14.23L12.69 14.12L12.3 13.89L12.01 13.65L11.75 13.35L11.59 13.1L11.4 12.67L11.31 12.4L11.25 11.97L11.25 11.3L11.29 11.03L11.97 8.53L12.04 8.19L12.25 7.52L12.38 6.97L12.43 6.85L12.48 6.54L12.39 6.5L11.76 6.48L11.54 5.96L11.39 5.69L11.22 5.45L11 5.17L10.63 4.81L10.21 4.5L10.25 4.46L16.69 4.46L17.03 4.46L17.09 4.5L16.96 4.93L16.57 6.42L16.54 6.49L14.65 6.5L14.57 6.54L14.45 6.91L14.23 7.79L14.18 7.92L13.59 10.11L13.44 10.57L13.35 10.97L13.35 11.33L13.42 11.64L13.58 11.94L13.74 12.13L14.04 12.35L14.46 12.5L15.29 12.52L15.35 12.52L15.36 12.58L15.26 12.89L15.11 13.22L14.93 13.5L14.72 13.71L14.52 13.87L14.28 14.02L13.98 14.15Z",
        "fill": "accent"
      },
      {
        "type": "polygon",
        "d": "M8.21 10.94L7.54 10.94L7.11 10.91L7.16 10.63L7.25 10.39L7.32 10.05L7.55 9.26L7.62 8.92L8.27 8.91L8.67 8.81L8.94 8.64L9.13 8.46L9.32 8.1L9.36 7.92L9.35 7.46L9.32 7.31L9.24 7.18L9.22 7.09L11.29 7.08L11.33 7.18L11.37 7.49L11.37 7.98L11.3 8.4L11.18 8.8L11 9.2L10.63 9.75L10.19 10.18L9.77 10.48L9.52 10.61L8.97 10.82L8.52 10.92Z",
        "fill": "accent"
      }
    ],
    "promed-delivery": [
      {
        "type": "polygon",
        "d": "M17.3 7.43L12.46 7.43L12.43 7.37L12.5 7.17L12.51 6.77L12.43 6.57L12.34 6.46L12.19 6.33L11.86 6.19L11.3 6.1L10.88 6.11L10.4 6.19L9.58 6.41L8.28 6.92L7.37 7.4L7.33 7.37L7.87 6.79L8.82 5.98L9.82 5.31L10.64 4.88L11.81 4.44L12.77 4.21L13.5 4.13L14.44 4.13L15.07 4.21L15.64 4.36L15.99 4.51L16.35 4.73L16.73 5.08L16.95 5.36L17.17 5.75L17.39 6.46L17.4 7.39Z",
        "fill": "#b3b3b3"
      },
      {
        "type": "polygon",
        "d": "M9.74 13.47L8.74 13.47L8.12 13.4L7.55 13.24L7.21 13.1L6.84 12.87L6.32 12.35L6.02 11.85L5.83 11.15L5.83 10.19L10.73 10.18L10.76 10.24L10.69 10.44L10.69 10.84L10.77 11.04L10.85 11.15L11.1 11.33L11.33 11.42L11.9 11.5L12.34 11.49L12.83 11.41L13.6 11.2L14.55 10.84L15.81 10.22L15.64 10.45L15.05 11.04L14.53 11.49L13.72 12.07L12.98 12.51L12.2 12.88L11.61 13.1L10.44 13.39Z",
        "fill": "accent"
      },
      {
        "type": "line",
        "d": "M6.49 9.9L7.54 7.71L8.01 7.71L8.21 7.75L8.34 7.88L8.37 8.08L8.3 8.31L8.15 8.54L7.93 8.74L7.68 8.87L7.43 8.91L6.96 8.91M8.16 9.9L9.21 7.71L9.68 7.71L9.88 7.75L10.01 7.88L10.04 8.08L9.97 8.31L9.82 8.54L9.6 8.74L9.35 8.87L9.1 8.91L8.63 8.91M9.05 8.91L9.21 9.9M11.53 8.8L11.37 9.09L11.19 9.35L10.98 9.58L10.77 9.75L10.58 9.86L10.41 9.9L10.27 9.86L10.18 9.75L10.14 9.58L10.15 9.35L10.22 9.09L10.34 8.8L10.49 8.52L10.68 8.26L10.88 8.03L11.09 7.86L11.29 7.75L11.46 7.71L11.6 7.75L11.69 7.86L11.73 8.03L11.71 8.26L11.65 8.52L11.53 8.8L11.37 9.09M11.62 9.9L12.67 7.71L12.88 7.71L12.72 9.07L13.87 7.71L14.08 7.71L13.02 9.9M15.6 7.71L14.69 7.71L13.63 9.9L14.55 9.9M14.16 8.8L14.94 8.8M15.59 8.8L16.12 7.71L16.57 7.71L16.73 7.73L16.86 7.8L16.94 7.91L16.98 8.06L16.97 8.23L16.9 8.41L16.52 9.2L16.41 9.38L16.26 9.55L16.09 9.69L15.89 9.8L15.7 9.87L15.51 9.9L15.06 9.9L15.59 8.8L16.12 7.71",
        "stroke": "accent",
        "strokeWidth": 0.34
      }
    ],
    "shipx-asia": [
      {
        "type": "line",
        "d": "M5.19 8.7L4.89 8.51L4.49 8.41L4.06 8.41L3.66 8.53L3.38 8.73L3.25 8.98L3.3 9.24L3.52 9.47L3.88 9.62L4.3 9.68L4.73 9.73L5.08 9.89L5.3 10.12L5.35 10.38L5.21 10.64L4.92 10.83L4.52 10.94L4.08 10.94L3.68 10.83L3.39 10.64M6.65 8.05L6.65 11.31M8.74 8.05L8.74 11.31M6.65 9.66L8.74 9.66M11.83 11.31L11.83 8.44L13.04 8.44L13.25 8.48L13.44 8.58L13.6 8.73L13.69 8.92L13.73 9.13L13.69 9.35L13.6 9.54L13.44 9.69L13.25 9.79L13.04 9.82L11.83 9.82",
        "stroke": "#1a1a1a",
        "strokeWidth": 0.8
      },
      {
        "type": "polygon",
        "d": "M9.89 9.87L10.68 9.68L10.68 11.31L9.89 11.31Z",
        "fill": "#1a1a1a"
      },
      {
        "type": "polygon",
        "d": "M9.89 8.05L10.68 8.05L10.68 9.48L9.89 9.67Z",
        "fill": "accent"
      },
      {
        "type": "polygon",
        "d": "M17.23 7.7L16.37 8.56L15.51 7.7L13.62 7.7L15.42 9.51L16.36 10.45L17.21 11.3L19.13 13.2L19.13 11.3L18.51 11.3L17.61 9.94L16.84 9.98L17.32 9.5L19.13 7.7L19.13 5.8Z",
        "fill": "accent"
      },
      {
        "type": "polygon",
        "d": "M17.32 9.5L16.84 9.98L17.61 9.94Z",
        "fill": "#99008a"
      },
      {
        "type": "polygon",
        "d": "M13.62 11.3L15.21 9.72L16.15 10.66L15.51 11.3Z",
        "fill": "#1a1a1a"
      }
    ],
    "spt-logistics": [
      {
        "type": "line",
        "d": "M15.61 8.95L15.58 9.47L15.5 9.98L15.35 10.49L15.15 10.97L14.9 11.43L14.6 11.86L14.25 12.25L13.86 12.6L13.43 12.9L12.97 13.15L12.49 13.35L11.98 13.5L11.47 13.59L10.95 13.62L10.42 13.59L9.91 13.5L9.4 13.35L8.92 13.15L8.46 12.9L8.03 12.6L7.64 12.25L7.29 11.86L6.99 11.43L6.74 10.97L6.54 10.49L6.39 9.98L6.31 9.47L6.28 8.95L6.31 8.42L6.39 7.91L6.54 7.4L6.74 6.92L6.99 6.46L7.29 6.03L7.64 5.64L8.03 5.3L8.46 4.99L8.92 4.74L9.4 4.54L9.91 4.39L10.42 4.31L10.94 4.28L11.47 4.31L11.98 4.39L12.49 4.54L12.97 4.74L13.43 4.99L13.86 5.3L14.25 5.64L14.6 6.03L14.9 6.46L15.15 6.92L15.35 7.4L15.5 7.91L15.58 8.42L15.61 8.95L15.58 9.47",
        "stroke": "accent",
        "strokeWidth": 0.75
      },
      {
        "type": "polygon",
        "d": "M7.93 6.22L11.75 6.42L12.54 6.66L12.91 6.85L13.36 7.25L14.07 7.5L17.56 7.44L18.51 6.98L18.51 5.5L14.15 5.47L11.81 5.35L7.93 5.59Z",
        "fill": "truck"
      },
      {
        "type": "line",
        "d": "M8 7.34L7.91 7.07L7.72 6.83L7.44 6.66L7.11 6.56L6.73 6.54L6.35 6.61L5.99 6.75L5.68 6.96L5.44 7.22L5.29 7.52L5.25 7.82L5.31 8.1L5.47 8.35L5.72 8.54L6.05 8.66L6.41 8.71L6.78 8.76L7.09 8.9L7.33 9.14L7.49 9.44L7.53 9.79L7.48 10.16L7.32 10.52L7.07 10.84L6.75 11.09L6.38 11.27L5.99 11.35L5.62 11.33L5.29 11.21L5.02 11L4.84 10.71L4.76 10.37M10.37 6.16L9.19 12.02M15.79 6.16L14.62 12.02",
        "stroke": "truck",
        "strokeWidth": 2.09
      },
      {
        "type": "line",
        "d": "M9.93 6.98L10.33 6.85L10.73 6.73L11.14 6.64L11.55 6.56L11.96 6.51L12.35 6.48L12.72 6.47L13.06 6.48L13.38 6.52L13.66 6.58L13.9 6.66L14.1 6.76L14.26 6.87L14.36 7.01L14.42 7.16L14.42 7.32L14.37 7.49L14.28 7.67L14.13 7.85L13.94 8.03L13.71 8.21L13.43 8.39L13.12 8.56L12.78 8.73L12.42 8.88L12.03 9.02L11.63 9.14L11.22 9.24L10.81 9.32L10.4 9.39L10 9.43L9.62 9.45L9.27 9.44L8.94 9.42L8.64 9.37L8.38 9.3L8.16 9.21L7.99 9.1L7.86 8.97L7.78 8.83",
        "stroke": "truck",
        "strokeWidth": 1.74
      },
      {
        "type": "line",
        "d": "M8 7.34L7.91 7.07L7.72 6.83L7.44 6.66L7.11 6.56L6.73 6.54L6.35 6.61L5.99 6.75L5.68 6.96L5.44 7.22L5.29 7.52L5.25 7.82L5.31 8.1L5.47 8.35L5.72 8.54L6.05 8.66L6.41 8.71L6.78 8.76L7.09 8.9L7.33 9.14L7.49 9.44L7.53 9.79L7.48 10.16L7.32 10.52L7.07 10.84L6.75 11.09L6.38 11.27L5.99 11.35L5.62 11.33L5.29 11.21L5.02 11L4.84 10.71L4.76 10.37M10.37 6.16L9.19 12.02M15.79 6.16L14.62 12.02",
        "stroke": "accent",
        "strokeWidth": 1.33
      },
      {
        "type": "line",
        "d": "M9.93 6.98L10.33 6.85L10.73 6.73L11.14 6.64L11.55 6.56L11.96 6.51L12.35 6.48L12.72 6.47L13.06 6.48L13.38 6.52L13.66 6.58L13.9 6.66L14.1 6.76L14.26 6.87L14.36 7.01L14.42 7.16L14.42 7.32L14.37 7.49L14.28 7.67L14.13 7.85L13.94 8.03L13.71 8.21L13.43 8.39L13.12 8.56L12.78 8.73L12.42 8.88L12.03 9.02L11.63 9.14L11.22 9.24L10.81 9.32L10.4 9.39L10 9.43L9.62 9.45L9.27 9.44L8.94 9.42L8.64 9.37L8.38 9.3L8.16 9.21L7.99 9.1L7.86 8.97L7.78 8.83",
        "stroke": "accent",
        "strokeWidth": 0.99
      },
      {
        "type": "polygon",
        "d": "M9.06 5.9L11.82 5.73L14.13 5.84L18.14 5.87L18.14 6.74L17.47 7.06L14.13 7.12L13.55 6.92L13.12 6.54L12.69 6.31L11.82 6.05Z",
        "fill": "accent"
      },
      {
        "type": "line",
        "d": "M12.87 8.69L12.52 8.84L12.14 8.98M11.51 9.17L11.11 9.27L10.7 9.34M10.08 9.42L9.7 9.45L9.34 9.45",
        "stroke": "truck",
        "strokeWidth": 0.23
      }
    ],
    "sptexp": [
      {
        "type": "circle",
        "cx": 11.9,
        "cy": 9.3,
        "r": 5,
        "fill": "#ffb838"
      },
      {
        "type": "polygon",
        "d": "M8.82 5.44L8.46 5.92L8.17 6.46L7.96 6.96L7.8 7.56L7.7 8.17L7.68 8.79L7.74 9.41L7.88 10.01L8.08 10.51L8.3 10.92L8.62 11.37L9.01 11.78L9.4 12.1L9.77 12.34L10.39 12.62L10.93 12.82L11.12 12.92L11.19 13L11.35 13.28L11.31 13.48L11.08 13.81L10.92 13.97L10.67 14.15L11.51 14.28L12 13.9L12.18 13.66L12.27 13.46L12.31 13.23L12.29 13L12.22 12.79L12.12 12.61L11.85 12.31L11.3 11.93L10.74 11.67L9.76 11.35L9.52 11.23L9.19 11.01L8.86 10.69L8.67 10.43L8.44 10.02L8.25 9.52L8.13 9.04L8.06 8.48L8.05 7.97L8.1 7.46L8.18 7.02L8.34 6.45L8.54 5.97Z",
        "fill": "accent"
      },
      {
        "type": "line",
        "d": "M8.13 7.92L7.77 7.65L7.3 7.65L6.95 7.92L6.86 8.31L7.1 8.66L7.54 8.8L7.99 8.94L8.24 9.29L8.15 9.69L7.78 9.95L7.29 9.95L6.92 9.69M9.23 9.95L9.23 7.65L10.05 7.65L10.29 7.7L10.49 7.84L10.63 8.04L10.68 8.28L10.63 8.53L10.49 8.73L10.29 8.87L10.05 8.92L9.23 8.92M12.89 7.65L11.65 7.65L11.65 9.95L12.89 9.95M11.65 8.8L12.64 8.8M14.81 7.65L13.58 7.65L13.58 9.95L14.81 9.95M13.58 8.8L14.57 8.8M15.51 8.8L15.51 7.65L16.36 7.65L16.59 7.7L16.78 7.83L16.91 8.02L16.96 8.25L16.96 9.35L16.91 9.58L16.78 9.78L16.59 9.91L16.36 9.95L15.51 9.95L15.51 8.8L15.51 7.65",
        "stroke": "#050e5b",
        "strokeWidth": 0.55
      }
    ],
    "superb-express": [
      {
        "type": "line",
        "d": "M4.17 6.32L5.88 6.32L6.06 6.37L6.17 6.51L6.17 6.7L6.02 7.32L5.92 7.51L5.74 7.65L5.54 7.7L3.45 7.7M6.18 5.9L5.83 7.32L5.83 7.51L5.93 7.65L6.11 7.7L7.25 7.7M7.7 5.9L7.25 7.7M8.46 5.9L7.75 8.75M8.46 5.9L9.7 5.9L9.87 5.95L9.98 6.08L9.98 6.28L9.72 7.32L9.62 7.51L9.45 7.65L9.25 7.7L8.01 7.7M10.52 6.8L12.13 6.8L12.26 6.28L12.26 6.08L12.15 5.95L11.98 5.9L11.12 5.9L10.92 5.95L10.74 6.08L10.65 6.28L10.39 7.32L10.39 7.51L10.49 7.65L10.67 7.7L11.91 7.7M12.57 7.7L12.93 6.28L13.02 6.08L13.2 5.95L13.4 5.9L14.16 5.9M15.26 4.95L14.57 7.7M15.03 5.9L16.26 5.9L16.44 5.95L16.54 6.08L16.55 6.28L16.28 7.32L16.19 7.51L16.01 7.65L15.81 7.7L14.57 7.7M5.69 9.59L4.17 9.59L3.97 9.65L3.8 9.79L3.7 9.97L3.2 11.97L3.2 12.16L3.31 12.3L3.49 12.35L5 12.35M3.45 10.97L5.06 10.97M5.84 10.54L6.81 12.35M7.26 10.54L5.38 12.35M8.12 10.54L7.4 13.39M8.12 10.54L9.35 10.54L9.53 10.6L9.63 10.73L9.64 10.92L9.38 11.97L9.28 12.16L9.1 12.3L8.9 12.35L7.67 12.35M9.95 12.35L10.3 10.92L10.4 10.73L10.57 10.6L10.78 10.54L11.54 10.54M12.17 11.45L13.79 11.45L13.92 10.92L13.92 10.73L13.81 10.6L13.64 10.54L12.78 10.54L12.58 10.6L12.4 10.73L12.31 10.92L12.04 11.97L12.05 12.16L12.15 12.3L12.33 12.35L13.56 12.35M16.2 10.54L15.06 10.54L14.86 10.6L14.68 10.73L14.59 10.92L14.55 11.07L14.55 11.26L14.66 11.4L14.83 11.45M14.83 11.45L15.59 11.45L15.77 11.5L15.88 11.64L15.88 11.83L15.84 11.97L15.75 12.16L15.57 12.3L15.37 12.35L14.23 12.35M18.48 10.54L17.34 10.54L17.14 10.6L16.96 10.73L16.87 10.92L16.83 11.07L16.83 11.26L16.94 11.4L17.11 11.45M17.11 11.45L17.87 11.45L18.05 11.5L18.16 11.64L18.16 11.83L18.12 11.97L18.03 12.16L17.85 12.3L17.65 12.35L16.51 12.35",
        "stroke": "accent",
        "strokeWidth": 0.65
      },
      {
        "type": "line",
        "d": "M6.61 4.95L4.52 4.95L4.32 5L4.14 5.13L4.04 5.33L3.89 5.94L3.89 6.13L4 6.27L4.17 6.32",
        "stroke": "#fd8103",
        "strokeWidth": 0.65
      }
    ],
    "tapuz-delivery": [
      {
        "type": "line",
        "d": "M3.25 7.65L6.29 7.65M4.74 7.65L4.74 11.75M5.93 11.75L7.49 7.65L7.74 7.65L9.35 11.75M6.4 10.52L8.87 10.52M10.02 11.75L10.02 7.65L11.28 7.65L11.53 7.69L11.76 7.82L11.94 8.03L12.05 8.28L12.09 8.56L12.05 8.85L11.94 9.1L11.76 9.3L11.53 9.43L11.28 9.48L10.02 9.48M12.89 7.4L12.89 10.06L12.94 10.43L13.07 10.78L13.27 11.08L13.53 11.31L13.84 11.45L14.17 11.5L14.5 11.45L14.81 11.31L15.07 11.08L15.28 10.78L15.41 10.43L15.45 10.06L15.45 7.4M16.11 7.65L18.29 7.65L16.57 11.5L18.75 11.5",
        "stroke": "accent",
        "strokeWidth": 0.5
      }
    ],
    "thabit-logistics": [
      {
        "type": "line",
        "d": "M3.4 7.53L6.36 7.53M4.9 7.53L4.9 11.75M7.13 7.2L7.13 11.75M7.13 9.78L7.17 9.5L7.29 9.25L7.47 9.05L7.71 8.92L7.96 8.88L8.22 8.92L8.45 9.05L8.64 9.25L8.76 9.5L8.8 9.78L8.8 11.75M10.15 9.43L10.26 9.21L10.45 9.04L10.69 8.95L10.95 8.94L11.2 9.01L11.4 9.16L11.54 9.36L11.58 9.6L11.58 11.75M11.58 10.75L11.55 10.96L11.44 11.14L11.27 11.29L11.05 11.39L10.81 11.42L10.57 11.39L10.36 11.29L10.19 11.14L10.08 10.96L10.04 10.75L10.08 10.54L10.19 10.36L10.36 10.21L10.57 10.11L10.81 10.08L11.05 10.11L11.27 10.21L11.44 10.36L11.55 10.54L11.58 10.75L11.55 10.96M12.87 7.6L12.87 11.75M14.71 10.28L14.67 10.63L14.54 10.95L14.33 11.2L14.08 11.36L13.79 11.42L13.51 11.36L13.25 11.2L13.05 10.95L12.91 10.63L12.87 10.28L12.91 9.92L13.05 9.6L13.25 9.35L13.51 9.19L13.79 9.13L14.08 9.19L14.33 9.35L14.54 9.6L14.67 9.92L14.71 10.28L14.67 10.63M15.78 8.55L15.78 11.75M17.33 7.2L17.33 11.75M16.6 8.3L18.44 8.3",
        "stroke": "accent",
        "strokeWidth": 0.66
      },
      {
        "type": "circle",
        "cx": 15.78,
        "cy": 7.67,
        "r": 0.44,
        "fill": "accent"
      },
      {
        "type": "polygon",
        "d": "M13.47 7.28L13.98 7.28L13.98 7.58L13.47 7.58Z",
        "fill": "accent"
      },
      {
        "type": "polygon",
        "d": "M14.2 7.28L15.31 7.28L15.31 7.58L14.2 7.58Z",
        "fill": "accent"
      },
      {
        "type": "polygon",
        "d": "M14.67 7.78L15.31 7.78L15.31 8.12L14.67 8.12Z",
        "fill": "accent"
      },
      {
        "type": "polygon",
        "d": "M15.31 7.63L15.78 7.63L15.78 7.77L15.31 7.77Z",
        "fill": "truck"
      }
    ],
    "togo-post": [
      {
        "type": "polygon",
        "d": "M15.13 10.65L15.42 10.04L15.6 9.38L15.64 8.36L15.52 7.69L15.29 7.05L14.95 6.46L14.26 5.71L13.7 5.32L13.09 5.03L12.43 4.85L11.75 4.79L10.74 4.93L10.1 5.16L9.51 5.5L8.99 5.94L8.37 6.75L8.18 7.12L14.1 7.12L14.1 8.04L7.9 8.04L7.85 8.84L14.38 8.84L14.38 9.71L7.98 9.71L8.21 10.35L8.39 10.7L15.11 10.7Z",
        "fill": "accent"
      },
      {
        "type": "polygon",
        "d": "M8.14 13.13L8.53 13.43L9.38 13.92L9.83 14.1L10.77 14.36L11.26 14.42L12.24 14.42L12.72 14.36L13.66 14.1L14.55 13.69L14.96 13.43L15.35 13.13L16.04 12.44L16.34 12.05L16.83 11.21L17.02 10.75L17.25 9.89L16.43 9.89L16.13 10.74L15.93 11.11L15.45 11.8L15.17 12.12L14.52 12.66L14.16 12.88L13.4 13.24L13 13.37L12.17 13.51L11.75 13.53L10.91 13.46L10.5 13.37L9.71 13.08L9.34 12.88L8.75 12.48L6.23 12.48L6.23 12.63L7.24 12.79L7.66 12.9Z",
        "fill": "accent"
      },
      {
        "type": "polygon",
        "d": "M17.2 7.97L19.21 7.97L17.29 9.89L17.2 9.89Z",
        "fill": "accent"
      },
      {
        "type": "polygon",
        "d": "M16.63 7.84L16.54 7.42L16.24 6.61L15.81 5.86L15.25 5.2L14.59 4.64L13.84 4.21L13.03 3.91L12.18 3.76L11.32 3.76L10.47 3.91L9.66 4.21L8.91 4.64L8.25 5.2L7.69 5.86L7.26 6.61L7.06 7.12L8.31 7.12L8.48 6.81L8.85 6.27L9.58 5.6L10.46 5.15L11.42 4.93L12.41 4.98L13.35 5.27L14.18 5.8L14.85 6.53L15.18 7.1L15.4 7.72L15.52 8.37L15.52 9.03L15.4 9.68L15.18 10.3L14.85 10.87L14.42 11.37L13.64 11.97L13.04 12.25L12.41 12.42L11.75 12.48L8.55 12.48L8.91 12.76L9.66 13.19L10.47 13.49L11.32 13.64L12.18 13.64L12.61 13.58L13.45 13.36L13.84 13.19L14.59 12.76L14.94 12.5L15.55 11.89L16.04 11.18L16.24 10.79L16.54 9.98L16.63 9.56L16.71 8.7Z",
        "fill": "#f78620"
      },
      {
        "type": "polygon",
        "d": "M6.81 8.27L6.8 8.84L7.98 8.84L8.03 8.04L6.84 8.04Z",
        "fill": "#f78620"
      },
      {
        "type": "polygon",
        "d": "M6.96 9.98L7.22 10.7L8.54 10.7L8.32 10.3L8.11 9.71L6.9 9.71Z",
        "fill": "#f78620"
      }
    ],
    "turkmenpost": [
      {
        "type": "polygon",
        "d": "M17.84 8.44L17.8 7.9L17.67 7.37L17.46 6.85L17.17 6.35L16.8 5.88L16.36 5.44L15.85 5.03L15.28 4.67L14.66 4.36L13.99 4.1L13.29 3.89L12.56 3.74L11.81 3.65L11.04 3.62L10.28 3.65L9.53 3.74L8.8 3.89L8.1 4.1L7.43 4.36L6.81 4.67L6.24 5.03L5.73 5.44L5.29 5.88L4.92 6.35L4.63 6.85L4.42 7.37L4.29 7.9L4.25 8.44L9.69 10.45L11.04 9.78L12.4 10.45Z",
        "fill": "accent"
      },
      {
        "type": "line",
        "d": "M6.27 8.44L6.39 8.04L6.58 7.65L6.82 7.28L7.13 6.94L7.49 6.62L7.9 6.33L8.36 6.09L8.85 5.88L9.37 5.71L9.91 5.59L10.48 5.52L11.04 5.5L11.61 5.52L12.18 5.59L12.72 5.71L13.24 5.88L13.73 6.09L14.19 6.33L14.6 6.62L14.96 6.94L15.27 7.28L15.51 7.65L15.7 8.04L15.82 8.44M6.27 8.44L15.82 8.44M8.79 9.32L8.79 8.73L8.84 8.16L8.96 7.61L9.14 7.1L9.37 6.64L9.64 6.24L9.96 5.92L10.3 5.69L10.67 5.54L11.04 5.5M11.04 5.5L11.42 5.54L11.79 5.69L12.13 5.92L12.45 6.24L12.72 6.64L12.95 7.1L13.13 7.61L13.25 8.16L13.3 8.73L13.3 9.32M11.04 5.5L11.04 9.32M7.65 6.37L8.18 6.63L8.78 6.9L9.38 7.1L10.06 7.26L11.04 7.3L12.03 7.26L12.71 7.1L13.31 6.9L13.91 6.63L14.44 6.37",
        "stroke": "#ffbc94",
        "strokeWidth": 0.15
      },
      {
        "type": "line",
        "d": "M4.91 7.84L4.99 7.25M4.95 7.55L5.66 7.65M5.57 6.9L5.97 7.04L6.09 7.05L6.2 7.02L6.29 6.95L6.35 6.85L6.37 6.74L6.34 6.62L6.26 6.53L6.16 6.47L5.76 6.34M6.97 6.3L6.35 5.93L6.55 5.61L6.6 5.55L6.67 5.52L6.75 5.52L6.82 5.54L6.88 5.6L6.91 5.67L6.91 5.74L6.89 5.82L6.69 6.13M6.81 5.94L7.27 5.81M7.33 5.22L7.85 5.73M7.75 4.8L7.64 5.53M7.68 5.25L8.27 5.3M9.01 5.28L8.68 4.64L9.25 4.91L9.35 4.29L9.68 4.94M10.64 4.18L10.13 4.25L10.24 4.97L10.75 4.89M10.19 4.61L10.62 4.54M11.32 4.89L11.44 4.18L11.94 5L12.06 4.29M12.57 4.9L12.9 4.26L13.19 4.41L13.25 4.46L13.29 4.54L13.3 4.62L13.28 4.69L13.23 4.76L13.16 4.8L13.08 4.81L13 4.78L12.7 4.63M14.42 5.46L14.35 5.52L14.26 5.56L14.17 5.57L14.09 5.57L14 5.54L13.93 5.49L13.88 5.42L13.85 5.34L13.84 5.25L13.86 5.16L13.89 5.07L13.95 5L14.02 4.94L14.11 4.9L14.2 4.88L14.29 4.89L14.37 4.92L14.44 4.97L14.49 5.04L14.52 5.12L14.53 5.21L14.52 5.3L14.48 5.38L14.42 5.46L14.35 5.52M15.66 6L15.68 5.91L15.67 5.81L15.63 5.73L15.57 5.66L15.49 5.62L15.41 5.6L15.31 5.6L15.23 5.64L15.13 5.7L15.06 5.75L15.01 5.83L14.98 5.92L14.98 6.01L15.01 6.1L15.07 6.17L15.14 6.22L15.23 6.25M15.02 6.11L14.91 6.24L14.71 6.17M16.3 6.16L16.51 6.72M16.4 6.44L15.73 6.69M16.07 7.19L16.83 7.34L16.85 7.46L16.2 7.87M16.32 7.24L16.41 7.74",
        "stroke": "#00d35c",
        "strokeWidth": 0.19
      },
      {
        "type": "circle",
        "cx": 5.39,
        "cy": 6.7,
        "r": 0.09,
        "fill": "#00d35c"
      },
      {
        "type": "circle",
        "cx": 5.49,
        "cy": 6.38,
        "r": 0.09,
        "fill": "#00d35c"
      },
      {
        "type": "line",
        "d": "M4.25 8.44L4.25 13.4L17.84 13.4L17.84 8.44L17.8 7.9L17.67 7.37L17.46 6.85L17.17 6.35L16.8 5.88L16.36 5.44L15.85 5.03L15.28 4.67L14.66 4.36L13.99 4.1L13.29 3.89L12.56 3.74L11.81 3.65L11.04 3.62L10.28 3.65L9.53 3.74L8.8 3.89L8.1 4.1L7.43 4.36L6.81 4.67L6.24 5.03L5.73 5.44L5.29 5.88L4.92 6.35L4.63 6.85L4.42 7.37L4.29 7.9L4.25 8.44L4.25 13.4L17.84 13.4M4.25 8.44L9.69 10.45L11.04 9.78L12.4 10.45L17.84 8.44M4.25 13.4L9.69 10.45M17.84 13.4L12.4 10.45",
        "stroke": "#0023af",
        "strokeWidth": 0.2
      }
    ],
    "usasd": [
      {
        "type": "line",
        "d": "M9.73 7.77L9.73 6.67L9.71 6.6L9.67 6.54L9.61 6.49L9.53 6.48L3.98 6.48L3.91 6.49L3.85 6.54L3.8 6.6L3.79 6.67L3.79 8.97L3.8 9.05L3.85 9.11L3.91 9.15L3.98 9.17L9.53 9.17L9.61 9.18L9.67 9.23L9.71 9.29L9.73 9.36L9.73 11.93L9.71 12L9.67 12.06L9.61 12.11L9.53 12.12L3.77 12.12L3.7 12.11L3.64 12.06L3.59 12L3.58 11.93L3.58 10.62",
        "stroke": "accent",
        "strokeWidth": 1.3
      },
      {
        "type": "polygon",
        "d": "M10.86 9.98L11.24 9.6L11.76 9.21L12.62 8.77L12.82 8.74L13.1 9.55L13.41 10.38L13.73 11.02L14.04 11.47L14.67 12.33L14.99 12.67L16.08 12.67L16.43 12.65L16.77 12.59L17.11 12.49L17.43 12.35L17.74 12.18L18.03 11.96L18.29 11.72L18.53 11.45L18.74 11.15L18.92 10.83L19.06 10.49L19.17 10.14L19.24 9.77L19.28 9.4L19.27 9.03L19.23 8.66L19.15 8.29L19.04 7.94L18.89 7.61L18.7 7.29L18.49 7L17.86 6.84L17.23 6.74L16.58 6.7L15.94 6.71L15.3 6.78L14.67 6.9L14.05 7.08L13.45 7.31L12.87 7.59L12.32 7.92L11.8 8.29L11.31 8.71L10.86 9.17Z",
        "fill": "accent"
      },
      {
        "type": "polygon",
        "d": "M10.86 10.22L12.04 10.31L12.46 10.9L12.93 11.33L13.51 11.7L13.9 11.85L14.16 12.11L14.37 12.39L14.63 12.67L10.86 12.67Z",
        "fill": "accent"
      },
      {
        "type": "polygon",
        "d": "M14.16 8.23L15.02 7.91L16.7 7.52L17.76 7.48L18.52 7.53L18.69 7.82L18.15 8.4L17.96 8.52L17.93 9.16L17.66 10.16L17.14 10.96L16.67 11.39L16.62 11.87L16.5 12.26L16.33 12.43L16.18 12.43L15.62 11.87L15.23 11.22L14.84 10.42L14.58 9.79L14.19 8.62Z",
        "fill": "truck"
      },
      {
        "type": "polygon",
        "d": "M10.86 5.83L14.06 5.83L13.18 6.24L12.53 6.77L12.13 7.29L11.82 7.98L11.07 8.72L10.86 8.87Z",
        "fill": "#4cc6e0"
      },
      {
        "type": "polygon",
        "d": "M15.53 5.83L16.08 5.83L16.44 5.85L16.79 5.92L17.13 6.02L17.47 6.17L17.78 6.35L18.07 6.57L18.34 6.83L17.93 6.83L17.78 6.62L17.23 6.48L16.7 6.4L16.1 6.1Z",
        "fill": "#4cc6e0"
      },
      {
        "type": "circle",
        "cx": 17.95,
        "cy": 7.93,
        "r": 0.22,
        "fill": "accent"
      },
      {
        "type": "circle",
        "cx": 11.71,
        "cy": 9.91,
        "r": 0.22,
        "fill": "accent"
      },
      {
        "type": "circle",
        "cx": 16.25,
        "cy": 11.74,
        "r": 0.17,
        "fill": "accent"
      }
    ],
    "v-xpress": [
      {
        "type": "polygon",
        "d": "M10.5 13.26L8.77 13.26L8.79 12.64L8.99 11.36L9.42 10.08L10.05 8.89L10.91 7.74L11.6 7.03L12.44 6.35L13.29 5.8L14.2 5.33L15.17 4.95L16.19 4.66L17.25 4.48L18.27 4.4L17.5 4.47L16.75 4.62L16.03 4.85L15.27 5.17L14.61 5.54L13.93 6.01L13.35 6.5L12.77 7.11L12.24 7.77L11.81 8.42L11.4 9.19L11.09 9.92L10.82 10.77L10.64 11.58L10.54 12.41Z",
        "fill": "#faa61a"
      },
      {
        "type": "polygon",
        "d": "M12.46 13.26L10.87 13.26L10.96 11.88L11.25 10.49L11.73 9.2L12.41 7.95L12.95 7.2L13.57 6.52L14.25 5.93L14.98 5.42L15.76 5.01L16.58 4.69L17.45 4.49L18.27 4.4L17.68 4.49L17.12 4.65L16.57 4.88L16.05 5.18L15.56 5.55L15.04 6.03L14.6 6.53L14.15 7.14L13.75 7.82L13.43 8.48L13.12 9.25L12.89 10L12.57 11.58Z",
        "fill": "#faa61a"
      },
      {
        "type": "polygon",
        "d": "M3.7 4.62L7.42 4.62L12.46 13.36L8.75 13.36Z",
        "fill": "accent"
      }
    ],
    "world-package": [
      {
        "type": "polygon",
        "d": "M13.89 9.52L9.73 13.67L9.54 13.8L9.3 13.84L9.12 13.8L8.92 13.67L4.77 9.52L4.64 9.33L4.6 9.1L4.64 8.91L4.77 8.71L8.92 4.57L9.12 4.44L9.35 4.4L9.58 4.46L9.73 4.57L13.92 8.75L14.01 8.91L14.05 9.14L14.01 9.33Z",
        "fill": "accent"
      },
      {
        "type": "polygon",
        "d": "M17.57 9.52L13.38 13.7L13.22 13.8L13.03 13.84L12.84 13.82L12.64 13.7L12.09 13.16L15.73 9.52L15.85 9.33L15.89 9.1L15.85 8.91L15.73 8.71L12.09 5.08L12.64 4.54L12.8 4.44L13.08 4.4L13.38 4.54L17.6 8.75L17.7 8.91L17.73 9.14L17.7 9.33Z",
        "fill": "#dd0035"
      }
    ],
    "xd-express": [
      {
        "type": "polygon",
        "d": "M5.49 9.14L5.43 9.14L5.45 9.08L5.74 8.7L6.22 8.23L6.71 7.83L7.57 7.25L9.08 6.44L9.76 5.95L10.07 5.67L10.54 5.15L10.84 4.68L11.04 4.22L11.19 3.62L11.65 3.91L12.09 4.11L12.99 4.41L13.74 4.59L14.79 4.8L16.09 4.99L17.35 5.12L17.48 5.16L15.16 5.41L13.86 5.6L11.99 5.99L10.22 6.48L8.67 7.06L7.31 7.74L6.15 8.53Z",
        "fill": "#e60012"
      },
      {
        "type": "polygon",
        "d": "M9.25 13.24L7.87 13.24L7.7 13.18L6.85 13.03L6.25 12.84L5.79 12.64L5.35 12.3L5.09 12L4.86 11.57L4.86 10.76L5.08 10.19L5.45 9.52L5.69 9.19L6.12 8.74L6.92 8.12L8.14 7.46L9.57 6.87L10.8 6.48L12.33 6.12L14.08 5.8L15.58 5.6L17.23 5.46L17.42 5.48L17.32 5.55L16.42 5.79L15.22 6.18L14.35 6.5L12.96 7.07L11.73 7.65L10.78 8.15L9.42 8.96L9.33 8.96L9.28 8.9L9.48 8.39L9.49 8.05L9.42 7.94L9.3 7.85L9.01 7.8L8.72 7.84L8.29 7.95L7.8 8.15L7.16 8.53L6.59 9.01L6.17 9.46L5.82 9.97L5.64 10.35L5.55 10.69L5.52 11.06L5.58 11.42L5.64 11.61L5.9 12L5.95 12.14L6.37 12.32L6.54 12.48L6.73 12.47L7.22 12.59L7.41 12.85L8.14 13.04L9.06 13.18Z",
        "fill": "accent"
      },
      {
        "type": "line",
        "d": "M8.27 9.13L9.14 12.72M10.64 9.13L6.76 12.72M11.66 9.59L13 9.59L13.32 9.64L13.59 9.77L13.78 9.98L13.87 10.26L13.87 10.58L13.77 10.92L13.58 11.27L13.31 11.59L12.98 11.87L12.62 12.08L12.24 12.21L11.88 12.26L10.54 12.26L11.86 9.13",
        "stroke": "accent",
        "strokeWidth": 0.92
      }
    ],
    "xlmiles": [
      {
        "type": "polygon",
        "d": "M6.39 11.14L7.77 7.22L7.12 10.5L11.65 9.43L11.56 9.9L16.11 8.9L15.98 9.3L19.34 8.43L14.79 10.08L15.05 9.62L10.12 10.82L10.18 10.23Z",
        "fill": "#fcb827"
      },
      {
        "type": "polygon",
        "d": "M4.02 9.69L3.25 8.49L4.75 8.17L4.94 8.55Z",
        "fill": "#fcb827"
      },
      {
        "type": "polygon",
        "d": "M2.61 11.98L4.03 10.02L4.53 10.96L4.07 11.63Z",
        "fill": "#fcb827"
      },
      {
        "type": "polygon",
        "d": "M4.94 11.43L4.12 9.86L5.62 7.95L7.33 7.47L5.69 9.59L6.22 11.13Z",
        "fill": "accent"
      },
      {
        "type": "line",
        "d": "M8.27 8.3L7.92 10.04M9.43 8.04L9.08 9.77M10.59 7.77L10.24 9.51M7.97 9.79L9.38 8.28M9.13 9.53L10.54 8.02M11.3 9.28L11.67 7.56M12.3 9.53L12.87 6.83M13.32 8.46L14.85 8.11L14.97 7.47L13.45 7.81L13.19 9.1L14.72 8.76L14.78 8.45M17.1 7.26L17.15 6.98L15.66 7.32L15.55 7.96L17.03 7.62L16.91 8.29L15.42 8.63L15.47 8.36",
        "stroke": "accent",
        "strokeWidth": 0.41
      },
      {
        "type": "polygon",
        "d": "M11.39 7.21L11.43 6.8L12.23 6.61L12.14 7.05Z",
        "fill": "accent"
      }
    ],
    "yoseus": [
      {
        "type": "line",
        "d": "M3.42 6.84L4.32 9.21M5.21 6.84L4.32 9.21L4.32 11.93M7.98 7.93L7.92 7.63L7.75 7.38L7.5 7.21L7.2 7.15L6.9 7.21L6.64 7.38L6.47 7.63L6.42 7.93L6.42 10.67L6.47 10.97L6.64 11.22L6.9 11.39L7.2 11.45L7.5 11.39L7.75 11.22L7.92 10.97L7.98 10.67L7.98 7.93L7.92 7.63M10.64 7.61L10.53 7.41L10.39 7.26L10.22 7.17L10.05 7.15L9.89 7.21L9.73 7.32L9.6 7.5L9.51 7.73L9.45 7.99L9.43 8.26L9.46 8.53L9.53 8.78L9.63 9L9.77 9.16L9.93 9.26L10.1 9.3L10.27 9.34L10.42 9.44L10.56 9.6L10.67 9.82L10.74 10.07L10.76 10.34L10.75 10.61L10.69 10.87L10.59 11.1L10.46 11.28L10.31 11.39L10.14 11.45L9.97 11.43L9.81 11.34L9.67 11.19L9.55 10.99M13.37 7.15L12.22 7.15L12.22 11.45L13.37 11.45M12.22 9.3L13.19 9.3M14.34 6.68L14.34 10.74L14.36 10.92L14.44 11.09L14.55 11.24L14.7 11.35L14.87 11.43L15.05 11.45L15.24 11.43L15.41 11.35L15.56 11.24L15.67 11.09L15.74 10.92L15.77 10.74L15.77 6.68M18.43 7.61L18.32 7.41L18.17 7.26L18.01 7.17L17.84 7.15L17.67 7.21L17.52 7.32L17.39 7.5L17.29 7.73L17.23 7.99L17.22 8.26L17.24 8.53L17.31 8.78L17.42 9L17.56 9.16L17.72 9.26L17.88 9.3L18.05 9.34L18.21 9.44L18.35 9.6L18.45 9.82L18.52 10.07L18.55 10.34L18.53 10.61L18.48 10.87L18.38 11.1L18.25 11.28L18.1 11.39L17.93 11.45L17.76 11.43L17.6 11.34L17.45 11.19L17.34 10.99",
        "stroke": "accent",
        "strokeWidth": 0.95
      }
    ],
    "yuema-express": [
      {
        "type": "polygon",
        "d": "M15.42 6.97L14.27 6.97L9.66 10.19L9.3 11.25Z",
        "fill": "accent"
      },
      {
        "type": "polygon",
        "d": "M17.62 6.97L16.47 6.97L8.96 12.22L8.6 13.28Z",
        "fill": "accent"
      },
      {
        "type": "polygon",
        "d": "M12.37 11.38L12.92 11.8L14.6 10.62L14.38 9.97Z",
        "fill": "accent"
      },
      {
        "type": "polygon",
        "d": "M13.42 12.18L13.96 12.6L15.02 11.86L14.81 11.21Z",
        "fill": "accent"
      },
      {
        "type": "polygon",
        "d": "M14.46 12.99L15.74 13.96L15.23 12.45Z",
        "fill": "accent"
      },
      {
        "type": "polygon",
        "d": "M5.33 7.92L5.37 7.96L5.49 7.99L5.75 7.93L6.84 7.42L7.83 6.8L9.85 5.33L10.19 5.12L10.93 4.79L11.48 4.64L12.24 4.59L12.93 4.6L13.84 4.87L13.92 4.88L13.97 4.84L13.97 4.73L13.81 4.56L13.44 4.31L13.01 4.1L12.7 4.02L11.98 3.97L11.46 4L10.95 4.09L10.48 4.22L9.88 4.49L9.41 4.77L7.77 6.2L6.82 6.98L6.13 7.43L5.68 7.68L5.36 7.82Z",
        "fill": "#132f57"
      },
      {
        "type": "polygon",
        "d": "M15.54 6.17L15.64 6.14L15.76 6.02L15.84 5.87L15.87 5.68L15.84 5.51L15.74 5.35L15.62 5.25L15.49 5.21L14.95 5.22L14.49 5.36L13.7 5.76L13.56 5.85L13.49 5.96L13.71 5.98L14.61 5.72L15.04 5.7L15.22 5.74L15.34 5.83L15.46 6.11Z",
        "fill": "#132f57"
      },
      {
        "type": "polygon",
        "d": "M12.34 5.86L12.66 5.83L12.83 5.74L13.1 5.5L13.18 5.37L13.16 5.3L12.96 5.24L12.4 5.24L12.04 5.32L11.76 5.45L11.73 5.55L11.79 5.65L12.03 5.79Z",
        "fill": "#132f57"
      },
      {
        "type": "polygon",
        "d": "M9.34 8.57L9.01 8.71L8.91 8.85L8.9 9L9.02 9.19L9.24 9.35L9.43 9.41L9.64 9.43L10.17 9.15L11.1 8.51L11.9 7.9L11.91 7.81L11.83 7.7L11.54 7.59L10.92 7.63L8.77 8.01L7.89 8.11L7.41 8.26L7.25 8.41L7.26 8.5L7.41 8.64L7.83 8.78L8.2 8.77L8.96 8.58Z",
        "fill": "#132f57"
      }
    ],
    "tuodatong": [
      {
        "type": "polygon",
        "d": "M14.13 13.29L14.87 13.18L15.68 12.83L16.26 12.41L16.87 11.78L17.39 10.97L17.67 10.25L17.9 9.38L17.91 8.48L17.65 7.49L17.24 6.61L16.83 6.01L16.13 5.33L15.55 4.92L14.59 4.51L13.65 4.3L12.67 4.32L11.75 4.54L10.87 4.94L10.16 5.44L9.53 6.11L9 6.98L8.74 7.69L8.52 8.76L8.58 9.57L8.85 10.6L8.95 10.83L9.05 10.86L9.07 10.74L8.95 9.99L8.95 9.39L9.11 8.5L9.29 7.91L9.65 7.22L10.08 6.63L10.61 6.11L11.38 5.61L11.49 5.44L11.68 5.47L11.88 5.31L12.05 5.32L12.49 5.2L13.52 5.17L13.86 5.22L14.54 5.42L15.27 5.83L15.83 6.35L16.22 6.94L16.49 7.61L16.62 8.22L16.63 9.21L16.52 9.75L16.25 10.45L15.95 10.9L15.55 11.34L15.11 11.65L14.48 11.91L14.12 11.97L13.7 11.97L13.42 11.88L13.15 11.62L12.97 11.16L13.05 10.71L13.29 10.32L15.08 8.76L15.46 8.27L15.67 7.74L15.7 7.35L15.6 6.89L15.47 6.76L15.32 6.71L15.14 6.74L14.95 6.87L12.25 9.18L11.74 9.86L11.59 10.24L11.49 10.69L11.49 11.15L11.61 11.78L11.87 12.27L12.11 12.56L12.57 12.93L13.09 13.17L13.5 13.26Z",
        "fill": "#2a7bfa"
      },
      {
        "type": "polygon",
        "d": "M14.52 13.25L15.19 13.07L15.68 12.83L16.26 12.41L16.87 11.78L17.39 10.97L17.67 10.25L17.9 9.38L17.91 8.48L17.62 7.42L17.56 7.77L17.68 8.24L17.66 8.92L17.53 9.46L17.3 10.09L16.71 10.99L16.43 11.28L15.76 11.77L15.52 11.89L14.65 12.16L13.99 12.14L13.28 11.77L13.04 11.42L12.97 11.16L13.05 10.71L13.29 10.32L15.08 8.76L15.46 8.27L15.67 7.74L15.7 7.35L15.6 6.89L15.47 6.76L15.32 6.71L15.14 6.74L14.95 6.87L12.25 9.18L11.74 9.86L11.59 10.24L11.49 10.69L11.49 11.15L11.61 11.78L11.87 12.27L12.36 12.79L13.09 13.17L13.5 13.26L14.13 13.29Z",
        "fill": "accent"
      },
      {
        "type": "polygon",
        "d": "M8.57 9.34L8.58 9.57L8.85 10.6L8.95 10.83L9.05 10.86L9.07 10.74L8.95 9.99L8.95 9.39L9.11 8.5L9.29 7.91L9.65 7.22L10.08 6.63L10.61 6.11L11.42 5.54L10.82 5.8L10.25 6.18L9.57 6.86L9.28 7.3L8.92 8.01L8.74 8.68L8.69 9.07Z",
        "fill": "#ffab00"
      },
      {
        "type": "polygon",
        "d": "M10.36 13.3L10.5 13.23L10.58 13.07L12.19 7.46L12.37 6.79L12.35 6.69L12.27 6.63L10.67 6.63L10.49 6.76L8.61 13.11L8.63 13.24L8.74 13.29Z",
        "fill": "#ffab00"
      }
    ],
    "utec-logistics": [
      {
        "type": "line",
        "d": "M3.25 7.43L3.25 10.66L3.29 10.84L3.38 10.98L3.53 11.08L3.7 11.11L5.28 11.11L5.46 11.08L5.6 10.98L5.7 10.84L5.73 10.66L5.73 9.04M5.38 7.89L11 7.89M7.19 7.89L7.19 11.57M10.87 9.54L8.71 9.54L8.71 11.11L11 11.11M14.67 7.89L12.38 7.89L12.15 7.93L11.96 8.06L11.83 8.26L11.78 8.49L11.78 10.51L11.83 10.74L11.96 10.94L12.15 11.07L12.38 11.11L14.67 11.11",
        "stroke": "accent",
        "strokeWidth": 0.8
      },
      {
        "type": "polygon",
        "d": "M15.16 7.43L17.48 7.43L19.1 9.5L17.53 11.57L15.16 11.57L16.67 9.5Z",
        "fill": "#01a2d9"
      }
    ],
    "dex-i": [
      {
        "type": "polygon",
        "d": "M17.23 10.49L17.8 10.32L18.28 10.16L18.65 9.99L18.92 9.83L19.06 9.68L19.09 9.61L19.1 9.53L19.07 9.47L19.01 9.4L18.81 9.28L18.5 9.18L18.08 9.09L17.56 9.03L16.94 8.98L15.47 8.94L13.73 8.98L11.84 9.1L9.9 9.29L8.03 9.54L6.31 9.84L4.88 10.16L4.29 10.33L3.79 10.5L3.4 10.67L3.11 10.83L2.95 10.98L2.9 11.06L2.89 11.13L2.93 11.23L3.02 11.32L3.17 11.4L3.39 11.48L3.97 11.6L4.77 11.69L4.77 11.67L4.14 11.57L3.8 11.47L3.67 11.41L3.59 11.34L3.55 11.27L3.56 11.19L3.6 11.11L3.7 11.02L4.02 10.83L4.52 10.64L5.17 10.45L5.97 10.25L6.9 10.07L7.93 9.89L9.03 9.73L10.18 9.59L11.36 9.47L12.52 9.38L13.65 9.32L15.13 9.28L16.41 9.3L17.41 9.38L17.8 9.45L18.1 9.53L18.31 9.61L18.43 9.71L18.45 9.82L18.39 9.94L18.24 10.06L18.02 10.19L17.67 10.33L17.22 10.48Z",
        "fill": "accent"
      },
      {
        "type": "line",
        "d": "M5.96 11.87L5.96 8.37L7.76 8.37L8.1 8.4L8.43 8.5L8.73 8.66L9 8.88L9.22 9.14L9.38 9.45L9.48 9.78L9.51 10.12L9.48 10.46L9.38 10.79L9.22 11.09L9 11.36L8.73 11.58L8.43 11.74L8.1 11.84L7.76 11.87L5.96 11.87L5.96 8.37M13.14 8.37L11.54 8.37L11.2 8.4L10.87 8.5L10.57 8.66L10.3 8.88L10.09 9.14L9.92 9.45L9.83 9.78L9.79 10.12L9.83 10.46L9.92 10.79L10.09 11.09L10.3 11.36L10.57 11.58L10.87 11.74L11.2 11.84L11.54 11.87L13.14 11.87M9.79 10.22L13.14 10.22M13.36 8.37L14.44 8.37L14.57 8.38L14.69 8.43L14.79 8.51L14.87 8.61L14.92 8.73L14.93 8.86L14.93 11.38L14.92 11.51L14.87 11.63L14.79 11.73L14.69 11.81L14.57 11.86L14.44 11.87L13.36 11.87M17.08 8.37L16 8.37L15.87 8.38L15.75 8.43L15.65 8.51L15.57 8.61L15.52 8.73L15.51 8.86L15.51 11.38L15.52 11.51L15.57 11.63L15.65 11.73L15.75 11.81L15.87 11.86L16 11.87L17.08 11.87",
        "stroke": "accent",
        "strokeWidth": 0.84
      },
      {
        "type": "circle",
        "cx": 17.7,
        "cy": 7.31,
        "r": 0.6,
        "fill": "#f15c21"
      }
    ],
    "jy-express": [
      {
        "type": "polygon",
        "d": "M6.98 8.59L6.43 8.4L6.24 8.6L5.26 8.55L5.26 8.12L5.3 7.69L5.39 7.22L5.53 6.76L5.75 6.23L6.04 5.74L6.37 5.32L6.74 4.93L7.17 4.58L7.64 4.28L8.14 4.04L8.66 3.87L9.07 3.77L9.49 3.72L9.91 3.7L10.34 3.72L10.75 3.78L11.16 3.88L11.55 4.01L11.94 4.18L12.32 4.39L12.68 4.64L13 4.91L13.3 5.2L13.58 5.54L13.83 5.9L14.18 6.59L14.22 6.69L13.85 6.67L13.65 6.3L13.34 6.33L12.83 5.12L12.48 4.89L12.46 5.04L12.68 5.13L12.76 5.35L12.41 5.23L11.86 4.42L11.66 4.37L11.62 4.49L12.52 5.52L12.65 5.78L12.56 5.91L12.17 5.62L11.55 5.47L10.96 4.76L10.34 4.68L9.99 4.46L9.59 4.53L9.28 4.3L8.81 4.77L9.01 5.14L9.17 5.27L9.83 5.23L10.08 5.43L10.49 6.17L10.45 6.44L10.13 6.44L10.29 6.6L10.26 6.76L9.99 6.7L9.79 6.21L9.88 5.98L9.7 5.66L9.73 5.98L9.48 6.29L9.55 6.64L9.91 6.82L10.22 6.81L10.69 7.19L10.69 7.36L10.57 7.45L10.18 7.34L10.14 7.44L10.38 7.62L10.28 7.77L9.91 7.93L9.75 7.75L9.13 8.22L8.74 8.03L7.99 8.24L7.45 7.99Z",
        "fill": "accent"
      },
      {
        "type": "line",
        "d": "M3.54 8.95L3.54 10.89L3.52 11L3.46 11.1L3.36 11.16L3.24 11.19L2.9 11.19M4.29 9L4.75 10.14L4.75 11.44M5.52 10.19L6.45 10.19M8.05 9.2L7.18 9.2L7.1 9.22L7.03 9.26L6.99 9.32L6.98 9.4L6.98 10.99L6.99 11.06L7.03 11.13L7.1 11.17L7.18 11.19L8.05 11.19M6.98 10.19L8 10.19M8.67 8.95L9.62 11.44M9.62 8.95L8.67 11.44M10.45 11.44L10.45 9.2L10.94 9.2L11.15 9.23L11.34 9.33L11.5 9.48L11.59 9.68L11.63 9.89L11.59 10.1L11.5 10.29L11.34 10.45L11.15 10.54L10.94 10.58L10.45 10.58M12.48 11.44L12.48 9.2L13.21 9.2L13.36 9.22L13.5 9.29L13.6 9.4L13.67 9.54L13.7 9.69L13.67 9.84L13.6 9.97L13.5 10.08L13.36 10.15L13.21 10.17L12.48 10.17M13.03 10.17L13.77 11.44M15.63 9.2L14.75 9.2L14.67 9.22L14.61 9.26L14.56 9.32L14.55 9.4L14.55 10.99L14.56 11.06L14.61 11.13L14.67 11.17L14.75 11.19L15.63 11.19M14.55 10.19L15.58 10.19M17.06 9.43L16.84 9.2L16.54 9.2L16.32 9.43L16.27 9.77L16.42 10.07L16.69 10.19L16.98 10.31L17.13 10.62L17.08 10.96L16.85 11.19L16.54 11.19L16.31 10.96M18.78 9.43L18.57 9.2L18.29 9.2L18.07 9.43L18.02 9.77L18.17 10.07L18.43 10.19L18.7 10.31L18.85 10.62L18.8 10.96L18.58 11.19L18.28 11.19L18.06 10.96",
        "stroke": "accent",
        "strokeWidth": 0.5
      },
      {
        "type": "polygon",
        "d": "M4.83 8.95L5.52 8.95L5.16 9.96Z",
        "fill": "#e67817"
      },
      {
        "type": "polygon",
        "d": "M6.23 11.84L6.55 12.21L6.92 12.56L7.34 12.86L7.78 13.12L8.25 13.33L8.73 13.48L9.24 13.58L9.75 13.63L10.26 13.61L10.76 13.55L11.26 13.42L11.74 13.24L12.2 13.01L12.63 12.73L13.02 12.41L13.38 12.04L12.73 12.53L11.99 12.9L11.22 13.1L10.39 13.16L9.57 13.05L8.79 12.79L8.07 12.38L7.44 11.83Z",
        "fill": "#e67817"
      }
    ],
    "citilogistics": [
      {
        "type": "line",
        "d": "M9.64 5.51L9.53 5.38L9.37 5.3L9.19 5.28L9.01 5.31L8.83 5.4L8.68 5.53L8.57 5.7L8.51 5.88L8.22 7.68L8.22 7.86L8.28 8.03L8.39 8.16L8.54 8.25L8.71 8.28L8.9 8.26L9.08 8.18L9.24 8.05M10.68 4.91L10.08 8.65M11.32 5.28L12.57 5.28M11.95 5.28L11.41 8.65M13.35 4.91L12.75 8.65M3.87 9.75L3.33 13.12L4.28 13.12M6.5 10.77L6.49 10.52L6.38 10.31L6.19 10.17L5.95 10.12L5.69 10.17L5.46 10.31L5.28 10.52L5.2 10.77L4.92 12.47L4.93 12.72L5.04 12.93L5.23 13.07L5.47 13.12L5.73 13.07L5.96 12.93L6.13 12.72L6.22 12.47L6.5 10.77L6.49 10.52M8.75 10.37L8.63 10.23L8.46 10.15L8.27 10.12L8.06 10.16L7.87 10.25L7.71 10.39L7.59 10.57L7.53 10.77L7.26 12.72L7.37 12.93L7.56 13.07L7.8 13.12L8.06 13.07L8.29 12.93L8.46 12.72L8.55 12.47L8.67 11.77L8.02 11.77M10.02 9.75L9.42 13.49M11.96 10.46L11.73 10.12L11.36 10.12L11.02 10.46L10.87 10.98L10.99 11.44L11.31 11.62L11.64 11.8L11.76 12.26L11.61 12.78L11.26 13.12L10.87 13.12L10.63 12.78M12.55 10.12L13.8 10.12M13.18 10.12L12.64 13.49M14.58 9.75L13.98 13.49M16.59 10.35L16.47 10.22L16.32 10.14L16.14 10.12L15.95 10.15L15.77 10.24L15.62 10.37L15.51 10.54L15.46 10.72L15.17 12.52L15.17 12.7L15.22 12.87L15.33 13L15.48 13.09L15.66 13.12L15.85 13.1L16.03 13.02L16.18 12.89M18.36 10.46L18.13 10.12L17.75 10.12L17.41 10.46L17.26 10.98L17.38 11.44L17.71 11.62L18.03 11.8L18.16 12.26L18.01 12.78L17.66 13.12L17.27 13.12L17.03 12.78",
        "stroke": "accent",
        "strokeWidth": 0.74
      }
    ],
    "comone-express": [
      {
        "type": "line",
        "d": "M4.85 5.58L4.71 5.44L4.52 5.35L4.31 5.33L4.09 5.37L3.89 5.47L3.72 5.63L3.59 5.82L3.53 6.04L3.28 7.87L3.28 8.08L3.35 8.27L3.47 8.43L3.65 8.53L3.86 8.57L4.07 8.55L4.28 8.46L4.47 8.32M7.17 6.12L7.15 5.82L7.02 5.56L6.78 5.39L6.48 5.33L6.17 5.39L5.89 5.56L5.68 5.82L5.57 6.12L5.34 7.78L5.36 8.08L5.5 8.34L5.73 8.51L6.03 8.57L6.34 8.51L6.63 8.34L6.84 8.08L6.94 7.78L7.17 6.12L7.15 5.82M7.92 8.95L8.43 5.33L8.73 5.33L8.98 7.76L9.38 7.76L10.33 5.33L10.63 5.33L10.12 8.95",
        "stroke": "accent",
        "strokeWidth": 0.75
      },
      {
        "type": "line",
        "d": "M13.26 6.12L13.24 5.82L13.1 5.56L12.86 5.39L12.57 5.33L12.25 5.39L11.97 5.56L11.76 5.82L11.66 6.12L11.42 7.78L11.44 8.08L11.58 8.34L11.81 8.51L12.11 8.57L12.43 8.51L12.71 8.34L12.92 8.08L13.02 7.78L13.26 6.12L13.24 5.82M14 8.95L14.51 5.33L14.81 5.33L15.45 8.57L15.75 8.57L16.26 4.95M18.65 5.33L17.35 5.33L16.89 8.57L18.19 8.57M17.12 6.95L18.23 6.95",
        "stroke": "#ee9827",
        "strokeWidth": 0.75
      },
      {
        "type": "polygon",
        "d": "M10.46 9.95L19.03 9.95L18.68 12.6L10.11 12.6Z",
        "fill": "accent"
      },
      {
        "type": "line",
        "d": "M11.84 10.52L11.28 10.52L11.09 12.02L11.64 12.02M11.18 11.27L11.66 11.27M12.22 10.42L12.7 12.13M12.92 10.42L11.99 12.13M13.22 12.19L13.44 10.52L13.67 10.52L13.82 10.55L13.93 10.64L14 10.77L14.01 10.91L13.96 11.06L13.86 11.19L13.72 11.28L13.57 11.3L13.34 11.3M14.39 12.19L14.61 10.52L14.84 10.52L14.99 10.55L15.1 10.64L15.17 10.77L15.18 10.91L15.13 11.06L15.03 11.19L14.89 11.28L14.74 11.3L14.51 11.3M14.76 11.3L15.07 12.12M16.36 10.52L15.8 10.52L15.61 12.02L16.16 12.02M15.7 11.27L16.18 11.27M17.28 10.7L17.14 10.52L16.92 10.52L16.74 10.7L16.67 10.96L16.75 11.18L16.94 11.27L17.13 11.37L17.21 11.59L17.14 11.85L16.95 12.02L16.73 12.02L16.58 11.85M18.31 10.7L18.18 10.52L17.96 10.52L17.78 10.7L17.71 10.96L17.79 11.18L17.97 11.27L18.16 11.37L18.25 11.59L18.17 11.85L17.98 12.02L17.76 12.02L17.62 11.85",
        "stroke": "truck",
        "strokeWidth": 0.34
      },
      {
        "type": "polygon",
        "d": "M5.83 9.95L10.16 9.95L10.05 10.78L8.19 10.47Z",
        "fill": "accent"
      },
      {
        "type": "polygon",
        "d": "M7.29 10.94L10.03 10.94L9.95 11.54L8.87 11.34Z",
        "fill": "accent"
      },
      {
        "type": "polygon",
        "d": "M7.92 11.84L9.91 11.84L9.81 12.6L9.11 12.32Z",
        "fill": "accent"
      }
    ],
    "arrow-express": [
      {
        "type": "polygon",
        "d": "M3.65 8.55L2.94 8.55L2.91 8.55L2.9 8.52L3.33 7.73L3.59 7.3L3.9 6.82L4.31 6.27L4.66 5.87L4.99 5.54L5.24 5.3L5.68 4.97L6.06 4.73L6.47 4.54L6.82 4.42L7.21 4.33L7.57 4.3L7.84 4.3L8.15 4.33L8.56 4.42L9.02 4.58L9.46 4.79L9.84 5.01L11.34 6.01L11.94 6.37L12.63 6.69L13.09 6.85L13.33 6.91L13.82 6.98L14.24 6.98L14.62 6.93L14.9 6.85L15.2 6.73L15.67 6.47L15.92 6.29L15.95 6.29L15.69 6.57L15.43 6.8L15.13 7.01L14.75 7.2L14.37 7.32L14.07 7.37L13.6 7.38L13.35 7.36L12.87 7.29L12.58 7.22L12.24 7.11L11.82 6.95L11.08 6.6L9.72 5.87L9.33 5.7L8.97 5.57L8.49 5.44L8.12 5.4L7.59 5.4L7.34 5.43L7.04 5.49L6.71 5.6L6.27 5.8L5.78 6.09L5.36 6.42L4.93 6.82L4.48 7.34L4.06 7.91Z",
        "fill": "accent"
      },
      {
        "type": "polygon",
        "d": "M16.83 9.36L16.81 9.32L16.81 7.52L16.79 7.46L16.46 7.78L16.04 8.12L15.53 8.44L15.2 8.6L14.84 8.72L14.49 8.79L14.11 8.82L13.64 8.8L13.04 8.7L12.62 8.57L12.21 8.4L11.45 8.01L10.03 7.2L9.42 6.91L9.03 6.77L8.69 6.67L8.17 6.59L7.7 6.59L7.27 6.65L6.93 6.74L6.43 6.93L5.99 7.15L5.57 7.42L5.27 7.63L4.94 7.91L4.51 8.3L4.48 8.3L4.83 7.81L5.32 7.23L5.74 6.83L6.1 6.53L6.52 6.27L6.94 6.08L7.39 5.94L7.87 5.89L8.22 5.89L8.61 5.93L9 6.02L9.33 6.14L9.96 6.43L11.48 7.28L12.1 7.56L12.65 7.75L13.14 7.88L13.7 7.93L14.09 7.92L14.48 7.86L14.74 7.79L15.02 7.68L15.25 7.57L15.53 7.39L15.95 7.04L16.3 6.65L16.26 6.58L15.97 6.26L14.86 5.06L14.81 5L14.81 4.97L19.05 4.96L19.1 4.98L19.07 5.06Z",
        "fill": "#cab274"
      },
      {
        "type": "line",
        "d": "M3.22 11.02L3.29 10.86L3.39 10.74L3.51 10.65L3.64 10.61L3.78 10.61L3.91 10.67L4.03 10.77L4.12 10.9L4.17 11.06L4.19 11.23L4.19 12.64M4.19 11.48L3.61 11.48L3.48 11.5L3.37 11.56L3.27 11.66L3.21 11.78L3.19 11.92L3.21 12.05L3.27 12.17L3.37 12.27L3.48 12.33L3.61 12.35L3.79 12.35L3.95 12.32L4.08 12.23L4.16 12.08L4.19 11.92M5.01 10.31L5.01 12.64M5.01 11.48L5.03 11.25L5.08 11.04L5.15 10.86L5.25 10.72L5.36 10.63L5.48 10.6L5.63 10.6M6.16 10.31L6.16 12.64M6.16 11.48L6.18 11.25L6.23 11.04L6.3 10.86L6.4 10.72L6.51 10.63L6.63 10.6L6.78 10.6M8.37 11.48L8.35 11.71L8.29 11.92L8.2 12.1L8.08 12.24L7.94 12.32L7.79 12.35L7.64 12.32L7.5 12.24L7.38 12.1L7.29 11.92L7.24 11.71L7.22 11.48L7.24 11.25L7.29 11.04L7.38 10.86L7.5 10.72L7.64 10.63L7.79 10.6L7.94 10.63L8.08 10.72L8.2 10.86L8.29 11.04L8.35 11.25L8.37 11.48L8.35 11.71M9.03 10.36L9.37 12.35L9.67 12.35L9.84 10.81L10.09 10.81L10.27 12.35L10.57 12.35L10.91 10.36",
        "stroke": "accent",
        "strokeWidth": 0.58
      },
      {
        "type": "line",
        "d": "M12.71 10.14L12.2 10.14L11.68 12.49L12.19 12.49M11.94 11.32L12.37 11.32M13.06 10.03L13.15 12.61M13.72 10.03L12.5 12.61M13.62 12.64L14.17 10.14L14.4 10.19L14.57 10.32L14.66 10.52L14.65 10.76L14.55 10.99L14.38 11.19L14.15 11.32L13.9 11.37M14.72 12.64L15.27 10.14L15.49 10.19L15.66 10.32L15.75 10.52L15.75 10.76L15.65 10.99L15.47 11.19L15.24 11.32L15 11.37M15.24 11.37L15.36 12.6M16.89 10.14L16.38 10.14L15.86 12.49L16.37 12.49M16.12 11.32L16.55 11.32M17.7 10.41L17.6 10.14L17.4 10.14L17.18 10.41L17.06 10.82L17.08 11.18L17.24 11.32L17.41 11.46L17.44 11.82L17.31 12.22L17.09 12.49L16.88 12.49L16.78 12.22M18.69 10.41L18.6 10.14L18.39 10.14L18.18 10.41L18.05 10.82L18.08 11.18L18.24 11.32L18.4 11.46L18.43 11.82L18.31 12.22L18.08 12.49L17.87 12.49L17.77 12.22",
        "stroke": "#cab274",
        "strokeWidth": 0.3
      }
    ],
    "geswl": [
      {
        "type": "line",
        "d": "M6.3 7.44L6.72 6.72L4.82 6.72L3.42 9.12L5.33 9.12L6.12 7.74M6.98 7.9L8.89 7.9L9.57 6.72L7.67 6.72L6.27 9.12L8.18 9.12L8.52 8.53M12.16 7.29L12.49 6.72L10.59 6.72L9.89 7.92L11.79 7.92L11.1 9.12L9.19 9.12L9.53 8.55M13.58 6.39L12.86 7.63L12.85 9.12L15.35 9.12L16.93 6.39M15.26 6.39L13.67 9.12",
        "stroke": "accent",
        "strokeWidth": 0.66
      },
      {
        "type": "polygon",
        "d": "M16.29 8.95L16.1 9.28L16.67 9.62L16.86 9.29L19.02 5.56L19.07 4.16Z",
        "fill": "accent"
      },
      {
        "type": "polygon",
        "d": "M4.41 9.12L5.66 9.12L4.11 11.78Z",
        "fill": "accent"
      },
      {
        "type": "polygon",
        "d": "M7.37 10.28L14.6 10.28L13.44 12.28L6.21 12.28Z",
        "fill": "#cd002d"
      },
      {
        "type": "polygon",
        "d": "M14.78 10.28L14.96 10.28L13.8 12.28L13.62 12.28Z",
        "fill": "#cd002d"
      },
      {
        "type": "polygon",
        "d": "M15.12 10.28L15.3 10.28L14.14 12.28L13.96 12.28Z",
        "fill": "#cd002d"
      },
      {
        "type": "polygon",
        "d": "M15.46 10.28L15.64 10.28L14.48 12.28L14.3 12.28Z",
        "fill": "#cd002d"
      },
      {
        "type": "line",
        "d": "M7.62 10.71L7.25 10.71L7.25 11.86L7.62 11.86M7.25 11.28L7.57 11.28M8.05 10.62L8.56 11.95M8.56 10.62L8.05 11.95M9.13 12L9.13 10.71L9.27 10.71L9.39 10.73L9.49 10.8L9.55 10.89L9.57 11.01L9.55 11.12L9.49 11.22L9.39 11.28L9.27 11.31L9.13 11.31M10.16 12L10.16 10.71L10.3 10.71L10.41 10.73L10.51 10.8L10.57 10.89L10.6 11.01L10.57 11.12L10.51 11.22L10.41 11.28L10.3 11.31L10.16 11.31M10.33 11.31L10.63 11.94M11.57 10.71L11.2 10.71L11.2 11.86L11.57 11.86M11.2 11.28L11.52 11.28M12.4 10.84L12.28 10.71L12.13 10.71L12.02 10.84L11.99 11.04L12.07 11.21L12.21 11.28L12.35 11.35L12.43 11.53L12.4 11.73L12.29 11.86L12.13 11.86L12.01 11.73M13.33 10.84L13.21 10.71L13.06 10.71L12.95 10.84L12.92 11.04L13 11.21L13.14 11.28L13.28 11.35L13.36 11.53L13.33 11.73L13.21 11.86L13.06 11.86L12.94 11.73",
        "stroke": "accent",
        "strokeWidth": 0.28
      }
    ],
    "dpx-logistics": [
      {
        "type": "line",
        "d": "M7.85 8.54L7.8 9.01L7.64 9.46L7.39 9.86L7.06 10.19L6.66 10.44L6.21 10.6L5.74 10.65L5.27 10.6L4.83 10.44L4.43 10.19L4.09 9.86L3.84 9.46L3.68 9.01L3.63 8.54L3.68 8.07L3.84 7.62L4.09 7.22L4.43 6.89L4.83 6.64L5.27 6.48L5.74 6.43L6.21 6.48L6.66 6.64L7.06 6.89L7.39 7.22L7.64 7.62L7.8 8.07L7.85 8.54L7.8 9.01M7.92 3.8L7.92 11.33M13.96 8.54L13.9 9.01L13.75 9.46L13.49 9.86L13.16 10.19L12.76 10.44L12.31 10.6L11.84 10.65L11.37 10.6L10.93 10.44L10.53 10.19L10.19 9.86L9.94 9.46L9.79 9.01L9.73 8.54L9.79 8.07L9.94 7.62L10.19 7.22L10.53 6.89L10.93 6.64L11.37 6.48L11.84 6.43L12.31 6.48L12.76 6.64L13.16 6.89L13.49 7.22L13.75 7.62L13.9 8.07L13.96 8.54L13.9 9.01M9.6 5.75L9.6 13.21",
        "stroke": "accent",
        "strokeWidth": 1.36
      },
      {
        "type": "polygon",
        "d": "M18.99 5.81L17.3 5.81L16.42 7.14L15.54 5.81L13.86 5.81L15.58 8.41L13.73 11.2L15.41 11.2L16.42 9.68L17.43 11.2L19.11 11.2L17.26 8.41Z",
        "fill": "#009cc8"
      },
      {
        "type": "polygon",
        "d": "M16.36 10.2L16.96 11.2L15.77 11.2Z",
        "fill": "#b0b3b5"
      },
      {
        "type": "line",
        "d": "M10.81 11.59L10.81 13.02L10.91 13.06L11.1 13.06M12.28 12.66L12.26 12.79L12.2 12.9L12.1 12.99L11.98 13.04L11.84 13.06L11.71 13.04L11.59 12.99L11.49 12.9L11.43 12.79L11.41 12.66L11.43 12.54L11.49 12.43L11.59 12.34L11.71 12.28L11.84 12.26L11.98 12.28L12.1 12.34L12.2 12.43L12.26 12.54L12.28 12.66L12.26 12.79M13.43 12.63L13.42 12.76L13.37 12.87L13.29 12.95L13.2 12.99L13.11 12.99L13.02 12.95L12.94 12.87L12.89 12.76L12.88 12.63L12.89 12.5L12.94 12.39L13.02 12.31L13.11 12.27L13.2 12.27L13.29 12.31L13.37 12.39L13.42 12.5L13.43 12.63L13.42 12.76M13.43 12.11L13.43 13.43L13.41 13.5L13.35 13.55L13.27 13.58L13.17 13.58L13.08 13.56L13.01 13.51M13.99 12.11L13.99 13.21M13.99 11.68L13.99 11.89M14.92 12.35L14.81 12.26L14.66 12.26L14.55 12.35L14.53 12.49L14.6 12.61L14.74 12.66L14.88 12.71L14.95 12.83L14.93 12.97L14.81 13.06L14.66 13.06L14.55 12.97M15.6 11.72L15.6 13.02L15.62 13.04L15.67 13.05L15.76 13.06L15.86 13.06L16.06 13.06M15.36 12.26L15.99 12.26M16.45 12.11L16.45 13.21M16.45 11.68L16.45 11.89M17.67 12.41L17.58 12.33L17.48 12.28L17.37 12.26L17.25 12.28L17.15 12.34L17.07 12.43L17.02 12.54L17.01 12.66L17.02 12.78L17.07 12.89L17.15 12.98L17.25 13.04L17.37 13.06L17.48 13.05L17.58 12.99L17.67 12.91M18.64 12.35L18.53 12.26L18.37 12.26L18.25 12.35L18.23 12.49L18.31 12.61L18.45 12.66L18.6 12.71L18.68 12.83L18.65 12.97L18.53 13.06L18.37 13.06L18.25 12.97",
        "stroke": "accent",
        "strokeWidth": 0.3
      }
    ],
    "uvan": [
      {
        "type": "polygon",
        "d": "M8.88 11.07L8.88 11.56L15.26 11.56L13.54 6.44L11.02 6.44L9.84 10.25L8.76 6.44L7.56 6.44Z",
        "fill": "accent"
      },
      {
        "type": "polygon",
        "d": "M13.66 10.41L10.99 10.41L11.87 7.59L12.72 7.59Z",
        "fill": "truck"
      },
      {
        "type": "polygon",
        "d": "M3.13 11.09L3.32 11.33L3.6 11.5L3.88 11.56L6.8 11.56L6.8 6.44L5.65 6.44L5.65 10.41L4.07 10.41L4.06 10.36L4.05 10.25L4.05 6.44L2.9 6.44L2.9 10.29L2.92 10.55L3 10.83Z",
        "fill": "accent"
      },
      {
        "type": "polygon",
        "d": "M17.68 7.64L17.77 7.75L17.86 7.93L17.92 8.18L17.95 8.47L17.95 11.56L19.1 11.56L19.1 8.42L19.06 7.98L18.94 7.53L18.74 7.12L18.45 6.77L18.06 6.52L17.66 6.44L15.26 6.44L15.26 11.56L16.41 11.56L16.41 7.59L17.54 7.59L17.62 7.6Z",
        "fill": "accent"
      }
    ],
    "fastwl": [
      {
        "type": "polygon",
        "d": "M15.98 13.16L16.93 8.07L16.79 7.61L16.54 7.1L12.96 5.78L12.89 5.61L15.09 3.86L19.37 5.46L18.27 11.29Z",
        "fill": "#bcbdc0"
      },
      {
        "type": "line",
        "d": "M7.14 10.29L7.06 10.86L6.85 11.39L6.5 11.84L6.04 12.19L5.52 12.41L4.95 12.48L4.39 12.41L3.86 12.19L3.41 11.84L3.06 11.39L2.84 10.86L2.77 10.29L2.84 9.73L3.06 9.2L3.41 8.75L3.86 8.4L4.39 8.18L4.95 8.11L5.52 8.18L6.04 8.4L6.5 8.75L6.85 9.2L7.06 9.73L7.14 10.29L7.06 10.86M5.94 10.29L5.9 10.86L5.8 11.39L5.65 11.84L5.44 12.19L5.21 12.41L4.95 12.48L4.7 12.41L4.46 12.19L4.26 11.84L4.1 11.39L4 10.86L3.97 10.29L4 9.73L4.1 9.2L4.26 8.75L4.46 8.4L4.7 8.18L4.95 8.11L5.21 8.18L5.44 8.4L5.65 8.75L5.8 9.2L5.9 9.73L5.94 10.29L5.9 10.86M4.95 8.11L4.95 12.48M3 9.31L6.9 9.31M3 11.28L6.9 11.28",
        "stroke": "#bcbdc0",
        "strokeWidth": 0.22
      },
      {
        "type": "line",
        "d": "M4.95 5L3.05 5L3.05 7.07M3.05 5.92L4.06 5.92M5.52 7.07L5.52 5L7.19 5L7.19 7.07M5.52 5.92L7.19 5.92M9.99 5L8.09 5L8.09 5.92L9.76 5.92L9.76 6.84L7.86 6.84M10.33 5L12.46 5M11.39 5L11.39 7.07",
        "stroke": "accent",
        "strokeWidth": 0.46
      },
      {
        "type": "polygon",
        "d": "M10.23 9.65L11.26 13.13L12.41 13.13L13.75 7.38L12.57 7.38L11.77 10.81L10.76 7.38L9.57 7.38L8.91 10.28L8.34 7.38L7.17 7.38L8.3 13.13L9.44 13.13Z",
        "fill": "accent"
      },
      {
        "type": "polygon",
        "d": "M15.41 13.13L15.41 11.98L14.59 11.98L15.32 7.38L14.16 7.38L13.24 13.13Z",
        "fill": "accent"
      }
    ],
    "tig-freight": [
      {
        "type": "polygon",
        "d": "M2.58 6.36L19.42 6.36L19.42 11.64L2.58 11.64Z",
        "fill": "accent"
      },
      {
        "type": "polygon",
        "d": "M2.8 6.58L8.13 6.58L8.13 11.42L2.8 11.42Z",
        "fill": "#974399"
      },
      {
        "type": "polygon",
        "d": "M8.34 6.58L13.66 6.58L13.66 11.42L8.34 11.42Z",
        "fill": "#148c45"
      },
      {
        "type": "polygon",
        "d": "M13.87 6.58L19.2 6.58L19.2 11.42L13.87 11.42Z",
        "fill": "#17479e"
      },
      {
        "type": "line",
        "d": "M3.53 8.59L3.53 7.88L7.39 7.88L7.39 8.59M5.46 7.88L5.46 10.24M4.54 10.24L6.38 10.24M10.08 7.88L11.94 7.88M11.02 7.88L11.02 10.24M10.1 10.24L11.96 10.24M18.53 8.76L18.53 8.41L18.33 8.24L18.08 8.09L17.8 7.96L17.49 7.87L17.15 7.8L16.8 7.76L16.45 7.76L16.09 7.78L15.75 7.84L15.43 7.93L15.14 8.05L14.89 8.19L14.67 8.36L14.51 8.54L14.39 8.73L14.33 8.94L14.32 9.14L14.37 9.34L14.48 9.54L14.64 9.73L14.84 9.89L15.09 10.04L15.38 10.16L15.69 10.26L16.03 10.32L16.38 10.36L16.74 10.36L17.09 10.33L17.43 10.26L17.74 10.17L18.03 10.05L18.28 9.91L18.28 9.17M17.49 9.17L18.78 9.17",
        "stroke": "accent",
        "strokeWidth": 0.66
      }
    ],
    "yha": [
      {
        "type": "polygon",
        "d": "M4.19 9.11L5.08 7.92L4.43 6.23L3.1 6.23Z",
        "fill": "accent"
      },
      {
        "type": "polygon",
        "d": "M5.53 10.01L8.35 6.23L6.79 6.23L4.4 9.43L3.64 11.77L4.95 11.77Z",
        "fill": "accent"
      },
      {
        "type": "polygon",
        "d": "M13.72 7.85L14.61 6.23L13.18 6.23L12.3 7.85Z",
        "fill": "accent"
      },
      {
        "type": "polygon",
        "d": "M10.17 11.77L11.59 11.77L13.48 8.3L12.46 8.3L12.06 8.3L10.19 8.3L11.31 6.23L9.89 6.23L6.9 11.77L8.32 11.77L9.52 9.55L11.38 9.55Z",
        "fill": "accent"
      },
      {
        "type": "polygon",
        "d": "M16.32 9.72L15.7 10.84L17.52 10.84L17.73 11.77L19.01 11.77L17.76 6.23L16.41 6.23L13.35 11.77L14.78 11.77L16.87 7.97L17.26 9.72Z",
        "fill": "accent"
      }
    ],
    "ecom-logistics": [
      {
        "type": "line",
        "d": "M7.31 9L7.3 9.28L7.24 9.55L7.15 9.81L7.03 10.06L6.87 10.29L6.69 10.5L6.48 10.69L6.25 10.84L6 10.97L5.74 11.05L5.46 11.11L5.19 11.13L4.91 11.11L4.64 11.05L4.37 10.97L4.12 10.84L3.89 10.69L3.68 10.5L3.5 10.29L3.34 10.06L3.22 9.81L3.13 9.55L3.08 9.28L3.06 9L3.08 8.72L3.13 8.45L3.22 8.19L3.34 7.94L3.5 7.71L3.68 7.5L3.89 7.31L4.12 7.16L4.37 7.03L4.64 6.95L4.91 6.89L5.19 6.87L5.46 6.89L5.74 6.95L6 7.03L6.25 7.16L6.48 7.31L6.69 7.5L6.87 7.71L7.03 7.94L7.15 8.19L7.24 8.45L7.3 8.72L7.31 9L7.3 9.28",
        "stroke": "#fdb706",
        "strokeWidth": 0.52
      },
      {
        "type": "line",
        "d": "M4.21 8.96L6.15 8.96L6.13 8.82L6.1 8.68L6.04 8.55L5.97 8.43L5.88 8.32L5.78 8.22L5.66 8.14L5.53 8.08L5.4 8.04L5.26 8.01L5.12 8.01L4.99 8.03L4.85 8.07L4.72 8.13L4.61 8.2L4.5 8.3L4.41 8.4L4.33 8.52L4.27 8.65L4.23 8.79L4.21 8.93L4.21 9.08L4.23 9.22L4.27 9.36L4.32 9.49L4.4 9.61L4.49 9.72L4.59 9.81L4.71 9.89L4.84 9.95L4.97 9.99L5.11 10.01L5.25 10.01L5.39 9.99L5.52 9.95L5.65 9.89L5.76 9.82L5.87 9.72L5.96 9.61L6.03 9.49",
        "stroke": "#fdb706",
        "strokeWidth": 0.42
      },
      {
        "type": "line",
        "d": "M10.9 7.86L10.79 7.66L10.67 7.49L10.53 7.34L10.38 7.21L10.22 7.12L10.06 7.05L9.89 7.02L9.71 7.01L9.54 7.04L9.38 7.1L9.22 7.19L9.06 7.31L8.92 7.46L8.8 7.63L8.69 7.82L8.59 8.04L8.52 8.26L8.47 8.5L8.43 8.75L8.42 9L8.43 9.25L8.47 9.5L8.52 9.74L8.59 9.96L8.69 10.18L8.8 10.37L8.92 10.54L9.06 10.69L9.22 10.81L9.38 10.9L9.54 10.96L9.71 10.99L9.89 10.98L10.06 10.95L10.22 10.88L10.38 10.79L10.53 10.66L10.67 10.51L10.79 10.34L10.9 10.14M14.67 9L14.66 9.26L14.62 9.52L14.57 9.76L14.49 9.99L14.39 10.21L14.27 10.41L14.14 10.58L13.99 10.72L13.83 10.84L13.66 10.92L13.49 10.97L13.31 10.99L13.13 10.97L12.96 10.92L12.79 10.84L12.63 10.72L12.48 10.58L12.35 10.41L12.23 10.21L12.14 9.99L12.06 9.76L12 9.52L11.97 9.26L11.95 9L11.97 8.74L12 8.48L12.06 8.24L12.14 8L12.23 7.79L12.35 7.59L12.48 7.42L12.63 7.28L12.79 7.16L12.96 7.08L13.13 7.03L13.31 7.01L13.49 7.03L13.66 7.08L13.83 7.16L13.99 7.28L14.14 7.42L14.27 7.59L14.39 7.79L14.49 8L14.57 8.24L14.62 8.48L14.66 8.74L14.67 9L14.66 9.26",
        "stroke": "accent",
        "strokeWidth": 0.62
      },
      {
        "type": "polygon",
        "d": "M17.38 11.02L18.58 8.94L18.58 11.23L19.2 11.23L19.2 6.69L19.16 6.69L17.38 9.78L15.6 6.69L15.56 6.69L15.56 11.23L16.18 11.23L16.18 8.94Z",
        "fill": "accent"
      }
    ],
    "fragilepak": [
      {
        "type": "line",
        "d": "M4.4 7.59L4.4 4.42L6.51 4.42M4.4 5.83L6.29 5.83M6.95 7.59L6.95 5.12M6.95 6.28L6.96 6.13L7.01 5.98L7.08 5.84L7.18 5.7L7.3 5.59L7.44 5.49L7.6 5.41L7.78 5.35L7.96 5.31L8.15 5.3M8.59 5.92L8.61 5.78L8.67 5.65L8.77 5.53L8.89 5.43L9.04 5.36L9.21 5.32L9.39 5.3L9.56 5.32L9.73 5.36L9.88 5.43L10.01 5.53L10.1 5.65L10.16 5.78L10.18 5.92L10.18 7.59M10.18 6.22L9.34 6.22L9.18 6.23L9.02 6.27L8.87 6.32L8.74 6.4L8.64 6.49L8.56 6.59L8.51 6.7L8.5 6.82L8.51 6.93L8.56 7.04L8.64 7.15L8.74 7.24L8.87 7.31L9.02 7.36L9.18 7.4L9.34 7.41L9.76 7.41L10.18 7.13M12.98 6.32L12.96 6.52L12.9 6.71L12.81 6.89L12.7 7.04L12.55 7.17L12.39 7.26L12.21 7.32L12.02 7.34L11.84 7.32L11.66 7.26L11.49 7.17L11.35 7.04L11.23 6.89L11.14 6.71L11.09 6.52L11.07 6.32L11.09 6.12L11.14 5.93L11.23 5.75L11.35 5.6L11.49 5.47L11.66 5.38L11.84 5.32L12.02 5.3L12.21 5.32L12.39 5.38L12.55 5.47L12.7 5.6L12.81 5.75L12.9 5.93L12.96 6.12L12.98 6.32L12.96 6.52M12.98 5.12L12.98 7.54L12.95 7.71L12.88 7.88L12.78 8.03L12.63 8.15L12.46 8.25L12.27 8.31L12.07 8.32L11.86 8.3L11.67 8.24L11.5 8.15L11.36 8.02L11.25 7.87M13.89 5.12L13.89 7.59M13.89 4.17L13.89 4.69M14.83 4.17L14.83 7.59M15.72 6.33L17.6 6.33L17.58 6.13L17.52 5.94L17.44 5.76L17.32 5.6L17.18 5.48L17.02 5.38L16.85 5.32L16.67 5.3L16.49 5.32L16.32 5.37L16.16 5.47L16.02 5.59L15.9 5.74L15.81 5.92L15.75 6.11L15.73 6.31L15.74 6.51L15.78 6.71L15.86 6.89L15.96 7.06L16.1 7.19L16.25 7.3L16.42 7.37L16.59 7.4L16.77 7.4L16.95 7.36L17.12 7.28L17.26 7.16L17.39 7.02L17.49 6.85",
        "stroke": "#000000",
        "strokeWidth": 0.5
      },
      {
        "type": "polygon",
        "d": "M14.21 12.64L17.33 9.02L15.61 9.02L14.21 10.65L14.21 9.02L12.91 9.02L12.91 13.63L14.21 13.63Z",
        "fill": "accent"
      },
      {
        "type": "polygon",
        "d": "M10.99 9.02L9.39 9.02L7.82 13.63L9.19 13.63L10.18 10.73L11.13 13.63L12.5 13.63Z",
        "fill": "accent"
      },
      {
        "type": "polygon",
        "d": "M7.22 12.12L7.5 11.97L7.74 11.77L7.94 11.52L8.09 11.25L8.18 10.94L8.21 10.63L8.18 10.32L8.09 10.01L7.94 9.74L7.74 9.49L7.5 9.29L7.22 9.14L6.92 9.05L6.64 9.02L4.15 9.02L4.15 13.63L5.45 13.63L5.45 12.23L6.64 12.23L6.92 12.21Z",
        "fill": "accent"
      },
      {
        "type": "polygon",
        "d": "M6.72 10.35L6.77 10.38L6.82 10.42L6.86 10.46L6.88 10.51L6.9 10.57L6.91 10.63L6.9 10.69L6.88 10.75L6.86 10.8L6.82 10.84L6.77 10.88L6.72 10.91L6.66 10.93L6.57 10.93L5.45 10.93L5.45 10.32L6.57 10.32L6.66 10.33Z",
        "fill": "truck"
      },
      {
        "type": "polygon",
        "d": "M6.47 13.6L7.13 13.16L7.86 12.75L8.56 12.4L9.21 12.14L9.72 11.98L10.16 11.9L10.92 11.81L11.63 11.78L12.33 11.81L12.97 11.9L13.58 12.04L14.16 12.25L14.72 12.52L15.19 12.83L15.61 13.2L15.93 13.6L17.84 13.6L17.37 12.96L16.83 12.39L16.23 11.89L15.61 11.5L14.93 11.19L14.22 10.98L13.46 10.85L12.65 10.8L11.83 10.85L11.05 10.99L10.25 11.22L9.4 11.56L8.54 12L7.65 12.56L6.95 13.09L6.37 13.6Z",
        "fill": "#000000"
      }
    ],
    "hkd-express": [
      {
        "type": "polygon",
        "d": "M4.35 4.69L2.84 4.69L2.84 11.05L4.35 11.05L4.35 8.58L7.57 8.58L7.57 7.08L4.35 7.08Z",
        "fill": "accent"
      },
      {
        "type": "polygon",
        "d": "M8.2 11.05L9.7 11.05L9.7 4.69L8.2 4.69Z",
        "fill": "accent"
      },
      {
        "type": "polygon",
        "d": "M14.18 4.69L12.17 4.69L10.25 6.89L10.25 8.85L12.17 11.05L14.18 11.05L11.39 7.87Z",
        "fill": "accent"
      },
      {
        "type": "polygon",
        "d": "M16.45 6.26L16.66 6.33L16.86 6.42L17.04 6.54L17.2 6.69L17.35 6.85L17.47 7.03L17.56 7.23L17.64 7.44L17.68 7.65L17.69 7.87L17.68 8.09L17.64 8.3L17.56 8.51L17.47 8.71L17.35 8.89L17.2 9.05L17.04 9.2L16.86 9.32L16.66 9.41L16.45 9.49L16.24 9.53L16 9.54L13.45 9.54L14.77 11.05L16.05 11.05L16.44 11.02L16.84 10.94L17.24 10.81L17.61 10.63L17.96 10.39L18.27 10.12L18.54 9.81L18.78 9.46L18.96 9.09L19.09 8.69L19.17 8.29L19.2 7.87L19.17 7.46L19.09 7.05L18.96 6.65L18.78 6.28L18.54 5.93L18.27 5.62L17.96 5.35L17.61 5.12L17.24 4.93L16.84 4.8L16.44 4.72L16.05 4.69L14.77 4.69L13.45 6.2L16 6.2L16.24 6.21Z",
        "fill": "#b50709"
      },
      {
        "type": "line",
        "d": "M3.79 11.65L2.98 11.65L2.98 13.13L3.79 13.13M2.98 12.39L3.67 12.39M4.42 11.65L5.64 13.13M5.64 11.65L4.42 13.13M6.45 13.31L6.45 11.65L6.88 11.65L7.02 11.68L7.15 11.76L7.23 11.89L7.26 12.03L7.23 12.18L7.15 12.31L7.02 12.39L6.88 12.42L6.45 12.42M8.11 13.31L8.11 11.65L8.7 11.65L8.85 11.68L8.97 11.76L9.06 11.89L9.09 12.03L9.06 12.18L8.97 12.31L8.85 12.39L8.7 12.42L8.11 12.42M8.45 12.42L9.14 13.19M10.75 11.65L9.94 11.65L9.94 13.13L10.75 13.13M9.94 12.39L10.63 12.39M12.28 11.82L12.03 11.65L11.69 11.65L11.44 11.82L11.38 12.07L11.55 12.3L11.86 12.39L12.18 12.48L12.36 12.7L12.3 12.96L12.03 13.13L11.69 13.13L11.42 12.96M13.83 11.82L13.6 11.65L13.29 11.65L13.06 11.82L13.01 12.07L13.16 12.3L13.45 12.39L13.74 12.48L13.9 12.7L13.85 12.96L13.61 13.13L13.29 13.13L13.05 12.96",
        "stroke": "accent",
        "strokeWidth": 0.36
      }
    ],
    "canada-air-express": [
      {
        "type": "line",
        "d": "M17.32 5.75L17.52 6.26L17.61 6.8M17.62 6.94L17.58 7.49L17.46 8.02M17.42 8.15L17.22 8.66L16.97 9.15M16.9 9.27L16.59 9.72L16.25 10.15M16.16 10.25L15.78 10.65L15.38 11.02M15.27 11.11L14.84 11.45L14.39 11.76M14.27 11.84L13.8 12.11L13.32 12.37M13.19 12.43L12.69 12.65L12.18 12.83M12.05 12.88L11.52 13.03L10.98 13.14M10.85 13.16L10.3 13.23L9.76 13.25M9.62 13.25L9.07 13.21L8.53 13.11M8.4 13.08L7.88 12.9L7.4 12.64M7.28 12.56L6.87 12.2L6.54 11.77M6.48 11.65L6.28 11.14L6.19 10.6M6.18 10.46L6.22 9.91L6.34 9.38M6.38 9.25L6.58 8.74L6.83 8.25M6.9 8.13L7.21 7.68L7.55 7.25M7.64 7.15L8.02 6.75L8.42 6.38M8.53 6.29L8.96 5.95L9.41 5.64M9.53 5.56L10 5.29L10.48 5.03M10.61 4.97L11.11 4.75L11.62 4.57M11.75 4.52L12.28 4.37L12.82 4.26M12.95 4.24L13.5 4.17L14.04 4.15M14.18 4.15L14.73 4.19L15.27 4.29M15.4 4.32L15.92 4.5L16.4 4.76M16.52 4.84L16.93 5.2L17.26 5.63",
        "stroke": "accent",
        "strokeWidth": 0.6
      },
      {
        "type": "circle",
        "cx": 11.9,
        "cy": 8.7,
        "r": 4.81,
        "fill": "#2284a3"
      },
      {
        "type": "line",
        "d": "M7.73 6.29L16.07 6.29M7.09 8.7L16.71 8.7M7.73 11.11L16.07 11.11M11.9 3.89L11.9 13.51M11.9 3.89L11.22 4.05L10.58 4.53L10.03 5.3L9.61 6.29L9.34 7.45L9.25 8.7L9.34 9.95L9.61 11.11L10.03 12.1L10.58 12.87L11.22 13.35L11.9 13.51M11.9 3.89L12.58 4.05L13.22 4.53L13.77 5.3L14.19 6.29L14.46 7.45L14.55 8.7L14.46 9.95L14.19 11.11L13.77 12.1L13.22 12.87L12.58 13.35L11.9 13.51",
        "stroke": "accent",
        "strokeWidth": 0.2
      },
      {
        "type": "line",
        "d": "M16.9 9.27L16.59 9.72L16.25 10.15L15.78 10.65L15.38 11.02L14.84 11.45L14.39 11.76L13.8 12.11L13.32 12.37L12.69 12.65L12.18 12.83L11.52 13.03L10.98 13.14L10.3 13.23L9.76 13.25",
        "stroke": "truck",
        "strokeWidth": 0.92
      },
      {
        "type": "line",
        "d": "M16.9 9.27L16.59 9.72L16.25 10.15M16.16 10.25L15.78 10.65L15.38 11.02M15.27 11.11L14.84 11.45L14.39 11.76M14.27 11.84L13.8 12.11L13.32 12.37M13.19 12.43L12.69 12.65L12.18 12.83M12.05 12.88L11.52 13.03L10.98 13.14M10.85 13.16L10.3 13.23L9.76 13.25",
        "stroke": "accent",
        "strokeWidth": 0.6
      }
    ],
    "bombax": [
      {
        "type": "polygon",
        "d": "M6.46 6.51L6.46 12.09L11.3 14.89L16.14 12.09L16.14 6.51L11.3 3.71Z",
        "fill": "accent"
      },
      {
        "type": "polygon",
        "d": "M7.05 6.84L11.3 4.39L15.55 6.84L15.55 11.76L11.3 14.21L7.05 11.76Z",
        "fill": "truck"
      },
      {
        "type": "polygon",
        "d": "M10.68 9.3L11.2 9.24L11.69 9.07L12.14 8.81L12.52 8.46L12.84 8.04L13.08 7.57L13.24 7.07L13.29 6.53L9.31 6.53L9.31 12.07L13.29 12.07L13.24 11.53L13.08 11.03L12.84 10.56L12.52 10.14L12.14 9.8L11.69 9.53L11.2 9.36Z",
        "fill": "accent"
      }
    ],
    "sm-express": [
      {
        "type": "circle",
        "cx": 11.5,
        "cy": 9.2,
        "r": 5.2,
        "fill": "accent"
      },
      {
        "type": "polygon",
        "d": "M9.8 5.57L9.85 5.68L9.98 5.69L10.65 5.69L10.79 5.61L11.15 4.5L11.06 4.43L10.41 4.9Z",
        "fill": "truck"
      },
      {
        "type": "polygon",
        "d": "M10.44 4.47L10.38 4.48L10.32 4.49L10.26 4.51L10.21 4.52L10.15 4.54L10.09 4.56L10.03 4.58L9.98 4.59L9.92 4.61L9.87 4.63L9.81 4.65L9.75 4.67L9.7 4.7L9.64 4.72L9.59 4.74L9.53 4.77L9.48 4.79L9.44 4.81L8.3 5.57L8.37 5.68L8.51 5.69L9.44 5.69L10 5.03L10.6 4.5L10.46 4.46Z",
        "fill": "truck"
      },
      {
        "type": "polygon",
        "d": "M9.3 6.38L8.94 7.45L10.46 7.45L10.71 5.97L9.58 5.92Z",
        "fill": "truck"
      },
      {
        "type": "polygon",
        "d": "M7.08 7.45L8.64 7.51L9.27 5.97L7.97 5.92L7.38 6.64Z",
        "fill": "truck"
      },
      {
        "type": "polygon",
        "d": "M12.53 10.93L12.43 11.07L12.21 12.42L13.34 12.45L13.8 11.48L13.94 11.07L13.89 10.94Z",
        "fill": "truck"
      },
      {
        "type": "polygon",
        "d": "M14.28 10.93L13.56 12.42L14.95 12.47L15.68 11.61L15.9 11.07L15.8 10.94Z",
        "fill": "truck"
      },
      {
        "type": "polygon",
        "d": "M12.13 12.79L11.82 13.76L12 13.77L12.53 13.41L13.06 12.82L12.93 12.74Z",
        "fill": "truck"
      },
      {
        "type": "polygon",
        "d": "M13.99 13.36L14.04 13.33L14.1 13.3L14.14 13.27L14.69 12.82L14.55 12.74L13.47 12.74L12.74 13.49L12.18 13.89L12.26 13.97L12.51 13.94L12.56 13.93L12.62 13.92L12.68 13.91L12.74 13.89L12.79 13.88L13.85 13.44L13.89 13.42L13.94 13.39Z",
        "fill": "truck"
      },
      {
        "type": "polygon",
        "d": "M12.26 5.5L12.71 5.5L12.48 5.89L13.65 5.83L13.65 5.5L14.36 5.5L14.56 5.38L14.64 5.22L14.52 5.06L14.24 4.98L13.3 4.98L12.56 4.36L12.3 4.36L12.72 4.98L11.98 4.98L11.54 4.42L11.35 4.43L11.35 5.4Z",
        "fill": "#088bd2"
      },
      {
        "type": "polygon",
        "d": "M15.83 7.18L15.83 6.94L14.76 6.42L12.34 6.42L12.34 6.99L11.85 6.99L11.85 6.19L10.79 6.19L10.79 7.18Z",
        "fill": "#088bd2"
      },
      {
        "type": "polygon",
        "d": "M12.12 12.52L12.22 12.42L12.22 11.29L11.73 11.29L11.73 11.44L9.67 11.44L9.67 11.23L9.08 11.23L9.08 11.69L7.38 11.69L7.87 12.52Z",
        "fill": "#088bd2"
      },
      {
        "type": "polygon",
        "d": "M11.97 13.76L11.97 12.86L9.91 12.86L9.91 12.94L9.67 12.94L9.34 13.3L9.34 13.76Z",
        "fill": "#088bd2"
      },
      {
        "type": "line",
        "d": "M10.93 8.54L10.61 8.32L10.18 8.32L9.86 8.54L9.78 8.86L10 9.15L10.4 9.26L10.8 9.38L11.03 9.66L10.95 9.99L10.61 10.2L10.17 10.2L9.83 9.99",
        "stroke": "#088bd2",
        "strokeWidth": 0.38
      },
      {
        "type": "line",
        "d": "M11.97 10.39L11.97 8.32L12.25 8.32L12.7 9.68L13.1 9.68L13.54 8.32L13.82 8.32L13.82 10.39",
        "stroke": "truck",
        "strokeWidth": 0.38
      }
    ],
    "asiafly": [
      {
        "type": "polygon",
        "d": "M4.8 8.05L4.02 8.05L2.74 12.85L3.53 12.85L4.41 9.53L4.78 10.94L4.32 10.94L4.14 11.63L4.96 11.63L5.29 12.85L6.08 12.85Z",
        "fill": "accent"
      },
      {
        "type": "polygon",
        "d": "M8.37 9.23L8.34 8.98L8.24 8.72L8.07 8.46L7.81 8.23L7.5 8.09L7.26 8.05L7.15 8.05L6.88 8.1L6.65 8.2L6.56 8.25L6.38 8.41L6.21 8.63L6.16 8.72L6.06 8.98L6.03 9.31L6.09 9.66L6.24 9.97L6.51 10.29L6.75 10.49L7.22 10.84L7.41 11L7.55 11.15L7.62 11.29L7.65 11.44L7.63 11.62L7.57 11.79L7.49 11.93L7.39 12.02L7.29 12.07L7.2 12.08L7.11 12.07L7.01 12.02L6.92 11.93L6.83 11.79L6.78 11.62L6.76 11.41L6.76 11.1L6 11.1L6 11.43L6.03 11.74L6.14 12.11L6.31 12.39L6.53 12.6L6.61 12.67L6.85 12.79L7.14 12.84L7.26 12.84L7.56 12.79L7.85 12.63L8.09 12.39L8.26 12.11L8.37 11.78L8.41 11.44L8.34 11.02L8.14 10.68L7.92 10.44L7.69 10.24L7.22 9.89L7.03 9.73L6.89 9.57L6.82 9.43L6.79 9.27L6.81 9.15L6.85 9.04L6.92 8.94L7.01 8.87L7.1 8.83L7.2 8.81L7.3 8.83L7.4 8.87L7.48 8.94L7.55 9.04L7.6 9.15L7.62 9.3L7.62 9.49L8.38 9.49Z",
        "fill": "accent"
      },
      {
        "type": "polygon",
        "d": "M9.38 8.05L8.62 8.05L8.62 12.85L9.38 12.85Z",
        "fill": "accent"
      },
      {
        "type": "polygon",
        "d": "M11.36 8.05L10.57 8.05L9.6 11.72L9.6 12.85L10.09 12.85L10.97 9.53L11.34 10.94L10.88 10.94L10.7 11.63L11.52 11.63L11.85 12.85L12.4 12.85L12.4 11.97Z",
        "fill": "accent"
      },
      {
        "type": "polygon",
        "d": "M14.77 8.81L14.77 8.05L12.62 8.05L12.62 12.85L13.38 12.85L13.38 10.58L14.57 10.58L14.57 9.9L13.38 9.9L13.38 8.81Z",
        "fill": "accent"
      },
      {
        "type": "polygon",
        "d": "M15.77 8.05L15.01 8.05L15.01 12.85L17.04 12.85L17.04 12.09L15.77 12.09Z",
        "fill": "#ec8524"
      },
      {
        "type": "polygon",
        "d": "M17.34 10.23L17.34 12.85L18.1 12.85L18.1 10.23L19.23 8.05L18.38 8.05L17.72 9.32L17.04 8.05L16.18 8.05Z",
        "fill": "accent"
      },
      {
        "type": "polygon",
        "d": "M9.94 5.86L9.57 6.65L9.62 7.12L9.15 7.07L8.36 7.44L8.73 6.65L8.68 6.18L9.15 6.23Z",
        "fill": "#ec8524"
      }
    ],
    "shunbang-express": [
      {
        "type": "polygon",
        "d": "M12.66 12.75L8.66 12.74L9.34 11.65L12.18 11.65L12.52 11.49L12.73 11.2L12.77 10.89L12.72 10.72L12.6 10.51L12.37 10.34L12.16 10.28L10.86 10.28L11.56 8.91L12.26 8.91L12.47 8.85L12.73 8.63L12.85 8.3L12.84 8.07L12.77 7.89L12.61 7.7L12.4 7.59L12.26 7.55L10.62 7.54L10.87 6.29L12.56 6.29L13.24 6.47L13.59 6.67L13.95 7.01L14.16 7.35L14.3 7.72L14.36 8.04L14.36 8.37L14.29 8.75L14.08 9.17L13.69 9.53L14.08 9.89L14.29 10.29L14.35 10.59L14.37 10.97L14.27 11.5L14 12.07L13.67 12.43L13.21 12.66Z",
        "fill": "accent"
      },
      {
        "type": "polygon",
        "d": "M7.52 13.65L7.93 10.4L7.03 10.48L10.57 5.55L9.78 9.11L10.54 9.07Z",
        "fill": "#ef841a"
      },
      {
        "type": "polygon",
        "d": "M10.85 5.5L10.7 5.37L10.61 5.45L10.6 5.34L10.4 5.34L10.48 5.24L10.65 5.17L10.76 4.7L10.03 4.75L10.12 4.66L10.87 4.38L11.12 3.86L11.3 3.85L11.27 4.04L11.12 4.47L11.5 5.15L11.52 5.31L10.98 4.79L10.78 5.22L10.86 5.39Z",
        "fill": "#ef841a"
      }
    ],
    "topex-logistics": [
      {
        "type": "polygon",
        "d": "M12.9 11.39L12.89 9.82L14.79 8.71L14.93 8.58L15.1 8.32L15.15 8.11L15.1 7.63L14.97 7.4L14.58 7.11L14.38 7.06L13.89 7.11L7.22 10.96L5.47 7.91L7.82 7.9L8.33 8.74L13.3 5.88L13.66 5.74L14.1 5.68L14.63 5.71L15.19 5.88L15.5 6.04L15.97 6.46L16.18 6.74L16.41 7.23L16.51 7.66L16.53 8.12L16.45 8.6L16.32 8.96L16.05 9.39L15.5 9.89Z",
        "fill": "accent"
      },
      {
        "type": "polygon",
        "d": "M10.12 14.4L10.11 10.1L12.18 8.92L12.18 13.19Z",
        "fill": "accent"
      },
      {
        "type": "polygon",
        "d": "M10.12 6.48L10.11 5.21L12.18 4L12.18 5.29Z",
        "fill": "#38bbc5"
      }
    ],
    "360lion": [
      {
        "type": "polygon",
        "d": "M6.66 12.98L6.66 11.88L4 11.88L4 5.04L2.9 5.04L2.9 12.98Z",
        "fill": "accent"
      },
      {
        "type": "polygon",
        "d": "M4.69 6.78L4.69 7.35L5.4 7.35L5.52 7.37L5.59 7.41L5.65 7.47L5.69 7.54L5.7 7.62L5.69 7.7L5.65 7.78L5.59 7.83L5.52 7.87L5.4 7.89L4.69 7.89L4.69 8.74L5.47 8.74L5.79 8.69L6.1 8.53L6.35 8.28L6.51 7.97L6.56 7.59L6.51 7.27L6.35 6.96L6.1 6.71L5.85 6.58L6.56 5.55L6.56 5L4.69 5L4.69 5.85L5.33 5.85Z",
        "fill": "accent"
      },
      {
        "type": "polygon",
        "d": "M6.97 6.46L6.92 6.6L6.88 6.81L6.87 7.03L6.89 7.24L6.93 7.42L7.01 7.62L7.12 7.81L7.26 7.97L7.43 8.1L7.59 8.17L7.84 8.22L8.03 8.2L8.14 8.17L8.29 8.1L8.47 7.97L8.63 7.78L8.72 7.62L8.8 7.42L8.85 7.18L8.86 7.03L8.85 6.81L8.8 6.57L8.73 6.4L8.59 6.15L8.47 6.02L8.29 5.89L8.11 5.81L7.98 5.78L8.14 5L7.27 5Z",
        "fill": "accent"
      },
      {
        "type": "polygon",
        "d": "M7.79 6.72L7.86 6.63L7.92 6.68L7.98 6.81L8 6.9L8.01 7L7.98 7.18L7.92 7.31L7.86 7.37L7.78 7.26L7.73 7.09L7.72 7.02Z",
        "fill": "truck"
      },
      {
        "type": "polygon",
        "d": "M10.08 4.95L9.8 4.99L9.57 5.09L9.37 5.25L9.2 5.49L9.12 5.7L9.09 5.93L9.09 7.24L9.12 7.48L9.2 7.68L9.26 7.78L9.39 7.95L9.57 8.08L9.77 8.17L9.88 8.2L10.08 8.22L10.35 8.18L10.58 8.08L10.78 7.92L10.95 7.68L11.03 7.48L11.06 7.24L11.06 5.93L11.03 5.7L10.95 5.49L10.9 5.4L10.76 5.22L10.58 5.09L10.38 5L10.28 4.97Z",
        "fill": "accent"
      },
      {
        "type": "polygon",
        "d": "M10.08 5.8L10.17 5.84L10.2 5.9L10.21 5.96L10.21 7.21L10.2 7.27L10.17 7.33L10.08 7.37L9.98 7.33L9.95 7.27L9.94 7.21L9.94 5.96L9.95 5.9L9.98 5.84Z",
        "fill": "truck"
      },
      {
        "type": "polygon",
        "d": "M8.28 8.65L7.18 8.65L7.18 12.98L8.28 12.98Z",
        "fill": "accent"
      },
      {
        "type": "polygon",
        "d": "M9.75 8.65L9.52 8.68L9.42 8.71L9.19 8.86L9.11 8.93L8.98 9.12L8.94 9.22L8.91 9.39L8.9 9.5L8.9 12.18L8.96 12.45L9.11 12.69L9.23 12.8L9.42 12.91L9.52 12.94L9.75 12.98L12.7 12.97L12.97 12.91L13.21 12.76L13.32 12.64L13.43 12.45L13.46 12.35L13.5 12.13L13.49 9.44L13.43 9.17L13.28 8.93L13.21 8.86L13.02 8.73L12.92 8.69L12.7 8.65Z",
        "fill": "accent"
      },
      {
        "type": "polygon",
        "d": "M12.4 9.75L12.4 11.88L10 11.88L10 9.75Z",
        "fill": "truck"
      },
      {
        "type": "polygon",
        "d": "M15.14 9.75L17.37 12.98L19.08 12.98L19.08 8.65L17.98 8.65L17.98 11.88L17.95 11.88L15.72 8.65L14.01 8.65L14.01 12.98L15.11 12.98L15.11 9.75Z",
        "fill": "accent"
      }
    ],
    "cititrans": [
      {
        "type": "polygon",
        "d": "M9.25 7.71L8.45 7.67L7.47 7.56L6.47 7.38L5.49 7.15L6.83 5.69L8.21 5.95L9.45 6.14L10.98 6.29L11.62 6.3L12.04 6.19L12.41 5.99L13.25 5.15L13.71 4.75L14.39 4.3L14.96 4.05L15.66 3.91L16.44 3.9L17.35 3.99L18.5 4.24L17.18 5.69L16.44 5.55L15.73 5.48L14.77 5.5L13.79 5.68L13.2 5.87L12.62 6.12L12.19 6.38L11.42 6.97L10.69 7.38L9.95 7.63Z",
        "fill": "accent"
      },
      {
        "type": "polygon",
        "d": "M8.09 9.98L7.15 9.95L5.91 9.81L4.29 9.51L3.5 9.32L4.84 7.86L6.13 8.14L7.35 8.31L8.28 8.39L9.26 8.35L9.89 8.22L10.67 7.9L11.35 7.46L12.01 6.85L11.61 7.48L11.06 8.18L10.47 8.8L9.97 9.23L9.42 9.6L8.95 9.81L8.54 9.93Z",
        "fill": "accent"
      },
      {
        "type": "line",
        "d": "M5.11 11.29L4.92 11.13L4.7 11.03L4.46 11L4.22 11.05L4.01 11.17L3.84 11.34L3.73 11.56L3.69 11.8L3.69 12.4L3.73 12.64L3.84 12.86L4.01 13.03L4.22 13.15L4.46 13.2L4.7 13.17L4.92 13.07L5.11 12.91M5.8 10.78L5.8 13.42M6.35 11L7.65 11M7 11L7 13.42M8.2 10.78L8.2 13.42M8.75 11L10.05 11M9.4 11L9.4 13.42M10.6 13.42L10.6 11L11.28 11L11.5 11.04L11.68 11.17L11.81 11.35L11.85 11.57L11.81 11.79L11.68 11.98L11.5 12.1L11.28 12.14L10.6 12.14M11.1 12.14L11.92 13.29M12.61 13.36L13.31 11L13.61 11L14.31 13.36M12.88 12.45L14.04 12.45M15.07 13.42L15.07 11L15.35 11L16.14 13.2L16.42 13.2L16.42 10.78M18.21 11.25L17.93 11L17.55 11L17.26 11.25L17.2 11.63L17.39 11.97L17.74 12.1L18.1 12.23L18.3 12.57L18.23 12.95L17.93 13.2L17.54 13.2L17.25 12.95",
        "stroke": "accent",
        "strokeWidth": 0.44
      }
    ],
    "syd": [
      {
        "type": "polygon",
        "d": "M14.37 7.02L14.7 5.63L13.35 5.63L12.26 8.06L11.45 8.7L11.45 6.45L11.42 6.27L11.34 6.06L11.2 5.88L11.01 5.74L10.8 5.65L10.63 5.63L8.11 5.63L7.73 5.68L7.33 5.85L6.98 6.11L6.72 6.45L6.55 6.85L6.5 7.23L6.5 11.47L3.02 11.47L2.7 12.97L6.75 12.97L7.04 12.93L7.36 12.8L7.63 12.59L7.84 12.32L7.97 12.01L8 11.72L8 7.33L8.02 7.24L8.05 7.18L8.12 7.14L8.2 7.13L9.95 7.13L9.95 9.24L10.61 10.43L10.05 12.97L11.59 12.97L12.2 10.19L12.13 10.07L13.48 9.02Z",
        "fill": "#000000"
      },
      {
        "type": "polygon",
        "d": "M18.16 12.97L19.25 7.3L19.26 6.93L19.16 6.52L18.94 6.15L18.62 5.87L18.23 5.68L17.87 5.63L14.92 5.63L13.22 12.97Z",
        "fill": "#000000"
      },
      {
        "type": "polygon",
        "d": "M15.11 11.47L16.92 11.47L17.75 7.13L16.11 7.13Z",
        "fill": "truck"
      },
      {
        "type": "polygon",
        "d": "M4.62 7.59L5.89 8.29L5.89 9.68L4.62 10.38L3.36 9.68L3.36 8.29Z",
        "fill": "accent"
      },
      {
        "type": "line",
        "d": "M3.19 8.19L4.62 9.05L6.05 8.19M4.62 9.05L4.62 10.54",
        "stroke": "truck",
        "strokeWidth": 0.26
      }
    ],
    "we-world-express": [
      {
        "type": "polygon",
        "d": "M9.87 12.87L13.78 6.2L13.99 5.75L13.61 5.75L12.69 5.96L12.02 6.28L11.32 6.78L10.81 7.31L10.42 7.86L9.42 9.59L9.35 9.53L9.34 5.75L8.94 5.75L8.01 5.96L7.43 6.22L6.69 6.74L5.88 7.66L4.72 9.59L4.68 5.75L2.8 5.75L2.8 12.87L5.19 12.87L7.46 9.02L7.5 12.87Z",
        "fill": "accent"
      },
      {
        "type": "polygon",
        "d": "M17.59 12.87L18.21 11.42L18.3 11.07L15.15 11.06L14.91 11L14.64 10.84L14.4 10.55L14.3 10.29L14.3 9.96L18.82 9.94L19.01 9.5L19.2 8.71L19.2 7.83L19.09 7.37L18.67 6.58L18.36 6.28L17.83 5.96L17.01 5.75L14.91 5.75L12.12 10.55L12.12 10.81L12.25 11.25L12.55 11.79L12.89 12.15L13.11 12.34L13.85 12.69L14.78 12.87Z",
        "fill": "accent"
      },
      {
        "type": "polygon",
        "d": "M14.91 5.75L12.12 10.56L16.84 7.19L16.89 7.07L16.6 6.56L16.28 6.21L15.82 5.91L15.46 5.75Z",
        "fill": "#60bb46"
      }
    ],
    "vnlin": [
      {
        "type": "polygon",
        "d": "M4.85 6.04L4.83 5.79L2.8 5.79L2.83 6.04Z",
        "fill": "accent"
      },
      {
        "type": "polygon",
        "d": "M3.02 7.54L5.01 7.54L4.97 7.14L2.97 7.14Z",
        "fill": "accent"
      },
      {
        "type": "polygon",
        "d": "M3.54 11.64L3.64 12.14L3.79 12.54L4 12.81L6.11 12.81L8.88 8.56L6.5 8.56L5.31 10.42L5.12 8.56L3.15 8.56L3.48 11.19Z",
        "fill": "accent"
      },
      {
        "type": "polygon",
        "d": "M9.28 7.95L6.89 7.95L6.66 8.31L9.04 8.31Z",
        "fill": "accent"
      },
      {
        "type": "polygon",
        "d": "M5.05 7.95L3.07 7.95L3.12 8.31L5.09 8.31Z",
        "fill": "accent"
      },
      {
        "type": "polygon",
        "d": "M7.41 7.14L7.15 7.54L9.54 7.54L9.8 7.14Z",
        "fill": "accent"
      },
      {
        "type": "polygon",
        "d": "M2.92 6.76L4.93 6.76L4.9 6.51L2.89 6.51Z",
        "fill": "accent"
      },
      {
        "type": "polygon",
        "d": "M7.66 6.76L10.05 6.76L10.21 6.51L7.82 6.51Z",
        "fill": "accent"
      },
      {
        "type": "polygon",
        "d": "M10.52 6.04L10.68 5.79L8.28 5.79L8.12 6.04Z",
        "fill": "accent"
      },
      {
        "type": "polygon",
        "d": "M12.7 12.42L12.89 12.63L13.15 12.77L13.41 12.81L13.59 12.81L13.59 11.96L13.48 11.96L13.43 11.96L13.41 11.93L13.39 11.89L13.37 11.82L13.38 11.71L14.16 6.75L13.74 6.69L13.31 6.69L12.53 11.62L12.52 11.88L12.57 12.16Z",
        "fill": "accent"
      },
      {
        "type": "polygon",
        "d": "M10.39 9.62L10.58 9.46L10.77 9.37L10.95 9.34L11.09 9.37L11.22 9.44L11.33 9.56L11.41 9.73L11.45 9.96L11.44 10.25L11.03 12.81L11.89 12.81L12.28 10.33L12.31 9.91L12.23 9.47L12.04 9.08L11.75 8.76L11.37 8.55L10.95 8.48L10.52 8.55L10.13 8.74L9.78 9.02L9.5 9.37L9.3 9.78L9.19 10.2L8.77 12.81L9.63 12.81L10.02 10.38L10.1 10.09L10.22 9.83Z",
        "fill": "accent"
      },
      {
        "type": "polygon",
        "d": "M17.3 9.62L17.49 9.46L17.68 9.37L17.85 9.34L18 9.37L18.12 9.44L18.23 9.56L18.32 9.73L18.36 9.96L18.34 10.25L17.94 12.81L18.8 12.81L19.19 10.33L19.21 9.91L19.13 9.47L18.95 9.08L18.66 8.76L18.28 8.55L17.86 8.48L17.43 8.55L17.03 8.74L16.69 9.02L16.41 9.37L16.2 9.78L16.09 10.2L15.68 12.81L16.54 12.81L16.92 10.38L17 10.09L17.13 9.83Z",
        "fill": "accent"
      },
      {
        "type": "polygon",
        "d": "M14.82 8.6L14.15 12.81L15.01 12.81L15.66 8.74Z",
        "fill": "accent"
      },
      {
        "type": "polygon",
        "d": "M15.07 7.05L15.92 7.05L15.76 8.08L14.91 8.08Z",
        "fill": "accent"
      }
    ],
    "xingyunyi": [
      {
        "type": "polygon",
        "d": "M16.64 6.84L15.02 6.84L13.49 7.9L13.4 7.14L13.38 6.84L11.57 6.84L10.12 7.88L9.78 6.84L9.54 6.84L9.54 6.82L7.84 6.82L7.89 6.73L8.21 6.48L8.61 6.36L9.16 6.34L19.2 6.34L19.2 5.82L9.15 5.82L8.53 5.84L7.97 6.02L7.51 6.37L7.21 6.82L5.78 6.82L4.85 6.83L4.21 6.94L3.63 7.23L3.19 7.61L2.85 8.12L2.65 8.73L2.62 9.39L3.14 9.41L3.14 9.31L3.81 9.34L4.41 9.45L4.82 9.63L5.18 9.85L5.54 10.15L6.3 10.99L7.1 11.81L7.59 12.17L8.16 12.45L8.85 12.61L9.66 12.66L11.81 12.66L11.81 12.14L9.68 12.14L8.93 12.09L8.33 11.95L7.86 11.72L7.44 11.41L6.69 10.64L5.9 9.77L5.48 9.43L5.06 9.17L4.56 8.95L3.87 8.82L3.18 8.79L3.32 8.35L3.58 7.96L3.92 7.67L4.37 7.44L4.9 7.35L7.02 7.34L6.95 7.55L6.9 8.27L6.95 9.07L7.13 9.79L7.4 10.38L7.78 10.84L8.27 11.18L8.86 11.31L13.75 11.31L13.75 10.79L8.92 10.79L8.48 10.69L8.14 10.46L7.84 10.11L7.82 10.04L8 10.04L9.61 8.89L9.99 10.04L10.83 10.04L10.29 8.4L11.75 7.35L12.62 7.35L12.76 8.55L12.17 10.04L13.02 10.04L13.58 8.67L13.49 7.93L13.77 8.34L15.2 7.35L15.89 7.35L16.12 8.4L15.46 9.9L15.41 10.04L16.27 10.04L16.96 8.48L16.85 7.97L17.13 8.32L18.94 6.84L18.12 6.84L16.83 7.9L16.65 7.12Z",
        "fill": "accent"
      },
      {
        "type": "polygon",
        "d": "M9.44 8.37L7.64 9.66L7.47 8.99L7.42 8.27L7.46 7.65L7.56 7.34L9.1 7.34Z",
        "fill": "truck"
      },
      {
        "type": "polygon",
        "d": "M4.72 8.17L4.98 7.9L5.34 7.7L5.81 7.63L5.63 8L5.26 8.29L4.93 8.34Z",
        "fill": "accent"
      }
    ],
    "aquiline": [
      {
        "type": "polygon",
        "d": "M8.22 6.62L4.94 12.66L2.9 12.66L7.58 4.04L8.86 4.04L11.79 9.44L12.02 9.86L12.31 10.25L12.66 10.57L13.06 10.84L13.5 11.03L13.96 11.15L14.44 11.19L14.92 11.15L15.39 11.03L13.97 9.53L15.15 8.43L16.72 10.1L16.99 9.66L17.17 9.18L17.26 8.68L17.25 8.17L17.16 7.67L16.97 7.19L16.7 6.76L16.36 6.38L15.95 6.07L15.5 5.84L15.01 5.69L14.5 5.64L13.98 5.67L13.48 5.79L13.01 6.01L12.58 6.31L12.95 6.68L10.95 6.68L10.95 4.68L11.33 5.06L11.79 4.7L12.29 4.4L12.83 4.17L13.39 4L13.97 3.91L14.56 3.9L15.22 3.95L15.87 4.1L16.5 4.34L17.08 4.67L17.61 5.08L18.07 5.56L18.45 6.11L18.75 6.7L18.96 7.34L19.08 7.99L19.1 8.66L19.02 9.26L18.87 9.85L18.63 10.4L18.32 10.92L17.94 11.39L18.65 12.14L17.47 13.25L16.66 12.38L16.07 12.65L15.45 12.83L14.82 12.92L14.17 12.93L13.53 12.85L12.91 12.68L12.32 12.43L11.77 12.1L11.26 11.7L10.82 11.23L10.44 10.71Z",
        "fill": "accent"
      },
      {
        "type": "polygon",
        "d": "M7.27 9.58L9.17 9.58L10.03 11.17L6.41 11.17Z",
        "fill": "#000000"
      }
    ],
    "wiio": [
      {
        "type": "polygon",
        "d": "M7.62 3.78L7.37 3.77L7.2 3.88L7.11 4.05L7.14 4.31L9.32 8.63L9.44 8.77L9.61 8.86L9.86 8.88L10.04 8.83L10.24 8.67L12.14 6.19L12.22 5.94L12.15 5.62L12.03 5.47L11.86 5.37Z",
        "fill": "#f4a665"
      },
      {
        "type": "polygon",
        "d": "M14.38 3.78L10.14 5.37L9.97 5.47L9.85 5.62L9.78 5.94L9.86 6.19L11.76 8.67L11.96 8.83L12.14 8.88L12.39 8.86L12.56 8.77L12.68 8.63L14.86 4.31L14.89 4.05L14.8 3.88L14.57 3.75Z",
        "fill": "accent"
      },
      {
        "type": "polygon",
        "d": "M12.03 5.47L11 5.05L10.08 5.4L9.93 5.52L9.82 5.68L9.78 5.94L9.86 6.19L11 7.67L12.2 6.07L12.22 5.88L12.15 5.62Z",
        "fill": "#fad3b2"
      },
      {
        "type": "polygon",
        "d": "M10.79 13.43L10.9 13.5L11.03 13.52L11.16 13.5L11.26 13.43L11.33 13.32L11.36 13.19L11.36 11.01L11.33 10.88L11.26 10.77L11.16 10.7L11.03 10.68L10.9 10.7L10.79 10.77L10.72 10.88L10.7 11.01L10.7 13.19L10.72 13.32Z",
        "fill": "accent"
      },
      {
        "type": "polygon",
        "d": "M12.31 13.43L12.42 13.5L12.54 13.52L12.67 13.5L12.78 13.43L12.85 13.32L12.87 13.19L12.87 11.01L12.85 10.88L12.78 10.77L12.67 10.7L12.54 10.68L12.42 10.7L12.31 10.77L12.24 10.88L12.21 11.01L12.21 13.19L12.24 13.32Z",
        "fill": "accent"
      },
      {
        "type": "polygon",
        "d": "M5.62 12.6L5.71 12.89L5.83 13.1L5.95 13.23L6.19 13.42L6.4 13.52L6.58 13.57L6.88 13.6L7.06 13.58L7.29 13.52L7.56 13.38L7.76 13.21L8.02 13.42L8.24 13.52L8.41 13.57L8.65 13.6L8.89 13.58L9.18 13.5L9.34 13.42L9.53 13.27L9.69 13.1L9.81 12.89L9.89 12.67L9.93 12.4L9.93 11.01L9.9 10.88L9.83 10.77L9.72 10.7L9.59 10.68L9.47 10.7L9.36 10.77L9.29 10.88L9.26 11.01L9.25 12.5L9.17 12.69L9.01 12.84L8.79 12.93L8.68 12.94L8.56 12.93L8.35 12.84L8.19 12.69L8.11 12.5L8.09 11.01L8.07 10.88L8 10.77L7.89 10.7L7.76 10.68L7.64 10.7L7.53 10.77L7.46 10.88L7.43 11.01L7.42 12.5L7.34 12.69L7.18 12.84L6.96 12.93L6.85 12.94L6.73 12.93L6.52 12.84L6.43 12.77L6.31 12.6L6.26 12.38L6.26 11.01L6.24 10.88L6.17 10.77L6.06 10.7L5.93 10.68L5.8 10.7L5.7 10.77L5.63 10.88L5.6 11.01L5.6 12.4Z",
        "fill": "accent"
      },
      {
        "type": "circle",
        "cx": 11.03,
        "cy": 9.9,
        "r": 0.41,
        "fill": "accent"
      },
      {
        "type": "circle",
        "cx": 12.54,
        "cy": 9.9,
        "r": 0.41,
        "fill": "accent"
      },
      {
        "type": "circle",
        "cx": 14.94,
        "cy": 12.11,
        "r": 1.45,
        "fill": "accent"
      },
      {
        "type": "circle",
        "cx": 14.94,
        "cy": 12.11,
        "r": 0.85,
        "fill": "truck"
      }
    ],
    "ukp-worldwide": [
      {
        "type": "polygon",
        "d": "M6.7 10.63L7.26 10.55L7.87 10.35L7.91 10.6L9.37 10.6L9.4 8.68L10.06 7.96L12.04 10.59L14.43 10.6L14.46 10.54L14.47 8.74L14.51 8.71L15.97 8.69L16.5 8.61L16.82 8.53L17.23 8.37L17.55 8.16L17.79 7.93L17.97 7.71L18.13 7.38L18.21 7.14L18.3 6.49L18.29 6.01L18.25 5.68L18.17 5.36L18.04 5.04L17.76 4.63L17.47 4.37L17.02 4.13L16.46 3.97L15.73 3.88L11.92 3.88L9.41 6.72L9.39 6.65L9.39 3.9L9.33 3.88L7.91 3.88L7.89 3.9L7.89 8.44L7.46 8.92L7.18 9.13L6.86 9.26L6.62 9.3L6.37 9.29L6.17 9.26L5.93 9.17L5.64 8.97L5.38 8.64L5.22 8.23L5.14 7.63L5.14 3.9L5.12 3.88L3.66 3.89L3.65 7.79L3.73 8.44L3.93 9.08L4.13 9.45L4.39 9.77L4.71 10.06L5.04 10.27L5.36 10.43L5.81 10.56L6.37 10.63Z",
        "fill": "accent"
      },
      {
        "type": "polygon",
        "d": "M15.92 7.38L16.21 7.3L16.42 7.19L16.54 7.06L16.67 6.82L16.75 6.49L16.76 6.13L16.72 5.84L16.63 5.64L16.51 5.48L16.38 5.38L15.97 5.22L15.44 5.17L14.47 5.18L14.47 7.4L15.44 7.42Z",
        "fill": "truck"
      },
      {
        "type": "polygon",
        "d": "M12.96 9.37L12.96 4.87L12.93 4.81L11.13 6.82L11.13 6.86L12.88 9.33L12.93 9.4Z",
        "fill": "truck"
      },
      {
        "type": "polygon",
        "d": "M4.38 12.73L4.11 11.45L3.9 11.45L3.71 11.49L4.17 13.65L4.58 13.65L4.88 12.34L5.18 13.65L5.59 13.65L6.06 11.5L5.86 11.45L5.66 11.45L5.38 12.74L5.08 11.45L4.67 11.45Z",
        "fill": "accent"
      },
      {
        "type": "polygon",
        "d": "M7.55 11.75L7.41 11.61L7.26 11.51L7.09 11.44L6.92 11.42L6.75 11.44L6.58 11.51L6.43 11.61L6.29 11.75L6.18 11.92L6.1 12.12L6.05 12.33L6.03 12.55L6.05 12.77L6.1 12.99L6.18 13.18L6.29 13.35L6.43 13.49L6.58 13.6L6.75 13.66L6.92 13.68L7.09 13.66L7.26 13.6L7.41 13.49L7.55 13.35L7.66 13.18L7.74 12.99L7.79 12.77L7.81 12.55L7.79 12.33L7.74 12.12L7.66 11.92Z",
        "fill": "accent"
      },
      {
        "type": "polygon",
        "d": "M7.27 13.07L7.19 13.16L7.11 13.23L7.01 13.27L6.92 13.28L6.82 13.27L6.73 13.23L6.65 13.16L6.57 13.07L6.51 12.96L6.47 12.83L6.44 12.7L6.43 12.55L6.44 12.41L6.47 12.27L6.51 12.15L6.57 12.04L6.65 11.95L6.73 11.88L6.82 11.84L6.92 11.82L7.01 11.84L7.11 11.88L7.19 11.95L7.27 12.04L7.33 12.15L7.37 12.27L7.4 12.41L7.41 12.55L7.4 12.7L7.37 12.83L7.33 12.96Z",
        "fill": "truck"
      },
      {
        "type": "polygon",
        "d": "M9.31 12.04L9.26 11.88L9.18 11.73L9.06 11.6L8.8 11.45L7.95 11.45L7.95 13.65L8.35 13.65L8.35 12.95L8.61 12.95L8.89 13.65L9.32 13.65L9.01 12.87L9.06 12.84L9.18 12.71L9.26 12.56L9.31 12.4L9.33 12.22Z",
        "fill": "accent"
      },
      {
        "type": "polygon",
        "d": "M8.93 12.22L8.92 12.32L8.89 12.41L8.85 12.48L8.77 12.54L8.35 12.55L8.35 11.85L8.69 11.85L8.81 11.92L8.85 11.96L8.89 12.03L8.92 12.12Z",
        "fill": "truck"
      },
      {
        "type": "polygon",
        "d": "M10.63 13.65L10.63 13.25L9.94 13.25L9.94 11.45L9.54 11.45L9.54 13.65Z",
        "fill": "accent"
      },
      {
        "type": "polygon",
        "d": "M12.3 12.55L12.28 12.29L12.21 12.04L12.09 11.82L11.92 11.65L11.73 11.54L11.52 11.45L10.76 11.45L10.76 13.65L11.52 13.65L11.73 13.57L11.92 13.46L12.09 13.28L12.21 13.06L12.28 12.81Z",
        "fill": "accent"
      },
      {
        "type": "polygon",
        "d": "M11.9 12.55L11.89 12.74L11.84 12.91L11.76 13.04L11.67 13.14L11.56 13.21L11.44 13.25L11.16 13.25L11.16 11.85L11.44 11.85L11.56 11.9L11.67 11.96L11.76 12.06L11.84 12.2L11.89 12.37Z",
        "fill": "truck"
      },
      {
        "type": "polygon",
        "d": "M13.65 11.45L13.24 11.45L12.95 12.73L12.68 11.45L12.47 11.45L12.28 11.5L12.75 13.65L13.16 13.65L13.45 12.35L13.75 13.65L14.16 13.65L14.62 11.49L14.42 11.45L14.22 11.45L13.95 12.73Z",
        "fill": "accent"
      },
      {
        "type": "polygon",
        "d": "M14.72 11.45L14.72 13.65L15.12 13.65L15.12 11.45Z",
        "fill": "accent"
      },
      {
        "type": "polygon",
        "d": "M16.8 12.04L16.68 11.82L16.52 11.65L16.33 11.54L16.12 11.45L15.36 11.45L15.36 13.65L16.12 13.65L16.33 13.57L16.52 13.46L16.68 13.28L16.8 13.06L16.88 12.81L16.9 12.55L16.88 12.29Z",
        "fill": "accent"
      },
      {
        "type": "polygon",
        "d": "M16.43 12.91L16.36 13.04L16.26 13.14L16.15 13.21L16.04 13.25L15.76 13.25L15.76 11.85L16.04 11.85L16.15 11.9L16.26 11.96L16.36 12.06L16.43 12.2L16.48 12.37L16.5 12.55L16.48 12.74Z",
        "fill": "truck"
      },
      {
        "type": "polygon",
        "d": "M17.46 12.36L17.46 11.85L18.26 11.85L18.26 11.45L17.06 11.45L17.06 13.65L18.28 13.65L18.28 13.25L17.46 13.25L17.46 12.76L18.17 12.76L18.17 12.36Z",
        "fill": "accent"
      }
    ],
    "btd": [
      {
        "type": "polygon",
        "d": "M4.12 6.15L6.75 6.15L6.9 5.35L4.27 5.35Z",
        "fill": "accent"
      },
      {
        "type": "polygon",
        "d": "M4.9 7.67L6.46 7.67L6.62 6.87L5.06 6.87Z",
        "fill": "accent"
      },
      {
        "type": "polygon",
        "d": "M4.6 9.27L6.16 9.27L6.31 8.47L4.75 8.47Z",
        "fill": "accent"
      },
      {
        "type": "polygon",
        "d": "M5.86 10.87L6.01 10.07L4.45 10.07L4.3 10.87Z",
        "fill": "accent"
      },
      {
        "type": "polygon",
        "d": "M5.54 12.55L5.69 11.75L3.05 11.75L2.9 12.55Z",
        "fill": "accent"
      },
      {
        "type": "polygon",
        "d": "M5.81 12.55L9.11 12.55L9.35 12.5L9.57 12.37L9.73 12.18L9.82 11.95L11.01 5.7L11.01 5.57L10.95 5.45L10.86 5.38L10.73 5.35L7.18 5.35L6.96 6.5L9.71 6.5L9.37 8.29L7.77 8.29L7.96 7.27L6.81 7.27Z",
        "fill": "accent"
      },
      {
        "type": "polygon",
        "d": "M7.55 9.45L9.15 9.45L8.78 11.4L7.18 11.4Z",
        "fill": "truck"
      },
      {
        "type": "polygon",
        "d": "M14.69 6.5L14.9 5.35L11.37 5.35L11.16 6.5L12.28 6.5L11.13 12.55L12.28 12.55L13.43 6.5Z",
        "fill": "#f08300"
      },
      {
        "type": "polygon",
        "d": "M13.82 12.55L17.13 12.55L17.37 12.5L17.59 12.37L17.76 12.18L17.85 11.95L19.03 5.7L19.03 5.57L18.98 5.45L18.88 5.38L18.75 5.35L15.19 5.35L14.97 6.5L17.73 6.5L16.8 11.4L15.19 11.4L15.98 7.27L14.83 7.27Z",
        "fill": "accent"
      }
    ],
    "xyl": [
      {
        "type": "polygon",
        "d": "M9.08 10.3L10.16 13.32L11 13.8L15.33 11.3L15.33 6.3L12.5 4.67L12.5 5.67L14.46 6.8L14.46 10.8L10.92 12.84L9.53 8.99L10.99 4.81L11.27 4.96L11.27 9.16L13.05 9.16L13.05 9.97L11.36 11.19L11.36 12.26L13.93 10.42L13.93 6.75L13.05 6.75L13.05 8.29L12.14 8.29L12.14 4.46L11 3.8L6.67 6.3L6.67 11.3L9.68 13.04L9.22 11.77L7.54 10.8L7.54 6.8L9.84 5.48L9.06 7.69L8.72 6.73L7.79 6.73L8.61 9L7.93 10.94L8.85 10.94Z",
        "fill": "accent"
      }
    ],
    "komon-express": [
      {
        "type": "polygon",
        "d": "M6.38 9.96L7.03 9.8L7.22 9.69L7.44 9.64L7.55 9.54L7.74 9.51L7.85 9.39L8.04 9.36L8.15 9.25L8.33 9.21L8.44 9.09L8.63 9.05L8.74 8.94L8.91 8.9L9.02 8.8L9.74 8.46L9.86 8.36L10.04 8.31L10.19 8.2L10.39 8.16L10.52 8.05L10.73 8.01L10.88 7.91L11.14 7.87L11.29 7.76L12.57 7.45L13.57 7.39L14.74 7.47L14.89 7.57L15.13 7.62L15.61 7.95L15.94 8.4L15.99 8.7L16.04 8.75L16.51 8.42L16.57 8.25L16.51 8.18L16.12 8.16L15.63 7.62L15.26 7.42L15.17 7.31L14.98 7.27L14.87 7.17L14.66 7.14L14.33 7.01L13.22 6.88L11.58 7L11.03 7.14L10.64 7.17L9.73 7.43L9.38 7.47L8.67 7.73L8.41 7.75L8.2 7.87L7.39 8.06L7.18 8.17L6.87 8.2L6.61 8.31L5.9 8.45L4.69 8.33L4.26 8.21L3.84 8.17L3.52 8.05L3.22 8.02L3.06 7.91L2.91 7.89L2.91 8.1L3.02 8.15L3.22 8.45L3.98 9.2L4.32 9.4L4.41 9.51L4.82 9.69L4.94 9.79L5.38 9.93L5.64 9.97Z",
        "fill": "accent"
      },
      {
        "type": "polygon",
        "d": "M16.38 7.88L16.54 7.74L17.4 7.71L17.88 7.59L17.95 7.53L17.84 7.44L17.38 7.44L17.25 7.31L17.04 7.27L16.95 7.16L16.77 7.13L16.72 6.97L16.77 6.86L16.97 6.86L17.06 6.99L17.25 7.01L17.38 7.14L17.71 7.15L17.97 7.24L18.25 7.25L18.61 7.04L18.66 6.82L18.64 6.59L18.53 6.57L18.33 6.83L18.18 6.82L17.94 6.67L17.88 6.43L17.66 6.39L17.58 6.28L17.04 5.93L16.82 5.7L16.53 5.63L16.43 5.52L16.1 5.52L15.98 5.63L15.71 5.68L15.54 5.79L15.26 5.82L14.95 5.94L14.26 5.94L14.18 5.99L14.16 6.06L14.24 6.34L14.44 6.43L14.63 6.6L14.58 6.8L14.85 6.87L14.98 6.99L15.17 7L15.28 7.14L15.47 7.18L15.95 7.6L16.17 7.87Z",
        "fill": "#000000"
      },
      {
        "type": "polygon",
        "d": "M16.65 6.55L16.49 6.55L16.42 6.49L16.4 6.3L16.49 6.11L16.65 6.11L16.72 6.17L16.75 6.36Z",
        "fill": "accent"
      },
      {
        "type": "polygon",
        "d": "M4.57 12.47L4.73 12.36L4.99 12.33L5.16 12.21L5.36 12.18L5.45 12.07L5.83 11.89L5.92 11.76L6.49 11.47L8.13 11.43L8.37 11.32L8.63 11.3L8.74 11.18L8.94 11.15L9.04 11.02L9.39 10.85L9.62 10.59L9.89 10.39L10.1 10.17L10.21 10.12L10.3 10.13L10.39 10.25L10.67 10.29L10.84 10.4L11.4 10.42L11.99 10.52L12.34 10.51L12.77 10.42L13.5 10.41L13.79 10.28L14.2 10.25L14.44 10.13L14.85 10.12L15.11 10.39L15.45 10.56L16.3 10.64L17.58 10.58L17.86 10.78L17.95 10.98L18.27 11.09L18.49 10.96L18.47 10.65L18.32 10.44L18.14 10.31L17.88 10.22L17.77 10.11L17.77 10L17.84 9.97L18.44 9.97L18.72 10.22L18.88 10.27L19.08 10.09L19.1 9.9L18.86 9.7L18.55 9.66L18.4 9.56L18.23 9.53L17.58 9.54L17.19 9.67L16.02 9.66L15.69 9.29L15.71 8.72L15.65 8.39L15.17 7.92L14.96 7.88L14.78 7.75L14.37 7.74L13.72 7.62L12.98 7.73L12.36 7.75L12.12 7.88L11.73 7.9L11.51 8.03L11.25 8.05L11.04 8.18L10.83 8.2L10.71 8.32L10.51 8.35L10.36 8.46L10.12 8.52L10 8.62L9.81 8.66L9.71 8.76L9.27 8.96L8.91 9.2L8.74 9.24L8.63 9.36L8.44 9.39L8.34 9.51L8.15 9.54L7.83 9.85L7.77 10.05L7.63 10.24L7.31 10.55L7.04 10.7L6.46 10.72L6.28 10.85L6.09 10.88L5.23 11.74L5.06 11.78L4.95 11.89L4.77 11.93L4.64 12.04L4.44 12.06L4.35 12.17L4.21 12.25L4.21 12.32L4.31 12.45Z",
        "fill": "#000000"
      },
      {
        "type": "polygon",
        "d": "M8.35 11.01L7.53 11.02L7.44 10.95L7.65 10.75L7.78 10.68L8 10.31L8.17 10.16L8.37 10.11L8.5 10L8.95 9.81L9.06 9.7L9.24 9.66L9.35 9.54L9.52 9.51L9.61 9.4L9.98 9.2L10.1 9.07L10.19 9.09L10.21 9.14L10.1 9.33L10.26 9.38L10.38 9.24L10.54 9.2L10.73 9.07L10.82 8.94L11.01 8.89L11.06 9.01L10.95 9.11L10.9 9.23L10.81 9.27L10.8 9.33L10.86 9.36L10.97 9.26L11.29 9.2L11.42 9.09L11.69 9.05L12.16 8.78L12.29 8.78L12.32 8.83L12.28 8.9L12.14 8.99L12.14 9.11L12.2 9.16L12.36 9.09L13.32 9.07L13.61 8.95L13.98 8.91L14.15 8.8L14.37 8.78L14.46 8.82L14.52 9.01L14.76 9.29L14.83 9.57L14.8 9.64L14.46 9.81L14.13 9.84L13.89 9.96L13.42 9.98L13.16 10.08L12.81 10.12L11.23 10.11L10.95 9.98L10.65 9.96L10.24 9.7L10.1 9.67L9.55 10.24L9.04 10.58L8.95 10.7L8.78 10.74L8.67 10.85Z",
        "fill": "truck"
      }
    ],
    "bel": [
      {
        "type": "polygon",
        "d": "M12.46 4.25L12 4.1L11.53 3.98L11.05 3.92L10.56 3.9L10.08 3.93L9.6 4.01L9.13 4.13L8.67 4.3L8.24 4.51L7.82 4.77L7.44 5.06L7.08 5.39L6.76 5.76L6.47 6.15L6.23 6.57L6.03 7.01L5.87 7.47L5.76 7.94L5.69 8.43L5.67 8.91L5.7 9.4L5.78 9.88L5.91 10.34L6.07 10.8L6.29 11.24L6.54 11.65L6.84 12.04L7.17 12.39L7.53 12.71L7.92 13L8.34 13.24L8.79 13.45L9.54 13.68L10.26 13.79L11.05 13.78L11.77 13.67L12.46 13.45L13.17 13.1L13.76 12.68L14.3 12.16L13.83 12.53L13.3 12.85L12.72 13.09L12.17 13.24L11.61 13.32L10.99 13.34L10.37 13.26L9.82 13.13L9.24 12.9L8.74 12.62L8.28 12.29L7.83 11.86L7.47 11.42L7.13 10.9L6.88 10.33L6.71 9.78L6.61 9.17L6.59 8.54L6.66 7.92L6.79 7.37L7.01 6.79L7.28 6.29L7.6 5.82L8.02 5.36L8.51 4.96L8.98 4.66L9.5 4.42L10.09 4.22L10.71 4.11L11.27 4.09L11.84 4.13Z",
        "fill": "#90a6cf"
      },
      {
        "type": "polygon",
        "d": "M6.26 6.68L6.15 6.76L6.29 6.96L6.24 7.15L6.31 7.39L6.72 7.56L7.02 7.86L7.27 7.75L7.38 7.76L7.34 8.05L7.47 8.22L7.94 8.48L8.11 8.68L8.34 9.14L8.39 9.41L8.57 9.61L9.45 10.34L9.85 10.37L9.98 10.46L9.98 10.63L9.88 10.72L9.33 10.88L8.61 10.92L8.29 11.09L8.29 11.2L8.6 11.26L8.75 11.4L9.11 11.43L9.48 11.58L10.33 11.56L10.82 11.25L11.08 11.23L11.35 11.44L11.59 11.49L11.65 11.7L11.62 12.03L11.85 12.25L12.29 12.28L12.44 12.36L12.57 12.78L13.49 12.82L13.7 12.66L13.79 12.34L13.47 12.28L13.3 12.44L12.97 12.45L12.58 12.23L12.51 12.03L12.54 11.25L12.7 11.09L12.96 11.03L13.07 10.91L13.52 10.7L13.62 10.57L14.03 10.35L14.48 9.86L14.7 9.7L14.9 9.65L15.01 9.51L15.22 9.47L15.26 9.39L15.16 9.32L14.35 9.27L13.99 9.34L13.83 9.47L13.44 9.54L13.27 9.48L13.26 9.33L13.41 9.01L13.53 8.94L13.81 8.54L14.22 8.25L14.49 7.94L14.92 7.72L15.11 7.53L15.18 7.32L15.49 6.89L16.16 6.31L16.17 6.21L16.06 6.05L16.33 5.58L16.22 5.51L15.77 5.88L15.65 5.86L15.69 5.59L16.02 5.06L15.98 4.97L15.86 4.98L15.77 5.12L15.54 5.25L15.22 5.76L15.04 5.92L14.84 5.93L14.64 6.3L14.53 6.33L14.39 6.21L14.27 6.22L14.01 6.48L13.6 6.74L13 7.38L12.68 7.42L12.38 7.61L11.5 8.48L11.42 8.7L11.2 8.99L10.98 8.95L9.34 7.25L9.11 7.2L9 7.08L8.56 6.86L8.46 6.73L8.25 6.68L8.01 6.5L7.66 6.05L7.48 5.94L7.37 5.71L7.22 5.72L7.16 5.8L7.17 5.96L7.31 6.09L7.3 6.24L7.19 6.24L7.05 6.06L6.77 6.02L6.66 6.16L6.42 6.25L6.58 6.54L6.58 6.66Z",
        "fill": "accent"
      }
    ],
    "parcelabc": [
      {
        "type": "polygon",
        "d": "M6.59 11.16L11 13.7L11 8.99L7.07 6.72L11 4.45L11 3.9L6.59 6.44Z",
        "fill": "#147390"
      },
      {
        "type": "polygon",
        "d": "M15.41 6.44L11 3.9L11 4.45L14.93 6.72L11 8.99L11 13.7L15.41 11.16Z",
        "fill": "accent"
      },
      {
        "type": "polygon",
        "d": "M8.61 6.37L10.77 6.37L10.77 5.23L13.29 6.71L10.77 8.19L10.77 7.05L8.61 7.05Z",
        "fill": "accent"
      }
    ],
    "pago": [
      {
        "type": "polygon",
        "d": "M6.22 3.85L15.78 3.85L15.78 4.15L6.22 4.15Z",
        "fill": "#7f7f7f"
      },
      {
        "type": "polygon",
        "d": "M6.22 4.7L15.78 4.7L15.78 4.99L6.22 4.99Z",
        "fill": "#7f7f7f"
      },
      {
        "type": "polygon",
        "d": "M6.22 5.54L15.78 5.54L15.78 5.84L6.22 5.84Z",
        "fill": "#7f7f7f"
      },
      {
        "type": "polygon",
        "d": "M6.22 6.39L15.78 6.39L15.78 6.68L6.22 6.68Z",
        "fill": "#7f7f7f"
      },
      {
        "type": "polygon",
        "d": "M6.22 7.23L15.78 7.23L15.78 7.53L6.22 7.53Z",
        "fill": "#7f7f7f"
      },
      {
        "type": "polygon",
        "d": "M6.22 8.08L15.78 8.08L15.78 8.37L6.22 8.37Z",
        "fill": "#7f7f7f"
      },
      {
        "type": "polygon",
        "d": "M6.22 8.93L15.78 8.93L15.78 9.22L6.22 9.22Z",
        "fill": "#7f7f7f"
      },
      {
        "type": "polygon",
        "d": "M6.22 9.77L15.78 9.77L15.78 10.07L6.22 10.07Z",
        "fill": "#7f7f7f"
      },
      {
        "type": "polygon",
        "d": "M6.22 10.62L15.78 10.62L15.78 10.91L6.22 10.91Z",
        "fill": "#7f7f7f"
      },
      {
        "type": "polygon",
        "d": "M6.22 11.46L15.78 11.46L15.78 11.76L6.22 11.76Z",
        "fill": "#7f7f7f"
      },
      {
        "type": "polygon",
        "d": "M6.22 12.31L15.78 12.31L15.78 12.6L6.22 12.6Z",
        "fill": "#7f7f7f"
      },
      {
        "type": "polygon",
        "d": "M6.22 13.15L15.78 13.15L15.78 13.45L6.22 13.45Z",
        "fill": "#7f7f7f"
      },
      {
        "type": "polygon",
        "d": "M6.92 5.44L8.57 5.44L8.57 13.49L6.92 13.49Z",
        "fill": "accent"
      },
      {
        "type": "line",
        "d": "M14.82 8.99L14.8 9.39L14.72 9.78L14.59 10.15L14.42 10.51L14.2 10.84L13.94 11.14L13.64 11.4L13.31 11.62L12.95 11.79L12.58 11.92L12.19 12L11.79 12.02L11.4 12L11.01 11.92L10.63 11.79L10.28 11.62L9.95 11.4L9.65 11.14L9.39 10.84L9.17 10.51L8.99 10.15L8.87 9.78L8.79 9.39L8.76 8.99L8.79 8.6L8.87 8.21L8.99 7.83L9.17 7.48L9.39 7.15L9.65 6.85L9.95 6.59L10.28 6.37L10.63 6.2L11.01 6.07L11.4 5.99L11.79 5.96L12.19 5.99L12.58 6.07L12.95 6.2L13.31 6.37L13.64 6.59L13.94 6.85L14.2 7.15L14.42 7.48L14.59 7.83L14.72 8.21L14.8 8.6L14.82 8.99L14.8 9.39",
        "stroke": "accent",
        "strokeWidth": 0.5
      },
      {
        "type": "polygon",
        "d": "M14.35 7.98L13.29 7.98L13.27 7.71L13.16 7.57L12.76 7.29L12.32 7.11L11.97 7.04L11.57 7.04L11 7.18L10.56 7.42L10.29 7.65L10 8.02L9.83 8.37L9.71 8.81L9.7 9.21L9.77 9.65L9.88 9.96L10.02 10.22L10.26 10.53L10.56 10.79L10.86 10.97L11.44 11.16L11.93 11.17L12.19 11.14L12.68 10.97L13.14 10.66L13.49 10.27L13.73 9.78L13.65 9.75L11.62 9.74L11.59 9.69L11.62 9.08L14 9.06L14.05 9.08L14.08 9.16L14.06 10.6L14.12 10.6L14.31 10.26L14.46 9.91L14.56 9.54L14.61 9.17L14.6 8.68L14.5 8.21L14.39 7.89L14.34 7.88Z",
        "fill": "accent"
      }
    ],
    "safeway-express-cargo": [
      {
        "type": "polygon",
        "d": "M8.21 13.38L7.43 12.91L6.69 12.36L5.6 11.46L4.76 10.71L5.62 9.72L6.59 8.71L7.87 7.56L8.9 6.77L9.8 6.15L10.86 5.54L12.05 4.96L12.88 4.66L14.16 3.95L14.2 3.9L13.78 3.97L12.78 4.2L12.05 4.41L11.18 4.71L10.31 5.06L9.48 5.44L8 6.24L6.27 7.37L5.6 7.85L4.89 8.43L4.24 9.04L3.86 9.46L3.09 10.42L2.9 10.71L3.23 11.07L3.86 11.62L4.89 12.32L5.5 12.67L6.17 12.97L6.78 13.16L7.62 13.34L8.2 13.4Z",
        "fill": "accent"
      },
      {
        "type": "polygon",
        "d": "M8.77 13.39L8.79 13.38L8.76 13.34L5.95 10.71L6.71 9.81L7.34 9.14L8.39 8.14L9.19 7.43L10.76 6.25L11.82 5.51L12.8 4.87L12.78 4.86L12.01 5.18L10.96 5.73L9.86 6.41L8.77 7.21L7.88 7.95L7.04 8.73L6.05 9.76L5.23 10.71L6.14 11.52L7.49 12.59L8.32 13.16Z",
        "fill": "#e00613"
      },
      {
        "type": "polygon",
        "d": "M11.3 7.44L11.18 8.01L11.52 8.48L12.4 8.75L12.54 8.94L12.5 9.14L12.26 9.3L11.92 9.3L11.61 9.09L11.36 9.46L11.78 9.75L12.4 9.75L12.9 9.41L13.03 8.84L12.68 8.37L11.8 8.1L11.66 7.91L11.71 7.71L11.93 7.55L12.25 7.55L12.55 7.76L12.81 7.39L12.4 7.1L11.79 7.1Z",
        "fill": "accent"
      },
      {
        "type": "polygon",
        "d": "M14.65 7.1L14.01 7.1L13.28 9.62L13.71 9.75L13.91 9.05L14.75 9.05L14.95 9.75L15.39 9.62Z",
        "fill": "accent"
      },
      {
        "type": "polygon",
        "d": "M14.33 7.61L14.62 8.6L14.04 8.6Z",
        "fill": "truck"
      },
      {
        "type": "polygon",
        "d": "M16.26 8.65L17.06 8.65L17.06 8.2L16.26 8.2L16.26 7.55L17.24 7.55L17.24 7.1L15.81 7.1L15.81 9.75L16.26 9.75Z",
        "fill": "accent"
      },
      {
        "type": "polygon",
        "d": "M19.1 9.3L18.11 9.3L18.11 8.65L18.91 8.65L18.91 8.2L18.11 8.2L18.11 7.55L19.1 7.55L19.1 7.1L17.66 7.1L17.66 9.75L19.1 9.75Z",
        "fill": "accent"
      },
      {
        "type": "polygon",
        "d": "M16.1 10.45L15.73 10.71L16.53 11.85L16.53 13.1L16.98 13.1L16.98 11.85L17.77 10.71L17.41 10.45L16.75 11.38Z",
        "fill": "accent"
      },
      {
        "type": "polygon",
        "d": "M12.54 12.05L12.79 13.1L13.39 13.1L13.89 10.54L13.45 10.45L13.08 12.37L12.81 11.29L12.26 11.29L12 12.37L11.62 10.45L11.18 10.54L11.68 13.1L12.28 13.1Z",
        "fill": "accent"
      },
      {
        "type": "polygon",
        "d": "M15.95 12.97L15.22 10.45L14.58 10.45L13.84 12.97L14.28 13.1L14.48 12.4L15.32 12.4L15.52 13.1Z",
        "fill": "accent"
      },
      {
        "type": "polygon",
        "d": "M14.61 11.95L14.9 10.96L15.19 11.95Z",
        "fill": "truck"
      }
    ],
    "w-express-ph": [
      {
        "type": "polygon",
        "d": "M13.46 5.31L13.68 5.19L13.87 4.93L13.93 4.74L13.92 4.41L13.8 4.16L13.52 3.93L13.27 3.86L12.94 3.88L12.68 4.03L12.49 4.28L12.41 4.61L12.46 4.87L12.62 5.12L12.81 5.28L13.14 5.36Z",
        "fill": "accent"
      },
      {
        "type": "polygon",
        "d": "M12.08 8.28L12.96 6.54L13.04 6.16L12.94 5.9L12.75 5.67L12.43 5.49L12.17 5.42L12.14 5.45L12.27 5.77L12.2 6.03L12.1 6.12L11.54 6.41L12.05 6.74Z",
        "fill": "accent"
      },
      {
        "type": "polygon",
        "d": "M14.81 12.83L17.14 5.9L17.07 5.86L15.2 5.86L15.16 5.9L13.63 10.41L13.62 10.54L13.71 10.73L14.75 12.84Z",
        "fill": "accent"
      },
      {
        "type": "polygon",
        "d": "M7.27 12.83L8.39 10.48L6.9 6.03L6.82 5.86L4.88 5.87L4.86 5.9L7.2 12.85Z",
        "fill": "accent"
      },
      {
        "type": "polygon",
        "d": "M14.36 13.35L12.1 8.74L10.23 9.91L9.52 9.53L7.63 13.38L7.65 13.45L7.72 13.45L9.59 13.42L11.01 10.58L12.43 13.43L14.3 13.45L14.36 13.44Z",
        "fill": "accent"
      },
      {
        "type": "polygon",
        "d": "M10.83 7.53L11.39 8.66L11.34 8.99L11.79 8.71L11.79 7.02Z",
        "fill": "#ec1a22"
      },
      {
        "type": "polygon",
        "d": "M10.53 7.03L10.7 7.33L11.72 6.78L11.33 6.57L10.53 6.96Z",
        "fill": "#ec1a22"
      },
      {
        "type": "polygon",
        "d": "M10.66 9.16L10.35 8.69L10.38 9.56L10.97 9.21L10.88 9.23Z",
        "fill": "#ec1a22"
      },
      {
        "type": "polygon",
        "d": "M8.71 6.74L9.56 7.2L9.39 6.88L9.39 6.73L9.46 6.52L9.63 6.37L10.27 6.04L10.12 6.04Z",
        "fill": "#ec1a22"
      },
      {
        "type": "polygon",
        "d": "M8.63 7.02L8.63 8.72L10.04 9.56L10.09 8.22L9.84 7.72L9.74 7.61Z",
        "fill": "#ec1a22"
      }
    ],
    "ecohai": [
      {
        "type": "polygon",
        "d": "M4.59 10.24L3.42 10.24L3.42 9.46L4.38 9.46L4.38 8.94L3.42 8.94L3.42 8.16L4.59 8.16L4.59 7.64L2.9 7.64L2.9 10.76L4.59 10.76Z",
        "fill": "accent"
      },
      {
        "type": "polygon",
        "d": "M5.74 7.69L5.43 7.84L5.19 8.08L5.03 8.39L4.98 8.71L4.98 9.69L5.03 10.01L5.19 10.32L5.43 10.56L5.74 10.71L6.08 10.77L6.42 10.71L6.73 10.55L6.94 10.33L6.57 9.97L6.41 10.12L6.26 10.21L6.08 10.24L5.9 10.21L5.74 10.13L5.61 10.01L5.53 9.85L5.5 9.65L5.5 8.75L5.53 8.55L5.61 8.39L5.74 8.27L5.9 8.19L6.08 8.16L6.26 8.19L6.41 8.28L6.57 8.43L6.94 8.07L6.73 7.85L6.42 7.69L6.08 7.63Z",
        "fill": "accent"
      },
      {
        "type": "polygon",
        "d": "M12.98 7.64L12.98 10.76L13.5 10.76L13.5 9.46L14.6 9.46L14.6 10.76L15.12 10.76L15.12 7.64L14.6 7.64L14.6 8.94L13.5 8.94L13.5 7.64Z",
        "fill": "accent"
      },
      {
        "type": "polygon",
        "d": "M17.45 7.64L16.25 7.64L15.61 10.66L16.12 10.76L16.3 9.93L17.4 9.93L17.57 10.76L18.08 10.66Z",
        "fill": "accent"
      },
      {
        "type": "polygon",
        "d": "M16.41 9.41L16.67 8.16L17.03 8.16L17.29 9.41Z",
        "fill": "truck"
      },
      {
        "type": "polygon",
        "d": "M18.58 10.76L19.1 10.76L19.1 7.64L18.58 7.64Z",
        "fill": "accent"
      },
      {
        "type": "circle",
        "cx": 9.86,
        "cy": 9.2,
        "r": 2.63,
        "fill": "accent"
      },
      {
        "type": "circle",
        "cx": 9.86,
        "cy": 9.2,
        "r": 2.11,
        "fill": "truck"
      }
    ],
    "qls-quince": [
      {
        "type": "polygon",
        "d": "M6.42 13.5L11 7.39L15.58 13.5L13.4 13.5L11 9.57L8.6 13.5Z",
        "fill": "accent"
      },
      {
        "type": "polygon",
        "d": "M7.51 8.48L11 3.9L14.49 8.48L12.96 8.48L11 5.65L9.04 8.48Z",
        "fill": "#6ba8d9"
      }
    ],
    "hongsuda": [
      {
        "type": "polygon",
        "d": "M17.79 12.16L15.73 10.23L13.59 9.92L11.18 9.77L9.71 9.77L8.18 9.83L6.84 9.94L5.15 10.15L3.87 10.37L2.9 10.6L4.51 10.37L6.53 10.23L8.75 10.24L10.47 10.37L12.72 10.68L14.35 11.03L15.99 11.49Z",
        "fill": "#0a99fd"
      },
      {
        "type": "polygon",
        "d": "M6.76 8.1L8.46 8.1L8.02 9.37L8.86 9.67L10.17 5.94L9.32 5.64L8.78 7.21L7.07 7.21L7.51 5.94L6.67 5.64L5.36 9.37L6.21 9.67Z",
        "fill": "accent"
      },
      {
        "type": "polygon",
        "d": "M10.68 7.06L11.27 7.89L12.87 8.23L12.9 8.27L12.83 8.38L12.21 8.63L11.47 8.63L10.96 8.36L10.54 9.14L11.24 9.52L12.38 9.52L13.41 9.12L14.01 8.25L13.39 7.43L11.8 7.08L11.77 7.05L11.85 6.93L12.45 6.69L13.15 6.69L13.62 6.95L14.06 6.18L13.39 5.79L12.27 5.79L11.27 6.2Z",
        "fill": "accent"
      },
      {
        "type": "polygon",
        "d": "M17.3 9.48L17.68 9.34L18.03 9.12L18.34 8.85L18.59 8.52L18.76 8.18L19.02 7.42L19.1 7.06L19.07 6.67L18.92 6.3L18.65 6.01L18.29 5.84L17.93 5.79L15.77 5.79L14.46 9.52L16.93 9.52Z",
        "fill": "accent"
      },
      {
        "type": "polygon",
        "d": "M18.03 6.71L18.11 6.75L18.16 6.8L18.19 6.87L18.2 6.99L18.16 7.18L17.93 7.84L17.83 8.05L17.68 8.24L17.5 8.4L17.29 8.53L17.09 8.6L16.88 8.63L15.72 8.63L16.4 6.69L17.87 6.69Z",
        "fill": "truck"
      },
      {
        "type": "circle",
        "cx": 4.57,
        "cy": 7.36,
        "r": 1.12,
        "fill": "#0b52c2"
      },
      {
        "type": "circle",
        "cx": 4.57,
        "cy": 7.36,
        "r": 0.94,
        "fill": "#269ded"
      }
    ],
    "expedico": [
      {
        "type": "polygon",
        "d": "M8.13 6.23L8.08 6.64L8.09 7.03L8.12 7.13L8.29 7.31L8.55 7.52L8.92 7.72L9.48 7.92L10.05 8.05L10.73 8.12L11.56 8.12L12.56 7.98L13.03 7.84L13.48 7.64L13.83 7.4L13.89 7.26L13.92 6.55L13.89 6.27L13.81 6.03L13.37 6.47L12.75 6.79L12.06 7L10.99 7.13L10.03 7.07L9.39 6.93L8.74 6.66Z",
        "fill": "accent"
      },
      {
        "type": "polygon",
        "d": "M8.43 7.96L8.46 8.16L8.66 8.43L8.97 8.64L9.41 8.83L10.24 9.04L10.86 9.1L11.56 9.1L12.45 8.97L13.17 8.71L13.5 8.31L13.77 7.7L13.73 7.68L13.21 7.98L12.47 8.23L11.75 8.37L11.04 8.43L9.94 8.38L9.54 8.31L8.85 8.11L8.48 7.94Z",
        "fill": "accent"
      },
      {
        "type": "polygon",
        "d": "M8.32 5.58L8.45 5.89L8.69 6.13L9.25 6.47L10.11 6.73L10.97 6.82L11.82 6.79L12.84 6.53L13.43 6.2L13.69 5.94L13.77 5.79L13.49 5.22L13.15 4.79L13.03 5.13L12.76 5.41L12.29 5.67L11.63 5.88L11.12 5.95L10.49 5.95L9.69 5.81L9.37 5.68L9.06 5.47L8.7 5L8.45 5.32Z",
        "fill": "accent"
      },
      {
        "type": "polygon",
        "d": "M9.19 4.66L9.17 4.85L9.25 5.01L9.38 5.14L9.7 5.35L10.25 5.54L11.07 5.66L11.85 5.62L12.37 5.48L12.63 5.34L12.84 5.16L12.97 4.99L13.01 4.79L12.97 4.59L12.71 4.38L12.39 4.19L11.94 3.99L11.89 4.01L11.98 4.16L11.99 4.34L11.91 4.57L11.64 4.82L11.32 4.95L11.03 5.02L10.67 5.02L10.2 4.89L9.9 4.61L9.79 4.18L9.43 4.38Z",
        "fill": "accent"
      },
      {
        "type": "polygon",
        "d": "M9.5 9.27L9.76 9.43L10.33 9.63L10.77 9.7L11.22 9.69L11.66 9.63L12.09 9.5L12.49 9.3L12.71 9.13L11.36 9.37L10.25 9.37Z",
        "fill": "accent"
      },
      {
        "type": "polygon",
        "d": "M10.3 4.35L10.42 4.49L10.63 4.62L11.21 4.73L11.65 4.62L11.84 4.44L11.87 4.31L11.85 4.18L11.64 3.99L11.45 3.91L11.11 3.9L10.86 3.92L10.51 4.06L10.3 4.26Z",
        "fill": "accent"
      },
      {
        "type": "polygon",
        "d": "M4.39 12.65L3.36 12.65L3.36 11.96L4.2 11.96L4.2 11.5L3.36 11.5L3.36 10.81L4.39 10.81L4.39 10.35L2.9 10.35L2.9 13.11L4.39 13.11Z",
        "fill": "accent"
      },
      {
        "type": "polygon",
        "d": "M6.89 10.61L6.5 10.35L5.87 11.32L5.23 10.35L4.85 10.61L5.59 11.73L4.85 12.86L5.23 13.11L5.87 12.15L6.5 13.11L6.89 12.86L6.14 11.73Z",
        "fill": "accent"
      },
      {
        "type": "polygon",
        "d": "M9.12 11.5L9.19 11.18L9.12 10.86L8.94 10.59L8.67 10.41L8.38 10.35L7.34 10.35L7.34 13.11L7.8 13.11L7.8 12.01L8.38 12.01L8.67 11.95L8.94 11.77Z",
        "fill": "accent"
      },
      {
        "type": "polygon",
        "d": "M8.69 11.04L8.72 11.18L8.69 11.32L8.61 11.44L8.49 11.52L8.33 11.55L7.8 11.55L7.8 10.81L8.33 10.81L8.49 10.85L8.61 10.92Z",
        "fill": "truck"
      },
      {
        "type": "polygon",
        "d": "M11.14 12.65L10.1 12.65L10.1 11.96L10.95 11.96L10.95 11.5L10.1 11.5L10.1 10.81L11.14 10.81L11.14 10.35L9.64 10.35L9.64 13.11L11.14 13.11Z",
        "fill": "accent"
      },
      {
        "type": "polygon",
        "d": "M12.93 12.93L13.21 12.71L13.43 12.42L13.57 12.09L13.62 11.73L13.57 11.37L13.43 11.04L13.21 10.76L12.93 10.54L12.6 10.4L12.25 10.35L11.6 10.35L11.6 13.11L12.25 13.11L12.6 13.06Z",
        "fill": "accent"
      },
      {
        "type": "polygon",
        "d": "M12.89 11.08L13.03 11.27L13.12 11.49L13.15 11.73L13.12 11.97L13.03 12.19L12.89 12.38L12.7 12.53L12.48 12.62L12.22 12.65L12.05 12.65L12.05 10.81L12.22 10.81L12.48 10.85L12.7 10.94Z",
        "fill": "truck"
      },
      {
        "type": "polygon",
        "d": "M14.08 10.35L14.08 13.11L14.54 13.11L14.54 10.35Z",
        "fill": "accent"
      },
      {
        "type": "polygon",
        "d": "M18.07 10.35L17.67 10.43L17.33 10.65L17.11 10.99L17.03 11.36L17.03 12.1L17.11 12.47L17.33 12.81L17.67 13.03L18.07 13.11L18.46 13.03L18.8 12.81L19.03 12.47L19.1 12.1L19.1 11.36L19.03 10.99L18.8 10.65L18.46 10.43Z",
        "fill": "accent"
      },
      {
        "type": "polygon",
        "d": "M18.59 12.29L18.47 12.48L18.28 12.6L18.07 12.65L17.85 12.6L17.66 12.48L17.54 12.29L17.49 12.05L17.49 11.41L17.54 11.17L17.66 10.98L17.85 10.86L18.07 10.82L18.28 10.86L18.47 10.98L18.59 11.17L18.64 11.41L18.64 12.05Z",
        "fill": "truck"
      },
      {
        "type": "polygon",
        "d": "M15.4 10.53L15.18 10.75L15.04 11.02L14.99 11.3L14.99 12.16L15.04 12.45L15.18 12.72L15.4 12.93L15.67 13.07L15.97 13.11L16.27 13.06L16.54 12.92L16.73 12.73L16.4 12.41L16.26 12.55L16.12 12.62L15.96 12.65L15.81 12.62L15.67 12.55L15.55 12.44L15.48 12.3L15.45 12.13L15.45 11.34L15.48 11.16L15.55 11.02L15.67 10.91L15.81 10.84L15.96 10.82L16.12 10.84L16.26 10.92L16.4 11.06L16.73 10.74L16.54 10.55L16.27 10.4L15.97 10.35L15.67 10.4Z",
        "fill": "accent"
      }
    ],
    "pasarex": [
      {
        "type": "polygon",
        "d": "M7.65 8.3L7.92 8.87L8.77 9.16L8.84 9.29L8.75 9.49L8.47 9.67L8.16 9.67L7.91 9.47L7.56 9.89L7.96 10.22L8.63 10.22L9.2 9.87L9.45 9.27L9.16 8.7L8.32 8.42L8.26 8.29L8.34 8.08L8.61 7.91L8.9 7.91L9.13 8.11L9.49 7.69L9.11 7.35L8.45 7.35L7.89 7.71Z",
        "fill": "accent"
      },
      {
        "type": "polygon",
        "d": "M7.16 10.17L7.19 7.35L6.03 7.35L4.96 10.07L5.48 10.27L5.79 9.48L6.61 9.48L6.61 10.17Z",
        "fill": "accent"
      },
      {
        "type": "polygon",
        "d": "M6.4 7.91L6.63 7.91L6.62 8.93L6.01 8.93Z",
        "fill": "truck"
      },
      {
        "type": "polygon",
        "d": "M11.76 10.17L11.78 7.35L10.62 7.35L9.56 10.07L10.08 10.27L10.38 9.48L11.21 9.48L11.2 10.17Z",
        "fill": "accent"
      },
      {
        "type": "polygon",
        "d": "M11 7.91L11.22 7.91L11.21 8.93L10.6 8.93Z",
        "fill": "truck"
      },
      {
        "type": "polygon",
        "d": "M4.88 8.87L5.11 8.61L5.24 8.29L5.24 7.94L5.09 7.63L4.82 7.42L4.51 7.35L3.46 7.35L2.9 10.17L3.45 10.28L3.68 9.11L4.26 9.11L4.58 9.05Z",
        "fill": "accent"
      },
      {
        "type": "polygon",
        "d": "M4.58 7.93L4.65 7.98L4.68 8.06L4.68 8.18L4.63 8.32L4.52 8.44L4.38 8.52L4.21 8.56L3.79 8.56L3.92 7.91L4.45 7.91Z",
        "fill": "truck"
      },
      {
        "type": "polygon",
        "d": "M14.18 8.87L14.41 8.61L14.53 8.29L14.54 7.94L14.39 7.63L14.12 7.42L13.8 7.35L12.71 7.35L12.15 10.17L12.7 10.28L12.93 9.11L13.05 9.11L13.74 10.19L14.21 9.9L13.69 9.09L13.87 9.05Z",
        "fill": "accent"
      },
      {
        "type": "polygon",
        "d": "M13.88 7.93L13.94 7.98L13.98 8.06L13.98 8.18L13.92 8.32L13.82 8.44L13.67 8.52L13.51 8.56L13.04 8.56L13.17 7.91L13.75 7.91Z",
        "fill": "truck"
      },
      {
        "type": "polygon",
        "d": "M16.16 10.22L16.16 9.67L15.23 9.67L15.35 9.07L16.2 9.07L16.2 8.51L15.46 8.51L15.58 7.91L16.62 7.91L16.62 7.35L15.12 7.35L14.55 10.22Z",
        "fill": "#119ad7"
      },
      {
        "type": "polygon",
        "d": "M18.15 8.83L19.1 7.67L18.67 7.32L17.91 8.25L17.54 7.39L17.03 7.61L17.51 8.74L16.56 9.9L16.99 10.25L17.75 9.32L18.11 10.18L18.63 9.97Z",
        "fill": "#119ad7"
      }
    ],
    "parceljet": [
      {
        "type": "polygon",
        "d": "M15.48 7.33L15.24 6.68L14.87 6.03L14.41 5.44L13.9 4.96L13.28 4.53L12.63 4.22L11.92 4L11.11 3.9L10.43 3.91L9.59 4.06L8.82 4.35L8.14 4.75L7.61 5.17L6.99 5.87L6.64 6.43L6.33 7.14L6.34 7.17L6.74 7.17L7.01 6.65L7.41 6.09L7.86 5.64L8.42 5.24L8.91 4.99L9.47 4.81L9.97 4.72L10.62 4.7L11.11 4.75L11.73 4.91L12.35 5.18L12.78 5.46L13.16 5.77L13.56 6.21L13.88 6.68L14.21 7.34Z",
        "fill": "accent"
      },
      {
        "type": "polygon",
        "d": "M11.14 13.49L11.82 13.41L12.32 13.28L12.94 13.04L13.5 12.72L14.02 12.33L14.5 11.85L14.9 11.32L15.18 10.83L13.81 10.81L13.37 11.35L13 11.71L12.63 11.99L12.13 12.26L11.67 12.45L11.2 12.57L10.77 12.63L10.12 12.63L9.66 12.57L9.1 12.41L8.6 12.2L8.11 11.89L7.74 11.58L7.23 11.01L6.92 10.52L6.65 9.87L6.22 9.87L6.46 10.58L6.89 11.38L7.42 12.03L8.08 12.6L8.82 13.04L9.53 13.31L10.34 13.47Z",
        "fill": "accent"
      },
      {
        "type": "polygon",
        "d": "M14.83 8.74L14.72 8.9L14.57 9.03L14.4 9.14L14.22 9.2L14.05 9.22L13.16 9.22L13.16 9.71L14.08 9.71L14.34 9.68L14.61 9.58L14.86 9.43L15.08 9.23L15.26 8.99L15.37 8.75L15.78 7.5L15.32 7.34L14.92 8.57Z",
        "fill": "accent"
      },
      {
        "type": "polygon",
        "d": "M8.77 8.85L9.02 8.8L9.27 8.66L9.48 8.46L9.61 8.21L9.64 7.93L9.55 7.66L9.34 7.47L9.08 7.42L7.28 7.42L6.54 9.64L7.01 9.79L7.32 8.85Z",
        "fill": "accent"
      },
      {
        "type": "polygon",
        "d": "M7.63 7.91L9.03 7.91L9.11 7.92L9.13 7.94L9.15 7.98L9.14 8.06L9.08 8.17L8.98 8.27L8.86 8.33L8.73 8.36L7.48 8.36Z",
        "fill": "truck"
      },
      {
        "type": "polygon",
        "d": "M12.17 7.42L11.28 7.42L10.5 7.66L10.06 8.21L10.61 8.69L12.06 8.91L12.15 8.99L12.1 9.05L11.51 9.22L10.76 9.22L10.23 9.03L10.06 9.49L10.67 9.71L11.58 9.71L12.39 9.47L12.83 8.91L12.26 8.44L10.82 8.23L10.74 8.15L10.79 8.08L11.36 7.91L12.08 7.91L12.57 8.1L12.75 7.64Z",
        "fill": "#cd6911"
      }
    ],
    "letter-track": [
      {
        "type": "polygon",
        "d": "M16.13 13.5L16.43 13.43L16.7 13.24L16.86 12.98L16.92 12.69L16.92 4.73L16.87 4.44L16.79 4.27L16.64 4.1L16.39 3.95L16.13 3.9L5.94 3.9L5.64 3.97L5.34 4.18L5.22 4.39L5.15 4.65L5.16 4.82L5.28 5.16L10.34 11.02L10.62 11.29L10.89 11.4L11.27 11.38L11.61 11.19L13.47 8.96L13.51 8.94L13.6 8.99L14.28 9.56L14.58 6.34L11.48 7.11L11.45 7.14L11.48 7.2L12.25 7.86L11.18 9.16L11.06 9.29L11.02 9.29L7.82 5.62L7.8 5.54L15.25 5.52L15.3 5.54L15.3 5.58L15.29 11.86L6.74 11.87L6.71 11.84L6.7 7.95L6.58 7.65L6.36 7.43L6.07 7.31L5.73 7.31L5.44 7.44L5.3 7.57L5.18 7.74L5.08 8.08L5.08 12.69L5.16 13.03L5.35 13.28L5.56 13.42L5.85 13.5Z",
        "fill": "accent"
      }
    ],
    "frontier-ca": [
      {
        "type": "polygon",
        "d": "M12.53 7.34L13.01 7.34L13.01 9.54L13.5 9.54L13.5 7.34L13.98 7.34L13.98 6.86L12.53 6.86Z",
        "fill": "#060808"
      },
      {
        "type": "polygon",
        "d": "M4.17 8.44L4.17 7.96L3.38 7.96L3.38 7.34L4.35 7.34L4.35 6.86L2.9 6.86L2.9 9.54L3.38 9.54L3.38 8.44Z",
        "fill": "#060808"
      },
      {
        "type": "polygon",
        "d": "M6.65 9.23L6 8.46L6.14 8.43L6.4 8.25L6.58 7.99L6.64 7.67L6.58 7.36L6.4 7.09L6.14 6.92L5.85 6.86L4.79 6.86L4.79 9.54L5.28 9.54L5.28 8.49L5.4 8.49L6.28 9.54Z",
        "fill": "#060808"
      },
      {
        "type": "polygon",
        "d": "M6.05 7.44L6.13 7.55L6.15 7.67L6.13 7.8L6.05 7.9L5.95 7.97L5.8 8L5.28 8L5.28 7.34L5.8 7.34L5.95 7.37Z",
        "fill": "truck"
      },
      {
        "type": "polygon",
        "d": "M12.09 6.86L11.61 6.86L11.61 9.06L11.44 9.06L11.14 6.86L10.07 6.86L10.07 9.54L10.55 9.54L10.55 7.34L10.71 7.34L11.02 9.54L12.09 9.54Z",
        "fill": "#060808"
      },
      {
        "type": "polygon",
        "d": "M14.42 6.86L14.42 9.54L14.91 9.54L14.91 6.86Z",
        "fill": "#060808"
      },
      {
        "type": "polygon",
        "d": "M15.83 9.06L15.83 8.44L16.62 8.44L16.62 7.96L15.83 7.96L15.83 7.34L16.8 7.34L16.8 6.86L15.35 6.86L15.35 9.54L16.8 9.54L16.8 9.06Z",
        "fill": "#060808"
      },
      {
        "type": "polygon",
        "d": "M19.1 9.23L18.45 8.46L18.58 8.43L18.85 8.25L19.03 7.99L19.09 7.67L19.03 7.36L18.85 7.09L18.58 6.92L18.29 6.86L17.24 6.86L17.24 9.54L17.72 9.54L17.72 8.49L17.84 8.49L18.73 9.54Z",
        "fill": "#060808"
      },
      {
        "type": "polygon",
        "d": "M18.5 7.44L18.57 7.55L18.6 7.67L18.57 7.8L18.5 7.9L18.39 7.97L18.25 8L17.72 8L17.72 7.34L18.25 7.34L18.39 7.37Z",
        "fill": "truck"
      },
      {
        "type": "circle",
        "cx": 8.32,
        "cy": 8.2,
        "r": 1.31,
        "fill": "accent"
      },
      {
        "type": "polygon",
        "d": "M9.17 7.15L8.79 7.12L8.4 7.17L8.03 7.29L7.69 7.49L7.51 7.63L7.35 7.79L7.21 7.96L7.09 8.15L6.98 8.39L7.04 8.65L7.15 8.35L7.31 8.06L7.52 7.81L7.77 7.6L7.94 7.49L8.14 7.4L8.34 7.33L8.54 7.29L8.74 7.26L8.96 7.26L9.16 7.29L9.37 7.33Z",
        "fill": "truck"
      },
      {
        "type": "polygon",
        "d": "M8.19 9.55L8.42 9.28L8.69 9.07L8.89 8.96L9.11 8.88L9.33 8.82L9.55 8.78L9.6 8.64L9.35 8.67L9.1 8.73L8.86 8.83L8.62 8.96L8.46 9.07L8.3 9.21L8.16 9.36L8.04 9.53Z",
        "fill": "truck"
      },
      {
        "type": "polygon",
        "d": "M7.81 9.46L7.93 9.24L8.09 9.03L8.28 8.84L8.49 8.69L8.76 8.54L9.06 8.45L9.36 8.4L9.66 8.41L9.68 8.27L9.35 8.26L9.02 8.31L8.71 8.42L8.42 8.57L8.24 8.69L8.1 8.82L7.95 8.97L7.83 9.13L7.68 9.4Z",
        "fill": "truck"
      },
      {
        "type": "polygon",
        "d": "M7.51 9.28L7.63 9L7.8 8.74L8.01 8.51L8.27 8.31L8.59 8.15L8.94 8.05L9.31 8.02L9.67 8.06L9.65 7.91L9.27 7.88L8.89 7.92L8.53 8.02L8.19 8.2L8.01 8.33L7.86 8.47L7.71 8.63L7.58 8.81L7.48 8.99L7.39 9.19Z",
        "fill": "truck"
      },
      {
        "type": "polygon",
        "d": "M7.25 9.03L7.37 8.71L7.55 8.41L7.77 8.15L8.04 7.94L8.21 7.84L8.4 7.76L8.58 7.7L8.78 7.66L8.99 7.64L9.18 7.64L9.39 7.67L9.59 7.72L9.51 7.55L9.12 7.5L8.91 7.51L8.72 7.53L8.52 7.57L8.33 7.64L8.13 7.72L7.96 7.82L7.78 7.96L7.61 8.12L7.46 8.29L7.33 8.48L7.23 8.68L7.15 8.89Z",
        "fill": "truck"
      },
      {
        "type": "polygon",
        "d": "M19.1 9.84L19.1 11.24L7.76 11.24L7.76 9.84Z",
        "fill": "accent"
      },
      {
        "type": "polygon",
        "d": "M9.96 10.1L9.85 10.16L9.77 10.24L9.71 10.35L9.69 10.46L9.69 10.62L9.71 10.73L9.77 10.84L9.85 10.93L9.96 10.98L10.08 11L10.2 10.98L10.31 10.92L10.38 10.84L10.24 10.71L10.19 10.77L10.14 10.8L10.08 10.81L10.02 10.8L9.97 10.77L9.92 10.73L9.89 10.67L9.88 10.61L9.88 10.48L9.89 10.41L9.92 10.36L9.97 10.31L10.02 10.29L10.08 10.28L10.14 10.29L10.19 10.32L10.24 10.37L10.38 10.24L10.31 10.16L10.2 10.11L10.08 10.09Z",
        "fill": "truck"
      },
      {
        "type": "polygon",
        "d": "M11.4 10.12L11.24 10.08L11.09 10.12L10.96 10.2L10.87 10.33L10.84 10.48L10.84 10.6L10.87 10.75L10.96 10.88L11.09 10.97L11.24 11L11.4 10.97L11.53 10.88L11.62 10.75L11.65 10.6L11.65 10.48L11.62 10.33L11.53 10.2Z",
        "fill": "truck"
      },
      {
        "type": "polygon",
        "d": "M11.39 10.74L11.32 10.79L11.24 10.8L11.16 10.79L11.1 10.74L11.05 10.68L11.03 10.59L11.03 10.5L11.05 10.41L11.1 10.34L11.16 10.29L11.24 10.28L11.32 10.29L11.39 10.34L11.44 10.41L11.46 10.5L11.46 10.59L11.44 10.68Z",
        "fill": "truck"
      },
      {
        "type": "polygon",
        "d": "M14.06 10.57L14.12 10.48L14.14 10.37L14.12 10.26L14.06 10.17L13.97 10.11L13.87 10.09L13.41 10.09L13.41 11L13.6 11L13.6 10.65L13.66 10.65L14.01 11L14.14 10.86L13.92 10.64L13.97 10.63Z",
        "fill": "truck"
      },
      {
        "type": "polygon",
        "d": "M13.92 10.3L13.94 10.33L13.95 10.37L13.94 10.4L13.92 10.43L13.89 10.45L13.85 10.46L13.6 10.46L13.6 10.28L13.85 10.28L13.89 10.29Z",
        "fill": "truck"
      },
      {
        "type": "polygon",
        "d": "M14.64 11L14.83 11L14.83 10.09L14.64 10.09Z",
        "fill": "truck"
      },
      {
        "type": "polygon",
        "d": "M15.52 10.81L15.52 10.64L15.86 10.64L15.86 10.45L15.52 10.45L15.52 10.28L15.93 10.28L15.93 10.09L15.33 10.09L15.33 11L15.93 11L15.93 10.81Z",
        "fill": "truck"
      },
      {
        "type": "polygon",
        "d": "M17.08 10.57L17.14 10.48L17.16 10.37L17.14 10.26L17.08 10.17L16.99 10.11L16.89 10.09L16.43 10.09L16.43 11L16.62 11L16.62 10.65L16.68 10.65L17.03 11L17.16 10.86L16.94 10.64L16.99 10.63Z",
        "fill": "truck"
      },
      {
        "type": "polygon",
        "d": "M16.94 10.3L16.96 10.33L16.97 10.37L16.96 10.4L16.94 10.43L16.91 10.45L16.87 10.46L16.62 10.46L16.62 10.28L16.87 10.28L16.91 10.29Z",
        "fill": "truck"
      },
      {
        "type": "polygon",
        "d": "M12.26 10.88L12.34 10.95L12.43 10.98L12.53 11L12.63 10.98L12.72 10.95L12.8 10.88L12.86 10.81L12.9 10.71L12.91 10.62L12.91 10.09L12.72 10.09L12.72 10.61L12.71 10.66L12.69 10.71L12.66 10.75L12.62 10.78L12.58 10.8L12.53 10.81L12.48 10.8L12.43 10.78L12.39 10.75L12.36 10.71L12.34 10.66L12.34 10.61L12.34 10.09L12.15 10.09L12.15 10.62L12.16 10.71L12.2 10.81Z",
        "fill": "truck"
      }
    ],
    "e24metro-ca": [
      {
        "type": "polygon",
        "d": "M7.92 11.98L7.43 11.92L6.94 11.71L6.52 11.37L6.22 10.94L6.04 10.42L6.01 10.14L6.02 9.85L6.14 9.37L6.26 9.12L6.42 8.89L6.12 9.06L5.8 9.18L5.46 9.24L5.1 9.23L4.76 9.16L4.44 9.03L4.16 8.84L3.86 8.56L3.58 8.1L3.44 7.63L3.43 7.13L3.54 6.67L3.25 7.2L3.07 7.72L2.95 8.34L2.94 8.92L3.01 9.47L3.19 10.06L3.43 10.55L3.77 11.05L4.18 11.48L4.67 11.84L5.21 12.12L5.79 12.3L6.49 12.4L7.19 12.36L7.91 12.17L8.57 11.86L8.29 11.94Z",
        "fill": "accent"
      },
      {
        "type": "polygon",
        "d": "M5.33 5.43L5.82 5.5L6.32 5.71L6.73 6.04L7.04 6.48L7.21 6.99L7.24 7.27L7.23 7.56L7.11 8.05L6.99 8.3L6.84 8.52L7.19 8.33L7.51 8.22L7.86 8.17L8.22 8.19L8.55 8.27L8.86 8.41L9.14 8.6L9.42 8.88L9.69 9.34L9.82 9.8L9.84 10.08L9.82 10.37L9.68 10.84L9.98 10.32L10.2 9.76L10.32 9.14L10.34 8.57L10.28 8.01L10.12 7.42L9.86 6.87L9.52 6.38L9.06 5.9L8.58 5.55L8.04 5.28L7.46 5.09L6.77 5L6.06 5.04L5.38 5.22L4.71 5.54L5.04 5.46Z",
        "fill": "#f2a900"
      },
      {
        "type": "polygon",
        "d": "M18.55 10.55L18.55 9.72L19.07 9.72L19.07 9.2L18.55 9.2L18.55 6.85L16.6 9.72L18.03 9.72L18.03 10.55Z",
        "fill": "accent"
      },
      {
        "type": "polygon",
        "d": "M18.03 8.54L18.03 9.2L17.59 9.2Z",
        "fill": "truck"
      },
      {
        "type": "polygon",
        "d": "M14.93 7.97L15.1 7.96L15.27 8L15.42 8.09L15.53 8.22L15.59 8.39L15.6 8.56L15.56 8.7L13.6 10.55L16.13 10.55L16.13 10.03L14.91 10.03L16.02 8.98L16.12 8.62L16.11 8.28L15.98 7.96L15.76 7.69L15.47 7.51L15.14 7.43L14.79 7.47L14.48 7.6L14.23 7.83L14.08 8.1L14.53 8.35L14.64 8.16L14.77 8.04Z",
        "fill": "accent"
      },
      {
        "type": "polygon",
        "d": "M13.03 10.55L13.03 10.03L11.86 10.03L11.86 9.25L12.82 9.25L12.82 8.73L11.86 8.73L11.86 7.95L13.03 7.95L13.03 7.43L11.35 7.43L11.35 10.55Z",
        "fill": "accent"
      }
    ],
    "hecny-ecom": [
      {
        "type": "polygon",
        "d": "M11.53 13.48L11.68 13.39L11.75 13.28L11.76 13.19L11.7 13.01L11.56 12.9L8.07 12.88L7.86 12.8L7.66 12.64L7.53 12.41L7.48 12.19L8.24 6.47L9.41 6.47L9.58 6.41L9.67 6.3L9.7 6.22L9.71 5.63L9.8 5.28L10 4.95L10.34 4.67L10.71 4.52L11.07 4.5L11.42 4.57L11.76 4.77L12.03 5.05L12.19 5.37L12.25 5.68L12.26 6.22L12.31 6.34L12.41 6.43L12.55 6.47L13.73 6.47L13.97 8.07L14.1 8.2L14.28 8.23L14.4 8.18L14.5 8.03L14.52 7.9L14.29 6.33L14.26 6.19L14.16 6.05L14.03 5.94L13.86 5.88L12.86 5.87L12.84 5.45L12.73 5.07L12.55 4.73L12.3 4.43L12 4.19L11.65 4.02L11.27 3.92L10.86 3.9L10.51 3.96L10.18 4.09L9.89 4.27L9.6 4.53L9.37 4.84L9.23 5.15L9.15 5.5L9.13 5.87L8.11 5.88L7.91 5.96L7.73 6.15L7.68 6.33L6.91 11.96L6.9 12.24L6.99 12.63L7.21 13L7.54 13.28L7.91 13.44L8.19 13.48Z",
        "fill": "accent"
      },
      {
        "type": "polygon",
        "d": "M13.54 13.49L13.75 13.41L13.93 13.27L14.09 13.05L14.15 12.84L14.51 12.9L14.69 12.86L14.84 12.78L15.01 12.59L15.09 12.35L15.1 12.12L14.72 9.4L14.59 9.1L14.46 8.98L14.33 8.93L14.18 8.92L14.01 8.96L13.75 9.16L12.13 11.39L12.04 11.56L11.99 11.73L12.01 11.99L12.14 12.23L12.31 12.37L12.62 12.47L12.57 12.63L12.57 12.86L12.63 13.07L12.76 13.25L12.93 13.39L13.1 13.47Z",
        "fill": "accent"
      },
      {
        "type": "polygon",
        "d": "M13.28 12.92L13.19 12.88L13.14 12.75L13.24 12.27L13.2 12.09L13.06 11.97L12.6 11.83L12.59 11.77L14.15 9.57L14.5 12.25L14.47 12.3L14.42 12.3L13.95 12.18L13.77 12.22L13.65 12.36L13.5 12.86L13.39 12.92Z",
        "fill": "truck"
      },
      {
        "type": "polygon",
        "d": "M10.15 7.62L9.65 7.94L10.69 9.57L10.69 10.83L11.28 10.83L11.28 9.57L12.33 7.94L11.83 7.62L10.99 8.94Z",
        "fill": "accent"
      }
    ],
    "jaskipin": [
      {
        "type": "polygon",
        "d": "M10.17 9.19L9.55 9.28L9.6 9.37L10.03 9.57L10.46 9.68L10.97 9.7L11.34 9.67L11.76 9.57L12.48 9.17L12.97 8.67L13.16 8.36L13.36 7.89L13.46 7.47L13.47 7.1L13.36 6.38L13.3 6.37L13.22 6.47L12.78 7.13L12.22 7.83L11.41 8.59L10.96 8.89L10.53 9.08Z",
        "fill": "accent"
      },
      {
        "type": "polygon",
        "d": "M8.33 6.92L8.36 7.55L8.55 7.89L8.78 8.11L9.01 8.22L9.43 8.25L9.77 8.21L10.19 8.01L10.57 7.73L10.92 7.38L11.42 6.65L11.81 5.73L12 5.04L12.01 4.84L11.89 4.75L11.58 4.64L10.82 4.55L10.2 4.65L9.7 4.84L9.14 5.24L8.73 5.72L8.44 6.32Z",
        "fill": "accent"
      },
      {
        "type": "polygon",
        "d": "M8.45 8.24L8.43 8.29L8.53 8.41L8.98 8.7L9.3 8.8L9.84 8.82L10.17 8.79L10.7 8.59L11.2 8.3L11.55 8.01L12.29 7.22L12.69 6.64L13.17 5.72L13.41 5.11L13.67 5.11L13.67 4.55L13.59 4.48L13.44 3.93L13.35 3.9L13.21 3.96L12.22 4.56L12.23 4.62L12.48 4.74L12.5 4.8L11.9 6.35L11.71 6.75L11.23 7.51L10.58 8.2L10.08 8.49L9.55 8.6L9.29 8.59L8.95 8.5Z",
        "fill": "#f61031"
      },
      {
        "type": "polygon",
        "d": "M11.65 10.38L10.39 11.45L10.57 10.44L10.07 10.35L9.55 13.28L10.05 13.37L10.25 12.24L10.57 11.97L11.11 13.29L11.58 13.1L10.97 11.62L11.98 10.77Z",
        "fill": "accent"
      },
      {
        "type": "polygon",
        "d": "M3.68 12.56L3.47 12.7L3.25 12.78L3 12.82L2.9 12.82L2.9 13.32L3.04 13.32L3.37 13.28L3.71 13.15L4.01 12.95L4.27 12.68L4.45 12.37L4.55 12.04L4.84 10.44L4.34 10.35L4.06 11.92L3.98 12.16L3.86 12.37Z",
        "fill": "accent"
      },
      {
        "type": "polygon",
        "d": "M7.72 11.92L8.58 12.21L8.66 12.39L8.57 12.62L8.28 12.82L7.95 12.82L7.69 12.6L7.36 12.99L7.76 13.32L8.43 13.32L8.99 12.96L9.22 12.36L8.94 11.8L8.09 11.51L8 11.33L8.09 11.09L8.38 10.9L8.68 10.9L8.92 11.12L9.26 10.74L8.88 10.4L8.22 10.4L7.68 10.76L7.45 11.36Z",
        "fill": "accent"
      },
      {
        "type": "polygon",
        "d": "M6.85 10.4L5.7 10.4L4.66 13.19L5.14 13.36L5.44 12.55L6.37 12.55L6.37 13.28L6.88 13.27Z",
        "fill": "accent"
      },
      {
        "type": "polygon",
        "d": "M6.05 10.9L6.35 10.9L6.36 12.04L5.63 12.04Z",
        "fill": "truck"
      },
      {
        "type": "polygon",
        "d": "M12.04 13.28L12.54 13.37L13.07 10.44L12.57 10.35Z",
        "fill": "accent"
      },
      {
        "type": "polygon",
        "d": "M19.1 10.44L18.6 10.35L18.16 12.82L17.97 12.82L18.16 10.4L16.99 10.4L16.47 13.28L16.98 13.37L17.42 10.9L17.61 10.9L17.42 13.32L18.58 13.32Z",
        "fill": "accent"
      },
      {
        "type": "polygon",
        "d": "M15.99 10.35L15.47 13.28L15.97 13.37L16.49 10.44Z",
        "fill": "accent"
      },
      {
        "type": "polygon",
        "d": "M15.2 11.65L15.33 11.32L15.32 10.98L15.17 10.67L14.9 10.46L14.58 10.4L13.57 10.4L13.05 13.28L13.55 13.37L13.77 12.16L14.35 12.16L14.67 12.1L14.97 11.92Z",
        "fill": "accent"
      },
      {
        "type": "polygon",
        "d": "M14.77 11L14.81 11.1L14.82 11.23L14.76 11.39L14.64 11.53L14.49 11.62L14.3 11.65L13.86 11.65L13.99 10.9L14.53 10.9L14.68 10.93Z",
        "fill": "truck"
      }
    ],
    "flashbird-ca": [
      {
        "type": "polygon",
        "d": "M5.86 3.92L6.56 4.51L7.5 5.45L8.21 6.32L8.92 7.4L9.81 9.19L10.53 11.26L10.62 11.23L11.1 10.68L11.48 10.17L11.62 10.11L12.17 10.77L12.81 11.75L13.75 13.5L13.76 13.34L13.57 12.6L13.16 11.55L12.7 10.59L11.68 8.84L11.61 8.83L10.97 9.6L10.87 9.6L10.33 8.11L9.92 7.35L9.21 6.34L8.8 5.86L8.06 5.18L8.01 5.05L8.14 5.03L8.67 5.39L9.8 6.4L10.57 7.28L11.13 8.09L11.22 8.08L11.72 7.27L11.8 7.21L11.87 7.24L12.4 8.26L13.06 9.9L13.49 11.81L13.57 11.73L13.72 10.85L13.9 10.37L14.31 9.6L14.55 9.28L14.97 8.93L15.33 8.74L15.7 8.62L16.11 8.6L16.12 8.46L15.76 8.22L15.38 8.14L15.17 7.76L14.8 7.51L14.54 7.45L13.91 7.5L13.3 7.74L13.5 8.73L13.49 8.92L13.4 8.96L12.7 6.93L12.34 6.17L11.97 5.57L11.39 6.38L11.2 6.54L9.85 5.44L8.4 4.62L7 4.09L6.3 3.93Z",
        "fill": "accent"
      }
    ],
    "lm-parcel": [
      {
        "type": "polygon",
        "d": "M12.84 11.33L14.52 8.53L14.52 12.1L15.36 12.1L15.36 5.5L12.84 9.7L10.32 5.5L10.32 12.1L11.16 12.1L11.16 8.53Z",
        "fill": "accent"
      },
      {
        "type": "polygon",
        "d": "M9.39 12.1L9.39 11.26L7.48 11.26L7.48 6.6L6.64 6.6L6.64 12.1Z",
        "fill": "accent"
      }
    ],
    "emirates-courier-express": [
      {
        "type": "polygon",
        "d": "M6.91 10.42L7.38 10.52L8.06 7.08L6.36 9.21L5.54 7.16L4.89 10.42L5.35 10.52L5.69 8.81L6.22 10.14L7.22 8.89Z",
        "fill": "accent"
      },
      {
        "type": "polygon",
        "d": "M3.48 10L3.61 9.35L4.46 9.35L4.46 8.88L3.7 8.88L3.83 8.22L4.87 8.22L4.87 7.75L3.44 7.75L2.9 10.47L4.42 10.47L4.42 10Z",
        "fill": "accent"
      },
      {
        "type": "polygon",
        "d": "M8.4 7.71L7.85 10.42L8.32 10.52L8.86 7.8Z",
        "fill": "accent"
      },
      {
        "type": "polygon",
        "d": "M13.22 7.75L12.15 7.75L11.14 10.34L11.58 10.51L11.88 9.75L12.73 9.75L12.73 10.42L13.2 10.43Z",
        "fill": "accent"
      },
      {
        "type": "polygon",
        "d": "M12.47 8.22L12.75 8.22L12.74 9.28L12.06 9.28Z",
        "fill": "truck"
      },
      {
        "type": "polygon",
        "d": "M10.91 8.92L11.03 8.62L11.03 8.3L10.9 8.01L10.65 7.81L10.35 7.75L9.33 7.75L8.79 10.42L9.26 10.52L9.48 9.39L9.65 9.39L10.32 10.45L10.72 10.19L10.2 9.38L10.41 9.34L10.7 9.17Z",
        "fill": "accent"
      },
      {
        "type": "polygon",
        "d": "M10.52 8.31L10.56 8.4L10.56 8.53L10.5 8.67L10.39 8.8L10.24 8.89L10.07 8.92L9.57 8.92L9.71 8.22L10.31 8.22L10.44 8.25Z",
        "fill": "truck"
      },
      {
        "type": "polygon",
        "d": "M14.09 8.22L13.65 10.42L14.11 10.52L14.57 8.22L15.07 8.22L15.07 7.75L13.68 7.75L13.68 8.22Z",
        "fill": "accent"
      },
      {
        "type": "polygon",
        "d": "M15.66 10L15.79 9.35L16.64 9.35L16.64 8.88L15.88 8.88L16.01 8.22L17.05 8.22L17.05 7.75L15.62 7.75L15.08 10.47L16.6 10.47L16.6 10Z",
        "fill": "accent"
      },
      {
        "type": "polygon",
        "d": "M17.62 9.17L18.44 9.44L18.52 9.6L18.43 9.82L18.14 10L17.81 10L17.57 9.79L17.27 10.16L17.64 10.47L18.27 10.47L18.81 10.14L19.04 9.58L18.77 9.05L17.96 8.78L17.88 8.63L17.98 8.4L18.26 8.22L18.56 8.22L18.79 8.42L19.1 8.07L18.74 7.75L18.12 7.75L17.6 8.09L17.37 8.64Z",
        "fill": "accent"
      }
    ],
    "viet-an-express": [
      {
        "type": "polygon",
        "d": "M15.7 8.48L15.59 7.57L15.3 6.7L14.84 5.89L14.24 5.2L13.51 4.63L12.69 4.21L11.8 3.97L10.88 3.9L9.97 4.01L9.1 4.3L8.29 4.76L7.6 5.36L7.03 6.09L6.61 6.91L6.37 7.8L6.3 8.72L6.41 9.63L6.7 10.5L7.16 11.31L7.76 12L8.49 12.57L9.31 12.99L10.2 13.23L11.12 13.3L12.03 13.19L12.9 12.9L13.71 12.44L14.4 11.84L14.97 11.11L15.39 10.29L15.63 9.4Z",
        "fill": "accent"
      },
      {
        "type": "polygon",
        "d": "M15.38 9.14L15.11 10.19L14.91 10.03L14.62 9.95L14.59 9.79L14.38 9.82L13.64 9.56L13.06 8.84L12.92 8.45L13.32 8.27L13.85 8.3L14.51 8.51L14.93 9.1Z",
        "fill": "truck"
      },
      {
        "type": "polygon",
        "d": "M14.99 10.48L14.79 10.85L13.54 11.15L11.69 11.34L10.58 11.32L10.59 11.03L10.8 10.81L11.06 10.73L11.35 10.74L11.92 11L12.68 10.99L13.08 10.91L13.33 10.49Z",
        "fill": "truck"
      },
      {
        "type": "polygon",
        "d": "M14.6 11.14L14.12 11.72L13.54 12.2L12.88 12.59L12.15 12.85L11.83 12.27L11.04 11.59L13.07 11.43Z",
        "fill": "truck"
      },
      {
        "type": "polygon",
        "d": "M9.02 12.54L8.12 11.94L7.37 11.1L9.21 11.47Z",
        "fill": "truck"
      },
      {
        "type": "polygon",
        "d": "M7.19 10.82L6.89 10.19L6.7 9.56L7.01 9.52L7.42 9.65L7.06 9.73L6.96 9.83L7.02 10.42L8.4 10.44L8.42 9.94L8.54 9.95L8.54 9.83L8 9.75L7.97 9.58L8.1 9.31L8.24 9.22L8.43 9.22L8.63 9.35L8.78 9.55L8.51 10.39L8.65 10.44L8.71 10.38L8.83 10.53L8.97 11.2L7.8 11.02Z",
        "fill": "truck"
      },
      {
        "type": "polygon",
        "d": "M10.73 4.2L11.81 4.27L12.84 4.59L13.75 5.16L14.52 5.95L14.13 6.17L14.05 6.48L13.41 7.23L13.21 7.73L13.09 7.75L12.83 7.55L12.81 7.15L13.19 6.82L13.7 6.55L13.78 6.24L13.66 6.14L13.46 6.1L12.79 6.16L12.73 5.92L12.87 5.63L13.17 5.55L13.34 5.37L13.31 4.94L13.04 4.93L12.6 5.22L12.2 5.35L11.71 5.32L11.35 4.82L10.94 4.7L10.77 4.55L10.68 4.3Z",
        "fill": "truck"
      },
      {
        "type": "polygon",
        "d": "M7.27 8.03L7.53 7.98L7.97 8.1L8.03 8.06L8 7.8L8.38 8.15L8.56 8.13L8.75 8L8.03 7.23L8.51 7.5L8.93 7.89L9.48 7.75L10.23 7.39L10.03 7.18L9.57 6.95L7.81 6.19L8.7 6.36L10.02 6.81L10.78 6.97L11.67 6.9L13.06 6.2L13.4 6.18L13.72 6.31L13.6 6.48L12.64 7.01L12.14 7.4L12.15 7.62L12.37 7.85L12.84 7.69L12.99 7.73L12.95 7.91L12.71 7.98L12.6 8.24L12.72 8.51L13.05 8.91L13.02 9.11L11.91 8.37L11.07 7.99L10.01 8.11L9.24 8.35L8.83 8.6L8.95 9.02L8.77 9.01L7.73 8.24Z",
        "fill": "truck"
      },
      {
        "type": "polygon",
        "d": "M10.33 11.34L10.34 11.25L10.51 11.31Z",
        "fill": "truck"
      },
      {
        "type": "polygon",
        "d": "M9.78 11.54L9.7 11.49L9.79 11.51Z",
        "fill": "truck"
      },
      {
        "type": "line",
        "d": "M17.41 8.92L17.36 9.22L17.22 9.52L16.98 9.82L16.66 10.1L16.25 10.36L15.76 10.6L15.2 10.81L14.58 11L13.9 11.16L13.19 11.28L11.66 11.42L10.1 11.41L9.33 11.35L8.48 11.23L7.78 11.09L7.13 10.92L6.53 10.73L5.93 10.46L5.49 10.21L5.13 9.94L4.85 9.65L4.67 9.35L4.58 9.05L4.59 8.74L4.69 8.44L4.89 8.14L5.18 7.85L5.55 7.58L6 7.33L6.55 7.1M15.46 7.11L16.31 7.51L16.9 7.93L17.13 8.18L17.27 8.39L17.37 8.65L17.41 8.92",
        "stroke": "#de117a",
        "strokeWidth": 0.29
      }
    ],
    "espoirer": [
      {
        "type": "polygon",
        "d": "M11.76 3.9L8.62 3.9L10.59 5.58L8.62 5.58L8.62 7.46L14.38 7.46L14.38 6.13Z",
        "fill": "accent"
      },
      {
        "type": "polygon",
        "d": "M8.62 9.14L8.62 11.02L10.59 11.02L8.62 12.7L11.76 12.7L14.38 10.47L14.38 9.14Z",
        "fill": "accent"
      }
    ],
    "performance-freight": [
      {
        "type": "polygon",
        "d": "M5.38 10.82L3.92 8.8L5.38 6.78L4.9 6.43L3.2 8.8L4.9 11.17Z",
        "fill": "accent"
      },
      {
        "type": "polygon",
        "d": "M4.92 8.8L6.37 6.78L5.9 6.43L4.19 8.8L5.9 11.17L6.37 10.82Z",
        "fill": "accent"
      },
      {
        "type": "polygon",
        "d": "M17.81 8.8L16.1 6.43L15.63 6.78L17.08 8.8L15.63 10.82L16.1 11.17Z",
        "fill": "accent"
      },
      {
        "type": "polygon",
        "d": "M18.8 8.8L17.1 6.43L16.62 6.78L18.08 8.8L16.62 10.82L17.1 11.17Z",
        "fill": "accent"
      },
      {
        "type": "polygon",
        "d": "M9.36 8.1L9.28 7.69L9.05 7.35L8.7 7.12L8.33 7.04L7.01 7.04L7.01 10.56L7.6 10.56L7.6 9.15L8.33 9.15L8.7 9.08L9.05 8.85L9.28 8.5Z",
        "fill": "accent"
      },
      {
        "type": "polygon",
        "d": "M8.76 8.1L8.73 8.27L8.63 8.42L8.48 8.53L8.27 8.57L7.6 8.57L7.6 7.63L8.27 7.63L8.48 7.67L8.63 7.77L8.73 7.92Z",
        "fill": "truck"
      },
      {
        "type": "polygon",
        "d": "M11.72 8.51L10.65 8.51L10.65 7.63L11.96 7.63L11.96 7.04L10.06 7.04L10.06 10.56L10.65 10.56L10.65 9.09L11.72 9.09Z",
        "fill": "accent"
      },
      {
        "type": "polygon",
        "d": "M12.99 8.87L14.17 9.23L14.36 9.49L14.3 9.75L13.98 9.97L13.52 9.97L13.11 9.69L12.78 10.17L13.34 10.56L14.16 10.56L14.82 10.1L14.99 9.36L14.53 8.73L13.36 8.37L13.17 8.11L13.23 7.85L13.53 7.63L13.97 7.63L14.36 7.91L14.7 7.44L14.16 7.04L13.35 7.04L12.71 7.5L12.55 8.24Z",
        "fill": "accent"
      }
    ],
    "stg-ltl": [
      {
        "type": "polygon",
        "d": "M14.45 5.77L14.45 5.9L14.57 6.04L14.73 6.03L14.82 5.94L14.83 5.77L14.7 5.65L14.57 5.65Z",
        "fill": "#e0221b"
      },
      {
        "type": "polygon",
        "d": "M14.45 11.5L14.45 11.63L14.57 11.75L14.68 11.75L14.82 11.67L14.83 11.48L14.74 11.38L14.58 11.38Z",
        "fill": "#e0221b"
      },
      {
        "type": "polygon",
        "d": "M13.69 12.27L13.76 12.44L13.93 12.5L14.12 12.38L14.13 12.16L14 12.06L13.84 12.06L13.75 12.15Z",
        "fill": "#e0221b"
      },
      {
        "type": "polygon",
        "d": "M13.77 4.95L13.69 5.13L13.75 5.25L13.84 5.34L14.03 5.34L14.13 5.24L14.13 5.04L14 4.9L13.89 4.9Z",
        "fill": "#e0221b"
      },
      {
        "type": "polygon",
        "d": "M12.95 12.58L12.81 12.79L12.82 12.95L13.01 13.08L13.14 13.08L13.31 12.9L13.32 12.79L13.26 12.67L13.08 12.54Z",
        "fill": "#e0221b"
      },
      {
        "type": "polygon",
        "d": "M11.85 13L11.83 13.28L11.96 13.42L12.18 13.44L12.34 13.31L12.39 13.18L12.34 13.03L12.21 12.89L11.98 12.88Z",
        "fill": "#e0221b"
      },
      {
        "type": "polygon",
        "d": "M6.16 8.2L6.16 9.19L6.21 9.24L6.23 9.65L6.27 9.71L6.34 10.11L6.47 10.47L6.81 11.17L6.9 11.25L6.99 11.46L7.36 11.9L7.39 11.98L8.03 12.56L8.12 12.59L8.55 12.9L9.53 13.37L9.72 13.43L9.89 13.45L9.95 13.49L10.18 13.51L10.24 13.55L10.63 13.56L10.69 13.6L10.75 13.57L10.81 13.6L10.87 13.57L10.92 13.6L10.98 13.57L11.05 13.6L11.28 13.48L11.35 13.35L11.35 13.19L11.17 13L10.59 12.98L10.52 12.94L10.24 12.92L10.17 12.88L9.94 12.86L9.59 12.74L9.42 12.65L9.18 12.57L8.97 12.43L8.9 12.42L8.67 12.28L8.26 11.99L8.01 11.76L7.78 11.52L7.75 11.44L7.62 11.31L7.46 11.04L7.38 10.95L7.03 10.25L6.85 9.66L6.77 9.11L6.79 8.04L6.83 7.97L6.85 7.74L6.97 7.33L7.02 7.26L7.03 7.15L7.18 6.88L7.21 6.74L7.29 6.65L7.38 6.45L7.46 6.36L7.61 6.12L7.81 5.9L7.84 5.82L8.2 5.47L8.27 5.44L8.49 5.23L8.74 5.09L8.83 5.01L9.41 4.71L9.94 4.54L10.11 4.52L10.17 4.48L10.71 4.4L11.1 4.4L11.21 4.35L11.29 4.27L11.35 4.15L11.35 4.05L11.28 3.92L11.21 3.85L11.05 3.8L10.99 3.83L10.94 3.8L10.88 3.83L10.82 3.8L10.76 3.83L10.69 3.8L10.63 3.84L10.18 3.85L10.12 3.89L9.89 3.91L9.19 4.15L8.51 4.49L8.23 4.7L8.15 4.73L7.93 4.93L7.86 4.96L7.33 5.48L7.31 5.56L7.1 5.77L7.07 5.86L6.86 6.13L6.41 7.1L6.29 7.52L6.27 7.75L6.23 7.81L6.21 8.16Z",
        "fill": "#e0221b"
      },
      {
        "type": "polygon",
        "d": "M11.19 7.03L11.19 7.64L11.74 7.64L11.74 10.38L12.35 10.38L12.35 7.64L12.89 7.64L12.89 7.03Z",
        "fill": "accent"
      },
      {
        "type": "polygon",
        "d": "M8.74 7.47L8.58 8.19L9.01 8.8L10.11 9.13L10.28 9.36L10.23 9.58L9.95 9.78L9.53 9.78L9.15 9.51L8.81 10.01L9.34 10.38L10.13 10.38L10.77 9.94L10.93 9.22L10.48 8.61L9.39 8.28L9.23 8.06L9.28 7.83L9.54 7.64L9.93 7.64L10.29 7.89L10.65 7.4L10.13 7.03L9.35 7.03Z",
        "fill": "accent"
      },
      {
        "type": "polygon",
        "d": "M15.04 9.58L14.83 9.72L14.58 9.77L14.33 9.72L14.12 9.58L13.98 9.37L13.92 9.09L13.92 8.32L13.96 8.09L14.05 7.91L14.2 7.76L14.38 7.67L14.59 7.64L14.79 7.67L14.97 7.77L15.15 7.95L15.58 7.53L15.34 7.28L14.99 7.1L14.59 7.03L14.2 7.09L13.84 7.27L13.56 7.55L13.38 7.9L13.32 8.27L13.32 9.15L13.41 9.6L13.68 10.01L14.09 10.29L14.58 10.39L15.06 10.29L15.48 10.01L15.75 9.6L15.84 9.15L15.84 8.54L14.58 8.54L14.58 9.15L15.23 9.15L15.18 9.37Z",
        "fill": "accent"
      }
    ],
    "tsb-es": [
      {
        "type": "polygon",
        "d": "M9.08 7.69L9.15 7.66L9.15 7.5L8.91 6.32L7.75 6.5L6.62 6.79L5.52 7.18L4.46 7.68Z",
        "fill": "accent"
      },
      {
        "type": "polygon",
        "d": "M10.47 10.39L9.9 9.52L9.61 8.94L9.38 8.32L9.28 8.25L3.5 8.25L3.35 8.29L2.9 8.64L3.07 8.81L3.61 9.21L4.56 9.78L5.64 10.26L6.86 10.69L7.92 10.98L8.86 11.18L10.41 11.4L11.77 11.48L11.02 10.96L10.73 10.69Z",
        "fill": "accent"
      },
      {
        "type": "polygon",
        "d": "M9.52 6.95L9.52 7.52L10.34 7.52L10.34 10.15L10.92 10.15L10.92 7.52L11.73 7.52L11.73 6.95Z",
        "fill": "accent"
      },
      {
        "type": "polygon",
        "d": "M12.92 7.35L12.73 8.06L13.24 8.65L14.53 8.97L14.73 9.19L14.68 9.37L14.31 9.57L13.75 9.57L13.28 9.31L13 9.81L13.6 10.15L14.46 10.15L15.17 9.76L15.37 9.03L14.84 8.45L13.55 8.13L13.37 7.92L13.42 7.73L13.77 7.52L14.29 7.52L14.74 7.79L15.04 7.29L14.45 6.95L13.61 6.95Z",
        "fill": "accent"
      },
      {
        "type": "polygon",
        "d": "M16.47 10.15L18.21 10.15L18.47 10.11L18.72 9.98L18.93 9.78L19.06 9.52L19.1 9.26L19.1 9.08L19.06 8.81L18.93 8.56L18.72 8.35L18.68 8.33L18.75 8.18L18.79 7.94L18.79 7.77L18.75 7.53L18.63 7.29L18.45 7.1L18.21 6.98L17.97 6.95L16.47 6.95Z",
        "fill": "accent"
      },
      {
        "type": "polygon",
        "d": "M17.05 7.52L17.92 7.52L18.03 7.54L18.1 7.58L18.16 7.64L18.2 7.71L18.21 7.81L18.21 7.89L18.2 8L18.16 8.07L18.1 8.13L18.03 8.17L17.92 8.18L17.05 8.18Z",
        "fill": "truck"
      },
      {
        "type": "polygon",
        "d": "M18.16 8.76L18.29 8.78L18.38 8.83L18.45 8.9L18.5 8.99L18.52 9.12L18.52 9.21L18.5 9.34L18.45 9.43L18.38 9.51L18.29 9.55L18.16 9.57L17.05 9.57L17.05 8.76Z",
        "fill": "truck"
      }
    ],
    "senyu": [
      {
        "type": "polygon",
        "d": "M13.28 6.79L12.7 7.17L13.84 8.9L13.84 10.81L14.54 10.81L14.54 8.9L15.68 7.17L15.1 6.79L14.19 8.17Z",
        "fill": "accent"
      },
      {
        "type": "polygon",
        "d": "M2.9 8.17L3.4 8.89L4.69 9.3L4.89 9.58L4.83 9.87L4.49 10.11L4.01 10.11L3.56 9.79L3.16 10.36L3.79 10.81L4.72 10.81L5.45 10.28L5.64 9.43L5.12 8.7L3.84 8.3L3.65 8.02L3.71 7.72L4.03 7.49L4.48 7.49L4.9 7.8L5.32 7.24L4.71 6.79L3.8 6.79L3.08 7.32Z",
        "fill": "accent"
      },
      {
        "type": "polygon",
        "d": "M8.48 10.11L7 10.11L7 9.15L8.2 9.15L8.2 8.45L7 8.45L7 7.49L8.48 7.49L8.48 6.79L6.3 6.79L6.3 10.81L8.48 10.81Z",
        "fill": "accent"
      },
      {
        "type": "polygon",
        "d": "M12.03 10.81L12.03 6.79L11.34 6.79L11.34 10.11L11.07 10.11L10.74 6.79L9.14 6.79L9.14 10.81L9.84 10.81L9.84 7.49L10.11 7.49L10.44 10.81Z",
        "fill": "accent"
      },
      {
        "type": "polygon",
        "d": "M16.74 10.41L17.03 10.63L17.36 10.76L17.72 10.81L18.08 10.76L18.41 10.63L18.7 10.41L18.92 10.12L19.06 9.79L19.1 9.45L19.1 6.79L18.4 6.79L18.4 9.41L18.38 9.61L18.31 9.77L18.2 9.91L18.06 10.02L17.9 10.08L17.72 10.11L17.55 10.08L17.38 10.02L17.24 9.91L17.13 9.77L17.07 9.61L17.04 9.41L17.04 6.79L16.34 6.79L16.34 9.45L16.39 9.79L16.53 10.12Z",
        "fill": "accent"
      }
    ],
    "zippd": [
      {
        "type": "polygon",
        "d": "M5.77 11.01L5.77 10.24L4.25 10.24L6.45 6.59L3.58 6.59L3.58 7.36L5.09 7.36L2.9 11.01Z",
        "fill": "accent"
      },
      {
        "type": "polygon",
        "d": "M7.94 6.59L7.18 6.59L7.18 11.01L7.94 11.01Z",
        "fill": "accent"
      },
      {
        "type": "polygon",
        "d": "M10.74 9.16L11.17 8.87L11.46 8.44L11.57 7.92L11.46 7.41L11.17 6.98L10.74 6.69L10.26 6.59L8.67 6.59L8.67 11.01L9.44 11.01L9.44 9.26L10.26 9.26Z",
        "fill": "accent"
      },
      {
        "type": "polygon",
        "d": "M10.44 7.41L10.62 7.53L10.74 7.71L10.78 7.92L10.74 8.14L10.62 8.32L10.44 8.44L10.19 8.49L9.44 8.49L9.44 7.36L10.19 7.36Z",
        "fill": "truck"
      },
      {
        "type": "polygon",
        "d": "M14.8 8.87L15.09 8.44L15.19 7.92L15.09 7.41L14.8 6.98L14.36 6.69L13.89 6.59L12.3 6.59L12.3 11.01L13.06 11.01L13.06 9.26L13.89 9.26L14.36 9.16Z",
        "fill": "accent"
      },
      {
        "type": "polygon",
        "d": "M14.24 7.53L14.36 7.71L14.41 7.92L14.36 8.14L14.24 8.32L14.06 8.44L13.81 8.49L13.06 8.49L13.06 7.36L13.81 7.36L14.06 7.41Z",
        "fill": "truck"
      },
      {
        "type": "polygon",
        "d": "M17.46 10.94L17.99 10.72L18.45 10.36L18.8 9.91L19.02 9.37L19.1 8.8L19.02 8.23L18.8 7.69L18.45 7.24L17.99 6.88L17.46 6.66L16.91 6.59L15.92 6.59L15.92 11.01L16.91 11.01Z",
        "fill": "accent"
      },
      {
        "type": "polygon",
        "d": "M17.61 7.55L17.9 7.78L18.13 8.08L18.28 8.43L18.33 8.8L18.28 9.17L18.13 9.52L17.9 9.82L17.61 10.05L17.26 10.19L16.86 10.24L16.69 10.24L16.69 7.36L16.86 7.36L17.26 7.41Z",
        "fill": "truck"
      }
    ],
    "global-delivery-network": [
      {
        "type": "polygon",
        "d": "M8.85 11.59L10.11 11.59L10.8 11.5L11.47 11.22L12.05 10.78L12.5 10.2L12.78 9.52L12.87 8.8L12.78 8.07L12.5 7.4L12.05 6.82L11.47 6.38L10.8 6.1L10.11 6.01L8.85 6.01Z",
        "fill": "accent"
      },
      {
        "type": "polygon",
        "d": "M10.04 6.98L10.55 7.04L10.98 7.22L11.36 7.51L11.65 7.89L11.83 8.33L11.89 8.8L11.83 9.27L11.65 9.71L11.36 10.08L10.98 10.37L10.55 10.56L10.04 10.62L9.82 10.62L9.82 6.98Z",
        "fill": "truck"
      },
      {
        "type": "polygon",
        "d": "M16.1 11.59L18.27 11.59L18.27 6.01L17.3 6.01L17.3 10.62L16.89 10.62L15.97 6.01L13.79 6.01L13.79 11.59L14.76 11.59L14.76 6.98L15.17 6.98Z",
        "fill": "accent"
      },
      {
        "type": "polygon",
        "d": "M6.62 10.28L6.26 10.53L5.83 10.61L5.4 10.53L5.04 10.28L4.79 9.92L4.7 9.44L4.7 8.14L4.76 7.76L4.92 7.44L5.17 7.19L5.49 7.03L5.84 6.98L6.19 7.04L6.5 7.21L6.8 7.52L7.5 6.84L7.09 6.42L6.51 6.11L5.85 6L5.2 6.1L4.6 6.39L4.13 6.86L3.83 7.45L3.73 8.07L3.73 9.54L3.88 10.3L4.34 10.98L5.02 11.44L5.83 11.6L6.64 11.44L7.32 10.98L7.78 10.3L7.93 9.54L7.93 8.54L5.83 8.54L5.83 9.51L6.95 9.51L6.86 9.92Z",
        "fill": "accent"
      }
    ],
    "vip-posta": [
      {
        "type": "polygon",
        "d": "M8.7 11.8L9.8 5.99L8.78 5.8L7.84 10.76L7.21 10.76L6.27 5.8L5.25 5.99L6.35 11.8Z",
        "fill": "#c7a658"
      },
      {
        "type": "polygon",
        "d": "M11.83 5.8L10.79 5.8L10.79 11.8L11.83 11.8Z",
        "fill": "#c7a658"
      },
      {
        "type": "polygon",
        "d": "M15.63 9.29L16.22 8.9L16.62 8.31L16.75 7.61L16.62 6.91L16.22 6.32L15.63 5.93L14.99 5.8L12.83 5.8L12.83 11.8L13.87 11.8L13.87 9.42L14.99 9.42Z",
        "fill": "#c7a658"
      },
      {
        "type": "polygon",
        "d": "M15.22 6.91L15.47 7.07L15.63 7.32L15.69 7.61L15.63 7.9L15.47 8.15L15.22 8.31L14.88 8.38L13.87 8.38L13.87 6.84L14.88 6.84Z",
        "fill": "truck"
      }
    ],
    "sfyd-express": [
      {
        "type": "polygon",
        "d": "M11.91 6.28L11.11 6.66L12.15 8.84L11.72 11.26L12.59 11.42L13.03 8.98L14.9 6.76L14.22 6.18L12.72 7.97Z",
        "fill": "accent"
      },
      {
        "type": "polygon",
        "d": "M3.03 7.9L3.53 8.89L5.08 9.4L5.24 9.71L5.08 10.11L4.54 10.45L3.93 10.45L3.46 10.06L2.9 10.75L3.62 11.34L4.8 11.34L5.8 10.71L6.22 9.65L5.7 8.67L4.16 8.16L4.01 7.86L4.17 7.45L4.68 7.11L5.26 7.11L5.7 7.49L6.27 6.82L5.58 6.23L4.42 6.23L3.45 6.86Z",
        "fill": "accent"
      },
      {
        "type": "polygon",
        "d": "M9.55 9.22L9.55 8.34L8.22 8.34L8.44 7.11L10.26 7.11L10.26 6.23L7.69 6.23L6.79 11.26L7.66 11.42L8.06 9.22Z",
        "fill": "accent"
      },
      {
        "type": "polygon",
        "d": "M16.16 11.34L16.8 11.25L17.45 11.01L18.03 10.61L18.51 10.11L18.87 9.51L19.07 8.86L19.1 8.19L18.95 7.56L18.62 7L18.14 6.58L17.55 6.31L16.93 6.23L15.85 6.23L14.93 11.34Z",
        "fill": "accent"
      },
      {
        "type": "polygon",
        "d": "M16.87 7.11L17.31 7.17L17.66 7.33L17.93 7.57L18.12 7.89L18.21 8.28L18.19 8.7L18.05 9.15L17.8 9.57L17.45 9.93L17.04 10.21L16.59 10.39L16.11 10.45L15.99 10.45L16.59 7.11Z",
        "fill": "truck"
      }
    ],
    "bfe-express": [
      {
        "type": "polygon",
        "d": "M16.96 10.08L17.81 9.47L18.46 8.85L18.67 8.58L18.88 8.24L18.99 7.98L19.07 7.69L18.77 8.07L18.35 8.47L17.6 9.02L16.78 9.51L16.78 9.64L16.53 9.64L15.12 10.28L16.64 10.28Z",
        "fill": "#1a94d3"
      },
      {
        "type": "polygon",
        "d": "M4.53 8.67L3.79 9.29L3.33 9.82L3.04 10.33L2.95 10.58L2.92 10.82L2.92 11.06L2.97 11.28L3.06 11.49L3.25 11.76L3.67 12.1L3.94 12.25L4.36 12.43L5.11 12.63L6.15 12.78L7.15 12.82L8.42 12.76L9.77 12.61L10.96 12.39L12.14 12.11L13.43 11.72L13.43 10.88L12.34 11.19L11.28 11.44L11.28 11.95L9.61 11.95L9.61 11.72L8.03 11.87L7.51 11.95L4.84 11.95L4.84 11.56L4.36 11.36L4.02 11.12L3.79 10.84L3.71 10.66L3.67 10.47L3.67 10.27L3.71 10.06L3.88 9.69L4.23 9.23L4.84 8.67L4.84 8.45Z",
        "fill": "#1a94d3"
      },
      {
        "type": "polygon",
        "d": "M8.54 8.14L8.6 7.72L8.6 7.43L8.54 7.01L8.33 6.6L8 6.27L7.59 6.07L7.18 6L5.19 6L5.19 11.6L7.48 11.6L7.94 11.53L8.38 11.3L8.73 10.95L8.96 10.5L9.03 10.05L9.03 9.73L8.96 9.27L8.73 8.83L8.37 8.47Z",
        "fill": "accent"
      },
      {
        "type": "polygon",
        "d": "M6.16 9.15L7.41 9.15L7.63 9.18L7.8 9.27L7.94 9.41L8.03 9.58L8.06 9.8L8.06 9.97L8.03 10.2L7.94 10.37L7.8 10.51L7.63 10.59L7.41 10.63L6.16 10.63Z",
        "fill": "truck"
      },
      {
        "type": "polygon",
        "d": "M7.42 7.07L7.53 7.18L7.6 7.31L7.63 7.5L7.63 7.64L7.6 7.83L7.53 7.97L7.42 8.08L7.29 8.15L7.1 8.18L6.16 8.18L6.16 6.97L7.1 6.97L7.29 7Z",
        "fill": "truck"
      },
      {
        "type": "polygon",
        "d": "M10.93 9.29L12.49 9.29L12.49 8.31L10.93 8.31L10.93 6.97L12.85 6.97L12.85 6L9.96 6L9.96 11.6L10.93 11.6Z",
        "fill": "accent"
      },
      {
        "type": "polygon",
        "d": "M16.81 10.63L14.75 10.63L14.75 9.29L16.43 9.29L16.43 8.31L14.75 8.31L14.75 6.97L16.81 6.97L16.81 6L13.78 6L13.78 11.6L16.81 11.6Z",
        "fill": "accent"
      }
    ],
    "paisley-freight": [
      {
        "type": "polygon",
        "d": "M11.58 12.25L11.58 9.41L10.89 9.41L10.89 12.28L8.06 10.81L7.74 11.42L11.25 13.25L14.57 11.31L14.57 7.24L13.88 7.24L13.88 10.91Z",
        "fill": "#c3d7ef"
      },
      {
        "type": "polygon",
        "d": "M7.47 10.44L8.16 10.44L8.16 7.07L11 8.62L14.91 6.49L11 4.35L7.47 6.28Z",
        "fill": "accent"
      },
      {
        "type": "polygon",
        "d": "M11 7.83L8.54 6.49L11 5.14L13.46 6.49Z",
        "fill": "truck"
      }
    ],
    "max-pakket": [
      {
        "type": "polygon",
        "d": "M7.83 8.87L7.83 11.9L8.71 11.9L8.71 5.7L6.39 9.56L4.07 5.7L4.07 11.9L4.95 11.9L4.95 8.87L6.39 11.27Z",
        "fill": "#000000"
      },
      {
        "type": "polygon",
        "d": "M12.52 11.9L13.39 11.74L12.46 6.85L10.48 6.85L9.55 11.74L10.41 11.9L10.66 10.56L12.27 10.56Z",
        "fill": "#000000"
      },
      {
        "type": "polygon",
        "d": "M12.1 9.69L10.83 9.69L11.2 7.72L11.73 7.72Z",
        "fill": "truck"
      },
      {
        "type": "polygon",
        "d": "M16.58 9.37L17.93 7.33L17.19 6.85L16.05 8.58L14.91 6.85L14.18 7.33L15.52 9.37L14.18 11.42L14.91 11.9L16.05 10.17L17.19 11.9L17.93 11.42Z",
        "fill": "#000000"
      }
    ],
    "diakinisis": [
      {
        "type": "polygon",
        "d": "M9.87 7.63L9.02 8.35L9.14 7.69L8.65 7.6L8.24 9.91L8.72 10L8.88 9.11L9.04 8.97L9.44 9.92L9.89 9.74L9.44 8.64L10.18 8.01Z",
        "fill": "accent"
      },
      {
        "type": "polygon",
        "d": "M4.08 9.81L4.34 9.63L4.55 9.4L4.71 9.14L4.8 8.84L4.82 8.54L4.75 8.25L4.6 8L4.38 7.8L4.11 7.68L3.83 7.65L3.32 7.65L2.9 9.95L3.5 9.95L3.79 9.92Z",
        "fill": "accent"
      },
      {
        "type": "polygon",
        "d": "M3.97 8.16L4.11 8.22L4.22 8.31L4.29 8.44L4.32 8.59L4.31 8.76L4.26 8.93L4.16 9.11L4.02 9.25L3.85 9.37L3.66 9.44L3.49 9.46L3.73 8.14L3.8 8.14Z",
        "fill": "truck"
      },
      {
        "type": "polygon",
        "d": "M5.05 9.91L5.54 10L5.95 7.69L5.47 7.6Z",
        "fill": "accent"
      },
      {
        "type": "polygon",
        "d": "M6.82 7.65L6.01 9.82L6.47 9.99L6.7 9.37L7.3 9.37L7.31 9.91L7.8 9.91L7.78 7.65Z",
        "fill": "accent"
      },
      {
        "type": "polygon",
        "d": "M7.16 8.14L7.29 8.14L7.3 8.88L6.88 8.88Z",
        "fill": "truck"
      },
      {
        "type": "polygon",
        "d": "M10.3 9.91L10.79 10L11.2 7.69L10.72 7.6Z",
        "fill": "accent"
      },
      {
        "type": "polygon",
        "d": "M13.34 7.69L12.86 7.6L12.53 9.46L12.49 9.46L12.63 7.65L11.65 7.65L11.24 9.91L11.73 10L12.06 8.14L12.1 8.14L11.96 9.95L12.94 9.95Z",
        "fill": "accent"
      },
      {
        "type": "polygon",
        "d": "M13.39 9.91L13.87 10L14.29 7.69L13.8 7.6Z",
        "fill": "accent"
      },
      {
        "type": "polygon",
        "d": "M14.83 8.89L15.5 9.11L15.55 9.2L15.5 9.34L15.29 9.46L15.06 9.46L14.87 9.31L14.56 9.69L14.89 9.95L15.43 9.95L15.89 9.67L16.09 9.17L15.84 8.71L15.18 8.49L15.14 8.4L15.19 8.26L15.38 8.14L15.59 8.14L15.77 8.29L16.09 7.91L15.77 7.65L15.24 7.65L14.79 7.94L14.6 8.43Z",
        "fill": "accent"
      },
      {
        "type": "polygon",
        "d": "M16.4 9.91L16.88 10L17.3 7.69L16.81 7.6Z",
        "fill": "accent"
      },
      {
        "type": "polygon",
        "d": "M17.84 8.89L18.51 9.11L18.56 9.2L18.51 9.34L18.3 9.46L18.08 9.46L17.89 9.31L17.58 9.69L17.9 9.95L18.45 9.95L18.91 9.67L19.1 9.17L18.85 8.71L18.19 8.49L18.15 8.4L18.2 8.26L18.39 8.14L18.6 8.14L18.78 8.29L19.1 7.91L18.79 7.65L18.25 7.65L17.8 7.94L17.61 8.43Z",
        "fill": "accent"
      }
    ],
    "shipgce": [
      {
        "type": "polygon",
        "d": "M9.41 6.22L8.86 6.3L8.36 6.55L7.96 6.94L7.71 7.44L7.62 7.95L7.62 9.64L7.71 10.16L7.96 10.65L8.36 11.05L8.86 11.3L9.41 11.38L9.96 11.28L10.45 11.02L10.79 10.67L10.15 10.05L9.91 10.3L9.67 10.43L9.4 10.47L9.13 10.43L8.88 10.31L8.69 10.12L8.57 9.88L8.52 9.57L8.52 8.03L8.57 7.72L8.69 7.48L8.88 7.29L9.13 7.16L9.4 7.12L9.67 7.17L9.91 7.3L10.15 7.54L10.79 6.92L10.45 6.57L9.96 6.31Z",
        "fill": "accent"
      },
      {
        "type": "polygon",
        "d": "M14.43 10.48L12.54 10.48L12.54 9.25L14.08 9.25L14.08 8.35L12.54 8.35L12.54 7.12L14.43 7.12L14.43 6.22L11.64 6.22L11.64 11.37L14.43 11.37Z",
        "fill": "accent"
      },
      {
        "type": "polygon",
        "d": "M17.73 8.8L19.1 6.72L18.35 6.22L17.19 7.99L16.03 6.22L15.28 6.72L16.65 8.8L15.28 10.88L16.03 11.37L17.19 9.61L18.35 11.37L19.1 10.88Z",
        "fill": "accent"
      },
      {
        "type": "polygon",
        "d": "M5.23 10.39L4.84 10.47L4.44 10.39L4.11 10.17L3.88 9.83L3.79 9.39L3.79 8.2L3.85 7.84L4 7.55L4.23 7.32L4.52 7.17L4.85 7.12L5.17 7.18L5.46 7.33L5.74 7.62L6.38 7L6 6.61L5.46 6.32L4.86 6.22L4.25 6.31L3.71 6.58L3.27 7.01L2.99 7.56L2.9 8.12L2.9 9.48L3.04 10.18L3.46 10.81L4.09 11.23L4.84 11.38L5.58 11.23L6.21 10.81L6.63 10.18L6.77 9.48L6.77 8.56L4.84 8.56L4.84 9.46L5.87 9.46L5.79 9.83L5.57 10.17Z",
        "fill": "accent"
      }
    ],
    "espeedpost": [
      {
        "type": "polygon",
        "d": "M4.04 9.49L3.27 9.49L3.27 8.98L3.9 8.98L3.9 8.62L3.27 8.62L3.27 8.11L4.04 8.11L4.04 7.75L2.9 7.75L2.9 9.85L4.04 9.85Z",
        "fill": "accent"
      },
      {
        "type": "polygon",
        "d": "M4.58 8.85L5.26 9.06L5.37 9.21L5.33 9.36L5.16 9.49L4.9 9.49L4.67 9.32L4.46 9.62L4.79 9.85L5.27 9.85L5.66 9.58L5.76 9.13L5.49 8.75L4.81 8.54L4.71 8.39L4.75 8.23L4.91 8.11L5.15 8.11L5.37 8.28L5.59 7.98L5.27 7.75L4.79 7.75L4.42 8.02L4.32 8.47Z",
        "fill": "accent"
      },
      {
        "type": "polygon",
        "d": "M7.44 8.63L7.49 8.38L7.44 8.14L7.3 7.93L7.09 7.79L6.87 7.75L6.11 7.75L6.11 9.85L6.47 9.85L6.47 9.02L6.87 9.02L7.09 8.97L7.3 8.83Z",
        "fill": "accent"
      },
      {
        "type": "polygon",
        "d": "M7.09 8.28L7.11 8.38L7.09 8.48L7.04 8.57L6.95 8.63L6.83 8.65L6.47 8.65L6.47 8.11L6.83 8.11L6.95 8.14L7.04 8.19Z",
        "fill": "truck"
      },
      {
        "type": "polygon",
        "d": "M8.2 9.49L8.2 8.98L8.83 8.98L8.83 8.62L8.2 8.62L8.2 8.11L8.98 8.11L8.98 7.75L7.84 7.75L7.84 9.85L8.98 9.85L8.98 9.49Z",
        "fill": "accent"
      },
      {
        "type": "polygon",
        "d": "M9.69 9.49L9.69 8.98L10.32 8.98L10.32 8.62L9.69 8.62L9.69 8.11L10.47 8.11L10.47 7.75L9.33 7.75L9.33 9.85L10.47 9.85L10.47 9.49Z",
        "fill": "accent"
      },
      {
        "type": "polygon",
        "d": "M18.02 8.11L18.38 8.11L18.38 9.85L18.74 9.85L18.74 8.11L19.1 8.11L19.1 7.75L18.02 7.75Z",
        "fill": "accent"
      },
      {
        "type": "polygon",
        "d": "M11.8 9.71L12.02 9.55L12.19 9.33L12.3 9.07L12.33 8.8L12.3 8.53L12.19 8.27L12.02 8.05L11.8 7.89L11.55 7.78L11.29 7.75L10.82 7.75L10.82 9.85L11.29 9.85L11.55 9.82Z",
        "fill": "accent"
      },
      {
        "type": "polygon",
        "d": "M11.76 8.31L11.87 8.46L11.94 8.62L11.96 8.8L11.94 8.98L11.87 9.14L11.76 9.29L11.62 9.39L11.45 9.46L11.26 9.49L11.18 9.49L11.18 8.11L11.26 8.11L11.45 8.14L11.62 8.21Z",
        "fill": "truck"
      },
      {
        "type": "polygon",
        "d": "M14.01 8.63L14.06 8.38L14.01 8.14L13.87 7.93L13.67 7.79L13.44 7.75L12.68 7.75L12.68 9.85L13.05 9.85L13.05 9.02L13.44 9.02L13.67 8.97L13.87 8.83Z",
        "fill": "accent"
      },
      {
        "type": "polygon",
        "d": "M13.67 8.28L13.69 8.38L13.67 8.48L13.61 8.57L13.52 8.63L13.4 8.65L13.05 8.65L13.05 8.11L13.4 8.11L13.52 8.14L13.61 8.19Z",
        "fill": "truck"
      },
      {
        "type": "polygon",
        "d": "M15.22 7.74L14.9 7.81L14.62 7.99L14.44 8.27L14.38 8.57L14.38 9.03L14.44 9.33L14.62 9.61L14.9 9.79L15.22 9.86L15.55 9.79L15.82 9.61L16.01 9.33L16.07 9.03L16.07 8.57L16.01 8.27L15.82 7.99L15.55 7.81Z",
        "fill": "accent"
      },
      {
        "type": "polygon",
        "d": "M15.66 9.19L15.56 9.35L15.41 9.45L15.22 9.48L15.04 9.45L14.89 9.35L14.78 9.19L14.74 8.99L14.74 8.61L14.78 8.41L14.89 8.25L15.04 8.15L15.22 8.12L15.41 8.15L15.56 8.25L15.66 8.41L15.7 8.61L15.7 8.99Z",
        "fill": "truck"
      },
      {
        "type": "polygon",
        "d": "M16.67 8.85L17.34 9.06L17.45 9.21L17.42 9.36L17.24 9.49L16.99 9.49L16.75 9.32L16.54 9.62L16.87 9.85L17.36 9.85L17.74 9.58L17.84 9.13L17.57 8.75L16.9 8.54L16.79 8.39L16.83 8.23L16.99 8.11L17.23 8.11L17.45 8.28L17.67 7.98L17.35 7.75L16.87 7.75L16.5 8.02L16.4 8.47Z",
        "fill": "accent"
      }
    ],
    "360zebra": [
      {
        "type": "polygon",
        "d": "M11.81 8.34L11.86 8.04L11.86 7.84L11.81 7.55L11.66 7.26L11.44 7.03L11.15 6.88L10.86 6.84L9.47 6.84L9.47 10.76L11.07 10.76L11.39 10.71L11.7 10.55L11.95 10.3L12.11 9.99L12.16 9.67L12.16 9.45L12.11 9.13L11.95 8.82L11.69 8.57Z",
        "fill": "accent"
      },
      {
        "type": "polygon",
        "d": "M10.15 9.04L11.02 9.04L11.18 9.07L11.3 9.13L11.39 9.22L11.45 9.34L11.48 9.5L11.48 9.62L11.45 9.78L11.39 9.9L11.3 9.99L11.18 10.06L11.02 10.08L10.15 10.08Z",
        "fill": "truck"
      },
      {
        "type": "polygon",
        "d": "M11.11 7.66L11.16 7.76L11.18 7.89L11.18 7.99L11.16 8.12L11.11 8.22L11.03 8.29L10.94 8.34L10.8 8.36L10.15 8.36L10.15 7.52L10.8 7.52L10.94 7.54L11.03 7.59Z",
        "fill": "truck"
      },
      {
        "type": "polygon",
        "d": "M5.45 10.08L4.1 10.08L6.05 6.84L3.5 6.84L3.5 7.52L4.85 7.52L2.9 10.76L5.45 10.76Z",
        "fill": "accent"
      },
      {
        "type": "polygon",
        "d": "M8.82 10.08L7.38 10.08L7.38 9.14L8.55 9.14L8.55 8.46L7.38 8.46L7.38 7.52L8.82 7.52L8.82 6.84L6.7 6.84L6.7 10.76L8.82 10.76Z",
        "fill": "accent"
      },
      {
        "type": "polygon",
        "d": "M15.16 8.86L15.41 8.48L15.5 8.02L15.41 7.57L15.16 7.18L14.77 6.92L14.35 6.84L12.81 6.84L12.81 10.76L13.49 10.76L13.49 9.21L13.69 9.21L15 10.76L15.52 10.32L14.55 9.17L14.77 9.12Z",
        "fill": "accent"
      },
      {
        "type": "polygon",
        "d": "M14.67 7.67L14.77 7.83L14.81 8.02L14.77 8.21L14.67 8.37L14.5 8.48L14.28 8.52L13.49 8.52L13.49 7.52L14.28 7.52L14.5 7.56Z",
        "fill": "truck"
      },
      {
        "type": "polygon",
        "d": "M19.1 10.63L18.38 6.84L16.84 6.84L16.12 10.63L16.79 10.76L16.99 9.72L18.23 9.72L18.43 10.76Z",
        "fill": "accent"
      },
      {
        "type": "polygon",
        "d": "M17.12 9.04L17.41 7.52L17.82 7.52L18.1 9.04Z",
        "fill": "truck"
      }
    ],
    "auexpress": [
      {
        "type": "polygon",
        "d": "M4.63 9.86L4.21 7.66L3.32 7.66L2.9 9.86L3.29 9.94L3.4 9.34L4.13 9.34L4.24 9.94Z",
        "fill": "accent"
      },
      {
        "type": "polygon",
        "d": "M3.48 8.94L3.65 8.06L3.88 8.06L4.05 8.94Z",
        "fill": "truck"
      },
      {
        "type": "polygon",
        "d": "M7.23 9.54L7.23 9L7.91 9L7.91 8.6L7.23 8.6L7.23 8.06L8.07 8.06L8.07 7.66L6.83 7.66L6.83 9.94L8.07 9.94L8.07 9.54Z",
        "fill": "accent"
      },
      {
        "type": "polygon",
        "d": "M9.8 7.66L9.29 8.44L8.77 7.66L8.44 7.88L9.05 8.8L8.44 9.72L8.77 9.94L9.29 9.16L9.8 9.94L10.13 9.72L9.53 8.8L10.13 7.88Z",
        "fill": "accent"
      },
      {
        "type": "polygon",
        "d": "M5.28 9.84L5.47 9.91L5.67 9.94L5.88 9.91L6.07 9.84L6.23 9.71L6.35 9.55L6.43 9.36L6.46 9.17L6.46 7.66L6.06 7.66L6.06 9.14L6.05 9.26L6.01 9.35L5.95 9.43L5.87 9.49L5.77 9.53L5.67 9.54L5.58 9.53L5.48 9.49L5.4 9.43L5.34 9.35L5.3 9.26L5.29 9.14L5.29 7.66L4.89 7.66L4.89 9.17L4.92 9.36L5 9.55L5.12 9.71Z",
        "fill": "accent"
      },
      {
        "type": "polygon",
        "d": "M11.8 8.84L11.95 8.61L12 8.35L11.95 8.08L11.8 7.86L11.58 7.71L11.33 7.66L10.51 7.66L10.51 9.94L10.91 9.94L10.91 9.03L11.33 9.03L11.58 8.99Z",
        "fill": "accent"
      },
      {
        "type": "polygon",
        "d": "M11.52 8.14L11.58 8.24L11.6 8.35L11.58 8.46L11.52 8.55L11.42 8.61L11.29 8.64L10.91 8.64L10.91 8.06L11.29 8.06L11.42 8.08Z",
        "fill": "truck"
      },
      {
        "type": "polygon",
        "d": "M13.89 8.61L13.95 8.35L13.89 8.08L13.75 7.86L13.52 7.71L13.28 7.66L12.38 7.66L12.38 9.94L12.78 9.94L12.78 9.03L12.89 9.03L13.65 9.94L13.96 9.68L13.39 9.01L13.52 8.99L13.75 8.84Z",
        "fill": "accent"
      },
      {
        "type": "polygon",
        "d": "M13.52 8.24L13.54 8.35L13.52 8.46L13.46 8.55L13.37 8.61L13.24 8.64L12.78 8.64L12.78 8.06L13.24 8.06L13.37 8.08L13.46 8.14Z",
        "fill": "truck"
      },
      {
        "type": "polygon",
        "d": "M14.73 9.54L14.73 9L15.41 9L15.41 8.6L14.73 8.6L14.73 8.06L15.57 8.06L15.57 7.66L14.33 7.66L14.33 9.94L15.57 9.94L15.57 9.54Z",
        "fill": "accent"
      },
      {
        "type": "polygon",
        "d": "M16.15 8.85L16.89 9.08L17 9.24L16.96 9.41L16.77 9.54L16.5 9.54L16.25 9.36L16.02 9.69L16.37 9.94L16.9 9.94L17.32 9.64L17.42 9.16L17.13 8.74L16.4 8.52L16.29 8.36L16.33 8.19L16.51 8.06L16.77 8.06L17 8.23L17.24 7.91L16.9 7.66L16.38 7.66L15.97 7.96L15.87 8.44Z",
        "fill": "accent"
      },
      {
        "type": "polygon",
        "d": "M17.83 8.85L18.56 9.08L18.68 9.24L18.64 9.41L18.45 9.54L18.18 9.54L17.92 9.36L17.69 9.69L18.05 9.94L18.58 9.94L19 9.64L19.1 9.16L18.81 8.74L18.08 8.52L17.97 8.36L18.01 8.19L18.19 8.06L18.44 8.06L18.68 8.23L18.92 7.91L18.57 7.66L18.05 7.66L17.65 7.96L17.55 8.44Z",
        "fill": "accent"
      }
    ],
    "ane-logistics": [
      {
        "type": "polygon",
        "d": "M6.96 12.25L8.13 12.02L6.87 5.35L4.17 5.35L2.9 12.02L4.08 12.25L4.42 10.42L6.61 10.42Z",
        "fill": "#1a1a1a"
      },
      {
        "type": "polygon",
        "d": "M6.38 9.23L4.65 9.23L5.16 6.55L5.88 6.55Z",
        "fill": "truck"
      },
      {
        "type": "polygon",
        "d": "M11.49 12.25L14.23 12.25L14.23 5.35L13.03 5.35L13.03 11.05L12.58 11.05L12.01 5.35L9.27 5.35L9.27 12.25L10.47 12.25L10.47 6.55L10.93 6.55Z",
        "fill": "#1a1a1a"
      },
      {
        "type": "polygon",
        "d": "M19.1 12.25L19.1 11.05L16.56 11.05L16.56 9.4L18.63 9.4L18.63 8.2L16.56 8.2L16.56 6.55L19.1 6.55L19.1 5.35L15.37 5.35L15.37 12.25Z",
        "fill": "#1a1a1a"
      }
    ],
    "china-railway-express": [
      {
        "type": "polygon",
        "d": "M5.48 5.07L4.68 5.19L3.96 5.55L3.39 6.12L3.02 6.84L2.9 7.58L2.9 10.02L3.02 10.76L3.39 11.48L3.96 12.05L4.68 12.41L5.48 12.53L6.27 12.39L6.99 12.01L7.47 11.51L6.55 10.61L6.2 10.97L5.85 11.15L5.46 11.22L5.07 11.16L4.72 10.98L4.44 10.71L4.26 10.36L4.19 9.92L4.19 7.68L4.26 7.24L4.44 6.89L4.72 6.62L5.07 6.44L5.46 6.38L5.85 6.45L6.2 6.63L6.55 6.99L7.47 6.09L6.99 5.59L6.27 5.21Z",
        "fill": "accent"
      },
      {
        "type": "polygon",
        "d": "M12.42 9.41L13.16 8.92L13.64 8.19L13.82 7.33L13.64 6.46L13.16 5.73L12.42 5.24L11.62 5.08L8.7 5.08L8.7 12.52L9.99 12.52L9.99 9.57L10.38 9.57L12.86 12.52L13.85 11.69L12 9.49Z",
        "fill": "accent"
      },
      {
        "type": "polygon",
        "d": "M11.92 6.46L12.23 6.66L12.43 6.97L12.5 7.33L12.43 7.68L12.23 7.99L11.92 8.19L11.5 8.28L9.99 8.28L9.99 6.37L11.5 6.37Z",
        "fill": "truck"
      },
      {
        "type": "polygon",
        "d": "M19.1 12.52L19.1 11.23L16.37 11.23L16.37 9.45L18.59 9.45L18.59 8.15L16.37 8.15L16.37 6.37L19.1 6.37L19.1 5.08L15.08 5.08L15.08 12.52Z",
        "fill": "accent"
      }
    ],
    "lhtex": [
      {
        "type": "polygon",
        "d": "M15.01 4.81L15.01 6.19L16.36 6.19L16.36 12.79L17.75 12.79L17.75 6.19L19.1 6.19L19.1 4.81Z",
        "fill": "accent"
      },
      {
        "type": "polygon",
        "d": "M4.29 11.41L4.29 4.81L2.9 4.81L2.9 12.79L6.89 12.79L6.89 11.41Z",
        "fill": "accent"
      },
      {
        "type": "polygon",
        "d": "M8.21 4.81L8.21 12.79L9.6 12.79L9.6 9.49L12.3 9.49L12.3 12.79L13.69 12.79L13.69 4.81L12.3 4.81L12.3 8.11L9.6 8.11L9.6 4.81Z",
        "fill": "accent"
      }
    ],
    "showl": [
      {
        "type": "polygon",
        "d": "M3.07 7.39L2.9 8.2L3.38 8.89L4.61 9.28L4.8 9.55L4.74 9.82L4.42 10.05L3.96 10.05L3.53 9.75L3.15 10.29L3.75 10.72L4.63 10.72L5.34 10.22L5.51 9.4L5.02 8.71L3.8 8.32L3.61 8.06L3.67 7.77L3.97 7.55L4.41 7.55L4.81 7.85L5.21 7.31L4.63 6.88L3.75 6.88Z",
        "fill": "accent"
      },
      {
        "type": "polygon",
        "d": "M8.11 9.13L8.11 10.72L8.78 10.72L8.78 6.88L8.11 6.88L8.11 8.47L6.81 8.47L6.81 6.88L6.15 6.88L6.15 10.72L6.81 10.72L6.81 9.13Z",
        "fill": "accent"
      },
      {
        "type": "polygon",
        "d": "M11.54 6.99L10.95 6.88L10.36 6.99L9.86 7.33L9.52 7.83L9.41 8.39L9.41 9.21L9.52 9.77L9.86 10.27L10.36 10.61L10.95 10.72L11.54 10.61L12.04 10.27L12.37 9.77L12.49 9.21L12.49 8.39L12.37 7.83L12.04 7.33Z",
        "fill": "accent"
      },
      {
        "type": "polygon",
        "d": "M11.75 9.51L11.56 9.79L11.28 9.98L10.95 10.05L10.62 9.98L10.34 9.79L10.15 9.51L10.08 9.15L10.08 8.45L10.15 8.09L10.34 7.81L10.62 7.62L10.95 7.55L11.28 7.62L11.56 7.81L11.75 8.09L11.82 8.45L11.82 9.15Z",
        "fill": "truck"
      },
      {
        "type": "polygon",
        "d": "M14.76 10.72L16.15 10.72L16.55 6.95L15.89 6.88L15.55 10.05L15.42 10.05L15.41 8.09L14.11 8.09L14.1 10.05L13.97 10.05L13.63 6.88L12.97 6.95L13.37 10.72L14.76 10.72L14.76 10.39Z",
        "fill": "accent"
      },
      {
        "type": "polygon",
        "d": "M17.85 10.05L17.85 6.88L17.18 6.88L17.18 10.72L19.1 10.72L19.1 10.05Z",
        "fill": "accent"
      }
    ],
    "elianpost": [
      {
        "type": "polygon",
        "d": "M5.51 11.21L5.51 10.38L3.74 10.38L3.74 9.22L5.19 9.22L5.19 8.38L3.74 8.38L3.74 7.22L5.51 7.22L5.51 6.39L2.9 6.39L2.9 11.21Z",
        "fill": "accent"
      },
      {
        "type": "polygon",
        "d": "M7.15 10.38L7.15 6.39L6.31 6.39L6.31 11.21L8.73 11.21L8.73 10.38Z",
        "fill": "accent"
      },
      {
        "type": "polygon",
        "d": "M9.53 6.39L9.53 11.21L10.36 11.21L10.36 6.39Z",
        "fill": "accent"
      },
      {
        "type": "polygon",
        "d": "M14.83 11.06L13.94 6.39L12.05 6.39L11.16 11.06L11.99 11.21L12.23 9.94L13.76 9.94L14.01 11.21Z",
        "fill": "accent"
      },
      {
        "type": "polygon",
        "d": "M12.39 9.1L12.74 7.22L13.25 7.22L13.6 9.1Z",
        "fill": "truck"
      },
      {
        "type": "polygon",
        "d": "M19.1 11.21L19.1 6.39L18.26 6.39L18.26 10.38L17.94 10.38L17.54 6.39L15.63 6.39L15.63 11.21L16.47 11.21L16.47 7.22L16.78 7.22L17.18 11.21Z",
        "fill": "accent"
      }
    ],
    "bqc-logistics": [
      {
        "type": "polygon",
        "d": "M6.89 7.84L6.97 7.34L6.97 6.99L6.89 6.5L6.64 6.01L6.25 5.62L5.76 5.37L5.27 5.29L2.9 5.29L2.9 11.97L5.63 11.97L6.17 11.88L6.7 11.61L7.12 11.19L7.39 10.66L7.48 10.12L7.48 9.74L7.39 9.19L7.12 8.66L6.7 8.24L6.69 8.24Z",
        "fill": "accent"
      },
      {
        "type": "polygon",
        "d": "M4.06 9.05L5.54 9.05L5.81 9.09L6.01 9.19L6.17 9.35L6.28 9.56L6.32 9.83L6.32 10.03L6.28 10.3L6.17 10.5L6.01 10.66L5.81 10.77L5.54 10.81L4.06 10.81Z",
        "fill": "truck"
      },
      {
        "type": "polygon",
        "d": "M5.56 6.57L5.69 6.7L5.77 6.86L5.81 7.09L5.81 7.25L5.77 7.48L5.69 7.64L5.56 7.77L5.4 7.85L5.17 7.89L4.06 7.89L4.06 6.45L5.17 6.45L5.4 6.49Z",
        "fill": "truck"
      },
      {
        "type": "polygon",
        "d": "M12.24 5.49L11.21 5.28L10.18 5.49L9.31 6.07L8.73 6.94L8.54 7.91L8.54 9.35L8.73 10.32L9.31 11.19L10.18 11.78L11.21 11.98L12.24 11.78L12.37 11.69L12.85 12.32L13.77 11.62L13.27 10.96L13.7 10.32L13.89 9.35L13.89 7.91L13.7 6.94L13.11 6.07Z",
        "fill": "accent"
      },
      {
        "type": "polygon",
        "d": "M12.73 9.24L12.6 9.87L12.54 9.97L12.1 9.39L11.17 10.08L11.64 10.71L11.21 10.8L10.64 10.69L10.15 10.36L9.82 9.87L9.7 9.24L9.7 8.03L9.82 7.39L10.15 6.9L10.64 6.58L11.21 6.46L11.79 6.58L12.28 6.9L12.6 7.39L12.73 8.03Z",
        "fill": "truck"
      },
      {
        "type": "polygon",
        "d": "M17.31 5.29L16.59 5.39L15.94 5.72L15.43 6.22L15.1 6.87L14.99 7.54L14.99 9.73L15.1 10.39L15.43 11.04L15.94 11.55L16.59 11.87L17.31 11.98L18.02 11.86L18.66 11.52L19.1 11.06L18.27 10.26L17.96 10.58L17.64 10.74L17.29 10.8L16.94 10.75L16.63 10.59L16.38 10.34L16.21 10.03L16.15 9.63L16.15 7.63L16.21 7.23L16.38 6.92L16.63 6.67L16.94 6.51L17.29 6.46L17.64 6.52L17.96 6.68L18.27 7.01L19.1 6.2L18.66 5.75L18.02 5.41Z",
        "fill": "accent"
      }
    ],
    "king-kong-express": [
      {
        "type": "polygon",
        "d": "M6.86 5.18L4.16 7.88L4.16 5.18L2.9 5.18L2.9 12.42L4.16 12.42L4.16 9.66L4.76 9.05L6.76 12.42L7.84 11.78L5.68 8.13L7.75 6.07Z",
        "fill": "accent"
      },
      {
        "type": "polygon",
        "d": "M13 5.18L10.3 7.88L10.3 5.18L9.04 5.18L9.04 12.42L10.3 12.42L10.3 9.66L10.9 9.05L12.9 12.42L13.98 11.78L11.82 8.13L13.89 6.07Z",
        "fill": "accent"
      },
      {
        "type": "polygon",
        "d": "M19.1 11.16L16.44 11.16L16.44 9.43L18.61 9.43L18.61 8.17L16.44 8.17L16.44 6.44L19.1 6.44L19.1 5.18L15.18 5.18L15.18 12.42L19.1 12.42Z",
        "fill": "accent"
      }
    ],
    "libang-logistics": [
      {
        "type": "polygon",
        "d": "M8.83 8.36L8.87 8.09L8.87 7.89L8.83 7.62L8.69 7.34L8.48 7.13L8.21 6.99L7.93 6.95L6.62 6.95L6.62 10.65L8.13 10.65L8.43 10.6L8.73 10.45L8.96 10.22L9.11 9.93L9.16 9.62L9.16 9.41L9.11 9.11L8.96 8.82L8.72 8.58Z",
        "fill": "accent"
      },
      {
        "type": "polygon",
        "d": "M7.26 9.03L8.08 9.03L8.23 9.05L8.34 9.11L8.43 9.2L8.49 9.31L8.52 9.46L8.52 9.57L8.49 9.72L8.43 9.84L8.34 9.93L8.23 9.98L8.08 10.01L7.26 10.01Z",
        "fill": "truck"
      },
      {
        "type": "polygon",
        "d": "M8.16 7.73L8.21 7.82L8.23 7.94L8.23 8.03L8.21 8.16L8.16 8.25L8.09 8.32L8 8.37L7.88 8.39L7.26 8.39L7.26 7.59L7.88 7.59L8 7.61L8.09 7.66Z",
        "fill": "truck"
      },
      {
        "type": "polygon",
        "d": "M3.54 10.01L3.54 6.95L2.9 6.95L2.9 10.65L4.75 10.65L4.75 10.01Z",
        "fill": "accent"
      },
      {
        "type": "polygon",
        "d": "M5.36 6.95L5.36 10.65L6.01 10.65L6.01 6.95Z",
        "fill": "accent"
      },
      {
        "type": "polygon",
        "d": "M12.43 10.53L11.75 6.95L10.3 6.95L9.62 10.53L10.25 10.65L10.44 9.67L11.61 9.67L11.8 10.65Z",
        "fill": "accent"
      },
      {
        "type": "polygon",
        "d": "M10.56 9.03L10.83 7.59L11.22 7.59L11.49 9.03Z",
        "fill": "truck"
      },
      {
        "type": "polygon",
        "d": "M15.7 10.65L15.7 6.95L15.06 6.95L15.06 10.01L14.82 10.01L14.51 6.95L13.04 6.95L13.04 10.65L13.68 10.65L13.68 7.59L13.93 7.59L14.23 10.65Z",
        "fill": "accent"
      },
      {
        "type": "polygon",
        "d": "M17.99 9.94L17.71 10L17.42 9.94L17.18 9.78L17.02 9.54L16.96 9.23L16.96 8.37L17 8.11L17.11 7.9L17.27 7.73L17.48 7.63L17.72 7.59L17.95 7.63L18.16 7.74L18.35 7.95L18.82 7.5L18.55 7.22L18.16 7.02L17.72 6.94L17.29 7.01L16.89 7.2L16.58 7.51L16.38 7.91L16.32 8.31L16.32 9.29L16.42 9.79L16.72 10.25L17.17 10.55L17.71 10.66L18.24 10.55L18.7 10.25L19 9.79L19.1 9.29L19.1 8.63L17.71 8.63L17.71 9.27L18.45 9.27L18.39 9.54L18.23 9.78Z",
        "fill": "accent"
      }
    ],
    "sumxpress": [
      {
        "type": "polygon",
        "d": "M16.26 11.82L18.02 8.88L18.02 12.6L19.1 12.6L19.1 5L16.26 9.73L13.42 5L13.42 12.6L14.49 12.6L14.49 8.88Z",
        "fill": "accent"
      },
      {
        "type": "polygon",
        "d": "M3.18 7.22L2.9 8.52L3.67 9.64L5.66 10.27L5.97 10.71L5.87 11.15L5.36 11.52L4.61 11.52L3.92 11.03L3.3 11.91L4.27 12.6L5.7 12.6L6.84 11.79L7.12 10.47L6.33 9.35L4.35 8.73L4.05 8.3L4.15 7.84L4.64 7.48L5.33 7.48L5.98 7.96L6.62 7.1L5.69 6.4L4.28 6.4Z",
        "fill": "accent"
      },
      {
        "type": "polygon",
        "d": "M8.43 11.54L8.76 11.98L9.2 12.32L9.72 12.53L10.27 12.6L10.82 12.53L11.33 12.32L11.77 11.98L12.11 11.54L12.33 11.02L12.39 10.51L12.39 6.4L11.32 6.4L11.32 10.44L11.28 10.74L11.17 10.99L11.01 11.21L10.79 11.38L10.54 11.48L10.27 11.52L10 11.48L9.75 11.38L9.53 11.21L9.36 10.99L9.26 10.74L9.22 10.44L9.22 6.4L8.14 6.4L8.14 10.51L8.21 11.02Z",
        "fill": "accent"
      }
    ],
    "suning-logistics": [
      {
        "type": "polygon",
        "d": "M3.06 7.49L2.9 8.24L3.34 8.88L4.48 9.24L4.66 9.49L4.61 9.75L4.31 9.96L3.88 9.96L3.49 9.68L3.13 10.18L3.69 10.58L4.51 10.58L5.16 10.11L5.32 9.36L4.87 8.71L3.73 8.36L3.56 8.11L3.62 7.85L3.9 7.64L4.3 7.64L4.67 7.92L5.04 7.42L4.5 7.02L3.69 7.02Z",
        "fill": "#2c2c2c"
      },
      {
        "type": "polygon",
        "d": "M11.49 10.58L11.49 7.02L10.87 7.02L10.87 9.96L10.64 9.96L10.35 7.02L8.94 7.02L8.94 10.58L9.55 10.58L9.55 7.64L9.79 7.64L10.08 10.58Z",
        "fill": "#2c2c2c"
      },
      {
        "type": "polygon",
        "d": "M12.08 7.02L12.08 10.58L12.7 10.58L12.7 7.02Z",
        "fill": "#2c2c2c"
      },
      {
        "type": "polygon",
        "d": "M14.43 10.58L15.84 10.58L15.84 7.02L15.22 7.02L15.22 9.96L14.99 9.96L14.69 7.02L13.28 7.02L13.28 10.58L13.9 10.58L13.9 7.64L14.14 7.64Z",
        "fill": "#2c2c2c"
      },
      {
        "type": "polygon",
        "d": "M18.04 9.9L17.76 9.95L17.49 9.9L17.26 9.74L17.1 9.51L17.04 9.21L17.04 8.38L17.08 8.14L17.19 7.93L17.35 7.78L17.55 7.68L17.77 7.64L17.99 7.68L18.19 7.79L18.38 7.98L18.83 7.55L18.57 7.29L18.19 7.09L17.78 7.02L17.36 7.08L16.98 7.27L16.68 7.57L16.49 7.94L16.43 8.33L16.43 9.27L16.52 9.75L16.81 10.19L17.25 10.48L17.76 10.58L18.28 10.48L18.71 10.19L19 9.75L19.1 9.27L19.1 8.64L17.76 8.64L17.76 9.25L18.47 9.25L18.42 9.51L18.27 9.74Z",
        "fill": "#2c2c2c"
      },
      {
        "type": "polygon",
        "d": "M6.26 10.22L6.52 10.42L6.81 10.54L7.13 10.58L7.45 10.54L7.74 10.42L7.99 10.22L8.19 9.97L8.31 9.67L8.35 9.38L8.35 7.02L7.73 7.02L7.73 9.34L7.71 9.51L7.65 9.66L7.55 9.78L7.43 9.88L7.28 9.94L7.13 9.96L6.97 9.94L6.83 9.88L6.7 9.78L6.61 9.66L6.55 9.51L6.53 9.34L6.53 7.02L5.91 7.02L5.91 9.38L5.95 9.67L6.07 9.97Z",
        "fill": "#2c2c2c"
      }
    ],
    "rrs-logistics": [
      {
        "type": "polygon",
        "d": "M6.3 9.36L6.96 8.91L7.41 8.24L7.57 7.45L7.41 6.67L6.96 6L6.3 5.55L5.57 5.41L2.9 5.41L2.9 12.19L4.08 12.19L4.08 9.5L4.43 9.5L6.69 12.19L7.6 11.44L5.91 9.43Z",
        "fill": "accent"
      },
      {
        "type": "polygon",
        "d": "M5.84 6.66L6.12 6.85L6.3 7.13L6.37 7.45L6.3 7.78L6.12 8.06L5.84 8.25L5.45 8.32L4.08 8.32L4.08 6.58L5.45 6.58Z",
        "fill": "truck"
      },
      {
        "type": "polygon",
        "d": "M12.11 9.36L12.78 8.91L13.23 8.24L13.39 7.45L13.23 6.67L12.78 6L12.11 5.55L11.38 5.41L8.72 5.41L8.72 12.19L9.9 12.19L9.9 9.5L10.25 9.5L12.51 12.19L13.41 11.44L11.73 9.43Z",
        "fill": "accent"
      },
      {
        "type": "polygon",
        "d": "M11.65 6.66L11.93 6.85L12.12 7.13L12.18 7.45L12.12 7.78L11.93 8.06L11.65 8.25L11.27 8.32L9.9 8.32L9.9 6.58L11.27 6.58Z",
        "fill": "truck"
      },
      {
        "type": "polygon",
        "d": "M14.78 6.3L14.47 7.73L15.32 8.96L17.5 9.64L17.84 10.12L17.73 10.61L17.17 11.02L16.35 11.02L15.6 10.48L14.91 11.44L15.97 12.19L17.54 12.19L18.79 11.31L19.1 9.86L18.23 8.64L16.06 7.96L15.73 7.48L15.84 6.98L16.38 6.58L17.14 6.58L17.85 7.11L18.56 6.17L17.53 5.41L15.99 5.41Z",
        "fill": "accent"
      }
    ],
    "changjiang-express": [
      {
        "type": "polygon",
        "d": "M3.39 7.82L3.19 7.91L3.03 8.07L2.93 8.26L2.9 8.47L2.9 9.13L2.93 9.33L3.03 9.53L3.19 9.68L3.39 9.78L3.6 9.81L3.82 9.78L4.01 9.68L4.15 9.54L3.89 9.29L3.8 9.39L3.7 9.44L3.6 9.46L3.49 9.44L3.4 9.39L3.32 9.32L3.27 9.22L3.25 9.1L3.25 8.5L3.27 8.38L3.32 8.28L3.4 8.2L3.49 8.16L3.6 8.14L3.7 8.16L3.8 8.21L3.89 8.31L4.15 8.06L4.01 7.92L3.82 7.82L3.6 7.78Z",
        "fill": "accent"
      },
      {
        "type": "polygon",
        "d": "M5.52 9.81L5.87 9.81L5.87 7.79L5.52 7.79L5.52 8.62L4.83 8.62L4.83 7.79L4.48 7.79L4.48 9.81L4.83 9.81L4.83 8.98L5.52 8.98Z",
        "fill": "accent"
      },
      {
        "type": "polygon",
        "d": "M7.37 7.79L6.58 7.79L6.21 9.75L6.55 9.81L6.65 9.28L7.3 9.28L7.4 9.81L7.74 9.75Z",
        "fill": "accent"
      },
      {
        "type": "polygon",
        "d": "M6.87 8.14L7.08 8.14L7.23 8.92L6.72 8.92Z",
        "fill": "truck"
      },
      {
        "type": "polygon",
        "d": "M9.54 7.79L9.18 7.79L9.18 9.46L9.05 9.46L8.88 7.79L8.08 7.79L8.08 9.81L8.43 9.81L8.43 8.14L8.57 8.14L8.73 9.81L9.54 9.81Z",
        "fill": "accent"
      },
      {
        "type": "polygon",
        "d": "M13.22 7.79L13.22 9.81L13.58 9.81L13.58 7.79Z",
        "fill": "accent"
      },
      {
        "type": "polygon",
        "d": "M15.08 7.79L14.28 7.79L13.91 9.75L14.26 9.81L14.36 9.28L15 9.28L15.1 9.81L15.45 9.75Z",
        "fill": "accent"
      },
      {
        "type": "polygon",
        "d": "M14.79 8.14L14.94 8.92L14.43 8.92L14.57 8.14Z",
        "fill": "truck"
      },
      {
        "type": "polygon",
        "d": "M17.24 7.79L16.89 7.79L16.89 9.46L16.76 9.46L16.59 7.79L15.78 7.79L15.78 9.81L16.14 9.81L16.14 8.14L16.27 8.14L16.44 9.81L17.24 9.81Z",
        "fill": "accent"
      },
      {
        "type": "polygon",
        "d": "M10.63 9.46L10.48 9.43L10.35 9.34L10.26 9.21L10.22 9.03L10.22 8.56L10.25 8.42L10.3 8.31L10.4 8.22L10.51 8.16L10.64 8.14L10.76 8.16L10.88 8.22L10.99 8.33L11.24 8.09L11.09 7.94L10.88 7.82L10.64 7.78L10.4 7.82L10.19 7.93L10.02 8.1L9.91 8.31L9.87 8.53L9.87 9.07L9.93 9.34L10.09 9.59L10.34 9.76L10.63 9.82L10.93 9.76L11.17 9.59L11.34 9.34L11.4 9.07L11.4 8.71L10.63 8.71L10.63 9.06L11.04 9.06L11.01 9.21L10.92 9.34L10.79 9.43Z",
        "fill": "accent"
      },
      {
        "type": "polygon",
        "d": "M18.34 9.46L18.18 9.43L18.05 9.34L17.96 9.21L17.93 9.03L17.93 8.56L17.95 8.42L18.01 8.31L18.1 8.22L18.22 8.16L18.34 8.14L18.47 8.16L18.58 8.22L18.69 8.33L18.94 8.09L18.8 7.94L18.58 7.82L18.35 7.78L18.11 7.82L17.89 7.93L17.72 8.1L17.61 8.31L17.58 8.53L17.58 9.07L17.63 9.34L17.8 9.59L18.05 9.76L18.34 9.82L18.63 9.76L18.88 9.59L19.05 9.34L19.1 9.07L19.1 8.71L18.34 8.71L18.34 9.06L18.74 9.06L18.71 9.21L18.63 9.34L18.49 9.43Z",
        "fill": "accent"
      },
      {
        "type": "polygon",
        "d": "M12.42 9.43L12.36 9.45L12.3 9.46L12.23 9.45L12.17 9.43L12.12 9.39L12.09 9.34L12.06 9.28L12.05 9.2L11.7 9.24L11.72 9.37L11.78 9.52L11.87 9.64L12 9.73L12.14 9.79L12.3 9.81L12.45 9.79L12.59 9.73L12.72 9.64L12.81 9.52L12.87 9.37L12.89 9.23L12.89 7.79L12.54 7.79L12.54 9.21L12.53 9.28L12.5 9.34L12.47 9.39Z",
        "fill": "accent"
      }
    ],
    "ees-logistics": [
      {
        "type": "polygon",
        "d": "M8.06 11.8L8.06 10.76L5.85 10.76L5.85 9.32L7.65 9.32L7.65 8.28L5.85 8.28L5.85 6.84L8.06 6.84L8.06 5.8L4.81 5.8L4.81 11.8Z",
        "fill": "accent"
      },
      {
        "type": "polygon",
        "d": "M12.3 11.8L12.3 10.76L10.09 10.76L10.09 9.32L11.89 9.32L11.89 8.28L10.09 8.28L10.09 6.84L12.3 6.84L12.3 5.8L9.05 5.8L9.05 11.8Z",
        "fill": "accent"
      },
      {
        "type": "polygon",
        "d": "M13.1 7.85L13.84 8.94L15.77 9.55L16.07 9.97L15.98 10.4L15.48 10.76L14.76 10.76L14.09 10.29L13.49 11.13L14.42 11.8L15.81 11.8L16.91 11.02L17.19 9.74L16.42 8.66L14.5 8.06L14.21 7.63L14.31 7.19L14.78 6.84L15.45 6.84L16.09 7.31L16.71 6.47L15.8 5.8L14.43 5.8L13.37 6.59Z",
        "fill": "accent"
      }
    ],
    "annto": [
      {
        "type": "polygon",
        "d": "M13.47 6.84L13.47 7.52L14.14 7.52L14.14 10.76L14.82 10.76L14.82 7.52L15.48 7.52L15.48 6.84Z",
        "fill": "accent"
      },
      {
        "type": "polygon",
        "d": "M5.88 10.64L5.16 6.84L3.62 6.84L2.9 10.64L3.57 10.76L3.77 9.72L5.01 9.72L5.21 10.76Z",
        "fill": "accent"
      },
      {
        "type": "polygon",
        "d": "M4.19 7.52L4.6 7.52L4.88 9.04L3.9 9.04Z",
        "fill": "truck"
      },
      {
        "type": "polygon",
        "d": "M9.35 10.76L9.35 6.84L8.67 6.84L8.67 10.08L8.41 10.08L8.09 6.84L6.53 6.84L6.53 10.76L7.21 10.76L7.21 7.52L7.47 7.52L7.8 10.76Z",
        "fill": "accent"
      },
      {
        "type": "polygon",
        "d": "M12.82 10.76L12.82 6.84L12.14 6.84L12.14 10.08L11.88 10.08L11.56 6.84L10 6.84L10 10.76L10.68 10.76L10.68 7.52L10.94 7.52L11.27 10.76Z",
        "fill": "accent"
      },
      {
        "type": "polygon",
        "d": "M18.13 6.95L17.53 6.83L16.92 6.95L16.41 7.29L16.07 7.81L15.95 8.38L15.95 9.22L16.07 9.79L16.41 10.31L16.92 10.65L17.53 10.77L18.13 10.65L18.64 10.31L18.99 9.79L19.1 9.22L19.1 8.38L18.99 7.81L18.64 7.29Z",
        "fill": "accent"
      },
      {
        "type": "polygon",
        "d": "M18.42 9.16L18.34 9.53L18.15 9.82L17.87 10.01L17.53 10.07L17.19 10.01L16.9 9.82L16.71 9.53L16.63 9.16L16.63 8.44L16.71 8.07L16.9 7.78L17.19 7.59L17.53 7.53L17.87 7.59L18.15 7.78L18.34 8.07L18.42 8.44Z",
        "fill": "truck"
      }
    ],
    "jdiex": [
      {
        "type": "polygon",
        "d": "M7.52 11.16L8.1 11.09L8.68 10.85L9.17 10.47L9.54 9.98L9.78 9.41L9.86 8.8L9.78 8.18L9.54 7.61L9.17 7.12L8.68 6.75L8.1 6.51L7.52 6.43L6.46 6.43L6.46 11.16Z",
        "fill": "accent"
      },
      {
        "type": "polygon",
        "d": "M7.89 7.31L8.26 7.46L8.58 7.71L8.83 8.03L8.98 8.4L9.03 8.8L8.98 9.2L8.83 9.57L8.58 9.89L8.26 10.13L7.89 10.29L7.46 10.34L7.28 10.34L7.28 7.25L7.46 7.25Z",
        "fill": "truck"
      },
      {
        "type": "polygon",
        "d": "M10.64 6.43L10.64 11.16L11.46 11.16L11.46 6.43Z",
        "fill": "accent"
      },
      {
        "type": "polygon",
        "d": "M14.81 10.34L13.07 10.34L13.07 9.21L14.49 9.21L14.49 8.39L13.07 8.39L13.07 7.25L14.81 7.25L14.81 6.43L12.25 6.43L12.25 11.16L14.81 11.16Z",
        "fill": "accent"
      },
      {
        "type": "polygon",
        "d": "M19.1 6.88L18.41 6.43L17.35 8.05L16.28 6.43L15.59 6.88L16.85 8.8L15.59 10.71L16.28 11.16L17.35 9.54L18.41 11.16L19.1 10.71L17.84 8.8Z",
        "fill": "accent"
      },
      {
        "type": "polygon",
        "d": "M4.68 10.17L4.57 10.26L4.43 10.32L4.28 10.34L4.14 10.32L4 10.26L3.89 10.17L3.8 10.06L3.74 9.92L3.71 9.72L2.9 9.83L2.94 10.14L3.08 10.47L3.3 10.76L3.59 10.98L3.92 11.12L4.28 11.17L4.65 11.12L4.98 10.98L5.27 10.76L5.49 10.47L5.63 10.14L5.67 9.8L5.67 6.43L4.85 6.43L4.85 9.75L4.83 9.92L4.77 10.06Z",
        "fill": "accent"
      }
    ],
    "sxjd-freight": [
      {
        "type": "polygon",
        "d": "M3.13 6.89L2.9 7.98L3.54 8.92L5.21 9.44L5.47 9.81L5.39 10.18L4.95 10.49L4.33 10.49L3.76 10.08L3.24 10.81L4.04 11.39L5.24 11.39L6.19 10.71L6.43 9.61L5.76 8.67L4.11 8.16L3.86 7.79L3.94 7.41L4.35 7.11L4.93 7.11L5.48 7.51L6.01 6.79L5.23 6.21L4.05 6.21Z",
        "fill": "accent"
      },
      {
        "type": "polygon",
        "d": "M9.48 8.8L10.87 6.71L10.12 6.21L8.95 7.98L7.78 6.21L7.03 6.71L8.41 8.8L7.03 10.89L7.78 11.39L8.95 9.61L10.12 11.39L10.87 10.89Z",
        "fill": "accent"
      },
      {
        "type": "polygon",
        "d": "M17.18 11.3L17.8 11.04L18.34 10.63L18.75 10.09L19.01 9.47L19.1 8.8L19.01 8.13L18.75 7.5L18.34 6.97L17.8 6.55L17.18 6.29L16.54 6.21L15.37 6.21L15.37 11.39L16.54 11.39Z",
        "fill": "accent"
      },
      {
        "type": "polygon",
        "d": "M17.35 7.34L17.7 7.61L17.97 7.96L18.14 8.36L18.19 8.8L18.14 9.23L17.97 9.64L17.7 9.99L17.35 10.26L16.94 10.43L16.48 10.49L16.27 10.49L16.27 7.11L16.48 7.11L16.94 7.17Z",
        "fill": "truck"
      },
      {
        "type": "polygon",
        "d": "M13.44 10.3L13.31 10.4L13.16 10.46L13 10.48L12.84 10.46L12.69 10.4L12.57 10.3L12.47 10.18L12.41 10.03L12.38 9.81L11.49 9.93L11.53 10.26L11.68 10.63L11.92 10.94L12.24 11.19L12.61 11.34L13 11.39L13.39 11.34L13.76 11.19L14.08 10.94L14.32 10.63L14.47 10.26L14.52 9.9L14.52 6.21L13.62 6.21L13.62 9.84L13.6 10.03L13.53 10.18Z",
        "fill": "accent"
      }
    ],
    "cpszy": [
      {
        "type": "polygon",
        "d": "M6.9 5.91L6.26 5.8L5.62 5.9L5.04 6.19L4.58 6.64L4.28 7.22L4.18 7.82L4.18 9.78L4.28 10.38L4.58 10.96L5.04 11.41L5.62 11.7L6.26 11.8L6.9 11.69L7.47 11.39L7.87 10.98L7.12 10.26L6.84 10.55L6.56 10.69L6.25 10.75L5.93 10.7L5.65 10.56L5.42 10.34L5.28 10.05L5.22 9.7L5.22 7.9L5.28 7.55L5.42 7.26L5.65 7.04L5.93 6.9L6.25 6.85L6.56 6.91L6.84 7.05L7.12 7.34L7.87 6.62L7.47 6.21Z",
        "fill": "accent"
      },
      {
        "type": "polygon",
        "d": "M11.65 9.29L12.24 8.9L12.64 8.31L12.78 7.61L12.64 6.92L12.24 6.33L11.65 5.93L11.01 5.81L8.86 5.81L8.86 11.79L9.9 11.79L9.9 9.42L11.01 9.42Z",
        "fill": "accent"
      },
      {
        "type": "polygon",
        "d": "M11.25 6.91L11.49 7.08L11.66 7.32L11.72 7.61L11.66 7.9L11.49 8.15L11.25 8.31L10.91 8.38L9.9 8.38L9.9 6.85L10.91 6.85Z",
        "fill": "truck"
      },
      {
        "type": "polygon",
        "d": "M14.01 6.59L13.74 7.86L14.48 8.94L16.4 9.54L16.7 9.97L16.61 10.4L16.11 10.75L15.39 10.75L14.73 10.28L14.12 11.13L15.06 11.79L16.44 11.79L17.54 11.01L17.82 9.74L17.05 8.66L15.14 8.06L14.85 7.64L14.94 7.2L15.41 6.85L16.09 6.85L16.72 7.31L17.34 6.48L16.43 5.81L15.07 5.81Z",
        "fill": "accent"
      }
    ],
    "valueway": [
      {
        "type": "polygon",
        "d": "M4.4 7.53L4 9.63L3.73 9.63L3.33 7.53L2.9 7.61L3.37 10.07L4.36 10.07L4.83 7.61Z",
        "fill": "accent"
      },
      {
        "type": "polygon",
        "d": "M6.27 7.53L5.27 7.53L4.81 9.99L5.24 10.07L5.37 9.4L6.18 9.4L6.3 10.07L6.74 9.99Z",
        "fill": "accent"
      },
      {
        "type": "polygon",
        "d": "M5.91 7.97L6.09 8.96L5.45 8.96L5.64 7.97Z",
        "fill": "truck"
      },
      {
        "type": "polygon",
        "d": "M7.6 7.53L7.16 7.53L7.16 10.07L8.43 10.07L8.43 9.63L7.6 9.63Z",
        "fill": "accent"
      },
      {
        "type": "polygon",
        "d": "M12.31 9.63L11.38 9.63L11.38 9.02L12.14 9.02L12.14 8.58L11.38 8.58L11.38 7.97L12.31 7.97L12.31 7.53L10.94 7.53L10.94 10.07L12.31 10.07Z",
        "fill": "accent"
      },
      {
        "type": "polygon",
        "d": "M9.21 9.96L9.42 10.04L9.64 10.07L9.87 10.04L10.08 9.96L10.26 9.82L10.4 9.64L10.49 9.42L10.52 9.21L10.52 7.53L10.08 7.53L10.08 9.18L10.06 9.31L10.02 9.41L9.95 9.5L9.86 9.57L9.76 9.61L9.64 9.63L9.53 9.61L9.43 9.57L9.34 9.5L9.27 9.41L9.23 9.31L9.21 9.18L9.21 7.53L8.77 7.53L8.77 9.21L8.8 9.42L8.89 9.64L9.03 9.82Z",
        "fill": "accent"
      },
      {
        "type": "polygon",
        "d": "M17.21 7.77L17.94 8.87L17.94 10.07L18.38 10.07L18.38 8.87L19.1 7.77L18.73 7.53L18.16 8.4L17.58 7.53Z",
        "fill": "accent"
      },
      {
        "type": "polygon",
        "d": "M14.84 10.07L15.11 7.57L14.67 7.53L14.45 9.63L14.36 9.63L14.35 8.33L13.49 8.33L13.48 9.63L13.39 9.63L13.17 7.53L12.73 7.57L13 10.07L13.92 10.07L13.92 9.85L13.92 10.07Z",
        "fill": "accent"
      },
      {
        "type": "polygon",
        "d": "M16.74 7.53L15.74 7.53L15.28 9.99L15.71 10.07L15.84 9.4L16.65 9.4L16.77 10.07L17.21 9.99Z",
        "fill": "accent"
      },
      {
        "type": "polygon",
        "d": "M15.92 8.96L16.11 7.97L16.37 7.97L16.56 8.96Z",
        "fill": "truck"
      }
    ],
    "jiachen-express": [
      {
        "type": "polygon",
        "d": "M5.32 7.19L5.32 10.41L5.88 10.41L5.88 7.19Z",
        "fill": "accent"
      },
      {
        "type": "polygon",
        "d": "M8.87 10.31L8.27 7.19L7.01 7.19L6.42 10.31L6.97 10.41L7.13 9.56L8.16 9.56L8.32 10.41Z",
        "fill": "accent"
      },
      {
        "type": "polygon",
        "d": "M7.47 7.75L7.81 7.75L8.05 9L7.24 9Z",
        "fill": "truck"
      },
      {
        "type": "polygon",
        "d": "M10.01 7.23L9.69 7.39L9.45 7.64L9.29 7.95L9.23 8.27L9.23 9.33L9.29 9.65L9.45 9.96L9.69 10.21L10.01 10.37L10.35 10.42L10.7 10.36L11.01 10.19L11.22 9.98L10.82 9.59L10.67 9.74L10.52 9.82L10.35 9.85L10.18 9.82L10.02 9.75L9.9 9.63L9.83 9.48L9.79 9.28L9.79 8.32L9.83 8.12L9.9 7.97L10.02 7.85L10.18 7.78L10.35 7.75L10.52 7.78L10.67 7.86L10.82 8.01L11.22 7.62L11.01 7.41L10.7 7.24L10.35 7.18Z",
        "fill": "accent"
      },
      {
        "type": "polygon",
        "d": "M11.75 10.41L12.31 10.41L12.31 9.08L13.41 9.08L13.41 10.41L13.97 10.41L13.97 7.19L13.41 7.19L13.41 8.52L12.31 8.52L12.31 7.19L11.75 7.19Z",
        "fill": "accent"
      },
      {
        "type": "polygon",
        "d": "M4.04 9.8L3.94 9.84L3.84 9.85L3.74 9.84L3.65 9.8L3.57 9.74L3.51 9.66L3.47 9.57L3.46 9.43L2.9 9.5L2.93 9.71L3.02 9.94L3.17 10.14L3.37 10.29L3.6 10.38L3.84 10.42L4.09 10.38L4.32 10.29L4.52 10.14L4.67 9.94L4.76 9.71L4.79 9.49L4.79 7.19L4.23 7.19L4.23 9.45L4.22 9.57L4.18 9.66L4.12 9.74Z",
        "fill": "accent"
      },
      {
        "type": "polygon",
        "d": "M16.25 9.85L15.06 9.85L15.06 9.08L16.03 9.08L16.03 8.52L15.06 8.52L15.06 7.75L16.25 7.75L16.25 7.19L14.5 7.19L14.5 10.41L16.25 10.41Z",
        "fill": "accent"
      },
      {
        "type": "polygon",
        "d": "M19.1 7.19L18.54 7.19L18.54 9.85L18.33 9.85L18.06 7.19L16.78 7.19L16.78 10.41L17.34 10.41L17.34 7.75L17.55 7.75L17.82 10.41L19.1 10.41Z",
        "fill": "accent"
      }
    ],
    "longcps": [
      {
        "type": "polygon",
        "d": "M4.33 9.73L3.4 9.73L3.4 7.37L2.9 7.37L2.9 10.23L4.33 10.23Z",
        "fill": "accent"
      },
      {
        "type": "polygon",
        "d": "M6.26 7.45L5.82 7.37L5.38 7.45L5 7.7L4.75 8.08L4.67 8.49L4.67 9.11L4.75 9.52L5 9.9L5.38 10.15L5.82 10.23L6.26 10.15L6.63 9.9L6.88 9.52L6.96 9.11L6.96 8.49L6.88 8.08L6.63 7.7Z",
        "fill": "accent"
      },
      {
        "type": "polygon",
        "d": "M6.41 9.33L6.27 9.54L6.06 9.68L5.82 9.73L5.57 9.68L5.36 9.54L5.22 9.33L5.17 9.06L5.17 8.54L5.22 8.27L5.36 8.06L5.57 7.92L5.82 7.87L6.06 7.92L6.27 8.06L6.41 8.27L6.47 8.54L6.47 9.06Z",
        "fill": "truck"
      },
      {
        "type": "polygon",
        "d": "M9.49 10.23L9.49 7.37L9 7.37L9 9.73L8.81 9.73L8.57 7.37L7.44 7.37L7.44 10.23L7.93 10.23L7.93 7.87L8.12 7.87L8.36 10.23Z",
        "fill": "accent"
      },
      {
        "type": "polygon",
        "d": "M13.27 7.41L13 7.55L12.78 7.77L12.63 8.04L12.59 8.33L12.59 9.27L12.63 9.56L12.78 9.83L13 10.05L13.27 10.19L13.58 10.23L13.89 10.18L14.16 10.04L14.35 9.84L13.99 9.5L13.86 9.63L13.72 9.7L13.57 9.73L13.42 9.71L13.29 9.64L13.18 9.53L13.11 9.4L13.08 9.23L13.08 8.37L13.11 8.2L13.18 8.07L13.29 7.96L13.42 7.89L13.57 7.87L13.72 7.9L13.86 7.97L13.99 8.1L14.35 7.76L14.16 7.56L13.89 7.42L13.58 7.37Z",
        "fill": "accent"
      },
      {
        "type": "polygon",
        "d": "M16.44 8.85L16.63 8.56L16.69 8.23L16.63 7.9L16.44 7.62L16.16 7.43L15.85 7.37L14.82 7.37L14.82 10.23L15.32 10.23L15.32 9.1L15.85 9.1L16.16 9.03Z",
        "fill": "accent"
      },
      {
        "type": "polygon",
        "d": "M16.08 7.98L16.16 8.09L16.19 8.23L16.16 8.37L16.08 8.49L15.96 8.57L15.8 8.6L15.32 8.6L15.32 7.87L15.8 7.87L15.96 7.9Z",
        "fill": "truck"
      },
      {
        "type": "polygon",
        "d": "M17.15 8.35L17.51 8.87L18.43 9.16L18.57 9.36L18.52 9.56L18.29 9.73L17.94 9.73L17.62 9.51L17.34 9.91L17.78 10.23L18.44 10.23L18.97 9.86L19.1 9.25L18.73 8.73L17.82 8.45L17.68 8.24L17.73 8.03L17.95 7.87L18.27 7.87L18.58 8.09L18.87 7.69L18.44 7.37L17.79 7.37L17.28 7.75Z",
        "fill": "accent"
      },
      {
        "type": "polygon",
        "d": "M11.26 9.68L11.04 9.73L10.82 9.68L10.63 9.56L10.51 9.37L10.46 9.13L10.46 8.47L10.49 8.27L10.58 8.1L10.7 7.98L10.87 7.9L11.05 7.87L11.23 7.9L11.39 7.98L11.54 8.14L11.9 7.8L11.69 7.58L11.39 7.42L11.05 7.37L10.72 7.42L10.41 7.57L10.17 7.81L10.02 8.11L9.97 8.43L9.97 9.18L10.04 9.57L10.28 9.92L10.63 10.15L11.04 10.23L11.45 10.15L11.8 9.92L12.04 9.57L12.12 9.18L12.12 8.67L11.04 8.67L11.04 9.17L11.61 9.17L11.57 9.37L11.45 9.56Z",
        "fill": "accent"
      }
    ],
    "bridge-intl": [
      {
        "type": "polygon",
        "d": "M5.1 8.36L5.15 8.09L5.15 7.89L5.1 7.62L4.97 7.35L4.75 7.14L4.48 7L4.21 6.95L2.9 6.95L2.9 10.64L4.41 10.64L4.71 10.6L5 10.45L5.23 10.21L5.38 9.92L5.43 9.62L5.43 9.41L5.38 9.11L5.23 8.82L4.99 8.58Z",
        "fill": "#1a1a1a"
      },
      {
        "type": "polygon",
        "d": "M3.54 9.03L4.36 9.03L4.51 9.05L4.62 9.11L4.71 9.2L4.77 9.31L4.79 9.46L4.79 9.57L4.77 9.72L4.71 9.83L4.62 9.92L4.51 9.98L4.36 10L3.54 10Z",
        "fill": "truck"
      },
      {
        "type": "polygon",
        "d": "M4.44 7.73L4.49 7.82L4.51 7.94L4.51 8.04L4.49 8.16L4.44 8.25L4.37 8.32L4.28 8.37L4.16 8.39L3.54 8.39L3.54 7.59L4.16 7.59L4.28 7.61L4.37 7.66Z",
        "fill": "truck"
      },
      {
        "type": "polygon",
        "d": "M8.25 8.86L8.49 8.5L8.58 8.07L8.49 7.64L8.25 7.28L7.89 7.03L7.49 6.95L6.04 6.95L6.04 10.64L6.68 10.64L6.68 9.18L6.87 9.18L8.1 10.64L8.59 10.23L7.68 9.14L7.89 9.1Z",
        "fill": "#1a1a1a"
      },
      {
        "type": "polygon",
        "d": "M7.79 7.74L7.89 7.89L7.92 8.07L7.89 8.25L7.79 8.4L7.64 8.5L7.43 8.54L6.68 8.54L6.68 7.59L7.43 7.59L7.64 7.64Z",
        "fill": "truck"
      },
      {
        "type": "polygon",
        "d": "M9.2 10.64L9.84 10.64L9.84 6.95L9.2 6.95Z",
        "fill": "#1a1a1a"
      },
      {
        "type": "polygon",
        "d": "M12.18 10.4L12.57 10.11L12.86 9.72L13.05 9.28L13.11 8.8L13.05 8.32L12.86 7.88L12.57 7.49L12.18 7.2L11.74 7.01L11.28 6.95L10.45 6.95L10.45 10.64L11.28 10.64L11.74 10.58Z",
        "fill": "#1a1a1a"
      },
      {
        "type": "polygon",
        "d": "M12.11 7.95L12.3 8.2L12.42 8.49L12.46 8.8L12.42 9.11L12.3 9.4L12.11 9.65L11.86 9.84L11.57 9.96L11.24 10L11.09 10L11.09 7.59L11.24 7.59L11.57 7.64L11.86 7.76Z",
        "fill": "truck"
      },
      {
        "type": "polygon",
        "d": "M19.1 10L17.74 10L17.74 9.12L18.85 9.12L18.85 8.48L17.74 8.48L17.74 7.59L19.1 7.59L19.1 6.95L17.1 6.95L17.1 10.64L19.1 10.64Z",
        "fill": "#1a1a1a"
      },
      {
        "type": "polygon",
        "d": "M15.39 9.94L15.11 10L14.82 9.94L14.58 9.78L14.42 9.54L14.36 9.22L14.36 8.37L14.4 8.11L14.51 7.9L14.67 7.74L14.88 7.63L15.11 7.6L15.34 7.64L15.55 7.75L15.75 7.95L16.21 7.51L15.94 7.23L15.55 7.02L15.12 6.95L14.69 7.01L14.3 7.21L13.98 7.52L13.78 7.91L13.72 8.32L13.72 9.29L13.82 9.79L14.12 10.24L14.57 10.54L15.11 10.65L15.64 10.54L16.09 10.24L16.39 9.79L16.49 9.29L16.49 8.63L15.11 8.63L15.11 9.27L15.84 9.27L15.79 9.54L15.63 9.78Z",
        "fill": "#1a1a1a"
      }
    ],
    "jiufang": [
      {
        "type": "polygon",
        "d": "M5.31 7.2L5.31 10.4L5.87 10.4L5.87 7.2Z",
        "fill": "accent"
      },
      {
        "type": "polygon",
        "d": "M9.68 9.08L10.58 9.08L10.58 8.52L9.68 8.52L9.68 7.75L10.78 7.75L10.78 7.2L9.13 7.2L9.13 10.4L9.68 10.4Z",
        "fill": "accent"
      },
      {
        "type": "polygon",
        "d": "M13.32 10.3L12.73 7.2L11.47 7.2L10.89 10.3L11.43 10.4L11.59 9.55L12.61 9.55L12.77 10.4Z",
        "fill": "accent"
      },
      {
        "type": "polygon",
        "d": "M11.94 7.75L12.27 7.75L12.51 9L11.7 9Z",
        "fill": "truck"
      },
      {
        "type": "polygon",
        "d": "M16.16 10.4L16.16 7.2L15.6 7.2L15.6 9.85L15.39 9.85L15.12 7.2L13.85 7.2L13.85 10.4L14.41 10.4L14.41 7.75L14.62 7.75L14.88 10.4Z",
        "fill": "accent"
      },
      {
        "type": "polygon",
        "d": "M18.14 9.79L17.89 9.84L17.65 9.79L17.44 9.65L17.3 9.44L17.24 9.17L17.24 8.42L17.28 8.2L17.37 8.02L17.52 7.88L17.7 7.79L17.9 7.76L18.1 7.79L18.28 7.88L18.45 8.06L18.85 7.68L18.62 7.43L18.28 7.26L17.91 7.19L17.53 7.25L17.19 7.42L16.92 7.69L16.74 8.03L16.69 8.38L16.69 9.22L16.77 9.66L17.04 10.05L17.43 10.32L17.89 10.41L18.36 10.32L18.75 10.05L19.01 9.66L19.1 9.22L19.1 8.65L17.89 8.65L17.89 9.21L18.54 9.21L18.49 9.44L18.35 9.65Z",
        "fill": "accent"
      },
      {
        "type": "polygon",
        "d": "M4.11 9.73L4.03 9.79L3.94 9.83L3.84 9.84L3.74 9.83L3.65 9.79L3.57 9.73L3.51 9.65L3.47 9.56L3.45 9.43L2.9 9.5L2.93 9.71L3.02 9.93L3.17 10.13L3.37 10.28L3.59 10.37L3.84 10.41L4.08 10.37L4.31 10.28L4.51 10.13L4.66 9.93L4.75 9.71L4.78 9.48L4.78 7.2L4.22 7.2L4.22 9.44L4.21 9.56L4.17 9.65Z",
        "fill": "accent"
      },
      {
        "type": "polygon",
        "d": "M6.95 10.26L7.21 10.37L7.5 10.41L7.78 10.37L8.05 10.26L8.28 10.08L8.45 9.85L8.56 9.59L8.6 9.32L8.6 7.2L8.04 7.2L8.04 9.28L8.02 9.44L7.97 9.57L7.88 9.69L7.77 9.77L7.64 9.83L7.5 9.84L7.36 9.83L7.23 9.77L7.11 9.69L7.03 9.57L6.97 9.44L6.95 9.28L6.95 7.2L6.4 7.2L6.4 9.32L6.43 9.59L6.54 9.85L6.72 10.08Z",
        "fill": "accent"
      }
    ],
    "cel-changda": [
      {
        "type": "polygon",
        "d": "M7.13 5.8L6.49 5.9L5.91 6.19L5.44 6.64L5.15 7.22L5.05 7.82L5.05 9.78L5.15 10.38L5.44 10.96L5.91 11.41L6.49 11.7L7.13 11.8L7.77 11.69L8.34 11.39L8.73 10.98L7.99 10.26L7.71 10.55L7.43 10.69L7.12 10.75L6.8 10.7L6.52 10.56L6.29 10.34L6.15 10.05L6.09 9.7L6.09 7.9L6.15 7.55L6.29 7.26L6.52 7.04L6.8 6.9L7.12 6.85L7.43 6.91L7.71 7.05L7.99 7.34L8.73 6.62L8.34 6.21L7.77 5.91Z",
        "fill": "#1a1a1a"
      },
      {
        "type": "polygon",
        "d": "M12.97 11.79L12.97 10.75L10.76 10.75L10.76 9.32L12.56 9.32L12.56 8.28L10.76 8.28L10.76 6.85L12.97 6.85L12.97 5.81L9.72 5.81L9.72 11.79Z",
        "fill": "#1a1a1a"
      },
      {
        "type": "polygon",
        "d": "M16.95 10.75L14.99 10.75L14.99 5.81L13.95 5.81L13.95 11.79L16.95 11.79Z",
        "fill": "#1a1a1a"
      }
    ],
    "too-express": [
      {
        "type": "polygon",
        "d": "M3.82 5.81L3.82 6.85L4.84 6.85L4.84 11.79L5.87 11.79L5.87 6.85L6.89 6.85L6.89 5.81Z",
        "fill": "accent"
      },
      {
        "type": "polygon",
        "d": "M11.7 6.5L10.92 5.98L10 5.8L9.08 5.98L8.3 6.5L7.77 7.29L7.6 8.16L7.6 9.44L7.77 10.31L8.3 11.1L9.08 11.62L10 11.8L10.92 11.62L11.7 11.1L12.22 10.31L12.39 9.44L12.39 8.16L12.22 7.29Z",
        "fill": "accent"
      },
      {
        "type": "polygon",
        "d": "M11.36 9.34L11.24 9.91L10.95 10.35L10.51 10.64L10 10.74L9.48 10.64L9.04 10.35L8.75 9.91L8.64 9.34L8.64 8.26L8.75 7.69L9.04 7.25L9.48 6.96L10 6.86L10.51 6.96L10.95 7.25L11.24 7.69L11.36 8.26Z",
        "fill": "truck"
      },
      {
        "type": "polygon",
        "d": "M17.48 6.5L16.7 5.98L15.78 5.8L14.86 5.98L14.08 6.5L13.56 7.29L13.38 8.16L13.38 9.44L13.56 10.31L14.08 11.1L14.86 11.62L15.78 11.8L16.7 11.62L17.48 11.1L18 10.31L18.18 9.44L18.18 8.16L18 7.29Z",
        "fill": "accent"
      },
      {
        "type": "polygon",
        "d": "M17.14 9.34L17.03 9.91L16.73 10.35L16.3 10.64L15.78 10.74L15.26 10.64L14.83 10.35L14.53 9.91L14.42 9.34L14.42 8.26L14.53 7.69L14.83 7.25L15.26 6.96L15.78 6.86L16.3 6.96L16.73 7.25L17.03 7.69L17.14 8.26Z",
        "fill": "truck"
      }
    ],
    "go-world-express": [
      {
        "type": "polygon",
        "d": "M6.67 7.59L6.28 7.51L5.88 7.59L5.55 7.82L5.32 8.15L5.25 8.52L5.25 9.08L5.32 9.45L5.55 9.78L5.88 10.01L6.28 10.09L6.67 10.01L7.01 9.78L7.23 9.45L7.3 9.08L7.3 8.52L7.23 8.15L7.01 7.82Z",
        "fill": "#2e3192"
      },
      {
        "type": "polygon",
        "d": "M6.86 9.03L6.81 9.28L6.69 9.46L6.5 9.59L6.28 9.63L6.06 9.59L5.87 9.46L5.74 9.28L5.7 9.03L5.7 8.57L5.74 8.32L5.87 8.14L6.06 8.01L6.28 7.97L6.5 8.01L6.69 8.14L6.81 8.32L6.86 8.57Z",
        "fill": "truck"
      },
      {
        "type": "polygon",
        "d": "M9.36 10.08L10.29 10.08L10.55 7.57L10.11 7.52L9.89 9.64L9.8 9.64L9.79 8.32L8.92 8.32L8.91 9.64L8.83 9.64L8.6 7.52L8.16 7.57L8.43 10.08L9.36 10.08L9.36 9.86Z",
        "fill": "#2e3192"
      },
      {
        "type": "polygon",
        "d": "M12.3 7.59L11.9 7.51L11.51 7.59L11.18 7.82L10.95 8.15L10.88 8.52L10.88 9.08L10.95 9.45L11.18 9.78L11.51 10.01L11.9 10.09L12.3 10.01L12.63 9.78L12.86 9.45L12.93 9.08L12.93 8.52L12.86 8.15L12.63 7.82Z",
        "fill": "#2e3192"
      },
      {
        "type": "polygon",
        "d": "M12.49 9.03L12.44 9.28L12.31 9.46L12.13 9.59L11.9 9.63L11.68 9.59L11.5 9.46L11.37 9.28L11.32 9.03L11.32 8.57L11.37 8.32L11.5 8.14L11.68 8.01L11.9 7.97L12.13 8.01L12.31 8.14L12.44 8.32L12.49 8.57Z",
        "fill": "truck"
      },
      {
        "type": "polygon",
        "d": "M14.89 8.84L15.06 8.59L15.12 8.29L15.06 7.99L14.89 7.74L14.64 7.57L14.36 7.52L13.36 7.52L13.36 10.08L13.8 10.08L13.8 9.06L13.93 9.06L14.79 10.08L15.13 9.8L14.49 9.04L14.64 9.01Z",
        "fill": "#2e3192"
      },
      {
        "type": "polygon",
        "d": "M14.57 8.06L14.64 8.17L14.66 8.29L14.64 8.42L14.57 8.52L14.46 8.59L14.32 8.62L13.8 8.62L13.8 7.96L14.32 7.96L14.46 7.99Z",
        "fill": "truck"
      },
      {
        "type": "polygon",
        "d": "M16 9.64L16 7.52L15.55 7.52L15.55 10.08L16.83 10.08L16.83 9.64Z",
        "fill": "#2e3192"
      },
      {
        "type": "polygon",
        "d": "M18.15 10.04L18.46 9.91L18.72 9.71L18.93 9.44L19.06 9.13L19.1 8.8L19.06 8.47L18.93 8.16L18.72 7.89L18.46 7.69L18.15 7.56L17.83 7.52L17.26 7.52L17.26 10.08L17.83 10.08Z",
        "fill": "#2e3192"
      },
      {
        "type": "polygon",
        "d": "M18.23 8.08L18.41 8.21L18.54 8.38L18.62 8.58L18.65 8.8L18.62 9.02L18.54 9.22L18.41 9.39L18.23 9.52L18.03 9.61L17.8 9.64L17.7 9.64L17.7 7.96L17.8 7.96L18.03 7.99Z",
        "fill": "truck"
      },
      {
        "type": "polygon",
        "d": "M4.06 9.59L3.86 9.63L3.67 9.59L3.5 9.48L3.39 9.31L3.34 9.1L3.34 8.5L3.37 8.32L3.45 8.18L3.56 8.06L3.71 7.99L3.87 7.97L4.03 7.99L4.17 8.07L4.31 8.21L4.63 7.9L4.44 7.71L4.17 7.57L3.87 7.52L3.57 7.56L3.3 7.7L3.08 7.91L2.95 8.18L2.9 8.46L2.9 9.14L2.97 9.49L3.18 9.8L3.49 10.01L3.86 10.09L4.23 10.01L4.55 9.8L4.76 9.49L4.83 9.14L4.83 8.68L3.86 8.68L3.86 9.13L4.38 9.13L4.34 9.31L4.23 9.48Z",
        "fill": "#2e3192"
      }
    ],
    "shenghang": [
      {
        "type": "polygon",
        "d": "M6.67 6.59L6.4 7.85L7.15 8.94L9.08 9.55L9.38 9.97L9.28 10.4L8.78 10.76L8.06 10.76L7.39 10.29L6.79 11.13L7.73 11.8L9.11 11.8L10.22 11.02L10.49 9.74L9.72 8.66L7.8 8.06L7.51 7.63L7.61 7.19L8.08 6.84L8.76 6.84L9.39 7.31L10.01 6.47L9.1 5.8L7.74 5.8Z",
        "fill": "accent"
      },
      {
        "type": "polygon",
        "d": "M12.52 9.32L14.56 9.32L14.56 11.8L15.6 11.8L15.6 5.8L14.56 5.8L14.56 8.28L12.52 8.28L12.52 5.8L11.48 5.8L11.48 11.8L12.52 11.8Z",
        "fill": "accent"
      }
    ],
    "hzt": [
      {
        "type": "polygon",
        "d": "M14.92 5.8L14.92 6.84L15.94 6.84L15.94 11.8L16.98 11.8L16.98 6.84L17.99 6.84L17.99 5.8Z",
        "fill": "#1e4a70"
      },
      {
        "type": "polygon",
        "d": "M7.08 9.32L7.08 11.8L8.12 11.8L8.12 5.8L7.08 5.8L7.08 8.28L5.05 8.28L5.05 5.8L4.01 5.8L4.01 11.8L5.05 11.8L5.05 9.32Z",
        "fill": "#1e4a70"
      },
      {
        "type": "polygon",
        "d": "M13.01 10.76L10.95 10.76L13.93 5.8L10.03 5.8L10.03 6.84L12.09 6.84L9.11 11.8L13.01 11.8Z",
        "fill": "#1e4a70"
      }
    ],
    "wld-express": [
      {
        "type": "polygon",
        "d": "M6.34 11.8L6.35 11.28L6.35 11.8L8.53 11.8L9.15 5.91L8.11 5.8L7.59 10.76L7.39 10.76L7.36 7.68L5.34 7.68L5.31 10.76L5.11 10.76L4.59 5.8L3.55 5.91L4.17 11.8Z",
        "fill": "accent"
      },
      {
        "type": "polygon",
        "d": "M13.14 10.76L11.18 10.76L11.18 5.8L10.14 5.8L10.14 11.8L13.14 11.8Z",
        "fill": "accent"
      },
      {
        "type": "polygon",
        "d": "M15.48 11.8L16.22 11.7L16.95 11.4L17.57 10.92L18.05 10.3L18.35 9.58L18.45 8.8L18.35 8.02L18.05 7.3L17.57 6.68L16.95 6.2L16.22 5.9L15.48 5.8L14.13 5.8L14.13 11.8Z",
        "fill": "accent"
      },
      {
        "type": "polygon",
        "d": "M15.95 6.91L16.42 7.11L16.83 7.42L17.14 7.82L17.33 8.29L17.4 8.8L17.33 9.31L17.14 9.78L16.83 10.18L16.42 10.49L15.95 10.69L15.41 10.76L15.17 10.76L15.17 6.84L15.41 6.84Z",
        "fill": "truck"
      }
    ],
    "wangjing-3cq": [
      {
        "type": "polygon",
        "d": "M9.22 11.8L11 8.49L12.78 11.8L14.88 6.18L13.87 5.8L12.6 9.19L11 6.2L9.4 9.19L8.13 5.8L7.12 6.18Z",
        "fill": "#1a1a1a"
      }
    ],
    "banling": [
      {
        "type": "polygon",
        "d": "M4.74 8.43L4.78 8.21L4.78 8.04L4.74 7.81L4.62 7.59L4.45 7.41L4.22 7.3L3.99 7.26L2.9 7.26L2.9 10.34L4.16 10.34L4.41 10.3L4.65 10.17L4.85 9.98L4.97 9.74L5.01 9.49L5.01 9.31L4.97 9.06L4.85 8.81L4.65 8.62Z",
        "fill": "accent"
      },
      {
        "type": "polygon",
        "d": "M3.43 8.99L4.12 8.99L4.24 9.01L4.34 9.06L4.41 9.13L4.46 9.23L4.48 9.35L4.48 9.44L4.46 9.57L4.41 9.66L4.34 9.74L4.24 9.78L4.12 9.8L3.43 9.8Z",
        "fill": "truck"
      },
      {
        "type": "polygon",
        "d": "M4.19 7.91L4.23 7.98L4.24 8.09L4.24 8.16L4.23 8.27L4.19 8.34L4.13 8.4L4.05 8.44L3.95 8.46L3.43 8.46L3.43 7.79L3.95 7.79L4.05 7.81L4.13 7.85Z",
        "fill": "truck"
      },
      {
        "type": "polygon",
        "d": "M7.73 10.24L7.17 7.26L5.96 7.26L5.4 10.24L5.92 10.34L6.08 9.52L7.05 9.52L7.21 10.34Z",
        "fill": "accent"
      },
      {
        "type": "polygon",
        "d": "M6.4 7.79L6.73 7.79L6.95 8.99L6.18 8.99Z",
        "fill": "truck"
      },
      {
        "type": "polygon",
        "d": "M10.46 7.26L9.92 7.26L9.92 9.8L9.72 9.8L9.47 7.26L8.24 7.26L8.24 10.34L8.78 10.34L8.78 7.79L8.98 7.79L9.24 10.34L10.46 10.34Z",
        "fill": "accent"
      },
      {
        "type": "polygon",
        "d": "M11.5 7.26L10.97 7.26L10.97 10.34L12.51 10.34L12.51 9.8L11.5 9.8Z",
        "fill": "accent"
      },
      {
        "type": "polygon",
        "d": "M13.02 7.26L13.02 10.34L13.55 10.34L13.55 7.26Z",
        "fill": "accent"
      },
      {
        "type": "polygon",
        "d": "M16.27 10.34L16.27 7.26L15.74 7.26L15.74 9.8L15.54 9.8L15.28 7.26L14.06 7.26L14.06 10.34L14.59 10.34L14.59 7.79L14.8 7.79L15.05 10.34Z",
        "fill": "accent"
      },
      {
        "type": "polygon",
        "d": "M18.18 9.75L17.94 9.8L17.71 9.75L17.5 9.62L17.37 9.42L17.32 9.15L17.32 8.44L17.35 8.22L17.44 8.05L17.58 7.91L17.76 7.83L17.95 7.8L18.14 7.83L18.31 7.92L18.48 8.09L18.86 7.72L18.64 7.49L18.32 7.32L17.95 7.26L17.59 7.31L17.27 7.47L17.01 7.73L16.84 8.06L16.78 8.4L16.78 9.21L16.87 9.63L17.12 10L17.5 10.26L17.94 10.34L18.39 10.26L18.76 10L19.02 9.63L19.1 9.21L19.1 8.66L17.94 8.66L17.94 9.19L18.56 9.19L18.51 9.42L18.38 9.62Z",
        "fill": "accent"
      }
    ],
    "jikuaida": [
      {
        "type": "polygon",
        "d": "M6.59 8.43L6.59 7.34L6.08 7.34L6.08 10.26L6.59 10.26L6.59 9.14L6.83 8.9L7.63 10.26L8.07 10L7.2 8.53L8.03 7.7L7.67 7.34Z",
        "fill": "accent"
      },
      {
        "type": "polygon",
        "d": "M5.09 10.26L5.6 10.26L5.6 7.34L5.09 7.34Z",
        "fill": "accent"
      },
      {
        "type": "polygon",
        "d": "M4 9.65L3.93 9.7L3.84 9.74L3.75 9.75L3.66 9.74L3.58 9.7L3.51 9.65L3.45 9.58L3.42 9.49L3.4 9.37L2.9 9.43L2.92 9.62L3.01 9.83L3.15 10.01L3.32 10.14L3.53 10.23L3.75 10.26L3.98 10.23L4.18 10.14L4.36 10.01L4.5 9.83L4.58 9.62L4.61 9.42L4.61 7.34L4.1 7.34L4.1 9.38L4.09 9.49L4.05 9.58Z",
        "fill": "accent"
      },
      {
        "type": "polygon",
        "d": "M9.01 10.12L9.25 10.22L9.51 10.26L9.77 10.22L10.01 10.12L10.22 9.97L10.38 9.76L10.48 9.52L10.51 9.27L10.51 7.34L10.01 7.34L10.01 9.24L9.99 9.38L9.94 9.5L9.86 9.6L9.76 9.68L9.64 9.73L9.51 9.75L9.39 9.73L9.27 9.68L9.17 9.6L9.09 9.5L9.04 9.38L9.02 9.24L9.02 7.34L8.51 7.34L8.51 9.27L8.54 9.52L8.65 9.76L8.8 9.97Z",
        "fill": "accent"
      },
      {
        "type": "polygon",
        "d": "M13.06 10.16L12.53 7.34L11.39 7.34L10.85 10.16L11.35 10.26L11.49 9.49L12.42 9.49L12.57 10.26Z",
        "fill": "accent"
      },
      {
        "type": "polygon",
        "d": "M11.59 8.98L11.8 7.85L12.11 7.85L12.32 8.98Z",
        "fill": "truck"
      },
      {
        "type": "polygon",
        "d": "M13.55 10.26L14.05 10.26L14.05 7.34L13.55 7.34Z",
        "fill": "accent"
      },
      {
        "type": "polygon",
        "d": "M15.9 10.06L16.2 9.83L16.44 9.53L16.58 9.18L16.63 8.8L16.58 8.42L16.44 8.07L16.2 7.77L15.9 7.53L15.55 7.39L15.19 7.34L14.53 7.34L14.53 10.26L15.19 10.26L15.55 10.21Z",
        "fill": "accent"
      },
      {
        "type": "polygon",
        "d": "M15.84 8.13L15.99 8.32L16.09 8.55L16.12 8.8L16.09 9.04L15.99 9.27L15.84 9.47L15.65 9.62L15.42 9.72L15.16 9.75L15.04 9.75L15.04 7.85L15.16 7.85L15.42 7.88L15.65 7.98Z",
        "fill": "truck"
      },
      {
        "type": "polygon",
        "d": "M18.56 7.34L17.42 7.34L16.89 10.16L17.38 10.26L17.53 9.49L18.46 9.49L18.6 10.26L19.1 10.16Z",
        "fill": "accent"
      },
      {
        "type": "polygon",
        "d": "M17.63 8.98L17.84 7.85L18.14 7.85L18.36 8.98Z",
        "fill": "truck"
      }
    ],
    "hye": [
      {
        "type": "polygon",
        "d": "M10.64 5.95L9.73 6.39L10.92 8.87L10.43 11.62L11.42 11.8L11.92 9.02L14.05 6.49L13.27 5.84L11.56 7.88Z",
        "fill": "accent"
      },
      {
        "type": "polygon",
        "d": "M4.85 5.8L3.8 11.62L4.79 11.8L5.24 9.31L7.2 9.31L6.78 11.62L7.78 11.8L8.82 5.98L7.83 5.8L7.38 8.29L5.43 8.29L5.84 5.98Z",
        "fill": "accent"
      },
      {
        "type": "polygon",
        "d": "M17.33 10.7L15.29 10.7L15.54 9.31L17.37 9.31L17.37 8.29L15.73 8.29L15.98 6.9L18.2 6.9L18.2 5.89L15.13 5.89L14.08 11.71L17.33 11.71Z",
        "fill": "accent"
      }
    ],
    "jet-global": [
      {
        "type": "polygon",
        "d": "M13.83 5.8L13.83 6.84L14.85 6.84L14.85 11.8L15.89 11.8L15.89 6.84L16.91 6.84L16.91 5.8Z",
        "fill": "accent"
      },
      {
        "type": "polygon",
        "d": "M12.84 11.8L12.84 10.75L10.64 10.75L10.64 9.32L12.43 9.32L12.43 8.28L10.64 8.28L10.64 6.84L12.84 6.84L12.84 5.8L9.6 5.8L9.6 11.8Z",
        "fill": "accent"
      },
      {
        "type": "polygon",
        "d": "M7.35 10.54L7.2 10.65L7.03 10.73L6.85 10.75L6.66 10.73L6.49 10.65L6.34 10.54L6.23 10.39L6.16 10.22L6.13 9.97L5.09 10.1L5.14 10.49L5.32 10.92L5.6 11.28L5.97 11.56L6.39 11.74L6.85 11.8L7.3 11.74L7.73 11.56L8.09 11.28L8.38 10.92L8.55 10.49L8.61 10.07L8.61 5.8L7.57 5.8L7.57 10L7.54 10.22L7.47 10.39Z",
        "fill": "accent"
      }
    ],
    "kuayuan-express": [
      {
        "type": "polygon",
        "d": "M12.14 5.8L11.27 6.37L12.98 8.96L12.98 11.8L14.02 11.8L14.02 8.96L15.72 6.37L14.85 5.8L13.5 7.85Z",
        "fill": "accent"
      },
      {
        "type": "polygon",
        "d": "M7.82 9.01L9.48 11.8L10.37 11.27L8.58 8.25L10.29 6.54L9.56 5.8L7.32 8.04L7.32 5.8L6.28 5.8L6.28 11.8L7.32 11.8L7.32 9.51Z",
        "fill": "accent"
      }
    ],
    "cmt-express": [
      {
        "type": "polygon",
        "d": "M14.3 6.91L14.3 7.76L15.13 7.76L15.13 11.79L15.98 11.79L15.98 7.76L16.81 7.76L16.81 6.91Z",
        "fill": "accent"
      },
      {
        "type": "polygon",
        "d": "M12.64 8.86L12.64 11.79L13.49 11.79L13.49 5.8L11.25 9.54L9.01 5.8L9.01 11.79L9.86 11.79L9.86 8.86L11.25 11.19Z",
        "fill": "accent"
      },
      {
        "type": "polygon",
        "d": "M6.89 6.9L6.37 6.98L5.89 7.22L5.51 7.59L5.27 8.06L5.19 8.55L5.19 10.15L5.27 10.64L5.51 11.11L5.89 11.49L6.37 11.72L6.89 11.8L7.41 11.71L7.88 11.46L8.2 11.13L7.59 10.54L7.36 10.78L7.14 10.9L6.88 10.94L6.62 10.9L6.39 10.79L6.21 10.6L6.09 10.37L6.04 10.08L6.04 8.62L6.09 8.33L6.21 8.1L6.39 7.91L6.62 7.8L6.88 7.76L7.14 7.8L7.36 7.93L7.59 8.16L8.2 7.57L7.88 7.24L7.41 6.99Z",
        "fill": "accent"
      }
    ],
    "2ebox": [
      {
        "type": "polygon",
        "d": "M5.18 7.69L5.32 7.85L5.4 8.05L5.41 8.26L5.36 8.43L2.9 10.75L6.09 10.75L6.09 10.08L4.6 10.08L5.96 8.79L6.09 8.34L6.07 7.91L5.91 7.5L5.64 7.17L5.27 6.94L4.85 6.85L4.42 6.88L4.02 7.06L3.7 7.35L3.52 7.68L4.11 8.01L4.24 7.78L4.39 7.63L4.59 7.55L4.8 7.53L5 7.58Z",
        "fill": "accent"
      },
      {
        "type": "polygon",
        "d": "M7.42 9.14L8.59 9.14L8.59 8.46L7.42 8.46L7.42 7.52L8.85 7.52L8.85 6.85L6.74 6.85L6.74 10.75L8.85 10.75L8.85 10.08L7.42 10.08Z",
        "fill": "accent"
      },
      {
        "type": "polygon",
        "d": "M11.88 7.84L11.83 7.55L11.69 7.27L11.46 7.04L11.18 6.89L10.88 6.85L9.5 6.85L9.5 10.75L11.1 10.75L11.42 10.7L11.73 10.55L11.97 10.3L12.13 9.99L12.18 9.67L12.18 9.45L12.13 9.13L11.97 8.82L11.72 8.57L11.83 8.34L11.88 8.05Z",
        "fill": "accent"
      },
      {
        "type": "polygon",
        "d": "M11.2 7.9L11.2 7.99L11.18 8.13L11.13 8.22L11.06 8.29L10.96 8.34L10.83 8.36L10.18 8.36L10.18 7.52L10.83 7.52L10.96 7.55L11.06 7.59L11.13 7.67L11.18 7.76Z",
        "fill": "truck"
      },
      {
        "type": "polygon",
        "d": "M11.2 9.07L11.32 9.13L11.42 9.22L11.48 9.34L11.5 9.5L11.5 9.62L11.48 9.78L11.42 9.9L11.32 9.99L11.2 10.05L11.04 10.08L10.18 10.08L10.18 9.04L11.04 9.04Z",
        "fill": "truck"
      },
      {
        "type": "polygon",
        "d": "M13.25 7.3L12.91 7.81L12.8 8.38L12.8 9.22L12.91 9.79L13.25 10.3L13.76 10.64L14.36 10.76L14.97 10.64L15.48 10.3L15.82 9.79L15.93 9.22L15.93 8.38L15.82 7.81L15.48 7.3L14.97 6.96L14.36 6.84L13.76 6.96Z",
        "fill": "accent"
      },
      {
        "type": "polygon",
        "d": "M14.36 10.07L14.03 10L13.74 9.81L13.55 9.52L13.48 9.15L13.48 8.45L13.55 8.08L13.74 7.79L14.03 7.6L14.36 7.53L14.7 7.6L14.99 7.79L15.18 8.08L15.25 8.45L15.25 9.15L15.18 9.52L14.99 9.81L14.7 10Z",
        "fill": "truck"
      },
      {
        "type": "polygon",
        "d": "M16.77 6.85L16.2 7.22L17.24 8.8L16.2 10.38L16.77 10.75L17.65 9.42L18.53 10.75L19.1 10.38L18.06 8.8L19.1 7.22L18.53 6.85L17.65 8.18Z",
        "fill": "accent"
      }
    ],
    "antaria": [
      {
        "type": "polygon",
        "d": "M8.73 6.08L10.18 5.65L10.18 5.83L9.92 7.12L9.85 7.5L9.79 7.61L6.36 8.09L6.34 8.11L9.36 10.04L9.36 10.27L9.27 10.78L9.29 10.83L11.19 9.33L12.03 8.62L13.07 7.68L13.53 7.2L12.34 7.31L12.13 7.3L11.29 5.5L11.26 5.34L11.34 5.36L12.21 5.15L13.05 5L13.66 4.93L14.22 4.9L14.57 4.9L15.06 5L15.27 5.14L15.37 5.34L15.37 5.52L15.29 5.78L14.99 6.31L14.46 6.97L13.53 7.92L12.44 8.92L11.47 9.73L9.41 11.38L7.51 12.83L7.31 12.99L7.33 13.01L8.96 11.89L11.19 10.21L12.77 8.91L13.71 8.07L14.69 7.07L15.09 6.56L15.35 6.18L15.47 5.93L15.57 5.65L15.6 5.37L15.5 5.09L15.28 4.88L14.95 4.75L14.57 4.7L13.91 4.7L12.82 4.85L11.32 5.21L11.24 5.23L11.23 5.27L11.14 5.17L10.56 3.9L10.23 5.53L10.19 5.57L10.12 5.56L8.71 6.06Z",
        "fill": "#00000c"
      },
      {
        "type": "polygon",
        "d": "M8.88 13.5L11.42 11.37L11.47 11.35L11.7 11.45L14.55 13.09L14.56 13.04L14.51 12.92L13.23 9.84L13.15 9.6L15.66 7L15.51 6.98L15.26 7.02L14.65 7.71L13.71 8.65L12.39 9.87L10.46 11.47L9.06 12.52L9.01 12.61L8.86 13.48Z",
        "fill": "#00000c"
      },
      {
        "type": "polygon",
        "d": "M7.18 13.13L7.32 13.02L7.3 13L7.14 13.12Z",
        "fill": "#00000c"
      }
    ],
    "bee-fast": [
      {
        "type": "polygon",
        "d": "M9.49 5.37L9.5 5.09L9.4 4.79L9.2 4.55L8.93 4.4L8.65 4.36L7.71 4.36L7.39 4.3L6.72 8.05L7.36 8.16L7.37 8.1L8.3 8.1L8.61 8.06L8.91 7.91L9.17 7.69L9.36 7.42L9.46 7.12L9.5 6.91L9.51 6.6L9.4 6.28L9.21 6.05L9.36 5.83L9.45 5.56Z",
        "fill": "#3e2311"
      },
      {
        "type": "polygon",
        "d": "M8.54 6.46L8.68 6.49L8.77 6.53L8.82 6.6L8.86 6.7L8.85 6.84L8.83 6.96L8.78 7.12L8.68 7.25L8.56 7.36L8.41 7.43L8.25 7.45L7.48 7.45L7.66 6.46Z",
        "fill": "truck"
      },
      {
        "type": "polygon",
        "d": "M8.84 5.18L8.84 5.3L8.82 5.4L8.78 5.54L8.7 5.65L8.6 5.74L8.48 5.79L8.34 5.81L7.78 5.81L7.92 5.01L8.6 5.01L8.72 5.03L8.78 5.06L8.82 5.11Z",
        "fill": "truck"
      },
      {
        "type": "polygon",
        "d": "M12.03 6.56L12.03 5.91L10.97 5.91L11.13 5.01L12.56 5.01L12.56 4.36L10.59 4.36L9.91 8.1L12.01 8.1L12.01 7.45L10.69 7.45L10.85 6.56Z",
        "fill": "#3e2311"
      },
      {
        "type": "polygon",
        "d": "M14.75 6.56L14.75 5.91L13.69 5.91L13.85 5.01L15.28 5.01L15.28 4.36L13.31 4.36L12.64 8.1L14.73 8.1L14.73 7.45L13.41 7.45L13.57 6.56Z",
        "fill": "#3e2311"
      },
      {
        "type": "polygon",
        "d": "M12.91 11.83L13.03 12.05L12.91 12.34L12.51 12.59L12.07 12.59L11.72 12.31L11.31 12.81L11.83 13.24L12.7 13.24L13.44 12.78L13.74 12.01L13.36 11.29L12.23 10.92L12.12 10.69L12.24 10.39L12.61 10.15L13.03 10.15L13.36 10.42L13.78 9.93L13.27 9.5L12.42 9.5L11.71 9.96L11.41 10.73L11.77 11.45Z",
        "fill": "#3e2311"
      },
      {
        "type": "polygon",
        "d": "M7.86 13.07L8.47 13.29L8.85 12.25L10.03 12.25L10.04 13.18L10.69 13.18L10.66 9.5L9.18 9.5Z",
        "fill": "#3e2311"
      },
      {
        "type": "polygon",
        "d": "M10.03 11.6L9.09 11.6L9.63 10.15L10.01 10.15Z",
        "fill": "truck"
      },
      {
        "type": "polygon",
        "d": "M6.89 10.15L8.23 10.15L8.23 9.5L6.34 9.5L5.68 13.18L6.32 13.3L6.61 11.69L7.71 11.69L7.71 11.04L6.73 11.04Z",
        "fill": "#3e2311"
      },
      {
        "type": "polygon",
        "d": "M14.42 13.18L15.06 13.3L15.63 10.15L16.32 10.15L16.32 9.5L14.4 9.5L14.4 10.15L14.97 10.15Z",
        "fill": "#3e2311"
      }
    ],
    "beexprss": [
      {
        "type": "polygon",
        "d": "M7.12 8.74L7.12 8.63L7.17 8.59L10.26 7.36L9.31 6.81L9.31 6.3L8.81 5.87L7.89 5.25L7.11 4.9L6.26 4.69L5.48 4.67L4.7 4.87L4.22 5.15L4.05 5.33L3.93 5.62L3.88 5.89L3.88 6.27L4.02 6.73L4.28 7.15L4.67 7.54L5.4 8.04L6.31 8.48Z",
        "fill": "#40c5f3"
      },
      {
        "type": "polygon",
        "d": "M14.84 8.75L15.68 8.48L16.59 8.04L17.24 7.61L17.71 7.15L17.99 6.72L18.13 6.2L18.11 5.83L18.03 5.51L17.94 5.31L17.77 5.15L17.22 4.84L16.51 4.67L15.73 4.69L14.88 4.9L14.11 5.25L13.18 5.87L12.59 6.39L12.59 6.81L11.67 7.35L14.79 8.59L14.84 8.63Z",
        "fill": "#40c5f3"
      },
      {
        "type": "polygon",
        "d": "M7.16 9.67L10.97 8.2L10.98 7.76L10.27 7.37L7.14 8.61Z",
        "fill": "#ffde00"
      },
      {
        "type": "polygon",
        "d": "M7.16 12.11L10.96 10.64L10.98 9.27L7.14 10.75Z",
        "fill": "#ffde00"
      },
      {
        "type": "polygon",
        "d": "M10.99 7.73L12.58 6.81L12.58 4.93L10.95 4L9.32 4.93L9.32 6.81L10.81 7.68Z",
        "fill": "#252026"
      },
      {
        "type": "polygon",
        "d": "M14.82 10.75L14.82 9.7L10.99 8.2L7.12 9.71L7.13 10.75L10.96 9.26L14.76 10.74Z",
        "fill": "#252026"
      },
      {
        "type": "polygon",
        "d": "M14.84 13.2L14.84 12.13L11.02 10.64L7.12 12.14L7.13 13.2L10.99 11.69Z",
        "fill": "#252026"
      }
    ],
    "carry-flap": [
      {
        "type": "polygon",
        "d": "M11.11 13.7L10.23 13.7L9.59 13.44L7.95 12.32L7.71 12.23L7.18 11.67L6.94 11.05L6.94 10.39L6.87 10.27L6.87 8.91L6.82 8.82L6.82 7.89L6.87 7.65L7.01 7.37L7.43 6.95L7.81 6.76L8.26 6.64L9.21 6.26L9.47 5.93L9.95 5.57L11.42 4.86L12.25 4.53L12.87 4.2L13.13 4.1L13.51 4.1L13.67 4.23L13.74 4.44L13.69 5.13L13.5 5.54L13.56 5.67L14.96 6.5L15.39 6.69L15.91 7.07L17.1 6.52L17.46 6.52L17.66 6.73L17.61 7.68L17.4 8.22L17.04 8.86L16.33 9.53L16.33 10.88L16.21 11L16.21 11.31L16.09 11.55L15.72 11.99L15.2 12.25Z",
        "fill": "#000000"
      },
      {
        "type": "polygon",
        "d": "M6.9 7.24L7.06 7.12L7.06 6.96L6.91 6.78L6.05 6.2L5.81 6.35L5.77 6.48L5.93 6.67L6.64 7.18Z",
        "fill": "#000000"
      },
      {
        "type": "polygon",
        "d": "M7.23 6.95L7.35 6.73L7.15 6.22L6.94 5.85L6.91 5.67L6.65 5.59L6.49 5.77L6.49 5.93L6.93 6.86L7.02 6.95Z",
        "fill": "#000000"
      },
      {
        "type": "polygon",
        "d": "M6.71 7.62L6.84 7.53L6.88 7.32L6.72 7.17L5.86 7.12L5.74 7.03L5.54 7.19L5.54 7.39L5.66 7.54Z",
        "fill": "#000000"
      },
      {
        "type": "polygon",
        "d": "M15.31 10.69L15.5 10.26L15.5 9.83L15.33 9.54L15.33 9.41L15.56 9.27L15.81 9.49L15.9 9.37L16.5 8.94L16.76 8.64L15.84 9.12L15.63 8.98L15.69 8.76L17.13 8.03L17.24 7.76L15.61 8.54L15.41 8.53L15.38 8.27L15.6 8.1L17.28 7.32L17.37 7.12L17.37 7L17.31 6.9L17.22 6.88L16.81 7.04L14.11 8.32L13.69 8.63L13.38 9.01L13.14 9.54L13.07 10.17L13.14 10.61L13.3 10.95L13.59 11.24L13.93 11.4L14.31 11.42L14.82 11.23L15.15 10.92Z",
        "fill": "accent"
      },
      {
        "type": "polygon",
        "d": "M7.77 11.76L9.16 12.69L9.16 12.64L9.76 13.09L10.06 13.23L10.5 13.32L10.8 13.32L11.27 13.23L13.45 12.46L13.46 12.35L13.61 12.41L15.25 11.83L15.46 11.71L15.7 11.47L15.86 11.22L15.97 10.81L15.96 10.05L15.78 10.64L15.61 10.98L15.41 11.25L14.99 11.63L14.52 11.82L13.86 11.82L13.29 11.55L12.95 11.16L12.79 10.68L12.74 9.84L12.84 9.33L12.97 8.99L13.23 8.57L13.52 8.24L13.89 7.98L15.51 7.23L15.25 7.04L13.07 5.85L12.67 5.74L12.02 5.69L11.6 5.79L7.76 7.18L7.41 7.45L7.18 7.85L7.23 10.31L7.34 11.18L7.5 11.47Z",
        "fill": "accent"
      },
      {
        "type": "polygon",
        "d": "M10.29 5.82L11.6 5.31L12.38 5.19L13.37 4.71L13.38 4.45L13.28 4.41L13.01 4.52Z",
        "fill": "accent"
      },
      {
        "type": "polygon",
        "d": "M9.21 8.55L9.32 8.25L9.61 7.95L9.93 7.77L11.8 7.11L12.5 7.48L12.9 7.83L13.04 8.16L13.05 8.86L13.23 8.57L13.61 8.17L13.56 7.78L13.38 7.45L13.19 7.26L12.54 6.86L13.93 6.33L13.29 6L11.78 6.48L10.94 6.04L10.78 6.08L10.21 6.31L11.07 6.75L9.57 7.25L9.2 7.5L8.94 7.76L8.69 8.2L8.62 8.53L8.66 12.34L8.77 12.45L9.27 12.72Z",
        "fill": "truck"
      },
      {
        "type": "polygon",
        "d": "M12.97 12.61L13.45 12.46L13.46 12.35L13.56 12.39L13.58 11.71L13.29 11.55L12.98 11.18Z",
        "fill": "truck"
      }
    ],
    "choir-express": [
      {
        "type": "polygon",
        "d": "M6.1 5.93L5.51 6.21L5 6.63L4.63 7.17L4.43 7.74L4.09 9.68L4.07 10.28L4.27 10.88L4.68 11.36L5.23 11.66L5.86 11.76L6.49 11.65L7.08 11.37L7.53 10.98L6.86 10.21L6.52 10.51L6.18 10.67L5.85 10.72L5.56 10.68L5.34 10.55L5.18 10.37L5.1 10.12L5.11 9.78L5.43 8L5.55 7.63L5.77 7.33L6.06 7.08L6.39 6.93L6.72 6.88L7.01 6.93L7.23 7.06L7.44 7.32L8.24 6.69L7.91 6.27L7.37 5.95L6.74 5.84Z",
        "fill": "accent"
      },
      {
        "type": "polygon",
        "d": "M9.61 10.73L9.86 9.31L11.72 9.31L11.72 8.29L10.05 8.29L10.3 6.87L12.56 6.87L12.56 5.85L9.45 5.85L8.38 11.75L11.68 11.75L11.68 10.73Z",
        "fill": "accent"
      },
      {
        "type": "polygon",
        "d": "M17.14 5.8L15.41 7.86L14.47 5.91L13.55 6.35L14.69 8.72L12.66 11.14L13.44 11.8L15.17 9.74L16.11 11.69L17.04 11.25L15.9 8.88L17.93 6.46Z",
        "fill": "accent"
      }
    ],
    "ckeex": [
      {
        "type": "polygon",
        "d": "M8.58 6.66L6.99 8.26L6.99 6.66L6.24 6.66L6.24 10.94L6.99 10.94L6.99 9.31L7.34 8.95L8.53 10.94L9.16 10.56L7.89 8.41L9.11 7.18Z",
        "fill": "#000000"
      },
      {
        "type": "polygon",
        "d": "M3.93 6.72L3.51 6.93L3.18 7.26L2.97 7.67L2.9 8.1L2.9 9.5L2.97 9.93L3.18 10.34L3.51 10.67L3.93 10.88L4.38 10.95L4.84 10.87L5.25 10.65L5.53 10.36L5 9.84L4.8 10.05L4.6 10.15L4.38 10.19L4.15 10.16L3.95 10.06L3.79 9.9L3.68 9.7L3.64 9.44L3.64 8.16L3.68 7.9L3.79 7.7L3.95 7.54L4.15 7.44L4.38 7.41L4.6 7.45L4.8 7.55L5 7.76L5.53 7.24L5.25 6.95L4.84 6.73L4.38 6.65Z",
        "fill": "#000000"
      },
      {
        "type": "polygon",
        "d": "M10.62 10.2L10.62 9.17L11.9 9.17L11.9 8.43L10.62 8.43L10.62 7.4L12.19 7.4L12.19 6.66L9.87 6.66L9.87 10.94L12.19 10.94L12.19 10.2Z",
        "fill": "#000000"
      },
      {
        "type": "polygon",
        "d": "M15.22 10.2L13.64 10.2L13.64 9.17L14.92 9.17L14.92 8.43L13.64 8.43L13.64 7.4L15.22 7.4L15.22 6.66L12.9 6.66L12.9 10.94L15.22 10.94Z",
        "fill": "#000000"
      },
      {
        "type": "polygon",
        "d": "M19.1 7.07L18.48 6.66L17.51 8.13L16.54 6.66L15.92 7.07L17.07 8.8L15.92 10.53L16.54 10.94L17.51 9.47L18.48 10.94L19.1 10.53L17.96 8.8Z",
        "fill": "#000000"
      }
    ],
    "corporate-couriers": [
      {
        "type": "polygon",
        "d": "M9.68 5.91L9.04 5.8L8.4 5.9L7.82 6.19L7.35 6.64L7.06 7.22L6.96 7.82L6.96 9.78L7.06 10.38L7.35 10.96L7.82 11.41L8.4 11.7L9.04 11.8L9.68 11.69L10.25 11.39L10.65 10.98L9.9 10.26L9.62 10.55L9.34 10.69L9.03 10.75L8.71 10.7L8.43 10.56L8.2 10.34L8.06 10.05L8 9.7L8 7.9L8.06 7.55L8.2 7.26L8.43 7.04L8.71 6.9L9.03 6.85L9.34 6.91L9.62 7.05L9.9 7.34L10.65 6.62L10.25 6.21Z",
        "fill": "accent"
      },
      {
        "type": "polygon",
        "d": "M14.07 5.91L13.43 5.8L12.79 5.9L12.21 6.19L11.75 6.64L11.45 7.22L11.35 7.82L11.35 9.78L11.45 10.38L11.75 10.96L12.21 11.41L12.79 11.7L13.43 11.8L14.07 11.69L14.64 11.39L15.04 10.98L14.29 10.26L14.01 10.55L13.73 10.69L13.42 10.75L13.1 10.7L12.82 10.56L12.59 10.34L12.45 10.05L12.39 9.7L12.39 7.9L12.45 7.55L12.59 7.26L12.82 7.04L13.1 6.9L13.42 6.85L13.73 6.91L14.01 7.05L14.29 7.34L15.04 6.62L14.64 6.21Z",
        "fill": "accent"
      }
    ],
    "correios-angola": [
      {
        "type": "polygon",
        "d": "M9.43 4.32L9.4 4.34L8.93 4.75L8.64 5.25L8.9 5.4L9.16 4.94L9.57 4.58L9.92 4.45L12.05 4.45L12.57 5.14L12.93 5.84L12.93 9.48L13.04 9.9L5.94 9.9L5.94 10.33L13.15 10.33L14.13 14L15.04 14L15.04 5.84L15.4 5.2L15.92 4.45L16.36 4.45L16.36 4L9.92 4L9.92 4.13Z",
        "fill": "accent"
      },
      {
        "type": "polygon",
        "d": "M12.57 6.53L5.76 6.53L5.76 7.7L7.63 7.7L7.63 8.01L6.18 8.01L6.18 8.55L8.77 8.55L8.77 8.85L5.64 8.85L5.64 9.42L12.57 9.42Z",
        "fill": "accent"
      },
      {
        "type": "polygon",
        "d": "M11.81 6.82L11.64 6.57L10.34 7.46L9.1 6.57L8.92 6.82L10.34 7.83Z",
        "fill": "truck"
      }
    ],
    "correos-ecuador": [
      {
        "type": "polygon",
        "d": "M11.99 7.11L13.72 10.99L16.41 9.27L18.67 9.27L18.67 8.93L19 8.85L18.72 7.77L17.95 7.16L13.51 7.16L14.18 9.49L14.83 9.3L14.4 7.84L17.71 7.84L18.12 8.16L18.24 8.6L16.22 8.6L14.02 10L12.15 5.81L3 5.81L3 6.49L11.71 6.49L11.86 6.82L11.53 6.59L10.25 8.45L8.34 6.99L4.35 6.99L4.35 7.67L8.11 7.67L8.78 8.17L5.36 8.17L5.36 8.85L8.43 8.85L9.36 10.79L13.03 10.79L13.03 10.11L9.79 10.11L8.91 8.27L10.41 9.41Z",
        "fill": "#202c5c"
      }
    ],
    "danniao": [
      {
        "type": "polygon",
        "d": "M10.08 8.63L10.24 8.62L10.5 8.52L11.53 8.52L12.18 8.75L14.14 9.74L14.62 9.88L15.2 9.88L15.71 9.69L16.04 9.48L16.47 8.97L16.73 8.33L16.73 7.7L16.48 7.09L16.06 6.58L15.51 6.25L15.05 6.13L14.59 6.14L14.19 6.25L13.01 6.81L12.52 7.13L11.98 7.38L11.58 7.5L10.39 7.5L10.17 7.39L9.93 7.35L8.07 6.35L7.38 6.14L6.87 6.14L6.49 6.25L5.92 6.6L5.52 7.06L5.27 7.63L5.27 8.41L5.46 8.87L5.67 9.18L5.95 9.48L6.34 9.72L6.79 9.87L7.39 9.88L7.77 9.77Z",
        "fill": "#482c21"
      },
      {
        "type": "circle",
        "cx": 11,
        "cy": 5.54,
        "r": 1.38,
        "fill": "#482c21"
      },
      {
        "type": "polygon",
        "d": "M11.55 14.2L10.42 14.2L10.22 14.09L9.93 14.06L9.31 13.75L9.03 13.52L8.47 12.91L8.1 12.11L8.1 11.86L8.02 11.63L8.02 11.17L8.1 10.81L8.33 10.44L8.51 10.25L9.28 9.8L10.36 9.31L10.59 9.31L10.84 9.23L11.16 9.23L11.41 9.31L11.61 9.31L12.01 9.46L12.97 9.94L13.37 10.17L13.61 10.38L13.9 10.83L13.9 10.98L13.98 11.17L13.98 11.54L13.9 11.83L13.9 12.08L13.64 12.71L13.3 13.19L12.69 13.75L12.26 13.97L11.98 14.09L11.78 14.09Z",
        "fill": "accent"
      }
    ],
    "ddu-express": [
      {
        "type": "polygon",
        "d": "M3.64 11.8L4.98 11.8L5.73 11.7L6.45 11.4L7.07 10.92L7.55 10.3L7.85 9.57L7.95 8.8L7.85 8.02L7.55 7.3L7.07 6.67L6.45 6.2L5.73 5.9L4.98 5.8L3.64 5.8Z",
        "fill": "#241b3a"
      },
      {
        "type": "polygon",
        "d": "M4.92 6.84L5.46 6.91L5.93 7.11L6.33 7.42L6.64 7.82L6.84 8.29L6.9 8.8L6.84 9.3L6.64 9.77L6.33 10.18L5.93 10.49L5.46 10.68L4.92 10.75L4.68 10.75L4.68 6.84Z",
        "fill": "truck"
      },
      {
        "type": "polygon",
        "d": "M10.29 11.8L11.03 11.7L11.76 11.4L12.38 10.92L12.86 10.3L13.16 9.57L13.26 8.8L13.16 8.02L12.86 7.3L12.38 6.67L11.76 6.2L11.03 5.9L10.29 5.8L8.94 5.8L8.94 11.8Z",
        "fill": "#241b3a"
      },
      {
        "type": "polygon",
        "d": "M10.76 6.91L11.23 7.11L11.64 7.42L11.95 7.82L12.14 8.29L12.21 8.8L12.14 9.3L11.95 9.77L11.64 10.18L11.23 10.49L10.76 10.68L10.22 10.75L9.98 10.75L9.98 6.84L10.22 6.84Z",
        "fill": "truck"
      },
      {
        "type": "polygon",
        "d": "M14.52 10.77L14.85 11.2L15.28 11.52L15.77 11.73L16.31 11.8L16.84 11.73L17.34 11.52L17.76 11.2L18.09 10.77L18.3 10.27L18.36 9.77L18.36 5.8L17.32 5.8L17.32 9.71L17.28 10L17.18 10.24L17.02 10.45L16.81 10.61L16.57 10.72L16.31 10.75L16.04 10.72L15.8 10.61L15.59 10.45L15.43 10.24L15.33 10L15.29 9.71L15.29 5.8L14.25 5.8L14.25 9.77L14.32 10.27Z",
        "fill": "#241b3a"
      }
    ],
    "dtd-pk": [
      {
        "type": "polygon",
        "d": "M9.21 5.8L9.21 6.84L10.22 6.84L10.22 11.8L11.26 11.8L11.26 6.84L12.28 6.84L12.28 5.8Z",
        "fill": "accent"
      },
      {
        "type": "polygon",
        "d": "M5.76 11.8L6.5 11.7L7.23 11.4L7.85 10.92L8.33 10.3L8.63 9.58L8.73 8.8L8.63 8.02L8.33 7.3L7.85 6.68L7.23 6.2L6.5 5.9L5.76 5.8L4.41 5.8L4.41 11.8Z",
        "fill": "accent"
      },
      {
        "type": "polygon",
        "d": "M6.23 6.91L6.7 7.11L7.11 7.42L7.42 7.82L7.61 8.29L7.68 8.8L7.61 9.31L7.42 9.78L7.11 10.18L6.7 10.49L6.23 10.69L5.69 10.76L5.45 10.76L5.45 6.84L5.69 6.84Z",
        "fill": "truck"
      },
      {
        "type": "polygon",
        "d": "M14.62 11.8L15.36 11.7L16.09 11.4L16.71 10.92L17.19 10.3L17.49 9.58L17.59 8.8L17.49 8.02L17.19 7.3L16.71 6.68L16.09 6.2L15.36 5.9L14.62 5.8L13.27 5.8L13.27 11.8Z",
        "fill": "accent"
      },
      {
        "type": "polygon",
        "d": "M15.09 6.91L15.56 7.11L15.97 7.42L16.28 7.82L16.47 8.29L16.54 8.8L16.47 9.31L16.28 9.78L15.97 10.18L15.56 10.49L15.09 10.69L14.55 10.76L14.31 10.76L14.31 6.84L14.55 6.84Z",
        "fill": "truck"
      }
    ],
    "endeavour-delivery": [
      {
        "type": "polygon",
        "d": "M10.99 3.9L10.25 3.98L9.54 4.19L8.89 4.54L8.32 5.01L7.85 5.59L7.49 6.25L7.28 6.96L7.21 7.7L7.25 8.24L7.37 8.78L7.56 9.29L7.83 9.76L8.25 10.3L9.24 11.24L9.86 11.91L10.28 12.48L10.83 13.42L10.92 13.48L11.01 13.5L11.11 13.47L11.18 13.41L11.7 12.5L12.1 11.93L12.7 11.29L13.64 10.42L13.94 10.08L14.17 9.76L14.44 9.27L14.64 8.76L14.75 8.23L14.79 7.69L14.72 6.94L14.5 6.23L14.15 5.58L13.67 5L13.1 4.54L12.45 4.19L11.74 3.97Z",
        "fill": "accent"
      },
      {
        "type": "polygon",
        "d": "M8.77 9.95L8.37 9.47L8.08 8.92L7.89 8.33L7.83 7.71L7.89 7.1L8.06 6.5L8.36 5.94L8.75 5.46L9.22 5.06L9.77 4.77L10.36 4.59L10.97 4.52L11.59 4.58L12.19 4.75L12.74 5.04L13.23 5.43L13.51 5.76L13.75 6.12L13.94 6.51L14.08 6.92L14.15 7.36L14.17 7.79L14.12 8.23L14.02 8.65L13.8 9.17L13.48 9.66L13.18 10L12.32 10.8L11.71 11.43L11.42 11.8L11 12.47L10.58 11.82L10.24 11.4L9.62 10.75Z",
        "fill": "truck"
      },
      {
        "type": "line",
        "d": "M11 5.74L11 5.19M11.51 5.81L11.65 5.28M11.99 6L12.26 5.53M12.39 6.32L12.78 5.93M12.71 6.72L13.18 6.45M12.9 7.2L13.43 7.06M12.97 7.71L13.52 7.71M12.9 8.22L13.43 8.36M12.71 8.7L13.18 8.97M12.39 9.1L12.78 9.49M11.99 9.42L12.26 9.89M11.51 9.61L11.65 10.14M11 9.68L11 10.23M10.49 9.61L10.35 10.14M10.01 9.42L9.74 9.89M9.61 9.1L9.22 9.49M9.29 8.7L8.82 8.97M9.1 8.22L8.57 8.36M9.03 7.71L8.48 7.71M9.1 7.2L8.57 7.06M9.29 6.72L8.82 6.45M9.61 6.32L9.22 5.93M10.01 6L9.74 5.53M10.49 5.81L10.35 5.28",
        "stroke": "accent",
        "strokeWidth": 0.2
      }
    ],
    "etomars": [
      {
        "type": "polygon",
        "d": "M12.7 6.26L10.32 6.24L11.5 4L12.59 5.94Z",
        "fill": "#000000"
      },
      {
        "type": "polygon",
        "d": "M13.47 14L12.61 14L12.55 13.94L12.53 10.88L12.03 10.9L12.03 13.94L11.97 14L11.01 13.98L10.99 10.88L10.45 10.9L10.45 13.94L10.39 14L9.53 14L9.47 13.94L9.47 6.8L9.53 6.74L13.51 6.74L13.57 6.8L13.55 7.76L10.45 7.78L10.45 8.25L10.52 8.32L13.57 8.34L13.55 9.34L10.45 9.36L10.47 9.85L13.51 9.85L13.57 9.92L13.57 13.94Z",
        "fill": "#000000"
      },
      {
        "type": "polygon",
        "d": "M8.89 13.4L7.57 13.4L7.5 13.34L8.94 10.92L8.96 13.34Z",
        "fill": "#000000"
      },
      {
        "type": "polygon",
        "d": "M15.47 13.4L14.09 13.38L14.11 10.92L15.5 13.29Z",
        "fill": "#000000"
      }
    ],
    "ezship": [
      {
        "type": "polygon",
        "d": "M3.56 9.13L4.7 9.13L4.7 8.47L3.56 8.47L3.56 7.56L4.95 7.56L4.95 6.9L2.9 6.9L2.9 10.7L4.95 10.7L4.95 10.04L3.56 10.04Z",
        "fill": "#0000c0"
      },
      {
        "type": "polygon",
        "d": "M6.16 6.9L6.16 7.56L7.46 7.56L5.58 10.7L8.04 10.7L8.04 10.04L6.74 10.04L8.63 6.9Z",
        "fill": "#0000c0"
      },
      {
        "type": "polygon",
        "d": "M10.58 9.27L10.77 9.54L10.71 9.81L10.39 10.04L9.94 10.04L9.51 9.74L9.13 10.28L9.73 10.7L10.6 10.7L11.3 10.2L11.47 9.4L10.99 8.71L9.77 8.33L9.59 8.06L9.65 7.78L9.95 7.56L10.38 7.56L10.78 7.86L11.17 7.33L10.59 6.9L9.73 6.9L9.06 7.4L8.89 8.2L9.36 8.89Z",
        "fill": "#0000c0"
      },
      {
        "type": "polygon",
        "d": "M14.7 10.7L14.7 6.9L14.04 6.9L14.04 8.47L12.76 8.47L12.76 6.9L12.1 6.9L12.1 10.7L12.76 10.7L12.76 9.13L14.04 9.13L14.04 10.7Z",
        "fill": "#0000c0"
      },
      {
        "type": "polygon",
        "d": "M15.33 6.9L15.33 10.7L15.99 10.7L15.99 6.9Z",
        "fill": "#0000c0"
      },
      {
        "type": "polygon",
        "d": "M18.76 7.23L18.39 6.98L17.98 6.9L16.62 6.9L16.62 10.7L17.27 10.7L17.27 9.19L17.98 9.19L18.39 9.11L18.76 8.86L19.01 8.49L19.1 8.05L19.01 7.61Z",
        "fill": "#0000c0"
      },
      {
        "type": "polygon",
        "d": "M18.29 8.39L18.13 8.49L17.92 8.53L17.27 8.53L17.27 7.56L17.92 7.56L18.13 7.6L18.29 7.71L18.39 7.86L18.43 8.05L18.39 8.23Z",
        "fill": "truck"
      }
    ],
    "fare-rata": [
      {
        "type": "polygon",
        "d": "M6.16 5.49L6.16 4.57L7.47 4.57L7.47 3.9L5.49 3.9L5.49 7.74L6.16 7.74L6.16 6.15L7.23 6.15L7.23 5.49Z",
        "fill": "#002043"
      },
      {
        "type": "polygon",
        "d": "M7.6 7.61L8.25 7.74L8.44 6.72L9.66 6.72L9.85 7.74L10.51 7.61L9.8 3.9L8.3 3.9Z",
        "fill": "#002043"
      },
      {
        "type": "polygon",
        "d": "M8.57 6.06L8.85 4.57L9.25 4.57L9.53 6.06Z",
        "fill": "truck"
      },
      {
        "type": "polygon",
        "d": "M13.69 4.61L13.44 4.23L13.06 3.98L12.65 3.9L11.14 3.9L11.14 7.74L11.81 7.74L11.81 6.21L12.01 6.21L13.29 7.74L13.8 7.31L12.85 6.18L13.06 6.13L13.44 5.88L13.69 5.5L13.78 5.06Z",
        "fill": "#002043"
      },
      {
        "type": "polygon",
        "d": "M13.07 5.24L12.96 5.4L12.8 5.51L12.58 5.55L11.81 5.55L11.81 4.57L12.58 4.57L12.8 4.61L12.96 4.71L13.07 4.87L13.1 5.06Z",
        "fill": "truck"
      },
      {
        "type": "polygon",
        "d": "M16.25 6.15L16.25 5.49L15.1 5.49L15.1 4.57L16.51 4.57L16.51 3.9L14.43 3.9L14.43 7.74L16.51 7.74L16.51 7.07L15.1 7.07L15.1 6.15Z",
        "fill": "#002043"
      },
      {
        "type": "polygon",
        "d": "M7.97 10.18L7.71 9.8L7.34 9.55L6.92 9.46L5.42 9.46L5.42 13.3L6.08 13.3L6.08 11.78L6.28 11.78L7.56 13.3L8.07 12.87L7.12 11.74L7.34 11.7L7.71 11.44L7.97 11.07L8.05 10.62Z",
        "fill": "#002043"
      },
      {
        "type": "polygon",
        "d": "M7.34 10.81L7.23 10.96L7.08 11.07L6.86 11.11L6.08 11.11L6.08 10.13L6.86 10.13L7.08 10.17L7.23 10.28L7.34 10.44L7.38 10.62Z",
        "fill": "truck"
      },
      {
        "type": "polygon",
        "d": "M8.66 13.18L9.31 13.3L9.5 12.29L10.72 12.29L10.92 13.3L11.57 13.18L10.87 9.46L9.36 9.46Z",
        "fill": "#002043"
      },
      {
        "type": "polygon",
        "d": "M9.63 11.62L9.91 10.13L10.31 10.13L10.6 11.62Z",
        "fill": "truck"
      },
      {
        "type": "polygon",
        "d": "M12.95 13.3L12.95 10.13L13.6 10.13L13.6 9.46L11.64 9.46L11.64 10.13L12.29 10.13L12.29 13.3Z",
        "fill": "#002043"
      },
      {
        "type": "polygon",
        "d": "M13.67 13.18L14.32 13.3L14.52 12.29L15.74 12.29L15.93 13.3L16.58 13.18L15.88 9.46L14.38 9.46Z",
        "fill": "#002043"
      },
      {
        "type": "polygon",
        "d": "M14.64 11.62L14.93 10.13L15.33 10.13L15.61 11.62Z",
        "fill": "truck"
      }
    ],
    "fasttrack-ar": [
      {
        "type": "polygon",
        "d": "M12.92 6.64L13.04 6.87L12.92 7.17L12.52 7.42L12.07 7.42L11.72 7.13L11.31 7.64L11.84 8.07L12.71 8.07L13.45 7.6L13.76 6.83L13.38 6.1L12.24 5.73L12.13 5.51L12.25 5.2L12.62 4.95L13.05 4.95L13.37 5.23L13.8 4.74L13.29 4.3L12.43 4.3L11.71 4.77L11.41 5.54L11.78 6.26Z",
        "fill": "accent"
      },
      {
        "type": "polygon",
        "d": "M7.84 7.9L8.45 8.12L8.84 7.07L10.03 7.07L10.04 8.01L10.69 8.01L10.65 4.3L9.17 4.3Z",
        "fill": "accent"
      },
      {
        "type": "polygon",
        "d": "M10.02 6.42L9.08 6.42L9.62 4.95L10.01 4.95Z",
        "fill": "truck"
      },
      {
        "type": "polygon",
        "d": "M6.86 4.95L8.21 4.95L8.21 4.3L6.31 4.3L5.65 8.01L6.29 8.13L6.58 6.51L7.68 6.51L7.68 5.86L6.7 5.86Z",
        "fill": "accent"
      },
      {
        "type": "polygon",
        "d": "M14.45 8.01L15.09 8.13L15.66 4.95L16.35 4.95L16.35 4.3L14.42 4.3L14.42 4.95L15 4.95Z",
        "fill": "accent"
      },
      {
        "type": "polygon",
        "d": "M12.77 10.32L12.65 10.68L12.42 11.92L12.42 12.3L12.54 12.68L12.8 12.99L13.15 13.18L13.56 13.25L13.96 13.18L14.34 13L14.62 12.75L14.19 12.26L13.98 12.45L13.76 12.55L13.55 12.58L13.37 12.56L13.22 12.48L13.13 12.36L13.07 12.2L13.08 11.98L13.28 10.85L13.36 10.61L13.5 10.42L13.68 10.26L13.9 10.16L14.11 10.13L14.29 10.16L14.43 10.24L14.56 10.41L15.08 10.01L14.87 9.74L14.52 9.54L14.12 9.47L13.71 9.53L13.33 9.7L13.01 9.97Z",
        "fill": "accent"
      },
      {
        "type": "polygon",
        "d": "M15.86 9.41L15.18 13.18L15.82 13.3L16.08 11.84L16.49 11.5L17.19 13.2L17.8 12.95L17.01 11.05L18.31 9.95L17.89 9.45L16.27 10.83L16.5 9.53Z",
        "fill": "accent"
      },
      {
        "type": "polygon",
        "d": "M9.56 13.29L9.95 12.25L11.14 12.25L11.15 13.18L11.8 13.18L11.76 9.47L10.28 9.47L8.95 13.07Z",
        "fill": "accent"
      },
      {
        "type": "polygon",
        "d": "M10.19 11.59L10.73 10.13L11.12 10.13L11.13 11.59Z",
        "fill": "truck"
      },
      {
        "type": "polygon",
        "d": "M4.93 10.13L5.62 10.13L5.62 9.47L3.69 9.47L3.69 10.13L4.26 10.13L3.71 13.18L4.35 13.3Z",
        "fill": "accent"
      },
      {
        "type": "polygon",
        "d": "M8.55 9.82L8.2 9.56L7.8 9.47L6.37 9.47L5.7 13.18L6.34 13.3L6.62 11.75L6.85 11.75L7.82 13.21L8.36 12.85L7.62 11.72L7.91 11.67L8.3 11.44L8.6 11.09L8.76 10.67L8.75 10.22Z",
        "fill": "accent"
      },
      {
        "type": "polygon",
        "d": "M8.03 10.75L7.87 10.93L7.68 11.05L7.44 11.09L6.74 11.09L6.92 10.13L7.73 10.13L7.92 10.17L8.03 10.25L8.1 10.38L8.1 10.55Z",
        "fill": "truck"
      }
    ],
    "fxdc-post": [
      {
        "type": "polygon",
        "d": "M3.81 11.42L3.81 9.26L5.27 9.26L5.27 8.34L3.81 8.34L3.81 7.09L5.61 7.09L5.61 6.18L2.9 6.18L2.9 11.42Z",
        "fill": "accent"
      },
      {
        "type": "polygon",
        "d": "M6.48 6.68L7.88 8.8L6.48 10.92L7.24 11.42L8.42 9.63L9.61 11.42L10.37 10.92L8.97 8.8L10.37 6.68L9.61 6.18L8.42 7.97L7.24 6.18Z",
        "fill": "accent"
      },
      {
        "type": "polygon",
        "d": "M13.06 11.34L13.69 11.07L14.24 10.66L14.66 10.11L14.92 9.48L15.01 8.8L14.92 8.12L14.66 7.49L14.24 6.94L13.69 6.53L13.06 6.26L12.41 6.18L11.23 6.18L11.23 11.42L12.41 11.42Z",
        "fill": "accent"
      },
      {
        "type": "polygon",
        "d": "M13.23 7.32L13.59 7.59L13.86 7.95L14.03 8.36L14.09 8.8L14.03 9.24L13.86 9.65L13.59 10.01L13.23 10.28L12.82 10.45L12.35 10.51L12.14 10.51L12.14 7.09L12.35 7.09L12.82 7.15Z",
        "fill": "truck"
      },
      {
        "type": "polygon",
        "d": "M17.13 6.26L16.62 6.51L16.22 6.91L15.96 7.42L15.87 7.94L15.87 9.66L15.96 10.18L16.22 10.69L16.62 11.09L17.13 11.34L17.69 11.43L18.25 11.33L18.76 11.07L19.1 10.71L18.45 10.08L18.2 10.33L17.96 10.46L17.68 10.51L17.41 10.47L17.16 10.34L16.96 10.15L16.83 9.9L16.78 9.59L16.78 8.01L16.83 7.7L16.96 7.45L17.16 7.26L17.41 7.13L17.68 7.09L17.96 7.14L18.2 7.27L18.45 7.52L19.1 6.89L18.76 6.53L18.25 6.27L17.69 6.17Z",
        "fill": "accent"
      }
    ],
    "global-business-tw": [
      {
        "type": "polygon",
        "d": "M13.5 8.4L13.54 8.14L13.54 7.96L13.5 7.71L13.37 7.46L13.18 7.26L12.92 7.13L12.67 7.09L11.46 7.09L11.46 10.51L12.86 10.51L13.13 10.47L13.41 10.33L13.62 10.11L13.76 9.84L13.8 9.56L13.8 9.37L13.76 9.09L13.62 8.82L13.4 8.6Z",
        "fill": "accent"
      },
      {
        "type": "polygon",
        "d": "M12.05 9.01L12.81 9.01L12.95 9.03L13.05 9.09L13.14 9.17L13.19 9.27L13.21 9.41L13.21 9.52L13.19 9.65L13.14 9.76L13.05 9.84L12.95 9.89L12.81 9.92L12.05 9.92Z",
        "fill": "truck"
      },
      {
        "type": "polygon",
        "d": "M12.89 7.81L12.93 7.89L12.95 8.01L12.95 8.09L12.93 8.21L12.89 8.29L12.82 8.36L12.74 8.4L12.62 8.42L12.05 8.42L12.05 7.68L12.62 7.68L12.74 7.7L12.82 7.74Z",
        "fill": "truck"
      },
      {
        "type": "polygon",
        "d": "M6.63 9.92L6.63 7.09L6.04 7.09L6.04 10.51L7.75 10.51L7.75 9.92Z",
        "fill": "accent"
      },
      {
        "type": "polygon",
        "d": "M10.05 7.19L9.52 7.08L9 7.19L8.55 7.49L8.25 7.93L8.15 8.43L8.15 9.17L8.25 9.67L8.55 10.11L9 10.41L9.52 10.52L10.05 10.41L10.5 10.11L10.8 9.67L10.89 9.17L10.89 8.43L10.8 7.93L10.5 7.49Z",
        "fill": "accent"
      },
      {
        "type": "polygon",
        "d": "M10.24 9.43L10.07 9.68L9.82 9.85L9.52 9.91L9.23 9.85L8.98 9.68L8.81 9.43L8.75 9.11L8.75 8.49L8.81 8.17L8.98 7.92L9.23 7.75L9.52 7.69L9.82 7.75L10.07 7.92L10.24 8.17L10.3 8.49L10.3 9.11Z",
        "fill": "truck"
      },
      {
        "type": "polygon",
        "d": "M16.83 10.4L16.2 7.09L14.86 7.09L14.23 10.4L14.81 10.51L14.98 9.61L16.07 9.61L16.24 10.51Z",
        "fill": "accent"
      },
      {
        "type": "polygon",
        "d": "M15.1 9.01L15.35 7.68L15.71 7.68L15.96 9.01Z",
        "fill": "truck"
      },
      {
        "type": "polygon",
        "d": "M17.98 9.92L17.98 7.09L17.39 7.09L17.39 10.51L19.1 10.51L19.1 9.92Z",
        "fill": "accent"
      },
      {
        "type": "polygon",
        "d": "M4.45 9.86L4.19 9.91L3.92 9.86L3.7 9.71L3.55 9.49L3.49 9.19L3.49 8.4L3.53 8.16L3.63 7.97L3.78 7.82L3.98 7.72L4.19 7.69L4.41 7.72L4.6 7.83L4.78 8.02L5.21 7.6L4.96 7.34L4.6 7.16L4.2 7.09L3.8 7.15L3.43 7.33L3.15 7.61L2.96 7.98L2.9 8.35L2.9 9.25L2.99 9.72L3.27 10.14L3.69 10.42L4.19 10.52L4.68 10.42L5.1 10.14L5.38 9.72L5.47 9.25L5.47 8.64L4.19 8.64L4.19 9.24L4.87 9.24L4.82 9.49L4.67 9.71Z",
        "fill": "accent"
      }
    ],
    "honducor": [
      {
        "type": "polygon",
        "d": "M11.52 10.9L15.16 9.33L15.16 5.31L11.46 3.9L7.64 5.19L7.64 9.21Z",
        "fill": "accent"
      },
      {
        "type": "polygon",
        "d": "M8.55 5.35L11.26 4.44L11.37 5.74L13.16 5.8L11.46 6.35Z",
        "fill": "truck"
      },
      {
        "type": "polygon",
        "d": "M14.64 5.86L14.64 5.79L14.72 5.77L14.72 9.04L11.73 10.32L11.68 6.75L14.45 5.85Z",
        "fill": "truck"
      },
      {
        "type": "polygon",
        "d": "M11.71 4.47L14.15 5.4L11.78 5.31Z",
        "fill": "truck"
      },
      {
        "type": "polygon",
        "d": "M7.6 11.4L7.78 11.94L8.34 11.94L7.88 12.27L8.06 12.81L7.6 12.48L7.14 12.81L7.32 12.27L6.86 11.94L7.42 11.94Z",
        "fill": "accent"
      },
      {
        "type": "polygon",
        "d": "M9.5 11.4L9.68 11.94L10.24 11.94L9.78 12.27L9.96 12.81L9.5 12.48L9.04 12.81L9.22 12.27L8.76 11.94L9.32 11.94Z",
        "fill": "accent"
      },
      {
        "type": "polygon",
        "d": "M11.4 11.4L11.58 11.94L12.14 11.94L11.68 12.27L11.86 12.81L11.4 12.48L10.94 12.81L11.12 12.27L10.66 11.94L11.22 11.94Z",
        "fill": "accent"
      },
      {
        "type": "polygon",
        "d": "M13.3 11.4L13.48 11.94L14.04 11.94L13.58 12.27L13.76 12.81L13.3 12.48L12.84 12.81L13.02 12.27L12.56 11.94L13.12 11.94Z",
        "fill": "accent"
      },
      {
        "type": "polygon",
        "d": "M15.2 11.4L15.38 11.94L15.94 11.94L15.48 12.27L15.66 12.81L15.2 12.48L14.74 12.81L14.92 12.27L14.46 11.94L15.02 11.94Z",
        "fill": "accent"
      }
    ],
    "hy-express": [
      {
        "type": "polygon",
        "d": "M11 3.9L9.89 4.46L9.89 7.55L7.73 8.66L7.73 6.08L8.83 5.52L8.83 5L6.43 6.22L6.43 11.17L11 13.49L11 13.5L15.57 11.17L15.57 6.22L14.24 5.54L14.24 8.66L13.21 8.14L13.21 5.02Z",
        "fill": "#041841"
      },
      {
        "type": "polygon",
        "d": "M7.73 11.31L7.73 9.87L9.89 8.76L9.89 11.14L11.01 11.71L11.01 4.43L12.03 4.94L12.03 9.13L12.78 9.13L14.24 9.87L14.24 10.43L12.03 11.55L12.03 12.46L11 12.98L11 12.97Z",
        "fill": "truck"
      }
    ],
    "indopaket": [
      {
        "type": "polygon",
        "d": "M6.39 5L5.76 5L5.76 8.6L6.39 8.6Z",
        "fill": "accent"
      },
      {
        "type": "polygon",
        "d": "M8.14 8.6L9.57 8.6L9.57 5L8.95 5L8.95 7.98L8.71 7.98L8.41 5L6.98 5L6.98 8.6L7.61 8.6L7.61 5.62L7.84 5.62Z",
        "fill": "accent"
      },
      {
        "type": "polygon",
        "d": "M10.97 8.6L11.42 8.54L11.86 8.36L12.23 8.07L12.52 7.7L12.7 7.27L12.76 6.8L12.7 6.33L12.52 5.9L12.23 5.53L11.86 5.24L11.42 5.06L10.97 5L10.17 5L10.17 8.6Z",
        "fill": "accent"
      },
      {
        "type": "polygon",
        "d": "M11.26 5.67L11.54 5.78L11.78 5.97L11.97 6.21L12.09 6.5L12.13 6.8L12.09 7.1L11.97 7.39L11.78 7.63L11.54 7.82L11.26 7.93L10.93 7.98L10.79 7.98L10.79 5.62L10.93 5.62Z",
        "fill": "truck"
      },
      {
        "type": "polygon",
        "d": "M15.82 5.42L15.35 5.1L14.79 4.99L14.24 5.1L13.77 5.42L13.46 5.89L13.35 6.41L13.35 7.19L13.46 7.71L13.77 8.18L14.24 8.5L14.79 8.61L15.35 8.5L15.82 8.18L16.13 7.71L16.24 7.19L16.24 6.41L16.13 5.89Z",
        "fill": "accent"
      },
      {
        "type": "polygon",
        "d": "M15.61 7.13L15.54 7.47L15.37 7.73L15.11 7.91L14.79 7.97L14.48 7.91L14.22 7.73L14.04 7.47L13.98 7.13L13.98 6.47L14.04 6.13L14.22 5.87L14.48 5.69L14.79 5.63L15.11 5.69L15.37 5.87L15.54 6.13L15.61 6.47Z",
        "fill": "truck"
      },
      {
        "type": "polygon",
        "d": "M15.79 10.43L16.4 10.43L16.4 13.41L17.03 13.41L17.03 10.43L17.64 10.43L17.64 9.81L15.79 9.81Z",
        "fill": "accent"
      },
      {
        "type": "polygon",
        "d": "M12.17 9.81L10.82 11.15L10.82 9.81L10.2 9.81L10.2 13.41L10.82 13.41L10.82 12.03L11.12 11.73L12.12 13.41L12.65 13.09L11.58 11.27L12.61 10.25Z",
        "fill": "accent"
      },
      {
        "type": "polygon",
        "d": "M6.4 11.66L6.64 11.31L6.72 10.89L6.64 10.47L6.4 10.12L6.04 9.88L5.66 9.81L4.36 9.81L4.36 13.41L4.99 13.41L4.99 11.98L5.66 11.98L6.04 11.9Z",
        "fill": "accent"
      },
      {
        "type": "polygon",
        "d": "M5.95 10.57L6.05 10.72L6.08 10.89L6.05 11.07L5.95 11.21L5.8 11.31L5.6 11.35L4.99 11.35L4.99 10.43L5.6 10.43L5.8 10.47Z",
        "fill": "truck"
      },
      {
        "type": "polygon",
        "d": "M8.94 9.81L7.53 9.81L6.87 13.29L7.48 13.41L7.66 12.45L8.81 12.45L8.99 13.41L9.6 13.29Z",
        "fill": "accent"
      },
      {
        "type": "polygon",
        "d": "M8.05 10.43L8.42 10.43L8.69 11.83L7.78 11.83Z",
        "fill": "truck"
      },
      {
        "type": "polygon",
        "d": "M15.2 12.78L13.87 12.78L13.87 11.92L14.95 11.92L14.95 11.29L13.87 11.29L13.87 10.43L15.2 10.43L15.2 9.81L13.25 9.81L13.25 13.41L15.2 13.41Z",
        "fill": "accent"
      }
    ],
    "ipostel": [
      {
        "type": "polygon",
        "d": "M8.87 4.75L9.62 4.38L10.38 4.14L11.34 4.02L10.66 4L10.61 4.05L10.05 4.09L9.67 4.24L9.53 4.24L8.49 4.71L8.06 4.99L7.1 5.91L6.58 6.67L6.15 7.7L6.38 7.78L6.57 7.78L6.77 7.14L7.24 6.29L7.52 5.91L8.44 5.04Z",
        "fill": "#f2de1c"
      },
      {
        "type": "polygon",
        "d": "M6.48 8.13L6.08 8.05L6.06 8.22L6.01 8.27L6.01 8.6L5.96 8.65L5.96 8.99L6.21 9.09L6.37 9.09L6.39 8.55L6.44 8.5L6.44 8.22Z",
        "fill": "#f2de1c"
      },
      {
        "type": "polygon",
        "d": "M6.39 9.5L6.22 9.42L5.99 9.39L6.01 9.92L6.06 9.97L6.06 10.16L6.14 10.43L6.32 10.52L6.57 10.52L6.44 10.01Z",
        "fill": "#f2de1c"
      },
      {
        "type": "polygon",
        "d": "M8.21 12.96L7.29 12L6.96 11.48L6.72 10.91L6.3 10.86L6.48 11.33L6.86 11.95L7.29 12.47L7.83 12.96L8.54 13.43L9.15 13.72L9.95 13.95L10.47 14L10.47 13.95L9.9 13.86L9.38 13.67L8.82 13.39Z",
        "fill": "#f2de1c"
      },
      {
        "type": "polygon",
        "d": "M14.42 7.19L13.99 6.56L13.6 6.16L13.17 5.82L12.65 5.51L12.13 5.31L11.55 5.16L10.95 5.1L10.39 5.12L9.8 5.23L9.28 5.41L8.78 5.66L8.28 6L7.84 6.41L7.49 6.84L7.2 7.31L6.97 7.86L7.48 7.88L7.56 7.92L10.08 7.92L10.15 7.88L10.69 7.88L10.77 7.83L11.11 7.83L11.19 7.78L12.15 7.69L12.22 7.64L12.44 7.64L12.51 7.59L13.61 7.41L13.69 7.36L14.37 7.22Z",
        "fill": "accent"
      },
      {
        "type": "polygon",
        "d": "M14.57 7.48L15.2 7.29L15.34 7.2L15.58 7.15L15.72 7.05L15.96 7L16.51 6.75L16.55 6.63L16.45 6.58L15.51 6.89L15.36 6.89L15.17 6.98L14.51 7.13L14.42 7.19Z",
        "fill": "accent"
      },
      {
        "type": "polygon",
        "d": "M5.45 7.15L5.32 7.18L5.32 7.38L5.37 7.54L5.64 7.85L6.03 8.04L6.45 8.09L6.6 8.19L6.87 8.19L6.97 7.86L6.74 7.78L6.38 7.78L6.19 7.74L5.68 7.46Z",
        "fill": "accent"
      },
      {
        "type": "polygon",
        "d": "M16.74 8L16.91 7.9L16.87 7.77L16.55 7.83L16.26 7.97L16.11 7.98L15.51 8.21L14.9 8.35L14.86 8.37L14.92 8.67L15.85 8.38L16.66 8Z",
        "fill": "accent"
      },
      {
        "type": "polygon",
        "d": "M14.86 8.37L14.57 7.48L14.44 7.48L13.17 7.86L12.99 7.86L12.5 8L11.98 8.05L11.66 8.14L11 8.19L10.92 8.24L9.97 8.28L9.88 8.33L8.09 8.33L8 8.28L7.51 8.28L7.44 8.24L6.87 8.19L6.74 9.15L6.89 9.2L7.3 9.2L7.37 9.25L8.32 9.25L8.41 9.29L10.08 9.25L10.15 9.2L11.11 9.15L11.19 9.1L11.82 9.06L11.9 9.01L12.67 8.92L12.74 8.87L13.38 8.77L13.62 8.68L13.8 8.68L13.87 8.63L14.75 8.45Z",
        "fill": "accent"
      },
      {
        "type": "polygon",
        "d": "M5.27 8.43L5.14 8.46L5.13 8.66L5.23 8.91L5.54 9.22L5.83 9.36L6.21 9.41L6.4 9.51L6.75 9.51L6.74 9.15L6.6 9.1L6.23 9.1L5.59 8.83L5.38 8.62Z",
        "fill": "accent"
      },
      {
        "type": "polygon",
        "d": "M14.88 9.98L16.09 9.51L16.2 9.5L16.44 9.36L16.47 9.25L16.36 9.2L14.93 9.63Z",
        "fill": "accent"
      },
      {
        "type": "polygon",
        "d": "M14.93 9.63L14.92 8.67L13.92 8.99L13.78 8.99L13.17 9.18L12.98 9.18L12.74 9.27L12.33 9.32L12.25 9.37L11.05 9.51L10.97 9.56L9.97 9.6L9.89 9.65L7.9 9.65L7.81 9.6L7.32 9.6L7.25 9.56L6.9 9.56L6.75 9.51L6.83 10.05L6.97 10.56L7.17 10.61L7.91 10.61L7.99 10.66L9.89 10.61L9.96 10.57L10.88 10.52L10.96 10.47L12.15 10.33L12.23 10.28L13.33 10.1L13.4 10.04L14.8 9.72Z",
        "fill": "accent"
      },
      {
        "type": "polygon",
        "d": "M5.25 9.79L5.12 9.79L5.08 9.98L5.23 10.36L5.45 10.59L5.84 10.78L7.15 10.98L6.97 10.56L6.33 10.52L6.14 10.43L5.72 10.33L5.45 10.15L5.29 9.95Z",
        "fill": "accent"
      },
      {
        "type": "polygon",
        "d": "M7.15 10.98L7.58 11.69L8.02 12.17L8.53 12.59L9.05 12.89L9.61 13.11L10.24 13.26L10.85 13.31L11.5 13.25L12.09 13.11L12.69 12.87L13.25 12.53L13.71 12.14L14.11 11.69L14.47 11.14L14.71 10.59L14.88 9.98L14.77 9.98L14.02 10.26L13.69 10.31L13.5 10.4L13.35 10.41L12.93 10.55L12.75 10.55L11.97 10.74L11.48 10.78L11.4 10.83L10.77 10.88L10.69 10.92L10.3 10.92L10.22 10.97L9.59 10.97L9.51 11.02Z",
        "fill": "accent"
      }
    ],
    "libya-post": [
      {
        "type": "polygon",
        "d": "M16.49 8.2L15.86 7.4L15.19 6.83L14.38 6.34L13.93 6.15L13.69 6.11L13.63 6.19L13.67 6.29L14.64 6.77L15.39 7.32L15.9 7.85L16.33 8.48L15.54 9.52L15.08 8.87L14.52 8.25L13.83 7.61L13.48 7.34L13.4 7.32L13.35 7.5L13.84 7.91L14.32 8.39L15.15 9.49L15.32 9.76L15.09 9.99L14.44 10.53L13.74 10.98L12.64 9.34L12.52 9.18L12.43 9.15L12.36 9.21L12.36 9.3L13.5 11.11L12.72 11.46L11.93 11.71L11.1 11.88L10.26 11.95L8.86 11.89L8.6 11.35L8.5 11.3L8.41 11.42L8.58 11.84L8.78 11.92L8.79 12.03L8.71 12.1L8.91 12.44L9.38 13.05L9.91 13.56L9.89 13.63L9.92 13.7L10.15 13.74L10.68 14.06L11.24 14.32L12.17 14.55L13.1 14.6L14.01 14.47L14.91 14.16L15.57 13.78L16.17 13.29L16.68 12.72L17.09 12.07L17.32 11.56L17.49 11.03L17.61 10.36L17.64 9.64L17.88 8.93L18.04 8.26L17.96 8.17L17.85 8.21L17.58 9.07L17.4 8.31L17.09 7.57L17.43 6.53L17.45 6.43L17.41 6.36L17.33 6.34L17.26 6.39L16.93 7.3L16.44 6.64L15.84 6.08L15.09 5.6L14.61 5.38L14.52 5.39L14.47 5.48L14.51 5.56L15.05 5.82L15.56 6.16L16.02 6.58L16.41 7.06L16.77 7.67Z",
        "fill": "accent"
      },
      {
        "type": "polygon",
        "d": "M17.18 9.97L16.97 9.18L16.66 8.48L16.91 7.99L17.08 8.51L17.19 9.06L17.24 9.8Z",
        "fill": "truck"
      },
      {
        "type": "polygon",
        "d": "M16.49 8.78L16.78 9.57L16.95 10.36L16.3 11.22L16.06 10.51L15.72 9.82Z",
        "fill": "truck"
      },
      {
        "type": "polygon",
        "d": "M17.01 10.84L17.02 11.04L16.86 11.46L16.42 12.23L16.38 11.64Z",
        "fill": "truck"
      },
      {
        "type": "polygon",
        "d": "M16.09 12.66L15.63 13.1L15.12 13.48L14.8 12.84L15.48 12.42L16.09 11.93L16.13 12.53Z",
        "fill": "truck"
      },
      {
        "type": "polygon",
        "d": "M14.9 13.61L13.9 14.01L12.92 14.16L12.35 14.14L11.86 14.08L11.34 13.94L10.86 13.75L11.86 13.69L12.83 13.54L13.69 13.31L14.53 12.98Z",
        "fill": "truck"
      },
      {
        "type": "polygon",
        "d": "M10.43 13.52L9.63 12.9L9 12.13L10.23 12.21L11.43 12.12L12.57 11.85L13.66 11.41L14.35 12.67L13.43 13.05L12.42 13.32L11.22 13.49Z",
        "fill": "truck"
      },
      {
        "type": "polygon",
        "d": "M13.92 11.27L14.75 10.72L15.49 10.07L15.8 10.79L16.01 11.52L15.36 12.07L14.63 12.53Z",
        "fill": "truck"
      },
      {
        "type": "polygon",
        "d": "M4.27 8.4L4.48 8.04L4.75 7.8L5.09 7.66L5.57 7.62L6.37 7.79L8.25 8.49L9.28 8.75L9.91 8.84L10.57 8.86L11.13 8.82L11.7 8.72L12.39 8.46L12.93 8.1L13.27 7.66L13.43 7.14L13.4 6.66L13.23 6.2L12.89 5.67L12.16 4.84L12.04 4.54L12.1 4.4L12.29 4.37L12.55 4.41L13.8 4.84L14.74 5.09L15.46 5.21L16.16 5.26L16.99 5.22L17.84 5.06L18.9 4.69L18.96 4.62L18.96 4.55L18.85 4.46L17.1 4.68L15.45 4.66L13.97 4.43L12.24 3.93L11.88 3.9L11.58 3.94L11.3 4.06L11.14 4.24L11.07 4.48L11.11 4.79L11.34 5.23L11.93 5.9L12.22 6.3L12.43 6.7L12.53 7.08L12.51 7.37L12.41 7.61L12.22 7.82L11.97 8L11.46 8.2L10.79 8.33L10.04 8.37L9.26 8.32L8.08 8.07L5.92 7.26L5.47 7.17L5.03 7.16L4.55 7.28L4.12 7.54L3.81 7.9L3.43 8.22L3.05 8.75L3.04 8.87L3.13 8.94L3.51 8.82L3.8 8.79L4.07 8.84L4.33 8.95L4.65 9.22L5.94 10.68L6.74 11.37L7.2 11.66L7.69 11.89L8.22 12.05L8.71 12.11L8.8 12.01L8.75 11.89L8 11.59L7.38 11.07L6.92 10.5L6.32 9.55L5.92 9.14L5.17 8.68Z",
        "fill": "#fbd829"
      }
    ],
    "macau-post": [
      {
        "type": "polygon",
        "d": "M10.82 6.8L10.12 6.83L10.13 6.8L4.57 7.02L10.05 7.24L9.84 8.4L4.29 8.61L9.76 8.82L9.55 10L4.02 10.2L9.47 10.4L9.25 11.59L3.74 11.79L9.18 11.98L9 13.13L8.96 13.19L3.47 13.38L9.62 13.6L12.18 13.6L12.52 13.54L12.81 13.36L13 13.09L13.05 12.85L12.96 12.62L12.77 12.46L12.53 12.41L10.83 12.4L10.62 12.3L10.48 12.11L10.42 11.84L10.43 11.64L10.93 8.79L11.01 8.55L11.1 8.41L11.28 8.23L11.49 8.1L11.73 8.03L15.28 8.02L15.45 8L15.74 7.87L15.92 7.7L16.08 7.42L16.07 7.18L16 7.04L15.88 6.93L15.72 6.85L15.54 6.81Z",
        "fill": "accent"
      },
      {
        "type": "polygon",
        "d": "M9.61 6.3L9.86 6.25L10.06 6.06L10.18 6.02L10.3 6.05L10.46 6.24L10.63 6.3L10.8 6.25L11.01 6.04L11.13 6L11.28 6.05L11.42 6.24L11.59 6.3L11.75 6.25L11.95 6.06L12.07 6.02L12.2 6.05L12.35 6.24L12.53 6.3L12.69 6.25L12.89 6.06L13.01 6.02L13.15 6.06L13.29 6.24L13.46 6.3L13.63 6.25L13.82 6.06L13.95 6.02L14.07 6.05L14.23 6.24L14.4 6.3L14.56 6.25L14.76 6.06L14.88 6.02L15.01 6.05L15.16 6.24L15.34 6.3L15.5 6.25L15.7 6.06L15.8 6.02L15.94 6.05L16.1 6.24L16.27 6.3L16.44 6.25L16.69 6.04L16.79 6.03L16.91 6.08L17.1 6.32L17.13 6.47L17.06 6.58L16.86 6.75L16.78 6.9L16.81 7.07L16.94 7.23L16.96 7.38L16.9 7.5L16.69 7.66L16.62 7.81L16.64 8L16.77 8.14L16.8 8.29L16.74 8.41L16.53 8.57L16.46 8.73L16.48 8.9L16.62 9.06L16.64 9.21L16.58 9.32L16.37 9.49L16.3 9.64L16.32 9.82L16.45 9.97L16.48 10.12L16.42 10.23L16.21 10.4L16.14 10.55L16.16 10.73L16.3 10.88L16.32 11.03L16.26 11.15L16.05 11.31L15.98 11.47L16 11.64L16.13 11.79L16.16 11.94L16.09 12.06L15.89 12.22L15.81 12.37L15.84 12.56L15.97 12.71L16 12.84L15.95 12.96L15.78 13.08L15.68 13.21L15.65 13.39L15.68 13.49L15.85 13.6L15.91 13.55L16.54 13.03L17.05 12.49L17.4 12.03L17.71 11.55L17.94 11.11L18.16 10.58L18.32 10.11L18.45 9.55L18.51 9.1L18.53 8.58L18.51 8.15L18.43 7.66L18.31 7.19L18.14 6.74L17.92 6.33L17.66 5.95L17.36 5.6L17.01 5.28L16.63 5L16.22 4.77L15.78 4.58L15.3 4.44L14.8 4.34L14.36 4.3L13.92 4.31L13.35 4.36L12.86 4.45L12.3 4.6L11.76 4.8L11.31 5.01L10.81 5.3L10.34 5.63Z",
        "fill": "accent"
      },
      {
        "type": "polygon",
        "d": "M11.81 9.2L13.63 9.92L13.82 9.89L15.78 9.2L15.77 8.95L15.62 8.73L15.38 8.63L12.49 8.63L12.32 8.66L12.16 8.72L11.96 8.89L11.87 9.04Z",
        "fill": "accent"
      },
      {
        "type": "polygon",
        "d": "M13.76 10.25L13.57 10.26L13.39 10.22L11.76 9.55L11.52 10.94L11.54 11.12L11.68 11.33L11.92 11.44L14.82 11.44L15.06 11.4L15.33 11.21L15.49 10.93L15.74 9.55Z",
        "fill": "accent"
      }
    ],
    "mikropakket": [
      {
        "type": "polygon",
        "d": "M7.56 6.82L7.31 10.24L9.6 10.24L10.72 6.82L10.8 6.82L9.84 11.6L10.85 11.8L12.05 5.8L9.98 5.8L8.86 9.21L8.41 9.21L8.66 5.8L6.61 5.8L5.45 11.6L6.46 11.8L7.45 6.82Z",
        "fill": "accent"
      },
      {
        "type": "polygon",
        "d": "M14.56 9.36L15.2 9.24L15.82 8.87L16.28 8.33L16.55 7.68L16.55 6.98L16.25 6.35L15.71 5.93L15.07 5.8L13.04 5.8L11.88 11.6L12.88 11.8L13.37 9.36Z",
        "fill": "accent"
      },
      {
        "type": "polygon",
        "d": "M13.88 6.82L14.97 6.82L15.27 6.89L15.43 7.01L15.52 7.21L15.52 7.48L15.4 7.79L15.15 8.08L14.83 8.26L14.46 8.34L13.58 8.34Z",
        "fill": "truck"
      }
    ],
    "mobi-logistica": [
      {
        "type": "polygon",
        "d": "M17.66 7.75L18.51 7.75L18.51 6.91L17.66 6.91Z",
        "fill": "#323241"
      },
      {
        "type": "polygon",
        "d": "M7.97 5.8L5.73 9.53L3.49 5.8L3.49 11.79L4.34 11.79L4.34 8.86L5.73 11.18L7.12 8.86L7.12 11.79L7.97 11.79Z",
        "fill": "#323241"
      },
      {
        "type": "polygon",
        "d": "M9.99 7.05L9.35 7.47L8.92 8.11L8.78 8.82L8.78 9.88L8.92 10.59L9.35 11.22L9.99 11.65L10.74 11.8L11.49 11.65L12.13 11.22L12.55 10.59L12.7 9.88L12.7 8.82L12.55 8.11L12.13 7.47L11.49 7.05L10.74 6.9Z",
        "fill": "#323241"
      },
      {
        "type": "polygon",
        "d": "M11.16 10.85L10.74 10.94L10.32 10.85L9.96 10.61L9.72 10.26L9.63 9.79L9.63 8.91L9.72 8.44L9.96 8.09L10.32 7.85L10.74 7.76L11.16 7.85L11.52 8.09L11.76 8.44L11.85 8.91L11.85 9.79L11.76 10.26L11.52 10.61Z",
        "fill": "truck"
      },
      {
        "type": "polygon",
        "d": "M16.42 7.79L16.24 7.43L15.95 7.15L15.6 6.96L15.23 6.91L13.5 6.91L13.5 11.79L15.5 11.79L15.9 11.73L16.29 11.53L16.59 11.22L16.79 10.84L16.85 10.44L16.85 10.16L16.79 9.76L16.59 9.37L16.27 9.06L16.42 8.77L16.48 8.41L16.48 8.15Z",
        "fill": "#323241"
      },
      {
        "type": "polygon",
        "d": "M15.63 8.34L15.6 8.51L15.54 8.62L15.45 8.72L15.33 8.78L15.17 8.8L14.35 8.8L14.35 7.75L15.17 7.75L15.33 7.78L15.45 7.84L15.54 7.93L15.6 8.05L15.63 8.22Z",
        "fill": "truck"
      },
      {
        "type": "polygon",
        "d": "M15.78 9.76L15.9 9.88L15.97 10.03L16.01 10.22L16.01 10.37L15.97 10.57L15.9 10.72L15.78 10.84L15.63 10.91L15.43 10.94L14.35 10.94L14.35 9.65L15.43 9.65L15.63 9.68Z",
        "fill": "truck"
      },
      {
        "type": "polygon",
        "d": "M18.51 8.74L17.66 8.74L17.66 11.79L18.51 11.79Z",
        "fill": "#323241"
      }
    ],
    "myanmar-post": [
      {
        "type": "polygon",
        "d": "M8.86 11.35L10.35 8.87L10.35 12L11.25 12L11.25 5.6L8.86 9.59L6.47 5.6L6.47 12L7.37 12L7.37 8.87Z",
        "fill": "accent"
      },
      {
        "type": "polygon",
        "d": "M13.99 9.93L14.56 9.82L15.07 9.48L15.41 8.96L15.53 8.36L15.41 7.75L15.07 7.24L14.56 6.89L13.99 6.78L12.12 6.78L12.12 12L13.02 12L13.02 9.93Z",
        "fill": "accent"
      },
      {
        "type": "polygon",
        "d": "M13.9 7.69L14.2 7.75L14.42 7.89L14.56 8.1L14.61 8.36L14.56 8.61L14.42 8.82L14.2 8.97L13.9 9.02L13.02 9.02L13.02 7.69Z",
        "fill": "truck"
      }
    ],
    "paositra-malagasy": [
      {
        "type": "polygon",
        "d": "M15.02 8.85L15.02 11.07L15.67 11.07L15.67 6.52L13.97 9.36L12.26 6.52L12.26 11.07L12.91 11.07L12.91 8.85L13.97 10.61Z",
        "fill": "#004387"
      },
      {
        "type": "polygon",
        "d": "M5 9.28L5.24 8.91L5.33 8.48L5.24 8.05L5 7.68L4.63 7.44L4.24 7.36L2.9 7.36L2.9 11.07L3.54 11.07L3.54 9.6L4.24 9.6L4.63 9.52Z",
        "fill": "#004387"
      },
      {
        "type": "polygon",
        "d": "M4.54 8.15L4.64 8.3L4.67 8.48L4.64 8.66L4.54 8.81L4.38 8.91L4.17 8.96L3.54 8.96L3.54 8.01L4.17 8.01L4.38 8.05Z",
        "fill": "truck"
      },
      {
        "type": "polygon",
        "d": "M8.3 10.95L7.62 7.36L6.17 7.36L5.48 10.95L6.12 11.07L6.3 10.09L7.48 10.09L7.67 11.07Z",
        "fill": "#004387"
      },
      {
        "type": "polygon",
        "d": "M6.7 8.01L7.09 8.01L7.36 9.45L6.43 9.45Z",
        "fill": "truck"
      },
      {
        "type": "polygon",
        "d": "M10.73 7.47L10.16 7.35L9.59 7.47L9.11 7.79L8.78 8.28L8.67 8.82L8.67 9.62L8.78 10.16L9.11 10.64L9.59 10.97L10.16 11.08L10.73 10.97L11.22 10.64L11.54 10.16L11.65 9.62L11.65 8.82L11.54 8.28L11.22 7.79Z",
        "fill": "#004387"
      },
      {
        "type": "polygon",
        "d": "M10.94 9.91L10.75 10.18L10.48 10.36L10.16 10.42L9.84 10.36L9.57 10.18L9.39 9.91L9.32 9.55L9.32 8.88L9.39 8.53L9.57 8.26L9.84 8.08L10.16 8.01L10.48 8.08L10.75 8.26L10.94 8.53L11.01 8.88L11.01 9.55Z",
        "fill": "truck"
      },
      {
        "type": "polygon",
        "d": "M19.1 10.95L18.42 7.36L16.96 7.36L16.28 10.95L16.91 11.07L17.1 10.09L18.28 10.09L18.47 11.07Z",
        "fill": "#004387"
      },
      {
        "type": "polygon",
        "d": "M17.22 9.45L17.5 8.01L17.88 8.01L18.16 9.45Z",
        "fill": "truck"
      }
    ],
    "redbox-mv": [
      {
        "type": "polygon",
        "d": "M6.05 4.3L12.72 4.3L12.72 7.01L8.86 7.01L8.86 10.86L6.05 10.86Z",
        "fill": "accent"
      },
      {
        "type": "polygon",
        "d": "M10.95 9.2L15.95 9.2L15.95 14.3L10.95 14.3Z",
        "fill": "accent"
      }
    ],
    "royale-international": [
      {
        "type": "polygon",
        "d": "M4.26 12.37L3.1 10.37L3.52 7.83L4.68 9.24Z",
        "fill": "accent"
      },
      {
        "type": "polygon",
        "d": "M9.81 8.99L4.68 12.79L6.26 8.64L10.14 5.21Z",
        "fill": "accent"
      },
      {
        "type": "polygon",
        "d": "M11.17 12.57L5.86 12.99L8.7 11.19L12.78 10.82Z",
        "fill": "accent"
      },
      {
        "type": "polygon",
        "d": "M14.23 8.62L10.01 9.83L12.06 7.63L15.54 6.47Z",
        "fill": "accent"
      },
      {
        "type": "polygon",
        "d": "M17.49 9.8L13.37 10.03L15.57 8.62L18.9 8.3Z",
        "fill": "accent"
      }
    ],
    "shippify": [
      {
        "type": "polygon",
        "d": "M11.21 4.84L3.3 4.84L5.43 6.88L5.64 7.01L5.91 7.09L6.59 7.11L7.05 7.56L4.91 8.8L12.25 13.01L13.09 13.29L13.99 13.4L14.89 13.33L15.76 13.09L16.57 12.68L17.29 12.12L17.86 11.44L18.31 10.65L18.59 9.81L18.7 8.91L18.63 8.01L18.39 7.14L17.98 6.33L17.42 5.61L16.74 5.04L15.96 4.6L15 4.29L14 4.2L13.38 4.26L12.78 4.4L12.19 4.62L11.63 4.92Z",
        "fill": "#000000"
      },
      {
        "type": "polygon",
        "d": "M7.63 8.14L7.99 8.44L8.26 8.55L8.95 8.59L9.99 9.64L10.33 9.86L10.71 9.94L11.86 9.95L12.1 10.33L12.41 10.66L12.77 10.93L13.2 11.14L13.71 11.28L14.24 11.3L14.72 11.23L15.21 11.05L15.66 10.76L16.01 10.42L16.29 10.03L16.5 9.55L16.6 9.03L16.6 8.53L16.5 8.05L16.31 7.6L16.04 7.19L15.72 6.87L15.36 6.61L14.91 6.41L14.49 6.3L13.99 6.27L13.56 6.33L13.1 6.48L12.26 5.46L12.78 5.22L13.29 5.07L13.87 4.99L14.44 5L15.2 5.14L15.88 5.42L16.51 5.84L17.03 6.35L17.43 6.94L17.73 7.63L17.89 8.37L17.9 9.13L17.76 9.89L17.48 10.58L17.07 11.21L16.55 11.73L15.96 12.13L15.27 12.44L14.53 12.59L13.77 12.61L13.01 12.46L12.32 12.18L6.47 8.8Z",
        "fill": "truck"
      },
      {
        "type": "polygon",
        "d": "M11.26 5.62L11.48 5.75L12.72 7.25L12.84 7.34L13.08 7.36L13.42 7.19L13.74 7.09L14.31 7.07L14.91 7.26L15.39 7.64L15.59 7.9L15.73 8.21L15.81 8.54L15.83 8.89L15.77 9.23L15.66 9.55L15.48 9.84L15.25 10.08L14.81 10.37L14.35 10.51L13.84 10.51L13.37 10.37L13.07 10.2L12.82 9.97L12.62 9.71L12.41 9.31L12.29 9.21L12.14 9.17L10.65 9.15L10.51 9.06L9.9 8.44L11.24 8.42L11.39 8.3L11.44 8.17L11.42 7.99L11.28 7.85L11.13 7.81L8.5 7.81L8.3 7.71L7.54 6.95L9.1 6.94L9.26 6.83L9.32 6.64L9.29 6.5L9.15 6.36L9.01 6.33L6.05 6.32L5.86 6.23L5.23 5.62Z",
        "fill": "truck"
      },
      {
        "type": "polygon",
        "d": "M11.21 5.62L5.23 5.62L5.86 6.23L6.05 6.32L9.01 6.33L9.15 6.36L9.29 6.5L9.32 6.64L9.26 6.83L9.1 6.94L7.54 6.95L8.3 7.71L8.5 7.81L11.13 7.81L11.28 7.85L11.42 7.99L11.44 8.17L11.39 8.3L11.24 8.42L9.9 8.44L10.51 9.06L10.65 9.15L12.14 9.17L12.29 9.21L12.41 9.31L12.62 9.71L12.82 9.97L13.07 10.2L13.37 10.37L13.84 10.51L14.35 10.51L14.81 10.37L15.25 10.08L15.48 9.84L15.66 9.55L15.77 9.23L15.83 8.89L15.81 8.54L15.73 8.21L15.59 7.9L15.39 7.64L14.91 7.26L14.31 7.07L13.74 7.09L13.42 7.19L13.08 7.36L12.84 7.34L12.72 7.25L11.48 5.75L11.36 5.65Z",
        "fill": "#ffdf00"
      }
    ],
    "suto-logistics": [
      {
        "type": "polygon",
        "d": "M14.99 5.8L11.96 5.8L11.96 6.82L12.85 6.82L11.9 11.6L12.9 11.8L13.9 6.82L14.99 6.82Z",
        "fill": "accent"
      },
      {
        "type": "polygon",
        "d": "M7.73 6.53L7.23 7.73L7.79 8.87L9.56 9.47L9.74 9.81L9.54 10.28L8.9 10.68L8.2 10.68L7.67 10.23L7.01 11.02L7.83 11.7L9.2 11.7L10.36 10.98L10.86 9.77L10.28 8.63L8.52 8.04L8.35 7.7L8.55 7.22L9.16 6.82L9.82 6.82L10.32 7.26L10.99 6.49L10.2 5.8L8.86 5.8Z",
        "fill": "accent"
      }
    ],
    "swftbox": [
      {
        "type": "polygon",
        "d": "M10.12 7.49L10.61 7.49L10.61 9.88L11.11 9.88L11.11 7.49L11.6 7.49L11.6 6.98L10.12 6.98Z",
        "fill": "#1d1d1d"
      },
      {
        "type": "polygon",
        "d": "M3.26 8.5L4.19 8.79L4.34 8.99L4.29 9.2L4.05 9.38L3.7 9.38L3.38 9.15L3.09 9.56L3.54 9.88L4.21 9.88L4.74 9.5L4.87 8.88L4.5 8.36L3.58 8.07L3.44 7.87L3.48 7.65L3.71 7.49L4.04 7.49L4.34 7.71L4.64 7.31L4.2 6.98L3.55 6.98L3.03 7.36L2.9 7.97Z",
        "fill": "#1d1d1d"
      },
      {
        "type": "polygon",
        "d": "M9.46 8.68L9.46 8.18L8.65 8.18L8.65 7.49L9.64 7.49L9.64 6.98L8.15 6.98L8.15 9.88L8.65 9.88L8.65 8.68Z",
        "fill": "#1d1d1d"
      },
      {
        "type": "polygon",
        "d": "M7.18 7.18L6.87 8.63L6.39 7.1L5.92 8.63L5.61 7.18L5.12 7.29L5.84 10.62L6.39 8.81L6.95 10.62L7.67 7.29Z",
        "fill": "#1d1d1d"
      },
      {
        "type": "polygon",
        "d": "M13.85 7.87L13.85 7.72L13.81 7.5L13.71 7.29L13.54 7.12L13.32 7.02L13.11 6.98L12.08 6.98L12.08 9.88L13.27 9.88L13.5 9.84L13.73 9.72L13.92 9.54L14.03 9.31L14.07 9.08L14.07 8.91L14.03 8.67L13.92 8.44L13.73 8.26L13.81 8.09Z",
        "fill": "#1d1d1d"
      },
      {
        "type": "polygon",
        "d": "M12.59 8.61L13.23 8.61L13.35 8.63L13.43 8.67L13.5 8.74L13.55 8.83L13.57 8.95L13.57 9.04L13.55 9.15L13.5 9.24L13.43 9.31L13.35 9.36L13.23 9.38L12.59 9.38Z",
        "fill": "truck"
      },
      {
        "type": "polygon",
        "d": "M13.29 7.59L13.33 7.66L13.34 7.76L13.34 7.83L13.33 7.93L13.29 8L13.24 8.06L13.17 8.09L13.07 8.11L12.59 8.11L12.59 7.49L13.07 7.49L13.17 7.5L13.24 7.54Z",
        "fill": "truck"
      },
      {
        "type": "polygon",
        "d": "M15.63 6.98L15.21 7.06L14.85 7.3L14.62 7.65L14.54 8.05L14.54 8.81L14.62 9.21L14.85 9.56L15.21 9.8L15.63 9.88L16.05 9.8L16.4 9.56L16.64 9.21L16.72 8.81L16.72 8.05L16.64 7.65L16.4 7.3L16.05 7.06Z",
        "fill": "#1d1d1d"
      },
      {
        "type": "polygon",
        "d": "M16.17 9.01L16.04 9.2L15.85 9.33L15.63 9.37L15.41 9.33L15.22 9.2L15.09 9.01L15.04 8.76L15.04 8.1L15.09 7.85L15.22 7.66L15.41 7.53L15.63 7.49L15.85 7.53L16.04 7.66L16.17 7.85L16.21 8.1L16.21 8.76Z",
        "fill": "truck"
      },
      {
        "type": "polygon",
        "d": "M19.1 7.26L18.68 6.98L18.03 7.97L17.37 6.98L16.95 7.26L17.73 8.43L16.95 9.6L17.37 9.88L18.03 8.89L18.68 9.88L19.1 9.6L18.33 8.43Z",
        "fill": "#1d1d1d"
      }
    ],
    "tolos": [
      {
        "type": "polygon",
        "d": "M9.97 6.6L9.32 10.95L11.53 10.95L11.53 10.2L10.18 10.2L10.71 6.71Z",
        "fill": "accent"
      },
      {
        "type": "polygon",
        "d": "M6.79 6.77L6.2 7.13L5.76 7.67L5.54 8.28L5.41 9.21L5.44 9.84L5.74 10.43L6.27 10.82L6.92 10.96L7.6 10.83L8.19 10.47L8.63 9.93L8.84 9.32L8.98 8.39L8.95 7.76L8.65 7.17L8.12 6.78L7.46 6.64Z",
        "fill": "accent"
      },
      {
        "type": "polygon",
        "d": "M6.93 10.2L6.58 10.12L6.32 9.93L6.17 9.64L6.15 9.24L6.27 8.46L6.42 8.04L6.69 7.7L7.06 7.48L7.46 7.4L7.8 7.48L8.06 7.67L8.21 7.96L8.23 8.36L8.12 9.14L7.97 9.56L7.69 9.9L7.32 10.12Z",
        "fill": "truck"
      },
      {
        "type": "polygon",
        "d": "M14.16 6.64L13.49 6.77L12.9 7.13L12.46 7.67L12.25 8.28L12.11 9.21L12.14 9.84L12.44 10.43L12.97 10.82L13.63 10.96L14.3 10.83L14.89 10.47L15.33 9.93L15.54 9.32L15.68 8.39L15.65 7.76L15.35 7.17L14.82 6.78Z",
        "fill": "accent"
      },
      {
        "type": "polygon",
        "d": "M14.02 10.12L13.63 10.2L13.28 10.12L13.03 9.93L12.88 9.64L12.86 9.24L12.97 8.46L13.12 8.04L13.4 7.7L13.77 7.48L14.16 7.4L14.51 7.48L14.77 7.67L14.92 7.96L14.93 8.36L14.82 9.14L14.67 9.56L14.39 9.9Z",
        "fill": "truck"
      },
      {
        "type": "polygon",
        "d": "M18.13 9.33L18.28 9.59L18.16 9.92L17.72 10.2L17.21 10.2L16.8 9.88L16.33 10.46L16.95 10.95L17.94 10.95L18.77 10.41L19.1 9.52L18.64 8.71L17.34 8.28L17.19 8.01L17.32 7.67L17.73 7.4L18.22 7.4L18.6 7.72L19.08 7.15L18.49 6.65L17.51 6.65L16.7 7.19L16.38 8.07L16.82 8.89Z",
        "fill": "accent"
      },
      {
        "type": "polygon",
        "d": "M3.04 10.89L3.78 11L4.32 7.4L5.1 7.4L5.1 6.65L2.9 6.65L2.9 7.4L3.57 7.4Z",
        "fill": "accent"
      }
    ],
    "vatican-post": [
      {
        "type": "polygon",
        "d": "M10.88 4.21L10.63 4.21L10.63 4.45L10.88 4.45L10.88 4.86L10.67 4.91L10.34 5.2L10.21 5.42L11.79 5.42L11.66 5.2L11.33 4.91L11.12 4.86L11.12 4.45L11.37 4.45L11.37 4.21L11.12 4.21L11.12 4L10.88 4Z",
        "fill": "#000000"
      },
      {
        "type": "polygon",
        "d": "M11.86 5.55L10.14 5.55L10.01 5.78L9.91 6.08L12.09 6.08L11.99 5.78Z",
        "fill": "#000000"
      },
      {
        "type": "polygon",
        "d": "M9.87 6.21L9.8 6.44L9.79 6.66L12.21 6.66L12.2 6.44L12.13 6.21Z",
        "fill": "#000000"
      },
      {
        "type": "polygon",
        "d": "M12.22 6.79L9.78 6.79L9.76 7.18L12.24 7.18Z",
        "fill": "#000000"
      },
      {
        "type": "polygon",
        "d": "M14.27 6.68L14.33 6.62L13.94 6.25L11 9.32L8.06 6.25L7.67 6.62L7.73 6.68L7.32 7.07L7.67 7.42L7.9 7.2L8.13 7.43L7.89 7.66L8.24 8.02L8.64 7.63L10.63 9.71L10.09 10.27L9.95 10.29L9.82 10.34L9.7 10.42L9.59 10.52L9.49 10.64L9.42 10.76L9.37 10.9L9.35 11.03L8.79 11.63L8.63 11.56L8.45 11.51L8.27 11.49L8.09 11.51L7.92 11.56L7.76 11.63L7.61 11.73L7.48 11.86L7.37 12.01L7.28 12.19L7.23 12.39L7.22 12.57L7.25 12.78L7.3 12.95L7.4 13.13L7.53 13.29L7.69 13.42L7.85 13.51L8.04 13.57L8.25 13.6L8.43 13.59L8.63 13.54L8.82 13.45L8.98 13.33L9.1 13.19L9.2 13.04L9.27 12.88L9.32 12.7L9.33 12.52L9.31 12.34L9.26 12.17L9.17 12L9.74 11.41L9.88 11.38L10.01 11.33L10.13 11.25L10.24 11.15L10.34 11.03L10.41 10.91L10.46 10.78L10.48 10.64L11 10.09L11.52 10.64L11.54 10.78L11.59 10.91L11.66 11.03L11.76 11.15L11.87 11.25L11.99 11.33L12.12 11.38L12.26 11.41L12.83 12L12.74 12.17L12.69 12.34L12.67 12.52L12.68 12.7L12.73 12.88L12.8 13.04L12.9 13.19L13.02 13.33L13.18 13.45L13.37 13.54L13.57 13.59L13.75 13.6L13.96 13.57L14.15 13.51L14.31 13.42L14.47 13.29L14.59 13.15L14.69 12.97L14.75 12.78L14.78 12.57L14.76 12.37L14.72 12.19L14.64 12.03L14.52 11.86L14.39 11.73L14.24 11.63L14.08 11.56L13.91 11.51L13.73 11.49L13.55 11.51L13.37 11.56L13.21 11.63L12.65 11.03L12.63 10.9L12.58 10.76L12.51 10.64L12.41 10.52L12.3 10.42L12.18 10.34L12.05 10.29L11.91 10.27L11.37 9.71L13.36 7.63L13.76 8.02L14.11 7.66L13.87 7.43L14.1 7.2L14.33 7.42L14.68 7.07Z",
        "fill": "#000000"
      },
      {
        "type": "polygon",
        "d": "M8.78 12.65L8.7 12.83L8.56 12.98L8.38 13.05L8.17 13.05L7.99 12.98L7.85 12.83L7.77 12.65L7.77 12.45L7.85 12.26L7.99 12.12L8.17 12.04L8.38 12.04L8.56 12.12L8.7 12.26L8.78 12.45Z",
        "fill": "truck"
      },
      {
        "type": "polygon",
        "d": "M14.23 12.65L14.15 12.83L14.01 12.98L13.83 13.05L13.62 13.05L13.44 12.98L13.3 12.83L13.22 12.65L13.22 12.45L13.3 12.26L13.44 12.12L13.62 12.04L13.83 12.04L14.01 12.12L14.15 12.26L14.23 12.45Z",
        "fill": "truck"
      }
    ],
    "viaxpress": [
      {
        "type": "polygon",
        "d": "M10.57 6.15L9.62 5.8L7.79 10.73L7.2 10.73L7.15 5.97L6.13 5.98L6.19 11.75L8.5 11.75Z",
        "fill": "accent"
      },
      {
        "type": "polygon",
        "d": "M15.87 6.49L15.09 5.83L13.37 7.89L12.44 5.94L11.52 6.38L12.65 8.74L10.63 11.14L11.41 11.8L13.13 9.75L14.07 11.69L14.98 11.25L13.85 8.89Z",
        "fill": "accent"
      }
    ],
    "wepost": [
      {
        "type": "polygon",
        "d": "M9.8 14.2L8.58 10.95L6.22 10.02L15.78 4.6L14.63 12.98L11.51 11.96Z",
        "fill": "accent"
      },
      {
        "type": "polygon",
        "d": "M9.93 12.95L9.31 11.14L13.94 6.9L10.56 11.41Z",
        "fill": "#44cdf2"
      }
    ],
    "xpressen": [
      {
        "type": "polygon",
        "d": "M15.37 4.82L16.02 3.9L14.31 3.9L13.62 4.82Z",
        "fill": "#000000"
      },
      {
        "type": "polygon",
        "d": "M9.52 12.76L7.84 12.76L7.18 13.7L8.85 13.7Z",
        "fill": "#000000"
      },
      {
        "type": "polygon",
        "d": "M13.36 5.27L11.89 7.25L11.33 5.27L9.89 5.27L10.84 8.65L8.07 12.38L9.8 12.38L11.32 10.34L11.89 12.38L13.33 12.38L12.36 8.93L15.09 5.27Z",
        "fill": "accent"
      }
    ],
    "66post": [
      {
        "type": "polygon",
        "d": "M17.35 7.09L17.35 7.69L17.93 7.69L17.93 10.51L18.52 10.51L18.52 7.69L19.1 7.69L19.1 7.09Z",
        "fill": "accent"
      },
      {
        "type": "polygon",
        "d": "M10.31 9.08L10.65 8.86L10.87 8.52L10.95 8.12L10.87 7.73L10.65 7.39L10.31 7.17L9.94 7.09L8.72 7.09L8.72 10.51L9.31 10.51L9.31 9.15L9.94 9.15Z",
        "fill": "accent"
      },
      {
        "type": "polygon",
        "d": "M10.08 7.73L10.22 7.82L10.31 7.96L10.35 8.12L10.31 8.29L10.22 8.43L10.08 8.52L9.89 8.56L9.31 8.56L9.31 7.69L9.89 7.69Z",
        "fill": "truck"
      },
      {
        "type": "polygon",
        "d": "M13.8 7.49L13.36 7.19L12.83 7.09L12.3 7.19L11.86 7.49L11.56 7.94L11.46 8.43L11.46 9.17L11.56 9.66L11.86 10.11L12.3 10.41L12.83 10.51L13.36 10.41L13.8 10.11L14.1 9.66L14.2 9.17L14.2 8.43L14.1 7.94Z",
        "fill": "accent"
      },
      {
        "type": "polygon",
        "d": "M13.61 9.11L13.54 9.43L13.37 9.68L13.12 9.85L12.83 9.91L12.54 9.85L12.29 9.68L12.12 9.43L12.05 9.11L12.05 8.49L12.12 8.17L12.29 7.92L12.54 7.75L12.83 7.69L13.12 7.75L13.37 7.92L13.54 8.17L13.61 8.49Z",
        "fill": "truck"
      },
      {
        "type": "polygon",
        "d": "M14.74 8.26L15.16 8.88L16.26 9.22L16.43 9.46L16.38 9.71L16.09 9.91L15.68 9.91L15.3 9.64L14.96 10.13L15.49 10.51L16.28 10.51L16.91 10.06L17.06 9.33L16.62 8.72L15.54 8.38L15.37 8.14L15.42 7.89L15.69 7.69L16.08 7.69L16.44 7.95L16.79 7.48L16.27 7.09L15.5 7.09L14.89 7.54Z",
        "fill": "accent"
      },
      {
        "type": "polygon",
        "d": "M3.86 8.14L3.97 8L4.1 7.89L4.23 7.8L4.36 7.74L4.5 7.7L4.66 7.69L4.61 7.1L4.39 7.11L4.16 7.18L3.94 7.28L3.73 7.42L3.55 7.59L3.38 7.78L3.24 8.01L3.12 8.25L3.02 8.5L2.96 8.77L2.92 9.05L2.9 9.34L2.94 9.64L3.06 9.92L3.24 10.16L3.49 10.35L3.77 10.47L4.07 10.51L4.38 10.47L4.66 10.35L4.9 10.16L5.09 9.92L5.2 9.64L5.24 9.37L5.24 9.34L5.2 9.03L5.09 8.75L4.9 8.51L4.66 8.32L4.38 8.2L4.07 8.16L3.82 8.2Z",
        "fill": "#ffea60"
      },
      {
        "type": "polygon",
        "d": "M4.48 9.74L4.36 9.83L4.22 9.89L4.07 9.91L3.92 9.89L3.78 9.83L3.67 9.74L3.57 9.62L3.52 9.48L3.5 9.34L3.52 9.19L3.57 9.05L3.67 8.93L3.78 8.84L3.92 8.78L4.07 8.76L4.22 8.78L4.36 8.84L4.48 8.93L4.57 9.05L4.63 9.19L4.65 9.34L4.63 9.48L4.57 9.62Z",
        "fill": "truck"
      },
      {
        "type": "polygon",
        "d": "M6.77 8.14L6.88 8L7.01 7.89L7.14 7.8L7.27 7.74L7.41 7.7L7.57 7.69L7.51 7.1L7.3 7.11L7.07 7.18L6.85 7.28L6.64 7.42L6.45 7.59L6.29 7.78L6.15 8.01L6.03 8.25L5.93 8.5L5.87 8.77L5.82 9.05L5.81 9.34L5.85 9.64L5.97 9.92L6.15 10.16L6.39 10.35L6.68 10.47L6.98 10.51L7.28 10.47L7.57 10.35L7.81 10.16L8 9.92L8.11 9.64L8.15 9.34L8.11 9.03L8 8.75L7.81 8.51L7.57 8.32L7.28 8.2L6.98 8.16L6.73 8.2Z",
        "fill": "#ffea60"
      },
      {
        "type": "polygon",
        "d": "M7.39 9.74L7.27 9.83L7.13 9.89L6.98 9.91L6.83 9.89L6.69 9.83L6.57 9.74L6.48 9.62L6.43 9.48L6.41 9.34L6.43 9.19L6.48 9.05L6.57 8.93L6.69 8.84L6.83 8.78L6.98 8.76L7.13 8.78L7.27 8.84L7.39 8.93L7.48 9.05L7.54 9.19L7.56 9.34L7.54 9.48L7.48 9.62Z",
        "fill": "truck"
      }
    ],
    "ahl-courier": [
      {
        "type": "polygon",
        "d": "M17.66 10.69L15.88 10.69L16.82 6L15.83 5.8L14.65 11.7L17.66 11.7Z",
        "fill": "accent"
      },
      {
        "type": "polygon",
        "d": "M13.12 9.3L12.66 11.6L13.65 11.8L14.81 6L13.82 5.8L13.32 8.3L11.38 8.3L11.84 6L10.85 5.8L9.69 11.6L10.68 11.8L11.18 9.3Z",
        "fill": "accent"
      },
      {
        "type": "polygon",
        "d": "M8.79 5.9L6.5 5.9L4.34 11.42L5.28 11.79L5.91 10.17L7.74 10.17L7.72 11.6L8.73 11.61Z",
        "fill": "accent"
      },
      {
        "type": "polygon",
        "d": "M6.3 9.16L7.18 6.91L7.77 6.91L7.75 9.16Z",
        "fill": "truck"
      }
    ],
    "bluestreak-couriers": [
      {
        "type": "polygon",
        "d": "M8.71 8.16L10.5 8.16L10.5 7.56L9.44 7.56L10 4.78L9.41 4.66Z",
        "fill": "accent"
      },
      {
        "type": "polygon",
        "d": "M12.03 8.16L12.33 8.12L12.63 8.01L12.89 7.83L13.11 7.61L13.28 7.34L13.37 7.06L13.83 4.78L13.24 4.66L12.79 6.9L12.74 7.08L12.64 7.24L12.51 7.37L12.35 7.48L12.19 7.54L12.03 7.56L11.89 7.54L11.78 7.49L11.69 7.42L11.63 7.31L11.61 7.19L11.62 7.02L12.07 4.78L11.48 4.66L11.03 6.94L11.01 7.23L11.07 7.53L11.22 7.79L11.44 8L11.72 8.12Z",
        "fill": "accent"
      },
      {
        "type": "polygon",
        "d": "M8.38 5.4L8.3 5.13L8.12 4.9L7.87 4.76L7.61 4.72L6.75 4.72L6.46 4.66L5.77 8.1L6.36 8.22L6.37 8.16L7.23 8.16L7.51 8.12L7.79 7.99L8.03 7.79L8.21 7.53L8.31 7.26L8.35 7.07L8.36 6.79L8.27 6.49L8.1 6.28L8.24 6.08L8.33 5.84L8.37 5.66Z",
        "fill": "accent"
      },
      {
        "type": "polygon",
        "d": "M7.77 5.59L7.76 5.68L7.71 5.8L7.64 5.9L7.54 5.99L7.43 6.04L7.3 6.06L6.79 6.06L6.94 5.32L7.57 5.32L7.67 5.34L7.72 5.37L7.76 5.41L7.78 5.48Z",
        "fill": "truck"
      },
      {
        "type": "polygon",
        "d": "M7.69 6.72L7.73 6.78L7.76 6.86L7.76 7L7.73 7.1L7.68 7.25L7.59 7.38L7.47 7.48L7.34 7.54L7.19 7.56L6.49 7.56L6.67 6.65L7.49 6.65L7.61 6.68Z",
        "fill": "truck"
      },
      {
        "type": "polygon",
        "d": "M15.71 6.14L14.74 6.14L14.91 5.32L16.23 5.32L16.23 4.72L14.42 4.72L13.73 8.16L15.66 8.16L15.66 7.56L14.46 7.56L14.62 6.74L15.71 6.74Z",
        "fill": "accent"
      },
      {
        "type": "polygon",
        "d": "M4.37 12.05L4 12.28L3.59 12.28L3.28 12.02L2.9 12.48L3.38 12.88L4.17 12.88L4.85 12.46L5.14 11.75L4.81 11.09L3.78 10.74L3.68 10.54L3.8 10.26L4.15 10.04L4.54 10.04L4.83 10.29L5.22 9.84L4.76 9.44L3.97 9.44L3.32 9.86L3.03 10.56L3.35 11.23L4.39 11.58L4.49 11.78Z",
        "fill": "accent"
      },
      {
        "type": "polygon",
        "d": "M12.49 10.86L11.53 10.86L11.69 10.04L13.01 10.04L13.01 9.44L11.2 9.44L10.51 12.88L12.44 12.88L12.44 12.28L11.24 12.28L11.41 11.46L12.49 11.46Z",
        "fill": "accent"
      },
      {
        "type": "polygon",
        "d": "M16.18 12.82L16.76 12.94L17.03 11.6L17.41 11.29L18.02 12.83L18.57 12.62L17.89 10.89L19.1 9.88L18.72 9.42L17.22 10.67L17.45 9.5L16.87 9.38Z",
        "fill": "accent"
      },
      {
        "type": "polygon",
        "d": "M13.57 12.93L13.94 11.97L15.02 11.97L15.01 12.82L15.61 12.82L15.64 9.44L14.29 9.44L13.01 12.71Z",
        "fill": "accent"
      },
      {
        "type": "polygon",
        "d": "M15.03 11.37L14.17 11.37L14.69 10.04L15.04 10.04Z",
        "fill": "truck"
      },
      {
        "type": "polygon",
        "d": "M6.91 10.04L7.55 10.04L7.55 9.44L5.79 9.44L5.79 10.04L6.3 10.04L5.75 12.82L6.33 12.94Z",
        "fill": "accent"
      },
      {
        "type": "polygon",
        "d": "M10.25 10.92L10.4 10.53L10.4 10.13L10.23 9.76L9.91 9.52L9.54 9.44L8.25 9.44L7.57 12.82L8.16 12.94L8.44 11.51L8.65 11.51L9.5 12.85L10 12.52L9.35 11.49L9.62 11.44L9.98 11.23Z",
        "fill": "accent"
      },
      {
        "type": "polygon",
        "d": "M9.73 10.6L9.59 10.77L9.41 10.88L9.19 10.92L8.56 10.92L8.74 10.04L9.48 10.04L9.66 10.07L9.75 10.15L9.81 10.26L9.81 10.42Z",
        "fill": "truck"
      }
    ],
    "branding-worldwide": [
      {
        "type": "polygon",
        "d": "M4.86 6.95L4.86 6.35L2.9 6.35L2.9 6.95Z",
        "fill": "accent"
      },
      {
        "type": "polygon",
        "d": "M4.86 8.02L4.86 7.43L2.9 7.43L2.9 8.02Z",
        "fill": "accent"
      },
      {
        "type": "polygon",
        "d": "M4.86 9.1L4.86 8.5L2.9 8.5L2.9 9.1Z",
        "fill": "accent"
      },
      {
        "type": "polygon",
        "d": "M8.36 7.24L8.18 6.88L7.9 6.59L7.54 6.41L7.18 6.35L5.44 6.35L5.44 11.25L7.44 11.25L7.84 11.18L8.23 10.98L8.54 10.68L8.74 10.29L8.8 9.89L8.8 9.61L8.74 9.21L8.54 8.82L8.22 8.51L8.36 8.22L8.42 7.86L8.42 7.6Z",
        "fill": "accent"
      },
      {
        "type": "polygon",
        "d": "M7.57 9.13L7.72 9.21L7.84 9.33L7.92 9.48L7.95 9.68L7.95 9.82L7.92 10.02L7.84 10.17L7.72 10.29L7.57 10.37L7.38 10.4L6.29 10.4L6.29 9.1L7.38 9.1Z",
        "fill": "truck"
      },
      {
        "type": "polygon",
        "d": "M7.57 7.67L7.57 7.79L7.55 7.96L7.49 8.07L7.39 8.17L7.27 8.23L7.11 8.25L6.29 8.25L6.29 7.2L7.11 7.2L7.27 7.23L7.39 7.29L7.49 7.38L7.55 7.5Z",
        "fill": "truck"
      },
      {
        "type": "polygon",
        "d": "M13.7 6.49L12.86 6.35L12.32 9.64L11.97 7.37L10.84 7.37L10.49 9.64L9.94 6.35L9.11 6.49L9.89 11.25L11.1 11.25L11.4 9.27L11.71 11.25L12.91 11.25Z",
        "fill": "accent"
      },
      {
        "type": "polygon",
        "d": "M18.26 6.35L17.72 9.64L17.37 7.37L16.24 7.37L15.89 9.64L15.34 6.35L14.51 6.49L15.29 11.25L16.5 11.25L16.8 9.27L17.11 11.25L18.32 11.25L19.1 6.49Z",
        "fill": "accent"
      },
      {
        "type": "polygon",
        "d": "M4.86 10.17L4.86 9.58L2.9 9.58L2.9 10.17Z",
        "fill": "accent"
      },
      {
        "type": "polygon",
        "d": "M4.86 11.25L4.86 10.65L2.9 10.65L2.9 11.25Z",
        "fill": "accent"
      }
    ],
    "czl-express": [
      {
        "type": "polygon",
        "d": "M17.49 10.77L15.66 10.77L16.52 5.98L15.51 5.8L14.44 11.79L17.49 11.79Z",
        "fill": "accent"
      },
      {
        "type": "polygon",
        "d": "M5.95 6.25L5.44 6.67L5.07 7.21L4.87 7.79L4.52 9.72L4.51 10.32L4.71 10.92L5.11 11.4L5.67 11.7L6.3 11.8L6.93 11.69L7.52 11.41L7.97 11.02L7.29 10.25L6.95 10.55L6.62 10.71L6.29 10.76L6 10.72L5.78 10.6L5.62 10.41L5.54 10.16L5.55 9.82L5.87 8.04L5.99 7.68L6.21 7.37L6.5 7.12L6.83 6.97L7.16 6.92L7.45 6.97L7.67 7.1L7.87 7.36L8.68 6.73L8.35 6.31L7.8 5.99L7.18 5.88L6.54 5.98Z",
        "fill": "accent"
      },
      {
        "type": "polygon",
        "d": "M10.7 10.77L14.51 5.89L10.53 5.89L10.53 6.92L12.41 6.92L8.6 11.79L12.58 11.79L12.58 10.77Z",
        "fill": "accent"
      }
    ],
    "dida-international": [
      {
        "type": "polygon",
        "d": "M8.35 13L9.02 12.69L9.48 12.38L9.78 12.13L10.26 11.61L10.63 11.08L10.87 10.62L11.1 9.97L11.11 9.8L11.03 9.73L10.53 9.67L8.41 9.52L8.31 9.6L7.66 10.62L7.56 10.69L7.51 10.66L7.15 10.37L7.32 9.32L7.07 9.09L6.98 8.88L6.99 8.7L7.07 8.55L7.32 8.32L7.16 7.29L7.49 7L7.64 7L8.23 7.94L8.43 8.12L11.05 7.93L11.11 7.86L11.11 7.75L11.02 7.4L10.78 6.85L10.48 6.31L10.01 5.74L9.55 5.32L8.85 4.86L8.43 4.68L3.2 4.68L3.24 4.8L3.44 5.01L3.9 5.7L4.29 6.48L4.6 7.48L4.75 8.67L4.67 9.74L4.52 10.48L4.36 10.98L3.82 12.07L3.5 12.55L3.23 12.86L3.22 12.97Z",
        "fill": "accent"
      },
      {
        "type": "polygon",
        "d": "M14.71 12.99L15.36 12.93L15.76 12.84L16.2 12.69L16.81 12.38L17.67 11.69L18.29 10.84L18.45 10.5L18.68 9.83L18.76 9.41L18.8 8.84L18.76 8.23L18.68 7.8L18.36 6.95L17.9 6.23L17.21 5.54L16.49 5.09L15.66 4.78L15.07 4.67L14.82 4.67L14.67 4.6L10.18 4.61L10.24 4.74L10.9 5.21L13.15 5.24L13.17 5.37L13.06 5.44L11.32 5.44L11.17 5.49L11.42 5.79L11.53 5.84L13.67 5.84L13.79 5.91L13.77 6.02L13.67 6.05L11.68 6.08L11.68 6.18L11.83 6.41L11.91 6.45L14.05 6.46L14.23 6.54L14.21 6.63L14.11 6.66L12.06 6.68L12.02 6.71L12.02 6.79L12.2 7.07L14.4 7.1L14.52 7.13L14.54 7.23L14.4 7.28L12.33 7.3L12.27 7.42L12.37 7.8L12.48 7.84L13.75 7.83L14.51 7.98L15.09 8.23L15.38 8.46L15.62 8.82L15.53 9.02L15.24 9.32L14.59 9.64L13.9 9.79L12.48 9.81L12.37 9.85L12.27 10.22L12.33 10.33L14.36 10.34L14.48 10.36L14.53 10.43L14.51 10.5L14.4 10.55L12.18 10.57L12.03 10.83L12.02 10.91L12.07 10.94L14.07 10.96L14.19 10.99L14.23 11.1L14.17 11.16L14.05 11.18L11.89 11.19L11.69 11.44L11.7 11.56L13.63 11.58L13.77 11.64L13.79 11.73L13.65 11.8L11.51 11.8L11.37 11.89L11.15 12.15L11.18 12.21L11.26 12.23L13.06 12.23L13.17 12.28L13.15 12.39L10.9 12.43L10.23 12.9L10.2 12.97Z",
        "fill": "#eaa035"
      }
    ],
    "eli-express": [
      {
        "type": "polygon",
        "d": "M11.36 10.71L12.08 5.95L11.07 5.8L10.19 11.72L13.19 11.72L13.19 10.71Z",
        "fill": "accent"
      },
      {
        "type": "polygon",
        "d": "M7.14 10.71L7.35 9.31L9.17 9.31L9.17 8.29L7.5 8.29L7.71 6.89L9.93 6.89L9.93 5.88L6.84 5.88L5.96 11.72L9.21 11.72L9.21 10.71Z",
        "fill": "accent"
      },
      {
        "type": "polygon",
        "d": "M14.16 11.65L15.16 11.8L16.04 5.95L15.04 5.8Z",
        "fill": "accent"
      }
    ],
    "explus-logistics": [
      {
        "type": "polygon",
        "d": "M4.81 9.95L3.51 9.95L3.51 9.1L4.57 9.1L4.57 8.49L3.51 8.49L3.51 7.65L4.81 7.65L4.81 7.04L2.9 7.04L2.9 10.56L4.81 10.56Z",
        "fill": "accent"
      },
      {
        "type": "polygon",
        "d": "M8 7.37L7.49 7.04L6.69 8.24L5.9 7.04L5.39 7.37L6.33 8.8L5.39 10.22L5.9 10.56L6.69 9.35L7.49 10.56L8 10.22L7.06 8.8Z",
        "fill": "accent"
      },
      {
        "type": "polygon",
        "d": "M10.57 8.86L10.81 8.51L10.89 8.1L10.81 7.69L10.57 7.34L10.23 7.11L9.85 7.04L8.58 7.04L8.58 10.56L9.19 10.56L9.19 9.16L9.85 9.16L10.23 9.09Z",
        "fill": "accent"
      },
      {
        "type": "polygon",
        "d": "M10.13 7.79L10.23 7.93L10.26 8.1L10.23 8.27L10.13 8.41L9.99 8.51L9.79 8.55L9.19 8.55L9.19 7.65L9.79 7.65L9.99 7.69Z",
        "fill": "truck"
      },
      {
        "type": "polygon",
        "d": "M12.08 9.95L12.08 7.04L11.47 7.04L11.47 10.56L13.23 10.56L13.23 9.95Z",
        "fill": "accent"
      },
      {
        "type": "polygon",
        "d": "M16.7 8.24L17.14 8.88L18.27 9.24L18.45 9.49L18.39 9.74L18.1 9.95L17.67 9.95L17.28 9.67L16.93 10.17L17.48 10.56L18.29 10.56L18.94 10.1L19.1 9.35L18.65 8.71L17.52 8.36L17.35 8.11L17.41 7.85L17.69 7.65L18.08 7.65L18.45 7.92L18.82 7.43L18.29 7.04L17.49 7.04L16.86 7.5Z",
        "fill": "accent"
      },
      {
        "type": "polygon",
        "d": "M14.06 10.21L14.31 10.4L14.6 10.52L14.91 10.56L15.22 10.52L15.52 10.4L15.77 10.21L15.96 9.96L16.08 9.66L16.12 9.37L16.12 7.04L15.51 7.04L15.51 9.33L15.48 9.51L15.43 9.65L15.33 9.77L15.21 9.87L15.06 9.93L14.91 9.95L14.76 9.93L14.61 9.87L14.49 9.77L14.4 9.65L14.34 9.51L14.31 9.33L14.31 7.04L13.7 7.04L13.7 9.37L13.74 9.66L13.86 9.96Z",
        "fill": "accent"
      }
    ],
    "flickpost": [
      {
        "type": "polygon",
        "d": "M14.33 14.2L14.49 14.13L14.6 14.01L14.7 13.83L14.76 13.58L14.77 13.28L14.66 12.44L14.68 12.2L14.73 11.96L14.87 11.76L14.99 11.71L15.47 11.62L15.71 11.42L15.84 11.18L15.91 10.94L15.91 10.7L15.86 10.46L15.79 10.28L15.63 10.04L15.47 9.89L15.17 9.7L15.01 9.25L14.81 8.95L14.37 8.53L13.91 8.21L13.36 7.91L11.69 7.21L11.69 7.15L11.74 7.13L12.88 6.92L13.55 6.69L13.92 6.43L14.04 6.25L14.07 6.07L14.03 5.88L13.91 5.7L13.73 5.56L13.48 5.45L12.88 5.32L12.1 5.33L12.07 5.28L12.43 4.8L12.59 4.5L12.65 4.2L12.61 3.96L12.46 3.76L12.22 3.64L11.92 3.6L11.56 3.64L11.2 3.76L10.91 3.9L10.3 4.32L9.8 4.86L9.39 5.53L7.89 6.09L7.47 6.34L7.17 6.63L7.02 6.91L6.94 7.21L6.95 7.51L7.03 7.81L7.17 8.05L7.35 8.27L7.59 8.49L7.98 8.77L7.95 8.84L7.29 9.25L7.05 9.43L6.91 9.61L6.89 9.79L6.95 9.92L7.05 10L7.29 10.09L8.67 10.2L9.7 10.45L10.48 10.74L11.08 11.04L11.68 11.46L12.1 11.83L12.77 12.56L13.86 13.95L14.09 14.14Z",
        "fill": "accent"
      }
    ],
    "go-rush": [
      {
        "type": "polygon",
        "d": "M7.38 7.37L6.91 7.27L6.44 7.37L6.04 7.63L5.78 8.03L5.69 8.47L5.69 9.13L5.78 9.57L6.04 9.97L6.44 10.23L6.91 10.33L7.38 10.23L7.77 9.97L8.04 9.57L8.13 9.13L8.13 8.47L8.04 8.03L7.77 7.63Z",
        "fill": "accent"
      },
      {
        "type": "polygon",
        "d": "M7.6 9.08L7.54 9.36L7.39 9.59L7.17 9.74L6.91 9.79L6.65 9.74L6.42 9.59L6.27 9.36L6.22 9.08L6.22 8.52L6.27 8.24L6.42 8.01L6.65 7.86L6.91 7.81L7.17 7.86L7.39 8.01L7.54 8.24L7.6 8.52Z",
        "fill": "truck"
      },
      {
        "type": "polygon",
        "d": "M11.08 8.85L11.28 8.55L11.35 8.2L11.28 7.84L11.08 7.54L10.78 7.34L10.45 7.28L9.26 7.28L9.26 10.32L9.79 10.32L9.79 9.11L9.94 9.11L10.96 10.32L11.36 9.98L10.61 9.08L10.78 9.05Z",
        "fill": "accent"
      },
      {
        "type": "polygon",
        "d": "M10.7 7.93L10.78 8.05L10.81 8.2L10.78 8.34L10.7 8.47L10.57 8.55L10.4 8.59L9.79 8.59L9.79 7.81L10.4 7.81L10.57 7.84Z",
        "fill": "truck"
      },
      {
        "type": "polygon",
        "d": "M14.44 8.32L14.82 8.87L15.79 9.18L15.95 9.39L15.9 9.61L15.65 9.79L15.28 9.79L14.94 9.55L14.64 9.98L15.11 10.32L15.81 10.32L16.37 9.92L16.51 9.28L16.12 8.73L15.15 8.42L15 8.21L15.05 7.98L15.29 7.81L15.63 7.81L15.95 8.04L16.27 7.62L15.81 7.28L15.12 7.28L14.58 7.68Z",
        "fill": "accent"
      },
      {
        "type": "polygon",
        "d": "M17.01 7.28L17.01 10.32L17.54 10.32L17.54 9.06L18.57 9.06L18.57 10.32L19.1 10.32L19.1 7.28L18.57 7.28L18.57 8.54L17.54 8.54L17.54 7.28Z",
        "fill": "accent"
      },
      {
        "type": "polygon",
        "d": "M4.28 9.74L4.04 9.79L3.81 9.74L3.61 9.61L3.48 9.41L3.43 9.15L3.43 8.44L3.46 8.23L3.55 8.06L3.69 7.93L3.86 7.84L4.05 7.81L4.24 7.84L4.41 7.93L4.57 8.1L4.95 7.74L4.73 7.51L4.41 7.34L4.06 7.28L3.7 7.33L3.38 7.49L3.12 7.74L2.95 8.07L2.9 8.4L2.9 9.2L2.98 9.62L3.23 9.99L3.6 10.24L4.04 10.33L4.48 10.24L4.86 9.99L5.1 9.62L5.19 9.2L5.19 8.66L4.04 8.66L4.04 9.19L4.65 9.19L4.61 9.41L4.48 9.61Z",
        "fill": "accent"
      },
      {
        "type": "polygon",
        "d": "M12.37 10.18L12.62 10.29L12.89 10.32L13.16 10.29L13.42 10.18L13.63 10.02L13.8 9.8L13.9 9.55L13.94 9.29L13.94 7.28L13.41 7.28L13.41 9.26L13.39 9.41L13.34 9.53L13.26 9.64L13.15 9.72L13.03 9.77L12.89 9.79L12.76 9.77L12.64 9.72L12.53 9.64L12.45 9.53L12.4 9.41L12.38 9.26L12.38 7.28L11.85 7.28L11.85 9.29L11.88 9.55L11.99 9.8L12.16 10.02Z",
        "fill": "accent"
      }
    ],
    "jiehang": [
      {
        "type": "polygon",
        "d": "M8.47 10.46L8.28 10.59L8.07 10.67L7.88 10.69L7.72 10.67L7.59 10.61L7.5 10.53L7.44 10.42L7.41 10.27L7.42 10.03L6.42 9.96L6.39 10.35L6.48 10.78L6.7 11.17L7.03 11.46L7.44 11.65L7.88 11.71L8.32 11.65L8.74 11.49L9.12 11.24L9.44 10.91L9.67 10.52L9.8 10.13L10.63 6L9.64 5.8L8.83 9.87L8.75 10.1L8.64 10.29Z",
        "fill": "accent"
      },
      {
        "type": "polygon",
        "d": "M13.92 9.3L13.46 11.6L14.45 11.8L15.61 6L14.62 5.8L14.12 8.3L12.18 8.3L12.64 6L11.65 5.8L10.49 11.6L11.48 11.8L11.97 9.3Z",
        "fill": "accent"
      }
    ],
    "junfeng-international": [
      {
        "type": "polygon",
        "d": "M6.91 9.82L6.57 10.23L6.57 10.3L6.61 10.34L6.74 10.37L7.35 10.38L7.88 10.31L7.88 11.9L7.92 12.18L8.01 12.4L8.17 12.64L8.38 12.85L8.68 13.01L8.93 13.07L8.95 13.1L9.15 13.1L14.36 13.1L14.38 13.07L14.61 13.01L14.93 12.84L15.18 12.6L15.35 12.3L15.43 11.96L15.43 7.63L15.39 7.34L15.26 7.05L15.02 6.75L14.78 6.58L14.46 6.46L14.23 6.44L11.9 6.44L12.08 6.12L12.28 5.58L12.35 5.2L12.32 4.77L12.2 4.48L11.99 4.27L11.84 4.19L11.57 4.1L11.34 4.1L11.14 4.19L10.99 4.32L10.87 4.5L10.82 4.68L10.82 4.93L10.87 5.13L11.18 5.87L10.99 5.63L10.71 5.39L10.47 5.3L10.23 5.31L10.05 5.39L9.84 5.56L9.75 5.73L9.72 5.84L9.73 5.94L9.81 6.08L9.94 6.19L10.16 6.31L10.53 6.44L8.91 6.45L8.61 6.54L8.29 6.75L8.05 7.05L7.91 7.38L7.88 7.61L7.87 9.08L7.47 9.34L7.22 9.54Z",
        "fill": "#4f3b2b"
      },
      {
        "type": "polygon",
        "d": "M13.14 12.62L13.14 6.91L14.2 6.9L14.38 6.93L14.57 7.01L14.76 7.16L14.88 7.33L14.96 7.6L14.95 11.99L14.88 12.19L14.73 12.39L14.6 12.5L14.43 12.58L14.19 12.62Z",
        "fill": "truck"
      },
      {
        "type": "polygon",
        "d": "M10.79 12.62L10.79 6.91L12 6.91L12.01 12.62Z",
        "fill": "truck"
      },
      {
        "type": "polygon",
        "d": "M8.36 7.53L8.43 7.34L8.55 7.16L8.68 7.04L8.82 6.97L9.07 6.9L9.65 6.91L9.65 12.62L9.1 12.62L8.79 12.54L8.66 12.46L8.51 12.31L8.43 12.18L8.36 11.99Z",
        "fill": "truck"
      },
      {
        "type": "polygon",
        "d": "M13.81 7.69L13.74 7.85L13.73 8.06L13.79 8.21L13.91 8.33L14.04 8.39L14.27 8.4L14.42 8.34L14.54 8.23L14.6 8.11L14.62 7.92L14.58 7.77L14.47 7.62L14.31 7.53L14.1 7.52L13.93 7.58Z",
        "fill": "#4f3b2b"
      }
    ],
    "ljx-express": [
      {
        "type": "polygon",
        "d": "M5.52 10.74L6.37 5.98L5.37 5.8L4.3 11.75L7.33 11.75L7.33 10.74Z",
        "fill": "accent"
      },
      {
        "type": "polygon",
        "d": "M10.16 10.63L9.96 10.71L9.77 10.73L9.6 10.71L9.47 10.65L9.37 10.56L9.3 10.45L9.27 10.3L9.28 10.06L8.26 10.01L8.25 10.39L8.35 10.83L8.58 11.22L8.91 11.51L9.32 11.7L9.76 11.76L10.21 11.7L10.64 11.54L11.02 11.28L11.33 10.95L11.57 10.55L11.69 10.15L12.44 5.98L11.44 5.8L10.7 9.91L10.63 10.14L10.52 10.33L10.36 10.5Z",
        "fill": "accent"
      },
      {
        "type": "polygon",
        "d": "M16.92 5.84L15.2 7.89L14.27 5.95L13.35 6.39L14.48 8.75L12.47 11.15L13.25 11.8L14.97 9.75L15.9 11.69L16.82 11.25L15.68 8.9L17.7 6.5Z",
        "fill": "accent"
      }
    ],
    "maxzeego": [
      {
        "type": "polygon",
        "d": "M4.36 6.97L2.9 4.54L2.9 8.44L3.45 8.44L3.45 6.53L4.36 8.04L5.27 6.53L5.27 8.44L5.82 8.44L5.82 4.54Z",
        "fill": "accent"
      },
      {
        "type": "polygon",
        "d": "M6.35 8.34L6.89 8.44L7.05 7.6L8.06 7.6L8.22 8.44L8.76 8.34L8.18 5.26L6.93 5.26Z",
        "fill": "accent"
      },
      {
        "type": "polygon",
        "d": "M7.15 7.05L7.39 5.81L7.72 5.81L7.95 7.05Z",
        "fill": "truck"
      },
      {
        "type": "polygon",
        "d": "M9.72 5.26L9.26 5.56L10.11 6.85L9.26 8.13L9.72 8.44L10.44 7.35L11.16 8.44L11.62 8.13L10.77 6.85L11.62 5.56L11.16 5.26L10.44 6.35Z",
        "fill": "accent"
      },
      {
        "type": "polygon",
        "d": "M12.54 5.81L13.63 5.81L12.05 8.44L14.12 8.44L14.12 7.89L13.03 7.89L14.6 5.26L12.54 5.26Z",
        "fill": "accent"
      },
      {
        "type": "polygon",
        "d": "M16.63 7.12L16.63 6.57L15.68 6.57L15.68 5.81L16.85 5.81L16.85 5.26L15.13 5.26L15.13 8.44L16.85 8.44L16.85 7.89L15.68 7.89L15.68 7.12Z",
        "fill": "accent"
      },
      {
        "type": "polygon",
        "d": "M18.88 7.12L18.88 6.57L17.93 6.57L17.93 5.81L19.1 5.81L19.1 5.26L17.38 5.26L17.38 8.44L19.1 8.44L19.1 7.89L17.93 7.89L17.93 7.12Z",
        "fill": "accent"
      },
      {
        "type": "polygon",
        "d": "M6.83 11.74L6.83 11.19L2.9 11.19L2.9 11.74Z",
        "fill": "accent"
      },
      {
        "type": "polygon",
        "d": "M19.1 11.74L19.1 11.19L15.17 11.19L15.17 11.74Z",
        "fill": "accent"
      },
      {
        "type": "polygon",
        "d": "M13.64 10.66L13.37 10.25L12.95 9.97L12.46 9.87L11.97 9.97L11.55 10.25L11.28 10.66L11.18 11.12L11.18 11.81L11.28 12.27L11.55 12.69L11.97 12.97L12.46 13.06L12.95 12.97L13.37 12.69L13.64 12.27L13.74 11.81L13.74 11.12Z",
        "fill": "#ffb500"
      },
      {
        "type": "polygon",
        "d": "M13.12 10.88L13.18 11.18L13.18 11.76L13.12 12.06L12.97 12.29L12.73 12.45L12.46 12.5L12.18 12.45L11.95 12.29L11.8 12.06L11.74 11.76L11.74 11.18L11.8 10.88L11.95 10.64L12.18 10.49L12.46 10.43L12.73 10.49L12.97 10.64Z",
        "fill": "truck"
      },
      {
        "type": "polygon",
        "d": "M10.05 12.11L9.91 12.31L9.71 12.45L9.46 12.5L9.22 12.45L9.01 12.31L8.87 12.11L8.82 11.83L8.82 11.09L8.85 10.87L8.94 10.69L9.09 10.55L9.27 10.46L9.47 10.43L9.67 10.47L9.85 10.56L10.02 10.74L10.41 10.35L10.18 10.11L9.85 9.94L9.47 9.87L9.1 9.93L8.76 10.1L8.49 10.36L8.32 10.7L8.26 11.05L8.26 11.89L8.35 12.32L8.61 12.71L9 12.97L9.46 13.06L9.92 12.97L10.31 12.71L10.57 12.32L10.66 11.89L10.66 11.32L9.46 11.32L9.46 11.88L10.1 11.88Z",
        "fill": "#ffb500"
      }
    ],
    "ondot-courier": [
      {
        "type": "polygon",
        "d": "M17 6.75L17 7.46L17.69 7.46L17.69 10.85L18.41 10.85L18.41 7.46L19.1 7.46L19.1 6.75Z",
        "fill": "accent"
      },
      {
        "type": "polygon",
        "d": "M5.17 6.87L4.54 6.74L3.91 6.87L3.38 7.23L3.02 7.76L2.9 8.36L2.9 9.24L3.02 9.84L3.38 10.37L3.91 10.73L4.54 10.86L5.17 10.73L5.71 10.37L6.07 9.84L6.19 9.24L6.19 8.36L6.07 7.76L5.71 7.23Z",
        "fill": "accent"
      },
      {
        "type": "polygon",
        "d": "M5.4 9.56L5.2 9.86L4.9 10.06L4.54 10.13L4.19 10.06L3.89 9.86L3.69 9.56L3.61 9.17L3.61 8.43L3.69 8.04L3.89 7.74L4.19 7.54L4.54 7.47L4.9 7.54L5.2 7.74L5.4 8.04L5.47 8.43L5.47 9.17Z",
        "fill": "truck"
      },
      {
        "type": "polygon",
        "d": "M9.81 10.85L9.81 6.75L9.1 6.75L9.1 10.14L8.83 10.14L8.49 6.75L6.86 6.75L6.86 10.85L7.57 10.85L7.57 7.46L7.84 7.46L8.18 10.85Z",
        "fill": "accent"
      },
      {
        "type": "polygon",
        "d": "M11.41 10.85L11.92 10.78L12.41 10.58L12.84 10.25L13.16 9.83L13.37 9.33L13.44 8.8L13.37 8.27L13.16 7.77L12.84 7.35L12.41 7.02L11.92 6.82L11.41 6.75L10.49 6.75L10.49 10.85Z",
        "fill": "accent"
      },
      {
        "type": "polygon",
        "d": "M11.73 7.51L12.05 7.64L12.33 7.86L12.54 8.13L12.67 8.45L12.72 8.8L12.67 9.15L12.54 9.47L12.33 9.74L12.05 9.96L11.73 10.09L11.36 10.14L11.2 10.14L11.2 7.46L11.36 7.46Z",
        "fill": "truck"
      },
      {
        "type": "polygon",
        "d": "M16.81 8.6L16.74 8.34L16.64 8.12L16.51 7.93L16.32 7.74L16.12 7.61L15.93 7.53L15.74 7.47L15.47 7.45L15.23 7.47L15.01 7.53L14.77 7.64L14.58 7.78L14.43 7.93L14.31 8.1L14.2 8.34L14.14 8.56L14.12 8.8L14.14 9.04L14.2 9.26L14.31 9.5L14.43 9.67L14.58 9.82L14.77 9.96L15.01 10.07L15.23 10.13L15.47 10.15L15.71 10.13L15.93 10.07L16.15 9.97L16.34 9.84L16.53 9.65L16.64 9.48L16.75 9.23L16.8 9.04L16.82 8.83Z",
        "fill": "accent"
      }
    ],
    "penguin-box": [
      {
        "type": "polygon",
        "d": "M9.33 6.67L9.34 6.47L9.39 6.24L9.45 6.05L9.55 5.84L9.66 5.68L9.8 5.5L9.98 5.35L10.13 5.24L10.45 5.09L10.8 5.01L11 5L12.04 5L10.65 6.39L10.57 6.54L10.55 6.69L10.59 6.85L10.65 6.95L11.54 7.85L11.64 7.91L11.77 7.94L11.93 7.93L12.04 7.89L12.14 7.81L12.23 7.67L12.27 7.51L12.25 7.36L12.2 7.26L12.14 7.18L11.64 6.67L13.47 4.83L13.53 4.73L13.57 4.59L13.57 4.48L13.52 4.33L13.46 4.25L13.37 4.17L13.23 4.11L13.12 4.1L10.86 4.1L10.47 4.15L10.1 4.26L9.79 4.4L9.5 4.58L9.24 4.8L9.01 5.04L8.82 5.32L8.66 5.61L8.54 5.93L8.47 6.23L8.43 6.67L8.43 13.05L8.44 13.15L8.48 13.26L8.54 13.35L8.66 13.44L8.76 13.48L8.88 13.5L11.11 13.49L11.49 13.44L11.9 13.32L12.17 13.19L12.39 13.06L12.63 12.88L12.82 12.71L13.02 12.48L13.17 12.27L13.31 12.01L13.43 11.73L13.53 11.36L13.57 10.98L13.57 8.8L13.54 8.64L13.5 8.54L13.42 8.45L13.29 8.38L13.18 8.35L10.92 8.34L10.6 8.3L10.31 8.19L10.1 8.08L9.92 7.95L9.73 7.76L9.59 7.57L9.48 7.37L9.4 7.15L9.35 6.92Z",
        "fill": "#231f20"
      },
      {
        "type": "polygon",
        "d": "M9.33 8.63L9.61 8.83L9.9 9L10.22 9.12L10.52 9.2L10.95 9.24L12.67 9.25L12.67 10.92L12.62 11.28L12.52 11.58L12.36 11.85L12.17 12.08L11.93 12.28L11.74 12.4L11.56 12.48L11.33 12.55L11.14 12.59L10.93 12.6L9.33 12.6Z",
        "fill": "truck"
      }
    ],
    "posta-e-kosoves": [
      {
        "type": "polygon",
        "d": "M8.14 6.79L7.55 7.14L7.1 7.66L6.86 8.25L6.68 9.15L6.68 9.77L6.96 10.35L7.46 10.74L8.1 10.87L8.76 10.75L9.35 10.4L9.8 9.88L10.03 9.29L10.21 8.39L10.21 7.77L9.94 7.19L9.43 6.8L8.8 6.66Z",
        "fill": "#0061a0"
      },
      {
        "type": "polygon",
        "d": "M8.1 10.13L7.77 10.06L7.54 9.88L7.41 9.61L7.41 9.22L7.56 8.46L7.73 8.04L8.02 7.7L8.4 7.48L8.79 7.41L9.12 7.48L9.36 7.66L9.48 7.93L9.48 8.32L9.33 9.08L9.17 9.5L8.87 9.83L8.5 10.05Z",
        "fill": "truck"
      },
      {
        "type": "polygon",
        "d": "M11.3 8.85L12.56 9.28L12.69 9.52L12.55 9.85L12.1 10.14L11.59 10.14L11.21 9.82L10.75 10.38L11.33 10.86L12.3 10.86L13.13 10.35L13.49 9.49L13.07 8.68L11.82 8.26L11.7 8.02L11.84 7.68L12.28 7.4L12.74 7.4L13.1 7.71L13.58 7.16L13.02 6.67L12.06 6.67L11.26 7.19L10.9 8.04Z",
        "fill": "#0061a0"
      },
      {
        "type": "polygon",
        "d": "M17.44 6.67L15.89 10.66L16.57 10.93L17.02 9.76L18.34 9.76L18.33 10.79L19.06 10.8L19.1 6.67Z",
        "fill": "#0061a0"
      },
      {
        "type": "polygon",
        "d": "M18.37 7.4L18.35 9.03L17.31 9.03L17.94 7.4Z",
        "fill": "truck"
      },
      {
        "type": "polygon",
        "d": "M6.22 7.51L6.01 7.07L5.62 6.77L5.17 6.67L3.72 6.67L2.9 10.79L3.61 10.94L3.96 9.2L4.81 9.2L5.26 9.11L5.7 8.86L6.03 8.47L6.22 8.01Z",
        "fill": "#0061a0"
      },
      {
        "type": "polygon",
        "d": "M5.49 7.87L5.4 8.09L5.22 8.29L5 8.42L4.74 8.47L4.11 8.47L4.32 7.4L5.09 7.4L5.31 7.44L5.42 7.53L5.49 7.67Z",
        "fill": "truck"
      },
      {
        "type": "polygon",
        "d": "M14.22 10.79L14.93 10.94L15.64 7.4L16.42 7.4L16.42 6.67L14.27 6.67L14.27 7.4L14.9 7.4Z",
        "fill": "#0061a0"
      }
    ],
    "rayspeed": [
      {
        "type": "polygon",
        "d": "M6.73 6.55L12.06 6.55L12.06 5.93L13.51 7.15L6.73 7.15Z",
        "fill": "accent"
      },
      {
        "type": "polygon",
        "d": "M5.18 7.99L11.73 7.99L11.73 7.5L13.18 8.58L5.18 8.58Z",
        "fill": "accent"
      },
      {
        "type": "polygon",
        "d": "M4.41 9.65L11.18 9.65L11.18 9.03L12.63 10.17L4.41 10.17Z",
        "fill": "accent"
      },
      {
        "type": "polygon",
        "d": "M3.2 11.07L10.88 11.07L10.88 10.59L12.19 11.67L3.2 11.67Z",
        "fill": "accent"
      },
      {
        "type": "polygon",
        "d": "M15.88 9.51L17.26 11.71L18.1 11.19L17.02 9.48L17.48 9.39L18.08 9.04L18.53 8.53L18.79 7.89L18.8 7.22L18.52 6.61L18 6.21L17.39 6.08L15.24 6.08L14.07 11.66L15.04 11.87L15.53 9.51Z",
        "fill": "accent"
      },
      {
        "type": "polygon",
        "d": "M16.04 7.07L17.28 7.07L17.57 7.13L17.73 7.25L17.81 7.43L17.81 7.69L17.68 8L17.44 8.27L17.13 8.45L16.77 8.52L15.74 8.52Z",
        "fill": "truck"
      }
    ],
    "rex-indonesia": [
      {
        "type": "polygon",
        "d": "M7.09 9.29L7.68 8.9L8.07 8.31L8.21 7.61L8.07 6.91L7.68 6.32L7.09 5.93L6.44 5.8L4.08 5.8L4.08 11.8L5.13 11.8L5.13 9.42L5.44 9.42L7.44 11.8L8.23 11.13L6.75 9.36Z",
        "fill": "accent"
      },
      {
        "type": "polygon",
        "d": "M6.68 6.91L6.93 7.07L7.09 7.32L7.15 7.61L7.09 7.9L6.93 8.15L6.68 8.31L6.34 8.38L5.13 8.38L5.13 6.84L6.34 6.84Z",
        "fill": "truck"
      },
      {
        "type": "polygon",
        "d": "M12.47 10.76L10.27 10.76L10.27 9.32L12.06 9.32L12.06 8.28L10.27 8.28L10.27 6.84L12.47 6.84L12.47 5.8L9.23 5.8L9.23 11.8L12.47 11.8Z",
        "fill": "accent"
      },
      {
        "type": "polygon",
        "d": "M16.31 8.8L17.92 6.37L17.05 5.8L15.69 7.85L14.33 5.8L13.47 6.37L15.07 8.8L13.47 11.23L14.33 11.8L15.69 9.75L17.05 11.8L17.92 11.23Z",
        "fill": "accent"
      }
    ],
    "ryder-last-mile": [
      {
        "type": "polygon",
        "d": "M11.92 10.2L12.29 9.81L12.57 9.35L12.72 8.85L12.75 8.33L12.63 7.84L12.38 7.42L12.01 7.09L11.55 6.88L11.07 6.82L10.24 6.82L9.53 10.75L10.49 10.75L10.98 10.69L11.48 10.5Z",
        "fill": "accent"
      },
      {
        "type": "polygon",
        "d": "M11.85 7.85L11.99 8.1L12.06 8.4L12.04 8.73L11.94 9.07L11.74 9.39L11.48 9.67L11.16 9.89L10.81 10.02L10.44 10.07L10.35 10.07L10.81 7.5L11.03 7.5L11.37 7.55L11.64 7.67Z",
        "fill": "truck"
      },
      {
        "type": "polygon",
        "d": "M14.03 9.13L15.26 9.13L15.26 8.44L14.15 8.44L14.32 7.5L15.82 7.5L15.82 6.82L13.75 6.82L13.04 10.75L15.24 10.75L15.24 10.07L13.86 10.07Z",
        "fill": "accent"
      },
      {
        "type": "polygon",
        "d": "M7.06 10.69L7.73 10.81L8.07 8.94L9.51 7.23L8.99 6.79L7.83 8.16L7.21 6.86L6.59 7.15L7.4 8.83Z",
        "fill": "accent"
      },
      {
        "type": "polygon",
        "d": "M6.08 7.6L5.88 7.18L5.51 6.9L5.09 6.82L3.6 6.82L2.9 10.69L3.57 10.81L3.86 9.19L4.1 9.19L5.11 10.72L5.68 10.35L4.9 9.17L5.21 9.11L5.62 8.87L5.92 8.5L6.09 8.06Z",
        "fill": "accent"
      },
      {
        "type": "polygon",
        "d": "M5.41 7.95L5.33 8.15L5.17 8.34L4.96 8.46L4.72 8.51L3.99 8.51L4.17 7.5L5.02 7.5L5.22 7.54L5.34 7.63L5.4 7.76Z",
        "fill": "truck"
      },
      {
        "type": "polygon",
        "d": "M18.63 8.87L18.93 8.5L19.1 8.06L19.09 7.6L18.89 7.18L18.52 6.9L18.1 6.82L16.61 6.82L15.91 10.69L16.58 10.81L16.87 9.19L17.11 9.19L18.12 10.72L18.69 10.35L17.91 9.17L18.22 9.11Z",
        "fill": "accent"
      },
      {
        "type": "polygon",
        "d": "M18.41 7.95L18.34 8.15L18.18 8.34L17.97 8.46L17.73 8.51L17 8.51L17.18 7.5L18.03 7.5L18.23 7.54L18.35 7.63L18.41 7.76Z",
        "fill": "truck"
      }
    ],
    "shipglobal-us": [
      {
        "type": "polygon",
        "d": "M6.82 6.53L7.92 6.88L8.09 7.12L8.04 7.36L7.75 7.57L7.34 7.57L6.96 7.3L6.62 7.78L7.15 8.16L7.94 8.16L8.57 7.72L8.73 6.99L8.29 6.37L7.2 6.03L7.03 5.79L7.09 5.54L7.36 5.34L7.74 5.34L8.1 5.6L8.45 5.13L7.94 4.74L7.16 4.74L6.55 5.19L6.4 5.91Z",
        "fill": "accent"
      },
      {
        "type": "polygon",
        "d": "M11.64 4.74L11.05 4.74L11.05 6.16L9.89 6.16L9.89 4.74L9.29 4.74L9.29 8.16L9.89 8.16L9.89 6.75L11.05 6.75L11.05 8.16L11.64 8.16Z",
        "fill": "accent"
      },
      {
        "type": "polygon",
        "d": "M12.8 4.74L12.2 4.74L12.2 8.16L12.8 8.16Z",
        "fill": "accent"
      },
      {
        "type": "polygon",
        "d": "M15.3 5.04L14.96 4.82L14.59 4.74L13.36 4.74L13.36 8.16L13.96 8.16L13.96 6.81L14.59 6.81L14.96 6.73L15.3 6.51L15.52 6.17L15.6 5.77L15.52 5.38Z",
        "fill": "accent"
      },
      {
        "type": "polygon",
        "d": "M14.87 6.08L14.73 6.17L14.53 6.21L13.96 6.21L13.96 5.34L14.53 5.34L14.73 5.37L14.87 5.47L14.96 5.61L15 5.77L14.96 5.94Z",
        "fill": "truck"
      },
      {
        "type": "polygon",
        "d": "M7.75 12.85L7.75 12.26L6.63 12.26L6.63 9.43L6.04 9.43L6.04 12.85Z",
        "fill": "accent"
      },
      {
        "type": "polygon",
        "d": "M8.55 9.83L8.25 10.28L8.15 10.77L8.15 11.51L8.25 12.01L8.55 12.45L9 12.75L9.52 12.86L10.05 12.75L10.5 12.45L10.8 12.01L10.89 11.51L10.89 10.77L10.8 10.28L10.5 9.83L10.05 9.53L9.52 9.43L9 9.53Z",
        "fill": "accent"
      },
      {
        "type": "polygon",
        "d": "M9.52 12.25L9.23 12.19L8.98 12.03L8.81 11.78L8.75 11.45L8.75 10.83L8.81 10.51L8.98 10.26L9.23 10.09L9.52 10.03L9.82 10.09L10.07 10.26L10.24 10.51L10.3 10.83L10.3 11.45L10.24 11.78L10.07 12.03L9.82 12.19Z",
        "fill": "truck"
      },
      {
        "type": "polygon",
        "d": "M13.5 10.05L13.37 9.8L13.18 9.6L12.92 9.47L12.67 9.43L11.46 9.43L11.46 12.85L12.86 12.85L13.13 12.81L13.41 12.67L13.62 12.45L13.76 12.18L13.8 11.9L13.8 11.71L13.76 11.43L13.62 11.16L13.4 10.94L13.5 10.74L13.54 10.48L13.54 10.3Z",
        "fill": "accent"
      },
      {
        "type": "polygon",
        "d": "M12.95 11.38L13.05 11.43L13.14 11.51L13.19 11.62L13.21 11.75L13.21 11.86L13.19 12L13.14 12.1L13.05 12.18L12.95 12.24L12.81 12.26L12.05 12.26L12.05 11.35L12.81 11.35Z",
        "fill": "truck"
      },
      {
        "type": "polygon",
        "d": "M12.95 10.44L12.93 10.55L12.89 10.63L12.82 10.7L12.74 10.74L12.62 10.76L12.05 10.76L12.05 10.03L12.62 10.03L12.74 10.04L12.82 10.09L12.89 10.15L12.93 10.24L12.95 10.35Z",
        "fill": "truck"
      },
      {
        "type": "polygon",
        "d": "M14.23 12.74L14.81 12.85L14.98 11.95L16.07 11.95L16.24 12.85L16.83 12.74L16.2 9.43L14.86 9.43Z",
        "fill": "accent"
      },
      {
        "type": "polygon",
        "d": "M15.96 11.35L15.1 11.35L15.35 10.03L15.71 10.03Z",
        "fill": "truck"
      },
      {
        "type": "polygon",
        "d": "M19.1 12.85L19.1 12.26L17.98 12.26L17.98 9.43L17.39 9.43L17.39 12.85Z",
        "fill": "accent"
      },
      {
        "type": "polygon",
        "d": "M3.55 11.83L3.49 11.54L3.49 10.74L3.53 10.5L3.63 10.31L3.78 10.16L3.98 10.06L4.19 10.03L4.41 10.07L4.6 10.17L4.78 10.36L5.21 9.94L4.96 9.69L4.6 9.5L4.2 9.43L3.8 9.49L3.43 9.67L3.15 9.96L2.96 10.32L2.9 10.69L2.9 11.6L2.99 12.06L3.27 12.48L3.69 12.76L4.19 12.86L4.68 12.76L5.1 12.48L5.38 12.06L5.47 11.6L5.47 10.99L4.19 10.99L4.19 11.58L4.87 11.58L4.82 11.83L4.67 12.05L4.45 12.2L4.19 12.25L3.92 12.2L3.7 12.05Z",
        "fill": "accent"
      }
    ],
    "sjl-express": [
      {
        "type": "polygon",
        "d": "M17 11.8L17 10.77L15.17 10.77L16.03 5.98L15.03 5.8L13.95 11.8Z",
        "fill": "accent"
      },
      {
        "type": "polygon",
        "d": "M12.18 10.17L12.06 10.36L11.9 10.53L11.71 10.66L11.5 10.74L11.31 10.77L11.14 10.74L11.01 10.68L10.91 10.6L10.84 10.48L10.81 10.33L10.82 10.09L9.79 10.04L9.77 10.43L9.88 10.87L10.11 11.25L10.44 11.56L10.86 11.74L11.3 11.8L11.76 11.74L12.18 11.58L12.57 11.32L12.88 10.98L13.12 10.59L13.24 10.19L14 5.98L12.99 5.8L12.25 9.94Z",
        "fill": "accent"
      },
      {
        "type": "polygon",
        "d": "M8.1 5.89L6.76 5.89L5.63 6.62L5.16 7.83L5.73 8.97L7.52 9.56L7.71 9.91L7.53 10.38L6.9 10.77L6.2 10.77L5.65 10.33L5 11.12L5.83 11.8L7.2 11.8L8.36 11.07L8.84 9.85L8.24 8.72L6.46 8.13L6.28 7.78L6.47 7.3L7.06 6.92L7.72 6.92L8.23 7.35L8.9 6.57Z",
        "fill": "#ed6d00"
      }
    ],
    "sol-express": [
      {
        "type": "polygon",
        "d": "M9.38 12.65L10.02 12.57L10.48 12.42L10.75 12.31L11.1 12.1L11.56 11.72L11.79 11.47L12 11.18L12.25 10.7L12.34 10.45L12.41 10.12L12.45 9.82L12.45 9.56L12.34 9.1L12.23 8.91L12.02 8.7L11.54 8.4L10.08 7.75L8.93 7.18L8.82 7.07L8.77 6.95L8.8 6.8L8.89 6.67L9.07 6.56L9.29 6.51L16.46 6.51L17.48 4.63L17.5 4.54L8.95 4.55L8.4 4.66L8.02 4.8L7.55 5.06L7.16 5.37L6.85 5.72L6.6 6.11L6.37 6.6L6.27 6.92L6.2 7.32L6.2 7.59L6.25 7.88L6.37 8.15L6.5 8.34L6.68 8.5L7.18 8.82L9.68 9.93L9.84 10.05L9.9 10.14L9.91 10.22L9.89 10.31L9.8 10.45L9.68 10.54L9.3 10.66L6.13 10.68L5.76 10.74L5.56 10.85L5.45 10.99L4.5 12.64Z",
        "fill": "accent"
      },
      {
        "type": "polygon",
        "d": "M15.4 8.39L15.96 7.34L9.73 7.34L11.94 8.39Z",
        "fill": "#ec3900"
      },
      {
        "type": "polygon",
        "d": "M13.07 12.66L13.97 11.04L12.37 11.03L12 11.6L11.79 11.83L11.53 12.06L11.31 12.22L10.95 12.42L10.37 12.65Z",
        "fill": "#ec3900"
      },
      {
        "type": "polygon",
        "d": "M14.43 10.19L14.93 9.27L14.93 9.23L12.6 9.24L12.66 9.69L12.63 10.2Z",
        "fill": "#ec3900"
      }
    ],
    "tiui": [
      {
        "type": "polygon",
        "d": "M5.9 6.84L5.9 11.8L6.94 11.8L6.94 6.84L7.95 6.84L7.95 5.8L4.88 5.8L4.88 6.84Z",
        "fill": "accent"
      },
      {
        "type": "polygon",
        "d": "M8.94 11.8L9.98 11.8L9.98 5.8L8.94 5.8Z",
        "fill": "accent"
      },
      {
        "type": "polygon",
        "d": "M16.08 11.8L17.12 11.8L17.12 5.8L16.08 5.8Z",
        "fill": "accent"
      },
      {
        "type": "polygon",
        "d": "M12.5 11.73L13.03 11.8L13.56 11.73L14.06 11.52L14.49 11.2L14.82 10.77L15.02 10.27L15.09 9.77L15.09 5.8L14.05 5.8L14.05 9.71L14.01 10L13.91 10.24L13.75 10.45L13.54 10.61L13.29 10.72L13.03 10.75L12.77 10.72L12.53 10.61L12.32 10.45L12.16 10.24L12.05 10L12.02 9.71L12.02 5.8L10.98 5.8L10.98 9.77L11.04 10.27L11.25 10.77L11.57 11.2L12 11.52Z",
        "fill": "accent"
      }
    ],
    "tpl-rider": [
      {
        "type": "polygon",
        "d": "M6.1 7.88L5.99 7.34L5.69 6.88L5.23 6.57L4.73 6.47L2.9 6.47L2.9 11.13L3.71 11.13L3.71 9.28L3.95 9.28L5.5 11.13L6.12 10.61L4.97 9.23L5.23 9.18L5.69 8.88L5.99 8.42Z",
        "fill": "accent"
      },
      {
        "type": "polygon",
        "d": "M5.28 7.88L5.23 8.1L5.11 8.29L4.91 8.42L4.65 8.47L3.71 8.47L3.71 7.28L4.65 7.28L4.91 7.33L5.11 7.46L5.23 7.65Z",
        "fill": "truck"
      },
      {
        "type": "polygon",
        "d": "M7.7 11.13L7.7 6.47L6.89 6.47L6.89 11.13Z",
        "fill": "accent"
      },
      {
        "type": "polygon",
        "d": "M11.14 10.45L11.51 9.97L11.74 9.4L11.82 8.8L11.74 8.2L11.51 7.63L11.14 7.15L10.65 6.78L10.09 6.55L9.51 6.47L8.47 6.47L8.47 11.13L9.51 11.13L10.09 11.05L10.65 10.82Z",
        "fill": "accent"
      },
      {
        "type": "polygon",
        "d": "M10.8 8.04L10.95 8.41L11 8.8L10.95 9.19L10.8 9.56L10.56 9.87L10.25 10.11L9.88 10.26L9.46 10.32L9.28 10.32L9.28 7.28L9.46 7.28L9.88 7.34L10.25 7.49L10.56 7.73Z",
        "fill": "truck"
      },
      {
        "type": "polygon",
        "d": "M14.79 9.2L14.79 8.4L13.4 8.4L13.4 7.28L15.11 7.28L15.11 6.47L12.59 6.47L12.59 11.13L15.11 11.13L15.11 10.32L13.4 10.32L13.4 9.2Z",
        "fill": "accent"
      },
      {
        "type": "polygon",
        "d": "M18.97 7.34L18.67 6.88L18.21 6.57L17.71 6.47L15.88 6.47L15.88 11.13L16.69 11.13L16.69 9.28L16.93 9.28L18.48 11.13L19.1 10.61L17.95 9.23L18.21 9.18L18.67 8.88L18.97 8.42L19.08 7.88Z",
        "fill": "accent"
      },
      {
        "type": "polygon",
        "d": "M18.21 8.1L18.09 8.29L17.89 8.42L17.63 8.47L16.69 8.47L16.69 7.28L17.63 7.28L17.89 7.33L18.09 7.46L18.21 7.65L18.26 7.88Z",
        "fill": "truck"
      }
    ],
    "union-express": [
      {
        "type": "polygon",
        "d": "M6.35 5.89L5.76 6.17L5.26 6.6L4.9 7.14L4.72 7.72L4.43 9.66L4.44 10.26L4.65 10.85L5.07 11.33L5.62 11.63L6.25 11.73L6.89 11.62L7.48 11.34L7.92 10.95L7.23 10.18L6.9 10.48L6.58 10.64L6.25 10.69L5.95 10.65L5.72 10.52L5.55 10.33L5.46 10.07L5.46 9.73L5.73 7.95L5.84 7.59L6.04 7.28L6.32 7.04L6.65 6.89L6.98 6.84L7.27 6.89L7.49 7.02L7.71 7.29L8.51 6.64L8.17 6.22L7.62 5.91L6.99 5.8Z",
        "fill": "accent"
      },
      {
        "type": "polygon",
        "d": "M14.93 10.69L14.51 10.6L14.2 10.37L14.02 10.02L13.99 9.52L14.2 8.15L14.33 7.72L14.57 7.36L14.9 7.08L15.29 6.9L15.68 6.84L16.02 6.9L16.3 7.06L16.56 7.37L17.35 6.72L16.98 6.26L16.38 5.92L15.69 5.8L14.99 5.9L14.34 6.2L13.79 6.68L13.39 7.28L13.19 7.92L12.96 9.47L13 10.29L13.39 11.05L14.08 11.56L14.93 11.73L15.79 11.57L16.56 11.1L17.13 10.41L17.4 9.62L17.57 8.5L15.26 8.5L15.26 9.52L16.35 9.52L16.22 9.9L15.87 10.32L15.42 10.59Z",
        "fill": "accent"
      },
      {
        "type": "polygon",
        "d": "M10.41 6.83L9.69 11.65L10.7 11.8L11.45 6.83L12.52 6.83L12.52 5.81L9.49 5.81L9.49 6.83Z",
        "fill": "accent"
      }
    ],
    "uof-express": [
      {
        "type": "polygon",
        "d": "M3.95 10.64L4.2 11.08L4.58 11.42L5.05 11.64L5.56 11.71L6.08 11.64L6.58 11.45L7.03 11.15L7.4 10.76L7.68 10.31L7.84 9.84L8.6 6L7.62 5.8L6.86 9.58L6.76 9.88L6.6 10.14L6.38 10.37L6.12 10.55L5.84 10.66L5.57 10.69L5.33 10.66L5.14 10.57L5 10.44L4.9 10.27L4.86 10.06L4.88 9.78L5.63 6L4.64 5.8L3.87 9.64L3.84 10.13Z",
        "fill": "accent"
      },
      {
        "type": "polygon",
        "d": "M13.42 6.61L12.72 6.07L11.84 5.89L10.93 6.06L10.12 6.54L9.49 7.26L9.17 8.08L8.92 9.33L8.92 10.18L9.29 10.99L9.99 11.53L10.87 11.71L11.78 11.54L12.6 11.06L13.22 10.34L13.55 9.52L13.8 8.27L13.8 7.42Z",
        "fill": "accent"
      },
      {
        "type": "polygon",
        "d": "M12.35 9.81L11.95 10.27L11.42 10.58L10.88 10.68L10.42 10.59L10.1 10.34L9.92 9.96L9.92 9.43L10.14 8.37L10.36 7.79L10.77 7.33L11.29 7.02L11.83 6.92L12.29 7.01L12.61 7.26L12.79 7.64L12.79 8.17L12.58 9.23Z",
        "fill": "truck"
      },
      {
        "type": "polygon",
        "d": "M15.8 8.3L16.08 6.91L18.16 6.91L18.16 5.9L15.25 5.9L14.11 11.6L15.1 11.8L15.6 9.3L17.3 9.3L17.3 8.3Z",
        "fill": "accent"
      }
    ],
    "yingtu": [
      {
        "type": "polygon",
        "d": "M14 7.58L14.64 7.58L14.64 10.67L15.29 10.67L15.29 7.58L15.92 7.58L15.92 6.93L14 6.93Z",
        "fill": "accent"
      },
      {
        "type": "polygon",
        "d": "M2.9 7.29L3.96 8.9L3.96 10.67L4.61 10.67L4.61 8.9L5.67 7.29L5.13 6.93L4.29 8.21L3.44 6.93Z",
        "fill": "accent"
      },
      {
        "type": "polygon",
        "d": "M6.29 6.93L6.29 10.67L6.94 10.67L6.94 6.93Z",
        "fill": "accent"
      },
      {
        "type": "polygon",
        "d": "M10.24 10.67L10.24 6.93L9.6 6.93L9.6 10.02L9.35 10.02L9.04 6.93L7.56 6.93L7.56 10.67L8.21 10.67L8.21 7.58L8.45 7.58L8.76 10.67Z",
        "fill": "accent"
      },
      {
        "type": "polygon",
        "d": "M12.55 9.96L12.27 10.01L11.98 9.96L11.74 9.79L11.57 9.55L11.51 9.23L11.51 8.36L11.55 8.1L11.66 7.89L11.83 7.72L12.04 7.62L12.28 7.58L12.51 7.62L12.72 7.73L12.92 7.94L13.39 7.49L13.11 7.21L12.72 7L12.28 6.93L11.84 6.99L11.45 7.19L11.13 7.5L10.93 7.9L10.86 8.31L10.86 9.29L10.96 9.8L11.27 10.26L11.73 10.57L12.27 10.67L12.81 10.57L13.27 10.26L13.57 9.8L13.67 9.29L13.67 8.63L12.27 8.63L12.27 9.28L13.01 9.28L12.96 9.55L12.8 9.79Z",
        "fill": "accent"
      },
      {
        "type": "polygon",
        "d": "M16.91 10.29L17.18 10.5L17.49 10.63L17.82 10.67L18.15 10.63L18.46 10.5L18.73 10.29L18.93 10.03L19.06 9.72L19.1 9.41L19.1 6.93L18.45 6.93L18.45 9.36L18.43 9.55L18.36 9.7L18.26 9.83L18.13 9.93L17.98 9.99L17.82 10.02L17.65 9.99L17.5 9.93L17.37 9.83L17.27 9.7L17.21 9.55L17.18 9.36L17.18 6.93L16.54 6.93L16.54 9.41L16.58 9.72L16.71 10.03Z",
        "fill": "accent"
      }
    ],
    "rtt": [
      {
        "type": "polygon",
        "d": "M9.28 5.8L9.28 6.84L10.84 6.84L10.84 11.8L11.88 11.8L11.88 6.84L13.44 6.84L13.44 5.8Z",
        "fill": "accent"
      },
      {
        "type": "polygon",
        "d": "M14.43 6.84L16 6.84L16 11.8L17.04 11.8L17.04 6.84L18.6 6.84L18.6 5.8L14.43 5.8Z",
        "fill": "accent"
      },
      {
        "type": "polygon",
        "d": "M7.89 8.9L8.28 8.31L8.42 7.61L8.28 6.91L7.89 6.32L7.3 5.93L6.65 5.8L3.4 5.8L3.4 11.8L4.44 11.8L4.44 9.42L5.11 9.42L7.68 11.8L8.39 11.03L6.64 9.42L7.3 9.29Z",
        "fill": "accent"
      },
      {
        "type": "polygon",
        "d": "M7.14 7.07L7.3 7.32L7.36 7.61L7.3 7.9L7.14 8.15L6.89 8.31L6.55 8.38L4.44 8.38L4.44 6.84L6.55 6.84L6.89 6.91Z",
        "fill": "truck"
      }
    ],
    "cupost": [
      {
        "type": "polygon",
        "d": "M17.32 7.07L17.32 7.67L17.91 7.67L17.91 10.53L18.51 10.53L18.51 7.67L19.1 7.67L19.1 7.07Z",
        "fill": "accent"
      },
      {
        "type": "polygon",
        "d": "M3.73 7.12L3.39 7.29L3.13 7.55L2.96 7.89L2.9 8.23L2.9 9.37L2.96 9.71L3.13 10.05L3.39 10.31L3.73 10.48L4.1 10.54L4.47 10.47L4.8 10.3L5.03 10.06L4.6 9.64L4.44 9.81L4.28 9.9L4.09 9.93L3.91 9.9L3.75 9.82L3.62 9.69L3.53 9.53L3.5 9.32L3.5 8.28L3.53 8.07L3.62 7.91L3.75 7.78L3.91 7.7L4.09 7.67L4.28 7.7L4.44 7.79L4.6 7.96L5.03 7.54L4.8 7.3L4.47 7.13L4.1 7.06Z",
        "fill": "accent"
      },
      {
        "type": "polygon",
        "d": "M10.51 8.86L10.74 8.52L10.82 8.11L10.74 7.71L10.51 7.37L10.17 7.14L9.8 7.07L8.55 7.07L8.55 10.53L9.15 10.53L9.15 9.16L9.8 9.16L10.17 9.08Z",
        "fill": "accent"
      },
      {
        "type": "polygon",
        "d": "M10.08 7.8L10.17 7.95L10.21 8.11L10.17 8.28L10.08 8.42L9.94 8.52L9.74 8.56L9.15 8.56L9.15 7.67L9.74 7.67L9.94 7.71Z",
        "fill": "truck"
      },
      {
        "type": "polygon",
        "d": "M13.26 7.17L12.73 7.06L12.2 7.17L11.74 7.47L11.44 7.92L11.34 8.43L11.34 9.17L11.44 9.68L11.74 10.13L12.2 10.43L12.73 10.54L13.26 10.43L13.72 10.13L14.02 9.68L14.12 9.17L14.12 8.43L14.02 7.92L13.72 7.47Z",
        "fill": "accent"
      },
      {
        "type": "polygon",
        "d": "M13.45 9.44L13.28 9.7L13.03 9.87L12.73 9.93L12.43 9.87L12.18 9.7L12.01 9.44L11.94 9.11L11.94 8.49L12.01 8.16L12.18 7.9L12.43 7.73L12.73 7.67L13.03 7.73L13.28 7.9L13.45 8.16L13.52 8.49L13.52 9.11Z",
        "fill": "truck"
      },
      {
        "type": "polygon",
        "d": "M14.67 8.25L15.1 8.88L16.21 9.23L16.39 9.48L16.33 9.73L16.04 9.93L15.63 9.93L15.24 9.66L14.89 10.15L15.43 10.53L16.23 10.53L16.87 10.08L17.03 9.34L16.59 8.72L15.48 8.37L15.31 8.13L15.37 7.87L15.64 7.67L16.03 7.67L16.39 7.94L16.75 7.46L16.23 7.07L15.44 7.07L14.83 7.52Z",
        "fill": "accent"
      },
      {
        "type": "polygon",
        "d": "M5.95 10.19L6.2 10.38L6.48 10.49L6.79 10.53L7.1 10.49L7.39 10.38L7.63 10.19L7.82 9.94L7.94 9.65L7.98 9.36L7.98 7.07L7.38 7.07L7.38 9.32L7.36 9.5L7.3 9.64L7.21 9.76L7.08 9.85L6.94 9.91L6.79 9.93L6.64 9.91L6.5 9.85L6.38 9.76L6.29 9.64L6.23 9.5L6.21 9.32L6.21 7.07L5.6 7.07L5.6 9.36L5.64 9.65L5.76 9.94Z",
        "fill": "accent"
      }
    ],
    "cargo-expreso": [
      {
        "type": "polygon",
        "d": "M4.69 6.21L4.14 6.29L3.64 6.54L3.24 6.94L2.98 7.44L2.9 7.95L2.9 9.65L2.98 10.16L3.24 10.66L3.64 11.06L4.14 11.31L4.69 11.39L5.24 11.29L5.74 11.03L6.08 10.68L5.43 10.06L5.19 10.31L4.95 10.43L4.68 10.48L4.41 10.44L4.16 10.32L3.97 10.12L3.85 9.88L3.8 9.58L3.8 8.02L3.85 7.72L3.97 7.48L4.16 7.28L4.41 7.16L4.68 7.12L4.95 7.17L5.19 7.29L5.43 7.54L6.08 6.92L5.74 6.57L5.24 6.31Z",
        "fill": "accent"
      },
      {
        "type": "polygon",
        "d": "M10.77 11.21L9.82 6.22L7.79 6.22L6.84 11.21L7.73 11.38L7.98 10.02L9.63 10.02L9.89 11.38Z",
        "fill": "accent"
      },
      {
        "type": "polygon",
        "d": "M8.54 7.11L9.07 7.11L9.46 9.12L8.16 9.12Z",
        "fill": "truck"
      },
      {
        "type": "polygon",
        "d": "M14.42 10.49L12.52 10.49L12.52 9.25L14.06 9.25L14.06 8.35L12.52 8.35L12.52 7.11L14.42 7.11L14.42 6.22L11.62 6.22L11.62 11.38L14.42 11.38Z",
        "fill": "accent"
      },
      {
        "type": "polygon",
        "d": "M19.1 6.71L18.35 6.22L17.18 7.99L16.02 6.22L15.27 6.71L16.65 8.8L15.27 10.89L16.02 11.38L17.18 9.61L18.35 11.38L19.1 10.89L17.72 8.8Z",
        "fill": "accent"
      }
    ],
    "gofast": [
      {
        "type": "polygon",
        "d": "M17.28 7.64L17.88 7.64L17.88 10.58L18.5 10.58L18.5 7.64L19.1 7.64L19.1 7.02L17.28 7.02Z",
        "fill": "accent"
      },
      {
        "type": "polygon",
        "d": "M8.13 7.13L7.58 7.02L7.04 7.13L6.57 7.44L6.26 7.9L6.16 8.42L6.16 9.18L6.26 9.7L6.57 10.16L7.04 10.47L7.58 10.58L8.13 10.47L8.6 10.16L8.91 9.7L9.01 9.18L9.01 8.42L8.91 7.9L8.6 7.44Z",
        "fill": "accent"
      },
      {
        "type": "polygon",
        "d": "M8.39 9.12L8.32 9.46L8.15 9.72L7.89 9.89L7.58 9.95L7.28 9.89L7.02 9.72L6.84 9.46L6.78 9.12L6.78 8.48L6.84 8.14L7.02 7.88L7.28 7.71L7.58 7.65L7.89 7.71L8.15 7.88L8.32 8.14L8.39 8.48Z",
        "fill": "truck"
      },
      {
        "type": "polygon",
        "d": "M10.21 9.11L11.2 9.11L11.2 8.49L10.21 8.49L10.21 7.64L11.43 7.64L11.43 7.02L9.6 7.02L9.6 10.58L10.21 10.58Z",
        "fill": "accent"
      },
      {
        "type": "polygon",
        "d": "M14.24 10.46L13.59 7.02L12.2 7.02L11.54 10.46L12.15 10.58L12.33 9.64L13.46 9.64L13.63 10.58Z",
        "fill": "accent"
      },
      {
        "type": "polygon",
        "d": "M12.44 9.02L12.71 7.64L13.08 7.64L13.34 9.02Z",
        "fill": "truck"
      },
      {
        "type": "polygon",
        "d": "M14.56 8.24L15 8.88L16.14 9.24L16.32 9.49L16.26 9.75L15.96 9.96L15.54 9.96L15.14 9.68L14.79 10.18L15.34 10.58L16.16 10.58L16.81 10.11L16.98 9.36L16.52 8.72L15.39 8.36L15.21 8.11L15.27 7.85L15.55 7.64L15.95 7.64L16.32 7.92L16.69 7.42L16.15 7.02L15.35 7.02L14.72 7.49Z",
        "fill": "accent"
      },
      {
        "type": "polygon",
        "d": "M4.51 9.9L4.24 9.95L3.96 9.9L3.73 9.74L3.58 9.51L3.52 9.21L3.52 8.38L3.56 8.14L3.66 7.94L3.82 7.78L4.02 7.68L4.24 7.64L4.47 7.68L4.67 7.79L4.86 7.98L5.3 7.56L5.04 7.29L4.67 7.09L4.25 7.02L3.83 7.08L3.46 7.27L3.16 7.57L2.96 7.94L2.9 8.34L2.9 9.27L3 9.75L3.29 10.19L3.72 10.48L4.24 10.58L4.75 10.48L5.19 10.19L5.48 9.75L5.57 9.27L5.57 8.64L4.24 8.64L4.24 9.26L4.95 9.26L4.9 9.51L4.74 9.74Z",
        "fill": "accent"
      }
    ],
    "hiyes": [
      {
        "type": "polygon",
        "d": "M9.34 6.95L10.05 8.82L9.47 10.89L10.2 11.1L10.79 8.99L12.59 7.08L12.03 6.56L10.59 8.1L10.05 6.68Z",
        "fill": "accent"
      },
      {
        "type": "polygon",
        "d": "M5.63 9.18L5.15 10.89L5.88 11.1L7.11 6.71L6.38 6.5L5.84 8.42L4.38 8.42L4.86 6.71L4.13 6.5L2.9 10.89L3.63 11.1L4.17 9.18Z",
        "fill": "accent"
      },
      {
        "type": "polygon",
        "d": "M7.92 6.5L6.69 10.89L7.42 11.1L8.65 6.71Z",
        "fill": "accent"
      },
      {
        "type": "polygon",
        "d": "M14.74 10.23L13.25 10.23L13.54 9.18L14.95 9.18L14.95 8.42L13.76 8.42L14.05 7.37L15.75 7.37L15.75 6.61L13.47 6.61L12.24 10.99L14.74 10.99Z",
        "fill": "accent"
      },
      {
        "type": "polygon",
        "d": "M16.6 8.88L17.88 9.33L17.99 9.56L17.8 9.93L17.29 10.23L16.77 10.23L16.4 9.91L15.9 10.48L16.48 10.99L17.5 10.99L18.39 10.47L18.82 9.58L18.45 8.71L17.17 8.28L17.08 8.04L17.26 7.67L17.76 7.37L18.24 7.37L18.58 7.68L19.1 7.13L18.54 6.61L17.54 6.61L16.68 7.14L16.24 8.01Z",
        "fill": "accent"
      }
    ],
    "htt-logistics": [
      {
        "type": "polygon",
        "d": "M9.98 5.8L9.98 6.84L11 6.84L11 11.8L12.04 11.8L12.04 6.84L13.06 6.84L13.06 5.8Z",
        "fill": "accent"
      },
      {
        "type": "polygon",
        "d": "M14.05 6.84L15.07 6.84L15.07 11.8L16.11 11.8L16.11 6.84L17.12 6.84L17.12 5.8L14.05 5.8Z",
        "fill": "accent"
      },
      {
        "type": "polygon",
        "d": "M4.88 5.8L4.88 11.8L5.92 11.8L5.92 9.32L7.95 9.32L7.95 11.8L8.99 11.8L8.99 5.8L7.95 5.8L7.95 8.28L5.92 8.28L5.92 5.8Z",
        "fill": "accent"
      }
    ],
    "nas-express": [
      {
        "type": "polygon",
        "d": "M5.79 6.79L5.09 6.79L5.09 9.68L3.88 6.79L2.9 6.79L2.9 10.81L3.6 10.81L3.6 7.92L4.81 10.81L5.79 10.81Z",
        "fill": "accent"
      },
      {
        "type": "polygon",
        "d": "M9.51 10.68L8.77 6.79L7.2 6.79L6.46 10.68L7.14 10.81L7.35 9.75L8.62 9.75L8.83 10.81Z",
        "fill": "accent"
      },
      {
        "type": "polygon",
        "d": "M7.77 7.49L8.19 7.49L8.49 9.05L7.48 9.05Z",
        "fill": "truck"
      },
      {
        "type": "polygon",
        "d": "M9.87 8.17L10.37 8.89L11.66 9.3L11.86 9.58L11.8 9.87L11.46 10.11L10.98 10.11L10.53 9.8L10.13 10.36L10.76 10.81L11.69 10.81L12.42 10.29L12.61 9.43L12.09 8.7L10.81 8.3L10.61 8.02L10.68 7.72L10.99 7.49L11.45 7.49L11.87 7.8L12.29 7.24L11.68 6.79L10.76 6.79L10.05 7.32Z",
        "fill": "accent"
      },
      {
        "type": "polygon",
        "d": "M15.45 10.11L13.97 10.11L13.97 9.15L15.18 9.15L15.18 8.45L13.97 8.45L13.97 7.49L15.45 7.49L15.45 6.79L13.27 6.79L13.27 10.81L15.45 10.81Z",
        "fill": "accent"
      },
      {
        "type": "polygon",
        "d": "M19.1 7.17L18.52 6.79L17.61 8.17L16.7 6.79L16.12 7.17L17.19 8.8L16.12 10.43L16.7 10.81L17.61 9.43L18.52 10.81L19.1 10.43L18.03 8.8Z",
        "fill": "accent"
      }
    ],
    "odm-express": [
      {
        "type": "polygon",
        "d": "M7.88 7.54L7.55 6.84L6.94 6.36L6.16 6.2L5.36 6.35L4.64 6.78L4.09 7.41L3.81 8.13L3.59 9.22L3.59 9.98L3.92 10.69L4.53 11.16L5.31 11.32L6.11 11.17L6.83 10.75L7.38 10.11L7.66 9.39L7.88 8.3Z",
        "fill": "accent"
      },
      {
        "type": "polygon",
        "d": "M6.81 9.14L6.61 9.65L6.25 10.06L5.79 10.33L5.32 10.42L4.91 10.34L4.63 10.12L4.47 9.78L4.47 9.31L4.66 8.38L4.86 7.87L5.22 7.47L5.68 7.19L6.15 7.1L6.56 7.19L6.84 7.41L7 7.74L7 8.21Z",
        "fill": "truck"
      },
      {
        "type": "polygon",
        "d": "M9.38 11.31L10.02 11.23L10.67 10.98L11.26 10.59L11.74 10.09L12.11 9.49L12.32 8.85L12.37 8.18L12.23 7.55L11.92 6.99L11.44 6.56L10.85 6.29L10.23 6.21L9.16 6.21L8.14 11.31Z",
        "fill": "accent"
      },
      {
        "type": "polygon",
        "d": "M10.17 7.09L10.61 7.15L10.95 7.31L11.22 7.55L11.4 7.87L11.48 8.25L11.45 8.67L11.3 9.12L11.04 9.54L10.69 9.91L10.26 10.19L9.81 10.37L9.33 10.43L9.22 10.43L9.89 7.09Z",
        "fill": "truck"
      },
      {
        "type": "polygon",
        "d": "M15.8 10.13L17.26 7.46L16.51 11.23L17.37 11.4L18.41 6.21L16.93 6.21L15.52 8.8L15.13 6.21L13.71 6.21L12.71 11.23L13.58 11.4L14.4 7.3L14.82 10.13Z",
        "fill": "accent"
      }
    ],
    "online-worldwide-logistics": [
      {
        "type": "polygon",
        "d": "M11.33 9.99L10.2 9.99L10.79 7.03L10.17 6.91L9.43 10.63L11.33 10.63Z",
        "fill": "#464646"
      },
      {
        "type": "polygon",
        "d": "M5.3 7.08L4.75 6.96L4.17 7.07L3.66 7.38L3.26 7.83L3.06 8.35L2.9 9.13L2.9 9.67L3.14 10.18L3.58 10.52L4.14 10.64L4.71 10.53L5.22 10.22L5.62 9.77L5.82 9.25L5.98 8.47L5.98 7.93L5.74 7.42Z",
        "fill": "#464646"
      },
      {
        "type": "polygon",
        "d": "M4.81 9.73L4.48 9.92L4.14 9.99L3.85 9.93L3.65 9.77L3.54 9.53L3.54 9.19L3.67 8.53L3.81 8.16L4.07 7.87L4.4 7.68L4.74 7.61L5.03 7.67L5.23 7.83L5.35 8.07L5.34 8.41L5.21 9.07L5.07 9.44Z",
        "fill": "truck"
      },
      {
        "type": "polygon",
        "d": "M9.53 7.03L8.91 6.91L8.36 9.63L7.78 6.97L6.9 6.97L6.18 10.57L6.8 10.69L7.34 7.97L7.93 10.63L8.81 10.63Z",
        "fill": "#464646"
      },
      {
        "type": "polygon",
        "d": "M12.66 6.91L11.93 10.57L12.55 10.69L13.29 7.03Z",
        "fill": "#464646"
      },
      {
        "type": "polygon",
        "d": "M16.55 7.03L15.92 6.91L15.38 9.63L14.79 6.97L13.91 6.97L13.2 10.57L13.82 10.69L14.36 7.97L14.95 10.63L15.83 10.63Z",
        "fill": "#464646"
      },
      {
        "type": "polygon",
        "d": "M18.5 9.99L17.22 9.99L17.39 9.12L18.55 9.12L18.55 8.48L17.52 8.48L17.7 7.61L19.1 7.61L19.1 6.97L17.18 6.97L16.44 10.63L18.5 10.63Z",
        "fill": "#464646"
      }
    ],
    "ontask-express": [
      {
        "type": "polygon",
        "d": "M9.2 7.69L9.78 7.69L9.78 10.5L10.37 10.5L10.37 7.69L10.95 7.69L10.95 7.1L9.2 7.1Z",
        "fill": "accent"
      },
      {
        "type": "polygon",
        "d": "M18.64 7.1L17.37 8.37L17.37 7.1L16.78 7.1L16.78 10.5L17.37 10.5L17.37 9.2L17.65 8.92L18.59 10.5L19.1 10.2L18.08 8.49L19.06 7.52Z",
        "fill": "accent"
      },
      {
        "type": "polygon",
        "d": "M4.79 7.2L4.26 7.09L3.74 7.2L3.3 7.49L3 7.94L2.9 8.43L2.9 9.17L3 9.66L3.3 10.11L3.74 10.4L4.26 10.51L4.79 10.4L5.23 10.11L5.53 9.66L5.63 9.17L5.63 8.43L5.53 7.94L5.23 7.49Z",
        "fill": "accent"
      },
      {
        "type": "polygon",
        "d": "M4.97 9.43L4.81 9.68L4.56 9.85L4.26 9.91L3.97 9.85L3.72 9.68L3.56 9.43L3.49 9.11L3.49 8.49L3.56 8.17L3.72 7.92L3.97 7.75L4.26 7.69L4.56 7.75L4.81 7.92L4.97 8.17L5.04 8.49L5.04 9.11Z",
        "fill": "truck"
      },
      {
        "type": "polygon",
        "d": "M8.05 7.1L8.05 9.54L7.02 7.1L6.19 7.1L6.19 10.5L6.78 10.5L6.78 8.06L7.81 10.5L8.64 10.5L8.64 7.1Z",
        "fill": "accent"
      },
      {
        "type": "polygon",
        "d": "M12.97 7.1L11.63 7.1L11.01 10.39L11.59 10.5L11.76 9.6L12.84 9.6L13.01 10.5L13.59 10.39Z",
        "fill": "accent"
      },
      {
        "type": "polygon",
        "d": "M12.12 7.69L12.48 7.69L12.73 9.01L11.87 9.01Z",
        "fill": "truck"
      },
      {
        "type": "polygon",
        "d": "M13.89 8.26L14.32 8.88L15.41 9.22L15.58 9.46L15.53 9.71L15.24 9.91L14.83 9.91L14.46 9.64L14.11 10.12L14.65 10.5L15.43 10.5L16.06 10.06L16.21 9.33L15.78 8.72L14.69 8.38L14.52 8.14L14.58 7.89L14.85 7.69L15.23 7.69L15.59 7.95L15.94 7.48L15.43 7.1L14.65 7.1L14.05 7.55Z",
        "fill": "accent"
      }
    ],
    "7hours-express": [
      {
        "type": "polygon",
        "d": "M12.72 7.97L11.45 7.97L13.48 5.65L4.94 5.65L3.2 7.76L7.88 7.76L5.92 9.94L15.06 9.95L15.47 9.47L18.8 5.65L14.75 5.64L14.69 5.71Z",
        "fill": "accent"
      },
      {
        "type": "polygon",
        "d": "M9.34 10.39L5.52 10.39L3.76 12.34L7.62 12.35Z",
        "fill": "accent"
      },
      {
        "type": "polygon",
        "d": "M14.68 10.38L10.62 10.38L8.9 12.36L12.96 12.36Z",
        "fill": "accent"
      }
    ],
    "a2b-express": [
      {
        "type": "polygon",
        "d": "M12.47 6.86L12.68 7.01L12.81 7.22L12.85 7.52L12.77 7.86L12.59 8.19L8.08 11.89L13.18 11.89L13.18 10.82L11.08 10.82L13.42 8.9L13.79 8.25L13.94 7.56L13.84 6.86L13.49 6.27L12.93 5.86L12.25 5.7L11.54 5.78L10.88 6.08L10.33 6.55L9.98 7.08L10.87 7.68L11.14 7.27L11.46 6.99L11.83 6.83L12.18 6.79Z",
        "fill": "accent"
      },
      {
        "type": "polygon",
        "d": "M18.88 7.39L18.9 6.92L18.75 6.43L18.43 6.03L17.98 5.78L17.52 5.71L15.97 5.71L15.44 5.6L14.21 11.79L15.26 12L15.28 11.89L16.83 11.89L17.34 11.82L17.84 11.58L18.28 11.22L18.6 10.77L18.77 10.28L18.84 9.93L18.87 9.42L18.7 8.89L18.4 8.51L18.66 8.15L18.81 7.71Z",
        "fill": "accent"
      },
      {
        "type": "polygon",
        "d": "M17.29 9.18L17.52 9.22L17.65 9.3L17.74 9.41L17.79 9.56L17.78 9.8L17.74 9.99L17.64 10.26L17.48 10.49L17.27 10.67L17.02 10.78L16.75 10.82L15.5 10.82L15.82 9.18Z",
        "fill": "truck"
      },
      {
        "type": "polygon",
        "d": "M17.82 7.06L17.81 7.26L17.78 7.42L17.69 7.65L17.56 7.83L17.38 7.98L17.18 8.07L16.96 8.11L16.04 8.11L16.3 6.78L17.43 6.78L17.62 6.81L17.72 6.87L17.78 6.94Z",
        "fill": "truck"
      },
      {
        "type": "polygon",
        "d": "M5.4 5.71L3.1 11.6L4.1 11.99L4.78 10.26L6.73 10.26L6.71 11.79L7.78 11.8L7.85 5.71Z",
        "fill": "accent"
      },
      {
        "type": "polygon",
        "d": "M6.14 6.78L6.76 6.78L6.74 9.18L5.2 9.18Z",
        "fill": "truck"
      }
    ],
    "acex": [
      {
        "type": "polygon",
        "d": "M16.85 8.28L17.57 8.28L17.57 9L18.38 9L18.38 8.28L19.1 8.28L19.1 7.47L18.38 7.47L18.38 6.75L17.57 6.75L17.57 7.47L16.85 7.47Z",
        "fill": "accent"
      },
      {
        "type": "polygon",
        "d": "M2.9 10.68L3.59 10.84L3.84 9.76L5.34 9.76L5.59 10.84L6.28 10.68L5.38 6.76L3.8 6.76Z",
        "fill": "accent"
      },
      {
        "type": "polygon",
        "d": "M5.18 9.05L4 9.05L4.37 7.47L4.82 7.47Z",
        "fill": "truck"
      },
      {
        "type": "polygon",
        "d": "M6.71 8.23L6.71 9.37L6.78 9.81L6.99 10.23L7.33 10.57L7.76 10.78L8.23 10.85L8.69 10.77L9.11 10.55L9.4 10.25L8.89 9.75L8.68 9.97L8.46 10.09L8.22 10.13L7.97 10.09L7.75 9.98L7.57 9.81L7.46 9.59L7.42 9.31L7.42 8.29L7.46 8.01L7.57 7.79L7.75 7.62L7.97 7.51L8.22 7.47L8.46 7.51L8.68 7.63L8.89 7.85L9.4 7.35L9.11 7.05L8.69 6.83L8.23 6.75L7.76 6.82L7.33 7.03L6.99 7.37L6.78 7.79Z",
        "fill": "accent"
      },
      {
        "type": "polygon",
        "d": "M10.79 7.47L12.46 7.47L12.46 6.76L10.08 6.76L10.08 10.84L12.46 10.84L12.46 10.13L10.79 10.13L10.79 9.15L12.16 9.15L12.16 8.45L10.79 8.45Z",
        "fill": "accent"
      },
      {
        "type": "polygon",
        "d": "M13.14 10.43L13.71 10.84L14.75 9.41L15.78 10.84L16.36 10.43L15.18 8.8L16.36 7.17L15.78 6.76L14.75 8.19L13.71 6.76L13.14 7.17L14.31 8.8Z",
        "fill": "accent"
      }
    ],
    "aics": [
      {
        "type": "polygon",
        "d": "M12.14 6.25L11.63 6.67L11.25 7.19L11.05 7.75L10.65 9.64L10.62 10.23L10.8 10.82L11.18 11.31L11.72 11.61L12.34 11.7L12.97 11.6L13.55 11.32L13.99 10.94L13.34 10.18L13 10.47L12.66 10.63L12.33 10.68L12.06 10.64L11.85 10.52L11.7 10.35L11.63 10.11L11.65 9.77L12.02 8.03L12.15 7.67L12.37 7.36L12.67 7.12L13.01 6.96L13.33 6.92L13.61 6.96L13.81 7.09L14.01 7.34L14.81 6.74L14.49 6.32L13.96 6.01L13.35 5.9L12.72 5.99Z",
        "fill": "accent"
      },
      {
        "type": "polygon",
        "d": "M8.24 11.59L9.22 11.8L10.44 6.01L9.45 5.8Z",
        "fill": "accent"
      },
      {
        "type": "polygon",
        "d": "M15.94 8.92L17.67 9.5L17.84 9.84L17.64 10.3L17.01 10.69L16.32 10.69L15.8 10.26L15.16 11.03L15.96 11.7L17.3 11.7L18.44 10.99L18.95 9.8L18.39 8.68L16.66 8.1L16.5 7.77L16.7 7.3L17.31 6.91L17.95 6.91L18.44 7.33L19.1 6.58L18.33 5.9L17.01 5.9L15.9 6.62L15.4 7.79Z",
        "fill": "accent"
      },
      {
        "type": "polygon",
        "d": "M2.9 11.41L3.83 11.79L4.48 10.16L6.3 10.16L6.27 11.59L7.28 11.61L7.39 5.9L5.1 5.9Z",
        "fill": "accent"
      },
      {
        "type": "polygon",
        "d": "M6.37 6.91L6.32 9.16L4.88 9.16L5.78 6.91Z",
        "fill": "truck"
      }
    ],
    "apg-global": [
      {
        "type": "polygon",
        "d": "M8.1 11.6L7 5.81L4.66 5.81L3.56 11.6L4.58 11.79L4.88 10.21L6.78 10.21L7.08 11.79Z",
        "fill": "accent"
      },
      {
        "type": "polygon",
        "d": "M5.08 9.17L5.52 6.84L6.14 6.84L6.58 9.17Z",
        "fill": "truck"
      },
      {
        "type": "polygon",
        "d": "M12.87 8.31L13.01 7.61L12.87 6.92L12.47 6.33L11.89 5.93L11.24 5.81L9.09 5.81L9.09 11.79L10.13 11.79L10.13 9.42L11.24 9.42L11.89 9.29L12.47 8.89Z",
        "fill": "accent"
      },
      {
        "type": "polygon",
        "d": "M11.89 7.32L11.95 7.61L11.89 7.9L11.73 8.15L11.48 8.31L11.14 8.38L10.13 8.38L10.13 6.84L11.14 6.84L11.48 6.91L11.73 7.08Z",
        "fill": "truck"
      },
      {
        "type": "polygon",
        "d": "M16.19 10.74L15.73 10.65L15.34 10.39L15.08 10L14.98 9.49L14.98 8.1L15.05 7.68L15.22 7.34L15.49 7.08L15.83 6.91L16.21 6.85L16.58 6.92L16.92 7.09L17.24 7.42L17.98 6.7L17.55 6.25L16.92 5.92L16.22 5.8L15.51 5.9L14.88 6.22L14.37 6.72L14.05 7.35L13.94 8.02L13.94 9.59L14.1 10.4L14.59 11.14L15.33 11.63L16.19 11.8L17.06 11.63L17.79 11.14L18.28 10.4L18.44 9.59L18.44 8.53L16.19 8.53L16.19 9.56L17.39 9.56L17.3 10L17.04 10.39L16.65 10.65Z",
        "fill": "accent"
      }
    ],
    "barq": [
      {
        "type": "polygon",
        "d": "M5.82 7.5L5.77 7.14L5.59 6.79L5.31 6.51L4.96 6.34L4.6 6.28L2.9 6.28L2.9 11.08L4.86 11.08L5.25 11.02L5.63 10.82L5.94 10.52L6.13 10.14L6.19 9.75L6.19 9.47L6.13 9.08L5.94 8.7L5.62 8.39L5.77 8.11L5.82 7.75Z",
        "fill": "#272822"
      },
      {
        "type": "polygon",
        "d": "M4.8 8.98L4.99 9.01L5.14 9.08L5.25 9.2L5.33 9.34L5.36 9.54L5.36 9.68L5.33 9.88L5.25 10.02L5.14 10.14L4.99 10.22L4.8 10.25L3.73 10.25L3.73 8.98Z",
        "fill": "truck"
      },
      {
        "type": "polygon",
        "d": "M4.99 7.57L4.99 7.69L4.97 7.85L4.91 7.97L4.81 8.06L4.7 8.12L4.54 8.14L3.73 8.14L3.73 7.11L4.54 7.11L4.7 7.14L4.81 7.2L4.91 7.29L4.97 7.41Z",
        "fill": "truck"
      },
      {
        "type": "polygon",
        "d": "M7.67 6.28L6.79 10.92L7.61 11.08L7.85 9.81L9.38 9.81L9.62 11.08L10.43 10.92L9.55 6.28Z",
        "fill": "#272822"
      },
      {
        "type": "polygon",
        "d": "M9.22 8.98L8.01 8.98L8.36 7.11L8.86 7.11Z",
        "fill": "truck"
      },
      {
        "type": "polygon",
        "d": "M14.53 7.73L14.42 7.17L14.1 6.7L13.63 6.38L13.11 6.28L11.23 6.28L11.23 11.08L12.06 11.08L12.06 9.17L12.31 9.17L13.91 11.08L14.55 10.54L13.36 9.13L13.63 9.07L14.1 8.76L14.42 8.28Z",
        "fill": "#272822"
      },
      {
        "type": "polygon",
        "d": "M13.68 7.73L13.63 7.96L13.5 8.16L13.31 8.29L13.03 8.34L12.06 8.34L12.06 7.11L13.03 7.11L13.31 7.17L13.5 7.3L13.63 7.49Z",
        "fill": "truck"
      },
      {
        "type": "polygon",
        "d": "M16.44 6.42L15.81 6.84L15.39 7.46L15.25 8.16L15.25 9.2L15.39 9.89L15.81 10.52L16.44 10.94L17.18 11.09L17.92 10.94L18.01 10.88L18.35 11.33L19.02 10.83L18.66 10.35L18.96 9.89L19.1 9.2L19.1 8.16L18.96 7.46L18.54 6.84L17.92 6.42L17.18 6.27Z",
        "fill": "#272822"
      },
      {
        "type": "polygon",
        "d": "M17.81 9.22L17.14 9.72L17.48 10.18L17.18 10.24L16.76 10.16L16.41 9.92L16.18 9.57L16.08 9.11L16.08 8.24L16.18 7.79L16.41 7.44L16.76 7.2L17.18 7.12L17.59 7.2L17.94 7.44L18.18 7.79L18.27 8.24L18.27 9.11L18.18 9.57L18.13 9.64Z",
        "fill": "truck"
      }
    ],
    "basic-shipping": [
      {
        "type": "polygon",
        "d": "M5.75 7.65L5.7 7.3L5.52 6.96L5.25 6.69L4.91 6.51L4.56 6.46L2.9 6.46L2.9 11.14L4.82 11.14L5.2 11.08L5.57 10.89L5.86 10.6L6.05 10.22L6.11 9.84L6.11 9.58L6.05 9.19L5.86 8.82L5.56 8.52L5.7 8.25L5.75 7.9Z",
        "fill": "#000000"
      },
      {
        "type": "polygon",
        "d": "M4.75 9.09L4.94 9.12L5.08 9.19L5.2 9.31L5.27 9.45L5.3 9.64L5.3 9.78L5.27 9.97L5.2 10.11L5.08 10.23L4.94 10.3L4.75 10.33L3.71 10.33L3.71 9.09Z",
        "fill": "truck"
      },
      {
        "type": "polygon",
        "d": "M4.94 7.72L4.94 7.83L4.91 7.99L4.86 8.1L4.77 8.19L4.65 8.25L4.5 8.28L3.71 8.28L3.71 7.27L4.5 7.27L4.65 7.3L4.77 7.35L4.86 7.44L4.91 7.56Z",
        "fill": "truck"
      },
      {
        "type": "polygon",
        "d": "M7.56 6.46L6.69 10.99L7.49 11.14L7.73 9.9L9.22 9.9L9.45 11.14L10.25 10.99L9.39 6.46Z",
        "fill": "#000000"
      },
      {
        "type": "polygon",
        "d": "M9.06 9.09L7.88 9.09L8.23 7.27L8.72 7.27Z",
        "fill": "truck"
      },
      {
        "type": "polygon",
        "d": "M11.25 8.91L12.75 9.38L12.99 9.71L12.92 10.05L12.52 10.33L11.96 10.33L11.44 9.96L10.97 10.62L11.7 11.14L12.78 11.14L13.64 10.53L13.86 9.53L13.26 8.69L11.76 8.22L11.53 7.89L11.61 7.54L11.98 7.27L12.51 7.27L13 7.64L13.48 6.98L12.77 6.46L11.71 6.46L10.88 7.07L10.67 8.06Z",
        "fill": "#000000"
      },
      {
        "type": "polygon",
        "d": "M15.44 6.46L14.63 6.46L14.63 11.14L15.44 11.14Z",
        "fill": "#000000"
      },
      {
        "type": "polygon",
        "d": "M16.29 7.56L16.22 8.03L16.22 9.57L16.29 10.04L16.53 10.49L16.89 10.85L17.34 11.07L17.84 11.15L18.34 11.06L18.79 10.82L19.1 10.51L18.52 9.94L18.3 10.17L18.08 10.28L17.83 10.32L17.59 10.29L17.37 10.18L17.19 10L17.08 9.78L17.03 9.5L17.03 8.1L17.08 7.82L17.19 7.6L17.37 7.42L17.59 7.31L17.83 7.28L18.08 7.32L18.3 7.43L18.52 7.66L19.1 7.09L18.79 6.78L18.34 6.54L17.84 6.45L17.34 6.53L16.89 6.75L16.53 7.11Z",
        "fill": "#000000"
      }
    ],
    "bluesky-parcel": [
      {
        "type": "polygon",
        "d": "M12.9 13.29L13.22 13.23L13.64 13.08L14.01 12.87L14.25 12.67L14.5 12.38L14.66 12.11L14.79 11.78L14.87 11.43L14.9 11.07L14.89 10.62L14.81 10.3L14.68 10.03L14.51 9.78L14.22 9.47L13.83 9.18L13.43 8.96L13.75 8.7L14.01 8.36L14.21 7.98L14.35 7.51L14.42 7.06L14.42 6.45L14.32 5.95L14.14 5.54L13.94 5.27L13.62 5L13.28 4.83L12.83 4.71L8.04 4.7L7.8 4.73L7.56 4.84L7.37 4.99L7.23 5.17L7.15 5.35L7.1 5.62L7.1 12.36L7.13 12.62L7.23 12.85L7.54 13.16L7.75 13.26L7.99 13.3Z",
        "fill": "accent"
      },
      {
        "type": "polygon",
        "d": "M10.09 11.06L10.61 11.05L10.7 11.02L12.56 9.12L12.61 9.04L12.61 8.95L12.52 8.8L10.8 7.05L9.38 7.04L9.29 7.12L9.32 7.23L10.86 8.85L10.92 8.95L10.92 9.04L10.87 9.12L9.18 10.85L9.18 10.96L9.3 11.06Z",
        "fill": "truck"
      }
    ],
    "bolt-kargo": [
      {
        "type": "polygon",
        "d": "M13.71 6.02L12.61 11.48L15.4 11.48L15.4 10.55L13.75 10.55L14.62 6.21Z",
        "fill": "#231f20"
      },
      {
        "type": "polygon",
        "d": "M6.95 7.58L6.97 7.17L6.84 6.75L6.56 6.4L6.17 6.18L5.77 6.12L4.43 6.12L3.97 6.02L2.9 11.39L3.81 11.58L3.83 11.48L5.18 11.48L5.62 11.42L6.06 11.21L6.43 10.9L6.71 10.5L6.86 10.08L6.92 9.78L6.94 9.34L6.8 8.88L6.54 8.55L6.76 8.24L6.9 7.85Z",
        "fill": "#231f20"
      },
      {
        "type": "polygon",
        "d": "M6.02 7.46L6 7.6L5.92 7.8L5.81 7.96L5.66 8.09L5.48 8.17L5.28 8.2L4.49 8.2L4.72 7.05L5.7 7.05L5.86 7.07L5.94 7.12L6 7.19L6.03 7.29Z",
        "fill": "truck"
      },
      {
        "type": "polygon",
        "d": "M5.77 9.16L5.89 9.23L5.96 9.33L6 9.46L5.99 9.67L5.96 9.84L5.88 10.07L5.74 10.26L5.55 10.42L5.34 10.52L5.11 10.55L4.02 10.55L4.3 9.13L5.57 9.13Z",
        "fill": "truck"
      },
      {
        "type": "polygon",
        "d": "M9.69 6.27L8.94 6.71L8.36 7.38L8.06 8.13L7.83 9.29L7.83 10.08L8.18 10.82L8.82 11.32L9.64 11.49L10.48 11.33L11.24 10.89L11.81 10.22L12.11 9.47L12.34 8.31L12.34 7.52L12 6.78L11.35 6.28L10.53 6.11Z",
        "fill": "#231f20"
      },
      {
        "type": "polygon",
        "d": "M9.65 10.54L9.22 10.46L8.92 10.22L8.76 9.87L8.76 9.38L8.96 8.4L9.17 7.87L9.54 7.44L10.03 7.15L10.53 7.06L10.95 7.14L11.25 7.38L11.41 7.73L11.41 8.22L11.22 9.2L11 9.73L10.63 10.16L10.15 10.45Z",
        "fill": "truck"
      },
      {
        "type": "polygon",
        "d": "M17.16 7.05L16.29 11.39L17.2 11.58L18.11 7.05L19.1 7.05L19.1 6.12L16.35 6.12L16.35 7.05Z",
        "fill": "#231f20"
      }
    ],
    "btc-logistic": [
      {
        "type": "polygon",
        "d": "M8.57 7.65L8.57 7.33L8.5 6.89L8.28 6.45L7.93 6.1L7.49 5.88L7.05 5.81L4.93 5.81L4.93 11.79L7.38 11.79L7.86 11.72L8.34 11.47L8.72 11.1L8.96 10.62L9.04 10.13L9.04 9.79L8.96 9.3L8.72 8.83L8.32 8.44L8.5 8.09Z",
        "fill": "accent"
      },
      {
        "type": "polygon",
        "d": "M5.97 9.17L7.29 9.17L7.54 9.21L7.72 9.3L7.86 9.45L7.96 9.63L8 9.87L8 10.05L7.96 10.3L7.86 10.48L7.72 10.62L7.54 10.72L7.29 10.75L5.97 10.75Z",
        "fill": "truck"
      },
      {
        "type": "polygon",
        "d": "M7.5 7.21L7.54 7.41L7.54 7.56L7.5 7.77L7.43 7.91L7.31 8.03L7.17 8.1L6.97 8.13L5.97 8.13L5.97 6.85L6.97 6.85L7.17 6.88L7.31 6.95L7.43 7.07Z",
        "fill": "truck"
      },
      {
        "type": "polygon",
        "d": "M10.51 6.85L10.51 11.79L11.55 11.79L11.55 6.85L12.57 6.85L12.57 5.81L9.5 5.81L9.5 6.85Z",
        "fill": "accent"
      },
      {
        "type": "polygon",
        "d": "M14.24 6.19L13.78 6.64L13.48 7.22L13.39 7.82L13.39 9.78L13.48 10.38L13.78 10.96L14.24 11.41L14.82 11.7L15.46 11.8L16.1 11.69L16.68 11.39L17.07 10.98L16.33 10.26L16.05 10.55L15.77 10.69L15.45 10.75L15.14 10.7L14.85 10.56L14.63 10.34L14.48 10.05L14.43 9.7L14.43 7.9L14.48 7.55L14.63 7.26L14.85 7.04L15.14 6.9L15.45 6.85L15.77 6.91L16.05 7.05L16.33 7.34L17.07 6.62L16.68 6.21L16.1 5.91L15.46 5.8L14.82 5.9Z",
        "fill": "accent"
      }
    ],
    "conveyor-uni-express": [
      {
        "type": "polygon",
        "d": "M15.97 4.35L15.77 4.33L5.31 7.99L5.2 8.13L8.54 8.13Z",
        "fill": "accent"
      },
      {
        "type": "polygon",
        "d": "M12.54 8.1L15.34 8.08L16.8 4.14L16.64 4.11L11.06 8.13L10.12 10.29L10.49 10.32Z",
        "fill": "accent"
      },
      {
        "type": "polygon",
        "d": "M9.73 9.86L10.38 8.09L14.96 5.11L14.8 5.07L9.41 8.08L9.26 8.24Z",
        "fill": "#000000"
      },
      {
        "type": "polygon",
        "d": "M3.85 11.11L3.63 11.22L3.45 11.4L3.34 11.62L3.3 11.85L3.3 12.61L3.34 12.84L3.45 13.06L3.63 13.24L3.85 13.35L4.1 13.39L4.35 13.34L4.57 13.23L4.72 13.07L4.43 12.79L4.33 12.9L4.22 12.96L4.1 12.98L3.98 12.96L3.87 12.91L3.78 12.82L3.72 12.71L3.7 12.58L3.7 11.88L3.72 11.74L3.78 11.64L3.87 11.55L3.98 11.49L4.1 11.48L4.22 11.5L4.33 11.55L4.43 11.67L4.72 11.39L4.57 11.23L4.35 11.11L4.1 11.07Z",
        "fill": "accent"
      },
      {
        "type": "polygon",
        "d": "M6.23 11.14L5.87 11.07L5.51 11.14L5.21 11.34L5.01 11.64L4.94 11.98L4.94 12.48L5.01 12.81L5.21 13.12L5.51 13.32L5.87 13.39L6.23 13.32L6.53 13.12L6.73 12.81L6.8 12.48L6.8 11.98L6.73 11.64L6.53 11.34Z",
        "fill": "accent"
      },
      {
        "type": "polygon",
        "d": "M6.35 12.66L6.24 12.83L6.07 12.94L5.87 12.98L5.67 12.94L5.5 12.83L5.39 12.66L5.34 12.44L5.34 12.02L5.39 11.8L5.5 11.63L5.67 11.52L5.87 11.48L6.07 11.52L6.24 11.63L6.35 11.8L6.39 12.02L6.39 12.44Z",
        "fill": "truck"
      },
      {
        "type": "polygon",
        "d": "M8.84 13.38L8.84 11.07L8.44 11.07L8.44 12.98L8.29 12.98L8.09 11.07L7.18 11.07L7.18 13.38L7.58 13.38L7.58 11.47L7.73 11.47L7.92 13.38Z",
        "fill": "accent"
      },
      {
        "type": "polygon",
        "d": "M10.22 12.98L9.98 12.98L9.62 11.07L9.22 11.15L9.65 13.38L10.55 13.38L10.98 11.15L10.58 11.07Z",
        "fill": "accent"
      },
      {
        "type": "polygon",
        "d": "M11.76 12.98L11.76 12.43L12.45 12.43L12.45 12.03L11.76 12.03L11.76 11.47L12.61 11.47L12.61 11.07L11.36 11.07L11.36 13.38L12.61 13.38L12.61 12.98Z",
        "fill": "accent"
      },
      {
        "type": "polygon",
        "d": "M13.65 13.38L14.05 13.38L14.05 12.29L14.71 11.29L14.37 11.07L13.85 11.86L13.33 11.07L12.99 11.29L13.65 12.29Z",
        "fill": "accent"
      },
      {
        "type": "polygon",
        "d": "M16.15 11.14L15.79 11.07L15.44 11.14L15.14 11.34L14.93 11.64L14.87 11.98L14.87 12.48L14.93 12.81L15.14 13.12L15.44 13.32L15.79 13.39L16.15 13.32L16.45 13.12L16.65 12.81L16.72 12.48L16.72 11.98L16.65 11.64L16.45 11.34Z",
        "fill": "accent"
      },
      {
        "type": "polygon",
        "d": "M16.27 12.66L16.16 12.83L15.99 12.94L15.79 12.98L15.59 12.94L15.42 12.83L15.31 12.66L15.27 12.44L15.27 12.02L15.31 11.8L15.42 11.63L15.59 11.52L15.79 11.48L15.99 11.52L16.16 11.63L16.27 11.8L16.32 12.02L16.32 12.44Z",
        "fill": "truck"
      },
      {
        "type": "polygon",
        "d": "M18.13 12.44L18.26 12.42L18.49 12.27L18.64 12.04L18.69 11.77L18.64 11.5L18.49 11.27L18.26 11.12L18.01 11.07L17.1 11.07L17.1 13.38L17.5 13.38L17.5 12.47L17.62 12.47L18.39 13.38L18.7 13.13Z",
        "fill": "accent"
      },
      {
        "type": "polygon",
        "d": "M18.26 11.66L18.28 11.77L18.26 11.88L18.2 11.98L18.1 12.04L17.97 12.07L17.5 12.07L17.5 11.47L17.97 11.47L18.1 11.5L18.2 11.56Z",
        "fill": "truck"
      }
    ],
    "coupang-logistics": [
      {
        "type": "polygon",
        "d": "M3.08 7.72L2.94 7.99L2.9 8.27L2.9 9.33L2.94 9.61L3.08 9.88L3.3 10.09L3.57 10.23L3.87 10.27L4.16 10.22L4.43 10.08L4.62 9.89L4.26 9.55L4.13 9.69L4.01 9.75L3.86 9.78L3.72 9.76L3.59 9.69L3.48 9.59L3.42 9.46L3.39 9.3L3.39 8.3L3.42 8.14L3.48 8.01L3.59 7.91L3.72 7.84L3.86 7.82L4.01 7.85L4.13 7.91L4.26 8.05L4.62 7.71L4.43 7.52L4.16 7.38L3.87 7.33L3.57 7.37L3.3 7.51Z",
        "fill": "accent"
      },
      {
        "type": "polygon",
        "d": "M5.22 7.63L4.99 7.98L4.92 8.36L4.92 9.24L4.99 9.62L5.22 9.97L5.57 10.2L5.97 10.28L6.38 10.2L6.72 9.97L6.95 9.62L7.03 9.24L7.03 8.36L6.95 7.98L6.72 7.63L6.38 7.4L5.97 7.32L5.57 7.4Z",
        "fill": "accent"
      },
      {
        "type": "polygon",
        "d": "M5.97 9.78L5.76 9.73L5.58 9.61L5.46 9.43L5.41 9.19L5.41 8.41L5.46 8.17L5.58 7.99L5.76 7.87L5.97 7.82L6.19 7.87L6.37 7.99L6.49 8.17L6.54 8.41L6.54 9.19L6.49 9.43L6.37 9.61L6.19 9.73Z",
        "fill": "truck"
      },
      {
        "type": "polygon",
        "d": "M11.67 7.87L11.48 7.58L11.19 7.39L10.88 7.33L9.87 7.33L9.87 10.27L10.36 10.27L10.36 9.09L10.88 9.09L11.19 9.03L11.48 8.84L11.67 8.55L11.74 8.21Z",
        "fill": "accent"
      },
      {
        "type": "polygon",
        "d": "M11.21 8.36L11.13 8.49L11 8.57L10.83 8.6L10.36 8.6L10.36 7.82L10.83 7.82L11 7.85L11.13 7.94L11.21 8.06L11.24 8.21Z",
        "fill": "truck"
      },
      {
        "type": "polygon",
        "d": "M11.88 10.19L12.36 10.27L12.49 9.49L13.38 9.49L13.52 10.27L14 10.19L13.51 7.33L12.36 7.33Z",
        "fill": "accent"
      },
      {
        "type": "polygon",
        "d": "M12.58 9L12.78 7.82L13.1 7.82L13.3 9Z",
        "fill": "truck"
      },
      {
        "type": "polygon",
        "d": "M16.08 9.78L15.86 9.78L15.62 7.33L14.47 7.33L14.47 10.27L14.96 10.27L14.96 7.82L15.18 7.82L15.42 10.27L16.57 10.27L16.57 7.33L16.08 7.33Z",
        "fill": "accent"
      },
      {
        "type": "polygon",
        "d": "M17.09 8.04L17.04 8.34L17.04 9.27L17.11 9.64L17.34 9.97L17.67 10.2L18.07 10.28L18.47 10.2L18.8 9.97L19.03 9.64L19.1 9.27L19.1 8.68L18.07 8.68L18.07 9.17L18.61 9.17L18.61 9.22L18.56 9.45L18.45 9.62L18.27 9.74L18.07 9.78L17.87 9.74L17.69 9.62L17.58 9.45L17.53 9.22L17.53 8.38L17.56 8.19L17.64 8.04L17.76 7.92L17.91 7.85L18.08 7.82L18.24 7.85L18.39 7.93L18.54 8.08L18.89 7.74L18.69 7.53L18.4 7.38L18.08 7.33L17.76 7.37L17.47 7.52L17.24 7.75Z",
        "fill": "accent"
      },
      {
        "type": "polygon",
        "d": "M8.45 10.27L8.7 10.24L8.93 10.15L9.13 9.99L9.28 9.79L9.38 9.56L9.41 9.33L9.41 7.33L8.92 7.33L8.92 9.3L8.9 9.44L8.85 9.55L8.78 9.64L8.68 9.72L8.57 9.76L8.45 9.78L8.33 9.76L8.22 9.72L8.12 9.64L8.05 9.55L8 9.44L7.98 9.3L7.98 7.33L7.49 7.33L7.49 9.33L7.52 9.56L7.62 9.79L7.77 9.99L7.97 10.15L8.2 10.24Z",
        "fill": "accent"
      }
    ],
    "der-kurier-sk": [
      {
        "type": "polygon",
        "d": "M3.98 7.01L4.14 6.81L4.23 6.58L4.26 6.34L4.23 6.09L4.14 5.86L3.98 5.67L3.79 5.52L3.56 5.42L3.33 5.39L2.9 5.39L2.9 7.28L3.33 7.28L3.56 7.25L3.79 7.16Z",
        "fill": "accent"
      },
      {
        "type": "polygon",
        "d": "M3.85 6.03L3.91 6.18L3.93 6.34L3.91 6.5L3.85 6.65L3.75 6.77L3.62 6.87L3.47 6.93L3.3 6.96L3.23 6.96L3.23 5.72L3.3 5.72L3.47 5.74L3.62 5.8L3.75 5.9Z",
        "fill": "truck"
      },
      {
        "type": "polygon",
        "d": "M4.9 6.5L5.47 6.5L5.47 6.17L4.9 6.17L4.9 5.72L5.6 5.72L5.6 5.39L4.57 5.39L4.57 7.28L5.6 7.28L5.6 6.96L4.9 6.96Z",
        "fill": "accent"
      },
      {
        "type": "polygon",
        "d": "M7.05 6.37L7.17 6.18L7.21 5.96L7.17 5.74L7.05 5.56L6.86 5.43L6.66 5.39L5.91 5.39L5.91 7.28L6.24 7.28L6.24 6.53L6.34 6.53L6.97 7.28L7.22 7.07L6.75 6.51L6.86 6.49Z",
        "fill": "accent"
      },
      {
        "type": "polygon",
        "d": "M6.86 6.05L6.81 6.13L6.73 6.18L6.62 6.21L6.24 6.21L6.24 5.72L6.62 5.72L6.73 5.74L6.81 5.79L6.86 5.87L6.88 5.96Z",
        "fill": "truck"
      },
      {
        "type": "polygon",
        "d": "M2.9 12.21L3.56 12.21L3.56 10.76L3.87 10.44L4.92 12.21L5.48 11.87L4.35 9.96L5.43 8.88L4.97 8.42L3.56 9.83L3.56 8.42L2.9 8.42Z",
        "fill": "accent"
      },
      {
        "type": "polygon",
        "d": "M11.8 9.12L11.55 8.75L11.18 8.5L10.77 8.42L9.28 8.42L9.28 12.21L9.94 12.21L9.94 10.7L10.14 10.7L11.4 12.21L11.9 11.78L10.96 10.67L11.18 10.62L11.55 10.37L11.8 10L11.88 9.56Z",
        "fill": "accent"
      },
      {
        "type": "polygon",
        "d": "M11.18 9.74L11.07 9.9L10.92 10L10.7 10.05L9.94 10.05L9.94 9.08L10.7 9.08L10.92 9.12L11.07 9.22L11.18 9.38L11.21 9.56Z",
        "fill": "truck"
      },
      {
        "type": "polygon",
        "d": "M12.52 8.42L12.52 12.21L13.18 12.21L13.18 8.42Z",
        "fill": "accent"
      },
      {
        "type": "polygon",
        "d": "M15.6 9.98L14.46 9.98L14.46 9.08L15.86 9.08L15.86 8.42L13.81 8.42L13.81 12.21L15.86 12.21L15.86 11.55L14.46 11.55L14.46 10.64L15.6 10.64Z",
        "fill": "accent"
      },
      {
        "type": "polygon",
        "d": "M19.08 9.56L19 9.12L18.75 8.75L18.38 8.5L17.97 8.42L16.48 8.42L16.48 12.21L17.14 12.21L17.14 10.7L17.34 10.7L18.6 12.21L19.1 11.78L18.16 10.67L18.38 10.62L18.75 10.37L19 10Z",
        "fill": "accent"
      },
      {
        "type": "polygon",
        "d": "M18.12 10L17.9 10.05L17.14 10.05L17.14 9.08L17.9 9.08L18.12 9.12L18.27 9.22L18.38 9.38L18.42 9.56L18.38 9.74L18.27 9.9Z",
        "fill": "truck"
      },
      {
        "type": "polygon",
        "d": "M8.01 12.03L8.28 11.83L8.48 11.56L8.61 11.24L8.66 10.93L8.66 8.42L8 8.42L8 10.89L7.97 11.07L7.91 11.23L7.81 11.36L7.68 11.46L7.52 11.52L7.36 11.55L7.19 11.52L7.04 11.46L6.91 11.36L6.8 11.23L6.74 11.07L6.72 10.89L6.72 8.42L6.06 8.42L6.06 10.93L6.1 11.24L6.23 11.56L6.44 11.83L6.71 12.03L7.02 12.16L7.36 12.21L7.69 12.16Z",
        "fill": "accent"
      }
    ],
    "emiro": [
      {
        "type": "polygon",
        "d": "M18.36 6.88L17.74 6.75L17.1 6.87L16.52 7.21L16.07 7.71L15.83 8.29L15.64 9.16L15.62 9.77L15.88 10.34L16.37 10.72L16.99 10.85L17.63 10.73L18.21 10.39L18.65 9.89L18.89 9.31L19.09 8.44L19.1 7.83L18.85 7.26Z",
        "fill": "accent"
      },
      {
        "type": "polygon",
        "d": "M18.05 9.5L17.75 9.83L17.38 10.05L16.99 10.13L16.68 10.06L16.45 9.89L16.34 9.62L16.34 9.25L16.51 8.5L16.68 8.1L16.97 7.77L17.35 7.55L17.73 7.47L18.05 7.54L18.27 7.71L18.39 7.98L18.38 8.35L18.22 9.1Z",
        "fill": "truck"
      },
      {
        "type": "polygon",
        "d": "M9.5 8.21L8.94 10.77L9.63 10.92L10.55 6.76L9.57 6.76L8.13 9.08L7.7 6.76L6.79 6.76L5.9 10.77L6.6 10.92L7.22 8.07L7.56 9.9L8.45 9.9Z",
        "fill": "accent"
      },
      {
        "type": "polygon",
        "d": "M14.67 10.43L13.91 9.2L14.25 9.14L14.67 8.89L15 8.52L15.19 8.06L15.2 7.58L15.01 7.14L14.63 6.85L14.19 6.76L12.66 6.76L11.77 10.77L12.47 10.92L12.84 9.22L13.09 9.22L14.07 10.8Z",
        "fill": "accent"
      },
      {
        "type": "polygon",
        "d": "M14.32 7.51L14.43 7.59L14.49 7.73L14.49 7.92L14.4 8.13L14.22 8.33L13.99 8.46L13.74 8.51L13 8.51L13.23 7.47L14.12 7.47Z",
        "fill": "truck"
      },
      {
        "type": "polygon",
        "d": "M5.2 10.84L5.2 10.13L3.78 10.13L4 9.15L5.29 9.15L5.29 8.45L4.15 8.45L4.37 7.47L5.94 7.47L5.94 6.76L3.8 6.76L2.9 10.84Z",
        "fill": "accent"
      },
      {
        "type": "polygon",
        "d": "M11.26 6.68L10.36 10.77L11.05 10.92L11.95 6.83Z",
        "fill": "accent"
      }
    ],
    "fimile": [
      {
        "type": "polygon",
        "d": "M9.88 7.96L9.88 11.25L10.73 11.25L10.73 6.35L9.61 6.35L8.48 9.16L7.35 6.35L6.24 6.35L6.24 11.25L7.09 11.25L7.09 7.96L7.95 10.11L9.01 10.11Z",
        "fill": "accent"
      },
      {
        "type": "polygon",
        "d": "M19.1 10.4L17.3 10.4L17.3 9.22L18.77 9.22L18.77 8.38L17.3 8.38L17.3 7.2L19.1 7.2L19.1 6.35L16.45 6.35L16.45 11.25L19.1 11.25Z",
        "fill": "accent"
      },
      {
        "type": "polygon",
        "d": "M3.75 11.25L3.75 9.22L5.11 9.22L5.11 8.38L3.75 8.38L3.75 7.2L5.43 7.2L5.43 6.35L2.9 6.35L2.9 11.25Z",
        "fill": "accent"
      },
      {
        "type": "polygon",
        "d": "M14.04 10.4L14.04 6.35L13.19 6.35L13.19 11.25L15.64 11.25L15.64 10.4Z",
        "fill": "accent"
      },
      {
        "type": "polygon",
        "d": "M11.54 6.35L11.54 11.25L12.39 11.25L12.39 6.35Z",
        "fill": "accent"
      }
    ],
    "flipxpress": [
      {
        "type": "polygon",
        "d": "M17.62 8.93L18.09 8.41L18.38 7.78L18.41 7.1L18.15 6.47L17.63 6.05L17.01 5.92L15.04 5.92L13.63 11.56L14.6 11.8L15.2 9.39L16.38 9.39L17.01 9.28Z",
        "fill": "#002726"
      },
      {
        "type": "polygon",
        "d": "M17.19 6.98L17.33 7.09L17.4 7.27L17.39 7.54L17.25 7.85L16.99 8.14L16.66 8.33L16.29 8.4L15.45 8.4L15.82 6.92L16.9 6.92Z",
        "fill": "truck"
      },
      {
        "type": "polygon",
        "d": "M5.43 8.3L5.78 6.92L7.86 6.92L7.86 5.92L5 5.92L3.59 11.56L4.56 11.8L5.18 9.3L6.89 9.3L6.89 8.3Z",
        "fill": "#002726"
      },
      {
        "type": "polygon",
        "d": "M10.67 10.68L8.93 10.68L10.09 6.04L9.12 5.8L7.65 11.68L10.67 11.68Z",
        "fill": "#002726"
      },
      {
        "type": "polygon",
        "d": "M14.03 6.04L13.06 5.8L11.62 11.56L12.59 11.8Z",
        "fill": "#002726"
      }
    ],
    "frontdoor-collective": [
      {
        "type": "polygon",
        "d": "M13.8 12.64L13.8 3.75L9 3.75L9 12.64Z",
        "fill": "accent"
      },
      {
        "type": "polygon",
        "d": "M9.6 4.35L13.2 4.35L13.2 12.04L9.6 12.04Z",
        "fill": "truck"
      },
      {
        "type": "polygon",
        "d": "M11.96 7.89L12.03 7.77L12.1 7.69L12.17 7.62L12.26 7.56L12.34 7.51L12.44 7.47L12.55 7.45L12.65 7.44L12.65 4.9L10.15 4.9L10.15 7.89Z",
        "fill": "accent"
      },
      {
        "type": "polygon",
        "d": "M12.23 7.47L10.57 7.47L10.57 5.32L12.23 5.32Z",
        "fill": "truck"
      },
      {
        "type": "polygon",
        "d": "M12.65 8.94L12.51 8.93L12.43 8.91L12.32 8.87L12.23 8.81L12.15 8.76L12.07 8.68L12.01 8.59L11.96 8.49L10.15 8.49L10.15 11.49L12.65 11.49Z",
        "fill": "accent"
      },
      {
        "type": "polygon",
        "d": "M10.57 11.07L10.57 8.91L12.23 8.91L12.23 11.07Z",
        "fill": "truck"
      },
      {
        "type": "polygon",
        "d": "M14.2 13.75L14.2 12.94L8.51 12.94L8.51 13.75Z",
        "fill": "accent"
      },
      {
        "type": "polygon",
        "d": "M13.1 8.15L13.08 8.06L13.05 7.98L13 7.91L12.94 7.85L12.86 7.8L12.78 7.76L12.69 7.75L12.61 7.75L12.52 7.76L12.44 7.8L12.36 7.85L12.3 7.91L12.25 7.98L12.22 8.06L12.2 8.15L12.2 8.24L12.22 8.33L12.25 8.41L12.3 8.48L12.36 8.54L12.44 8.59L12.52 8.63L12.61 8.64L12.69 8.64L12.78 8.63L12.86 8.59L12.94 8.54L13 8.48L13.05 8.41L13.08 8.33L13.1 8.24Z",
        "fill": "accent"
      }
    ],
    "furniture-logis": [
      {
        "type": "polygon",
        "d": "M7.22 12L8.33 12L8.33 9.36L10.11 9.36L10.11 8.24L8.33 8.24L8.33 6.71L10.52 6.71L10.52 5.6L7.22 5.6Z",
        "fill": "accent"
      },
      {
        "type": "polygon",
        "d": "M14.78 10.89L12.69 10.89L12.69 5.6L11.58 5.6L11.58 12L14.78 12Z",
        "fill": "accent"
      }
    ],
    "golilla": [
      {
        "type": "polygon",
        "d": "M7.69 6.87L7.19 6.77L6.69 6.87L6.26 7.15L5.98 7.58L5.89 8.05L5.89 8.75L5.98 9.22L6.26 9.65L6.69 9.93L7.19 10.03L7.69 9.93L8.12 9.65L8.4 9.22L8.49 8.75L8.49 8.05L8.4 7.58L8.12 7.15Z",
        "fill": "accent"
      },
      {
        "type": "polygon",
        "d": "M7.93 8.69L7.87 9L7.71 9.24L7.47 9.4L7.19 9.46L6.91 9.4L6.67 9.24L6.51 9L6.45 8.69L6.45 8.11L6.51 7.8L6.67 7.56L6.91 7.4L7.19 7.34L7.47 7.4L7.71 7.56L7.87 7.8L7.93 8.11Z",
        "fill": "truck"
      },
      {
        "type": "polygon",
        "d": "M19.1 9.92L18.5 6.77L17.23 6.77L16.63 9.92L17.18 10.03L17.35 9.17L18.38 9.17L18.55 10.03Z",
        "fill": "accent"
      },
      {
        "type": "polygon",
        "d": "M17.45 8.6L17.69 7.34L18.03 7.34L18.27 8.6Z",
        "fill": "truck"
      },
      {
        "type": "polygon",
        "d": "M4.37 9.41L4.12 9.46L3.87 9.41L3.66 9.27L3.52 9.05L3.46 8.78L3.46 8.02L3.5 7.79L3.6 7.61L3.74 7.46L3.93 7.37L4.13 7.34L4.33 7.38L4.52 7.47L4.69 7.65L5.1 7.26L4.86 7.01L4.52 6.83L4.14 6.77L3.75 6.83L3.41 7L3.13 7.27L2.96 7.61L2.9 7.97L2.9 8.83L2.99 9.27L3.25 9.67L3.65 9.94L4.12 10.03L4.59 9.94L4.99 9.67L5.26 9.27L5.35 8.83L5.35 8.25L4.12 8.25L4.12 8.82L4.77 8.82L4.73 9.05L4.59 9.27Z",
        "fill": "accent"
      },
      {
        "type": "polygon",
        "d": "M15.03 9.46L15.03 6.77L14.46 6.77L14.46 10.03L16.09 10.03L16.09 9.46Z",
        "fill": "accent"
      },
      {
        "type": "polygon",
        "d": "M12.86 9.46L12.86 6.77L12.3 6.77L12.3 10.03L13.93 10.03L13.93 9.46Z",
        "fill": "accent"
      },
      {
        "type": "polygon",
        "d": "M9.6 9.46L9.6 6.77L9.03 6.77L9.03 10.03L10.66 10.03L10.66 9.46Z",
        "fill": "accent"
      },
      {
        "type": "polygon",
        "d": "M11.2 6.77L11.2 10.03L11.76 10.03L11.76 6.77Z",
        "fill": "accent"
      },
      {
        "type": "polygon",
        "d": "M8.49 10.58L8.49 11.23L2.9 11.23L2.9 10.58Z",
        "fill": "#ffd100"
      }
    ],
    "logista-parcel": [
      {
        "type": "polygon",
        "d": "M6.78 7.24L6.27 7.14L5.76 7.24L5.33 7.53L5.04 7.96L4.95 8.44L4.95 9.16L5.04 9.64L5.33 10.07L5.76 10.36L6.27 10.46L6.78 10.36L7.22 10.07L7.5 9.64L7.6 9.16L7.6 8.44L7.5 7.96L7.22 7.53Z",
        "fill": "accent"
      },
      {
        "type": "polygon",
        "d": "M6.96 9.41L6.8 9.66L6.56 9.82L6.27 9.87L5.99 9.82L5.75 9.66L5.58 9.41L5.52 9.1L5.52 8.5L5.58 8.19L5.75 7.94L5.99 7.78L6.27 7.73L6.56 7.78L6.8 7.94L6.96 8.19L7.03 8.5L7.03 9.1Z",
        "fill": "truck"
      },
      {
        "type": "polygon",
        "d": "M19.1 10.35L18.49 7.15L17.2 7.15L16.59 10.35L17.15 10.45L17.32 9.58L18.37 9.58L18.54 10.45Z",
        "fill": "accent"
      },
      {
        "type": "polygon",
        "d": "M17.43 9.01L17.67 7.72L18.02 7.72L18.26 9.01Z",
        "fill": "truck"
      },
      {
        "type": "polygon",
        "d": "M9.64 9.82L9.39 9.87L9.14 9.82L8.92 9.68L8.78 9.46L8.72 9.18L8.72 8.41L8.76 8.18L8.85 8L9 7.85L9.19 7.75L9.4 7.72L9.6 7.76L9.79 7.86L9.97 8.04L10.38 7.64L10.14 7.39L9.79 7.21L9.4 7.14L9.01 7.2L8.66 7.38L8.38 7.65L8.2 8L8.15 8.37L8.15 9.24L8.24 9.69L8.51 10.09L8.91 10.36L9.39 10.46L9.87 10.36L10.27 10.09L10.54 9.69L10.63 9.24L10.63 8.65L9.39 8.65L9.39 9.22L10.05 9.22L10 9.46L9.86 9.68Z",
        "fill": "accent"
      },
      {
        "type": "polygon",
        "d": "M12.3 8.28L12.71 8.88L13.78 9.21L13.94 9.44L13.89 9.68L13.61 9.88L13.22 9.88L12.85 9.62L12.52 10.09L13.03 10.45L13.8 10.45L14.4 10.02L14.55 9.32L14.13 8.72L13.07 8.39L12.91 8.16L12.97 7.91L13.23 7.72L13.6 7.72L13.95 7.98L14.29 7.52L13.79 7.15L13.04 7.15L12.45 7.58Z",
        "fill": "accent"
      },
      {
        "type": "polygon",
        "d": "M14.84 7.72L15.4 7.72L15.4 10.45L15.97 10.45L15.97 7.72L16.53 7.72L16.53 7.15L14.84 7.15Z",
        "fill": "accent"
      },
      {
        "type": "polygon",
        "d": "M3.47 9.88L3.47 7.15L2.9 7.15L2.9 10.45L4.55 10.45L4.55 9.88Z",
        "fill": "accent"
      },
      {
        "type": "polygon",
        "d": "M11.18 7.15L11.18 10.45L11.75 10.45L11.75 7.15Z",
        "fill": "accent"
      }
    ],
    "lucky-fast-express": [
      {
        "type": "polygon",
        "d": "M12.9 8.27L13.34 6.81L16.07 6.81L16.07 5.75L12.55 5.75L10.77 11.7L11.78 12L12.59 9.33L14.85 9.33L14.85 8.27Z",
        "fill": "#1e3c72"
      },
      {
        "type": "polygon",
        "d": "M9.76 11.85L9.76 10.79L7.35 10.79L8.82 5.9L7.8 5.6L5.93 11.85Z",
        "fill": "#1e3c72"
      }
    ],
    "megacity-courier": [
      {
        "type": "polygon",
        "d": "M4.82 10.04L5.26 10.13L5.78 7.51L5.17 7.51L4.28 8.98L3.99 7.51L3.41 7.51L2.9 10.04L3.34 10.13L3.7 8.34L3.93 9.49L4.5 9.49L5.14 8.42Z",
        "fill": "accent"
      },
      {
        "type": "polygon",
        "d": "M11.78 7.51L10.76 7.51L9.8 9.97L10.22 10.13L10.5 9.41L11.31 9.41L11.3 10.04L11.75 10.05Z",
        "fill": "accent"
      },
      {
        "type": "polygon",
        "d": "M10.67 8.96L11.06 7.96L11.32 7.96L11.31 8.96Z",
        "fill": "truck"
      },
      {
        "type": "polygon",
        "d": "M8.54 9.64L8.36 9.6L8.23 9.5L8.17 9.36L8.17 9.14L8.29 8.54L8.35 8.35L8.47 8.19L8.62 8.07L8.8 7.99L8.97 7.96L9.12 7.99L9.23 8.05L9.33 8.19L9.69 7.92L9.53 7.71L9.27 7.56L8.98 7.51L8.67 7.55L8.38 7.68L8.14 7.89L7.95 8.14L7.85 8.42L7.72 9.1L7.72 9.45L7.87 9.79L8.17 10.02L8.54 10.09L8.91 10.02L9.25 9.82L9.51 9.52L9.65 9.18L9.75 8.68L8.73 8.68L8.73 9.13L9.19 9.13L9.13 9.29L8.96 9.47L8.75 9.6Z",
        "fill": "accent"
      },
      {
        "type": "polygon",
        "d": "M7.14 9.64L6.24 9.64L6.37 9.02L7.18 9.02L7.18 8.58L6.46 8.58L6.58 7.96L7.57 7.96L7.57 7.51L6.21 7.51L5.7 10.09L7.14 10.09Z",
        "fill": "accent"
      },
      {
        "type": "polygon",
        "d": "M12.84 7.67L12.62 7.85L12.45 8.09L12.36 8.34L12.19 9.18L12.18 9.44L12.26 9.7L12.44 9.92L12.68 10.05L12.95 10.09L13.23 10.05L13.49 9.92L13.69 9.75L13.4 9.41L13.24 9.54L13.09 9.61L12.95 9.64L12.82 9.62L12.73 9.57L12.67 9.49L12.63 9.38L12.64 9.23L12.79 8.46L12.85 8.29L12.95 8.16L13.08 8.05L13.23 7.98L13.37 7.96L13.5 7.98L13.59 8.04L13.68 8.15L14.03 7.88L13.89 7.7L13.65 7.56L13.38 7.51L13.1 7.55Z",
        "fill": "accent"
      },
      {
        "type": "polygon",
        "d": "M17.69 8.83L17.45 10.04L17.89 10.13L18.14 8.9L19.1 7.78L18.76 7.49L17.99 8.39L17.6 7.54L17.19 7.73Z",
        "fill": "accent"
      },
      {
        "type": "polygon",
        "d": "M15.44 7.96L15.83 7.96L15.41 10.04L15.85 10.13L16.29 7.96L16.76 7.96L16.76 7.51L15.44 7.51Z",
        "fill": "accent"
      },
      {
        "type": "polygon",
        "d": "M14.58 7.47L14.06 10.04L14.5 10.13L15.02 7.56Z",
        "fill": "accent"
      }
    ],
    "mgl-express": [
      {
        "type": "polygon",
        "d": "M5.62 10.41L6.91 10.41L7.97 7.78L7.97 11.79L9.01 11.79L9.01 5.81L7.65 5.81L6.27 9.23L4.89 5.81L3.52 5.81L3.52 11.79L4.56 11.79L4.56 7.78Z",
        "fill": "accent"
      },
      {
        "type": "polygon",
        "d": "M13.1 10.39L12.71 10.65L12.25 10.74L11.79 10.65L11.4 10.39L11.14 10L11.04 9.49L11.04 8.1L11.1 7.68L11.28 7.34L11.55 7.08L11.89 6.91L12.26 6.85L12.64 6.92L12.97 7.09L13.29 7.42L14.04 6.7L13.6 6.25L12.97 5.92L12.27 5.8L11.57 5.9L10.93 6.22L10.43 6.72L10.1 7.35L10 8.02L10 9.59L10.16 10.4L10.65 11.14L11.38 11.63L12.25 11.8L13.11 11.63L13.85 11.14L14.34 10.4L14.5 9.59L14.5 8.53L12.25 8.53L12.25 9.56L13.45 9.56L13.36 10Z",
        "fill": "accent"
      },
      {
        "type": "polygon",
        "d": "M18.48 10.75L16.53 10.75L16.53 5.81L15.49 5.81L15.49 11.79L18.48 11.79Z",
        "fill": "accent"
      }
    ],
    "miller-deliveries": [
      {
        "type": "polygon",
        "d": "M5.8 8.13L5.8 10.75L6.48 10.75L6.48 6.85L5.59 6.85L4.69 9.08L3.79 6.85L2.9 6.85L2.9 10.75L3.58 10.75L3.58 8.13L4.27 9.85L5.11 9.85Z",
        "fill": "accent"
      },
      {
        "type": "polygon",
        "d": "M19.1 10.32L18.13 9.16L18.35 9.12L18.74 8.86L18.99 8.48L19.08 8.03L18.99 7.57L18.74 7.19L18.35 6.93L17.93 6.85L16.4 6.85L16.4 10.75L17.08 10.75L17.08 9.2L17.28 9.2L18.58 10.75Z",
        "fill": "accent"
      },
      {
        "type": "polygon",
        "d": "M18.25 7.68L18.36 7.84L18.39 8.03L18.36 8.21L18.25 8.37L18.09 8.48L17.87 8.53L17.08 8.53L17.08 7.53L17.87 7.53L18.09 7.57Z",
        "fill": "truck"
      },
      {
        "type": "polygon",
        "d": "M15.76 10.07L14.32 10.07L14.32 9.14L15.49 9.14L15.49 8.46L14.32 8.46L14.32 7.53L15.76 7.53L15.76 6.85L13.64 6.85L13.64 10.75L15.76 10.75Z",
        "fill": "accent"
      },
      {
        "type": "polygon",
        "d": "M9.13 10.07L9.13 6.85L8.45 6.85L8.45 10.75L10.4 10.75L10.4 10.07Z",
        "fill": "accent"
      },
      {
        "type": "polygon",
        "d": "M11.72 10.07L11.72 6.85L11.05 6.85L11.05 10.75L13 10.75L13 10.07Z",
        "fill": "accent"
      },
      {
        "type": "polygon",
        "d": "M7.13 6.85L7.13 10.75L7.8 10.75L7.8 6.85Z",
        "fill": "accent"
      }
    ],
    "mobel-services": [
      {
        "type": "polygon",
        "d": "M9.36 7.44L8.75 7.32L8.14 7.44L7.63 7.79L7.28 8.3L7.17 8.88L7.17 9.72L7.28 10.3L7.63 10.81L8.14 11.16L8.75 11.28L9.36 11.16L9.87 10.81L10.22 10.3L10.33 9.72L10.33 8.88L10.22 8.3L9.87 7.79Z",
        "fill": "accent"
      },
      {
        "type": "polygon",
        "d": "M9.57 10.03L9.38 10.32L9.09 10.51L8.75 10.58L8.41 10.51L8.12 10.32L7.93 10.03L7.85 9.66L7.85 8.94L7.93 8.57L8.12 8.28L8.41 8.09L8.75 8.02L9.09 8.09L9.38 8.28L9.57 8.57L9.65 8.94L9.65 9.66Z",
        "fill": "truck"
      },
      {
        "type": "polygon",
        "d": "M13.34 8.83L13.39 8.54L13.39 8.33L13.34 8.04L13.19 7.75L12.96 7.52L12.67 7.37L12.38 7.33L10.98 7.33L10.98 11.27L12.6 11.27L12.92 11.22L13.23 11.06L13.48 10.81L13.64 10.5L13.69 10.18L13.69 9.95L13.64 9.63L13.48 9.32L13.22 9.07Z",
        "fill": "accent"
      },
      {
        "type": "polygon",
        "d": "M11.67 9.54L12.54 9.54L12.7 9.57L12.82 9.63L12.92 9.73L12.98 9.85L13 10.01L13 10.13L12.98 10.29L12.92 10.41L12.82 10.5L12.7 10.56L12.54 10.59L11.67 10.59Z",
        "fill": "truck"
      },
      {
        "type": "polygon",
        "d": "M12.63 8.16L12.68 8.25L12.7 8.39L12.7 8.49L12.68 8.62L12.63 8.71L12.56 8.79L12.46 8.84L12.33 8.86L11.67 8.86L11.67 8.01L12.33 8.01L12.46 8.03L12.56 8.08Z",
        "fill": "truck"
      },
      {
        "type": "polygon",
        "d": "M5.83 8.63L5.83 11.27L6.52 11.27L6.52 7.33L5.62 7.33L4.71 9.59L3.8 7.33L2.9 7.33L2.9 11.27L3.58 11.27L3.58 8.63L4.28 10.36L5.14 10.36Z",
        "fill": "accent"
      },
      {
        "type": "polygon",
        "d": "M16.48 10.59L15.03 10.59L15.03 9.64L16.21 9.64L16.21 8.96L15.03 8.96L15.03 8.01L16.48 8.01L16.48 7.33L14.34 7.33L14.34 11.27L16.48 11.27Z",
        "fill": "accent"
      },
      {
        "type": "polygon",
        "d": "M17.81 10.59L17.81 7.33L17.13 7.33L17.13 11.27L19.1 11.27L19.1 10.59Z",
        "fill": "accent"
      },
      {
        "type": "circle",
        "cx": 8.06,
        "cy": 6.38,
        "r": 0.42,
        "fill": "accent"
      },
      {
        "type": "circle",
        "cx": 9.45,
        "cy": 6.38,
        "r": 0.42,
        "fill": "accent"
      }
    ],
    "nk-logistic": [
      {
        "type": "polygon",
        "d": "M10.67 11.8L10.67 5.8L9.63 5.8L9.63 10.23L6.98 5.8L5.66 5.8L5.66 11.8L6.71 11.8L6.71 7.37L9.36 11.8Z",
        "fill": "accent"
      },
      {
        "type": "polygon",
        "d": "M13.44 8.93L15.49 11.8L16.34 11.2L14.25 8.26L16.23 6.6L15.57 5.8L12.71 8.18L12.71 5.8L11.66 5.8L11.66 11.8L12.71 11.8L12.71 9.54Z",
        "fill": "accent"
      }
    ],
    "penta-express": [
      {
        "type": "polygon",
        "d": "M7.53 9.17L8.88 9.17L8.88 8.43L7.68 8.43L7.88 7.4L9.52 7.4L9.52 6.66L7.27 6.66L6.42 10.94L8.82 10.94L8.82 10.2L7.32 10.2Z",
        "fill": "#3c3055"
      },
      {
        "type": "polygon",
        "d": "M12.74 6.59L12.02 10.2L11.74 10.2L12.1 6.66L10.39 6.66L9.55 10.87L10.28 11.01L11 7.4L11.28 7.4L10.92 10.94L12.63 10.94L13.47 6.73Z",
        "fill": "#3c3055"
      },
      {
        "type": "polygon",
        "d": "M17.41 6.66L15.82 10.73L16.51 11L16.98 9.81L18.33 9.81L18.32 10.86L19.06 10.87L19.1 6.66Z",
        "fill": "#3c3055"
      },
      {
        "type": "polygon",
        "d": "M18.35 7.4L18.33 9.07L17.27 9.07L17.92 7.4Z",
        "fill": "truck"
      },
      {
        "type": "polygon",
        "d": "M6.28 7.52L6.07 7.06L5.67 6.76L5.21 6.66L3.74 6.66L2.9 10.87L3.63 11.01L3.98 9.24L4.84 9.24L5.31 9.15L5.75 8.89L6.09 8.5L6.28 8.02Z",
        "fill": "#3c3055"
      },
      {
        "type": "polygon",
        "d": "M5.54 7.88L5.45 8.11L5.27 8.31L5.04 8.45L4.77 8.5L4.13 8.5L4.35 7.4L5.14 7.4L5.35 7.45L5.47 7.54L5.54 7.68Z",
        "fill": "truck"
      },
      {
        "type": "polygon",
        "d": "M14.85 11.01L15.57 7.4L16.36 7.4L16.36 6.66L14.17 6.66L14.17 7.4L14.82 7.4L14.12 10.87Z",
        "fill": "#3c3055"
      }
    ],
    "pxc-pacific": [
      {
        "type": "polygon",
        "d": "M7.73 8.9L8.12 8.31L8.26 7.61L8.12 6.92L7.73 6.33L7.14 5.93L6.49 5.81L4.34 5.81L4.34 11.79L5.38 11.79L5.38 9.42L6.49 9.42L7.14 9.29Z",
        "fill": "accent"
      },
      {
        "type": "polygon",
        "d": "M6.98 7.08L7.14 7.32L7.2 7.61L7.14 7.9L6.98 8.15L6.73 8.31L6.39 8.38L5.38 8.38L5.38 6.85L6.39 6.85L6.73 6.91Z",
        "fill": "truck"
      },
      {
        "type": "polygon",
        "d": "M12.52 5.81L11.17 7.86L9.82 5.81L8.95 6.38L10.55 8.8L8.95 11.22L9.82 11.79L11.17 9.74L12.52 11.79L13.39 11.22L11.79 8.8L13.39 6.38Z",
        "fill": "accent"
      },
      {
        "type": "polygon",
        "d": "M14.83 6.19L14.37 6.64L14.07 7.22L13.98 7.82L13.98 9.78L14.07 10.38L14.37 10.96L14.83 11.41L15.41 11.7L16.05 11.8L16.69 11.69L17.27 11.39L17.66 10.98L16.91 10.26L16.64 10.55L16.35 10.69L16.04 10.75L15.73 10.7L15.44 10.56L15.22 10.34L15.07 10.05L15.02 9.7L15.02 7.9L15.07 7.55L15.22 7.26L15.44 7.04L15.73 6.9L16.04 6.85L16.35 6.91L16.64 7.05L16.91 7.34L17.66 6.62L17.27 6.21L16.69 5.91L16.05 5.8L15.41 5.9Z",
        "fill": "accent"
      }
    ],
    "servex": [
      {
        "type": "polygon",
        "d": "M3.33 8.88L4.43 9.23L4.6 9.47L4.54 9.71L4.26 9.92L3.85 9.92L3.47 9.65L3.12 10.13L3.66 10.51L4.45 10.51L5.08 10.07L5.23 9.34L4.79 8.72L3.7 8.38L3.53 8.13L3.59 7.88L3.86 7.68L4.24 7.68L4.6 7.95L4.96 7.47L4.44 7.09L3.66 7.09L3.06 7.54L2.9 8.26Z",
        "fill": "accent"
      },
      {
        "type": "polygon",
        "d": "M7.42 9.1L7.42 8.5L6.39 8.5L6.39 7.68L7.65 7.68L7.65 7.09L5.8 7.09L5.8 10.51L7.65 10.51L7.65 9.92L6.39 9.92L6.39 9.1Z",
        "fill": "accent"
      },
      {
        "type": "polygon",
        "d": "M10.27 7.39L9.93 7.16L9.56 7.09L8.22 7.09L8.22 10.51L8.81 10.51L8.81 9.15L8.99 9.15L10.13 10.51L10.59 10.13L9.74 9.12L9.93 9.08L10.27 8.86L10.49 8.52L10.57 8.12L10.49 7.72Z",
        "fill": "accent"
      },
      {
        "type": "polygon",
        "d": "M9.84 8.43L9.7 8.52L9.51 8.56L8.81 8.56L8.81 7.68L9.51 7.68L9.7 7.72L9.84 7.81L9.93 7.96L9.97 8.12L9.93 8.29Z",
        "fill": "truck"
      },
      {
        "type": "polygon",
        "d": "M11.56 7.09L10.97 7.2L11.6 10.51L12.95 10.51L13.57 7.2L12.99 7.09L12.45 9.92L12.1 9.92Z",
        "fill": "accent"
      },
      {
        "type": "polygon",
        "d": "M15.76 9.1L15.76 8.5L14.73 8.5L14.73 7.68L15.99 7.68L15.99 7.09L14.14 7.09L14.14 10.51L15.99 10.51L15.99 9.92L14.73 9.92L14.73 9.1Z",
        "fill": "accent"
      },
      {
        "type": "polygon",
        "d": "M17.06 7.09L16.56 7.42L17.47 8.8L16.56 10.18L17.06 10.51L17.83 9.34L18.6 10.51L19.1 10.18L18.19 8.8L19.1 7.42L18.6 7.09L17.83 8.26Z",
        "fill": "accent"
      }
    ],
    "skladusa": [
      {
        "type": "polygon",
        "d": "M5.95 6.84L6.11 7.07L6.06 7.3L5.79 7.5L5.4 7.5L5.04 7.24L4.71 7.7L5.22 8.06L5.97 8.06L6.56 7.64L6.71 6.95L6.3 6.36L5.26 6.04L5.1 5.81L5.15 5.57L5.41 5.38L5.78 5.38L6.12 5.63L6.45 5.18L5.96 4.81L5.22 4.81L4.65 5.24L4.5 5.93L4.9 6.51Z",
        "fill": "#3d3d3e"
      },
      {
        "type": "polygon",
        "d": "M7.25 4.81L7.25 8.06L7.81 8.06L7.81 6.82L8.09 6.55L8.98 8.06L9.46 7.77L8.5 6.14L9.42 5.21L9.02 4.81L7.81 6.03L7.81 4.81Z",
        "fill": "#3d3d3e"
      },
      {
        "type": "polygon",
        "d": "M10 8.06L11.62 8.06L11.62 7.5L10.56 7.5L10.56 4.81L10 4.81Z",
        "fill": "#3d3d3e"
      },
      {
        "type": "polygon",
        "d": "M12.16 7.96L12.71 8.06L12.88 7.2L13.91 7.2L14.07 8.06L14.63 7.96L14.03 4.81L12.76 4.81Z",
        "fill": "#3d3d3e"
      },
      {
        "type": "polygon",
        "d": "M13.8 6.64L12.99 6.64L13.22 5.38L13.56 5.38Z",
        "fill": "truck"
      },
      {
        "type": "polygon",
        "d": "M17.28 7.25L17.44 6.86L17.5 6.44L17.44 6.02L17.28 5.62L17.02 5.29L16.69 5.03L16.3 4.87L15.89 4.81L15.16 4.81L15.16 8.06L15.89 8.06L16.3 8.01L16.69 7.85L17.02 7.59Z",
        "fill": "#3d3d3e"
      },
      {
        "type": "polygon",
        "d": "M16.9 6.16L16.93 6.44L16.9 6.71L16.79 6.97L16.62 7.19L16.4 7.35L16.15 7.46L15.86 7.5L15.73 7.5L15.73 5.38L15.86 5.38L16.15 5.42L16.4 5.52L16.62 5.69L16.79 5.91Z",
        "fill": "truck"
      },
      {
        "type": "polygon",
        "d": "M10.27 11.24L11.31 11.56L11.48 11.79L11.42 12.03L11.15 12.22L10.76 12.22L10.4 11.96L10.08 12.42L10.58 12.78L11.33 12.78L11.93 12.36L12.08 11.67L11.66 11.08L10.62 10.76L10.47 10.53L10.52 10.29L10.78 10.1L11.14 10.1L11.48 10.35L11.82 9.9L11.33 9.54L10.59 9.54L10.01 9.96L9.87 10.65Z",
        "fill": "#3d3d3e"
      },
      {
        "type": "polygon",
        "d": "M13.03 9.54L12.43 12.68L12.99 12.78L13.15 11.92L14.18 11.92L14.34 12.78L14.9 12.68L14.3 9.54Z",
        "fill": "#3d3d3e"
      },
      {
        "type": "polygon",
        "d": "M13.83 10.1L14.07 11.36L13.26 11.36L13.5 10.1Z",
        "fill": "truck"
      },
      {
        "type": "polygon",
        "d": "M7.93 12.75L8.22 12.79L8.5 12.75L8.77 12.64L9 12.46L9.18 12.23L9.29 11.96L9.33 11.69L9.33 9.54L8.77 9.54L8.77 11.65L8.74 11.81L8.69 11.94L8.6 12.06L8.49 12.14L8.36 12.2L8.22 12.22L8.07 12.2L7.94 12.14L7.83 12.06L7.74 11.94L7.69 11.81L7.67 11.65L7.67 9.54L7.1 9.54L7.1 11.69L7.14 11.96L7.25 12.23L7.43 12.46L7.66 12.64Z",
        "fill": "#3d3d3e"
      }
    ],
    "tamex": [
      {
        "type": "polygon",
        "d": "M11.84 11.29L12.54 11.29L12.54 6.31L10.68 9.41L8.81 6.31L8.81 11.29L9.52 11.29L9.52 8.85L10.68 10.79L11.84 8.85Z",
        "fill": "accent"
      },
      {
        "type": "polygon",
        "d": "M3.59 7.93L3.59 11.29L4.29 11.29L4.29 7.93L4.98 7.93L4.98 7.23L2.9 7.23L2.9 7.93Z",
        "fill": "accent"
      },
      {
        "type": "polygon",
        "d": "M5.8 7.23L5.05 11.16L5.75 11.29L5.95 10.22L7.24 10.22L7.45 11.29L8.14 11.16L7.39 7.23Z",
        "fill": "accent"
      },
      {
        "type": "polygon",
        "d": "M6.38 7.93L6.81 7.93L7.11 9.51L6.08 9.51Z",
        "fill": "truck"
      },
      {
        "type": "polygon",
        "d": "M15.41 10.59L13.92 10.59L13.92 9.61L15.14 9.61L15.14 8.91L13.92 8.91L13.92 7.93L15.41 7.93L15.41 7.23L13.21 7.23L13.21 11.29L15.41 11.29Z",
        "fill": "#e87a25"
      },
      {
        "type": "polygon",
        "d": "M19.1 7.62L18.51 7.23L17.59 8.62L16.67 7.23L16.08 7.62L17.17 9.26L16.08 10.9L16.67 11.29L17.59 9.9L18.51 11.29L19.1 10.9L18.02 9.26Z",
        "fill": "#e87a25"
      }
    ],
    "transfera": [
      {
        "type": "polygon",
        "d": "M13.2 14.7L13.22 13.43L13.69 13.37L14.27 13.22L14.77 12.97L15.02 12.79L15.29 12.52L15.53 12.19L15.87 11.45L16.04 10.7L16.12 10.04L16.14 8.79L16.03 7.72L15.78 6.8L15.54 6.31L15.15 5.81L14.85 5.54L14.19 5.19L13.61 5.04L12.7 4.99L12.12 5.04L11.37 5.28L10.96 5.55L10.69 5.81L10.28 6.47L10.1 7.05L9.42 10.29L9.14 10.55L8.89 10.58L8.47 10.54L8.19 10.37L8.03 10.04L7.98 9.54L8.05 8.96L8.28 8.54L8.56 8.36L8.64 8.37L8.66 9.37L8.72 9.43L9.89 6.8L9.81 6.56L8.72 4.1L8.65 4.24L8.64 5.26L8.56 5.32L8.22 5.37L7.64 5.55L7.23 5.78L6.98 5.98L6.54 6.47L6.28 6.97L6.12 7.38L5.97 8.05L5.89 8.71L5.86 9.87L5.97 10.87L6.2 11.69L6.46 12.19L6.82 12.61L7.31 12.97L7.89 13.2L8.47 13.3L9.47 13.3L10.21 13.14L10.71 12.94L11.32 12.52L11.47 12.36L11.73 11.94L11.89 11.45L12.42 8.88L12.57 8.38L12.71 8.21L12.95 8.1L13.28 8.1L13.53 8.18L13.72 8.38L13.82 8.63L13.88 9.13L13.78 9.79L13.71 9.95L13.53 10.13L13.28 10.24L13.21 10.2L13.2 9.26L13.11 9.34L11.96 11.94L12 12.11L13.09 14.59Z",
        "fill": "accent"
      }
    ],
    "u-envios": [
      {
        "type": "polygon",
        "d": "M7.79 9.04L7.79 8.56L6.94 8.56L6.94 7.88L7.98 7.88L7.98 7.39L6.46 7.39L6.46 10.21L7.98 10.21L7.98 9.72L6.94 9.72L6.94 9.04Z",
        "fill": "#9a328a"
      },
      {
        "type": "polygon",
        "d": "M9.98 9.72L9.79 9.72L9.56 7.39L8.44 7.39L8.44 10.21L8.93 10.21L8.93 7.88L9.12 7.88L9.35 10.21L10.47 10.21L10.47 7.39L9.98 7.39Z",
        "fill": "#9a328a"
      },
      {
        "type": "polygon",
        "d": "M11.41 7.39L10.93 7.48L11.45 10.21L12.55 10.21L13.07 7.48L12.59 7.39L12.14 9.72L11.85 9.72Z",
        "fill": "#9a328a"
      },
      {
        "type": "polygon",
        "d": "M14.02 7.39L13.53 7.39L13.53 10.21L14.02 10.21Z",
        "fill": "#9a328a"
      },
      {
        "type": "polygon",
        "d": "M14.81 7.72L14.56 8.09L14.48 8.5L14.48 9.1L14.56 9.51L14.81 9.88L15.18 10.12L15.61 10.21L16.04 10.12L16.41 9.88L16.66 9.51L16.74 9.1L16.74 8.5L16.66 8.09L16.41 7.72L16.04 7.48L15.61 7.39L15.18 7.48Z",
        "fill": "#9a328a"
      },
      {
        "type": "polygon",
        "d": "M15.85 9.66L15.61 9.71L15.37 9.66L15.16 9.53L15.02 9.32L14.97 9.05L14.97 8.55L15.02 8.28L15.16 8.07L15.37 7.94L15.61 7.89L15.85 7.94L16.06 8.07L16.2 8.28L16.25 8.55L16.25 9.05L16.2 9.32L16.06 9.53Z",
        "fill": "truck"
      },
      {
        "type": "polygon",
        "d": "M18.44 9.15L18.58 9.35L18.53 9.55L18.3 9.72L17.96 9.72L17.65 9.5L17.37 9.89L17.81 10.21L18.45 10.21L18.97 9.84L19.1 9.24L18.74 8.73L17.84 8.45L17.71 8.25L17.75 8.05L17.97 7.88L18.29 7.88L18.58 8.1L18.87 7.71L18.45 7.39L17.81 7.39L17.31 7.76L17.18 8.36L17.53 8.87Z",
        "fill": "#9a328a"
      },
      {
        "type": "polygon",
        "d": "M4.11 10.18L4.35 10.08L4.55 9.93L4.7 9.72L4.8 9.49L4.83 9.26L4.83 7.39L4.34 7.39L4.34 9.23L4.32 9.36L4.28 9.48L4.2 9.58L4.1 9.65L3.99 9.7L3.86 9.72L3.74 9.7L3.63 9.65L3.53 9.58L3.45 9.48L3.41 9.36L3.39 9.23L3.39 7.39L2.9 7.39L2.9 9.26L2.93 9.49L3.03 9.72L3.18 9.93L3.38 10.08L3.61 10.18L3.86 10.21Z",
        "fill": "#9a328a"
      },
      {
        "type": "polygon",
        "d": "M5.29 9.16L5.99 9.16L5.99 8.67L5.29 8.67Z",
        "fill": "#9a328a"
      }
    ],
    "us-cargo": [
      {
        "type": "polygon",
        "d": "M6.9 8.03L7.19 8.07L7.48 8.03L7.75 7.93L8 7.76L8.2 7.54L8.35 7.29L8.44 7.03L8.82 4.89L8.27 4.79L7.89 6.89L7.84 7.06L7.75 7.2L7.63 7.33L7.49 7.43L7.34 7.49L7.19 7.51L7.06 7.49L6.95 7.44L6.87 7.37L6.81 7.27L6.78 7.15L6.79 6.99L7.17 4.89L6.62 4.79L6.23 6.93L6.22 7.2L6.28 7.48L6.43 7.73L6.64 7.91Z",
        "fill": "#231f20"
      },
      {
        "type": "polygon",
        "d": "M11.51 6.52L12.49 6.85L12.59 7.04L12.49 7.29L12.15 7.51L11.76 7.51L11.46 7.26L11.11 7.7L11.56 8.07L12.31 8.07L12.94 7.67L13.2 7.01L12.87 6.39L11.9 6.06L11.81 5.87L11.91 5.61L12.23 5.4L12.59 5.4L12.87 5.64L13.24 5.22L12.8 4.84L12.07 4.84L11.45 5.24L11.19 5.9Z",
        "fill": "#231f20"
      },
      {
        "type": "polygon",
        "d": "M11.05 6.93L10.25 6.89L10.11 6.17L9.71 6.89L9 6.92L9.47 7.36L9.1 8.18L9.89 7.71L10.39 8.09L10.33 7.43Z",
        "fill": "#231f20"
      },
      {
        "type": "polygon",
        "d": "M15.78 6.93L14.98 6.89L14.84 6.17L14.44 6.89L13.73 6.92L14.2 7.36L13.83 8.18L14.62 7.71L15.12 8.09L15.06 7.43Z",
        "fill": "#231f20"
      },
      {
        "type": "polygon",
        "d": "M4.51 9.96L4.3 10.25L4.2 10.57L4.01 11.62L4 11.95L4.11 12.28L4.33 12.54L4.63 12.71L4.97 12.76L5.32 12.7L5.64 12.55L5.89 12.34L5.52 11.91L5.33 12.08L5.15 12.16L4.97 12.19L4.81 12.17L4.69 12.1L4.61 12L4.56 11.87L4.57 11.68L4.74 10.71L4.81 10.51L4.92 10.34L5.09 10.21L5.27 10.12L5.45 10.1L5.6 10.12L5.72 10.19L5.84 10.34L6.28 9.99L6.1 9.76L5.8 9.59L5.46 9.53L5.11 9.58L4.78 9.73Z",
        "fill": "#231f20"
      },
      {
        "type": "polygon",
        "d": "M15.94 9.89L15.6 10.29L15.42 10.75L15.3 11.44L15.31 11.92L15.52 12.36L15.92 12.66L16.41 12.76L16.91 12.67L17.36 12.4L17.7 12L17.88 11.54L18 10.85L17.99 10.37L17.77 9.93L17.38 9.63L16.89 9.53L16.39 9.62Z",
        "fill": "#231f20"
      },
      {
        "type": "polygon",
        "d": "M16.41 12.19L16.15 12.14L15.97 12L15.87 11.79L15.86 11.49L15.97 10.9L16.09 10.58L16.3 10.33L16.59 10.16L16.89 10.1L17.14 10.15L17.33 10.29L17.43 10.5L17.44 10.8L17.33 11.39L17.21 11.71L17 11.96L16.71 12.13Z",
        "fill": "truck"
      },
      {
        "type": "polygon",
        "d": "M12.97 12.02L12.87 11.83L12.87 11.57L13 10.82L13.08 10.58L13.22 10.38L13.41 10.23L13.63 10.13L13.84 10.1L14.03 10.13L14.17 10.21L14.31 10.38L14.75 10.04L14.55 9.78L14.22 9.6L13.85 9.53L13.47 9.58L13.11 9.75L12.8 10L12.58 10.33L12.46 10.68L12.31 11.52L12.32 11.97L12.52 12.39L12.89 12.67L13.35 12.76L13.82 12.67L14.25 12.42L14.56 12.05L14.73 11.62L14.84 11L13.57 11L13.57 11.56L14.15 11.56L14.07 11.76L13.88 11.99L13.62 12.14L13.36 12.19L13.13 12.15Z",
        "fill": "#231f20"
      },
      {
        "type": "polygon",
        "d": "M6.88 12.8L7.21 11.9L8.23 11.9L8.24 12.71L8.8 12.7L8.76 9.53L7.49 9.53L6.36 12.61Z",
        "fill": "#231f20"
      },
      {
        "type": "polygon",
        "d": "M7.42 11.34L7.88 10.09L8.21 10.09L8.22 11.34Z",
        "fill": "truck"
      },
      {
        "type": "polygon",
        "d": "M11.77 9.83L11.47 9.6L11.12 9.53L9.9 9.53L9.33 12.71L9.88 12.81L10.12 11.48L10.31 11.48L11.14 12.73L11.61 12.42L10.97 11.46L11.22 11.41L11.55 11.21L11.81 10.91L11.94 10.55L11.94 10.17Z",
        "fill": "#231f20"
      },
      {
        "type": "polygon",
        "d": "M11.32 10.63L11.19 10.78L11.02 10.88L10.82 10.92L10.22 10.92L10.37 10.09L11.07 10.09L11.23 10.13L11.32 10.2L11.38 10.31L11.38 10.46Z",
        "fill": "truck"
      }
    ],
    "vert-chez-vous": [
      {
        "type": "polygon",
        "d": "M7.9 5.9L7.49 5.98L7.93 8.26L8.85 8.26L9.28 5.98L8.88 5.9L8.51 7.85L8.27 7.85Z",
        "fill": "#53585b"
      },
      {
        "type": "polygon",
        "d": "M10.79 6.88L10.08 6.88L10.08 6.31L10.95 6.31L10.95 5.9L9.67 5.9L9.67 8.26L10.95 8.26L10.95 7.85L10.08 7.85L10.08 7.29L10.79 7.29Z",
        "fill": "#53585b"
      },
      {
        "type": "polygon",
        "d": "M2.9 10.13L2.9 10.9L2.94 11.14L3.05 11.36L3.24 11.54L3.46 11.66L3.72 11.69L3.97 11.65L4.2 11.53L4.35 11.37L4.06 11.09L3.95 11.2L3.84 11.26L3.71 11.28L3.59 11.26L3.48 11.21L3.39 11.12L3.33 11.01L3.31 10.87L3.31 10.16L3.33 10.02L3.39 9.91L3.48 9.82L3.59 9.76L3.71 9.75L3.84 9.77L3.95 9.83L4.06 9.94L4.35 9.65L4.2 9.49L3.97 9.37L3.72 9.33L3.46 9.37L3.24 9.48L3.05 9.66L2.94 9.89Z",
        "fill": "#53585b"
      },
      {
        "type": "polygon",
        "d": "M6.36 9.33L5.95 9.33L5.95 10.31L5.15 10.31L5.15 9.33L4.74 9.33L4.74 11.69L5.15 11.69L5.15 10.72L5.95 10.72L5.95 11.69L6.36 11.69Z",
        "fill": "#53585b"
      },
      {
        "type": "polygon",
        "d": "M7.16 10.31L7.16 9.74L8.02 9.74L8.02 9.33L6.75 9.33L6.75 11.69L8.02 11.69L8.02 11.28L7.16 11.28L7.16 10.72L7.86 10.72L7.86 10.31Z",
        "fill": "#53585b"
      },
      {
        "type": "polygon",
        "d": "M9.58 9.74L8.41 11.69L9.94 11.69L9.94 11.28L9.14 11.28L10.31 9.33L8.78 9.33L8.78 9.74Z",
        "fill": "#53585b"
      },
      {
        "type": "polygon",
        "d": "M12.91 6.34L12.75 6.11L12.52 5.95L12.27 5.9L11.34 5.9L11.34 8.26L11.75 8.26L11.75 7.33L11.87 7.33L12.66 8.26L12.97 8L12.39 7.3L12.52 7.28L12.75 7.12L12.91 6.89L12.96 6.62Z",
        "fill": "#53585b"
      },
      {
        "type": "polygon",
        "d": "M12.52 6.73L12.46 6.83L12.36 6.89L12.23 6.92L11.75 6.92L11.75 6.31L12.23 6.31L12.36 6.34L12.46 6.4L12.52 6.5L12.54 6.62Z",
        "fill": "truck"
      },
      {
        "type": "polygon",
        "d": "M14.11 8.26L14.11 6.31L14.51 6.31L14.51 5.9L13.3 5.9L13.3 6.31L13.7 6.31L13.7 8.26Z",
        "fill": "#53585b"
      },
      {
        "type": "polygon",
        "d": "M13.27 9.92L13.21 10.26L13.21 10.77L13.27 11.11L13.48 11.42L13.79 11.62L14.15 11.7L14.51 11.62L14.82 11.42L15.03 11.11L15.1 10.77L15.1 10.26L15.03 9.92L14.82 9.61L14.51 9.4L14.15 9.33L13.79 9.4L13.48 9.61Z",
        "fill": "#53585b"
      },
      {
        "type": "polygon",
        "d": "M14.15 11.28L13.95 11.24L13.77 11.12L13.66 10.95L13.61 10.73L13.61 10.3L13.66 10.08L13.77 9.9L13.95 9.79L14.15 9.75L14.35 9.79L14.53 9.9L14.64 10.08L14.69 10.3L14.69 10.73L14.64 10.95L14.53 11.12L14.35 11.24Z",
        "fill": "truck"
      },
      {
        "type": "polygon",
        "d": "M11.18 9.41L11.61 11.69L12.54 11.69L12.97 9.41L12.57 9.33L12.2 11.28L11.95 11.28L11.58 9.33Z",
        "fill": "#53585b"
      },
      {
        "type": "polygon",
        "d": "M18.63 11.14L18.43 11.28L18.14 11.28L17.88 11.1L17.65 11.43L18.01 11.69L18.56 11.69L18.99 11.38L19.1 10.88L18.8 10.46L18.04 10.22L17.93 10.05L17.97 9.88L18.15 9.74L18.42 9.74L18.67 9.93L18.91 9.6L18.55 9.33L18.02 9.33L17.6 9.64L17.49 10.14L17.79 10.57L18.54 10.81L18.66 10.97Z",
        "fill": "#53585b"
      },
      {
        "type": "polygon",
        "d": "M16.7 11.59L16.87 11.46L17 11.29L17.08 11.09L17.1 10.9L17.1 9.33L16.69 9.33L16.69 10.87L16.68 10.99L16.64 11.08L16.58 11.16L16.49 11.23L16.4 11.27L16.29 11.28L16.19 11.27L16.1 11.23L16.01 11.16L15.95 11.08L15.91 10.99L15.9 10.87L15.9 9.33L15.49 9.33L15.49 10.9L15.51 11.09L15.59 11.29L15.72 11.46L15.89 11.59L16.08 11.67L16.29 11.69L16.5 11.67Z",
        "fill": "#53585b"
      }
    ],
    "wassel": [
      {
        "type": "polygon",
        "d": "M6.16 7.12L5.56 7.05L5.25 9.94L5.13 9.94L5.12 8.15L3.94 8.15L3.93 9.94L3.81 9.94L3.5 7.05L2.9 7.12L3.26 10.55L4.53 10.55L4.53 10.25L4.53 10.55L5.8 10.55Z",
        "fill": "accent"
      },
      {
        "type": "polygon",
        "d": "M6.39 10.43L6.99 10.55L7.16 9.62L8.27 9.62L8.45 10.55L9.04 10.43L8.4 7.05L7.03 7.05Z",
        "fill": "accent"
      },
      {
        "type": "polygon",
        "d": "M7.28 9.02L7.54 7.66L7.9 7.66L8.16 9.02Z",
        "fill": "truck"
      },
      {
        "type": "polygon",
        "d": "M10.91 9.23L11.09 9.48L11.03 9.73L10.74 9.94L10.32 9.94L9.93 9.66L9.58 10.16L10.13 10.55L10.93 10.55L11.58 10.09L11.74 9.35L11.29 8.72L10.17 8.37L10 8.12L10.06 7.86L10.33 7.66L10.73 7.66L11.09 7.93L11.46 7.44L10.93 7.05L10.13 7.05L9.51 7.51L9.35 8.25L9.79 8.88Z",
        "fill": "accent"
      },
      {
        "type": "polygon",
        "d": "M12.36 8.88L13.48 9.23L13.66 9.48L13.6 9.73L13.31 9.94L12.89 9.94L12.5 9.66L12.15 10.16L12.7 10.55L13.5 10.55L14.15 10.09L14.31 9.35L13.86 8.72L12.74 8.37L12.57 8.12L12.63 7.86L12.9 7.66L13.3 7.66L13.67 7.93L14.03 7.44L13.5 7.05L12.7 7.05L12.08 7.51L11.93 8.25Z",
        "fill": "accent"
      },
      {
        "type": "polygon",
        "d": "M16.54 9.1L16.54 8.5L15.49 8.5L15.49 7.66L16.78 7.66L16.78 7.05L14.88 7.05L14.88 10.55L16.78 10.55L16.78 9.94L15.49 9.94L15.49 9.1Z",
        "fill": "accent"
      },
      {
        "type": "polygon",
        "d": "M17.35 10.55L19.1 10.55L19.1 9.94L17.96 9.94L17.96 7.05L17.35 7.05Z",
        "fill": "accent"
      }
    ],
    "widect": [
      {
        "type": "polygon",
        "d": "M6.42 6.98L5.77 6.91L5.44 10.03L5.31 10.03L5.3 8.1L4.02 8.1L4.01 10.03L3.88 10.03L3.55 6.91L2.9 6.98L3.29 10.69L4.66 10.69L4.66 10.36L4.66 10.69L6.03 10.69Z",
        "fill": "accent"
      },
      {
        "type": "polygon",
        "d": "M7.7 6.91L7.04 6.91L7.04 10.69L7.7 10.69Z",
        "fill": "accent"
      },
      {
        "type": "polygon",
        "d": "M10.78 9.74L10.97 9.29L11.04 8.8L10.97 8.31L10.78 7.86L10.48 7.46L10.09 7.16L9.64 6.97L9.17 6.91L8.32 6.91L8.32 10.69L9.17 10.69L9.64 10.63L10.09 10.44L10.48 10.14Z",
        "fill": "accent"
      },
      {
        "type": "polygon",
        "d": "M10.34 8.48L10.38 8.8L10.34 9.12L10.21 9.41L10.02 9.67L9.76 9.86L9.47 9.99L9.13 10.03L8.98 10.03L8.98 7.57L9.13 7.57L9.47 7.61L9.76 7.74L10.02 7.93L10.21 8.19Z",
        "fill": "truck"
      },
      {
        "type": "polygon",
        "d": "M12.32 9.13L13.45 9.13L13.45 8.47L12.32 8.47L12.32 7.57L13.7 7.57L13.7 6.91L11.66 6.91L11.66 10.69L13.7 10.69L13.7 10.03L12.32 10.03Z",
        "fill": "accent"
      },
      {
        "type": "polygon",
        "d": "M14.28 7.8L14.22 8.18L14.22 9.42L14.28 9.8L14.47 10.16L14.76 10.45L15.13 10.63L15.53 10.69L15.93 10.62L16.29 10.43L16.54 10.17L16.07 9.72L15.9 9.9L15.72 9.99L15.52 10.03L15.32 10L15.15 9.91L15 9.77L14.91 9.59L14.88 9.37L14.88 8.23L14.91 8.01L15 7.83L15.15 7.69L15.32 7.6L15.52 7.57L15.72 7.61L15.9 7.7L16.07 7.88L16.54 7.43L16.29 7.17L15.93 6.98L15.53 6.91L15.13 6.97L14.76 7.15L14.47 7.44Z",
        "fill": "accent"
      },
      {
        "type": "polygon",
        "d": "M18.46 10.69L18.46 7.57L19.1 7.57L19.1 6.91L17.17 6.91L17.17 7.57L17.81 7.57L17.81 10.69Z",
        "fill": "accent"
      }
    ],
    "xpress-courier-link": [
      {
        "type": "polygon",
        "d": "M15.11 10.77L15.93 5.97L14.92 5.8L13.9 11.79L16.95 11.79L16.95 10.77Z",
        "fill": "accent"
      },
      {
        "type": "polygon",
        "d": "M10.98 6.25L10.47 6.67L10.1 7.21L9.91 7.79L9.58 9.72L9.58 10.32L9.78 10.92L10.19 11.4L10.74 11.7L11.37 11.8L12.01 11.69L12.6 11.41L13.04 11.02L12.36 10.25L12.03 10.55L11.7 10.71L11.37 10.76L11.08 10.72L10.85 10.59L10.69 10.41L10.61 10.16L10.61 9.81L10.91 8.04L11.03 7.67L11.24 7.36L11.53 7.12L11.86 6.97L12.19 6.92L12.48 6.97L12.7 7.1L12.91 7.36L13.71 6.72L13.38 6.31L12.83 5.99L12.21 5.88L11.57 5.97Z",
        "fill": "accent"
      },
      {
        "type": "polygon",
        "d": "M6.27 10.77L6.51 9.35L8.36 9.35L8.36 8.33L6.68 8.33L6.92 6.91L9.17 6.91L9.17 5.89L6.06 5.89L5.05 11.79L8.34 11.79L8.34 10.77Z",
        "fill": "accent"
      }
    ],
    "zajel": [
      {
        "type": "polygon",
        "d": "M4.26 10.24L6.46 6.58L3.58 6.58L3.58 7.35L5.1 7.35L2.9 11.01L5.78 11.01L5.78 10.24Z",
        "fill": "#132818"
      },
      {
        "type": "polygon",
        "d": "M7.32 6.58L6.51 10.87L7.26 11.01L7.49 9.84L8.89 9.84L9.12 11.01L9.87 10.87L9.06 6.58Z",
        "fill": "#132818"
      },
      {
        "type": "polygon",
        "d": "M8.75 9.07L7.63 9.07L7.96 7.35L8.42 7.35Z",
        "fill": "truck"
      },
      {
        "type": "polygon",
        "d": "M14.52 9.18L15.85 9.18L15.85 8.41L14.52 8.41L14.52 7.35L16.15 7.35L16.15 6.58L13.75 6.58L13.75 11.01L16.15 11.01L16.15 10.24L14.52 10.24Z",
        "fill": "#132818"
      },
      {
        "type": "polygon",
        "d": "M16.88 11.01L19.1 11.01L19.1 10.24L17.65 10.24L17.65 6.58L16.88 6.58Z",
        "fill": "#132818"
      },
      {
        "type": "polygon",
        "d": "M11.72 10.24L11.58 10.22L11.46 10.17L11.35 10.09L11.26 9.98L11.21 9.85L11.19 9.66L10.42 9.76L10.46 10.05L10.59 10.37L10.8 10.64L11.07 10.84L11.38 10.97L11.72 11.02L12.06 10.97L12.37 10.84L12.64 10.64L12.85 10.37L12.98 10.05L13.02 9.74L13.02 6.58L12.25 6.58L12.25 9.69L12.23 9.85L12.18 9.98L12.09 10.09L11.99 10.17L11.86 10.22Z",
        "fill": "#132818"
      }
    ],
    "ecparcel": [
      {
        "type": "polygon",
        "d": "M5.81 11.49L5.81 10.55L3.83 10.55L3.83 9.27L5.44 9.27L5.44 8.33L3.83 8.33L3.83 7.05L5.81 7.05L5.81 6.11L2.9 6.11L2.9 11.49Z",
        "fill": "accent"
      },
      {
        "type": "polygon",
        "d": "M7.83 6.19L7.31 6.45L6.9 6.86L6.63 7.38L6.54 7.92L6.54 9.68L6.63 10.22L6.9 10.74L7.31 11.15L7.83 11.41L8.41 11.49L8.98 11.39L9.5 11.12L9.85 10.76L9.18 10.11L8.93 10.37L8.68 10.5L8.4 10.55L8.12 10.51L7.86 10.38L7.66 10.18L7.53 9.92L7.48 9.61L7.48 7.99L7.53 7.68L7.66 7.42L7.86 7.22L8.12 7.09L8.4 7.05L8.68 7.1L8.93 7.23L9.18 7.49L9.85 6.84L9.5 6.48L8.98 6.21L8.41 6.11Z",
        "fill": "accent"
      },
      {
        "type": "polygon",
        "d": "M13.26 8.8L14.7 6.63L13.92 6.11L12.7 7.95L11.49 6.11L10.71 6.63L12.14 8.8L10.71 10.97L11.49 11.49L12.7 9.65L13.92 11.49L14.7 10.97Z",
        "fill": "accent"
      },
      {
        "type": "polygon",
        "d": "M18.62 8.89L18.98 8.36L19.1 7.73L18.98 7.11L18.62 6.58L18.09 6.23L17.52 6.11L15.58 6.11L15.58 11.49L16.52 11.49L16.52 9.35L17.52 9.35L18.09 9.24Z",
        "fill": "accent"
      },
      {
        "type": "polygon",
        "d": "M17.95 7.25L18.1 7.47L18.15 7.73L18.1 7.99L17.95 8.21L17.73 8.36L17.42 8.42L16.52 8.42L16.52 7.05L17.42 7.05L17.73 7.11Z",
        "fill": "truck"
      }
    ],
    "go-logistics-au": [
      {
        "type": "polygon",
        "d": "M16.38 7.16L15.82 6.31L14.97 5.75L13.97 5.55L12.97 5.75L12.13 6.31L11.56 7.16L11.37 8.1L11.37 9.5L11.56 10.44L12.13 11.29L12.97 11.85L13.97 12.05L14.97 11.85L15.82 11.29L16.38 10.44L16.57 9.5L16.57 8.1Z",
        "fill": "accent"
      },
      {
        "type": "polygon",
        "d": "M15.32 7.6L15.44 8.21L15.44 9.39L15.32 10L15 10.48L14.53 10.79L13.97 10.9L13.41 10.79L12.94 10.48L12.62 10L12.5 9.39L12.5 8.21L12.62 7.6L12.94 7.12L13.41 6.81L13.97 6.7L14.53 6.81L15 7.12Z",
        "fill": "truck"
      },
      {
        "type": "polygon",
        "d": "M9.07 10.1L8.79 10.52L8.37 10.8L7.87 10.9L7.37 10.8L6.95 10.52L6.67 10.1L6.56 9.55L6.56 8.04L6.63 7.59L6.82 7.23L7.11 6.94L7.48 6.75L7.88 6.69L8.29 6.76L8.65 6.95L9 7.31L9.81 6.53L9.33 6.04L8.65 5.68L7.89 5.55L7.13 5.67L6.45 6.01L5.9 6.55L5.55 7.24L5.43 7.95L5.43 9.66L5.61 10.54L6.14 11.33L6.93 11.86L7.87 12.05L8.8 11.86L9.6 11.33L10.13 10.54L10.3 9.66L10.3 8.51L7.87 8.51L7.87 9.63L9.16 9.63Z",
        "fill": "accent"
      }
    ],
    "hey-couriers": [
      {
        "type": "polygon",
        "d": "M14.59 5.55L13.65 6.17L15.5 8.97L15.5 12.05L16.63 12.05L16.63 8.97L18.47 6.17L17.53 5.55L16.06 7.78Z",
        "fill": "accent"
      },
      {
        "type": "polygon",
        "d": "M6.86 9.36L6.86 12.05L7.98 12.05L7.98 5.55L6.86 5.55L6.86 8.24L4.65 8.24L4.65 5.55L3.53 5.55L3.53 12.05L4.65 12.05L4.65 9.36Z",
        "fill": "accent"
      },
      {
        "type": "polygon",
        "d": "M12.58 10.92L10.19 10.92L10.19 9.36L12.13 9.36L12.13 8.24L10.19 8.24L10.19 6.68L12.58 6.68L12.58 5.55L9.06 5.55L9.06 12.05L12.58 12.05Z",
        "fill": "accent"
      }
    ],
    "ahamove": [
      {
        "type": "polygon",
        "d": "M17.52 12.46L15.14 5.96L14.82 5.46L14.41 5.06L13.92 4.75L13.52 4.59L13.09 4.51L12.5 4.52L12.07 4.61L11.53 4.84L11.05 5.17L10.74 5.48L10.08 6.54L8.28 6.54L8.1 6.58L7.95 6.68L7.86 6.82L7.82 7L7.86 7.17L7.95 7.32L8.1 7.42L8.28 7.45L9.74 7.45L10.03 7.55L10.2 7.79L10.23 7.94L10.13 8.23L9.89 8.4L5.51 8.43L5.33 8.46L5.19 8.56L5.09 8.71L5.05 8.88L5.09 9.06L5.19 9.2L5.33 9.3L5.51 9.34L8.46 9.34L7.89 10.32L6.56 10.32L6.39 10.36L6.24 10.45L6.15 10.6L6.11 10.77L6.15 10.95L6.24 11.1L6.39 11.19L7.37 11.23L6.64 12.55L6.7 12.86L6.95 13.07L9.56 13.1L9.89 13.04L10.29 12.76L11.21 11.19L14.19 11.19L14.79 12.75L14.99 12.96L15.25 13.07L17.22 13.07L17.36 13L17.52 12.76Z",
        "fill": "#ff7f32"
      },
      {
        "type": "circle",
        "cx": 11.86,
        "cy": 8.9,
        "r": 0.47,
        "fill": "truck"
      },
      {
        "type": "circle",
        "cx": 13.61,
        "cy": 8.9,
        "r": 0.47,
        "fill": "truck"
      }
    ],
    "gle-colombia": [
      {
        "type": "polygon",
        "d": "M6.1 6.7L3 6.7L3.5 7.54L6.1 7.54Z",
        "fill": "accent"
      },
      {
        "type": "polygon",
        "d": "M15.9 6.7L19 6.7L18.5 7.54L15.9 7.54Z",
        "fill": "accent"
      },
      {
        "type": "polygon",
        "d": "M6.1 8.38L4.01 8.38L4.51 9.22L6.1 9.22Z",
        "fill": "accent"
      },
      {
        "type": "polygon",
        "d": "M15.9 8.38L17.99 8.38L17.49 9.22L15.9 9.22Z",
        "fill": "accent"
      },
      {
        "type": "polygon",
        "d": "M6.1 10.06L5.02 10.06L5.52 10.9L6.1 10.9Z",
        "fill": "accent"
      },
      {
        "type": "polygon",
        "d": "M15.9 10.06L16.98 10.06L16.48 10.9L15.9 10.9Z",
        "fill": "accent"
      },
      {
        "type": "polygon",
        "d": "M11.12 10.17L11.12 6.7L10.39 6.7L10.39 10.89L12.49 10.89L12.49 10.17Z",
        "fill": "accent"
      },
      {
        "type": "polygon",
        "d": "M13.91 10.17L13.91 9.16L15.16 9.16L15.16 8.44L13.91 8.44L13.91 7.43L15.45 7.43L15.45 6.7L13.18 6.7L13.18 10.89L15.45 10.89L15.45 10.17Z",
        "fill": "accent"
      },
      {
        "type": "polygon",
        "d": "M8.13 10.16L7.81 10.09L7.53 9.91L7.35 9.64L7.28 9.28L7.28 8.31L7.33 8.02L7.45 7.78L7.64 7.59L7.87 7.48L8.14 7.44L8.4 7.48L8.63 7.6L8.86 7.84L9.38 7.33L9.07 7.02L8.63 6.78L8.14 6.7L7.65 6.77L7.21 7L6.85 7.35L6.63 7.79L6.55 8.25L6.55 9.35L6.67 9.92L7.01 10.44L7.52 10.78L8.13 10.9L8.73 10.78L9.25 10.44L9.59 9.92L9.7 9.35L9.7 8.61L8.13 8.61L8.13 9.34L8.96 9.34L8.9 9.64L8.72 9.91L8.45 10.09Z",
        "fill": "accent"
      }
    ],
    "greenway-vn": [
      {
        "type": "polygon",
        "d": "M6.87 7.97L6.69 7.71L6.43 7.54L6.15 7.48L5.19 7.48L5.19 10.12L5.67 10.12L5.67 9.08L5.75 9.08L6.57 10.12L6.94 9.82L6.33 9.04L6.43 9.02L6.69 8.85L6.87 8.59L6.93 8.28Z",
        "fill": "accent"
      },
      {
        "type": "polygon",
        "d": "M6.42 8.4L6.35 8.51L6.25 8.58L6.1 8.6L5.67 8.6L5.67 7.96L6.1 7.96L6.25 7.98L6.35 8.05L6.42 8.16L6.44 8.28Z",
        "fill": "truck"
      },
      {
        "type": "polygon",
        "d": "M8.45 8.56L7.77 8.56L7.77 7.96L8.61 7.96L8.61 7.48L7.29 7.48L7.29 10.12L8.61 10.12L8.61 9.64L7.77 9.64L7.77 9.04L8.45 9.04Z",
        "fill": "accent"
      },
      {
        "type": "polygon",
        "d": "M10.11 9.04L10.11 8.56L9.43 8.56L9.43 7.96L10.28 7.96L10.28 7.48L8.96 7.48L8.96 10.12L10.28 10.12L10.28 9.64L9.43 9.64L9.43 9.04Z",
        "fill": "accent"
      },
      {
        "type": "polygon",
        "d": "M11.82 9.64L11.69 7.48L10.62 7.48L10.62 10.12L11.1 10.12L11.1 7.96L11.24 7.96L11.37 10.12L12.44 10.12L12.44 7.48L11.96 7.48L11.96 9.64Z",
        "fill": "accent"
      },
      {
        "type": "polygon",
        "d": "M14.48 9.64L14.47 8.3L13.57 8.3L13.55 9.64L13.49 9.64L13.26 7.48L12.79 7.53L13.06 10.12L14.98 10.12L15.25 7.53L14.78 7.48L14.55 9.64Z",
        "fill": "accent"
      },
      {
        "type": "polygon",
        "d": "M15.8 10.12L15.92 9.43L16.67 9.43L16.79 10.12L17.26 10.04L16.82 7.48L15.77 7.48L15.33 10.04Z",
        "fill": "accent"
      },
      {
        "type": "polygon",
        "d": "M16 8.95L16.17 7.96L16.42 7.96L16.59 8.95Z",
        "fill": "truck"
      },
      {
        "type": "polygon",
        "d": "M18.4 8.87L19.1 7.73L18.7 7.48L18.16 8.35L17.62 7.48L17.21 7.73L17.92 8.87L17.92 10.12L18.4 10.12Z",
        "fill": "accent"
      },
      {
        "type": "polygon",
        "d": "M3.42 9.33L3.38 9.12L3.38 8.47L3.4 8.3L3.47 8.16L3.59 8.05L3.72 7.98L3.88 7.96L4.03 7.98L4.17 8.06L4.31 8.2L4.65 7.87L4.46 7.67L4.19 7.53L3.88 7.48L3.58 7.52L3.3 7.66L3.09 7.88L2.95 8.15L2.9 8.43L2.9 9.17L2.97 9.52L3.18 9.84L3.5 10.05L3.87 10.12L4.25 10.05L4.57 9.84L4.78 9.52L4.85 9.17L4.85 8.67L3.87 8.67L3.87 9.15L4.37 9.15L4.33 9.33L4.22 9.49L4.06 9.6L3.87 9.64L3.68 9.6L3.52 9.49Z",
        "fill": "accent"
      }
    ],
    "mensajeros-urbanos": [
      {
        "type": "polygon",
        "d": "M11.06 13.7L10.59 13.68L10.13 13.62L9.62 13.5L9.16 13.33L8.42 12.95L8.07 12.69L7.65 12.33L7.37 12.03L7.06 11.64L6.8 11.22L6.62 10.85L6.48 10.5L6.33 9.99L6.25 9.57L6.2 9.07L6.21 8.56L6.26 8.17L6.37 7.63L6.51 7.21L6.65 6.87L6.92 6.37L7.2 5.97L7.53 5.59L7.88 5.26L8.24 4.98L8.69 4.7L9.06 4.51L9.56 4.32L9.99 4.21L10.87 4.1L11.32 4.11L11.78 4.16L12.26 4.27L12.65 4.39L12.99 4.53L13.54 4.83L14.24 5.36L14.54 5.66L14.89 6.09L15.13 6.45L15.35 6.86L15.64 7.65L15.74 8.14L15.8 8.63L15.8 9.17L15.74 9.66L15.64 10.15L15.51 10.56L15.34 10.95L15.09 11.42L14.8 11.86L14.53 12.15L14.17 12.5L13.85 12.76L13.39 13.06L12.94 13.29L12.44 13.48L12.04 13.59L11.51 13.67Z",
        "fill": "accent"
      },
      {
        "type": "polygon",
        "d": "M11.19 13.06L11.91 12.96L12.45 12.81L12.78 12.67L13.18 12.45L13.51 12.22L13.86 11.93L14.18 11.58L12.37 6.85L12.23 6.57L12.12 6.74L11.31 8.61L12.14 10.6L12.19 11.02L12.11 11.32L12 11.5L11.81 11.69L11.58 11.81L11.29 11.88L10.73 11.89L10.4 11.83L10.12 11.7L9.92 11.52L9.8 11.33L9.73 11.15L9.72 10.84L9.74 10.67L10.62 8.61L9.85 6.78L9.73 6.61L9.61 6.83L7.79 11.54L8.21 11.98L8.43 12.18L8.81 12.44L9.28 12.69L9.76 12.88L10.22 12.99L10.68 13.05Z",
        "fill": "truck"
      },
      {
        "type": "polygon",
        "d": "M14.62 10.95L14.84 10.52L14.99 10.1L15.14 9.39L15.16 9.04L15.15 8.49L14.99 7.7L14.68 6.95L14.23 6.27L13.63 5.67L12.99 5.24L12.24 4.92L11.92 4.84L11.44 4.76L10.66 4.75L10.21 4.81L9.82 4.91L9.08 5.2L8.4 5.65L7.84 6.19L7.61 6.48L7.37 6.86L7.14 7.34L7 7.74L6.91 8.15L6.84 8.66L6.85 9.25L6.95 9.86L7.1 10.35L7.36 10.91L9.05 6.52L9.24 6.2L9.46 6.02L9.69 5.95L9.91 5.97L10.13 6.11L10.29 6.29L10.43 6.52L10.96 7.81L11.54 6.48L11.69 6.22L11.95 5.99L12.09 5.93L12.25 5.91L12.45 5.96L12.65 6.09L12.77 6.23L12.91 6.47Z",
        "fill": "truck"
      },
      {
        "type": "polygon",
        "d": "M11.21 11.24L11.36 11.21L11.5 11.1L11.55 11.01L11.55 10.84L10.96 9.43L10.39 10.73L10.35 10.95L10.4 11.11L10.56 11.22L10.69 11.25Z",
        "fill": "truck"
      }
    ],
    "moova": [
      {
        "type": "polygon",
        "d": "M6.23 11.02L6.23 6.57L4.57 9.35L2.9 6.57L2.9 11.02L3.53 11.02L3.53 8.85L4.57 10.57L5.6 8.85L5.6 11.02Z",
        "fill": "accent"
      },
      {
        "type": "polygon",
        "d": "M7.73 7.5L7.25 7.81L6.94 8.29L6.83 8.82L6.83 9.6L6.94 10.13L7.25 10.6L7.73 10.92L8.29 11.03L8.85 10.92L9.32 10.6L9.64 10.13L9.74 9.6L9.74 8.82L9.64 8.29L9.32 7.81L8.85 7.5L8.29 7.39Z",
        "fill": "accent"
      },
      {
        "type": "polygon",
        "d": "M8.6 10.33L8.29 10.39L7.97 10.33L7.71 10.15L7.53 9.88L7.46 9.54L7.46 8.88L7.53 8.53L7.71 8.27L7.97 8.09L8.29 8.03L8.6 8.09L8.87 8.27L9.04 8.53L9.11 8.88L9.11 9.54L9.04 9.88L8.87 10.15Z",
        "fill": "truck"
      },
      {
        "type": "polygon",
        "d": "M11.24 7.5L10.77 7.81L10.45 8.29L10.34 8.82L10.34 9.6L10.45 10.13L10.77 10.6L11.24 10.92L11.8 11.03L12.36 10.92L12.83 10.6L13.15 10.13L13.26 9.6L13.26 8.82L13.15 8.29L12.83 7.81L12.36 7.5L11.8 7.39Z",
        "fill": "accent"
      },
      {
        "type": "polygon",
        "d": "M12.11 10.33L11.8 10.39L11.49 10.33L11.22 10.15L11.04 9.88L10.97 9.54L10.97 8.88L11.04 8.53L11.22 8.27L11.49 8.09L11.8 8.03L12.11 8.09L12.38 8.27L12.56 8.53L12.63 8.88L12.63 9.54L12.56 9.88L12.38 10.15Z",
        "fill": "truck"
      },
      {
        "type": "polygon",
        "d": "M14.81 10.39L14.24 7.39L13.62 7.51L14.29 11.02L15.71 11.02L16.38 7.51L15.76 7.39L15.19 10.39Z",
        "fill": "accent"
      },
      {
        "type": "polygon",
        "d": "M16.96 11.02L17.14 10.06L18.3 10.06L18.48 11.02L19.1 10.91L18.43 7.39L17.01 7.39L16.34 10.91Z",
        "fill": "accent"
      },
      {
        "type": "polygon",
        "d": "M18.18 9.43L17.26 9.43L17.53 8.02L17.91 8.02Z",
        "fill": "truck"
      }
    ],
    "moovin": [
      {
        "type": "polygon",
        "d": "M5.91 10.81L5.91 6.78L4.41 9.29L2.9 6.78L2.9 10.81L3.47 10.81L3.47 8.84L4.41 10.4L5.34 8.84L5.34 10.81Z",
        "fill": "accent"
      },
      {
        "type": "polygon",
        "d": "M6.84 7.91L6.55 8.34L6.46 8.82L6.46 9.52L6.55 10L6.84 10.43L7.27 10.72L7.77 10.82L8.28 10.72L8.71 10.43L8.99 10L9.09 9.52L9.09 8.82L8.99 8.34L8.71 7.91L8.28 7.62L7.77 7.52L7.27 7.62Z",
        "fill": "accent"
      },
      {
        "type": "polygon",
        "d": "M7.77 10.24L7.49 10.18L7.25 10.02L7.09 9.78L7.02 9.47L7.02 8.87L7.09 8.56L7.25 8.32L7.49 8.16L7.77 8.1L8.05 8.16L8.29 8.32L8.46 8.56L8.52 8.87L8.52 9.47L8.46 9.78L8.29 10.02L8.05 10.18Z",
        "fill": "truck"
      },
      {
        "type": "polygon",
        "d": "M10.01 7.91L9.73 8.34L9.63 8.82L9.63 9.52L9.73 10L10.01 10.43L10.44 10.72L10.95 10.82L11.45 10.72L11.88 10.43L12.17 10L12.26 9.52L12.26 8.82L12.17 8.34L11.88 7.91L11.45 7.62L10.95 7.52L10.44 7.62Z",
        "fill": "accent"
      },
      {
        "type": "polygon",
        "d": "M10.95 10.24L10.66 10.18L10.42 10.02L10.26 9.78L10.2 9.47L10.2 8.87L10.26 8.56L10.42 8.32L10.66 8.16L10.95 8.1L11.23 8.16L11.47 8.32L11.63 8.56L11.69 8.87L11.69 9.47L11.63 9.78L11.47 10.02L11.23 10.18Z",
        "fill": "truck"
      },
      {
        "type": "polygon",
        "d": "M14.01 10.24L13.67 10.24L13.15 7.53L12.59 7.63L13.19 10.81L14.48 10.81L15.08 7.63L14.52 7.53Z",
        "fill": "accent"
      },
      {
        "type": "polygon",
        "d": "M16.2 7.53L15.63 7.53L15.63 10.81L16.2 10.81Z",
        "fill": "accent"
      },
      {
        "type": "polygon",
        "d": "M18.53 10.24L18.31 10.24L18.04 7.53L16.74 7.53L16.74 10.81L17.31 10.81L17.31 8.1L17.53 8.1L17.8 10.81L19.1 10.81L19.1 7.53L18.53 7.53Z",
        "fill": "accent"
      }
    ],
    "ots-chile": [
      {
        "type": "circle",
        "cx": 6.8,
        "cy": 8.8,
        "r": 3.13,
        "fill": "#000000"
      },
      {
        "type": "circle",
        "cx": 6.8,
        "cy": 8.8,
        "r": 2.32,
        "fill": "#ffffff"
      },
      {
        "type": "polygon",
        "d": "M6.49 9.24L8.37 9.24L8.52 9.2L8.64 9.08L8.68 8.93L8.64 8.77L8.52 8.65L8.37 8.61L7.12 8.61L7.12 7.05L7.07 6.89L6.96 6.77L6.8 6.73L6.65 6.77L6.53 6.89L6.49 7.05Z",
        "fill": "#000000"
      },
      {
        "type": "polygon",
        "d": "M10.63 5.9L10.63 6.91L11.62 6.91L11.62 11.7L12.62 11.7L12.62 6.91L13.6 6.91L13.6 5.9Z",
        "fill": "#000000"
      },
      {
        "type": "polygon",
        "d": "M14.37 7.89L15.1 8.94L16.96 9.52L17.25 9.93L17.16 10.35L16.67 10.69L15.98 10.69L15.33 10.24L14.75 11.06L15.66 11.7L17 11.7L18.06 10.94L18.33 9.71L17.58 8.66L15.73 8.08L15.45 7.67L15.54 7.25L16 6.91L16.65 6.91L17.26 7.36L17.86 6.55L16.99 5.9L15.67 5.9L14.64 6.66Z",
        "fill": "#000000"
      }
    ],
    "rodonaves": [
      {
        "type": "polygon",
        "d": "M4.4 7.75L4.25 7.53L4.03 7.38L3.78 7.33L2.9 7.33L2.9 9.59L3.29 9.59L3.29 8.69L3.41 8.69L4.16 9.59L4.46 9.33L3.9 8.67L4.03 8.64L4.25 8.5L4.4 8.27L4.45 8.01Z",
        "fill": "accent"
      },
      {
        "type": "polygon",
        "d": "M4.03 8.12L3.97 8.21L3.87 8.28L3.75 8.3L3.29 8.3L3.29 7.72L3.75 7.72L3.87 7.75L3.97 7.81L4.03 7.9L4.05 8.01Z",
        "fill": "truck"
      },
      {
        "type": "polygon",
        "d": "M4.8 7.86L4.74 8.16L4.74 8.76L4.8 9.06L4.99 9.34L5.26 9.53L5.59 9.59L5.91 9.53L6.19 9.34L6.38 9.06L6.44 8.76L6.44 8.16L6.38 7.86L6.19 7.58L5.91 7.39L5.59 7.33L5.26 7.39L4.99 7.58Z",
        "fill": "accent"
      },
      {
        "type": "polygon",
        "d": "M5.42 9.16L5.27 9.06L5.17 8.91L5.13 8.72L5.13 8.2L5.17 8.01L5.27 7.86L5.42 7.76L5.59 7.73L5.76 7.76L5.91 7.86L6.01 8.01L6.05 8.2L6.05 8.72L6.01 8.91L5.91 9.06L5.76 9.16L5.59 9.19Z",
        "fill": "truck"
      },
      {
        "type": "polygon",
        "d": "M8.26 8.75L8.3 8.46L8.26 8.17L8.15 7.9L7.97 7.66L7.74 7.48L7.46 7.37L7.18 7.33L6.75 7.33L6.75 9.59L7.18 9.59L7.46 9.55L7.74 9.44L7.97 9.26L8.15 9.02Z",
        "fill": "accent"
      },
      {
        "type": "polygon",
        "d": "M7.91 8.46L7.88 8.65L7.81 8.83L7.69 8.98L7.54 9.1L7.36 9.17L7.14 9.2L7.14 7.72L7.36 7.75L7.54 7.82L7.69 7.94L7.81 8.09L7.88 8.27Z",
        "fill": "truck"
      },
      {
        "type": "polygon",
        "d": "M8.86 7.58L8.68 7.86L8.62 8.16L8.62 8.76L8.68 9.06L8.86 9.34L9.14 9.53L9.46 9.59L9.79 9.53L10.06 9.34L10.25 9.06L10.31 8.76L10.31 8.16L10.25 7.86L10.06 7.58L9.79 7.39L9.46 7.33L9.14 7.39Z",
        "fill": "accent"
      },
      {
        "type": "polygon",
        "d": "M9.46 9.19L9.29 9.16L9.14 9.06L9.05 8.91L9.01 8.72L9.01 8.2L9.05 8.01L9.14 7.86L9.29 7.76L9.46 7.73L9.64 7.76L9.78 7.86L9.88 8.01L9.92 8.2L9.92 8.72L9.88 8.91L9.78 9.06L9.64 9.16Z",
        "fill": "truck"
      },
      {
        "type": "polygon",
        "d": "M11.71 9.2L11.52 7.33L10.63 7.33L10.63 9.59L11.02 9.59L11.02 7.72L11.17 7.72L11.35 9.59L12.25 9.59L12.25 7.33L11.86 7.33L11.86 9.2Z",
        "fill": "accent"
      },
      {
        "type": "polygon",
        "d": "M12.56 9.52L12.95 9.59L13.05 8.99L13.71 8.99L13.81 9.59L14.19 9.52L13.82 7.33L12.93 7.33Z",
        "fill": "accent"
      },
      {
        "type": "polygon",
        "d": "M13.64 8.6L13.12 8.6L13.26 7.72L13.49 7.72Z",
        "fill": "truck"
      },
      {
        "type": "polygon",
        "d": "M14.16 7.4L14.53 9.59L15.42 9.59L15.79 7.4L15.4 7.33L15.09 9.2L14.86 9.2L14.54 7.33Z",
        "fill": "accent"
      },
      {
        "type": "polygon",
        "d": "M16.49 8.26L16.49 7.72L17.32 7.72L17.32 7.33L16.1 7.33L16.1 9.59L17.32 9.59L17.32 9.2L16.49 9.2L16.49 8.66L17.17 8.66L17.17 8.26Z",
        "fill": "accent"
      },
      {
        "type": "polygon",
        "d": "M18.65 9.06L18.46 9.2L18.19 9.2L17.94 9.02L17.71 9.34L18.06 9.59L18.58 9.59L19 9.29L19.1 8.81L18.81 8.41L18.09 8.18L17.98 8.02L18.02 7.86L18.2 7.72L18.45 7.72L18.69 7.9L18.92 7.59L18.58 7.33L18.07 7.33L17.67 7.63L17.57 8.11L17.85 8.51L18.57 8.74L18.68 8.9Z",
        "fill": "accent"
      },
      {
        "type": "polygon",
        "d": "M2.9 10.08L19.1 10.08L19.1 10.67L2.9 10.67Z",
        "fill": "#ff9d3b"
      }
    ],
    "taqbin-sg": [
      {
        "type": "polygon",
        "d": "M6.4 5L9.2 7.5L12 5L13.4 7.7L15.8 7.7L15.8 11.6L13.6 11.6L12.4 10.2L11.2 11.6L9.6 11.6L8.4 13.2L6.4 13.2Z",
        "fill": "#000000"
      }
    ],
    "the-human-express": [
      {
        "type": "polygon",
        "d": "M7.97 7.7L8.58 7.7L8.58 4.81L9.17 4.81L9.17 4.2L7.37 4.2L7.37 4.81L7.97 4.81Z",
        "fill": "accent"
      },
      {
        "type": "polygon",
        "d": "M12.15 4.2L11.54 4.2L11.54 5.65L10.36 5.65L10.36 4.2L9.75 4.2L9.75 7.7L10.36 7.7L10.36 6.26L11.54 6.26L11.54 7.7L12.15 7.7Z",
        "fill": "accent"
      },
      {
        "type": "polygon",
        "d": "M14.39 6.26L14.39 5.65L13.34 5.65L13.34 4.81L14.63 4.81L14.63 4.2L12.73 4.2L12.73 7.7L14.63 7.7L14.63 7.09L13.34 7.09L13.34 6.26Z",
        "fill": "accent"
      },
      {
        "type": "polygon",
        "d": "M10.81 11.18L9.21 8.5L9.21 12.8L9.81 12.8L9.81 10.7L10.81 12.36L11.81 10.7L11.81 12.8L12.42 12.8L12.42 8.5Z",
        "fill": "accent"
      },
      {
        "type": "polygon",
        "d": "M5.65 9.29L5.04 9.29L5.04 10.74L3.85 10.74L3.85 9.29L3.24 9.29L3.24 12.8L3.85 12.8L3.85 11.35L5.04 11.35L5.04 12.8L5.65 12.8Z",
        "fill": "accent"
      },
      {
        "type": "polygon",
        "d": "M13 12.68L13.6 12.8L13.77 11.87L14.89 11.87L15.06 12.8L15.66 12.68L15.01 9.29L13.64 9.29Z",
        "fill": "accent"
      },
      {
        "type": "polygon",
        "d": "M14.77 11.26L13.89 11.26L14.15 9.9L14.51 9.9Z",
        "fill": "truck"
      },
      {
        "type": "polygon",
        "d": "M18.15 12.19L17.92 12.19L17.63 9.29L16.24 9.29L16.24 12.8L16.85 12.8L16.85 9.9L17.08 9.9L17.37 12.8L18.76 12.8L18.76 9.29L18.15 9.29Z",
        "fill": "accent"
      },
      {
        "type": "polygon",
        "d": "M7.43 12.8L7.74 12.76L8.03 12.64L8.28 12.45L8.47 12.2L8.59 11.91L8.63 11.62L8.63 9.29L8.02 9.29L8.02 11.58L8 11.75L7.94 11.89L7.84 12.01L7.72 12.11L7.58 12.17L7.43 12.19L7.27 12.17L7.13 12.11L7.01 12.01L6.92 11.89L6.86 11.75L6.83 11.58L6.83 9.29L6.23 9.29L6.23 11.62L6.26 11.91L6.38 12.2L6.58 12.45L6.82 12.64L7.12 12.76Z",
        "fill": "accent"
      }
    ],
    "uparcel": [
      {
        "type": "polygon",
        "d": "M7.78 8.81L7.71 8.46L7.52 8.17L7.22 7.98L6.9 7.91L5.83 7.91L5.83 10.89L6.35 10.89L6.35 9.71L6.9 9.71L7.22 9.64L7.52 9.45L7.71 9.16Z",
        "fill": "#593636"
      },
      {
        "type": "polygon",
        "d": "M7.26 8.81L7.23 8.95L7.14 9.08L7.02 9.16L6.85 9.19L6.35 9.19L6.35 8.43L6.85 8.43L7.02 8.46L7.14 8.54L7.23 8.67Z",
        "fill": "truck"
      },
      {
        "type": "polygon",
        "d": "M7.91 10.79L8.41 10.89L8.56 10.1L9.51 10.1L9.66 10.89L10.17 10.79L9.62 7.91L8.45 7.91Z",
        "fill": "#593636"
      },
      {
        "type": "polygon",
        "d": "M8.66 9.58L8.88 8.43L9.19 8.43L9.41 9.58Z",
        "fill": "truck"
      },
      {
        "type": "polygon",
        "d": "M12.64 8.46L12.44 8.17L12.15 7.98L11.83 7.91L10.66 7.91L10.66 10.89L11.17 10.89L11.17 9.71L11.33 9.71L12.32 10.89L12.72 10.56L11.98 9.68L12.15 9.64L12.44 9.45L12.64 9.16L12.7 8.81Z",
        "fill": "#593636"
      },
      {
        "type": "polygon",
        "d": "M12.15 8.95L12.07 9.08L11.95 9.16L11.78 9.19L11.17 9.19L11.17 8.43L11.78 8.43L11.95 8.46L12.07 8.54L12.15 8.67L12.18 8.81Z",
        "fill": "truck"
      },
      {
        "type": "polygon",
        "d": "M13.19 8.91L13.19 9.89L13.23 10.19L13.38 10.47L13.61 10.7L13.9 10.84L14.22 10.89L14.54 10.84L14.82 10.69L15.02 10.48L14.65 10.13L14.51 10.27L14.37 10.34L14.21 10.37L14.06 10.35L13.91 10.27L13.8 10.16L13.73 10.02L13.7 9.85L13.7 8.95L13.73 8.78L13.8 8.64L13.91 8.53L14.06 8.45L14.21 8.43L14.37 8.46L14.51 8.53L14.65 8.67L15.02 8.32L14.82 8.11L14.54 7.96L14.22 7.91L13.9 7.96L13.61 8.1L13.38 8.33L13.23 8.61Z",
        "fill": "#593636"
      },
      {
        "type": "polygon",
        "d": "M16.92 9.14L16.03 9.14L16.03 8.43L17.12 8.43L17.12 7.91L15.51 7.91L15.51 10.89L17.12 10.89L17.12 10.37L16.03 10.37L16.03 9.66L16.92 9.66Z",
        "fill": "#593636"
      },
      {
        "type": "polygon",
        "d": "M17.61 10.89L19.1 10.89L19.1 10.37L18.13 10.37L18.13 7.91L17.61 7.91Z",
        "fill": "#593636"
      },
      {
        "type": "polygon",
        "d": "M4.32 10.89L4.59 10.86L4.83 10.75L5.04 10.59L5.21 10.38L5.31 10.13L5.34 9.88L5.34 7.91L4.82 7.91L4.82 9.85L4.81 10L4.76 10.12L4.68 10.22L4.57 10.3L4.45 10.35L4.32 10.37L4.19 10.35L4.07 10.3L3.97 10.22L3.89 10.12L3.84 10L3.82 9.85L3.82 7.91L3.3 7.91L3.3 9.88L3.33 10.13L3.43 10.38L3.6 10.59L3.81 10.75L4.06 10.86Z",
        "fill": "#593636"
      },
      {
        "type": "polygon",
        "d": "M2.94 7.91L3.56 7.13L4.18 7.91Z",
        "fill": "#593636"
      }
    ],
    "welivery": [
      {
        "type": "polygon",
        "d": "M10.93 4.2L10.36 4.31L9.87 4.59L7.47 7.01L7.24 7.3L7.09 7.6L7 7.91L6.97 8.25L7.06 8.78L7.34 9.3L9.78 11.79L10.06 12.02L10.34 12.16L10.66 12.26L11.02 12.29L11.59 12.19L12.1 11.9L14.53 9.45L14.75 9.18L14.9 8.9L15 8.55L15.03 8.2L14.94 7.67L14.66 7.16L12.23 4.69L11.97 4.48L11.64 4.31L11.29 4.22Z",
        "fill": "accent"
      },
      {
        "type": "polygon",
        "d": "M10.57 11L8.24 8.62L8.11 8.37L8.1 8.11L8.25 7.82L10.57 5.48L10.84 5.34L11.14 5.33L11.45 5.5L13.75 7.82L13.89 8.06L13.9 8.34L13.75 8.64L11.33 11.07L11.04 11.17L10.76 11.12Z",
        "fill": "truck"
      },
      {
        "type": "polygon",
        "d": "M8.2 12.66L9 13.12L9.77 13.42L10.56 13.58L11.34 13.59L12.23 13.42L13.14 13.05L13.92 12.56L14.04 12.38L14.08 12.18L14.03 11.97L13.91 11.8L13.74 11.69L13.53 11.65L13.33 11.69L12.61 12.12L11.96 12.38L11.33 12.51L10.71 12.51L10.23 12.43L9.8 12.3L9.27 12.05L8.67 11.69L8.47 11.65L8.17 11.73L8.02 11.88L7.94 12.07L7.96 12.38Z",
        "fill": "#6fe0cb"
      }
    ],
    "anc-delivers": [
      {
        "type": "polygon",
        "d": "M8.98 8.62L8.16 4.3L6.42 4.3L5.6 8.62L6.36 8.76L6.58 7.58L8 7.58L8.22 8.76Z",
        "fill": "#4b3674"
      },
      {
        "type": "polygon",
        "d": "M6.73 6.81L7.06 5.08L7.52 5.08L7.85 6.81Z",
        "fill": "truck"
      },
      {
        "type": "polygon",
        "d": "M12.92 4.3L12.15 4.3L12.15 7.99L11.86 7.99L11.49 4.3L9.72 4.3L9.72 8.76L10.49 8.76L10.49 5.08L10.79 5.08L11.16 8.76L12.92 8.76Z",
        "fill": "#4b3674"
      },
      {
        "type": "polygon",
        "d": "M14.29 4.59L13.95 4.93L13.73 5.36L13.66 5.8L13.66 7.26L13.73 7.71L13.95 8.14L14.29 8.48L14.73 8.69L15.2 8.76L15.68 8.68L16.11 8.46L16.4 8.16L15.84 7.62L15.64 7.83L15.43 7.94L15.2 7.98L14.96 7.95L14.75 7.84L14.58 7.68L14.47 7.47L14.43 7.2L14.43 5.86L14.47 5.6L14.58 5.39L14.75 5.22L14.96 5.12L15.2 5.08L15.43 5.12L15.64 5.23L15.84 5.45L16.4 4.91L16.11 4.61L15.68 4.38L15.2 4.3L14.73 4.37Z",
        "fill": "#4b3674"
      },
      {
        "type": "polygon",
        "d": "M7.16 10.03L7.12 9.89L7.06 9.76L6.98 9.64L6.87 9.55L6.74 9.47L6.61 9.42L6.47 9.4L6.32 9.41L6.18 9.44L6.05 9.51L5.93 9.59L5.84 9.7L5.76 9.82L5.71 9.96L5.69 10.1L5.7 10.25L5.74 10.39L5.8 10.52L5.86 10.6L5.96 10.71L6.08 10.79L6.22 10.84L6.36 10.87L6.53 10.87L6.73 11.13L7.01 11.43L7.36 11.75L7.7 12.02L8.05 12.25L8.44 12.47L8.86 12.66L9.27 12.82L9.68 12.93L10.13 13.02L10.57 13.07L10.99 13.09L11.45 13.07L11.89 13.02L12.3 12.93L12.75 12.81L13.16 12.65L13.56 12.47L13.95 12.25L14.3 12.02L14.64 11.75L14.99 11.43L15.27 11.13L15.47 10.87L15.64 10.87L15.78 10.84L15.92 10.79L16.04 10.71L16.14 10.6L16.24 10.45L16.29 10.32L16.31 10.14L16.29 9.96L16.22 9.79L16.12 9.64L15.95 9.51L15.78 9.43L15.61 9.4L15.43 9.41L15.26 9.47L15.1 9.57L15 9.67L14.9 9.82L14.86 9.96L14.83 10.14L14.85 10.28L14.89 10.42L14.98 10.57L14.84 10.74L14.57 11.04L14.28 11.3L13.97 11.55L13.64 11.77L13.29 11.96L12.93 12.13L12.56 12.27L12.18 12.37L11.79 12.45L11.4 12.5L11 12.51L10.6 12.5L10.21 12.45L9.82 12.37L9.44 12.27L9.07 12.13L8.71 11.96L8.36 11.77L8.03 11.55L7.72 11.3L7.43 11.04L7.16 10.74L7.02 10.57L7.1 10.45L7.14 10.32L7.17 10.17Z",
        "fill": "#4b3674"
      },
      {
        "type": "polygon",
        "d": "M6.83 10.2L6.78 10.35L6.67 10.47L6.53 10.53L6.37 10.54L6.22 10.49L6.1 10.38L6.03 10.24L6.02 10.08L6.08 9.93L6.19 9.81L6.33 9.74L6.49 9.73L6.64 9.79L6.76 9.89L6.83 10.04Z",
        "fill": "truck"
      },
      {
        "type": "polygon",
        "d": "M15.97 10.22L15.91 10.36L15.8 10.48L15.65 10.54L15.49 10.54L15.34 10.48L15.23 10.36L15.17 10.22L15.17 10.06L15.23 9.91L15.34 9.8L15.49 9.74L15.65 9.74L15.8 9.8L15.91 9.91L15.97 10.06Z",
        "fill": "truck"
      }
    ],
    "bestfulfill": [
      {
        "type": "polygon",
        "d": "M7.68 4.45L7.68 13.45L14.32 13.45L14.32 6.79L9.7 6.79L9.7 4.45Z",
        "fill": "accent"
      },
      {
        "type": "polygon",
        "d": "M9.74 8.87L12.35 8.87L12.35 11.57L9.74 11.57Z",
        "fill": "truck"
      }
    ],
    "braspress": [
      {
        "type": "polygon",
        "d": "M4.19 7.85L4.05 7.71L3.87 7.62L3.69 7.59L2.9 7.59L2.9 10.01L3.81 10.01L4.01 9.98L4.2 9.88L4.36 9.73L4.45 9.54L4.48 9.34L4.48 9.2L4.45 9L4.36 8.81L4.21 8.66L4.28 8.51L4.31 8.33L4.31 8.2L4.28 8.02Z",
        "fill": "accent"
      },
      {
        "type": "polygon",
        "d": "M3.95 9L4.01 9.06L4.05 9.14L4.06 9.23L4.06 9.31L4.05 9.41L4.01 9.48L3.95 9.54L3.88 9.58L3.78 9.59L3.32 9.59L3.32 8.95L3.78 8.95L3.88 8.97Z",
        "fill": "truck"
      },
      {
        "type": "polygon",
        "d": "M3.89 8.3L3.88 8.38L3.85 8.44L3.8 8.49L3.74 8.52L3.66 8.53L3.32 8.53L3.32 8.01L3.66 8.01L3.74 8.02L3.8 8.05L3.85 8.1L3.88 8.16L3.89 8.24Z",
        "fill": "truck"
      },
      {
        "type": "polygon",
        "d": "M6.2 7.8L5.96 7.64L5.7 7.59L4.83 7.59L4.83 10.01L5.25 10.01L5.25 9.05L5.34 9.05L6.1 10.01L6.43 9.75L5.85 9.02L5.96 9L6.2 8.84L6.36 8.6L6.41 8.32L6.36 8.04Z",
        "fill": "accent"
      },
      {
        "type": "polygon",
        "d": "M5.9 8.54L5.8 8.6L5.66 8.63L5.25 8.63L5.25 8.01L5.66 8.01L5.8 8.04L5.9 8.1L5.96 8.2L5.98 8.32L5.96 8.44Z",
        "fill": "truck"
      },
      {
        "type": "polygon",
        "d": "M9.79 9.27L9.75 9.45L9.57 9.59L9.31 9.59L9.07 9.4L8.81 9.74L9.17 10.01L9.71 10.01L10.13 9.69L10.24 9.18L9.95 8.75L9.22 8.5L9.11 8.33L9.15 8.14L9.32 8.01L9.56 8.01L9.79 8.19L10.06 7.86L9.71 7.59L9.18 7.59L8.77 7.91L8.67 8.42L8.95 8.85L9.68 9.1Z",
        "fill": "accent"
      },
      {
        "type": "polygon",
        "d": "M11.89 7.8L11.65 7.64L11.39 7.59L10.58 7.59L10.58 10.01L11 10.01L11 9.05L11.39 9.05L11.65 9L11.89 8.84L12.05 8.6L12.11 8.32L12.05 8.04Z",
        "fill": "accent"
      },
      {
        "type": "polygon",
        "d": "M11.59 8.54L11.49 8.6L11.35 8.63L11 8.63L11 8.01L11.35 8.01L11.49 8.04L11.59 8.1L11.65 8.2L11.68 8.32L11.65 8.44Z",
        "fill": "truck"
      },
      {
        "type": "polygon",
        "d": "M13.82 7.8L13.58 7.64L13.32 7.59L12.45 7.59L12.45 10.01L12.87 10.01L12.87 9.05L12.96 9.05L13.72 10.01L14.05 9.75L13.47 9.02L13.58 9L13.82 8.84L13.98 8.6L14.04 8.32L13.98 8.04Z",
        "fill": "accent"
      },
      {
        "type": "polygon",
        "d": "M13.52 8.54L13.42 8.6L13.28 8.63L12.87 8.63L12.87 8.01L13.28 8.01L13.42 8.04L13.52 8.1L13.58 8.2L13.61 8.32L13.58 8.44Z",
        "fill": "truck"
      },
      {
        "type": "polygon",
        "d": "M15.45 8.59L14.81 8.59L14.81 8.01L15.6 8.01L15.6 7.59L14.39 7.59L14.39 10.01L15.6 10.01L15.6 9.59L14.81 9.59L14.81 9.01L15.45 9.01Z",
        "fill": "accent"
      },
      {
        "type": "polygon",
        "d": "M16.99 9.27L16.96 9.45L16.77 9.59L16.52 9.59L16.27 9.4L16.02 9.74L16.38 10.01L16.92 10.01L17.34 9.69L17.44 9.18L17.15 8.75L16.43 8.5L16.32 8.33L16.35 8.14L16.53 8.01L16.76 8.01L17 8.19L17.26 7.86L16.91 7.59L16.38 7.59L15.97 7.91L15.87 8.42L16.15 8.85L16.88 9.1Z",
        "fill": "accent"
      },
      {
        "type": "polygon",
        "d": "M18.62 9.45L18.43 9.59L18.18 9.59L17.93 9.4L17.68 9.74L18.04 10.01L18.58 10.01L19 9.69L19.1 9.18L18.81 8.75L18.09 8.5L17.98 8.33L18.01 8.14L18.19 8.01L18.42 8.01L18.66 8.19L18.92 7.86L18.57 7.59L18.04 7.59L17.63 7.91L17.53 8.42L17.81 8.85L18.54 9.1L18.65 9.27Z",
        "fill": "accent"
      },
      {
        "type": "polygon",
        "d": "M7.27 9.37L7.98 9.37L8.09 10.01L8.5 9.94L8.1 7.59L7.14 7.59L6.74 9.94L7.16 10.01Z",
        "fill": "accent"
      },
      {
        "type": "polygon",
        "d": "M7.5 8.01L7.74 8.01L7.9 8.95L7.34 8.95Z",
        "fill": "truck"
      }
    ],
    "c807-xpress": [
      {
        "type": "polygon",
        "d": "M10.27 6.74L10.04 6.49L9.76 6.31L9.44 6.21L9.1 6.17L8.76 6.21L8.43 6.3L8.12 6.46L7.85 6.66L7.62 6.92L7.44 7.21L7.34 7.53L7.31 7.86L7.38 8.19L7.54 8.5L7.27 8.7L7.01 8.99L6.81 9.31L6.7 9.67L6.67 10.05L6.74 10.42L6.92 10.75L7.17 11.02L7.5 11.22L7.86 11.33L8.24 11.37L8.63 11.34L9 11.23L9.36 11.05L9.67 10.82L9.93 10.54L10.13 10.21L10.25 9.85L10.27 9.47L10.2 9.11L10.03 8.77L9.88 8.62L9.96 8.56L10.19 8.31L10.36 8.02L10.46 7.7L10.49 7.37L10.42 7.04Z",
        "fill": "accent"
      },
      {
        "type": "polygon",
        "d": "M8.9 9.07L9.07 9.13L9.2 9.21L9.29 9.3L9.34 9.41L9.37 9.53L9.36 9.67L9.31 9.83L9.21 9.99L9.06 10.15L8.88 10.28L8.68 10.38L8.46 10.45L8.24 10.47L8.04 10.45L7.88 10.39L7.75 10.31L7.66 10.22L7.6 10.11L7.58 9.99L7.59 9.85L7.64 9.69L7.74 9.53L7.88 9.37L8.06 9.24L8.27 9.14L8.49 9.08L8.7 9.05Z",
        "fill": "truck"
      },
      {
        "type": "polygon",
        "d": "M9.04 8.08L8.87 8.13L8.7 8.15L8.55 8.13L8.43 8.09L8.34 8.04L8.28 7.97L8.24 7.89L8.22 7.81L8.23 7.7L8.27 7.58L8.34 7.46L8.45 7.33L8.6 7.23L8.76 7.15L8.93 7.1L9.1 7.08L9.25 7.1L9.37 7.14L9.46 7.19L9.53 7.26L9.56 7.33L9.58 7.42L9.57 7.53L9.53 7.65L9.46 7.77L9.35 7.9L9.21 8Z",
        "fill": "truck"
      },
      {
        "type": "polygon",
        "d": "M4.23 6.49L3.78 6.86L3.44 7.33L3.26 7.84L2.92 9.54L2.9 10.06L3.07 10.59L3.41 11.02L3.9 11.29L4.45 11.38L5.01 11.28L5.53 11.03L5.93 10.69L5.35 10.01L5.04 10.27L4.74 10.41L4.45 10.46L4.2 10.42L4 10.32L3.87 10.16L3.81 9.94L3.82 9.64L4.13 8.08L4.25 7.75L4.44 7.48L4.71 7.26L5.01 7.13L5.3 7.08L5.55 7.13L5.73 7.24L5.91 7.47L6.63 6.92L6.34 6.55L5.87 6.27L5.32 6.17L4.75 6.25Z",
        "fill": "accent"
      },
      {
        "type": "polygon",
        "d": "M13.43 6.17L12.77 6.29L12.18 6.64L11.73 7.16L11.5 7.74L11.12 9.63L11.12 10.25L11.4 10.85L11.92 11.25L12.57 11.38L13.23 11.25L13.82 10.91L14.26 10.39L14.5 9.8L14.88 7.92L14.88 7.3L14.6 6.7L14.08 6.3Z",
        "fill": "accent"
      },
      {
        "type": "polygon",
        "d": "M13.23 10.2L12.9 10.4L12.57 10.46L12.31 10.4L12.13 10.26L12.02 10.05L12.03 9.72L12.37 8L12.52 7.63L12.77 7.34L13.1 7.15L13.43 7.09L13.69 7.14L13.87 7.28L13.97 7.5L13.97 7.83L13.63 9.55L13.48 9.91Z",
        "fill": "truck"
      },
      {
        "type": "polygon",
        "d": "M15.71 7.08L17.46 7.08L15.02 10.95L15.78 11.43L19.1 6.18L15.71 6.18Z",
        "fill": "accent"
      }
    ],
    "cathedis": [
      {
        "type": "polygon",
        "d": "M2.9 9.18L2.9 10.04L2.94 10.3L3.07 10.55L3.27 10.75L3.53 10.88L3.81 10.92L4.09 10.87L4.34 10.74L4.51 10.56L4.18 10.25L4.06 10.37L3.94 10.44L3.8 10.46L3.66 10.44L3.54 10.38L3.44 10.28L3.38 10.16L3.35 10L3.35 9.22L3.38 9.06L3.44 8.94L3.54 8.84L3.66 8.78L3.8 8.76L3.94 8.78L4.06 8.85L4.18 8.97L4.51 8.66L4.34 8.48L4.09 8.35L3.81 8.3L3.53 8.34L3.27 8.47L3.07 8.67L2.94 8.92Z",
        "fill": "accent"
      },
      {
        "type": "polygon",
        "d": "M5.34 10.92L5.47 10.23L6.3 10.23L6.44 10.92L6.88 10.83L6.4 8.3L5.38 8.3L4.9 10.83Z",
        "fill": "accent"
      },
      {
        "type": "polygon",
        "d": "M5.56 9.77L5.75 8.76L6.03 8.76L6.22 9.77Z",
        "fill": "truck"
      },
      {
        "type": "polygon",
        "d": "M7.82 10.92L7.82 8.76L8.27 8.76L8.27 8.3L6.93 8.3L6.93 8.76L7.37 8.76L7.37 10.92Z",
        "fill": "accent"
      },
      {
        "type": "polygon",
        "d": "M10.49 8.3L10.04 8.3L10.04 9.38L9.15 9.38L9.15 8.3L8.7 8.3L8.7 10.92L9.15 10.92L9.15 9.84L10.04 9.84L10.04 10.92L10.49 10.92Z",
        "fill": "accent"
      },
      {
        "type": "polygon",
        "d": "M12.16 9.38L11.38 9.38L11.38 8.76L12.34 8.76L12.34 8.3L10.92 8.3L10.92 10.92L12.34 10.92L12.34 10.46L11.38 10.46L11.38 9.84L12.16 9.84Z",
        "fill": "accent"
      },
      {
        "type": "polygon",
        "d": "M14.61 9.95L14.65 9.61L14.61 9.27L14.48 8.96L14.27 8.68L14 8.48L13.68 8.35L13.36 8.3L12.77 8.3L12.77 10.92L13.36 10.92L13.68 10.87L14 10.74L14.27 10.54L14.48 10.26Z",
        "fill": "accent"
      },
      {
        "type": "polygon",
        "d": "M14.19 9.61L14.16 9.83L14.08 10.04L13.94 10.21L13.77 10.35L13.56 10.43L13.33 10.46L13.22 10.46L13.22 8.76L13.33 8.76L13.56 8.79L13.77 8.87L13.94 9.01L14.08 9.18L14.16 9.39Z",
        "fill": "truck"
      },
      {
        "type": "polygon",
        "d": "M15.08 8.3L15.08 10.92L15.54 10.92L15.54 8.3Z",
        "fill": "accent"
      },
      {
        "type": "polygon",
        "d": "M17.26 10.12L17.22 10.31L17.01 10.46L16.69 10.46L16.4 10.26L16.14 10.63L16.55 10.92L17.15 10.92L17.63 10.58L17.75 10.02L17.41 9.55L16.58 9.29L16.45 9.1L16.5 8.91L16.7 8.76L17 8.76L17.27 8.96L17.54 8.6L17.15 8.3L16.55 8.3L16.09 8.65L15.97 9.2L16.29 9.67L17.13 9.93Z",
        "fill": "accent"
      },
      {
        "type": "polygon",
        "d": "M16.63 7.85L17.44 7.01L19.02 7.01L19.02 8.62L18.2 9.45L18.2 7.86Z",
        "fill": "accent"
      }
    ],
    "cps-lastmile": [
      {
        "type": "polygon",
        "d": "M6.9 5.8L6.26 5.89L5.66 6.16L5.15 6.58L4.77 7.12L4.56 7.69L4.18 9.62L4.16 10.22L4.34 10.82L4.74 11.3L5.29 11.61L5.92 11.71L6.55 11.6L7.14 11.32L7.59 10.93L6.93 10.16L6.58 10.45L6.24 10.62L5.91 10.67L5.62 10.63L5.41 10.51L5.26 10.32L5.18 10.08L5.2 9.74L5.55 7.97L5.68 7.6L5.91 7.29L6.21 7.04L6.55 6.88L6.88 6.84L7.16 6.89L7.37 7.01L7.57 7.27L8.38 6.65L8.06 6.23L7.52 5.91Z",
        "fill": "accent"
      },
      {
        "type": "polygon",
        "d": "M14.64 8.87L16.42 9.47L16.59 9.81L16.4 10.28L15.76 10.68L15.06 10.68L14.52 10.23L13.87 11.02L14.69 11.7L16.05 11.7L17.22 10.98L17.72 9.77L17.14 8.63L15.38 8.04L15.21 7.7L15.41 7.22L16.02 6.83L16.67 6.83L17.17 7.26L17.84 6.49L17.06 5.81L15.71 5.81L14.59 6.53L14.09 7.73Z",
        "fill": "accent"
      },
      {
        "type": "polygon",
        "d": "M12.85 8.34L13.12 7.68L13.12 6.99L12.82 6.36L12.28 5.94L11.64 5.81L9.61 5.81L8.45 11.6L9.46 11.8L9.95 9.36L11.13 9.36L11.77 9.24L12.39 8.88Z",
        "fill": "accent"
      },
      {
        "type": "polygon",
        "d": "M12 7.02L12.09 7.21L12.09 7.49L11.97 7.8L11.72 8.08L11.41 8.27L11.04 8.34L10.15 8.34L10.45 6.83L11.54 6.83L11.84 6.89Z",
        "fill": "truck"
      }
    ],
    "daiichi": [
      {
        "type": "polygon",
        "d": "M13.4 9.37L16.33 7.09L16.5 6.87L14.95 4.74L14.71 4.48L14.6 4.48L14.54 4.57L14.26 5.65L14.17 5.8L14.06 5.87L13.05 5.84L12.69 5.37L12.21 4.91L11.92 4.71L11.48 4.56L10.93 4.5L9.99 4.5L9.8 4.52L9.67 4.65L9.34 5.81L9.16 5.88L8.53 5.88L8.4 5.83L8.38 5.69L8.68 4.62L8.62 4.43L5.97 6.46L5.5 6.9L5.56 7.09L5.78 7.4L7.24 9.35L7.35 9.34L7.43 9.26L7.7 8.14L7.88 7.99L8.57 7.98L8.71 8.05L8.69 8.34L8.47 9.15L8.48 9.26L8.55 9.32L10.96 9.34L11.7 9.19L12.07 9.01L12.53 8.66L12.99 8.03L13.38 7.97L13.53 8L13.59 8.12L13.28 9.21L13.3 9.34Z",
        "fill": "accent"
      },
      {
        "type": "polygon",
        "d": "M11 8.62L9.58 8.63L9.44 8.58L9.4 8.36L9.62 7.42L9.54 7.28L7.42 7.26L7.22 7.36L7.13 7.62L7.04 7.68L6.55 7.07L6.51 6.87L7.39 6.19L7.47 6.24L7.5 6.5L7.61 6.58L9.82 6.55L9.92 6.42L10.21 5.35L10.32 5.23L10.5 5.2L11.31 5.25L11.92 5.57L12.07 5.78L11.94 5.88L10.96 5.88L10.76 5.93L10.67 6.04L10.6 6.42L10.63 6.52L10.71 6.57L14.54 6.58L14.71 6.5L14.85 6.2L14.93 6.15L15.47 6.83L15.46 6.92L15.33 7.07L14.58 7.64L14.49 7.6L14.45 7.31L14.34 7.26L10.41 7.29L10.31 7.4L10.23 7.79L10.3 7.95L11.9 7.97L12.04 8.05L11.98 8.18L11.57 8.48Z",
        "fill": "truck"
      },
      {
        "type": "polygon",
        "d": "M7.02 12.62L7.23 12.35L7.36 12.04L7.4 11.7L7.36 11.36L7.23 11.05L7.02 10.78L6.75 10.57L6.44 10.45L6.12 10.4L5.53 10.4L5.53 13L6.12 13L6.44 12.95L6.75 12.83Z",
        "fill": "accent"
      },
      {
        "type": "polygon",
        "d": "M6.83 11.28L6.92 11.48L6.95 11.7L6.92 11.92L6.83 12.12L6.7 12.3L6.52 12.43L6.32 12.52L6.09 12.55L5.98 12.55L5.98 10.85L6.09 10.85L6.32 10.88L6.52 10.97L6.7 11.1Z",
        "fill": "truck"
      },
      {
        "type": "polygon",
        "d": "M7.63 12.91L8.07 13L8.2 12.31L9.02 12.31L9.15 13L9.6 12.91L9.12 10.4L8.1 10.4Z",
        "fill": "accent"
      },
      {
        "type": "polygon",
        "d": "M8.28 11.86L8.48 10.85L8.75 10.85L8.94 11.86Z",
        "fill": "truck"
      },
      {
        "type": "polygon",
        "d": "M10.48 10.4L10.02 10.4L10.02 13L10.48 13Z",
        "fill": "accent"
      },
      {
        "type": "polygon",
        "d": "M10.9 10.4L10.9 13L11.35 13L11.35 10.4Z",
        "fill": "accent"
      },
      {
        "type": "polygon",
        "d": "M11.78 11.27L11.78 12.13L11.82 12.39L11.95 12.64L12.15 12.83L12.4 12.96L12.68 13L12.96 12.95L13.21 12.82L13.38 12.65L13.06 12.33L12.94 12.46L12.81 12.52L12.68 12.54L12.54 12.52L12.42 12.46L12.32 12.37L12.26 12.24L12.23 12.09L12.23 11.31L12.26 11.16L12.32 11.03L12.42 10.94L12.54 10.88L12.68 10.86L12.81 10.88L12.94 10.94L13.06 11.07L13.38 10.75L13.21 10.58L12.96 10.45L12.68 10.4L12.4 10.44L12.15 10.57L11.95 10.76L11.82 11.01Z",
        "fill": "accent"
      },
      {
        "type": "polygon",
        "d": "M15.59 10.4L15.14 10.4L15.14 11.47L14.26 11.47L14.26 10.4L13.81 10.4L13.81 13L14.26 13L14.26 11.93L15.14 11.93L15.14 13L15.59 13Z",
        "fill": "accent"
      },
      {
        "type": "polygon",
        "d": "M16.02 10.4L16.02 13L16.47 13L16.47 10.4Z",
        "fill": "accent"
      }
    ],
    "deliveright": [
      {
        "type": "polygon",
        "d": "M9.36 6.07L8.13 4.5L4.73 8.8L8.13 13.1L9.36 11.53L7.21 8.8Z",
        "fill": "#6e6f72"
      },
      {
        "type": "polygon",
        "d": "M11.44 8.8L8.13 13.1L10.56 13.1L13.92 8.8L10.56 4.5L8.13 4.5Z",
        "fill": "accent"
      },
      {
        "type": "polygon",
        "d": "M14.84 8.8L11.6 13.1L14.08 13.1L17.27 8.8L14.08 4.5L11.6 4.5Z",
        "fill": "accent"
      }
    ],
    "ecourier-uk": [
      {
        "type": "polygon",
        "d": "M15.3 7.31L15.28 7.01L15.23 6.71L15.15 6.41L15.03 6.13L14.88 5.87L14.71 5.62L14.51 5.39L14.28 5.19L14.03 5.02L13.77 4.87L13.49 4.75L13.19 4.67L12.89 4.62L12.59 4.6L9.41 4.6L9.11 4.62L8.81 4.67L8.51 4.75L8.23 4.87L7.97 5.02L7.72 5.19L7.49 5.39L7.29 5.62L7.12 5.87L6.97 6.13L6.85 6.41L6.77 6.71L6.72 7.01L6.7 7.31L6.7 10.49L6.72 10.79L6.77 11.09L6.85 11.39L6.97 11.67L7.12 11.93L7.29 12.18L7.49 12.41L7.72 12.61L7.97 12.78L8.23 12.93L8.51 13.05L8.81 13.13L9.11 13.18L9.41 13.2L12.59 13.2L12.89 13.18L13.19 13.13L13.49 13.05L13.77 12.93L14.03 12.78L14.28 12.61L14.51 12.41L14.71 12.18L14.88 11.93L15.03 11.67L15.15 11.39L15.23 11.09L15.28 10.79L15.29 10.63L13.43 10.63L13.39 10.84L13.32 11.01L13.22 11.17L13.1 11.31L12.96 11.43L12.8 11.53L12.63 11.6L12.44 11.64L12.26 11.66L9.81 11.66L9.63 11.64L9.45 11.6L9.27 11.53L9.11 11.43L8.97 11.31L8.85 11.17L8.75 11.01L8.68 10.84L8.64 10.63L8.62 10.63L8.62 9.59L15.3 9.59Z",
        "fill": "accent"
      },
      {
        "type": "polygon",
        "d": "M8.62 7.33L8.64 7.15L8.68 6.96L8.75 6.79L8.85 6.63L8.97 6.49L9.11 6.37L9.27 6.27L9.45 6.2L9.63 6.16L9.81 6.14L12.24 6.14L12.42 6.16L12.6 6.2L12.77 6.27L12.93 6.37L13.08 6.49L13.2 6.63L13.29 6.79L13.37 6.96L13.41 7.15L13.42 7.33L13.42 8.12L8.62 8.12Z",
        "fill": "truck"
      }
    ],
    "jamef": [
      {
        "type": "polygon",
        "d": "M4.04 10.06L3.91 10.08L3.8 10.07L3.71 10.03L3.65 9.97L3.61 9.9L3.59 9.8L3.6 9.64L2.92 9.59L2.9 9.85L2.96 10.14L3.11 10.4L3.33 10.6L3.61 10.73L3.91 10.77L4.21 10.73L4.49 10.62L4.75 10.45L4.96 10.23L5.12 9.97L5.21 9.7L5.77 6.9L5.1 6.77L4.55 9.52L4.5 9.68L4.42 9.81L4.31 9.92L4.18 10.01Z",
        "fill": "accent"
      },
      {
        "type": "polygon",
        "d": "M14.5 9.14L15.74 9.14L15.74 8.46L14.64 8.46L14.82 7.52L16.33 7.52L16.33 6.83L14.26 6.83L13.48 10.77L15.68 10.77L15.68 10.08L14.31 10.08Z",
        "fill": "accent"
      },
      {
        "type": "polygon",
        "d": "M7.04 6.83L5.58 10.58L6.22 10.83L6.65 9.73L7.89 9.73L7.88 10.7L8.56 10.71L8.6 6.83Z",
        "fill": "accent"
      },
      {
        "type": "polygon",
        "d": "M7.91 7.52L7.89 9.04L6.91 9.04L7.51 7.52Z",
        "fill": "truck"
      },
      {
        "type": "polygon",
        "d": "M12.61 6.83L11.38 8.75L10.92 6.83L9.98 6.83L9.21 10.7L9.88 10.83L10.47 7.88L11.09 10.47L12.67 8L12.13 10.7L12.8 10.83L13.6 6.83Z",
        "fill": "accent"
      },
      {
        "type": "polygon",
        "d": "M17.69 7.52L19.1 7.52L19.1 6.83L17.13 6.83L16.36 10.7L17.03 10.83L17.37 9.14L18.52 9.14L18.52 8.46L17.5 8.46Z",
        "fill": "accent"
      }
    ],
    "kerry-express-tw": [
      {
        "type": "polygon",
        "d": "M2.9 6.75L2.9 10.85L3.61 10.85L3.61 9.29L3.95 8.94L5.08 10.85L5.69 10.49L4.47 8.42L5.64 7.26L5.14 6.75L3.61 8.28L3.61 6.75Z",
        "fill": "accent"
      },
      {
        "type": "polygon",
        "d": "M7.08 9.16L8.31 9.16L8.31 8.44L7.08 8.44L7.08 7.46L8.59 7.46L8.59 6.75L6.37 6.75L6.37 10.85L8.59 10.85L8.59 10.14L7.08 10.14Z",
        "fill": "accent"
      },
      {
        "type": "polygon",
        "d": "M11.99 7.51L11.72 7.11L11.31 6.84L10.87 6.75L9.26 6.75L9.26 10.85L9.98 10.85L9.98 9.22L10.19 9.22L11.55 10.85L12.1 10.39L11.08 9.18L11.31 9.14L11.72 8.87L11.99 8.46L12.08 7.99Z",
        "fill": "accent"
      },
      {
        "type": "polygon",
        "d": "M11.32 8.19L11.2 8.35L11.04 8.47L10.8 8.51L9.98 8.51L9.98 7.46L10.8 7.46L11.04 7.51L11.2 7.62L11.32 7.79L11.36 7.99Z",
        "fill": "truck"
      },
      {
        "type": "polygon",
        "d": "M15.23 7.11L14.82 6.84L14.38 6.75L12.77 6.75L12.77 10.85L13.48 10.85L13.48 9.22L13.7 9.22L15.06 10.85L15.61 10.39L14.59 9.18L14.82 9.14L15.23 8.87L15.49 8.46L15.59 7.99L15.49 7.51Z",
        "fill": "accent"
      },
      {
        "type": "polygon",
        "d": "M14.71 8.35L14.55 8.47L14.31 8.51L13.48 8.51L13.48 7.46L14.31 7.46L14.55 7.51L14.71 7.62L14.83 7.79L14.86 7.99L14.83 8.19Z",
        "fill": "truck"
      },
      {
        "type": "polygon",
        "d": "M17.94 8.91L19.1 7.14L18.51 6.75L17.58 8.15L16.66 6.75L16.06 7.14L17.23 8.91L17.23 10.85L17.94 10.85Z",
        "fill": "accent"
      }
    ],
    "latam-global-express": [
      {
        "type": "polygon",
        "d": "M4.99 8.12L6.54 8.12L6.54 7.6L5.61 7.6L6.05 5.18L5.54 5.08Z",
        "fill": "#020203"
      },
      {
        "type": "polygon",
        "d": "M7.03 7.98L7.52 8.16L7.83 7.33L8.77 7.33L8.78 8.07L9.3 8.07L9.27 5.13L8.09 5.13Z",
        "fill": "#020203"
      },
      {
        "type": "polygon",
        "d": "M8.02 6.81L8.45 5.65L8.75 5.65L8.77 6.81Z",
        "fill": "truck"
      },
      {
        "type": "polygon",
        "d": "M10.3 8.17L10.75 5.65L11.3 5.65L11.3 5.13L9.77 5.13L9.77 5.65L10.23 5.65L9.79 8.07Z",
        "fill": "#020203"
      },
      {
        "type": "polygon",
        "d": "M8.1 12.47L8.1 11.95L7.17 11.95L7.61 9.53L7.1 9.43L6.55 12.47Z",
        "fill": "#020203"
      },
      {
        "type": "polygon",
        "d": "M8.79 10.18L8.63 10.61L8.51 11.25L8.52 11.69L8.72 12.1L9.09 12.38L9.54 12.47L10.01 12.38L10.43 12.14L10.74 11.76L10.9 11.34L11.02 10.7L11.01 10.26L10.81 9.84L10.45 9.57L9.99 9.47L9.52 9.56L9.11 9.81Z",
        "fill": "#020203"
      },
      {
        "type": "polygon",
        "d": "M9.31 11.9L9.14 11.77L9.04 11.57L9.03 11.29L9.13 10.75L9.24 10.45L9.45 10.21L9.71 10.06L9.99 10L10.23 10.05L10.4 10.18L10.49 10.38L10.5 10.66L10.4 11.2L10.29 11.5L10.09 11.73L9.82 11.89L9.55 11.95Z",
        "fill": "truck"
      },
      {
        "type": "polygon",
        "d": "M4.61 11.79L4.52 11.61L4.52 11.37L4.65 10.67L4.72 10.45L4.85 10.27L5.02 10.12L5.22 10.03L5.42 10L5.59 10.03L5.73 10.11L5.85 10.27L6.26 9.95L6.08 9.71L5.77 9.54L5.43 9.48L5.07 9.53L4.74 9.68L4.46 9.92L4.25 10.22L4.14 10.54L4 11.32L4.01 11.74L4.2 12.13L4.54 12.39L4.97 12.47L5.41 12.39L5.8 12.16L6.09 11.81L6.24 11.41L6.34 10.84L5.17 10.84L5.17 11.36L5.71 11.36L5.64 11.54L5.46 11.76L5.22 11.9L4.97 11.95L4.76 11.9Z",
        "fill": "#020203"
      },
      {
        "type": "polygon",
        "d": "M11.45 8.16L11.76 7.33L12.7 7.33L12.71 8.07L13.23 8.07L13.2 5.13L12.02 5.13L10.97 7.98Z",
        "fill": "#020203"
      },
      {
        "type": "polygon",
        "d": "M12.38 5.65L12.69 5.65L12.7 6.81L11.95 6.81Z",
        "fill": "truck"
      },
      {
        "type": "polygon",
        "d": "M15.35 6.59L14.97 5.13L14.26 5.13L13.73 8.07L14.24 8.17L14.64 5.92L15.15 7.89L16.32 6.01L15.95 8.07L16.46 8.17L17.01 5.13L16.26 5.13Z",
        "fill": "#020203"
      },
      {
        "type": "polygon",
        "d": "M16.45 12.47L18 12.47L18 11.95L17.07 11.95L17.51 9.53L17 9.43Z",
        "fill": "#020203"
      },
      {
        "type": "polygon",
        "d": "M13.35 9.83L13.2 9.64L12.98 9.52L12.76 9.48L12 9.48L11.75 9.43L11.21 12.42L11.72 12.52L11.73 12.47L12.48 12.47L12.72 12.43L12.96 12.32L13.17 12.14L13.32 11.92L13.4 11.69L13.43 11.52L13.44 11.27L13.36 11.02L13.2 10.83L13.32 10.66L13.4 10.44L13.43 10.29L13.43 10.06Z",
        "fill": "#020203"
      },
      {
        "type": "polygon",
        "d": "M12.85 11.22L12.89 11.27L12.92 11.35L12.92 11.46L12.9 11.56L12.86 11.69L12.78 11.79L12.68 11.88L12.57 11.93L12.44 11.95L11.82 11.95L11.97 11.16L12.67 11.16L12.78 11.18Z",
        "fill": "truck"
      },
      {
        "type": "polygon",
        "d": "M12.86 10.42L12.8 10.51L12.71 10.58L12.62 10.62L12.51 10.64L12.06 10.64L12.18 10L12.72 10L12.81 10.01L12.86 10.04L12.89 10.08L12.91 10.14L12.91 10.24L12.89 10.31Z",
        "fill": "truck"
      },
      {
        "type": "polygon",
        "d": "M14.49 11.68L15.44 11.68L15.44 12.42L15.96 12.42L15.93 9.48L14.75 9.48L13.7 12.33L14.19 12.51Z",
        "fill": "#020203"
      },
      {
        "type": "polygon",
        "d": "M14.69 11.16L15.12 10L15.42 10L15.43 11.16Z",
        "fill": "truck"
      }
    ],
    "lex-id": [
      {
        "type": "line",
        "d": "M4.49 6.9L3.52 11.21L7.24 11.21M12.82 7.46L9.06 7.46L8.22 11.21L11.98 11.21M8.64 9.33L11.89 9.33",
        "stroke": "accent",
        "strokeWidth": 1.12
      },
      {
        "type": "polygon",
        "d": "M16.72 11.77L18.15 11.77L17.09 9.41L19.2 6.99L19.1 6.9L17.55 6.9L15.56 9.19Z",
        "fill": "accent"
      },
      {
        "type": "polygon",
        "d": "M12.06 11.67L12.17 11.77L13.72 11.77L15.83 9.43L14.62 6.9L13.18 6.9L14.28 9.2Z",
        "fill": "accent"
      }
    ],
    "m24-logistics": [
      {
        "type": "polygon",
        "d": "M7.77 8.87L7.77 11.8L8.62 11.8L8.62 5.8L6.37 9.54L4.13 5.8L4.13 11.8L4.98 11.8L4.98 8.87L6.37 11.19Z",
        "fill": "accent"
      },
      {
        "type": "polygon",
        "d": "M17.87 10.51L17.87 9.66L17.07 9.66L17.07 5.95L13.98 10.51L16.22 10.51L16.22 11.8L17.07 11.8L17.07 10.51Z",
        "fill": "accent"
      },
      {
        "type": "polygon",
        "d": "M15.58 9.66L16.22 8.71L16.22 9.66Z",
        "fill": "truck"
      },
      {
        "type": "polygon",
        "d": "M11.96 7.82L12.18 7.95L12.34 8.15L12.43 8.38L12.44 8.63L12.38 8.84L9.43 11.8L13.3 11.8L13.3 10.95L11.47 10.95L13.14 9.28L13.29 8.73L13.27 8.2L13.08 7.71L12.74 7.31L12.29 7.03L11.78 6.91L11.25 6.95L10.77 7.17L10.38 7.52L10.15 7.92L10.89 8.34L11.05 8.06L11.24 7.89L11.47 7.79L11.72 7.76Z",
        "fill": "accent"
      }
    ],
    "multientrega": [
      {
        "type": "polygon",
        "d": "M13.69 6.72L11.61 8.79L11.6 4.14L11.31 4.1L10.69 4.1L10.4 4.14L10.4 8.75L8.29 6.66L7.59 7.36L11.01 10.78L14.38 7.39Z",
        "fill": "accent"
      },
      {
        "type": "polygon",
        "d": "M7.6 8.85L7.59 12.4L8.53 13.35L8.55 9.79Z",
        "fill": "accent"
      },
      {
        "type": "polygon",
        "d": "M14.4 8.85L13.45 9.79L13.47 13.35L14.41 12.4Z",
        "fill": "accent"
      },
      {
        "type": "polygon",
        "d": "M11.56 11.82L10.99 12.36L10.41 11.82L10.4 13.69L11.59 13.7L11.6 11.83Z",
        "fill": "accent"
      }
    ],
    "om-logistics": [
      {
        "type": "polygon",
        "d": "M12.24 7.5L12.29 7.24L12.31 6.99L12.3 6.73L12.27 6.47L12.22 6.22L12.14 5.97L12.03 5.73L11.9 5.51L11.75 5.3L11.58 5.1L11.5 5.03L11.68 4.96L11.87 4.91L12.08 4.88L12.28 4.88L12.48 4.89L12.68 4.92L12.88 4.97L13.07 5.04L13.25 5.13L13.43 5.24L13.59 5.37L13.74 5.51L13.87 5.66L13.98 5.83L14.08 6.01L14.16 6.2L14.22 6.39L14.27 6.59L14.29 6.79L14.29 7L14.27 7.2L14.23 7.4L14.17 7.59L14.09 7.78L13.99 7.96L13.87 8.13L13.74 8.28L13.6 8.43L13.44 8.55L13.26 8.66L13.08 8.75L12.88 8.83L13.07 9.34L13.3 9.26L13.53 9.14L13.75 9L13.96 8.84L14.14 8.66L14.31 8.46L14.46 8.25L14.58 8.02L14.68 7.78L14.76 7.54L14.81 7.28L14.84 7.02L14.84 6.76L14.81 6.51L14.76 6.25L14.68 6.01L14.58 5.77L14.45 5.54L14.3 5.33L14.14 5.13L13.95 4.95L13.74 4.79L13.52 4.65L13.29 4.54L13.05 4.45L12.8 4.38L12.54 4.34L12.28 4.32L12.02 4.34L11.77 4.37L11.52 4.44L11.27 4.52L11 4.66L10.73 4.52L10.48 4.44L10.23 4.37L9.98 4.34L9.72 4.32L9.46 4.34L9.2 4.38L8.95 4.45L8.71 4.54L8.48 4.65L8.26 4.79L8.05 4.95L7.86 5.13L7.7 5.33L7.55 5.54L7.42 5.77L7.32 6.01L7.24 6.25L7.19 6.51L7.16 6.76L7.16 7.02L7.19 7.28L7.24 7.54L7.32 7.78L7.42 8.02L7.54 8.25L7.69 8.46L7.86 8.66L8.04 8.84L8.25 9L8.47 9.14L8.7 9.26L8.93 9.34L9.12 8.83L8.92 8.75L8.74 8.66L8.56 8.55L8.4 8.43L8.26 8.28L8.13 8.13L8.01 7.96L7.91 7.78L7.83 7.59L7.77 7.4L7.73 7.2L7.71 7L7.71 6.79L7.73 6.59L7.78 6.39L7.84 6.2L7.92 6.01L8.02 5.83L8.13 5.66L8.26 5.51L8.41 5.37L8.57 5.24L8.75 5.13L8.93 5.04L9.12 4.97L9.32 4.92L9.52 4.89L9.72 4.88L9.92 4.88L10.13 4.91L10.32 4.96L10.5 5.03L10.42 5.1L10.25 5.3L10.1 5.51L9.97 5.73L9.86 5.97L9.78 6.22L9.73 6.47L9.7 6.73L9.69 6.99L9.71 7.24L9.76 7.5L9.83 7.75L9.93 7.98L10.44 7.77L10.35 7.57L10.3 7.37L10.26 7.17L10.24 6.97L10.24 6.76L10.27 6.56L10.31 6.36L10.38 6.17L10.46 5.98L10.56 5.81L10.68 5.64L10.81 5.49L11 5.32L11.19 5.49L11.32 5.64L11.44 5.81L11.54 5.98L11.62 6.17L11.69 6.36L11.73 6.56L11.76 6.76L11.76 6.97L11.74 7.17L11.7 7.37L11.65 7.57L11.56 7.77L12.07 7.98L12.17 7.75Z",
        "fill": "accent"
      },
      {
        "type": "polygon",
        "d": "M13.07 11.78L13.07 13.4L13.53 13.4L13.53 10.1L12.3 12.15L11.07 10.1L11.07 13.4L11.53 13.4L11.53 11.78L12.3 13.06Z",
        "fill": "accent"
      },
      {
        "type": "polygon",
        "d": "M10.31 11.02L9.96 10.79L9.55 10.7L9.13 10.79L8.78 11.02L8.55 11.37L8.47 11.76L8.47 12.34L8.55 12.73L8.78 13.08L9.13 13.32L9.55 13.4L9.96 13.32L10.31 13.08L10.54 12.73L10.62 12.34L10.62 11.76L10.54 11.37Z",
        "fill": "accent"
      },
      {
        "type": "polygon",
        "d": "M10.16 12.3L10.11 12.55L9.97 12.75L9.78 12.88L9.55 12.92L9.31 12.88L9.12 12.75L8.99 12.55L8.93 12.3L8.93 11.81L8.99 11.55L9.12 11.36L9.31 11.23L9.55 11.18L9.78 11.23L9.97 11.36L10.11 11.55L10.16 11.81Z",
        "fill": "truck"
      }
    ],
    "peru-box-air": [
      {
        "type": "polygon",
        "d": "M8.36 6.3L8.17 6.01L7.88 5.82L7.56 5.76L6.51 5.76L6.51 8.69L7.02 8.69L7.02 7.53L7.56 7.53L7.88 7.46L8.17 7.27L8.36 6.98L8.43 6.64Z",
        "fill": "accent"
      },
      {
        "type": "polygon",
        "d": "M7.88 6.78L7.8 6.9L7.68 6.98L7.51 7.02L7.02 7.02L7.02 6.27L7.51 6.27L7.68 6.3L7.8 6.38L7.88 6.5L7.91 6.64Z",
        "fill": "truck"
      },
      {
        "type": "polygon",
        "d": "M10.3 7.48L10.3 6.97L9.42 6.97L9.42 6.27L10.5 6.27L10.5 5.76L8.91 5.76L8.91 8.69L10.5 8.69L10.5 8.18L9.42 8.18L9.42 7.48Z",
        "fill": "accent"
      },
      {
        "type": "polygon",
        "d": "M12.93 6.3L12.74 6.01L12.45 5.82L12.13 5.76L10.98 5.76L10.98 8.69L11.49 8.69L11.49 7.53L11.64 7.53L12.62 8.69L13.01 8.36L12.28 7.5L12.45 7.46L12.74 7.27L12.93 6.98L13 6.64Z",
        "fill": "accent"
      },
      {
        "type": "polygon",
        "d": "M12.45 6.78L12.37 6.9L12.25 6.98L12.08 7.02L11.49 7.02L11.49 6.27L12.08 6.27L12.25 6.3L12.37 6.38L12.45 6.5L12.48 6.64Z",
        "fill": "truck"
      },
      {
        "type": "polygon",
        "d": "M6.56 10.74L6.47 11.17L6.47 11.8L6.56 12.23L6.81 12.61L7.2 12.87L7.65 12.96L8.1 12.87L8.48 12.61L8.74 12.23L8.82 11.8L8.82 11.17L8.74 10.74L8.48 10.36L8.1 10.11L7.65 10.02L7.2 10.11L6.81 10.36Z",
        "fill": "accent"
      },
      {
        "type": "polygon",
        "d": "M7.65 12.44L7.39 12.39L7.18 12.24L7.04 12.03L6.98 11.75L6.98 11.22L7.04 10.94L7.18 10.73L7.39 10.58L7.65 10.53L7.9 10.58L8.11 10.73L8.26 10.94L8.31 11.22L8.31 11.75L8.26 12.03L8.11 12.24L7.9 12.39Z",
        "fill": "truck"
      },
      {
        "type": "polygon",
        "d": "M5.64 10.33L5.47 10.16L5.26 10.05L5.04 10.02L4 10.02L4 12.95L5.2 12.95L5.44 12.91L5.67 12.79L5.85 12.61L5.97 12.38L6.01 12.14L6.01 11.97L5.97 11.73L5.85 11.5L5.66 11.31L5.75 11.14L5.78 10.92L5.78 10.77L5.75 10.55Z",
        "fill": "accent"
      },
      {
        "type": "polygon",
        "d": "M5.37 11.73L5.44 11.8L5.48 11.89L5.5 12.01L5.5 12.1L5.48 12.22L5.44 12.31L5.37 12.38L5.28 12.42L5.16 12.44L4.51 12.44L4.51 11.67L5.16 11.67L5.28 11.69Z",
        "fill": "truck"
      },
      {
        "type": "polygon",
        "d": "M5.26 10.98L5.22 11.05L5.17 11.11L5.1 11.14L5 11.16L4.51 11.16L4.51 10.53L5 10.53L5.1 10.54L5.17 10.58L5.22 10.64L5.26 10.71L5.28 10.81L5.28 10.88Z",
        "fill": "truck"
      },
      {
        "type": "polygon",
        "d": "M9.03 10.3L9.81 11.49L9.03 12.67L9.45 12.95L10.11 11.95L10.77 12.95L11.2 12.67L10.42 11.49L11.2 10.3L10.77 10.02L10.11 11.02L9.45 10.02Z",
        "fill": "accent"
      },
      {
        "type": "polygon",
        "d": "M14.18 5.2L14.55 5.54L15.06 4.99L14.68 4.64Z",
        "fill": "accent"
      },
      {
        "type": "polygon",
        "d": "M14.75 8.66L14.99 8.56L15.2 8.4L15.36 8.19L15.46 7.94L15.49 7.7L15.49 5.76L14.98 5.76L14.98 7.67L14.96 7.81L14.91 7.93L14.84 8.03L14.73 8.11L14.61 8.16L14.49 8.18L14.36 8.16L14.24 8.11L14.14 8.03L14.06 7.93L14.01 7.81L13.99 7.67L13.99 5.76L13.48 5.76L13.48 7.7L13.51 7.94L13.61 8.19L13.77 8.4L13.98 8.56L14.23 8.66L14.49 8.69Z",
        "fill": "accent"
      },
      {
        "type": "polygon",
        "d": "M12.77 12.95L12.92 12.18L13.85 12.18L14 12.95L14.5 12.86L13.96 10.02L12.81 10.02L12.27 12.86Z",
        "fill": "accent"
      },
      {
        "type": "polygon",
        "d": "M13.23 10.53L13.54 10.53L13.75 11.67L13.02 11.67Z",
        "fill": "truck"
      },
      {
        "type": "polygon",
        "d": "M14.98 12.95L15.49 12.95L15.49 10.02L14.98 10.02Z",
        "fill": "accent"
      },
      {
        "type": "polygon",
        "d": "M17.92 11.24L17.99 10.9L17.92 10.56L17.73 10.28L17.44 10.08L17.12 10.02L15.97 10.02L15.97 12.95L16.48 12.95L16.48 11.79L16.63 11.79L17.61 12.95L18 12.62L17.27 11.76L17.44 11.73L17.73 11.53Z",
        "fill": "accent"
      },
      {
        "type": "polygon",
        "d": "M17.36 11.17L17.24 11.25L17.07 11.28L16.48 11.28L16.48 10.53L17.07 10.53L17.24 10.56L17.36 10.64L17.44 10.76L17.47 10.9L17.44 11.05Z",
        "fill": "truck"
      }
    ],
    "premier-deliveries-uk": [
      {
        "type": "polygon",
        "d": "M13.18 6.89L11.75 9.27L10.32 6.89L10.32 10.71L10.86 10.71L10.86 8.84L11.75 10.32L12.64 8.84L12.64 10.71L13.18 10.71Z",
        "fill": "accent"
      },
      {
        "type": "polygon",
        "d": "M4.87 8.17L4.66 7.87L4.36 7.66L4.02 7.6L2.9 7.6L2.9 10.71L3.44 10.71L3.44 9.47L4.02 9.47L4.36 9.41L4.66 9.2L4.87 8.9L4.94 8.54Z",
        "fill": "accent"
      },
      {
        "type": "polygon",
        "d": "M4.36 8.69L4.27 8.81L4.14 8.9L3.97 8.93L3.44 8.93L3.44 8.14L3.97 8.14L4.14 8.17L4.27 8.26L4.36 8.38L4.39 8.54Z",
        "fill": "truck"
      },
      {
        "type": "polygon",
        "d": "M7.52 8.17L7.32 7.87L7.01 7.66L6.68 7.6L5.45 7.6L5.45 10.71L5.99 10.71L5.99 9.47L6.16 9.47L7.19 10.71L7.61 10.36L6.83 9.44L7.01 9.41L7.32 9.2L7.52 8.9L7.59 8.54Z",
        "fill": "accent"
      },
      {
        "type": "polygon",
        "d": "M7.01 8.69L6.93 8.81L6.8 8.9L6.62 8.93L5.99 8.93L5.99 8.14L6.62 8.14L6.8 8.17L6.93 8.26L7.01 8.38L7.04 8.54Z",
        "fill": "truck"
      },
      {
        "type": "polygon",
        "d": "M9.59 8.88L8.66 8.88L8.66 8.14L9.81 8.14L9.81 7.6L8.12 7.6L8.12 10.71L9.81 10.71L9.81 10.17L8.66 10.17L8.66 9.42L9.59 9.42Z",
        "fill": "accent"
      },
      {
        "type": "polygon",
        "d": "M13.69 7.6L13.69 10.71L14.23 10.71L14.23 7.6Z",
        "fill": "accent"
      },
      {
        "type": "polygon",
        "d": "M16.22 8.88L15.29 8.88L15.29 8.14L16.43 8.14L16.43 7.6L14.75 7.6L14.75 10.71L16.43 10.71L16.43 10.17L15.29 10.17L15.29 9.42L16.22 9.42Z",
        "fill": "accent"
      },
      {
        "type": "polygon",
        "d": "M19.02 8.9L19.09 8.54L19.02 8.17L18.81 7.87L18.5 7.66L18.17 7.6L16.95 7.6L16.95 10.71L17.49 10.71L17.49 9.47L17.65 9.47L18.69 10.71L19.1 10.36L18.33 9.44L18.5 9.41L18.81 9.2Z",
        "fill": "accent"
      },
      {
        "type": "polygon",
        "d": "M18.42 8.81L18.29 8.9L18.12 8.93L17.49 8.93L17.49 8.14L18.12 8.14L18.29 8.17L18.42 8.26L18.51 8.38L18.54 8.54L18.51 8.69Z",
        "fill": "truck"
      }
    ],
    "product-care-group": [
      {
        "type": "polygon",
        "d": "M7.48 8.02L7.99 7.68L8.33 7.17L8.45 6.57L8.33 5.97L7.99 5.46L7.48 5.12L6.92 5.01L5.06 5.01L5.06 10.19L5.96 10.19L5.96 8.13L6.92 8.13Z",
        "fill": "accent"
      },
      {
        "type": "polygon",
        "d": "M7.13 5.96L7.34 6.11L7.49 6.32L7.54 6.57L7.49 6.82L7.34 7.03L7.13 7.18L6.84 7.23L5.96 7.23L5.96 5.91L6.84 5.91Z",
        "fill": "truck"
      },
      {
        "type": "polygon",
        "d": "M10.03 5.33L9.63 5.73L9.38 6.23L9.29 6.75L9.29 8.45L9.38 8.97L9.63 9.47L10.03 9.86L10.53 10.11L11.09 10.2L11.64 10.1L12.14 9.84L12.48 9.49L11.84 8.86L11.59 9.11L11.35 9.24L11.08 9.29L10.81 9.25L10.56 9.12L10.37 8.93L10.24 8.68L10.19 8.38L10.19 6.82L10.24 6.51L10.37 6.27L10.56 6.07L10.81 5.95L11.08 5.91L11.35 5.96L11.59 6.09L11.84 6.34L12.48 5.71L12.14 5.36L11.64 5.09L11.09 5L10.53 5.08Z",
        "fill": "accent"
      },
      {
        "type": "polygon",
        "d": "M14.99 9.28L14.59 9.2L14.26 8.98L14.03 8.64L13.94 8.2L13.94 6.99L14 6.63L14.15 6.34L14.38 6.11L14.68 5.96L15 5.91L15.33 5.97L15.62 6.12L15.9 6.41L16.54 5.78L16.16 5.39L15.62 5.1L15.01 5L14.4 5.09L13.85 5.37L13.41 5.8L13.13 6.35L13.04 6.92L13.04 8.29L13.18 8.99L13.61 9.63L14.24 10.05L14.99 10.2L15.74 10.05L16.38 9.63L16.8 8.99L16.94 8.29L16.94 7.36L14.99 7.36L14.99 8.26L16.03 8.26L15.95 8.64L15.73 8.98L15.39 9.2Z",
        "fill": "accent"
      },
      {
        "type": "circle",
        "cx": 5.68,
        "cy": 11.72,
        "r": 0.62,
        "fill": "#e30613"
      },
      {
        "type": "circle",
        "cx": 7.2,
        "cy": 11.72,
        "r": 0.62,
        "fill": "#e6007e"
      },
      {
        "type": "circle",
        "cx": 8.72,
        "cy": 11.72,
        "r": 0.62,
        "fill": "#a1007d"
      },
      {
        "type": "circle",
        "cx": 10.24,
        "cy": 11.72,
        "r": 0.62,
        "fill": "#1947ba"
      },
      {
        "type": "circle",
        "cx": 11.76,
        "cy": 11.72,
        "r": 0.62,
        "fill": "#009fe3"
      },
      {
        "type": "circle",
        "cx": 13.28,
        "cy": 11.72,
        "r": 0.62,
        "fill": "#93d50a"
      },
      {
        "type": "circle",
        "cx": 14.8,
        "cy": 11.72,
        "r": 0.62,
        "fill": "#fd8204"
      },
      {
        "type": "circle",
        "cx": 16.32,
        "cy": 11.72,
        "r": 0.62,
        "fill": "#ffed00"
      }
    ],
    "rangel": [
      {
        "type": "polygon",
        "d": "M17.88 7.08L17.37 10.48L19.1 10.48L19.1 9.9L18.05 9.9L18.46 7.16Z",
        "fill": "accent"
      },
      {
        "type": "polygon",
        "d": "M11.21 7.08L10.79 9.9L10.57 9.9L10.71 7.12L9.38 7.12L8.88 10.44L9.46 10.52L9.88 7.7L10.1 7.7L9.96 10.48L11.29 10.48L11.79 7.16Z",
        "fill": "accent"
      },
      {
        "type": "polygon",
        "d": "M15.75 9.09L16.79 9.09L16.79 8.51L15.83 8.51L15.95 7.7L17.23 7.7L17.23 7.12L15.45 7.12L14.95 10.48L16.81 10.48L16.81 9.9L15.62 9.9Z",
        "fill": "accent"
      },
      {
        "type": "polygon",
        "d": "M5.78 10.33L6.33 10.52L6.65 9.59L7.71 9.59L7.74 10.44L8.32 10.41L8.19 7.12L6.87 7.12Z",
        "fill": "accent"
      },
      {
        "type": "polygon",
        "d": "M7.69 9.01L6.85 9.01L7.29 7.7L7.63 7.7Z",
        "fill": "truck"
      },
      {
        "type": "polygon",
        "d": "M5.53 7.78L5.35 7.43L5.04 7.19L4.68 7.12L3.4 7.12L2.9 10.44L3.48 10.52L3.68 9.15L3.88 9.15L4.78 10.46L5.26 10.13L4.57 9.12L4.82 9.08L5.17 8.87L5.42 8.55L5.55 8.18Z",
        "fill": "accent"
      },
      {
        "type": "polygon",
        "d": "M4.97 8.09L4.91 8.27L4.78 8.42L4.61 8.52L4.4 8.56L3.77 8.56L3.9 7.7L4.62 7.7L4.79 7.74L4.9 7.82L4.96 7.94Z",
        "fill": "truck"
      },
      {
        "type": "polygon",
        "d": "M13.97 9.23L13.89 9.44L13.7 9.68L13.44 9.84L13.17 9.89L12.93 9.84L12.75 9.71L12.65 9.51L12.63 9.23L12.75 8.45L12.82 8.21L12.96 8L13.15 7.84L13.37 7.74L13.59 7.71L13.78 7.74L13.94 7.83L14.09 8.01L14.54 7.64L14.33 7.38L13.99 7.19L13.6 7.12L13.2 7.18L12.83 7.35L12.52 7.61L12.29 7.96L12.18 8.32L12.05 9.2L12.07 9.67L12.29 10.1L12.68 10.39L13.16 10.48L13.65 10.39L14.09 10.13L14.41 9.73L14.57 9.29L14.66 8.65L13.35 8.65L13.35 9.23Z",
        "fill": "#ef5222"
      }
    ],
    "route1-fulfilment": [
      {
        "type": "polygon",
        "d": "M17.97 8.62L18.47 8.18L18.47 10.82L19.1 10.82L19.1 6.78L17.55 8.15Z",
        "fill": "accent"
      },
      {
        "type": "polygon",
        "d": "M5.33 7.84L5.09 7.48L4.73 7.24L4.33 7.16L2.9 7.16L2.9 10.82L3.53 10.82L3.53 9.37L3.72 9.37L4.94 10.82L5.43 10.41L4.52 9.33L4.73 9.29L5.09 9.05L5.33 8.69L5.41 8.27Z",
        "fill": "accent"
      },
      {
        "type": "polygon",
        "d": "M4.73 8.44L4.63 8.59L4.48 8.69L4.27 8.73L3.53 8.73L3.53 7.8L4.27 7.8L4.48 7.84L4.63 7.94L4.73 8.09L4.77 8.27Z",
        "fill": "truck"
      },
      {
        "type": "polygon",
        "d": "M6.39 7.59L6.07 8.06L5.96 8.6L5.96 9.38L6.07 9.91L6.39 10.39L6.86 10.71L7.43 10.82L7.99 10.71L8.47 10.39L8.78 9.91L8.89 9.38L8.89 8.6L8.78 8.06L8.47 7.59L7.99 7.27L7.43 7.16L6.86 7.27Z",
        "fill": "accent"
      },
      {
        "type": "polygon",
        "d": "M7.43 10.18L7.11 10.11L6.84 9.93L6.66 9.67L6.6 9.32L6.6 8.66L6.66 8.31L6.84 8.04L7.11 7.87L7.43 7.8L7.74 7.87L8.01 8.04L8.19 8.31L8.26 8.66L8.26 9.32L8.19 9.67L8.01 9.93L7.74 10.11Z",
        "fill": "truck"
      },
      {
        "type": "polygon",
        "d": "M13.22 10.82L13.86 10.82L13.86 7.8L14.47 7.8L14.47 7.16L12.6 7.16L12.6 7.8L13.22 7.8Z",
        "fill": "accent"
      },
      {
        "type": "polygon",
        "d": "M16.81 9.31L16.81 8.67L15.71 8.67L15.71 7.8L17.06 7.8L17.06 7.16L15.08 7.16L15.08 10.82L17.06 10.82L17.06 10.18L15.71 10.18L15.71 9.31Z",
        "fill": "accent"
      },
      {
        "type": "polygon",
        "d": "M10.75 10.82L11.07 10.78L11.37 10.65L11.63 10.45L11.83 10.19L11.96 9.89L12 9.58L12 7.16L11.37 7.16L11.37 9.54L11.34 9.72L11.28 9.87L11.18 10L11.05 10.1L10.91 10.16L10.75 10.18L10.59 10.16L10.44 10.1L10.31 10L10.21 9.87L10.15 9.72L10.13 9.54L10.13 7.16L9.49 7.16L9.49 9.58L9.53 9.89L9.66 10.19L9.86 10.45L10.12 10.65L10.42 10.78Z",
        "fill": "accent"
      }
    ],
    "seabourne-logistics": [
      {
        "type": "polygon",
        "d": "M16.82 9.08L16.87 9.03L16.87 6.95L16.58 6.65L16.2 6.32L15.62 5.91L14.51 5.31L13.26 4.9L12.09 4.71L11.05 4.7L10.19 4.8L9.26 5.02L8.24 5.41L7.41 5.88L6.5 6.55L5.72 7.33L5.17 8.07L5.21 8.11L7.26 8.11L7.44 7.74L7.63 7.45L8.2 6.94L9.09 6.86L9.99 6.88L10.66 6.97L11.32 7.12L12.51 7.54L13.69 8.22L14.72 9.08Z",
        "fill": "#9c9e9b"
      },
      {
        "type": "polygon",
        "d": "M14.72 9.08L16.75 9.07L16.79 9.02L16.52 8.7L15.66 7.89L14.88 7.3L14.14 6.85L13.2 6.38L12.24 6.02L11.31 5.78L10.24 5.61L8.79 5.56L7.8 5.66L7.12 6.07L6.43 6.63L5.7 7.37L5.23 7.98L5.27 8.02L6.43 7.42L7.63 7.04L8.74 6.87L10.07 6.88L11.34 7.12L12.5 7.53L13.1 7.84L13.66 8.19Z",
        "fill": "accent"
      },
      {
        "type": "polygon",
        "d": "M10.72 13.1L11.69 13.01L12.55 12.83L13.26 12.6L14.07 12.23L14.03 12.14L14.2 12.13L14.62 11.89L15.21 11.47L15.71 11.04L16.45 10.25L16.82 9.75L16.82 9.68L14.74 9.67L14.57 10.02L14.35 10.33L13.8 10.83L12.94 10.92L11.99 10.89L10.73 10.67L9.53 10.24L8.38 9.59L7.3 8.7L5.14 8.72L5.13 10.84L5.84 11.49L6.93 12.2L7.6 12.52L8.2 12.74L9.53 13.04Z",
        "fill": "#861d1a"
      },
      {
        "type": "polygon",
        "d": "M12.94 12.22L14.2 12.12L14.62 11.87L15.21 11.46L15.73 11L16.38 10.32L16.71 9.89L16.75 9.78L15.52 10.38L14.4 10.73L13.15 10.92L12.03 10.9L11.36 10.82L10.69 10.67L9.5 10.24L8.84 9.9L8.29 9.54L7.28 8.7L5.25 8.71L5.21 8.75L5.86 9.46L6.71 10.17L7.58 10.76L8.55 11.27L9.42 11.63L10.37 11.94L11.82 12.17Z",
        "fill": "accent"
      }
    ],
    "sgk-home-delivery": [
      {
        "type": "polygon",
        "d": "M3.69 7.86L4.43 8.94L6.35 9.54L6.65 9.96L6.56 10.4L6.06 10.75L5.34 10.75L4.67 10.28L4.07 11.13L5.01 11.79L6.39 11.79L7.49 11.01L7.76 9.74L7 8.66L5.08 8.06L4.8 7.64L4.89 7.19L5.36 6.84L6.04 6.84L6.67 7.31L7.28 6.48L6.38 5.81L5.02 5.81L3.96 6.59Z",
        "fill": "accent"
      },
      {
        "type": "polygon",
        "d": "M18.31 11.26L16.53 8.25L18.24 6.54L17.5 5.81L15.27 8.04L15.27 5.81L14.23 5.81L14.23 11.79L15.27 11.79L15.27 9.51L15.77 9.01L17.42 11.79Z",
        "fill": "accent"
      },
      {
        "type": "polygon",
        "d": "M10.53 10.65L10.14 10.39L9.88 10L9.78 9.49L9.78 8.1L9.85 7.68L10.02 7.34L10.29 7.08L10.63 6.91L11 6.85L11.38 6.92L11.71 7.09L12.04 7.42L12.78 6.7L12.35 6.25L11.72 5.92L11.02 5.8L10.31 5.9L9.68 6.22L9.17 6.72L8.85 7.35L8.74 8.02L8.74 9.59L8.9 10.4L9.39 11.14L10.13 11.63L10.99 11.8L11.86 11.63L12.59 11.14L13.08 10.4L13.24 9.59L13.24 8.53L10.99 8.53L10.99 9.56L12.19 9.56L12.1 10L11.84 10.39L11.45 10.65L10.99 10.74Z",
        "fill": "accent"
      }
    ],
    "shalom-pe": [
      {
        "type": "polygon",
        "d": "M11.6 7.2L10.67 10.32L12.28 10.32L12.28 9.8L11.38 9.8L12.11 7.35Z",
        "fill": "accent"
      },
      {
        "type": "polygon",
        "d": "M4.29 9.16L4.36 9.32L4.23 9.58L3.86 9.8L3.5 9.8L3.25 9.57L2.9 9.97L3.3 10.32L4 10.32L4.63 9.96L4.94 9.35L4.69 8.74L3.81 8.44L3.75 8.28L3.89 8.02L4.24 7.8L4.57 7.8L4.8 8.02L5.17 7.64L4.79 7.28L4.09 7.28L3.48 7.64L3.17 8.25L3.41 8.86Z",
        "fill": "accent"
      },
      {
        "type": "polygon",
        "d": "M8.18 7.35L7.67 7.2L7.27 8.54L6.26 8.54L6.62 7.35L6.11 7.2L5.2 10.25L5.7 10.4L6.11 9.06L7.12 9.06L6.76 10.25L7.27 10.4Z",
        "fill": "accent"
      },
      {
        "type": "polygon",
        "d": "M13.96 7.36L13.52 7.61L13.16 7.98L12.95 8.4L12.76 9.05L12.71 9.5L12.87 9.94L13.22 10.23L13.68 10.33L14.17 10.24L14.61 9.99L14.97 9.62L15.18 9.2L15.37 8.55L15.42 8.1L15.26 7.66L14.91 7.37L14.44 7.27Z",
        "fill": "accent"
      },
      {
        "type": "polygon",
        "d": "M13.69 9.79L13.46 9.74L13.32 9.62L13.25 9.43L13.28 9.15L13.44 8.6L13.6 8.29L13.84 8.03L14.14 7.87L14.44 7.81L14.67 7.86L14.81 7.98L14.88 8.17L14.85 8.45L14.68 9L14.53 9.31L14.28 9.57L13.98 9.73Z",
        "fill": "truck"
      },
      {
        "type": "polygon",
        "d": "M8.34 10.39L8.77 9.52L9.71 9.52L9.63 10.25L10.16 10.3L10.49 7.28L9.28 7.28L7.87 10.16Z",
        "fill": "accent"
      },
      {
        "type": "polygon",
        "d": "M9.77 8.99L9.03 8.99L9.61 7.8L9.9 7.8Z",
        "fill": "truck"
      },
      {
        "type": "polygon",
        "d": "M17.23 8.71L17.07 7.28L16.28 7.28L15.39 10.25L15.9 10.4L16.62 8L16.86 10.14L18.29 8.14L17.66 10.25L18.16 10.4L19.1 7.28L18.26 7.28Z",
        "fill": "accent"
      }
    ],
    "sorthub": [
      {
        "type": "polygon",
        "d": "M4.42 8.59L4.56 8.78L4.51 8.98L4.28 9.14L3.96 9.14L3.65 8.92L3.38 9.31L3.8 9.61L4.44 9.61L4.94 9.26L5.06 8.68L4.71 8.18L3.84 7.91L3.71 7.72L3.75 7.51L3.97 7.35L4.27 7.35L4.56 7.57L4.84 7.19L4.43 6.88L3.81 6.88L3.32 7.24L3.2 7.82L3.54 8.31Z",
        "fill": "accent"
      },
      {
        "type": "polygon",
        "d": "M5.58 7.55L5.5 7.95L5.5 8.54L5.58 8.94L5.82 9.3L6.17 9.53L6.59 9.62L7.02 9.53L7.37 9.3L7.61 8.94L7.69 8.54L7.69 7.95L7.61 7.55L7.37 7.2L7.02 6.96L6.59 6.87L6.17 6.96L5.82 7.2Z",
        "fill": "accent"
      },
      {
        "type": "polygon",
        "d": "M6.36 9.09L6.16 8.95L6.02 8.75L5.97 8.49L5.97 8L6.02 7.74L6.16 7.54L6.36 7.41L6.59 7.36L6.83 7.41L7.03 7.54L7.16 7.74L7.22 8L7.22 8.49L7.16 8.75L7.03 8.95L6.83 9.09L6.59 9.13Z",
        "fill": "truck"
      },
      {
        "type": "polygon",
        "d": "M9.96 7.39L9.78 7.12L9.51 6.94L9.22 6.88L8.14 6.88L8.14 9.61L8.62 9.61L8.62 8.53L8.76 8.53L9.67 9.61L10.03 9.31L9.36 8.5L9.51 8.47L9.78 8.29L9.96 8.02L10.02 7.7Z",
        "fill": "accent"
      },
      {
        "type": "polygon",
        "d": "M9.51 7.84L9.44 7.95L9.33 8.02L9.17 8.05L8.62 8.05L8.62 7.35L9.17 7.35L9.33 7.38L9.44 7.46L9.51 7.57L9.54 7.7Z",
        "fill": "truck"
      },
      {
        "type": "polygon",
        "d": "M11.35 9.61L11.35 7.35L11.82 7.35L11.82 6.88L10.41 6.88L10.41 7.35L10.88 7.35L10.88 9.61Z",
        "fill": "accent"
      },
      {
        "type": "polygon",
        "d": "M13.67 8.48L13.67 9.61L14.14 9.61L14.14 6.88L13.67 6.88L13.67 8.01L12.74 8.01L12.74 6.88L12.27 6.88L12.27 9.61L12.74 9.61L12.74 8.48Z",
        "fill": "accent"
      },
      {
        "type": "polygon",
        "d": "M18.46 7.17L18.3 7.01L18.1 6.91L17.89 6.88L16.92 6.88L16.92 9.61L18.04 9.61L18.26 9.58L18.48 9.47L18.65 9.3L18.76 9.08L18.8 8.86L18.8 8.7L18.76 8.48L18.65 8.26L18.48 8.08L18.56 7.92L18.59 7.72L18.59 7.58L18.56 7.37Z",
        "fill": "accent"
      },
      {
        "type": "polygon",
        "d": "M18.1 7.77L18.07 7.84L18.01 7.89L17.95 7.93L17.86 7.94L17.4 7.94L17.4 7.35L17.86 7.35L17.95 7.37L18.01 7.4L18.07 7.45L18.1 7.52L18.12 7.61L18.12 7.68Z",
        "fill": "truck"
      },
      {
        "type": "polygon",
        "d": "M18.27 8.54L18.31 8.63L18.33 8.74L18.33 8.82L18.31 8.93L18.27 9.01L18.2 9.08L18.12 9.12L18 9.14L17.4 9.14L17.4 8.42L18 8.42L18.12 8.43L18.2 8.48Z",
        "fill": "truck"
      },
      {
        "type": "polygon",
        "d": "M15.78 9.58L16 9.49L16.2 9.34L16.35 9.15L16.44 8.92L16.47 8.69L16.47 6.88L16 6.88L16 8.66L15.98 8.8L15.93 8.91L15.86 9L15.76 9.08L15.65 9.12L15.53 9.14L15.41 9.12L15.3 9.08L15.21 9L15.13 8.91L15.09 8.8L15.07 8.66L15.07 6.88L14.6 6.88L14.6 8.69L14.63 8.92L14.72 9.15L14.87 9.34L15.06 9.49L15.29 9.58L15.53 9.62Z",
        "fill": "accent"
      },
      {
        "type": "polygon",
        "d": "M18.57 9.91L18.57 10.73L3.43 10.73L3.43 9.91Z",
        "fill": "#fcb415"
      }
    ],
    "spfly": [
      {
        "type": "polygon",
        "d": "M3.44 7.11L3.06 8.02L3.49 8.89L4.84 9.34L4.97 9.61L4.82 9.96L4.34 10.26L3.8 10.26L3.4 9.93L2.9 10.53L3.52 11.04L4.56 11.04L5.45 10.49L5.83 9.57L5.39 8.71L4.05 8.26L3.92 8L4.07 7.63L4.53 7.34L5.03 7.34L5.41 7.67L5.92 7.08L5.33 6.56L4.3 6.56Z",
        "fill": "accent"
      },
      {
        "type": "polygon",
        "d": "M8.83 9.17L9.3 8.89L9.66 8.48L9.86 7.99L9.86 7.45L9.63 6.98L9.22 6.66L8.73 6.56L7.19 6.56L6.31 10.97L7.07 11.12L7.44 9.26L8.35 9.26Z",
        "fill": "accent"
      },
      {
        "type": "polygon",
        "d": "M8.65 7.34L8.88 7.38L9.01 7.48L9.08 7.63L9.08 7.84L8.98 8.07L8.79 8.29L8.55 8.43L8.27 8.48L7.6 8.48L7.83 7.34Z",
        "fill": "truck"
      },
      {
        "type": "polygon",
        "d": "M14.11 10.26L14.84 6.63L14.07 6.48L13.16 11.04L15.49 11.04L15.49 10.26Z",
        "fill": "#231f20"
      },
      {
        "type": "polygon",
        "d": "M16.65 8.85L16.23 10.97L16.99 11.12L17.42 8.98L19.1 7.02L18.51 6.52L17.16 8.09L16.48 6.61L15.77 6.93Z",
        "fill": "#231f20"
      },
      {
        "type": "polygon",
        "d": "M13.14 7.34L13.14 6.56L10.9 6.56L10.01 10.97L10.78 11.12L11.16 9.19L12.48 9.19L12.48 8.41L11.32 8.41L11.54 7.34Z",
        "fill": "#231f20"
      }
    ],
    "stop-start": [
      {
        "type": "polygon",
        "d": "M7.69 6.7L8.71 7.02L8.86 7.24L8.82 7.47L8.55 7.66L8.17 7.66L7.82 7.41L7.5 7.86L7.99 8.21L8.73 8.21L9.31 7.8L9.45 7.12L9.05 6.55L8.03 6.23L7.88 6.01L7.93 5.78L8.18 5.59L8.54 5.59L8.87 5.84L9.2 5.39L8.72 5.04L8 5.04L7.44 5.46L7.29 6.13Z",
        "fill": "accent"
      },
      {
        "type": "polygon",
        "d": "M10.26 8.21L10.81 8.21L10.81 5.59L11.35 5.59L11.35 5.04L9.72 5.04L9.72 5.59L10.26 5.59Z",
        "fill": "accent"
      },
      {
        "type": "polygon",
        "d": "M12.51 5.13L12.1 5.41L11.82 5.82L11.73 6.28L11.73 6.97L11.82 7.43L12.1 7.84L12.51 8.12L13 8.22L13.49 8.12L13.9 7.84L14.18 7.43L14.27 6.97L14.27 6.28L14.18 5.82L13.9 5.41L13.49 5.13L13 5.03Z",
        "fill": "accent"
      },
      {
        "type": "polygon",
        "d": "M13.27 7.6L13 7.66L12.73 7.6L12.49 7.45L12.34 7.21L12.28 6.91L12.28 6.34L12.34 6.04L12.49 5.81L12.73 5.65L13 5.6L13.27 5.65L13.51 5.81L13.66 6.04L13.72 6.34L13.72 6.91L13.66 7.21L13.51 7.45Z",
        "fill": "truck"
      },
      {
        "type": "polygon",
        "d": "M16.8 5.63L16.59 5.32L16.28 5.11L15.94 5.04L14.8 5.04L14.8 8.21L15.35 8.21L15.35 6.95L15.94 6.95L16.28 6.89L16.59 6.68L16.8 6.37L16.87 6Z",
        "fill": "accent"
      },
      {
        "type": "polygon",
        "d": "M16.28 6.15L16.19 6.28L16.06 6.37L15.88 6.4L15.35 6.4L15.35 5.59L15.88 5.59L16.06 5.63L16.19 5.71L16.28 5.84L16.31 6Z",
        "fill": "truck"
      },
      {
        "type": "polygon",
        "d": "M8.71 11.37L8.86 11.6L8.82 11.83L8.55 12.02L8.17 12.02L7.82 11.76L7.5 12.21L7.99 12.57L8.73 12.57L9.31 12.15L9.45 11.48L9.05 10.9L8.03 10.59L7.88 10.36L7.93 10.13L8.18 9.94L8.54 9.94L8.87 10.19L9.2 9.75L8.72 9.39L8 9.39L7.44 9.81L7.29 10.48L7.69 11.05Z",
        "fill": "accent"
      },
      {
        "type": "polygon",
        "d": "M10.81 12.57L10.81 9.94L11.35 9.94L11.35 9.39L9.72 9.39L9.72 9.94L10.26 9.94L10.26 12.57Z",
        "fill": "accent"
      },
      {
        "type": "polygon",
        "d": "M11.4 12.46L11.95 12.57L12.11 11.73L13.11 11.73L13.27 12.57L13.81 12.46L13.23 9.39L11.99 9.39Z",
        "fill": "accent"
      },
      {
        "type": "polygon",
        "d": "M12.21 11.18L12.44 9.94L12.77 9.94L13.01 11.18Z",
        "fill": "truck"
      },
      {
        "type": "polygon",
        "d": "M16.24 9.67L15.93 9.46L15.58 9.39L14.34 9.39L14.34 12.57L14.89 12.57L14.89 11.31L15.05 11.31L16.11 12.57L16.53 12.21L15.75 11.27L15.93 11.24L16.24 11.03L16.45 10.72L16.52 10.35L16.45 9.98Z",
        "fill": "accent"
      },
      {
        "type": "polygon",
        "d": "M15.84 10.63L15.71 10.72L15.53 10.76L14.89 10.76L14.89 9.94L15.53 9.94L15.71 9.98L15.84 10.07L15.93 10.2L15.96 10.35L15.93 10.5Z",
        "fill": "truck"
      },
      {
        "type": "polygon",
        "d": "M18.06 9.94L18.6 9.94L18.6 9.39L16.97 9.39L16.97 9.94L17.51 9.94L17.51 12.57L18.06 12.57Z",
        "fill": "accent"
      },
      {
        "type": "polygon",
        "d": "M6.11 5.52L6.1 5.43L6.07 5.34L6 5.21L5.93 5.15L5.85 5.09L5.76 5.06L5.67 5.04L3.89 5.03L3.79 5.04L3.66 5.09L3.54 5.18L3.48 5.25L3.42 5.38L3.4 5.52L3.4 12.08L3.42 12.22L3.48 12.35L3.54 12.42L3.62 12.48L3.75 12.54L3.89 12.57L5.67 12.56L5.81 12.53L5.93 12.45L6.03 12.35L6.09 12.22L6.11 12.08Z",
        "fill": "accent"
      },
      {
        "type": "circle",
        "cx": 4.76,
        "cy": 6.29,
        "r": 0.98,
        "fill": "#d2372a"
      },
      {
        "type": "circle",
        "cx": 4.76,
        "cy": 8.8,
        "r": 0.98,
        "fill": "truck"
      },
      {
        "type": "circle",
        "cx": 4.76,
        "cy": 11.31,
        "r": 0.98,
        "fill": "#038747"
      }
    ],
    "svuum": [
      {
        "type": "polygon",
        "d": "M19.1 11.11L19.1 6.49L17.37 9.37L15.64 6.49L15.64 11.11L16.3 11.11L16.3 8.85L17.37 10.64L18.45 8.85L18.45 11.11Z",
        "fill": "#0160aa"
      },
      {
        "type": "polygon",
        "d": "M3.37 9.31L4.58 9.69L4.77 9.96L4.71 10.23L4.39 10.46L3.94 10.46L3.52 10.16L3.14 10.69L3.73 11.11L4.6 11.11L5.3 10.62L5.47 9.82L4.98 9.14L3.78 8.76L3.6 8.49L3.66 8.22L3.96 8L4.38 8L4.78 8.29L5.17 7.76L4.6 7.34L3.74 7.34L3.07 7.84L2.9 8.63Z",
        "fill": "#0160aa"
      },
      {
        "type": "polygon",
        "d": "M7.37 10.46L6.98 10.46L6.39 7.34L5.74 7.46L6.44 11.11L7.91 11.11L8.6 7.46L7.96 7.34Z",
        "fill": "#0160aa"
      },
      {
        "type": "polygon",
        "d": "M10.52 11.11L10.85 11.07L11.17 10.94L11.44 10.73L11.64 10.46L11.77 10.15L11.81 9.84L11.81 7.34L11.16 7.34L11.16 9.8L11.13 9.98L11.07 10.13L10.97 10.27L10.84 10.37L10.68 10.43L10.52 10.45L10.36 10.43L10.2 10.37L10.07 10.27L9.97 10.13L9.91 9.98L9.88 9.8L9.88 7.34L9.23 7.34L9.23 9.84L9.27 10.15L9.4 10.46L9.6 10.73L9.87 10.94L10.18 11.07Z",
        "fill": "#0160aa"
      },
      {
        "type": "polygon",
        "d": "M13.73 11.11L14.06 11.07L14.38 10.94L14.64 10.73L14.85 10.46L14.98 10.15L15.02 9.84L15.02 7.34L14.37 7.34L14.37 9.8L14.34 9.98L14.28 10.13L14.18 10.27L14.05 10.37L13.89 10.43L13.73 10.45L13.56 10.43L13.41 10.37L13.28 10.27L13.18 10.13L13.11 9.98L13.09 9.8L13.09 7.34L12.44 7.34L12.44 9.84L12.48 10.15L12.61 10.46L12.81 10.73L13.08 10.94L13.39 11.07Z",
        "fill": "#0160aa"
      }
    ],
    "value-logistics": [
      {
        "type": "polygon",
        "d": "M5.17 8.79L4.74 8.79L4.1 5.4L3.4 5.53L4.15 9.51L5.76 9.51L6.52 5.53L5.82 5.4Z",
        "fill": "accent"
      },
      {
        "type": "polygon",
        "d": "M7.23 5.4L6.48 9.37L7.18 9.51L7.39 8.42L8.69 8.42L8.9 9.51L9.6 9.37L8.84 5.4Z",
        "fill": "accent"
      },
      {
        "type": "polygon",
        "d": "M8.56 7.71L7.52 7.71L7.82 6.11L8.25 6.11Z",
        "fill": "truck"
      },
      {
        "type": "polygon",
        "d": "M10.28 5.4L10.28 9.51L12.33 9.51L12.33 8.79L10.99 8.79L10.99 5.4Z",
        "fill": "accent"
      },
      {
        "type": "polygon",
        "d": "M18.32 7.81L18.32 7.1L17.09 7.1L17.09 6.11L18.6 6.11L18.6 5.4L16.38 5.4L16.38 9.51L18.6 9.51L18.6 8.79L17.09 8.79L17.09 7.81Z",
        "fill": "accent"
      },
      {
        "type": "polygon",
        "d": "M14.29 9.51L14.66 9.46L15 9.32L15.29 9.1L15.51 8.8L15.65 8.46L15.7 8.12L15.7 5.4L14.99 5.4L14.99 8.07L14.96 8.28L14.89 8.44L14.78 8.59L14.64 8.7L14.47 8.77L14.29 8.79L14.11 8.77L13.94 8.7L13.8 8.59L13.69 8.44L13.62 8.28L13.59 8.07L13.59 5.4L12.88 5.4L12.88 8.12L12.93 8.46L13.07 8.8L13.29 9.1L13.58 9.32L13.92 9.46Z",
        "fill": "accent"
      },
      {
        "type": "polygon",
        "d": "M18.6 10.66L18.59 10.59L18.57 10.53L18.54 10.46L18.5 10.41L18.44 10.37L18.38 10.34L18.32 10.32L18.25 10.31L3.75 10.31L3.68 10.32L3.62 10.34L3.56 10.37L3.5 10.41L3.46 10.46L3.43 10.53L3.41 10.59L3.4 10.66L3.4 11.56L3.41 11.63L3.43 11.69L3.46 11.75L3.5 11.81L3.56 11.85L3.62 11.88L3.68 11.9L3.75 11.91L18.25 11.91L18.32 11.9L18.38 11.88L18.44 11.85L18.5 11.81L18.54 11.75L18.57 11.69L18.59 11.63L18.6 11.56Z",
        "fill": "#782b90"
      }
    ],
    "xpect-same-day": [
      {
        "type": "polygon",
        "d": "M6.15 10.57L4.98 8.8L6.15 7.03L5.51 6.61L4.52 8.11L3.53 6.61L2.9 7.03L4.07 8.8L2.9 10.57L3.53 10.99L4.52 9.49L5.51 10.99Z",
        "fill": "#ff01c9"
      },
      {
        "type": "polygon",
        "d": "M9.74 7.93L9.64 7.42L9.35 6.99L8.92 6.7L8.45 6.61L6.87 6.61L6.87 10.99L7.63 10.99L7.63 9.25L8.45 9.25L8.92 9.16L9.35 8.87L9.64 8.44Z",
        "fill": "accent"
      },
      {
        "type": "polygon",
        "d": "M8.97 7.93L8.92 8.14L8.8 8.32L8.62 8.44L8.37 8.49L7.63 8.49L7.63 7.37L8.37 7.37L8.62 7.42L8.8 7.54L8.92 7.72Z",
        "fill": "truck"
      },
      {
        "type": "polygon",
        "d": "M11.23 9.18L12.54 9.18L12.54 8.42L11.23 8.42L11.23 7.37L12.84 7.37L12.84 6.61L10.46 6.61L10.46 10.99L12.84 10.99L12.84 10.23L11.23 10.23Z",
        "fill": "accent"
      },
      {
        "type": "polygon",
        "d": "M13.72 7.22L13.51 7.64L13.44 8.08L13.44 9.52L13.51 9.96L13.72 10.38L14.06 10.71L14.49 10.93L14.96 10.99L15.42 10.92L15.84 10.69L16.13 10.4L15.59 9.87L15.38 10.08L15.18 10.19L14.95 10.23L14.72 10.19L14.51 10.09L14.34 9.92L14.24 9.72L14.2 9.46L14.2 8.14L14.24 7.88L14.34 7.68L14.51 7.51L14.72 7.41L14.95 7.37L15.18 7.41L15.38 7.52L15.59 7.73L16.13 7.2L15.84 6.91L15.42 6.68L14.96 6.61L14.49 6.67L14.06 6.89Z",
        "fill": "accent"
      },
      {
        "type": "polygon",
        "d": "M17.6 7.37L17.6 10.99L18.36 10.99L18.36 7.37L19.1 7.37L19.1 6.61L16.86 6.61L16.86 7.37Z",
        "fill": "accent"
      }
    ],
    "alil-post": [
      {
        "type": "polygon",
        "d": "M7.39 4.5L6.75 7.89L7.35 8L7.52 7.08L8.63 7.08L8.81 8L9.41 7.89L8.76 4.5Z",
        "fill": "accent"
      },
      {
        "type": "polygon",
        "d": "M8.26 5.11L8.52 6.47L7.64 6.47L7.89 5.11Z",
        "fill": "truck"
      },
      {
        "type": "polygon",
        "d": "M9.99 4.5L9.99 8L11.74 8L11.74 7.39L10.59 7.39L10.59 4.5Z",
        "fill": "accent"
      },
      {
        "type": "polygon",
        "d": "M12.92 8L12.92 4.5L12.31 4.5L12.31 8Z",
        "fill": "accent"
      },
      {
        "type": "polygon",
        "d": "M13.5 8L15.25 8L15.25 7.39L14.11 7.39L14.11 4.5L13.5 4.5Z",
        "fill": "accent"
      },
      {
        "type": "polygon",
        "d": "M9.35 9.69L8.9 10L8.59 10.46L8.49 10.97L8.49 11.72L8.59 12.23L8.9 12.69L9.35 12.99L9.89 13.1L10.43 12.99L10.89 12.69L11.19 12.23L11.3 11.72L11.3 10.97L11.19 10.46L10.89 10L10.43 9.69L9.89 9.59Z",
        "fill": "accent"
      },
      {
        "type": "polygon",
        "d": "M10.2 12.42L9.89 12.48L9.59 12.42L9.33 12.25L9.16 11.99L9.1 11.66L9.1 11.03L9.16 10.69L9.33 10.44L9.59 10.27L9.89 10.21L10.2 10.27L10.45 10.44L10.62 10.69L10.69 11.03L10.69 11.66L10.62 11.99L10.45 12.25Z",
        "fill": "truck"
      },
      {
        "type": "polygon",
        "d": "M7.96 10.65L7.88 10.24L7.65 9.9L7.31 9.67L6.93 9.59L5.67 9.59L5.67 13.09L6.28 13.09L6.28 11.71L6.93 11.71L7.31 11.63L7.65 11.4L7.88 11.06Z",
        "fill": "accent"
      },
      {
        "type": "polygon",
        "d": "M7.34 10.65L7.31 10.82L7.21 10.96L7.07 11.06L6.87 11.1L6.28 11.1L6.28 10.2L6.87 10.2L7.07 10.24L7.21 10.34L7.31 10.48Z",
        "fill": "truck"
      },
      {
        "type": "polygon",
        "d": "M13.41 11.78L13.59 12.03L13.53 12.28L13.24 12.49L12.82 12.49L12.43 12.21L12.08 12.71L12.63 13.09L13.43 13.09L14.08 12.64L14.24 11.89L13.79 11.26L12.67 10.91L12.5 10.66L12.56 10.4L12.83 10.2L13.23 10.2L13.59 10.47L13.96 9.98L13.43 9.59L12.63 9.59L12.01 10.05L11.85 10.79L12.29 11.43Z",
        "fill": "accent"
      },
      {
        "type": "polygon",
        "d": "M15.13 13.09L15.74 13.09L15.74 10.2L16.33 10.2L16.33 9.59L14.54 9.59L14.54 10.2L15.13 10.2Z",
        "fill": "accent"
      }
    ],
    "kargoturk": [
      {
        "type": "polygon",
        "d": "M3.43 8.01L4.03 8.01L4.03 6.67L4.33 6.38L5.29 8.01L5.81 7.7L4.77 5.93L5.77 4.94L5.34 4.51L4.03 5.81L4.03 4.51L3.43 4.51Z",
        "fill": "accent"
      },
      {
        "type": "polygon",
        "d": "M6.37 7.89L6.96 8.01L7.14 7.08L8.25 7.08L8.43 8.01L9.02 7.89L8.38 4.51L7.01 4.51Z",
        "fill": "accent"
      },
      {
        "type": "polygon",
        "d": "M7.25 6.47L7.51 5.11L7.88 5.11L8.14 6.47Z",
        "fill": "truck"
      },
      {
        "type": "polygon",
        "d": "M9 8.53L8.4 8.53L8.4 9.13L9 9.13Z",
        "fill": "accent"
      },
      {
        "type": "polygon",
        "d": "M9.4 8.53L9.4 9.13L10.01 9.13L10.01 8.53Z",
        "fill": "accent"
      },
      {
        "type": "polygon",
        "d": "M6.83 10.2L7.42 10.2L7.42 9.6L5.63 9.6L5.63 10.2L6.22 10.2L6.22 13.1L6.83 13.1Z",
        "fill": "accent"
      },
      {
        "type": "polygon",
        "d": "M9.2 13.1L9.51 13.06L9.8 12.94L10.05 12.75L10.24 12.5L10.36 12.21L10.4 11.92L10.4 9.6L9.8 9.6L9.8 11.88L9.77 12.05L9.71 12.19L9.62 12.31L9.5 12.41L9.36 12.47L9.2 12.49L9.05 12.47L8.91 12.41L8.79 12.31L8.69 12.19L8.63 12.05L8.61 11.88L8.61 9.6L8 9.6L8 11.92L8.04 12.21L8.16 12.5L8.35 12.75L8.6 12.94L8.89 13.06Z",
        "fill": "accent"
      },
      {
        "type": "polygon",
        "d": "M11.7 4.81L11.35 4.58L10.98 4.51L9.6 4.51L9.6 8.01L10.21 8.01L10.21 6.62L10.39 6.62L11.56 8.01L12.02 7.62L11.16 6.58L11.35 6.54L11.7 6.31L11.93 5.97L12.01 5.56L11.93 5.16Z",
        "fill": "accent"
      },
      {
        "type": "polygon",
        "d": "M11.26 5.87L11.12 5.97L10.92 6.01L10.21 6.01L10.21 5.11L10.92 5.11L11.12 5.15L11.26 5.25L11.36 5.39L11.39 5.56L11.36 5.73Z",
        "fill": "truck"
      },
      {
        "type": "polygon",
        "d": "M15.87 5.37L15.77 5.88L15.77 6.63L15.87 7.14L16.18 7.6L16.63 7.9L17.17 8.01L17.71 7.9L18.17 7.6L18.47 7.14L18.57 6.63L18.57 5.88L18.47 5.37L18.17 4.91L17.71 4.61L17.17 4.5L16.63 4.61L16.18 4.91Z",
        "fill": "accent"
      },
      {
        "type": "polygon",
        "d": "M17.17 7.39L16.87 7.33L16.61 7.16L16.44 6.91L16.38 6.57L16.38 5.94L16.44 5.61L16.61 5.35L16.87 5.18L17.17 5.12L17.47 5.18L17.73 5.35L17.9 5.61L17.97 5.94L17.97 6.57L17.9 6.91L17.73 7.16L17.47 7.33Z",
        "fill": "truck"
      },
      {
        "type": "polygon",
        "d": "M13.38 7.19L13.22 6.96L13.16 6.66L13.16 5.85L13.2 5.6L13.31 5.41L13.46 5.25L13.66 5.15L13.88 5.12L14.1 5.15L14.3 5.26L14.48 5.45L14.92 5.03L14.67 4.77L14.3 4.57L13.89 4.5L13.48 4.56L13.1 4.75L12.81 5.04L12.62 5.41L12.56 5.8L12.56 6.72L12.65 7.2L12.94 7.62L13.37 7.91L13.87 8.01L14.38 7.91L14.81 7.62L15.1 7.2L15.19 6.72L15.19 6.1L13.87 6.1L13.87 6.7L14.57 6.7L14.52 6.96L14.37 7.19L14.14 7.34L13.87 7.39L13.6 7.34Z",
        "fill": "accent"
      },
      {
        "type": "polygon",
        "d": "M12.73 9.67L12.36 9.6L10.98 9.6L10.98 13.1L11.59 13.1L11.59 11.71L11.77 11.71L12.94 13.1L13.4 12.71L12.53 11.67L12.73 11.63L13.08 11.4L13.31 11.06L13.39 10.65L13.31 10.25L13.08 9.9Z",
        "fill": "accent"
      },
      {
        "type": "polygon",
        "d": "M12.5 11.06L12.3 11.1L11.59 11.1L11.59 10.2L12.3 10.2L12.5 10.24L12.64 10.34L12.74 10.48L12.77 10.65L12.74 10.82L12.64 10.97Z",
        "fill": "truck"
      },
      {
        "type": "polygon",
        "d": "M14.59 13.1L14.59 11.76L14.88 11.47L15.85 13.1L16.37 12.79L15.33 11.03L16.32 10.03L15.89 9.6L14.59 10.9L14.59 9.6L13.98 9.6L13.98 13.1Z",
        "fill": "accent"
      }
    ],
    "spark-kz": [
      {
        "type": "polygon",
        "d": "M3.4 8.89L4.7 9.3L4.9 9.59L4.84 9.88L4.5 10.12L4.02 10.12L3.57 9.8L3.16 10.37L3.79 10.82L4.73 10.82L5.47 10.29L5.65 9.43L5.14 8.7L3.84 8.3L3.65 8.01L3.71 7.72L4.03 7.48L4.49 7.48L4.91 7.8L5.33 7.23L4.72 6.78L3.8 6.78L3.08 7.31L2.9 8.16Z",
        "fill": "#333333"
      },
      {
        "type": "polygon",
        "d": "M8.97 8L8.88 7.53L8.61 7.13L8.21 6.87L7.78 6.78L6.32 6.78L6.32 10.82L7.02 10.82L7.02 9.22L7.78 9.22L8.21 9.13L8.61 8.87L8.88 8.47Z",
        "fill": "#333333"
      },
      {
        "type": "polygon",
        "d": "M8.25 8L8.22 8.19L8.1 8.36L7.94 8.47L7.71 8.52L7.02 8.52L7.02 7.48L7.71 7.48L7.94 7.53L8.1 7.64L8.22 7.8Z",
        "fill": "truck"
      },
      {
        "type": "polygon",
        "d": "M9.88 6.78L9.14 10.69L9.83 10.82L10.03 9.75L11.32 9.75L11.52 10.82L12.21 10.69L11.46 6.78Z",
        "fill": "#333333"
      },
      {
        "type": "polygon",
        "d": "M11.18 9.05L10.16 9.05L10.46 7.48L10.88 7.48Z",
        "fill": "truck"
      },
      {
        "type": "polygon",
        "d": "M15.56 7.53L15.3 7.13L14.9 6.87L14.46 6.78L12.88 6.78L12.88 10.82L13.58 10.82L13.58 9.22L13.79 9.22L15.14 10.82L15.67 10.37L14.67 9.18L14.9 9.13L15.3 8.87L15.56 8.47L15.66 8Z",
        "fill": "#333333"
      },
      {
        "type": "polygon",
        "d": "M14.9 8.19L14.79 8.36L14.63 8.47L14.4 8.52L13.58 8.52L13.58 7.48L14.4 7.48L14.63 7.53L14.79 7.64L14.9 7.8L14.94 8Z",
        "fill": "truck"
      },
      {
        "type": "polygon",
        "d": "M16.34 6.78L16.34 10.82L17.04 10.82L17.04 9.28L17.38 8.94L18.5 10.82L19.1 10.46L17.89 8.43L19.05 7.27L18.55 6.78L17.04 8.29L17.04 6.78Z",
        "fill": "#333333"
      }
    ],
    "tinypack": [
      {
        "type": "polygon",
        "d": "M6.97 8L7.57 8L7.57 5.11L8.17 5.11L8.17 4.5L6.37 4.5L6.37 5.11L6.97 5.11Z",
        "fill": "#1d1d1b"
      },
      {
        "type": "polygon",
        "d": "M9.35 4.5L8.75 4.5L8.75 8L9.35 8Z",
        "fill": "#1d1d1b"
      },
      {
        "type": "polygon",
        "d": "M11.84 4.5L11.84 7.39L11.61 7.39L11.32 4.5L9.93 4.5L9.93 8L10.54 8L10.54 5.11L10.77 5.11L11.06 8L12.45 8L12.45 4.5Z",
        "fill": "#1d1d1b"
      },
      {
        "type": "polygon",
        "d": "M14.63 8L14.63 6.34L15.63 4.83L15.12 4.5L14.33 5.7L13.54 4.5L13.03 4.83L14.02 6.34L14.02 8Z",
        "fill": "#1d1d1b"
      },
      {
        "type": "polygon",
        "d": "M11.24 10.42L11.19 10.77L11.19 11.92L11.24 12.27L11.42 12.61L11.69 12.87L12.02 13.04L12.4 13.1L12.77 13.04L13.11 12.86L13.34 12.62L12.9 12.2L12.74 12.37L12.58 12.45L12.39 12.48L12.21 12.46L12.04 12.37L11.91 12.24L11.83 12.08L11.79 11.87L11.79 10.82L11.83 10.61L11.91 10.45L12.04 10.32L12.21 10.23L12.39 10.21L12.58 10.24L12.74 10.32L12.9 10.49L13.34 10.07L13.11 9.83L12.77 9.65L12.4 9.59L12.02 9.65L11.69 9.82L11.42 10.08Z",
        "fill": "#1d1d1b"
      },
      {
        "type": "polygon",
        "d": "M7.9 10.24L7.67 9.9L7.33 9.67L6.95 9.59L5.69 9.59L5.69 13.1L6.3 13.1L6.3 11.71L6.95 11.71L7.33 11.63L7.67 11.4L7.9 11.06L7.98 10.65Z",
        "fill": "#1d1d1b"
      },
      {
        "type": "polygon",
        "d": "M7.33 10.82L7.23 10.96L7.09 11.06L6.89 11.1L6.3 11.1L6.3 10.2L6.89 10.2L7.09 10.24L7.23 10.34L7.33 10.48L7.36 10.65Z",
        "fill": "truck"
      },
      {
        "type": "polygon",
        "d": "M8.13 12.98L8.73 13.1L8.9 12.17L10.02 12.17L10.19 13.1L10.79 12.98L10.14 9.59L8.77 9.59Z",
        "fill": "#1d1d1b"
      },
      {
        "type": "polygon",
        "d": "M9.02 11.56L9.28 10.2L9.64 10.2L9.9 11.56Z",
        "fill": "truck"
      },
      {
        "type": "polygon",
        "d": "M15.26 11.02L16.26 10.02L15.83 9.59L14.53 10.9L14.53 9.59L13.92 9.59L13.92 13.1L14.53 13.1L14.53 11.76L14.82 11.47L15.79 13.1L16.31 12.79Z",
        "fill": "#1d1d1b"
      }
    ],
    "flecha-amarilla": [
      {
        "type": "polygon",
        "d": "M6.97 8.21L8.31 8.21L8.31 7.77L7.52 7.77L7.93 5.68L7.49 5.59Z",
        "fill": "#110100"
      },
      {
        "type": "polygon",
        "d": "M9.5 6.7L9.62 6.08L10.61 6.08L10.61 5.63L9.25 5.63L8.74 8.21L10.18 8.21L10.18 7.77L9.28 7.77L9.41 7.15L10.22 7.15L10.22 6.7Z",
        "fill": "#110100"
      },
      {
        "type": "polygon",
        "d": "M6.96 6.08L6.96 5.63L5.67 5.63L5.16 8.17L5.6 8.26L5.82 7.15L6.58 7.15L6.58 6.7L5.91 6.7L6.04 6.08Z",
        "fill": "#110100"
      },
      {
        "type": "polygon",
        "d": "M3.32 12.01L3.6 11.29L4.41 11.29L4.4 11.92L4.85 11.93L4.88 9.39L3.86 9.39L2.9 11.84Z",
        "fill": "#110100"
      },
      {
        "type": "polygon",
        "d": "M3.77 10.84L4.16 9.83L4.43 9.83L4.42 10.84Z",
        "fill": "truck"
      },
      {
        "type": "polygon",
        "d": "M8.81 11.29L9.62 11.29L9.61 11.92L10.06 11.93L10.09 9.39L9.07 9.39L8.11 11.84L8.52 12.01Z",
        "fill": "#110100"
      },
      {
        "type": "polygon",
        "d": "M9.63 9.83L9.62 10.84L8.98 10.84L9.37 9.83Z",
        "fill": "truck"
      },
      {
        "type": "polygon",
        "d": "M6.45 9.39L5.79 9.39L5.28 11.92L5.72 12.01L6.12 9.99L6.51 11.81L7.57 10.08L7.2 11.92L7.64 12.01L8.16 9.39L7.47 9.39L6.71 10.62Z",
        "fill": "#110100"
      },
      {
        "type": "polygon",
        "d": "M12.49 9.63L12.25 9.44L11.97 9.39L10.99 9.39L10.49 11.92L10.93 12.01L11.14 10.94L11.3 10.94L11.94 11.94L12.31 11.7L11.82 10.93L12.02 10.89L12.29 10.73L12.5 10.5L12.61 10.21L12.61 9.9Z",
        "fill": "#110100"
      },
      {
        "type": "polygon",
        "d": "M12.11 10.26L12 10.38L11.86 10.47L11.7 10.5L11.23 10.5L11.36 9.83L11.92 9.83L12.05 9.86L12.13 9.92L12.17 10L12.17 10.12Z",
        "fill": "truck"
      },
      {
        "type": "polygon",
        "d": "M11.02 6.21L10.93 6.46L10.76 7.3L10.75 7.56L10.83 7.83L11 8.04L11.24 8.17L11.52 8.22L11.8 8.17L12.06 8.05L12.25 7.88L11.96 7.54L11.81 7.67L11.66 7.74L11.52 7.76L11.39 7.74L11.3 7.69L11.23 7.61L11.2 7.5L11.2 7.35L11.36 6.58L11.42 6.42L11.51 6.28L11.65 6.17L11.8 6.1L11.94 6.08L12.06 6.1L12.16 6.16L12.24 6.27L12.6 6L12.46 5.82L12.22 5.68L11.95 5.63L11.67 5.67L11.41 5.79L11.18 5.97Z",
        "fill": "#110100"
      },
      {
        "type": "polygon",
        "d": "M14.25 6.7L13.38 6.7L13.59 5.68L13.15 5.59L12.63 8.17L13.07 8.26L13.29 7.15L14.16 7.15L13.95 8.17L14.39 8.26L14.91 5.68L14.47 5.59Z",
        "fill": "#110100"
      },
      {
        "type": "polygon",
        "d": "M16.37 7.53L16.37 8.17L16.81 8.17L16.84 5.63L15.82 5.63L14.86 8.09L15.28 8.25L15.56 7.53Z",
        "fill": "#110100"
      },
      {
        "type": "polygon",
        "d": "M16.13 6.08L16.39 6.08L16.38 7.08L15.74 7.08Z",
        "fill": "truck"
      },
      {
        "type": "polygon",
        "d": "M14.93 11.97L14.93 11.52L14.14 11.52L14.55 9.43L14.11 9.34L13.59 11.97Z",
        "fill": "#110100"
      },
      {
        "type": "polygon",
        "d": "M16.7 11.52L15.9 11.52L16.32 9.43L15.88 9.34L15.36 11.97L16.7 11.97Z",
        "fill": "#110100"
      },
      {
        "type": "polygon",
        "d": "M12.71 11.92L13.14 12.01L13.66 9.43L13.22 9.34Z",
        "fill": "#110100"
      },
      {
        "type": "polygon",
        "d": "M17.82 11.29L18.63 11.29L18.63 11.92L19.07 11.93L19.1 9.39L18.08 9.39L17.12 11.84L17.54 12.01Z",
        "fill": "#110100"
      },
      {
        "type": "polygon",
        "d": "M18 10.84L18.39 9.83L18.65 9.83L18.64 10.84Z",
        "fill": "truck"
      }
    ],
    "porlor": [
      {
        "type": "polygon",
        "d": "M4.89 8.2L4.82 7.84L4.62 7.54L4.32 7.34L4 7.28L2.9 7.28L2.9 10.32L3.43 10.32L3.43 9.11L4 9.11L4.32 9.05L4.62 8.85L4.82 8.55Z",
        "fill": "#000544"
      },
      {
        "type": "polygon",
        "d": "M4.35 8.2L4.33 8.34L4.24 8.47L4.12 8.55L3.94 8.59L3.43 8.59L3.43 7.81L3.94 7.81L4.12 7.84L4.24 7.92L4.33 8.05Z",
        "fill": "truck"
      },
      {
        "type": "polygon",
        "d": "M5.71 7.63L5.44 8.03L5.35 8.47L5.35 9.13L5.44 9.57L5.71 9.97L6.1 10.23L6.57 10.33L7.04 10.23L7.44 9.97L7.7 9.57L7.79 9.13L7.79 8.47L7.7 8.03L7.44 7.63L7.04 7.37L6.57 7.27L6.1 7.37Z",
        "fill": "#000544"
      },
      {
        "type": "polygon",
        "d": "M6.57 9.79L6.31 9.74L6.09 9.59L5.94 9.36L5.88 9.08L5.88 8.52L5.94 8.24L6.09 8.01L6.31 7.86L6.57 7.81L6.84 7.86L7.06 8.01L7.21 8.24L7.26 8.52L7.26 9.08L7.21 9.36L7.06 9.59L6.84 9.74Z",
        "fill": "truck"
      },
      {
        "type": "polygon",
        "d": "M10.32 7.84L10.12 7.54L9.82 7.34L9.49 7.28L8.3 7.28L8.3 10.32L8.82 10.32L8.82 9.11L8.98 9.11L10 10.32L10.4 9.98L9.65 9.08L9.82 9.05L10.12 8.85L10.32 8.55L10.39 8.2Z",
        "fill": "#000544"
      },
      {
        "type": "polygon",
        "d": "M9.82 8.34L9.74 8.47L9.61 8.55L9.44 8.59L8.82 8.59L8.82 7.81L9.44 7.81L9.61 7.84L9.74 7.92L9.82 8.05L9.85 8.2Z",
        "fill": "truck"
      },
      {
        "type": "polygon",
        "d": "M12.16 7.28L12.16 10.32L13.69 10.32L13.69 9.79L12.69 9.79L12.69 7.28Z",
        "fill": "#000544"
      },
      {
        "type": "polygon",
        "d": "M14.4 7.63L14.14 8.03L14.05 8.47L14.05 9.13L14.14 9.57L14.4 9.97L14.8 10.23L15.27 10.33L15.74 10.23L16.14 9.97L16.4 9.57L16.49 9.13L16.49 8.47L16.4 8.03L16.14 7.63L15.74 7.37L15.27 7.27L14.8 7.37Z",
        "fill": "#000544"
      },
      {
        "type": "polygon",
        "d": "M15.27 9.79L15.01 9.74L14.78 9.59L14.64 9.36L14.58 9.08L14.58 8.52L14.64 8.24L14.78 8.01L15.01 7.86L15.27 7.81L15.53 7.86L15.76 8.01L15.9 8.24L15.96 8.52L15.96 9.08L15.9 9.36L15.76 9.59L15.53 9.74Z",
        "fill": "truck"
      },
      {
        "type": "polygon",
        "d": "M19.02 7.84L18.82 7.54L18.52 7.34L18.19 7.28L16.99 7.28L16.99 10.32L17.52 10.32L17.52 9.11L17.68 9.11L18.7 10.32L19.1 9.98L18.35 9.08L18.52 9.05L18.82 8.85L19.02 8.55L19.09 8.2Z",
        "fill": "#000544"
      },
      {
        "type": "polygon",
        "d": "M18.52 8.34L18.44 8.47L18.31 8.55L18.14 8.59L17.52 8.59L17.52 7.81L18.14 7.81L18.31 7.84L18.44 7.92L18.52 8.05L18.55 8.2Z",
        "fill": "truck"
      }
    ],
    "motorex": [
      {
        "type": "polygon",
        "d": "M5.42 7.43L4.7 7.43L4.16 8.74L3.61 7.43L2.9 7.43L2.9 10.17L3.38 10.17L3.38 8.1L4.16 9.99L4.94 8.1L4.94 10.17L5.42 10.17Z",
        "fill": "#020100"
      },
      {
        "type": "polygon",
        "d": "M6.55 7.51L6.19 7.75L5.95 8.11L5.87 8.5L5.87 9.1L5.95 9.49L6.19 9.85L6.55 10.09L6.97 10.18L7.39 10.09L7.75 9.85L7.99 9.49L8.07 9.1L8.07 8.5L7.99 8.11L7.75 7.75L7.39 7.51L6.97 7.42Z",
        "fill": "#020100"
      },
      {
        "type": "polygon",
        "d": "M7.2 9.64L6.97 9.69L6.73 9.64L6.53 9.51L6.4 9.31L6.34 9.05L6.34 8.55L6.4 8.29L6.53 8.09L6.73 7.96L6.97 7.91L7.2 7.96L7.41 8.09L7.54 8.29L7.59 8.55L7.59 9.05L7.54 9.31L7.41 9.51Z",
        "fill": "truck"
      },
      {
        "type": "polygon",
        "d": "M8.86 7.9L8.86 10.17L9.33 10.17L9.33 7.9L9.8 7.9L9.8 7.43L8.39 7.43L8.39 7.9Z",
        "fill": "#020100"
      },
      {
        "type": "polygon",
        "d": "M10.45 7.75L10.21 8.11L10.13 8.5L10.13 9.1L10.21 9.49L10.45 9.85L10.8 10.09L11.23 10.18L11.65 10.09L12.01 9.85L12.25 9.49L12.32 9.1L12.32 8.5L12.25 8.11L12.01 7.75L11.65 7.51L11.23 7.42L10.8 7.51Z",
        "fill": "#020100"
      },
      {
        "type": "polygon",
        "d": "M11.23 9.69L10.99 9.64L10.79 9.51L10.65 9.31L10.6 9.05L10.6 8.55L10.65 8.29L10.79 8.09L10.99 7.96L11.23 7.91L11.46 7.96L11.66 8.09L11.8 8.29L11.85 8.55L11.85 9.05L11.8 9.31L11.66 9.51L11.46 9.64Z",
        "fill": "truck"
      },
      {
        "type": "polygon",
        "d": "M14.6 7.94L14.42 7.67L14.15 7.49L13.86 7.43L12.78 7.43L12.78 10.17L13.25 10.17L13.25 9.08L13.4 9.08L14.31 10.17L14.67 9.87L14 9.06L14.15 9.02L14.42 8.84L14.6 8.57L14.66 8.26Z",
        "fill": "#020100"
      },
      {
        "type": "polygon",
        "d": "M14.15 8.39L14.08 8.5L13.96 8.58L13.81 8.61L13.25 8.61L13.25 7.9L13.81 7.9L13.96 7.94L14.08 8.01L14.15 8.12L14.18 8.26Z",
        "fill": "truck"
      },
      {
        "type": "polygon",
        "d": "M16.61 9.7L15.6 9.7L15.6 9.04L16.43 9.04L16.43 8.56L15.6 8.56L15.6 7.9L16.61 7.9L16.61 7.43L15.13 7.43L15.13 10.17L16.61 10.17Z",
        "fill": "accent"
      },
      {
        "type": "polygon",
        "d": "M19.1 7.69L18.7 7.43L18.08 8.37L17.46 7.43L17.07 7.69L17.8 8.8L17.07 9.91L17.46 10.17L18.08 9.23L18.7 10.17L19.1 9.91L18.37 8.8Z",
        "fill": "accent"
      }
    ],
    "garantpost": [
      {
        "type": "polygon",
        "d": "M15.69 6.61L15.36 7.95L15.93 8.1L16.79 4.68L16.21 4.54L15.84 6.02L14.7 6.02L15.04 4.68L14.46 4.54L13.61 7.95L14.18 8.1L14.55 6.61Z",
        "fill": "accent"
      },
      {
        "type": "polygon",
        "d": "M4.83 7.85L5.37 8.09L5.8 7.12L6.87 7.12L6.82 7.95L7.41 7.99L7.61 4.61L6.26 4.61Z",
        "fill": "accent"
      },
      {
        "type": "polygon",
        "d": "M6.9 6.53L6.06 6.53L6.64 5.2L6.98 5.2Z",
        "fill": "truck"
      },
      {
        "type": "polygon",
        "d": "M10.46 7.85L11.01 8.09L11.43 7.12L12.5 7.12L12.45 7.95L13.04 7.99L13.24 4.61L11.89 4.61Z",
        "fill": "accent"
      },
      {
        "type": "polygon",
        "d": "M11.69 6.53L12.28 5.2L12.61 5.2L12.53 6.53Z",
        "fill": "truck"
      },
      {
        "type": "polygon",
        "d": "M2.9 7.95L3.47 8.1L4.2 5.2L5.38 5.2L5.38 4.61L3.74 4.61Z",
        "fill": "accent"
      },
      {
        "type": "polygon",
        "d": "M19.1 5.2L19.1 4.61L17.35 4.61L17.35 5.2L17.85 5.2L17.16 7.95L17.73 8.1L18.46 5.2Z",
        "fill": "accent"
      },
      {
        "type": "polygon",
        "d": "M10.65 4.94L10.34 4.69L9.98 4.61L8.81 4.61L7.97 7.95L8.55 8.1L8.91 6.67L9.61 6.67L9.98 6.6L10.34 6.39L10.62 6.09L10.79 5.71L10.81 5.31Z",
        "fill": "accent"
      },
      {
        "type": "polygon",
        "d": "M10.12 5.76L9.96 5.92L9.77 6.04L9.55 6.08L9.05 6.08L9.27 5.2L9.91 5.2L10.08 5.24L10.17 5.3L10.21 5.41L10.2 5.57Z",
        "fill": "truck"
      },
      {
        "type": "polygon",
        "d": "M12.51 10.02L12.28 10.33L12.15 10.65L11.87 11.77L11.84 12.12L11.93 12.47L12.15 12.76L12.46 12.94L12.83 12.99L13.2 12.93L13.54 12.77L13.81 12.55L13.44 12.09L13.23 12.27L13.02 12.36L12.82 12.39L12.66 12.37L12.55 12.3L12.47 12.2L12.44 12.07L12.45 11.87L12.71 10.84L12.8 10.62L12.94 10.44L13.13 10.29L13.33 10.2L13.53 10.17L13.68 10.2L13.8 10.27L13.9 10.42L14.39 10.07L14.21 9.83L13.9 9.64L13.54 9.57L13.17 9.63L12.82 9.78Z",
        "fill": "accent"
      },
      {
        "type": "polygon",
        "d": "M9.85 9.67L9.36 9.95L8.98 10.37L8.76 10.85L8.58 11.58L8.55 12.08L8.75 12.56L9.16 12.89L9.67 13L10.21 12.89L10.7 12.61L11.08 12.2L11.3 11.72L11.48 10.99L11.51 10.48L11.31 10L10.9 9.68L10.38 9.57Z",
        "fill": "accent"
      },
      {
        "type": "polygon",
        "d": "M9.68 12.39L9.42 12.34L9.24 12.2L9.15 11.98L9.17 11.67L9.32 11.04L9.48 10.7L9.73 10.42L10.06 10.24L10.38 10.17L10.64 10.23L10.82 10.37L10.91 10.59L10.89 10.9L10.74 11.52L10.58 11.87L10.33 12.15L10 12.33Z",
        "fill": "truck"
      },
      {
        "type": "polygon",
        "d": "M5.88 13.06L6.6 10.17L7.74 10.17L7.05 12.92L7.62 13.06L8.5 9.58L6.14 9.58L5.3 12.92Z",
        "fill": "accent"
      },
      {
        "type": "polygon",
        "d": "M15.33 13.06L16.06 10.17L16.7 10.17L16.7 9.58L14.95 9.58L14.95 10.17L15.45 10.17L14.76 12.92Z",
        "fill": "accent"
      }
    ],
    "korexgarant": [
      {
        "type": "polygon",
        "d": "M2.9 8L3.46 8.11L3.71 6.84L4.08 6.54L4.65 8.01L5.18 7.8L4.54 6.15L5.69 5.19L5.33 4.75L3.89 5.95L4.12 4.83L3.56 4.71Z",
        "fill": "accent"
      },
      {
        "type": "polygon",
        "d": "M6.1 5.54L5.92 6L5.78 6.71L5.78 7.2L5.99 7.65L6.39 7.96L6.89 8.06L7.4 7.96L7.86 7.69L8.22 7.28L8.4 6.82L8.54 6.11L8.54 5.63L8.33 5.17L7.93 4.87L7.43 4.76L6.92 4.86L6.46 5.13Z",
        "fill": "accent"
      },
      {
        "type": "polygon",
        "d": "M6.45 7.28L6.35 7.07L6.35 6.77L6.47 6.17L6.6 5.84L6.83 5.58L7.12 5.4L7.43 5.35L7.69 5.4L7.87 5.54L7.97 5.75L7.97 6.06L7.85 6.66L7.72 6.98L7.49 7.24L7.2 7.42L6.89 7.48L6.63 7.42Z",
        "fill": "truck"
      },
      {
        "type": "polygon",
        "d": "M10.85 4.84L10.5 4.77L9.36 4.77L8.72 8L9.28 8.11L9.55 6.75L10.21 6.75L10.57 6.68L10.91 6.48L11.17 6.18L11.32 5.82L11.32 5.43L11.15 5.08Z",
        "fill": "accent"
      },
      {
        "type": "polygon",
        "d": "M10.54 6.04L10.36 6.14L10.16 6.18L9.66 6.18L9.83 5.34L10.44 5.34L10.6 5.37L10.69 5.44L10.75 5.55L10.75 5.71L10.68 5.88Z",
        "fill": "truck"
      },
      {
        "type": "polygon",
        "d": "M5.14 12.67L5.67 12.88L6.03 11.96L7.06 11.96L7.05 12.77L7.62 12.78L7.65 9.55L6.36 9.55Z",
        "fill": "accent"
      },
      {
        "type": "polygon",
        "d": "M7.07 11.39L6.25 11.39L6.75 10.12L7.08 10.12Z",
        "fill": "truck"
      },
      {
        "type": "polygon",
        "d": "M3.32 12.77L3.88 12.89L4.43 10.12L5.55 10.12L5.55 9.55L3.96 9.55Z",
        "fill": "accent"
      },
      {
        "type": "polygon",
        "d": "M10.29 9.62L9.94 9.55L8.81 9.55L8.16 12.77L8.72 12.89L9 11.53L9.66 11.53L10.01 11.46L10.36 11.26L10.62 10.96L10.76 10.59L10.76 10.2L10.6 9.85Z",
        "fill": "accent"
      },
      {
        "type": "polygon",
        "d": "M9.99 10.81L9.81 10.92L9.6 10.96L9.11 10.96L9.28 10.12L9.88 10.12L10.05 10.15L10.14 10.22L10.19 10.33L10.19 10.48L10.12 10.66Z",
        "fill": "truck"
      },
      {
        "type": "polygon",
        "d": "M16.97 5.82L16.76 6.89L16.74 7.23L16.85 7.56L17.07 7.83L17.37 8L17.72 8.06L18.08 8L18.41 7.84L18.66 7.63L18.29 7.19L18.1 7.36L17.91 7.45L17.72 7.48L17.56 7.46L17.44 7.39L17.36 7.29L17.32 7.15L17.32 6.96L17.52 5.97L17.6 5.77L17.72 5.59L17.89 5.46L18.08 5.37L18.26 5.34L18.42 5.37L18.54 5.44L18.65 5.59L19.1 5.24L18.92 5.01L18.62 4.83L18.27 4.77L17.91 4.82L17.58 4.97L17.3 5.2L17.09 5.5Z",
        "fill": "accent"
      },
      {
        "type": "polygon",
        "d": "M14.41 8.11L14.66 6.84L15.03 6.54L15.61 8.01L16.14 7.8L15.49 6.15L16.64 5.19L16.28 4.75L14.84 5.95L15.07 4.83L14.51 4.71L13.85 8Z",
        "fill": "accent"
      },
      {
        "type": "polygon",
        "d": "M13.09 6.13L12.15 6.13L12.15 6.7L12.98 6.7L12.95 6.85L12.87 7.06L12.75 7.23L12.58 7.37L12.39 7.45L12.21 7.48L12.05 7.45L11.93 7.38L11.82 7.24L11.37 7.58L11.55 7.82L11.85 8L12.2 8.06L12.55 8.01L12.88 7.86L13.17 7.62L13.38 7.32L13.5 7L13.71 5.93L13.72 5.6L13.62 5.26L13.4 4.99L13.09 4.82L12.74 4.77L12.39 4.82L12.06 4.98L11.81 5.2L12.18 5.63L12.37 5.46L12.56 5.37L12.75 5.34L12.91 5.37L13.03 5.43L13.11 5.54L13.15 5.67L13.14 5.86Z",
        "fill": "accent"
      },
      {
        "type": "polygon",
        "d": "M15.5 11.47L15.24 12.77L15.8 12.89L16.46 9.6L15.9 9.49L15.62 10.9L14.52 10.9L14.78 9.6L14.22 9.49L13.56 12.77L14.12 12.89L14.4 11.47Z",
        "fill": "accent"
      },
      {
        "type": "polygon",
        "d": "M11.06 12.88L11.42 11.96L12.46 11.96L12.45 12.77L13.02 12.78L13.05 9.55L11.75 9.55L10.53 12.67Z",
        "fill": "accent"
      },
      {
        "type": "polygon",
        "d": "M12.14 10.12L12.47 10.12L12.46 11.39L11.64 11.39Z",
        "fill": "truck"
      },
      {
        "type": "polygon",
        "d": "M18.68 10.12L18.68 9.55L17 9.55L17 10.12L17.49 10.12L16.96 12.77L17.52 12.89L18.08 10.12Z",
        "fill": "accent"
      }
    ],
    "emu-express": [
      {
        "type": "polygon",
        "d": "M6.83 10.75L4.62 10.75L4.62 9.32L6.42 9.32L6.42 8.28L4.62 8.28L4.62 6.84L6.83 6.84L6.83 5.8L3.58 5.8L3.58 11.8L6.83 11.8Z",
        "fill": "accent"
      },
      {
        "type": "polygon",
        "d": "M13.32 11.8L13.32 5.8L11.75 5.8L10.57 8.67L9.38 5.8L7.82 5.8L7.82 11.8L8.86 11.8L8.86 7.26L10.57 11.4L12.28 7.26L12.28 11.8Z",
        "fill": "accent"
      },
      {
        "type": "polygon",
        "d": "M15.33 11.52L15.83 11.73L16.36 11.8L16.9 11.73L17.39 11.52L17.82 11.2L18.15 10.77L18.35 10.27L18.42 9.77L18.42 5.8L17.38 5.8L17.38 9.71L17.34 10L17.24 10.24L17.08 10.45L16.87 10.61L16.63 10.72L16.36 10.75L16.1 10.72L15.86 10.61L15.65 10.45L15.49 10.24L15.39 10L15.35 9.71L15.35 5.8L14.31 5.8L14.31 9.77L14.37 10.27L14.58 10.77L14.91 11.2Z",
        "fill": "accent"
      }
    ],
    "dimex": [
      {
        "type": "polygon",
        "d": "M4.93 10.56L5.4 10.25L5.8 9.86L6.11 9.39L6.3 8.88L6.37 8.36L6.28 7.86L6.05 7.41L5.69 7.06L5.23 6.85L4.74 6.79L3.91 6.79L2.9 10.81L3.9 10.81L4.41 10.75Z",
        "fill": "accent"
      },
      {
        "type": "polygon",
        "d": "M5.29 7.65L5.49 7.84L5.61 8.08L5.66 8.38L5.62 8.72L5.48 9.07L5.26 9.41L4.96 9.7L4.61 9.93L4.24 10.07L3.86 10.12L3.8 10.12L4.45 7.48L4.69 7.48L5.03 7.53Z",
        "fill": "truck"
      },
      {
        "type": "polygon",
        "d": "M7.21 10.9L8.22 6.87L7.54 6.7L6.53 10.73Z",
        "fill": "accent"
      },
      {
        "type": "polygon",
        "d": "M13.46 9.15L14.74 9.15L14.74 8.45L13.63 8.45L13.87 7.48L15.43 7.48L15.43 6.79L13.33 6.79L12.32 10.81L14.6 10.81L14.6 10.12L13.22 10.12Z",
        "fill": "accent"
      },
      {
        "type": "polygon",
        "d": "M16.76 6.85L16.11 7.11L16.78 8.73L15.27 10.39L15.78 10.86L17.07 9.44L17.61 10.75L18.25 10.49L17.59 8.87L19.1 7.21L18.58 6.74L17.3 8.16Z",
        "fill": "accent"
      },
      {
        "type": "polygon",
        "d": "M11.54 6.79L10.27 8.7L9.96 6.79L8.92 6.79L7.94 10.73L8.62 10.9L9.41 7.74L9.87 10.57L11.64 7.89L10.93 10.73L11.61 10.9L12.64 6.79Z",
        "fill": "accent"
      }
    ],
    "express-ru": [
      {
        "type": "polygon",
        "d": "M3.43 6.26L4.33 6.26L4.33 5.74L3.43 5.74L3.43 5.02L4.54 5.02L4.54 4.5L2.91 4.5L2.91 7.51L4.54 7.51L4.54 6.98L3.43 6.98Z",
        "fill": "accent"
      },
      {
        "type": "polygon",
        "d": "M5.47 4.5L5.03 4.79L5.84 6L5.03 7.22L5.47 7.51L6.15 6.48L6.83 7.51L7.26 7.22L6.46 6L7.26 4.79L6.83 4.5L6.15 5.53Z",
        "fill": "accent"
      },
      {
        "type": "polygon",
        "d": "M9.46 4.76L9.17 4.56L8.84 4.5L7.76 4.5L7.76 7.51L8.28 7.51L8.28 6.31L8.84 6.31L9.17 6.25L9.46 6.05L9.66 5.76L9.73 5.41L9.66 5.06Z",
        "fill": "accent"
      },
      {
        "type": "polygon",
        "d": "M9.09 5.68L8.96 5.76L8.79 5.79L8.28 5.79L8.28 5.02L8.79 5.02L8.96 5.06L9.09 5.14L9.17 5.26L9.2 5.41L9.17 5.55Z",
        "fill": "truck"
      },
      {
        "type": "polygon",
        "d": "M12.22 5.06L12.03 4.76L11.73 4.56L11.41 4.5L10.23 4.5L10.23 7.51L10.75 7.51L10.75 6.31L10.9 6.31L11.91 7.51L12.31 7.17L11.56 6.28L11.73 6.25L12.03 6.05L12.22 5.76L12.29 5.41Z",
        "fill": "accent"
      },
      {
        "type": "polygon",
        "d": "M11.73 5.55L11.65 5.68L11.53 5.76L11.36 5.79L10.75 5.79L10.75 5.02L11.36 5.02L11.53 5.06L11.65 5.14L11.73 5.26L11.76 5.41Z",
        "fill": "truck"
      },
      {
        "type": "polygon",
        "d": "M14.23 5.74L13.32 5.74L13.32 5.02L14.43 5.02L14.43 4.5L12.8 4.5L12.8 7.51L14.43 7.51L14.43 6.98L13.32 6.98L13.32 6.26L14.23 6.26Z",
        "fill": "accent"
      },
      {
        "type": "polygon",
        "d": "M16.17 6.38L16.32 6.59L16.27 6.81L16.02 6.98L15.66 6.98L15.33 6.75L15.02 7.17L15.49 7.51L16.19 7.51L16.74 7.11L16.88 6.47L16.49 5.93L15.53 5.63L15.39 5.42L15.43 5.2L15.67 5.02L16.01 5.02L16.33 5.26L16.64 4.84L16.18 4.5L15.5 4.5L14.97 4.9L14.83 5.53L15.2 6.07Z",
        "fill": "accent"
      },
      {
        "type": "polygon",
        "d": "M18.53 6.59L18.49 6.81L18.23 6.98L17.87 6.98L17.54 6.75L17.24 7.17L17.71 7.51L18.4 7.51L18.95 7.11L19.09 6.47L18.71 5.93L17.74 5.63L17.6 5.42L17.65 5.2L17.88 5.02L18.22 5.02L18.54 5.26L18.85 4.84L18.4 4.5L17.71 4.5L17.18 4.9L17.04 5.53L17.42 6.07L18.38 6.38Z",
        "fill": "accent"
      },
      {
        "type": "polygon",
        "d": "M19.09 9.37L19.06 9.15L18.97 8.94L18.84 8.76L18.66 8.62L18.45 8.53L18.22 8.5L13.74 8.5L13.52 8.53L13.31 8.62L13.13 8.76L12.99 8.94L12.9 9.15L12.87 9.37L12.87 12.23L12.9 12.46L12.99 12.67L13.13 12.85L13.31 12.98L13.52 13.07L13.74 13.1L18.22 13.1L18.45 13.07L18.66 12.98L18.84 12.85L18.97 12.67L19.06 12.46L19.09 12.23Z",
        "fill": "accent"
      },
      {
        "type": "polygon",
        "d": "M15.35 12.3L15.75 11.97L15 11.08L15.17 11.05L15.47 10.85L15.67 10.55L15.74 10.2L15.67 9.85L15.47 9.56L15.17 9.36L14.85 9.3L13.67 9.3L13.67 12.3L14.19 12.3L14.19 11.11L14.35 11.11Z",
        "fill": "truck"
      },
      {
        "type": "polygon",
        "d": "M14.97 9.85L15.09 9.93L15.18 10.06L15.2 10.2L15.18 10.35L15.09 10.47L14.97 10.55L14.8 10.59L14.19 10.59L14.19 9.82L14.8 9.82Z",
        "fill": "truck"
      },
      {
        "type": "polygon",
        "d": "M16.53 12L16.75 12.17L17 12.27L17.26 12.3L17.53 12.27L17.78 12.17L18 12L18.16 11.79L18.26 11.54L18.3 11.29L18.3 9.3L17.77 9.3L17.77 11.25L17.75 11.4L17.7 11.52L17.62 11.63L17.52 11.71L17.4 11.76L17.26 11.78L17.13 11.76L17.01 11.71L16.91 11.63L16.83 11.52L16.77 11.4L16.75 11.25L16.75 9.3L16.23 9.3L16.23 11.29L16.27 11.54L16.37 11.79Z",
        "fill": "truck"
      }
    ],
    "topdelivery": [
      {
        "type": "polygon",
        "d": "M4.5 5.38L9.87 5.38L11.92 7.29L11.28 7.29L11.28 13.02L8.6 13.02L8.6 7.29L6.27 7.29Z",
        "fill": "#006fc3"
      },
      {
        "type": "polygon",
        "d": "M10.86 5.38L15.8 5.38L16.24 5.44L16.65 5.61L17 5.88L17.27 6.23L17.44 6.64L17.5 7.08L17.5 11.32L17.44 11.76L17.27 12.17L17 12.52L16.65 12.79L16.24 12.96L15.8 13.02L12.84 13.02L12.84 11.11L14.96 11.11L14.96 7.29L12.91 7.29Z",
        "fill": "accent"
      }
    ],
    "dnipro-llc": [
      {
        "type": "polygon",
        "d": "M4.56 10.34L4.93 10.06L5.21 9.69L5.39 9.26L5.45 8.8L5.39 8.34L5.21 7.91L4.93 7.54L4.56 7.26L4.14 7.08L3.7 7.03L2.9 7.03L2.9 10.57L3.7 10.57L4.14 10.52Z",
        "fill": "accent"
      },
      {
        "type": "polygon",
        "d": "M4.49 7.98L4.68 8.22L4.79 8.5L4.83 8.8L4.79 9.1L4.68 9.38L4.49 9.62L4.25 9.8L3.98 9.92L3.66 9.96L3.52 9.96L3.52 7.64L3.66 7.64L3.98 7.68L4.25 7.8Z",
        "fill": "truck"
      },
      {
        "type": "polygon",
        "d": "M7.97 9.96L7.74 9.96L7.45 7.03L6.04 7.03L6.04 10.57L6.65 10.57L6.65 7.64L6.89 7.64L7.18 10.57L8.59 10.57L8.59 7.03L7.97 7.03Z",
        "fill": "accent"
      },
      {
        "type": "polygon",
        "d": "M9.79 7.03L9.17 7.03L9.17 10.57L9.79 10.57Z",
        "fill": "accent"
      },
      {
        "type": "polygon",
        "d": "M12.7 8.1L12.62 7.68L12.38 7.34L12.03 7.1L11.65 7.03L10.38 7.03L10.38 10.57L10.99 10.57L10.99 9.17L11.65 9.17L12.03 9.09L12.38 8.86L12.62 8.51Z",
        "fill": "accent"
      },
      {
        "type": "polygon",
        "d": "M12.07 8.1L12.04 8.27L11.94 8.41L11.79 8.51L11.59 8.55L10.99 8.55L10.99 7.64L11.59 7.64L11.79 7.68L11.94 7.78L12.04 7.93Z",
        "fill": "truck"
      },
      {
        "type": "polygon",
        "d": "M15.64 7.68L15.41 7.34L15.06 7.1L14.68 7.03L13.28 7.03L13.28 10.57L13.9 10.57L13.9 9.17L14.08 9.17L15.27 10.57L15.74 10.18L14.86 9.13L15.06 9.09L15.41 8.86L15.64 8.51L15.72 8.1Z",
        "fill": "accent"
      },
      {
        "type": "polygon",
        "d": "M15.06 8.27L14.96 8.41L14.82 8.51L14.62 8.55L13.9 8.55L13.9 7.64L14.62 7.64L14.82 7.68L14.96 7.78L15.06 7.93L15.1 8.1Z",
        "fill": "truck"
      },
      {
        "type": "polygon",
        "d": "M16.67 7.44L16.36 7.9L16.26 8.42L16.26 9.18L16.36 9.7L16.67 10.16L17.13 10.47L17.68 10.58L18.22 10.47L18.69 10.16L19 9.7L19.1 9.18L19.1 8.42L19 7.9L18.69 7.44L18.22 7.13L17.68 7.02L17.13 7.13Z",
        "fill": "accent"
      },
      {
        "type": "polygon",
        "d": "M17.98 9.89L17.68 9.95L17.37 9.89L17.11 9.72L16.94 9.46L16.87 9.12L16.87 8.48L16.94 8.14L17.11 7.88L17.37 7.71L17.68 7.65L17.98 7.71L18.24 7.88L18.42 8.14L18.48 8.48L18.48 9.12L18.42 9.46L18.24 9.72Z",
        "fill": "truck"
      }
    ],
    "agt-kurye": [
      {
        "type": "polygon",
        "d": "M8.91 11.6L7.81 5.81L5.47 5.81L4.37 11.6L5.39 11.79L5.69 10.21L7.59 10.21L7.89 11.79Z",
        "fill": "accent"
      },
      {
        "type": "polygon",
        "d": "M5.89 9.17L6.33 6.84L6.95 6.84L7.39 9.17Z",
        "fill": "truck"
      },
      {
        "type": "polygon",
        "d": "M15.58 6.84L15.58 11.79L16.62 11.79L16.62 6.84L17.63 6.84L17.63 5.81L14.57 5.81L14.57 6.84Z",
        "fill": "accent"
      },
      {
        "type": "polygon",
        "d": "M11.79 10.74L11.33 10.65L10.94 10.39L10.68 10L10.58 9.49L10.58 8.1L10.64 7.68L10.81 7.34L11.08 7.08L11.42 6.91L11.8 6.85L12.17 6.92L12.51 7.09L12.83 7.42L13.58 6.7L13.14 6.25L12.51 5.92L11.81 5.8L11.11 5.9L10.47 6.22L9.97 6.72L9.64 7.35L9.54 8.02L9.54 9.59L9.7 10.4L10.19 11.14L10.92 11.63L11.79 11.8L12.65 11.63L13.38 11.14L13.87 10.4L14.04 9.59L14.04 8.53L11.79 8.53L11.79 9.56L12.98 9.56L12.9 10L12.64 10.39L12.25 10.65Z",
        "fill": "accent"
      }
    ],
    "aqx-logistics": [
      {
        "type": "polygon",
        "d": "M7.84 11.53L6.7 5.56L4.29 5.56L3.15 11.53L4.2 11.73L4.51 10.1L6.47 10.1L6.78 11.73Z",
        "fill": "accent"
      },
      {
        "type": "polygon",
        "d": "M4.72 9.03L5.17 6.63L5.82 6.63L6.27 9.03Z",
        "fill": "truck"
      },
      {
        "type": "polygon",
        "d": "M11.87 5.74L10.92 5.55L9.97 5.74L9.17 6.28L8.63 7.08L8.45 7.98L8.45 9.31L8.63 10.21L9.17 11.01L9.97 11.55L10.92 11.74L11.87 11.55L12 11.47L12.43 12.05L13.29 11.41L12.83 10.79L13.22 10.21L13.4 9.31L13.4 7.98L13.22 7.08L12.68 6.28Z",
        "fill": "accent"
      },
      {
        "type": "polygon",
        "d": "M12.21 9.79L12.15 9.88L11.74 9.34L10.88 9.99L11.32 10.57L10.92 10.65L10.39 10.54L9.94 10.24L9.64 9.79L9.52 9.2L9.52 8.09L9.64 7.5L9.94 7.05L10.39 6.75L10.92 6.64L11.46 6.75L11.91 7.05L12.21 7.5L12.33 8.09L12.33 9.2Z",
        "fill": "truck"
      },
      {
        "type": "polygon",
        "d": "M18.85 11.14L17.2 8.64L18.85 6.15L17.95 5.56L16.56 7.67L15.17 5.56L14.27 6.15L15.92 8.64L14.27 11.14L15.17 11.73L16.56 9.62L17.95 11.73Z",
        "fill": "#0e7dfd"
      }
    ],
    "domesa": [
      {
        "type": "polygon",
        "d": "M7.23 5.06L7.32 4.76L7.27 4.7L6.76 4.7L6.71 4.71L6.65 4.81L3.87 13.05L3.93 13.12L4.49 13.11L4.64 12.75Z",
        "fill": "accent"
      },
      {
        "type": "polygon",
        "d": "M8.91 5.27L9.06 4.81L9.04 4.73L8.28 4.71L8.18 4.78L5.39 13.05L5.4 13.1L5.45 13.12L6.21 13.12L6.29 13Z",
        "fill": "accent"
      },
      {
        "type": "polygon",
        "d": "M11.3 4.81L11.26 4.72L10.05 4.71L9.94 4.76L7.16 13.05L7.18 13.1L7.27 13.12L8.48 13.11L11.22 5.06Z",
        "fill": "accent"
      },
      {
        "type": "polygon",
        "d": "M14.65 13L15 12.85L15.35 12.64L15.66 12.39L15.98 12.04L16.22 11.68L16.47 11.23L17.73 7.54L18.1 6.33L18.13 5.92L18.03 5.52L17.78 5.19L17.43 4.96L16.92 4.79L16.26 4.72L12.98 4.71L12.88 4.73L12.83 4.79L10.06 13.15L10.15 13.2L13.63 13.2L14.19 13.12Z",
        "fill": "accent"
      },
      {
        "type": "polygon",
        "d": "M12.85 11.63L14.63 6.28L14.75 6.2L15.2 6.21L15.4 6.26L15.51 6.33L15.56 6.43L15.53 6.78L14.05 11.23L13.95 11.43L13.84 11.54L13.48 11.69L12.93 11.7Z",
        "fill": "truck"
      }
    ],
    "herona-express": [
      {
        "type": "polygon",
        "d": "M15.95 7.46L15.91 7.06L15.84 6.69L15.73 6.34L15.62 6.08L15.46 5.75L15.26 5.43L15.03 5.14L14.84 4.93L14.63 4.74L14.34 4.51L14.02 4.31L13.69 4.14L13.34 4.01L12.98 3.91L12.62 3.85L12.31 3.82L12.31 7.46Z",
        "fill": "accent"
      },
      {
        "type": "polygon",
        "d": "M12.31 11.41L12.62 11.39L12.98 11.33L13.34 11.23L13.69 11.09L13.94 10.97L14.26 10.78L14.56 10.56L14.84 10.31L15.09 10.03L15.26 9.81L15.46 9.49L15.62 9.16L15.76 8.81L15.86 8.45L15.92 8.08L15.95 7.78L12.31 7.78Z",
        "fill": "accent"
      },
      {
        "type": "polygon",
        "d": "M11.99 3.82L11.59 3.86L11.23 3.93L10.87 4.04L10.53 4.18L10.28 4.31L9.96 4.51L9.67 4.74L9.4 5L9.21 5.21L8.99 5.51L8.8 5.83L8.64 6.16L8.51 6.52L8.44 6.79L8.38 7.15L8.35 7.46L11.99 7.46Z",
        "fill": "accent"
      },
      {
        "type": "polygon",
        "d": "M8.35 7.78L8.39 8.18L8.46 8.54L8.54 8.81L8.68 9.16L8.84 9.49L9.04 9.81L9.27 10.1L9.46 10.31L9.67 10.5L9.96 10.73L10.28 10.92L10.61 11.09L10.96 11.23L11.32 11.33L11.68 11.39L11.99 11.41L11.99 7.78Z",
        "fill": "accent"
      },
      {
        "type": "polygon",
        "d": "M7.53 7.92L7.64 8.74L7.87 9.4L8.24 10.08L8.37 10.28L8.78 10.78L9.1 11.07L9.44 11.34L9.79 11.57L10.15 11.76L10.4 11.87L10.87 12.02L11.68 12.19L11.69 14.31L11.75 14.61L12.07 14.55L12.01 14.26L12.01 12.18L11.96 12L11.82 11.89L11.74 11.86L11.43 11.81L10.97 11.7L10.51 11.55L10.3 11.46L9.96 11.29L9.62 11.07L9.32 10.83L9.01 10.54L8.63 10.08L8.16 9.25L7.95 8.64L7.86 7.92L7.91 7.73L7.59 7.64Z",
        "fill": "#000000"
      },
      {
        "type": "polygon",
        "d": "M16.11 9.29L15.76 9.93L15.32 10.48L15.04 10.76L14.8 10.96L14.31 11.3L13.76 11.56L13.33 11.7L12.87 11.81L12.49 11.87L12.29 12L12.22 12.21L12.22 14.3L12.17 14.58L12.49 14.64L12.55 14.34L12.57 12.2L13.43 12.02L13.87 11.87L14.28 11.69L14.49 11.58L15.01 11.22L15.27 10.99L15.57 10.69L16.04 10.1L16.4 9.43L16.63 8.77L16.77 7.96L16.86 7.78L16.57 7.62L16.44 7.88L16.31 8.68Z",
        "fill": "#000000"
      },
      {
        "type": "polygon",
        "d": "M16.55 9.6L16.37 9.97L16.07 10.43L15.69 10.89L14.99 11.5L14.44 11.84L14.01 12.04L13.01 12.34L12.83 12.48L12.76 12.69L12.76 14.3L12.71 14.58L13.03 14.64L13.09 14.31L13.11 12.67L14.15 12.35L14.61 12.12L15.18 11.77L15.91 11.13L16.34 10.62L16.65 10.14L16.86 9.73L17.11 9.06L17.27 8.35L17.37 8.17L17.09 8L16.95 8.25L16.8 8.95Z",
        "fill": "#000000"
      },
      {
        "type": "polygon",
        "d": "M7.44 9.76L7.65 10.18L7.97 10.63L8.51 11.27L9.1 11.77L9.58 12.07L10.15 12.35L11.16 12.67L11.17 14.26L11.12 14.55L11.44 14.61L11.5 14.28L11.5 12.69L11.46 12.53L11.41 12.45L11.26 12.34L10.29 12.05L9.73 11.78L9.31 11.51L8.75 11.05L8.23 10.43L7.93 10L7.74 9.63L7.46 8.93L7.31 8.04L6.99 8.09L7.14 9Z",
        "fill": "#000000"
      },
      {
        "type": "polygon",
        "d": "M17.42 8.65L17.3 9.18L17.15 9.61L16.91 10.1L16.51 10.75L16.12 11.21L15.65 11.65L15.28 11.95L14.97 12.16L14.63 12.35L14.27 12.52L13.61 12.75L13.4 12.93L13.34 13.17L13.34 14.28L13.4 14.61L13.72 14.55L13.67 14.26L13.67 13.19L13.69 13.1L13.74 13.06L14.38 12.83L14.78 12.65L15.47 12.22L15.87 11.9L16.35 11.44L16.78 10.93L17.21 10.25L17.45 9.74L17.62 9.28L17.74 8.74L17.76 8.68L17.91 8.57L17.71 8.31L17.53 8.45Z",
        "fill": "#000000"
      },
      {
        "type": "polygon",
        "d": "M6.63 9.2L6.93 9.96L7.14 10.36L7.52 10.95L7.98 11.51L8.56 12.03L9.03 12.37L9.71 12.74L9.98 12.86L10.53 13.04L10.59 13.09L10.6 14.3L10.55 14.58L10.87 14.64L10.93 14.31L10.93 13.1L10.87 12.89L10.66 12.74L10.1 12.55L9.85 12.44L9.2 12.09L8.77 11.78L8.22 11.27L7.78 10.75L7.42 10.19L7.23 9.82L7.03 9.36L6.95 9.12L6.83 8.59L6.79 8.48L6.71 8.41L6.51 8.31L6.37 8.61L6.52 8.68Z",
        "fill": "#000000"
      }
    ],
    "hub-group-final-mile": [
      {
        "type": "polygon",
        "d": "M6.64 12L7.75 12L7.75 5.6L6.64 5.6L6.64 8.24L4.47 8.24L4.47 5.6L3.36 5.6L3.36 12L4.47 12L4.47 9.35L6.64 9.35Z",
        "fill": "accent"
      },
      {
        "type": "polygon",
        "d": "M18.15 7.23L18.07 6.75L17.83 6.29L17.46 5.91L16.99 5.68L16.52 5.6L14.25 5.6L14.25 12L16.87 12L17.38 11.91L17.89 11.65L18.3 11.25L18.55 10.74L18.64 10.22L18.64 9.86L18.55 9.34L18.3 8.83L17.88 8.42L18.07 8.04L18.15 7.56Z",
        "fill": "accent"
      },
      {
        "type": "polygon",
        "d": "M17 7.1L17.04 7.32L17.04 7.48L17 7.69L16.92 7.85L16.8 7.97L16.64 8.05L16.43 8.08L15.36 8.08L15.36 6.71L16.43 6.71L16.64 6.74L16.8 6.82L16.92 6.95Z",
        "fill": "truck"
      },
      {
        "type": "polygon",
        "d": "M17.04 9.24L17.23 9.33L17.39 9.49L17.49 9.68L17.53 9.94L17.53 10.14L17.49 10.4L17.39 10.59L17.23 10.74L17.04 10.84L16.78 10.89L15.36 10.89L15.36 9.19L16.78 9.19Z",
        "fill": "truck"
      },
      {
        "type": "polygon",
        "d": "M10.43 11.93L11 12L11.57 11.93L12.1 11.71L12.55 11.36L12.9 10.9L13.12 10.37L13.19 9.84L13.19 5.6L12.08 5.6L12.08 9.77L12.04 10.08L11.93 10.34L11.76 10.56L11.54 10.74L11.28 10.84L11 10.88L10.72 10.84L10.46 10.74L10.24 10.56L10.07 10.34L9.96 10.08L9.92 9.77L9.92 5.6L8.81 5.6L8.81 9.84L8.88 10.37L9.1 10.9L9.45 11.36L9.9 11.71Z",
        "fill": "accent"
      }
    ],
    "jetizz": [
      {
        "type": "polygon",
        "d": "M9.96 9.25L10.83 9.25L10.83 8.75L9.96 8.75L9.96 8.06L11.02 8.06L11.02 7.56L9.46 7.56L9.46 10.44L11.02 10.44L11.02 9.94L9.96 9.94Z",
        "fill": "accent"
      },
      {
        "type": "polygon",
        "d": "M12.49 10.44L12.49 8.06L12.98 8.06L12.98 7.56L11.5 7.56L11.5 8.06L11.99 8.06L11.99 10.44Z",
        "fill": "accent"
      },
      {
        "type": "polygon",
        "d": "M13.96 7.56L13.46 7.56L13.46 10.44L13.96 10.44Z",
        "fill": "accent"
      },
      {
        "type": "polygon",
        "d": "M16.75 7.56L14.88 7.56L14.88 8.06L15.87 8.06L14.43 10.44L16.31 10.44L16.31 9.94L15.32 9.94Z",
        "fill": "accent"
      },
      {
        "type": "polygon",
        "d": "M17.23 7.56L17.23 8.06L18.22 8.06L16.78 10.44L18.66 10.44L18.66 9.94L17.67 9.94L19.1 7.56Z",
        "fill": "accent"
      },
      {
        "type": "polygon",
        "d": "M8.14 9.94L8.05 9.93L7.97 9.89L7.9 9.84L7.84 9.77L7.81 9.68L7.79 9.56L7.3 9.63L7.32 9.81L7.4 10.02L7.54 10.2L7.72 10.33L7.92 10.41L8.14 10.44L8.36 10.41L8.56 10.33L8.74 10.2L8.87 10.02L8.96 9.81L8.99 9.61L8.99 7.56L8.49 7.56L8.49 9.58L8.47 9.68L8.44 9.77L8.38 9.84L8.31 9.89L8.23 9.93Z",
        "fill": "accent"
      },
      {
        "type": "polygon",
        "d": "M5.72 7.08L6.75 9.9L3.93 10.92L2.9 8.1Z",
        "fill": "#ffe046"
      },
      {
        "type": "polygon",
        "d": "M4.9 7.37L5.47 8.93L4.73 9.19L4.17 7.64Z",
        "fill": "#d89b30"
      }
    ],
    "mailex": [
      {
        "type": "polygon",
        "d": "M18.8 4.65L18.8 12.97L13.94 12.97Z",
        "fill": "#36419a"
      },
      {
        "type": "polygon",
        "d": "M3.2 4L3.2 4.52L11 9.81L18.8 4.52L18.8 4L18.42 4L11 9.03L3.58 4Z",
        "fill": "accent"
      },
      {
        "type": "polygon",
        "d": "M4.43 9.68L3.2 9.68L3.2 10.2L5.26 10.2Z",
        "fill": "accent"
      },
      {
        "type": "polygon",
        "d": "M3.2 10.63L3.2 11.06L6.35 11.06L5.7 10.63Z",
        "fill": "accent"
      },
      {
        "type": "polygon",
        "d": "M3.2 11.5L3.2 11.93L7.39 11.93L6.74 11.5Z",
        "fill": "accent"
      }
    ],
    "znlogic": [
      {
        "type": "polygon",
        "d": "M4.67 10.68L7.53 5.91L3.78 5.91L3.78 6.92L5.76 6.92L2.9 11.69L6.65 11.69L6.65 10.68Z",
        "fill": "accent"
      },
      {
        "type": "polygon",
        "d": "M8.49 11.69L9.49 11.69L9.49 5.91L8.49 5.91Z",
        "fill": "accent"
      },
      {
        "type": "polygon",
        "d": "M14.59 5.91L13.59 5.91L13.59 10.68L13.21 10.68L12.73 5.91L10.44 5.91L10.44 11.69L11.44 11.69L11.44 6.92L11.83 6.92L12.3 11.69L14.59 11.69Z",
        "fill": "accent"
      },
      {
        "type": "polygon",
        "d": "M16.37 6.28L15.93 6.72L15.64 7.28L15.55 7.85L15.55 9.75L15.64 10.32L15.93 10.88L16.37 11.32L16.93 11.6L17.55 11.69L18.17 11.59L18.72 11.3L19.1 10.9L18.38 10.21L18.11 10.48L17.84 10.63L17.54 10.68L17.24 10.63L16.96 10.5L16.74 10.28L16.6 10.01L16.55 9.67L16.55 7.93L16.6 7.59L16.74 7.32L16.96 7.1L17.24 6.97L17.54 6.92L17.84 6.97L18.11 7.12L18.38 7.39L19.1 6.7L18.72 6.3L18.17 6.01L17.55 5.91L16.93 6Z",
        "fill": "accent"
      }
    ],
    "ltl-kr": [
      {
        "type": "polygon",
        "d": "M5.96 11.09L5.96 5.3L4.74 5.3L4.74 12.3L8.24 12.3L8.24 11.09Z",
        "fill": "accent"
      },
      {
        "type": "polygon",
        "d": "M8.21 5.3L8.21 6.51L9.4 6.51L9.4 12.3L10.61 12.3L10.61 6.51L11.8 6.51L11.8 5.3Z",
        "fill": "accent"
      },
      {
        "type": "polygon",
        "d": "M12.96 12.3L16.46 12.3L16.46 11.09L14.17 11.09L14.17 5.3L12.96 5.3Z",
        "fill": "accent"
      },
      {
        "type": "polygon",
        "d": "M16.36 4.66L16.58 5.54L17.14 5.76L16.58 5.98L16.36 6.86L16.14 5.98L15.58 5.76L16.14 5.54Z",
        "fill": "accent"
      }
    ],
    "jiaying-express": [
      {
        "type": "polygon",
        "d": "M11.04 5.77L13.17 8.99L13.17 12.54L14.47 12.54L14.47 8.99L16.59 5.77L15.51 5.05L13.82 7.62L12.12 5.05Z",
        "fill": "accent"
      },
      {
        "type": "polygon",
        "d": "M8.23 10.98L8.04 11.12L7.83 11.21L7.6 11.24L7.37 11.21L7.15 11.12L6.97 10.98L6.83 10.79L6.74 10.58L6.69 10.26L5.41 10.43L5.47 10.92L5.69 11.45L6.04 11.9L6.5 12.25L7.03 12.47L7.6 12.55L8.17 12.47L8.7 12.25L9.16 11.9L9.51 11.45L9.73 10.92L9.8 10.39L9.8 5.05L8.5 5.05L8.5 10.3L8.46 10.58L8.37 10.79Z",
        "fill": "accent"
      }
    ],
    "okay-parcel": [
      {
        "type": "circle",
        "cx": 7.99,
        "cy": 8.8,
        "r": 3.75,
        "fill": "accent"
      },
      {
        "type": "circle",
        "cx": 7.99,
        "cy": 8.8,
        "r": 2.45,
        "fill": "truck"
      },
      {
        "type": "polygon",
        "d": "M7.64 10.83L10.02 8L9.26 7.36L7.6 9.33L6.78 8.46L6.06 9.14Z",
        "fill": "accent"
      },
      {
        "type": "polygon",
        "d": "M14.57 9.06L16.64 12.55L17.76 11.89L15.52 8.11L17.66 5.97L16.74 5.05L13.94 7.85L13.94 5.05L12.64 5.05L12.64 12.55L13.94 12.55L13.94 9.69Z",
        "fill": "accent"
      }
    ],
    "magic-trans": [
      {
        "type": "polygon",
        "d": "M2.9 11.7L3.23 11.48L4.95 9.72L6.5 8.25L7.72 7.22L8.68 6.5L9.75 5.81L10.27 5.52L10.95 5.21L11.93 4.86L12.41 4.74L13.06 4.64L14.2 4.58L14.52 4.61L14.99 4.72L15.29 4.84L15.73 5.09L16.14 5.42L16.51 5.82L16.86 6.29L17.17 6.82L17.44 7.42L17.66 8.06L17.83 8.76L17.94 9.5L18 10.27L18 10.81L19 10.79L18.92 9.65L18.83 9.1L18.65 8.3L18.5 7.8L18.23 7.09L17.9 6.43L17.66 6.02L17.25 5.47L16.95 5.14L16.47 4.72L16.13 4.48L15.58 4.19L15.2 4.05L14.81 3.96L14.4 3.92L13.32 3.98L12.62 4.09L12.11 4.21L11.42 4.43L10.9 4.64L9.86 5.18L8.6 6.01L7.28 7.08L5.64 8.63L4.53 9.78L3.09 11.36Z",
        "fill": "accent"
      },
      {
        "type": "polygon",
        "d": "M8.81 9.4L10.32 13.03L11.82 9.4L11.82 13.38L12.73 13.38L12.73 8.12L11.36 8.12L10.32 10.64L9.27 8.12L7.9 8.12L7.9 13.38L8.81 13.38Z",
        "fill": "accent"
      },
      {
        "type": "polygon",
        "d": "M16.3 8.12L13.6 8.12L13.6 9.03L14.49 9.03L14.49 13.38L15.41 13.38L15.41 9.03L16.3 9.03Z",
        "fill": "#042e65"
      }
    ],
    "red-express": [
      {
        "type": "polygon",
        "d": "M7.42 8.91L7.85 8.26L8 7.49L7.85 6.72L7.42 6.08L6.77 5.64L6.06 5.5L3.47 5.5L3.47 12.1L4.61 12.1L4.61 9.48L4.95 9.48L7.15 12.1L8.03 11.36L6.39 9.41L6.77 9.34Z",
        "fill": "accent"
      },
      {
        "type": "polygon",
        "d": "M6.59 6.9L6.77 7.17L6.84 7.49L6.77 7.81L6.59 8.08L6.32 8.26L5.95 8.34L4.61 8.34L4.61 6.65L5.95 6.65L6.32 6.72Z",
        "fill": "truck"
      },
      {
        "type": "polygon",
        "d": "M10.27 10.95L10.27 9.37L12.24 9.37L12.24 8.23L10.27 8.23L10.27 6.65L12.69 6.65L12.69 5.5L9.12 5.5L9.12 12.1L12.69 12.1L12.69 10.95Z",
        "fill": "accent"
      },
      {
        "type": "polygon",
        "d": "M17.57 11.14L18.09 10.45L18.42 9.66L18.53 8.8L18.42 7.94L18.09 7.15L17.57 6.46L16.88 5.94L16.09 5.61L15.27 5.5L13.78 5.5L13.78 12.1L15.27 12.1L16.09 11.99L16.88 11.66Z",
        "fill": "accent"
      },
      {
        "type": "polygon",
        "d": "M17.09 7.73L17.31 8.24L17.38 8.8L17.31 9.36L17.09 9.87L16.75 10.32L16.3 10.66L15.79 10.88L15.19 10.95L14.93 10.95L14.93 6.65L15.19 6.65L15.79 6.72L16.3 6.94L16.75 7.28Z",
        "fill": "truck"
      }
    ],
    "qatar-post": [
      {
        "type": "polygon",
        "d": "M7.38 5.79L6.54 6.35L5.98 7.17L5.79 8.11L5.79 9.49L5.98 10.41L6.54 11.25L7.38 11.81L8.37 12.01L9.35 11.81L9.47 11.73L9.93 12.33L10.82 11.67L10.34 11.03L10.74 10.41L10.93 9.49L10.93 8.11L10.74 7.17L10.18 6.35L9.35 5.79L8.37 5.59Z",
        "fill": "accent"
      },
      {
        "type": "polygon",
        "d": "M9.21 9.52L8.31 10.19L8.77 10.8L8.37 10.88L7.81 10.77L7.34 10.45L7.03 9.99L6.9 9.37L6.9 8.21L7.03 7.61L7.34 7.15L7.81 6.83L8.37 6.72L8.91 6.83L9.38 7.15L9.7 7.61L9.82 8.21L9.82 9.37L9.7 9.99L9.63 10.08Z",
        "fill": "truck"
      },
      {
        "type": "polygon",
        "d": "M15 9.32L15.63 8.91L16.06 8.28L16.21 7.53L16.06 6.79L15.63 6.16L15 5.73L14.31 5.6L12.01 5.6L12.01 12L13.13 12L13.13 9.46L14.31 9.46Z",
        "fill": "accent"
      },
      {
        "type": "polygon",
        "d": "M14.57 6.78L14.83 6.96L15.01 7.22L15.07 7.53L15.01 7.84L14.83 8.1L14.57 8.28L14.21 8.35L13.13 8.35L13.13 6.71L14.21 6.71Z",
        "fill": "truck"
      }
    ],
    "wp-ground": [
      {
        "type": "polygon",
        "d": "M5.57 9.41L5.83 11.67L7.17 11.67L9.5 6.23L8.58 5.83L6.68 10.29L6.4 7.82L5.27 7.82L4.01 10.26L3.9 6.02L2.9 6.04L3.05 11.67L4.42 11.67Z",
        "fill": "#000000"
      },
      {
        "type": "polygon",
        "d": "M16.4 10.66L16 10.58L15.72 10.36L15.57 10.03L15.57 9.56L15.84 8.22L15.99 7.8L16.24 7.44L16.59 7.16L16.98 6.98L17.36 6.92L17.69 6.98L17.95 7.13L18.18 7.43L18.97 6.82L18.62 6.37L18.04 6.03L17.38 5.91L16.69 6.01L16.05 6.3L15.51 6.75L15.1 7.33L14.87 7.95L14.57 9.46L14.57 10.25L14.92 11L15.58 11.51L16.4 11.68L17.24 11.52L18 11.07L18.57 10.41L18.88 9.65L19.1 8.53L16.83 8.53L16.83 9.53L17.85 9.53L17.71 9.88L17.35 10.29L16.88 10.57Z",
        "fill": "#000000"
      },
      {
        "type": "polygon",
        "d": "M13.69 8.39L13.94 7.75L13.95 7.07L13.66 6.46L13.13 6.05L12.51 5.92L10.53 5.92L9.4 11.57L10.38 11.77L10.85 9.39L12.01 9.39L12.63 9.27L13.23 8.92Z",
        "fill": "#000000"
      },
      {
        "type": "polygon",
        "d": "M12.86 7.1L12.95 7.29L12.95 7.56L12.82 7.86L12.59 8.14L12.28 8.32L11.92 8.39L11.05 8.39L11.35 6.92L12.41 6.92L12.7 6.98Z",
        "fill": "truck"
      }
    ],
    "global-parcel-service": [
      {
        "type": "polygon",
        "d": "M12.06 9.29L12.65 8.89L13.05 8.31L13.18 7.61L13.05 6.92L12.65 6.33L12.06 5.93L11.42 5.81L9.27 5.81L9.27 11.79L10.31 11.79L10.31 9.42L11.42 9.42Z",
        "fill": "accent"
      },
      {
        "type": "polygon",
        "d": "M11.66 6.91L11.9 7.08L12.07 7.32L12.13 7.61L12.07 7.9L11.9 8.15L11.66 8.31L11.32 8.38L10.31 8.38L10.31 6.84L11.32 6.84Z",
        "fill": "truck"
      },
      {
        "type": "polygon",
        "d": "M14.89 8.94L16.81 9.54L17.11 9.96L17.02 10.4L16.52 10.75L15.8 10.75L15.13 10.28L14.53 11.13L15.47 11.79L16.85 11.79L17.95 11.01L18.22 9.74L17.45 8.66L15.54 8.06L15.25 7.64L15.35 7.19L15.82 6.84L16.49 6.84L17.12 7.31L17.74 6.48L16.84 5.81L15.48 5.81L14.42 6.59L14.14 7.86Z",
        "fill": "accent"
      },
      {
        "type": "polygon",
        "d": "M6.03 10.74L5.57 10.65L5.18 10.39L4.92 10L4.82 9.49L4.82 8.1L4.88 7.68L5.06 7.34L5.33 7.08L5.67 6.91L6.04 6.85L6.42 6.92L6.75 7.09L7.07 7.42L7.82 6.7L7.38 6.25L6.75 5.92L6.05 5.8L5.35 5.9L4.71 6.22L4.21 6.72L3.88 7.35L3.78 8.02L3.78 9.59L3.94 10.4L4.43 11.14L5.16 11.63L6.03 11.8L6.89 11.63L7.63 11.14L8.12 10.4L8.28 9.59L8.28 8.53L6.03 8.53L6.03 9.56L7.22 9.56L7.14 10L6.88 10.39L6.49 10.65Z",
        "fill": "accent"
      }
    ],
    "logistics-solution": [
      {
        "type": "polygon",
        "d": "M13.36 13.85L12.73 12.46L8.23 12.46L11.73 5.52L10.88 3.85L5.9 13.85Z",
        "fill": "accent"
      },
      {
        "type": "polygon",
        "d": "M14.5 13.84L16.1 13.84L13.02 7.65L12.23 9.22Z",
        "fill": "accent"
      }
    ],
    "quick-fort": [
      {
        "type": "polygon",
        "d": "M14.1 6.34L16.65 6.34L16.65 5.11L13.1 5.11L11.7 12.08L12.91 12.32L13.52 9.27L15.6 9.27L15.6 8.04L13.76 8.04Z",
        "fill": "accent"
      },
      {
        "type": "polygon",
        "d": "M10 5.32L8.93 5.1L7.82 5.31L6.82 5.9L6.06 6.78L5.66 7.78L5.35 9.3L5.35 10.35L5.81 11.33L6.67 11.99L7.75 12.22L8.86 12L9 11.92L9.32 12.5L10.39 11.91L10.02 11.23L10.62 10.54L11.02 9.54L11.32 8.02L11.32 6.97L10.86 5.98Z",
        "fill": "accent"
      },
      {
        "type": "polygon",
        "d": "M9.39 10.08L9.09 9.53L8.01 10.13L8.4 10.84L7.76 10.96L7.2 10.84L6.8 10.54L6.58 10.08L6.58 9.42L6.84 8.13L7.12 7.43L7.62 6.86L8.26 6.48L8.92 6.35L9.48 6.47L9.87 6.78L10.09 7.24L10.09 7.89L9.83 9.19L9.55 9.89Z",
        "fill": "truck"
      }
    ],
    "flight-logistics": [
      {
        "type": "polygon",
        "d": "M7.2 8.29L14.8 3.85L10.84 9.95L10.79 8.34Z",
        "fill": "accent"
      },
      {
        "type": "polygon",
        "d": "M6.04 11.74L5.13 11.74L5.13 10.97L6.25 10.97L6.25 10.4L4.57 10.4L4.57 13.64L5.13 13.64L5.13 12.31L6.04 12.31Z",
        "fill": "accent"
      },
      {
        "type": "polygon",
        "d": "M8.4 13.64L8.4 13.08L7.34 13.08L7.34 10.4L6.78 10.4L6.78 13.64Z",
        "fill": "accent"
      },
      {
        "type": "polygon",
        "d": "M8.94 10.4L8.94 13.64L9.5 13.64L9.5 10.4Z",
        "fill": "accent"
      },
      {
        "type": "polygon",
        "d": "M15.23 13.64L15.23 10.4L14.67 10.4L14.67 11.74L13.57 11.74L13.57 10.4L13.01 10.4L13.01 13.64L13.57 13.64L13.57 12.31L14.67 12.31L14.67 13.64Z",
        "fill": "accent"
      },
      {
        "type": "polygon",
        "d": "M16.88 13.64L16.88 10.97L17.43 10.97L17.43 10.4L15.77 10.4L15.77 10.97L16.32 10.97L16.32 13.64Z",
        "fill": "accent"
      },
      {
        "type": "polygon",
        "d": "M10.65 12.67L10.6 12.4L10.6 11.64L10.63 11.42L10.73 11.24L10.87 11.09L11.06 11L11.26 10.97L11.46 11L11.65 11.1L11.82 11.28L12.22 10.89L11.99 10.64L11.65 10.46L11.27 10.4L10.89 10.46L10.54 10.63L10.27 10.9L10.09 11.24L10.04 11.6L10.04 12.45L10.12 12.89L10.39 13.29L10.79 13.56L11.25 13.65L11.72 13.56L12.12 13.29L12.39 12.89L12.47 12.45L12.47 11.88L11.25 11.88L11.25 12.44L11.9 12.44L11.86 12.67L11.71 12.89L11.5 13.03L11.25 13.08L11.01 13.03L10.79 12.89Z",
        "fill": "accent"
      }
    ],
    "peregrine-ship": [
      {
        "type": "polygon",
        "d": "M10.33 10.71L10.57 11.42L10.85 11.87L11.21 12.26L11.58 12.54L12.79 13.26L12.79 12.34L12.95 12.11L13.33 12L13.83 12.03L14.4 12.18L14.88 12.47L14.97 12.48L15.04 12.44L15.04 12.28L14.91 12.01L14.93 11.69L14.89 11.49L14.74 11.25L14.47 10.99L13.27 10.27L13.18 10.38L13.14 10.87L12.91 10.9L12.83 10.86L12.8 9.48L12.76 9.2L12.46 8.56L12.05 8.07L10.27 6.96L10.27 7.95L6.91 5.92L6.61 5.67L6.35 5.29L6.23 4.84L6.25 4.43L6.39 4.59L10.28 6.95L10.28 6.52L12 7.56L12.41 7.88L12.71 8.24L12.98 8.71L13.12 9.13L13.18 9.66L13.23 9.75L14.69 10.68L15.13 11.13L15.27 11.44L15.3 11.92L15.44 12.37L15.45 12.69L15.39 13.2L15.27 13.29L14.73 12.81L14.28 12.53L13.74 12.38L13.26 12.37L13.17 12.48L13.12 13.45L15.2 14.66L15.44 14.7L15.66 14.66L15.86 14.56L16.02 14.41L16.13 14.2L16.16 13.96L16.14 8.72L16.03 8.21L15.82 7.73L15.53 7.3L15.16 6.93L11.25 4.52L11.03 4.48L10.75 4.53L10.5 4.68L10.33 4.91L10.27 5.22L10.27 6.5L6.01 3.91L5.86 3.94L5.85 4.85L6.01 5.43L6.25 5.81L6.51 6.09L7.54 6.76L7.61 7.67L7.71 7.96L7.91 8.29L8.36 8.71L10.27 9.89Z",
        "fill": "accent"
      },
      {
        "type": "polygon",
        "d": "M8.23 8.06L8.01 7.66L7.94 7.18L8.03 7.07L10.28 8.4L10.28 9.45L11.14 10.01L11.12 10.09L10.97 10.28L10.27 9.89L10.27 9.45L8.5 8.34Z",
        "fill": "truck"
      },
      {
        "type": "polygon",
        "d": "M10.28 7.96L11.08 8.45L11.13 8.52L11.04 8.74L10.97 8.79L10.89 8.77L10.28 8.4Z",
        "fill": "truck"
      },
      {
        "type": "polygon",
        "d": "M12.78 13.35L12.72 13.49L12.56 13.61L12.38 13.63L12.15 13.56L9.55 12.01L9.16 11.62L8.84 11.09L8.71 10.68L8.67 9.98L8.43 9.96L8.36 9.99L8.34 10.69L8.53 11.31L8.96 11.97L9.23 12.24L9.54 12.47L11.86 13.85L12.16 13.97L12.44 14.01L12.69 13.98L12.87 13.87L13.03 13.7L13.14 13.47L12.79 13.26Z",
        "fill": "accent"
      }
    ],
    "southwestern-motor-transport": [
      {
        "type": "polygon",
        "d": "M8.78 7.56L9.11 7.18L9.46 6.91L9.85 6.69L10.23 6.55L2.84 6.55L2.85 6.75L2.89 6.94L2.95 7.12L3.04 7.29L3.14 7.43L3.28 7.56Z",
        "fill": "accent"
      },
      {
        "type": "polygon",
        "d": "M18.96 7.29L19.05 7.12L19.11 6.94L19.15 6.75L19.16 6.55L11.77 6.55L12.18 6.71L12.57 6.93L12.91 7.21L13.08 7.38L13.22 7.56L18.72 7.56L18.86 7.43Z",
        "fill": "accent"
      },
      {
        "type": "polygon",
        "d": "M8.3 8.59L8.43 8.18L8.59 7.84L4.1 7.84L4.14 8.05L4.21 8.22L4.29 8.36L4.39 8.49L4.51 8.59Z",
        "fill": "accent"
      },
      {
        "type": "polygon",
        "d": "M17.86 8.05L17.9 7.84L13.41 7.84L13.59 8.22L13.7 8.59L17.49 8.59L17.61 8.49L17.71 8.36L17.79 8.22Z",
        "fill": "accent"
      },
      {
        "type": "polygon",
        "d": "M8.26 9.62L8.23 9.25L8.25 8.87L5.36 8.87L5.4 9.09L5.46 9.25L5.55 9.4L5.65 9.53L5.77 9.63Z",
        "fill": "accent"
      },
      {
        "type": "polygon",
        "d": "M16.54 9.25L16.6 9.09L16.64 8.87L13.75 8.87L13.77 9.25L13.74 9.63L16.23 9.63L16.35 9.53L16.45 9.4Z",
        "fill": "accent"
      },
      {
        "type": "polygon",
        "d": "M7.02 10.66L8.64 10.66L8.45 10.31L8.32 9.91L6.61 9.91L6.65 10.12L6.72 10.29L6.8 10.43L6.9 10.56Z",
        "fill": "accent"
      },
      {
        "type": "polygon",
        "d": "M15.28 10.29L15.35 10.12L15.39 9.91L13.68 9.91L13.55 10.31L13.36 10.66L14.98 10.66L15.1 10.56L15.2 10.43Z",
        "fill": "accent"
      },
      {
        "type": "polygon",
        "d": "M8.28 11.7L8.41 11.78L8.55 11.82L8.7 11.84L10.11 11.84L9.75 11.69L9.4 11.48L9.09 11.22L8.83 10.94L7.87 10.94L7.91 11.16L7.97 11.32L8.06 11.47L8.16 11.6Z",
        "fill": "accent"
      },
      {
        "type": "polygon",
        "d": "M13.84 11.6L13.94 11.47L14.03 11.32L14.09 11.16L14.13 10.94L13.17 10.94L12.91 11.22L12.6 11.48L12.25 11.69L11.89 11.84L13.3 11.84L13.45 11.82L13.59 11.78L13.72 11.7Z",
        "fill": "accent"
      },
      {
        "type": "circle",
        "cx": 11,
        "cy": 9.21,
        "r": 2.47,
        "fill": "#ffb500"
      },
      {
        "type": "polygon",
        "d": "M11 6.79L11.64 8.33L13.3 8.46L12.04 9.55L12.42 11.17L11 10.3L9.58 11.17L9.96 9.55L8.7 8.46L10.36 8.33Z",
        "fill": "truck"
      }
    ],
    "topnic": [
      {
        "type": "polygon",
        "d": "M8.34 5.55L8.45 5.72L8.65 5.9L8.86 6L9.21 6.04L11.24 6.04L11.43 5.15L8.24 5.15Z",
        "fill": "accent"
      },
      {
        "type": "polygon",
        "d": "M7.47 4.22L7.66 4.49L7.93 4.69L8.23 4.78L8.57 4.8L11.87 4.8L11.14 8.2L11.17 8.41L11.3 8.62L11.62 8.35L12.25 7.77L12.87 4.8L14.39 4.8L14.62 3.9L7.38 3.9Z",
        "fill": "accent"
      },
      {
        "type": "polygon",
        "d": "M9.17 6.67L9.28 6.86L9.51 7.09L9.7 7.2L10.07 7.27L11 7.27L11.18 6.38L9.11 6.38Z",
        "fill": "accent"
      },
      {
        "type": "polygon",
        "d": "M13.18 5.15L12.59 7.89L11.52 8.89L11.94 9.29L11.96 9.3L12.81 8.53L13.06 8.22L13.22 7.85L13.62 6.02L14.15 6L14.32 5.15Z",
        "fill": "#fb7f21"
      },
      {
        "type": "polygon",
        "d": "M4.75 10.66L4.75 13.29L5.31 13.29L5.31 10.66L5.85 10.66L5.85 10.11L4.21 10.11L4.21 10.66Z",
        "fill": "accent"
      },
      {
        "type": "polygon",
        "d": "M6.6 10.48L6.32 10.89L6.23 11.36L6.23 12.04L6.32 12.51L6.6 12.92L7.01 13.2L7.5 13.3L8 13.2L8.41 12.92L8.69 12.51L8.78 12.04L8.78 11.36L8.69 10.89L8.41 10.48L8 10.2L7.5 10.1L7.01 10.2Z",
        "fill": "accent"
      },
      {
        "type": "polygon",
        "d": "M7.5 12.74L7.23 12.68L7 12.52L6.84 12.29L6.78 11.99L6.78 11.41L6.84 11.11L7 10.88L7.23 10.72L7.5 10.66L7.78 10.72L8.01 10.88L8.17 11.11L8.23 11.41L8.23 11.99L8.17 12.29L8.01 12.52L7.78 12.68Z",
        "fill": "truck"
      },
      {
        "type": "polygon",
        "d": "M11.32 10.7L11.11 10.38L10.8 10.17L10.46 10.11L9.31 10.11L9.31 13.29L9.86 13.29L9.86 12.03L10.46 12.03L10.8 11.96L11.11 11.75L11.32 11.44L11.4 11.07Z",
        "fill": "accent"
      },
      {
        "type": "polygon",
        "d": "M10.8 11.22L10.72 11.35L10.58 11.44L10.4 11.48L9.86 11.48L9.86 10.66L10.4 10.66L10.58 10.7L10.72 10.78L10.8 10.91L10.83 11.07Z",
        "fill": "truck"
      },
      {
        "type": "polygon",
        "d": "M13.66 10.11L13.66 12.74L13.45 12.74L13.19 10.11L11.93 10.11L11.93 13.29L12.48 13.29L12.48 10.66L12.69 10.66L12.95 13.29L14.22 13.29L14.22 10.11Z",
        "fill": "accent"
      },
      {
        "type": "polygon",
        "d": "M15.3 10.11L14.75 10.11L14.75 13.29L15.3 13.29Z",
        "fill": "accent"
      },
      {
        "type": "polygon",
        "d": "M15.88 10.86L15.83 11.18L15.83 12.22L15.88 12.54L16.03 12.85L16.28 13.09L16.59 13.25L16.93 13.3L17.27 13.24L17.58 13.08L17.79 12.86L17.39 12.48L17.24 12.63L17.09 12.71L16.93 12.74L16.76 12.71L16.61 12.64L16.49 12.52L16.41 12.37L16.38 12.18L16.38 11.22L16.41 11.03L16.49 10.88L16.61 10.76L16.76 10.69L16.93 10.66L17.09 10.69L17.24 10.77L17.39 10.92L17.79 10.54L17.58 10.32L17.27 10.16L16.93 10.1L16.59 10.15L16.28 10.31L16.03 10.55Z",
        "fill": "accent"
      }
    ],
    "magnum-transportation": [
      {
        "type": "polygon",
        "d": "M2.93 10L3.1 10L3.77 7.6L3.6 7.6Z",
        "fill": "accent"
      },
      {
        "type": "polygon",
        "d": "M3.32 10L3.56 10L4.23 7.6L3.99 7.6Z",
        "fill": "accent"
      },
      {
        "type": "polygon",
        "d": "M3.78 10L4.1 10L4.78 7.6L4.45 7.6Z",
        "fill": "accent"
      },
      {
        "type": "polygon",
        "d": "M4.32 10L4.8 10L5.47 7.6L4.99 7.6Z",
        "fill": "accent"
      },
      {
        "type": "polygon",
        "d": "M5.02 10L5.65 10L6.33 7.6L5.69 7.6Z",
        "fill": "accent"
      },
      {
        "type": "polygon",
        "d": "M8.54 7.6L8.14 7.6L7.17 8.8L6.87 7.6L6.52 7.6L5.87 9.94L6.09 10L6.32 10L6.68 8.7L6.95 9.77L7.74 8.8L7.43 9.94L7.64 10L7.87 10Z",
        "fill": "accent"
      },
      {
        "type": "polygon",
        "d": "M8.98 9.37L9.62 9.37L9.56 9.93L10.01 9.98L10.27 7.6L9.29 7.6L8.27 9.87L8.56 10L8.7 10Z",
        "fill": "accent"
      },
      {
        "type": "polygon",
        "d": "M9.19 8.93L9.58 8.05L9.77 8.05L9.67 8.93Z",
        "fill": "truck"
      },
      {
        "type": "polygon",
        "d": "M10.88 9.35L10.9 9.19L11.08 8.53L11.15 8.37L11.25 8.24L11.39 8.14L11.53 8.07L11.67 8.05L11.78 8.07L11.85 8.12L11.92 8.22L12.29 7.97L12.16 7.79L11.94 7.65L11.69 7.6L11.41 7.64L11.16 7.75L10.94 7.92L10.76 8.14L10.66 8.37L10.45 9.11L10.43 9.42L10.55 9.73L10.8 9.93L11.1 10L11.14 10L11.45 9.94L11.75 9.77L11.99 9.52L12.13 9.23L12.28 8.67L11.37 8.67L11.37 9.12L11.68 9.12L11.62 9.26L11.47 9.41L11.3 9.51L11.12 9.54L11 9.52L10.92 9.45Z",
        "fill": "accent"
      },
      {
        "type": "polygon",
        "d": "M12.95 7.6L12.29 9.94L12.51 10L12.74 10L13.15 8.52L13.74 10L14.06 10L14.72 7.66L14.5 7.6L14.27 7.6L13.86 9.08L13.27 7.6Z",
        "fill": "accent"
      },
      {
        "type": "polygon",
        "d": "M15.3 10L15.49 9.97L15.69 9.9L15.87 9.78L16.02 9.64L16.14 9.46L16.22 9.28L16.67 7.66L16.46 7.6L16.22 7.6L15.79 9.14L15.75 9.25L15.68 9.34L15.59 9.43L15.49 9.49L15.38 9.53L15.29 9.55L15.21 9.54L15.15 9.51L15.12 9.47L15.09 9.42L15.08 9.36L15.1 9.25L15.54 7.66L15.33 7.6L15.1 7.6L14.66 9.16L14.63 9.35L14.66 9.56L14.75 9.74L14.89 9.88L15.08 9.97Z",
        "fill": "accent"
      },
      {
        "type": "polygon",
        "d": "M19.07 7.6L18.67 7.6L17.7 8.8L17.39 7.6L17.05 7.6L16.4 9.94L16.61 10L16.85 10L17.21 8.7L17.48 9.77L18.27 8.8L17.95 9.94L18.17 10L18.4 10Z",
        "fill": "accent"
      }
    ],
    "crane-worldwide": [
      {
        "type": "polygon",
        "d": "M10.11 3.99L9.85 4.09L9.59 4.22L9.35 4.38L9.13 4.56L8.93 4.76L8.75 4.98L8.6 5.22L8.47 5.47L8.36 5.74L8.29 6.01L8.25 6.3L8.23 6.58L8.25 6.86L8.29 7.15L8.36 7.42L8.47 7.69L8.6 7.94L8.75 8.18L8.93 8.4L9.13 8.6L9.35 8.78L9.59 8.94L9.85 9.06L10.11 9.17L10.39 9.24L10.67 9.29L10.95 9.3L11.24 9.29L11.52 9.24L11.79 9.17L11.95 9.11L11.7 9.07L11.4 8.99L11.12 8.88L10.85 8.74L10.59 8.57L10.35 8.38L10.13 8.16L9.94 7.92L9.77 7.67L9.63 7.39L9.52 7.11L9.45 6.81L9.4 6.51L9.38 6.2L9.4 5.9L9.45 5.59L9.52 5.3L9.63 5.01L9.77 4.74L9.94 4.48L10.13 4.24L10.35 4.03L10.51 3.9L10.39 3.92Z",
        "fill": "accent"
      },
      {
        "type": "polygon",
        "d": "M12.46 8.79L12.69 8.65L12.9 8.47L13.1 8.28L13.27 8.07L13.42 7.84L13.54 7.59L13.64 7.34L13.71 7.07L13.75 6.8L13.77 6.53L13.75 6.25L13.71 5.98L13.64 5.72L13.54 5.46L13.42 5.22L13.27 4.99L13.1 4.77L12.9 4.58L12.69 4.41L12.46 4.26L12.21 4.13L11.96 4.03L11.69 3.96L11.42 3.92L11.15 3.91L10.88 3.92L10.66 3.96L10.51 4.08L10.3 4.28L10.12 4.51L9.96 4.76L9.83 5.02L9.72 5.29L9.65 5.57L9.6 5.86L9.59 6.15L9.6 6.44L9.65 6.73L9.72 7.02L9.83 7.29L9.96 7.55L10.12 7.79L10.3 8.02L10.51 8.23L10.74 8.41L10.98 8.57L11.24 8.7L11.52 8.81L11.8 8.88L12.09 8.93L12.17 8.94L12.21 8.92Z",
        "fill": "accent"
      },
      {
        "type": "line",
        "d": "M11.27 3.83L11.98 4.12L12.37 4.37L12.75 4.72L13.2 5.25L13.42 5.6L13.85 6.47M10.08 4.42L10.86 4.78L11.36 5.06L11.89 5.49L12.26 5.85L12.67 6.41L13.01 7.01L13.43 7.98M9.58 5.49L10.54 6.11L11.38 6.91L11.79 7.44L12.13 8L12.54 8.84M9.56 6.71L10.41 7.57L11.44 8.87M9.59 5.45L10.33 4.46L10.69 3.86M9.63 7.01L10.18 6.56L11.04 5.66L11.7 4.61L12 3.96M10.05 7.85L10.39 7.7L10.95 7.36L11.51 6.91L11.89 6.48L12.34 5.85L13 4.55M10.92 8.63L11.98 8L12.56 7.46L13.03 6.82L13.63 5.46",
        "stroke": "truck",
        "strokeWidth": 0.15
      },
      {
        "type": "polygon",
        "d": "M4.86 10.55L4.7 10.86L4.65 11.18L4.65 12.22L4.7 12.54L4.86 12.85L5.11 13.09L5.42 13.25L5.76 13.3L6.1 13.24L6.41 13.08L6.62 12.86L6.22 12.48L6.07 12.63L5.92 12.71L5.75 12.74L5.59 12.71L5.43 12.64L5.31 12.52L5.24 12.37L5.21 12.18L5.21 11.22L5.24 11.03L5.31 10.88L5.43 10.76L5.59 10.69L5.75 10.66L5.92 10.69L6.07 10.77L6.22 10.92L6.62 10.54L6.41 10.32L6.1 10.16L5.76 10.1L5.42 10.15L5.11 10.31Z",
        "fill": "accent"
      },
      {
        "type": "polygon",
        "d": "M9.34 11.07L9.27 10.7L9.06 10.38L8.74 10.17L8.4 10.1L7.14 10.1L7.14 13.3L7.7 13.3L7.7 12.03L7.87 12.03L8.93 13.3L9.35 12.94L8.56 12L8.74 11.96L9.06 11.75L9.27 11.44Z",
        "fill": "accent"
      },
      {
        "type": "polygon",
        "d": "M8.78 11.07L8.74 11.22L8.66 11.35L8.53 11.44L8.34 11.48L7.7 11.48L7.7 10.66L8.34 10.66L8.53 10.69L8.66 10.78L8.74 10.91Z",
        "fill": "truck"
      },
      {
        "type": "polygon",
        "d": "M10.43 10.1L9.84 13.19L10.39 13.3L10.55 12.45L11.56 12.45L11.72 13.3L12.27 13.19L11.68 10.1Z",
        "fill": "accent"
      },
      {
        "type": "polygon",
        "d": "M11.46 11.9L10.65 11.9L10.89 10.66L11.22 10.66Z",
        "fill": "truck"
      },
      {
        "type": "polygon",
        "d": "M14.54 12.74L14.33 12.74L14.06 10.1L12.8 10.1L12.8 13.3L13.35 13.3L13.35 10.66L13.56 10.66L13.82 13.3L15.09 13.3L15.09 10.1L14.54 10.1Z",
        "fill": "accent"
      },
      {
        "type": "polygon",
        "d": "M17.13 11.98L17.13 11.42L16.17 11.42L16.17 10.66L17.35 10.66L17.35 10.1L15.62 10.1L15.62 13.3L17.35 13.3L17.35 12.74L16.17 12.74L16.17 11.98Z",
        "fill": "accent"
      }
    ],
    "rohlig": [
      {
        "type": "polygon",
        "d": "M8.58 5.17L8.59 5.25L8.67 5.62L8.79 5.94L8.94 6.21L9.09 6.42L9.28 6.64L9.5 6.83L9.53 6.51L9.59 6.22L9.68 5.94L9.81 5.66L9.97 5.4L10.15 5.17L10.36 4.96L10.59 4.77L10.83 4.61L11.08 4.49L11.35 4.38L11.67 4.31L11.99 4.27L12.28 4.26L12.57 4.29L12.86 4.36L12.61 4.14L12.36 3.98L12.1 3.84L11.82 3.73L11.53 3.65L11.21 3.61L10.92 3.6L10.59 3.63L10.28 3.7L10.01 3.79L9.71 3.93L9.47 4.09L9.21 4.3L9.01 4.51L8.82 4.74Z",
        "fill": "accent"
      },
      {
        "type": "polygon",
        "d": "M11.32 6.83L11.53 6.64L11.64 6.42L11.65 6.17L11.57 5.93L11.39 5.72L11.16 5.61L10.91 5.6L10.68 5.68L10.46 5.86L10.36 6.08L10.34 6.34L10.42 6.58L10.61 6.79L10.83 6.89L11.08 6.91Z",
        "fill": "accent"
      },
      {
        "type": "polygon",
        "d": "M13.15 4.7L13.07 4.67L12.71 4.55L12.37 4.5L12.1 4.49L11.8 4.51L11.52 4.57L11.24 4.66L11.48 4.83L11.7 5.02L11.9 5.24L12.08 5.48L12.23 5.75L12.35 6.02L12.43 6.31L12.49 6.63L12.5 6.92L12.49 7.21L12.44 7.49L12.35 7.81L12.22 8.11L12.08 8.36L11.91 8.59L11.71 8.81L11.98 8.72L12.29 8.57L12.54 8.41L12.77 8.22L12.98 8.01L13.19 7.75L13.33 7.51L13.47 7.21L13.57 6.9L13.62 6.62L13.65 6.29L13.64 6.01L13.59 5.68L13.51 5.4L13.39 5.12Z",
        "fill": "accent"
      },
      {
        "type": "polygon",
        "d": "M11.27 8.88L11.33 8.83L11.62 8.58L11.83 8.31L11.97 8.09L12.1 7.82L12.19 7.54L12.25 7.25L11.95 7.39L11.67 7.48L11.38 7.54L11.08 7.57L10.77 7.56L10.47 7.52L10.19 7.44L9.92 7.34L9.66 7.21L9.42 7.05L9.2 6.87L8.97 6.63L8.78 6.37L8.63 6.12L8.51 5.86L8.42 5.58L8.35 6.21L8.36 6.51L8.41 6.81L8.48 7.09L8.61 7.4L8.75 7.65L8.94 7.91L9.15 8.15L9.37 8.34L9.64 8.52L9.89 8.66L10.2 8.78L10.48 8.85L10.78 8.89Z",
        "fill": "accent"
      },
      {
        "type": "polygon",
        "d": "M7.81 9.4L7.28 9.4L7.28 9.92L7.81 9.92Z",
        "fill": "accent"
      },
      {
        "type": "polygon",
        "d": "M8.87 9.4L8.35 9.4L8.35 9.92L8.87 9.92Z",
        "fill": "accent"
      },
      {
        "type": "polygon",
        "d": "M6.34 10.88L6.14 10.59L5.85 10.39L5.52 10.32L4.33 10.32L4.33 13.34L4.86 13.34L4.86 12.15L5.02 12.15L6.02 13.34L6.42 13.01L5.68 12.12L5.85 12.08L6.14 11.88L6.34 11.59L6.41 11.24Z",
        "fill": "accent"
      },
      {
        "type": "polygon",
        "d": "M5.85 11.38L5.77 11.51L5.64 11.59L5.47 11.62L4.86 11.62L4.86 10.85L5.47 10.85L5.64 10.88L5.77 10.97L5.85 11.09L5.88 11.24Z",
        "fill": "truck"
      },
      {
        "type": "polygon",
        "d": "M6.95 11.07L6.87 11.51L6.87 12.16L6.95 12.6L7.22 12.99L7.61 13.26L8.08 13.35L8.54 13.26L8.94 12.99L9.2 12.6L9.29 12.16L9.29 11.51L9.2 11.07L8.94 10.67L8.54 10.41L8.08 10.32L7.61 10.41L7.22 10.67Z",
        "fill": "accent"
      },
      {
        "type": "polygon",
        "d": "M7.82 12.76L7.6 12.62L7.45 12.39L7.39 12.11L7.39 11.56L7.45 11.27L7.6 11.05L7.82 10.91L8.08 10.85L8.34 10.91L8.56 11.05L8.71 11.27L8.76 11.56L8.76 12.11L8.71 12.39L8.56 12.62L8.34 12.76L8.08 12.82Z",
        "fill": "truck"
      },
      {
        "type": "polygon",
        "d": "M11.34 12.1L11.34 13.34L11.86 13.34L11.86 10.32L11.34 10.32L11.34 11.57L10.31 11.57L10.31 10.32L9.79 10.32L9.79 13.34L10.31 13.34L10.31 12.1Z",
        "fill": "accent"
      },
      {
        "type": "polygon",
        "d": "M12.36 13.34L13.87 13.34L13.87 12.82L12.88 12.82L12.88 10.32L12.36 10.32Z",
        "fill": "accent"
      },
      {
        "type": "polygon",
        "d": "M14.37 10.32L14.37 13.34L14.89 13.34L14.89 10.32Z",
        "fill": "accent"
      },
      {
        "type": "polygon",
        "d": "M15.97 12.44L15.92 12.18L15.92 11.48L15.95 11.27L16.04 11.1L16.17 10.97L16.35 10.88L16.54 10.85L16.72 10.88L16.89 10.97L17.06 11.14L17.43 10.78L17.21 10.55L16.9 10.38L16.54 10.32L16.19 10.37L15.87 10.53L15.61 10.79L15.45 11.11L15.39 11.44L15.39 12.23L15.47 12.65L15.72 13.02L16.09 13.26L16.53 13.35L16.97 13.26L17.34 13.02L17.58 12.65L17.67 12.23L17.67 11.7L16.53 11.7L16.53 12.22L17.13 12.22L17.09 12.44L16.96 12.64L16.76 12.77L16.53 12.82L16.3 12.77L16.1 12.64Z",
        "fill": "accent"
      }
    ],
    "jb-hunt": [
      {
        "type": "polygon",
        "d": "M7.67 7.85L7.5 7.68L7.28 7.58L7.07 7.54L6.03 7.54L6.03 10.46L7.23 10.46L7.46 10.42L7.69 10.3L7.88 10.12L8 9.89L8.03 9.65L8.03 9.48L8 9.24L7.88 9.01L7.69 8.83L7.78 8.65L7.81 8.44L7.81 8.28L7.78 8.07Z",
        "fill": "accent"
      },
      {
        "type": "polygon",
        "d": "M7.39 9.24L7.46 9.31L7.51 9.4L7.53 9.52L7.53 9.61L7.51 9.73L7.46 9.82L7.39 9.89L7.3 9.93L7.19 9.95L6.54 9.95L6.54 9.18L7.19 9.18L7.3 9.2Z",
        "fill": "truck"
      },
      {
        "type": "polygon",
        "d": "M7.3 8.4L7.29 8.5L7.25 8.57L7.2 8.62L7.13 8.66L7.03 8.67L6.54 8.67L6.54 8.05L7.03 8.05L7.13 8.06L7.2 8.1L7.25 8.15L7.29 8.23L7.3 8.32Z",
        "fill": "truck"
      },
      {
        "type": "polygon",
        "d": "M11.56 9.25L11.56 10.46L12.06 10.46L12.06 7.54L11.56 7.54L11.56 8.75L10.57 8.75L10.57 7.54L10.06 7.54L10.06 10.46L10.57 10.46L10.57 9.25Z",
        "fill": "accent"
      },
      {
        "type": "polygon",
        "d": "M16.43 9.95L16.18 7.54L15.03 7.54L15.03 10.46L15.53 10.46L15.53 8.05L15.73 8.05L15.97 10.46L17.12 10.46L17.12 7.54L16.62 7.54L16.62 9.95Z",
        "fill": "accent"
      },
      {
        "type": "polygon",
        "d": "M18.61 8.05L19.1 8.05L19.1 7.54L17.61 7.54L17.61 8.05L18.1 8.05L18.1 10.46L18.61 10.46Z",
        "fill": "accent"
      },
      {
        "type": "polygon",
        "d": "M3.75 9.95L3.66 9.94L3.58 9.9L3.51 9.85L3.45 9.77L3.42 9.69L3.4 9.57L2.9 9.63L2.92 9.82L3.01 10.03L3.15 10.21L3.32 10.34L3.53 10.43L3.75 10.46L3.98 10.43L4.18 10.34L4.36 10.21L4.5 10.03L4.58 9.82L4.61 9.62L4.61 7.54L4.1 7.54L4.1 9.58L4.09 9.69L4.05 9.77L4 9.85L3.93 9.9L3.84 9.94Z",
        "fill": "accent"
      },
      {
        "type": "polygon",
        "d": "M13.81 10.42L14.05 10.32L14.25 10.17L14.41 9.96L14.51 9.72L14.55 9.47L14.55 7.54L14.04 7.54L14.04 9.44L14.02 9.58L13.97 9.7L13.89 9.8L13.79 9.88L13.67 9.93L13.55 9.95L13.42 9.93L13.3 9.88L13.2 9.8L13.12 9.7L13.07 9.58L13.05 9.44L13.05 7.54L12.55 7.54L12.55 9.47L12.58 9.72L12.68 9.96L12.84 10.17L13.05 10.32L13.29 10.42L13.55 10.46Z",
        "fill": "accent"
      },
      {
        "type": "polygon",
        "d": "M5.05 9.95L5.05 10.46L5.55 10.46L5.55 9.95Z",
        "fill": "accent"
      },
      {
        "type": "polygon",
        "d": "M8.98 9.95L8.47 9.95L8.47 10.46L8.98 10.46Z",
        "fill": "accent"
      }
    ],
    "dhx": [
      {
        "type": "polygon",
        "d": "M8.21 9.9L7.88 9.18L8.21 8.48L8.09 8.13L7.59 9.18L8.09 10.25Z",
        "fill": "accent"
      },
      {
        "type": "polygon",
        "d": "M7.06 11.53L7.36 11.29L6.37 9.18L7.35 7.1L7 6.83L6.67 6.66L5.48 9.18L6.69 11.74Z",
        "fill": "accent"
      },
      {
        "type": "polygon",
        "d": "M3.94 6.87L3.62 7.13L3.38 7.37L3.13 7.7L2.97 8L2.82 8.39L2.73 8.79L2.7 9.2L2.73 9.61L2.82 10.01L2.97 10.4L3.13 10.7L3.38 11.03L3.67 11.32L4 11.57L4.35 11.75L3.14 9.18L4.33 6.66Z",
        "fill": "accent"
      },
      {
        "type": "polygon",
        "d": "M8.4 9.2L8.36 8.72L8.14 9.18L8.36 9.64Z",
        "fill": "#ec519d"
      },
      {
        "type": "polygon",
        "d": "M7.83 10.76L7.98 10.51L7.35 9.18L7.97 7.87L7.79 7.59L7.61 7.36L6.76 9.18L7.62 11.02Z",
        "fill": "#ec519d"
      },
      {
        "type": "polygon",
        "d": "M5.36 12L5.71 11.99L6.05 11.95L6.33 11.87L5.07 9.18L6.32 6.52L5.98 6.44L5.77 6.41L5.5 6.4L5.23 6.41L4.99 6.45L3.7 9.18L5.02 11.96Z",
        "fill": "#ec519d"
      },
      {
        "type": "polygon",
        "d": "M10.42 10.91L10.89 10.74L11.33 10.48L11.71 10.14L12.03 9.74L12.25 9.31L12.35 8.85L12.33 8.41L12.17 8L11.88 7.69L11.49 7.49L11.06 7.43L10.36 7.43L9.05 10.97L9.98 10.97Z",
        "fill": "accent"
      },
      {
        "type": "polygon",
        "d": "M11.31 8.09L11.51 8.19L11.65 8.33L11.73 8.54L11.74 8.79L11.67 9.09L11.51 9.41L11.27 9.72L10.97 9.98L10.63 10.19L10.28 10.31L9.93 10.35L10.78 8.05L11.02 8.05Z",
        "fill": "truck"
      },
      {
        "type": "polygon",
        "d": "M14.68 11.07L15.98 7.54L15.41 7.33L14.83 8.89L13.67 8.89L14.18 7.54L13.6 7.33L12.29 10.86L12.87 11.07L13.45 9.51L14.6 9.51L14.1 10.86Z",
        "fill": "accent"
      },
      {
        "type": "polygon",
        "d": "M17.49 8.63L17.17 7.52L16.58 7.69L17 9.11L15.48 10.58L15.91 11.02L17.19 9.77L17.51 10.88L18.1 10.71L17.69 9.29L19.2 7.82L18.77 7.38Z",
        "fill": "accent"
      }
    ],
    "wooliiporter": [
      {
        "type": "polygon",
        "d": "M10.44 10.51L10.87 5.71L10.91 5.71L11.34 10.51L13.28 10.51L14.35 4.89L13.36 4.7L12.44 9.51L12.26 9.51L11.83 4.7L9.95 4.7L9.52 9.51L9.34 9.51L8.42 4.7L7.43 4.89L8.5 10.51Z",
        "fill": "accent"
      },
      {
        "type": "polygon",
        "d": "M14.53 12.39L14.57 12.46L14.67 12.53L14.79 12.58L14.91 12.59L15.03 12.58L15.15 12.53L15.25 12.46L15.32 12.36L15.37 12.24L15.39 12.12L15.37 12L15.32 11.88L15.25 11.78L15.15 11.71L15.03 11.66L14.91 11.64L14.79 11.66L14.67 11.71L14.57 11.78L14.53 11.85L11.11 11.85L6.92 11.34L6.81 11.35L6.72 11.4L6.65 11.48L6.61 11.58L6.62 11.68L6.67 11.78L6.75 11.85L6.85 11.88L8.81 12.12L6.85 12.36L6.75 12.39L6.67 12.46L6.62 12.55L6.61 12.66L6.65 12.76L6.72 12.84L6.81 12.89L6.92 12.9L11.11 12.39Z",
        "fill": "#85c3bb"
      }
    ],
    "matson": [
      {
        "type": "polygon",
        "d": "M5.96 7.2L5.47 7.2L4.45 9.41L4.41 9.41L3.39 7.2L2.9 7.2L2.9 10.4L3.5 10.4L3.5 8.85L4.03 10.01L4.83 10.01L5.36 8.85L5.36 10.4L5.96 10.4Z",
        "fill": "accent"
      },
      {
        "type": "polygon",
        "d": "M7.07 10.4L7.22 9.57L8.18 9.57L8.34 10.4L8.92 10.28L8.34 7.2L7.07 7.2L6.48 10.28Z",
        "fill": "accent"
      },
      {
        "type": "polygon",
        "d": "M7.56 7.8L7.84 7.8L8.07 8.97L7.34 8.97Z",
        "fill": "truck"
      },
      {
        "type": "polygon",
        "d": "M10.08 7.8L10.59 7.8L10.59 7.2L8.98 7.2L8.98 7.8L9.49 7.8L9.49 10.4L10.08 10.4Z",
        "fill": "accent"
      },
      {
        "type": "polygon",
        "d": "M12.42 9.21L12.57 9.42L12.52 9.62L12.27 9.8L11.91 9.8L11.57 9.56L11.22 10.04L11.72 10.4L12.46 10.4L13.06 9.98L13.2 9.29L12.79 8.7L11.79 8.39L11.65 8.18L11.69 7.97L11.92 7.8L12.26 7.8L12.58 8.04L12.94 7.56L12.46 7.2L11.73 7.2L11.16 7.63L11.01 8.31L11.41 8.9Z",
        "fill": "accent"
      },
      {
        "type": "polygon",
        "d": "M14.08 7.58L13.8 7.99L13.7 8.46L13.7 9.14L13.8 9.61L14.08 10.02L14.49 10.3L14.96 10.4L15.02 10.4L15.48 10.3L15.9 10.02L16.18 9.61L16.27 9.14L16.27 8.46L16.18 7.99L15.9 7.58L15.48 7.3L15.02 7.2L14.96 7.2L14.49 7.3Z",
        "fill": "accent"
      },
      {
        "type": "polygon",
        "d": "M14.73 9.74L14.51 9.59L14.36 9.37L14.3 9.08L14.3 8.52L14.36 8.23L14.51 8.01L14.73 7.86L14.99 7.81L15.25 7.86L15.47 8.01L15.62 8.23L15.68 8.52L15.68 9.08L15.62 9.37L15.47 9.59L15.25 9.74L14.99 9.79Z",
        "fill": "truck"
      },
      {
        "type": "polygon",
        "d": "M18.35 9.8L18.09 7.2L16.79 7.2L16.79 10.4L17.39 10.4L17.39 7.8L17.55 7.8L17.81 10.4L19.1 10.4L19.1 7.2L18.5 7.2L18.5 9.8Z",
        "fill": "accent"
      }
    ],
    "schneider": [
      {
        "type": "polygon",
        "d": "M4.12 8.81L3.88 8.96L3.62 8.96L3.4 8.78L3.11 9.15L3.45 9.43L4.02 9.43L4.5 9.12L4.7 8.61L4.45 8.13L3.73 7.89L3.67 7.78L3.73 7.61L3.96 7.46L4.2 7.46L4.4 7.63L4.71 7.27L4.38 6.99L3.82 6.99L3.35 7.29L3.15 7.8L3.4 8.28L4.12 8.52L4.18 8.64Z",
        "fill": "accent"
      },
      {
        "type": "polygon",
        "d": "M5.16 7.78L5.02 8.56L5.01 8.81L5.1 9.06L5.27 9.26L5.5 9.39L5.78 9.43L6.03 9.39L6.28 9.27L6.46 9.11L6.15 8.75L6.01 8.87L5.89 8.93L5.76 8.95L5.66 8.94L5.57 8.89L5.52 8.82L5.49 8.73L5.49 8.6L5.61 7.89L5.66 7.75L5.74 7.63L5.85 7.54L5.98 7.48L6.11 7.46L6.21 7.48L6.29 7.53L6.37 7.63L6.74 7.34L6.6 7.16L6.37 7.03L6.13 6.99L5.85 7.02L5.6 7.14L5.39 7.31L5.24 7.54Z",
        "fill": "accent"
      },
      {
        "type": "polygon",
        "d": "M8.61 6.99L8.37 6.99L8.2 7.97L7.46 7.97L7.62 7.03L7.39 6.99L7.15 6.99L6.73 9.39L6.96 9.43L7.2 9.43L7.37 8.44L8.11 8.44L7.95 9.39L8.18 9.43L8.42 9.43L8.84 7.03Z",
        "fill": "accent"
      },
      {
        "type": "polygon",
        "d": "M8.98 9.43L9.22 9.43L9.47 7.98L10.17 9.43L10.52 9.43L10.94 7.03L10.71 6.99L10.47 6.99L10.22 8.43L9.52 6.99L9.17 6.99L8.75 9.39Z",
        "fill": "accent"
      },
      {
        "type": "polygon",
        "d": "M11.57 7.97L11.66 7.46L12.55 7.46L12.55 6.99L11.27 6.99L10.84 9.43L12.2 9.43L12.2 8.96L11.4 8.96L11.49 8.44L12.21 8.44L12.21 7.97Z",
        "fill": "accent"
      },
      {
        "type": "polygon",
        "d": "M13.19 6.99L12.95 6.99L12.53 9.39L12.76 9.43L13 9.43L13.42 7.03Z",
        "fill": "accent"
      },
      {
        "type": "polygon",
        "d": "M15.31 8.25L15.32 7.93L15.25 7.63L15.09 7.36L14.86 7.15L14.58 7.03L14.28 6.99L13.75 6.99L13.32 9.43L13.93 9.43L14.24 9.39L14.54 9.27L14.82 9.08L15.05 8.84L15.21 8.56Z",
        "fill": "accent"
      },
      {
        "type": "polygon",
        "d": "M14.84 8.17L14.78 8.37L14.67 8.56L14.51 8.72L14.32 8.85L14.12 8.93L13.89 8.96L14.15 7.46L14.25 7.46L14.45 7.49L14.6 7.56L14.72 7.66L14.81 7.8L14.85 7.98Z",
        "fill": "truck"
      },
      {
        "type": "polygon",
        "d": "M16.25 7.46L17.13 7.46L17.13 6.99L15.85 6.99L15.42 9.43L16.79 9.43L16.79 8.96L15.99 8.96L16.07 8.44L16.8 8.44L16.8 7.97L16.16 7.97Z",
        "fill": "accent"
      },
      {
        "type": "polygon",
        "d": "M19.09 7.48L18.96 7.22L18.73 7.04L18.46 6.99L17.53 6.99L17.11 9.39L17.35 9.43L17.59 9.43L17.75 8.48L17.85 8.48L18.47 9.41L18.86 9.15L18.41 8.46L18.55 8.43L18.8 8.28L19 8.05L19.1 7.77Z",
        "fill": "accent"
      },
      {
        "type": "polygon",
        "d": "M18.38 7.98L18.24 8.01L17.83 8.01L17.93 7.46L18.42 7.46L18.53 7.48L18.59 7.53L18.62 7.6L18.63 7.69L18.58 7.81L18.49 7.91Z",
        "fill": "truck"
      },
      {
        "type": "polygon",
        "d": "M2.9 11.01L3.08 9.96L9.29 9.96L9.15 10.77L10.12 9.96L18.4 9.96L18.22 11.01Z",
        "fill": "accent"
      }
    ],
    "alliance-air-freight": [
      {
        "type": "polygon",
        "d": "M3.44 10.19L3.68 9.48L4.46 9.48L4.48 10.15L5.04 10.13L4.94 7.41L3.8 7.41L2.9 10.05L3.31 10.19Z",
        "fill": "accent"
      },
      {
        "type": "polygon",
        "d": "M4.2 7.97L4.4 7.97L4.44 8.92L3.87 8.92Z",
        "fill": "truck"
      },
      {
        "type": "polygon",
        "d": "M5.43 10.19L6.87 10.19L6.87 9.63L6.08 9.63L6.41 7.45L6.14 7.41L5.86 7.41Z",
        "fill": "accent"
      },
      {
        "type": "polygon",
        "d": "M7.27 10.19L8.71 10.19L8.71 9.63L7.92 9.63L8.25 7.45L7.97 7.41L7.69 7.41Z",
        "fill": "accent"
      },
      {
        "type": "polygon",
        "d": "M10.08 7.45L9.8 7.41L9.52 7.41L9.11 10.15L9.38 10.19L9.66 10.19Z",
        "fill": "accent"
      },
      {
        "type": "polygon",
        "d": "M10.63 10.19L10.87 9.48L11.65 9.48L11.67 10.15L12.23 10.13L12.13 7.41L10.99 7.41L10.09 10.05L10.5 10.19Z",
        "fill": "accent"
      },
      {
        "type": "polygon",
        "d": "M11.39 7.97L11.59 7.97L11.63 8.92L11.06 8.92Z",
        "fill": "truck"
      },
      {
        "type": "polygon",
        "d": "M12.9 10.19L13.18 10.19L13.43 8.59L14.24 10.19L14.65 10.19L15.07 7.45L14.79 7.41L14.51 7.41L14.27 9.01L13.45 7.41L13.04 7.41L12.63 10.15Z",
        "fill": "accent"
      },
      {
        "type": "polygon",
        "d": "M15.21 9.2L15.21 9.49L15.31 9.77L15.51 10L15.78 10.15L16.06 10.19L16.1 10.19L16.38 10.14L16.66 10.01L16.87 9.83L16.5 9.41L16.35 9.54L16.21 9.61L16.08 9.63L15.96 9.61L15.87 9.56L15.8 9.49L15.77 9.39L15.76 9.24L15.89 8.44L15.93 8.28L16.02 8.16L16.14 8.05L16.28 7.99L16.41 7.97L16.53 7.99L16.62 8.04L16.71 8.16L17.14 7.81L16.98 7.61L16.72 7.46L16.44 7.41L16.4 7.41L16.12 7.45L15.84 7.58L15.6 7.78L15.43 8.04L15.34 8.31Z",
        "fill": "accent"
      },
      {
        "type": "polygon",
        "d": "M18.75 8.52L18.03 8.52L18.12 7.97L19.1 7.97L19.1 7.41L17.64 7.41L17.22 10.19L18.76 10.19L18.76 9.63L17.86 9.63L17.95 9.08L18.75 9.08Z",
        "fill": "accent"
      }
    ],
    "mountain-movers": [
      {
        "type": "polygon",
        "d": "M2.8 13.4L19.2 13.4L19.2 12.99L16.17 8.4L15.43 9.29L13.73 5.64L12.44 7.1L10.68 3.6L7.75 8.55L6.73 7.25L5.52 9.6L4.96 8.98L2.8 11.69Z",
        "fill": "#e6e7e8"
      },
      {
        "type": "polygon",
        "d": "M9.45 12.32L8.34 12.32L7.83 11.16L7.83 12.95L7.1 12.95L7.1 9.05L7.7 9.05L8.81 11.59L8.97 11.59L10.08 9.05L10.68 9.05L10.68 12.95L9.95 12.95L9.95 11.16Z",
        "fill": "truck"
      },
      {
        "type": "polygon",
        "d": "M13.66 12.32L12.55 12.32L12.05 11.16L12.05 12.95L11.32 12.95L11.32 9.05L11.92 9.05L13.03 11.59L13.19 11.59L14.3 9.05L14.9 9.05L14.9 12.95L14.17 12.95L14.17 11.16Z",
        "fill": "truck"
      }
    ],
    "fmd-distribution": [
      {
        "type": "polygon",
        "d": "M2.9 9L2.9 11.29L7.07 11.29L7.35 9Z",
        "fill": "#c4c5c8"
      },
      {
        "type": "polygon",
        "d": "M10.25 7.6L10.25 6.71L7.94 6.71L7.4 11.23L7.84 11.29L8.28 11.29L8.51 9.44L9.74 9.44L9.74 8.56L8.61 8.56L8.73 7.6Z",
        "fill": "accent"
      },
      {
        "type": "polygon",
        "d": "M14.32 11.29L14.76 11.29L15.31 6.71L14.55 6.71L12.92 9.59L12.76 9.59L11.81 6.71L11.1 6.71L10.56 11.23L11 11.29L11.44 11.29L11.7 9.19L12.12 10.47L13.43 10.47L14.11 9.28L13.88 11.23Z",
        "fill": "accent"
      },
      {
        "type": "polygon",
        "d": "M18.26 10.64L18.66 10.18L18.95 9.64L19.1 9.05L19.09 8.46L18.93 7.89L18.61 7.4L18.16 7.02L17.62 6.79L17.06 6.71L16.05 6.71L15.5 11.29L16.62 11.29L17.19 11.21L17.76 10.99Z",
        "fill": "accent"
      },
      {
        "type": "polygon",
        "d": "M18.11 8.26L18.21 8.59L18.21 8.95L18.12 9.32L17.93 9.67L17.66 9.97L17.33 10.2L16.97 10.35L16.56 10.4L16.5 10.4L16.84 7.6L17.01 7.6L17.38 7.65L17.69 7.78L17.94 7.99Z",
        "fill": "truck"
      }
    ],
    "edi-express": [
      {
        "type": "polygon",
        "d": "M4.2 10.13L4.56 9.15L6 9.15L6 8.25L4.89 8.25L5.25 7.27L7.01 7.27L7.01 6.37L4.63 6.37L2.9 11.03L5.62 11.03L5.62 10.13Z",
        "fill": "accent"
      },
      {
        "type": "polygon",
        "d": "M9.47 10.4L9.98 9.95L10.38 9.43L10.67 8.86L10.82 8.26L10.79 7.66L10.58 7.12L10.18 6.7L9.66 6.45L9.09 6.37L8.14 6.37L6.42 11.03L7.7 11.03L8.29 10.96L8.9 10.74Z",
        "fill": "accent"
      },
      {
        "type": "polygon",
        "d": "M9.8 7.62L9.89 7.86L9.91 8.17L9.82 8.54L9.62 8.94L9.32 9.33L8.94 9.66L8.51 9.92L8.07 10.07L7.72 10.12L8.77 7.27L9.03 7.27L9.39 7.32L9.64 7.44Z",
        "fill": "truck"
      },
      {
        "type": "polygon",
        "d": "M10.73 10.88L11.15 11.03L11.63 11.03L13.3 6.52L12.88 6.37L12.4 6.37Z",
        "fill": "accent"
      },
      {
        "type": "polygon",
        "d": "M12.78 3.95L15.33 3.95L16.83 6.95L15.85 6.95L19.23 14.9L13.68 6.5L14.52 6.5Z",
        "fill": "#cfe1f2"
      }
    ],
    "cargo-trans-logistik": [
      {
        "type": "polygon",
        "d": "M5.32 7.06L4.46 11.12L2.9 11.12L3.76 7.06Z",
        "fill": "accent"
      },
      {
        "type": "polygon",
        "d": "M7.67 6.31L6.81 10.37L5.25 10.37L6.11 6.31Z",
        "fill": "accent"
      },
      {
        "type": "polygon",
        "d": "M9.73 7.06L8.87 11.12L7.31 11.12L8.18 7.06Z",
        "fill": "accent"
      },
      {
        "type": "polygon",
        "d": "M11.88 6.82L11.45 7.03L11.11 7.37L10.89 7.79L10.83 8.22L10.83 9.58L10.89 10.01L11.11 10.43L11.45 10.77L11.88 10.98L12.35 11.05L12.82 10.97L13.25 10.75L13.53 10.46L12.85 9.81L12.68 9.99L12.52 10.07L12.34 10.1L12.17 10.08L12.01 10L11.88 9.87L11.8 9.71L11.77 9.5L11.77 8.3L11.8 8.09L11.88 7.93L12.01 7.8L12.17 7.72L12.34 7.7L12.52 7.73L12.68 7.81L12.85 7.99L13.53 7.34L13.25 7.05L12.82 6.83L12.35 6.75Z",
        "fill": "accent"
      },
      {
        "type": "polygon",
        "d": "M14.77 7.69L14.77 11.05L15.71 11.05L15.71 7.69L16.28 7.69L16.28 6.75L14.2 6.75L14.2 7.69Z",
        "fill": "accent"
      },
      {
        "type": "polygon",
        "d": "M17.89 6.75L16.95 6.75L16.95 11.05L19.1 11.05L19.1 10.11L17.89 10.11Z",
        "fill": "accent"
      }
    ],
    "jas-worldwide": [
      {
        "type": "polygon",
        "d": "M6.11 10.5L5.93 10.57L5.76 10.59L5.63 10.58L5.52 10.53L5.45 10.46L5.39 10.37L5.37 10.26L5.38 10.03L4.18 9.97L4.16 10.37L4.27 10.83L4.51 11.23L4.86 11.55L5.29 11.74L5.72 11.8L5.8 11.8L6.23 11.74L6.67 11.57L7.06 11.31L7.39 10.96L7.63 10.56L7.76 10.14L8.52 5.91L7.93 5.8L7.32 5.8L6.59 9.86L6.53 10.06L6.43 10.24L6.28 10.39Z",
        "fill": "accent"
      },
      {
        "type": "polygon",
        "d": "M8.32 11.48L9.18 11.8L9.48 11.8L10.04 10.26L11.71 10.26L11.73 11.69L12.93 11.68L12.87 5.8L10.42 5.8Z",
        "fill": "accent"
      },
      {
        "type": "polygon",
        "d": "M11.68 7L11.7 9.06L10.49 9.06L11.25 7Z",
        "fill": "truck"
      },
      {
        "type": "polygon",
        "d": "M14.59 9L16.36 9.59L16.5 9.86L16.35 10.25L15.78 10.6L15.15 10.6L14.64 10.18L13.88 11.11L14.72 11.8L16.13 11.8L17.32 11.05L17.82 9.79L17.19 8.6L15.44 8.02L15.31 7.75L15.46 7.35L16 7L16.58 7L17.06 7.41L17.84 6.5L17.03 5.8L15.64 5.8L14.49 6.55L13.99 7.81Z",
        "fill": "accent"
      }
    ]
  }
};
